/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 925);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(481);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(482)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\wrapper\\index.jsx';



/**
 * Wrapper
 */
var Wrapper = function Wrapper(_ref) {
  var anchorPoint = _ref.anchorPoint,
      anchorName = _ref.anchorName,
      containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      children = _ref.children;

  //
  var getAnchor = function getAnchor(anchorChildren) {
    if (anchorPoint !== null && anchorName !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: anchorPoint, 'data-id': anchorPoint, 'data-anchor-name': anchorName, __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        },
        anchorChildren !== null ? anchorChildren : null
      );
    } else if (anchorPoint !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: anchorPoint, __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        anchorChildren !== null ? anchorChildren : null
      );
    } else if (anchorName !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { 'data-anchor-name': anchorName, __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        },
        anchorChildren !== null ? anchorChildren : null
      );
    } else {
      return anchorChildren !== null ? anchorChildren : null;
    }
  };
  //
  var getContainer = function getContainer(containerChildren) {
    if (containerId !== null && containerClass !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: containerId, className: containerClass, __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        containerChildren !== null ? containerChildren : null
      );
    } else if (containerId !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: containerId, __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        },
        containerChildren !== null ? containerChildren : null
      );
    } else if (containerClass !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: containerClass, __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        containerChildren !== null ? containerChildren : null
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        },
        containerChildren !== null ? containerChildren : null
      );
    }
  };
  //
  return getAnchor(getContainer(children));
};
Wrapper.propTypes = {
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
Wrapper.defaultProps = {
  anchorPoint: null,
  anchorName: null,
  containerId: null,
  containerClass: null,
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mjo__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__function__ = __webpack_require__(45);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__function__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__(132);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_3__object__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(210);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__array__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__(209);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__string__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__number__ = __webpack_require__(478);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom__ = __webpack_require__(479);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__dom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__(480);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__component__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__component__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__component__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__component__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__environment__ = __webpack_require__(530);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__environment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__async__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hash__ = __webpack_require__(532);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__hash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scroll__ = __webpack_require__(538);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_12__scroll__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_12__scroll__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(94);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__history__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__query__ = __webpack_require__(539);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_14__query__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__page__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__touch_helper__ = __webpack_require__(544);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__touch_helper__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_16__touch_helper__["b"]; });
/* unused harmony reexport validation */





















/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(14)
  , core      = __webpack_require__(34)
  , hide      = __webpack_require__(35)
  , redefine  = __webpack_require__(31)
  , ctx       = __webpack_require__(36)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target && !own)redefine(target, key, out);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_BROWSER; });
/* unused harmony export IS_DEV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IS_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WINDOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NAVIGATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_IFRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HAS_TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IS_IOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_ANDROID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MIN_BROWSERS; });
var IS_BROWSER = typeof window !== 'undefined';
var IS_DEV = "production" !== 'production';
var IS_TEST = "production" === 'test';
var WINDOW = IS_BROWSER && window;
var NAVIGATOR = WINDOW && WINDOW.navigator;
var DOCUMENT = WINDOW && WINDOW.document;
var IS_IFRAME = WINDOW && WINDOW.self !== WINDOW.top;
var HAS_TOUCH = DOCUMENT && 'ontouchstart' in DOCUMENT.documentElement;
var IS_IOS = NAVIGATOR && /iPhone|iPad|iPod/i.test(NAVIGATOR.userAgent || '');
var IS_ANDROID = NAVIGATOR && /Android/i.test(NAVIGATOR.userAgent || '');
var IS_MOBILE = NAVIGATOR && /iPhone|iPod|Android/i.test(NAVIGATOR.userAgent);
var MIN_BROWSERS = {
  safari: 9.1,
  chrome: 57,
  firefox: 53,
  msie: 11,
  msedge: 14
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineHOCs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return withRadium; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configured_radium__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_location__ = __webpack_require__(238);
/* unused harmony reexport ConnectLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detect_thresholds__ = __webpack_require__(239);
/* unused harmony reexport DetectThresholds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detect_compact__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__detect_compact__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_params__ = __webpack_require__(585);
/* unused harmony reexport SearchParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detect_window_scroll__ = __webpack_require__(586);
/* unused harmony reexport DetectWindowScroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__price__ = __webpack_require__(587);
/* unused harmony reexport Price */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__specs__ = __webpack_require__(588);
/* unused harmony reexport Specs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gtm_event__ = __webpack_require__(589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__gtm_event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__local_vehicle__ = __webpack_require__(590);
/* unused harmony reexport LocalVehicle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__with_hash__ = __webpack_require__(595);
/* unused harmony reexport withHash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__with_search__ = __webpack_require__(596);
/* unused harmony reexport withSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__with_dynamic_components__ = __webpack_require__(597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__with_dynamic_components__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__with_data_components__ = __webpack_require__(598);
/* unused harmony reexport withDataComponents */
/* unused harmony reexport Radium */
/* unused harmony reexport keyframes */

































var combineHOCs = __WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */];

var withRadium = function withRadium() {
  for (var _len = arguments.length, hocs = Array(_len), _key = 0; _key < _len; _key++) {
    hocs[_key] = arguments[_key];
  }

  return combineHOCs.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__configured_radium__["a" /* default */]].concat(hocs));
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var $Object = Object;
module.exports = {
  create:     $Object.create,
  getProto:   $Object.getPrototypeOf,
  isEnum:     {}.propertyIsEnumerable,
  getDesc:    $Object.getOwnPropertyDescriptor,
  setDesc:    $Object.defineProperty,
  setDescs:   $Object.defineProperties,
  getKeys:    $Object.keys,
  getNames:   $Object.getOwnPropertyNames,
  getSymbols: $Object.getOwnPropertySymbols,
  each:       [].forEach
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweet_scroll__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





/**
 *  Body Control
 */
var BodyControl = (_temp = _class = function BodyControl() {
  _classCallCheck(this, BodyControl);
}, _class.scrollTop = 0, _class.setUnScroll = function () {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.add('un-scroll');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["f" /* IS_IOS */]) {
    // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll')) {
    //   DOCUMENT.body.parentNode.classList.add('un-scroll');
    // }
    //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
  }
}, _class.setUnScrollPc = function () {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll-pc')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.add('un-scroll-pc');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["f" /* IS_IOS */]) {
    // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll-pc')) {
    //   DOCUMENT.body.parentNode.classList.add('un-scroll-pc');
    // }
    //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
  }
}, _class.setUnScrollMb = function () {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll-mb')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.add('un-scroll-mb');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["f" /* IS_IOS */]) {
    // if (!DOCUMENT.body.parentNode.classList.contains('un-scroll-mb')) {
    //   DOCUMENT.body.parentNode.classList.add('un-scroll-mb');
    // }
    //WINDOW.addEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
  }
}, _class.clearUnScroll = function () {
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.remove('un-scroll');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll-pc')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.remove('un-scroll-pc');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('un-scroll-mb')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.remove('un-scroll-mb');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["f" /* IS_IOS */]) {
    // if (DOCUMENT.body.parentNode.classList.contains('un-scroll')) {
    //   DOCUMENT.body.parentNode.classList.remove('un-scroll');
    // }
    // if (DOCUMENT.body.parentNode.classList.contains('un-scroll-pc')) {
    //   DOCUMENT.body.parentNode.classList.remove('un-scroll-pc');
    // }
    // if (DOCUMENT.body.parentNode.classList.contains('un-scroll-mb')) {
    //   DOCUMENT.body.parentNode.classList.remove('un-scroll-mb');
    // }
    //WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
  }
}, _class.openModal = function () {
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["b" /* HAS_TOUCH */]) {
    // スクロールを無効にする
    BodyControl.scrollTop = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].pageYOffset;

    // DOCUMENT.body.style.position = 'fixed';
    if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].MZD_SCROLL_DEPTH_TARGET && __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].MZD_SCROLL_DEPTH_TARGET.list) {
      if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].location) {
        var flg = false;
        // リストと一致しているか
        __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].MZD_SCROLL_DEPTH_TARGET.list.map(function (url) {
          if (0 <= String(__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].location.href).indexOf(url)) {
            flg = true;
          }
        });
        // 不許可リストにある場合は除去
        __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].MZD_SCROLL_DEPTH_TARGET.ignore.map(function (url) {
          if (0 <= String(__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].location.href).indexOf(url)) {
            flg = false;
          }
        });
        if (flg) {
          __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.position = 'absolute';
        } else {
          __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.position = 'fixed';
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.position = 'fixed';
    }

    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.top = -BodyControl.scrollTop + 'px';
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('modal-open')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.add('modal-open');
  }

  setTimeout(function () {
    var elements = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.querySelectorAll('main > div > div');
    if (elements) {
      Array.prototype.slice.call(elements, 0).forEach(function (element) {
        var openedVideo = element.querySelectorAll('.Video .is-open');
        if (1 <= openedVideo.length) {
          if (!element.classList.contains('modal-open-item')) {
            element.classList.add('modal-open-item');
          }
        }
      });
    }
  }, 100);
}, _class.closeModal = function () {
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.contains('modal-open')) {
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.classList.remove('modal-open');
  }
  // if (IS_MOBILE) {
  if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["b" /* HAS_TOUCH */]) {
    // スクロール無効を解除する
    // WINDOW.scrollTo(0, BodyControl.scrollTop);
    // if (DOCUMENT.body.parentNode.classList.contains('modal-open')) {
    //   DOCUMENT.body.parentNode.classList.remove('modal-open');
    // }
    //WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});

    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.position = 'static';
    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.style.top = '0px';

    __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].scrollTo(0, BodyControl.scrollTop);
  }

  var elements = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.querySelectorAll('main > div > div');
  if (elements) {
    Array.prototype.slice.call(elements, 0).forEach(function (element) {
      if (element.classList.contains('modal-open-item')) {
        element.classList.remove('modal-open-item');
      }
    });
  }

  // if (!IS_MOBILE && HAS_TOUCH) {
  //   WINDOW.removeEventListener('touchmove', BodyControl.onTouchMove, {passive: false});
  // }
}, _class.onTouchMove = function (e) {
  e.preventDefault();
}, _class.getSubNavigationHeight = function (e) {
  var navigation = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].body.getElementsByClassName('StandardPage__navigation')[0] || null;
  if (!navigation) {
    return 0;
  } else {
    return navigation.clientHeight;
  }
}, _class.scrollToElementId = function (id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var element = document.querySelector("[data-id=\"" + id + "\"]");
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */] || !id || !element) {} else {
    BodyControl.scrollToNode(element, _extends({}, options), callBack);
  }
}, _class.scrollToNode = function (target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1000 : _ref$duration,
      _ref$container = _ref.container,
      container = _ref$container === undefined ? 'body, html' : _ref$container,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? -BodyControl.getSubNavigationHeight() : _ref$offset;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */] || !target) return;
  var sweetScroll = new __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default.a({ duration: duration, offset: offset, stopPropagation: false, afterScroll: callback }, container);
  sweetScroll.toElement(target);
}, _class.getUrlParameter = function (name) {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */]) return null;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  if (results === null) {
    return null;
  } else {
    var result = decodeURIComponent(results[1].replace(/\+/g, ' '));
    return result === null || result === '' ? null : result;
  }
}, _class.setGTMEvent = function (data) {
  if (!window) return;
  //console.log('GTMイベント', data);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (BodyControl);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhotoInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hero_video__ = __webpack_require__(114);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\photo-info\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---




/**
 * BC03_PhotoInfo - Hero Image/Hero Videoブロック>PhotoInfoに設定するブロック
 * > ※画像を設定する以下ブロックにも利用予定 　Hero Image /Hero Video プレゼンテーション 　スライドギャラリー 　スライドショー 　フォトギャラリー 　360view Picker Full Width プロモ 　オーナーライブラリー　など
 */
var PhotoInfo = (_temp = _class = function (_Component) {
  _inherits(PhotoInfo, _Component);

  // static getDerivedStateFromProps(props, state) {
  //     // console.log('PhotoInfo.getDerivedStateFromProps', props, state);
  //     if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
  //         return {
  //             isOpen: '',
  //             prevHeroCarouselSlideId: state.heroCarouselSlideId,
  //             heroCarouselSlideId: props.heroCarouselSlideId,
  //         };
  //     }
  //     return null;
  // }
  /**
   * BC03_PhotoInfo 初期処理を行います
   * - button event handler を bind します
   * - state.isOpen 初期値を '' に設定します
   * @param {*} props React.props
   */
  function PhotoInfo(props) {
    _classCallCheck(this, PhotoInfo);

    // ---
    /**
     * `photo info` open / close をコントロールする class name
     * - open - ``
     * - close - `is-open`
     * @type {{isOpen: string}}
     */
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isOpen: '',
      heroCarouselSlideId: ''
    };
    /**
     * open button click event handler - bind onOpen
     * @type {bound|any}
     */
    _this.onOpen = _this.onOpen.bind(_this);
    /**
     * close button click event handler - bind onClose
     * @type {bound|any}
     */
    _this.onClose = _this.onClose.bind(_this);
    //this.close = this.close.bind(this);
    /**
     * info open class - body へ付与します
     * @type {string}
     */
    _this.infoOpened = 'PhotoInfo__opened';
    /**
     * bound onCycle
     * @type {bound|any}
     */
    _this.onCycle = _this.onCycle.bind(_this);
    /**
     * requestAnimationFrame id
     * @type {number}
     */
    _this.cycleId = 0;
    return _this;
  }

  /**
   * ticks
   * - document.body `.PhotoInfo__opened` 有無をチェックします
   * - carousel pager 重なり順問題を解決します
   */


  PhotoInfo.prototype.onCycle = function onCycle() {
    this.cycleId = requestAnimationFrame(this.onCycle);
    var isOpen = this.state.isOpen;

    if (isOpen && !document.body.classList.contains(this.infoOpened)) {
      this.setState({ isOpen: '' });
    }
  };

  /**
   * open button event handler
   * - state.isOpen - `is-open`
   * @param {Event} event click Event
   */


  PhotoInfo.prototype.onOpen = function onOpen(event) {
    event.preventDefault();
    document.body.classList.add(this.infoOpened);
    this.setState({ isOpen: 'is-open' });
    // @since 2018-07-06
    var _props = this.props,
        photoInfoWillOpen = _props.photoInfoWillOpen,
        containerId = _props.containerId;

    if (typeof photoInfoWillOpen === 'function') {
      photoInfoWillOpen.call(this, containerId);
    }
  };

  /**
   * close button click event handler
   * - state.isOpen - ``
   * @param {Event} event click Event
   */


  PhotoInfo.prototype.onClose = function onClose(event) {
    event.preventDefault();
    this.setState({ isOpen: '' });
    document.body.classList.remove(this.infoOpened);
    // @since 2018-07-06
    var _props2 = this.props,
        photoInfoWillClose = _props2.photoInfoWillClose,
        containerId = _props2.containerId;

    if (typeof photoInfoWillClose === 'function') {
      photoInfoWillClose.call(this, containerId);
    }
  };

  /**
   * {@link HeroCarousel} 内 - PhotoInfo open 時に slide 移動したら閉じる
   * @param {*} prevProps previous props
   */


  PhotoInfo.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    // console.log('PhotoInfo.componentDidUpdate', this.props.parentComponentId, this.state.isOpen, prevProps.heroCarouselSlideId, this.props.heroCarouselSlideId);
    var _props3 = this.props,
        inHeroCarousel = _props3.inHeroCarousel,
        heroCarouselSlideId = _props3.heroCarouselSlideId;

    if (inHeroCarousel && prevProps.heroCarouselSlideId !== heroCarouselSlideId && this.state.isOpen) {
      // console.log('PhotoInfo.componentDidUpdate --- close ---', this.props.parentComponentId, this.state.isOpen, prevProps.heroCarouselSlideId, this.props.heroCarouselSlideId);
      this.setState({ isOpen: '' });
    }
  };

  PhotoInfo.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      document.body.classList.add(this.infoOpened);
      this.setState({ isOpen: 'is-open' });
      // @since 2018-07-06
      var _props4 = this.props,
          photoInfoWillOpen = _props4.photoInfoWillOpen,
          containerId = _props4.containerId;

      if (typeof photoInfoWillOpen === 'function') {
        photoInfoWillOpen.call(this, containerId);
      }
    } else {
      this.setState({ isOpen: '' });
      document.body.classList.remove(this.infoOpened);
      // @since 2018-07-06
      var _props5 = this.props,
          photoInfoWillClose = _props5.photoInfoWillClose,
          _containerId = _props5.containerId;

      if (typeof photoInfoWillClose === 'function') {
        photoInfoWillClose.call(this, _containerId);
      }
    }
  };

  // /**
  //  * delegate - will unmount
  //  * - onCycle cancel します
  //  */
  // componentWillUnmount() {
  //     cancelAnimationFrame(this.cycleId);
  // }
  // /**
  //  * delegate - after mount
  //  * - onCycle 稼働し modal open 監視します
  //  */
  // componentDidMount() {
  //     this.onCycle();
  // }
  /**
   * `section.PhotoInfo` Element を作成します
   * - props null check を行います
   * - open / close click event を watch します
   * - color style 設定します
   * @returns {?Element} `section.PhotoInfo`
   */


  PhotoInfo.prototype.render = function render() {
    var _props6 = this.props,
        containerId = _props6.containerId,
        containerClass = _props6.containerClass,
        label = _props6.label,
        style = _props6.style,
        htmlText = _props6.htmlText;
    // null check

    if (htmlText === null) {
      return null;
    }
    // open class
    var isOpen = this.state.isOpen;
    // color mode - default `Dark`

    var colorStyle = 'link__color__' + (style || 'Dark').toLowerCase();
    // ---
    // const derivedStateFromProps = HeroVideo.getDerivedStateFromProps(this.props, this.state);
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'PhotoInfo ' + colorStyle, __source: {
            fileName: _jsxFileName,
            lineNumber: 222
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PhotoInfo__btn__open__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 223
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              href: '#',
              className: 'PhotoInfo__btn__open',
              type: 'button',
              onClick: this.onOpen,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 229
              }
            },
            label || 'Photo info'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PhotoInfo__content ' + isOpen, __source: {
              fileName: _jsxFileName,
              lineNumber: 239
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PhotoInfo__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 240
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              className: 'PhotoInfo__text Wysiwyg',
              dangerouslySetInnerHTML: { __html: htmlText || '' },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
              className: 'PhotoInfo__btn__close',
              type: 'button',
              onClick: this.onClose,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 245
              }
            })
          )
        )
      )
    );
  };

  return PhotoInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  htmlText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // extend props.js
  photoInfoWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  photoInfoWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inHeroCarousel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heroCarouselSlideId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  parentComponentName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  parentComponentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  label: null,
  style: null,
  htmlText: null,
  // extend props.js
  photoInfoWillOpen: null,
  photoInfoWillClose: null,
  inHeroCarousel: false,
  heroCarouselSlideId: '',
  parentComponentName: '',
  parentComponentId: ''
}, _temp);
PhotoInfo.displayName = 'PhotoInfo';


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store  = __webpack_require__(186)('wks')
  , uid    = __webpack_require__(49)
  , Symbol = __webpack_require__(14).Symbol;
module.exports = function(name){
  return store[name] || (store[name] =
    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
};

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Html; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dangerous_html__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dangerous_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dangerous_html__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\html\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// /**
//  * Html
//  */
// const Html = ({
//   htmlText,
// }) => (
//   <div
//     className="Html"
//     dangerouslySetInnerHTML={{__html: (htmlText !== null) ? htmlText: ''}}
//   />
// );
// Html.propTypes = {
//   htmlText: PropTypes.string,
// };
// Html.defaultProps = {
//   htmlText: null,
// };
// export default Html;

var Html = (_temp = _class = function (_Component) {
  _inherits(Html, _Component);

  function Html(props) {
    _classCallCheck(this, Html);

    // this.state = {
    //   firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    // };
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.refsContent = null;
    return _this;
  }
  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }
  // render() {
  //   const {
  //     htmlText,
  //   } = this.props;
  //   return (
  //     <div
  //       className="Html"
  //       dangerouslySetInnerHTML={{__html: (htmlText !== null) ? htmlText: ''}}
  //       ref={(component) => (this.refsContent = component)}
  //     />
  //   )
  // }

  Html.prototype.render = function render() {
    var _this2 = this;

    var htmlText = this.props.htmlText;


    htmlText = htmlText.replace(new RegExp('&lt;', 'g'), '<');
    htmlText = htmlText.replace(new RegExp('&gt;', 'g'), '>');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'Html',
        ref: function ref(component) {
          return _this2.refsContent = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dangerous_html___default.a, { html: htmlText !== null ? htmlText : '', __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        }
      })
    );
  };

  return Html;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  htmlText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inFeatureCategoriesHorizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  htmlText: null,
  inFeatureCategoriesHorizontal: false
}, _temp);
Html.displayName = 'Html';


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childParser; });
/* unused harmony export renderComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEqualId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* unused harmony reexport rafThrottle */
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\utilities\\index.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/**
 * @param {Object} props - True sets columns to full width.
 * @param {Function} additionalProps - Return props as a function of index.
 * @returns {Array} Array of React Component
 */
var childParser = function childParser(_ref) {
  var children = _ref.children,
      components = _ref.components;
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };

  if (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
      if (!child) return null;
      if (additionalProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, additionalProps(index));
      }
      return child;
    });
  }

  if (components) {
    return components.map(function (_ref2, index) {
      var name = _ref2.name,
          props = _ref2.props;
      return renderComponent({
        name: name,
        props: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["w" /* nullCheckProps */])(props), additionalProps(index), {
          key: index
        })
      });
    });
  }
  return null;
};

// For rendering flexible component given name and props
var renderComponent = function renderComponent(component) {
  var Component = __WEBPACK_IMPORTED_MODULE_1_blocks__[component.name];
  if (!Component) {
    console.error(component.name + ' tried to render but was not found. Please make sure ' + component.name + ' is imported in /blocks');
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, component.props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    }
  }));
};

renderComponent.displayName = 'renderComponent';
var getComponents = function getComponents(components, props) {
  return components.map(function (component, index) {
    var Component = null;
    if (component.name) {
      Component = __WEBPACK_IMPORTED_MODULE_1_blocks__[component.name];
    } else if (component.type) {
      Component = __WEBPACK_IMPORTED_MODULE_1_blocks__[component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '')];
      // Component = blocks[component.type.displayName.replace('withDynamicComponents(', '').replace(')', '')];
    }
    if (Component) {
      if (props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, component.props, props, { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, component.props, { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 64
          }
        }));
      }
    } else {
      return null;
    }
  });
};

// パラメータ取得
var getParams = function getParams() {
  var arr = window.location.search.replace('?', '').split('&');
  var params = {};
  var flg = false;
  var i = void 0,
      max = void 0;
  for (i = 0, max = arr.length; i < max; i = i + 1) {
    var pair = arr[i].split('=');
    if (pair[1]) {
      flg = true;
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  if (flg) {
    return params;
  } else {
    return null;
  }
};

// Cookie設定
var setCookie = function setCookie(key, val) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // Secure属性
  var secure = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    secure = '';
  } else {
    secure = ';secure';
  }
  // SameSite属性
  var domain = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    domain = '';
  } else {
    domain = ';domain=' + String(location.hostname);
  }
  //
  var str = null;
  if (0 < expires) {
    // 期限付き保存
    var date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    str = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + domain + ';path=/' + secure + ';samesite=lax';
    document.cookie = str;
  } else {
    // セッション保存
    str = key + '=' + encodeURIComponent(val) + ';path=/' + secure + ';samesite=lax';
    document.cookie = str;
  }
  //console.log('Cookie設定', str);
};

// Cookie削除
var removeCookie = function removeCookie(key) {
  // Secure属性
  var secure = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    secure = '';
  } else {
    secure = '; secure';
  }
  // SameSite属性
  var domain = null;
  if (0 <= String(location.hostname).indexOf('localhost')) {
    domain = '';
  } else {
    domain = '; domain=' + String(location.hostname);
  }
  document.cookie = key + '=; max-age=0' + domain + '; path=/' + secure + '; samesite=lax';
  //console.log('Cookie削除', key);
};

// Cookie取得
var getCookie = function getCookie(key) {
  var arr = document.cookie.split(';');
  var i = void 0,
      max = void 0;
  for (i = 0, max = arr.length; i < max; i = i + 1) {
    var pair = arr[i].split('=');
    if (key === pair[0].trim()) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
};

// 大文字を小文字にして、スペースをハイフンにして比較
var isEqualId = function isEqualId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var id2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (id) {
    id = id.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  }
  if (id2) {
    id2 = id2.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  }
  if (id === id2) {
    return true;
  } else {
    return false;
  }
};

// 大文字を小文字に、スペースをハイフンにフォーマット
var formatId = function formatId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (id) {
    return id.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  } else {
    return id;
  }
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wysiwyg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\wysiwyg\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line no-unused-vars





// const Wysiwyg = ({
//   containerId,
//   containerClass,
//   htmlText,
// }) => (
//   htmlText ?
//     <Wrapper
//       containerId={containerId}
//       containerClass={containerClass}
//     >
//       <div className="Wysiwyg" dangerouslySetInnerHTML={{__html: htmlText}}/>
//     </Wrapper> :
//     null
// );
//
// Wysiwyg.propTypes = {
//   containerId: PropTypes.string,
//   containerClass: PropTypes.string,
//   htmlText: PropTypes.string,
// };
//
// Wysiwyg.defaultProps = {
//   containerId: null,
//   containerClass: null,
//   htmlText: null,
// };

// export default Wysiwyg;

var Wysiwyg = (_temp = _class = function (_Component) {
  _inherits(Wysiwyg, _Component);

  function Wysiwyg(props) {
    _classCallCheck(this, Wysiwyg);

    // this.state = {
    //   firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    // };
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.refsContent = null;
    return _this;
  }
  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }


  Wysiwyg.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        htmlText = _props.htmlText;


    if (!htmlText) {
      return null;
    }

    var isColumnLauoutMode = false;
    if (this.props.parentColumn === 'oneColumnLayout' || this.props.parentColumn === 'twoColumnLayout' || this.props.parentColumn === 'threeColumnLayout' || this.props.parentColumn === 'fourColumnLayout') {
      isColumnLauoutMode = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'Wysiwyg' + (isColumnLauoutMode === true ? ' column-layout' : ''),
        dangerouslySetInnerHTML: { __html: htmlText },
        ref: function ref(component) {
          return _this2.refsContent = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      })
    );
  };

  return Wysiwyg;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  htmlText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inFeatureCategoriesHorizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parentColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  htmlText: null,
  inFeatureCategoriesHorizontal: false,
  parentColumn: null
}, _temp);
Wysiwyg.displayName = 'Wysiwyg';


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sub_footer_navigation__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_page__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__promo_navigation_container__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__promo_navigation__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_navigation__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sub_navigation__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hero_image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hero_video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hero_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__standard_page__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__full_width__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__slideshow__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__photogallery_item__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__slidegallery__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__slidegallery_item__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__feature_categories__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__feature_category_container__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__picker__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__picker_container__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__picker_item__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__exterior_view__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__promo_slider__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__equipment__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__equipment_container__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__maker_set_option__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__spec_comparison__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__grade_and_spec__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__grade_and_spec_data__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__car_lineup__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__car_lineup_filter__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__car_lineup_filter_item__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__car_navigation__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__car_navigation_link_item__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__credit_plan__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__accordion_container__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__accordion_item__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__cta_navigation__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__accessory_list__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__accessory_body_type_tab_name__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__accessory_detail_page__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__accessory_detail_content__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__accessory_info_container__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__accessory_info_item__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__interior360__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__interior360_item__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationSample", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Html", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FooterNavigation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SocialIconsContainerBlock", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubFooterNavigation", function() { return __WEBPACK_IMPORTED_MODULE_2__sub_footer_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HomePage", function() { return __WEBPACK_IMPORTED_MODULE_3__home_page__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SiteSearch", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PrimaryNavigation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PromoNavigationItem", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["D"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PromoNavigationContainer", function() { return __WEBPACK_IMPORTED_MODULE_4__promo_navigation_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PromoNavigation", function() { return __WEBPACK_IMPORTED_MODULE_5__promo_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalNavigation", function() { return __WEBPACK_IMPORTED_MODULE_6__global_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return __WEBPACK_IMPORTED_MODULE_7__header__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubNavigation", function() { return __WEBPACK_IMPORTED_MODULE_8__sub_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhotoInfo", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeroVideo", function() { return __WEBPACK_IMPORTED_MODULE_10__hero_video__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeroImage", function() { return __WEBPACK_IMPORTED_MODULE_9__hero_image__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeroCarousel", function() { return __WEBPACK_IMPORTED_MODULE_11__hero_carousel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StandardPage", function() { return __WEBPACK_IMPORTED_MODULE_12__standard_page__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FullWidth", function() { return __WEBPACK_IMPORTED_MODULE_13__full_width__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Video", function() { return __WEBPACK_IMPORTED_MODULE_14__video__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RelatedVideo", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Promo", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Wysiwyg", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["L"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OneColumnLayout", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TwoColumnLayout", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["K"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThreeColumnLayout", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["J"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FourColumnLayout", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slideshow", function() { return __WEBPACK_IMPORTED_MODULE_15__slideshow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Presentation", function() { return __WEBPACK_IMPORTED_MODULE_16__presentation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PresentationItem", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Photogallery", function() { return __WEBPACK_IMPORTED_MODULE_17__photogallery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhotogalleryItem", function() { return __WEBPACK_IMPORTED_MODULE_18__photogallery_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhotogalleryLayout", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slidegallery", function() { return __WEBPACK_IMPORTED_MODULE_19__slidegallery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SlidegalleryItem", function() { return __WEBPACK_IMPORTED_MODULE_20__slidegallery_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cta", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeatureCategories", function() { return __WEBPACK_IMPORTED_MODULE_21__feature_categories__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeatureCategoryContainer", function() { return __WEBPACK_IMPORTED_MODULE_22__feature_category_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Picker", function() { return __WEBPACK_IMPORTED_MODULE_23__picker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerContainer", function() { return __WEBPACK_IMPORTED_MODULE_24__picker_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PickerItem", function() { return __WEBPACK_IMPORTED_MODULE_25__picker_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabNavigation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ExteriorView", function() { return __WEBPACK_IMPORTED_MODULE_26__exterior_view__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ExteriorViewAccessories", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PromoSlider", function() { return __WEBPACK_IMPORTED_MODULE_27__promo_slider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BodySize", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Equipment", function() { return __WEBPACK_IMPORTED_MODULE_28__equipment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentContainer", function() { return __WEBPACK_IMPORTED_MODULE_29__equipment_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentItem", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MakerSetOptionMoreInfoItem", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MakerSetOption", function() { return __WEBPACK_IMPORTED_MODULE_30__maker_set_option__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SpecComparison", function() { return __WEBPACK_IMPORTED_MODULE_31__spec_comparison__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OwnerLibraryContainer", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GradeAndSpecData", function() { return __WEBPACK_IMPORTED_MODULE_33__grade_and_spec_data__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GradeAndSpec", function() { return __WEBPACK_IMPORTED_MODULE_32__grade_and_spec__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EcoTax", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarLineup", function() { return __WEBPACK_IMPORTED_MODULE_34__car_lineup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarLineupFilter", function() { return __WEBPACK_IMPORTED_MODULE_35__car_lineup_filter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarLineupFilterItem", function() { return __WEBPACK_IMPORTED_MODULE_36__car_lineup_filter_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagenation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarNavigation", function() { return __WEBPACK_IMPORTED_MODULE_37__car_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarNavigationLinkItem", function() { return __WEBPACK_IMPORTED_MODULE_38__car_navigation_link_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CreditPlan", function() { return __WEBPACK_IMPORTED_MODULE_39__credit_plan__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OwnerLibrary", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionContainer", function() { return __WEBPACK_IMPORTED_MODULE_40__accordion_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItem", function() { return __WEBPACK_IMPORTED_MODULE_41__accordion_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnchorNavigation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbNavigation", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CTANavigation", function() { return __WEBPACK_IMPORTED_MODULE_42__cta_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DriversVoice", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryList", function() { return __WEBPACK_IMPORTED_MODULE_43__accessory_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryBodyTypeTabName", function() { return __WEBPACK_IMPORTED_MODULE_44__accessory_body_type_tab_name__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryDetailPage", function() { return __WEBPACK_IMPORTED_MODULE_45__accessory_detail_page__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryDetailContent", function() { return __WEBPACK_IMPORTED_MODULE_46__accessory_detail_content__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryInfoContainer", function() { return __WEBPACK_IMPORTED_MODULE_47__accessory_info_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessoryInfoItem", function() { return __WEBPACK_IMPORTED_MODULE_48__accessory_info_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarsComparison", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DealerDetailContent", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sitemap", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EstimationHistory", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PromoAndButtonModalWindow", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MyMazda", function() { return __WEBPACK_IMPORTED_MODULE_0_containers__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Interior360", function() { return __WEBPACK_IMPORTED_MODULE_49__interior360__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Interior360Item", function() { return __WEBPACK_IMPORTED_MODULE_50__interior360_item__["a"]; });
// Import Containers


// Import Components


// Import Blocks
// WP1


// WP2









// WP3








// WP4







// WP5









// WP6



// WP7










// 2021/08



// Export All


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\cta\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















/**
 *  Cta
 */
var Cta = (_temp = _class = function (_PureComponent) {
  _inherits(Cta, _PureComponent);

  function Cta(props) {
    _classCallCheck(this, Cta);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.getCookie = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */] || !__WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].cookie) {
        return false;
      }
      var cookies = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].cookie.split(';');
      for (var i = 0; i < cookies.length; i += 1) {
        var cookie = cookies[i].split('=');
        if (cookie[0].trim() === key) {
          return cookie[1].trim();
        }
      }

      return false;
    };

    _this.getQuery = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location) {
        return false;
      }
      var params = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location.search.substring(1).split('&');
      for (var i = 0; i < params.length; i += 1) {
        var param = params[i].split('=');
        if (param[0].trim() === key) {
          return param[1].trim();
        }
      }
      return false;
    };

    _this.getCarIdForAkamai = function (queryCarId, cookieCarId) {
      if (!__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS || !Array.isArray(__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS) || __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS.length === 0) {
        return '';
      }

      var pathname = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location.pathname;
      var result = pathname.match(/\/cars\/(.+?)\//);
      var modelname = result ? result[1] : '';
      var resultRoadsterRf = pathname.match(/\/cars\/(roadster-rf)\//);

      // URL の Modelname が「roadster-rf」の場合
      if (resultRoadsterRf != null) {
        return '';
      }

      // MZD_CARINFO_SETTINGS の Modelname と CarId が一致する場合
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS.length; i += 1) {
        var setting = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS[i];
        if (setting.ModelName === modelname && setting.ModelName === setting.CarId) {
          return '';
        }
      }

      // URL の 「car_id=xxx」が付与されている場合
      if (queryCarId) {
        return queryCarId;
      }

      // coookieにmjcaridが存在しない場合
      if (!cookieCarId) {
        return '';
      }

      // MZD_CARINFO_SETTINGS の CarId と mjcarid が合致する場合
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS.length; _i += 1) {
        var _setting = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS[_i];
        if (_setting.ModelName === modelname && _setting.CarId === cookieCarId) {
          return cookieCarId;
        }
      }

      return '';
    };

    _this.props = props;
    return _this;
  }

  Cta.prototype.componentDidMount = function componentDidMount() {
    // WINDOW.MZD_CARINFO_SETTINGS = [
    //   {
    //     BodyTypeModel: 'MAZDA2', VehicleType: 'PassengerCar', CarNavigationNumber: '1', ModelName: 'mazda2', CarId: 'mazda2', CarTypeCode: 'DJ1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA3 FASTBACK', VehicleType: 'PassengerCar', CarNavigationNumber: '2', ModelName: 'mazda3', CarId: 'mazda3-fastback', CarTypeCode: 'BP2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA3 SEDAN', VehicleType: 'PassengerCar', CarNavigationNumber: '3', ModelName: 'mazda3', CarId: 'mazda3-sedan', CarTypeCode: 'BP1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA6 SEDAN', VehicleType: 'PassengerCar', CarNavigationNumber: '4', ModelName: 'mazda6', CarId: 'mazda6-sedan', CarTypeCode: 'AS1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA6 WAGON', VehicleType: 'PassengerCar', CarNavigationNumber: '5', ModelName: 'mazda6', CarId: 'mazda6-wagon', CarTypeCode: 'AW2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-3', VehicleType: 'PassengerCar', CarNavigationNumber: '6', ModelName: 'cx-3', CarId: 'cx-3', CarTypeCode: 'DK4'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-5', VehicleType: 'PassengerCar', CarNavigationNumber: '7', ModelName: 'cx-5', CarId: 'cx-5', CarTypeCode: 'KF4'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-8', VehicleType: 'PassengerCar', CarNavigationNumber: '8', ModelName: 'cx-8', CarId: 'cx-8', CarTypeCode: 'GK2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA ROADSTER', VehicleType: 'PassengerCar', CarNavigationNumber: '9', ModelName: 'roadster', CarId: 'roadster', CarTypeCode: 'RS2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA ROADSTER RF', VehicleType: 'PassengerCar', CarNavigationNumber: '10', ModelName: 'roadsterrf', CarId: 'roadsterrf', CarTypeCode: 'RF2'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR', VehicleType: 'LightCar', CarNavigationNumber: '1', ModelName: 'flair', CarId: 'flair', CarTypeCode: 'MJ6'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR WAGON', VehicleType: 'LightCar', CarNavigationNumber: '2', ModelName: 'flair-wagon', CarId: 'flair-wagon', CarTypeCode: 'MM6'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR CROSSOVER', VehicleType: 'LightCar', CarNavigationNumber: '3', ModelName: 'flair-crossover', CarId: 'flair-crossover', CarTypeCode: 'ZK4'
    //   },
    //   {
    //     BodyTypeModel: 'CAROL', VehicleType: 'LightCar', CarNavigationNumber: '4', ModelName: 'carol', CarId: 'carol', CarTypeCode: 'HB1'
    //   },
    //   {
    //     BodyTypeModel: 'SCRUM WAGON', VehicleType: 'LightCar', CarNavigationNumber: '5', ModelName: 'scrum-wagon', CarId: 'scrum-wagon', CarTypeCode: 'DG2'
    //   }
    // ]

    var href = null;

    var query_car_id = this.getQuery('car_id');

    var cookie_car_id = this.getCookie('mjcarid');

    // console.log('query_car_id', query_car_id);
    // console.log('cookie_car_id', cookie_car_id);

    // axelaかatenzaのとき、この単語がmjcaridに含まれていなければ、Cookieを見ない
    if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */]) {
      var pathname = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location.pathname; // ex: '/cars/atenza/safety/'
      var result = pathname.match(/\/cars\/(axela|atenza)\//);
      if (result != null && cookie_car_id !== false && cookie_car_id.indexOf(result[1]) === -1) {
        cookie_car_id = false;
      }
    }

    // let car_id = query_car_id || (cookie_car_id || '')

    var car_id = this.getCarIdForAkamai(query_car_id, cookie_car_id);

    switch (this.props.ctaType) {
      case 'Testdrive':
        car_id = car_id !== '' ? car_id : this.props.urlParams.testdrive && this.props.urlParams.testdrive !== '' ? this.props.urlParams.testdrive : '';
        href = '/purchase/testdrive/';
        href += car_id !== '' ? '?car_id=' + car_id : '';
        this.refs.link.href = href;
        break;
      case 'Estimate':
        car_id = car_id !== '' ? car_id : this.props.urlParams.estimate && this.props.urlParams.estimate !== '' ? this.props.urlParams.estimate : '';
        // href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';
        // href += car_id !== '' ? ('edit.html?car_id=' + car_id) : '';
        href = 'https://www.mazda.co.jp/purchase/estimate/';
        href += car_id !== '' ? '?car_id=' + car_id : '';
        this.refs.link.href = href;
        break;
      case 'Catalog':
        car_id = this.props.urlParams.catalog && this.props.urlParams.catalog !== '' ? this.props.urlParams.catalog : '';
        // href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/catalog/': 'https://ssl.mazda.co.jp/purchase/catalog/';
        href = 'https://my.mazda.co.jp/purchase/catalog/';
        href += car_id !== '' ? car_id : 'index.html';
        this.refs.link.href = href;
        break;
      case 'Cars-Comparison':
        car_id = car_id !== '' ? car_id : this.props.urlParams.comparison && this.props.urlParams.comparison !== '' ? this.props.urlParams.comparison : '';
        href = '/purchase/compare/';
        href += car_id !== '' ? '?car_id1=' + car_id : '';
        this.refs.link.href = href;
        break;
      default:
    }
  };

  Cta.prototype.componentWillUnmount = function componentWillUnmount() {};

  // Akamai対応のためのロジック改修
  // return '' したものは car_id のデフォルト値が適用される


  Cta.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        ctaType = _props.ctaType,
        href = _props.href,
        text = _props.text,
        targetBlank = _props.targetBlank,
        linkType = _props.linkType,
        iconSrc = _props.iconSrc,
        hoverIconSrc = _props.hoverIconSrc,
        color = _props.color,
        buttonStyle = _props.buttonStyle,
        additionalClass = _props.additionalClass,
        urlParams = _props.urlParams,
        handleClick = _props.handleClick,
        buttonLength = _props.buttonLength;


    var new_href = void 0;
    var new_text = void 0;
    var new_icon = void 0;
    var new_icon_hover = void 0;

    switch (ctaType) {
      case 'Dealer':
        new_href = 'http://www.mazda.co.jp/purchase/dealer/';
        new_text = '販売店検索';
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_6__icon_dealer_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_5__icon_dealer_dark_png___default.a;
          }
        }
        break;
      case 'Testdrive':
        new_href = '/purchase/testdrive/';
        new_href += urlParams.testdrive && urlParams.testdrive !== '' ? '?car_id=' + urlParams.testdrive : '';
        new_text = '試乗車検索';
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_8__icon_testdrive_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_7__icon_testdrive_dark_png___default.a;
          }
        }
        break;
      case 'Estimate':
        new_href = 'https://ssl.mazda.co.jp/purchase/estimate/';
        new_href += urlParams.estimate && urlParams.estimate !== '' ? 'edit.html?car_id=' + urlParams.estimate : '';
        new_text = 'カンタン見積り';
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_10__icon_estimate_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_9__icon_estimate_dark_png___default.a;
          }
        }
        break;
      case 'Catalog':
        new_href = 'https://ssl.mazda.co.jp/purchase/catalog/';
        new_href += urlParams.catalog && urlParams.catalog !== '' ? urlParams.catalog : '';
        new_text = 'カタログ請求';
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_dark_png___default.a;
          }
        }
        break;
      case 'Cars-Comparison':
        new_href = '/purchase/compare/';
        new_text = '車種比較';
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            } else {
              new_icon = __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default.a;
              new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
          } else {
            new_icon = __WEBPACK_IMPORTED_MODULE_14__icon_cars_comparison_light_png___default.a;
            new_icon_hover = __WEBPACK_IMPORTED_MODULE_13__icon_cars_comparison_dark_png___default.a;
          }
        }
        break;
      default:
        new_href = href && href !== '' ? href : '';
        new_text = text && text !== '' ? text : '';
        new_icon = iconSrc && iconSrc !== '' ? iconSrc : '';
        new_icon_hover = hoverIconSrc && hoverIconSrc !== '' ? hoverIconSrc : '';
    }

    var cta_container_attrs = {
      className: ['Cta__container', color && color !== '' ? 'Cta__container--' + color : null].join(' ')

      // const cta_button_attrs = {
      //   href: new_href,
      //   target: (targetBlank && targetBlank !== '' && targetBlank === true) ? '_blank': '',
      //   className: [
      //     'Cta__button',
      //     (linkType && linkType !== '') ? 'Cta__button--linkType--' + linkType: null,
      //     (buttonStyle && buttonStyle !== '') ? 'Cta__button--buttonStyle--' + buttonStyle: null,
      //     (additionalClass && additionalClass !== '') ? additionalClass: null,
      //   ].join(' '),
      // };
      //

    };var props = null;
    if (handleClick !== null) {
      new_href = 'javascript:void(0)';
      props = {
        onClick: function onClick(e) {
          e.preventDefault();
          handleClick(e);
        }
      };
    }

    var renderText = function renderText() {

      var cls = '';
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["c" /* IS_ANDROID */]) {
        cls = ' isAndroid';
      }

      if (buttonStyle === 'CTA-Navi') {
        if (0 <= new_text.indexOf('|')) {
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */]) {
            if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].matchMedia('(max-width: 767px)').matches) {
              new_text = new_text.replace('|', '<br />');
              return new_text && new_text !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Cta__button__text' + cls, dangerouslySetInnerHTML: { __html: new_text }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 516
                }
              }) : '';
            } else {
              new_text = new_text.replace('|', '');
              return new_text && new_text !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'Cta__button__text' + cls, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 521
                  }
                },
                new_text
              ) : '';
            }
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */]) {
            if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].matchMedia('(max-width: 320px)').matches) {
              if ((3 === buttonLength || 5 <= buttonLength) && 7 <= new_text.length) {
                return new_text && new_text !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'Cta__button__text' + cls, style: { letterSpacing: '-0.1em' }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 530
                    }
                  },
                  new_text
                ) : '';
              }
            }
          }
        }
      }

      // if (buttonStyle === 'CTA-Navi' && 0 <= new_text.indexOf('|')) {
      //   if (WINDOW) {
      //     if (WINDOW && WINDOW.matchMedia('(max-width: 767px)').matches) {
      //       new_text = new_text.replace('|', '<br />')
      //       return (
      //         (new_text && new_text !== '') ? <span className="Cta__button__text" dangerouslySetInnerHTML={{__html: new_text}} /> : ''
      //       )
      //     } else {
      //       new_text = new_text.replace('|', '')
      //       return (
      //         (new_text && new_text !== '') ? <span className="Cta__button__text">{new_text}</span> : ''
      //       )
      //     }
      //   }
      // }

      new_text = new_text.replace('|', '');
      return new_text && new_text !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'Cta__button__text' + cls, __source: {
            fileName: _jsxFileName,
            lineNumber: 556
          }
        },
        new_text
      ) : '';
    };

    var renderIcon = function renderIcon() {
      if (linkType === 'Button-With-Icon' || linkType === 'Text-With-Icon' || buttonStyle === 'CTA-Navi') {
        // const iconStyle = { backgroundImage: 'url(' + new_icon + ')' }
        // const iconStyleHover = { backgroundImage: 'url(' + new_icon_hover + ')' }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'Cta__button__icon__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 565
            }
          },
          new_icon && new_icon !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: new_icon, className: 'Cta__button__icon', __source: {
              fileName: _jsxFileName,
              lineNumber: 566
            }
          }) : null,
          new_icon_hover && new_icon_hover !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: new_icon_hover, className: 'Cta__button__icon--hover', __source: {
              fileName: _jsxFileName,
              lineNumber: 567
            }
          }) : null
        );
      }
      return null;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass, __source: {
          fileName: _jsxFileName,
          lineNumber: 575
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Cta', __source: {
            fileName: _jsxFileName,
            lineNumber: 578
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({}, cta_container_attrs, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 579
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            _extends({}, props, {
              ref: 'link',
              href: new_href,
              target: targetBlank && targetBlank !== '' && targetBlank === true ? '_blank' : '',
              className: function () {
                return ['Cta__button', linkType && linkType !== '' ? 'Cta__button--linkType--' + linkType : null, buttonStyle && buttonStyle !== '' ? 'Cta__button--buttonStyle--' + buttonStyle : null, additionalClass && additionalClass !== '' ? additionalClass : null, function () {
                  if (5 <= buttonLength) {
                    return 'Cta__button--buttonLength--5';
                  } else if (1 <= buttonLength) {
                    return 'Cta__button--buttonLength--' + buttonLength;
                  }
                  return null;
                }()].join(' ');
              }(), __source: {
                fileName: _jsxFileName,
                lineNumber: 580
              }
            }),
            function () {
              if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */]) {
                if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].matchMedia('(max-width: 767px)').matches) {
                  if (buttonStyle === 'CTA-Navi') {
                    if (4 <= buttonLength) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Cta__button__container', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 607
                          }
                        },
                        renderIcon(),
                        renderText()
                      );
                    } else {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Cta__button__container', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 614
                          }
                        },
                        renderText(),
                        renderIcon()
                      );
                    }
                  } else {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 622
                        }
                      },
                      renderText(),
                      renderIcon()
                    );
                  }
                }
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 631
                  }
                },
                renderText(),
                renderIcon()
              );
            }()
          )
        )
      )
    );
  };

  return Cta;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ctaType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  linkType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hoverIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  additionalClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  urlParams: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    testdrive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    estimate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    catalog: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    comparison: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  buttonLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  ctaType: null,
  href: null,
  text: null,
  targetBlank: null,
  linkType: null,
  iconSrc: null,
  hoverIconSrc: null,
  color: null,
  buttonStyle: null,
  additionalClass: null,
  urlParams: null,
  handleClick: null,
  buttonLength: null
}, _temp);
Cta.displayName = 'Cta';


/* harmony default export */ __webpack_exports__["a"] = (Cta);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\slider\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Slider = (_temp = _class = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.slickGoTo = function (index, dontAnimate) {
      _this.refs.slick.slickGoTo(index, dontAnimate);
    };

    _this.beforeChange = function (old, current) {
      //console.log(old + ' > ' + current);
      //
      var isNext = false;
      if (current === 0) {
        if (_this.currentIndex === 1) {
          isNext = false;
        } else if (_this.currentIndex === _this.props.children.length - 1) {
          isNext = true;
        } else {
          if (_this.currentIndex < current) {
            isNext = true;
          } else {
            isNext = false;
          }
        }
      } else if (current === _this.props.children.length - 1) {
        if (_this.currentIndex === 0) {
          isNext = false;
        } else if (_this.currentIndex === _this.props.children.length - 2) {
          isNext = true;
        } else {
          if (_this.currentIndex < current) {
            isNext = true;
          } else {
            isNext = false;
          }
        }
      } else {
        if (_this.currentIndex < current) {
          isNext = true;
        } else {
          isNext = false;
        }
      }
      _this.currentIndex = current;
      //
      if (_this.next) {
        _this.next.classList.remove('next');
        _this.next.classList.remove('change');
        if (isNext) {
          _this.next.classList.add('next');
        } else {
          _this.next.classList.add('change');
        }
      }
      if (_this.prev) {
        _this.prev.classList.remove('prev');
        _this.prev.classList.remove('change');
        if (!isNext) {
          _this.prev.classList.add('prev');
        } else {
          _this.prev.classList.add('change');
        }
      }
    };

    _this.settingsObj = {};
    if (_this.props.settings === null) {
      _this.settingsObj = {
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        fade: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        swipe: true,
        draggable: false,
        arrows: true,
        dots: true,
        adaptiveHeight: false,
        centerMode: false,
        centerPadding: 0,
        lazyLoad: 'progressive',
        waitForAnimate: false,
        beforeChange: function beforeChange(old, current) {
          _this.beforeChange(old, current);
        },
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }]
      };
    } else {
      if (!_this.props.settings.beforeChange) {
        _this.props.settings.beforeChange = function (old, current) {
          _this.beforeChange(old, current);
        };
      }
      _this.settingsObj = _this.props.settings;
    }
    _this.next = null;
    _this.prev = null;
    _this.currentIndex = 0;
    return _this;
  }

  Slider.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Slide', ref: 'slide', __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
        _extends({}, this.settingsObj, { ref: 'slick', __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        }),
        this.props.children
      )
    );
  };

  Slider.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.next = this.refs.slide.getElementsByClassName('slick-next')[0];
    if (this.next) {
      this.next.addEventListener('animationend', function () {
        _this2.next.classList.remove('change');
        _this2.next.classList.remove('next');
      });
    }
    this.prev = this.refs.slide.getElementsByClassName('slick-prev')[0];
    if (this.prev) {
      this.prev.addEventListener('animationend', function () {
        _this2.prev.classList.remove('change');
        _this2.prev.classList.remove('prev');
      });
    }
  };

  //


  //


  return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
}, _class.defaultProps = {
  children: null,
  settings: null
}, _temp);
Slider.displayName = 'Slider';


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Promo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Promo = (_temp = _class = function (_Component) {
  _inherits(Promo, _Component);

  Promo.imgTag = function imgTag(src) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Promo__image';

    if (!src) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: src, alt: '', className: baseClass + ' ' + baseClass + (suffix ? '-' : '') + suffix, __source: {
        fileName: _jsxFileName,
        lineNumber: 47
      }
    });
  };

  Promo.descriptionTag = function descriptionTag(description) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Promo__wysiwyg';

    if (!description) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: '' + baseClass + (suffix ? '-' : '') + suffix + ' Wysiwyg',
      dangerouslySetInnerHTML: { __html: description },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55
      }
    });
  };

  /**
   * `Image-On-Left(60:40)` to `image-on-left-60_40`
   * @param {string} className `pcLayout` / `mbLayout` value
   * @returns {string} valid css name
   * @see https://www.w3.org/TR/CSS21/grammar.html#scanner
   */


  Promo.convert = function convert(className) {
    return className.toLowerCase().replace(/[\/|:]/g, '_').replace(/[)]/g, '').replace(/[(]/g, '-');
  };

  function Promo(props) {
    _classCallCheck(this, Promo);

    // if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
    //   console.log('hasBackground(Promo) : ' + true);
    // } else {
    //   console.log('hasBackground(Promo) : ' + false);
    // }
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    if (_this.props.getRef) _this.props.getRef(_this);
    _this.state = {
      containerHeight: null
      // firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    };
    _this.refsContainer = null;
    return _this;
  }

  Promo.prototype.layoutClass = function layoutClass() {
    var _props = this.props,
        pcLayout = _props.pcLayout,
        mbLayout = _props.mbLayout;

    var pcClass = pcLayout || 'Image-On-Top';
    var mbClass = mbLayout || pcClass;
    return {
      pc: 'pcLayout__' + Promo.convert(pcClass),
      mb: 'mbLayout__' + Promo.convert(mbClass)
    };
  };

  Promo.prototype.renderFigures = function renderFigures() {
    var _this2 = this;

    var getStyle = function getStyle() {
      if (_this2.props.link && _this2.props.link.href && _this2.props.link.href !== '') {
        return null;
      } else {
        return {
          backgroundColor: 'transparent'
        };
      }
    };

    var _props2 = this.props,
        pcSrc = _props2.pcSrc,
        mbSrc = _props2.mbSrc;

    var pcImg = pcSrc || '';
    var mbImg = mbSrc || pcImg;
    if (!pcImg && !mbImg) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Promo__image__block', style: getStyle(), __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        }
      },
      Promo.imgTag(pcImg, 'pc'),
      Promo.imgTag(mbImg, 'mb')
    );
  };

  Promo.prototype.renderDescriptions = function renderDescriptions() {
    var _props3 = this.props,
        pcDescription = _props3.pcDescription,
        mbDescription = _props3.mbDescription;

    var pcHtml = pcDescription || '';
    var mbHtml = mbDescription || pcHtml;
    if (!pcHtml && !mbHtml) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Promo__text__block', __source: {
          fileName: _jsxFileName,
          lineNumber: 140
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Promo__wysiwyg', __source: {
            fileName: _jsxFileName,
            lineNumber: 141
          }
        },
        Promo.descriptionTag(pcHtml, 'pc'),
        Promo.descriptionTag(mbHtml, 'mb')
      )
    );
  };

  Promo.prototype.getContentsHeight = function getContentsHeight() {
    // console.log('getContentsHeight', this.refsContainer.clientHeight);
    // return this.refs.contents.clientHeight;
    // console.log('Promo.getContentsHeight', this.refsContainer.clientHeight, this.refsContainer.getBoundingClientRect());
    return this.refsContainer.clientHeight;
  };

  Promo.prototype.setContainerHeight = function setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height
      });
    }
    // this.setState({
    //   containerHeight: height,
    // })
  };

  Promo.prototype.clearContainerHeight = function clearContainerHeight() {
    if (this.state.containerHeight !== null) {
      this.setState({
        containerHeight: null
      });
    }
    // this.setState({
    //   containerHeight: null,
    // })
  };

  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }

  Promo.prototype.render = function render() {
    var _this3 = this;

    var _props4 = this.props,
        containerId = _props4.containerId,
        containerClass = _props4.containerClass,
        link = _props4.link;
    // ---

    var figures = this.renderFigures();
    var descriptions = this.renderDescriptions();
    if (!figures && !descriptions) {
      return null;
    }
    // ---
    var Link = link && link.href ? 'a' : 'span';
    var attributes = {
      className: 'Promo__link'
    };
    if (Link === 'a') {
      attributes.href = link.href;
      if (link.targetBlank) {
        attributes.target = '_blank';
      }
    }
    // ---
    var layout = this.layoutClass();
    //
    var layout2 = null;
    if (this.props.hasBackground || this.props.backgroundColor && this.props.backgroundColor !== '') {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 227
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'Promo ' + layout.pc + ' ' + layout.mb + (layout2 ? ' ' + layout2 : ''),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 231
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, attributes, {
            style: this.props.backgroundColor ? { backgroundColor: '#' + this.props.backgroundColor.replace(/#/g, '') } : null,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 234
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Promo__wrapper',
              style: this.state.containerHeight ? { height: this.state.containerHeight } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 237
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Promo__container'
                // ref="contents"
                , ref: function ref(component) {
                  return _this3.refsContainer = component;
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 240
                }
              },
              figures,
              descriptions
            )
          )
        )
      )
    );
  };

  return Promo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  pcLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inFeatureCategoriesHorizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasBackground: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parentColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcDescription: null,
  mbDescription: null,
  pcSrc: null,
  mbSrc: null,
  link: null,
  pcLayout: null,
  mbLayout: null,
  backgroundColor: null,
  getRef: null,
  inFeatureCategoriesHorizontal: false,
  hasBackground: false,
  parentColumn: null
}, _temp);
Promo.displayName = 'Promo';


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_video__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_related_video__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\video\\index.jsx';





var VideoBlock = function VideoBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_video__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
VideoBlock.displayName = 'VideoBlock';
VideoBlock.displayName = 'Video';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_related_video__["a" /* default */]],
  mapInputToOutput: [['relatedVideo', 'relatedVideo']]
})(VideoBlock));

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\scroll-loader\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ScrollLoader = function (_Component) {
  _inherits(ScrollLoader, _Component);

  function ScrollLoader(props) {
    _classCallCheck(this, ScrollLoader);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleScrollAndResize = function () {
      if (_this.state.opened === true) return;
      var element = _this.ref.current;
      var scrollTop = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].pageYOffset;
      var clientRect = element.getBoundingClientRect();
      var top = scrollTop + clientRect.top;
      var windowHeight = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].innerHeight;
      if (windowHeight / 3 <= windowHeight - (top - scrollTop)) {
        if (_this.state.opened === false) {
          _this.setState({
            opened: true
          });
          __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].removeEventListener('resize', _this.handleScrollAndResize);
          __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', _this.handleScrollAndResize);
        }
      }
    };

    _this.state = {
      opened: false
    };
    _this.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }

  ScrollLoader.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var flg = false;
    if (this.ref.current) {
      var parentElement = this.ref.current.closest('.PromoAndButtonModalWindow-Modal') || null;
      if (parentElement) {
        flg = true;
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true
      });
    } else if (flg) {
      // プロモモーダルブロックのモーダル内の処理
      this.setState({
        opened: true
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.handleScrollAndResize);
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.handleScrollAndResize);
      setTimeout(function () {
        _this2.handleScrollAndResize();
      }, 200);
    }
  };

  ScrollLoader.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.handleScrollAndResize);
    __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.handleScrollAndResize);
  };

  ScrollLoader.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ScrollLoader' + (this.state.opened === true ? ' opened' : ''), ref: this.ref, __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        }
      },
      this.state.opened === true ? this.props.children : null
    );
  };

  //


  return ScrollLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollLoader.displayName = 'ScrollLoader';


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(62)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\accordion\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  Accordion
 */
var Accordion = (_temp = _class = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getPcText = function () {
      if (_this.props.pcText !== null) {
        return _this.props.pcText;
      }
      return _this.props.pageName;
    };

    _this.getMbText = function () {
      if (_this.props.mbText !== null) {
        return _this.props.mbText;
      } else {
        if (_this.props.pcText !== null) {
          return _this.props.pcText;
        }
      }
      return _this.props.pageName;
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      if (_this.state.open === true) {
        _this.setState({
          open: false,
          height: 0
        });
        if (_this.props.onClose !== null) _this.props.onClose();
      } else {
        _this.setState({
          open: true,
          height: _this.refs.wrap.clientHeight
        });
        if (_this.props.onOpen !== null) _this.props.onOpen();
      }
    };

    _this.handleResize = function () {
      if (_this.state.open === false || _this.props.simpleAnimation === true) return;
      _this.setState({ height: _this.refs.wrap.clientHeight });
    };

    _this.props = props;
    _this.state = {
      open: _this.props.open,
      height: 0
    };
    _this.intervalId = null;
    return _this;
  }

  Accordion.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this2.handleResize();
    }, 500);
    //this.handleResize();
  };

  // componentWillReceiveProps(nextProps) {
  //   if (this.state.open !== nextProps.open) {
  //     if (this.state.open === true) {
  //       this.setState({
  //         open: false,
  //         height: 0,
  //       });
  //       if (this.props.onClose !== null) this.props.onClose();
  //     } else {
  //       this.setState({
  //         open: true,
  //         height: this.refs.wrap.clientHeight,
  //       });
  //       if (this.props.onOpen !== null) this.props.onOpen();
  //     }
  //   }
  // };

  Accordion.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  Accordion.prototype.open = function open() {
    this.setState({
      open: true,
      height: this.refs.wrap.clientHeight
    });
    if (this.props.onOpen !== null) this.props.onOpen();
  };

  Accordion.prototype.close = function close() {
    this.setState({
      open: false,
      height: 0
    });
    if (this.props.onClose !== null) this.props.onClose();
  };

  Accordion.prototype.onResize = function onResize() {
    var _this3 = this;

    setTimeout(function () {
      _this3.handleResize();
    }, 200);
  };

  Accordion.prototype.render = function render() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'dl',
      {
        className: 'Accordion' + (this.props.enabled === true ? '--enabled' : '') + (this.state.open === true ? ' open' : '') + (this.props.simpleAnimation === true ? ' simpleAnimation' : '') + (this.props.current === true ? ' current' : ''), __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'dt',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'Accordion__title',
            href: 'javascript:void(0);',
            onClick: function onClick(e) {
              _this4.handleClick(e);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 104
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Accordion__title-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 110
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(this.getPcText()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 111
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Accordion__title-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 113
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(this.getMbText()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 114
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Accordion__title-icon', __source: {
              fileName: _jsxFileName,
              lineNumber: 116
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Accordion__title-icon2', __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          })
        )
      ),
      function () {
        if (_this4.props.simpleAnimation === false) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { className: 'Accordion__contents',
              style: { height: _this4.state.height },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 123
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Accordion__container',
                ref: 'wrap', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 126
                }
              },
              _this4.props.children !== null ? _this4.props.children : null
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { className: 'Accordion__contents', __source: {
                fileName: _jsxFileName,
                lineNumber: 134
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Accordion__container',
                ref: 'wrap', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 135
                }
              },
              _this4.props.children !== null ? _this4.props.children : null
            )
          );
        }
      }()
    );
  };

  //


  //


  //


  //


  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  simpleAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  pageName: null,
  pcText: null,
  mbText: null,
  open: false,
  children: null,
  simpleAnimation: false,
  enabled: false,
  onClose: null,
  onOpen: null,
  current: false
}, _temp);
Accordion.displayName = 'Accordion';


/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__body__ = __webpack_require__(8);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\modal-window\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ModalWindow = (_temp = _class = function (_Component) {
  _inherits(ModalWindow, _Component);

  function ModalWindow(props) {
    _classCallCheck(this, ModalWindow);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function () {
      if (_this.state.open === false) return;
      //
      _this.setState({
        height: window.parent.innerHeight
        //width: window.innerWidth
      });
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      //
      _this.close();
    };

    _this.onTouchMove = function (e) {
      e.preventDefault();
    };

    _this.props = props;
    _this.state = {
      open: _this.props.open,
      height: 0,
      //width: 0,
      type: _this.props.type,
      buttonType: null
    };

    // EPIServerのプレビュー時のモーダルの位置調整
    _this.wrapperScrollTop = 0;

    return _this;
  }

  ModalWindow.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  ModalWindow.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  //


  ModalWindow.prototype.open = function open(type, buttonType) {
    if (this.state.open === false) {

      // EPIServerのプレビュー時のモーダルの位置調整
      var isEpiServerPreview = false;
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
        var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          var wrapperHeight = wrapperElement.clientHeight;
          this.wrapperScrollTop = wrapperElement.scrollTop;
          var iframe = wrapperElement.querySelector('iframe');
          if (iframe) {
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.style.position = 'absolute';
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.style.top = -this.wrapperScrollTop + 'px';
            var headerElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
            if (headerElement) {
              headerElement.style.zIndex = 0;
            }
            iframe.style.height = wrapperHeight + 'px';
            isEpiServerPreview = true;
          }
          if (type === 'Dark' || type === 'Light') {
            this.setState({
              open: true,
              height: wrapperHeight,
              type: type,
              buttonType: buttonType
            });
          } else {
            this.setState({
              open: true,
              height: wrapperHeight,
              type: null,
              buttonType: null
            });
          }
        }
      }
      if (!isEpiServerPreview) {
        if (type === 'Dark' || type === 'Light') {
          this.setState({
            open: true,
            height: window.innerHeight,
            type: type,
            buttonType: buttonType
          });
        } else {
          this.setState({
            open: true,
            height: window.innerHeight,
            type: null,
            buttonType: null
          });
        }
        // // BODYのスクロール無効化
        // BodyControl.openModal();
      }

      // BODYのスクロール無効化
      __WEBPACK_IMPORTED_MODULE_4__body__["a" /* default */].openModal();

      if (this.props.onOpen !== null) this.props.onOpen();
    }
  };

  //


  ModalWindow.prototype.close = function close() {
    if (this.state.open === true) {

      // EPIServerのプレビュー時のモーダルの位置調整
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
        var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          var iframe = wrapperElement.querySelector('iframe');
          if (iframe) {
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.style.position = 'static';
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.style.top = 'auto';
            var headerElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
            if (headerElement) {
              headerElement.style.zIndex = 3000;
            }
            iframe.style.height = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight + 'px';
            wrapperElement.scrollTop = this.wrapperScrollTop;
          }
        }
      }

      this.setState({
        open: false,
        height: 0
        //width: 0
      });
      // BODYのスクロール無効化を解除
      __WEBPACK_IMPORTED_MODULE_4__body__["a" /* default */].closeModal();
      if (this.props.onClose !== null) this.props.onClose();
    }
  };

  //


  ModalWindow.prototype.setType = function setType(type, buttonType) {
    if (type === 'Dark' || type === 'Light') {
      this.setState({
        type: type,
        buttonType: buttonType
      });
    }
  };

  //


  ModalWindow.prototype.render = function render() {
    var children = this.props.children;
    //

    var typeClass = '';
    if (this.state.type === 'Dark') {
      typeClass = ' dark';
    } else if (this.state.type === 'Light') {
      typeClass = ' light';
    }
    //
    var buttonTypeClass = '';
    if (this.state.buttonType === 'Dark') {
      buttonTypeClass = ' dark';
    } else if (this.state.buttonType === 'Light') {
      buttonTypeClass = ' light';
    }
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ModalWindow' + (this.state.open === true ? ' open' : '') + typeClass,
        style: {
          height: this.state.height
          //width: this.state.width
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ModalWindow__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 184
          }
        },
        children !== null ? children : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'ModalWindow__link-close' + buttonTypeClass,
            href: 'javascript:void(0);',
            onClick: this.handleClick,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 186
            }
          },
          'CLOSE'
        )
      )
    );
  };

  //


  //


  //


  return ModalWindow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  open: false,
  type: 'Dark',
  children: null,
  onOpen: null,
  onClose: null
}, _temp);
ModalWindow.displayName = 'ModalWindow';


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// add fake Function#toString
// for correct work wrapped methods / constructors with methods like LoDash isNative
var global    = __webpack_require__(14)
  , hide      = __webpack_require__(35)
  , SRC       = __webpack_require__(49)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(34).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  if(typeof val == 'function'){
    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
    val.hasOwnProperty('name') || hide(val, 'name', key);
  }
  if(O === global){
    O[key] = val;
  } else {
    if(!safe)delete O[key];
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(81)
  , defined = __webpack_require__(37);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4)
  , core    = __webpack_require__(34)
  , fails   = __webpack_require__(19);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var $          = __webpack_require__(7)
  , createDesc = __webpack_require__(44);
module.exports = __webpack_require__(30) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(50);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prefixedValue, value, keepUnprefixed) {
  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
};

module.exports = exports["default"];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(247);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(37);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pipe; });
/* unused harmony export compose */
/* unused harmony export nAry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return curry; });
/* unused harmony export partial */
/* unused harmony export defer */
/* unused harmony export tap */
/* unused harmony export until */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invokeFuncs; });
var _this2 = this;

var PLACEHOLDER = Symbol('PLACEHOLDER');

var basePartial = function basePartial(fn, args) {
  return fn.bind.apply(fn, [null].concat(args));
};

var nextPlaceholderIdx = function nextPlaceholderIdx(args) {
  return args.indexOf(PLACEHOLDER);
};

var noop = function noop() {};

var identity = function identity(x) {
  return x;
};

var constant = function constant(x) {
  return function () {
    return x;
  };
};

var isFunction = function isFunction(t) {
  return t ? typeof t === 'function' : false;
};

var pipe = function pipe(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return function () {
    return rest.reduce(function (result, fn) {
      return fn(result);
    }, first.apply(undefined, arguments));
  };
};

var compose = function compose() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return pipe.apply(undefined, fns.reverse());
};

var nAry = function nAry(arity, fn) {
  if (fn === undefined) return function (cFn) {
    return nAry(arity, cFn);
  };
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return fn.apply(undefined, args.slice(0, arity));
  };
};

var unary = nAry(1);

var curry = function curry(fn) {
  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (nextPlaceholderIdx(args) === -1) {
      return args.length >= fn.length ? fn.apply(undefined, args) : curry(basePartial(fn, args));
    }

    return function () {
      for (var _len5 = arguments.length, nextArgs = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        nextArgs[_key5] = arguments[_key5];
      }

      var newArgs = args.map(function (v) {
        return v === PLACEHOLDER && nextArgs.length ? nextArgs.shift() : v;
      });
      newArgs = newArgs.concat(nextArgs);

      return newArgs.length >= fn.length && nextPlaceholderIdx(newArgs) === -1 ? fn.apply(undefined, newArgs) : curry(fn).apply(undefined, newArgs);
    };
  };
};

var partial = curry(basePartial);

var defer = function defer(fn) {
  return setTimeout(fn, 0);
};

var tap = curry(function (fn, x) {
  fn(x);
  return x;
});

function shallowRecursively(wrapper, selector) {
  // Do not try to shallow render empty nodes and host elements
  // (a.k.a primitives). Simply return the wrapper in that case.
  if (wrapper.isEmptyRender() || typeof wrapper.getElement().type === 'string') return wrapper;

  var nextWrapper = wrapper.dive();

  return selector && wrapper.is(selector) ? nextWrapper : shallowRecursively(nextWrapper, selector);
}

function until(selector) {
  var _this = this;

  return this.single('until', function () {
    return shallowRecursively(_this, selector);
  });
}

// Invoke an array of functions object that has the blueprint of {func: func, args: []}
var invokeFuncs = function invokeFuncs(functions) {
  if (Array.isArray(functions)) {
    functions.map(function (funcObj, i) {
      if (!funcObj) return;
      if (Array.isArray(funcObj.args)) {
        funcObj.func.apply(_this2, funcObj.args);
      } else {
        funcObj.func.call(_this2, funcObj.args);
      }
    });
  } else {
    console.warn('You did not pass an array to invokeFuncs');
  }
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["i"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["f"] = put;
/* unused harmony export all */
/* harmony export (immutable) */ __webpack_exports__["g"] = race;
/* harmony export (immutable) */ __webpack_exports__["c"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["e"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["d"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["h"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* unused harmony export takeEvery */
/* harmony export (immutable) */ __webpack_exports__["j"] = takeLatest;
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(244);



var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(626),
    getValue = __webpack_require__(629);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RelatedVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\related-video\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * 関連動画 `RelatedVideo`
 * - click で YouTube iframe.src を変更するのは使用側で行う
 * - `.RelatedVideo` に設定されている `data-yt` を取得します
 */
var RelatedVideo = (_temp = _class = function (_Component) {
  _inherits(RelatedVideo, _Component);

  function RelatedVideo() {
    _classCallCheck(this, RelatedVideo);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * `div.RelatedVideo__[pcTitle|mbTitle]` 作成します
   * @param {?string} title title text - {@link convertPipeToBrTag} します
   * @param {string} [suffix=''] [pcTitle|mbTitle]
   * @param {string} [alternate=''] title 不正値時の置換え文字
   * @param {string} [baseClass=RelatedVideo] class name 接頭詞
   * @returns {*} `div.RelatedVideo__[pcTitle|mbTitle]`
   */
  RelatedVideo.titleTag = function titleTag(title) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var alternate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var baseClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'RelatedVideo';

    var text = title !== null && title ? title : alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    var className = '' + baseClass + (suffix ? '__' : '') + suffix;
    // ReactElement
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
        fileName: _jsxFileName,
        lineNumber: 49
      }
    });
  };

  /**
   * `div.RelatedVideo__[pcDescription|mbDescription]` 作成します
   * @param {?string} title description text - {@link convertPipeToBrTag} します
   * @param {string} [suffix=''] [pcTitle|mbTitle]
   * @param {string} [alternate=''] title 不正値時の置換え文字
   * @param {string} [baseClass=RelatedVideo] class name 接頭詞
   * @returns {*} `div.RelatedVideo__[pcDescription|mbDescription]`
   */


  RelatedVideo.descriptionTag = function descriptionTag(title) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var alternate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var baseClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'RelatedVideo';

    var text = title !== null && title ? title : alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    var className = '' + baseClass + (suffix ? '__' : '') + suffix;
    // ReactElement
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
        fileName: _jsxFileName,
        lineNumber: 70
      }
    });
  };

  // constructor(props) {
  //     super(props);
  //     // ---
  //     // const youtubeId = props.youtubeId || '';
  //     // const path = youtubeId ? `//img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : '';
  //     // /**
  //     //  * React.state
  //     //  * - path - thumbnail path
  //     //  * @type {{path: string}}
  //     //  */
  //     // this.state = {
  //     //     path,
  //     // };
  // }
  /**
   * description を作成します - {@link RelatedVideo}.titleTag
   * @returns {?ReactElement} `div.RelatedVideo__descriptions`
   */


  RelatedVideo.prototype.renderDescriptions = function renderDescriptions() {
    var _props = this.props,
        pcDescription = _props.pcDescription,
        mbDescription = _props.mbDescription;

    var alternate = pcDescription || '';
    var pc = RelatedVideo.descriptionTag(pcDescription, 'pcDescription');
    var mb = RelatedVideo.descriptionTag(mbDescription, 'mbDescription', alternate);
    if (!pc && !mb) {
      return null;
    }
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'RelatedVideo__descriptions', __source: {
          fileName: _jsxFileName,
          lineNumber: 105
        }
      },
      pc,
      mb
    );
  };

  /**
   * description を作成します - {@link RelatedVideo}.descriptionTag
   * @returns {?ReactElement} `div.RelatedVideo__titles`
   */


  RelatedVideo.prototype.renderTitles = function renderTitles() {
    var _props2 = this.props,
        pcTitle = _props2.pcTitle,
        mbTitle = _props2.mbTitle;

    var alternate = pcTitle || '';
    var pc = RelatedVideo.titleTag(pcTitle, 'pcTitle');
    var mb = RelatedVideo.titleTag(mbTitle, 'mbTitle', alternate);
    if (!pc && !mb) {
      return null;
    }
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'RelatedVideo__titles', __source: {
          fileName: _jsxFileName,
          lineNumber: 129
        }
      },
      pc,
      mb
    );
  };

  /**
   * YouTube thumbnail `//img.youtube.com/vi/YOUTUBE_ID/maxresdefault.jpg`
   * @returns {?ReactElement} `div.RelatedVideo__thumb__block`
   */


  RelatedVideo.prototype.renderThumbnail = function renderThumbnail() {
    var youtubeId = this.props.youtubeId;

    var attributes = {
      className: 'RelatedVideo__thumb'
    };
    if (youtubeId) {
      var path = '//img.youtube.com/vi/' + youtubeId + '/maxresdefault.jpg';
      attributes.style = { backgroundImage: 'url(' + path + ')' };
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'RelatedVideo__thumb__block', __source: {
          fileName: _jsxFileName,
          lineNumber: 150
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151
        }
      }))
    );
  };

  /**
   * `div.RelatedVideo`
   * - {@link RelatedVideo.renderDescriptions}
   * - {@link RelatedVideo.renderTitles}
   * - {@link RelatedVideo.renderThumbnail}
   * @returns {?ReactElement} `div.RelatedVideo`
   */


  RelatedVideo.prototype.render = function render() {
    var _props3 = this.props,
        containerId = _props3.containerId,
        containerClass = _props3.containerClass,
        youtubeId = _props3.youtubeId;
    // require check
    // YouTube ID 不正の場合は出力しない

    if (!youtubeId) {
      return null;
    }
    // title
    var title = this.renderTitles();
    var description = this.renderDescriptions();
    // thumbnail
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'RelatedVideo',
        'data-yt': youtubeId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 179
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
        {
          containerId: containerId,
          containerClass: containerClass,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 183
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'RelatedVideo__link', onTouchStart: function onTouchStart(e) {}, __source: {
              fileName: _jsxFileName,
              lineNumber: 187
            }
          },
          this.renderThumbnail(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'RelatedVideo__text', __source: {
                fileName: _jsxFileName,
                lineNumber: 191
              }
            },
            title,
            description
          )
        )
      )
    );
  };

  return RelatedVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcTitle: null,
  mbTitle: null,
  pcDescription: null,
  mbDescription: null,
  youtubeId: null
}, _temp);
RelatedVideo.displayName = 'RelatedVideo';


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(35)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(540);
var objectAssign = __webpack_require__(79);
var decodeComponent = __webpack_require__(541);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocalStorageSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return persist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return load; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var cookies = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["a" /* DOCUMENT */] && new __WEBPACK_IMPORTED_MODULE_0_universal_cookie___default.a();

var getLocal = function getLocal(key) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].localStorage.getItem(key) || undefined;
};
var setLocal = function setLocal(key, value) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].localStorage.setItem(key, value);
};
var getCookie = function getCookie(key) {
  return cookies && cookies.get(key);
};
var setCookie = function setCookie(key, value) {
  return cookies && cookies.set(key, value, { path: '/' });
};

var isLocalStorageSupported = function isLocalStorageSupported() {
  if (__WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].localStorage) {
    var test = '__localstoragetest__';
    try {
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].localStorage.setItem(test, test);
      __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].localStorage.removeItem(test);
    } catch (ex) {
      console.log('localStorage not supported!');
      return false;
    }
    return true;
  }
  return false;
};

var persist = function persist(props) {
  return Object.keys(props).forEach(function (key) {
    var value = void 0;
    if (_typeof(props[key]) === 'object') {
      value = JSON.stringify(props[key]);
    } else {
      value = String(props[key]);
    }
    setCookie(key, value);
    // localStorage doesn't work in iOS Safari private mode, hence the checking
    if (isLocalStorageSupported()) {
      setLocal(key, value);
    }
  });
};

var load = function load(key) {
  var _persist;

  var fromCookie = getCookie(key);
  var fromLocal = getLocal(key);
  if (fromCookie) return fromCookie;

  if (fromLocal) persist((_persist = {}, _persist[key] = fromLocal, _persist));
  if (typeof fromLocal === 'string') {
    try {
      return JSON.parse(fromLocal);
    } catch (error) {
      return fromLocal;
    }
  }
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(241);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport all */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* unused harmony reexport takeEvery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* unused harmony reexport throttle */


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\one-column-layout\\index.jsx';
// eslint-disable-next-line no-unused-vars












/**
 * one column
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} components - 1カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.OneColumnLayout`
 */
var OneColumnLayout = function OneColumnLayout(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      anchorPoint = _ref.anchorPoint,
      anchorName = _ref.anchorName,
      backgroundColor = _ref.backgroundColor,
      size = _ref.size,
      resetUpperMargin = _ref.resetUpperMargin,
      setLowerMargin = _ref.setLowerMargin,
      nested = _ref.nested,
      components = _ref.components;

  if (components === null || !Array.isArray(components) || !components.length) {
    return null;
  }

  // ---
  var baseClass = 'OneColumnLayout';
  var sizeClass = 'size__' + (size || 'Full-Width').toLowerCase();
  var upperMargin = resetUpperMargin ? 'OneColumnLayout__resetUpperMargin' : '';
  var lowerMargin = setLowerMargin ? 'OneColumnLayout__setLowerMargin' : '';
  var nestedClass = nested ? 'OneColumnLayout__nested' : '';
  var classes = [baseClass, sizeClass, upperMargin, lowerMargin, nestedClass];
  // ---
  var attributes = {
    className: classes.filter(function (cssClass) {
      return cssClass;
    }).join(' ')
  };
  // if (backgroundColor) {
  //     attributes.style = { backgroundColor };
  // }
  // ---

  var getNestedComponents = function getNestedComponents(components) {
    var hasBackground = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return components.map(function (component, index) {
      var name = null;
      if (component.name) {
        name = component.name;
      } else if (component.type) {
        name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
        // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
      }
      if (name === 'Video') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks_video__["a" /* default */], _extends({}, component.props, {
          key: index,
          hasBackground: hasBackground,
          parentColumn: 'oneColumnLayout',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 78
          }
        }));
      } else if (name === 'Promo') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__promo__["a" /* default */], _extends({}, component.props, {
          key: index,
          hasBackground: hasBackground,
          parentColumn: 'oneColumnLayout',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        }));
      } else if (name === 'PromoAndButtonModalWindow') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__["a" /* default */], _extends({}, component.props, {
          key: index,
          hasBackground: hasBackground,
          parentColumn: 'oneColumnLayout',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 94
          }
        }));
      } else if (name === 'Wysiwyg') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__wysiwyg__["a" /* default */], _extends({}, component.props, {
          key: index,
          parentColumn: 'oneColumnLayout',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        }));
      } else {
        var Block = __WEBPACK_IMPORTED_MODULE_8__blocks__[name];
        if (Block) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          }));
        } else {
          return null;
        }
      }
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { id: anchorPoint, 'data-anchor-name': anchorName, __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 125
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OneColumnLayout__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 126
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'OneColumnLayout__column',
              style: backgroundColor && backgroundColor !== '' ? { backgroundColor: backgroundColor } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 127
              }
            },
            getNestedComponents(components, backgroundColor && backgroundColor !== '' ? true : false)
          )
        )
      )
    )
  );
};

OneColumnLayout.displayName = 'OneColumnLayout';
OneColumnLayout.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resetUpperMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setLowerMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  // components: PropTypes.arrayOf(PropTypes.node)
};

OneColumnLayout.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  backgroundColor: null,
  size: null,
  resetUpperMargin: null,
  setLowerMargin: null,
  nested: null,
  components: null
};

/* harmony default export */ __webpack_exports__["a"] = (OneColumnLayout);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TwoColumnLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\two-column-layout\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line no-unused-vars






//import { getComponents } from '../../utils'






/**
 * two columns
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?string} mbLayout - モバイル時のレイアウト方法（Horizontal / Vertical）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} firstContent - 2カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} secondContent - 2カラム第2コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.TwoColumnLayout`
 */
var TwoColumnLayout = (_temp = _class = function (_Component) {
  _inherits(TwoColumnLayout, _Component);

  function TwoColumnLayout(props) {
    _classCallCheck(this, TwoColumnLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getNestedComponents = function (components) {
      var hasBackground = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return components.map(function (component, index) {
        var name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
          // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
        }
        if (name === 'Video') {
          if (component.props.size) {
            component.props.size = 'Standard';
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks_video__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {
              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'twoColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 118
            }
          }));
        } else if (name === 'PromoAndButtonModalWindow') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {
              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'twoColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          }));
        } else if (name === 'Promo') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_promo__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {
              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'twoColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 142
            }
          }));
        } else if (name === 'Wysiwyg') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__wysiwyg__["a" /* default */], _extends({}, component.props, {
            key: index,
            parentColumn: 'twoColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 154
            }
          }));
        }
        // else {
        //   let Block = blocks[name];
        //   if (Block) {
        //     return <Block {...component.props} key={index}/>
        //   } else {
        //     return null;
        //   }
        // }
        var Block = __WEBPACK_IMPORTED_MODULE_8__blocks__[name];
        return Block ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 169
          }
        })) : null;
      });
    };

    _this.props = props;
    _this.components = [];
    _this.onResize = _this.onResize.bind(_this);
    _this.timer = {
      fitHeight: 0
    };
    _this.intervalId = null;
    return _this;
  }

  TwoColumnLayout.prototype.onResize = function onResize() {
    this.clearMaxHeight();
    this.delayGetAndSetMaxHeight();
  };

  TwoColumnLayout.prototype.clearMaxHeight = function clearMaxHeight() {
    this.components.filter(function (component) {
      return component && component.clearContainerHeight;
    }).map(function (component) {
      return component.clearContainerHeight();
    });
  };

  TwoColumnLayout.prototype.delayGetAndSetMaxHeight = function delayGetAndSetMaxHeight() {
    var _this2 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16 * 10;

    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(function () {
      _this2.getAndSetMaxHeight();
    }, delay);
  };

  TwoColumnLayout.prototype.getAndSetMaxHeight = function getAndSetMaxHeight() {
    var results = this.components.map(function (component) {
      if (component && component.getContentsHeight) {
        return component.getContentsHeight();
      }
      return 0;
    });
    results.sort(function (a, b) {
      return b - a;
    });
    var maxHeight = results[0];
    // console.log('ThreeColumnLayout.getAndSetMaxHeight', maxHeight, this.components);
    this.components.filter(function (component) {
      return component && component.setContainerHeight;
    }).map(function (component) {
      return component.setContainerHeight(maxHeight);
    });
  };

  TwoColumnLayout.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    // window.addEventListener('resize', this.handleResize);
    // setTimeout(() => {
    //   this.handleResize();
    // }, 100)
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('orientationchange', this.onResize, false);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize, false);
    }
    this.onResize();

    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this3.getAndSetMaxHeight();
    }, 500);
  };

  TwoColumnLayout.prototype.componentWillUnmount = function componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('orientationchange', this.onResize);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    }
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });

    if (this.intervalId) clearInterval(this.intervalId);
  };

  TwoColumnLayout.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        backgroundColor = _props.backgroundColor,
        size = _props.size,
        mbLayout = _props.mbLayout,
        resetUpperMargin = _props.resetUpperMargin,
        setLowerMargin = _props.setLowerMargin,
        nested = _props.nested,
        firstContent = _props.firstContent,
        secondContent = _props.secondContent;
    // require check
    // firstContent / secondContent 必須

    var firstComponents = Array.isArray(firstContent) ? firstContent : [];
    var secondComponents = Array.isArray(secondContent) ? secondContent : [];
    if (!firstComponents.length && !secondComponents.length) {
      return null;
    }
    // ---
    var baseClass = 'TwoColumnLayout';
    var sizeClass = 'size__' + (size || 'Full-Width').toLowerCase();
    var mbLayoutClass = 'mbLayout__' + (mbLayout || 'Horizontal').toLowerCase();
    var upperMargin = resetUpperMargin ? 'TwoColumnLayout__resetUpperMargin' : '';
    var lowerMargin = setLowerMargin ? 'TwoColumnLayout__setLowerMargin' : '';
    var nestedClass = nested ? 'TwoColumnLayout__nested' : '';
    var classes = [baseClass, sizeClass, mbLayoutClass, upperMargin, lowerMargin, nestedClass];
    var attributes = {
      className: classes.filter(function (cssClass) {
        return cssClass;
      }).join(' ')
    };
    // ---
    // this.components = [];
    // const getNestedComponents = (components, hasBackground = false) => {
    //   return (
    //     components.map((component, index) => {
    //       let name = null;
    //       if (component.name) {
    //         name = component.name;
    //       } else if (component.type) {
    //         name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
    //       }
    //       if (name === 'Video') {
    //         if (component.props.size) {
    //           component.props.size = 'Standard';
    //         }
    //         return (
    //           <Video {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='twoColumnLayout'
    //           />
    //         )
    //       } else if (name === 'Promo') {
    //         return (
    //           <Promo {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='twoColumnLayout'
    //           />
    //         )
    //       }
    //       // else {
    //       //   let Block = blocks[name];
    //       //   if (Block) {
    //       //     return <Block {...component.props} key={index}/>
    //       //   } else {
    //       //     return null;
    //       //   }
    //       // }
    //       const Block = blocks[name];
    //       return Block ? <Block {...component.props} key={index}/> : null;
    //     })
    //   )
    // };
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 296
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({ className: "TwoColumnLayout" }, attributes, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 302
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'TwoColumnLayout__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 303
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'TwoColumnLayout__column TwoColumnLayout__firstContent',
              style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 304
              }
            },
            this.getNestedComponents(firstComponents, backgroundColor && backgroundColor !== '' ? true : false)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'TwoColumnLayout__column TwoColumnLayout__secondContent',
              style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 311
              }
            },
            this.getNestedComponents(secondComponents, backgroundColor && backgroundColor !== '' ? true : false)
          )
        )
      )
    );
  };
  //
  // //
  // handleResize = () => {
  //   let maxHeight = 0;
  //   let i, max;
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.getContentsHeight) {
  //       const height = component.getContentsHeight();
  //       if (maxHeight < height) {
  //         maxHeight = height;
  //       }
  //     }
  //   }
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.setContainerHeight) {
  //       component.setContainerHeight(maxHeight);
  //     }
  //   }
  // };

  return TwoColumnLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resetUpperMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setLowerMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  firstContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  // firstContent: PropTypes.arrayOf(PropTypes.node),
  // secondContent: PropTypes.arrayOf(PropTypes.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  backgroundColor: null,
  size: null,
  mbLayout: null,
  resetUpperMargin: null,
  setLowerMargin: null,
  nested: null,
  firstContent: null,
  secondContent: null
}, _temp);
TwoColumnLayout.displayName = 'TwoColumnLayout';

;

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThreeColumnLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\three-column-layout\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line no-unused-vars






//import { getComponents } from '../../utils'






/**
 * three columns
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?string} mbLayout - モバイル時のレイアウト方法（Horizontal / Vertical）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} firstContent - 3カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} secondContent - 3カラム第2コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} thirdContent - 3カラム第3コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.ThreeColumnLayout`
 */
var ThreeColumnLayout = (_temp = _class = function (_Component) {
  _inherits(ThreeColumnLayout, _Component);

  function ThreeColumnLayout(props) {
    _classCallCheck(this, ThreeColumnLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getNestedComponents = function (components) {
      var hasBackground = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index2 = arguments[2];

      return components.map(function (component, index) {
        var name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
          // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
        }
        // console.log(name)
        if (name === 'Video') {
          if (component.props.size) {
            component.props.size = 'Standard';
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks_video__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */] && _this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'threeColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 148
            }
          }));
        } else if (name === 'Promo') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_promo__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */] && _this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'threeColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 164
            }
          }));
        } else if (name === 'PromoAndButtonModalWindow') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */] && _this.props.mbLayout === 'Two-Line' && index2 === 0) return null;

              ref ? _this.components.push(ref) : null;
            },
            hasBackground: hasBackground,
            parentColumn: 'threeColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 180
            }
          }));
        } else if (name === 'Wysiwyg') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__wysiwyg__["a" /* default */], _extends({}, component.props, {
            key: index,
            parentColumn: 'threeColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 196
            }
          }));
        }
        // else {
        //   let Block = blocks[name];
        //   if (Block) {
        //     return <Block {...component.props} key={index}/>
        //   } else {
        //     return null;
        //   }
        // }
        var Block = __WEBPACK_IMPORTED_MODULE_8__blocks__[name];
        return Block ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 211
          }
        })) : null;
      });
    };

    _this.props = props;
    _this.components = [];
    _this.onResize = _this.onResize.bind(_this);
    _this.timer = {
      fitHeight: 0
    };
    _this.intervalId = null;
    return _this;
  }

  ThreeColumnLayout.prototype.onResize = function onResize() {
    this.clearMaxHeight();
    this.delayGetAndSetMaxHeight();
  };

  ThreeColumnLayout.prototype.clearMaxHeight = function clearMaxHeight() {
    this.components.filter(function (component) {
      return component && component.clearContainerHeight;
    }).map(function (component) {
      return component.clearContainerHeight();
    });
  };

  ThreeColumnLayout.prototype.delayGetAndSetMaxHeight = function delayGetAndSetMaxHeight() {
    var _this2 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16 * 10;

    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(function () {
      _this2.getAndSetMaxHeight();
    }, delay);
  };

  ThreeColumnLayout.prototype.getAndSetMaxHeight = function getAndSetMaxHeight() {

    // if (IS_MOBILE && this.props.mbLayout === 'Two-Line') {
    //
    //   let components = [];
    //   this.components.map((component, index)=> {
    //     if (1 <= index) {
    //       components.push(component);
    //     }
    //   });
    //   const results = components
    //     .map(component => {
    //       if (component && component.getContentsHeight) {
    //         return component.getContentsHeight();
    //       }
    //       return 0;
    //     });
    //   results.sort((a, b) => (b - a));
    //   const maxHeight = results[0];
    //   components
    //     .filter(component => (component && component.setContainerHeight))
    //     .map(component => (component.setContainerHeight(maxHeight)));
    //
    // } else {

    var results = this.components.map(function (component) {
      if (component && component.getContentsHeight) {
        return component.getContentsHeight();
      }
      return 0;
    });
    results.sort(function (a, b) {
      return b - a;
    });
    var maxHeight = results[0];
    this.components.filter(function (component) {
      return component && component.setContainerHeight;
    }).map(function (component) {
      return component.setContainerHeight(maxHeight);
    });

    // }
  };

  ThreeColumnLayout.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    // window.addEventListener('resize', this.handleResize);
    // setTimeout(() => {
    //   this.handleResize();
    // }, 100)
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('orientationchange', this.onResize, false);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize, false);
    }
    this.onResize();

    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this3.getAndSetMaxHeight();
    }, 500);
  };

  ThreeColumnLayout.prototype.componentWillUnmount = function componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('orientationchange', this.onResize);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    }
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });

    if (this.intervalId) clearInterval(this.intervalId);
  };

  ThreeColumnLayout.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        backgroundColor = _props.backgroundColor,
        size = _props.size,
        mbLayout = _props.mbLayout,
        resetUpperMargin = _props.resetUpperMargin,
        setLowerMargin = _props.setLowerMargin,
        nested = _props.nested,
        firstContent = _props.firstContent,
        secondContent = _props.secondContent,
        thirdContent = _props.thirdContent;
    // require check
    // firstContent / secondContent / thirdContent 必須

    var firstComponents = Array.isArray(firstContent) ? firstContent : [];
    var secondComponents = Array.isArray(secondContent) ? secondContent : [];
    var thirdComponents = Array.isArray(thirdContent) ? thirdContent : [];
    if (!firstComponents.length && !secondComponents.length && !thirdComponents.length) {
      return null;
    }
    // ---
    var baseClass = 'ThreeColumnLayout';
    var sizeClass = 'size__' + (size || 'Full-Width').toLowerCase();
    var mbLayoutClass = 'mbLayout__' + (mbLayout || 'Horizontal').toLowerCase();
    var upperMargin = resetUpperMargin ? 'ThreeColumnLayout__resetUpperMargin' : '';
    var lowerMargin = setLowerMargin ? 'ThreeColumnLayout__setLowerMargin' : '';
    var nestedClass = nested ? 'ThreeColumnLayout__nested' : '';
    var classes = [baseClass, sizeClass, mbLayoutClass, upperMargin, lowerMargin, nestedClass];
    var attributes = {
      className: classes.filter(function (cssClass) {
        return cssClass;
      }).join(' ')
    };
    // ---
    // this.components = [];
    // const getNestedComponents = (components, hasBackground = false) => {
    //   return (
    //     components.map((component, index) => {
    //       let name = null;
    //       if (component.name) {
    //         name = component.name;
    //       } else if (component.type) {
    //         name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
    //       }
    //       if (name === 'Video') {
    //         if (component.props.size) {
    //           component.props.size = 'Standard';
    //         }
    //         return (
    //           <Video {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='threeColumnLayout'
    //           />
    //         )
    //       } else if (name === 'Promo') {
    //         return (
    //           <Promo {...component.props}
    //                  key={index}
    //                  getRef={(ref) => {
    //                    (ref) ? this.components.push(ref): null;
    //                  }}
    //                  hasBackground={hasBackground}
    //                  parentColumn='threeColumnLayout'
    //           />
    //         )
    //       }
    //       // else {
    //       //   let Block = blocks[name];
    //       //   if (Block) {
    //       //     return <Block {...component.props} key={index}/>
    //       //   } else {
    //       //     return null;
    //       //   }
    //       // }
    //       const Block = blocks[name];
    //       return Block ? <Block {...component.props} key={index}/> : null;
    //     })
    //   )
    // };
    // ---
    // console.log('ThreeColumnLayout.render', this.props);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 342
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: anchorPoint, 'data-anchor-name': anchorName, __source: {
            fileName: _jsxFileName,
            lineNumber: 346
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({}, attributes, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 347
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ThreeColumnLayout__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 348
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ThreeColumnLayout__column ThreeColumnLayout__firstContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 349
                }
              },
              this.getNestedComponents(firstComponents, backgroundColor && backgroundColor !== '' ? true : false, 0)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ThreeColumnLayout__column ThreeColumnLayout__secondContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 356
                }
              },
              this.getNestedComponents(secondComponents, backgroundColor && backgroundColor !== '' ? true : false, 1)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ThreeColumnLayout__column ThreeColumnLayout__thirdContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 363
                }
              },
              this.getNestedComponents(thirdComponents, backgroundColor && backgroundColor !== '' ? true : false, 2)
            )
          )
        )
      )
    );
  };
  //
  // //
  // handleResize = () => {
  //   let maxHeight = 0;
  //   let i, max;
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.getContentsHeight) {
  //       const height = component.getContentsHeight();
  //       if (maxHeight < height) {
  //         maxHeight = height;
  //       }
  //     }
  //   }
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.setContainerHeight) {
  //       component.setContainerHeight(maxHeight);
  //     }
  //   }
  // };

  return ThreeColumnLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resetUpperMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setLowerMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  firstContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  thirdContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  // firstContent: PropTypes.arrayOf(PropTypes.node),
  // secondContent: PropTypes.arrayOf(PropTypes.node),
  // thirdContent: PropTypes.arrayOf(PropTypes.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  backgroundColor: null,
  size: null,
  mbLayout: null,
  resetUpperMargin: null,
  setLowerMargin: null,
  nested: null,
  firstContent: null,
  secondContent: null,
  thirdContent: null
}, _temp);
ThreeColumnLayout.displayName = 'ThreeColumnLayout';

;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FourColumnLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\four-column-layout\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line no-unused-vars






//import { getComponents } from '../../utils'






/**
 * fourth columns
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?string} mbLayout - モバイル時のレイアウト方法（Horizontal / Vertical / Two-Line）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} firstContent - 4カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} secondContent - 4カラム第2コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} thirdContent - 4カラム第3コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @param {?Array<Component>} fourthContent - 4カラム第4コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.FourColumnLayout`
 */
var FourColumnLayout = (_temp = _class = function (_Component) {
  _inherits(FourColumnLayout, _Component);

  function FourColumnLayout(props) {
    _classCallCheck(this, FourColumnLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getNestedComponents = function (components) {
      var hasBackground = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index2 = arguments[2];

      return components.map(function (component, index) {
        var name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
          // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
        }
        if (name === 'Video') {
          if (component.props.size) {
            component.props.size = 'Standard';
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks_video__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (index2 === 0 || index2 === 1) {
                ref ? _this.components.push(ref) : null;
              } else {
                ref ? _this.components2.push(ref) : null;
              }

              // (ref) ? this.components.push(ref): null;
            },
            hasBackground: hasBackground,
            parentColumn: 'fourColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          }));
        } else if (name === 'PromoAndButtonModalWindow') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__blocks_promo_and_button_modal_window__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (index2 === 0 || index2 === 1) {
                ref ? _this.components.push(ref) : null;
              } else {
                ref ? _this.components2.push(ref) : null;
              }

              // (ref) ? this.components.push(ref): null;
            },
            hasBackground: hasBackground,
            parentColumn: 'fourColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 164
            }
          }));
        } else if (name === 'Promo') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_promo__["a" /* default */], _extends({}, component.props, {
            key: index,
            getRef: function getRef(ref) {

              // 配列の順番が変わってしまう不具合の対応
              if (index2 === 0 || index2 === 1) {
                ref ? _this.components.push(ref) : null;
              } else {
                ref ? _this.components2.push(ref) : null;
              }

              // (ref) ? this.components.push(ref): null;
            },
            hasBackground: hasBackground,
            parentColumn: 'fourColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 184
            }
          }));
        } else if (name === 'Wysiwyg') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__wysiwyg__["a" /* default */], _extends({}, component.props, {
            key: index,
            parentColumn: 'fourColumnLayout',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 204
            }
          }));
        }
        // else {
        //   let Block = blocks[name];
        //   if (Block) {
        //     return <Block {...component.props} key={index}/>
        //   } else {
        //     return null;
        //   }
        // }
        var Block = __WEBPACK_IMPORTED_MODULE_8__blocks__[name];
        return Block ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 219
          }
        })) : null;
      });
    };

    _this.props = props;
    _this.components = [];
    _this.components2 = [];
    _this.onResize = _this.onResize.bind(_this);
    _this.timer = {
      fitHeight: 0
    };
    _this.intervalId = null;
    return _this;
  }

  FourColumnLayout.prototype.onResize = function onResize() {
    this.clearMaxHeight();
    this.delayGetAndSetMaxHeight();
  };

  FourColumnLayout.prototype.clearMaxHeight = function clearMaxHeight() {
    this.components.filter(function (component) {
      return component && component.clearContainerHeight;
    }).map(function (component) {
      return component.clearContainerHeight();
    });
    this.components2.filter(function (component) {
      return component && component.clearContainerHeight;
    }).map(function (component) {
      return component.clearContainerHeight();
    });
  };

  FourColumnLayout.prototype.delayGetAndSetMaxHeight = function delayGetAndSetMaxHeight() {
    var _this2 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16 * 10;

    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(function () {
      _this2.getAndSetMaxHeight();
    }, delay);
  };

  FourColumnLayout.prototype.getAndSetMaxHeight = function getAndSetMaxHeight() {

    var setHeight = function setHeight(components) {
      var results = components.map(function (component) {
        if (component && component.getContentsHeight) {
          return component.getContentsHeight();
        }
        return 0;
      });
      results.sort(function (a, b) {
        return b - a;
      });
      var maxHeight = results[0];
      components.filter(function (component) {
        return component && component.setContainerHeight;
      }).map(function (component) {
        return component.setContainerHeight(maxHeight);
      });
    };

    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */] && this.props.mbLayout === 'Two-Line') {

      setHeight(this.components);
      setHeight(this.components2);
    } else {

      setHeight(this.components.concat(this.components2));
    }
  };

  FourColumnLayout.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    // window.addEventListener('resize', this.handleResize);
    // setTimeout(() => {
    //   this.handleResize();
    // }, 100)
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('orientationchange', this.onResize, false);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize, false);
    }
    this.onResize();

    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this3.getAndSetMaxHeight();
    }, 500);
  };

  FourColumnLayout.prototype.componentWillUnmount = function componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('orientationchange', this.onResize);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    }
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });

    if (this.intervalId) clearInterval(this.intervalId);
  };

  FourColumnLayout.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        backgroundColor = _props.backgroundColor,
        size = _props.size,
        mbLayout = _props.mbLayout,
        resetUpperMargin = _props.resetUpperMargin,
        setLowerMargin = _props.setLowerMargin,
        nested = _props.nested,
        firstContent = _props.firstContent,
        secondContent = _props.secondContent,
        thirdContent = _props.thirdContent,
        fourthContent = _props.fourthContent;
    // require check
    // firstContent / secondContent / thirdContent 必須

    var firstComponents = Array.isArray(firstContent) ? firstContent : [];
    var secondComponents = Array.isArray(secondContent) ? secondContent : [];
    var thirdComponents = Array.isArray(thirdContent) ? thirdContent : [];
    var fourthComponents = Array.isArray(fourthContent) ? fourthContent : [];
    if (!firstComponents.length && !secondComponents.length && !thirdComponents.length && !fourthComponents.length) {
      return null;
    }
    // ---
    var baseClass = 'FourColumnLayout';
    var sizeClass = 'size__' + (size || 'Full-Width').toLowerCase();
    var mbLayoutClass = 'mbLayout__' + (mbLayout || 'Horizontal').toLowerCase();
    var upperMargin = resetUpperMargin ? 'FourColumnLayout__resetUpperMargin' : '';
    var lowerMargin = setLowerMargin ? 'FourColumnLayout__setLowerMargin' : '';
    var nestedClass = nested ? 'FourColumnLayout__nested' : '';
    var classes = [baseClass, sizeClass, mbLayoutClass, upperMargin, lowerMargin, nestedClass];
    var attributes = {
      className: classes.filter(function (cssClass) {
        return cssClass;
      }).join(' ')
    };
    // ---
    // this.components = [];
    // const getNestedComponents = (components, hasBackground = false) => {
    //   return (
    //     components.map((component, index) => {
    //       let name = null;
    //       if (component.name) {
    //         name = component.name;
    //       } else if (component.type) {
    //         name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
    //       }
    //       if (name === 'Video') {
    //         if (component.props.size) {
    //           component.props.size = 'Standard';
    //         }
    //         return (
    //           <Video
    //             {...component.props}
    //             key={index}
    //             getRef={(ref) => {
    //               (ref) ? this.components.push(ref): null;
    //             }}
    //             hasBackground={hasBackground}
    //             parentColumn='fourColumnLayout'
    //           />
    //         )
    //       } else if (name === 'Promo') {
    //         return (
    //           <Promo
    //             {...component.props}
    //             key={index}
    //             getRef={(ref) => {
    //               (ref) ? this.components.push(ref): null;
    //             }}
    //             hasBackground={hasBackground}
    //             parentColumn='fourColumnLayout'
    //           />
    //         )
    //       }
    //       // else {
    //       //   let Block = blocks[name];
    //       //   if (Block) {
    //       //     return <Block {...component.props} key={index}/>
    //       //   } else {
    //       //     return null;
    //       //   }
    //       // }
    //       const Block = blocks[name];
    //       return Block ? <Block {...component.props} key={index}/> : null;
    //     })
    //   )
    // };
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 353
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: anchorPoint, 'data-anchor-name': anchorName, __source: {
            fileName: _jsxFileName,
            lineNumber: 357
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({}, attributes, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 358
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'FourColumnLayout__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 359
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'FourColumnLayout__column FourColumnLayout__firstContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 360
                }
              },
              this.getNestedComponents(firstComponents, backgroundColor && backgroundColor !== '' ? true : false, 0)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'FourColumnLayout__column FourColumnLayout__secondContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 365
                }
              },
              this.getNestedComponents(secondComponents, backgroundColor && backgroundColor !== '' ? true : false, 1)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'FourColumnLayout__column FourColumnLayout__thirdContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 370
                }
              },
              this.getNestedComponents(thirdComponents, backgroundColor && backgroundColor !== '' ? true : false, 2)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'FourColumnLayout__column FourColumnLayout__fourthContent',
                style: backgroundColor && backgroundColor !== '' ? { backgroundColor: '#' + backgroundColor.replace(/#/g, '') } : null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 375
                }
              },
              this.getNestedComponents(fourthComponents, backgroundColor && backgroundColor !== '' ? true : false, 3)
            )
          )
        )
      )
    );
  };

  // handleResize = () => {
  //   let maxHeight = 0;
  //   let i, max;
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.getContentsHeight) {
  //       const height = component.getContentsHeight();
  //       if (maxHeight < height) {
  //         maxHeight = height;
  //       }
  //     }
  //   }
  //   for (i = 0, max = this.components.length; i < max; i = i + 1) {
  //     const component = this.components[i];
  //     if (component && component.setContainerHeight) {
  //       component.setContainerHeight(maxHeight);
  //     }
  //   }
  // };


  return FourColumnLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resetUpperMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setLowerMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  firstContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  thirdContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  fourthContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  // firstContent: PropTypes.arrayOf(PropTypes.node),
  // secondContent: PropTypes.arrayOf(PropTypes.node),
  // thirdContent: PropTypes.arrayOf(PropTypes.node),
  // fourthContent: PropTypes.arrayOf(PropTypes.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  backgroundColor: null,
  size: null,
  mbLayout: null,
  resetUpperMargin: null,
  setLowerMargin: null,
  nested: null,
  firstContent: null,
  secondContent: null,
  thirdContent: null,
  fourthContent: null
}, _temp);
FourColumnLayout.displayName = 'FourColumnLayout';

;

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_photogallery__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery_item__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_photogallery_layout__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\photogallery\\index.jsx';






var PhotogalleryBlock = function PhotogalleryBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
PhotogalleryBlock.displayName = 'PhotogalleryBlock';
PhotogalleryBlock.displayName = 'Photogallery';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_photogallery_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_photogallery_layout__["a" /* default */]],
  mapInputToOutput: [['photogalleryItem', 'photogalleryItem'], ['photogalleryLayout', 'photogalleryLayout']]
})(PhotogalleryBlock));

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_presentation__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_presentation_item__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\presentation\\index.jsx';







var PresentationBlock = function PresentationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_presentation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  }));
};
PresentationBlock.displayName = 'PresentationBlock';
PresentationBlock.displayName = 'Presentation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_5__containers_cta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__containers_presentation_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['cta', 'cta'], ['photoInfo', 'photoInfo'], ['presentationItem', 'presentationItem']]
})(PresentationBlock));

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(62)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(7).setDesc
  , has = __webpack_require__(26)
  , TAG = __webpack_require__(12)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(36)
  , call        = __webpack_require__(195)
  , isArrayIter = __webpack_require__(196)
  , anObject    = __webpack_require__(11)
  , toLength    = __webpack_require__(27)
  , getIterFn   = __webpack_require__(197);
module.exports = function(iterable, entries, fn, that){
  var iterFn = getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    call(iterator, f, step.value, entries);
  }
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THRESHOLD_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_THRESHOLD_WIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_IFRAME_HEIGHT; });
var DEFAULT_THRESHOLD_NORMAL = 768;
var DEFAULT_THRESHOLD_WIDE = 1200;
var DEFAULT_IFRAME_HEIGHT = 800;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * sweet-scroll
 * Modern and the sweet smooth scroll library.
 * @author tsuyoshiwada
 * @license MIT
 * @version 2.2.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.SweetScroll = factory());
}(this, (function () { 'use strict';

var cos = Math.cos;
var sin = Math.sin;
var pow = Math.pow;
var abs = Math.abs;
var sqrt = Math.sqrt;
var asin = Math.asin;
var PI = Math.PI;
var max = Math.max;
var min = Math.min;
var round = Math.round;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var MAX_ARRAY_INDEX = pow(2, 53) - 1;
var classTypeList = ["Boolean", "Number", "String", "Function", "Array", "Object"];
var classTypes = {};

classTypeList.forEach(function (name) {
  classTypes["[object " + name + "]"] = name.toLowerCase();
});

function getType(obj) {
  if (obj == null) {
    return "";
  }

  return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? classTypes[Object.prototype.toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
}

function isNumber(obj) {
  return getType(obj) === "number";
}

function isString(obj) {
  return getType(obj) === "string";
}



function isFunction(obj) {
  return getType(obj) === "function";
}

function isArray(obj) {
  return Array.isArray(obj);
}

function isArrayLike(obj) {
  var length = obj == null ? null : obj.length;

  return isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
}

function isNumeric(obj) {
  return !isArray(obj) && obj - parseFloat(obj) + 1 >= 0;
}

function isObject(obj) {
  return !isArray(obj) && getType(obj) === "object";
}

function hasProp(obj, key) {
  return obj && obj.hasOwnProperty(key);
}



function each(obj, iterate, context) {
  if (obj == null) return obj;

  var ctx = context || obj;

  if (isObject(obj)) {
    for (var key in obj) {
      if (!hasProp(obj, key)) continue;
      if (iterate.call(ctx, obj[key], key) === false) break;
    }
  } else if (isArrayLike(obj)) {
    for (var i = 0; i < obj.length; i++) {
      if (iterate.call(ctx, obj[i], i) === false) break;
    }
  }

  return obj;
}

function merge(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  each(sources, function (source) {
    each(source, function (value, key) {
      obj[key] = value;
    });
  });

  return obj;
}

function removeSpaces(str) {
  return str.replace(/\s*/g, "") || "";
}

function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  /* eslint-enable no-console */

  /* eslint-disable no-empty */
  try {
    throw new Error(message);
  } catch (e) {}
  /* eslint-enable no-empty */
}

// @link https://github.com/JedWatson/exenv/blob/master/index.js
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);

// @link https://github.com/Modernizr/Modernizr
var history = function () {
  if (!canUseDOM) return false;

  var ua = navigator.userAgent;
  if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) {
    return false;
  }

  return window.history && "pushState" in window.history && window.location.protocol !== "file:";
}();

var win = canUseDOM ? window : null;
var doc = canUseDOM ? document : null;

function $(selector) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!selector) return;

  return (context == null ? doc : context).querySelector(selector);
}

function $$(selector) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!selector) return;

  return (context == null ? doc : context).querySelectorAll(selector);
}

function matches(el, selector) {
  var results = (el.document || el.ownerDocument).querySelectorAll(selector);
  var i = results.length;
  while (--i >= 0 && results.item(i) !== el) {}

  return i > -1;
}

var directionMethodMap = {
  y: "scrollTop",
  x: "scrollLeft"
};

var directionPropMap = {
  y: "pageYOffset",
  x: "pageXOffset"
};

function isRootContainer(el) {
  return el === doc.documentElement || el === doc.body;
}

function getZoomLevel() {
  var outerWidth = win.outerWidth,
      innerWidth = win.innerWidth;


  return outerWidth ? outerWidth / innerWidth : 1;
}

function getScrollable(selectors) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "y";
  var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var method = directionMethodMap[direction];
  var elements = selectors instanceof Element ? [selectors] : $$(selectors);
  var scrollables = [];
  var $div = doc.createElement("div");

  for (var i = 0; i < elements.length; i++) {
    var el = elements[i];

    if (el[method] > 0) {
      scrollables.push(el);
    } else {
      $div.style.width = el.clientWidth + 1 + "px";
      $div.style.height = el.clientHeight + 1 + "px";
      el.appendChild($div);

      el[method] = 1.5 / getZoomLevel();
      if (el[method] > 0) {
        scrollables.push(el);
      }
      el[method] = 0;

      el.removeChild($div);
    }

    if (!all && scrollables.length > 0) break;
  }

  return scrollables;
}

function scrollableFind(selectors, direction) {
  var scrollables = getScrollable(selectors, direction, false);

  return scrollables.length >= 1 ? scrollables[0] : null;
}

function getWindow(el) {
  return el != null && el === el.window ? el : el.nodeType === 9 && el.defaultView;
}

function getHeight(el) {
  return max(el.scrollHeight, el.clientHeight, el.offsetHeight);
}

function getWidth(el) {
  return max(el.scrollWidth, el.clientWidth, el.offsetWidth);
}

function getSize(el) {
  return {
    width: getWidth(el),
    height: getHeight(el)
  };
}

function getDocumentSize() {
  return {
    width: max(getWidth(doc.body), getWidth(doc.documentElement)),
    height: max(getHeight(doc.body), getHeight(doc.documentElement))
  };
}

function getViewportAndElementSizes(el) {
  if (isRootContainer(el)) {
    return {
      viewport: {
        width: min(win.innerWidth, doc.documentElement.clientWidth),
        height: win.innerHeight
      },
      size: getDocumentSize()
    };
  }

  return {
    viewport: {
      width: el.clientWidth,
      height: el.clientHeight
    },
    size: getSize(el)
  };
}

function getScroll(el) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "y";

  var currentWindow = getWindow(el);

  return currentWindow ? currentWindow[directionPropMap[direction]] : el[directionMethodMap[direction]];
}

function setScroll(el, offset) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "y";

  var currentWindow = getWindow(el);
  var top = direction === "y";
  if (currentWindow) {
    currentWindow.scrollTo(!top ? offset : currentWindow[directionPropMap.x], top ? offset : currentWindow[directionPropMap.y]);
  } else {
    el[directionMethodMap[direction]] = offset;
  }
}

function getOffset(el) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!el || el && !el.getClientRects().length) {
    return { top: 0, left: 0 };
  }

  var rect = el.getBoundingClientRect();

  if (rect.width || rect.height) {
    var scroll = {};
    var ctx = null;
    if (context == null || isRootContainer(context)) {
      ctx = el.ownerDocument.documentElement;
      scroll.top = win.pageYOffset;
      scroll.left = win.pageXOffset;
    } else {
      ctx = context;
      var ctxRect = ctx.getBoundingClientRect();
      scroll.top = ctxRect.top * -1 + ctx.scrollTop;
      scroll.left = ctxRect.left * -1 + ctx.scrollLeft;
    }

    return {
      top: rect.top + scroll.top - ctx.clientTop,
      left: rect.left + scroll.left - ctx.clientLeft
    };
  }

  return rect;
}

function addEvent(el, event, listener) {
  var events = event.split(",");
  events.forEach(function (eventName) {
    el.addEventListener(eventName.trim(), listener, false);
  });
}

function removeEvent(el, event, listener) {
  var events = event.split(",");
  events.forEach(function (eventName) {
    el.removeEventListener(eventName.trim(), listener, false);
  });
}

/* eslint-disable no-param-reassign, newline-before-return, max-params, new-cap */
function linear(p) {
  return p;
}

function InQuad(x, t, b, c, d) {
  return c * (t /= d) * t + b;
}

function OutQuad(x, t, b, c, d) {
  return -c * (t /= d) * (t - 2) + b;
}

function InOutQuad(x, t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t + b;
  }
  return -c / 2 * (--t * (t - 2) - 1) + b;
}

function InCubic(x, t, b, c, d) {
  return c * (t /= d) * t * t + b;
}

function OutCubic(x, t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function InOutCubic(x, t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t * t + b;
  }
  return c / 2 * ((t -= 2) * t * t + 2) + b;
}

function InQuart(x, t, b, c, d) {
  return c * (t /= d) * t * t * t + b;
}

function OutQuart(x, t, b, c, d) {
  return -c * ((t = t / d - 1) * t * t * t - 1) + b;
}

function InOutQuart(x, t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t * t * t + b;
  }
  return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

function InQuint(x, t, b, c, d) {
  return c * (t /= d) * t * t * t * t + b;
}

function OutQuint(x, t, b, c, d) {
  return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
}

function InOutQuint(x, t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return c / 2 * t * t * t * t * t + b;
  }
  return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
}

function InSine(x, t, b, c, d) {
  return -c * cos(t / d * (PI / 2)) + c + b;
}

function OutSine(x, t, b, c, d) {
  return c * sin(t / d * (PI / 2)) + b;
}

function InOutSine(x, t, b, c, d) {
  return -c / 2 * (cos(PI * t / d) - 1) + b;
}

function InExpo(x, t, b, c, d) {
  return t === 0 ? b : c * pow(2, 10 * (t / d - 1)) + b;
}

function OutExpo(x, t, b, c, d) {
  return t === d ? b + c : c * (-pow(2, -10 * t / d) + 1) + b;
}

function InOutExpo(x, t, b, c, d) {
  if (t === 0) return b;
  if (t === d) return b + c;
  if ((t /= d / 2) < 1) return c / 2 * pow(2, 10 * (t - 1)) + b;
  return c / 2 * (-pow(2, -10 * --t) + 2) + b;
}

function InCirc(x, t, b, c, d) {
  return -c * (sqrt(1 - (t /= d) * t) - 1) + b;
}

function OutCirc(x, t, b, c, d) {
  return c * sqrt(1 - (t = t / d - 1) * t) + b;
}

function InOutCirc(x, t, b, c, d) {
  if ((t /= d / 2) < 1) {
    return -c / 2 * (sqrt(1 - t * t) - 1) + b;
  }
  return c / 2 * (sqrt(1 - (t -= 2) * t) + 1) + b;
}

function InElastic(x, t, b, c, d) {
  var s = 1.70158;
  var p = 0;
  var a = c;
  if (t === 0) return b;
  if ((t /= d) === 1) return b + c;
  if (!p) p = d * .3;
  if (a < abs(c)) {
    a = c;
    s = p / 4;
  } else {
    s = p / (2 * PI) * asin(c / a);
  }
  return -(a * pow(2, 10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p)) + b;
}

function OutElastic(x, t, b, c, d) {
  var s = 1.70158;
  var p = 0;
  var a = c;
  if (t === 0) return b;
  if ((t /= d) === 1) return b + c;
  if (!p) p = d * .3;
  if (a < abs(c)) {
    a = c;
    s = p / 4;
  } else {
    s = p / (2 * PI) * asin(c / a);
  }
  return a * pow(2, -10 * t) * sin((t * d - s) * (2 * PI) / p) + c + b;
}

function InOutElastic(x, t, b, c, d) {
  var s = 1.70158;
  var p = 0;
  var a = c;
  if (t === 0) return b;
  if ((t /= d / 2) === 2) return b + c;
  if (!p) p = d * (.3 * 1.5);
  if (a < abs(c)) {
    a = c;
    s = p / 4;
  } else {
    s = p / (2 * PI) * asin(c / a);
  }
  if (t < 1) {
    return -.5 * (a * pow(2, 10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p)) + b;
  }
  return a * pow(2, -10 * (t -= 1)) * sin((t * d - s) * (2 * PI) / p) * .5 + c + b;
}

function InBack(x, t, b, c, d) {
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1.70158;

  return c * (t /= d) * t * ((s + 1) * t - s) + b;
}

function OutBack(x, t, b, c, d) {
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1.70158;

  return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
}

function InOutBack(x, t, b, c, d) {
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1.70158;

  if ((t /= d / 2) < 1) {
    return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
  }
  return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
}

function OutBounce(x, t, b, c, d) {
  if ((t /= d) < 1 / 2.75) {
    return c * (7.5625 * t * t) + b;
  } else if (t < 2 / 2.75) {
    return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
  } else if (t < 2.5 / 2.75) {
    return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
  } else {
    return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
  }
}

function InBounce(x, t, b, c, d) {
  return c - OutBounce(x, d - t, 0, c, d) + b;
}

function InOutBounce(x, t, b, c, d) {
  if (t < d / 2) {
    return InBounce(x, t * 2, 0, c, d) * .5 + b;
  }
  return OutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
}

var Easing = Object.freeze({
	linear: linear,
	InQuad: InQuad,
	OutQuad: OutQuad,
	InOutQuad: InOutQuad,
	InCubic: InCubic,
	OutCubic: OutCubic,
	InOutCubic: InOutCubic,
	InQuart: InQuart,
	OutQuart: OutQuart,
	InOutQuart: InOutQuart,
	InQuint: InQuint,
	OutQuint: OutQuint,
	InOutQuint: InOutQuint,
	InSine: InSine,
	OutSine: OutSine,
	InOutSine: InOutSine,
	InExpo: InExpo,
	OutExpo: OutExpo,
	InOutExpo: InOutExpo,
	InCirc: InCirc,
	OutCirc: OutCirc,
	InOutCirc: InOutCirc,
	InElastic: InElastic,
	OutElastic: OutElastic,
	InOutElastic: InOutElastic,
	InBack: InBack,
	OutBack: OutBack,
	InOutBack: InOutBack,
	OutBounce: OutBounce,
	InBounce: InBounce,
	InOutBounce: InOutBounce
});

var vendors = ["ms", "moz", "webkit"];
var lastTime = 0;

var raf = canUseDOM ? win.requestAnimationFrame : null;
var caf = canUseDOM ? win.cancelAnimationFrame : null;

if (canUseDOM) {
  for (var x = 0; x < vendors.length && !raf; ++x) {
    raf = win[vendors[x] + "RequestAnimationFrame"];
    caf = win[vendors[x] + "CancelAnimationFrame"] || win[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!raf) {
    raf = function raf(callback) {
      var currentTime = Date.now();
      var timeToCall = max(0, 16 - (currentTime - lastTime));
      var id = setTimeout(function () {
        callback(currentTime + timeToCall);
      }, timeToCall);

      lastTime = currentTime + timeToCall;

      return id;
    };
  }

  if (!caf) {
    caf = function caf(id) {
      clearTimeout(id);
    };
  }
}

var ScrollTween = function () {
  function ScrollTween(el) {
    classCallCheck(this, ScrollTween);

    this.el = el;
    this.props = {};
    this.options = {};
    this.progress = false;
    this.easing = null;
    this.startTime = null;
    this.rafId = null;
  }

  createClass(ScrollTween, [{
    key: "run",
    value: function run(x, y, options) {
      var _this = this;

      if (this.progress) return;
      this.props = { x: x, y: y };
      this.options = options;
      this.easing = isFunction(options.easing) ? options.easing : Easing[options.easing.replace("ease", "")];
      this.progress = true;

      setTimeout(function () {
        _this.startProps = _this.calcStartProps(x, y);
        _this.rafId = raf(function (time) {
          return _this._loop(time);
        });
      }, this.options.delay);
    }
  }, {
    key: "stop",
    value: function stop() {
      var gotoEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var complete = this.options.complete;

      this.startTime = null;
      this.progress = false;
      caf(this.rafId);

      if (gotoEnd) {
        setScroll(this.el, this.props.x, "x");
        setScroll(this.el, this.props.y, "y");
      }

      if (isFunction(complete)) {
        complete.call(this);
        this.options.complete = null;
      }
    }
  }, {
    key: "_loop",
    value: function _loop(time) {
      var _this2 = this;

      if (!this.startTime) {
        this.startTime = time;
      }

      if (!this.progress) {
        this.stop(false);

        return;
      }

      var el = this.el,
          props = this.props,
          options = this.options,
          startTime = this.startTime,
          startProps = this.startProps,
          easing = this.easing;
      var duration = options.duration,
          step = options.step;

      var toProps = {};
      var timeElapsed = time - startTime;
      var t = min(1, max(timeElapsed / duration, 0));

      each(props, function (value, key) {
        var initialValue = startProps[key];
        var delta = value - initialValue;
        if (delta === 0) return true;

        var val = easing(t, duration * t, 0, 1, duration);
        toProps[key] = round(initialValue + delta * val);
      });

      each(toProps, function (value, key) {
        setScroll(el, value, key);
      });

      if (timeElapsed <= duration) {
        step.call(this, t, toProps);
        this.rafId = raf(function (currentTime) {
          return _this2._loop(currentTime);
        });
      } else {
        this.stop(true);
      }
    }
  }, {
    key: "calcStartProps",
    value: function calcStartProps(x, y) {
      var startProps = {
        x: getScroll(this.el, "x"),
        y: getScroll(this.el, "y")
      };

      if (this.options.quickMode) {
        var _Dom$getViewportAndEl = getViewportAndElementSizes(this.el),
            _Dom$getViewportAndEl2 = _Dom$getViewportAndEl.viewport,
            width = _Dom$getViewportAndEl2.width,
            height = _Dom$getViewportAndEl2.height;

        if (abs(startProps.y - y) > height) {
          startProps.y = startProps.y > y ? y + height : y - height;
        }

        if (abs(startProps.x - x) > width) {
          startProps.x = startProps.x > x ? x + width : x - width;
        }
      }

      return startProps;
    }
  }]);
  return ScrollTween;
}();

var WHEEL_EVENT = function () {
  if (!canUseDOM) return "wheel";

  if ("onwheel" in doc) {
    return "wheel";
  } else if ("onmousewheel" in doc) {
    return "mousewheel";
  } else {
    return "DOMMouseScroll";
  }
}();

var CONTAINER_STOP_EVENTS = WHEEL_EVENT + ", touchstart, touchmove";

var SweetScroll = function () {
  /* eslint-enable max-len */

  /**
   * SweetScroll constructor
   * @constructor
   * @param {Object} options
   * @param {String | Element} container
   */
  function SweetScroll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body, html";
    classCallCheck(this, SweetScroll);

    this.isSSR = !canUseDOM;
    this.options = merge({}, SweetScroll.defaults, options);
    this.container = this.getContainer(container);

    if (this.container == null) {
      this.header = null;
      this.tween = null;

      if (!this.isSSR) {
        if (!/comp|inter|loaded/.test(doc.readyState)) {
          this.log("Should be initialize later than DOMContentLoaded.");
        } else {
          this.log("Not found scrollable container. => \"" + container + "\"");
        }
      }
    } else {
      this.header = $(this.options.header);
      this.tween = new ScrollTween(this.container);
      this._trigger = null;
      this._shouldCallCancelScroll = false;
      this.bindContainerClick();
    }
  }

  /**
   * Output log
   * @param {String} message
   * @return {void}
   */


  // Default options
  /* eslint-disable max-len */


  createClass(SweetScroll, [{
    key: "log",
    value: function log(message) {
      if (this.options.outputLog) {
        warning("[SweetScroll] " + message);
      }
    }

    /**
     * Get scroll offset
     * @param {*} distance
     * @param {Object} options
     * @return {Object}
     * @private
     */

  }, {
    key: "getScrollOffset",
    value: function getScrollOffset(distance, options) {
      var container = this.container,
          header = this.header;

      var offset = this.parseCoodinate(options.offset);
      var scroll = this.parseCoodinate(distance);

      // Using the coordinates in the case of CSS Selector
      if (!scroll && isString(distance)) {
        if (distance === "#") {
          scroll = {
            top: 0,
            left: 0
          };
        } else {
          var target = $(distance);
          var targetOffset = getOffset(target, container);
          if (!targetOffset) return;
          scroll = targetOffset;
        }
      }

      if (!scroll) {
        return null;
      }

      // Apply `offset` value
      if (offset) {
        scroll.top += offset.top;
        scroll.left += offset.left;
      }

      // If the header is present apply the height
      if (header) {
        scroll.top = max(0, scroll.top - getSize(header).height);
      }

      return scroll;
    }

    /**
     * Normalize scroll offset
     * @param {Ojbect} scroll
     * @param {Ojbect} options
     * @return {Object}
     * @private
     */

  }, {
    key: "normalizeScrollOffset",
    value: function normalizeScrollOffset(scroll, options) {
      var container = this.container;

      var finalScroll = merge({}, scroll);

      // Determine the final scroll coordinates

      var _Dom$getViewportAndEl = getViewportAndElementSizes(container),
          viewport = _Dom$getViewportAndEl.viewport,
          size = _Dom$getViewportAndEl.size;

      // Adjustment of the maximum value


      finalScroll.top = options.verticalScroll ? max(0, min(size.height - viewport.height, finalScroll.top)) : getScroll(container, "y");

      finalScroll.left = options.horizontalScroll ? max(0, min(size.width - viewport.width, finalScroll.left)) : getScroll(container, "x");

      return finalScroll;
    }

    /**
     * Scroll animation to the specified position
     * @param {*} distance
     * @param {Object} options
     * @return {void}
     */

  }, {
    key: "to",
    value: function to(distance) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.isSSR) return;

      var container = this.container;

      var params = merge({}, this.options, options);
      var trigger = this._trigger;
      var hash = isString(distance) && /^#/.test(distance) ? distance : null;

      // Temporary options
      this._options = params;

      // Remove the triggering elements which has been temporarily retained
      this._trigger = null;

      // Disable the call flag of `cancelScroll`
      this._shouldCallCancelScroll = false;

      // Stop current animation
      this.stop();

      // Does not move if the container is not found
      if (!container) {
        return this.log("Not found container element.");
      }

      // Get scroll offset
      var scroll = this.getScrollOffset(distance, params);

      if (!scroll) {
        return this.log("Invalid parameter of distance. => " + distance);
      }

      // Call `beforeScroll`
      // Stop scrolling when it returns false
      if (this.hook(params, "beforeScroll", scroll, trigger) === false) {
        this._options = null;
        return;
      }

      scroll = this.normalizeScrollOffset(scroll, params);

      // Run the animation!!
      this.tween.run(scroll.left, scroll.top, {
        duration: params.duration,
        delay: params.delay,
        easing: params.easing,
        quickMode: params.quickMode,
        complete: function complete() {
          // Update URL
          if (hash != null && hash !== win.location.hash) {
            _this.updateURLHash(hash, params.updateURL);
          }

          // Unbind the scroll stop events, And call `afterScroll` or `cancelScroll`
          _this.unbindContainerStop();

          // Remove the temporary options
          _this._options = null;

          // Call `cancelScroll` or `afterScroll`
          if (_this._shouldCallCancelScroll) {
            _this.hook(params, "cancelScroll");
          } else {
            _this.hook(params, "afterScroll", scroll, trigger);
          }

          // Call `completeScroll`
          _this.hook(params, "completeScroll", _this._shouldCallCancelScroll);
        },
        step: function step(currentTime, props) {
          _this.hook(params, "stepScroll", currentTime, props);
        }
      });

      // Bind the scroll stop events
      this.bindContainerStop();
    }

    /**
     * Scroll animation to the specified top position
     * @param {*} distance
     * @param {Object} options
     * @return {void}
     */

  }, {
    key: "toTop",
    value: function toTop(distance) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.to(distance, merge({}, options, {
        verticalScroll: true,
        horizontalScroll: false
      }));
    }

    /**
     * Scroll animation to the specified left position
     * @param {*} distance
     * @param {Object} options
     * @return {void}
     */

  }, {
    key: "toLeft",
    value: function toLeft(distance) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.to(distance, merge({}, options, {
        verticalScroll: false,
        horizontalScroll: true
      }));
    }

    /**
     * Scroll animation to the specified element
     * @param {Element} el
     * @param {Object} options
     * @return {void}
     */

  }, {
    key: "toElement",
    value: function toElement(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.isSSR) return;

      if (el instanceof Element) {
        var offset = getOffset(el, this.container);
        this.to(offset, merge({}, options));
      } else {
        this.log("Invalid parameter.");
      }
    }

    /**
     * Stop the current animation
     * @param {Boolean} gotoEnd
     * @return {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      var gotoEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isSSR) return;

      if (!this.container) {
        this.log("Not found scrollable container.");
      } else {
        if (this._stopScrollListener) {
          this._shouldCallCancelScroll = true;
        }

        this.tween.stop(gotoEnd);
      }
    }

    /**
     * Update the instance
     * @param {Object} options
     * @return {void}
     */

  }, {
    key: "update",
    value: function update() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.container) {
        if (!this.isSSR) {
          this.log("Not found scrollable container.");
        }
      } else {
        this.stop();
        this.unbindContainerClick();
        this.unbindContainerStop();
        this.options = merge({}, this.options, options);
        this.header = $(this.options.header);
        this.bindContainerClick();
      }
    }

    /**
     * Destroy SweetScroll instance
     * @return {void}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.container) {
        if (!this.isSSR) {
          this.log("Not found scrollable container.");
        }
      } else {
        this.stop();
        this.unbindContainerClick();
        this.unbindContainerStop();
        this.container = null;
        this.header = null;
        this.tween = null;
      }
    }

    /* eslint-disable no-unused-vars */
    /**
     * Called at before of the scroll.
     * @param {Object} toScroll
     * @param {Element} trigger
     * @return {Boolean}
     */

  }, {
    key: "beforeScroll",
    value: function beforeScroll(toScroll, trigger) {
      return true;
    }

    /**
     * Called at cancel of the scroll.
     * @return {void}
     */

  }, {
    key: "cancelScroll",
    value: function cancelScroll() {}

    /**
     * Called at after of the scroll.
     * @param {Object} toScroll
     * @param {Element} trigger
     * @return {void}
     */

  }, {
    key: "afterScroll",
    value: function afterScroll(toScroll, trigger) {}

    /**
     * Called at complete of the scroll.
     * @param {Boolean} isCancel
     * @return {void}
     */

  }, {
    key: "completeScroll",
    value: function completeScroll(isCancel) {}

    /**
     * Called at each animation frame of the scroll.
     * @param {Float} currentTime
     * @param {Object} props
     * @return {void}
     */

  }, {
    key: "stepScroll",
    value: function stepScroll(currentTime, props) {}
    /* eslint-enable no-unused-vars */

    /**
     * Parse the value of coordinate
     * @param {*} coodinate
     * @return {Object}
     */

  }, {
    key: "parseCoodinate",
    value: function parseCoodinate(coodinate) {
      var enableTop = this._options ? this._options.verticalScroll : this.options.verticalScroll;
      var scroll = { top: 0, left: 0 };

      // Object
      if (hasProp(coodinate, "top") || hasProp(coodinate, "left")) {
        scroll = merge(scroll, coodinate);

        // Array
      } else if (isArray(coodinate)) {
        if (coodinate.length === 2) {
          scroll.top = coodinate[0];
          scroll.left = coodinate[1];
        } else {
          scroll.top = enableTop ? coodinate[0] : 0;
          scroll.left = !enableTop ? coodinate[0] : 0;
        }

        // Number
      } else if (isNumeric(coodinate)) {
        scroll.top = enableTop ? coodinate : 0;
        scroll.left = !enableTop ? coodinate : 0;

        // String
      } else if (isString(coodinate)) {
        var trimedCoodinate = removeSpaces(coodinate);

        // "{n},{n}" (Array like syntax)
        if (/^\d+,\d+$/.test(trimedCoodinate)) {
          trimedCoodinate = trimedCoodinate.split(",");
          scroll.top = trimedCoodinate[0];
          scroll.left = trimedCoodinate[1];

          // "top:{n}, left:{n}" (Object like syntax)
        } else if (/^(top|left):\d+,?(?:(top|left):\d+)?$/.test(trimedCoodinate)) {
          var top = trimedCoodinate.match(/top:(\d+)/);
          var left = trimedCoodinate.match(/left:(\d+)/);
          scroll.top = top ? top[1] : 0;
          scroll.left = left ? left[1] : 0;

          // "+={n}", "-={n}" (Relative position)
        } else if (this.container && /^(\+|-)=(\d+)$/.test(trimedCoodinate)) {
          var current = getScroll(this.container, enableTop ? "y" : "x");
          var results = trimedCoodinate.match(/^(\+|-)=(\d+)$/);
          var op = results[1];
          var value = parseInt(results[2], 10);
          if (op === "+") {
            scroll.top = enableTop ? current + value : 0;
            scroll.left = !enableTop ? current + value : 0;
          } else {
            scroll.top = enableTop ? current - value : 0;
            scroll.left = !enableTop ? current - value : 0;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }

      scroll.top = parseInt(scroll.top, 10);
      scroll.left = parseInt(scroll.left, 10);

      return scroll;
    }

    /**
     * Update the Hash of the URL.
     * @param {String} hash
     * @param {Boolean | String} historyType
     * @return {void}
     */

  }, {
    key: "updateURLHash",
    value: function updateURLHash(hash, historyType) {
      if (this.isSSR || !history || !historyType) return;
      win.history[historyType === "replace" ? "replaceState" : "pushState"](null, null, hash);
    }

    /**
     * Get the container for the scroll, depending on the options.
     * @param {String | Element} selector
     * @return {?Element}
     * @private
     */

  }, {
    key: "getContainer",
    value: function getContainer(selector) {
      var _options = this.options,
          verticalScroll = _options.verticalScroll,
          horizontalScroll = _options.horizontalScroll;

      var container = null;

      if (this.isSSR) return container;

      if (verticalScroll) {
        container = scrollableFind(selector, "y");
      }

      if (!container && horizontalScroll) {
        container = scrollableFind(selector, "x");
      }

      return container;
    }

    /**
     * Bind a click event to the container
     * @return {void}
     * @private
     */

  }, {
    key: "bindContainerClick",
    value: function bindContainerClick() {
      var container = this.container;

      if (!container) return;
      this._containerClickListener = this.handleContainerClick.bind(this);
      addEvent(container, "click", this._containerClickListener);
    }

    /**
     * Unbind a click event to the container
     * @return {void}
     * @private
     */

  }, {
    key: "unbindContainerClick",
    value: function unbindContainerClick() {
      var container = this.container;

      if (!container || !this._containerClickListener) return;
      removeEvent(container, "click", this._containerClickListener);
      this._containerClickListener = null;
    }

    /**
     * Bind the scroll stop of events
     * @return {void}
     * @private
     */

  }, {
    key: "bindContainerStop",
    value: function bindContainerStop() {
      var container = this.container;

      if (!container) return;
      this._stopScrollListener = this.handleStopScroll.bind(this);
      addEvent(container, CONTAINER_STOP_EVENTS, this._stopScrollListener);
    }

    /**
     * Unbind the scroll stop of events
     * @return {void}
     * @private
     */

  }, {
    key: "unbindContainerStop",
    value: function unbindContainerStop() {
      var container = this.container;

      if (!container || !this._stopScrollListener) return;
      removeEvent(container, CONTAINER_STOP_EVENTS, this._stopScrollListener);
      this._stopScrollListener = null;
    }

    /**
     * Call the specified callback
     * @param {Object} options
     * @param {String} type
     * @param {...*} args
     * @return {void}
     * @private
     */

  }, {
    key: "hook",
    value: function hook(options, type) {
      var callback = options[type];

      // callback

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      if (isFunction(callback)) {
        var result = callback.apply(this, args);
        if (typeof result === "undefined") return result;
      }

      // method
      return this[type].apply(this, args);
    }

    /**
     * Handling of scroll stop event
     * @param {Event} e
     * @return {void}
     * @private
     */

  }, {
    key: "handleStopScroll",
    value: function handleStopScroll(e) {
      var stopScroll = this._options ? this._options.stopScroll : this.options.stopScroll;
      if (stopScroll) {
        this.stop();
      } else {
        e.preventDefault();
      }
    }

    /**
     * Handling of container click event
     * @param {Event} e
     * @return {void}
     * @private
     */

  }, {
    key: "handleContainerClick",
    value: function handleContainerClick(e) {
      var options = this.options;

      var el = e.target;

      // Explore parent element until the trigger selector matches
      for (; el && el !== doc; el = el.parentNode) {
        if (!matches(el, options.trigger)) continue;
        var data = el.getAttribute("data-scroll");
        var dataOptions = this.parseDataOptions(el);
        var href = data || el.getAttribute("href");

        options = merge({}, options, dataOptions);

        if (options.preventDefault) e.preventDefault();
        if (options.stopPropagation) e.stopPropagation();

        // Passes the trigger elements to callback
        this._trigger = el;

        if (options.horizontalScroll && options.verticalScroll) {
          this.to(href, options);
        } else if (options.verticalScroll) {
          this.toTop(href, options);
        } else if (options.horizontalScroll) {
          this.toLeft(href, options);
        }
      }
    }

    /**
     * Parse the data-scroll-options attribute
     * @param {Element} el
     * @return {Object}
     * @private
     */

  }, {
    key: "parseDataOptions",
    value: function parseDataOptions(el) {
      var options = el.getAttribute("data-scroll-options");
      return options ? JSON.parse(options) : {};
    }
  }]);
  return SweetScroll;
}();

// Export SweetScroll class


SweetScroll.defaults = {
  trigger: "[data-scroll]", // Selector for trigger (must be a valid css selector)
  header: "[data-scroll-header]", // Selector for fixed header (must be a valid css selector)
  duration: 1000, // Specifies animation duration in integer
  delay: 0, // Specifies timer for delaying the execution of the scroll in milliseconds
  easing: "easeOutQuint", // Specifies the pattern of easing
  offset: 0, // Specifies the value to offset the scroll position in pixels
  verticalScroll: true, // Enable the vertical scroll
  horizontalScroll: false, // Enable the horizontal scroll
  stopScroll: true, // When fired wheel or touchstart events to stop scrolling
  updateURL: false, // Update the URL hash on after scroll (true | false | "push" | "replace")
  preventDefault: true, // Cancels the container element click event
  stopPropagation: true, // Prevents further propagation of the container element click event in the bubbling phase
  outputLog: false, // Specify level of output to log
  quickMode: false, // Instantly scroll to the destination! (It's recommended to use it with `easeOutExpo`)

  // Callbacks
  beforeScroll: null,
  afterScroll: null,
  cancelScroll: null,
  completeScroll: null,
  stepScroll: null
};

return SweetScroll;

})));


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);


// Action Types

var actionTypes = {
  UPDATE_POSTCODE_REQUEST: 'UPDATE_POSTCODE_REQUEST',
  UPDATE_POSTCODE_SUCCESS: 'UPDATE_POSTCODE_SUCCESS',
  LOCATION_FETCH_REQUEST: 'LOCATION_FETCH_REQUEST',
  POSTCODE_INPUT_REQUEST: 'POSTCODE_INPUT_REQUEST',
  POSTCODE_INPUT_CANCEL: 'POSTCODE_INPUT_CANCEL',
  POSTCODE_POPUP_SHOW: 'POSTCODE_POPUP_SHOW',
  POSTCODE_POPUP_HIDE: 'POSTCODE_POPUP_HIDE',
  LOCATION_FETCH_START: 'LOCATION_FETCH_START',
  LOCATION_FETCH_SUCCESS: 'LOCATION_FETCH_SUCCESS',
  LOCATION_FETCH_ERROR: 'LOCATION_FETCH_ERROR',
  LOCATION_CONFIRMED: 'LOCATION_CONFIRMED'

  // Action Creators

};var updatePostcode = function updatePostcode(postcode) {
  return {
    type: actionTypes.UPDATE_POSTCODE_REQUEST,
    payload: { postcode: postcode }
  };
};

var fetchLocation = function fetchLocation() {
  return {
    type: actionTypes.LOCATION_FETCH_REQUEST
  };
};

var requestPostcodeInput = function requestPostcodeInput() {
  return {
    type: actionTypes.POSTCODE_INPUT_REQUEST
  };
};

var cancelPostcodeInput = function cancelPostcodeInput() {
  return {
    type: actionTypes.POSTCODE_INPUT_CANCEL
  };
};

var actionCreators = {
  updatePostcode: updatePostcode,
  fetchLocation: fetchLocation,
  requestPostcodeInput: requestPostcodeInput,
  cancelPostcodeInput: cancelPostcodeInput

  // Selectors

};var getLocation = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('location');

var selectors = {
  getLocation: getLocation
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(700);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YoutubePlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_youtube__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__body__ = __webpack_require__(8);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\youtube-player\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var YoutubePlayer = (_temp = _class = function (_Component) {
  _inherits(YoutubePlayer, _Component);

  function YoutubePlayer(props) {
    _classCallCheck(this, YoutubePlayer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onMouseDown = function (e) {
      _this.clientX = e.clientX;
      _this.clientY = e.clientY;
    };

    _this.onMouseUp = function (e) {
      if (Math.abs(_this.clientX - e.clientX) <= 10 && Math.abs(_this.clientY - e.clientY) <= 10) {
        if (_this.playState === -1) {
          // -1（未開始）
          if (_this.player) _this.player.playVideo();
        } else if (_this.playState === 0) {
          // 0（終了）
          if (_this.player) _this.player.playVideo();
        } else if (_this.playState === 1) {
          // 1（再生中）
          if (_this.player) _this.player.pauseVideo();
        } else if (_this.playState === 2) {
          // 2（停止）
          if (_this.player) _this.player.playVideo();
        } else if (_this.playState === 3) {
          // 3（バッファリング中）
          if (_this.player) _this.player.pauseVideo();
        } else if (_this.playState === 5) {
          // 5（頭出し済み）
          if (_this.player) _this.player.playVideo();
        }
      }
    };

    _this.player = null;
    _this.clientX = null;
    _this.clientY = null;
    _this.playState = null;
    _this.state = {
      isMounted: false
      // isMuted: false,
    };
    return _this;
  }

  YoutubePlayer.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        cls = _props.cls,
        height = _props.height,
        width = _props.width,
        autoplay = _props.autoplay,
        controls = _props.controls,
        youtubeId = _props.youtubeId,
        _onReady = _props.onReady,
        _onStateChange = _props.onStateChange,
        isModal = _props.isModal;


    var renderPlayer = function renderPlayer() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_youtube__["a" /* default */], {
        videoId: youtubeId,
        opts: {
          height: height,
          width: width,
          playerVars: {
            autoplay: autoplay,
            // showinfo: 0,
            controls: controls,
            enablejsapi: 1,
            modestbranding: 1,
            origin: encodeURIComponent(location.protocol + '//' + location.hostname + '/'),
            playsinline: function () {
              if (isModal) {
                var isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
                if (isIOS) {
                  return 1;
                }
              }
              return 0;
            }()
          }
        },
        onReady: function onReady(e) {
          _this2.player = e.target;
          _this2.playState = _this2.player.getPlayerState();

          if (autoplay) {
            _this2.player.mute(); // 音声を消す
            // this.setState({
            //   isMuted: true,
            // })
            _this2.player.playVideo(); // 動画再生
          }

          if (_onReady) _onReady();
        },
        onStateChange: function onStateChange(e) {
          // -1（未開始）
          // 0（終了）
          // 1（再生中）
          // 2（停止）
          // 3（バッファリング中）
          // 5（頭出し済み）
          _this2.playState = e.data;
          if (_onStateChange) _onStateChange();

          if (e.data === 1) {
            // GTMイベント
            __WEBPACK_IMPORTED_MODULE_5__body__["a" /* default */].setGTMEvent({
              trackvideoid: youtubeId,
              event: 'youtubeplay'
            });
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      });
    };

    // const renderPlayer = ()=> {
    //   let src = 'https://www.youtube.com/embed/';
    //   src += youtubeId;
    //   // src += '?enablejsapi=1';
    //   // src += '&modestbranding=1';
    //   // src += '&rel=0';
    //   src += '?playsinline=1';
    //   // src += '&showinfo=0';
    //   // src += '&controls=' + controls;
    //   // src += '&autoplay=' + autoplay;
    //   // src += '&origin=' + location.protocol + '//' + location.hostname + '/';
    //   return (
    //     <iframe
    //       width="100%"
    //       height="315"
    //       id="player"
    //       src={src}
    //       frameBorder="0"
    //       allowFullScreen
    //     ></iframe>
    //   )
    // };

    if (!this.state.isMounted) {
      return null;
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: cls && cls !== '' ? cls : 'YoutubePlayer',
          onMouseDown: function onMouseDown(e) {
            if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
              _this2.onMouseDown(e);
            }
          },
          onMouseUp: function onMouseUp(e) {
            if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
              _this2.onMouseUp(e);
            }
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          }
        },
        renderPlayer()
      );
    }
  };

  YoutubePlayer.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  return YoutubePlayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  cls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  //height: PropTypes.number,
  //width: PropTypes.number,
  autoplay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  youtubeId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onReady: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  isModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}, _class.defaultProps = {
  cls: 'YoutubePlayer',
  height: 585,
  width: 1040,
  autoplay: 0,
  controls: 0,
  youtubeId: null,
  onReady: null,
  onStateChange: null,
  isModal: false
}, _temp);
YoutubePlayer.displayName = 'YoutubePlayer';


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_promo_and_button_modal_window__ = __webpack_require__(116);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\promo-and-button-modal-window\\index.jsx';



// import Wysiwyg from '../../containers/wysiwyg';

var PromoAndButtonModalWindowBlock = function PromoAndButtonModalWindowBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_promo_and_button_modal_window__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
PromoAndButtonModalWindowBlock.displayName = 'PromoAndButtonModalWindowBlock';
PromoAndButtonModalWindowBlock.displayName = 'PromoAndButtonModalWindow';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [
    // Wysiwyg,
  ],
  mapInputToOutput: [
    // ['ctaButton', 'ctaButton'],
    // ['pcContents', 'pcContents'],
    // ['mbContents', 'mbContents'],
  ]
})(PromoAndButtonModalWindowBlock));

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\estimate-link\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EstimateLink = (_temp = _class = function (_PureComponent) {
  _inherits(EstimateLink, _PureComponent);

  function EstimateLink(props) {
    _classCallCheck(this, EstimateLink);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.props = props;
    _this.state = {
      isMounted: false
    };
    return _this;
  }

  EstimateLink.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  EstimateLink.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  EstimateLink.prototype.render = function render() {
    var href = '/purchase/estimate/';
    // let href = 'https://ssl.mazda.co.jp/purchase/estimate/';
    // if (this.state.isMounted) {
    //   href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/' : 'https://ssl.mazda.co.jp/purchase/estimate/';
    // }
    // CarId
    if (this.props.carId && this.props.carId !== '') {
      href = href + '?car_id=' + this.props.carId;
      // href = href + 'edit.html?car_id=' + this.props.carId;
    }
    // CarTypeCode
    if (this.props.carTypeCode && this.props.carTypeCode !== '') {
      href = href + '&car_type_code=' + this.props.carTypeCode;
    }
    // GradeCode
    if (this.props.gradeCode && this.props.gradeCode !== '') {
      href = href + '&grade_code=' + this.props.gradeCode;
    }
    // エクステリアカラー
    // if (this.props.ecode && this.props.ecode !== '') {
    //   href = href + '&ecode=' + this.props.ecode;
    // }
    // ドライブ
    if (this.props.drive && this.props.drive !== '') {
      href = href + '&drive=' + this.props.drive;
    }
    // エンジン
    if (this.props.engine && this.props.engine !== '') {
      href = href + '&engine=' + this.props.engine;
    }
    // ミッション
    if (this.props.mission && this.props.mission !== '') {
      href = href + '&mission=' + this.props.mission;
    }
    // ショップオプション
    if (this.props.soptions && 1 <= this.props.soptions.length) {
      var str = '';
      this.props.soptions.map(function (soption) {
        str = str + soption + ':';
      });
      if (str !== '') {
        href = href + '&soptions=' + str.slice(0, -1);
      }
    }
    // 遷移画面
    if (this.props.direct && this.props.direct !== '') {
      if (this.props.direct === 'Grade') {
        href = href + '&direct=id_contents_grade';
      } else if (this.props.direct === 'Color-And-Sheet') {
        href = href + '&direct=id_contents_color';
      } else if (this.props.direct === 'Maker-Set-Option') {
        href = href + '&direct=id_contents_maker';
      } else if (this.props.direct === 'Shop-Option') {
        href = href + '&direct=id_contents_shop';
      } else if (this.props.direct === 'Result') {
        href = href + '&direct=id_contents_estimate';
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'EstimateLink', __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__blocks__["Cta"], _extends({
        ctaType: 'Free',
        href: href,
        text: this.props.label || '見積りシミュレーション',
        targetBlank: this.props.targetBlank || false,
        linkType: this.props.linkType || 'Button',
        color: this.props.color || 'Dark',
        buttonStyle: this.props.buttonStyle || 'Standard'
      }, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        }
      }))
    );
  };

  return EstimateLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ecode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  soptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  direct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  label: null,
  targetBlank: null,
  color: null,
  buttonStyle: null,
  linkType: null,
  carId: null,
  carTypeCode: null,
  gradeCode: null,
  drive: null,
  mission: null,
  engine: null,
  ecode: null,
  soptions: null,
  direct: null
}, _temp);
EstimateLink.displayName = 'EstimateLink';


/* harmony default export */ __webpack_exports__["a"] = (EstimateLink);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_hero_video__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_related_video__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\hero-video\\index.jsx';







var HeroVideoBlock = function HeroVideoBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_hero_video__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  }));
};
HeroVideoBlock.displayName = 'HeroVideoBlock';
HeroVideoBlock.displayName = 'HeroVideo';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_related_video__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo'], ['relatedVideo', 'relatedVideo']]
})(HeroVideoBlock));

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_hero_image__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\hero-image\\index.jsx';






var HeroImageBlock = function HeroImageBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_hero_image__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
HeroImageBlock.displayName = 'HeroImageBlock';
HeroImageBlock.displayName = 'HeroImage';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(HeroImageBlock));

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_slideshow__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\slideshow\\index.jsx';





var SlideshowBlock = function SlideshowBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_slideshow__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
SlideshowBlock.displayName = 'SlideshowBlock';
SlideshowBlock.displayName = 'Slideshow';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(SlideshowBlock));

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_slidegallery__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_slidegallery_item__ = __webpack_require__(160);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\slidegallery\\index.jsx';




//import PhotoInfo from '../../containers/photo-info';

var SlidegalleryBlock = function SlidegalleryBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_slidegallery__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
SlidegalleryBlock.displayName = 'SlidegalleryBlock';
SlidegalleryBlock.displayName = 'Slidegallery';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_slidegallery_item__["a" /* default */]],
  mapInputToOutput: [['slidegalleryItem', 'slidegalleryItem']]
})(SlidegalleryBlock));

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(40);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(36)
  , IObject  = __webpack_require__(81)
  , toObject = __webpack_require__(41)
  , toLength = __webpack_require__(27)
  , asc      = __webpack_require__(360);
module.exports = function(TYPE){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(40)
  , TAG = __webpack_require__(12)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4)
  , defined = __webpack_require__(37)
  , fails   = __webpack_require__(19)
  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec){
  var exp  = {};
  exp[KEY] = exec(trim);
  $export($export.P + $export.F * fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  }), 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(14)
  , $           = __webpack_require__(7)
  , DESCRIPTORS = __webpack_require__(30)
  , SPECIES     = __webpack_require__(12)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(35)
  , redefine = __webpack_require__(31)
  , fails    = __webpack_require__(19)
  , defined  = __webpack_require__(37)
  , wks      = __webpack_require__(12);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , original = ''[KEY];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return original.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return original.call(string, this); }
    );
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(31);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(14)
  , $export        = __webpack_require__(4)
  , redefine       = __webpack_require__(31)
  , redefineAll    = __webpack_require__(88)
  , forOf          = __webpack_require__(66)
  , strictNew      = __webpack_require__(87)
  , isObject       = __webpack_require__(9)
  , fails          = __webpack_require__(19)
  , $iterDetect    = __webpack_require__(131)
  , setToStringTag = __webpack_require__(64);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO;
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        strictNew(target, C, NAME);
        var that = new Base;
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    IS_WEAK || instance.forEach(function(val, key){
      BUGGY_ZERO = 1 / key === -Infinity;
    });
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRICE_ERRORS; });
/* unused harmony export SERVICE_SCHEDULE_ERRORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GEO_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORM_ERRORS; });
/* unused harmony export DEALER_ERRORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_ERRORS; });
var ERRORS = {
  POSTCODE_INVALID: 'Invalid postcode. Please try again.'
};

var PRICE_ERRORS = {
  LOADING: 'Your price is on its way.',
  /**
   * @todo  NO_LOCATION not used, text 'postcode' needs to be link
   */
  NO_LOCATION: 'Enter your postcode to see accurate pricing in your area.',
  LAST_RESORT: 'Price unavailable. Please contact your local Dealer.'
};

var SERVICE_SCHEDULE_ERRORS = {
  NOTFOUND: 'Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.',
  MULTIPLERESULTS: 'Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer.'
};

var GEO_ERRORS = {
  // Internal
  // comment out to remove errors from client side

  // // Could not load geocoding functionality
  // NO_GEOCODER: 'Could not access your location',
  // // Could not load geolocation functionality
  // NO_GEOLOCATION: 'Could not access your location',
  // // Could not find post code or location
  POSTCODE_NOT_FOUND: 'Invalid postcode. Please try again.',
  LOCATION_NOT_FOUND: 'Invalid postcode. Please try again.'
  //
  // // Geocoder status via Google Maps Geocoder API
  // // https://developers.google.com/maps/documentation/geocoding/intro#StatusCodes
  //
  // GEOCODER_ZERO_RESULTS: 'Could not find your location',
  // GEOCODER_OVER_QUERY_LIMIT: 'Could not access your location',
  // GEOCODER_REQUEST_DENIED: 'Could not access your location',
  // GEOCODER_INVALID_REQUEST: 'Could not access your location',
  // GEOCODER_UNKNOWN_ERROR: 'Could not access your location',
  //
  // // Geolocation error codes via browser geolocationAPI
  // // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
  //
  // // User denied access to location
  // GEOLOCATION_1: 'Location access denied',
  // // There was error attempting to find user location
  // GEOLOCATION_2: 'Could not access your location',
  // // Attempts to find user location timed out
  // GEOLOCATION_3: 'Could not access your location',
  //
  // // For all else
  // default: 'Could not access your location'


  // Register Interest
  // Book-service
};var FORM_ERRORS = {
  // PERSONAL INFORMATION
  TITLE_REQUIRED: 'Please select a title from the drop-down list.',
  FIRSTNAME_MAXLENGTH: 'First name must be shorter than 30 characters',
  FIRSTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_SPECIAL_CHARACTERS_POSITION: 'Please use only letters (a-z) for the first and last character of your name.',
  FIRSTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_REQUIRED: 'Please enter a first name.',
  LASTNAME_MAXLENGTH: 'Last name must be shorter than 50 characters',
  LASTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_SPECIAL_CHARACTERS_POSITION: 'Please use only letters (a-z) for the first and last character of your name.',
  LASTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_REQUIRED: 'Please enter a last name.',
  PHONE_NUMBER_AREACODE_INVALID: 'Please enter a valid landline or mobile number using the correct area code.',
  PHONE_NUMBER_INVALID: 'Please enter a valid landline or mobile number using the correct area code.',
  MOBILE_NUMBER_INVALID: 'Please enter a valid mobile number',
  PHONE_NUMBER_REQUIRED: 'Please enter your phone number.',
  MOBILE_NUMBER_REQUIRED: 'Please enter your mobile number.',
  EMAIL_MAXLENGTH: 'Email is too long.',
  EMAIL_INVALID: 'Please enter a valid email address.',
  EMAIL_REQUIRED: 'Please enter an email address.',
  VIN_INVALID: 'Please enter valid VIN number.',
  REGISTRATION_INVALID: 'Please enter valid registration number.',
  MODEL_REQUIRED: 'Please select a model from the drop-down list.',
  MODEL_FREETEXT_REQUIRED: 'Please enter a model.',
  ODOMETER_REQUIRED: 'Please enter odometer value.',
  ODOMETER_INVALID: 'Please enter odometer value as a whole number.',
  REGO_OR_VIN_REQUIRED: 'Please enter a valid registration or VIN.',
  TOPIC_REQUIRED: 'Please select an enquiry topic from the drop-down list.',
  TIME_INVALID: 'Please enter time in the format HH/MM.',
  LOCATION_REQUIRED: 'Please enter your postcode or tell us which suburb you live in.',
  LOCATION_INVALID: 'Please enter a valid postcode or suburb.',
  DEALERS_NO_POSTCODE: 'Enter your postcode above and we’ll give you a list of your local Mazda Dealerships.'
};

var DEALER_ERRORS = {
  FIRST_VISIT: '',
  NO_DEALERS_FOUND: "Sorry, we can't seem to find the Dealership you're looking for. Please try again."
};

var SEARCH_ERRORS = {
  API_ERROR: 'Sorry, there was an error with your search. Please try again later.'
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssRuleSetToString;

var _appendPxIfNeeded = __webpack_require__(215);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _camelCasePropsToDashCase = __webpack_require__(485);

var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);

var _mapObject = __webpack_require__(216);

var _mapObject2 = _interopRequireDefault(_mapObject);

var _prefixer = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMarkupForStyles(style) {
  return Object.keys(style).map(function (property) {
    return property + ': ' + style[property] + ';';
  }).join('\n');
}

function cssRuleSetToString(selector, rules, userAgent) {
  if (!rules) {
    return '';
  }

  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
    return (0, _appendPxIfNeeded2.default)(key, value);
  });
  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
  var serializedRules = createMarkupForStyles(cssPrefixedRules);

  return selector + '{' + serializedRules + '}';
}
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Based on https://github.com/jsstyles/css-vendor, but without having to
                                                                                                                                                                                                                                                                               * convert between different cases all the time.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                               */

exports.getPrefixedKeyframes = getPrefixedKeyframes;
exports.getPrefixedStyle = getPrefixedStyle;

var _inlineStylePrefixer = __webpack_require__(486);

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformValues(style) {
  return Object.keys(style).reduce(function (newStyle, key) {
    var value = style[key];
    if (Array.isArray(value)) {
      value = value.join(';' + key + ':');
    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
      value = value.toString();
    }

    newStyle[key] = value;
    return newStyle;
  }, {});
}

var _hasWarnedAboutUserAgent = false;
var _lastUserAgent = void 0;
var _cachedPrefixer = void 0;

function getPrefixer(userAgent) {
  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;

  if (false) {
    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
      /* eslint-disable no-console */
      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
      /* eslint-enable no-console */
      _hasWarnedAboutUserAgent = true;
    }
  }

  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
    if (actualUserAgent === 'all') {
      _cachedPrefixer = {
        prefix: _inlineStylePrefixer2.default.prefixAll,
        prefixedKeyframes: 'keyframes'
      };
    } else {
      _cachedPrefixer = new _inlineStylePrefixer2.default({ userAgent: actualUserAgent });
    }
    _lastUserAgent = actualUserAgent;
  }
  return _cachedPrefixer;
}

function getPrefixedKeyframes(userAgent) {
  return getPrefixer(userAgent).prefixedKeyframes;
}

// Returns a new style object with vendor prefixes added to property names
// and values.
function getPrefixedStyle(style, userAgent) {
  var styleWithFallbacks = transformValues(style);
  var prefixer = getPrefixer(userAgent);
  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
  return prefixedStyle;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// returns a style object with a single concated prefixed value string

exports.default = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
    return replacer(prefix, value);
  }));
};

module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);





var history = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["d" /* IS_BROWSER */] ? __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()() : __WEBPACK_IMPORTED_MODULE_1_history_createMemoryHistory___default()();

var getLocation = function getLocation() {
  return history.location;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(547);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);



// Action Types

var actionTypes = {
  UPDATE_FOOTER_HEIGHT: 'UPDATE_FOOTER_HEIGHT',
  UPDATE_GLOBAL_HEADER_HEIGHT: 'UPDATE_GLOBAL_HEADER_HEIGHT',
  UPDATE_IN_PAGE_NAV_HEIGHT: 'UPDATE_IN_PAGE_NAV_HEIGHT',
  UPDATE_WINDOW_SIZE: 'UPDATE_WINDOW_SIZE',
  UPDATE_WINDOW_SCROLL: 'UPDATE_WINDOW_SCROLL'

  // Action Creators

};var updateGlobalHeaderHeight = function updateGlobalHeaderHeight(height) {
  return {
    type: actionTypes.UPDATE_GLOBAL_HEADER_HEIGHT,
    payload: { height: height }
  };
};

var updateInPageNavHeight = function updateInPageNavHeight(height) {
  return {
    type: actionTypes.UPDATE_IN_PAGE_NAV_HEIGHT,
    payload: { height: height }
  };
};

var updateFooterHeight = function updateFooterHeight(height) {
  return {
    type: actionTypes.UPDATE_FOOTER_HEIGHT,
    payload: { height: height }
  };
};

var updateWindowSize = function updateWindowSize(win) {
  return {
    type: actionTypes.UPDATE_WINDOW_SIZE,
    payload: win
  };
};

var updateWindowScroll = function updateWindowScroll(win) {
  return {
    type: actionTypes.UPDATE_WINDOW_SCROLL,
    payload: win
  };
};

var actionCreators = {
  updateGlobalHeaderHeight: updateGlobalHeaderHeight,
  updateInPageNavHeight: updateInPageNavHeight,
  updateWindowSize: updateWindowSize,
  updateWindowScroll: updateWindowScroll,
  updateFooterHeight: updateFooterHeight

  // Selectors

};var pickDimensions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* pick */])(['innerWidth', 'innerHeight']);
var pickScroll = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["y" /* pick */])(['scrollY']);

var getEnvironment = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('environment');
var getGlobalHeaderHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('globalHeaderHeight'));
var getInPageNavHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('inPageNavHeight'));
var getFooterHeight = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('footerHeight'));
var getWindow = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('window'));
var getWindowSize = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getWindow, pickDimensions);
var getWindowScroll = function getWindowScroll() {
  return {
    scrollY: __WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */] ? window.scrollY || window.pageYOffset || document.documentElement.scrollTop : 0
  };
};
var getIsOldBrowser = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["z" /* pipe */])(getEnvironment, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])('isOldBrowser'));

var selectors = {
  getGlobalHeaderHeight: getGlobalHeaderHeight,
  getInPageNavHeight: getInPageNavHeight,
  getFooterHeight: getFooterHeight,
  getWindowSize: getWindowSize,
  getWindowScroll: getWindowScroll,
  getIsOldBrowser: getIsOldBrowser,
  pickDimensions: pickDimensions,
  pickScroll: pickScroll
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRequestTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = action;
/* unused harmony export generateActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInitialFromQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var REQUEST = 'REQUEST';
var SUCCESS = 'SUCCESS';
var FAILURE = 'FAILURE';

var requestTypes = {
  REQUEST: REQUEST,
  SUCCESS: SUCCESS,
  FAILURE: FAILURE
};

var createRequestTypes = function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce(function (acc, type) {
    acc[type] = base + '_' + type;
    return acc;
  }, {});
};

function action(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return { type: type, payload: payload };
}

var generateActionTypes = function generateActionTypes(names) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return names.reduce(function (t, name) {
    var _extends2;

    return _extends({}, t, (_extends2 = {}, _extends2[name] = '' + prefix + name + suffix, _extends2));
  }, {});
};

var getInitialFromQuery = function getInitialFromQuery(key) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* get */])(key, __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].location.search));
};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
// Action Types

var actionTypes = {
  UPDATE_COUNTER_CLICKED_TIME: 'UPDATE_COUNTER_CLICKED_TIME'

  // Action Creators

};var updateCounterClickedTime = function updateCounterClickedTime(parameters) {
  return {
    type: actionTypes.UPDATE_COUNTER_CLICKED_TIME,
    payload: parameters
  };
};

var actionCreators = {
  updateCounterClickedTime: updateCounterClickedTime
};

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(101),
    getRawTag = __webpack_require__(617),
    objectToString = __webpack_require__(618);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(639),
    listCacheDelete = __webpack_require__(640),
    listCacheGet = __webpack_require__(641),
    listCacheHas = __webpack_require__(642),
    listCacheSet = __webpack_require__(643);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(645);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hyperlink__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\footer-navigation\\index.jsx';






/**
 * FooterNavigation
 */
var FooterNavigation = function FooterNavigation(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      copyright = _ref.copyright,
      links = _ref.links;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FooterNavigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FooterNavigation__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FooterNavigation__layout', __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'FooterNavigation__layout-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 24
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'FooterNavigation__list', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 25
                }
              },
              links !== null ? links.map(function (link, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'FooterNavigation__list-item',
                    key: index,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 29
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_hyperlink__["a" /* default */], {
                    pageName: link.pageName,
                    pcText: link.pcText,
                    mbText: link.mbText,
                    href: link.href,
                    external: link.external,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 32
                    }
                  })
                );
              }) : null
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'FooterNavigation__layout-right', __source: {
                fileName: _jsxFileName,
                lineNumber: 45
              }
            },
            copyright !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'small',
              { className: 'FooterNavigation__copyright Wysiwyg', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 47
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: copyright }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 48
                }
              })
            ) : null
          )
        )
      )
    )
  );
};

FooterNavigation.displayName = 'FooterNavigation';
FooterNavigation.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  copyright: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
};
FooterNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  copyright: null,
  links: null
};
/* harmony default export */ __webpack_exports__["a"] = (FooterNavigation);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\social-icons-container-block\\index.jsx';






/**
 * SocialIconsContainerBlock
 */
var SocialIconsContainerBlock = function SocialIconsContainerBlock(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      links = _ref.links;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SocialIconsContainerBlock', __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      links !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SocialIconsContainerBlock__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'SocialIconsContainerBlock__list-ul', __source: {
              fileName: _jsxFileName,
              lineNumber: 23
            }
          },
          links.map(function (link, index) {
            return link.text !== null || link.text2 !== null || link.src !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 27
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIconsContainerBlockLink, {
                href: link.href,
                targetBlank: link.targetBlank,
                text: link.text,
                text2: link.text2,
                src: link.src,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 28
                }
              })
            ) : null;
          })
        )
      ) : null
    )
  );
};
SocialIconsContainerBlock.displayName = 'SocialIconsContainerBlock';
SocialIconsContainerBlock.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }))
};
SocialIconsContainerBlock.defaultProps = {
  containerId: null,
  containerClass: null,
  links: null
};
/* harmony default export */ __webpack_exports__["a"] = (SocialIconsContainerBlock);

/**
 * SocialIconsContainerBlockLink
 */
var SocialIconsContainerBlockLink = function SocialIconsContainerBlockLink(_ref2) {
  var href = _ref2.href,
      targetBlank = _ref2.targetBlank,
      text = _ref2.text,
      text2 = _ref2.text2,
      src = _ref2.src;


  var getLinkElement = function getLinkElement(element) {
    if (href !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'SocialIconsContainerBlock__link',
          href: href !== null ? href : '',
          target: targetBlank === true ? '_blank' : '',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 78
          }
        },
        element
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SocialIconsContainerBlock__box', __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        },
        element
      );
    }
  };
  var getTextElement = function getTextElement() {
    if (text !== null && text2 !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SocialIconsContainerBlock__text', __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 97
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text2) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 99
          }
        })
      );
    } else if (text !== null && text2 === null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SocialIconsContainerBlock__text', __source: {
            fileName: _jsxFileName,
            lineNumber: 104
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 105
          }
        })
      );
    } else if (text === null && text2 !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SocialIconsContainerBlock__text', __source: {
            fileName: _jsxFileName,
            lineNumber: 110
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text2) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 111
          }
        })
      );
    } else {
      return null;
    }
  };
  return getLinkElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120
      }
    },
    src !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SocialIconsContainerBlock__image', src: src, __source: {
        fileName: _jsxFileName,
        lineNumber: 121
      }
    }) : null,
    getTextElement()
  ));
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\scroll-top\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * ScrollTop
 */

var ScrollTop = function (_Component) {
  _inherits(ScrollTop, _Component);

  function ScrollTop(props) {
    _classCallCheck(this, ScrollTop);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleScroll = function () {
      //const top = document.documentElement.scrollTop;
      var top = window.pageYOffset;
      if (top < 100) {
        if (_this.isOpen === false) return;
        _this.isOpen = false;
        _this.setState({
          open: false
        });
      } else {
        if (_this.isOpen === true) return;
        _this.isOpen = true;
        _this.setState({
          open: true
        });
      }
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      //
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["E" /* scrollToOffset */])(0);
    };

    _this.props = props;
    _this.state = {
      open: false
    };
    _this.isOpen = false;
    return _this;
  }

  ScrollTop.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  };

  ScrollTop.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  ScrollTop.prototype.render = function render() {
    var _this2 = this;

    var open = this.state.open === true ? ' open' : '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'ScrollTop' + open,
        href: '#',
        onClick: function onClick(e) {
          _this2.handleClick(e);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      },
      'ScrollTop'
    );
  };

  //


  //


  return ScrollTop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollTop.displayName = 'ScrollTop';


/* harmony default export */ __webpack_exports__["a"] = (ScrollTop);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(95);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _class,
    _temp,
    _jsxFileName = "C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\navigation-container\\index.jsx";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NavigationContainer = (_temp = _class = function (_Component) {
  _inherits(NavigationContainer, _Component);

  function NavigationContainer(props) {
    _classCallCheck(this, NavigationContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.setCurrentCenter = function () {
      _this.containerWidth = _this.refs.container.clientWidth;
      _this.contentWidth = _this.refs.content.scrollWidth;
      _this.currentItemPosition = _this.props.getCurrentItemPosition();
      //
      if (_this.contentWidth <= _this.containerWidth) {
        _this.positionLeft = 0;
        _this.setState({
          positionLeft: _this.positionLeft,
          opacity: 1
        });
      } else {
        _this.positionLeft = _this.currentItemPosition - _this.containerWidth / 2;
        if (_this.contentWidth - _this.containerWidth < _this.positionLeft) _this.positionLeft = _this.contentWidth - _this.containerWidth;
        if (_this.positionLeft < 0) _this.positionLeft = 0;
        //
        _this.setState({
          positionLeft: -_this.positionLeft,
          opacity: 1
        });
      }
      //
      _this.checkDisabledLink();
    };

    _this.handleResize = function () {
      if (_this.state.open === false) return;
      _this.containerWidth = _this.refs.container.clientWidth;
      _this.contentWidth = _this.refs.content.scrollWidth;
      //
      if (_this.contentWidth <= _this.containerWidth) {
        _this.setState({
          containerWidth: _this.containerWidth,
          contentWidth: _this.contentWidth,
          scrollEnabled: false
        });
      } else {
        _this.setState({
          containerWidth: _this.containerWidth,
          contentWidth: _this.contentWidth,
          scrollEnabled: true
        });
      }
      //
      if (1360 <= document.body.clientWidth) {
        _this.setState({
          maxWidth: 1220 - (_this.props.excludedWidth + 60)
          //maxWidth: 1220 - this.props.excludedWidth,
        });
      } else if (768 <= document.body.clientWidth) {
        _this.setState({
          maxWidth: document.body.clientWidth - (_this.props.excludedWidth + 80 + 60)
          //maxWidth: document.body.clientWidth - 140 - this.props.excludedWidth,
        });
      } else {
        _this.setState({
          maxWidth: 'auto'
        });
      }
      //
      if (window.innerWidth <= 1024) {
        if (_this.desktop === true) {
          _this.desktop = false;
          _this.setState({
            positionLeft: 0
          });
          _this.refs.container.scrollLeft = 0;
        }
      } else {
        if (_this.desktop === false) {
          _this.desktop = true;
          _this.setState({
            positionLeft: 0
          });
          _this.refs.container.scrollLeft = 0;
        }
      }
      //
      _this.checkDisabledLink();
    };

    _this.prev = function (e) {
      e.preventDefault();
      //
      _this.itemPositions = _this.props.getItemPositions();
      var left = 0;
      var i = void 0;
      for (i = _this.itemPositions.length - 1; 0 <= i; i = i - 1) {
        if (_this.itemPositions[i] <= _this.positionLeft - _this.containerWidth) {
          break;
        } else {
          left = _this.itemPositions[i];
        }
      }
      _this.positionLeft = left;
      if (_this.positionLeft < 0) {
        _this.positionLeft = 0;
        _this.setState({
          positionLeft: -_this.positionLeft,
          opened: true
        });
      } else {
        _this.setState({
          positionLeft: -_this.positionLeft,
          opened: true
        });
      }
      _this.checkDisabledLink();
    };

    _this.next = function (e) {
      e.preventDefault();
      //
      _this.itemPositions = _this.props.getItemPositions();
      var left = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.itemPositions.length; i < max; i = i + 1) {
        if (_this.containerWidth + _this.positionLeft <= _this.itemPositions[i]) {
          break;
        } else {
          left = _this.itemPositions[i];
        }
      }
      _this.positionLeft = left;
      if (_this.itemPositions[_this.itemPositions.length - 1] - _this.containerWidth <= _this.positionLeft) {
        _this.positionLeft = _this.itemPositions[_this.itemPositions.length - 1] - _this.containerWidth;
        _this.setState({
          positionLeft: -_this.positionLeft,
          opened: true
        });
      } else {
        _this.setState({
          positionLeft: -_this.positionLeft,
          opened: true
        });
      }
      _this.checkDisabledLink();
    };

    _this.checkDisabledLink = function (e) {
      //
      if (_this.positionLeft <= 0) {
        _this.setState({
          disabledPrev: true
        });
      } else {
        _this.setState({
          disabledPrev: false
        });
      }
      //
      if (_this.contentWidth - _this.containerWidth <= _this.positionLeft) {
        _this.setState({
          disabledNext: true
        });
      } else {
        _this.setState({
          disabledNext: false
        });
      }
    };

    _this.props = props;
    _this.state = {
      containerWidth: 0,
      contentWidth: 0,
      positionLeft: 0,
      scrollEnabled: false,
      disabledPrev: true,
      disabledNext: false,
      maxWidth: 'auto',
      opened: false,
      opacity: _this.props.opacity
    };
    _this.containerWidth = 0;
    _this.contentWidth = 0;
    _this.positionLeft = 0;
    //
    _this.itemPositions = [];
    _this.currentItemPosition = 0;
    _this.desktop = null;
    _this.isTablet = false;
    return _this;
  }

  NavigationContainer.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    setTimeout(function () {
      _this2.handleResize();
      _this2.setCurrentCenter();
    }, 200);
  };

  NavigationContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  NavigationContainer.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: 'NavigationContainer' + (this.isTablet === true ? ' tablet' : '') + (this.state.opened === true ? ' opened' : ''),
        style: { opacity: this.state.opacity },
        ref: "navigationContainer",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "NavigationContainer__container-left", __source: {
            fileName: _jsxFileName,
            lineNumber: 65
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            className: 'NavigationContainer__link-prev' + (this.state.scrollEnabled ? ' enabled' : '') + (this.state.disabledPrev ? ' disabled' : ''),
            href: "#",
            onClick: this.prev,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 66
            }
          },
          'Prev'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "NavigationContainer__container-center",
          style: { maxWidth: this.state.maxWidth },
          ref: "container",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "NavigationContainer__content",
            ref: "content",
            style: { left: this.state.positionLeft },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 78
            }
          },
          this.props.children
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "NavigationContainer__container-right", __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            className: 'NavigationContainer__link-next' + (this.state.scrollEnabled ? ' enabled' : '') + (this.state.disabledNext ? ' disabled' : ''),
            href: "#",
            onClick: this.next,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          'Next'
        )
      )
    );
  };

  //


  //


  //


  //


  //


  return NavigationContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  getItemPositions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getCurrentItemPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  excludedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  opacity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  children: null,
  getItemPositions: null,
  getCurrentItemPosition: null,
  excludedWidth: 0,
  opacity: 0
}, _temp);
NavigationContainer.displayName = "NavigationContainer";


/* harmony default export */ __webpack_exports__["a"] = (NavigationContainer);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__related_video__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_youtube_player__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\hero-video\\index.jsx',
    _class,
    _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// ---


// ---






/**
 * heading - tag + text pare を作成します - {@link convertPipeToBrTag} で `|` to `<br>` 変換を行い insert します
 * @param {?string} tag heading tag
 * @param {?string} label tag 内 text - `dangerous` option true の時は HTML それ以外は pure text
 * @param {string} defaultTagName argument tag value が `Default` 時の代替 tag - HTML で定義されているタグを指定します
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します - 必須です
 * @param {boolean} [dangerous=false] HTML の時に `true` セットします
 * @param {string} [alternate=''] 代替データ - string
 * @param {string} [baseClass=HeroVideo__heading] `tag` 引数へ付与する class name 先頭文字
 * @returns {?Element} heading tag を返します
 * @constructor
 */
var HeadingTag = function HeadingTag(_ref) {
  var tag = _ref.tag,
      label = _ref.label,
      defaultTagName = _ref.defaultTagName,
      suffix = _ref.suffix,
      dangerous = _ref.dangerous,
      alternate = _ref.alternate,
      baseClass = _ref.baseClass;

  var labelText = label !== null && label ? label : alternate;
  if (labelText === null || !labelText) {
    return null;
  }
  // make attribute
  var attributes = {
    className: '' + baseClass + (suffix ? '__' : '') + suffix
  };
  // tag name
  var tagName = tag ? tag.toLowerCase() : 'default';
  // create element
  var Element = tagName === 'default' ? defaultTagName : tagName;
  // label is plane text
  if (!dangerous) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Element,
      _extends({}, attributes, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        }
      }),
      labelText
    );
  }
  // dangerous - label is HTML
  attributes.dangerouslySetInnerHTML = { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(labelText) };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element, _extends({}, attributes, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    }
  }));
};

HeadingTag.displayName = 'HeadingTag';
HeadingTag.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultTagName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dangerous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  alternate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

HeadingTag.defaultProps = {
  tag: null,
  label: null,
  suffix: '',
  dangerous: false,
  alternate: '',
  baseClass: 'HeroVideo__heading'
};

// -----------------------------------------------
/**
 * description tag text 作成します
 * @param {?string} description 説明文
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します
 * @param {string} [alternate=''] 代替データ - string
 * @param {string} [baseClass=HeroVideo__heading] コンテナへ付与する class name 先頭文字
 * @returns {?Element} description tag を返します
 * @constructor
 */
var DescriptionTag = function DescriptionTag(_ref2) {
  var description = _ref2.description,
      suffix = _ref2.suffix,
      alternate = _ref2.alternate,
      baseClass = _ref2.baseClass;

  var text = description !== null && description ? description : alternate;
  if (text === null || !text) {
    return null;
  }
  var className = '' + baseClass + (suffix ? '__' : '') + suffix;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className + ' Wysiwyg', dangerouslySetInnerHTML: { __html: text }, __source: {
      fileName: _jsxFileName,
      lineNumber: 92
    }
  });
};

DescriptionTag.displayName = 'DescriptionTag';
DescriptionTag.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  alternate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

DescriptionTag.defaultProps = {
  description: null,
  suffix: '',
  alternate: '',
  baseClass: 'HeroVideo__heading'
};

// -----------------------------------------------
/**
 * CTA link tag を作成します - large lint `imageLink` と共存できないので出力時に注意します
 * @param {?{href: string, text: string, type: string, targetBlank: boolean}} link props.link object
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__btn__link] コンテナへ付与する class name 先頭文字
 * @returns {?Element} CTA `a` tag を返します
 * @constructor
 */
var CtaTag = function CtaTag(_ref3) {
  var link = _ref3.link,
      suffix = _ref3.suffix,
      baseClass = _ref3.baseClass;

  if (link === null || !link || !link.href || !link.text) {
    return null;
  }
  // a tag
  var type = link.type || '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      href: link.href,
      className: '' + baseClass + (suffix ? '-' : '') + suffix + ' ' + type,
      target: link.targetBlank ? '_blank' : '_self',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126
      }
    },
    link.text
  );
};

CtaTag.displayName = 'CtaTag';
CtaTag.propTypes = {
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

CtaTag.defaultProps = {
  link: null,
  suffix: '',
  baseClass: 'HeroVideo__btn__link'
};

// -----------------------------------------------
/**
 * `span.HeroVideo__videoFilter` filter tag を作成します
 * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
 * @returns {?Element} `span.HeroVideo__videoFilter`
 * @constructor
 */
var FilterTag = function FilterTag(_ref4) {
  var filterFlag = _ref4.filterFlag,
      suffix = _ref4.suffix,
      baseClass = _ref4.baseClass;

  if (filterFlag === null || !filterFlag) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: '' + baseClass + (suffix ? '-' : '') + suffix, __source: {
      fileName: _jsxFileName,
      lineNumber: 161
    }
  });
};

FilterTag.displayName = 'FilterTag';
FilterTag.propTypes = {
  filterFlag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
FilterTag.defaultProps = {
  suffix: '',
  baseClass: 'HeroVideo__videoFilter'
};

// -----------------------------------------------
var LikeVideoPosterBackground = function LikeVideoPosterBackground(_ref5) {
  var src = _ref5.src,
      suffix = _ref5.suffix,
      videoVisible = _ref5.videoVisible;

  if (!src || videoVisible) {
    return null;
  }
  // video 非表示に表示する
  var style = {
    backgroundImage: 'url(' + src + ')'
    // display: videoVisible ? 'none' : 'block',
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: 'HeroVideo__video__poster HeroVideo__video__poster-' + suffix,
    style: style,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185
    }
  });
};

LikeVideoPosterBackground.displayName = 'LikeVideoPosterBackground';
LikeVideoPosterBackground.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  videoVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

LikeVideoPosterBackground.defaultProps = {
  src: null
};

// -----------------------------------------------

/**
 * HeroVideo component
 * - YouTube - modal で再生します
 * - inline 再生できない端末は poster 画像表示になります
 */
var HeroVideo = (_temp = _class = function (_Component) {
  _inherits(HeroVideo, _Component);

  /**
   * props から state 情報を設定する
   * @param {*} props React.prop
   * @param {*} state React.state
   * @returns {*} 変更情報
   */
  HeroVideo.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // console.log('HeroVideo.getDerivedStateFromProps', props.heroCarouselSlideId !== state.heroCarouselSlideId, props.heroCarouselSlideId, state.heroCarouselSlideId);
    if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
      return {
        prevHeroCarouselSlideId: state.heroCarouselSlideId,
        heroCarouselSlideId: props.heroCarouselSlideId
      };
    }
    return null;
  };

  /**
   * `div.RelatedVideo` が見つかるまで再帰的に parent 探索します
   * - `data-yt` から YouTube ID を取得します
   * @param {Node|HTMLElement|Element} target event target 探索起点 Node
   * @returns {?string} `data-yt` value - YouTube ID
   */


  HeroVideo.parseNode = function parseNode(target) {
    if (!target) {
      return null;
    }
    if (!target.classList || !target.classList.contains('RelatedVideo')) {
      return HeroVideo.parseNode(target.parentNode);
    }
    return target.dataset.yt;
  };

  function HeroVideo(props) {
    _classCallCheck(this, HeroVideo);

    // ---
    /**
     * React.state
     * - isOpen - modal open class name - 'is-open' / ''
     * - mbHeight - mobile `Vertical` option container は `height` 必須 - image height
     * @type {{isOpen: string, mbHeight: ?number, visiblePc: boolean, visibleMb: boolean, entered: string, youtubeId: ?string, fitWidth: ?{}}}
     */
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      // modal open / close
      isOpen: '',
      // mb image height
      mbHeight: null,
      visiblePc: true,
      visibleMb: true,
      entered: '',
      // YouTube ID
      youtubeId: props.youtubeId,
      fitWidth: null,
      // extend
      heroCarouselSlideId: '',
      btnScrollClicked: ''
    };
    _this.timer = {
      btnScroll: 0,
      btnEmpty: 0,
      waitPc: 0,
      waitMb: 0,
      pauseRewind: 0,
      // ---
      load: 0,
      figure: 0,
      playingPc: 0,
      playingMb: 0,
      checkPlayingPc: 0,
      checkPlayingMb: 0,
      firstVideoPlay: 0
    };
    // console.log('HeroVideo', props.heroCarouselUniqueId);
    /**
     * bound onClickModalOpen - modal open event handler
     * @type {bound|any}
     */
    _this.onClickModalOpen = _this.onClickModalOpen.bind(_this);
    /**
     * bound onClickModalClose - modal close event handler
     * @type {bound|any}
     */
    _this.onClickModalClose = _this.onClickModalClose.bind(_this);
    /**
     * bound onClickInnerLink - scroll to hash `data-id["CSS_ID"]` event handler
     * @type {bound|any}
     */
    _this.onClickInnerLink = _this.onClickInnerLink.bind(_this);
    /**
     * bound onPcVideoEnded - PC video ended event handler
     * @type {bound|any}
     */
    _this.onPcVideoEnded = _this.onPcVideoEnded.bind(_this);
    /**
     * bound onMbVideoEnded - MB video ended event handler
     * @type {bound|any}
     */
    _this.onMbVideoEnded = _this.onMbVideoEnded.bind(_this);
    /**
     * YouTube iframe 参照 - mount 後設定されます
     * @type {?Element}
     */
    _this.youtubeIframe = null;
    /**
     * YouTube iframe src - `postMessage` 失敗する Browser のみ失敗時に設定されます
     * @type {string}
     */
    _this.youtubeIframeSrc = '';
    /**
     * YouTube iframe id - 識別子として使用できるように念のために設定しておきます
     * @type {string}
     */
    _this.youtubeIframeId = 'HeroVideo__modal__movie-' + Date.now();
    // this.activate = this.activate.bind(this);
    // this.playVideo = this.playVideo.bind(this);
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    _this.videos = {
      pc: null,
      mb: null
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.ended = {
      pc: false,
      mb: false
    };
    // this.onResize = this.onResize.bind(this);
    /**
     * PC / MB breakpoint
     * - PC: >= 768
     * - MB: < 768
     * @type {number}
     */
    _this.breakPoint = 768;
    /**
     * MB `Vertical` container 参照 - mount 後に設定されます
     * @type {?Element}
     */
    _this.mbImg = null;
    // scroll to id
    var link = props.link;
    // href - `#HASH` なリンクがあるかをチェックする

    var href = link && link.href ? link.href : null;
    var hash = href ? href.split('#').pop() : null;
    /**
     * link.href から HASH 文字取り出す - page 内リンク sweet scroll - {@link scrollToElementId} で使用します
     * @type {?string}
     */
    _this.targetId = hash && hash !== href ? hash : null;
    // console.log('HeroVideo', href, hash, this.targetId);
    /**
     * modal open class name
     * @type {string}
     */
    _this.modalOpened = 'HeroVideo__modal__opened';
    /**
     * bound onClickModalCloseByContent - `div.HeroVideo__modal__content` click handler
     * @type {bound|any}
     */
    _this.onClickModalCloseByContent = _this.onClickModalCloseByContent.bind(_this);
    /**
     * bound onPcVideoPlay - pc.video.play event handler
     * @type {bound|any}
     */
    _this.onPcVideoPlay = _this.onPcVideoPlay.bind(_this);
    /**
     * bound onMbVideoPlay - mb.video.play event handler
     * @type {bound|any}
     */
    _this.onMbVideoPlay = _this.onMbVideoPlay.bind(_this);
    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.played = {
      pc: false,
      mb: false
    };
    /**
     * poster 画像存在 flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.posters = {
      pc: false,
      mb: false
    };
    /**
     * bound onLinkEnter - imageLink.onmouseenter handler
     * @type {bound|any}
     */
    _this.onLinkEnter = _this.onLinkEnter.bind(_this);
    /**
     * bound onLinkLeave- imageLink.onmouseuleave handler
     * @type {bound|any}
     */
    _this.onLinkLeave = _this.onLinkLeave.bind(_this);
    /**
     * bind onClickRelated - {@link RelatedVideo} click を親 Node で delegate します
     * @type {bound|any}
     */
    _this.onClickRelated = _this.onClickRelated.bind(_this);
    /**
     * mb - vertical retry count - get video size
     * @type {number}
     */
    _this.iniCount = 0;
    /**
     * `.hero` Element - cache のために用意したが {@link scrollToNode} が正しく位置取得できないので使用しない - 残しておく
     * @type {?Element}
     */
    _this.heroElement = null;
    _this.bodyClasses = ['modal-open'];
    _this.canPlay = {
      pc: false,
      mb: false
    };
    _this.onPcVideoCanPlay = _this.onPcVideoCanPlay.bind(_this);
    _this.onMbVideoCanPlay = _this.onMbVideoCanPlay.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.element = {
      figure: null
    };
    _this.onPcVideoPlaying = _this.onPcVideoPlaying.bind(_this);
    _this.onMbVideoPlaying = _this.onMbVideoPlaying.bind(_this);
    _this.playing = {
      pc: false,
      mb: false
    };
    _this.tryPlayCount = {
      pc: 0,
      mb: 0
    };
    // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];

    // EPIServerのプレビュー時のモーダルの位置調整
    _this.wrapperScrollTop = 0;

    return _this;
  }
  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   const video = this.videos.mb;
  //   const playing = this.playing.mb;
  //   if (video && !playing && this.hitTest()) {
  //     // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //     this.playVideo(false);
  //   }
  // }


  HeroVideo.prototype.hitTest = function hitTest() {
    var inHeroCarousel = this.props.inHeroCarousel;

    return !inHeroCarousel || this.shouldVideoPlay();
  };
  /**
   * `a.HeroVideo__Youtube__link` click event handler
   * - modal open します - state.isOpen: 'is-open'
   * @param {Event} event click Event
   */


  HeroVideo.prototype.onClickModalOpen = function onClickModalOpen(event) {
    event.preventDefault();
    this.executeOpen();
  };

  /**
   * `button.HeroVideo__modal__btn__close` click event handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */


  HeroVideo.prototype.onClickModalClose = function onClickModalClose(event) {
    event.preventDefault();
    this.executeClose();
  };

  /**
   * `div.HeroVideo__modal__content` click handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */


  HeroVideo.prototype.onClickModalCloseByContent = function onClickModalCloseByContent(event) {
    var target = event.target;
    // console.log('HeroVideo.onClickModalCloseByContent', target, event);
    var nodeName = target.nodeName.toLowerCase();
    // const className = target.className;
    if (nodeName === 'div' && (target.classList.contains('HeroVideo__modal__content') || target.classList.contains('HeroVideo__modal__content__inner'))) {
      this.executeClose();
    }
  };

  /**
   * modal を開きます
   * - document.body - `.HeroVideo__modal__opened`, `.un-scroll-pc`, `.un-scroll-mb`
   */


  HeroVideo.prototype.executeOpen = function executeOpen() {
    // modal open flag on body
    document.body.classList.add(this.modalOpened);

    // EPIServerのプレビュー時のモーダルの位置調整
    // let isEpiServerPreview = false;
    if (__WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.style.position = 'absolute';
          __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.style.top = -this.wrapperScrollTop + 'px';
          var headerElement = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          // isEpiServerPreview = true;
        }
      }
    }
    // if (!isEpiServerPreview) {
    //   // BODYのスクロール無効化
    //   BodyControl.openModal();
    // }

    // BODYのスクロール無効化
    __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].openModal();
    //this.bodyClasses.map(className => (document.body.classList.add(className)));
    // extend
    // @since 2018-07-06
    var _props = this.props,
        modalWillOpen = _props.modalWillOpen,
        containerId = _props.containerId,
        youtubeId = _props.youtubeId;

    if (typeof modalWillOpen === 'function') {
      modalWillOpen.call(this, containerId);
    }
    // ---
    // pause video
    this.pauseVideos();
    // ---
    // state change
    this.setState({ isOpen: 'is-open', youtubeId: youtubeId });
  };

  /**
   * modal を閉じ YouTube 再生を止めます
   * - state.isOpen: ''
   * - {@link HeroVideo.stopYouTube}
   */


  HeroVideo.prototype.executeClose = function executeClose() {
    this.stopYouTube();
    // ---
    document.body.classList.remove(this.modalOpened);

    // EPIServerのプレビュー時のモーダルの位置調整
    if (__WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.style.position = 'static';
          __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.style.top = 'auto';
          var headerElement = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].closeModal();
    //this.bodyClasses.map(className => (document.body.classList.remove(className)));
    // ---
    // @since 2018-07-06
    var _props2 = this.props,
        modalWillClose = _props2.modalWillClose,
        containerId = _props2.containerId,
        youtubeId = _props2.youtubeId;

    if (typeof modalWillClose === 'function') {
      modalWillClose.call(this, containerId);
    }
    // ---
    // play video - check can play
    this.afterModalClosePlayVideoIfCan();
    // ---
    // state change
    this.setState({ isOpen: '', youtubeId: null });
  };
  /**
   * modal close 後に video 再生可能(NO ENDED)なら play します
   */


  HeroVideo.prototype.afterModalClosePlayVideoIfCan = function afterModalClosePlayVideoIfCan() {
    var _ended = this.ended,
        pc = _ended.pc,
        mb = _ended.mb;

    if (!pc || !mb) {
      clearTimeout(this.timer.pauseRewind);
    }
    if (!pc) {
      this.playVideo(true);
    }
    if (!mb) {
      this.playVideo(false);
    }
  };
  // -----------------------------------------------------
  /**
   * window.onresize event handler - clientRect を再計算します
   * - {@link HeroVideo.getAndSendRectFigureBlock} 実行し可能なら `clientRect` 通知します
   */


  HeroVideo.prototype.onResize = function onResize() {
    var _this2 = this;

    setTimeout(function () {
      _this2.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  };

  HeroVideo.prototype.sendMessageFigureRect = function sendMessageFigureRect() {
    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    var _props3 = this.props,
        sendMessage = _props3.sendMessage,
        heroCarouselUniqueId = _props3.heroCarouselUniqueId;
    var figure = this.element.figure;

    if (typeof sendMessage !== 'function' || !figure || !heroCarouselUniqueId) {
      return;
    }
    // console.log('HeroVideo.sendMessageFigureRect', heroCarouselUniqueId, figure);
    var rect = figure.getBoundingClientRect();
    sendMessage.call(this, heroCarouselUniqueId, rect);
  };

  HeroVideo.prototype.waitingExistFigureAndCanPlay = function waitingExistFigureAndCanPlay() {
    var _this3 = this;

    clearTimeout(this.timer.load);
    var sendMessage = this.props.sendMessage;

    if (typeof sendMessage !== 'function') {
      return;
    }
    // console.log('HeroVideo.waitingExistFigureAndCanPlay', heroCarouselUniqueId, heroCarouselSlideId);
    var _canPlay = this.canPlay,
        pc = _canPlay.pc,
        mb = _canPlay.mb;
    var figure = this.element.figure;

    if (!pc || !mb || !figure) {
      this.timer.load = setTimeout(function () {
        _this3.waitingExistFigureAndCanPlay();
      }, 16);
      return;
    }
    this.sendMessageFigureRect();
  };
  /**
   * {@link HeroVideo.element} `clientRect` を取得し通知します
   */


  HeroVideo.prototype.getAndSendRectFigureBlock = function getAndSendRectFigureBlock() {
    var _this4 = this;

    clearTimeout(this.timer.figure);
    var sendMessage = this.props.sendMessage;

    if (typeof sendMessage !== 'function') {
      return;
    }
    // console.log('HeroVideo.getAndSendRectFigureBlock', this.props.heroCarouselUniqueId);
    this.timer.figure = setTimeout(function () {
      _this4.sendMessageFigureRect();
    }, 1000);
    this.waitingExistFigureAndCanPlay();
  };

  // -----------------------------------------------------

  HeroVideo.prototype.onPcVideoCanPlay = function onPcVideoCanPlay() {
    var _this5 = this;

    // console.log('HeroCarousel.onPcVideoCanPlay', this.canPlay.pc);
    // 複数回呼び出されるので onetime 保証する
    if (this.canPlay.pc) {
      return;
    }
    this.canPlay.pc = true;
    // this.played.pc = true;
    // ---
    setTimeout(function () {
      _this5.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  };

  HeroVideo.prototype.onMbVideoCanPlay = function onMbVideoCanPlay() {
    var _this6 = this;

    // console.log('HeroCarousel.onMbVideoCanPlay', this.canPlay.mb);
    // 複数回呼び出されるので onetime 保証する
    if (this.canPlay.mb) {
      return;
    }
    this.canPlay.mb = true;
    // this.played.mb = true;
    // ---
    setTimeout(function () {
      _this6.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  };
  /**
   * pc: video.play event handler
   * - played flag true
   */


  HeroVideo.prototype.onPcVideoPlay = function onPcVideoPlay() {
    // console.log('HeroVideo.onPcVideoPlay', this.props.heroCarouselUniqueId);
    this.played.pc = true;
    this.playing.pc = true;
  };
  /**
   * mb: video.play event handler
   * - played flag true
   */


  HeroVideo.prototype.onMbVideoPlay = function onMbVideoPlay() {
    // console.log('HeroVideo.onMbVideoPlay', this.played);
    this.played.mb = true;
    this.playing.mb = true;
    // this.disposeTouches();
  };

  HeroVideo.prototype.onPcVideoPlaying = function onPcVideoPlaying() {
    this.playing.pc = true;
  };

  HeroVideo.prototype.onMbVideoPlaying = function onMbVideoPlaying() {
    // console.log('HeroVideo.onMbVideoPlaying', this.playing);
    this.playing.mb = true;
  };
  /**
   * PC: video ended event handler
   * - {@link HeroVideo.pc.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */


  HeroVideo.prototype.onPcVideoEnded = function onPcVideoEnded() {
    // video end
    var pcLoop = this.props.pcLoop;

    var video = this.videos.pc;
    // console.log('HeroVideo.onPcVideoEnded', pcLoop, video, this.ended, this.posters);
    // video element が存在し loop: false の時に rewind させる
    if (video && !pcLoop) {
      this.ended.pc = true;
      this.pauseVideo(true);
      // 背景に画像がある時のみ video 非表示
      if (this.posters.pc) {
        this.setState({ visiblePc: false });
      } else {
        this.rewindVideo(true);
      }
    }
  };

  /**
   * MB: video ended event handler
   * - {@link HeroVideo.mb.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */


  HeroVideo.prototype.onMbVideoEnded = function onMbVideoEnded() {
    // video end
    var mbLoop = this.props.mbLoop;

    var video = this.videos.mb;
    // console.log('HeroVideo.onMbVideoEnded', mbLoop, video, this.ended);
    // video element が存在し loop: false の時に rewind させる
    if (video && !mbLoop) {
      this.ended.mb = true;
      this.pauseVideo(false);
      // 背景に画像がある時のみ video 非表示
      if (this.posters.mb) {
        this.setState({ visibleMb: false });
      } else {
        this.rewindVideo(false);
      }
    }
  };

  /**
   * button.HeroVideo__btn__scroll click event handler
   * - link.href から hash を取り出します
   * - {@link scrollToNode} で smooth scroll させます
   * - `.hero` 見切れるまで移動します
   * @param {Event} event click event - `preventDefault` します
   */


  HeroVideo.prototype.onClickInnerLink = function onClickInnerLink(event) {
    event.preventDefault();
    // resize 時の移動位置がおかしくなる(scrollToNode bug?)ので毎回新規に取得する
    var heroElement = document.querySelector('.hero');
    if (heroElement) {
      this.heroElement = heroElement;
      var rect = heroElement.getBoundingClientRect();
      // console.log('HeroVideo.onClickInnerLink', rect);
      var option = {
        duration: 480,
        offset: rect.height
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* scrollToNode */])(heroElement, option);
      this.enableButtonScrollEffect();
    }
  };

  HeroVideo.prototype.enableButtonScrollEffect = function enableButtonScrollEffect() {
    var _this7 = this;

    // clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    var delay = this.state.btnScrollClicked ? 16 : 0;
    if (delay) {
      this.setState({ btnScrollClicked: '' });
    }
    this.timer.btnEmpty = setTimeout(function () {
      _this7.delayDisposeButtonScrollEffect();
    }, delay);
  };

  HeroVideo.prototype.delayDisposeButtonScrollEffect = function delayDisposeButtonScrollEffect() {
    var _this8 = this;

    clearTimeout(this.timer.btnScroll);
    this.setState({ btnScrollClicked: 'HeroVideo__btn__scroll__clicked' });
    this.timer.btnScroll = setTimeout(function () {
      _this8.setState({ btnScrollClicked: '' });
    }, 1750);
  };

  /**
   * imageLink enter event handler
   * - `.ImageLink__entered` class 追加
   */


  HeroVideo.prototype.onLinkEnter = function onLinkEnter() {
    this.setState({ entered: 'ImageLink__entered' });
  };

  /**
   * imageLink leave event handler
   * - `.ImageLink__entered` class 削除
   */


  HeroVideo.prototype.onLinkLeave = function onLinkLeave() {
    this.setState({ entered: '' });
  };

  /**
   * 関連動画 click delegate event handler
   * @param {Event} event click Event
   */


  HeroVideo.prototype.onClickRelated = function onClickRelated(event) {
    var target = event.target;
    var youtubeId = HeroVideo.parseNode(target);
    // console.log('HeroVideo.onClickRelated', youtubeId, target);
    if (youtubeId) {
      this.setState({ youtubeId: youtubeId });
    } else {
      this.executeClose();
    }
  };

  /**
   * YouTube modal 閉じる時に再生を止めます
   */


  HeroVideo.prototype.stopYouTube = function stopYouTube() {
    var player = this.youtubeIframe;
    // console.log('HeroVideo.onClickModalClose', player);
    if (!player) {
      return;
    }
    try {
      player.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    } catch (error) {
      console.warn('HeroVideo.stopYouTube', error);
      // postMessage - 実行できないときは iframe src を空にして無理やり止める
      this.youtubeIframeSrc = player.src;
      player.src = '';
    }
  };

  /**
   * window size から pc / mb どちらのモードかを調べます
   * @returns {{pc: boolean, mb: boolean}} 真偽値として返します
   */


  HeroVideo.prototype.size = function size() {
    var width = window.innerWidth;
    var breakPoint = this.breakPoint;
    return {
      pc: width >= breakPoint,
      mb: width < breakPoint
    };
  };

  /**
   * HTML5 video pause します
   * @param {boolean} pc video file select flag - true: PC
   * @param {?function} [func=null] pause 後に実行する関数
   */


  HeroVideo.prototype.pauseVideo = function pauseVideo(pc) {
    var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var played = pc ? this.played.pc : this.played.mb;
    if (!played) {
      return;
    }
    if (pc) {
      clearTimeout(this.timer.checkPlayingPc);
    } else {
      clearTimeout(this.timer.checkPlayingMb);
    }
    var videos = this.videos;
    var video = pc ? videos.pc : videos.mb;
    var _state = this.state,
        visiblePc = _state.visiblePc,
        visibleMb = _state.visibleMb;

    var visible = pc ? visiblePc : visibleMb;

    if (!video || !visible) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // console.log('HeroVideo.pauseVideo ---------', this.props.heroCarouselUniqueId, pc, visible, video.src);
    try {
      video.pause();
    } catch (e) {
      console.warn('[HeroVideo] - pauseVideo - error', e);
    }

    if (func) {
      func.call(this, !pc);
    }
    // if (pc) {
    //   this.played.pc = false;
    // } else {
    //   this.played.mb = false;
    // }
  };
  // checkPlayingPc(noHideVideo = false) {
  //   this.tryPlayCount.pc += 1;
  //   clearTimeout(this.timer.playingPc);
  //   if (this.tryPlayCount.pc <= 30) {
  //     if (!this.playing.pc) {
  //       this.timer.playingPc = setTimeout(() => {
  //         this.playVideo(true);
  //       }, 16);
  //     }
  //   } else if (!noHideVideo) {
  //     this.hideVideoTag(true);
  //   }
  // }
  // checkPlayingMb(noHideVideo = false) {
  //   this.tryPlayCount.mb += 1;
  //   // console.log('HeroVideo.checkPlayingMb', this.props.heroCarouselUniqueId, this.tryPlayCount.mb, this.playing.mb);
  //   clearTimeout(this.timer.playingMb);
  //   if (this.tryPlayCount.mb <= 30) {
  //     if (!this.playing.mb) {
  //       this.timer.playingMb = setTimeout(() => {
  //         this.playVideo(false);
  //       }, 32);
  //     }
  //   } else if (!noHideVideo) {
  //     // console.log('HeroVideo.checkPlayingMb - noHideVideo', this.props.heroCarouselUniqueId, this.tryPlayCount.mb, this.playing.mb);
  //     this.hideVideoTag(false);
  //   }
  // }


  HeroVideo.prototype.hideVideoTag = function hideVideoTag(pc) {
    if (pc) {
      if (this.state.visiblePc) {
        this.setState({ visiblePc: false });
      }
    } else if (this.state.visibleMb) {
      this.setState({ visibleMb: false });
    }
  };
  // -----------------------------------------------------


  HeroVideo.prototype.delayCheckPlayingAfterSuccess = function delayCheckPlayingAfterSuccess(pc) {
    var _this9 = this;

    if (pc) {
      clearTimeout(this.timer.checkPlayingPc);
      this.tryPlayCount.pc = 0;
      this.timer.checkPlayingPc = setTimeout(function () {
        _this9.checkPlayingPc(true);
      }, 500);
    } else {
      clearTimeout(this.timer.checkPlayingMb);
      this.tryPlayCount.mb = 0;
      this.timer.checkPlayingMb = setTimeout(function () {
        _this9.checkPlayingMb(true);
      }, 500);
    }
  };
  // -----------------------------------------------------
  /**
   * video.play success 処理
   * - played flag true
   * @param {boolean} pc video file select flag - true: PC
   */


  HeroVideo.prototype.playSuccess = function playSuccess(pc) {
    if (pc) {
      this.played.pc = true;
      // this.delayCheckPlayingAfterSuccess(true);
    } else {
      this.played.mb = true;
      // this.delayCheckPlayingAfterSuccess(false);
    }
  };

  HeroVideo.prototype.needHideVideo = function needHideVideo(pc, error) {
    if (!error) {
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    var massages = ['no supported source', 'interact width'];
    var result = massages.some(function (message) {
      return error.message.indexOf(message) !== -1;
    });
    if (result) {
      var state = pc ? { visiblePc: false } : { visibleMb: false };
      this.setState(state);
      return true;
    }
    return false;
  };

  /**
   * {@link HeroVideo.needHideVideo} - error message より　｀ヴィデオ｀非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */


  HeroVideo.prototype.playFaultAlternateImage = function playFaultAlternateImage(pc) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }

    this.pauseVideo(pc);
    this.rewindVideo(pc);
  };
  /**
   * video.play fault 処理
   * - {@link HeroVideo.playFaultAlternateImage} - error message により `video` 非表示判断します
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */


  HeroVideo.prototype.playFault = function playFault(pc) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    this.playFaultAlternateImage(pc, error);
  };

  /**
   * HTML5 video start します
   * @param {boolean} pc video file select flag - true: PC
   * @param {?function} [func=null] play resolve function - play 実行後に実行します
   */


  HeroVideo.prototype.playVideo = function playVideo(pc) {
    var _this10 = this;

    var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var videos = this.videos;
    var video = pc ? videos.pc : videos.mb;
    // const played = (pc) ? this.played.pc : this.played.mb;
    var ended = pc ? this.ended.pc : this.ended.mb;
    var _state2 = this.state,
        visiblePc = _state2.visiblePc,
        visibleMb = _state2.visibleMb;

    var visible = pc ? visiblePc : visibleMb;
    // console.log('HeroVideo.playVideo --------- ', this.props.heroCarouselUniqueId, pc, video.src, visible, ended);
    if (!video || !visible || ended) {
      if (func) {
        func.call(this, pc);
      }
      return;
    }
    // ---
    if (!video.paused) {
      if (func) {
        func.call(this, pc);
      }
      return;
    }
    // ---
    var playPromise = null;
    try {
      playPromise = video.play();
      this.playSuccess(pc);
    } catch (e) {
      console.warn('[HeroVideo] play video fault - pc: ' + pc + ', ' + error, video.src);
      this.playFault(pc, e);
    }
    if (playPromise) {
      playPromise.then(function () {
        // sequence function execute
        _this10.playSuccess(pc);
      }).catch(function (error) {
        console.warn('[HeroVideo] play video fault in Promise - pc: ' + pc + ', ' + error, video.src);
        _this10.playFault(pc, error);
      });
    }
    if (func) {
      func.call(this, pc);
    }
  };

  /**
   * rewind します
   * @param {boolean} pc video file select flag - true: PC
   */


  HeroVideo.prototype.rewindVideo = function rewindVideo(pc) {
    var videos = this.videos;
    var video = pc ? videos.pc : videos.mb;
    var _state3 = this.state,
        visiblePc = _state3.visiblePc,
        visibleMb = _state3.visibleMb;

    var visible = pc ? visiblePc : visibleMb;
    if (!video || !visible) {
      return;
    }
    // 再生中は rewind しない
    if (!video.paused) {
      return;
    }
    // console.log('HeroVideo.rewindVideo', pc, visible);
    try {
      video.currentTime = 0;
    } catch (error) {
      console.warn('[HeroVideo].rewindVideo', pc, video.src, error);
    }
    // if (pc) {
    //   this.video.pc = false;
    // } else {
    //   this.video.mb = false;
    // }
  };

  // waitPlayVideoUntilCanPlayPc() {
  //   clearTimeout(this.timer.waitPc);
  //   const { visiblePc } = this.state;
  //   if (!visiblePc) {
  //     return;
  //   }
  //   // console.log('HeroVideo.waitPlayVideoUntilCanPlayPc', visiblePc, this.canPlay.pc);
  //   if (!this.canPlay.pc) {
  //     this.timer.waitPc = setTimeout(() => {
  //       this.waitPlayVideoUntilCanPlayPc();
  //     }, 16);
  //     return;
  //   }
  //   // pc
  //   this.playVideo(true);
  // }

  // waitPlayVideoUntilCanPlayMb() {
  //   clearTimeout(this.timer.waitMb);
  //   const { visibleMb } = this.state;
  //   if (!visibleMb) {
  //     return;
  //   }
  //   // console.log('HeroVideo.waitPlayVideoUntilCanPlayMb', this.props.heroCarouselUniqueId, this.canPlay.mb);
  //   if (!this.canPlay.mb) {
  //     // can play になるまで待機します
  //     this.timer.waitMb = setTimeout(() => {
  //       this.waitPlayVideoUntilCanPlayMb();
  //     }, 16);
  //     return;
  //   }
  //   // ---
  //   // mb
  //   this.playVideo(false);
  // }

  // waitPlayVideosUntilCanPlay() {
  //   clearTimeout(this.timer.pauseRewind);
  //   this.waitPlayVideoUntilCanPlayPc();
  //   this.waitPlayVideoUntilCanPlayMb();
  // }

  /**
   * 動画再生を行う - {@link HeroVideo.playVideo}
   */


  HeroVideo.prototype.playVideos = function playVideos() {
    clearTimeout(this.timer.pauseRewind);
    this.playVideo(true);
    this.playVideo(false);
  };

  /**
   * 動画再生停止を行う - {@link HeroVideo.pauseVideo}
   */


  HeroVideo.prototype.pauseVideos = function pauseVideos() {
    clearTimeout(this.timer.pauseRewind);
    // console.log('HeroVideo.pauseVideos ----', this.props.heroCarouselUniqueId);
    // pc
    this.pauseVideo(true);
    // mb
    this.pauseVideo(false);
  };

  HeroVideo.prototype.rewindVideos = function rewindVideos() {
    clearTimeout(this.timer.pauseRewind);
    // console.log('HeroVideo.rewindVideos ====', this.props.heroCarouselUniqueId);
    // pc
    this.rewindVideo(true);
    // mb
    this.rewindVideo(false);
  };

  /**
   * video mute を実行します
   */


  HeroVideo.prototype.muteVideos = function muteVideos() {
    // react video.muted bug ?
    // @see https://github.com/facebook/react/blob/1c2876d5b558b8591feb335d8d7204bc46f7da8a/packages/react-dom/src/shared/DOMProperty.js#L312
    // video muted attribute を追加する
    // not work `setAttribute` - muted="muted", muted="true"
    Object.values(this.videos).map(function (video) {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  };

  HeroVideo.prototype.delayPauseAndRewind = function delayPauseAndRewind() {
    var _this11 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 160;

    clearTimeout(this.timer.pauseRewind);
    this.timer.pauseRewind = setTimeout(function () {
      _this11.pauseVideos();
      _this11.rewindVideos();
    }, delay);
  };

  // -----------------------------------------------
  /**
   * video tag 存在 flag
   * @returns {boolean} true: exist
   */


  HeroVideo.prototype.hasVideo = function hasVideo() {
    return Object.values(this.videos).some(function (video) {
      return video !== null;
    });
  };

  // -----------------------------------------------
  /**
   * YouTube iframe src path を作成します
   * @param {string} id YouTibe ID
   * @returns {string} `//www.youtube.com/embed/${id}?rel=0&version=3&enablejsapi=1`
   */


  HeroVideo.prototype.createPath = function createPath(id) {
    var path = id ? '//www.youtube.com/embed/' + id + '?rel=0&showinfo=0&version=3&enablejsapi=1' : '';
    this.youtubeIframeSrc = path;
    return path;
  };

  // -----------------------------------------------
  /**
   * same id check - HeroCarousel 内の時 video 再生行うかを判定します
   * @returns {boolean} true -> will video play
   */


  HeroVideo.prototype.shouldVideoPlay = function shouldVideoPlay() {
    var _props4 = this.props,
        heroCarouselSlideId = _props4.heroCarouselSlideId,
        heroCarouselUniqueId = _props4.heroCarouselUniqueId;

    return heroCarouselSlideId === heroCarouselUniqueId;
  };

  // -----------------------------------------------


  HeroVideo.prototype.checkVideoPlaying = function checkVideoPlaying() {
    var _this12 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

    clearTimeout(this.timer.firstVideoPlay);
    // console.log('HeroVideo.checkVideoPlaying - 1000', this.playing);
    this.timer.firstVideoPlay = setTimeout(function () {
      _this12.playVideos();
    }, delay);
  };
  // -----------------------------------------------
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  // -----------------------------------------------
  /**
   * delegate update
   * - modal close && props.heroCarouselSlideId === props.heroCarouselUniqueId の時に play video します
   * - else -> video pause and rewind します
   * @param {*} prevProps previous props
   */


  HeroVideo.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this13 = this;

    var isOpen = this.state.isOpen;
    // console.log('HeroVideo.componentDidUpdate derivedStateFromProps', heroCarouselUniqueId, heroCarouselSlideId, this.state.heroCarouselSlideId);
    // flag 変更されたときのみ message 送信する

    if (prevProps.requestMessageFlag !== this.props.requestMessageFlag) {
      setTimeout(function () {
        _this13.getAndSendRectFigureBlock();
      }, 0);
    }
    if (isOpen) {
      return;
    }
    if (this.shouldVideoPlay()) {
      // console.log('HeroVideo.componentDidUpdate shouldVideoPlay', this.shouldVideoPlay(), this.state.heroCarouselSlideId);
      setTimeout(function () {
        _this13.playVideos();
      }, 0);
    } else {
      var heroCarouselSlideId = prevProps.heroCarouselSlideId,
          heroCarouselUniqueId = prevProps.heroCarouselUniqueId;

      var delay = heroCarouselSlideId === heroCarouselUniqueId ? 160 : 0;
      this.delayPauseAndRewind(delay);
    }
  };

  /**
   * delegate after mount
   * - played
   */


  HeroVideo.prototype.componentDidMount = function componentDidMount() {
    var _this14 = this;

    setTimeout(function () {
      _this14.muteVideos();
    }, 0);
    // ---
    var inHeroCarousel = this.props.inHeroCarousel;

    if (inHeroCarousel && !this.shouldVideoPlay()) {
      // in HeroCarousel && myId と currentId を比較し異なる時に pause する
      setTimeout(function () {
        _this14.pauseVideos();
      }, 0);
    } else {
      // Android 6 - cant work autoplay + touch require
      // this.checkVideoPlaying(0);
      this.playVideos();
    }
    // hero carousel child 時に resize watch
    if (inHeroCarousel) {
      window.addEventListener('resize', this.onResize, false);
    }
    // // ---
    // // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  };

  HeroVideo.prototype.componentWillUnmount = function componentWillUnmount() {
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
    window.removeEventListener('resize', this.onResize);
    // this.disposeTouches();
  };

  // -----------------------------------------------
  /**
   * props `imageLink` と `link` 値をもとに - Hero全体でリンク設定するか否かのためのコンテナを作成します
   * - HeroVideoRoot - `a` or `div`
   * - attributes - HeroVideoRoot 属性
   * a 設定時に必要な属性を `attributes` に追加します
   * @returns {?Element} Hero全体でリンク設定するか否かのためのコンテナを返します
   */


  HeroVideo.prototype.renderImageLink = function renderImageLink() {
    var _props5 = this.props,
        imageLink = _props5.imageLink,
        link = _props5.link,
        youtubeId = _props5.youtubeId;
    // imageLink 設定なし

    if (imageLink === null || !imageLink) {
      return null;
    }
    // youtubeId - 存在する時は設定無い
    if (youtubeId !== null && youtubeId) {
      return null;
    }
    // link check
    // imageLink の設定有り, link property illegal なので出力しない
    if (link === null || !link.href) {
      return null;
    }
    // type を className へ
    var type = link.type || '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
      className: 'HeroVideo__imageLink ' + type,
      href: link.href,
      target: link.targetBlank ? '_blank' : '_self',
      onMouseEnter: this.onLinkEnter,
      onMouseLeave: this.onLinkLeave,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1452
      }
    });
  };

  // -----------------------------------------------
  /**
   * YouTube modal link 作成します - `a.HeroVideo__Youtube__link`
   * @returns {?Element} `a.HeroVideo__Youtube__link`
   */


  HeroVideo.prototype.renderYoutubeLink = function renderYoutubeLink() {
    var _props6 = this.props,
        youtubeId = _props6.youtubeId,
        link = _props6.link;

    if (youtubeId === null || !youtubeId) {
      return null;
    }
    // modal open
    // type を className へ
    var type = link.type || '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
      href: '#',
      className: 'HeroVideo__Youtube__link ' + type,
      onClick: this.onClickModalOpen,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1475
      }
    });
  };
  /**
   * button.HeroVideo__btn__scroll Element を作成します
   * - click -> onClickInnerLink -> {@link scrollToElementId}
   * @returns {?Element} button.HeroVideo__btn__scroll
   */


  HeroVideo.prototype.renderButtonScroll = function renderButtonScroll() {
    var scrollToSlug = this.props.scrollToSlug;
    // hash

    var id = this.targetId;
    // require check
    if (scrollToSlug === null) {
      return null;
    }
    var btnScrollClicked = this.state.btnScrollClicked;
    // output

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: 'HeroVideo__btn__scroll ' + btnScrollClicked,
        type: 'button',
        onClick: this.onClickInnerLink,
        'data-target': id,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1499
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1505
        }
      })
    );
  };
  /**
   * `div.HeroVideo__heading` section 作成します
   * - preHeading
   * - heading
   * - description
   * @returns {?Element} `div.HeroVideo__heading` を返します
   */


  HeroVideo.prototype.renderHeading = function renderHeading() {
    var _props7 = this.props,
        pcPreHeading = _props7.pcPreHeading,
        mbPreHeading = _props7.mbPreHeading,
        preHeadingTag = _props7.preHeadingTag,
        pcHeading = _props7.pcHeading,
        mbHeading = _props7.mbHeading,
        headingTag = _props7.headingTag,
        pcDescription = _props7.pcDescription,
        mbDescription = _props7.mbDescription;
    // ---

    var alternate = {
      heading: pcHeading,
      pre: pcPreHeading,
      description: pcDescription
    };
    // ---
    var tags = {
      pcPre: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeadingTag, {
        tag: preHeadingTag,
        label: pcHeading,
        defaultTagName: 'h3',
        suffix: 'pcPreHeading',
        dangerous: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1535
        }
      }),
      pcHead: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeadingTag, {
        tag: headingTag,
        label: mbHeading,
        defaultTagName: 'h2',
        suffix: 'mbHeading',
        dangerous: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1542
        }
      }),
      mbPre: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeadingTag, {
        tag: preHeadingTag,
        label: mbPreHeading,
        defaultTagName: 'h3',
        suffix: 'mbPreHeading',
        dangerous: true,
        alternate: alternate.pre,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1549
        }
      }),
      mbHead: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeadingTag, {
        tag: headingTag,
        label: mbHeading,
        defaultTagName: 'h2',
        suffix: 'mbHeading',
        dangerous: true,
        alternate: alternate.heading,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1557
        }
      }),
      pcDescription: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescriptionTag, {
        description: pcDescription,
        suffix: 'pcDescription',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1565
        }
      }),
      mbDescription: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescriptionTag, {
        description: mbDescription,
        suffix: 'mbDescription',
        alternate: alternate.description,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1569
        }
      })
      // pcPre: HeroVideo.headingTag(preHeadingTag, pcPreHeading, 'h3', 'pcPreHeading', true),
      // pcHead: HeroVideo.headingTag(headingTag, pcHeading, 'h2', 'pcHeading', true),
      // mbPre: HeroVideo.headingTag(preHeadingTag, mbPreHeading, 'h3', 'mbPreHeading', true, alternate.pre),
      // mbHead: HeroVideo.headingTag(headingTag, mbHeading, 'h2', 'mbHeading', true, alternate.heading),
      // pcDescription: HeroVideo.descriptionTag(pcDescription, 'pcDescription'),
      // mbDescription: HeroVideo.descriptionTag(mbDescription, 'mbDescription', alternate.description),
    };
    // null 以外を check
    var hasTag = Object.values(tags).some(function (tag) {
      return tag !== null;
    });
    if (!hasTag) {
      // 全て null なので処理しない
      return null;
    }
    // tag exist
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroVideo__heading', __source: {
          fileName: _jsxFileName,
          lineNumber: 1589
        }
      },
      tags.pcPre,
      tags.mbPre,
      tags.pcHead,
      tags.mbHead,
      tags.pcDescription,
      tags.mbDescription
    );
  };

  /**
   * `div.HeroVideo__container` section 作成します
   * - pcPosition / mbPosition から css class 作成し設定します
   * - pcTextAlign / mbTextAlign から css class 作成し設定します
   * - {@link HeroVideo.renderHeading}
   * - {@link HeroVideo.renderButtonScroll}
   * - mb - CTA
   * @returns {?Element} `div.HeroVideo__container` を返します
   */


  HeroVideo.prototype.renderContainer = function renderContainer() {
    var _props8 = this.props,
        pcPosition = _props8.pcPosition,
        mbPosition = _props8.mbPosition,
        pcTextAlign = _props8.pcTextAlign,
        mbTextAlign = _props8.mbTextAlign,
        link = _props8.link,
        youtubeId = _props8.youtubeId;
    // ---

    var heading = this.renderHeading();
    // buttons
    // // scroll
    // const buttonScroll = this.buttonScroll();
    // 仕様変更 - VideoIDが設定されていた場合、CTAボタンは非表示としてください。
    var cta = !youtubeId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CtaTag, { link: link, __source: {
        fileName: _jsxFileName,
        lineNumber: 1625
      }
    }) : null;
    // const cta = !youtubeId ? HeroVideo.ctaTag(link): null;
    // output
    if (!heading && !cta) {
      return null;
    }
    // positions
    var positions = {
      pc: pcPosition !== null && pcPosition ? pcPosition.toLowerCase() : '',
      mb: mbPosition !== null && mbPosition ? mbPosition.toLowerCase() + '-mb' : ''
    };
    var ctaClassName = cta ? 'has-btn__link' : '';
    // align
    var alignPc = pcTextAlign !== null && pcTextAlign ? 'align-' + pcTextAlign.toLowerCase() + '-pc' : '';
    var alignMb = mbTextAlign !== null && mbTextAlign ? 'align-' + mbTextAlign.toLowerCase() + '-mb' : '';
    // tag exist
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroVideo__container ' + positions.pc + ' ' + positions.mb + ' ' + ctaClassName + ' ' + alignPc + ' ' + alignMb,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1642
        }
      },
      heading,
      cta
    );
  };

  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?boolean} loop loop flag
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=HeroVideo__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.HeroVideo__video` tag を返します
   */


  HeroVideo.prototype.renderVideoTag = function renderVideoTag(src, loop) {
    var poster = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _this15 = this;

    var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var baseClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'HeroVideo__video';

    // 制御に必要な property が無い時は null を返す
    if (src === null || !src || !suffix) {
      return null;
    }
    // state - visible
    var _state4 = this.state,
        visiblePc = _state4.visiblePc,
        visibleMb = _state4.visibleMb;

    var isPc = suffix === 'pc';
    var visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // class name
    var className = '' + baseClass + (suffix ? '-' : '') + suffix;
    // video tag
    var attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: true にしないと onCanPlay 発火しない
      // autoPlay: true,
      // @since 2018-07-06
      // in HeroCarousel auto play させない <- 仕様変更に伴い false 変更する
      // autoPlay: false,
      playsInline: true,
      // not work - react bug?
      muted: true,
      // custom
      loop: !!loop,
      src: src,
      className: className,
      type: 'video/' + src.split('.').pop().split('?').shift()
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    // 基本 auto play - HeroCarousel - didMount で pause させる
    if (isPc) {
      // ---
      // autoPlay
      attributes.autoPlay = visiblePc;
      // ---
      attributes.ref = function (component) {
        return _this15.videos.pc = component;
      };
      attributes.onEnded = this.onPcVideoEnded;
      attributes.onPlay = this.onPcVideoPlay;
      attributes.onCanPlay = this.onPcVideoCanPlay;
      attributes.onPlaying = this.onPcVideoPlaying;
      attributes.style = visiblePc ? null : { display: 'none' };
    } else {
      // ---
      // autoPlay
      attributes.autoPlay = visibleMb;
      // ---
      attributes.ref = function (component) {
        return _this15.videos.mb = component;
      };
      attributes.onEnded = this.onMbVideoEnded;
      attributes.onPlay = this.onMbVideoPlay;
      attributes.onCanPlay = this.onMbVideoCanPlay;
      attributes.onPlaying = this.onMbVideoPlaying;
      attributes.style = visibleMb ? null : { display: 'none' };
    }
    // tag
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({}, attributes, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1729
      }
    }));
  };

  /**
   * {@link PhotoInfo} props 拡張し render する
   * @returns {?Array<?ReactElement>} `PhotoInfo` list
   */


  HeroVideo.prototype.renderPhotoInfoContainer = function renderPhotoInfoContainer() {
    var _props9 = this.props,
        photoInfo = _props9.photoInfo,
        containerId = _props9.containerId,
        photoInfoWillOpen = _props9.photoInfoWillOpen,
        photoInfoWillClose = _props9.photoInfoWillClose,
        inHeroCarousel = _props9.inHeroCarousel,
        heroCarouselSlideId = _props9.heroCarouselSlideId;
    // console.log('HeroVideo.photoInfoContainer', heroCarouselSlideId, this.state.heroCarouselSlideId);
    // photoInfo - arrayOf だけど出力は1件

    var photoInfoList = photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length ? photoInfo : [];
    // PhotoInfo.props extends
    return photoInfoList.map(function (child, index) {
      // console.log('HeroImage.photoInfoContainer.map', child, child.type.displayName);
      return child.type.displayName === 'PhotoInfo' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__photo_info__["a" /* default */], _extends({
        key: 'PhotoInfo-' + child.props.containerId + '-' + index
      }, child.props, {
        parentComponentName: 'HeroVideo',
        parentComponentId: containerId,
        photoInfoWillOpen: photoInfoWillOpen,
        photoInfoWillClose: photoInfoWillClose,
        inHeroCarousel: inHeroCarousel,
        heroCarouselSlideId: heroCarouselSlideId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1752
        }
      })) : null;
    });
  };

  /**
   * `div.HeroVideo__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.HeroVideo__figure__block`
   */


  HeroVideo.prototype.renderFigureVideo = function renderFigureVideo() {
    var _this16 = this;

    var _props10 = this.props,
        pcVideoSrc = _props10.pcVideoSrc,
        mbVideoSrc = _props10.mbVideoSrc,
        pcVideoFilter = _props10.pcVideoFilter,
        mbVideoFilter = _props10.mbVideoFilter,
        pcLoop = _props10.pcLoop,
        mbLoop = _props10.mbLoop,
        pcSrc = _props10.pcSrc,
        mbSrc = _props10.mbSrc;
    // ---

    if (pcVideoSrc === null || !pcVideoSrc) {
      return null;
    }
    // ---
    var mobileVideo = mbVideoSrc || pcVideoSrc;
    var mobilePoster = mbSrc || pcSrc;
    // ---
    var pcVideo = this.renderVideoTag(pcVideoSrc, pcLoop, pcSrc, 'pc');
    var mbVideo = this.renderVideoTag(mobileVideo, mbLoop, mobilePoster, 'mb');
    // ---
    var _state5 = this.state,
        visiblePc = _state5.visiblePc,
        visibleMb = _state5.visibleMb;

    var pcPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LikeVideoPosterBackground, {
      src: pcSrc,
      suffix: 'pc',
      videoVisible: visiblePc,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1794
      }
    });
    var mbPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LikeVideoPosterBackground, {
      src: mobilePoster,
      suffix: 'mb',
      videoVisible: visibleMb,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1799
      }
    });
    // ---
    if (!pcVideo && !mbVideo && !pcPoster && !mbPoster) {
      return null;
    }
    // ---
    this.posters.pc = !!pcSrc;
    this.posters.mb = !!mobilePoster;
    // console.log('HEroVideo.renderFigureVideo', this.posters, pcSrc, mobilePoster, pcPoster, mbPoster);
    // ---
    // filter
    var pcFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, { filterFlag: pcVideoFilter, suffix: 'pc', __source: {
        fileName: _jsxFileName,
        lineNumber: 1814
      }
    });
    var mbFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, { filterFlag: mbVideoFilter, suffix: 'mb', __source: {
        fileName: _jsxFileName,
        lineNumber: 1815
      }
    });
    // ---
    // youtube modal trigger
    var youtubeLink = this.renderYoutubeLink();
    // ---
    // large link
    var imageLink = !youtubeLink ? this.renderImageLink() : null;
    // ---
    // scroll
    var buttonScroll = this.renderButtonScroll();
    // ---
    // photoInfo
    // photoInfo - arrayOf だけど出力は1件
    var photoInfoList = this.renderPhotoInfoContainer();
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroVideo__figure__block',
        ref: function ref(component) {
          return _this16.element.figure = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1831
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'HeroVideo__video__block', 'data-hero-movie': this.props.youtubeId ? this.props.youtubeId : '', __source: {
            fileName: _jsxFileName,
            lineNumber: 1835
          }
        },
        pcVideo,
        mbVideo,
        pcPoster,
        mbPoster
      ),
      pcFilter,
      mbFilter,
      youtubeLink,
      imageLink,
      photoInfoList,
      buttonScroll
    );
  };

  /**
   * `div.HeroVideo__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.HeroVideo__figure__block`
   */


  HeroVideo.prototype.renderFigureImage = function renderFigureImage() {
    var _this17 = this;

    var _props11 = this.props,
        pcVideoFilter = _props11.pcVideoFilter,
        mbVideoFilter = _props11.mbVideoFilter,
        pcSrc = _props11.pcSrc,
        mbSrc = _props11.mbSrc;
    // ---

    if (pcSrc === null || !pcSrc) {
      return null;
    }
    // ---
    var mobilePoster = mbSrc || pcSrc;
    // ---
    var pcPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LikeVideoPosterBackground, {
      src: pcSrc,
      suffix: 'pc',
      videoVisible: false,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1871
      }
    });
    var mbPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LikeVideoPosterBackground, {
      src: mobilePoster,
      suffix: 'mb',
      videoVisible: false,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1876
      }
    });
    // ---
    if (!pcPoster && !mbPoster) {
      return null;
    }
    // ---
    // filter
    var pcFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, { filterFlag: pcVideoFilter, suffix: 'pc', __source: {
        fileName: _jsxFileName,
        lineNumber: 1887
      }
    });
    var mbFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, { filterFlag: mbVideoFilter, suffix: 'mb', __source: {
        fileName: _jsxFileName,
        lineNumber: 1888
      }
    });
    // ---
    // youtube modal trigger
    var youtubeLink = this.renderYoutubeLink();
    // ---
    // large link
    var imageLink = !youtubeLink ? this.renderImageLink() : null;
    // ---
    // scroll
    var buttonScroll = this.renderButtonScroll();
    // ---
    // photoInfo
    // photoInfo - arrayOf だけど出力は1件
    var photoInfoList = this.renderPhotoInfoContainer();
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroVideo__figure__block',
        ref: function ref(component) {
          return _this17.element.figure = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1904
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'HeroVideo__video__block', 'data-hero-movie': this.props.youtubeId ? this.props.youtubeId : '', __source: {
            fileName: _jsxFileName,
            lineNumber: 1908
          }
        },
        pcPoster,
        mbPoster
      ),
      pcFilter,
      mbFilter,
      youtubeLink,
      imageLink,
      photoInfoList,
      buttonScroll
    );
  };

  /**
   * YouTube modal 関連動画 - `div.HeroVideo__modal__relatedVideos`
   * @returns {?Element} `div.HeroVideo__modal__relatedVideos`
   */


  HeroVideo.prototype.renderRelatedVideo = function renderRelatedVideo() {
    var relatedVideo = this.props.relatedVideo;

    if (relatedVideo === null || !Array.isArray(relatedVideo) || !relatedVideo.length) {
      return null;
    }
    // truncate 5
    if (relatedVideo.length > 5) {
      relatedVideo.length = 5;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'RelatedVideo__container',
        role: 'presentation',
        onClick: this.onClickRelated,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1936
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'RelatedVideo__main_title', __source: {
            fileName: _jsxFileName,
            lineNumber: 1941
          }
        },
        '\u95A2\u9023\u52D5\u753B'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'RelatedVideo__wrap', __source: {
            fileName: _jsxFileName,
            lineNumber: 1942
          }
        },

        // 保険 - component 保証する
        relatedVideo.map(function (component, index) {
          var id = 'HeroVideo-relatedVideo-' + index;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__related_video__["a" /* default */], _extends({ key: id }, component.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1947
            }
          }));
        })
      )
    );
  };

  /**
   * YouTube 再生するための modal container - `div.HeroVideo__modal`
   * - YouTube iframe API 使用する
   * - `postMessage` を使用し control します `//www.youtube.com/embed/` - `embed` 必須 not `v`
   * - `enablejsapi=1` 必須
   * - {@link HeroVideo.youtubeIframe} へ iframe 参照を保存します
   * @returns {?Element} `div.HeroVideo__modal`
   * @see https://developers.google.com/youtube/iframe_api_reference?hl=ja
   */


  HeroVideo.prototype.renderModal = function renderModal() {
    var _this18 = this;

    var youtubeId = this.state.youtubeId;
    // if (youtubeId === null || !youtubeId) {
    //   return null;
    // }
    // ---
    // unique id - control する時に識別子として必要になるかもなので念のために設定する

    var id = this.youtubeIframeId;
    // ---
    // const src = this.youtubeIframeSrc || `//www.youtube.com/embed/${youtubeId}?rel=0&version=3&enablejsapi=1`;
    // ---
    var src = this.createPath(youtubeId);
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroVideo__modal ' + this.state.isOpen, __source: {
          fileName: _jsxFileName,
          lineNumber: 1978
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'HeroVideo__modal__overlay',
        role: 'presentation',
        onClick: this.onClickModalClose,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1979
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'HeroVideo__modal__content',
          onClick: this.onClickModalCloseByContent,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1984
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'HeroVideo__modal__content__inner',
            onClick: this.onClickModalCloseByContent,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1988
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'HeroVideo__modal__movie__block', __source: {
                fileName: _jsxFileName,
                lineNumber: 1992
              }
            },
            function () {
              if (_this18.state.isOpen) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_youtube_player__["a" /* default */], {
                  cls: 'HeroVideo__modal__movie',
                  height: '100%',
                  width: '100%',
                  autoplay: 1,
                  controls: 1,
                  youtubeId: youtubeId,
                  isModal: true,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1996
                  }
                });
              }
            }()
          ),
          this.renderRelatedVideo()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
        className: 'HeroVideo__modal__btn__close',
        onClick: this.onClickModalClose,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 2030
        }
      })
    );
  };

  /**
   * `div.HeroVideo` 作成します
   * @returns {?Element} `div.HeroVideo`
   */


  HeroVideo.prototype.render = function render() {
    var _props12 = this.props,
        containerId = _props12.containerId,
        containerClass = _props12.containerClass,
        pcSize = _props12.pcSize,
        mbSize = _props12.mbSize,
        scrollToSlug = _props12.scrollToSlug;
    // ---
    // figure
    // figureImage - YouTube only - figureVideo(background video) 優先 - 共存しない

    var figureVideo = this.renderFigureVideo();
    // const figureImage = (!figureVideo) ? this.figure(): null;
    var figureImage = !figureVideo ? this.renderFigureImage() : null;
    // ---
    // container
    var container = this.renderContainer();
    // ---
    // 出力対象存在チェック
    if (!figureVideo && !figureImage && !container) {
      return null;
    }
    // ---
    var entered = this.state.entered;
    // ---
    // modal - trigger

    var youtubeModal = this.renderModal();
    // ---
    // size setting
    var sizePc = pcSize !== null && pcSize ? pcSize.toLowerCase() + 'Size-pc' : '';
    var sizeMb = mbSize !== null && mbSize ? mbSize.toLowerCase() + 'Size-mb' : '';
    // ---
    // visible class
    var visible = !!scrollToSlug ? 'is-show-scroll_btn' : 'is-hide-scroll_btn';
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 2078
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'HeroVideo__article', __source: {
            fileName: _jsxFileName,
            lineNumber: 2082
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'HeroVideo ' + sizePc + ' ' + sizeMb + ' ' + visible + ' ' + entered, __source: {
              fileName: _jsxFileName,
              lineNumber: 2083
            }
          },
          figureVideo,
          figureImage,
          container,
          youtubeModal
        )
      )
    );
  };

  return HeroVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcPreHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbPreHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preHeadingTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  headingTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTextAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTextAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcVideoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbVideoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcVideoFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  mbVideoFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pcLoop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  mbLoop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  imageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollToSlug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  relatedVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  // props extends
  photoInfoWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  photoInfoWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  modalWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  modalWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inHeroCarousel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heroCarouselSlideId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heroCarouselUniqueId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // ---
  sendMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  requestMessageFlag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcPreHeading: null,
  mbPreHeading: null,
  preHeadingTag: null,
  pcHeading: null,
  mbHeading: null,
  headingTag: null,
  pcDescription: null,
  mbDescription: null,
  pcPosition: null,
  mbPosition: null,
  pcTextAlign: null,
  mbTextAlign: null,
  youtubeId: null,
  pcVideoSrc: null,
  mbVideoSrc: null,
  pcVideoFilter: null,
  mbVideoFilter: null,
  pcLoop: null,
  mbLoop: null,
  pcSrc: null,
  mbSrc: null,
  pcSize: null,
  mbSize: null,
  link: null,
  imageLink: null,
  scrollToSlug: null,
  photoInfo: null,
  relatedVideo: null,
  // props extends
  photoInfoWillOpen: null,
  photoInfoWillClose: null,
  modalWillOpen: null,
  modalWillClose: null,
  inHeroCarousel: false,
  heroCarouselSlideId: '',
  heroCarouselUniqueId: '',
  // ---
  sendMessage: null,
  requestMessageFlag: false
}, _temp);
HeroVideo.displayName = 'HeroVideo';


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__related_video__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_youtube_player__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\video\\index.jsx',
    _class,
    _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// -----------------------------------------------
/**
 * `div.Video__wysiwyg-[pc|mb]` tag 生成します
 * @param {?string} description 説明文(HTML)
 * @param {?string} [suffix=''] [pc|mb] 識別子
 * @param {string} [baseClass=Video__wysiwyg] base class name
 * @returns {?ReactElement} `div.Video__wysiwyg-[pc|mb]` tag
 * @constructor
 */
var WysiwygTag = function WysiwygTag(_ref) {
  var description = _ref.description,
      suffix = _ref.suffix,
      baseClass = _ref.baseClass;

  if (!description) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: '' + baseClass + (suffix ? '-' : '') + suffix + ' Wysiwyg',
    dangerouslySetInnerHTML: { __html: description },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    }
  });
};

WysiwygTag.displayName = 'WysiwygTag';
WysiwygTag.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

WysiwygTag.defaultProps = {
  description: null,
  suffix: '',
  baseClass: 'Video__wysiwyg'
};
// -----------------------------------------------
/**
 * video tag 下に敷く `img` - poster 画像
 * @param {?string} path 画像までのパス
 * @param {?string} [suffix=''] [pc|mb] 識別子
 * @param {boolean} [useYouTube=false] YouTube thumbnail use flag
 * @param {string} [baseClass=Video__video__poster] base class name
 * @returns {?ReactElement} `div.Video__video__poster-[pc|mb]` tag
 * @constructor
 */
var FigurePosterBgTag = function FigurePosterBgTag(_ref2) {
  var path = _ref2.path,
      suffix = _ref2.suffix,
      useYouTube = _ref2.useYouTube,
      baseClass = _ref2.baseClass,
      visibleVideo = _ref2.visibleVideo;

  if (!path) {
    return null;
  }
  // YouTube thumbnail は特別なクラス付与
  var ytClass = useYouTube ? baseClass + '__youtube' : '';
  var style = {
    display: visibleVideo && !useYouTube ? 'none' : 'block',
    backgroundImage: 'url(' + path + ')'
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: baseClass + ' ' + baseClass + (suffix ? '-' : '') + suffix + ' ' + ytClass,
    style: style,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62
    }
  });
};

FigurePosterBgTag.displayName = 'FigurePosterBgTag';
FigurePosterBgTag.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  useYouTube: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  visibleVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

FigurePosterBgTag.defaultProps = {
  path: null,
  suffix: '',
  baseClass: ' Video__video__poster',
  useYouTube: false
};
// -----------------------------------------------
/**
 * `span.HeroVideo__videoFilter` filter tag を作成します
 * @param {boolean} youtube YouTube flag - true: no filter
 * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
 * @returns {?ReactElement} `span.HeroVideo__videoFilter`
 * @constructor
 */
var FilterTag = function FilterTag(_ref3) {
  var youtube = _ref3.youtube,
      filterFlag = _ref3.filterFlag,
      suffix = _ref3.suffix,
      baseClass = _ref3.baseClass;
  return !youtube && filterFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: '' + baseClass + (suffix ? '-' : '') + suffix, __source: {
      fileName: _jsxFileName,
      lineNumber: 96
    }
  }) : null;
};

FilterTag.propTypes = {
  youtube: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  filterFlag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

FilterTag.defaultProps = {
  filterFlag: false,
  suffix: '',
  baseClass: 'Video__videoFilter'
};

// -----------------------------------------------
/**
 * Video component
 * - {@link RelatedVideo} modal に内蔵する
 */
var Video = (_temp = _class = function (_Component) {
  _inherits(Video, _Component);

  /**
   * `div.RelatedVideo` が見つかるまで再帰的に parent 探索します
   * - `data-yt` から YouTube ID を取得します
   * @param {Node|HTMLElement|Element} target event target 探索起点 Node
   * @returns {?string} `data-yt` value - YouTube ID
   */
  Video.parseNode = function parseNode(target) {
    if (!target) {
      return null;
    }
    if (!target.classList || !target.classList.contains('RelatedVideo')) {
      return Video.parseNode(target.parentNode);
    }
    return target.dataset.yt;
  };

  // /**
  //  * `div.Video__wysiwyg-[pc|mb]` tag 生成します
  //  * @param {?string} description 説明文(HTML)
  //  * @param {?string} [suffix=''] [pc|mb] 識別子
  //  * @param {string} [baseClass=Video__wysiwyg] base class name
  //  * @returns {?ReactElement} `div.Video__wysiwyg-[pc|mb]` tag
  //  */
  // static wysiwygTag(description, suffix = '', baseClass = 'Video__wysiwyg') {
  //   if (!description) {
  //     return null;
  //   }
  //   return (
  //     <div
  //       className={`${baseClass}${suffix ? '-': ''}${suffix}` +  ' Wysiwyg'}
  //       dangerouslySetInnerHTML={{__html: description}}
  //     />
  //   );
  // }

  // /**
  //  * video tag 下に敷く `img` - poster 画像
  //  * @param {?string} path 画像までのパス
  //  * @param {?string} [suffix=''] [pc|mb] 識別子
  //  * @param {boolean} [useYouTube=false] YouTube thumbnail use flag
  //  * @param {string} [baseClass=Video__video__poster] base class name
  //  * @returns {?ReactElement} `div.Video__video__poster-[pc|mb]` tag
  //  */
  // static figurePosterBgTag(path, suffix = '', useYouTube = false, baseClass = ' v') {
  //   if (!path) {
  //     return null;
  //   }
  //   // YouTube thumbnail は特別なクラス付与
  //   const ytClass = useYouTube ? `${baseClass}__youtube`: '';
  //   return (
  //     <div
  //       className={`${baseClass} ${baseClass}${suffix ? '-': ''}${suffix} ${ytClass}`}
  //       style={{backgroundImage: `url(${path})`}}
  //     />
  //   );
  // }

  // /**
  //  * `span.HeroVideo__videoFilter` filter tag を作成します
  //  * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
  //  * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
  //  * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
  //  * @returns {?ReactElement} `span.HeroVideo__videoFilter`
  //  */
  // static filterTag(filterFlag, suffix = '', baseClass = 'Video__videoFilter') {
  //   if (filterFlag === null || !filterFlag) {
  //     return null;
  //   }
  //   return <span className={`${baseClass}${(suffix) ? '-': ''}${suffix}`}/>;
  // }

  function Video(props) {
    _classCallCheck(this, Video);

    // if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
    //   console.log('hasBackground(Video) : ' + true);
    // } else {
    //   console.log('hasBackground(Video) : ' + false);
    // }
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    if (_this.props.getRef) _this.props.getRef(_this);
    /**
     * bound onClickModalOpen - modal open event handler
     * @type {bound|any}
     */
    _this.onClickModalOpen = _this.onClickModalOpen.bind(_this);
    /**
     * bound onClickModalClose - modal close event handler
     * @type {bound|any}
     */
    _this.onClickModalClose = _this.onClickModalClose.bind(_this);
    /**
     * bound onClickModalCloseByContent - `div.Video__modal__content` click handler
     * @type {bound|any}
     */
    _this.onClickModalCloseByContent = _this.onClickModalCloseByContent.bind(_this);
    /**
     * bound onPcVideoEnded - PC video ended event handler
     * @type {bound|any}
     */
    _this.onPcVideoEnded = _this.onPcVideoEnded.bind(_this);
    /**
     * bound onMbVideoEnded - MB video ended event handler
     * @type {bound|any}
     */
    _this.onMbVideoEnded = _this.onMbVideoEnded.bind(_this);
    /**
     * YouTube iframe 参照 - mount 後設定されます
     * @type {?Element}
     */
    _this.youtubeIframe = null;
    /**
     * YouTube iframe src - `postMessage` 失敗する Browser のみ失敗時に設定されます
     * @type {string}
     */
    _this.youtubeIframeSrc = '';
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    _this.videos = {
      pc: null,
      mb: null
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.ended = {
      pc: false,
      mb: false
    };
    /**
     * bound onPcVideoPlay - pc.video.play event handler
     * @type {bound|any}
     */
    _this.onPcVideoPlay = _this.onPcVideoPlay.bind(_this);
    /**
     * bound onMbVideoPlay - mb.video.play event handler
     * @type {bound|any}
     */
    _this.onMbVideoPlay = _this.onMbVideoPlay.bind(_this);
    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.playing = {
      pc: false,
      mb: false
    };
    /**
     * poster 画像存在 flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.posters = {
      pc: false,
      mb: false
    };
    var hasVideo = !!props.videoSrc;
    _this.state = {
      // modal open / close
      isOpen: '',
      // YouTube ID
      youtubeId: '',
      visiblePc: hasVideo,
      visibleMb: hasVideo,
      playOut: '',
      showControls: !props.autoPlay,
      containerHeight: null
    };
    /**
     * bind onClickRelated - {@link RelatedVideo} click を親 Node で delegate します
     * @type {bound|any}
     */
    _this.onClickRelated = _this.onClickRelated.bind(_this);
    /**
     * autoPlay flag true の時に scroll / resize event 監視します
     * @type {bound|any}
     */
    _this.onScroll = _this.onScroll.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    /**
     * scroll 監視 flag
     * - autoPlay ON
     * - video src enabled
     * @type {boolean}
     */
    _this.watchScroll = props.autoPlay && props.videoSrc;
    /**
     * `div.Video__video__block` Element - mount 後に有効になります
     * @type {?Element}
     */
    _this.videoContainer = null;
    _this.played = false;
    _this.bodyClasses = ['modal-open'];
    // this.onClickPlayVideo = this.onClickPlayVideo.bind(this);
    /**
     * modal open 時に動画再生しているか flag - modal 閉じたら再生再開
     * @type {boolean}
     */
    _this.shouldPlaying = false;
    /**
     * move flag
     * @type {boolean}
     */
    _this.moveFirstFrame = false;
    _this.timer = {
      firstFrame: 0,
      hitTest: 0,
      hitTestCheck: 0,
      needHidePc: 0,
      needHideMb: 0
    };
    /**
     * {@link Video} component reference - `clientHeight` 取得します
     * @type {?*}
     */
    _this.refsContent = null;
    // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];

    // EPIServerのプレビュー時のモーダルの位置調整
    _this.wrapperScrollTop = 0;

    return _this;
  }

  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   const video = this.videos.mb;
  //   const playing = this.playing.mb;
  //   if (video && !playing && this.hitTest()) {
  //     // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //     this.playVideo(false);
  //   }
  // }

  Video.prototype.getContentsHeight = function getContentsHeight() {
    // return this.refs.contents.clientHeight;
    return this.refsContent.clientHeight;
  };

  Video.prototype.setContainerHeight = function setContainerHeight(height) {
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height
      });
    }
    // this.setState({
    //   containerHeight: height,
    // })
  };

  Video.prototype.clearContainerHeight = function clearContainerHeight() {
    if (this.state.containerHeight !== null) {
      this.setState({
        containerHeight: null
      });
    }
    // this.setState({
    //   containerHeight: null,
    // })
  };

  // /**
  //  * click で not auto play video 再生します
  //  * @param {Event} event clck event
  //  */
  // onClickPlayVideo(event) {
  //   event.preventDefault();
  //   this.playVideo();
  //   this.setState({playOut: 'Video__btn__play__video__out'});
  // }

  /**
   * `a.Video__Youtube__link` click event handler
   * - modal open します - state.isOpen: 'is-open'
   * @param {Event} event click Event
   */


  Video.prototype.onClickModalOpen = function onClickModalOpen(event) {
    event.preventDefault();
    this.executeOpen();
  };

  /**
   * `button.Video__modal__btn__close` click event handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */


  Video.prototype.onClickModalClose = function onClickModalClose(event) {
    event.preventDefault();
    this.executeClose();
  };

  /**
   * `div.Video__modal__content` click handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */


  Video.prototype.onClickModalCloseByContent = function onClickModalCloseByContent(event) {
    var target = event.target;
    var nodeName = target.nodeName.toLowerCase();
    // const className = target.className;
    if (nodeName === 'div' && target.classList.contains('Video__modal__content')) {
      this.executeClose();
    }
  };

  /**
   * PC: video ended event handler
   * - {@link Video.pc.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */


  Video.prototype.onPcVideoEnded = function onPcVideoEnded() {
    // video end
    var pcLoop = this.props.pcLoop;

    var video = this.videos.pc;
    // video element が存在し loop: false の時に rewind させる
    if (video && !pcLoop) {
      this.dispose();
      // ---
      this.ended.pc = true;
      this.played = false;
      this.pauseVideo(true);
      this.rewindVideo(true);
      // this.rewindVideos();
      this.shouldPlaying = false;
      // 背景に画像がある時のみ video 非表示
      if (this.posters.pc) {
        this.setState({ visiblePc: false });
      }
    }
  };

  /**
   * MB: video ended event handler
   * - {@link Video.mb.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */


  Video.prototype.onMbVideoEnded = function onMbVideoEnded() {
    // video end
    var mbLoop = this.props.mbLoop;

    var video = this.videos.mb;
    // video element が存在し loop: false の時に rewind させる
    if (video && !mbLoop) {
      this.dispose();
      // ---
      this.ended.mb = true;
      this.played = false;
      this.pauseVideo(false);
      this.rewindVideo(false);
      this.shouldPlaying = false;
      // 背景に画像がある時のみ video 非表示
      if (this.posters.mb) {
        this.setState({ visibleMb: false });
      }
    }
  };

  /**
   * pc: video.play event handler
   * - timer clear
   * - playing flag true
   */


  Video.prototype.onPcVideoPlay = function onPcVideoPlay() {
    // console.log('Video.onPcVideoPlay', Date.now());
    this.playing.pc = true;
  };

  /**
   * mb: video.play event handler
   * - timer clear
   * - playing flag true
   */


  Video.prototype.onMbVideoPlay = function onMbVideoPlay() {
    // console.log('Video.onMbVideoPlay');
    this.playing.mb = true;
    // this.disposeTouches();
  };

  /**
   * 関連動画コンテナ click event handelr
   * - parent parse し youtubeId が見つかれば - this.state.youtubeId 更新する
   * - 見つからない時は modal 閉じる
   * @param {Event} event click Event
   */


  Video.prototype.onClickRelated = function onClickRelated(event) {
    var target = event.target;
    var youtubeId = Video.parseNode(target);
    if (youtubeId) {
      this.setState({ youtubeId: youtubeId });
    } else {
      // close modal
      this.executeClose();
    }
  };

  // -----------------------------------------------------
  // [SCROLL / RESIZE]
  /**
   * window.onscroll|onresize event handler
   * - コンテナ `div.Video__video__block` の window 内チェックを行います - {@link Video.checkHitWithPlayOrPause} -> {@link Video.hitTest} -> {@link Video.clientRect}
   */


  Video.prototype.onScroll = function onScroll() {
    this.checkHitWithPlayOrPause();
  };

  Video.prototype.onResize = function onResize() {
    this.checkHitWithPlayOrPause();
  };

  /**
   * `div.Video__video__block` の window 内チェックを行います
   * - {@link Video.hitTest} -> {@link Video.clientRect}
   * - window 内 - {@link Video.playVideos} 再生します
   * - window 外 - {@link Video.pauseVideos} 停止します
   * @param {boolean} [mountCheck=false]
   */


  Video.prototype.checkHitWithPlayOrPause = function checkHitWithPlayOrPause() {
    var _this2 = this;

    var mountCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    clearTimeout(this.timer.hitTestCheck);
    var hit = this.hitTest();
    if (hit === null) {
      this.timer.hitTestCheck = setTimeout(function () {
        _this2.checkHitWithPlayOrPause();
      }, 16);
      return;
    }
    // ---
    if (hit) {
      if (!mountCheck) {
        // console.log('Video.checkHitWithPlayOrPause - hit -> play', this.videos.pc.src, hit, this.clientRect(), window.innerHeight);
        this.playVideos();
      }
    } else {
      // console.log('Video.checkHitWithPlayOrPause - hit -> pause', this.videos.pc.src, hit, this.clientRect(), window.innerHeight);
      this.pauseVideos();
      this.rewindVideos();
    }
  };

  /**
   * `div.Video__video__block`.getBoundingClientRect 実行し clientRect 取得します
   * @returns {?ClientRect} offset 値を返します {top, width, height...}
   */


  Video.prototype.clientRect = function clientRect() {
    return this.videoContainer ? this.videoContainer.getBoundingClientRect() : null;
  };

  /**
   * `div.Video__video__block` clientRect と `window.innerHeight` を比較し hit test を行います
   * @returns {?boolean} true: window 内
   */


  Video.prototype.hitTest = function hitTest() {
    var clientRect = this.clientRect();
    if (!clientRect) {
      return false;
    }
    var top = clientRect.top,
        bottom = clientRect.bottom,
        left = clientRect.left,
        right = clientRect.right;

    if (top === 0 && bottom === 0 && left === 0 && right === 0) {
      return null;
    }
    // clientRect.top が scroll 位置を考慮しない
    var display = {
      top: 0,
      bottom: window.innerHeight,
      left: 0,
      right: window.innerWidth
    };
    // console.log('Video.hitTest', clientRect, display, (display.top < clientRect.bottom && display.bottom > clientRect.top), (clientRect.left >= 0 && clientRect.left < display.right), (clientRect.right <= display.right && clientRect.right >= 0));
    return (top >= display.top && top < display.bottom || bottom <= display.bottom && bottom > display.top) && (left >= 0 && left < display.right || right <= display.right && right > 0);
  };

  // -----------------------------------------------------
  /**
   * error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} error video play error message
   * @returns {boolean} true - 非表示実行
   */


  Video.prototype.needHideVideo = function needHideVideo(pc, error) {
    if (!error) {
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    var massages = ['no supported source', 'didn\'t interact'];
    var result = massages.some(function (message) {
      return error.message.indexOf(message) !== -1;
    });
    if (result) {
      var state = pc ? { visiblePc: false } : { visibleMb: false };
      // console.log('Video.needHideVideo -', result, massages, error, state);
      this.setState(state);
      return true;
    }
    return false;
  };
  /**
   * {@link Video.needHideVideo} - error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */


  Video.prototype.playFaultAlternateImage = function playFaultAlternateImage(pc) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }
    this.pauseVideo(pc);
    this.rewindVideo(pc);
  };
  /**
   * HTML5 video start します
   * @param {boolean} pc video file select flag - true: PC
   */


  Video.prototype.playVideo = function playVideo(pc) {
    var _this3 = this;

    // console.log('Video.playVideo', pc, this.played, this.ended);
    var ended = pc ? this.ended.pc : this.ended.mb;
    if (ended) {
      return;
    }
    var video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    if (!video.paused) {
      return;
    }
    var playPromise = null;
    // let success = false;
    try {
      playPromise = video.play();
      // success = true;
    } catch (e) {
      console.warn('[VIDEO] play video fault, ' + error, video.src);
      // success  = false;
      this.playFaultAlternateImage(pc, e);
    }
    if (playPromise) {
      playPromise.catch(function (error) {
        console.warn('[VIDEO] play video fault in Promise, ' + error, video.src);
        // success  = false;
        _this3.playFaultAlternateImage(pc, error);
      });
    }
  };
  /**
   * video tag play 実行します - {@link Video.playVideo}
   */


  Video.prototype.playVideos = function playVideos() {
    // console.log('Video.playVideos', this.played, this.ended, this.videos.pc.src);
    this.played = true;
    this.playVideo(true);
    this.playVideo(false);
  };

  Video.prototype.pauseVideo = function pauseVideo(pc) {
    var visible = pc ? this.state.visiblePc : this.state.visibleMb;
    if (!visible) {
      return;
    }
    var video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // console.log('Video.pauseVideo - pc', pc, visible, this.ended, this.videos.pc.src);
    try {
      video.pause();
    } catch (error) {
      console.warn('[VIDEO] pause video fault, ' + error, pc, video.src);
    }
  };
  /**
   * video tag - pause 実行します
   */


  Video.prototype.pauseVideos = function pauseVideos() {
    // console.log('Video.pauseVideos', this.played, this.ended, this.videos.pc.src);
    this.played = false;
    this.pauseVideo(true);
    this.pauseVideo(false);
  };

  Video.prototype.rewindVideo = function rewindVideo(pc) {
    // ---
    // 再生中は rewind しない
    if (this.played) {
      return;
    }
    var visible = pc ? this.state.visiblePc : this.state.visibleMb;
    if (!visible) {
      return;
    }
    var video = pc ? this.videos.pc : this.videos.mb;
    if (!video) {
      return;
    }
    try {
      video.currentTime = 0;
    } catch (error) {
      console.warn('[VIDEO] rewindVideo fault, ' + error, pc, video.src);
    }
  };
  /**
   * rewind します
   */


  Video.prototype.rewindVideos = function rewindVideos() {
    // console.log('Video.rewindVideos', this.played, this.ended, this.videos.pc.src);
    this.rewindVideo(true);
    this.rewindVideo(false);
  };

  // -----------------------------------------------
  // doMoveFirstFrame(delay = 32) {
  //   clearTimeout(this.timer.firstFrame);
  //   // 完全に再生が始まるのを待つ
  //   if (!this.played) {
  //     this.timer.firstFrame = setTimeout(() => {
  //       this.doMoveFirstFrame(delay);
  //     }, delay);
  //     return;
  //   }
  //   this.pauseVideos();
  //   // first frame
  //   this.rewindVideos();
  // }

  /**
   * ~~poster 画像を表示できない時のみ video 1frame へ移動します~~
   *
   * autoPlay: false -  video 1frame へ移動します
   */


  Video.prototype.shouldFirstFrame = function shouldFirstFrame() {
    var autoPlay = this.props.autoPlay;
    // console.log('Video.shouldFirstFrame', autoPlay, this.videos);

    if (autoPlay) {
      return;
    }
    // video tag exist
    var _videos = this.videos,
        pc = _videos.pc,
        mb = _videos.mb;

    if (!pc && !mb) {
      return;
    }
    // ---
    this.pauseVideos();
    this.rewindVideos();
  };

  // -----------------------------------------------
  /**
   * modal 開きます
   * - modal open します - state.isOpen: 'is-open'
   * - document.body add `.un-scroll-pc`, `.un-scroll-mb`
   */


  Video.prototype.executeOpen = function executeOpen() {
    var _this4 = this;

    // modal open flag on body
    // document.body.classList.add(this.modalOpened);

    // 再生中のみ止める
    // console.log('Video.executeOpen', this.played, this.videos.pc.src);
    if (this.played) {
      this.pauseVideos();
      // 再生 flag ON
      this.shouldPlaying = true;
    }

    // EPIServerのプレビュー時のモーダルの位置調整
    // let isEpiServerPreview = false;
    if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].body.style.position = 'absolute';
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].body.style.top = -this.wrapperScrollTop + 'px';
          var headerElement = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          // isEpiServerPreview = true;
        }
      }
    }

    // if (!isEpiServerPreview) {
    //   // BODYのスクロール無効化
    //   BodyControl.openModal();
    // }

    // BODYのスクロール無効化
    __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].openModal();
    //this.bodyClasses.map(className => (document.body.classList.add(className)));

    if (0 <= String(navigator.userAgent).indexOf('MyMazda')) {
      this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
    } else {
      // IOS10の場合の処理
      var iosVer = function () {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
          var versions = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
          return versions[0];
        } else return 0;
      }();
      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["f" /* IS_IOS */] && iosVer < 11) {
        setTimeout(function () {
          _this4.setState({ isOpen: 'is-open', youtubeId: _this4.props.youtubeId });
        }, 200);
      } else {
        this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
      }
    }

    //this.setState({ isOpen: 'is-open', youtubeId: this.props.youtubeId });
  };

  /**
   * modal を閉じ YouTube 再生を止めます
   * - state.isOpen: ''
   * - {@link Video.stopYouTube}
   * - document.body remove `.un-scroll-pc`, `.un-scroll-mb`
   */


  Video.prototype.executeClose = function executeClose() {
    this.stopYouTube();
    // ---
    // document.body.classList.remove(this.modalOpened);

    // 再生 flag ON の時のみ再開させる
    if (this.shouldPlaying) {
      this.playVideos();
    }

    // EPIServerのプレビュー時のモーダルの位置調整
    if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].body.style.position = 'static';
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].body.style.top = 'auto';
          var headerElement = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].closeModal();
    //this.bodyClasses.map(className => (document.body.classList.remove(className)));

    // this.setState({ isOpen: '', youtubeId: this.props.youtubeId });
    this.setState({ isOpen: '', youtubeId: null });
  };

  /**
   * YouTube modal 閉じる時に再生を止めます
   */


  Video.prototype.stopYouTube = function stopYouTube() {
    var player = this.youtubeIframe;
    if (!player) {
      return;
    }
    try {
      player.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    } catch (error) {
      console.warn('Video.stopYouTube', error);
      // postMessage - 実行できないときは iframe src を空にして無理やり止める
      this.youtubeIframeSrc = player.src;
      player.src = '';
    }
  };
  /**
   * YouTube iframe src path を作成します
   * @param {string} [id=''] YouTube ID YouTube modal は必ず開くエラーになっても...
   * @returns {string} `//www.youtube.com/embed/${id}?rel=0&version=3&enablejsapi=1`
   */


  Video.prototype.createPath = function createPath() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var path = id ? '//www.youtube.com/embed/' + id + '?rel=0&version=3&enablejsapi=1&showinfo=0&modestbranding=0' : '';
    this.youtubeIframeSrc = path;
    return path;
  };

  /**
   * React 経由で無い event handler を unbind します
   */


  Video.prototype.dispose = function dispose() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  };
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  /**
   * HTML5 video mete します
   * - attribute muted が有効にならないので property を制御します
   */


  Video.prototype.videosToMute = function videosToMute() {
    Object.values(this.videos).map(function (video) {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  };

  Video.prototype.afterDidUpdateHitTest = function afterDidUpdateHitTest() {
    var _this5 = this;

    clearTimeout(this.timer.hitTest);
    if (this.state.isOpen) {
      return;
    }
    var hit = this.hitTest();
    if (hit === null) {
      this.timer.hitTest = setTimeout(function () {
        _this5.afterDidUpdateHitTest();
      }, 16);
      return;
    }
    // console.log('Video.afterDidUpdateHitTest - check hit', this.videos.pc.src, hit, this.clientRect(), window.innerWidth);
    if (hit) {
      this.playVideos();
    }
  };

  Video.prototype.componentDidUpdate = function componentDidUpdate() {
    var _ended = this.ended,
        pc = _ended.pc,
        mb = _ended.mb;

    if (!pc && !mb && this.watchScroll) {
      this.afterDidUpdateHitTest();
    }
  };
  /**
   * delegate - after mount
   * - 条件により scroll / resize 監視を行います
   */


  Video.prototype.componentDidMount = function componentDidMount() {
    this.videosToMute();
    // console.log('Video.componentDidMount', Date.now());
    // ---
    if (this.watchScroll) {
      // 要監視
      this.dispose();
      window.addEventListener('scroll', this.onScroll, false);
      window.addEventListener('resize', this.onResize, false);
      // first check を強制的に実行します
      // console.log('Video.componentDidMount', this.videos.pc.src);
      this.checkHitWithPlayOrPause();
    } else {
      // console.log('Video.componentDidMount - shouldFirstFrame', this.watchScroll);
      this.shouldFirstFrame();
    }
    // // ---
    // // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  };

  /**
   * delegate - before unmount
   * - timer clear する
   */


  Video.prototype.componentWillUnmount = function componentWillUnmount() {
    // console.log('Video.componentWillUnmount', this.videos.pc.src);
    // this.pauseVideos();
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
    // ---
    this.dispose();
    // this.disposeTouches();
  };

  /**
   * YouTube modal link 作成します - `a.HeroVideo__Youtube__link`
   * @returns {?Element} `a.HeroVideo__Youtube__link`
   */


  Video.prototype.renderYouTubeLink = function renderYouTubeLink() {
    var playOnModal = this.props.playOnModal;

    if (!playOnModal) {
      return null;
    }
    // modal open
    // type を className へ
    // @since 2018-10-27 - FB: #ref https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-271#comment-9355197
    // win(IE11) ・モーダルを開くと、ページTOPに移動してしまう（URLの末尾に#）
    // a to span
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      'data-href': '#',
      className: 'Video__Youtube__link',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1075
      }
    });
  };

  // -----------------------------------------------
  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?boolean} loop loop flag
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=Video__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.Video__video` tag を返します
   */


  Video.prototype.renderVideoTag = function renderVideoTag(src, loop) {
    var poster = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _this6 = this;

    var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var baseClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Video__video';

    // require check
    // console.log('Video.renderVideoTag', suffix, src, poster);
    if (src === null || !src || !suffix) {
      return null;
    }
    var _state = this.state,
        visiblePc = _state.visiblePc,
        visibleMb = _state.visibleMb;
    // ---

    var isPc = suffix === 'pc';
    var visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // ---
    // this.played = autoPlay && visiblePc && visibleMb;
    // class name
    var className = '' + baseClass + (suffix ? '-' : '') + suffix;
    // video tag
    var attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: false,
      autoPlay: true,
      playsInline: true,
      muted: true,
      loop: !!loop,
      src: src,
      className: className,
      type: 'video/' + src.split('.').pop().split('?').shift()
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    if (isPc) {
      attributes.ref = function (component) {
        return _this6.videos.pc = component;
      };
      attributes.onEnded = this.onPcVideoEnded;
      attributes.onPlay = this.onPcVideoPlay;
      attributes.style = visiblePc ? null : { display: 'none' };
      // attributes.autoPlay = visiblePc && autoPlay;
      if (!visiblePc) {
        attributes.autoPlay = null;
      }
      // attributes.preload = 'none';
    } else {
      attributes.ref = function (component) {
        return _this6.videos.mb = component;
      };
      attributes.onEnded = this.onMbVideoEnded;
      attributes.onPlay = this.onMbVideoPlay;
      attributes.style = visibleMb ? null : { display: 'none' };
      // attributes.autoPlay = visibleMb && autoPlay;
      if (!visibleMb) {
        attributes.autoPlay = null;
      }
      // attributes.preload = 'metadata';
    }
    // ---
    // tag
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({}, attributes, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1156
      }
    }));
    // return (
    //   <video {...attributes} muted={true}>
    //     <source src={src} type={`video/${src.split('.').pop().split('?').shift()}`} />
    //   </video>
    // );
  };

  /**
   * page 内表示の YouTube iframe タグを作成します
   * @returns {?HTMLIFrameElement} YouTube `iframe.Video__youtube__iframe`
   */


  Video.prototype.renderYtPage = function renderYtPage() {
    var _props = this.props,
        youtubeId = _props.youtubeId,
        playOnModal = _props.playOnModal;

    if (!youtubeId || playOnModal) {
      return null;
    }

    //const src = `//www.youtube.com/embed/${youtubeId}?rel=0&version=3&showinfo=0&enablejsapi=1&modestbranding=0`;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_youtube_player__["a" /* default */], {
      cls: 'Video__youtube__iframe',
      height: '100%',
      width: '100%',
      autoplay: 0,
      controls: 1,
      youtubeId: youtubeId,
      isModal: false,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1176
      }
    })
    // <iframe
    //   src={src}
    //   frameBorder="0"
    //   className="Video__youtube__iframe"
    //   // allow="autoplay; encrypted-media"
    //   allowFullScreen={true}
    // />
    ;
  };
  /**
   * `div.Video__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.Video__figure__block`
   */


  Video.prototype.renderFigureVideo = function renderFigureVideo() {
    var _this7 = this;

    var _props2 = this.props,
        videoSrc = _props2.videoSrc,
        videoFilter = _props2.videoFilter,
        loop = _props2.loop,
        pcImageSrc = _props2.pcImageSrc,
        mbImageSrc = _props2.mbImageSrc,
        youtubeId = _props2.youtubeId;
    // ---

    var ytThumb = youtubeId ? '//img.youtube.com/vi/' + youtubeId + '/maxresdefault.jpg' : '';
    //const pcPosterSrc = pcImageSrc || ytThumb;
    var pcPosterSrc = pcImageSrc || null;
    pcPosterSrc = !pcPosterSrc && !videoSrc ? ytThumb : pcPosterSrc;
    var mbPosterSrc = mbImageSrc || pcPosterSrc;
    // ---
    var pcVideo = this.renderVideoTag(videoSrc, loop, pcPosterSrc, 'pc');
    var mbVideo = this.renderVideoTag(videoSrc, loop, mbPosterSrc, 'mb');
    // ---
    var _state2 = this.state,
        visiblePc = _state2.visiblePc,
        visibleMb = _state2.visibleMb;

    var pcPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FigurePosterBgTag, {
      path: pcPosterSrc,
      suffix: 'pc',
      useYouTube: pcPosterSrc === ytThumb,
      visibleVideo: visiblePc,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1219
      }
    });
    var mbPoster = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FigurePosterBgTag, {
      path: mbPosterSrc,
      suffix: 'mb',
      useYouTube: mbPosterSrc === ytThumb,
      visibleVideo: visibleMb,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1225
      }
    });
    // const pcPoster = Video.figurePosterBgTag(pcPosterSrc, 'pc', pcPosterSrc === ytThumb);
    // const mbPoster = Video.figurePosterBgTag(mbPosterSrc, 'mb', mbPosterSrc === ytThumb);
    // ---
    // video tag 無い時のみ
    var youtube = !pcVideo || !mbVideo ? this.renderYtPage() : null;
    // ---
    if (!pcVideo && !mbVideo && !pcPoster && !mbPoster && !youtube) {
      return null;
    }
    // ---
    this.posters.pc = !!pcPosterSrc;
    this.posters.mb = !!mbPosterSrc;
    // ---
    // filter
    var pcFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, {
      youtube: !!youtube,
      filterFlag: videoFilter,
      suffix: 'pc',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1245
      }
    });
    var mbFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterTag, {
      youtube: !!youtube,
      filterFlag: videoFilter,
      suffix: 'mb',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1250
      }
    });
    // const pcFilter = (!youtube) ? Video.filterTag(videoFilter, 'pc'): null;
    // const mbFilter = (!youtube) ? Video.filterTag(videoFilter, 'mb'): null;
    // ---
    // youtube modal trigger
    var youtubeLink = this.renderYouTubeLink();
    // ---
    // mp4 play icon
    // const playButton = this.videoPlayButton();
    // ---
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'Video__figure__block',
        ref: function ref(component) {
          return _this7.videoContainer = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1266
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'Video__video__block'
          // ref={component => (this.videoContainer = component)}
          , __source: {
            fileName: _jsxFileName,
            lineNumber: 1270
          }
        },
        youtube,
        pcVideo,
        mbVideo,
        pcPoster,
        mbPoster
      ),
      pcFilter,
      mbFilter,
      youtubeLink
    );
  };

  /**
   * `div.Video__container > div.Video__wysiwyg` 作成します
   * @returns {?ReactElement} `div.Video__container > div.Video__wysiwyg`
   */


  Video.prototype.renderWysiwyg = function renderWysiwyg() {
    var _props3 = this.props,
        pcDescription = _props3.pcDescription,
        mbDescription = _props3.mbDescription;

    var mbHtml = mbDescription || pcDescription;
    var pc = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WysiwygTag, { description: pcDescription, suffix: 'pc', __source: {
        fileName: _jsxFileName,
        lineNumber: 1297
      }
    });
    var mb = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WysiwygTag, { description: mbHtml, suffix: 'mb', __source: {
        fileName: _jsxFileName,
        lineNumber: 1298
      }
    });
    // const pc = Video.wysiwygTag(pcDescription, 'pc');
    // const mb = Video.wysiwygTag(mbHtml, 'mb');
    if (!pc && !mb) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Video__container', ref: 'container', __source: {
          fileName: _jsxFileName,
          lineNumber: 1305
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Video__wysiwyg Wysiwyg', __source: {
            fileName: _jsxFileName,
            lineNumber: 1306
          }
        },
        pc,
        mb
      )
    );
  };

  /**
   * YouTube modal 関連動画 - `div.Video__modal__relatedVideos`
   * @returns {?Element} `div.Video__modal__relatedVideos`
   */


  Video.prototype.renderRelatedVideo = function renderRelatedVideo() {
    var relatedVideo = this.props.relatedVideo;

    if (relatedVideo === null || !Array.isArray(relatedVideo) || !relatedVideo.length) {
      return null;
    }
    if (relatedVideo.length > 6) {
      relatedVideo.length = 6;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'RelatedVideo__container',
        role: 'presentation',
        onClick: this.onClickRelated,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1327
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'RelatedVideo__main_title', __source: {
            fileName: _jsxFileName,
            lineNumber: 1332
          }
        },
        '\u95A2\u9023\u52D5\u753B'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'RelatedVideo__wrap', __source: {
            fileName: _jsxFileName,
            lineNumber: 1333
          }
        },
        relatedVideo.map(function (component, index) {
          var id = 'video-relatedVideo-' + index;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__related_video__["a" /* default */], _extends({ key: id }, component.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1337
            }
          }));
        })
      )
    );
  };

  /**
   * YouTube 再生するための modal container - `div.Video__modal`
   * - 関連動画クリックで iframe src 差替えます - {@link Video.state.youtubeId} を使用します
   * - YouTube iframe API 使用する
   * - `postMessage` を使用し control します `//www.youtube.com/embed/` - `embed` 必須 not `v`
   * - `enablejsapi=1` 必須
   * - {@link Video.youtubeIframe} へ iframe 参照を保存します
   * @returns {?Element} `div.Video__modal`
   * @see https://developers.google.com/youtube/iframe_api_reference?hl=ja
   */


  Video.prototype.renderModalYouTube = function renderModalYouTube() {
    var _state3 = this.state,
        youtubeId = _state3.youtubeId,
        isOpen = _state3.isOpen;
    var playOnModal = this.props.playOnModal;

    if (!playOnModal) {
      return null;
    }
    if (!isOpen) {
      return null;
    }
    // ---
    // unique id - control する時に識別子として必要になるかもなので念のために設定する
    var id = this.youtubeIframeId;
    // ---
    var src = this.createPath(youtubeId);
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Video__modal ' + isOpen, __source: {
          fileName: _jsxFileName,
          lineNumber: 1372
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'Video__modal__overlay',
        role: 'presentation',
        onClick: this.onClickModalClose,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1373
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'Video__modal__content',
          onClick: this.onClickModalCloseByContent,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1378
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Video__modal__content__inner', __source: {
              fileName: _jsxFileName,
              lineNumber: 1382
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Video__modal__movie__block', __source: {
                fileName: _jsxFileName,
                lineNumber: 1383
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_youtube_player__["a" /* default */], {
              cls: 'Video__modal__movie',
              height: '100%',
              width: '100%',
              autoplay: 1
              // autoplay={0}
              , controls: 1,
              youtubeId: youtubeId,
              isModal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1384
              }
            })
          ),
          this.renderRelatedVideo()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
        className: 'Video__modal__btn__close',
        onClick: this.onClickModalClose,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1407
        }
      })
    );
  };

  Video.prototype.render = function render() {
    var _this8 = this;

    var _props4 = this.props,
        containerId = _props4.containerId,
        containerClass = _props4.containerClass,
        size = _props4.size,
        playOnModal = _props4.playOnModal;
    // ---

    var figureVideo = this.renderFigureVideo();
    var wysiwyg = this.renderWysiwyg();
    // ---
    if (!figureVideo && !wysiwyg) {
      return null;
    }
    // ---
    var sizeClass = 'size__' + (size || 'Standard').toLowerCase();
    // ---
    var style = {};
    if (this.props.backgroundColor) {
      style.backgroundColor = '#' + this.props.backgroundColor.replace(/#/g, '');
    }
    if (this.state.containerHeight) {
      style.height = this.state.containerHeight;
    }
    //
    var layout2 = null;
    if (this.props.hasBackground || this.props.backgroundColor && this.props.backgroundColor !== '') {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1455
        }
      },
      function () {
        if (playOnModal === true) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'article',
            {
              className: 'Video__article',
              style: style.backgroundColor ? { backgroundColor: style.backgroundColor } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1462
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'Video ' + sizeClass + ' ' + (layout2 ? layout2 : ''),
                ref: function ref(component) {
                  return _this8.refsContent = component;
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1466
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'Video__link',
                  style: style.height ? { height: style.height } : null,
                  onClick: _this8.onClickModalOpen,
                  'data-movie': _this8.props.youtubeId ? _this8.props.youtubeId : '',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1470
                  }
                },
                figureVideo,
                wysiwyg
              ),
              _this8.renderModalYouTube()
            )
          );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'article',
          {
            className: 'Video__article',
            style: style,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1485
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'Video ' + sizeClass,
              ref: function ref(component) {
                return _this8.refsContent = component;
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1489
              }
            },
            figureVideo,
            wysiwyg,
            _this8.renderModalYouTube()
          )
        );
      }()
    );
  };

  return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  playOnModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  videoFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // relatedVideo: PropTypes.arrayOf(PropTypes.node),
  relatedVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inFeatureCategoriesHorizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasBackground: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parentColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcDescription: null,
  mbDescription: null,
  youtubeId: null,
  pcImageSrc: null,
  mbImageSrc: null,
  videoSrc: null,
  size: null,
  autoPlay: null,
  loop: null,
  playOnModal: null,
  videoFilter: null,
  relatedVideo: null,
  backgroundColor: null,
  getRef: null,
  inFeatureCategoriesHorizontal: false,
  hasBackground: false,
  parentColumn: null
}, _temp);
Video.displayName = 'Video';


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromoAndButtonModalWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__icon_open_black_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__icon_open_white_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo-and-button-modal-window\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3,
    _class4,
    _temp4;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PromoAndButtonModalWindow = (_temp = _class = function (_Component) {
  _inherits(PromoAndButtonModalWindow, _Component);

  function PromoAndButtonModalWindow(props) {
    _classCallCheck(this, PromoAndButtonModalWindow);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isModalOpened: false
    };
    _this.refs = null;
    _this.refsPromoItem = null;
    _this.wrapperScrollTop = 0;
    return _this;
  }

  PromoAndButtonModalWindow.prototype.openModal = function openModal() {
    this.setState({
      isModalOpened: true
    });

    // EPIServerのプレビュー時のモーダルの位置調整
    var isEpiServerPreview = false;
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["a" /* DOCUMENT */].body.style.position = 'absolute';
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["a" /* DOCUMENT */].body.style.top = -this.wrapperScrollTop + 'px';
          var headerElement = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          isEpiServerPreview = true;
        }
      }
    }

    if (!isEpiServerPreview) {
      // BODYのスクロール無効化
      __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].openModal();
    }
    // Video停止
    if (this.refsPromoItem) this.refsPromoItem.pauseVideo();
    // FeatureCategoriesの重なり順調整
    if (this.refs) {
      var parentElement = this.refs.closest('.FeatureCategories') || null;
      if (parentElement) {
        parentElement.style.zIndex = 2;
      }
    }
  };

  PromoAndButtonModalWindow.prototype.closeModal = function closeModal() {
    this.setState({
      isModalOpened: false
    });

    // EPIServerのプレビュー時のモーダルの位置調整
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["a" /* DOCUMENT */].body.style.position = 'static';
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["a" /* DOCUMENT */].body.style.top = 'auto';
          var headerElement = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["a" /* DOCUMENT */].body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].closeModal();
    // Video再生
    if (this.refsPromoItem) this.refsPromoItem.playVideo();
    // FeatureCategoriesの重なり順調整
    if (this.refs) {
      var parentElement = this.refs.closest('.FeatureCategories') || null;
      if (parentElement) {
        parentElement.style.zIndex = 1;
      }
    }
  };

  PromoAndButtonModalWindow.prototype.getContentsHeight = function getContentsHeight() {
    // console.log('getContentsHeight', this.refsPromoItem.getContentsHeight());
    if (this.refsPromoItem) {
      return this.refsPromoItem.getContentsHeight();
    } else {
      return null;
    }
  };

  PromoAndButtonModalWindow.prototype.setContainerHeight = function setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.refsPromoItem) {
      this.refsPromoItem.setContainerHeight(height);
    }
  };

  PromoAndButtonModalWindow.prototype.renderCta = function renderCta() {
    var promo = this.props.promo;

    if (promo && promo.ctaButton && 1 <= promo.ctaButton.length) {
      var components = promo.ctaButton;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'PromoAndButtonModalWindow__list', __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          }
        },
        function () {
          return components.map(function (component, index) {
            var name = null;
            if (component.name) {
              name = component.name;
            } else if (component.type) {
              name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
            }
            if (name === 'Cta') {
              var classNames = [];
              // 2個以上ある場合は50%にする
              if (2 <= components.length) {
                classNames.push('multiple');
              }
              // リンクタイプがボタンかテキストか
              classNames.push('linkType__' + component.props.linkType);

              // テキスト（Text）リンク、はFreeでもなんでも矢印アイコンになる
              if (component.props.linkType === 'Text') {
                classNames.push('color__' + component.props.color);
                classNames.push('buttonStyle__' + component.props.buttonStyle);
                classNames.push('withArrowIcon');
              } else {
                classNames.push('color__' + component.props.color);
                classNames.push('buttonStyle__' + component.props.buttonStyle);
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: classNames.join(' '), key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 221
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PromoAndButtonModalWindow__box', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 222
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_cta__["a" /* default */], _extends({}, component.props, {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 223
                    }
                  }))
                )
              );
            }
          });
        }()
      );
    } else {
      return null;
    }
  };

  PromoAndButtonModalWindow.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        deleteIconOnPromo = _props.deleteIconOnPromo,
        linkItem = _props.linkItem,
        promo = _props.promo,
        linkButtonText = _props.linkButtonText,
        modal = _props.modal,
        getRef = _props.getRef,
        hasBackground = _props.hasBackground,
        parentColumn = _props.parentColumn;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      { containerId: containerId, containerClass: containerClass, __source: {
          fileName: _jsxFileName,
          lineNumber: 252
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'PromoAndButtonModalWindow' + (modal && modal.modalId ? ' ' + modal.modalId : ''),
          ref: function ref(component) {
            return _this2.refs = component;
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 253
          }
        },
        function () {
          if (linkItem === 'Promo') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              ScrollLoaderForPromoItem,
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 260
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PromoItem, _extends({}, promo, {
                getRef: getRef,
                hasBackground: hasBackground,
                parentColumn: parentColumn,
                deleteIconOnPromo: deleteIconOnPromo,
                openModal: function openModal() {
                  _this2.openModal();
                },
                ref: function ref(component) {
                  return _this2.refsPromoItem = component;
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 261
                }
              })),
              _this2.renderCta()
            );
          } else if (linkItem === 'Link-Button-Text') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CtaItem, _extends({}, linkButtonText, { openModal: function openModal() {
                _this2.openModal();
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 276
              }
            }));
          }
        }(),
        function () {
          if (_this2.state.isModalOpened) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, _extends({}, modal, { closeModal: function closeModal() {
                _this2.closeModal();
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 285
              }
            }));
          } else {
            return null;
          }
        }()
      )
    );
  };

  return PromoAndButtonModalWindow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deleteIconOnPromo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  promo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    pcLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ctaButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  linkButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    linkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    linkType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    buttonColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ctaButtonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    additionalClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    mbContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    modalId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasBackground: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parentColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  linkItem: 'Promo',
  deleteIconOnPromo: false,
  promo: {
    pcDescription: null,
    mbDescription: null,
    pcSrc: null,
    mbSrc: null,
    videoSrc: null,
    loop: true,
    pcLayout: 'Image-On-Top',
    mbLayout: 'Image-On-Top',
    backgroundColor: null,
    ctaButton: []
  },
  linkButtonText: {
    linkText: null,
    linkType: 'Button',
    buttonColor: 'Light',
    ctaButtonStyle: 'Standard',
    additionalClass: null
  },
  modal: {
    pcContents: [],
    mbContents: [],
    modalId: null
  },
  getRef: null,
  hasBackground: false,
  parentColumn: null
}, _temp);
PromoAndButtonModalWindow.displayName = 'PromoAndButtonModalWindow';

var PromoItem = (_temp2 = _class2 = function (_Component2) {
  _inherits(PromoItem, _Component2);

  PromoItem.imgTag = function imgTag(src) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'PromoAndButtonModalWindow-Promo__image';

    if (!src) return null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: src, alt: '', className: baseClass + ' ' + baseClass + (suffix ? '-' : '') + suffix, __source: {
        fileName: _jsxFileName,
        lineNumber: 337
      }
    });
  };

  PromoItem.descriptionTag = function descriptionTag(description) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'PromoAndButtonModalWindow-Promo__wysiwyg';

    if (!description) return null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: '' + baseClass + (suffix ? '-' : '') + suffix + ' Wysiwyg',
      dangerouslySetInnerHTML: { __html: description },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 343
      }
    });
  };

  PromoItem.convert = function convert(className) {
    return className.toLowerCase().replace(/[\/|:]/g, '_').replace(/[)]/g, '').replace(/[(]/g, '-');
  };

  function PromoItem(props) {
    _classCallCheck(this, PromoItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.handleScrollAndResize = function () {
      var element = _this3.refsContainer;
      if (!element) return;
      var scrollTop = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].pageYOffset;
      var clientRect = element.getBoundingClientRect();
      var top = scrollTop + clientRect.top;
      var windowHeight = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].innerHeight;
      var videoHeight = _this3.refsVideo.getBoundingClientRect().height;
      if (top <= scrollTop + windowHeight && scrollTop - videoHeight < top) {
        if (!_this3.state.isPlayed) {
          _this3.setState({
            isPlayed: true
          });
          _this3.playVideo();
        }
      } else {
        if (_this3.state.isPlayed) {
          _this3.setState({
            isPlayed: false
          });
          _this3.pauseVideo();
        }
      }
    };

    if (_this3.props.getRef) _this3.props.getRef(_this3);
    _this3.state = {
      containerHeight: null,
      isPlayed: false,
      ended: false,
      //loadedPcImg: false,
      //loadedMbImg: false,
      openedImg: false
    };
    _this3.refsContainer = null;
    _this3.refsVideo = null;
    return _this3;
  }

  PromoItem.prototype.getContentsHeight = function getContentsHeight() {
    // console.log('getContentsHeight', this.refsContainer.clientHeight);
    return this.refsContainer.clientHeight;
  };

  PromoItem.prototype.setContainerHeight = function setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height
      });
    }
  };

  PromoItem.prototype.clearContainerHeight = function clearContainerHeight() {
    return null;
    // if (this.state.containerHeight !== null) {
    //   this.setState({
    //     containerHeight: null,
    //   });
    // }
  };

  PromoItem.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    var _props2 = this.props,
        videoSrc = _props2.videoSrc,
        loop = _props2.loop;


    var ua = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["j" /* NAVIGATOR */].userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      setTimeout(function () {
        _this4.setState({
          openedImg: true
        });
      }, 100);
    } else {
      this.setState({
        openedImg: true
      });
    }

    //
    if (videoSrc) {
      if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent.EPi) {
        this.setState({
          played: true
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.handleScrollAndResize);
        __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.handleScrollAndResize);
        setTimeout(function () {
          _this4.handleScrollAndResize();
        }, 200);
      }
    } else {
      this.setState({
        played: true
      });
    }
    //
    if (this.refsVideo) {
      this.refsVideo.addEventListener('ended', function () {
        _this4.setState({
          ended: true
        });
        if (!loop) {
          _this4.refsVideo.load();
          _this4.refsVideo.autoplay = false;
        }
      }, false);
    }
  };

  PromoItem.prototype.componentWillUnmount = function componentWillUnmount() {
    var videoSrc = this.props.videoSrc;
    //

    if (videoSrc) {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.handleScrollAndResize);
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.handleScrollAndResize);
    }
  };

  PromoItem.prototype.playVideo = function playVideo() {
    var loop = this.props.loop;
    //

    if (!this.refsVideo) return;
    //
    if (this.state.ended && !loop) return;
    //再生
    try {
      this.refsVideo.play();
    } catch (e) {
      console.warn('PromoAndButtonModalWindow', e);
    }
  };

  PromoItem.prototype.pauseVideo = function pauseVideo() {
    if (!this.refsVideo) return;
    //一時停止
    try {
      this.refsVideo.pause();
    } catch (e) {
      console.warn('PromoAndButtonModalWindow', e);
    }
  };

  PromoItem.prototype.render = function render() {
    var _this5 = this;

    var _props3 = this.props,
        pcSrc = _props3.pcSrc,
        mbSrc = _props3.mbSrc,
        videoSrc = _props3.videoSrc,
        loop = _props3.loop,
        pcDescription = _props3.pcDescription,
        mbDescription = _props3.mbDescription,
        pcLayout = _props3.pcLayout,
        mbLayout = _props3.mbLayout,
        openModal = _props3.openModal,
        deleteIconOnPromo = _props3.deleteIconOnPromo;


    var renderFigures = function renderFigures() {
      var pcImg = pcSrc || '';
      var mbImg = mbSrc || pcImg;
      if (!pcImg && !mbImg) {
        return null;
      }

      // テキストの有無
      var hasDescription = true;
      var pcHtml = pcDescription || '';
      var mbHtml = mbDescription || pcHtml;
      if (!pcHtml && !mbHtml) {
        hasDescription = false;
      }

      // setTimeout(()=> {
      //   this.setState({
      //     openedImg: true,
      //   })
      // }, 100);

      var isIE = false;
      var ua = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["j" /* NAVIGATOR */].userAgent.toLowerCase();
      if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
        isIE = true;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoAndButtonModalWindow-Promo__image__block' + (isIE || _this5.state.openedImg ? ' opened' : ''),
          style: !hasDescription ? { width: '100%' } : null, __source: {
            fileName: _jsxFileName,
            lineNumber: 547
          }
        },
        PromoItem.imgTag(pcImg, 'pc'),
        PromoItem.imgTag(mbImg, 'mb')
      );

      /*
      // PC用画像読み込み
      if (!this.state.loadedPcImg) {
        const pcImage = new Image();
        pcImage.onload = ()=> {
          setTimeout(()=> {
            this.setState({
              loadedPcImg: true,
            })
          }, 1000)
        }
        pcImage.src = pcImg;
      }
        // MB用画像読み込み
      if (!this.state.loadedMbImg) {
        const mbImage = new Image();
        mbImage.onload = ()=> {
          this.setState({
            loadedMbImg: true,
          })
        }
        mbImage.src = mbImg;
      }
        if (this.state.loadedMbImg && this.state.loadedPcImg) {
        setTimeout(()=> {
          this.setState({
            openedImg: true,
          })
        }, 100);
        return (
          <div className={'PromoAndButtonModalWindow-Promo__image__block' + ((this.state.openedImg) ? ' opened' : '')}
               style={(!hasDescription) ? {width: '100%'} : null}>
            {PromoItem.imgTag(pcImg, 'pc')}
            {PromoItem.imgTag(mbImg, 'mb')}
          </div>
        );
      } else {
        return (
          <div className="PromoAndButtonModalWindow-Promo__image__block"
               style={(!hasDescription) ? {width: '100%'} : null}>
            <div className="PromoAndButtonModalWindow-Promo__image__blank">
              <span>&nbsp;</span>
            </div>
          </div>
        );
      }
      */
    };

    var renderVideo = function renderVideo() {
      if (!videoSrc) return;
      var poster = null;
      var pcImg = pcSrc || '';
      var mbImg = mbSrc || pcImg;
      if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */]) {
        poster = mbImg;
      } else {
        poster = pcImg;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoAndButtonModalWindow-Promo__video__block', __source: {
            fileName: _jsxFileName,
            lineNumber: 617
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', { className: 'PromoAndButtonModalWindow-Promo__video',
          src: videoSrc,
          poster: poster,
          autoPlay: true,
          loop: loop,
          muted: true,
          playsInline: true,
          controls: false,
          ref: function ref(component) {
            return _this5.refsVideo = component;
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 618
          }
        })
      );
    };

    var renderDescriptions = function renderDescriptions() {
      var pcHtml = pcDescription || '';
      var mbHtml = mbDescription || pcHtml;
      if (!pcHtml && !mbHtml) {
        return null;
      }

      // 画像の有無
      var hasFigure = true;
      var pcImg = pcSrc || '';
      var mbImg = mbSrc || pcImg;
      if (!pcImg && !mbImg) {
        hasFigure = false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoAndButtonModalWindow-Promo__text__block',
          style: !hasFigure ? { width: '100%' } : null, __source: {
            fileName: _jsxFileName,
            lineNumber: 648
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PromoAndButtonModalWindow-Promo__wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 650
            }
          },
          PromoItem.descriptionTag(pcHtml, 'pc'),
          PromoItem.descriptionTag(mbHtml, 'mb')
        )
      );
    };

    var figures = renderFigures();
    var video = renderVideo();
    var descriptions = renderDescriptions();
    if (!video && !figures && !descriptions) {
      return null;
    }

    var layout = function () {
      var pcClass = pcLayout || 'Image-On-Top';
      var mbClass = mbLayout || pcClass;
      return {
        pc: 'pcLayout__' + PromoItem.convert(pcClass),
        mb: 'mbLayout__' + PromoItem.convert(mbClass)
      };
    }();

    var layout2 = null;
    if (this.props.hasBackground || this.props.backgroundColor && this.props.backgroundColor !== '') {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }

    var deleteIconOnPromoClass = function deleteIconOnPromoClass() {
      if (deleteIconOnPromo) return ' deleteIcon';
      if ((figures || video) && !descriptions) return ' deleteIcon';
      return '';
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PromoAndButtonModalWindow-Promo ' + layout.pc + ' ' + layout.mb + (layout2 ? ' ' + layout2 : '') + deleteIconOnPromoClass(), __source: {
          fileName: _jsxFileName,
          lineNumber: 695
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'PromoAndButtonModalWindow-Promo__link', onClick: function onClick() {
            if (openModal) openModal();
          }, style: this.props.backgroundColor ? { backgroundColor: '#' + this.props.backgroundColor.replace(/#/g, '') } : null, __source: {
            fileName: _jsxFileName,
            lineNumber: 697
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PromoAndButtonModalWindow-Promo__wrapper', style: descriptions && this.state.containerHeight ? { height: this.state.containerHeight } : null, __source: {
              fileName: _jsxFileName,
              lineNumber: 700
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PromoAndButtonModalWindow-Promo__container', ref: function ref(component) {
                return _this5.refsContainer = component;
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 701
              }
            },
            function () {
              if (video) {
                return video;
              } else {
                return figures;
              }
            }(),
            descriptions
          )
        )
      )
    );
  };

  return PromoItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pcLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // ctaButton: PropTypes.array,
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasBackground: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parentColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deleteIconOnPromo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  pcDescription: null,
  mbDescription: null,
  pcSrc: null,
  mbSrc: null,
  videoSrc: null,
  loop: null,
  pcLayout: null,
  mbLayout: null,
  backgroundColor: null,
  // ctaButton: null,
  getRef: null,
  hasBackground: false,
  parentColumn: null,
  openModal: null,
  deleteIconOnPromo: false
}, _temp2);
PromoItem.displayName = 'PromoItem';
var CtaItem = (_temp3 = _class3 = function (_Component3) {
  _inherits(CtaItem, _Component3);

  function CtaItem(props) {
    _classCallCheck(this, CtaItem);

    return _possibleConstructorReturn(this, _Component3.call(this, props));
  }

  CtaItem.prototype.componentDidMount = function componentDidMount() {};

  CtaItem.prototype.componentWillUnmount = function componentWillUnmount() {};

  CtaItem.prototype.render = function render() {
    var _props4 = this.props,
        linkText = _props4.linkText,
        linkType = _props4.linkType,
        buttonColor = _props4.buttonColor,
        ctaButtonStyle = _props4.ctaButtonStyle,
        additionalClass = _props4.additionalClass,
        openModal = _props4.openModal;


    var ctaContainerAttrs = {
      className: ['PromoAndButtonModalWindow-Cta__container', buttonColor && buttonColor !== '' ? 'PromoAndButtonModalWindow-Cta__container--' + buttonColor : null].join(' ')
    };

    var renderText = function renderText() {
      return linkText && linkText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'PromoAndButtonModalWindow-Cta__button__text', __source: {
            fileName: _jsxFileName,
            lineNumber: 765
          }
        },
        linkText
      ) : '';
    };

    var renderIcon = function renderIcon() {
      var icon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
      var hoverIcon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
      if (buttonColor === 'Light') {
        if (ctaButtonStyle === 'Action') {
          if (linkType === 'Text') {
            icon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
            hoverIcon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
          } else {
            icon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
            hoverIcon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
          }
        } else {
          icon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
          hoverIcon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
        }
      } else if (buttonColor === 'Dark') {
        if (ctaButtonStyle === 'Action') {
          if (linkType === 'Text') {
            icon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
            hoverIcon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
          } else {
            icon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
            hoverIcon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
          }
        } else {
          icon = __WEBPACK_IMPORTED_MODULE_8__icon_open_black_png___default.a;
          hoverIcon = __WEBPACK_IMPORTED_MODULE_9__icon_open_white_png___default.a;
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'PromoAndButtonModalWindow-Cta__button__icon__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 800
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: icon, className: 'PromoAndButtonModalWindow-Cta__button__icon', __source: {
            fileName: _jsxFileName,
            lineNumber: 801
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: hoverIcon, className: 'PromoAndButtonModalWindow-Cta__button__icon--hover', __source: {
            fileName: _jsxFileName,
            lineNumber: 802
          }
        })
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PromoAndButtonModalWindow-Cta', __source: {
          fileName: _jsxFileName,
          lineNumber: 808
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, ctaContainerAttrs, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 809
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            onClick: function onClick() {
              if (openModal) openModal();
            },
            className: function () {
              return ['PromoAndButtonModalWindow-Cta__button', linkType && linkType !== '' ? 'PromoAndButtonModalWindow-Cta__button--linkType--' + linkType : null, ctaButtonStyle && ctaButtonStyle !== '' ? 'PromoAndButtonModalWindow-Cta__button--buttonStyle--' + ctaButtonStyle : null, additionalClass && additionalClass !== '' ? additionalClass : null].join(' ');
            }(), __source: {
              fileName: _jsxFileName,
              lineNumber: 810
            }
          },
          renderText(),
          renderIcon()
        )
      )
    );
  };

  return CtaItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  linkText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ctaButtonStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  additionalClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class3.defaultProps = {
  linkText: null,
  linkType: null,
  buttonColor: null,
  ctaButtonStyle: null,
  additionalClass: null,
  openModal: null
}, _temp3);
CtaItem.displayName = 'CtaItem';
var ModalItem = (_temp4 = _class4 = function (_Component4) {
  _inherits(ModalItem, _Component4);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this7 = _possibleConstructorReturn(this, _Component4.call(this, props));

    _this7.getNestedComponents = function (components) {
      return components.map(function (component, index) {
        var name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
        }
        var Block = __WEBPACK_IMPORTED_MODULE_6__blocks__[name];
        if (Block) {
          if (1 <= _this7.state.scrollTop) {
            if (index < 4) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 923
                }
              }));
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                ScrollLoaderForModalItem,
                { scrollTop: _this7.state.scrollTop, key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 927
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 928
                  }
                }))
              );
            }
          } else {
            if (index < 4) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 935
                }
              }));
            }
          }
        } else {
          return null;
        }
      });
    };

    _this7.state = {
      isOpened: false,
      scrollTop: 0
    };
    _this7.onScroll = _this7.onScroll.bind(_this7);
    _this7.containerRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this7;
  }

  ModalItem.prototype.componentDidMount = function componentDidMount() {
    var _this8 = this;

    this.containerRef.current.addEventListener('scroll', this.onScroll);

    var ua = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["j" /* NAVIGATOR */].userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {

      this.setState({
        isOpened: true
      });

      // GTMイベント
      if (this.props.modalId && this.props.modalId !== '') {
        __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer || [];
        __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer.push({
          trackmodalId: this.props.modalId,
          event: 'loadmodal'
        });
      }
    } else {

      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].requestAnimationFrame(function () {

        _this8.setState({
          isOpened: true
        });

        // GTMイベント
        if (_this8.props.modalId && _this8.props.modalId !== '') {
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer || [];
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].dataLayer.push({
            trackmodalId: _this8.props.modalId,
            event: 'loadmodal'
          });
        }
      });
    }
  };

  ModalItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.containerRef.current.removeEventListener('scroll', this.onScroll);
    this.setState({
      isOpened: false
    });
  };

  ModalItem.prototype.onScroll = function onScroll() {
    this.setState({
      scrollTop: this.containerRef.current.scrollTop
    });
  };

  ModalItem.prototype.renderContents = function renderContents() {
    var _props5 = this.props,
        pcContents = _props5.pcContents,
        mbContents = _props5.mbContents;

    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["g" /* IS_MOBILE */] && mbContents && 1 <= mbContents.length) {
      return this.getNestedComponents(mbContents);
    } else if (pcContents && 1 <= pcContents.length) {
      return this.getNestedComponents(pcContents);
    } else {
      return null;
    }
  };

  ModalItem.prototype.render = function render() {
    var closeModal = this.props.closeModal;


    var isIE = false;
    var ua = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["j" /* NAVIGATOR */].userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      isIE = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PromoAndButtonModalWindow-Modal', __source: {
          fileName: _jsxFileName,
          lineNumber: 972
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'PromoAndButtonModalWindow-Modal__link-close5', onClick: function onClick() {
            if (closeModal) closeModal();
          }, __source: {
            fileName: _jsxFileName,
            lineNumber: 973
          }
        },
        '\u9589\u3058\u308B'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoAndButtonModalWindow-Modal__container2', __source: {
            fileName: _jsxFileName,
            lineNumber: 976
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'PromoAndButtonModalWindow-Modal__link-close', onClick: function onClick() {
              if (closeModal) closeModal();
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 977
            }
          },
          '\u9589\u3058\u308B'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoAndButtonModalWindow-Modal__container', ref: this.containerRef, __source: {
            fileName: _jsxFileName,
            lineNumber: 981
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'PromoAndButtonModalWindow-Modal__link-close4', onClick: function onClick() {
              if (closeModal) closeModal();
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 982
            }
          },
          '\u9589\u3058\u308B'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PromoAndButtonModalWindow-Modal__container3', __source: {
              fileName: _jsxFileName,
              lineNumber: 985
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'PromoAndButtonModalWindow-Modal__link-close3', onClick: function onClick() {
                if (closeModal) closeModal();
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 986
              }
            },
            '\u9589\u3058\u308B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PromoAndButtonModalWindow-Modal__contents' + (isIE || this.state.isOpened ? ' isOpened' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 989
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'PromoAndButtonModalWindow-Modal__rule', __source: {
                fileName: _jsxFileName,
                lineNumber: 990
              }
            }),
            this.state.isOpened ? this.renderContents() : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'PromoAndButtonModalWindow-Modal__link-close2', onClick: function onClick() {
                  if (closeModal) closeModal();
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 992
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 994
                  }
                },
                '\u9589\u3058\u308B'
              )
            )
          )
        )
      )
    );
  };

  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class4.propTypes = {
  pcContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  mbContents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  modalId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class4.defaultProps = {
  pcContents: null,
  mbContents: null,
  modalId: null,
  closeModal: null
}, _temp4);
ModalItem.displayName = 'ModalItem';

// PromoItem用のスクロールローダー
var ScrollLoaderForPromoItem = function (_Component5) {
  _inherits(ScrollLoaderForPromoItem, _Component5);

  function ScrollLoaderForPromoItem(props) {
    _classCallCheck(this, ScrollLoaderForPromoItem);

    var _this9 = _possibleConstructorReturn(this, _Component5.call(this, props));

    _this9.handleScrollAndResize = function () {
      if (_this9.state.opened === true) return;
      var element = _this9.ref.current;
      var scrollTop = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].pageYOffset;
      var clientRect = element.getBoundingClientRect();
      var top = scrollTop + clientRect.top;
      var windowHeight = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].innerHeight;
      if (top <= scrollTop + windowHeight) {
        if (_this9.state.opened === false) {
          _this9.setState({
            opened: true
          });
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', _this9.handleScrollAndResize);
          __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', _this9.handleScrollAndResize);
        }
      }
    };

    _this9.state = {
      opened: false
    };
    _this9.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this9;
  }

  ScrollLoaderForPromoItem.prototype.componentDidMount = function componentDidMount() {
    var _this10 = this;

    var isPromoModal = false;
    if (this.ref.current) {
      var parentElement = this.ref.current.closest('.FeatureCategories') || null;
      if (!parentElement) {
        parentElement = this.ref.current.closest('.PromoAndButtonModalWindow-Modal') || null;
      }
      if (parentElement) {
        isPromoModal = true;
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true
      });
    } else if (isPromoModal) {
      // プロモモーダルブロックのモーダル内の処理
      this.setState({
        opened: true
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.handleScrollAndResize);
      __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.handleScrollAndResize);
      this.handleScrollAndResize();
      setTimeout(function () {
        _this10.handleScrollAndResize();
      }, 200);
    }
  };

  ScrollLoaderForPromoItem.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.handleScrollAndResize);
    __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.handleScrollAndResize);
  };

  ScrollLoaderForPromoItem.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ScrollLoader' + (this.state.opened === true ? ' opened' : ''), ref: this.ref, __source: {
          fileName: _jsxFileName,
          lineNumber: 1053
        }
      },
      this.state.opened === true ? this.props.children : null
    );
  };

  //


  return ScrollLoaderForPromoItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollLoaderForPromoItem.displayName = 'ScrollLoaderForPromoItem';

// ModalItem内のスクロールローダー
var ScrollLoaderForModalItem = function (_Component6) {
  _inherits(ScrollLoaderForModalItem, _Component6);

  function ScrollLoaderForModalItem(props) {
    _classCallCheck(this, ScrollLoaderForModalItem);

    var _this11 = _possibleConstructorReturn(this, _Component6.call(this, props));

    _this11.handleScrollAndResize = function () {
      if (_this11.state.opened) return;
      var element = _this11.ref.current;
      if (element) {
        var scrollTop = _this11.props.scrollTop;
        var top = element.offsetTop;
        var windowHeight = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].innerHeight;
        if (top <= scrollTop + windowHeight) {
          if (_this11.state.opened === false) {
            _this11.setState({
              opened: true
            });
            if (_this11.intervalId) clearInterval(_this11.intervalId);
          }
        }
      }
    };

    _this11.state = {
      opened: false
    };
    _this11.intervalId = null;
    _this11.ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this11;
  }

  ScrollLoaderForModalItem.prototype.componentDidMount = function componentDidMount() {
    var _this12 = this;

    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true
      });
    } else {
      this.intervalId = setInterval(function () {
        _this12.handleScrollAndResize();
      }, 200);
    }
  };

  ScrollLoaderForModalItem.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  };

  ScrollLoaderForModalItem.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ScrollLoader' + (this.state.opened === true ? ' opened' : ''), ref: this.ref, __source: {
          fileName: _jsxFileName,
          lineNumber: 1128
        }
      },
      this.state.opened === true ? this.props.children : null
    );
  };

  return ScrollLoaderForModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollLoaderForModalItem.displayName = 'ScrollLoaderForModalItem';

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FeatureCategorySlider */
/* unused harmony export FeatureCategoryContainerHorizontal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureCategoryContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promo_and_button_modal_window__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__video__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\feature-category-container\\index.jsx',
    _class,
    _temp,
    _class2,
    _temp2,
    _class3,
    _temp3,
    _class4,
    _temp4,
    _class5,
    _temp5;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---

// import ReactSlick from './react-slick';
// ---

// ---

// ---









// --------------------------------------------------
var FeatureCategorySlider = function FeatureCategorySlider(_ref) {
  var settings = _ref.settings,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
    _extends({}, settings, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22
      }
    }),
    children
  );
};

FeatureCategorySlider.displayName = 'FeatureCategorySlider';
FeatureCategorySlider.propTypes = {
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["d" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["a" /* DetectCompact */])())(FeatureCategorySlider);

// --------------------------------------------------
/**
 * slick 使用しない component
 * @param {*} props Resct.props
 * @returns {any[]} `ReactElement` - {@link Promo} /  {@link Video} /  {@link Html} /  {@link Wysiwyg}
 * @constructor
 */
var FeatureCategoryContainerItemWrap = function FeatureCategoryContainerItemWrap(props) {
  return props.components.map(function (component, index) {
    var componentProps = Object.assign({}, component.props);
    // console.log('FeatureCategoryContainerItemWrap', index, component.name, props);
    // getRef だと height 取れないので `ref` に変えて取得する
    switch (component.name) {
      case 'Promo':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__promo__["a" /* default */], _extends({
            uniqueId: 'promo-' + props.mode + '-' + props.filterId + '-' + index
          }, componentProps, {
            ref: function ref(element) {
              return Array.isArray(props.childRefs) ? props.childRefs.push(element) : null;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          }));
        }
      case 'PromoAndButtonModalWindow':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__promo_and_button_modal_window__["a" /* default */], _extends({
            uniqueId: 'promo-' + props.mode + '-' + props.filterId + '-' + index
          }, componentProps, {
            ref: function ref(element) {
              return Array.isArray(props.childRefs) ? props.childRefs.push(element) : null;
            },
            parentColumn: 'featureCategoryContainer',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 55
            }
          }));
        }
      case 'Video':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__video__["a" /* default */], _extends({
            uniqueId: 'promo-' + props.mode + '-' + props.filterId + '-' + index
          }, componentProps, {
            ref: function ref(element) {
              return Array.isArray(props.childRefs) ? props.childRefs.push(element) : null;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          }));
        }
      case 'Html':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__html__["a" /* default */], _extends({
            uniqueId: 'promo-' + props.mode + '-' + props.filterId + '-' + index
          }, componentProps, {
            ref: function ref(element) {
              return Array.isArray(props.childRefs) ? props.childRefs.push(element) : null;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          }));
        }
      case 'Wysiwyg':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__wysiwyg__["a" /* default */], _extends({
            uniqueId: 'promo-' + props.mode + '-' + props.filterId + '-' + index
          }, componentProps, {
            ref: function ref(element) {
              return Array.isArray(props.childRefs) ? props.childRefs.push(element) : null;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          }));
        }
      default:
        {
          return null;
        }
    }
  }).filter(function (component) {
    return component !== null;
  }).map(function (component) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { key: component.props.uniqueId, className: 'FeatureCategoryContainer__content__item', __source: {
          fileName: _jsxFileName,
          lineNumber: 90
        }
      },
      component
    );
  });
};

FeatureCategoryContainerItemWrap.propTypes = {
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};
// --------------------------------------------------
// `div.FeatureCategoryContainer__content__item` 毎 component にしないと react-slick がそれぞれ子供と認識してしまう

// getRef だと height 取れないので `ref` に変えて取得する
var ItemPromo = function ItemPromo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      // key={`item-${props.uniqueId}`}
      className: 'FeatureCategoryContainer__content__item',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__promo__["a" /* default */], _extends({}, props, {
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref: function ref(component) {
        return props.childRefs.push(component);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110
      }
    }))
  );
};

ItemPromo.displayName = 'ItemPromo';
var ItemPromoAndButtonModalWindow = function ItemPromoAndButtonModalWindow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      // key={`item-${props.uniqueId}`}
      className: 'FeatureCategoryContainer__content__item',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__promo_and_button_modal_window__["a" /* default */], _extends({}, props, {
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref: function ref(component) {
        return props.childRefs.push(component);
      },
      parentColumn: 'featureCategoryContainer',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123
      }
    }))
  );
};

ItemPromoAndButtonModalWindow.displayName = 'ItemPromoAndButtonModalWindow';
var ItemVideo = function ItemVideo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      // key={`item-${props.uniqueId}`}
      className: 'FeatureCategoryContainer__content__item',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__video__["a" /* default */], _extends({}, props, {
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref: function ref(component) {
        return props.childRefs.push(component);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 137
      }
    }))
  );
};

ItemVideo.displayName = 'ItemVideo';
var ItemHtml = function ItemHtml(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      // key={`item-${props.uniqueId}`}
      className: 'FeatureCategoryContainer__content__item',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__html__["a" /* default */], _extends({}, props, {
      ref: function ref(component) {
        return props.childRefs.push(component);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153
      }
    }))
  );
};

ItemHtml.displayName = 'ItemHtml';
var ItemWysiwyg = function ItemWysiwyg(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      // key={`item-${props.uniqueId}`}
      className: 'FeatureCategoryContainer__content__item',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 161
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__wysiwyg__["a" /* default */], _extends({}, props, {
      ref: function ref(component) {
        return props.childRefs.push(component);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168
      }
    }))
  );
};
ItemWysiwyg.displayName = 'ItemWysiwyg';
// // --------------------------------------------------
// /**
//  * filter title component
//  * @param {string} title title `|` `<br`> 変換
//  * @param {string} filterId title filter Id
//  * @param {boolean} hasSecond 第二階層存在 flag
//  * @param {string} titleClickCaller click callback receiver
//  * @param {boolean} sameFilterId selected flag
//  * @returns {React.Element} `div.FeatureCategoryContainer__title`
//  * @constructor
//  */
// const FeatureCategoryContainerTitle = ({ title, filterId, hasSecond, titleClickCaller, sameFilterId }) => {
//   if (!title) {
//     return null;
//   }
//   // ---
//   const selectedClass = sameFilterId ? 'FeatureCategoryContainer__title__selected': '';
//   const hasSecondClass = hasSecond ? 'FeatureCategoryContainer__title__has_child': '';
//   // console.log('FeatureCategoryContainerTitle', title, filterId, currentFilterId, selectedClass, sameFilterId);
//   return (
//     <div
//       className={`FeatureCategoryContainer__title ${selectedClass} ${hasSecondClass}`}
//       data-id={filterId}
//       role="presentation"
//       dangerouslySetInnerHTML={{__html: convertPipeToBrTag(title)}}
//       onClick={(event) => {
//         event.preventDefault();
//         if (typeof titleClickCaller === 'function') {
//           titleClickCaller.call(this, filterId, title);
//         }
//       }}
//     />
//   );
// };
//
// FeatureCategoryContainerTitle.propTypes = {
//   title: PropTypes.string,
//   titleClickCaller: PropTypes.func,
//   filterId: PropTypes.string.isRequired,
//   hasSecond: PropTypes.bool.isRequired,
//   sameFilterId: PropTypes.bool.isRequired,
// };
//
// FeatureCategoryContainerTitle.defaultProps = {
//   title: null,
//   titleClickCaller: null,
// };

var FeatureCategoryContainerTitle = (_temp = _class = function (_Component) {
  _inherits(FeatureCategoryContainerTitle, _Component);

  function FeatureCategoryContainerTitle(props) {
    _classCallCheck(this, FeatureCategoryContainerTitle);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.refContainer = null;
    return _this;
  }

  FeatureCategoryContainerTitle.prototype.getTitleClientRect = function getTitleClientRect() {
    return this.refContainer ? this.refContainer.getBoundingClientRect() : null;
  };

  FeatureCategoryContainerTitle.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        title = _props.title,
        filterId = _props.filterId,
        hasSecond = _props.hasSecond,
        titleClickCaller = _props.titleClickCaller,
        sameFilterId = _props.sameFilterId;

    if (!title) {
      return null;
    }
    // ---
    var selectedClass = sameFilterId ? 'FeatureCategoryContainer__title__selected' : '';
    var hasSecondClass = hasSecond ? 'FeatureCategoryContainer__title__has_child' : '';
    // console.log('FeatureCategoryContainerTitle', title, filterId, sameFilterId, selectedClass, hasSecond, hasSecondClass);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'FeatureCategoryContainer__title ' + selectedClass + ' ' + hasSecondClass,
      'data-id': filterId,
      role: 'presentation',
      dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(title) },
      onClick: function onClick(event) {
        event.preventDefault();
        if (typeof titleClickCaller === 'function') {
          titleClickCaller.call(_this2, filterId, title);
        }
      },
      ref: function ref(component) {
        return _this2.refContainer = component;
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 251
      }
    });
  };

  return FeatureCategoryContainerTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  hasSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  sameFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
}, _class.defaultProps = {
  title: null,
  titleClickCaller: null
}, _temp);
FeatureCategoryContainerTitle.displayName = 'FeatureCategoryContainerTitle';


// --------------------------------------------------
var getComponentsHeight = function getComponentsHeight(components) {
  return components
  // .filter(component => (component && component.getContentsHeight))
  .map(function (component) {
    if (component && component.getContentsHeight) {
      return component.getContentsHeight();
    }
    return 0;
  });
};

// --------------------------------------------------
var FeatureCategoryContainerItemSelect = function FeatureCategoryContainerItemSelect(_ref2) {
  var component = _ref2.component,
      index = _ref2.index,
      mode = _ref2.mode,
      childRefs = _ref2.childRefs,
      filterId = _ref2.filterId;

  var props = Object.assign({}, component.props);
  switch (component.name) {
    case 'Promo':
      {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemPromo, _extends({
          key: 'promo-' + mode + '-' + filterId + '-' + index
        }, props, {
          uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
          childRefs: childRefs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 286
          }
        }));
      }
    case 'PromoAndButtonModalWindow':
      {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemPromoAndButtonModalWindow, _extends({
          key: 'promo-' + mode + '-' + filterId + '-' + index
        }, props, {
          uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
          childRefs: childRefs,
          parentColumn: 'featureCategoryContainer',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 296
          }
        }));
      }
    case 'Video':
      {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemVideo, _extends({
          key: 'promo-' + mode + '-' + filterId + '-' + index
        }, props, {
          uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
          childRefs: childRefs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 307
          }
        }));
      }
    case 'Html':
      {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemHtml, _extends({
          key: 'promo-' + mode + '-' + filterId + '-' + index
        }, props, {
          uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
          childRefs: childRefs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 317
          }
        }));
      }
    case 'Wysiwyg':
      {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemWysiwyg, _extends({
          key: 'promo-' + mode + '-' + filterId + '-' + index
        }, props, {
          uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
          childRefs: childRefs,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 327
          }
        }));
      }
    default:
      {
        return null;
      }
  }
};
// --------------------------------------------------
/**
 * desktop size - layout `Vertical`
 */
var FeatureCategoryContainerVerticalPc = (_temp2 = _class2 = function (_Component2) {
  _inherits(FeatureCategoryContainerVerticalPc, _Component2);

  // --------------------------------------------------
  function FeatureCategoryContainerVerticalPc(props) {
    _classCallCheck(this, FeatureCategoryContainerVerticalPc);

    // ---
    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.state = {
      more: true,
      read: -1
    };
    _this3.didMount = false;
    _this3.onClickMore = _this3.onClickMore.bind(_this3);
    // ---
    /**
     * contents per line
     * @type {number}
     */
    _this3.each = 4;
    /**
     * 各 filter id 毎の current page number を保存します
     * @type {{}}
     */
    _this3.pages = {};
    // ---
    _this3.components = [];
    /**
     * last components inderx
     * @type {number}
     */
    _this3.last = 0;
    /**
     * current line number
     * @type {number}
     */
    _this3.page = 0;
    /**
     * last line number - limit page number
     * @type {number}
     */
    _this3.lastPage = 0;
    /**
     * display line
     * @type {number}
     */
    _this3.line = 0;
    /**
     * components length
     * @type {number}
     */
    _this3.length = 0;
    /**
     * pc / mb flag - true: PC
     * @type {boolean}
     */
    _this3.pc = true;
    _this3.initComponents(props.pcDisplayLine);
    _this3.containerComponents = {};
    _this3.onResize = _this3.onResize.bind(_this3);
    _this3.timer = {
      fitHeight: 0,
      didUpdate: 0
    };
    _this3.opacityZeroClassName = props.opacityZeroClassName;
    _this3.isIE = props.isIE;
    _this3.displayLine = props.pcDisplayLine;
    _this3.intervalId = null;
    return _this3;
  }
  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.onResize = function onResize() {
    this.delayGetAndSetMaxHeight();
  };
  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.onClickMore = function onClickMore(event) {
    event.preventDefault();
    this.next();
  };

  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.next = function next() {
    var needMore = this.checkNeedMore();
    // console.log('FeatureCategoryContainerVerticalPc.next', needMore);
    if (needMore) {
      // ---
      this.page += 1;
      this.pages[this.props.filterId] = this.page;
      this.setState({ read: this.page, more: needMore });
    }
  };

  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.initComponents = function initComponents(line) {
    var filterId = this.props.filterId;
    // ---

    if (typeof this.pages[filterId] === 'undefined') {
      this.pages[filterId] = 1;
      this.page = 1;
    } else {
      this.page = this.pages[filterId];
    }
    // ---
    var components = this.filterComponents();
    var length = components.length;
    this.components = components;
    this.last = length - 1;
    this.length = length;
    this.line = line;
    this.lastPage = Math.ceil(length / (this.each * line));
  };

  FeatureCategoryContainerVerticalPc.prototype.filterComponents = function filterComponents() {
    var components = this.props.components;

    return components.filter(function (component) {
      return component.name === 'Promo' || component.name === 'PromoAndButtonModalWindow' || component.name === 'Video' || component.name === 'Html' || component.name === 'Wysiwyg';
    });
  };

  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.checkNeedMore = function checkNeedMore() {
    return this.page < this.lastPage;
  };

  FeatureCategoryContainerVerticalPc.prototype.shouldUpdateMore = function shouldUpdateMore() {
    var state = null;
    var need = this.checkNeedMore();
    if (this.state.more !== need) {
      state = {
        more: need
      };
    }
    if (state) {
      this.setState(state);
    }
  };

  FeatureCategoryContainerVerticalPc.prototype.limitByPage = function limitByPage(page) {
    // current page - has more
    // console.log('FeatureCategoryContainerVerticalPc.limitByPage', this.pc, page, this.line, this.each, this.last);
    // return Math.min(page * this.line * this.each, this.length);
    return this.length;
  };

  FeatureCategoryContainerVerticalPc.prototype.nextLimit = function nextLimit(page) {
    return this.limitByPage(page);
  };

  FeatureCategoryContainerVerticalPc.prototype.resetView = function resetView() {
    // console.log('FeatureCategoryContainerVerticalPc.resetView', this.props);
    var _props2 = this.props,
        pcDisplayLine = _props2.pcDisplayLine,
        mbDisplayLine = _props2.mbDisplayLine;

    var line = this.pc ? pcDisplayLine : mbDisplayLine;
    this.initComponents(line);
    this.setState({ read: this.page, more: this.checkNeedMore() });
  };
  // --------------------------------------------------
  /**
   * 子供の高さを揃えるために高さを取得し max height を設定する
   * @param {array[*]} list component list - 行ごと
   */


  FeatureCategoryContainerVerticalPc.prototype.getAndSetMaxHeight = function getAndSetMaxHeight(list) {
    var results = getComponentsHeight(list);
    results.sort(function (a, b) {
      return b - a;
    });
    var maxHeight = results[0];
    list.filter(function (component) {
      return component && component.setContainerHeight;
    }).map(function (component) {
      return component.setContainerHeight(maxHeight);
    });
  };
  /**
   * 行ごと（1行表示個数毎）に component list を分割します
   */


  FeatureCategoryContainerVerticalPc.prototype.splitEachLine = function splitEachLine() {
    var _props3 = this.props,
        filterId = _props3.filterId,
        components = _props3.components;

    var containerItems = this.containerComponents[filterId].pc;
    var last = containerItems.length - 1;
    var eachTime = this.each;
    var divide = -1;
    // @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    return containerItems.reduce(function (result, value, index, array) {
      if ((index + 1) % eachTime === 0) {
        var sliced = array.slice(divide + 1, divide + 1 + eachTime);
        result.push(sliced);
        // console.log('FeatureCategoryContainerVerticalPc.splitEachLine - slice', divide + 1, divide + 1 + eachTime, sliced);
        divide = index;
      } else if (index === last) {
        var _sliced = array.slice(divide + 1, index + eachTime);
        result.push(_sliced);
        // console.log('FeatureCategoryContainerVerticalPc.splitEachLine - slice last', divide + 1, index, last, sliced);
      }
      return result;
    }, []);
  };

  FeatureCategoryContainerVerticalPc.prototype.delayGetAndSetMaxHeight = function delayGetAndSetMaxHeight() {
    var _this4 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 112 * 2;

    var k = 1;
    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(function () {
      var lines = _this4.splitEachLine().slice(0);
      lines.length = _this4.page * _this4.displayLine;
      // console.log('FeatureCategoryContainerVerticalPc.delayGetAndSetMaxHeight', lines, this.page);
      lines.map(function (list) {
        return _this4.getAndSetMaxHeight(list);
      });
    }, delay * k);
  };
  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.splitByDisplayLine = function splitByDisplayLine(containerItems) {
    var _props4 = this.props,
        filterId = _props4.filterId,
        pcDisplayLine = _props4.pcDisplayLine,
        mbDisplayLine = _props4.mbDisplayLine;

    var line = this.pc ? pcDisplayLine : mbDisplayLine;
    var eachTime = this.each * line;
    // @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    return containerItems.reduce(function (result, value, index, array) {
      if (index % eachTime === 0) {
        result.push(array.slice(index, index + eachTime));
      }
      return result;
    }, []);
  };
  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.abortOpacityZero = function abortOpacityZero() {
    // const { abortOpacityZero } = this.props;
    // if (typeof abortOpacityZero === 'function') {
    //   abortOpacityZero.call(this);
    // }
  };

  FeatureCategoryContainerVerticalPc.prototype.delayAbortOpacityZero = function delayAbortOpacityZero() {
    var _this5 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 320;

    this.timer.opacityZero = setTimeout(function () {
      _this5.abortOpacityZero();
    }, delay);
  };
  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    // console.log('FeatureCategoryContainerVerticalPc.componentDidUpdate', this.props.filterId, this.props.currentFilterId, prevProps.currentFilterId, prevProps.currentFilterId !== this.props.currentFilterId);
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      this.resetView();
      // if (this.props.currentFilterId === this.props.filterId) {
      //   // this.delayAbortOpacityZero(1000);
      //   this.delayAbortOpacityZero(500);
      // }
    } else {
      this.shouldUpdateMore();
      if (this.pc) {
        this.delayGetAndSetMaxHeight();
      }
    }
  };

  FeatureCategoryContainerVerticalPc.prototype.componentDidMount = function componentDidMount() {
    var _this6 = this;

    this.didMount = true;
    this.shouldUpdateMore();
    if (this.pc) {
      this.delayGetAndSetMaxHeight();

      // window.addEventListener('resize', this.onResize, false);
      setTimeout(function () {
        window.addEventListener('resize', _this6.onResize, false);
      }, 500);
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(function () {
        _this6.onResize();
      }, 1000);

      // this.delayAbortOpacityZero(1500);
      // this.delayAbortOpacityZero(16);
    }
  };

  FeatureCategoryContainerVerticalPc.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
    window.removeEventListener('resize', this.onResize);
  };
  // --------------------------------------------------
  /**
   * FeatureCategoryContainer.props.components を出力します
   * @param {number} limit length - 使用しない - コード互換のために残す
   * @returns {ReactElement} FeatureCategoryContainer.props.components
   */


  FeatureCategoryContainerVerticalPc.prototype.renderItemsAllWithSegment = function renderItemsAllWithSegment(limit) {
    var _this7 = this;

    var filterId = this.props.filterId;

    var mode = this.pc ? 'pc-vertical' : 'mb-vertical';
    var components = this.components;
    var componentsClone = components.slice(0);
    // crop output components array
    componentsClone.length = limit;
    var outputComponents = this.splitByDisplayLine(componentsClone);
    // ---
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: []
      };
    }
    // ---
    if (this.pc) {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    var childRefs = this.pc ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // console.log('FeatureCategoryContainer.renderItemsAllWithSegment', this.pc, filterId, this.page, limit, childRefs);

    return outputComponents.map(function (list, i) {
      if (i <= _this7.page - 1) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            key: filterId + '-' + i,
            className: 'FeatureCategoryContainer__content__item__wrap ' + (i <= _this7.page - 1 ? 'FeatureCategoryContainer__content__item__wrap__current' : ''),
            'data-segment': '' + i,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 696
            }
          },
          list.map(function (component, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerItemSelect, {
              key: component.name + '-' + mode + '-' + filterId + '-' + index,
              component: component,
              index: index,
              mode: mode,
              childRefs: childRefs,
              filterId: filterId,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 703
              }
            });
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          key: filterId + '-' + i,
          className: 'FeatureCategoryContainer__content__item__wrap',
          'data-segment': '' + i,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 717
          }
        });
      }
    });

    /*
    return (
      outputComponents.map((list, i) => (
        <div
          key={`${filterId}-${i}`}
          className={`FeatureCategoryContainer__content__item__wrap ${i <= (this.page - 1) ? 'FeatureCategoryContainer__content__item__wrap__current' : ''}`}
          data-segment={`${i}`}
        >
          {
            list.map((component, index) => (
              <FeatureCategoryContainerItemSelect
                key={`${component.name}-${mode}-${filterId}-${index}`}
                component={component}
                index={index}
                mode={mode}
                childRefs={childRefs}
                filterId={filterId}
              />
            ))
          }
        </div>
      ))
    );
    */
  };

  /**
   * @deprecated instead use {@link FeatureCategoryContainer.renderItemsAllWithSegment}
   * FeatureCategoryContainer.props.components を出力します
   * @param {string} mode class に付与する識別子
   * @param {number} limit length
   * @returns {ReactElement} FeatureCategoryContainer.props.components
   */


  FeatureCategoryContainerVerticalPc.prototype.renderItemWrap = function renderItemWrap(mode, limit) {
    var filterId = this.props.filterId;

    var components = this.components;
    var componentsClone = components.slice(0);
    // crop output components array
    componentsClone.length = limit;
    // ---
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: []
      };
    }
    // ---
    if (this.pc) {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    var childRefs = this.pc ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // return (
    //   componentsClone.map((component, index) => {
    //       const props = Object.assign({}, component.props);
    //       // console.log('FeatureCategoryContainerItemWrap', index, component.name);
    //       switch(component.name) {
    //         case 'Promo': {
    //           return (
    //             <ItemPromo
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //               childRefs={childRefs}
    //             />
    //           );
    //         }
    //         case 'Video': {
    //           return (
    //             <ItemVideo
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //               childRefs={childRefs}
    //             />
    //           );
    //         }
    //         case 'Html': {
    //           return (
    //             <ItemHtml
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //             />
    //           );
    //         }
    //         case 'Wysiwyg': {
    //           return (
    //             <ItemWysiwyg
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //             />
    //           );
    //         }
    //         default: {
    //           return null;
    //         }
    //       }
    //     })
    //     .filter(component => (component !== null))
    // );
    return componentsClone.map(function (component, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerItemSelect, {
        key: component.name + '-' + mode + '-' + filterId + '-' + index,
        component: component,
        index: index,
        mode: mode,
        childRefs: childRefs,
        filterId: filterId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 834
        }
      });
    });
  };

  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.renderMore = function renderMore() {
    var more = this.state.more;

    if (!more) {
      return null;
    }
    var _props5 = this.props,
        readMoreLabel = _props5.readMoreLabel,
        selectTextColor = _props5.selectTextColor;
    // return (
    //   <button
    //     className={`FeatureCategoryContainer__content__btn__more-${this.pc ? 'pc' : 'mb'}`}
    //     type="button"
    //     onClick={this.onClickMore}
    //   >
    //     {readMoreLabel}
    //   </button>
    // );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FeatureCategoryContainer__content__btn__more-' + (this.pc ? 'pc' : 'mb'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 863
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__cta__["a" /* default */], {
        ctaType: 'Free',
        text: readMoreLabel,
        linkType: 'Button',
        color: selectTextColor,
        buttonStyle: 'Standard',
        handleClick: this.onClickMore,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 866
        }
      })
    );
  };

  FeatureCategoryContainerVerticalPc.prototype.renderItem = function renderItem() {
    var limit = this.nextLimit(this.page);
    // console.log('FeatureCategoryContainerVerticalPc.renderItem', limit, this.state);
    // ---
    // return (
    //   <div className="FeatureCategoryContainer__content__item__wrap">
    //     {
    //       // this.renderItemWrap('pc-vertical', limit)
    //       this.renderItemsAllWithSegment('pc-vertical', limit)
    //     }
    //   </div>
    // );
    return this.renderItemsAllWithSegment(limit);
  };

  // --------------------------------------------------


  FeatureCategoryContainerVerticalPc.prototype.render = function render() {
    var layout = this.props.layout;
    // ---

    if (layout !== 'Vertical') {
      return null;
    }
    // ---
    var components = this.components;
    if (!components.length) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content-' + (this.pc ? 'pc' : 'mb'), __source: {
          fileName: _jsxFileName,
          lineNumber: 908
        }
      },
      this.renderItem(),
      this.renderMore()
    );
  };

  return FeatureCategoryContainerVerticalPc;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // ---
  // extend
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // ---
  readMoreLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectTextColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentContainerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  opacityZeroClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortTransitionClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  slickThumbnailChangedCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  containerId: null,
  containerClass: null,
  title: null,
  components: [],
  // ---
  // extend
  showTitle: false,
  currentFilterId: '',
  filterId: '',
  titleClickCaller: null,
  // ---
  layout: 'Horizontal',
  pcDisplayLine: 4,
  mbDisplayLine: 4,
  // ---
  readMoreLabel: '',
  selectTextColor: '',
  currentContainerIndex: 0,
  opacityZeroClassName: '',
  abortTransitionClassName: '',
  slickThumbnailChangedCallback: null
}, _temp2);
FeatureCategoryContainerVerticalPc.displayName = 'FeatureCategoryContainerVerticalPc';


// --------------------------------------------------
/**
 * mobile - layout `Vertical`
 */
var FeatureCategoryContainerVerticalMb = (_temp3 = _class3 = function (_FeatureCategoryConta) {
  _inherits(FeatureCategoryContainerVerticalMb, _FeatureCategoryConta);

  function FeatureCategoryContainerVerticalMb(props) {
    _classCallCheck(this, FeatureCategoryContainerVerticalMb);

    // ---
    var _this8 = _possibleConstructorReturn(this, _FeatureCategoryConta.call(this, props));

    _this8.each = 1;
    _this8.pages = {};
    // console.log('FeatureCategoryContainerVerticalMb', props.mbDisplayLine);
    _this8.pc = false;
    _this8.initComponents(props.mbDisplayLine);
    _this8.onClickMore = _this8.onClickMore.bind(_this8);
    _this8.displayLine = props.mbDisplayLine;
    return _this8;
  }

  // --------------------------------------------------
  // renderMore() {
  //   const {more} = this.state;
  //   if (!more) {
  //     return null;
  //   }
  //   const {readMoreLabel} = this.props;
  //   return (
  //     <button
  //       className="FeatureCategoryContainer__content__btn__more-mb"
  //       type="button"
  //       onClick={this.onClickMore}
  //     >
  //       {readMoreLabel}
  //       </button>
  //   );
  // }
  // renderItem() {
  //   const limit = this.nextLimit(this.page);
  //   return this.renderItemsAllWithSegment('mb-vertical', limit);
  // }
  // --------------------------------------------------
  // render() {
  //   const {
  //     layout,
  //   } = this.props;
  //   // ---
  //   if (layout !== 'Vertical') {
  //     return null;
  //   }
  //   // ---
  //   const components = this.components;
  //   if (!components.length) {
  //     return null;
  //   }
  //   return (
  //     <div className="FeatureCategoryContainer__content-mb">
  //       {this.renderItem()}
  //       {this.renderMore()}
  //     </div>
  //   );
  // }


  return FeatureCategoryContainerVerticalMb;
}(FeatureCategoryContainerVerticalPc), _class3.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // ---
  // extend
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // ---
  readMoreLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectTextColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentContainerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  opacityZeroClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortTransitionClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  slickThumbnailChangedCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class3.defaultProps = {
  containerId: null,
  containerClass: null,
  title: null,
  components: [],
  // ---
  // extend
  showTitle: false,
  currentFilterId: '',
  filterId: '',
  titleClickCaller: null,
  // ---
  layout: 'Horizontal',
  pcDisplayLine: 4,
  mbDisplayLine: 4,
  // ---
  readMoreLabel: '',
  selectTextColor: '',
  currentContainerIndex: 0,
  opacityZeroClassName: '',
  abortTransitionClassName: '',
  slickThumbnailChangedCallback: null
}, _temp3);

// --------------------------------------------------
/**
 * Horizontal - slick or not slick (desktop / mobile)
 */

var FeatureCategoryContainerHorizontal = (_temp4 = _class4 = function (_Component3) {
  _inherits(FeatureCategoryContainerHorizontal, _Component3);

  function FeatureCategoryContainerHorizontal(props) {
    _classCallCheck(this, FeatureCategoryContainerHorizontal);

    // ---
    var _this9 = _possibleConstructorReturn(this, _Component3.call(this, props));

    var pcEachTime = 4;
    var mbEachTime = 1;
    _this9.components = props.components;
    var componentsLength = _this9.components.length;
    _this9.slider = {
      pc: null,
      mb: null,
      page: {
        index: {
          pc: 0,
          mb: 0
        },
        last: {
          pc: 0,
          mb: 0
        }
      },
      eachTime: {
        pc: pcEachTime,
        mb: mbEachTime
      },
      length: componentsLength,
      // length: 0,
      index: {
        pc: 0,
        mb: 0
      }
    };
    _this9.transitionClasses = {
      click: 'FeatureCategoryContainer__content__btn__clicked',
      blink: 'FeatureCategoryContainer__content__btn__blink',
      slickTrackTransition: 'FeatureCategoryContainer__no__slick__transition'
    };
    _this9.state = {
      pcIndex: 0,
      mbIndex: 0,
      length: componentsLength,
      didMount: false,
      didMpUpdate: false,
      resizeByMaxHeight: false,
      heightFromMaxHeight: 0,
      arrowPrevClass: '',
      arrowNextClass: '',
      slickTrackTransition: _this9.transitionClasses.slickTrackTransition
    };
    // ---
    /**
     * mb - thumbnail swipe 計算に使用します
     * @type {{start: Vectors, end: Vectors}}
     */
    _this9.vectors = {
      start: new __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* Vectors */](),
      end: new __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* Vectors */]()
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    _this9.swipeThreshold = 5;
    _this9.onPcPrev = _this9.onPcPrev.bind(_this9);
    _this9.onPcNext = _this9.onPcNext.bind(_this9);
    _this9.onClickPager = _this9.onClickPager.bind(_this9);
    _this9.onTouchStart = _this9.onTouchStart.bind(_this9);
    _this9.onTouchEnd = _this9.onTouchEnd.bind(_this9);
    _this9.onTouchCancel = _this9.onTouchCancel.bind(_this9);
    _this9.onMbPrev = _this9.onMbPrev.bind(_this9);
    _this9.onMbNext = _this9.onMbNext.bind(_this9);
    /**
     * slick transition `none` class name
     * - filter 切替時の slick 初期化時に ON します
     * @type {string}
     */
    _this9.trackIgnore = props.abortTransitionClassName;
    /**
     * timer id list
     * @type {{fitHeight: number, thumbnailPc: number, thumbnailMb: number}}
     */
    _this9.timer = {
      fitHeight: 0,
      thumbnailPc: 0,
      thumbnailMb: 0,
      didMount: 0,
      resetSlider: 0,
      didUpdate: 0,
      arrow: 0,
      opacityZero: 0,
      slickTrackDuration: 0
    };
    _this9.containerComponents = {};
    _this9.onResize = _this9.onResize.bind(_this9);
    // ---
    _this9.onPcThumbnailBeforeChange = _this9.onPcThumbnailBeforeChange.bind(_this9);
    _this9.onPcThumbnailAfterChange = _this9.onPcThumbnailAfterChange.bind(_this9);
    _this9.onMbThumbnailBeforeChange = _this9.onMbThumbnailBeforeChange.bind(_this9);
    _this9.onMbThumbnailAfterChange = _this9.onMbThumbnailAfterChange.bind(_this9);
    _this9.slickIndex = {
      pc: 0,
      mb: 0
    };
    _this9.syncCount = {
      pc: 0,
      mb: 0
    };
    // ---
    _this9.contents = {
      pc: null,
      mb: null
    };
    // ---
    _this9.currentFilterId = props.currentFilterId;
    // ---
    _this9.opacityZeroClassName = props.opacityZeroClassName;
    // ---
    _this9.initSliderProps();
    _this9.intervalId = null;
    return _this9;
  }
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.initSliderProps = function initSliderProps() {
    // console.log('FeatureCategoryContainer.initSliderProps', this.props.filterId, this.props.currentFilterId);
    var components = this.props.components;

    this.components = components;
    var componentsLength = this.components.length;
    var pcEachTime = this.slider.eachTime.pc;
    var mbEachTime = this.slider.eachTime.mb;
    this.slider.page.index = {
      pc: 0,
      mb: 0
    };
    this.slider.index = {
      pc: 0,
      mb: 0
    };
    this.slider.page.last = {
      pc: Math.ceil(componentsLength / pcEachTime) - 1,
      mb: Math.ceil(componentsLength / mbEachTime) - 1
    };
    this.slider.length = componentsLength;
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.onResize = function onResize() {
    this.delayGetAndSetMaxHeight();
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.onPcThumbnailBeforeChange = function onPcThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.pc = nextSlideIndex;
  };

  FeatureCategoryContainerHorizontal.prototype.onPcThumbnailAfterChange = function onPcThumbnailAfterChange(currentSlideIndex) {
    this.slickIndex.pc = currentSlideIndex;
    // const { slickThumbnailChangedCallback } = this.props;
    // if (typeof slickThumbnailChangedCallback === 'function') {
    //   slickThumbnailChangedCallback.call(this);
    // }
    this.slickAfterChange();
  };

  FeatureCategoryContainerHorizontal.prototype.onMbThumbnailBeforeChange = function onMbThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.mb = nextSlideIndex;
  };

  FeatureCategoryContainerHorizontal.prototype.onMbThumbnailAfterChange = function onMbThumbnailAfterChange(currentSlideIndex) {
    this.slickIndex.mb = currentSlideIndex;
    // const {slickThumbnailChangedCallback} = this.props;
    // if (typeof slickThumbnailChangedCallback === 'function') {
    //   slickThumbnailChangedCallback.call(this);
    // }
    this.slickAfterChange();
  };

  /**
   * slick after change で callback 起動する
   */


  FeatureCategoryContainerHorizontal.prototype.slickAfterChange = function slickAfterChange() {
    // console.log('FeatureCategoriesContainer.slickAfterChange', this.props.filterId, this.slickIndex);
    if (this.props.currentFilterId === this.props.filterId) {
      this.abortOpacityZero();
    }
    this.abortSlickTransitionZero();
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.onClickPager = function onClickPager(event) {
    // console.log('FeatureCategoriesContainer.onClickPager - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    event.preventDefault();
    var target = event.target.nodeName.toLowerCase() === 'span' ? event.target.parentNode : event.target;
    var pcIndex = parseInt(target.dataset.page, 10);
    if (this.state.pcIndex !== pcIndex) {
      this.setState({ pcIndex: pcIndex });
      this.slider.page.index.pc = pcIndex;
      var pcExpectIndex = pcIndex * this.slider.eachTime.pc;
      if (pcIndex !== this.slider.page.last.pc) {
        this.pcGoto(pcExpectIndex);
      } else {
        this.pcLastWithDead(pcIndex);
      }
    }
  };

  FeatureCategoryContainerHorizontal.prototype.onPcPrev = function onPcPrev(event) {
    var _this10 = this;

    event.preventDefault();
    // prev / next click - arrow animation を止める
    if (this.state.arrowPrevClass || this.state.arrowNextClass) {
      this.delayClearArrowClass(0);
    }
    // this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    // console.log('FeatureCategoriesContainer.onPcPrev - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    // this.pcPrev();
    setTimeout(function () {
      _this10.pcPrev();
    }, 1);
  };

  FeatureCategoryContainerHorizontal.prototype.onPcNext = function onPcNext(event) {
    var _this11 = this;

    event.preventDefault();
    // prev / next click - arrow animation を止める
    if (this.state.arrowPrevClass || this.state.arrowNextClass) {
      this.delayClearArrowClass(0);
    }
    // this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    // console.log('FeatureCategoriesContainer.onPcNext - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    setTimeout(function () {
      _this11.pcNext();
    }, 1);
  };

  FeatureCategoryContainerHorizontal.prototype.pcPrev = function pcPrev() {
    var noMbMove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var pc = this.slider.pc;

    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.click, arrowNextClass: this.transitionClasses.blink });
      this.delayClearArrowClass();
      // pc.slickPrev();
      var page = this.slider.page.index.pc - 1;
      // console.log('FeatureCategoryContainerHorizontal.pcPrev', page, this.slider.page.last.pc);
      if (page < 0) {
        this.pcFirstToLast(noMbMove);
        return;
      } else if (page === 0) {
        this.pcFirstWithDead(page, noMbMove);
        return;
      }
      // normal
      this.slider.page.index.pc = page;
      var pcEachTime = this.slider.eachTime.pc;
      var pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  };

  /**
   * PC - slick prev, page: 0 移動
   * @param {number} page page number
   * @param {boolean} noMbMove - mb move flag
   */


  FeatureCategoryContainerHorizontal.prototype.pcFirstWithDead = function pcFirstWithDead(page, noMbMove) {
    var pc = this.slider.pc;

    if (pc) {
      this.slider.page.index.pc = page;
      var pcEachTime = this.slider.eachTime.pc;
      var pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  };
  /**
   * PC - slick prev, page last to first move
   * @param {boolean} noMbMove - mb move flag
   */


  FeatureCategoryContainerHorizontal.prototype.pcFirstToLast = function pcFirstToLast(noMbMove) {
    var pc = this.slider.pc;

    if (pc) {
      var pcLast = this.slider.page.last.pc;
      this.slider.page.index.pc = pcLast;
      var pcEachTime = this.slider.eachTime.pc;
      var pcExpectIndex = -pcEachTime;
      // console.log('FeatureCategoryContainerHorizontal.pcFirstToLast', pcExpectIndex, pcLast, rest, length, pcLast * pcEachTime);
      pc.slickGoTo(pcExpectIndex);
      if (!noMbMove) {
        this.mbMoveByPc(pcLast * pcEachTime);
      }
      this.pcChangeState(pcLast);
    }
  };

  FeatureCategoryContainerHorizontal.prototype.pcNext = function pcNext() {
    var noMbMove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var pc = this.slider.pc;

    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.blink, arrowNextClass: this.transitionClasses.click });
      this.delayClearArrowClass();
      var page = this.slider.page.index.pc + 1;
      // console.log('FeatureCategoryContainerHorizontal.pcNext --- continue', page, this.slider.page.last.pc);
      if (page === this.slider.page.last.pc) {
        this.pcLastWithDead(page, noMbMove, 1);
        return;
      } else if (page > this.slider.page.last.pc) {
        this.pcLastToFirst(noMbMove);
        return;
      }
      // normal
      this.slider.page.index.pc = page;
      var pcEachTime = this.slider.eachTime.pc;
      var pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  };

  /**
   * pc next - 最終ページで最終アイテムを右端になるように移動します
   * @param {number} page page number
   * @param {boolean} noMbMove - mb move flag
   * @param {number} [direction=1] 方向
   */


  FeatureCategoryContainerHorizontal.prototype.pcLastWithDead = function pcLastWithDead(page, noMbMove) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var pc = this.slider.pc;

    if (pc) {
      var pcEachTime = this.slider.eachTime.pc;
      var total = pcEachTime * (page + 1);
      var pcExpectIndex = page * pcEachTime;
      var rest = this.slider.length - pcExpectIndex;
      var added = total - (pcExpectIndex + rest);
      var moveTo = (pcExpectIndex - added) * direction;
      // console.log('FeatureCategoryContainerHorizontal.pcLastWithDead ||||||', moveTo, pcExpectIndex, page, total, rest, added);
      this.slider.page.index.pc = page;
      this.pcGoto(moveTo);
      this.pcChangeState(page);
    }
  };

  FeatureCategoryContainerHorizontal.prototype.pcLastToFirst = function pcLastToFirst(noMbMove) {
    var pc = this.slider.pc;

    if (pc) {
      this.slider.page.index.pc = 0;
      // console.log('FeatureCategoryContainerHorizontal.pcLastToFirst', this.slider.length, 0);
      // pc.slickGoTo(this.slider.length + 1);

      // 不具合対応
      // https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-2050
      if (this.slider.length % 4 === 0) {
        pc.slickGoTo(this.slider.length);
      } else {
        pc.slickGoTo(this.slider.length + 1);
      }

      this.slider.index.pc = 0;
      if (!noMbMove) {
        this.mbMoveByPc(0);
      }
      this.pcChangeState(0);
    }
  };

  FeatureCategoryContainerHorizontal.prototype.pcGoto = function pcGoto(index, noMbMove) {
    this.clearTimerResetSlider();
    // ---
    var pc = this.slider.pc;

    if (pc) {
      pc.slickGoTo(index);
      if (!noMbMove) {
        this.mbMoveByPc(index);
      }
      this.slider.index.pc = index;
      this.slider.index.mb = index;
    }
  };

  FeatureCategoryContainerHorizontal.prototype.pcMoveByMb = function pcMoveByMb() {
    var _slider$page$index = this.slider.page.index,
        pc = _slider$page$index.pc,
        mb = _slider$page$index.mb;

    var pcEachTime = this.slider.eachTime.pc;
    var pcExpectPage = Math.floor(mb / pcEachTime);
    // console.log('FeatureCategoryContainerHorizontal.pcMoveByMb', pcExpectPage, pc);
    if (pcExpectPage > pc) {
      this.pcNext(true);
    } else if (pcExpectPage < pc) {
      this.pcPrev(true);
    }
    this.pcChangeState(pcExpectPage);
  };

  FeatureCategoryContainerHorizontal.prototype.pcChangeState = function pcChangeState(page) {
    // console.log('FeatureCategoryContainerHorizontal.pcChangeState', page, this.state.pcIndex);
    if (this.state.pcIndex !== page) {
      this.setState({ pcIndex: page });
    }
  };

  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.onTouchStart = function onTouchStart(event) {
    this.clearTimerResetSlider();
    this.abortOpacityZero();
    // ---
    this.resetTouchMoveVectors();
    // console.log('FeatureCategoryContainerHorizontal.onTouchStart ======', event);
    this.vectors.start.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* eventWithPoint */])(event));
  };

  FeatureCategoryContainerHorizontal.prototype.onTouchEnd = function onTouchEnd(event) {
    // this.clearTimerResetSlider();
    // ---
    this.vectors.end.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* eventWithPoint */])(event));
    var distanceX = this.vectors.end.distanceX(this.vectors.start);
    // swipe
    if (Math.abs(distanceX) >= this.swipeThreshold) {
      if (distanceX < 0) {
        // left
        this.mbNext();
      } else {
        // right
        this.mbPrev();
      }
    }
    this.resetTouchMoveVectors();
  };

  FeatureCategoryContainerHorizontal.prototype.onTouchCancel = function onTouchCancel() {
    this.resetTouchMoveVectors();
  };

  /**
   * touch move value を初期化します
   */


  FeatureCategoryContainerHorizontal.prototype.resetTouchMoveVectors = function resetTouchMoveVectors() {
    var _vectors = this.vectors,
        start = _vectors.start,
        end = _vectors.end;

    start.reset();
    end.reset();
  };
  // ---


  FeatureCategoryContainerHorizontal.prototype.onMbPrev = function onMbPrev() {
    this.mbPrev();
  };

  FeatureCategoryContainerHorizontal.prototype.onMbNext = function onMbNext() {
    this.mbNext();
  };

  FeatureCategoryContainerHorizontal.prototype.mbPrev = function mbPrev() {
    this.clearTimerResetSlider();
    // ---
    var mb = this.slider.mb;

    if (mb) {
      var page = this.slider.page.index.mb - 1;
      if (page < 0) {
        page = this.slider.page.last.mb;
      }
      // console.log('FeatureCategoryContainerHorizontal.mbPrev ---', mb);
      mb.slickPrev();
      this.slider.page.index.mb = page;
      this.pcMoveByMb();
    }
  };

  FeatureCategoryContainerHorizontal.prototype.mbNext = function mbNext() {
    this.clearTimerResetSlider();
    // ---
    var mb = this.slider.mb;
    // console.log('FeatureCategoryContainerHorizontal.mbNext +++', mb);

    if (mb) {
      // setTimeout(() => {
      //   mb.slickNext();
      // }, 0);
      mb.slickNext();
      var page = this.slider.page.index.mb + 1;
      if (page > this.slider.page.last.mb) {
        page = 0;
      }
      this.slider.page.index.mb = page;
      this.pcMoveByMb();
    }
  };

  FeatureCategoryContainerHorizontal.prototype.mbGoTo = function mbGoTo(index) {
    this.clearTimerResetSlider();
    // ---
    var mb = this.slider.mb;

    var page = this.slider.page.index.mb;
    if (mb && page !== index) {
      setTimeout(function () {
        mb.slickGoTo(index);
      }, 0);
      this.slider.page.index.mb = index;
    }
  };

  FeatureCategoryContainerHorizontal.prototype.mbMoveByPc = function mbMoveByPc(index) {
    var mb = this.slider.mb;

    if (mb) {
      setTimeout(function () {
        mb.slickGoTo(index);
      }, 0);
      this.slider.page.index.mb = index;
    }
  };
  // --------------------------------------------------
  // syncPcThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailPc);
  //   const slider = this.slider.pc;
  //   if (this.syncCount.pc > 50 || !slider || this.slider.index.pc === this.slickIndex.pc) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.pc = this.slider.index.pc;
  //     return;
  //   }
  //   this.syncCount.pc += 1;
  //   this.timer.thumbnailPc = setTimeout(() => {
  //     this.pcGoto(0);
  //     // console.log('PickerContainer.syncPcThumbnailIndex *** timeOut', this.props.filterId, this.syncCount.pc, this.slider.index.pc, this.slickIndex.pc, Date.now());
  //     this.syncPcThumbnailIndex();
  //   }, 16);
  // }
  // syncMbThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailMb);
  //   const slider = this.slider.mb;
  //   if (this.syncCount.mb > 50 || !slider || this.slider.index.mb === this.slickIndex.mb) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.mb = this.slider.index.mb;
  //     return;
  //   }
  //   this.syncCount.mb += 1;
  //   this.timer.thumbnailMb = setTimeout(() => {
  //     this.mbGoTo(0);
  //     // console.log('PickerContainer.syncMbThumbnailIndex ::: timeOut', this.props.filterId, this.syncCount.mb, this.slider.index.mb, this.slickIndex.mb, Date.now());
  //     this.syncMbThumbnailIndex();
  //   }, 16);
  // }
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.resetSlider = function resetSlider(pc) {
    var slider = pc ? this.slider.pc : this.slider.mb;
    if (slider) {
      slider.slickGoTo(0);
    }
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.abortOpacityZero = function abortOpacityZero() {
    // console.log('FeatureCategoryContainer.abortOpacityZero --------------- remove', this.props.filterId, Date.now());
    // const { abortOpacityZero } = this.props;
    // if (typeof abortOpacityZero === 'function') {
    //   abortOpacityZero.call(this);
    // }
  };

  FeatureCategoryContainerHorizontal.prototype.delayAbortOpacityZeroWithTransitionZero = function delayAbortOpacityZeroWithTransitionZero() {
    var _this12 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 320;

    this.timer.opacityZero = setTimeout(function () {
      _this12.abortOpacityZero();
      _this12.abortSlickTransitionZero();
    }, delay);
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.abortSlickTransitionZero = function abortSlickTransitionZero() {
    var slickThumbnailChangedCallback = this.props.slickThumbnailChangedCallback;

    if (typeof slickThumbnailChangedCallback === 'function') {
      slickThumbnailChangedCallback.call(this);
    }
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.clearTimerResetSlider = function clearTimerResetSlider() {
    // console.log('FeatureCategoriesContainer.clearTimerResetSlider - noCountUpdate', noCountUpdate, this.timer.resetSlider);
    clearTimeout(this.timer.resetSlider);
  };
  // likeDestroySliders() {
  //   const index = this.slider.length;
  //   // console.log('FeatureCategoriesContainer.likeDestroySliders - index', index);
  //   const { pc, mb } = this.slider;
  //   if (mb) {
  //     mb.slickGoTo(index);
  //     this.slickIndex.mb = index;
  //   }
  //   if (pc) {
  //     mb.slickGoTo(index);
  //     this.slickIndex.pc = index;
  //   }
  // }

  /**
   * `react-slick` が
   */


  FeatureCategoryContainerHorizontal.prototype.resetSlidersAfterDelay = function resetSlidersAfterDelay() {
    // console.log('FeatureCategoriesContainer.resetSlidersAfterDelay', this.props.filterId, this.props.currentFilterId, this.slider.length, this.slider.index);
    this.clearTimerResetSlider();
    // ---
    // pc
    this.resetSlider(true);
    // false
    this.resetSlider(false);
    this.slider.index.pc = 0;
    this.slider.index.mb = 0;
    if (this.state.length !== this.components.length || this.state.pcIndex !== 0 || this.state.mbIndex !== 0) {
      this.setState({ length: this.components.length, pcIndex: 0, mbIndex: 0 });
    }
  };
  // // --------------------------------------------------
  // slickTrackDurationZero(duration) {
  //   if (this.state.slickTrackTransition === this.transitionClasses.slickTrackTransition) {
  //     return;
  //   }
  //   this.setState({ slickTrackTransition: this.transitionClasses.slickTrackTransition });
  //   clearTimeout(this.timer.slickTrackDuration);
  //   this.timer.slickTrackDuration = setTimeout(() => {
  //     this.setState({ slickTrackTransition: '' });
  //   }, duration);
  // }
  // --------------------------------------------------
  /**
   * index: 0, に強制的に戻す - `componentDidUpdate` 後とか...
   * - componentDidUpdate 後直ぐ slick の準備ができず, `slickGoTo(0)` が空振りするので 160ms(10fps) delay させる
   */


  FeatureCategoryContainerHorizontal.prototype.resetSliders = function resetSliders() {
    var _this13 = this;

    this.resetSliderCount = 0;
    // ---
    var delay = 160;
    // ---
    // this.slickTrackDurationZero(delay + 160);
    // ---
    // this.likeDestroySliders();
    // ---
    this.timer.resetSlider = setTimeout(function () {
      _this13.resetSlidersAfterDelay();
    }, delay);
  };

  // --------------------------------------------------
  // /**
  //  * document.body `FeatureCategoryContainer__slick-track__transition__none` add します
  //  * - transition abort します
  //  */
  // abortTrackTransition() {
  //   clearTimeout(this.timer.track);
  //   document.body.classList.add(this.trackIgnore);
  // }
  // /**
  //  * document.body `FeatureCategoryContainer__slick-track__transition__none` remove します
  //  * - transition enable します
  //  */
  // enableTrackTransition() {
  //   document.body.classList.remove(this.trackIgnore);
  // }
  // /**
  //  * {@link FeatureCategoryContainer.enableTrackTransition} 遅延実行します
  //  * @param {number} [delay=516] 遅延時間(ms)
  //  */
  // delayEnableTrackTransition(delay = 516) {
  //   clearTimeout(this.timer.track);
  //   this.timer.track = setTimeout(() => {
  //     this.enableTrackTransition();
  //     // this.abortOpacityZero();
  //   }, delay);
  // }
  // --------------------------------------------------
  /**
   * maxHeight style を削除します - orientation 時の計算のじゃまになるので
   */


  FeatureCategoryContainerHorizontal.prototype.resetMaxHeight = function resetMaxHeight() {
    var filterId = this.props.filterId;
    var _containerComponents$ = this.containerComponents[filterId],
        pc = _containerComponents$.pc,
        mb = _containerComponents$.mb;

    [pc, mb].map(function (containerItems) {
      return containerItems.filter(function (component) {
        return component && component.setContainerHeight;
      }).map(function (component) {
        return component.setContainerHeight(null);
      });
    });
    this.setState({ heightFromMaxHeight: null });
  };
  /**
   * 子供の高さを揃えるために高さを取得し max height を設定する
   * @param {string} [mode=pc] reference switch に使用します
   */


  FeatureCategoryContainerHorizontal.prototype.getAndSetMaxHeight = function getAndSetMaxHeight() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pc';
    var _props6 = this.props,
        components = _props6.components,
        filterId = _props6.filterId;

    var containerItems = this.containerComponents[filterId][mode];
    // slick が component 複製してしまうので original component.length で truncate する
    var cloneItems = containerItems.slice(0);

    cloneItems.length = (components || []).length;
    var results = getComponentsHeight(cloneItems);
    results.sort(function (a, b) {
      return b - a;
    });
    var maxHeight = results[0];
    // console.log('FeatureCategoryContainerHorizontal.getAndSetMaxHeight sort', maxHeight, containerItems);
    containerItems.filter(function (component) {
      return component && component.setContainerHeight;
    }).map(function (component) {
      return component.setContainerHeight(maxHeight);
    });
    if (mode === 'mb') {
      this.setState({ heightFromMaxHeight: maxHeight });
    }
  };
  /**
   * maxHeight 設定を遅延実行します - child component render を待ちます
   * @param {number} [delay=112] {@link FeatureCategoryContainerHorizontal.getAndSetMaxHeight} を遅延実行します
   */


  FeatureCategoryContainerHorizontal.prototype.delayGetAndSetMaxHeight = function delayGetAndSetMaxHeight() {
    var _this14 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 112;

    // console.log('FeatureCategoryContainerHorizontal.delayGetAndSetMaxHeight delay', delay);
    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(function () {
      _this14.getAndSetMaxHeight();
      _this14.getAndSetMaxHeight('mb');
    }, delay);
    //this.resetMaxHeight();
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.afterMountShowSlick = function afterMountShowSlick() {
    this.setState({ didMount: true, slickTrackTransition: '' });
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.clearArrowClass = function clearArrowClass() {
    clearTimeout(this.timer.arrow);
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
  };

  FeatureCategoryContainerHorizontal.prototype.delayClearArrowClass = function delayClearArrowClass() {
    var _this15 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1750;

    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(function () {
      _this15.clearArrowClass();
    }, delay);
  };
  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      this.currentFilterId = this.props.currentFilterId;
      this.clearTimerResetSlider();
      this.initSliderProps();
      // ---
      this.resetSliders();
      // ---
      // component 高さを測るために render が終わる時間待機します
      var delay = 112 * 2;
      this.delayGetAndSetMaxHeight(delay);
      // ---
      // console.log('FeatureCategoryContainerHorizontal.componentDidUpdate with clear ---------------', this.props.currentFilterId, this.props.filterId, this.slickIndex, this.props.currentFilterId === this.props.filterId && (this.slickIndex.pc === 0 || this.slickIndex.mb === 0));
      // current 表示で - index: 0 のときは slick.afterChange が fire しないので timer で起動する
      if (this.props.currentFilterId === this.props.filterId && (this.slickIndex.pc === 0 || this.slickIndex.mb === 0)) {
        this.delayAbortOpacityZeroWithTransitionZero(500);
      }
    }
  };

  FeatureCategoryContainerHorizontal.prototype.componentDidMount = function componentDidMount() {
    var _this16 = this;

    this.delayGetAndSetMaxHeight();

    // window.addEventListener('resize', this.onResize, false);
    setTimeout(function () {
      window.addEventListener('resize', _this16.onResize, false);
    }, 500);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this16.onResize();
    }, 1000);

    this.timer.didMount = setTimeout(function () {
      _this16.afterMountShowSlick();
      _this16.delayAbortOpacityZeroWithTransitionZero(16);
    }, 0);
  };

  FeatureCategoryContainerHorizontal.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
    window.removeEventListener('resize', this.onResize);
  };

  // --------------------------------------------------
  /**
   * スライド用の丸ポチが表示される
   */


  FeatureCategoryContainerHorizontal.prototype.renderSliderPagerPc = function renderSliderPagerPc() {
    var _this17 = this;

    var pcIndex = this.state.pcIndex;
    // console.log('FeatureCategoryContainerHorizontal.renderSliderPagerPc', this.props.filterId, pcIndex, this.slider);

    var total = this.slider.page.last.pc + 1;
    var list = Array.apply(null, Array(total));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content__pager__block', __source: {
          fileName: _jsxFileName,
          lineNumber: 1851
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__content__pager', __source: {
            fileName: _jsxFileName,
            lineNumber: 1852
          }
        },
        list.map(function (value, index) {
          var id = 'pager-' + index;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              key: id,
              type: 'button',
              className: 'FeatureCategoryContainer__content__pager__dot ' + (pcIndex === index ? 'is-active' : ''),
              'data-page': index,
              onClick: _this17.onClickPager,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1857
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1864
              }
            })
          );
        })
      )
    );
  };

  // --------------------------------------------------
  /**
   * 各カテゴリの、スライド内の、各画像を表示する DOM 要素を返す
   */


  FeatureCategoryContainerHorizontal.prototype.renderItemWrap = function renderItemWrap(mode) {
    var _props7 = this.props,
        components = _props7.components,
        filterId = _props7.filterId;
    // ---

    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: []
      };
    }
    if (mode === 'pc-slide') {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    var childRefs = mode === 'pc-slide' ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // ---
    return components.map(function (component, index) {
      var props = Object.assign({}, component.props);
      switch (component.name) {
        case 'Promo':
          {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemPromo, _extends({
              key: 'promo-' + mode + '-' + filterId + '-' + index
            }, props, {
              uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
              childRefs: childRefs,
              inFeatureCategoriesHorizontal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1900
              }
            }));
          }
        case 'PromoAndButtonModalWindow':
          {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemPromoAndButtonModalWindow, _extends({
              key: 'promo-' + mode + '-' + filterId + '-' + index
            }, props, {
              uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
              childRefs: childRefs,
              inFeatureCategoriesHorizontal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1911
              }
            }));
          }
        case 'Video':
          {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemVideo, _extends({
              key: 'promo-' + mode + '-' + filterId + '-' + index
            }, props, {
              uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
              childRefs: childRefs,
              inFeatureCategoriesHorizontal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1922
              }
            }));
          }
        case 'Html':
          {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemHtml, _extends({
              uniqueId: 'promo-' + mode + '-' + filterId + '-' + index
            }, props, {
              key: 'promo-' + mode + '-' + filterId + '-' + index,
              childRefs: childRefs,
              inFeatureCategoriesHorizontal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1933
              }
            }));
          }
        case 'Wysiwyg':
          {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemWysiwyg, _extends({
              key: 'promo-' + mode + '-' + filterId + '-' + index
            }, props, {
              uniqueId: 'promo-' + mode + '-' + filterId + '-' + index,
              childRefs: childRefs,
              inFeatureCategoriesHorizontal: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1944
              }
            }));
          }
        default:
          {
            return null;
          }
      }
    })
    // .filter(component => (component !== null))
    ;
  };

  FeatureCategoryContainerHorizontal.prototype.renderSliderPcSlick = function renderSliderPcSlick() {
    var _this18 = this;

    var settings = {
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 500,
      ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      ref: function ref(component) {
        return _this18.slider.pc = component;
      },
      // initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      className: 'feature-category_container-slick-pc',
      // ---
      fade: false,
      useTransform: false,
      // variableWidth: true,
      variableWidth: false,
      adaptiveHeight: false,
      // slidesToShow: 1,
      // slidesToScroll: 1,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      useCSS: true,
      // row: 1,
      centerMode: false,
      centerPadding: 0,
      beforeChange: this.onPcThumbnailBeforeChange,
      afterChange: this.onPcThumbnailAfterChange,
      waitForAnimate: false
    };
    // console.log('FeatureCategoryContainerHorizontal.renderSliderPcSlick', settings);
    // console.log('ReactSlick', ReactSlick);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content__item__wrap', __source: {
          fileName: _jsxFileName,
          lineNumber: 1997
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        FeatureCategorySlider,
        { settings: settings, __source: {
            fileName: _jsxFileName,
            lineNumber: 1998
          }
        },
        this.renderItemWrap('pc-slide')
      )
    );
  };

  FeatureCategoryContainerHorizontal.prototype.renderSliderPc = function renderSliderPc() {
    var components = this.props.components;

    if (components.length <= 4) {
      return null;
    }
    var _state = this.state,
        arrowNextClass = _state.arrowNextClass,
        arrowPrevClass = _state.arrowPrevClass;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 2014
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__content__controls', __source: {
            fileName: _jsxFileName,
            lineNumber: 2015
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__prev ' + arrowPrevClass,
            type: 'button',
            onClick: this.onPcPrev,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 2016
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 2021
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__next ' + arrowNextClass,
            type: 'button',
            onClick: this.onPcNext,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 2023
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 2028
            }
          })
        )
      ),
      this.renderSliderPagerPc(),
      this.renderSliderPcSlick()
    );
  };

  FeatureCategoryContainerHorizontal.prototype.renderFlatPc = function renderFlatPc() {
    var _props8 = this.props,
        components = _props8.components,
        filterId = _props8.filterId;
    // const components = this.components;

    if (components.length > 4) {
      return null;
    }
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: []
      };
    }
    this.containerComponents[filterId].pc = [];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content-pc not__carousel-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 2051
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__content__item__wrap', __source: {
            fileName: _jsxFileName,
            lineNumber: 2052
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerItemWrap, _extends({}, this.props, {
          mode: 'pc-flat',
          childRefs: this.containerComponents[filterId].pc,
          inFeatureCategoriesHorizontal: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2053
          }
        }))
      )
    );
  };

  FeatureCategoryContainerHorizontal.prototype.renderPc = function renderPc() {
    var _this19 = this;

    var didMount = this.state.didMount;

    var style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    if (style && this.contents.pc) {
      style.minHeight = this.contents.pc.getBoundingClientRect().height + 'px';
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FeatureCategoryContainer__content__desktop',
        style: style,
        ref: function ref(component) {
          return _this19.contents.pc = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 2071
        }
      },
      this.renderSliderPc(),
      this.renderFlatPc()
    );
  };

  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.renderSliderMb = function renderSliderMb() {
    var _this20 = this;

    var components = this.props.components;
    // const components = this.components;

    if (components.length <= 1) {
      return null;
    }
    // ---
    var settings = {
      arrows: false,
      autoplay: false,
      speed: 500,
      ref: function ref(component) {
        return _this20.slider.mb = component;
      },
      initialSlide: 0,
      swipeToSlide: false,

      // スワイプさせるようにすると、スクロールしないようにできるが、リンク（画像部分）がクリックできなくなる。
      // swipe: false,
      // touchMove: false,
      swipe: true,
      touchMove: true,

      useTransform: false,
      // ---
      // variableWidth: true,
      variableWidth: false,
      fade: false,
      // rows: 1,
      slidesPerRow: 1,
      slidesToShow: 1,
      slidesToScroll: 1,
      // centerMode: false,
      centerMode: true,
      centerPadding: 0,
      useCSS: true,
      beforeChange: this.onMbThumbnailBeforeChange,
      afterChange: this.onMbThumbnailAfterChange
      // on　すると length 5 の挙動がおかしくなる
      // waitForAnimate: false,
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content-mb', __source: {
          fileName: _jsxFileName,
          lineNumber: 2123
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__content__controls', __source: {
            fileName: _jsxFileName,
            lineNumber: 2125
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__prev',
          type: 'button',
          onClick: this.onMbPrev,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2126
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__next',
          type: 'button',
          onClick: this.onMbNext,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2131
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'FeatureCategoryContainer__content__item__wrap',
          onTouchStart: this.onTouchStart,
          onTouchEnd: this.onTouchEnd,
          onTouchCancel: this.onTouchCancel,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2137
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          FeatureCategorySlider,
          { settings: settings, __source: {
              fileName: _jsxFileName,
              lineNumber: 2143
            }
          },
          this.renderItemWrap('mb-slide')
        )
      )
    );
  };

  FeatureCategoryContainerHorizontal.prototype.renderFlatMb = function renderFlatMb() {
    var components = this.props.components;
    // const components = this.components;

    if (components.length > 1) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content-mb not__carousel-mb', __source: {
          fileName: _jsxFileName,
          lineNumber: 2160
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__content__item__wrap', __source: {
            fileName: _jsxFileName,
            lineNumber: 2161
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerItemWrap, _extends({}, this.props, {
          mode: 'mb-flat',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2162
          }
        }))
      )
    );
  };

  FeatureCategoryContainerHorizontal.prototype.renderMb = function renderMb() {
    var _this21 = this;

    var _state2 = this.state,
        didMount = _state2.didMount,
        heightFromMaxHeight = _state2.heightFromMaxHeight;

    var style = didMount ? {} : { overflow: 'hidden', maxHeight: '0' };
    style.maxHeight = 'auto';
    // style.maxHeight = heightFromMaxHeight;
    // console.log('FeatureCategoryContainer.renderMb - didMount', style);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FeatureCategoryContainer__content__mobile',
        style: style,
        ref: function ref(component) {
          return _this21.contents.mb = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 2178
        }
      },
      this.renderSliderMb(),
      this.renderFlatMb()
    );
  };

  // --------------------------------------------------


  FeatureCategoryContainerHorizontal.prototype.render = function render() {
    var _props9 = this.props,
        components = _props9.components,
        layout = _props9.layout;
    // ---

    if (layout !== 'Horizontal') {
      return null;
    }
    // ---
    if (!components.length) {
      return null;
    }
    var slickTrackTransition = this.state.slickTrackTransition;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategoryContainer__content FeatureCategoryContainer__content__Horizontal ' + slickTrackTransition, __source: {
          fileName: _jsxFileName,
          lineNumber: 2205
        }
      },
      this.renderPc(),
      this.renderMb()
    );
  };

  return FeatureCategoryContainerHorizontal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class4.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // ---
  // extend
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // ---
  readMoreLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentContainerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  opacityZeroClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortTransitionClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterChangeOpacityClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortOpacityZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  changedFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  slickThumbnailChangedCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class4.defaultProps = {
  containerId: null,
  containerClass: null,
  title: null,
  components: [],
  // ---
  // extend
  showTitle: false,
  currentFilterId: '',
  filterId: '',
  titleClickCaller: null,
  // ---
  layout: 'Horizontal',
  pcDisplayLine: 4,
  mbDisplayLine: 4,
  // ---
  readMoreLabel: '',
  currentContainerIndex: 0,
  opacityZeroClassName: '',
  abortTransitionClassName: '',
  filterChangeOpacityClassName: '',
  abortOpacityZero: null,
  changedFilter: false,
  slickThumbnailChangedCallback: null
}, _temp4);

FeatureCategoryContainerHorizontal.displayName = 'FeatureCategoryContainerHorizontal';
// --------------------------------------------------
/**
 *  FeatureCategoryContainer
 */
var FeatureCategoryContainer = (_temp5 = _class5 = function (_Component4) {
  _inherits(FeatureCategoryContainer, _Component4);

  /**
   * second filter id から first filter id を生成し 親子関係を判定します
   * @param {string} filterId my filter id
   * @param {string} currentFilterId current filter id
   * @returns {boolean} true: 親子関係
   */
  FeatureCategoryContainer.gaveCurrentFromChild = function gaveCurrentFromChild(filterId, currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    var divideId = filterId.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  };

  FeatureCategoryContainer.getDerivedStateFromPropsByMarkedId = function getDerivedStateFromPropsByMarkedId(props, state) {
    var notEmpty = props.currentFilterMarkedId !== '';
    var sameFilterId = notEmpty && props.currentFilterMarkedId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = FeatureCategoryContainer.gaveCurrentFromChild(props.filterId, props.currentFilterMarkedId);
      // console.log('FeatureCategoryContainer.getDerivedStateFromPropsByMarkedId', props.filterId, sameFilterId, props.currentFilterMarkedId, props.currentFilterId);
    }
    return {
      changeFilterId: notEmpty && props.currentFilterMarkedId !== state.currentFilterId,
      sameFilterId: sameFilterId
    };
  };
  /**
   * filter id から view update 必要を判定します
   * @param {*} props React.props
   * @param {*} state React.state
   * @param {boolean} [useMarked=false] `props.currentFilterMarkedId` を使用する flag
   * @returns {{changeFilterId: boolean, sameFilterId: boolean}} change / same boolean list 返します
   */


  FeatureCategoryContainer.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var useMarked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (useMarked) {
      return FeatureCategoryContainer.getDerivedStateFromPropsByMarkedId(props, state);
    }
    var notEmpty = props.currentFilterId !== '';
    var sameFilterId = notEmpty && props.currentFilterId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = FeatureCategoryContainer.gaveCurrentFromChild(props.filterId, props.currentFilterId);
    }
    return {
      changeFilterId: notEmpty && props.currentFilterId !== state.currentFilterId,
      sameFilterId: sameFilterId
    };
  };

  function FeatureCategoryContainer(props) {
    _classCallCheck(this, FeatureCategoryContainer);

    // ---
    var _this22 = _possibleConstructorReturn(this, _Component4.call(this, props));

    _this22.state = {
      activateCurrent: props.currentFilterId === props.filterId,
      currentFilterId: props.currentFilterId,
      currentContainerIndex: props.currentContainerIndex
    };
    _this22.refTitle = null;
    return _this22;
  }

  // --------------------------------------------------


  FeatureCategoryContainer.prototype.getTitleClientRect = function getTitleClientRect() {
    return this.refTitle && this.refTitle.getTitleClientRect ? this.refTitle.getTitleClientRect() : null;
  };
  // --------------------------------------------------
  // /**
  //  * {@link getComponents} で components を洗浄します
  //  * - getComponents - array check していないので事前にチェックする
  //  * - getComponents - null が含まれる可能性があるので filter する
  //  * - PickerContainer を除外する
  //  * @returns {Array<*>} 洗浄後の components list `PropTypes.node`
  //  */
  // convertPropsComponents() {
  //     const { components } = this.props;
  //     return Array.isArray(components) ? getComponents(components).filter(component => (component !== null)) : [];
  // }
  // --------------------------------------------------
  /**
   * 各カテゴリのコンテントを表示するための DOM要素を返す
   */


  FeatureCategoryContainer.prototype.renderWhichLayout = function renderWhichLayout() {
    var _props10 = this.props,
        layout = _props10.layout,
        abortOpacityZero = _props10.abortOpacityZero,
        slickThumbnailChangedCallback = _props10.slickThumbnailChangedCallback,
        changedFilter = _props10.changedFilter;

    if (layout === 'Vertical') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__Vertical', __source: {
            fileName: _jsxFileName,
            lineNumber: 2359
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerVerticalPc, _extends({}, this.props, {
          abortOpacityZero: abortOpacityZero,
          slickThumbnailChangedCallback: slickThumbnailChangedCallback,
          changedFilter: changedFilter,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2360
          }
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerVerticalMb, _extends({}, this.props, {
          abortOpacityZero: abortOpacityZero,
          slickThumbnailChangedCallback: slickThumbnailChangedCallback,
          changedFilter: changedFilter,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2366
          }
        }))
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerHorizontal, _extends({}, this.props, {
      abortOpacityZero: abortOpacityZero,
      slickThumbnailChangedCallback: slickThumbnailChangedCallback,
      changedFilter: changedFilter,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 2376
      }
    }));
  };
  // --------------------------------------------------
  /**
   * navigation 部分の title を出力します
   * @returns {*} `FeatureCategoryContainerTitle`
   */


  FeatureCategoryContainer.prototype.renderTitle = function renderTitle() {
    var _this23 = this;

    // title
    // console.log('FeatureCategoryContainer.renderTitle', this.props);
    var _FeatureCategoryConta2 = FeatureCategoryContainer.getDerivedStateFromProps(this.props, this.state),
        sameFilterId = _FeatureCategoryConta2.sameFilterId;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureCategoryContainerTitle, _extends({}, this.props, {
      sameFilterId: sameFilterId,
      ref: function ref(component) {
        return _this23.refTitle = component;
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 2393
      }
    }));
  };
  // --------------------------------------------------


  FeatureCategoryContainer.prototype.render = function render() {
    var _props11 = this.props,
        containerId = _props11.containerId,
        containerClass = _props11.containerClass,
        showTitle = _props11.showTitle,
        filterId = _props11.filterId,
        currentFilterId = _props11.currentFilterId,
        filterChangeOpacityClassName = _props11.filterChangeOpacityClassName;
    // ---

    if (showTitle) {
      return this.renderTitle();
    } else if (currentFilterId !== filterId) {
      // no title - need same current filter id and filter id
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 2417
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategoryContainer__transition__root ' + filterChangeOpacityClassName, __source: {
            fileName: _jsxFileName,
            lineNumber: 2421
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FeatureCategoryContainer', 'data-id': filterId, __source: {
              fileName: _jsxFileName,
              lineNumber: 2422
            }
          },
          this.renderWhichLayout()
        )
      )
    );
  };

  return FeatureCategoryContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class5.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // ---
  // extend
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // ---
  readMoreLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectTextColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterChangeOpacityClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortOpacityZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  changedFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  slickThumbnailChangedCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  mobileFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class5.defaultProps = {
  containerId: null,
  containerClass: null,
  title: null,
  components: null,
  // ---
  // extend
  showTitle: false,
  currentFilterId: '',
  filterId: '',
  titleClickCaller: null,
  // ---
  layout: 'Horizontal',
  pcDisplayLine: 4,
  mbDisplayLine: 4,
  // ---
  readMoreLabel: '',
  selectTextColor: 'Dark',
  filterChangeOpacityClassName: '',
  abortOpacityZero: null,
  changedFilter: false,
  slickThumbnailChangedCallback: null,
  // mobile flag
  mobileFilter: false
}, _class5.OPACITY_ZERO_CLASS_NAME = 'FeatureCategoryContainer__content__opacity_0', _class5.ABORT_SLICK_TRANSITION = 'FeatureCategoryContainer__slick-track__transition__none', _temp5);
FeatureCategoryContainer.displayName = 'FeatureCategoryContainer';


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PickerSlider */
/* unused harmony export PickerContainerItemThumbnail */
/* unused harmony export PickerContainerItemView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker_item__ = __webpack_require__(162);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\picker-container\\index.jsx',
    _class,
    _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---

// ---
// import ReactSlider from '../hero-carousel/react-slick'

// ---


// ---


// import Slider from '../../containers/slider';

/**
 * ReactSlider 作成します
 * @param {*} settings react-slick 設定
 * @param {React.node} children 子 node list
 * @returns {React.Element} `ReactSlider`
 * @constructor
 */
var PickerSlider = function PickerSlider(_ref) {
  var settings = _ref.settings,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
    _extends({}, settings, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    }),
    children
  );
};

PickerSlider.displayName = 'PickerSlider';
PickerSlider.propTypes = {
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape().isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired).isRequired
};

Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["d" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["a" /* DetectCompact */])())(PickerSlider);

/**
 * {@link PickerItem} thumbnail
 * @param {*} props React.props
 * @returns {React.Element} {@link PickerItem}
 * @constructor
 */
var PickerContainerItemThumbnail = function PickerContainerItemThumbnail(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_item__["a" /* default */], _extends({}, props, { showView: false, __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    }
  }));
};

PickerContainerItemThumbnail.displayName = 'PickerContainerItemThumbnail';
/**
 * {@link PickerItem} view
 * @param {*} props React.props
 * @returns {React.Element} {@link PickerItem}
 * @constructor
 */
var PickerContainerItemView = function PickerContainerItemView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_item__["a" /* default */], _extends({}, props, { showView: true, __source: {
      fileName: _jsxFileName,
      lineNumber: 55
    }
  }));
};

PickerContainerItemView.displayName = 'PickerContainerItemView';
/**
 *  PickerContainer
 */
var PickerContainer = (_temp = _class = function (_Component) {
  _inherits(PickerContainer, _Component);

  /**
   * second filter id から first filter id を生成し 親子関係を判定します
   * @param {string} filterId my filter id
   * @param {string} currentFilterId current filter id
   * @returns {boolean} true: 親子関係
   */
  PickerContainer.gaveCurrentFromChild = function gaveCurrentFromChild(_ref2) {
    var filterId = _ref2.filterId,
        currentFilterId = _ref2.currentFilterId;

    var divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    var divideId = filterId.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  };

  /**
   * filter id から view update 必要を判定します
   * @param {*} props React.props
   * @param {*} state React.state
   * @returns {{changeFilterId: boolean, sameFilterId: boolean}} change / same boolean list 返します
   */


  PickerContainer.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var notEmpty = props.currentFilterId !== '';
    var sameFilterId = notEmpty && props.currentFilterId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = PickerContainer.gaveCurrentFromChild(props);
    }
    return {
      changeFilterId: notEmpty && props.currentFilterId !== state.currentFilterId,
      sameFilterId: sameFilterId
    };
  };

  function PickerContainer(props) {
    _classCallCheck(this, PickerContainer);

    // ---
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onClickTitle = _this.onClickTitle.bind(_this);
    _this.onCallClickThumbnail = _this.onCallClickThumbnail.bind(_this);
    var pcEachTime = 8;
    var mbEachTime = 1;
    var components = _this.componentsWithOutPickerContainer();
    var componentsLength = components.length;
    _this.slider = {
      view: null,
      thumbnails: {
        pc: null,
        mb: null,
        page: {
          index: {
            pc: 0,
            mb: 0
          },
          last: {
            pc: 0,
            mb: 0
          }
        },
        index: {
          pc: 0,
          mb: 0
        },
        eachTime: {
          pc: pcEachTime,
          mb: mbEachTime
        },
        // length: componentsLength,
        length: 0
      }
    };
    // console.log('PickerContainer', props.filterId, components, this.slider.thumbnails);
    _this.transitionClasses = {
      click: 'PickerContainer__thumb__btn__clicked',
      blink: 'PickerContainer__thumb__btn__blink'
    };
    _this.state = {
      activateCurrent: props.currentFilterId === props.filterId,
      currentFilterId: props.currentFilterId,
      currentPickerIndex: props.currentPickerIndex,
      length: componentsLength,
      didMount: false,
      arrowPrevClass: '',
      arrowNextClass: ''
    };
    /**
     * mb - thumbnail swipe 計算に使用します
     * @type {{start: Vectors, end: Vectors}}
     */
    _this.vectors = {
      start: new __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* Vectors */](),
      end: new __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* Vectors */]()
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    _this.swipeThreshold = 5;
    /**
     * 表示されている view index
     * @type {number}
     */
    _this.viewIndex = props.currentPickerIndex;
    _this.onPcThumbnailClickSlickPrev = _this.onPcThumbnailClickSlickPrev.bind(_this);
    _this.onPcThumbnailClickSlickNext = _this.onPcThumbnailClickSlickNext.bind(_this);
    // ---
    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    _this.onTouchCancel = _this.onTouchCancel.bind(_this);
    /**
     * responsive mb 以下サイズ - thumbnail pc - mb 連動必要判定に使用します
     * @type {number}
     */
    _this.mbWidth = 767;
    /**
     * timeOut id list
     * @type {{viewChange: number, thumbnailPc: number, thumbnailMb: number}}
     */
    _this.timer = {
      track: 0,
      viewChange: 0,
      thumbnailPc: 0,
      thumbnailMb: 0,
      mbOpacity: 0,
      didMount: 0,
      didUpdate: 0,
      arrow: 0,
      opacityZero: 0
    };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    _this.enableThumbnailClick = true;
    _this.trackIgnore = 'PickerContainer__slick-track__transition__none';
    _this.components = [];
    // ---
    _this.initSliderProps();
    _this.onViewBeforeChange = _this.onViewBeforeChange.bind(_this);
    _this.onViewAfterChange = _this.onViewAfterChange.bind(_this);
    _this.onPcThumbnailBeforeChange = _this.onPcThumbnailBeforeChange.bind(_this);
    _this.onPcThumbnailAfterChange = _this.onPcThumbnailAfterChange.bind(_this);
    _this.onMbThumbnailBeforeChange = _this.onMbThumbnailBeforeChange.bind(_this);
    _this.onMbThumbnailAfterChange = _this.onMbThumbnailAfterChange.bind(_this);
    _this.slickIndex = {
      view: _this.viewIndex,
      thumbnails: {
        pc: 0,
        mb: 0
      }
    };
    _this.syncCount = {
      view: 0,
      thumbnails: {
        pc: 0,
        mb: 0
      }
    };
    _this.currentFilterId = props.currentFilterId;
    // this.mbThumbnailOpacity = 0;
    // this.didMount = false;
    _this.refTitle = null;
    return _this;
  }
  // --------------------------------------------------


  PickerContainer.prototype.getTitleClientRect = function getTitleClientRect() {
    return this.refTitle ? this.refTitle.getBoundingClientRect() : null;
  };
  // --------------------------------------------------


  PickerContainer.prototype.initSliderProps = function initSliderProps() {
    // const items = components.filter(component => (component.name !== 'PickerContainer'));
    var items = this.componentsWithOutPickerContainer();
    var componentsLength = items.length;
    var pcEachTime = this.slider.thumbnails.eachTime.pc;
    var mbEachTime = this.slider.thumbnails.eachTime.mb;
    this.slider.thumbnails.page.index = {
      pc: 0,
      mb: 0
    };
    this.slider.thumbnails.page.last = {
      pc: Math.ceil(componentsLength / pcEachTime) - 1,
      mb: Math.ceil(componentsLength / mbEachTime) - 1
    };
    this.slider.thumbnails.length = componentsLength;

    this.slider.thumbnails.index = {
      pc: 0,
      mb: 0
    };
  };
  // --------------------------------------------------
  /**
   * vew slick beforeChange callback
   * - slick の index を把握します - `slickGoto` しても実行されないことがあるので...
   * @param {?number} currentSlideIndex data こない `undefine` なる
   * @param {number} nextSlideIndex 次の slide index - 処理が始まった
   */


  PickerContainer.prototype.onViewBeforeChange = function onViewBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.view = nextSlideIndex;
  };

  PickerContainer.prototype.onViewAfterChange = function onViewAfterChange(currentSlideIndex) {
    this.slickIndex.view = currentSlideIndex;
  };

  PickerContainer.prototype.onPcThumbnailBeforeChange = function onPcThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    // console.log('PickerContainer.onPcThumbnailBeforeChange ===================', this.props.filterId, nextSlideIndex);
    this.slickIndex.thumbnails.pc = nextSlideIndex;
  };

  PickerContainer.prototype.onPcThumbnailAfterChange = function onPcThumbnailAfterChange(currentSlideIndex) {
    // console.log('PickerContainer.onPcThumbnailAfterChange ===================', this.props.filterId, currentSlideIndex);
    this.slickIndex.thumbnails.pc = currentSlideIndex;
  };

  PickerContainer.prototype.onMbThumbnailBeforeChange = function onMbThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.thumbnails.mb = nextSlideIndex;
  };

  PickerContainer.prototype.onMbThumbnailAfterChange = function onMbThumbnailAfterChange(currentSlideIndex) {
    // console.log('PickerContainer.onMbThumbnailAfterChange ===================', this.props.filterId, currentSlideIndex);
    this.slickIndex.thumbnails.mb = currentSlideIndex;
  };
  // --------------------------------------------------
  /**
   * thumbnail click callback
   * - `props.thumbnailClickCaller` を実行し thumbnail current 更新します
   * - view (slick) を update します
   * @param {string} filterId filter id
   * @param {number} pickerIndex picker index
   */


  PickerContainer.prototype.onCallClickThumbnail = function onCallClickThumbnail(filterId, pickerIndex) {
    // console.log('PickerContainer.onCallClickThumbnail', this.props.filterId, filterId, pickerIndex);
    this.shouldViewSlickUpdate(pickerIndex);
    this.mbThumbnailCurrentWithClick(pickerIndex);
    this.callThumbnailCaller(filterId, pickerIndex);
  };

  /**
   * thumbnail callback を親 component へ伝達します
   * @param {string} filterId filter id
   * @param {number} pickerIndex thumbnail index
   */


  PickerContainer.prototype.callThumbnailCaller = function callThumbnailCaller(filterId, pickerIndex) {
    var thumbnailClickCaller = this.props.thumbnailClickCaller;

    if (typeof thumbnailClickCaller === 'function') {
      thumbnailClickCaller.call(this, filterId, pickerIndex);
    }
  };
  /**
   * filter title click event handler
   * - `props.titleClickCaller` 通知します
   * @param {Event} event click event
   */


  PickerContainer.prototype.onClickTitle = function onClickTitle(event) {
    event.preventDefault();
    var _props = this.props,
        titleClickCaller = _props.titleClickCaller,
        filterId = _props.filterId,
        filterIndex = _props.filterIndex,
        title = _props.title;
    // console.log('PickerContainer.onClickTitle', event, filterId, filterIndex);

    if (typeof titleClickCaller === 'function') {
      titleClickCaller.call(this, filterId, filterIndex, title);
    }
  };

  // --------------------------------------------------
  // pc thumbnail slick


  PickerContainer.prototype.onPcThumbnailClickSlickPrev = function onPcThumbnailClickSlickPrev(event) {
    var _this2 = this;

    event.preventDefault();
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    setTimeout(function () {
      _this2.pcThumbnailPrev();
    }, 1);
    // this.pcThumbnailPrev();
  };

  PickerContainer.prototype.onPcThumbnailClickSlickNext = function onPcThumbnailClickSlickNext(event) {
    var _this3 = this;

    event.preventDefault();
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    setTimeout(function () {
      _this3.pcThumbnailNext();
    }, 1);
    // this.pcThumbnailNext();
  };

  /**
   * pc thumbnail prev を処理します
   * - `slickPrev` bug てるので使用しません
   */


  PickerContainer.prototype.pcThumbnailPrev = function pcThumbnailPrev() {
    var pc = this.slider.thumbnails.pc;

    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.click, arrowNextClass: this.transitionClasses.blink });
      this.delayClearArrowClass();
      var page = this.slider.thumbnails.page.index.pc - 1;
      if (page < 0) {
        // page = this.slider.thumbnails.page.last.pc;
        this.pcThumbnailFirstToLast();
        return;
      }
      this.slider.thumbnails.page.index.pc = page;
      // ---
      var pcEachTime = this.slider.thumbnails.eachTime.pc;
      var pcExpectIndex = page * pcEachTime;
      // console.log('PickerContainer.pcThumbnailPrev', page, pcExpectIndex, this.slider.thumbnails.page);
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  };

  /**
   * prev - first to last
   * - 独自実装計算を行います
   */


  PickerContainer.prototype.pcThumbnailFirstToLast = function pcThumbnailFirstToLast() {
    // prev
    // first -> last
    var pc = this.slider.thumbnails.pc;

    if (pc) {
      this.slider.thumbnails.page.index.pc = this.slider.thumbnails.page.last.pc;
      var pcExpectIndex = -this.slider.thumbnails.eachTime.pc;
      // console.log('PickerContainer.pcThumbnailFirstToLast', pcExpectIndex, this.slider.thumbnails);
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  };

  /**
   * pc thumbnail next を処理します
   * - `slickNext` bug てるので使用しません
   */


  PickerContainer.prototype.pcThumbnailNext = function pcThumbnailNext() {
    var pc = this.slider.thumbnails.pc;

    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.blink, arrowNextClass: this.transitionClasses.click });
      this.delayClearArrowClass();
      // pc.slickNext();
      var page = this.slider.thumbnails.page.index.pc + 1;
      // console.log('PickerContainer.pcThumbnailNext', page, this.slider.thumbnails.page);
      if (page > this.slider.thumbnails.page.last.pc) {
        // page = 0;
        this.pcThumbnailLastToFirst();
        return;
      }
      this.slider.thumbnails.page.index.pc = page;
      // ---
      var pcEachTime = this.slider.thumbnails.eachTime.pc;
      var pcExpectIndex = page * pcEachTime;
      this.pcThumbnailGoTo(pcExpectIndex);
    }
  };

  /**
   * next - last to first
   * - 独自実装計算を行います
   */


  PickerContainer.prototype.pcThumbnailLastToFirst = function pcThumbnailLastToFirst() {
    // next
    // last -> top
    var pc = this.slider.thumbnails.pc;

    if (pc) {
      this.slider.thumbnails.page.index.pc = 0;
      this.pcThumbnailGoTo(this.slider.thumbnails.length);
    }
  };

  /**
   * `slickGoTo` します
   * @param {number} index target index
   */


  PickerContainer.prototype.pcThumbnailGoTo = function pcThumbnailGoTo(index) {
    var pc = this.slider.thumbnails.pc;

    if (pc) {
      pc.slickGoTo(index);
      this.slider.thumbnails.index.pc = index;
    }
  };

  /**
   * responsive mobile size の移動を反映します
   */


  PickerContainer.prototype.pcThumbnailMoveByMb = function pcThumbnailMoveByMb() {
    var _slider$thumbnails$pa = this.slider.thumbnails.page.index,
        mb = _slider$thumbnails$pa.mb,
        pc = _slider$thumbnails$pa.pc;

    var pcEachTime = this.slider.thumbnails.eachTime.pc;
    var pcExpectPage = Math.floor(mb / pcEachTime);
    // console.log('PickerContainer.pcThumbnailMoveByMb', pcExpectPage, pc);
    if (pcExpectPage > pc) {
      this.pcThumbnailNext();
    } else if (pcExpectPage < pc) {
      this.pcThumbnailPrev();
    }
  };

  // --------------------------------------------------
  // mb thumbnail slick


  PickerContainer.prototype.onTouchStart = function onTouchStart(event) {
    this.resetMove();
    this.vectors.start.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* eventWithPoint */])(event));
  };

  PickerContainer.prototype.onTouchEnd = function onTouchEnd(event) {
    this.vectors.end.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* eventWithPoint */])(event));
    var distanceX = this.vectors.end.distanceX(this.vectors.start);
    // swipe
    if (Math.abs(distanceX) >= this.swipeThreshold) {
      if (distanceX < 0) {
        // left
        this.mbThumbnailNext();
      } else {
        // right
        this.mbThumbnailPrev();
      }
    }
    this.resetMove();
  };

  PickerContainer.prototype.onTouchCancel = function onTouchCancel() {
    this.resetMove();
  };

  /**
   * mb swipe で 中央サムネイルを `current` にするために {@link }PickerContainer.onCallClickThumbnail} を実行します
   * - view も thumbnail に連動します
   */


  PickerContainer.prototype.mbCallThumbnailMove = function mbCallThumbnailMove() {
    var filterId = this.props.filterId;

    var index = this.slider.thumbnails.page.index.mb;
    this.shouldViewSlickUpdate(index);
    this.callThumbnailCaller(filterId, index);
  };

  PickerContainer.prototype.mbThumbnailPrev = function mbThumbnailPrev() {
    var notPcMove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var mb = this.slider.thumbnails.mb;

    if (mb) {
      // console.log('PickerContainer.mbThumbnailPrev', this.slider.thumbnails.page);
      var page = this.slider.thumbnails.page.index.mb - 1;
      if (page < 0) {
        page = this.slider.thumbnails.page.last.mb;
      }
      this.slider.thumbnails.page.index.mb = page;
      this.slider.thumbnails.index.mb = page;
      mb.slickPrev();
      // ---
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(page, 'prev');
      // ---
      // if (!notPcMove) {
      //   this.pcThumbnailMoveByMb();
      // }
      this.mbCallThumbnailMove();
    }
  };

  PickerContainer.prototype.mbThumbnailNext = function mbThumbnailNext() {
    var notPcMove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var mb = this.slider.thumbnails.mb;

    if (mb) {
      var page = this.slider.thumbnails.page.index.mb + 1;
      if (page > this.slider.thumbnails.page.last.mb) {
        page = 0;
      }
      this.slider.thumbnails.page.index.mb = page;
      this.slider.thumbnails.index.mb = page;
      mb.slickNext();
      // ---
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(page, 'next');
      // ---
      // if (!notPcMove) {
      //   this.pcThumbnailMoveByMb();
      // }
      this.mbCallThumbnailMove();
    }
  };

  // /**
  //  * mb - thumbnail slick を pc - slick 移動にシンクロさせます
  //  * @param {number} index pc 移動後の左端 picker index
  //  */
  // mbThumbnailMoveByPc(index) {
  //     const { mb } = this.slider.thumbnails;
  //     // console.log('PickerContainer.mbThumbnailMoveByPc', index);
  //     if (mb) {
  //         mb.slickGoTo(index);
  //         this.slider.thumbnails.page.mb = index;
  //         // this.viewIndex = index;
  //     }
  // }
  /**
   * pc - slick thumbnail click で mb thumbnail 移動させます
   * @param {number} index click thumbnail picker index
   * @param {string} [mode=go] move mode, 'go' || 'prev' || 'next'
   */


  PickerContainer.prototype.mbThumbnailGoTo = function mbThumbnailGoTo(index) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'go';
    var mb = this.slider.thumbnails.mb;
    // console.log('PickerContainer.mbThumbnailGoTo', index, this.props.filterId);

    if (mb) {
      this.slider.thumbnails.page.index.mb = index;
      // this.viewIndex = index;
      this.slider.thumbnails.index.mb = index;
      // ---
      mb.slickGoTo(index);
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex(index, mode);
    }
  };

  /**
   * touch move value を初期化します
   */


  PickerContainer.prototype.resetMove = function resetMove() {
    var _vectors = this.vectors,
        start = _vectors.start,
        end = _vectors.end;

    start.reset();
    end.reset();
  };

  /**
   * MB - click thumbnail を center にします
   * @param {number} pickerIndex click thumbnail index
   */


  PickerContainer.prototype.mbThumbnailCurrentWithClick = function mbThumbnailCurrentWithClick(pickerIndex) {
    var currentPickerIndex = this.props.currentPickerIndex;

    var last = this.slider.thumbnails.page.last.mb;
    // console.log('PickerContainer.mbThumbnailCurrentWithClick', pickerIndex, currentPickerIndex, pickerIndex === last, currentPickerIndex === 0, pickerIndex > currentPickerIndex, last);
    if (pickerIndex > currentPickerIndex) {
      if (pickerIndex === last && currentPickerIndex === 0) {
        // console.log('PickerContainer.mbThumbnailCurrentWithClick - mbThumbnailPrev');
        this.mbThumbnailPrev(true);
      } else {
        // this.mbThumbnailNext(true);
        // console.log('PickerContainer.mbThumbnailCurrentWithClick - mbThumbnailGoTo', pickerIndex);
        this.mbThumbnailGoTo(pickerIndex, 'next');
      }
    } else if (pickerIndex < currentPickerIndex) {
      if (pickerIndex === 0 && currentPickerIndex === last) {
        this.mbThumbnailNext(true);
      } else {
        this.mbThumbnailGoTo(pickerIndex, 'prev');
      }
    }
  };

  // --------------------------------------------------
  // syncPcThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailPc);
  //   const slider = this.slider.thumbnails.pc;
  //   if (this.syncCount.thumbnails.pc > 50 || !slider || this.slider.thumbnails.index.pc === this.slickIndex.thumbnails.pc) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.thumbnails.pc = this.slider.thumbnails.index.pc;
  //     return;
  //   }
  //   this.syncCount.thumbnails.pc += 1;
  //   this.timer.thumbnailPc = setTimeout(() => {
  //     this.pcThumbnailGoTo(0);
  //     // console.log('PickerContainer.syncPcThumbnailIndex *** timeOut', this.props.filterId, this.syncCount.thumbnails.pc, this.slider.thumbnails.index.pc, this.slickIndex.thumbnails.pc, Date.now());
  //     this.syncPcThumbnailIndex();
  //   }, 16);
  // }
  // syncMbThumbnailIndex(index = 0, mode = 'go') {
  //   clearTimeout(this.timer.thumbnailMb);
  //   const slider = this.slider.thumbnails.mb;
  //   if (this.syncCount.thumbnails.mb > 50 || !slider || this.slider.thumbnails.index.mb === this.slickIndex.thumbnails.mb) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.thumbnails.mb = this.slider.thumbnails.index.mb;
  //     return;
  //   }
  //   this.syncCount.thumbnails.mb += 1;
  //   this.timer.thumbnailMb = setTimeout(() => {
  //     // this.mbThumbnailGoTo(index);
  //     switch (mode) {
  //       case 'prev': {
  //         slider.slickPrev();
  //         break;
  //       }
  //       case 'next': {
  //         slider.slickNext();
  //         break;
  //       }
  //       case 'go':
  //       default:{
  //         slider.slickGoTo(index);
  //         break;
  //       }
  //     }
  //     // console.log('PickerContainer.syncMbThumbnailIndex ::: timeOut', this.props.filterId, index, mode, this.syncCount.thumbnails.mb, this.slider.thumbnails.index.mb, this.slickIndex.thumbnails.mb, Date.now());
  //     this.syncMbThumbnailIndex(index, mode);
  //   }, 16);
  // }

  PickerContainer.prototype.resetThumbnail = function resetThumbnail(pc) {
    var slick = pc ? this.slider.thumbnails.pc : this.slider.thumbnails.mb;
    if (!slick) {
      return;
    }
    // console.log('PickerContainer.resetThumbnail', this.props.filterId, pc, slick);
    if (pc) {
      this.pcThumbnailGoTo(0);
      this.slider.thumbnails.page.index.pc = 0;
      this.slider.thumbnails.index.pc = 0;
      // this.syncCount.thumbnails.pc = 0;
      // this.syncPcThumbnailIndex();
    } else {
      this.mbThumbnailGoTo(0);
      this.slider.thumbnails.page.index.mb = 0;
      this.slider.thumbnails.index.mb = 0;
      // this.syncCount.thumbnails.mb = 0;
      // this.syncMbThumbnailIndex();
    }
  };

  PickerContainer.prototype.resetThumbnails = function resetThumbnails() {
    // console.log('PickerContainer.resetThumbnails', this.props.filterId, Date.now());
    this.resetThumbnail(true);
    this.resetThumbnail(false);
  };
  // --------------------------------------------------
  // view slick
  // /**
  //  * slick が処理中だと命令を無視するようなので実行できるまでしつこく待機する
  //  */
  // syncViewIndex() {
  //   clearTimeout(this.timer.viewChange);
  //   const view = this.slider.view;
  //   if (this.syncCount.view > 50 || !view || this.viewIndex === this.slickIndex.view) {
  //     return;
  //   }
  //   this.syncCount.view += 1;
  //   this.timer.viewChange = setTimeout(() => {
  //     view.slickGoTo(this.viewIndex);
  //     // console.log('PickerContainer.syncViewIndex -- timeOut', this.viewIndex, this.slickIndex.view, Date.now());
  //     this.syncViewIndex();
  //   }, 16);
  // }
  /**
   * `currentPickerIndex` value で view を変更します
   * - view - slick 移動します
   * @param {number} index pickerIndex -> 表示する view index
   */


  PickerContainer.prototype.shouldViewSlickUpdate = function shouldViewSlickUpdate(index) {
    var view = this.slider.view;
    if (!view) {
      return;
    }
    clearTimeout(this.timer.viewChange);
    this.viewIndex = index;
    view.slickGoTo(index);
    // // pc サイズのときに mb （非表示）thumbnail を移動します
    // if (window.innerWidth > this.mbWidth) {
    //   this.mbThumbnailGoTo(index);
    // }
    // this.syncCount.view = 0;
    // this.syncViewIndex();
  };

  PickerContainer.prototype.resetViewSlick = function resetViewSlick() {
    this.viewIndex = 0;
    var view = this.slider.view;

    if (view) {
      view.slickGoTo(0);
      // this.syncCount.view = 0;
      // this.syncViewIndex();
    }
  };
  // --------------------------------------------------
  // abortTrackTransition() {
  //   // console.log('PickerContainer.abortTrackTransition +++++', this.props.filterId, Date.now());
  //   document.body.classList.add(this.trackIgnore);
  // }
  // enableTrackTransition() {
  //   // console.log('PickerContainer.enableTrackTransition ------', this.props.filterId, Date.now());
  //   document.body.classList.remove(this.trackIgnore);
  // }
  // delayEnableTrackTransition(delay = 516) {
  //   clearTimeout(this.timer.track);
  //   this.timer.track = setTimeout(() => {
  //     this.enableTrackTransition();
  //   }, delay);
  // }
  // --------------------------------------------------


  PickerContainer.prototype.abortOpacityZero = function abortOpacityZero() {
    // document.body.classList.remove(this.opacityZeroClassName);
    // this.setState({ filterChangeOpacityClassName: '' });
    var abortOpacityZero = this.props.abortOpacityZero;
    // console.log('PickerContainer.abortOpacityZero --------------- remove', this.props.filterId, Date.now());

    if (typeof abortOpacityZero === 'function') {
      abortOpacityZero.call(this);
    }
  };

  PickerContainer.prototype.delayAbortOpacityZero = function delayAbortOpacityZero() {
    var _this4 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 320;

    this.timer.opacityZero = setTimeout(function () {
      _this4.abortOpacityZero();
    }, delay);
  };
  // --------------------------------------------------
  /**
   * state を変更するかをチェックします
   * @param {boolean} activateCurrent `state.activateCurrent` と違っていたら `setState` します
   */


  PickerContainer.prototype.willChangeStateCurrent = function willChangeStateCurrent(activateCurrent) {
    var _props2 = this.props,
        currentFilterId = _props2.currentFilterId,
        currentPickerIndex = _props2.currentPickerIndex;
    // console.log(`PickerContainer.willChangeStateCurrent - activateCurrent(${activateCurrent})`, currentFilterId, this.props.filterId, this.state.activateCurrent);

    if (this.state.activateCurrent !== activateCurrent) {
      this.shouldViewSlickUpdate(this.viewIndex);
      this.setState({ activateCurrent: activateCurrent, currentFilterId: currentFilterId, currentPickerIndex: currentPickerIndex });
    }
  };
  // --------------------------------------------------


  PickerContainer.prototype.afterMountShowSlick = function afterMountShowSlick() {
    // console.log('PickerContainer.afterMountShowSlick ===========');
    this.setState({ didMount: true });
  };
  // --------------------------------------------------


  PickerContainer.prototype.clearArrowClass = function clearArrowClass() {
    // console.log('FeatureCategoryContainerHorizontal.clearArrowClass');
    clearTimeout(this.timer.arrow);
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
  };

  PickerContainer.prototype.delayClearArrowClass = function delayClearArrowClass() {
    var _this5 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1750;

    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(function () {
      _this5.clearArrowClass();
    }, delay);
  };
  // --------------------------------------------------
  /**
   * props.components から {@link PickerContainer} を除いたリストを作成します
   * @returns {Array<*>} {@link PickerContainer} を除いたリストを返します
   */


  PickerContainer.prototype.componentsWithOutPickerContainer = function componentsWithOutPickerContainer() {
    var components = this.props.components;

    var list = Array.isArray(components) ? components : [];
    return list.filter(function (component) {
      return component.name !== 'PickerContainer';
    });
  };
  // --------------------------------------------------


  PickerContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _PickerContainer$getD = PickerContainer.getDerivedStateFromProps(this.props, this.state),
        sameFilterId = _PickerContainer$getD.sameFilterId;

    this.willChangeStateCurrent(sameFilterId);
    // filter id が変わったら slick 表示位置をリセットする
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      // console.log('PickerContainer.componentDidUpdate', sameFilterId, this.props.filterId, this.props.currentFilterId, prevProps.currentFilterId);
      this.currentFilterId = this.props.currentFilterId;
      this.initSliderProps();
      // ---
      // this.abortTrackTransition();
      // this.delayEnableTrackTransition();
      // ---
      this.resetViewSlick();
      this.resetThumbnails();
      // ---
      if (this.props.currentFilterId === this.props.filterId) {
        // const delay = this.state.didMount ? 640 : 1000;
        this.delayAbortOpacityZero(500);
      }
    }
  };

  PickerContainer.prototype.componentDidMount = function componentDidMount() {
    var _this6 = this;

    // this.enableTrackTransition();
    // this.abortOpacityZero();
    // this.timer.didMount = setTimeout(() => {
    //   this.afterMountShowSlick();
    //   this.delayAbortOpacityZero(1000);
    // }, 1000);

    this.timer.didMount = setTimeout(function () {
      _this6.afterMountShowSlick();
      _this6.delayAbortOpacityZero(16);
    }, 0);
  };

  PickerContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    // clear timer
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
  };

  // --------------------------------------------------
  // title


  PickerContainer.prototype.renderTitle = function renderTitle() {
    var _this7 = this;

    var _props3 = this.props,
        title = _props3.title,
        filterId = _props3.filterId,
        hasSecond = _props3.hasSecond;


    if (!title) {
      return null;
    }

    // const {
    //   activateCurrent,
    // } = this.state;

    var _PickerContainer$getD2 = PickerContainer.getDerivedStateFromProps(this.props, this.state),
        sameFilterId = _PickerContainer$getD2.sameFilterId;
    // const activateCurrent = sameFilterId;


    var selectedClass = sameFilterId ? 'PickerContainer__title__selected' : '';
    var hasSecondClass = hasSecond ? 'PickerContainer__title__has_child' : '';
    // console.log('PickerContainer.renderTitle', filterId, this.props.currentFilterId, activateCurrent);

    var titleHtml = title || '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'PickerContainer__title PickerContainer__title-' + filterId + ' ' + selectedClass + ' ' + hasSecondClass,
      role: 'presentation',
      onClick: this.onClickTitle,
      dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(titleHtml) },
      ref: function ref(component) {
        return _this7.refTitle = component;
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 894
      }
    });
  };

  // --------------------------------------------------
  // thumbnail


  PickerContainer.prototype.renderThumbnailSlickMb = function renderThumbnailSlickMb(components) {
    var _this8 = this;

    var _props4 = this.props,
        filterId = _props4.filterId,
        currentFilterId = _props4.currentFilterId,
        currentPickerIndex = _props4.currentPickerIndex;
    // ---

    var settings = {
      arrows: false,
      autoplay: false,
      ref: function ref(component) {
        return _this8.slider.thumbnails.mb = component;
      },
      initialSlide: 0,
      swipeToSlide: false,

      // swipe: false,
      // touchMove: false,
      swipe: true,
      touchMove: true,

      useTransform: false,
      // ---
      variableWidth: false,
      fade: false,
      // rows: 1,
      slidesPerRow: 1,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      className: 'picker-thumbnail-slick-mb',
      beforeChange: this.onMbThumbnailBeforeChange,
      afterChange: this.onMbThumbnailAfterChange,
      waitForAnimate: false
    };
    // ---
    var didMount = this.state.didMount;

    var style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerContainer__thumb__container-mb PickerContainer__thumb__carousel', style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 944
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'PickerContainer__thumb__block',
          onTouchStart: this.onTouchStart,
          onTouchEnd: this.onTouchEnd,
          onTouchCancel: this.onTouchCancel,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 945
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerContainer__thumb__item__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 951
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            PickerSlider,
            { settings: settings, __source: {
                fileName: _jsxFileName,
                lineNumber: 952
              }
            },
            components.map(function (component, index) {
              var id = filterId + '-' + index;
              var props = Object.assign({}, component.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemThumbnail, _extends({
                key: id
              }, props, {
                pickerIndex: index,
                currentPickerId: currentFilterId + '-' + currentPickerIndex,
                pickerId: id,
                thumbnailClickCaller: _this8.onCallClickThumbnail,
                currentFilterId: currentFilterId,
                filterId: filterId,
                currentPickerIndex: currentPickerIndex,
                showMb: true,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 958
                }
              }));
            })
          )
        )
      )
    );
  };

  PickerContainer.prototype.renderThumbnailFlatMb = function renderThumbnailFlatMb(components) {
    var _this9 = this;

    var _props5 = this.props,
        filterId = _props5.filterId,
        currentFilterId = _props5.currentFilterId,
        currentPickerIndex = _props5.currentPickerIndex;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerContainer__thumb__container-mb', __source: {
          fileName: _jsxFileName,
          lineNumber: 988
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'PickerContainer__thumb__block',
          onTouchStart: this.onTouchStart,
          onTouchEnd: this.onTouchEnd,
          onTouchCancel: this.onTouchCancel,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 989
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerContainer__thumb__item__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 995
            }
          },
          components.map(function (component, index) {
            var id = filterId + '-' + index;
            var props = Object.assign({}, component.props);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemThumbnail, _extends({
              key: id
            }, props, {
              pickerIndex: index,
              currentPickerId: currentFilterId + '-' + currentPickerIndex,
              pickerId: id,
              thumbnailClickCaller: _this9.onCallClickThumbnail,
              currentFilterId: currentFilterId,
              filterId: filterId,
              currentPickerIndex: currentPickerIndex,
              showMb: true,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1001
              }
            }));
          })
        )
      )
    );
  };

  PickerContainer.prototype.renderThumbnailMb = function renderThumbnailMb(components) {
    return components.length < 3 ? this.renderThumbnailFlatMb(components) : this.renderThumbnailSlickMb(components);
  };
  // --------------------------------------------------


  PickerContainer.prototype.renderThumbnailSlickPc = function renderThumbnailSlickPc(components) {
    var _this10 = this;

    var _props6 = this.props,
        filterId = _props6.filterId,
        currentFilterId = _props6.currentFilterId,
        currentPickerIndex = _props6.currentPickerIndex;
    // ---

    var settings = {
      arrows: false,
      autoplay: false,
      ref: function ref(component) {
        return _this10.slider.thumbnails.pc = component;
      },
      // initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      className: 'picker-thumbnail-slick-pc',
      // ---
      fade: false,
      useTransform: false,
      variableWidth: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      useCSS: true,
      beforeChange: this.onPcThumbnailBeforeChange,
      afterChange: this.onPcThumbnailAfterChange,
      waitForAnimate: false
    };
    // ---
    var didMount = this.state.didMount;

    var style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    var _state = this.state,
        arrowNextClass = _state.arrowNextClass,
        arrowPrevClass = _state.arrowPrevClass;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerContainer__thumb__container-pc PickerContainer__thumb__carousel', style: style, __source: {
          fileName: _jsxFileName,
          lineNumber: 1061
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PickerContainer__thumb__block', __source: {
            fileName: _jsxFileName,
            lineNumber: 1062
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerContainer__thumb__item__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 1063
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            PickerSlider,
            { settings: settings, __source: {
                fileName: _jsxFileName,
                lineNumber: 1064
              }
            },
            components.map(function (component, index) {
              var id = filterId + '-' + index;
              var props = Object.assign({}, component.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemThumbnail, _extends({
                key: id
              }, props, {
                pickerIndex: index,
                currentPickerId: currentFilterId + '-' + currentPickerIndex,
                pickerId: id,
                thumbnailClickCaller: _this10.onCallClickThumbnail,
                currentFilterId: currentFilterId,
                filterId: filterId,
                currentPickerIndex: currentPickerIndex,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1070
                }
              }));
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PickerContainer__thumb__controls', __source: {
            fileName: _jsxFileName,
            lineNumber: 1087
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'PickerContainer__thumb__btn PickerContainer__thumb__prev ' + arrowPrevClass,
            type: 'button',
            onClick: this.onPcThumbnailClickSlickPrev,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1088
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1093
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'PickerContainer__thumb__btn PickerContainer__thumb__next ' + arrowNextClass,
            type: 'button',
            onClick: this.onPcThumbnailClickSlickNext,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1095
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1100
            }
          })
        )
      )
    );
  };

  // --------------------------------------------------


  PickerContainer.prototype.renderThumbnailFlatPc = function renderThumbnailFlatPc(components) {
    var _this11 = this;

    var _props7 = this.props,
        filterId = _props7.filterId,
        currentFilterId = _props7.currentFilterId,
        currentPickerIndex = _props7.currentPickerIndex;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerContainer__thumb__container-pc PickerContainer__thumb__container-pc__flat', __source: {
          fileName: _jsxFileName,
          lineNumber: 1116
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PickerContainer__thumb__block', __source: {
            fileName: _jsxFileName,
            lineNumber: 1117
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerContainer__thumb__item__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 1118
            }
          },
          components.map(function (component, index) {
            var id = filterId + '-' + index;
            var props = Object.assign({}, component.props);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemThumbnail, _extends({
              key: id
            }, props, {
              pickerIndex: index,
              currentPickerId: currentFilterId + '-' + currentPickerIndex,
              pickerId: id,
              thumbnailClickCaller: _this11.onCallClickThumbnail,
              currentFilterId: currentFilterId,
              filterId: filterId,
              currentPickerIndex: currentPickerIndex,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1124
              }
            }));
          })
        )
      )
    );
  };

  /**
   * pc - thumbnail component 出力します
   * - length 9 未満 - {@link PickerContainer.renderThumbnailFlatPc}
   * - 9 以上 - {@link PickerContainer.renderThumbnailSlickPc}
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {*}
   */


  PickerContainer.prototype.renderThumbnailPc = function renderThumbnailPc(components) {
    return components.length < 9 ? this.renderThumbnailFlatPc(components) : this.renderThumbnailSlickPc(components);
  };

  // --------------------------------------------------
  /**
   * thumbnail component
   * - pc / mb 出力分岐します
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {*} `div.PickerContainer__thumbnails__root`
   */


  PickerContainer.prototype.renderThumbnail = function renderThumbnail(components) {
    if (components.length <= 1) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerContainer__thumbnails__root', __source: {
          fileName: _jsxFileName,
          lineNumber: 1167
        }
      },
      this.renderThumbnailPc(components),
      this.renderThumbnailMb(components)
    );
  };

  // --------------------------------------------------
  // view
  /**
   * view slick - length 1 以外
   * @param {Array<*>} components 出力対象 {@link PickerItem} list
   * @returns {React.Element} {@link PickerSlider}
   */


  PickerContainer.prototype.renderViewSlick = function renderViewSlick(components) {
    var _this12 = this;

    var _props8 = this.props,
        filterId = _props8.filterId,
        currentFilterId = _props8.currentFilterId,
        currentPickerIndex = _props8.currentPickerIndex;

    var settings = {
      speed: 1500,
      arrows: false,
      autoplay: false,
      ref: function ref(component) {
        return _this12.slider.view = component;
      },
      fade: true,
      initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      useTransform: false,
      // ---
      variableWidth: false,
      className: filterId,
      beforeChange: this.onViewBeforeChange,
      afterChange: this.onViewAfterChange,
      waitForAnimate: false
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      PickerSlider,
      { settings: settings, __source: {
          fileName: _jsxFileName,
          lineNumber: 1206
        }
      },
      components.map(function (component, index) {
        var id = filterId + '-' + index;
        var props = Object.assign({}, component.props);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemView, _extends({
          key: id
        }, props, {
          pickerIndex: index,
          currentPickerId: currentFilterId + '-' + currentPickerIndex,
          pickerId: id,
          currentPickerIndex: currentPickerIndex,
          filterId: filterId,
          currentFilterId: currentFilterId,
          inCarousel: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1212
          }
        }));
      })
    );
  };

  /**
   * view 1個の時は slick いらない
   * */


  PickerContainer.prototype.renderViewSingle = function renderViewSingle(components) {
    var component = components[0];
    var props = Object.assign({}, component.props);
    var _props9 = this.props,
        filterId = _props9.filterId,
        currentFilterId = _props9.currentFilterId,
        currentPickerIndex = _props9.currentPickerIndex;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerContainerItemView, _extends({}, props, {
      pickerIndex: 0,
      currentPickerId: currentFilterId + '-' + currentPickerIndex,
      pickerId: filterId + '-0',
      currentPickerIndex: currentPickerIndex,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1242
      }
    }));
  };

  PickerContainer.prototype.renderView = function renderView(components) {
    return components.length === 1 ? this.renderViewSingle(components) : this.renderViewSlick(components);
  };

  // --------------------------------------------------


  PickerContainer.prototype.render = function render() {
    var _props10 = this.props,
        containerId = _props10.containerId,
        containerClass = _props10.containerClass,
        showTitle = _props10.showTitle,
        filterId = _props10.filterId,
        currentFilterId = _props10.currentFilterId,
        filterChangeOpacityClassName = _props10.filterChangeOpacityClassName;
    // ---

    if (showTitle) {
      return this.renderTitle();
    }
    // ---
    var components = this.componentsWithOutPickerContainer();
    this.components = components;
    // ---
    // console.log(`PickerContainer.render - filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, filterId, Date.now());
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1278
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PickerContainer__transition_root ' + filterChangeOpacityClassName, __source: {
            fileName: _jsxFileName,
            lineNumber: 1282
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'PickerContainer ' + filterId,
            'data-current': currentFilterId,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1283
            }
          },
          this.renderThumbnail(components),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PickerContainer__view', __source: {
                fileName: _jsxFileName,
                lineNumber: 1290
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerContainer__view__item', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1291
                }
              },
              this.renderView(components)
            )
          )
        )
      )
    );
  };

  return PickerContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // components: PropTypes.arrayOf(PropTypes.node),
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // extend
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // container filter number
  filterIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentPickerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  titleClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  thumbnailClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  filterChangeOpacityClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  abortOpacityZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  title: null,
  components: null,
  // extend
  showTitle: false,
  currentFilterId: '',
  filterId: '',
  filterIndex: -1,
  currentPickerIndex: 0,
  titleClickCaller: null,
  thumbnailClickCaller: null,
  hasSecond: false,
  filterChangeOpacityClassName: '',
  abortOpacityZero: null
}, _class.OPACITY_ZERO_CLASS_NAME = 'PickerContainer__content__opacity_0', _temp);
PickerContainer.displayName = 'PickerContainer';


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_sub_footer_navigation__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_html__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\sub-footer-navigation\\index.jsx';





var SubFooterNavigationBlock = function SubFooterNavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_sub_footer_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
SubFooterNavigationBlock.displayName = 'SubFooterNavigationBlock';
SubFooterNavigationBlock.displayName = 'SubFooterNavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_html__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(SubFooterNavigationBlock));

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_header__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_primary_navigation__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_site_search__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_global_navigation__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_my_mazda__ = __webpack_require__(155);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\header\\index.jsx';









var HeaderBlock = function HeaderBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_header__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};
HeaderBlock.displayName = 'HeaderBlock';
HeaderBlock.displayName = 'Header';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_primary_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_site_search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_global_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__containers_my_mazda__["a" /* default */]],
  mapInputToOutput: [['primaryNavigation', 'primaryNavigation'], ['siteSearch', 'siteSearch'], ['globalNavigation', 'globalNavigation'], ['myMazda', 'myMazda']]
})(HeaderBlock));

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_hero_carousel__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_hero_video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_hero_image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_related_video__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\hero-carousel\\index.jsx';









var HeroCarouselBlock = function HeroCarouselBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_hero_carousel__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};
HeroCarouselBlock.displayName = 'HeroCarouselBlock';
HeroCarouselBlock.displayName = 'HeroCarousel';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_hero_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_hero_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__containers_related_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(HeroCarouselBlock));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(40);
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var getDesc  = __webpack_require__(7).getDesc
  , isObject = __webpack_require__(9)
  , anObject = __webpack_require__(11);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(36)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
module.exports = Math.expm1 || function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(62)
  , defined   = __webpack_require__(37);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(123)
  , $export        = __webpack_require__(4)
  , redefine       = __webpack_require__(31)
  , hide           = __webpack_require__(35)
  , has            = __webpack_require__(26)
  , Iterators      = __webpack_require__(65)
  , $iterCreate    = __webpack_require__(192)
  , setToStringTag = __webpack_require__(64)
  , getProto       = __webpack_require__(7).getProto
  , ITERATOR       = __webpack_require__(12)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , methods, key;
  // Fix native
  if($native){
    var IteratorPrototype = getProto($default.call(new Base));
    // Set @@toStringTag to native iterators
    setToStringTag(IteratorPrototype, TAG, true);
    // FF fix
    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES  ? $default : getMethod(VALUES),
      keys:    IS_SET      ? $default : getMethod(KEYS),
      entries: !DEF_VALUES ? $default : getMethod('entries')
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(193)
  , defined  = __webpack_require__(37);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(12)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* unused harmony export mapKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapValues; });
/* unused harmony export mapKeysDeep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return omit; });
/* unused harmony export toPairs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return shallowEq; });
/* unused harmony export isEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(45);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/*
 **  Function to test if an object is a plain object, i.e. is constructed
 **  by the built-in Object constructor and inherits directly from Object.prototype
 **  or null. Some built-in objects pass the test, e.g. Math which is a plain object
 **  and some host or exotic objects may pass also.
 **  Modified from http://stackoverflow.com/questions/5876332/how-can-i-differentiate-between-an-object-literal-other-javascript-objects
 **  See also http://stackoverflow.com/questions/10919915/ie8-getprototypeof-method
 **
 **  @param {} obj - value to test
 **  @returns {Boolean} true if passes tests, false otherwise
 */
var isPlainObject = function isPlainObject(obj) {
  // Basic check for Type object that's not null
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
    // If Object.getPrototypeOf supported, use it
    if (typeof Object.getPrototypeOf === 'function') {
      var proto = Object.getPrototypeOf(obj);
      return proto === Object.prototype || proto === null;
    }

    // Otherwise, use internal class
    // This should be reliable as if getPrototypeOf not supported, is pre-ES5
    return Object.prototype.toString.call(obj) === '[object Object]';
  }

  // Not an object
  return false;
};

var mapKeys = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, obj) {
  return Object.keys(obj).reduce(function (result, key) {
    result[fn(key, obj[key])] = obj[key];
    return result;
  }, {});
});

var mapValues = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, obj) {
  return Object.keys(obj).reduce(function (result, key) {
    result[key] = fn(obj[key], key);
    return result;
  }, {});
});

var mapKeysDeep = function mapKeysDeep(fn) {
  return function (obj) {
    if (!isPlainObject(obj) && !Array.isArray(obj)) return obj;
    var mapper = mapKeysDeep(fn);
    return Object.keys(obj).reduce(function (result, key) {
      var val = obj[key];
      var mappedVal = val;
      if (Array.isArray(val)) mappedVal = val.map(mapper);else if (isPlainObject(val)) mappedVal = mapper(val);
      result[fn(key)] = mappedVal;
      return result;
    }, {});
  };
};

var get = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (pathSpec, obj) {
  var path = typeof pathSpec === 'string' ? pathSpec.split('.') : pathSpec;

  if (!Array.isArray(path)) {
    console.warn('Expecting path to be a string or an array of strings');
    return undefined;
  }

  var shouldPick = function shouldPick(found) {
    return (typeof found === 'undefined' ? 'undefined' : _typeof(found)) === 'object' && !Array.isArray(found) && found !== null;
  };
  var first = path[0],
      rest = path.slice(1);


  return rest.reduce(function (found, key) {
    return shouldPick(found) ? found[key] : found;
  }, obj[first]);
});

var pick = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (keys, obj) {
  return keys.reduce(function (o, key) {
    // Sometime we need to pick from special objects like Window, which in IE does not register
    // as a plain object
    if (!isPlainObject(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') o[key] = obj[key];else if (obj.hasOwnProperty(key)) o[key] = obj[key];
    return o;
  }, {});
});

var omit = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (keys, obj) {
  return Object.keys(obj).reduce(function (o, key) {
    if (!~keys.indexOf(key)) o[key] = obj[key];
    return o;
  }, {});
});

var toPairs = function toPairs(obj) {
  var isArray = Array.isArray(obj);

  return Object.keys(obj).reduce(function (pairs, key) {
    pairs.push([isArray ? parseInt(key, 10) : key, obj[key]]);
    return pairs;
  }, []);
};

var shallowEq = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (obj1, obj2) {
  var _map = [obj1, obj2].map(Object.keys),
      keys1 = _map[0],
      keys2 = _map[1];

  if (keys1.length !== keys2.length) return false;
  if (keys1.some(function (key) {
    return keys2.indexOf(key) === -1;
  })) return false;

  return keys1.every(function (key) {
    var _ref = [obj1[key], obj2[key]],
        v1 = _ref[0],
        v2 = _ref[1];

    return isNaN(v1) && isNaN(v1) ? true : v1 === v2;
  });
});

var isEmpty = function isEmpty(obj) {
  return isPlainObject(obj) ? !Object.keys(obj).length : true;
};

// !!Mutations be here, affects original object
var bindAll = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (attrs, context) {
  (Array.isArray(attrs) && attrs.length ? attrs : Object.keys(context)).filter(function (key) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(context[key]);
  }).forEach(function (key) {
    context[key] = context[key].bind(context);
  });
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vh_px_plugin_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyframes__ = __webpack_require__(528);
/* unused harmony reexport keyframes */
/* unused harmony reexport Style */




/* harmony default export */ __webpack_exports__["a"] = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_0_radium___default()({
    plugins: [__WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.mergeStyleArray, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.checkProps, __WEBPACK_IMPORTED_MODULE_1__vh_px_plugin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.resolveMediaQueries, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.resolveInteractionStyles, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.keyframes, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.visited, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.removeNestedStyles, __WEBPACK_IMPORTED_MODULE_0_radium___default.a.Plugins.checkProps]
  })(component);
});



/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleKeeper = function () {
  function StyleKeeper(userAgent) {
    _classCallCheck(this, StyleKeeper);

    this._userAgent = userAgent;
    this._listeners = [];
    this._cssSet = {};
  }

  StyleKeeper.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    if (this._listeners.indexOf(listener) === -1) {
      this._listeners.push(listener);
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        var listenerIndex = _this._listeners.indexOf(listener);
        if (listenerIndex > -1) {
          _this._listeners.splice(listenerIndex, 1);
        }
      }
    };
  };

  StyleKeeper.prototype.addCSS = function addCSS(css) {
    var _this2 = this;

    if (!this._cssSet[css]) {
      this._cssSet[css] = true;
      this._emitChange();
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        delete _this2._cssSet[css];
        _this2._emitChange();
      }
    };
  };

  StyleKeeper.prototype.getCSS = function getCSS() {
    return Object.keys(this._cssSet).join('\n');
  };

  StyleKeeper.prototype._emitChange = function _emitChange() {
    this._listeners.forEach(function (listener) {
      return listener();
    });
  };

  return StyleKeeper;
}();

exports.default = StyleKeeper;
module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hash;


// a simple djb2 hash based on hash-string:
// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
// returns a hex-encoded hash
function hash(text) {
  if (!text) {
    return '';
  }

  var hashValue = 5381;
  var index = text.length - 1;

  while (index) {
    hashValue = hashValue * 33 ^ text.charCodeAt(index);
    index -= 1;
  }

  return (hashValue >>> 0).toString(16);
}
module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(573);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvent; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var gtmEvent = function gtmEvent(_ref) {
  var gtmID = _ref.gtmID,
      _ref$gtmPayload = _ref.gtmPayload,
      gtmPayload = _ref$gtmPayload === undefined ? {} : _ref$gtmPayload;

  var newGtmPayload = gtmPayload;
  if (gtmPayload.CMSGroupGTM) {
    newGtmPayload.CMSGroupGTM = _extends({}, gtmPayload.CMSGroupGTM, {
      eventID: gtmPayload.CMSGroupGTM.id,
      pageCategory: gtmPayload.CMSGroupGTM.category,
      pageAction: gtmPayload.CMSGroupGTM.action,
      customValue: gtmPayload.CMSGroupGTM.customValue,
      version: gtmPayload.CMSGroupGTM.version
    });
  }
  return _extends({
    type: gtmID
  }, newGtmPayload);
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_SEARCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var FETCH_SEARCH = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* createRequestTypes */])('FETCH_SEARCH');

var actionTypes = {
  LOAD_INITIAL_DATA: 'LOAD_INITIAL_DATA',
  UPDATE_SEARCH_QUERY: 'UPDATE_SEARCH_QUERY',
  UPDATE_NAV_SEARCH_QUERY: 'UPDATE_NAV_SEARCH_QUERY',
  CHANGE_PAGE: 'CHANGE_PAGE',
  REQUEST_PAGE: 'REQUEST_PAGE',
  FETCH_SEARCH: FETCH_SEARCH
};

var getSiteSearch = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('search');
var getPages = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteSearch, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('pages'));
var getSiteStatus = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteSearch, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('status'));
var getNavSearchQuery = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('navQuery'));
var getQuery = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('query'));
var getSearchResults = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('results'));
var getCurrentPage = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('currentPage'));
var getPageCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('totalPage'));
var getResultsPerPage = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* pipe */])(getSiteStatus, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('resultsPerPage'));
var getPage = function getPage(page) {
  return function (state) {
    var pages = getPages(state);
    return pages[page];
  };
};
var getCurrentPageData = function getCurrentPageData(state) {
  var currentPage = getCurrentPage(state);
  return getPage(currentPage)(state);
};
var getPageResults = function getPageResults(page) {
  return function (state) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('results', getPage(page)(state));
  };
};

var getResults = function getResults(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('results', getPageResults(state));
};

var selectors = {
  getSiteStatus: getSiteStatus,
  getSearchResults: getSearchResults,
  getNavSearchQuery: getNavSearchQuery,
  getQuery: getQuery,
  getCurrentPage: getCurrentPage,
  getPageCount: getPageCount,
  getResultsPerPage: getResultsPerPage,
  getCurrentPageData: getCurrentPageData,
  getPage: getPage,
  getPageResults: getPageResults,
  getResults: getResults
};

var fetchSearch = {
  request: function request(page, query) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].REQUEST], { page: page, query: query });
  },
  success: function success(page, data) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].SUCCESS], _extends({ page: page }, data));
  },
  failure: function failure(page, error) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* action */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* requestTypes */].FAILURE], { page: page, error: error });
  }
};

var loadInitialData = function loadInitialData(query) {
  return {
    type: actionTypes.LOAD_INITIAL_DATA,
    payload: query
  };
};

var updateNavSearchQuery = function updateNavSearchQuery(query) {
  return {
    type: actionTypes.UPDATE_NAV_SEARCH_QUERY,
    payload: query
  };
};

var updateSearchQuery = function updateSearchQuery(query) {
  return {
    type: actionTypes.UPDATE_SEARCH_QUERY,
    payload: query
  };
};

var changePage = function changePage(page) {
  return {
    type: actionTypes.CHANGE_PAGE,
    payload: page
  };
};

var requestPage = function requestPage(page) {
  return {
    type: actionTypes.REQUEST_PAGE,
    payload: page
  };
};

var actionCreators = {
  loadInitialData: loadInitialData,
  updateNavSearchQuery: updateNavSearchQuery,
  updateSearchQuery: updateSearchQuery,
  changePage: changePage,
  requestPage: requestPage,
  fetchSearch: fetchSearch
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gtm_events_compare_vehicle_selector_duck__ = __webpack_require__(260);
/* unused harmony reexport compareVehicleSelectorActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gtm_events_compare_tool_duck__ = __webpack_require__(261);
/* unused harmony reexport compareToolActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtm_events_image_tout_block_duck__ = __webpack_require__(262);
/* unused harmony reexport imageToutBlockActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gtm_events_wysiwyg_content_duck__ = __webpack_require__(263);
/* unused harmony reexport wysiwygActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gtm_events_book_testdrive_duck__ = __webpack_require__(264);
/* unused harmony reexport bookTestDriveFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gtm_events_contact_us_duck__ = __webpack_require__(265);
/* unused harmony reexport getInTouchFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gtm_events_book_service_duck__ = __webpack_require__(266);
/* unused harmony reexport requestServiceFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gtm_events_postcode_popup_duck__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__gtm_events_postcode_popup_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gtm_events_outlet_store_duck__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__gtm_events_outlet_store_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gtm_events_global_nav_duck__ = __webpack_require__(269);
/* unused harmony reexport gtmGlobalNavActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gtm_events_global_footer_duck__ = __webpack_require__(270);
/* unused harmony reexport gtmGlobalFooterActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gtm_events_outlet_store_enquiry_form_duck__ = __webpack_require__(271);
/* unused harmony reexport gtmOutletStoreEnquiryFormActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gtm_events_map_search_duck__ = __webpack_require__(272);
/* unused harmony reexport gtmFindADealerActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__gtm_events_map_select_state_duck__ = __webpack_require__(273);
/* unused harmony reexport gtmMapCampaignBlockActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__gtm_events_offers_duck__ = __webpack_require__(274);
/* unused harmony reexport gtmOffersActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__gtm_events_mymazda_login_duck__ = __webpack_require__(275);
/* unused harmony reexport gtmMyMazdaLoginActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__gtm_events_recalls_block_duck__ = __webpack_require__(276);
/* unused harmony reexport gtmRecallsActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__gtm_events_mymazda_summary_duck__ = __webpack_require__(277);
/* unused harmony reexport gtmMyMazdaSummaryActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__gtm_events_feature_youtube_duck__ = __webpack_require__(278);
/* unused harmony reexport gtmFeatureYoutubeActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gtm_events_accordion_duck__ = __webpack_require__(279);
/* unused harmony reexport gtmAccordionActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gtm_events_accessory_list_duck__ = __webpack_require__(280);
/* unused harmony reexport gtmAccessoryListActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__gtm_events_in_page_navigation_duck__ = __webpack_require__(281);
/* unused harmony reexport gtmInPageNavigationActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__gtm_events_mini_configurator_duck__ = __webpack_require__(282);
/* unused harmony reexport gtmMiniConfiguratorActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__gtm_events_button_duck__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__gtm_events_button_duck__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__gtm_events_background_image_selector_duck__ = __webpack_require__(284);
/* unused harmony reexport gtmBackgroundImageSelectorActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__gtm_events_icon_tout_block_duck__ = __webpack_require__(285);
/* unused harmony reexport gtmIconToutBlockActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gtm_events_build_duck__ = __webpack_require__(286);
/* unused harmony reexport gtmBuildToolActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__gtm_events_register_interest_duck__ = __webpack_require__(287);
/* unused harmony reexport gtmRegisterInterestActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__gtm_events_search_duck__ = __webpack_require__(288);
/* unused harmony reexport gtmSearchActionTypes */































/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createEvents = function createEvents(eventDefinition, prevState, action, nextState) {
  return [].concat(eventDefinition(action, prevState, nextState)).filter(function (ifTruethy) {
    return ifTruethy;
  });
};

exports.default = createEvents;

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_function__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\hyperlink\\index.jsx';








/**
 * Hyperlink
 */
var Hyperlink = function Hyperlink(_ref) {
  var href = _ref.href,
      external = _ref.external,
      pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      onClick = _ref.onClick,
      gtmEvents = _ref.gtmEvents,
      gtmEvent = _ref.gtmEvent,
      gtm = _ref.gtm,
      children = _ref.children;

  var handleClick = function handleClick(e) {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(e);
    }
    //
    if (gtmEvents !== null && 0 <= gtmEvents.length) {
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_function__["e" /* invokeFuncs */])(gtmEvents);
    } else if (gtm !== null && gtm.category) {
      var buttonName = '';
      if (pcText !== null) {
        buttonName = pcText;
      } else {
        if (mbText !== null) {
          buttonName = mbText;
        }
      }
      gtmEvent({
        gtmID: __WEBPACK_IMPORTED_MODULE_4_store_gtm_events__["a" /* gtmButtonActionTypes */].CLICK_BUTTON,
        gtmPayload: {
          CMSGroupGTM: gtm,
          buttonName: buttonName
        }
      });
    }
  };
  //
  var getPcText = function getPcText() {
    if (pcText !== null) {
      return pcText;
    }
    return pageName !== null ? pageName : '';
  };
  var getMbText = function getMbText() {
    if (mbText !== null) {
      return mbText;
    } else {
      if (pcText !== null) {
        return pcText;
      }
    }
    return pageName !== null ? pageName : '';
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { className: 'Hyperlink',
      href: href !== null ? href : '',
      target: external === true ? '_blank' : null,
      onClick: function onClick(e) {
        handleClick(e);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'Hyperlink__text-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'Hyperlink__text-mb', __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      })
    ),
    children !== null ? children : null
  );
};
Hyperlink.displayName = 'Hyperlink';
Hyperlink.propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  gtmEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  gtm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
Hyperlink.defaultProps = {
  href: null,
  external: null,
  pageName: null,
  pcText: null,
  mbText: null,
  onClick: null,
  gtmEvents: null,
  gtm: null,
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["d" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_2_higher_order_components__["b" /* gtmEvent */])())(Hyperlink));

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pc_jsx__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mb_jsx__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\site-search\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  SiteSearch
 */
var SiteSearch = (_temp = _class = function (_Component) {
  _inherits(SiteSearch, _Component);

  function SiteSearch(props) {
    _classCallCheck(this, SiteSearch);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getMbSearchCode = function (e) {
      if (_this.props.mbSearchCode !== null) {
        return _this.props.mbSearchCode;
      } else {
        return _this.props.pcSearchCode;
      }
    };

    _this.props = props;
    return _this;
  }

  SiteSearch.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pc_jsx__["a" /* default */], {
        searchCode: this.props.pcSearchCode,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mb_jsx__["a" /* default */], {
        searchCode: this.getMbSearchCode(),
        scrollToSearchTop: this.props.scrollToSearchTop !== null ? this.props.scrollToSearchTop : null,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      })
    );
  };

  //


  return SiteSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSearchCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSearchCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scrollToSearchTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcSearchCode: null,
  mbSearchCode: null,
  scrollToSearchTop: null
}, _temp);
SiteSearch.displayName = 'SiteSearch';


/* harmony default export */ __webpack_exports__["a"] = (SiteSearch);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SiteSearch":"SiteSearch","pc":"pc","SiteSearch__container":"SiteSearch__container","SiteSearch__inner":"SiteSearch__inner","SiteSearch__code":"SiteSearch__code","button-clear":"button-clear","SiteSearch__link-open":"SiteSearch__link-open","SiteSearch__border":"SiteSearch__border","SiteSearch__link-close":"SiteSearch__link-close","open":"open","mb":"mb","sug_list":"sug_list","sug_element":"sug_element","current_element":"current_element"};

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\image-loader\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ImageLoader = (_temp = _class = function (_Component) {
  _inherits(ImageLoader, _Component);

  function ImageLoader(props) {
    _classCallCheck(this, ImageLoader);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      src: null,
      opened: false
    };
    _this.loadImage = _this.loadImage.bind(_this);
    // this.onLoaded = this.onLoaded.bind(this);
    return _this;
  }

  ImageLoader.prototype.componentWillMount = function componentWillMount() {
    if (!this.props.src) return;
    this.loadImage(this.props.src);
  };

  ImageLoader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, prevState) {
    if (!nextProps.src) return;
    if (this.props.src !== nextProps.src) {
      this.loadImage(nextProps.src);
    }
  };

  ImageLoader.prototype.loadImage = function loadImage(src) {
    var _this2 = this;

    var image = new Image();
    this.setState({
      src: null,
      opened: false
    });
    // image.removeEventListener('load', ()=> {
    //   onLoad();
    // })
    // image.addEventListener('load', ()=> {
    //   onLoad();
    // })
    // const onLoad = ()=> {
    //   this.setState({
    //     src: src,
    //     opened: true,
    //   });
    // }
    image.onload = function () {
      _this2.setState({
        src: src,
        opened: true
      });
    };
    image.src = src;
  };

  // onLoaded() {
  // }

  ImageLoader.prototype.render = function render() {

    var getRatioClass = function getRatioClass(ratio) {
      if (1 <= ratio) {
        return ' ratio100';
      } else if (0.9 <= ratio) {
        return ' ratio90';
      } else if (0.8 <= ratio) {
        return ' ratio80';
      } else if (0.7 <= ratio) {
        return ' ratio70';
      } else if (0.6 <= ratio) {
        return ' ratio60';
      } else if (0.5 <= ratio) {
        return ' ratio50';
      } else if (0.4 <= ratio) {
        return ' ratio40';
      } else if (0.3 <= ratio) {
        return ' ratio30';
      } else if (0.2 <= ratio) {
        return ' ratio20';
      } else {
        return ' ratio10';
      }
    };

    var getOpenedClass = function getOpenedClass(opened) {
      if (opened === true) {
        return ' opened';
      } else {
        return '';
      }
    };

    if (this.state.src) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'image-loader' + getRatioClass(this.props.ratio) + getOpenedClass(this.state.opened), style: { width: this.props.width }, __source: {
            fileName: _jsxFileName,
            lineNumber: 107
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'image-loader__box', style: { backgroundImage: 'url(' + this.state.src + ')', backgroundSize: this.props.backgroundSize }, __source: {
            fileName: _jsxFileName,
            lineNumber: 108
          }
        })
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'image-loader' + getRatioClass(this.props.ratio) + getOpenedClass(this.state.opened), style: { width: this.props.width }, __source: {
            fileName: _jsxFileName,
            lineNumber: 113
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'image-loader__box', __source: {
            fileName: _jsxFileName,
            lineNumber: 114
          }
        })
      );
    }
  };

  return ImageLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  width: '100%',
  ratio: 1,
  src: null,
  backgroundSize: 'cover'
}, _temp);
ImageLoader.displayName = 'ImageLoader';


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__car_navigation_link_item__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_image_loader__ = __webpack_require__(152);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\car-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/**
 *  CarNavigation
 */
var CarNavigation = (_temp = _class = function (_Component) {
  _inherits(CarNavigation, _Component);

  function CarNavigation(props) {
    _classCallCheck(this, CarNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onChangeVehicle = function (e) {
      _this.setState({
        vehicle: e.target.value
      });

      _this.applyFilter();

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */]) {
        _this.slideVehicleNavi();
        _this.props.onChange(_this.props.parentIndex);
      }
    };

    _this.slideVehicleNavi = function () {
      var checkedRadio = _this.refs.vehiclesFilter.querySelector("input[type='radio']:checked");
      var current = checkedRadio.parentNode.parentNode;
      var parent = current.parentNode;
      var currentRect = current.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();

      var children = parent.children;
      var child = void 0;
      var currentLeft = 0;
      var totalWidth = 0;
      for (var i = 0; i < parent.children.length; i++) {
        child = parent.children[i];
        totalWidth += child.getBoundingClientRect().width;
      }
      for (var _i = 0; _i < parent.children.length; _i++) {
        child = parent.children[_i];
        if (child === current) {
          break;
        }
        currentLeft += child.getBoundingClientRect().width;
      }

      var scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2;
      scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;

      if (totalWidth - scrollLeft < parentRect.width) {
        scrollLeft = totalWidth - parentRect.width;
      }

      scrollLeft = Math.floor(scrollLeft);

      clearInterval(_this.vehicleIntervalId);
      _this.vehicleIntervalId = setInterval(function () {
        if (scrollLeft - parent.scrollLeft < 0) {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1;
        } else {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1);
        }

        if (Math.abs(scrollLeft - parent.scrollLeft) < 1) {
          parent.scrollLeft = scrollLeft;
          clearInterval(_this.vehicleIntervalId);
        }
        // console.log(parent.scrollLeft, scrollLeft);
      }, 1000 / 60);
    };

    _this.onClickCarLink = function (e) {

      var date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000); //24h
      var expires = date.toGMTString();

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */]) {
        if (e.currentTarget.dataset.car_id) {
          __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].cookie = "carId=" + e.currentTarget.dataset.car_id + ";expires=" + expires + ";path=/";
        }
        if (e.currentTarget.dataset.grade_id) {
          __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].cookie = "gradeId=" + e.currentTarget.dataset.grade_id + ";expires=" + expires + ";path=/";
        }
      }

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */]) {
        __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location.href = e.currentTarget.href;
      }

      e.preventDefault();
      return false;
    };

    _this.getVehicleTabNames = function (models) {
      var vehicles = {
        'Passenger Car': [],
        'Light Car': [],
        'Special Car': [],
        'Commercial Car': [],
        'Welfare Car': []
      };

      if (models) {
        models.map(function (model, index) {
          if (model.vehicleType === 'Passenger Car' && model.vehicleTabName !== '') {
            vehicles['Passenger Car'].push(model.vehicleTabName);
          } else if (model.vehicleType === 'Light Car' && model.vehicleTabName !== '') {
            vehicles['Light Car'].push(model.vehicleTabName);
          } else if (model.vehicleType === 'Commercial Car' && model.vehicleTabName !== '') {
            vehicles['Commercial Car'].push(model.vehicleTabName);
          }

          if (model.bodyTypes && Array.isArray(model.bodyTypes)) {
            model.bodyTypes.map(function (bodyType, index) {
              if (bodyType.grades && Array.isArray(bodyType.grades)) {
                bodyType.grades.map(function (grade, index) {
                  if (grade.specialCar === true && grade.specialCarTabName && grade.specialCarTabName !== '') {
                    vehicles['Special Car'].push(grade.specialCarTabName);
                  } else if (grade.welfareCar === true && grade.welfareCarTabName && grade.welfareCarTabName !== '') {
                    vehicles['Welfare Car'].push(grade.welfareCarTabName);
                  }
                });
              }
            });
          }
        });
      }

      for (var vehicleType in vehicles) {
        if (vehicles.hasOwnProperty(vehicleType)) {
          // 重複を削除
          vehicles[vehicleType] = vehicles[vehicleType].filter(function (x, i, self) {
            return self.indexOf(x) === i;
          });
        }
      }

      return vehicles;
    };

    _this.applyFilter = function () {
      var vehicles = _this.refs.vehiclesFilter;

      if (_this.refs.cars != null && _this.refs.cars.classList != null) {
        _this.refs.cars.classList.remove('fadein');
        _this.refs.cars.style.opacity = 0;
        setTimeout(function () {
          _this.refs.cars.classList.add('fadein');
          _this.refs.cars.style.opacity = 1;
        }, 1);
      }

      var currentVehicleType = '';
      for (var i = 0; i < vehicles.vehicle.length; i++) {
        if (vehicles.vehicle[i].checked) {
          currentVehicleType = vehicles.vehicle[i].value;
          break;
        }
      }

      var models = JSON.parse(JSON.stringify(_this.props.models));
      if (models && models.length > 0) {
        var _i2 = models.length;
        loopModel: while (_i2--) {
          //車種（Passenger Car/Light Car/Commercial Car）
          if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/) && models[_i2].vehicleType !== currentVehicleType) {
            models.splice(_i2, 1);
            continue loopModel;
          }

          if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/)) {
            var bodyTypes = models[_i2].bodyTypes;
            if (bodyTypes && bodyTypes.length > 0) {
              var j = bodyTypes.length;
              loopBodyType: while (j--) {
                var bodyType = bodyTypes[j];

                if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
                  var k = bodyType.grades.length;
                  loopGrade: while (k--) {
                    var grade = bodyType.grades[k];
                    if (grade.welfareCar === true) {
                      bodyTypes.splice(j, 1);
                      continue loopBodyType;
                    }
                    if (grade.specialCar === true) {
                      bodyTypes.splice(j, 1);
                      continue loopBodyType;
                    }
                  }
                }
              }
            }
          }

          if (true) {
            var _bodyTypes = models[_i2].bodyTypes;
            if (_bodyTypes && _bodyTypes.length > 0) {
              var _j = _bodyTypes.length;
              loopBodyType: while (_j--) {
                var _bodyType = _bodyTypes[_j];
                if (_bodyType.grades && Array.isArray(_bodyType.grades) && _bodyType.grades.length > 0) {
                  var _k = _bodyType.grades.length;
                  loopGrade: while (_k--) {
                    var _grade = _bodyType.grades[_k];
                    //特別仕様車チェック
                    if (currentVehicleType.match(/Special Car/) && (_grade === null || _grade.specialCar !== true || _grade.specialCarDefaultGrade !== true)) {
                      _bodyType.grades.splice(_k, 1);
                      continue loopGrade;
                    }
                    //福祉車両チェック
                    else if (currentVehicleType.match(/Welfare Car/) && (_grade === null || _grade.welfareCar !== true || _grade.welfareCarDefaultGrade !== true)) {
                        _bodyType.grades.splice(_k, 1);
                        continue loopGrade;
                      }
                  }
                  if (_bodyType.grades.length === 0) {
                    delete _bodyType.grades;
                  }
                }
                if (currentVehicleType.match(/Special Car/) || currentVehicleType.match(/Welfare Car/)) {
                  if (!_bodyType.grades || _bodyType.grades.length === 0) {
                    _bodyTypes.splice(_j, 1);
                    continue loopBodyType;
                  }
                }
              }
            }
          }
        }
      }

      _this.setState({
        models: models
      });

      setTimeout(_this.setNamePlateHeight, 200);
    };

    _this.getTargetVehicles = function (targetNumber) {
      var models = _this.state.models;
      var vehicles = [];

      //特別仕様車・福祉車両はnumberを参照せず順番通りに取得する
      if (_this.state.vehicle.match(/Special Car|Welfare Car/)) {
        var targetIndex = targetNumber - 1;
        var bodyTypeCount = 0;
        models.map(function (model, index) {
          if (model.bodyTypes) {
            model.bodyTypes.map(function (bodyType, index) {
              if (bodyTypeCount === targetIndex) {

                var carName = void 0,
                    carCategory = void 0,
                    carPrice = void 0,
                    carFreeText = void 0,
                    carImageSrc = void 0,
                    carLinkUrl = void 0,
                    carId = void 0,
                    carGradeId = void 0;

                if (bodyType.grades) {
                  bodyType.grades.map(function (grade, index) {
                    switch (_this.state.vehicle) {
                      case 'Special Car':
                        carName = grade && grade.gradeName ? grade.gradeName : null;
                        carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                        carPrice = grade && grade.minPrice ? grade.minPrice : null;
                        carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/' + _this.format(grade.gradeId) + '/common/' + _this.format(grade.gradeId) + '_default_s.png';
                        // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                        carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                        carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                        carId = bodyType.carId ? bodyType.carId : null;
                        carGradeId = grade.gradeId ? grade.gradeId : null;
                        break;
                      case 'Welfare Car':
                        carName = grade && grade.gradeName ? grade.gradeName : null;
                        carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null;
                        carPrice = null;
                        carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/' + _this.format(grade.gradeId) + '/common/welfare_' + _this.format(grade.gradeId) + '_default_s.png';
                        // carImageSrc = '/assets-dev/Mazda6_SonicSilver.png';
                        carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                        carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                        carId = bodyType.carId ? bodyType.carId : null;
                        carGradeId = grade.gradeId ? grade.gradeId : null;
                        break;
                    }

                    vehicles.push({
                      name: carName,
                      category: carCategory,
                      price: carPrice,
                      freeText: carFreeText,
                      src: carImageSrc,
                      url: carLinkUrl,
                      carId: carId,
                      gradeId: carGradeId
                    });
                  });
                }
              }
              bodyTypeCount++;
            });
          }
        });
        return vehicles;
      }

      //乗用車／軽自動車／商用車・特装車
      models.map(function (model, index) {
        if (model.bodyTypes) {
          model.bodyTypes.map(function (bodyType, index) {
            if (bodyType.number != null && bodyType.number === targetNumber) {

              var carName = void 0,
                  carCategory = void 0,
                  carPrice = void 0,
                  carFreeText = void 0,
                  carImageSrc = void 0,
                  carLinkUrl = void 0,
                  carId = void 0,
                  carGradeId = void 0;

              if (_this.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)) {
                switch (_this.state.vehicle) {
                  case 'Passenger Car':
                  case 'Light Car':
                    carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                    carName = carName ? carName : bodyType.carId;
                    carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                    carPrice = bodyType.minPrice ? bodyType.minPrice : null;
                    carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/common/default_s.png';
                    // carImageSrc = '/assets-dev/Mazda2_DynamicBlue.png';
                    carLinkUrl = '/cars/' + _this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/?car_id=' + _this.format(bodyType.carId);
                    carFreeText = bodyType.bodyTypeFreeText ? bodyType.bodyTypeFreeText : null;
                    carId = bodyType.carId ? bodyType.carId : null;
                    carGradeId = null;
                    break;
                  case 'Commercial Car':
                    carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                    carName = carName ? carName : bodyType.carId;
                    carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                    carPrice = null;
                    carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/common/commercial_default_s.png';
                    // carImageSrc = '/assets-dev/Mazda3_MachineGrey.png';
                    carLinkUrl = '/cars/' + _this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/';
                    carFreeText = bodyType.bodyTypeFreeText ? bodyType.bodyTypeFreeText : null;
                    carId = bodyType.carId ? bodyType.carId : null;
                    carGradeId = null;
                    break;
                }

                vehicles.push({
                  name: carName,
                  category: carCategory,
                  price: carPrice,
                  freeText: carFreeText,
                  src: carImageSrc,
                  url: carLinkUrl,
                  carId: carId,
                  gradeId: carGradeId
                });
              } else if (_this.state.vehicle.match(/Special Car|Welfare Car/)) {
                if (bodyType.grades) {
                  bodyType.grades.map(function (grade, index) {
                    switch (_this.state.vehicle) {
                      case 'Special Car':
                        carName = grade && grade.gradeName ? grade.gradeName : null;
                        carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                        carPrice = grade && grade.minPrice ? grade.minPrice : null;
                        carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/' + _this.format(grade.gradeId) + '/common/' + _this.format(grade.gradeId) + '_default_s.png';
                        // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                        carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                        carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                        carId = bodyType.carId ? bodyType.carId : null;
                        carGradeId = grade.gradeId ? grade.gradeId : null;
                        break;
                      case 'Welfare Car':
                        carName = grade && grade.gradeName ? grade.gradeName : null;
                        carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null;
                        carPrice = null;
                        carImageSrc = '/globalassets/assets/cars/' + _this.format(model.modelName) + '/' + _this.format(bodyType.carId) + '/' + _this.format(bodyType.carTypeCode) + '/' + _this.format(grade.gradeId) + '/common/welfare_' + _this.format(grade.gradeId) + '_default_s.png';
                        // carImageSrc = '/assets-dev/Mazda6_SonicSilver.png';
                        carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                        carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                        carId = bodyType.carId ? bodyType.carId : null;
                        carGradeId = grade.gradeId ? grade.gradeId : null;
                        break;
                    }

                    vehicles.push({
                      name: carName,
                      category: carCategory,
                      price: carPrice,
                      freeText: carFreeText,
                      src: carImageSrc,
                      url: carLinkUrl,
                      carId: carId,
                      gradeId: carGradeId
                    });
                  });
                }
              }
            }
          });
        }
      });

      return vehicles;
    };

    _this.getTargetPageLinks = function (targetNumber) {
      var links = [];
      var pageLinks = _this.props.pageLinks;

      if (pageLinks) {
        pageLinks.map(function (pageLink, index) {
          if (_this.state.vehicle === pageLink.props.type && pageLink.props.number != null && pageLink.props.number === targetNumber) {
            links.push(pageLink);
          }
        });
      }

      return links;
    };

    _this.getVehiclesMaxNumber = function () {
      var models = _this.state.models;
      var pageLinks = _this.props.pageLinks;
      var maxNumber = 0;

      if (models) {
        models.map(function (model, index) {
          if (model.bodyTypes) {
            model.bodyTypes.map(function (bodyType, index) {
              if (bodyType.number != null) {
                maxNumber = Math.max(maxNumber, Number(bodyType.number));
              }
            });
          }
        });
      }

      if (pageLinks) {
        pageLinks.map(function (pageLink, index) {
          if (_this.state.vehicle === pageLink.props.type && pageLink.props.number != null) {
            maxNumber = Math.max(maxNumber, Number(pageLink.props.number));
          }
        });
      }

      //特別仕様車・福祉車両の場合はnumberを参照せずに総数を参照する（大きい方を採用する）
      if (_this.state.vehicle.match(/Special Car|Welfare Car/)) {
        if (models) {
          models.map(function (model, index) {
            if (model.bodyTypes) {
              model.bodyTypes.map(function (bodyType, index) {
                maxNumber = Math.max(maxNumber, Number(bodyType.number));
              });
            }
          });
        }
        if (pageLinks) {
          pageLinks.map(function (pageLink, index) {
            if (_this.state.vehicle === pageLink.props.type) {
              maxNumber = Math.max(maxNumber, Number(pageLink.props.number));
            }
          });
        }
      }

      return maxNumber;
    };

    _this.onResize = function (e) {
      _this.setNamePlateHeight();
    };

    _this.setNamePlateHeight = function () {
      var cars = void 0;
      var items = void 0,
          itemsNum = void 0;
      var namePlates = void 0,
          namePlate = void 0;
      var namePlatesNum = void 0;
      var heights = [];
      var maxHeight = 0;
      var columnNum = void 0;

      cars = _this.refs.cars;

      if (!__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] || !cars) {
        return false;
      }

      columnNum = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */] ? 2 : 5;

      items = cars.querySelectorAll('.CarNavigation__Cars__Body__Item');

      if (!items) {
        return false;
      }

      //モバイルでは空白のセルを除外する
      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */]) {
        var cleanItems = [];
        var i = items.length;
        for (var _i3 = 0; _i3 < items.length; _i3++) {
          var item = items[_i3];
          if (!item.classList.contains('CarNavigation__Cars__Body__Item--blank')) {
            cleanItems.push(item);
          }
        }
        items = cleanItems;
      }

      itemsNum = items.length;

      //全ネームプレートの高さ取得＆初期化
      for (var _i4 = 0; _i4 < itemsNum; _i4++) {
        namePlate = items[_i4].querySelector('.CarNavigation__Cars__Body__Item__Link__title');
        if (namePlate) {
          namePlate.style.height = ''; //リサイズイベントに対応するために初期化
          // heights[i] = namePlate.getBoundingClientRect().height;
          heights[_i4] = namePlate.offsetHeight;
        } else {
          heights[_i4] = null;
        }
      }

      if (_this.state.view !== 'Grid') {
        return false;
      }

      //行ごとのネームプレートの高さを最大値に揃える
      for (var _i5 = 0; _i5 < itemsNum; _i5++) {
        if (_i5 % columnNum === 0) {
          maxHeight = 0;
        }
        if (heights[_i5] != null && heights[_i5] > maxHeight) {
          maxHeight = heights[_i5];
        }

        var j = _i5;
        loop: do {
          heights[j] = heights[j] == null ? null : maxHeight;
          if (j % columnNum === 0) {
            break loop;
          }
        } while (j--);
      }

      //ネームプレートの高さをセットする
      for (var _i6 = 0; _i6 < itemsNum; _i6++) {
        namePlate = items[_i6].querySelector('.CarNavigation__Cars__Body__Item__Link__title');
        // console.log(i, heights[i]);
        if (namePlate) {
          namePlate.style.height = heights[_i6] + 'px';
        }
      }
    };

    _this.format = function (str) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(String(str).toLowerCase().split(' ').join('-'));
    };

    _this.inArray = function (array, val) {
      if (!Array.isArray(array)) {
        return false;
      }
      if (array.indexOf(val) >= 0) {
        return true;
      } else {
        return false;
      }
    };

    _this.props = props;
    _this.state = {
      vehicle: 'Passenger Car',
      view: 'Grid',
      models: null
    };
    _this.onChangeVehicle = _this.onChangeVehicle.bind(_this);

    _this.vehicleIntervalId;

    return _this;
  }

  CarNavigation.prototype.componentDidMount = function componentDidMount() {
    //console.log('[DidMount]', this.state);

    this.setState({
      vehicle: 'Passenger Car',
      view: 'Grid',
      models: null
    });

    // setTimeout(this.applyFilter, 100);
    this.applyFilter();
  };

  CarNavigation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        link = _props.link,
        pageLinks = _props.pageLinks,
        commonLinks = _props.commonLinks,
        models = _props.models;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'CarNavigation', ref: 'CarNavigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 120
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarNavigation__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 121
            }
          },
          function () {
            var vehicles = _this2.getVehicleTabNames(models);

            if (vehicles) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { className: "CarNavigation__VehiclesForm", name: 'vehiclesFilter', ref: 'vehiclesFilter', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 127
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'CarNavigation__VehiclesForm__List', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 128
                    }
                  },
                  function () {
                    if (vehicles['Passenger Car'] && Array.isArray(vehicles['Passenger Car'])) {
                      return vehicles['Passenger Car'].map(function (name, index) {
                        {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__VehiclesForm__List__Item', key: 'PassengerCar' + index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 135
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'CarNavigation__VehiclesForm__List__Item__Label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 135
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarNavigation__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Passenger Car', checked: _this2.state.vehicle === 'Passenger Car', onChange: _this2.onChangeVehicle, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 135
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'CarNavigation__VehiclesForm__List__Item__Label__Text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 135
                                  }
                                },
                                name
                              )
                            )
                          );
                        }
                      });
                    }
                  }(),
                  function () {
                    if (vehicles['Light Car'] && Array.isArray(vehicles['Light Car'])) {
                      return vehicles['Light Car'].map(function (name, index) {
                        {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__VehiclesForm__List__Item', key: 'LightCar' + index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 148
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'CarNavigation__VehiclesForm__List__Item__Label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 148
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarNavigation__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Light Car', checked: _this2.state.vehicle === 'Light Car', onChange: _this2.onChangeVehicle, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 148
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'CarNavigation__VehiclesForm__List__Item__Label__Text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 148
                                  }
                                },
                                name
                              )
                            )
                          );
                        }
                      });
                    }
                  }(),
                  function () {
                    if (vehicles['Special Car'] && Array.isArray(vehicles['Special Car'])) {
                      return vehicles['Special Car'].map(function (name, index) {
                        {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__VehiclesForm__List__Item', key: 'SpecialCar' + index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 161
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'CarNavigation__VehiclesForm__List__Item__Label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 161
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarNavigation__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Special Car', checked: _this2.state.vehicle === 'Special Car', onChange: _this2.onChangeVehicle, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 161
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'CarNavigation__VehiclesForm__List__Item__Label__Text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 161
                                  }
                                },
                                name
                              )
                            )
                          );
                        }
                      });
                    }
                  }(),
                  function () {
                    if (vehicles['Commercial Car'] && Array.isArray(vehicles['Commercial Car'])) {
                      return vehicles['Commercial Car'].map(function (name, index) {
                        {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__VehiclesForm__List__Item', key: 'CommercialCar' + index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 174
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'CarNavigation__VehiclesForm__List__Item__Label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 174
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarNavigation__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Commercial Car', checked: _this2.state.vehicle === 'Commercial Car', onChange: _this2.onChangeVehicle, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 174
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'CarNavigation__VehiclesForm__List__Item__Label__Text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 174
                                  }
                                },
                                name
                              )
                            )
                          );
                        }
                      });
                    }
                  }(),
                  function () {
                    if (vehicles['Welfare Car'] && Array.isArray(vehicles['Welfare Car'])) {
                      return vehicles['Welfare Car'].map(function (name, index) {
                        {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__VehiclesForm__List__Item', key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 187
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'CarNavigation__VehiclesForm__List__Item__Label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 187
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarNavigation__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Welfare Car', checked: _this2.state.vehicle === 'Welfare Car', onChange: _this2.onChangeVehicle, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 187
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'CarNavigation__VehiclesForm__List__Item__Label__Text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 187
                                  }
                                },
                                name
                              )
                            )
                          );
                        }
                      });
                    }
                  }()
                )
              );
            }
          }(),
          function () {
            if (_this2.state.models) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: "CarNavigation__Cars CarNavigation__Cars--" + _this2.state.view,
                  ref: 'cars',
                  onTransitionEnd: function onTransitionEnd(e) {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 203
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'CarNavigation__Cars__Body', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 210
                    }
                  },
                  function () {

                    var vehicles = [];
                    var links = [];
                    var currentNumber = 1;
                    var maxNumber = _this2.getVehiclesMaxNumber();
                    var listItems = [];

                    // make list items
                    while (currentNumber <= maxNumber) {
                      vehicles = _this2.getTargetVehicles(currentNumber);
                      links = _this2.getTargetPageLinks(currentNumber);
                      if (vehicles && vehicles.length > 0) {
                        vehicles.map(function (vehicle, index) {
                          listItems.push(
                          // <li className="CarNavigation__Cars__Body__Item" key={'vehicle' + currentNumber + '_' + index}>
                          // <li className="CarNavigation__Cars__Body__Item" key={vehicle.category + '_' + currentNumber + '_' + index}>
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: "CarNavigation__Cars__Body__Item " + 'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000), key: 'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000), __source: {
                                fileName: _jsxFileName,
                                lineNumber: 228
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'a',
                              {
                                href: vehicle.url,
                                className: "CarNavigation__Cars__Body__Item__Link" + (!vehicle.url ? ' CarNavigation__Cars__Body__Item__Link--disabled' : ''),
                                onClick: _this2.onClickCarLink,
                                'data-car_id': vehicle.carId,
                                'data-grade_id': vehicle.gradeId,
                                disabled: !vehicle.url ? 'disabled' : null,
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 229
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_image_loader__["a" /* default */], {
                                width: '90%',
                                ratio: 0.5,
                                src: vehicle.src,
                                backgroundSize: 'contain',
                                key: 'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000),
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 238
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarNavigation__Cars__Body__Item__Link__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 254
                                  }
                                },
                                vehicle.name ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarNavigation__Cars__Body__Item__Link__title', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(vehicle.name) }, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 255
                                  }
                                }) : null,
                                vehicle.category ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  { className: 'CarNavigation__Cars__Body__Item__Link__category', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 256
                                    }
                                  },
                                  vehicle.category
                                ) : null,
                                vehicle.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  { className: 'CarNavigation__Cars__Body__Item__Link__price', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 257
                                    }
                                  },
                                  '\xA5',
                                  Number(vehicle.price).toLocaleString(),
                                  '\u301C\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                                ) : null,
                                vehicle.freeText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  { className: 'CarNavigation__Cars__Body__Item__Link__free-text', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 258
                                    }
                                  },
                                  vehicle.freeText
                                ) : null
                              )
                            )
                          ));
                        });
                      } else if (links && links.length > 0) {
                        links.map(function (link, index) {
                          var props = Object.assign({}, link.props);
                          listItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'CarNavigation__Cars__Body__Item', key: 'link' + currentNumber + '_' + index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 269
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__car_navigation_link_item__["a" /* default */], _extends({}, props, {
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 270
                              }
                            }))
                          ));
                        });
                      } else {
                        if (_this2.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)) {
                          listItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarNavigation__Cars__Body__Item CarNavigation__Cars__Body__Item--blank', key: 'blank' + currentNumber, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 280
                            }
                          }));
                        }
                      }
                      currentNumber++;
                    }
                    return listItems;
                  }()
                )
              );
            }
          }(),
          function () {
            if (commonLinks) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarNavigation__commonLinks', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 298
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'CarNavigation__commonLinks__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 299
                    }
                  },
                  commonLinks.map(function (data, index) {
                    var props = Object.assign({}, data.props);
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarNavigation__commonLinks__list__item', key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 304
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cta__["a" /* default */], _extends({}, props, {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 305
                        }
                      }))
                    );
                  })
                )
              );
            }
          }()
        )
      )
    );
  };

  return CarNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  pageLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  commonLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    modelNameJa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vehicleType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vehicleTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeFreeText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      minPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      grades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        specialCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        welfareCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        weflareCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        welfareCarTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeFreeText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        specialCarDefaultGrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        welfareCarDefaultGrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        carLineupUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
      }))
    }))
  })),
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  parentIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  link: null,
  pageLinks: null,
  commonLinks: null,
  models: null
}, _temp);
CarNavigation.displayName = 'CarNavigation';


/* harmony default export */ __webpack_exports__["a"] = (CarNavigation);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\car-navigation-link-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  CarNavigationLinkItem
 */
var CarNavigationLinkItem = (_temp = _class = function (_Component) {
  _inherits(CarNavigationLinkItem, _Component);

  function CarNavigationLinkItem(props) {
    _classCallCheck(this, CarNavigationLinkItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  CarNavigationLinkItem.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        type = _props.type,
        label = _props.label,
        url = _props.url,
        external = _props.external,
        pcSrc = _props.pcSrc,
        mbSrc = _props.mbSrc,
        number = _props.number;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarNavigationLinkItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        function () {
          if (pcSrc && pcSrc !== '' || mbSrc && mbSrc !== '') {
            var mbSrcFix = mbSrc ? mbSrc : pcSrc;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarNavigationLinkItem__container CarNavigationLinkItem__container--image', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 62
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  href: url && url !== '' ? url : null,
                  target: external ? '_blank' : null,
                  className: 'CarNavigationLinkItem__container__link',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 63
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'CarNavigationLinkItem__container__link__image__container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 68
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pcSrc, className: 'CarNavigationLinkItem__container__link__image CarNavigationLinkItem__container__link__image--pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 69
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: mbSrcFix, className: 'CarNavigationLinkItem__container__link__image CarNavigationLinkItem__container__link__image--mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 70
                    }
                  })
                ),
                label && label !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarNavigationLinkItem__container__link__label', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 72
                    }
                  },
                  label
                ) : ''
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarNavigationLinkItem__container CarNavigationLinkItem__container--noimage', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 79
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  href: url && url !== '' ? url : null,
                  target: external ? '_blank' : null,
                  className: 'CarNavigationLinkItem__container__link',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 80
                  }
                },
                label && label !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarNavigationLinkItem__container__link__label', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 85
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CarNavigationLinkItem__container__link__label__text', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 85
                      }
                    },
                    label
                  )
                ) : ''
              )
            );
          }
        }()
      )
    );
  };

  return CarNavigationLinkItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  type: null,
  label: null,
  url: null,
  external: null,
  pcSrc: null,
  mbSrc: null,
  number: null
}, _temp);
CarNavigationLinkItem.displayName = 'CarNavigationLinkItem';


/* harmony default export */ __webpack_exports__["a"] = (CarNavigationLinkItem);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_environment__ = __webpack_require__(5);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\my-mazda\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * MyMazda
 */
var MyMazda = (_temp = _class = function (_Component) {
  _inherits(MyMazda, _Component);

  function MyMazda(props) {
    _classCallCheck(this, MyMazda);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.close = function () {
      _this.setState({
        opened: false
      });
    };

    _this.getName = function () {
      if (_this.props.myMazdaName && _this.props.myMazdaName !== '') {

        // 名前が41文字以上の場合は改行
        if (41 <= _this.props.myMazdaName.length) {
          var name = _this.props.myMazdaName;
          var a = name.slice(0, 40);
          var b = '|';
          var c = name.slice(40);
          return a + b + c + ' 様 ';
        }

        return _this.props.myMazdaName + ' 様 ';
      }
      // if (this.state.name && this.state.name !== '') {
      //   return this.state.name + ' 様 '
      // }
      return '';
    };

    _this.getText = function (pc, mb) {
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


      var getPcText = function getPcText() {
        if (pc !== null && pc !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'MyMazda__text-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 325
              }
            },
            getBorderText(name + pc)
          );
        }
        if (name !== null && name !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'MyMazda__text-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 330
              }
            },
            name
          );
        }
        return null;
      };

      var getMbText = function getMbText() {
        if (mb !== null && mb !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'MyMazda__text-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 339
              }
            },
            getBorderText(name + mb)
          );
        } else {
          if (pc !== null && pc !== '') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'MyMazda__text-mb', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 344
                }
              },
              getBorderText(name + pc)
            );
          }
        }
        if (name !== null && name !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'MyMazda__text-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 350
              }
            },
            name
          );
        }
        return null;
      };

      var getBorderText = function getBorderText(val) {
        if (val.indexOf('|')) {
          var arr = val.split('|');
          return arr.map(function (val2, i) {
            if (i < arr.length - 1) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                { key: i, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 362
                  }
                },
                val2,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 362
                  }
                })
              );
            } else {
              return val2;
            }
          });
        } else {
          return val;
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 374
          }
        },
        getPcText(),
        getMbText()
      );
    };

    _this.getIcon = function (cls, pc, mb) {

      var getPcIcon = function getPcIcon() {
        if (pc !== null && pc !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: cls + ' MyMazda__icon-pc', src: pc, alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 387
            }
          });
        }
        return null;
      };

      var getMbIcon = function getMbIcon() {
        if (mb !== null && mb !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: cls + ' MyMazda__icon-mb', src: mb, alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 396
            }
          });
        } else {
          if (pc !== null && pc !== '') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: cls + ' MyMazda__icon-mb', src: pc, alt: '', __source: {
                fileName: _jsxFileName,
                lineNumber: 401
              }
            });
          }
        }
        return null;
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 409
          }
        },
        getPcIcon(),
        getMbIcon()
      );
    };

    _this.handleClick = function (e) {
      e.preventDefault();
      if (_this.state.opened) {
        _this.setState({
          opened: false
        });
        // BODYのスクロール無効化を解除
        __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].clearUnScroll();
        //
        if (_this.props.onClosed) {
          _this.props.onClosed();
        }
      } else {
        _this.setState({
          opened: true
        });
        // BODYのスクロール無効化
        __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].setUnScrollMb();
        //
        if (_this.props.onOpened) {
          _this.props.onOpened();
        }
      }
    };

    _this.getUserId = function () {
      if (!__WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */] || !__WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].cookie) {
        return false;
      }
      var cookies = document.cookie;
      var arr = cookies.split(';');
      for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var c = _ref;

        var arr2 = c.split('=');
        if (arr2[0].match(/\mmuid/)) {
          return arr2[1];
        }
      }
    };

    _this.getTarget = function (target) {
      if (target === 'External') {
        return '_blank';
      }
      return '_self';
    };

    _this.getIsEmptyTextClass = function (pc, mb) {
      var arr = [];
      if (!pc || pc === '') {
        arr.push('MyMazda__no-text-pc');
      }
      if (!mb || mb === '') {
        if (!pc || pc === '') {
          arr.push('MyMazda__no-text-mb');
        }
      }
      return ' ' + arr.join(' ');
    };

    _this.getIsEmptyIconClass = function (pc, mb) {
      var arr = [];
      if (!pc || pc === '') {
        arr.push('MyMazda__no-icon-pc');
      }
      if (!mb || mb === '') {
        if (!pc || pc === '') {
          arr.push('MyMazda__no-icon-mb');
        }
      }
      return ' ' + arr.join(' ');
    };

    _this.getIsEmptyLinksClassPc = function () {
      if (_this.state.login) {
        if ((!_this.props.myMazdaLink.pcText || _this.props.myMazdaLink.pcText === '') && (!_this.props.myMazdaLink.pcIconSrc || _this.props.myMazdaLink.pcIconSrc === '') && (!_this.props.logoutLink.pcText || _this.props.logoutLink.pcText === '') && (!_this.props.logoutLink.pcIconSrc || _this.props.logoutLink.pcIconSrc === '')) {
          return ' MyMazda__no-links-pc';
        }
      } else {
        if ((!_this.props.registrationLink.pcText || _this.props.registrationLink.pcText === '') && (!_this.props.registrationLink.pcIconSrc || _this.props.registrationLink.pcIconSrc === '') && (!_this.props.loginLink.pcText || _this.props.loginLink.pcText === '') && (!_this.props.loginLink.pcIconSrc || _this.props.loginLink.pcIconSrc === '')) {
          return ' MyMazda__no-links-pc';
        }
      }
      return '';
    };

    _this.getIsEmptyLinksClassMb = function () {
      if (_this.state.login) {
        if ((!_this.props.myMazdaLink.mbText || _this.props.myMazdaLink.mbText === '') && (!_this.props.myMazdaLink.pcText || _this.props.myMazdaLink.pcText === '') && (!_this.props.myMazdaLink.mbIconSrc || _this.props.myMazdaLink.mbIconSrc === '') && (!_this.props.myMazdaLink.pcIconSrc || _this.props.myMazdaLink.pcIconSrc === '') && (!_this.props.logoutLink.mbText || _this.props.logoutLink.mbText === '') && (!_this.props.logoutLink.pcText || _this.props.logoutLink.pcText === '') && (!_this.props.logoutLink.mbIconSrc || _this.props.logoutLink.mbIconSrc === '') && (!_this.props.logoutLink.pcIconSrc || _this.props.logoutLink.pcIconSrc === '')) {
          return ' MyMazda__no-links-mb';
        }
      } else {
        if ((!_this.props.registrationLink.mbText || _this.props.registrationLink.mbText === '') && (!_this.props.registrationLink.pcText || _this.props.registrationLink.pcText === '') && (!_this.props.registrationLink.mbIconSrc || _this.props.registrationLink.mbIconSrc === '') && (!_this.props.registrationLink.pcIconSrc || _this.props.registrationLink.pcIconSrc === '') && (!_this.props.loginLink.mbText || _this.props.loginLink.mbText === '') && (!_this.props.loginLink.pcText || _this.props.loginLink.pcText === '') && (!_this.props.loginLink.mbIconSrc || _this.props.loginLink.mbIconSrc === '') && (!_this.props.loginLink.pcIconSrc || _this.props.loginLink.pcIconSrc === '')) {
          return ' MyMazda__no-links-mb';
        }
      }
      return '';
    };

    _this.getIsHideNameClass = function () {
      if (_this.props.myMazdaLink.hideName) {
        return ' MyMazda__hide-name';
      }
      return '';
    };

    _this.props = props;
    _this.state = {
      mounted: false,
      login: false,
      uid: null,
      opened: false
      // name: null,
    };
    //
    _this.hostname = null;
    _this.href = null;
    if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.hostname && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href) {
      _this.hostname = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.hostname || null;
      _this.href = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href || null;
    }
    return _this;
  }

  MyMazda.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true
    });
    // ユーザID取得
    var uid = this.getUserId();
    if (uid && uid !== '') {
      // ログイン
      this.setState({
        uid: uid,
        login: true
      });
      // if (!this.props.myMazdaLink.hideName) {
      //   // MyMazda Webログインユーザー氏名取得
      //   this.apiAccessLoginUserName(uid).then((value)=> {
      //     // ログイン
      //     this.setState({
      //       name: value,
      //     })
      //   });
      // }
    } else {
      // ログアウト
      this.setState({
        uid: null,
        login: false
      });
    }
  };

  MyMazda.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      mounted: false
    });
  };

  MyMazda.prototype.render = function render() {
    var _this2 = this;

    // ログインステータス
    var renderStatus = function renderStatus() {
      if (_this2.state.login) {
        // 既ログイン
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'MyMazda__link' + _this2.getIsEmptyLinksClassPc() + _this2.getIsEmptyLinksClassMb() + _this2.getIsEmptyTextClass(_this2.props.loginStatus.pcText, _this2.props.loginStatus.mbText) + _this2.getIsEmptyIconClass(_this2.props.loginStatus.pcIconSrc, _this2.props.loginStatus.mbIconSrc), href: '#', onClick: function onClick(e) {
              _this2.handleClick(e);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 137
              }
            },
            _this2.getText(_this2.props.loginStatus.pcText, _this2.props.loginStatus.mbText)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 138
              }
            },
            _this2.getIcon('MyMazda__icon', _this2.props.loginStatus.pcIconSrc, _this2.props.loginStatus.mbIconSrc)
          )
        );
      } else {
        // 未ログイン
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'MyMazda__link' + _this2.getIsEmptyLinksClassPc() + _this2.getIsEmptyLinksClassMb() + _this2.getIsEmptyTextClass(_this2.props.logoutStatus.pcText, _this2.props.logoutStatus.mbText) + _this2.getIsEmptyIconClass(_this2.props.logoutStatus.pcIconSrc, _this2.props.logoutStatus.mbIconSrc), href: '#', onClick: function onClick(e) {
              _this2.handleClick(e);
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 144
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 147
              }
            },
            _this2.getText(_this2.props.logoutStatus.pcText, _this2.props.logoutStatus.mbText)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 148
              }
            },
            _this2.getIcon('MyMazda__icon', _this2.props.logoutStatus.pcIconSrc, _this2.props.logoutStatus.mbIconSrc)
          )
        );
      }
    };

    // ログインリンク
    var renderLoginLink = function renderLoginLink() {
      if (!_this2.state.login) {
        // 未ログイン
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: _this2.getIsEmptyTextClass(_this2.props.loginLink.pcText, _this2.props.loginLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.loginLink.pcIconSrc, _this2.props.loginLink.mbIconSrc), __source: {
              fileName: _jsxFileName,
              lineNumber: 159
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MyMazda__link2' + _this2.getIsEmptyTextClass(_this2.props.loginLink.pcText, _this2.props.loginLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.loginLink.pcIconSrc, _this2.props.loginLink.mbIconSrc), href: '#', onClick: function onClick(e) {
                e.preventDefault();
                //
                if (_this2.hostname && _this2.href) {
                  var str = void 0;
                  // if (0 <= String(this.hostname).indexOf('localhost') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp')) {
                  // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
                  if (_this2.hostname && (0 <= String(_this2.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(_this2.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(_this2.hostname).indexOf('.test.mazda.jp'))) {
                    str = 'https://my-mazda-co-jp.test.mazda.jp/login';
                  } else {
                    str = 'https://my.mazda.co.jp/login';
                  }
                  // str += '?target=' + encodeURIComponent(this.href);
                  if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href) __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href = str;
                }
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            },
            _this2.getText(_this2.props.loginLink.pcText, _this2.props.loginLink.mbText),
            _this2.getIcon('MyMazda__icon2', _this2.props.loginLink.pcIconSrc, _this2.props.loginLink.mbIconSrc)
          )
        );
      }
      return null;
    };

    // 新規会員登録リンク
    var renderRegistrationLink = function renderRegistrationLink() {
      if (!_this2.state.login) {
        // 未ログイン
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: _this2.getIsEmptyTextClass(_this2.props.registrationLink.pcText, _this2.props.registrationLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.registrationLink.pcIconSrc, _this2.props.registrationLink.mbIconSrc), __source: {
              fileName: _jsxFileName,
              lineNumber: 190
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MyMazda__link2 MyMazda__link2--white' + _this2.getIsEmptyTextClass(_this2.props.registrationLink.pcText, _this2.props.registrationLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.registrationLink.pcIconSrc, _this2.props.registrationLink.mbIconSrc), href: _this2.props.registrationLink.href, target: _this2.getTarget(_this2.props.registrationLink.target), __source: {
                fileName: _jsxFileName,
                lineNumber: 191
              }
            },
            _this2.getText(_this2.props.registrationLink.pcText, _this2.props.registrationLink.mbText),
            _this2.getIcon('MyMazda__icon2', _this2.props.registrationLink.pcIconSrc, _this2.props.registrationLink.mbIconSrc)
          )
        );
      }
      return null;
    };

    // MyMazdaリンク
    var renderMyMazdaLink = function renderMyMazdaLink() {
      if (_this2.state.login) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: 'MyMazda__list-item--my-mazda' + _this2.getIsHideNameClass() + _this2.getIsEmptyTextClass(_this2.props.myMazdaLink.pcText, _this2.props.myMazdaLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.myMazdaLink.pcIconSrc, _this2.props.myMazdaLink.mbIconSrc), __source: {
              fileName: _jsxFileName,
              lineNumber: 205
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MyMazda__link2 MyMazda__link2--white MyMazda__link2--my-mazda' + _this2.getIsHideNameClass() + _this2.getIsEmptyTextClass(_this2.props.myMazdaLink.pcText, _this2.props.myMazdaLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.myMazdaLink.pcIconSrc, _this2.props.myMazdaLink.mbIconSrc), href: _this2.props.myMazdaLink.href, target: _this2.getTarget(_this2.props.myMazdaLink.target), __source: {
                fileName: _jsxFileName,
                lineNumber: 206
              }
            },
            _this2.getText(_this2.props.myMazdaLink.pcText, _this2.props.myMazdaLink.mbText, _this2.getName()),
            _this2.getIcon('MyMazda__icon2', _this2.props.myMazdaLink.pcIconSrc, _this2.props.myMazdaLink.mbIconSrc)
          )
        );
      }
      return null;
    };

    // ログアウトリンク
    var renderLogoutLink = function renderLogoutLink() {
      if (_this2.state.login) {
        // 既ログイン
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: _this2.getIsEmptyTextClass(_this2.props.logoutLink.pcText, _this2.props.logoutLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.logoutLink.pcIconSrc, _this2.props.logoutLink.mbIconSrc), __source: {
              fileName: _jsxFileName,
              lineNumber: 221
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MyMazda__link2 ' + _this2.getIsEmptyTextClass(_this2.props.logoutLink.pcText, _this2.props.logoutLink.mbText) + _this2.getIsEmptyIconClass(_this2.props.logoutLink.pcIconSrc, _this2.props.logoutLink.mbIconSrc), href: '#', onClick: function onClick(e) {
                e.preventDefault();
                //
                if (_this2.hostname && _this2.href) {
                  var str = void 0;
                  // if (0 <= String(this.hostname).indexOf('localhost') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp')) {
                  // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
                  if (_this2.hostname && (0 <= String(_this2.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(_this2.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(_this2.hostname).indexOf('.test.mazda.jp'))) {
                    str = 'https://my-mazda-co-jp.test.mazda.jp/logout';
                  } else {
                    str = 'https://my.mazda.co.jp/logout';
                  }
                  str += '?target=' + encodeURIComponent(_this2.href);
                  if (_this2.state.uid && _this2.state.uid !== '') {
                    str += '&id=' + _this2.state.uid;
                  }
                  if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href) __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].location.href = str;
                }
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 222
              }
            },
            _this2.getText(_this2.props.logoutLink.pcText, _this2.props.logoutLink.mbText),
            _this2.getIcon('MyMazda__icon2', _this2.props.logoutLink.pcIconSrc, _this2.props.logoutLink.mbIconSrc)
          )
        );
      }
      return null;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 251
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'MyMazda', __source: {
            fileName: _jsxFileName,
            lineNumber: 255
          }
        },
        function () {
          if (_this2.state.opened) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'MyMazda__bg', onClick: function onClick(e) {
                  _this2.handleClick(e);
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 259
                }
              },
              '\xA0'
            );
          } else {
            return null;
          }
        }(),
        function () {
          if (_this2.state.mounted) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'MyMazda__status' + (_this2.state.opened ? ' hide' : ''), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 270
                }
              },
              renderStatus()
            );
          } else {
            return null;
          }
        }(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MyMazda__container' + (this.state.opened ? ' opened' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 278
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'MyMazda__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 279
              }
            },
            renderLoginLink(),
            renderRegistrationLink(),
            renderMyMazdaLink(),
            renderLogoutLink()
          )
        )
      )
    );
  };

  // 閉じる


  // 名前取得


  // テキスト取得


  // アイコン取得


  // OPEN / CLOSE


  // ユーザID取得


  // ターゲット取得


  // テキストの有無で非表示にするクラスを付与


  // アイコンの有無で余白を調整するクラスを付与


  // リンクの有無によってプルダウンメニューを非表示にするクラスを付与


  // リンクの有無によってプルダウンメニューを非表示にするクラスを付与


  // 名前を非表示に


  return MyMazda;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  logoutStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  loginStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  loginLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  registrationLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  myMazdaLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hideName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  logoutLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  logoutStatus: null,
  loginStatus: null,
  loginLink: null,
  registrationLink: null,
  myMazdaLink: null,
  logoutLink: null,
  onOpened: null,
  onClosed: null
}, _temp);
MyMazda.displayName = 'MyMazda';

/* harmony default export */ __webpack_exports__["a"] = (MyMazda);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\hero-image\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---







/**
 * BC0102HeroImage - 各ページのHeroに直接設定されるか、Hero Carousel Blockに設定されるBlock。
 * - article
 *   - section.HeroImage
 *   - figure `HeroImage__figure__block` - {@link HeroImage.figure}
 *     - {@link HeroImage.imageLink}
 *     - {@link PhotoInfo}
 *   - container `div.HeroImage__container` - {@link HeroImage.container}
 *     - {@link HeroImage.heading}
 *
 * position - `.HeroImage__container`
 * - 【PC】
 *   - Left-Upper：`.left-upper`
 *   - Left-Middle：`.left-middle`
 *   - Left-Lower：`.left-lower`
 *   - Center-Upper：`.center-upper`
 *   - Center-Middle：`.center-middle`
 *   - Center-Lower：`.center-lower`
 *   - Right-Upper：`.right-upper`
 *   - Right-Middle：`.right-middle`
 *   - Right-Lower：`.right-lower`
 * - 【MB】
 *   - Upper：`.upper-mb`
 *   - Middle：`.middle-mb`
 *   - Lower：`.lower-mb`
 *
 * text-align - `.HeroImage__container`
 * - 【PC】
 *   - left：`.align-left-pc`
 *   - center：`.align-center-pc`
 *   - right：`.align-right-pc`
 * - 【MB】
 *   - left：`.align-left-mb`
 *   - center：`.align-center-mb`
 *   - right：`.align-right-mb`
 *
 * 画像サイズ切り替え - `.HeroImage`
 * - 【PC】
 *   - Full：`.fullSize-pc`
 *   - Half：`.halfSize-pc`
 * - 【MB】
 *   - Full：`.fullSize-mb`
 *   - Half：`.halfSize-mb`
 *   - Vertical：`.verticalSize-mb`
 */
var HeroImage = (_temp = _class = function (_Component) {
  _inherits(HeroImage, _Component);

  // static getDerivedStateFromProps(props, state) {
  //     // console.log('HeroImage.getDerivedStateFromProps', props, state);
  //     if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
  //         return {
  //             prevHeroCarouselSlideId: state.heroCarouselSlideId,
  //             heroCarouselSlideId: props.heroCarouselSlideId,
  //         };
  //     }
  //     return null;
  // }
  /**
   * heading - tag + text pare を作成します
   * @param {?string} tag heading tag
   * @param {?string} label tag 内 text - `dangerous` option true の時は HTML それ以外は pure text
   * @param {string} defaultClass argument tag value が `Default` 時の代替 tag - HTML で定義されているタグを指定します
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します - 必須です
   * @param {boolean} [dangerous=false] HTML の時に `true` セットします
   * @param {string} [alternate=''] 代替データ - string
   * @param {string} [baseClass=HeroImage__heading] `tag` 引数へ付与する class name 先頭文字
   * @returns {?Element} heading tag を返します
   */
  HeroImage.headingTag = function headingTag(tag, label, defaultClass) {
    var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var dangerous = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var alternate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    var baseClass = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'HeroImage__heading';

    var labelText = label !== null && label ? label : alternate;
    if (labelText === null || !labelText) {
      return null;
    }
    // make attribute
    var attributes = {
      className: '' + baseClass + (suffix ? '__' : '') + suffix
    };
    // tag name
    var tagName = tag ? tag.toLowerCase() : 'default';
    // create element
    var Element = tagName === 'default' ? defaultClass : tagName;
    // label is plane text
    if (!dangerous) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Element,
        _extends({}, attributes, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 166
          }
        }),
        labelText
      );
    }
    // dangerous - label is HTML
    attributes.dangerouslySetInnerHTML = { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(labelText) };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element, _extends({}, attributes, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175
      }
    }));
  };

  /**
   * description tag text 作成します - {@link convertPipeToBrTag} で `|` to `<br>` 変換を行い insert します
   * @param {?string} description 説明文
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します
   * @param {string} [alternate=''] 代替データ - string
   * @param {string} [baseClass=HeroImage__heading] コンテナへ付与する class name 先頭文字
   * @returns {?Element} description tag を返します
   */


  HeroImage.descriptionTag = function descriptionTag(description) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var alternate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var baseClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'HeroImage__heading';

    // // require check
    // if (description === null || !description) {
    //     return null;
    // }
    var text = description !== null && description ? description : alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    var className = '' + baseClass + (suffix ? '__' : '') + suffix;
    // ReactElement
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className + ' Wysiwyg', dangerouslySetInnerHTML: { __html: text }, __source: {
        fileName: _jsxFileName,
        lineNumber: 199
      }
    });
  };

  /**
   * CTA link tag を作成します - large lint `imageLink` と共存できないので出力時に注意します
   * @param {?{href: string, text: string, type: string, targetBlank: boolean}} link props.link object
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=HeroImage__btn__link] コンテナへ付与する class name 先頭文字
   * @returns {?Element} CTA `a` tag を返します
   */


  HeroImage.ctaTag = function ctaTag(link) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HeroImage__btn__link';

    // require check
    if (link === null || !link || !link.href || !link.text) {
      return null;
    }
    // a tag
    var type = link.type || '';
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        href: link.href,
        className: '' + baseClass + (suffix ? '-' : '') + suffix + ' ' + type,
        target: link.targetBlank ? '_blank' : '_self',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 219
        }
      },
      link.text
    );
  };

  /**
   * `HeroImage` component 初期化作業を行います
   * - {@link HeroImage.onClickInnerLink} bind します
   * @param {*} props React.props
   */


  function HeroImage(props) {
    _classCallCheck(this, HeroImage);

    /**
     * bound onClickInnerLink - button.HeroImage__btn__scroll click event handler
     * @type {bound|any}
     */
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onClickInnerLink = _this.onClickInnerLink.bind(_this);
    /**
     * mobile `Vertical` option - height 必須になるので state 管理します
     * @type {{mbHeight: ?number, entered: string}}
     */
    _this.state = {
      mbHeight: null,
      entered: '',
      heroCarouselSlideId: '',
      btnScrollClicked: ''
    };
    _this.timer = {
      btnScroll: 0,
      btnEmpty: 0,
      load: 0,
      figure: 0
    };
    /**
     * mobile `Vertical` option - height 必須になるの load 用ダミー `img` 配置する参照
     * @type {?Element}
     */
    _this.mbImg = null;
    // scroll to id
    var link = props.link;
    // href - `#HASH` なリンクがあるかをチェックする

    var href = link && link.href ? link.href : null;
    var hash = href ? href.split('#').pop() : null;
    /**
     * link.href から HASH 文字取り出す - page 内リンク sweet scroll - {@link scrollToElementId} で使用します
     * @type {?string}
     */
    _this.targetId = hash && hash !== href ? hash : null;
    /**
     * bound onLinkEnter - imageLink.onmouseenter handler
     * @type {bound|any}
     */
    _this.onLinkEnter = _this.onLinkEnter.bind(_this);
    /**
     * bound onLinkLeave- imageLink.onmouseuleave handler
     * @type {bound|any}
     */
    _this.onLinkLeave = _this.onLinkLeave.bind(_this);
    /**
     * `.hero` element
     * @type {?Element}
     */
    _this.heroElement = null;
    _this.element = {
      figure: null
    };
    _this.load = {
      pc: false,
      mb: false
    };
    _this.onResize = _this.onResize.bind(_this);
    _this.onPcLoad = _this.onPcLoad.bind(_this);
    _this.onMbLoad = _this.onMbLoad.bind(_this);
    return _this;
  }

  /**
   * button.HeroVideo__btn__scroll click event handler
   * - link.href から hash を取り出します
   * - {@link scrollToNode} で smooth scroll させます
   * - `.hero` 見切れるまで移動します
   * @param {Event} event click event - `preventDefault` します
   */


  HeroImage.prototype.onClickInnerLink = function onClickInnerLink(event) {
    event.preventDefault();
    // resize 時の移動位置がおかしくなる(scrollToNode bug?)ので毎回新規に取得する
    var heroElement = document.querySelector('.hero');
    if (heroElement) {
      this.heroElement = heroElement;
      var rect = heroElement.getBoundingClientRect();
      // console.log('HeroImage.onClickInnerLink', rect);
      var option = {
        duration: 480,
        offset: rect.height
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* scrollToNode */])(heroElement, option);
    }
    this.enableButtonScrollEffect();
  };

  HeroImage.prototype.enableButtonScrollEffect = function enableButtonScrollEffect() {
    var _this2 = this;

    clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    // clicked flag が ON の時は一度 OFF にし delay し `.HeroImage__btn__scroll__clicked` を付与する
    var delay = this.state.btnScrollClicked ? 16 : 0;
    if (delay) {
      this.setState({ btnScrollClicked: '' });
    }
    this.timer.btnEmpty = setTimeout(function () {
      _this2.delayDisposeButtonScrollEffect();
    }, delay);
  };

  HeroImage.prototype.delayDisposeButtonScrollEffect = function delayDisposeButtonScrollEffect() {
    var _this3 = this;

    this.setState({ btnScrollClicked: 'HeroImage__btn__scroll__clicked' });
    this.timer.btnScroll = setTimeout(function () {
      _this3.setState({ btnScrollClicked: '' });
    }, 1750);
  };

  /**
   * imageLink enter event handler
   * - `.ImageLink__entered` class 追加
   */


  HeroImage.prototype.onLinkEnter = function onLinkEnter() {
    this.setState({ entered: 'ImageLink__entered' });
  };

  /**
   * imageLink leave event handler
   * - `.ImageLink__entered` class 削除
   */


  HeroImage.prototype.onLinkLeave = function onLinkLeave() {
    this.setState({ entered: '' });
  };

  // -----------------------------------------------------


  HeroImage.prototype.onResize = function onResize() {
    this.getRectFigureBlock();
  };

  HeroImage.prototype.onPcLoad = function onPcLoad() {
    this.load.pc = true;
    this.getRectFigureBlock();
  };

  HeroImage.prototype.onMbLoad = function onMbLoad() {
    this.load.mb = true;
    this.getRectFigureBlock();
  };

  HeroImage.prototype.getRectFigureBlock = function getRectFigureBlock() {
    var _this4 = this;

    var _props = this.props,
        sendMessage = _props.sendMessage,
        heroCarouselUniqueId = _props.heroCarouselUniqueId;
    // console.log('HeroImage.getRectFigureBlock', heroCarouselUniqueId, heroCarouselSlideId);

    if (typeof sendMessage !== 'function') {
      return;
    }
    var _load = this.load,
        pc = _load.pc,
        mb = _load.mb;

    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    if (!pc || !mb) {
      this.timer.load = setTimeout(function () {
        _this4.getRectFigureBlock();
      }, 16);
      return;
    }
    var figure = this.element.figure;

    if (!figure) {
      this.timer.figure = setTimeout(function () {
        _this4.getRectFigureBlock();
      }, 16);
      return;
    }
    var rect = figure.getBoundingClientRect();
    sendMessage.call(this, heroCarouselUniqueId, rect);
  };

  // -----------------------------------------------------


  HeroImage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.requestMessageFlag !== this.props.requestMessageFlag) {
      this.getRectFigureBlock();
    }
  };

  HeroImage.prototype.componentDidMount = function componentDidMount() {
    var inHeroCarousel = this.props.inHeroCarousel;

    if (inHeroCarousel) {
      window.addEventListener('resize', this.onResize, false);
    }
  };

  HeroImage.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    window.removeEventListener('resize', this.onResize);
  };

  // -----------------------------------------------------
  /**
   * props `imageLink` と `link` 値をもとに - Hero全体でリンク設定するか否かのためのコンテナを作成します
   * - HeroImageRoot - `a` or `div`
   * - attributes - HeroImageRoot 属性
   * a 設定時に必要な属性を `attributes` に追加します
   * @returns {?Element} Hero全体でリンク設定するか否かのためのコンテナを返します
   */


  HeroImage.prototype.renderImageLink = function renderImageLink() {
    var _props2 = this.props,
        imageLink = _props2.imageLink,
        link = _props2.link;
    // imageLink 設定なし

    if (imageLink === null || !imageLink) {
      return null;
    }
    // link check
    // imageLink の設定有り, link property illegal なので出力しない
    if (link === null || !link.href) {
      return null;
    }
    // type を className へ
    var type = link.type || '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
      className: 'HeroImage__imageLink ' + type,
      href: link.href,
      target: link.targetBlank ? '_blank' : '_self',
      onMouseEnter: this.onLinkEnter,
      onMouseLeave: this.onLinkLeave,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 444
      }
    });
  };

  /**
   * button.HeroImage__btn__scroll Element を作成します
   * - require - link.href HASH
   * - require - scrollToSlug not null
   * - tag have to output - visible control by css class
   * - click -> onClickInnerLink -> {@link scrollToElementId}
   * @returns {?Element} button.HeroImage__btn__scroll
   */


  HeroImage.prototype.renderButtonScroll = function renderButtonScroll() {
    var scrollToSlug = this.props.scrollToSlug;
    // const id = this.targetId;
    // require check
    // if (scrollToSlug === null || !id) {

    if (scrollToSlug === null) {
      return null;
    }
    var btnScrollClicked = this.state.btnScrollClicked;
    // ---
    // output

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: 'HeroImage__btn__scroll ' + btnScrollClicked,
        type: 'button',
        onClick: this.onClickInnerLink,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 477
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 482
        }
      })
    );
  };

  // /**
  //  * mobile の背景画像 - onLoad で高さを設定します
  //  * @param {?string|*} src image path
  //  * @returns {{vertical: ?Element, img: ?Element}} mobile figure image
  //  */
  // mbVerticalBg(src) {
  //     if (src === null || !src) {
  //         return {
  //             bg: null,
  //             img: null,
  //         };
  //     }
  //     const vertical = <div className="HeroImage__figure__img HeroImage__figure__img-mb vertical" style={{backgroundImage: `url(${src})`, height: `${this.state.mbHeight}px`}} />;
  //     const img = <img
  //         src={src}
  //         alt=""
  //         style={{display: 'none'}}
  //         ref={component =>(this.mbImg = component)}
  //         onLoad={()=> {
  //             // console.log('img.onLoad', this.mbImg.height);
  //             this.setState({ mbHeight: this.mbImg.height * 0.5 });
  //         }}
  //     />;
  //     // ---
  //     return {
  //         vertical,
  //         img,
  //     };
  // }


  HeroImage.prototype.renderFigureImagePc = function renderFigureImagePc(src) {
    var inHeroCarousel = this.props.inHeroCarousel;

    var dummy = inHeroCarousel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
      src: src,
      alt: '',
      onLoad: this.onPcLoad,
      style: { display: 'none' },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 518
      }
    }) : null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroImage__figure__img HeroImage__figure__img-pc',
        style: { backgroundImage: 'url(' + src + ')' },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 525
        }
      },
      dummy
    );
  };

  HeroImage.prototype.renderFigureImageMb = function renderFigureImageMb(src) {
    var inHeroCarousel = this.props.inHeroCarousel;
    // console.log('HeroImage.renderFigureImageMb', inHeroCarousel, src);

    var dummy = inHeroCarousel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
      src: src,
      alt: '',
      onLoad: this.onMbLoad,
      style: { display: 'none' },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 537
      }
    }) : null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroImage__figure__img HeroImage__figure__img-mb',
        style: { backgroundImage: 'url(' + src + ')' },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 544
        }
      },
      dummy
    );
  };

  /**
   * figure.HeroImage__figure Element 作成します
   * @returns {?Element} figure.HeroImage__figure
   */


  HeroImage.prototype.renderFigureImage = function renderFigureImage() {
    var _props3 = this.props,
        pcSrc = _props3.pcSrc,
        mbSrc = _props3.mbSrc;
    // src exist check

    if (pcSrc === null || !pcSrc) {
      return null;
    }
    // pc - default
    var mobileSrc = mbSrc || pcSrc;
    // const pcImg = <div
    //     className="HeroImage__figure__img HeroImage__figure__img-pc"
    //     style={{backgroundImage: `url(${pcSrc})`}}
    // />;
    // const mbImg = <div
    //     className="HeroImage__figure__img HeroImage__figure__img-mb"
    //     style={{backgroundImage: `url(${mobileSrc})`}}
    // />;
    var pcImg = this.renderFigureImagePc(pcSrc);
    var mbImg = this.renderFigureImageMb(mobileSrc);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroImage__figure', __source: {
          fileName: _jsxFileName,
          lineNumber: 579
        }
      },
      pcImg,
      mbImg
    );
  };

  /**
   * {@link PhotoInfo} props 拡張します
   * @returns {?Array<ReactElement>}
   */


  HeroImage.prototype.renderPhotoInfoContainer = function renderPhotoInfoContainer() {
    var _props4 = this.props,
        photoInfo = _props4.photoInfo,
        containerId = _props4.containerId,
        photoInfoWillOpen = _props4.photoInfoWillOpen,
        photoInfoWillClose = _props4.photoInfoWillClose,
        inHeroCarousel = _props4.inHeroCarousel,
        heroCarouselSlideId = _props4.heroCarouselSlideId;
    // photoInfo - arrayOf だけど出力は1件

    var photoInfoList = photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length ? photoInfo : [];
    // PhotoInfo.props extends
    return photoInfoList.map(function (child, index) {
      // console.log('HeroImage.photoInfoContainer.map', child, child.type.displayName);
      return child.type.displayName === 'PhotoInfo' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__photo_info__["a" /* default */], _extends({
        key: 'PhotoInfo-' + child.props.containerId + '-' + index
      }, child.props, {
        parentComponentName: 'HeroImage',
        parentComponentId: containerId,
        photoInfoWillOpen: photoInfoWillOpen,
        photoInfoWillClose: photoInfoWillClose,
        inHeroCarousel: inHeroCarousel,
        heroCarouselSlideId: heroCarouselSlideId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 605
        }
      })) : null;
    });
  };

  /**
   * `pcSrc` / `spSrc` から figure tag を作成します
   * - {@link HeroImage.figureImage}
   * - {@link HeroImage.imageLink}
   * - {@link PhotoInfo}
   * @returns {?Element}
   */


  HeroImage.prototype.renderFigure = function renderFigure() {
    var _this5 = this;

    // src exit check
    var figure = this.renderFigureImage();
    // large link
    var imageLink = this.renderImageLink();
    // PhotoInfo
    var photoInfoList = this.renderPhotoInfoContainer();
    // button scroll
    var buttonScroll = this.renderButtonScroll();
    // console.log('HeroImage.figure - photoInfoList', photoInfoList);
    // output check
    if (!figure && !imageLink && !photoInfoList.length && !buttonScroll) {
      return null;
    }
    // output
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroImage__figure__block',
        ref: function ref(component) {
          return _this5.element.figure = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 641
        }
      },
      figure,
      imageLink,
      photoInfoList,
      buttonScroll
    );
  };

  /**
   * `div.HeroImage__heading` section 作成します
   * - preHeading
   * - heading
   * - description
   * @returns {?Element} `div.HeroImage__heading` を返します
   */


  HeroImage.prototype.renderHeading = function renderHeading() {
    var _props5 = this.props,
        pcPreHeading = _props5.pcPreHeading,
        mbPreHeading = _props5.mbPreHeading,
        preHeadingTag = _props5.preHeadingTag,
        pcHeading = _props5.pcHeading,
        mbHeading = _props5.mbHeading,
        headingTag = _props5.headingTag,
        pcDescription = _props5.pcDescription,
        mbDescription = _props5.mbDescription;
    // ---

    var alternate = {
      heading: pcHeading,
      pre: pcPreHeading,
      description: pcDescription
    };
    // ---
    var tags = {
      pcPre: HeroImage.headingTag(preHeadingTag, pcPreHeading, 'h3', 'pcPreHeading', true),
      pcHead: HeroImage.headingTag(headingTag, pcHeading, 'h2', 'pcHeading', true),
      mbPre: HeroImage.headingTag(preHeadingTag, mbPreHeading, 'h3', 'mbPreHeading', true, alternate.pre),
      mbHead: HeroImage.headingTag(headingTag, mbHeading, 'h2', 'mbHeading', true, alternate.heading),
      pcDescription: HeroImage.descriptionTag(pcDescription, 'pcDescription'),
      mbDescription: HeroImage.descriptionTag(mbDescription, 'mbDescription', alternate.description)
    };
    // null 以外を check
    var hasTag = Object.values(tags).some(function (tag) {
      return tag !== null;
    });
    if (!hasTag) {
      // 全て null なので処理しない
      return null;
    }
    // tag exist
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroImage__heading', __source: {
          fileName: _jsxFileName,
          lineNumber: 694
        }
      },
      tags.pcPre,
      tags.mbPre,
      tags.pcHead,
      tags.mbHead,
      tags.pcDescription,
      tags.mbDescription
    );
  };

  /**
   * `div.HeroImage__container` section 作成します
   * - pcPosition / mbPosition から css class 作成し設定します
   * - pcTextAlign / mbTextAlign から css class 作成し設定します
   * - {@link HeroImage.heading}
   * - {@link HeroImage.buttonScroll}
   * - mb - CTA
   * @returns {?Element} `div.HeroImage__container` を返します
   */


  HeroImage.prototype.renderContainer = function renderContainer() {
    var _props6 = this.props,
        pcPosition = _props6.pcPosition,
        mbPosition = _props6.mbPosition,
        pcTextAlign = _props6.pcTextAlign,
        mbTextAlign = _props6.mbTextAlign,
        link = _props6.link;
    // ---

    var heading = this.renderHeading();
    // buttons
    // // scroll
    // const buttonScroll = this.buttonScroll();
    // cta mb - large link ある時は cta 無い
    // const cta = (imageLink === null || !imageLink) ? HeroImage.ctaTag(link) : null;
    var cta = HeroImage.ctaTag(link);
    // output
    if (!heading && !cta) {
      return null;
    }
    // positions
    var positions = {
      pc: pcPosition !== null && pcPosition ? pcPosition.toLowerCase() : '',
      mb: mbPosition !== null && mbPosition ? mbPosition.toLowerCase() + '-mb' : ''
    };
    var ctaClassName = cta ? 'has-btn__link' : '';
    // align
    var alignPc = pcTextAlign !== null && pcTextAlign ? 'align-' + pcTextAlign.toLowerCase() + '-pc' : '';
    var alignMb = mbTextAlign !== null && mbTextAlign ? 'align-' + mbTextAlign.toLowerCase() + '-mb' : '';
    // tag exist
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'HeroImage__container ' + positions.pc + ' ' + positions.mb + ' ' + ctaClassName + ' ' + alignPc + ' ' + alignMb,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 746
        }
      },
      heading,
      cta
    );
  };

  /**
   * `HeroImage` Element - props `null` check 後に render します
   * - {@link HeroImage.figure}
   * - {@link HeroImage.container}
   * @returns {?Element} `HeroImage`
   */


  HeroImage.prototype.render = function render() {
    var _props7 = this.props,
        containerId = _props7.containerId,
        containerClass = _props7.containerClass,
        pcSize = _props7.pcSize,
        mbSize = _props7.mbSize,
        scrollToSlug = _props7.scrollToSlug;
    // ---

    var figure = this.renderFigure();
    var container = this.renderContainer();
    // 出力対象存在チェック
    if (!figure && !container) {
      return null;
    }
    // ---
    // size setting
    var sizePc = pcSize !== null && pcSize ? pcSize.toLowerCase() + 'Size-pc' : '';
    var sizeMb = mbSize !== null && mbSize ? mbSize.toLowerCase() + 'Size-mb' : '';
    // ---
    // visible class
    var visible = !!scrollToSlug ? 'is-show-scroll_btn' : 'is-hide-scroll_btn';
    // ---
    var entered = this.state.entered;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 787
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'HeroImage__article', __source: {
            fileName: _jsxFileName,
            lineNumber: 791
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          {
            className: 'HeroImage ' + sizePc + ' ' + sizeMb + ' ' + visible + ' ' + entered,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 792
            }
          },

          /* figure */
          figure,

          /* container */
          container
        )
      )
    );
  };

  return HeroImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcPreHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbPreHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preHeadingTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  headingTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTextAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTextAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  imageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scrollToSlug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  // props extends
  photoInfoWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  photoInfoWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inHeroCarousel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  heroCarouselSlideId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heroCarouselUniqueId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // ---
  sendMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  requestMessageFlag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcPreHeading: null,
  mbPreHeading: null,
  preHeadingTag: null,
  pcHeading: null,
  mbHeading: null,
  headingTag: null,
  pcDescription: null,
  mbDescription: null,
  pcPosition: null,
  mbPosition: null,
  pcTextAlign: null,
  mbTextAlign: null,
  pcSrc: null,
  mbSrc: null,
  pcSize: null,
  mbSize: null,
  link: null,
  imageLink: null,
  scrollToSlug: null,
  photoInfo: null,
  // props extends
  photoInfoWillOpen: null,
  photoInfoWillClose: null,
  inHeroCarousel: false,
  heroCarouselSlideId: '',
  heroCarouselUniqueId: '',
  // ---
  sendMessage: null,
  requestMessageFlag: false
}, _temp);
HeroImage.displayName = 'HeroImage';


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\presentation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  Presentation
 */
var Presentation = (_temp = _class = function (_Component) {
  _inherits(Presentation, _Component);

  function Presentation(props) {
    _classCallCheck(this, Presentation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  Presentation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        pcDescription = _props.pcDescription,
        mbDescription = _props.mbDescription,
        backgroundColor = _props.backgroundColor,
        bulletsBelow = _props.bulletsBelow,
        presentationItem = _props.presentationItem,
        cta = _props.cta,
        photoInfo = _props.photoInfo;

    var settings = {
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 1500,
      ease: 'linear',
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      draggable: false,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      centerMode: false,
      centerPadding: 0,
      //mobileFirst: true,
      //prevArrow: '<button type="button" class="slick-prev" style="display: none;">Previous</button>',
      //nextArrow: '<div></div>',
      // prevArrow: '<button type="button" class="slick-prev" style="display: none;">Previous</button>',
      // nextArrow: '<button type="button" class="slick-next" style="display: none;">Next</button>',
      lazyLoad: 'progressive',
      //lazyLoad: 'ondemand',
      waitForAnimate: false,
      responsive: [{
        breakpoint: 767,
        settings: {
          swipe: true,
          arrows: false,
          prevArrow: '<div></div>',
          nextArrow: '<div></div>'
        }
      }],
      beforeChange: function beforeChange(old, current) {
        var slickList = _this2.refs.slider.refs.slide.getElementsByClassName('slick-list')[0];
        slickList.classList.add('open');
        setTimeout(function () {
          slickList.classList.remove('open');
        }, 1000);
        _this2.refs.slider.beforeChange(old, current);
      }
    };

    //
    var getPcDescription = function getPcDescription() {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };

    //
    var getMbDescription = function getMbDescription() {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Presentation',
          style: { backgroundColor: backgroundColor ? backgroundColor : '#f5f5f5' },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Presentation__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 131
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Presentation__description', __source: {
                fileName: _jsxFileName,
                lineNumber: 132
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Presentation__description-pc Wysiwyg',
              dangerouslySetInnerHTML: { __html: getPcDescription() },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Presentation__description-mb Wysiwyg',
              dangerouslySetInnerHTML: { __html: getMbDescription() },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            })
          ),
          bulletsBelow === false && presentationItem.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Presentation__pager', __source: {
              fileName: _jsxFileName,
              lineNumber: 141
            }
          }) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Presentation__carousel' + (bulletsBelow === false ? ' bulletsBelow' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 142
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__components_slider__["a" /* default */],
              { ref: 'slider',
                settings: settings,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 143
                }
              },
              presentationItem.map(function (child, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Presentation__carousel-item',
                    key: index,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 148
                    }
                  },
                  child
                );
              })
            )
          ),
          bulletsBelow === true && presentationItem.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Presentation__pager', __source: {
              fileName: _jsxFileName,
              lineNumber: 158
            }
          }) : null
        ),
        cta !== null && 1 <= cta.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Presentation__cta', __source: {
              fileName: _jsxFileName,
              lineNumber: 160
            }
          },
          cta
        ) : null,
        photoInfo !== null && 1 <= photoInfo.length ? photoInfo : null
      )
    );
  };

  return Presentation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bulletsBelow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  presentationItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcDescription: null,
  mbDescription: null,
  backgroundColor: null,
  bulletsBelow: null,
  presentationItem: null,
  cta: null,
  photoInfo: null
}, _temp);
Presentation.displayName = 'Presentation';


/* harmony default export */ __webpack_exports__["a"] = (Presentation);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhotogalleryLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\photogallery-layout\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PhotogalleryLayout = (_temp = _class = function (_Component) {
  _inherits(PhotogalleryLayout, _Component);

  function PhotogalleryLayout(props) {
    _classCallCheck(this, PhotogalleryLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.openModal = function (index) {
      if (_this.props.openModal !== null) _this.props.openModal(index);
    };

    return _this;
  }

  PhotogalleryLayout.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        layout = _props.layout,
        children = _props.children,
        openModal = _props.openModal,
        index = _props.index;
    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'table',
        { className: 'PhotogalleryLayout', __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        },
        function () {
          if (layout === 'Large') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 48
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 49
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td', ref: 'td', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 50
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[0].props, { openModal: _this2.openModal, index: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 51
                    }
                  }))
                )
              )
            );
          } else if (layout === 'Medium') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 58
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 59
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td3', ref: 'td3', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 60
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[0].props, { openModal: _this2.openModal, index: index, mbTwoColumn: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 61
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td3', ref: 'td3', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 63
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[1].props, { openModal: _this2.openModal, index: index + 1, mbTwoColumn: true, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 64
                    }
                  }))
                )
              )
            );
          } else if (layout === '2-Small-Left-Medium-Right') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 71
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 72
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td4', ref: 'td4', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 73
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'PhotogalleryLayout__box', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 74
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[0].props, { openModal: _this2.openModal, index: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 75
                      }
                    }))
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'PhotogalleryLayout__box2', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 77
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[1].props, { openModal: _this2.openModal, index: index + 1, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 78
                      }
                    }))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td2', ref: 'td2', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 81
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[2].props, { openModal: _this2.openModal, index: index + 2, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 82
                    }
                  }))
                )
              )
            );
            // return (
            //   <tbody>
            //   <tr>
            //     <td className="PhotogalleryLayout__td4" ref="td4">
            //       <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index}/>
            //     </td>
            //     <td className="PhotogalleryLayout__td2" rowSpan="2" ref="td2">
            //       <PhotogalleryItem {...children[1].props} openModal={this.openModal} index={index + 1}/>
            //     </td>
            //   </tr>
            //   <tr>
            //     <td className="PhotogalleryLayout__td4" ref="td4">
            //       <PhotogalleryItem {...children[2].props} openModal={this.openModal} index={index + 2}/>
            //     </td>
            //   </tr>
            //   </tbody>
            // )
          } else if (layout === 'Medium-Left-2-Small-Right') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 106
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 107
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td2', rowSpan: '2', ref: 'td2', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 108
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[0].props, { openModal: _this2.openModal, index: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 109
                    }
                  }))
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td4', ref: 'td4', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 111
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[1].props, { openModal: _this2.openModal, index: index + 1, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 112
                    }
                  }))
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 115
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'PhotogalleryLayout__td4', ref: 'td4', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 116
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, children[2].props, { openModal: _this2.openModal, index: index + 2, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 117
                    }
                  }))
                )
              )
            );
          }
        }()
      )
    );
  };

  //


  return PhotogalleryLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  layout: null,
  children: null,
  openModal: null,
  index: null
}, _temp);
PhotogalleryLayout.displayName = 'PhotogalleryLayout';


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhotogalleryItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_layout__ = __webpack_require__(67);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\photogallery-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PhotogalleryItem = (_temp = _class = function (_Component) {
  _inherits(PhotogalleryItem, _Component);

  function PhotogalleryItem(props) {
    _classCallCheck(this, PhotogalleryItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResizeVideo = function () {
      if (!_this.refs.wrapper) return;
      //
      var wrapperWidth = _this.refs.wrapper.clientWidth;
      var wrapperHeight = _this.refs.wrapper.clientHeight;
      var videoWidth = _this.refs.video.videoWidth;
      var videoHeight = _this.refs.video.videoHeight;
      var percent = null;
      var percentWidth = wrapperWidth / videoWidth;
      var percentHeight = wrapperHeight / videoHeight;
      if (percentWidth < percentHeight) {
        percent = percentHeight;
      } else {
        percent = percentWidth;
      }
      _this.setState({
        videoWidth: videoWidth * percent,
        videoHeight: videoHeight * percent,
        // videoWidth: videoWidth * percent * 1.05,
        // videoHeight: videoHeight * percent * 1.05,
        videoLoaded: true
      });
    };

    _this.handleResizeImage = function () {
      if (!_this.refs.wrapper) return;
      //
      var wrapperWidth = _this.refs.wrapper.clientWidth;
      var wrapperHeight = _this.refs.wrapper.clientHeight;
      var imageWidth = _this.refs.image.clientWidth;
      var imageHeight = _this.refs.image.clientHeight;
      var percent = null;
      var percentWidth = wrapperWidth / imageWidth;
      var percentHeight = wrapperHeight / imageHeight;
      if (percentWidth < percentHeight) {
        percent = percentHeight;
      } else {
        percent = percentWidth;
      }
      var newImageWidth = _this.props.mbTwoColumn && window.innerWidth < __WEBPACK_IMPORTED_MODULE_5__constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] ? wrapperWidth * 2 : imageWidth * percent;

      _this.setState({
        imageWidth: newImageWidth,
        imageHeight: imageHeight * percent
      });
    };

    _this.loadImage = function (src) {
      var image = new Image();
      _this.setState({
        opened: false
      });
      image.onload = function () {
        _this.setState({
          opened: true
        });
      };
      image.src = src;
    };

    _this.state = {
      imageWidth: 0,
      imageHeight: 0,
      videoWidth: 0,
      videoHeight: 0,
      // imageWidth: '100%',
      // imageHeight: '100%',
      // videoWidth: '100%',
      // videoHeight: '100%',
      videoLoaded: false,
      opened: false
    };
    return _this;
  }

  PhotogalleryItem.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.refs.video) {
      //
      setTimeout(function () {
        if (!_this2.state.videoLoaded) {
          _this2.refs.video.load();
        }
      }, 500);
      //
      this.refs.video.addEventListener('loadedmetadata', function (e) {
        window.addEventListener('resize', _this2.handleResizeVideo);
        _this2.handleResizeVideo();
      });
      this.refs.video.addEventListener('mouseenter', function (e) {
        _this2.refs.video.play();
      });
      this.refs.video.addEventListener('mouseleave', function (e) {
        _this2.refs.video.pause();
      });
    } else if (this.refs.image) {
      window.addEventListener('resize', this.handleResizeImage);
      this.handleResizeImage();
    }
    //
    if (this.props.imageSrc) {
      this.loadImage(this.props.imageSrc);
    }
  };

  PhotogalleryItem.prototype.componentWillUnmount = function componentWillUnmount() {};

  PhotogalleryItem.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        imageSrc = _props.imageSrc,
        videoSrc = _props.videoSrc,
        youtubeId = _props.youtubeId,
        openModal = _props.openModal,
        index = _props.index,
        mbTwoColumn = _props.mbTwoColumn,
        trimSettingForMbTwoColumn = _props.trimSettingForMbTwoColumn;

    //

    var handleClick = function handleClick(e) {
      e.preventDefault();
      //
      if (openModal !== null) openModal(index);
    };

    //
    var getStyle = function getStyle() {
      var style = {
        position: 'absolute',
        backgroundImage: 'url(' + imageSrc + ')'
      };
      //
      var top = (_this3.state.imageHeight - _this3.state.imageHeight * PhotogalleryItem.scale) / 2;
      if (!isNaN(top)) {
        style.top = top;
      }
      //
      var left = (_this3.state.imageWidth - _this3.state.imageWidth * PhotogalleryItem.scale) / 2;
      if (!isNaN(left)) {
        style.left = left;
      }
      //
      var width = _this3.state.imageWidth * PhotogalleryItem.scale;
      if (0 < width) {
        style.width = width;
      }
      //
      var height = _this3.state.imageHeight * PhotogalleryItem.scale;
      if (0 < height) {
        style.height = height;
      }
      //
      return style;
    };

    var renderIcon = function renderIcon() {
      if (_this3.props.deleteIconOnImage === true) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PhotogalleryItem__icon-open', __source: {
          fileName: _jsxFileName,
          lineNumber: 136
        }
      });
    };

    var trimSettingClass = trimSettingForMbTwoColumn === 'Left' ? ' showLeft' : trimSettingForMbTwoColumn === 'Right' ? ' showRight' : '';

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PhotogalleryItem', ref: 'wrapper', __source: {
            fileName: _jsxFileName,
            lineNumber: 150
          }
        },
        function () {
          if (videoSrc && videoSrc !== '') {
            var autoPlay = false;
            if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */]) {
              autoPlay = true;
            }
            var attributes = {
              //preload: 'none',
              preload: 'metadata',
              controls: false,
              autoPlay: autoPlay,
              playsInline: true,
              muted: true,
              loop: true,
              src: videoSrc,
              //poster: imageSrc,
              width: _this3.state.videoWidth,
              height: _this3.state.videoHeight
              // width: '100%',
              // height: '100%'
            };
            if (youtubeId && youtubeId !== '') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : ''),
                  href: '#',
                  onClick: handleClick,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 174
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PhotogalleryItem__container' + (_this3.state.videoLoaded === true ? ' opened' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 178
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({
                    className: 'PhotogalleryItem__video' + (_this3.state.videoLoaded ? ' loaded' : '') + trimSettingClass }, attributes, {
                    ref: 'video', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 179
                    }
                  })),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PhotogalleryItem__icon-play', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 182
                    }
                  }),
                  renderIcon()
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : ''),
                  href: '#',
                  onClick: handleClick,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 189
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PhotogalleryItem__container' + (_this3.state.videoLoaded === true ? ' opened' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 193
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({
                    className: 'PhotogalleryItem__video' + (_this3.state.videoLoaded ? ' loaded' : '') + trimSettingClass }, attributes, {
                    ref: 'video', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 194
                    }
                  })),
                  renderIcon()
                )
              );
            }
          } else if (imageSrc && imageSrc !== '') {
            //
            if (youtubeId && youtubeId !== '') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : ''),
                  href: '#',
                  onClick: handleClick,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 206
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PhotogalleryItem__container' + (_this3.state.opened === true ? ' opened' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 210
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PhotogalleryItem__image' + trimSettingClass,
                    style: getStyle(),
                    ref: 'image',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 211
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PhotogalleryItem__icon-play', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 215
                    }
                  }),
                  renderIcon()
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PhotogalleryItem__link' + (mbTwoColumn ? ' mbTwoColumn' : ''),
                  href: '#',
                  onClick: handleClick,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 222
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PhotogalleryItem__container' + (_this3.state.opened === true ? ' opened' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 226
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PhotogalleryItem__image' + trimSettingClass,
                    style: getStyle(),
                    ref: 'image',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 227
                    }
                  }),
                  renderIcon()
                )
              );
            }
          } else {
            return null;
          }
        }()
      )
    );
  };

  return PhotogalleryItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.scale = 1.05, _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deleteIconOnImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbTwoColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  imageSrc: null,
  deleteIconOnImage: null,
  videoSrc: null,
  youtubeId: null,
  openModal: null,
  index: null,
  mbTwoColumn: null
}, _temp);
PhotogalleryItem.displayName = 'PhotogalleryItem';


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_slidegallery_item__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\slidegallery-item\\index.jsx';





var SlidegalleryItemBlock = function SlidegalleryItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_slidegallery_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
SlidegalleryItemBlock.displayName = 'SlidegalleryItemBlock';
SlidegalleryItemBlock.displayName = 'SlidegalleryItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(SlidegalleryItemBlock));

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\tab-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 *  TabNavigation
 */
var TabNavigation = (_temp = _class = function (_Component) {
  _inherits(TabNavigation, _Component);

  function TabNavigation(props) {
    _classCallCheck(this, TabNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {
      subNavigationHeight: 0
    };
    return _this;
  }

  TabNavigation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        links = _props.links,
        bottom = _props.bottom,
        linkColor = _props.linkColor,
        linkToTabAnchor = _props.linkToTabAnchor;


    var tab_anch_hash = linkToTabAnchor && linkToTabAnchor === true ? '#tab_anch' : '';

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'TabNavigation',
          id: function () {
            if (_this2.props.bottom === false) {
              return 'tab_anch';
            }
          }(),
          style: 0 < this.state.subNavigationHeight ? { paddingTop: this.state.subNavigationHeight, marginTop: -this.state.subNavigationHeight } : null,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 72
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: "TabNavigation__container" + (this.props.linkColor && this.props.linkColor !== '' ? ' TabNavigation__container--' + this.props.linkColor : '') + (this.props.bottom && this.props.bottom === true ? ' TabNavigation__container--bottom' : ''),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 81
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            {
              className: "TabNavigation__list" + (this.props.links.length > 0 ? ' TabNavigation__list--' + this.props.links.length : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 88
              }
            },
            this.props.links.map(function (link, index) {
              var pcText = void 0,
                  mbText = void 0;
              if (link.pcText && link.pcText !== '') {
                pcText = link.pcText;
              } else {
                if (link.mbText && link.mbText !== '') {
                  pcText = link.mbText;
                } else if (link.pageName && link.pageName !== '') {
                  pcText = link.pageName;
                } else {
                  pcText = '';
                }
              }
              if (link.mbText && link.mbText !== '') {
                mbText = link.mbText;
              } else {
                if (link.pcText && link.pcText !== '') {
                  mbText = link.pcText;
                } else if (link.pageName && link.pageName !== '') {
                  mbText = link.pageName;
                } else {
                  mbText = '';
                }
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                {
                  key: index,
                  ref: 'item' + index,
                  className: "TabNavigation__list__item" + (link.current === true ? ' TabNavigation__list__item--current' : ''),
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 121
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    href: link.href && link.href !== null ? link.href + tab_anch_hash : null,
                    target: link.external === true ? '_blank' : '',
                    className: 'TabNavigation__list__item__link',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 126
                    }
                  },
                  pcText && pcText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(pcText) },
                    className: 'TabNavigation__list__item__link__text--pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 131
                    }
                  }) : null,
                  mbText && mbText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) },
                    className: 'TabNavigation__list__item__link__text--mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 133
                    }
                  }) : null
                )
              );
            })
          )
        )
      )
    );
  };

  TabNavigation.prototype.componentDidMount = function componentDidMount() {
    var height = __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].getSubNavigationHeight();
    if (0 < height) {
      this.setState({
        subNavigationHeight: height
      });
    }
    //
    var hash = location.hash;
    if (hash && hash === '#tab_anch') {
      setTimeout(function () {
        var element = document.getElementById('tab_anch');
        if (element) {
          var top = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo(0, top - 1);
        }
      }, 200);
    }
  };

  return TabNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // links: PropTypes.array,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })),
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  linkColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkToTabAnchor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  links: null,
  bottom: null,
  linkColor: null,
  linkToTabAnchor: null
}, _temp);
TabNavigation.displayName = 'TabNavigation';


/* harmony default export */ __webpack_exports__["a"] = (TabNavigation);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\picker-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  PickerItem
 */
var PickerItem = (_temp = _class = function (_Component) {
  _inherits(PickerItem, _Component);

  /**
   * props / state 比較し update が必要かを判定します
   * @param {*} props React.props
   * @returns {{samePickerIndex: boolean, sameFilterId: boolean}}
   * - samePickerIndex: true current index と my index が同じ
   * - sameFilterId: filterId と currentFilterId が同じ
   */
  PickerItem.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var notEmpty = props.currentFilterId !== '';
    var sameFilterId = notEmpty && props.filterId === props.currentFilterId;
    return {
      sameFilterId: sameFilterId,
      samePickerIndex: sameFilterId && props.currentPickerIndex === props.pickerIndex
    };
  };

  // ----------------------------------------------------


  function PickerItem(props) {
    _classCallCheck(this, PickerItem);

    // state
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      activateCurrent: props.currentPickerIndex === props.pickerIndex,
      currentPickerIndex: props.currentPickerIndex,
      currentFilterId: props.currentFilterId
      // thumbPcStyle: { opacity: 0, float: 'left' },
      // thumbMbStyle: { opacity: 0, float: 'left' },
      // thumbPcStyle: { float: 'left' },
      // thumbMbStyle: { float: 'left' },
    };
    _this.onClickThumbnail = _this.onClickThumbnail.bind(_this);
    // this.timer = {
    //   thumbnail: 0,
    //   mount: 0,
    // };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    _this.enableThumbnailClick = true;
    // this.onMbLoad = this.onMbLoad.bind(this);
    // this.onPcLoad = this.onPcLoad.bind(this);
    return _this;
  }

  // ----------------------------------------------------
  /**
   * thumbnail click event handler
   * - props.thumbnailClickCaller 実行します
   * @param {Event} event click event
   */


  PickerItem.prototype.onClickThumbnail = function onClickThumbnail(event) {
    event.preventDefault();
    // ---
    // const { activateCurrent } = this.state;

    var _PickerItem$getDerive = PickerItem.getDerivedStateFromProps(this.props),
        sameFilterId = _PickerItem$getDerive.sameFilterId,
        samePickerIndex = _PickerItem$getDerive.samePickerIndex;

    if (sameFilterId && !samePickerIndex) {
      // current は通知しない
      // 親 component へ click 通知します
      var _props = this.props,
          thumbnailClickCaller = _props.thumbnailClickCaller,
          filterId = _props.filterId,
          pickerIndex = _props.pickerIndex;

      if (typeof thumbnailClickCaller === 'function') {
        thumbnailClickCaller.call(this, filterId, pickerIndex);
      }
    }
  };
  // onPcLoad() {
  //   this.setState({ thumbPcStyle: null });
  // }
  // onMbLoad() {
  //   this.setState({ thumbMbStyle: null });
  // }
  // activateThumbnailClick() {
  //   // console.log('PickerItem.activateThumbnailClick', Date.now());
  //   this.enableThumbnailClick = true;
  // }
  //
  // abortThumbnailClick() {
  //   clearTimeout(this.timer.thumbnail);
  //   // console.log('PickerItem.abortThumbnailClick', Date.now());
  //   this.enableThumbnailClick = false;
  //   this.timer.thumbnail = setTimeout(() => {
  //     this.activateThumbnailClick();
  //   }, 532);
  // }

  // /**
  //  * thumbnail をカレント表示するために update するかを判定します
  //  * - {@link PickerItem.getDerivedStateFromProps}
  //  * @param {*} props React.props
  //  * @param {*} state React.state
  //  */
  // willChangeStateCurrent(props, state) {
  //   const {
  //     showView,
  //     currentFilterId,
  //     currentPickerIndex,
  //   } = this.props;
  //   if (showView) {
  //     return;
  //   }
  //   const { changePickerIndex, samePickerIndex } = PickerItem.getDerivedStateFromProps(props, state);
  //   if (!changePickerIndex) {
  //     return;
  //   }
  //   // if (this.state.activateCurrent !== samePickerIndex) {
  //   //     console.log('PickerItem.willChangeStateCurrent', changePickerIndex, samePickerIndex, this.state, this.props.pickerIndex);
  //   //     this.setState({ activateCurrent: samePickerIndex, currentFilterId, currentPickerIndex  });
  //   // }
  //   this.setState({ activateCurrent: samePickerIndex, currentFilterId, currentPickerIndex });
  // }

  // ----------------------------------------------------
  // afterMountUpdateShowThumbnail(delay = 1000) {
  //   const { thumbPcStyle, thumbMbStyle } = this.state;
  //   if (!thumbPcStyle && !thumbMbStyle) {
  //     return;
  //   }
  //   clearTimeout(this.timer.mount);
  //   this.timer.mount = setTimeout(() => {
  //     this.setState({ thumbPcStyle: null, thumbMbStyle: null });
  //   }, delay);
  // }
  // // ----------------------------------------------------
  // componentDidUpdate() {
  //   this.willChangeStateCurrent(this.props, this.state);
  //   // this.afterMountUpdateShowThumbnail();
  // }
  //
  // componentDidMount() {
  //   this.willChangeStateCurrent(this.props, this.state);
  //   // this.afterMountUpdateShowThumbnail();
  // }

  // componentWillUnmount() {
  //   // clear timer
  //   Object.values(this.timer).map(id => (clearTimeout(id)));
  // }

  // ----------------------------------------------------
  // main - view


  PickerItem.prototype.renderPhotoInfo = function renderPhotoInfo() {
    var _props2 = this.props,
        photoInfo = _props2.photoInfo,
        currentPickerId = _props2.currentPickerId,
        inCarousel = _props2.inCarousel;
    // photoInfo 配列内 React.node では無いのでコンバートする
    // if (!Array.isArray(photoInfo) || !photoInfo.length) {
    //     return null;
    // }

    var list = Array.isArray(photoInfo) ? photoInfo : [];
    // return photoInfo;
    var filtered = list.filter(function (component) {
      return component.name === 'PhotoInfo';
    });
    if (!filtered.length) {
      return null;
    }
    // 1 件のみ出力
    var component = filtered[0];
    var props = Object.assign({}, component.props);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__photo_info__["a" /* default */], _extends({}, props, {
      inHeroCarousel: inCarousel,
      heroCarouselSlideId: currentPickerId,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215
      }
    }));
  };

  PickerItem.prototype.renderFigures = function renderFigures() {
    var _props3 = this.props,
        pcSrc = _props3.pcSrc,
        mbSrc = _props3.mbSrc;

    if (!pcSrc) {
      return null;
    }
    var mbImg = mbSrc || pcSrc;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerItem__photo__block', __source: {
          fileName: _jsxFileName,
          lineNumber: 233
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PickerItem__photo__image', __source: {
            fileName: _jsxFileName,
            lineNumber: 234
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pcSrc, alt: '', className: 'PickerItem__photo__image-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 235
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: mbImg, alt: '', className: 'PickerItem__photo__image-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 236
          }
        })
      ),
      this.renderPhotoInfo()
    );
  };

  PickerItem.prototype.renderDescriptions = function renderDescriptions() {
    var _props4 = this.props,
        pcDescription = _props4.pcDescription,
        mbDescription = _props4.mbDescription;

    if (!pcDescription) {
      return null;
    }
    var mbHtml = mbDescription || pcDescription;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PickerItem__Description', __source: {
          fileName: _jsxFileName,
          lineNumber: 253
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PickerItem__pcDescription', dangerouslySetInnerHTML: { __html: pcDescription }, __source: {
          fileName: _jsxFileName,
          lineNumber: 254
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PickerItem__mbDescription', dangerouslySetInnerHTML: { __html: mbHtml }, __source: {
          fileName: _jsxFileName,
          lineNumber: 255
        }
      })
    );
  };

  PickerItem.prototype.renderView = function renderView() {
    var _props5 = this.props,
        containerId = _props5.containerId,
        containerClass = _props5.containerClass,
        pickerId = _props5.pickerId,
        pickerIndex = _props5.pickerIndex,
        showView = _props5.showView;
    // ---

    if (!showView) {
      return null;
    }
    // ---
    var renderFigures = this.renderFigures();
    var renderDescriptions = this.renderDescriptions();
    // ---
    if (!renderDescriptions && !renderFigures) {
      return null;
    }
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 281
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'PickerItem',
          'data-id': pickerId + ':' + pickerIndex,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 285
          }
        },
        renderDescriptions,
        renderFigures
      )
    );
  };

  // ----------------------------------------------------
  // thumbnail


  PickerItem.prototype.renderThumbnailMb = function renderThumbnailMb() {
    var _props6 = this.props,
        pcThumbSrc = _props6.pcThumbSrc,
        mbThumbSrc = _props6.mbThumbSrc,
        filterId = _props6.filterId,
        pickerIndex = _props6.pickerIndex,
        pcSrc = _props6.pcSrc,
        mbSrc = _props6.mbSrc;

    var pcImg = pcThumbSrc || pcSrc;
    var mbImg = mbThumbSrc || mbSrc;
    var mbThumb = mbImg || pcImg;
    if (!mbThumb) {
      return null;
    }
    // const {
    //   activateCurrent,
    //   // thumbMbStyle,
    // } = this.state;
    // ---
    // const currentClass = activateCurrent ? 'is-active': '';

    var _PickerItem$getDerive2 = PickerItem.getDerivedStateFromProps(this.props),
        sameFilterId = _PickerItem$getDerive2.sameFilterId,
        samePickerIndex = _PickerItem$getDerive2.samePickerIndex;

    var currentClass = sameFilterId && samePickerIndex ? 'is-active' : '';
    // ---
    // console.log('PickerItem.renderThumbnailMb', filterId, pickerIndex, currentPickerIndex, this.state.activateCurrent, currentClass);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'PickerItem__thumb__item PickerItem__thumb__item-mb ' + currentClass,
        role: 'presentation',
        'data-id': filterId,
        'data-index': pickerIndex,
        onClick: this.onClickThumbnail,
        'data-size': 'mb'
        // style={thumbMbStyle}
        , __source: {
          fileName: _jsxFileName,
          lineNumber: 324
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
        className: 'PickerItem__thumb__item__image',
        style: { backgroundImage: 'url(' + mbThumb + ')' },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 333
        }
      })
    );
  };

  PickerItem.prototype.renderThumbnailPc = function renderThumbnailPc() {
    var _props7 = this.props,
        pcThumbSrc = _props7.pcThumbSrc,
        filterId = _props7.filterId,
        pickerIndex = _props7.pickerIndex,
        pcSrc = _props7.pcSrc;

    var pcImg = pcThumbSrc || pcSrc;
    // if (!pcThumbSrc) {
    if (!pcImg) {
      return null;
    }
    // const {
    //   activateCurrent,
    //   // thumbPcStyle,
    // } = this.state;
    // ---
    // const currentClass = activateCurrent ? 'is-active': '';

    var _PickerItem$getDerive3 = PickerItem.getDerivedStateFromProps(this.props),
        sameFilterId = _PickerItem$getDerive3.sameFilterId,
        samePickerIndex = _PickerItem$getDerive3.samePickerIndex;

    var currentClass = sameFilterId && samePickerIndex ? 'is-active' : '';
    // console.log('PickerItem.renderThumbnailPc', filterId, currentFilterId, pickerIndex, currentPickerIndex, this.state.activateCurrent, currentClass);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'PickerItem__thumb__item PickerItem__thumb__item-pc ' + currentClass,
        role: 'presentation',
        'data-id': filterId,
        'data-index': pickerIndex,
        onClick: this.onClickThumbnail
        // style={thumbPcStyle}
        , __source: {
          fileName: _jsxFileName,
          lineNumber: 363
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
        className: 'PickerItem__thumb__item__image',
        style: { backgroundImage: 'url(' + pcImg + ')' },
        'data-id': filterId,
        'data-index': pickerIndex,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 371
        }
      })
    );
  };

  PickerItem.prototype.renderThumbnail = function renderThumbnail() {
    var _props8 = this.props,
        showMb = _props8.showMb,
        showView = _props8.showView;

    if (showView) {
      return null;
    }
    return showMb ? this.renderThumbnailMb() : this.renderThumbnailPc();
  };

  // ----------------------------------------------------


  PickerItem.prototype.render = function render() {
    var showView = this.props.showView;
    // ---

    var view = this.renderView();
    var thumbnail = this.renderThumbnail();
    // ---
    if (!view && !thumbnail) {
      return null;
    }
    // ---
    // main view と thumbnail container を分ける
    return showView ? view : thumbnail;
  };

  return PickerItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcThumbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbThumbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // extend
  // view / thumbnail 出力 flag - true: view
  showView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pickerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentPickerIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentPickerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pickerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  thumbnailClickCaller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  currentFilterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inCarousel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcDescription: null,
  mbDescription: null,
  pcSrc: null,
  mbSrc: null,
  pcThumbSrc: null,
  mbThumbSrc: null,
  photoInfo: null,
  // extend
  showView: false,
  showMb: false,
  pickerIndex: -1,
  currentPickerIndex: -1,
  currentPickerId: '',
  pickerId: '',
  thumbnailClickCaller: null,
  currentFilterId: '',
  filterId: '',
  inCarousel: false
}, _temp);
PickerItem.displayName = 'PickerItem';


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Picker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweet_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker_container__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feature_category_container__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\picker\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// ---


// ---






/**
 *  Picker
 */
var Picker = (_temp = _class = function (_Component) {
  _inherits(Picker, _Component);

  /**
   *  filter - parent / child
   *  - child 選択時 他の child も同一グループなのをチェックする
   *  @param {string} parentName - 親名称 `first-0`
   *  @param {string} currentFilterId - 子名称 `first-0-second0`
   */
  Picker.secondFilterContains = function secondFilterContains(parentName, currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    var divideId = parentName.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  };

  /**
   * second filter id name 判定します ex. `first-0-second0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true second filter id
   */


  Picker.isSecondFilterId = function isSecondFilterId(currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 3;
  };

  /**
   * first filter id name 判定します ex. `first-0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true first filter id
   */


  Picker.isFirstFilterId = function isFirstFilterId(currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 2;
  };

  function Picker(props) {
    _classCallCheck(this, Picker);

    // ---
    /**
     * props.categories を `PickerContainer` のみ抽出し list する
     * @type {{first: Array, second: Array, concat: ?Array}}
     */
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.containers = {
      first: [],
      second: [],
      concat: []
    };
    _this.onTitleClickCaller = _this.onTitleClickCaller.bind(_this);
    _this.onThumbnailClickCaller = _this.onThumbnailClickCaller.bind(_this);
    // `getComponents` 通す
    /**
     * props.categories を {@link getComponents} を通す - props.categories 使用しない
     * @type {Array<*>}
     */
    _this.categories = _this.convertPropsCategories();
    // categories を filter する
    _this.parseCategoriesList(_this.categories);
    // ---
    _this.opacityZeroClassName = __WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */].OPACITY_ZERO_CLASS_NAME;
    _this.abortOpacityZero = _this.abortOpacityZero.bind(_this);
    _this.state = {
      // mbWidth: false,
      currentFilterId: 'first-0',
      pickerIndex: 0,
      // for mb filter title
      filterTitle: '',
      filterSecondOpen: false,
      filterChangeOpacityClassName: _this.opacityZeroClassName
    };
    _this.timer = {
      thumbnail: 0,
      titleCenter: 0,
      titleCenterSequence: 0
    };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    _this.enableThumbnailClick = true;
    // this.delayTime = 532;
    // this.delayTime = 0;
    _this.refFilterFirst = null;
    _this.filterFirstTitles = {};
    _this.onResize = _this.onResize.bind(_this);
    _this.currentFilterId = _this.state.currentFilterId;
    return _this;
  }

  Picker.prototype.onResize = function onResize() {
    this.titleMoveCenter(this.currentFilterId);
  };

  // --------------------------------------------------
  /**
   * title click callback
   * - filter id が変更になったか判定し state 変更します
   * @param {string} id filterId
   * @param {number} index filterIndex
   * @param {string} title filter title
   */


  Picker.prototype.onTitleClickCaller = function onTitleClickCaller(id, index, title) {
    // console.log('Picker.onTitleClickCaller', id, index, title, this.state.currentFilterId !== id);
    var isFirstSecondFilterId = Picker.isFirstFilterId(this.state.currentFilterId);
    var argIdIsFirst = Picker.isFirstFilterId(id);
    var currentFilterIdContainsId = Picker.secondFilterContains(id, this.state.currentFilterId);
    if (argIdIsFirst && currentFilterIdContainsId && isFirstSecondFilterId) {
      return;
    }
    // ---
    if (this.state.currentFilterId !== id) {
      this.currentFilterId = id;
      // ---
      // console.log('Picker.onTitleClickCaller do enableOpacityZero ----', Date.now());
      this.enableOpacityZero();
      // ---
      this.titleMoveCenter(id);
      // ---
      var changeState = {
        currentFilterId: id,
        pickerIndex: 0,
        filterTitle: Picker.isSecondFilterId(id) ? title : '',
        filterSecondOpen: false
      };
      this.setState(changeState);
    }
  };
  // --------------------------------------------------


  Picker.prototype.titleMoveCenter = function titleMoveCenter(id) {
    var _this2 = this;

    var innerWidth = window.innerWidth;
    if (innerWidth >= 768 || !this.refFilterFirst) {
      return;
    }
    var component = this.filterFirstTitles[id];
    if (!component || !component.getTitleClientRect) {
      return;
    }
    var rect = component.getTitleClientRect();
    if (!rect) {
      return;
    }
    var center = innerWidth * 0.5;
    var middle = rect.left + rect.width * 0.5;
    var scrollLeft = this.refFilterFirst.scrollLeft;
    // const subtract = middle - center;
    // const sweetScroll = new SweetScroll({
    //   horizontal: true,
    //   horizontalScroll: true,
    // }, this.refFilterFirst);
    // sweetScroll.toLeft((scrollLeft + subtract));
    clearTimeout(this.timer.titleCenter);
    clearTimeout(this.timer.titleCenterSequence);
    if (scrollLeft === 0) {
      // PC browser left: 0 だと移動できない問題
      this.timer.titleCenter = setTimeout(function () {
        _this2.refFilterFirst.scrollLeft = 1;
      }, 0);
      this.timer.titleCenterSequence = setTimeout(function () {
        _this2.sequenceTitleMoveCenter(center, middle, scrollLeft);
      }, 1);
    } else {
      this.sequenceTitleMoveCenter(center, middle, scrollLeft);
    }
  };

  Picker.prototype.sequenceTitleMoveCenter = function sequenceTitleMoveCenter(center, middle, scrollLeft) {
    var subtract = middle - center;
    var expectMove = scrollLeft + subtract;
    var duration = 320;
    var sweetScroll = new __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default.a({
      duration: duration,
      easing: 'easeOutCubic',
      horizontal: true,
      horizontalScroll: true,
      cancellable: false,
      stopPropagation: false
    }, this.refFilterFirst);
    sweetScroll.toLeft(expectMove);
  };
  // --------------------------------------------------


  Picker.prototype.enableOpacityZero = function enableOpacityZero() {
    // document.body.classList.add(this.opacityZeroClassName);
    // console.log('Picker.enableOpacityZero ++++++++++++++', Date.now());
    this.setState({ filterChangeOpacityClassName: this.opacityZeroClassName });
  };

  Picker.prototype.abortOpacityZero = function abortOpacityZero() {
    // console.log('Picker.abortOpacityZero -----------------------------', Date.now());
    this.setState({ filterChangeOpacityClassName: '' });
  };
  // --------------------------------------------------
  /**
   * thumbnail click callback
   * @param {string} id filterId
   * @param {number} index picker index
   */


  Picker.prototype.onThumbnailClickCaller = function onThumbnailClickCaller(id, index) {
    // console.log('Picker.onThumbnailClickCaller', id, index);
    // this.shouldChangeView(index);
    this.setState({ pickerIndex: index });
  };
  // /**
  //  * picker index が変更になっかを判定し state 変更します
  //  * @param {number} pickerIndex picker index
  //  */
  // shouldChangeView(pickerIndex) {
  //   // console.log('Picker.shouldChangeView', pickerIndex, this.state.pickerIndex, this.state.currentFilterId, this.state.pickerIndex !== pickerIndex);
  //   // if (this.state.pickerIndex !== pickerIndex) {
  //   //   this.setState({ pickerIndex });
  //   // }
  //   this.setState({ pickerIndex });
  // }

  // activateThumbnailClick() {
  //   // console.log('Picker.activateThumbnailClick +++', Date.now());
  //   this.enableThumbnailClick = true;
  // }
  //
  // abortThumbnailClick() {
  //   clearTimeout(this.timer.thumbnail);
  //   // console.log('Picker.abortThumbnailClick ---', Date.now());
  //   this.enableThumbnailClick = false;
  //   this.timer.thumbnail = setTimeout(() => {
  //     this.activateThumbnailClick();
  //   }, this.delayTime);
  // }

  // --------------------------------------------------

  /**
   * {@link getComponents} を通し `null` 除外します
   * @returns {Array} filter 後の categories
   */


  Picker.prototype.convertPropsCategories = function convertPropsCategories() {
    var categories = this.props.categories;

    return Array.isArray(categories) ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities__["c" /* getComponents */])(categories).filter(function (component) {
      return component !== null;
    }) : [];
  };

  /**
   * props.categories をパースします
   * - 第一階層は `PickerContainer` のみ
   * - 第二回層は `PickerContainer` / `PickerItem` - `PickerContainer` のみに filter する
   * @param {array} categories props.categories
   */


  Picker.prototype.parseCategoriesList = function parseCategoriesList() {
    var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var list = {
      first: [],
      second: [],
      concat: null
    };
    categories.map(function (category, index) {
      var step0 = 'first-' + index;
      // 第一階層は `PickerContainer` のみ
      list.first.push({
        name: step0,
        parent: null,
        category: category
      });
      var components = Array.isArray(category.props.components) ? category.props.components : [];
      // 第二回層は `PickerContainer` / `PickerItem`
      // `PickerContainer` のみに filter する
      components.map(function (component, count) {
        if (component.name === 'PickerContainer') {
          var step1 = step0 + '-second' + count;
          list.second.push({
            name: step1,
            parent: step0,
            category: component
          });
        }
        return component;
      });
      return category;
    });
    // parse しやすいように first / second concat する
    list.concat = [].concat(list.first, list.second);
    this.containers = list;
  };

  /**
   * filter id が second list を持つか判定し index を返します
   * @param currentFilterID
   * @returns {{result: boolean, index: number}}
   */


  Picker.prototype.hasSecondItems = function hasSecondItems(currentFilterID) {
    var index = -1;
    if (!Picker.isFirstFilterId(currentFilterID)) {
      return { result: false, index: index };
    }
    var second = this.containers.second;

    var result = second.some(function (data, i) {
      if (data.parent === currentFilterID) {
        index = i;
        return true;
      }
      return false;
    });
    return { result: result, index: index };
  };

  /**
   * first filter selected - second filter exist の時は second filter first を active にするための対応
   * */


  Picker.prototype.shouldSecondFirstActivate = function shouldSecondFirstActivate() {
    // 選択 filter id が first で second が存在するかのチェック
    var _hasSecondItems = this.hasSecondItems(this.state.currentFilterId),
        result = _hasSecondItems.result,
        index = _hasSecondItems.index;

    if (!result) {
      return;
    }
    var data = this.containers.second[index];
    if (data.name !== this.state.currentFilterId) {
      // console.log('Picker.shouldSecondFirstActivate changed', result, index, data.name, this.state.currentFilterId);
      this.setState({ currentFilterId: data.name });
      return true;
    }
    return false;
  };

  // --------------------------------------------------


  Picker.prototype.componentDidUpdate = function componentDidUpdate() {
    this.shouldSecondFirstActivate();
  };

  Picker.prototype.componentDidMount = function componentDidMount() {
    this.shouldSecondFirstActivate();
    window.addEventListener('resize', this.onResize, false);
  };

  Picker.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    // clear timer
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
  };

  // --------------------------------------------------
  // thumbnail


  Picker.prototype.renderThumbnails = function renderThumbnails() {
    var currentFilterId = this.state.currentFilterId;
    // @type {array} filter id に該当する `PickerContainer` を探す

    var current = this.containers.concat.filter(function (data) {
      return data.name === currentFilterId;
    });
    // console.log('Picker.renderThumbnails - parent', currentFilterId, divided, current);
    if (!current.length) {
      return null;
    }
    // ---
    // 配列から data を取り出す
    var data = current.shift();
    var divided = currentFilterId.split('-');
    var keyName = divided[0],
        parentIndex = divided[1],
        childIndex = divided[2];

    var component = data.category;
    var _state = this.state,
        pickerIndex = _state.pickerIndex,
        filterChangeOpacityClassName = _state.filterChangeOpacityClassName;

    var num = pickerIndex < 0 ? 0 : parseInt(pickerIndex, 10);
    // ---
    var props = Object.assign({}, component.props);
    // console.log(`Picker.renderThumbnails - filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, currentFilterId, Date.now());
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */], _extends({}, props, {
      showTitle: false,
      currentFilterId: currentFilterId,
      filterId: currentFilterId,
      filterIndex: parseInt(parentIndex, 10),
      currentPickerIndex: num,
      thumbnailClickCaller: this.onThumbnailClickCaller
      // filterChangeOpacityClassName={filterChangeOpacityClassName}
      , abortOpacityZero: this.abortOpacityZero,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 399
      }
    }));
  };

  // --------------------------------------------------
  // filter
  /**
   * 第一階層 filter
   * */


  Picker.prototype.renderFilterFirst = function renderFilterFirst() {
    var _this3 = this;

    var first = this.containers.first;

    var firstTitles = first.filter(function (data) {
      return !!data.category.props.title;
    });
    if (!firstTitles.length) {
      return null;
    }
    if (!first.length) {
      return null;
    }
    var currentFilterId = this.state.currentFilterId;

    this.filterFirstTitles = {};
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'Picker__filter__first',
        ref: function ref(component) {
          return _this3.refFilterFirst = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 430
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Picker__filter__first__title__wrap', __source: {
            fileName: _jsxFileName,
            lineNumber: 434
          }
        },
        firstTitles.map(function (data, index) {
          var component = data.category;
          // console.log('Picker.renderFilterFirst', id, result);
          var id = data.name;

          var _hasSecondItems2 = _this3.hasSecondItems(id),
              result = _hasSecondItems2.result;

          var props = Object.assign({}, component.props);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */], _extends({
            key: id
          }, props, {
            showTitle: true,
            currentFilterId: currentFilterId,
            filterId: id,
            filterIndex: index,
            titleClickCaller: _this3.onTitleClickCaller,
            hasSecond: result,
            ref: function ref(component) {
              return _this3.filterFirstTitles[id] = component;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 443
            }
          }));
        })
      )
    );
  };

  /**
   * 第二階層 filter - PC
   * */


  Picker.prototype.renderFilterSecondPc = function renderFilterSecondPc() {
    var _this4 = this;

    var second = this.containers.second;
    var currentFilterId = this.state.currentFilterId;
    // console.log('Picker.renderFilterSecondPc', currentFilterId, second);

    var filtered = second.filter(function (data) {
      return data.parent === currentFilterId || data.name === currentFilterId || Picker.secondFilterContains(data.parent, currentFilterId);
    })
    // title 不正値除く
    .filter(function (data) {
      return !!data.category.props.title;
    });
    if (!filtered.length) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Picker__filter__second-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 477
        }
      },
      filtered.map(function (data, index) {
        var component = data.category;
        var id = data.name;
        var props = Object.assign({}, component.props);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */], _extends({
          key: id
        }, props, {
          showTitle: true,
          currentFilterId: currentFilterId,
          filterId: id,
          filterIndex: index,
          titleClickCaller: _this4.onTitleClickCaller,
          parentFilter: data.parent,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 484
          }
        }));
      })
    );
  };

  /**
   * 第二階層 filter - MB
   * */


  Picker.prototype.renderFilterSecondMb = function renderFilterSecondMb() {
    var _this5 = this;

    var second = this.containers.second;
    var _state2 = this.state,
        currentFilterId = _state2.currentFilterId,
        filterTitle = _state2.filterTitle,
        filterSecondOpen = _state2.filterSecondOpen;
    // ---

    var filtered = second.filter(function (data) {
      return data.parent === currentFilterId || data.name === currentFilterId || Picker.secondFilterContains(data.parent, currentFilterId);
    })
    // title 不正値除く
    .filter(function (data) {
      return !!data.category.props.title;
    });
    if (!filtered.length) {
      return null;
    }
    var openedClass = filterSecondOpen ? 'Picker__filter__second__opened' : '';
    // console.log('Picker.renderFilterSecondMb', second, filterTitle, filtered[0].category.props.title);
    var filterSelectedTitle = filterTitle || filtered[0].category.props.title || '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Picker__filter__second-mb ' + openedClass, __source: {
          fileName: _jsxFileName,
          lineNumber: 522
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Picker__filter__second__heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 523
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'Picker__filter__second__heading__title__set',
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* convertPipeToBrTag */])(filterSelectedTitle) },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 524
          }
        }),
        filtered.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'Picker__filter__second__heading__btn',
          type: 'button',
          onClick: function onClick(event) {
            event.preventDefault();
            var opposite = !filterSecondOpen;
            _this5.setState({ filterSecondOpen: opposite });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 530
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Picker__filter__second__heading__btn__margin', __source: {
            fileName: _jsxFileName,
            lineNumber: 539
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Picker__filter__second__title__list', __source: {
            fileName: _jsxFileName,
            lineNumber: 543
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Picker__filter__second__title__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 544
            }
          },
          filtered.map(function (data, index) {
            var component = data.category;
            var id = data.name;
            var props = Object.assign({}, component.props);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */], _extends({
              key: id
            }, props, {
              showTitle: true,
              currentFilterId: currentFilterId,
              filterId: id,
              filterIndex: index,
              titleClickCaller: _this5.onTitleClickCaller,
              parentFilter: data.parent,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 551
              }
            }));
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'Picker__filter__second__title__list__btn__close',
          type: 'button',
          onClick: function onClick(event) {
            event.preventDefault();
            _this5.setState({ filterSecondOpen: false });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 565
          }
        })
      )
    );
  };

  /**
   * filter out put
   * @returns {React.Element} `div.filter__seconds__root`
   * */


  Picker.prototype.renderFilterSecond = function renderFilterSecond() {
    var pc = this.renderFilterSecondPc();
    var mb = this.renderFilterSecondMb();
    if (!pc && !mb) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'filter__seconds__root', __source: {
          fileName: _jsxFileName,
          lineNumber: 589
        }
      },
      pc,
      mb
    );
  };

  // --------------------------------------------------
  /**
   * filter out put - 階層数を class 末尾に付与します `Picker__filter__line1`
   * @returns {React.Element} `div.Picker__filter`
   * */


  Picker.prototype.renderFilters = function renderFilters() {
    var filterFirst = this.renderFilterFirst();
    var filterSecond = this.renderFilterSecond();
    if (!filterFirst && !filterSecond) {
      return null;
    }
    // const line = second.length > 0 ? 2 : 1;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Picker__filter', __source: {
          fileName: _jsxFileName,
          lineNumber: 609
        }
      },
      filterFirst,
      filterSecond
    );
  };

  // --------------------------------------------------


  Picker.prototype.renderCta = function renderCta() {
    var cta = this.props.cta;

    if (!Array.isArray(cta) || !cta.length) {
      return null;
    }
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Picker__cta', __source: {
          fileName: _jsxFileName,
          lineNumber: 624
        }
      },
      cta
    );
  };

  // --------------------------------------------------


  Picker.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        textColor = _props.textColor,
        layout = _props.layout,
        thumbnail = _props.thumbnail;
    // ---
    // const categories = this.convertPropsCategories();

    var categories = this.categories;
    // console.log('Picker.render', this.state);
    if (!categories.length) {
      return null;
    }
    // ---
    var textColorClass = 'textColor__' + (textColor || 'Dark').toLowerCase();
    var layoutClass = 'layout__' + (layout || 'Article').toLowerCase();
    var thumbnailClass = thumbnail ? '' : 'thumbnail__hide';
    var filterChangeOpacityClassName = this.state.filterChangeOpacityClassName;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 655
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 661
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Picker ' + textColorClass + ' ' + layoutClass + ' ' + thumbnailClass + ' ' + filterChangeOpacityClassName, __source: {
              fileName: _jsxFileName,
              lineNumber: 662
            }
          },
          this.renderFilters(),
          this.renderThumbnails(),
          this.renderCta()
        )
      )
    );
  };

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  textColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  thumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  categories: null,
  textColor: null,
  layout: null,
  thumbnail: null,
  cta: null
}, _temp);
Picker.displayName = 'Picker';


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spacer_png__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spacer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__spacer_png__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view-accessories\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  ExteriorViewAccessories
 */
var ExteriorViewAccessories = (_temp = _class = function (_Component) {
  _inherits(ExteriorViewAccessories, _Component);

  function ExteriorViewAccessories(props) {
    _classCallCheck(this, ExteriorViewAccessories);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {
      selectedIndex: _this.props.selectedIndex
    };
    return _this;
  }

  ExteriorViewAccessories.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        description = _props.description,
        information = _props.information,
        items = _props.items,
        isFirst = _props.isFirst,
        isLast = _props.isLast,
        step = _props.step,
        selectedIndex = _props.selectedIndex,
        selectAccessoryIndex = _props.selectAccessoryIndex,
        closeAccessorySelector = _props.closeAccessorySelector,
        clearAccessoryIndex = _props.clearAccessoryIndex,
        goToStep = _props.goToStep,
        isPrev = _props.isPrev,
        accessoryLabel = _props.accessoryLabel,
        openAccessoryDetail = _props.openAccessoryDetail;

    // 詳細

    var renderDescription = function renderDescription() {
      if (description && description !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorViewAccessories__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: description }, __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          })
        );
      } else {
        return null;
      }
    };

    // アイテム
    var renderItems = function renderItems() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'ExteriorViewAccessories__list', __source: {
            fileName: _jsxFileName,
            lineNumber: 99
          }
        },
        items.map(function (item, index) {
          if ((!item.text || item.text === '') && (!item.src || item.src === '')) {
            return null;
          } else {
            var name = ' ExteriorViewAccessories__link-';
            if (step === 0) {
              name = name + 'A' + String(index + 1);
            } else if (step === 1) {
              name = name + 'B' + String(index + 1);
            } else if (step === 1) {
              name = name + 'C' + String(index + 1);
            } else if (step === 1) {
              name = name + 'D' + String(index + 1);
            }

            var getExtendClass = function getExtendClass(index) {
              if (_this2.state.selectedIndex === index) {
                return ' selected';
              } else if (_this2.state.selectedIndex !== null && 0 <= _this2.state.selectedIndex) {
                return ' unselected';
              } else {
                return '';
              }
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 126
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'ExteriorViewAccessories__link' + name + getExtendClass(index)
                  //href={'#' + item.id}
                  , href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this2.setState({
                      selectedIndex: index
                    });
                    //if (selectAccessoryIndex) selectAccessoryIndex(step, index, item.id);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 127
                  }
                },
                item.src && item.src !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'ExteriorViewAccessories__image-wrapper', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 141
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'ExteriorViewAccessories__image-wrapper2',
                      style: { backgroundImage: 'url(' + item.src + ')' }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 142
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'ExteriorViewAccessories__image', src: __WEBPACK_IMPORTED_MODULE_4__spacer_png___default.a, alt: '', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 144
                      }
                    })
                  )
                ) : '',
                item.text && item.text !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'ExteriorViewAccessories__paragraph Wysiwyg', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 149
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: item.text }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 150
                    }
                  })
                ) : ''
              )
            );
          }
        })
      );
    };

    // 前へ、次へ、決定、ナビゲーション
    var renderNav = function renderNav() {
      var renderLinkPrev = function renderLinkPrev() {
        if (isFirst === true) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 167
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'ExteriorViewAccessories__link-prev',
                href: 'javascript:void(0);',
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 168
                }
              },
              '\xA0'
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 174
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'ExteriorViewAccessories__link-prev',
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  //
                  if (goToStep) goToStep(step - 1);
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 175
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 182
                  }
                },
                '\u524D\u306B\u623B\u308B'
              )
            )
          );
        }
      };
      var renderLinkNext = function renderLinkNext() {
        if (isLast === false) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 189
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'ExteriorViewAccessories__link-next' + (_this2.state.selectedIndex !== null ? ' active' : ''),
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  //
                  if (selectAccessoryIndex) selectAccessoryIndex(step, _this2.state.selectedIndex, _this2.props.items[_this2.state.selectedIndex].id);
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 190
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 197
                  }
                },
                '\u6B21\u306E\u30A2\u30AF\u30BB\u30B5\u30EA\u30FC\u3092\u9078\u629E'
              )
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 202
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'ExteriorViewAccessories__link-next' + (_this2.state.selectedIndex !== null ? ' active' : ''),
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  //
                  if (selectAccessoryIndex) selectAccessoryIndex(step, _this2.state.selectedIndex, _this2.props.items[_this2.state.selectedIndex].id);
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 203
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 210
                  }
                },
                '360\xB0View\u3067\u898B\u308B'
              )
            )
          );
        }
      };
      var renderLinkClear = function renderLinkClear() {
        if (isFirst === false || _this2.state.selectedIndex !== null) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 218
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'ExteriorViewAccessories__link-clear',
                href: 'javascript:void(0)',
                onClick: function onClick(e) {
                  e.preventDefault();
                  if (clearAccessoryIndex) clearAccessoryIndex();
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 219
                }
              },
              '全選択解除'
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 232
            }
          });
        }
        // if (isFirst ===  true) {
        //   return (
        //     <li>
        //       <a className="ExteriorViewAccessories__link-clear"
        //          href="javascript:void(0)"
        //          onClick={(e) => {
        //            e.preventDefault();
        //            if (clearAccessoryIndex) clearAccessoryIndex();
        //            if (closeAccessorySelector) closeAccessorySelector();
        //          }}
        //       >
        //         {'全選択解除'}
        //       </a>
        //     </li>
        //   )
        // } else {
        //   return (
        //     <li>
        //       <a className="ExteriorViewAccessories__link-clear"
        //          href="javascript:void(0)"
        //          onClick={(e) => {
        //            e.preventDefault();
        //            if (clearAccessoryIndex) clearAccessoryIndex();
        //          }}
        //       >
        //         {'全選択解除'}
        //       </a>
        //     </li>
        //   )
        // }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'ExteriorViewAccessories__list-nav', __source: {
            fileName: _jsxFileName,
            lineNumber: 268
          }
        },
        renderLinkPrev(),
        renderLinkNext(),
        renderLinkClear()
      );
    };

    // アクセサリ詳細
    var renderLinkDetail = function renderLinkDetail() {
      if (accessoryLabel && accessoryLabel !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'ExteriorViewAccessories__link-detail',
            href: 'javascript:void(0)',
            onClick: function onClick(e) {
              e.preventDefault();
              if (openAccessoryDetail) openAccessoryDetail();
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 280
            }
          },
          accessoryLabel
        );
      } else {
        return null;
      }
    };

    // インフォメーション
    var renderInformation = function renderInformation() {
      if (information && information !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorViewAccessories__information Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 299
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: information }, __source: {
              fileName: _jsxFileName,
              lineNumber: 300
            }
          })
        );
      } else {
        return null;
      }
    };

    // 開くクラス取得
    var getOpenClass = function getOpenClass() {
      if (_this2.props.open === true) {
        if (_this2.props.isPrev === true) {
          return ' prev';
        } else {
          return ' next';
        }
      } else {
        return '';
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 322
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ExteriorViewAccessories' + getOpenClass(), __source: {
            fileName: _jsxFileName,
            lineNumber: 327
          }
        },
        renderDescription(),
        renderItems(),
        renderNav(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorViewAccessories__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 335
            }
          },
          renderLinkDetail()
        ),
        renderInformation()
      )
    );
  };

  ExteriorViewAccessories.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      selectedIndex: nextProps.selectedIndex
    });
  };

  return ExteriorViewAccessories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  information: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isFirst: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isLast: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selectedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selectAccessoryIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  closeAccessorySelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearAccessoryIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  accessoryLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openAccessoryDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  description: null,
  information: null,
  items: null,
  open: null,
  isFirst: null,
  isLast: null,
  step: null,
  selectedIndex: null,
  selectAccessoryIndex: null,
  closeAccessorySelector: null,
  clearAccessoryIndex: null,
  goToStep: null,
  isPrev: null,
  accessoryLabel: null,
  openAccessoryDetail: null
}, _temp);
ExteriorViewAccessories.displayName = 'ExteriorViewAccessories';


/* harmony default export */ __webpack_exports__["a"] = (ExteriorViewAccessories);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_accordion__ = __webpack_require__(28);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\maker-set-option-more-info-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  MakerSetOptionMoreInfoItem
 */
var MakerSetOptionMoreInfoItem = (_temp = _class = function (_Component) {
  _inherits(MakerSetOptionMoreInfoItem, _Component);

  function MakerSetOptionMoreInfoItem(props) {
    _classCallCheck(this, MakerSetOptionMoreInfoItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getHeight = function () {
      if (_this.props.makerSetOptionImageSrc && _this.props.makerSetOptionImageSrc !== '') {
        var titleHeight = _this.refs.container.getElementsByClassName('Accordion__title')[0].clientHeight;
        var imageHeight = _this.refs.image.clientHeight;
        return titleHeight + imageHeight + 75;
      } else {
        return 240;
      }
    };

    _this.setHeight = function (height) {
      height = Math.floor(height);
      if (height < _this.refs.container.clientHeight) {
        _this.setState({
          wrapHeight: height,
          isHidden: true
        });
      } else {
        _this.setState({
          wrapHeight: height,
          isHidden: false
        });
      }
    };

    _this.props = props;
    _this.state = {
      wrapHeight: 'auto',
      isHidden: true,
      isOpened: false
    };
    return _this;
  }

  MakerSetOptionMoreInfoItem.prototype.render = function render() {
    var _this2 = this;

    var getPcImage = function getPcImage() {
      if (_this2.props.makerSetOptionImageSrc && _this2.props.makerSetOptionImageSrc !== '') {
        return _this2.props.makerSetOptionImageSrc;
      } else {
        return null;
      }
    };

    var getMbImage = function getMbImage() {
      if (_this2.props.mbMakerSetOptionImageSrc && _this2.props.mbMakerSetOptionImageSrc !== '') {
        return _this2.props.mbMakerSetOptionImageSrc;
      } else {
        return getPcImage();
      }
    };

    var getDetailPc = function getDetailPc() {
      if (_this2.props.detail && _this2.props.detail !== '') {
        return _this2.props.detail;
      } else {
        return null;
      }
    };

    var getDetailMb = function getDetailMb() {
      if (_this2.props.mbDetail && _this2.props.mbDetail !== '') {
        return _this2.props.mbDetail;
      } else {
        return getDetailPc();
      }
    };

    // 画像
    var renderImage = function renderImage() {
      if (getPcImage()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOptionMoreInfoItem__image', __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'MakerSetOptionMoreInfoItem__image__box', __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'MakerSetOptionMoreInfoItem__image-pc', src: getPcImage(), alt: '', __source: {
                fileName: _jsxFileName,
                lineNumber: 90
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'MakerSetOptionMoreInfoItem__image-mb', src: getMbImage(), alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            }
          })
        );
      } else {
        return null;
      }
    };

    // アイテム
    var renderItems = function renderItems() {
      if (_this2.props.items && _this2.props.items !== '') {
        var items = _this2.props.items;
        items = items.replace(/<br>/g, '|');
        items = items.replace(/<br \/>/g, '|');
        items = items.replace(/<br\/>/g, '|');
        var arr = items.split('|');
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOptionMoreInfoItem__items', __source: {
              fileName: _jsxFileName,
              lineNumber: 109
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'MakerSetOptionMoreInfoItem__items__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 110
              }
            },
            arr.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 113
                  }
                },
                item
              );
            })
          )
        );
      } else {
        return null;
      }
    };

    // 詳細
    var renderDetail = function renderDetail() {
      var detail = getDetailPc();
      var detailMb = getDetailMb();
      if (detail && detailMb) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOptionMoreInfoItem__detail', __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MakerSetOptionMoreInfoItem__detail__link',
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                if (_this2.props.openModalWindow !== null) {
                  _this2.props.openModalWindow({
                    detail: detail,
                    detailMb: detailMb
                  });
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 131
              }
            },
            _this2.props.detailLinkLabel && _this2.props.detailLinkLabel !== '' ? _this2.props.detailLinkLabel : null
          )
        );
      } else {
        return null;
      }
    };

    // もっと見る
    var renderMoreInfo = function renderMoreInfo() {
      if (_this2.state.isHidden === true && _this2.state.isOpened === false) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOptionMoreInfoItem__more-info', __source: {
              fileName: _jsxFileName,
              lineNumber: 158
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'MakerSetOptionMoreInfoItem__more-info__link', href: 'javascript:void(0);', onClick: function onClick(e) {
                e.preventDefault();
                //
                _this2.setState({
                  isOpened: true
                });
              }, __source: {
                fileName: _jsxFileName,
                lineNumber: 159
              }
            },
            '\u3059\u3079\u3066\u8868\u793A'
          )
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 174
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'MakerSetOptionMoreInfoItem', style: this.state.isOpened === true ? { height: 'auto' } : { height: this.state.wrapHeight }, __source: {
            fileName: _jsxFileName,
            lineNumber: 180
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOptionMoreInfoItem__container', ref: 'container', __source: {
              fileName: _jsxFileName,
              lineNumber: 181
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'MakerSetOptionMoreInfoItem__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 182
              }
            },
            function () {
              if (getMbImage() || _this2.props.items && _this2.props.items !== '' || getDetailMb()) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__components_accordion__["a" /* default */],
                  {
                    pcText: _this2.props.name && _this2.props.name !== '' ? _this2.props.name : '',
                    open: false,
                    current: false,
                    simpleAnimation: false,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 186
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'MakerSetOptionMoreInfoItem__box', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 192
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { ref: 'image', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 193
                        }
                      },
                      renderImage()
                    ),
                    renderItems(),
                    renderDetail()
                  )
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Accordion', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 203
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Accordion__title', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 204
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'Accordion__title-pc', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 205
                        }
                      },
                      _this2.props.name && _this2.props.name !== '' ? _this2.props.name : ''
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'Accordion__title-mb', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 206
                        }
                      },
                      _this2.props.name && _this2.props.name !== '' ? _this2.props.name : ''
                    )
                  )
                );
              }
            }(),
            renderMoreInfo()
          )
        )
      )
    );
  };

  // 高さ取得


  // 高さ設定


  return MakerSetOptionMoreInfoItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  makerSetOptionImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbMakerSetOptionImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detailLinkLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openModalWindow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  name: null,
  items: null,
  makerSetOptionImageSrc: null,
  mbMakerSetOptionImageSrc: null,
  detailLinkLabel: null,
  detail: null,
  mbDetail: null,
  openModalWindow: null
}, _temp);
MakerSetOptionMoreInfoItem.displayName = 'MakerSetOptionMoreInfoItem';


/* harmony default export */ __webpack_exports__["a"] = (MakerSetOptionMoreInfoItem);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_estimate_link__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\eco-tax\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 *  EcoTax
 */
var EcoTax = (_temp = _class = function (_Component) {
  _inherits(EcoTax, _Component);

  function EcoTax(props) {
    _classCallCheck(this, EcoTax);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getDefaultBodyTypeModel = function () {
      var bodyTypeModel = null;
      _this.props.models[0].bodyTypes.map(function (bodyType) {
        if (bodyType.default === true) {
          bodyTypeModel = bodyType.carId;
        }
      });
      return bodyTypeModel;
    };

    _this.getBodyTypeInfo = function () {
      var arr = [];
      _this.props.models[0].bodyTypes.map(function (bodyType) {
        arr.push({
          carId: bodyType.carId,
          bodyTypeTabName: bodyType.bodyTypeTabName
        });
      });
      return arr;
    };

    _this.changeBodyType = function (bodyTypeModel) {
      _this.setState({
        currentBodyTypeModel: bodyTypeModel,
        isOpened: false
      });
      setTimeout(function () {
        _this.setState({
          totalCount: _this.getVariantInfoByBodyTypeModel(_this.state.currentBodyTypeModel).length,
          currentBodyTypeModel: bodyTypeModel,
          isOpened: true
        });
      }, 100);
    };

    _this.getVariantInfoByBodyTypeModel = function (bodyTypeModel) {
      var arr = [];
      _this.props.models[0].bodyTypes.map(function (bodyType) {
        if (bodyType.carId === bodyTypeModel) {
          var carId = bodyType.carId;
          var carTypeCode = bodyType.generations[0].carTypeCode;
          bodyType.generations[0].grades.map(function (grade) {
            //const gradeCode = grade.gradeCode;
            var gradeId = grade.gradeId;
            var gradeName = grade.gradeName;
            var specialCar = grade.specialCar;
            grade.variants.map(function (variant) {
              arr.push({
                carId: carId,
                carTypeCode: carTypeCode,
                //gradeCode: gradeCode,
                gradeId: gradeId,
                gradeName: gradeName,
                specialCar: specialCar,
                drive: variant.drive,
                transmission: variant.transmission,
                gradeCode: variant.gradeCode,
                engine: variant.engine,
                kankyowari: variant.kankyowari,
                subsidy: variant.subsidy,
                taxInfo: variant.taxInfo ? {
                  //acquisitionTaxPrice: variant.taxInfo.acquisitionTaxPrice,
                  //acquisitionTaxRate: variant.taxInfo.acquisitionTaxRate,
                  //weightTaxPrice: variant.taxInfo.weightTaxPrice,
                  weightTaxRate: variant.taxInfo.weightTaxRate,
                  grTaxRate: variant.taxInfo.grTaxRate
                  //taxCut: variant.taxInfo.taxCut,
                } : null
              });
            });
          });
        }
      });
      return arr;
    };

    _this.handleResize = function () {
      if (_this.intervalId) clearTimeout(_this.intervalId);
      _this.intervalId = setTimeout(function () {
        var maxHeight = 0;
        _this.variants.map(function (ref, index) {
          if (_this.refs[ref] && _this.refs[ref].clientHeight) {
            var height = _this.refs[ref].clientHeight;
            if (maxHeight < height) {
              maxHeight = height;
            }
          }
        });
        _this.setState({
          variantHeight: maxHeight
        });
      }, 200);
    };

    _this.props = props;
    _this.state = {
      isOpened: true,
      currentBodyTypeModel: _this.getDefaultBodyTypeModel(),
      variantHeight: null,
      isMounted: false,
      currentIndex: 1,
      totalCount: _this.getVariantInfoByBodyTypeModel(_this.getDefaultBodyTypeModel()).length
    };
    _this.variants = [];
    _this.intervalId = null;
    return _this;
  }

  EcoTax.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
    if (this.getVariantInfoByBodyTypeModel(this.state.currentBodyTypeModel).length <= (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] === true ? 1 : 4)) {} else {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  };

  EcoTax.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  EcoTax.prototype.render = function render() {
    var _this2 = this;

    // ボディタイプ選択
    var renderBodyTypeSelector = function renderBodyTypeSelector() {
      var bodyTypeInfo = _this2.getBodyTypeInfo();
      return bodyTypeInfo && 2 <= bodyTypeInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'EcoTax__body-type-selector', __source: {
            fileName: _jsxFileName,
            lineNumber: 102
          }
        },
        bodyTypeInfo.map(function (bodyTypeInfo, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 105
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'EcoTax__body-type-selector__link' + (bodyTypeInfo.carId === _this2.state.currentBodyTypeModel ? ' current' : ''),
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this2.setState({
                    currentIndex: 1
                  });
                  _this2.changeBodyType(bodyTypeInfo.carId);
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 106
                }
              },
              bodyTypeInfo.bodyTypeTabName
            )
          );
        })
      ) : null;
    };

    // 機種一覧
    var renderVariants = function renderVariants() {
      if (_this2.getVariantInfoByBodyTypeModel(_this2.state.currentBodyTypeModel).length <= (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] === true ? 1 : 4)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants fixed' + (_this2.state.isOpened === true ? ' current' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 131
            }
          },
          _this2.getVariantInfoByBodyTypeModel(_this2.state.currentBodyTypeModel).map(function (variantInfo, index) {
            return renderVariant(variantInfo, index);
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 141
            }
          },
          _this2.props.models[0].bodyTypes.map(function (bodyType, index) {
            if (bodyType.carId === _this2.state.currentBodyTypeModel) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'EcoTax__variants' + (_this2.state.isOpened === true ? ' current' : ''), key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 145
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'EcoTax__variants__pager', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 147
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 147
                      }
                    },
                    _this2.state.currentIndex
                  ),
                  '/',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 147
                      }
                    },
                    _this2.getVariantInfoByBodyTypeModel(bodyType.carId).length
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__components_slider__["a" /* default */],
                  {
                    ref: 'slider',
                    settings: {
                      autoplay: false,
                      autoplaySpeed: 3000,
                      speed: 1000,
                      ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                      fade: false,
                      infinite: true,
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      swipe: true,
                      draggable: false,
                      arrows: true,
                      dots: true,
                      adaptiveHeight: false,
                      centerMode: false,
                      centerPadding: 0,
                      waitForAnimate: false,
                      lazyLoad: 'progressive',
                      // appendDots: (dots)=> {
                      //   return (
                      //     <ol>{dots}</ol>
                      //   )
                      // },
                      beforeChange: function beforeChange(oldIndex, newIndex) {
                        _this2.refs.slider.beforeChange(oldIndex, newIndex);
                        _this2.setState({
                          currentIndex: newIndex + 1
                        });
                      },
                      responsive: [{
                        breakpoint: 767,
                        settings: {
                          speed: 500,
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          centerMode: true,
                          centerPadding: '10%',
                          dots: false
                        }
                      }]
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 149
                    }
                  },
                  _this2.getVariantInfoByBodyTypeModel(bodyType.carId).map(function (variantInfo, index) {
                    return renderVariant(variantInfo, index);
                  })
                )
              );
            } else {
              return null;
            }
          })
        );
      }
    };

    // 機種
    var renderVariant = function renderVariant(variantInfo, index) {
      var ref = 'container' + index;
      _this2.variants.push(ref);
      //
      var getGradeName = function getGradeName() {
        if (variantInfo.specialCar === true) {
          return variantInfo.gradeId;
        } else {
          if (variantInfo.gradeName && variantInfo.gradeName !== '') {
            return variantInfo.gradeName;
          } else {
            return variantInfo.gradeId;
          }
        }
      };

      // 100th Anniversary Special Edition > 100周年特別記念車
      var convert100th = function convert100th(text) {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '2020 WCDOTY受賞記念モデル');
          // text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          return text;
        } else {
          return text;
        }
      };

      //
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'EcoTax__variants__item', key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 258
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__container', style: _this2.state.variantHeight && 0 < _this2.state.variantHeight ? { height: _this2.state.variantHeight } : null, __source: {
              fileName: _jsxFileName,
              lineNumber: 259
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { ref: ref, __source: {
                fileName: _jsxFileName,
                lineNumber: 260
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'EcoTax__variants__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 261
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'EcoTax__variants__box-inner', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 262
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'EcoTax__variants__grade', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 263
                    }
                  },
                  convert100th(getGradeName())
                ),
                variantInfo.drive && variantInfo.drive !== '' && variantInfo.transmission && variantInfo.transmission !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'EcoTax__variants__spec', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 267
                    }
                  },
                  variantInfo.drive + '/' + variantInfo.transmission
                ) : null
              )
            ),
            renderKankyowari(variantInfo),
            renderSubsidy(variantInfo),
            renderWeightTax(variantInfo),
            renderEstimationLink(variantInfo)
          )
        )
      );
    };

    // 環境性能割
    var renderKankyowari = function renderKankyowari(variantInfo) {
      if (variantInfo.kankyowari === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 290
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 291
              }
            },
            '\u81EA\u52D5\u8ECA\u7A0E\uFF08\u74B0\u5883\u6027\u80FD\u5272\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy', __source: {
                fileName: _jsxFileName,
                lineNumber: 292
              }
            },
            '\u975E\u8AB2\u7A0E'
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 297
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 298
              }
            },
            '\u81EA\u52D5\u8ECA\u7A0E\uFF08\u74B0\u5883\u6027\u80FD\u5272\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy-excluded', __source: {
                fileName: _jsxFileName,
                lineNumber: 299
              }
            },
            '\u8AB2\u7A0E\u5BFE\u8C61'
          )
        );
      }
    };

    // クリーンディーゼル補助金
    var renderSubsidy = function renderSubsidy(variantInfo) {
      if (!_this2.props.hideSubsidy) {
        if (variantInfo.subsidy === true) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'EcoTax__variants__box3', __source: {
                fileName: _jsxFileName,
                lineNumber: 310
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'EcoTax__variants__heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 311
                }
              },
              '\u88DC\u52A9\u91D1'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'EcoTax__variants__subsidy', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 312
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 312
                  }
                },
                'CEV'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 312
                  }
                },
                '\u88DC\u52A9\u91D1\u5BFE\u8C61'
              )
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'EcoTax__variants__box3', __source: {
                fileName: _jsxFileName,
                lineNumber: 318
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'EcoTax__variants__heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 319
                }
              },
              '\u88DC\u52A9\u91D1'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'EcoTax__variants__subsidy-excluded', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 320
                }
              },
              '\u5BFE\u8C61\u5916'
            )
          );
        }
      } else {
        return null;
      }
    };

    // エコカー減税
    var renderWeightTax = function renderWeightTax(variantInfo) {
      if (variantInfo.taxInfo && 100 <= variantInfo.taxInfo.weightTaxRate) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 333
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 334
              }
            },
            '\u91CD\u91CF\u7A0E\uFF08\u30A8\u30B3\u30AB\u30FC\u6E1B\u7A0E\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy', __source: {
                fileName: _jsxFileName,
                lineNumber: 335
              }
            },
            '\u514D\u7A0E'
          )
        );
      } else if (variantInfo.taxInfo && 0 < variantInfo.taxInfo.weightTaxRate) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 340
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 341
              }
            },
            '\u91CD\u91CF\u7A0E\uFF08\u30A8\u30B3\u30AB\u30FC\u6E1B\u7A0E\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy', __source: {
                fileName: _jsxFileName,
                lineNumber: 342
              }
            },
            variantInfo.taxInfo.weightTaxRate,
            '%\u6E1B\u7A0E'
          )
        );
      } else if (variantInfo.taxInfo && variantInfo.taxInfo.grTaxRate === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 347
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 348
              }
            },
            '\u91CD\u91CF\u7A0E\uFF08\u30A8\u30B3\u30AB\u30FC\u6E1B\u7A0E\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy-excluded', __source: {
                fileName: _jsxFileName,
                lineNumber: 349
              }
            },
            '\u672C\u5247\u7A0E\u7387'
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box3', __source: {
              fileName: _jsxFileName,
              lineNumber: 354
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'EcoTax__variants__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 355
              }
            },
            '\u91CD\u91CF\u7A0E\uFF08\u30A8\u30B3\u30AB\u30FC\u6E1B\u7A0E\uFF09'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'EcoTax__variants__subsidy-excluded', __source: {
                fileName: _jsxFileName,
                lineNumber: 356
              }
            },
            '\u6E1B\u7A0E\u5BFE\u8C61\u5916'
          )
        );
      }
    };

    // 見積もりシミュレーションボタン
    var renderEstimationLink = function renderEstimationLink(variantInfo) {
      if (!_this2.props.hideEstimationButton && _this2.props.models[0].vehicleType !== 'Commercial Car') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__variants__box4', __source: {
              fileName: _jsxFileName,
              lineNumber: 366
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_estimate_link__["a" /* default */], _extends({
            label: '見積りシミュレーション',
            targetBlank: false,
            color: 'Dark',
            buttonStyle: 'Action',
            linkType: 'Button',
            carId: variantInfo.carId,
            carTypeCode: variantInfo.carTypeCode,
            gradeCode: variantInfo.gradeCode,
            drive: variantInfo.drive,
            mission: variantInfo.transmission,
            engine: variantInfo.engine,
            ecode: null,
            soptions: null,
            direct: 'Result'
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 367
            }
          }))
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 391
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'EcoTax', __source: {
            fileName: _jsxFileName,
            lineNumber: 397
          }
        },
        renderBodyTypeSelector(),
        this.state.isMounted === true ? renderVariants() : null,
        this.props.description && this.props.description !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EcoTax__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 404
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            dangerouslySetInnerHTML: { __html: this.props.description }, __source: {
              fileName: _jsxFileName,
              lineNumber: 405
            }
          })
        ) : null
      )
    );
  };

  // デフォルトCarId取得


  // ボディタイプ情報取得


  // ボディタイプ変更


  // 機種情報取得


  //


  return EcoTax;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideSubsidy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideEstimationButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    vehicleType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      generations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        grades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          variants: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            taxInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
              //acquisitionTaxPrice: PropTypes.number,
              //acquisitionTaxRate: PropTypes.number,
              //weightTaxPrice: PropTypes.number,
              weightTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
              grTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
              //taxCut: PropTypes.number,
            }),
            kankyowari: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
            subsidy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
          }))
        }))
      }))
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  description: null,
  hideSubsidy: null,
  hideEstimationButton: null,
  models: null
}, _temp);
EcoTax.displayName = 'EcoTax';


/* harmony default export */ __webpack_exports__["a"] = (EcoTax);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\car-lineup-filter\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  CarLineupFilter
 */
var CarLineupFilter = (_temp = _class = function (_PureComponent) {
  _inherits(CarLineupFilter, _PureComponent);

  function CarLineupFilter(props) {
    _classCallCheck(this, CarLineupFilter);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.props = props;
    _this.state = {};
    return _this;
  }

  CarLineupFilter.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        bodyType = _props.bodyType,
        engineType = _props.engineType,
        mission = _props.mission,
        drive = _props.drive,
        capacity = _props.capacity,
        price = _props.price,
        displacement = _props.displacement,
        bodySize = _props.bodySize,
        others = _props.others;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass, __source: {
          fileName: _jsxFileName,
          lineNumber: 100
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarLineupFilter', __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--bodyType', __source: {
              fileName: _jsxFileName,
              lineNumber: 104
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 105
              }
            },
            bodyType.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              }
            },
            bodyType.filterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'CarLineupFilter__Column__List__Item', key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 111
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'radio',
                  formName: 'bodyType',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 112
                  }
                }))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--engineType', __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 124
              }
            },
            engineType.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 125
              }
            },
            engineType.filterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'CarLineupFilter__Column__List__Item', key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 130
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'radio',
                  formName: 'engineType',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 131
                  }
                }))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--mission', __source: {
              fileName: _jsxFileName,
              lineNumber: 142
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 143
              }
            },
            mission.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            },
            mission.filterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 149
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'radio',
                  formName: 'mission',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 150
                  }
                }))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--drive', __source: {
              fileName: _jsxFileName,
              lineNumber: 161
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 162
              }
            },
            drive.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 163
              }
            },
            drive.filterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 168
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'radio',
                  formName: 'drive',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 169
                  }
                }))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--capacity', __source: {
              fileName: _jsxFileName,
              lineNumber: 180
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 181
              }
            },
            capacity.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 182
              }
            },
            capacity.filterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 187
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'radio',
                  formName: 'capacity',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 188
                  }
                }))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--price-displacement', __source: {
              fileName: _jsxFileName,
              lineNumber: 200
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column CarLineupFilter__Column--price', __source: {
                fileName: _jsxFileName,
                lineNumber: 201
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__Title', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 202
                }
              },
              price.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { name: 'price', className: 'CarLineupFilter__Column__Select', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 203
                }
              },
              price.filterItems.map(function (data, index) {
                var props = Object.assign({}, data.props);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'option',
                  formName: 'price',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 208
                  }
                }));
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column CarLineupFilter__Column--displacement', __source: {
                fileName: _jsxFileName,
                lineNumber: 218
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__Title', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 219
                }
              },
              displacement.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__Container', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 220
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'select',
                { name: 'minDisplacement', className: 'CarLineupFilter__Column__Select', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 221
                  }
                },
                displacement.minFilterItems.map(function (data, index) {
                  var props = Object.assign({}, data.props);
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                    formType: 'option',
                    formName: 'minDisplacement',
                    key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 226
                    }
                  }));
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'CarLineupFilter__Column--displacement__range', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 235
                  }
                },
                '\u301C'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'select',
                { name: 'maxDisplacement', className: 'CarLineupFilter__Column__Select', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 236
                  }
                },
                displacement.maxFilterItems.map(function (data, index) {
                  var props = Object.assign({}, data.props);
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                    formType: 'option',
                    formName: 'maxDisplacement',
                    key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 241
                    }
                  }));
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--bodySize', __source: {
              fileName: _jsxFileName,
              lineNumber: 254
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            },
            bodySize.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Container', __source: {
                fileName: _jsxFileName,
                lineNumber: 256
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__FormTitle', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 257
                }
              },
              bodySize.lengthTitle
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { name: 'bodySizeLength', className: 'CarLineupFilter__Column__Select', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 258
                }
              },
              bodySize.lengthFilterItems.map(function (data, index) {
                var props = Object.assign({}, data.props);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'option',
                  formName: 'bodySizeLength',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 263
                  }
                }));
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Container', __source: {
                fileName: _jsxFileName,
                lineNumber: 273
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__FormTitle', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 274
                }
              },
              bodySize.widthTitle
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { name: 'bodySizeWidth', className: 'CarLineupFilter__Column__Select', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 275
                }
              },
              bodySize.widthFilterItems.map(function (data, index) {
                var props = Object.assign({}, data.props);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'option',
                  formName: 'bodySizeWidth',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 280
                  }
                }));
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Container', __source: {
                fileName: _jsxFileName,
                lineNumber: 290
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineupFilter__Column__FormTitle', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 291
                }
              },
              bodySize.heightTitle
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { name: 'bodySizeHeight', className: 'CarLineupFilter__Column__Select', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 292
                }
              },
              bodySize.heightFilterItems.map(function (data, index) {
                var props = Object.assign({}, data.props);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'option',
                  formName: 'bodySizeHeight',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 297
                  }
                }));
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarLineupFilter__Column CarLineupFilter__Column--others', __source: {
              fileName: _jsxFileName,
              lineNumber: 308
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilter__Column__Title', __source: {
                fileName: _jsxFileName,
                lineNumber: 309
              }
            },
            others.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarLineupFilter__Column__List', __source: {
                fileName: _jsxFileName,
                lineNumber: 310
              }
            },
            others.kankyowariFilterItems ? others.kankyowariFilterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 316
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'checkbox',
                  formName: 'othersKankyowari',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 317
                  }
                }))
              );
            }) : null,
            others.svFilterItems ? others.svFilterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 332
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'checkbox',
                  formName: 'othersSv',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 333
                  }
                }))
              );
            }) : null,
            others.supportCarFilterItems ? others.supportCarFilterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 348
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'checkbox',
                  formName: 'othersSupportCar',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 349
                  }
                }))
              );
            }) : null,
            others.ecoTaxFilterItems ? others.ecoTaxFilterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 364
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'checkbox',
                  formName: 'othersEcoTax',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 365
                  }
                }))
              );
            }) : null,
            others.subsidyFilterItems ? others.subsidyFilterItems.map(function (data, index) {
              var props = Object.assign({}, data.props);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, className: 'CarLineupFilter__Column__List__Item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 380
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__car_lineup_filter_item__["a" /* default */], _extends({}, props, {
                  formType: 'checkbox',
                  formName: 'othersSubsidy',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 381
                  }
                }))
              );
            }) : null
          )
        )
      )
    );
  };

  return CarLineupFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  engineType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  mission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  capacity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    filterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  displacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    minFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    maxFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  bodySize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    lengthTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    lengthFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    widthTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    widthFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    heightTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    heightFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  others: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    svTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    svFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    supportCarTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    supportCarFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    ecoTaxTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ecoTaxFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    subsidyTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    subsidyFilterItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  })
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  bodyType: null,
  engineType: null,
  mission: null,
  drive: null,
  capacity: null,
  price: null,
  displacement: null,
  bodySize: null,
  others: null
}, _temp);
CarLineupFilter.displayName = 'CarLineupFilter';


/* harmony default export */ __webpack_exports__["a"] = (CarLineupFilter);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\car-lineup-filter-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  CarLineupFilterItem
 */
var CarLineupFilterItem = (_temp = _class = function (_PureComponent) {
  _inherits(CarLineupFilterItem, _PureComponent);

  function CarLineupFilterItem(props) {
    _classCallCheck(this, CarLineupFilterItem);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.props = props;
    _this.state = {};
    return _this;
  }

  CarLineupFilterItem.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        displayLabel = _props.displayLabel,
        value = _props.value,
        operator = _props.operator,
        formType = _props.formType,
        formName = _props.formName;


    switch (formType) {
      case 'radio':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
          { containerId: containerId, containerClass: containerClass, __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilterItem', __source: {
                fileName: _jsxFileName,
                lineNumber: 50
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { className: 'CarLineupFilterItem__Label', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 51
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', name: formName, value: value, 'data-operator': operator, className: 'CarLineupFilterItem__Label__Radio', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 51
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarLineupFilterItem__Label__Icon', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 51
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'CarLineupFilterItem__Label__Text', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 51
                  }
                },
                displayLabel
              )
            )
          )
        );
        break;
      case 'checkbox':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
          { containerId: containerId, containerClass: containerClass, __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilterItem', __source: {
                fileName: _jsxFileName,
                lineNumber: 59
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { className: 'CarLineupFilterItem__Label', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 60
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox', name: formName, value: value, 'data-operator': operator, className: 'CarLineupFilterItem__Label__Checkbox', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 60
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarLineupFilterItem__Label__Icon', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 60
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'CarLineupFilterItem__Label__Text', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 60
                  }
                },
                displayLabel
              )
            )
          )
        );
        break;
      case 'option':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { value: value, 'data-operator': operator, className: 'CarLineupFilterItem__Option', __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          },
          displayLabel
        );
        break;
      default:
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
          { containerId: containerId, containerClass: containerClass, __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarLineupFilterItem', __source: {
                fileName: _jsxFileName,
                lineNumber: 73
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { className: 'CarLineupFilterItem__Label', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', name: formName, value: value, 'data-operator': operator, className: 'CarLineupFilterItem__Label__Radio', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarLineupFilterItem__Label__Icon', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 74
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'CarLineupFilterItem__Label__Text', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 74
                  }
                },
                displayLabel
              )
            )
          )
        );
    }
  };

  return CarLineupFilterItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  displayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  operator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  displayLabel: null,
  value: null,
  operator: null,
  formType: null,
  formName: null
}, _temp);
CarLineupFilterItem.displayName = 'CarLineupFilterItem';


/* harmony default export */ __webpack_exports__["a"] = (CarLineupFilterItem);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__four_column_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accordion-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














/**
 *  AccordionItem
 */
var AccordionItem = (_temp = _class = function (_Component) {
  _inherits(AccordionItem, _Component);

  function AccordionItem(props) {
    _classCallCheck(this, AccordionItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onClick = function (e) {
      var isOpen = !_this.state.open;
      _this.setState({
        open: isOpen
      });
      setTimeout(function () {
        _this.setState({
          contentHeight: _this.state.open ? _this.innerRef.current.clientHeight : 0
        });
      }, 100);
    };

    _this.props = props;

    _this.state = {
      open: _this.props.open != null && _this.props.open === true ? true : false,
      contentHeight: _this.props.open != null && _this.props.open === true ? 'auto' : 0
    };

    _this.innerRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.onResize = _this.onResize.bind(_this);
    _this.intervalId = null;

    return _this;
  }

  AccordionItem.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      contentHeight: this.state.open ? this.innerRef.current.clientHeight : 0
    });
    __WEBPACK_IMPORTED_MODULE_10__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this2.onResize();
    }, 500);
  };

  AccordionItem.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_10__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  AccordionItem.prototype.onResize = function onResize() {
    this.setState({
      contentHeight: this.state.open ? this.innerRef.current.clientHeight : 0
    });
  };

  AccordionItem.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        pcText = _props.pcText,
        mbText = _props.mbText,
        components = _props.components,
        open = _props.open,
        color = _props.color;


    var itemPcText = void 0,
        itemMbText = void 0;
    itemPcText = pcText != null && pcText !== '' ? pcText : '';
    itemMbText = mbText != null && mbText !== '' ? mbText : pcText != null && pcText !== '' ? pcText : '';

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AccordionItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 104
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccordionItem__container AccordionItem__container--' + color + ' AccordionItem__container--' + (this.state.open ? 'open' : 'close'), __source: {
              fileName: _jsxFileName,
              lineNumber: 105
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccordionItem__container__title', onClick: this.onClick, __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              }
            },
            itemPcText && itemPcText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(itemPcText) }, className: 'AccordionItem__container__title__text--pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 107
              }
            }) : null,
            itemMbText && itemMbText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(itemMbText) }, className: 'AccordionItem__container__title__text--mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'AccordionItem__container__title__icon', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 109
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'AccordionItem__container__title__icon__v', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 110
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'AccordionItem__container__title__icon__h', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 111
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: "AccordionItem__container__content", style: { height: this.state.contentHeight }, __source: {
                fileName: _jsxFileName,
                lineNumber: 114
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: "AccordionItem__container__inner", ref: this.innerRef, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 115
                }
              },
              components.map(function (component, index) {
                if (component.name === 'Wysiwyg') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__wysiwyg__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 119
                    }
                  }));
                } else if (component.name === 'Html') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__html__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 124
                    }
                  }));
                } else if (component.name === 'OneColumnLayout') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__one_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 129
                    }
                  }));
                } else if (component.name === 'TwoColumnLayout') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__two_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 134
                    }
                  }));
                } else if (component.name === 'ThreeColumnLayout') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__three_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 139
                    }
                  }));
                } else if (component.name === 'FourColumnLayout') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__four_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 144
                    }
                  }));
                }
              })
            )
          )
        )
      )
    );
  };

  return AccordionItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcText: null,
  mbText: null,
  components: null,
  open: null,
  color: null
}, _temp);
AccordionItem.displayName = 'AccordionItem';


/* harmony default export */ __webpack_exports__["a"] = (AccordionItem);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\cta-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  CTANavigation
 */
var CTANavigation = (_temp = _class = function (_Component) {
  _inherits(CTANavigation, _Component);

  function CTANavigation(props) {
    _classCallCheck(this, CTANavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.init = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        _this.setState({
          hasTouch: true
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
        setTimeout(function () {

          // EPIServerのプレビュー時のモーダルの位置調整
          var isEpiServerPreview = false;
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
            var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
            if (wrapperElement) {
              isEpiServerPreview = true;
              setInterval(function () {
                _this.onScrollEpiPreview();
              }, 200);
              setTimeout(function () {
                if (_this.flg) {
                  _this.flg = false;
                  _this.setState({
                    open: false
                  });
                }
              }, 3000);
            }
          }
          if (!isEpiServerPreview) {
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].addEventListener('scroll', _this.onScroll);
          }
        }, 1000);
      } else {
        if (_this.props.interaction === true) {
          setTimeout(function () {
            _this.setState({
              open: true
            });
            __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].addEventListener('scroll', _this.onScrollTemporaryCheck);
          }, 1000);
        }

        // EPIServerのプレビュー時のモーダルの位置調整
        if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
          var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
          if (wrapperElement) {
            setInterval(function () {
              _this.onScrollTemporaryCheckEpiPreview();
            }, 200);
            setTimeout(function () {
              if (_this.flg) {
                _this.flg = false;
                _this.setState({
                  open: false
                });
              }
            }, 3000);
          }
        }
      }
    };

    _this.onScrollTemporaryCheck = function (e) {
      if (_this.props.interaction !== true) return;
      __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', _this.onScrollTemporaryCheck);
      if (_this.state.open) {
        _this.setState({
          open: false
        });
      }
    };

    _this.onScrollTemporaryCheckEpiPreview = function (e) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        var wrapperScrollTop = wrapperElement.scrollTop;
        //
        var bottom = function () {
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight);
          } else {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight - 100);
          }
        }();
        _this.setState({
          bottom: bottom
        });
      }
    };

    _this.onMouseOver = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        return false;
      }
      if (!_this.state.open) {
        _this.setState({
          open: true
        });
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    _this.onMouseOut = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        return false;
      }
      if (_this.state.open) {
        _this.setState({
          open: false
        });
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    _this.onClickHandle = function (e) {
      if (_this.state.open) {
        _this.setState({
          open: false
        });
      } else if (!_this.state.open) {
        _this.setState({
          open: true
        });
      }
    };

    _this.onScroll = function () {
      if (_this.flg) {
        _this.flg = false;
        _this.setState({
          open: false
        });
      }
      var element = document.getElementsByClassName('SocialIconsContainerBlock')[0];
      if (element) {
        var rect = element.getBoundingClientRect();
        var elementTop = rect.top + window.pageYOffset;
        var scrollTop = window.pageYOffset;
        var _windowHeight = window.innerHeight;
        if (elementTop <= _windowHeight + scrollTop) {
          if (_this.state.open) {
            _this.setState({
              open: false
            });
          }
        } else {
          if (!_this.state.open) {
            _this.setState({
              open: true
            });
          }
        }
      }
    };

    _this.onScrollEpiPreview = function () {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        var wrapperScrollTop = wrapperElement.scrollTop;
        //
        if (_this.flg) {
          _this.flg = false;
          _this.setState({
            open: false
          });
        }
        var element = document.getElementsByClassName('SocialIconsContainerBlock')[0];
        if (element) {
          var rect = element.getBoundingClientRect();
          var elementTop = rect.top + wrapperScrollTop;
          if (elementTop <= windowHeight + wrapperScrollTop) {
            if (_this.state.open) {
              _this.setState({
                open: false
              });
            }
          } else {
            if (!_this.state.open) {
              _this.setState({
                open: true
              });
            }
          }
        }
        //
        var bottom = function () {
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight);
          } else {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight - 100);
          }
        }();
        _this.setState({
          bottom: bottom
        });
      }
    };

    _this.props = props;
    _this.state = {
      open: false,
      hasTouch: false,
      bottom: 0
    };
    _this.touch = {
      startX: 100,
      startY: null,
      moveX: null,
      moveY: null
    };
    _this.flg = true;

    return _this;
  }

  CTANavigation.prototype.componentDidMount = function componentDidMount() {
    if (this.props.invisible) return;
    this.init();
  };

  // EPIServerのプレビュー時のモーダルの位置調整


  // EPIServerのプレビュー時のモーダルの位置調整


  CTANavigation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        items = _props.items;


    if (this.props.invisible) return null;

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 267
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'CTANavigation' + (this.state.open ? ' open' : '') + (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */] ? ' isMobile' : ' isPc'),
          style: function () {
            if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
              var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
              if (wrapperElement) {
                var wrapperWidth = wrapperElement.clientWidth;
                if (wrapperWidth < 768) {
                  return {
                    display: 'none'
                  };
                }
                return {
                  position: 'fixed',
                  bottom: _this2.state.bottom
                };
              }
            }
            return null;
          }()
          // style={(WINDOW && WINDOW.epi && WINDOW.parent) ? {position: 'fixed', bottom: this.state.bottom} : null}
          , __source: {
            fileName: _jsxFileName,
            lineNumber: 271
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'CTANavigation__container' + (this.state.open ? ' open' : '') + (this.state.hasTouch ? ' hasTouch' : ''),
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            ref: 'container',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 297
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CTANavigation__container__wrap', style: { paddingBottom: 'calc(env(safe-area-inset-bottom))' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 307
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'CTANavigation__container__wrap__list', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 308
                }
              },
              items.map(function (item, index) {
                item.props.buttonLength = items.length;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CTANavigation__container__wrap__list__item', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 312
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cta__["a" /* default */], _extends({}, item.props, {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 313
                    }
                  }))
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'CTANavigation__container__wrap__handle', onClick: this.onClickHandle, __source: {
                fileName: _jsxFileName,
                lineNumber: 320
              }
            })
          )
        )
      )
    );
  };

  return CTANavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interaction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  interaction: true,
  items: []
}, _temp);
CTANavigation.displayName = 'CTANavigation';

/* harmony default export */ __webpack_exports__["a"] = (CTANavigation);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessory_body_type_tab_name__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-list\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















// 「すべて」カテゴリのデフォルト写真枚数
var ACCESSORIES_COEFFICIENT = 16;

/**
 *  AccessoryList
 */
var AccessoryList = (_temp = _class = function (_Component) {
  _inherits(AccessoryList, _Component);

  function AccessoryList(props) {
    _classCallCheck(this, AccessoryList);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.setDefaultState = function () {
      //URLパラメータのcar_idから初期状態を設定
      // let query_car_id = this.getQuery('car_id');

      // if(query_car_id !== false){
      //   let isExist = false;
      //   //表示タブ名の中に存在するかどうか
      //   if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
      //     for(let i = 0; i < this.props.bodyTypeNames.length; i++){
      //       let _bodyTypeName = this.props.bodyTypeNames[i].props.bodyTypeName;
      //       if(_bodyTypeName === query_car_id){
      //         isExist = true;
      //         break;
      //       }
      //     }
      //   }
      //   //存在しなかった場合は、無効なcar_idが参照されたとして、上書きして無効とする
      //   if(!isExist){
      //     query_car_id = false;
      //   }
      // }

      // if(query_car_id !== false){
      //   this.tmp.bodyTypeName = query_car_id;
      //   this.tmp.category = '';
      //   this.tmp.subCategory = '';
      //   this.setState({
      //     bodyTypeName: query_car_id,
      //     category: '',
      //     subCategory: ''
      //   });
      //   return;
      // }

      //////////////////////////////////////////////////////////////////////////////////////////

      //cookieに前回保存した状態から初期状態を設定
      var bodyTypeName = _this.getCookie('mj_acbt');
      var category = _this.getCookie('mj_accg');
      var subCategory = _this.getCookie('mj_acscg');

      console.log('before', bodyTypeName, category, subCategory);

      //他の車種でセットされたbodyTypeNameのクッキー値（mj_acbt）は反映されないようにする
      if (bodyTypeName !== false && bodyTypeName !== '') {
        var isExist = false;
        //表示タブ名の中に存在するかどうか
        if (_this.props.bodyTypeNames && Array.isArray(_this.props.bodyTypeNames) && _this.props.bodyTypeNames.length > 0) {
          for (var i = 0; i < _this.props.bodyTypeNames.length; i++) {
            var _bodyTypeName = _this.props.bodyTypeNames[i].props.bodyTypeName;
            if (_bodyTypeName === bodyTypeName) {
              isExist = true;
              break;
            }
          }
        }
        //存在しなかった場合は、他の車種でセットされたbodyTypeNameが参照されたとして、上書きして無効とする
        if (!isExist) {
          // const firstBodyTypeName = this.refs.form.querySelector('input[name="bodyTypeName"]');
          // let value = firstBodyTypeName && firstBodyTypeName.value && firstBodyTypeName.value !== '' ? firstBodyTypeName.value : '';
          // bodyTypeName = value;
          if (_this.props.bodyTypeNames && Array.isArray(_this.props.bodyTypeNames) && _this.props.bodyTypeNames.length > 0) {
            bodyTypeName = _this.props.bodyTypeNames[0].props.bodyTypeName;
            category = false;
            subCategory = false;
          } else {
            bodyTypeName = false;
            category = false;
            subCategory = false;
          }

          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accopen=;path=/;max-age=0;secure;samesite=lax";
        }
      }

      //存在しないcategoryのクッキー値（mj_accg）は無効とする
      if (category !== false && category !== '') {
        var _isExist = false;
        //表示タブ名の中に存在するかどうか
        if (_this.props.accessories && Array.isArray(_this.props.accessories) && _this.props.accessories.length > 0) {
          for (var _i = 0; _i < _this.props.accessories.length; _i++) {
            var _category = _this.props.accessories[_i].category;
            if (_category === category) {
              _isExist = true;
              break;
            }
          }
        }
        //存在しなかった場合は、上書きして無効とする
        if (!_isExist) {
          category = false;
          subCategory = false;
        }
      }

      //存在しないsubCategoryのクッキー値（mj_acscg）は無効とする
      if (subCategory !== false && subCategory !== '') {
        var _isExist2 = false;
        //表示タブ名の中に存在するかどうか
        if (_this.props.accessories && Array.isArray(_this.props.accessories) && _this.props.accessories.length > 0) {
          for (var _i2 = 0; _i2 < _this.props.accessories.length; _i2++) {
            var _subCategory = _this.props.accessories[_i2].subCategory;
            if (_subCategory === subCategory) {
              _isExist2 = true;
              break;
            }
          }
        }
        //存在しなかった場合は、上書きして無効とする
        if (!_isExist2) {
          subCategory = false;
        }
      }

      if (bodyTypeName !== false) {
        _this.tmp.bodyTypeName = bodyTypeName;
        _this.setState({
          bodyTypeName: bodyTypeName
        });
      }
      if (category !== false) {
        _this.tmp.category = category;
        _this.setState({
          category: category
        });
      }
      if (subCategory !== false) {
        _this.tmp.subCategory = subCategory;
        _this.setState({
          subCategory: subCategory
        });
      }
      console.log('after', bodyTypeName, category, subCategory);
      if (bodyTypeName !== false || category !== false || subCategory !== false) {
        return;
      }

      //////////////////////////////////////////////////////////////////////////////////////////

      //cookieに保存されたcar_idから初期状態を設定
      // let cookie_car_id = this.getCookie('mjcarid');

      // if(cookie_car_id !== false){
      //   let isExist = false;
      //   //表示タブ名の中に存在するかどうか
      //   if(this.props.bodyTypeNames && Array.isArray(this.props.bodyTypeNames) && this.props.bodyTypeNames.length > 0){
      //     for(let i = 0; i < this.props.bodyTypeNames.length; i++){
      //       let _bodyTypeName = this.props.bodyTypeNames[i].props.bodyTypeName;
      //       if(_bodyTypeName === cookie_car_id){
      //         isExist = true;
      //         break;
      //       }
      //     }
      //   }
      //   //存在しなかった場合は、無効なcar_idが参照されたとして、上書きして無効とする
      //   if(!isExist){
      //     cookie_car_id = false;
      //   }
      // }

      // if(cookie_car_id !== false){
      //   this.tmp.bodyTypeName = cookie_car_id;
      //   this.tmp.category = '';
      //   this.tmp.subCategory = '';
      //   this.setState({
      //     bodyTypeName: cookie_car_id,
      //     category: '',
      //     subCategory: ''
      //   });
      //   return;
      // }

      //////////////////////////////////////////////////////////////////////////////////////////

      //デフォルト値から初期状態を設定
      if (_this.refs.form) {
        var firstBodyTypeName = _this.refs.form.querySelector('input[name="bodyTypeName"]');
        if (firstBodyTypeName) {
          var value = firstBodyTypeName.value;
          _this.tmp.bodyTypeName = value;
          _this.tmp.category = '';
          _this.tmp.subCategory = '';
          _this.setState({
            bodyTypeName: value,
            category: '',
            subCategory: ''
          });
        }
      }
    };

    _this.getCookie = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */] || !__WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie) {
        return false;
      }
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].split('=');
        if (cookie[0].trim() === key) {
          return unescape(cookie[1].trim());
        }
      }

      return false;
    };

    _this.getQuery = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location) {
        return false;
      }
      var params = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.search.substring(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var param = params[i].split('=');
        if (param[0].trim() === key) {
          return param[1].trim();
        }
      }
      return false;
    };

    _this.onChangeForm = function (e) {

      // const form = this.refs.form;

      // this.tmp.bodyTypeName = form.bodyTypeName != null && form.bodyTypeName.value != null ? form.bodyTypeName.value : '';
      // this.tmp.category = form.category != null && form.category.value != null ? form.category.value : '';
      // this.tmp.subCategory = form.subCategory != null && form.subCategory.value != null ? form.subCategory.value : '';

      // this.applyFilter();
    };

    _this.onChangeBodyTypeName = function (e) {
      _this.tmp.bodyTypeName = e.target.value;
      _this.tmp.category = '';
      _this.tmp.subCategory = '';
      _this.setState({
        bodyTypeName: _this.tmp.bodyTypeName,
        category: _this.tmp.category,
        subCategory: _this.tmp.subCategory,
        isOpenSubCategory: false
      });

      setTimeout(function () {
        _this.setMinHeight(false);
      }, 10);

      // cookie削除
      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
        var pathname = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.pathname;
        // pathname = '/';
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accopen=;path=" + pathname + ";max-age=0;secure;samesite=lax";
      }

      _this.applyFilter();

      //fadein
      _this.refs.category.classList.remove('fadein');
      _this.refs.subCategory.classList.remove('fadein');
      _this.refs.accessories.classList.remove('fadein');
      _this.refs.category.style.opacity = 0;
      _this.refs.subCategory.style.opacity = 0;
      _this.refs.accessories.style.opacity = 0;
      setTimeout(function () {
        _this.refs.category.classList.add('fadein');
        _this.refs.subCategory.classList.add('fadein');
        _this.refs.accessories.classList.add('fadein');
        _this.refs.category.style.opacity = 1;
        _this.refs.subCategory.style.opacity = 1;
        _this.refs.accessories.style.opacity = 1;
      }, 10);

      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */]) {
        var categoryList = _this.refs.category.querySelector(".AccessoryList__container__form__category__list");
        categoryList.scrollLeft = 0;
        clearInterval(_this.categoryIntervalId);
      }
    };

    _this.onChangeCategory = function (e) {
      _this.tmp.category = e.target.value;
      _this.tmp.subCategory = '';
      _this.setState({
        category: _this.tmp.category,
        subCategory: _this.tmp.subCategory,
        isOpenSubCategory: false
      });

      setTimeout(function () {
        _this.setMinHeight(false);
      }, 10);

      // cookie削除
      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
        var pathname = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.pathname;
        // pathname = '/';
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accopen=;path=" + pathname + ";max-age=0;secure;samesite=lax";
      }

      _this.applyFilter();

      //fadein
      _this.refs.subCategory.classList.remove('fadein');
      _this.refs.accessories.classList.remove('fadein');
      _this.refs.subCategory.style.opacity = 0;
      _this.refs.accessories.style.opacity = 0;
      setTimeout(function () {
        _this.refs.subCategory.classList.add('fadein');
        _this.refs.accessories.classList.add('fadein');
        _this.refs.subCategory.style.opacity = 1;
        _this.refs.accessories.style.opacity = 1;
      }, 10);

      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */]) {
        _this.slideCategory();
      }
    };

    _this.slideCategory = function () {
      var noTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var checkedRadio = _this.refs.category.querySelector("input[type='radio']:checked");
      var current = checkedRadio.parentNode.parentNode;
      var parent = current.parentNode;
      var currentRect = current.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();

      var children = parent.children;
      var child = void 0;
      var currentLeft = 0;
      var totalWidth = 0;
      for (var i = 0; i < parent.children.length; i++) {
        child = parent.children[i];
        totalWidth += child.getBoundingClientRect().width;
      }
      for (var _i3 = 0; _i3 < parent.children.length; _i3++) {
        child = parent.children[_i3];
        if (child === current) {
          break;
        }
        currentLeft += child.getBoundingClientRect().width;
      }

      var scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2;
      scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;

      if (totalWidth - scrollLeft < parentRect.width) {
        scrollLeft = totalWidth - parentRect.width;
      }

      scrollLeft = Math.floor(scrollLeft);

      //スライドアニメーションなしで処理したい場合
      if (noTime) {
        parent.scrollLeft = scrollLeft;
        return;
      }

      clearInterval(_this.categoryIntervalId);
      _this.categoryIntervalId = setInterval(function () {
        if (scrollLeft - parent.scrollLeft < 0) {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1;
        } else {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1);
        }

        if (Math.abs(scrollLeft - parent.scrollLeft) < 1) {
          parent.scrollLeft = scrollLeft;
          clearInterval(_this.categoryIntervalId);
        }
        // console.log(parent.scrollLeft, scrollLeft);
      }, 1000 / 60);
    };

    _this.onChangeSubCategory = function (e) {
      _this.tmp.subCategory = e.target.value;
      _this.setState({
        subCategory: _this.tmp.subCategory,
        isOpenSubCategory: false
      });
      _this.applyFilter();

      setTimeout(function () {
        _this.setMinHeight(false);
      }, 10);

      //fadein
      _this.refs.accessories.classList.remove('fadein');
      _this.refs.accessories.style.opacity = 0;
      setTimeout(function () {
        _this.refs.accessories.classList.add('fadein');
        _this.refs.accessories.style.opacity = 1;
      }, 10);
    };

    _this.getCategories = function (accessories) {
      var arr = [];
      if (!accessories || !Array.isArray(accessories)) {
        return arr;
      }
      accessories.map(function (accessory, index) {
        if (_this.tmp.bodyTypeName && _this.tmp.bodyTypeName !== accessory.bodyTypeModel) {
          return false;
        }
        arr.push({
          label: accessory.category,
          value: accessory.category
        });
      });
      if (arr.length > 0) {
        arr.unshift({
          label: 'すべて',
          value: ''
        });
      }
      var cleanArr = arr.filter(function (v1, i1, a1) {
        return a1.findIndex(function (v2) {
          return v1.value === v2.value;
        }) === i1;
      });
      return cleanArr;
    };

    _this.getSubCategories = function (accessories) {
      var arr = [];
      if (!accessories || !Array.isArray(accessories)) {
        return arr;
      }
      accessories.map(function (accessory, index) {
        if (_this.tmp.bodyTypeName && _this.tmp.bodyTypeName !== accessory.bodyTypeModel) {
          return false;
        } else if (_this.tmp.category !== '' && _this.tmp.category !== accessory.category) {
          return false;
        }
        arr.push({
          label: accessory.subCategory,
          value: accessory.subCategory
        });
      });
      if (arr.length > 0) {
        arr.unshift({
          label: 'すべてのアクセサリ',
          value: ''
        });
      }
      var cleanArr = arr.filter(function (v1, i1, a1) {
        return a1.findIndex(function (v2) {
          return v1.value === v2.value;
        }) === i1;
      });
      return cleanArr;
    };

    _this.getSubCategoriesAccessories = function (accessories, subCategory) {
      var arr = [];
      accessories.map(function (accessory, index) {
        if (accessory.subCategory === subCategory) {
          arr.push(accessory);
        }
      });
      return arr;
    };

    _this.onClickMore = function (e) {
      if (!_this.props.isCountable) {
        return;
      }

      // 「さらに表示する」押下回数算出用の係数
      var additionalNumber = 1;
      // 「さらに表示する」押下回数
      var latestCountNumber = _this.state.counterClickedTime + additionalNumber;
      // 「さらに表示する」押下時の表示枚数 (16枚毎に乗算)
      var latestTotal = ACCESSORIES_COEFFICIENT * latestCountNumber;

      // 「さらに表示する」押下時の表示アイテムを配列にする
      var mustDisplayAccessories = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(_this.state.accessories, function (accumulator, currentValue, index) {
        if (index < _this.state.accessories.length && index < latestTotal) {
          return [].concat(accumulator, [currentValue]);
        }
        return [].concat(accumulator);
      }, []);

      if (latestTotal > _this.state.accessories.length) {
        _this.props.updateCounterClickedTime({
          isCountable: false, everySixteenAccessories: mustDisplayAccessories
        });
      } else {
        _this.props.updateCounterClickedTime({
          isCountable: true, everySixteenAccessories: mustDisplayAccessories
        });
      }

      var items = _this.closest(e.currentTarget, '.AccessoryList__container__accessories__category').querySelectorAll('.AccessoryList__container__accessories__category__list__item');
      var appendCount = _this.tmp.category === '' ? 16 : items.length;
      var showCount = 0;

      for (var i = 0; i < items.length; i++) {
        if (!items[i].classList.contains('show') && appendCount > 0) {
          items[i].classList.add('show');
          appendCount--;
        }
        if (items[i].classList.contains('show')) {
          showCount++;
        }
      }

      if (items.length === showCount) {
        var category = _this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
        var more = category.querySelector('.AccessoryList__container__accessories__category__more');
        var less = category.querySelector('.AccessoryList__container__accessories__category__less');
        if (more) {
          more.classList.remove('show');
        }
        if (less) {
          less.classList.add('show');
        }
      }

      //「すべて」の際は表示個数を記録して、アクセサリ詳細から戻ったときに表示個数を再現する
      if (_this.tmp.category === '') {
        // cookieに値をセット
        if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
          var pathname = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.pathname;
          // pathname = '/';
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accopen=" + showCount + ";path=" + pathname + ";secure;samesite=lax";
        }
      }

      // 「さらに表示する」押下回数をキャッシュしておく
      _this.setState({ counterClickedTime: latestCountNumber });

      //
      _this.triggerEvent(__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */], 'scroll');
    };

    _this.onClickLess = function (e) {
      var items = _this.closest(e.currentTarget, '.AccessoryList__container__accessories__category').querySelectorAll('.AccessoryList__container__accessories__category__list__item');
      var showCount = void 0;

      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */]) {
        showCount = _this.tmp.category === '' ? 16 : 2;
      } else {
        showCount = _this.tmp.category === '' ? 16 : 4;
      }

      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('show');
        if (i < showCount) {
          items[i].classList.add('show');
        }
      }

      var category = _this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
      var more = category.querySelector('.AccessoryList__container__accessories__category__more');
      var less = category.querySelector('.AccessoryList__container__accessories__category__less');
      if (more) {
        more.classList.add('show');
      }
      if (less) {
        less.classList.remove('show');
      }

      //「すべて」の際は表示個数を記録して、アクセサリ詳細から戻ったときに表示個数を再現する
      if (_this.tmp.category === '') {
        // cookieに値をセット
        if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
          var pathname = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.pathname;
          // pathname = '/';
          __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accopen=16;path=" + pathname + ";secure;samesite=lax";
        }
      }

      //上部へスクロール
      if (_this.tmp.category === '') {
        __WEBPACK_IMPORTED_MODULE_9__components_body__["a" /* default */].scrollToNode(_this.refs.self);
      } else {
        var selfCategory = _this.closest(e.currentTarget, '.AccessoryList__container__accessories__category');
        __WEBPACK_IMPORTED_MODULE_9__components_body__["a" /* default */].scrollToNode(selfCategory);
      }
    };

    _this.onClickPulldown = function (e) {
      var flg = !_this.state.isOpenSubCategory;
      _this.setState({
        isOpenSubCategory: flg
      });

      setTimeout(function () {
        _this.setMinHeight(flg);
      }, 10);
    };

    _this.onClickPulldownClose = function (e) {
      _this.setState({
        isOpenSubCategory: false
      });
      setTimeout(function () {
        _this.setMinHeight(false);
      }, 10);
    };

    _this.setMinHeight = function (isOpen) {
      var height = '';
      if (isOpen) {
        var minHeight = _this.refs.form.clientHeight + _this.refs.pulldownList.clientHeight + 70;
        var selfHeight = _this.refs.self.clientHeight;
        var accessoriesHeight = _this.refs.accessories.clientHeight;
        if (minHeight > selfHeight) {
          height = accessoriesHeight + (minHeight - selfHeight) + 'px';
        }
      }
      _this.refs.accessories.style.height = height;
    };

    _this.onClickAccessoryLink = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */]) {
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.href = e.currentTarget.href;
      }
      e.preventDefault();
      return false;
    };

    _this.applyFilter = function () {
      // 「すべて」カテゴリ初期表示用
      var accessoriesStartIndex = 0;

      var accessories = JSON.parse(JSON.stringify(_this.props.accessories));

      _this.tmp.accessories = [];

      // cookieに値をセット
      if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
        var pathname = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */].location.pathname;
        // pathname = '/';
        var date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_acbt=" + escape(_this.tmp.bodyTypeName) + ";path=" + pathname + ";secure;samesite=lax";
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_accg=" + escape(_this.tmp.category) + ";path=" + pathname + ";secure;samesite=lax";
        __WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */].cookie = "mj_acscg=" + escape(_this.tmp.subCategory) + ";path=" + pathname + ";secure;samesite=lax";
        // DOCUMENT.cookie = "mj_acbt=" + escape(this.tmp.bodyTypeName) + ";path=" + pathname;
        // DOCUMENT.cookie = "mj_accg=" + escape(this.tmp.category) + ";path=" + pathname;
        // DOCUMENT.cookie = "mj_acscg=" + escape(this.tmp.subCategory) + ";path=" + pathname;
      }

      if (accessories && Array.isArray(accessories) && accessories.length > 0) {
        accessories.map(function (accessory, index) {
          if (_this.tmp.bodyTypeName !== '' && _this.tmp.bodyTypeName !== accessory.bodyTypeModel) {
            return false; //skip
          } else if (_this.tmp.category !== '' && _this.tmp.category !== accessory.category) {
            return false;
          } else if (_this.tmp.subCategory !== '' && _this.tmp.subCategory !== accessory.subCategory) {
            return false;
          }
          _this.tmp.accessories.push(accessory);
        });
      }

      // 「さらに表示する」押下回数算出用の係数
      var additionalNumber = 2;
      var subtractNumber = 1;
      // 「さらに表示する」初回表示枚数
      var firstCacheNumber = ACCESSORIES_COEFFICIENT * additionalNumber;
      // 「さらに表示する」押下時表示用に、デフォルトデータをキャッシュしておく (再レンダーさせるために、reducer での state 更新を想定)
      // 初期表示の段階で 32 枚設定しておく (「さらに表示する」初回クリック時の state 更新が再レンダーに追いつかないため)
      _this.props.updateCounterClickedTime({
        isCountable: true,
        everySixteenAccessories: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this.tmp.accessories, function (item, index) {
          return accessoriesStartIndex <= index && index < firstCacheNumber - subtractNumber;
        })
      });

      _this.setState({
        accessories: _this.tmp.accessories
      });
    };

    _this.closest = function (node, selector) {
      // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
      return (node.closest || function (_selector) {
        do {
          // nodeとselectorがマッチしたら返す
          if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
            return node;
          }
          // マッチしなかったら親要素を代入
          node = node.parentElement || node.parentNode;
        } while (node !== null && node.nodeType === 1);

        return null;
      }).call(node, selector);
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return !element.dispatchEvent(evt);
      } else {
        // IE
        var _evt = document.createEventObject();
        return element.fireEvent("on" + event, _evt);
      }
    };

    _this.props = props;

    _this.state = {
      bodyTypeName: '',
      category: '',
      subCategory: '',
      accessories: [],
      // 「さらに表示する」押下時の表示用
      everySixteenAccessories: [],
      // 「さらに表示する」押下回数キャッシュ用
      counterClickedTime: 1,
      isOpenSubCategory: false
    };

    _this.tmp = {
      bodyTypeName: '',
      category: '',
      subCategory: '',
      accessories: []
    };

    _this.showItemNum = 4;

    _this.categoryIntervalId;

    return _this;
  }

  AccessoryList.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(this.setDefaultState, 100);

    this.showItemNum = __WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] ? 2 : 4;

    // this.applyFilter();
    setTimeout(this.applyFilter, 200);

    if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */]) {
      setTimeout(function () {
        _this2.slideCategory(true);
      }, 300);
    }
  };

  AccessoryList.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        bodyTypeNames = _props.bodyTypeNames,
        color = _props.color,
        accessories = _props.accessories,
        isCountable = _props.isCountable,
        everySixteenAccessories = _props.everySixteenAccessories;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 337
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 343
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccessoryList', ref: 'self', __source: {
              fileName: _jsxFileName,
              lineNumber: 344
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccessoryList__container' + (color && color !== '' ? ' AccessoryList__container--' + color : null), __source: {
                fileName: _jsxFileName,
                lineNumber: 345
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { className: 'AccessoryList__container__form', ref: 'form', onChange: this.onChangeForm, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 346
                }
              },
              function () {
                if (bodyTypeNames && Array.isArray(bodyTypeNames) && bodyTypeNames.length > 0) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'AccessoryList__container__form__bodyTypeName', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 350
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'ul',
                      { className: 'AccessoryList__container__form__bodyTypeName__list', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 351
                        }
                      },
                      bodyTypeNames.map(function (item, index) {
                        var props = item.props;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'AccessoryList__container__form__bodyTypeName__list__item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 356
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
                            {
                              containerId: props.containerId,
                              containerClass: props.containerClass,
                              anchorPoint: props.anchorPoint,
                              anchorName: props.anchorName,
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 357
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'AccessoryList__container__form__bodyTypeName__list__item__label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 363
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'AccessoryList__container__form__bodyTypeName__list__item__label__radio', type: 'radio', name: 'bodyTypeName', value: props.bodyTypeName, checked: _this3.state.bodyTypeName === props.bodyTypeName, onChange: _this3.onChangeBodyTypeName, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 364
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'AccessoryList__container__form__bodyTypeName__list__item__label__text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 365
                                  }
                                },
                                props.bodyTypeTabName
                              )
                            )
                          )
                        );
                      })
                    )
                  );
                }
              }(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'AccessoryList__container__form__category',
                  ref: 'category',
                  onTransitionEnd: function onTransitionEnd(e) {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 377
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'AccessoryList__container__form__category__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 385
                    }
                  },
                  function () {
                    var categories = _this3.getCategories(_this3.props.accessories);
                    return categories.map(function (category, index) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { className: 'AccessoryList__container__form__category__list__item', key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 391
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          { className: 'AccessoryList__container__form__category__list__item__label', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 392
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'AccessoryList__container__form__category__list__item__label__radio', type: 'radio', name: 'category', value: category.value, checked: _this3.tmp.category === category.value, onChange: _this3.onChangeCategory, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 393
                            }
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'AccessoryList__container__form__category__list__item__label__text', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 394
                              }
                            },
                            category.label
                          )
                        )
                      );
                    });
                  }()
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'AccessoryList__container__form__subCategory' + (this.state.category === '' ? ' hide' : '') + (this.state.isOpenSubCategory ? ' open' : ''),
                  ref: 'subCategory',
                  onTransitionEnd: function onTransitionEnd(e) {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 403
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryList__container__form__subCategory__title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 415
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: 'javascript:void(0)', className: 'AccessoryList__container__form__subCategory__title__link', onClick: this.onClickPulldown, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 416
                      }
                    },
                    this.state.subCategory === '' ? 'さらに絞り込む' : this.state.subCategory
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryList__container__form__subCategory__pulldown', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 420
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'AccessoryList__container__form__subCategory__pulldown__container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 421
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'ul',
                      { className: 'AccessoryList__container__form__subCategory__pulldown__list', ref: 'pulldownList', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 422
                        }
                      },
                      function () {
                        var subCategories = _this3.getSubCategories(_this3.props.accessories);
                        return subCategories.map(function (subCategory, index) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'AccessoryList__container__form__subCategory__pulldown__list__item', key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 428
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'label',
                              { className: 'AccessoryList__container__form__subCategory__pulldown__list__item__label', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 429
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'AccessoryList__container__form__subCategory__pulldown__list__item__label__radio', type: 'radio', name: 'subCategory', value: subCategory.value, checked: _this3.tmp.subCategory === subCategory.value, onChange: _this3.onChangeSubCategory, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 430
                                }
                              }),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'AccessoryList__container__form__subCategory__pulldown__list__item__label__text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 431
                                  }
                                },
                                subCategory.label
                              )
                            )
                          );
                        });
                      }()
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: 'javascript:void(0)', className: 'AccessoryList__container__form__subCategory__pulldown__close', onClick: this.onClickPulldownClose, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 440
                      }
                    },
                    'CLOSE'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'AccessoryList__container__accessories',
                ref: 'accessories',
                onTransitionEnd: function onTransitionEnd(e) {
                  e.currentTarget.classList.remove('fadein');
                  e.currentTarget.style.opacity = "";
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 444
                }
              },
              function () {
                // category: すべて
                if (_this3.state.category === '') {
                  var showCount = void 0;
                  if (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["a" /* DOCUMENT */]) {
                    showCount = _this3.getCookie('mj_accopen');
                    showCount = showCount !== false ? parseInt(showCount) : 16;
                  }
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'AccessoryList__container__accessories__category', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 461
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'ul',
                      { className: 'AccessoryList__container__accessories__category__list', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 462
                        }
                      },
                      everySixteenAccessories && everySixteenAccessories.length > 0 && everySixteenAccessories.map(function (accessory, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          {
                            className: 'AccessoryList__container__accessories__category__list__item' + (index < showCount ? ' show' : ''),
                            key: index,
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 467
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            {
                              href: '' + accessory.href + accessory.accessoryId,
                              className: 'AccessoryList__container__accessories__category__list__item__link',
                              onClick: _this3.onClickAccessoryLink,
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 471
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'AccessoryList__container__accessories__category__list__item__link__content', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 476
                                }
                              },
                              accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'AccessoryList__container__accessories__category__list__item__link__content__image__wrap', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 478
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: accessory.images[0], className: 'AccessoryList__container__accessories__category__list__item__link__content__image', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 479
                                  }
                                })
                              ) : null,
                              accessory.title && accessory.title !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'AccessoryList__container__accessories__category__list__item__link__content__title', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 482
                                  }
                                },
                                accessory.title
                              ) : null,
                              accessory.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'AccessoryList__container__accessories__category__list__item__link__content__price', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 483
                                  }
                                },
                                '\xA5',
                                Number(accessory.price).toLocaleString(),
                                '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                              ) : null
                            )
                          )
                        );
                      })
                    ),
                    isCountable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__cta__["a" /* default */], _extends({
                      ctaType: 'Free',
                      text: 'さらに表示する',
                      linkType: 'Button',
                      color: _this3.props.color || 'Light',
                      buttonStyle: 'Standard',
                      handleClick: _this3.onClickMore
                    }, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 493
                      }
                    })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__cta__["a" /* default */], _extends({
                      ctaType: 'Free',
                      text: '閉じる',
                      linkType: 'Button',
                      color: _this3.props.color || 'Light',
                      buttonStyle: 'Standard',
                      handleClick: _this3.onClickLess
                    }, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 503
                      }
                    }))
                  );
                }
                // category: すべて以外
                else {
                    var subCategories = _this3.getSubCategories(_this3.state.accessories);
                    return subCategories.map(function (subCategory, index) {
                      if (subCategory.value === '') {
                        return false;
                      }
                      var accessories = _this3.getSubCategoriesAccessories(_this3.state.accessories, subCategory.value);
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'AccessoryList__container__accessories__category', key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 527
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'AccessoryList__container__accessories__category__title', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 528
                            }
                          },
                          subCategory.label
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'ul',
                          { className: 'AccessoryList__container__accessories__category__list', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 529
                            }
                          },
                          accessories.map(function (accessory, index) {
                            var href = accessory.href + accessory.accessoryId;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              {
                                className: "AccessoryList__container__accessories__category__list__item" + " show"
                                // (index < this.showItemNum || this.state.subCategory !== '' ? ' show' : '')
                                ,
                                key: index,
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 534
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                  href: href,
                                  className: 'AccessoryList__container__accessories__category__list__item__link',
                                  onClick: _this3.onClickAccessoryLink,
                                  __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 543
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'AccessoryList__container__accessories__category__list__item__link__content', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 548
                                    }
                                  },
                                  accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'AccessoryList__container__accessories__category__list__item__link__content__image__wrap', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 550
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: accessory.images[0], className: 'AccessoryList__container__accessories__category__list__item__link__content__image', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 551
                                      }
                                    })
                                  ) : null,
                                  accessory.title && accessory.title !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'AccessoryList__container__accessories__category__list__item__link__content__title', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 554
                                      }
                                    },
                                    accessory.title
                                  ) : null,
                                  accessory.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'AccessoryList__container__accessories__category__list__item__link__content__price', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 555
                                      }
                                    },
                                    '\xA5',
                                    Number(accessory.price).toLocaleString(),
                                    '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                                  ) : null
                                )
                              )
                            );
                          })
                        ),
                        function () {
                          // if(accessories.length > this.showItemNum && this.state.subCategory === ''){
                          //   return(
                          //     <React.Fragment>
                          //       <div className='AccessoryList__container__accessories__category__more show'>
                          //         <Cta
                          //           {...{
                          //             ctaType: 'Free',
                          //             text: 'すべて見る',
                          //             linkType: 'Button',
                          //             color: this.props.color || 'Light',
                          //             buttonStyle: 'Standard',
                          //             handleClick: this.onClickMore
                          //           }}
                          //         />
                          //       </div>
                          //       <div className='AccessoryList__container__accessories__category__less'>
                          //         <Cta
                          //           {...{
                          //             ctaType: 'Free',
                          //             text: '閉じる',
                          //             linkType: 'Button',
                          //             color: this.props.color || 'Light',
                          //             buttonStyle: 'Standard',
                          //             handleClick: this.onClickLess
                          //           }}
                          //         />
                          //       </div>
                          //     </React.Fragment>
                          //   )
                          // }
                        }()
                      );
                    });
                  }
              }()
            )
          )
        )
      )
    );
  };

  /**
   * 「さらに表示する」押下時に呼ばれる
   */


  //サブカテゴリまで選択時にブロック自体の高さがプルダウンよりも小さくなったときに、プルダウン開閉時に高さを調整する処理


  return AccessoryList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  bodyTypeNames: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  color: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  accessories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    accessoryId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    category: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    subCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    price: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    images: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    modelName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyTypeModel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })),
  isCountable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  everySixteenAccessories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  bodyTypeNames: null,
  color: null,
  accessories: null
}, _temp);
AccessoryList.displayName = 'AccessoryList';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryList);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-body-type-tab-name\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  AccessoryBodyTypeTabName
 */
var AccessoryBodyTypeTabName = (_temp = _class = function (_Component) {
  _inherits(AccessoryBodyTypeTabName, _Component);

  function AccessoryBodyTypeTabName(props) {
    _classCallCheck(this, AccessoryBodyTypeTabName);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  AccessoryBodyTypeTabName.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        bodyTypeName = _props.bodyTypeName,
        bodyTypeTabName = _props.bodyTypeTabName;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AccessoryBodyTypeTabName', __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      })
    );
  };

  return AccessoryBodyTypeTabName;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  bodyTypeName: null,
  bodyTypeTabName: null
}, _temp);
AccessoryBodyTypeTabName.displayName = 'AccessoryBodyTypeTabName';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryBodyTypeTabName);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessory_info_container__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_catalog_dark_png__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_catalog_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__icon_catalog_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_link_light_png__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_link_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__icon_link_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icon_link_dark_png__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__icon_link_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__icon_link_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__icon_pdf_dark_png__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__icon_pdf_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__icon_pdf_dark_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-detail-content\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















/**
 *  AccessoryDetailContent
 */
var AccessoryDetailContent = (_temp = _class = function (_Component) {
  _inherits(AccessoryDetailContent, _Component);

  function AccessoryDetailContent(props) {
    _classCallCheck(this, AccessoryDetailContent);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.embedEst = function () {

      if (!__WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].location) {
        return false;
      }
      //クエリ文字列に「est=1」を含む時（カンタン見積からiframeで参照された時）
      if (__WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].location.search.indexOf('est=1') !== -1) {
        __WEBPACK_IMPORTED_MODULE_9__constants_environment__["a" /* DOCUMENT */].body.classList.add('embeded-est');

        setInterval(function () {
          var main = document.querySelector('.embeded-est');
          if (main) {
            var contentsHeight = main.getBoundingClientRect().height;
            if (0 < contentsHeight) {
              parent.postMessage({ event: 'change_module_height', value: contentsHeight }, '*');
            }
          }
        }, 200);
      }
    };

    _this.openModal = function () {
      _this.refs.modalWindow.open('Light', 'Light');
      //BodyControl.openModal();
    };

    _this.closeModal = function () {
      //BodyControl.closeModal();
    };

    _this.onClickBack = function (e) {
      history.back();
      e.preventDefault();
    };

    _this.formatReleaseDate = function () {
      var YYYYMMDD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!YYYYMMDD || YYYYMMDD === '') return '';
      var str = String(YYYYMMDD).substr(0, 4) + '年';
      str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
      str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
      return str;
    };

    _this.props = props;
    return _this;
  }

  AccessoryDetailContent.prototype.componentDidMount = function componentDidMount() {
    // this.openModal();
    this.embedEst();
  };

  AccessoryDetailContent.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        descriptionOfBasePrice = _props.descriptionOfBasePrice,
        detailTitle = _props.detailTitle,
        variationTitle = _props.variationTitle,
        ctaButtons = _props.ctaButtons,
        library = _props.library,
        accessoryId = _props.accessoryId,
        category = _props.category,
        subCategory = _props.subCategory,
        title = _props.title,
        description = _props.description,
        price = _props.price,
        images = _props.images,
        modelName = _props.modelName,
        bodyTypeModel = _props.bodyTypeModel,
        href = _props.href,
        variations = _props.variations,
        info = _props.info;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AccessoryDetailContent', __source: {
            fileName: _jsxFileName,
            lineNumber: 139
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccessoryDetailContent__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 140
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccessoryDetailContent__container__header', __source: {
                fileName: _jsxFileName,
                lineNumber: 141
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'AccessoryDetailContent__container__header__content', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 142
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'AccessoryDetailContent__container__header__content__text-container', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 143
                  }
                },
                title && title !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__container__header__content__text-container__title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 144
                    }
                  },
                  title
                ) : null,
                price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__container__header__content__text-container__price', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 145
                    }
                  },
                  '\xA5',
                  Number(price).toLocaleString(),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'AccessoryDetailContent__container__header__content__text-container__price__tax', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 145
                      }
                    },
                    '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                  )
                ) : null,
                descriptionOfBasePrice && descriptionOfBasePrice !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AccessoryDetailContent__container__header__content__text-container__description-of-base-price', dangerouslySetInnerHTML: { __html: descriptionOfBasePrice }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 146
                  }
                }) : null
              ),
              images && Array.isArray(images) && images[0] !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'AccessoryDetailContent__container__header__content__image-container', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 149
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__container__header__content__image-container__wrap', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 150
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: images[0], className: 'AccessoryDetailContent__container__header__content__image-container__wrap__image', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 151
                    }
                  })
                )
              ) : null
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccessoryDetailContent__container__back', __source: {
                fileName: _jsxFileName,
                lineNumber: 157
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'javascript:void(0)', className: 'AccessoryDetailContent__container__back__link', onClick: this.onClickBack, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 158
                }
              },
              '\u524D\u306B\u623B\u308B'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccessoryDetailContent__container__body', __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'AccessoryDetailContent__container__body__detail', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 161
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'AccessoryDetailContent__container__body__detail__title', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 162
                  }
                },
                detailTitle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AccessoryDetailContent__container__body__detail__description', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(description) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 163
                }
              })
            ),
            function () {
              if (ctaButtons && Array.isArray(ctaButtons) && ctaButtons.length > 0 || library && library.category && library.category !== '') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__container__body__buttons', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 168
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'AccessoryDetailContent__container__body__buttons__list', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 169
                      }
                    },
                    function () {
                      if (ctaButtons && Array.isArray(ctaButtons) && ctaButtons.length > 0) {
                        return ctaButtons.map(function (cta, index) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'AccessoryDetailContent__container__body__buttons__list__item', key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 175
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cta__["a" /* default */], _extends({}, cta.props, {
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 176
                              }
                            }))
                          );
                        });
                      }
                    }(),
                    function () {
                      if (library && library.category && library.category !== '') {
                        var props = {};
                        var icon = void 0,
                            linkType = void 0;
                        if (library['function'] === 'Direct-Link') {
                          switch (library.icon1) {
                            case 'PDF':
                              icon = __WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png___default.a;
                              linkType = 'Button-With-Icon';
                              break;
                            case 'E-Book':
                              icon = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png___default.a;
                              linkType = 'Button-With-Icon';
                              break;
                            case 'Link':
                              icon = __WEBPACK_IMPORTED_MODULE_13__icon_link_light_png___default.a;
                              linkType = 'Button-With-Icon';
                              break;
                            default:
                              icon = null;
                              linkType = 'Button';
                          }
                          props = {
                            ctaType: 'Free',
                            href: library.href1,
                            text: library.category,
                            targetBlank: library.external1,
                            linkType: linkType,
                            iconSrc: icon,
                            hoverIconSrc: icon,
                            color: 'Dark',
                            buttonStyle: 'Action'
                          };
                        } else if (library['function'] === 'Modal-Agreement-Window') {
                          var _icon = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png___default.a;
                          props = {
                            ctaType: 'Free',
                            href: 'javascript:void(0)',
                            text: library.category,
                            targetBlank: false,
                            linkType: 'Button-With-Icon',
                            iconSrc: _icon,
                            hoverIconSrc: _icon,
                            color: 'Dark',
                            buttonStyle: 'Action',
                            handleClick: _this2.openModal
                          };
                        }

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'AccessoryDetailContent__container__body__buttons__list__item', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 234
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cta__["a" /* default */], _extends({}, props, {
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 235
                            }
                          }))
                        );
                      }
                    }()
                  )
                );
              }
            }()
          ),
          function () {
            if (variations && Array.isArray(variations) && variations.length > 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'AccessoryDetailContent__container__variations', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 249
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__container__body__variations__title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 250
                    }
                  },
                  variationTitle
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'AccessoryDetailContent__container__body__variations__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 251
                    }
                  },
                  variations.map(function (accessory, index) {
                    if (!accessory) {
                      return false; // skip
                    }
                    var detailHref = href + (accessory.accessoryId && accessory.accessoryId !== '' ? accessory.accessoryId : '');
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'AccessoryDetailContent__container__body__variations__list__item', key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 259
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: detailHref, className: 'AccessoryDetailContent__container__body__variations__list__item__link', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 260
                          }
                        },
                        accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'AccessoryDetailContent__container__body__variations__list__item__image__wrap', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 262
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: accessory.images[0], className: 'AccessoryDetailContent__container__body__variations__list__item__image', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 263
                            }
                          })
                        ) : null,
                        accessory.title && accessory.title !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'AccessoryDetailContent__container__body__variations__list__item__title', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 266
                            }
                          },
                          accessory.title
                        ) : null,
                        accessory.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'AccessoryDetailContent__container__body__variations__list__item__price', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 267
                            }
                          },
                          '\xA5',
                          Number(accessory.price).toLocaleString(),
                          '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                        ) : null
                      )
                    );
                  })
                )
              );
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AccessoryDetailContent__container__info', __source: {
                fileName: _jsxFileName,
                lineNumber: 278
              }
            },
            function () {
              if (info && Array.isArray(info) && info.length > 0) {
                return info.map(function (item, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__accessory_info_container__["a" /* default */], _extends({}, item.props, { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 284
                    }
                  }));
                });
              }
            }()
          )
        ),
        function () {
          if (library) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__components_modal_window__["a" /* default */],
              { ref: 'modalWindow', type: 'Light', onClose: _this2.closeModal, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 296
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'AccessoryDetailContent__ModalWindow__modal-item', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 297
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'AccessoryDetailContent__ModalWindow__modal-item__container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 298
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 299
                      }
                    },
                    library.titleAndPreText && library.titleAndPreText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__header Wysiwyg', dangerouslySetInnerHTML: { __html: library.titleAndPreText }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 301
                      }
                    }) : null,
                    library.agreementText && library.agreementText instanceof Array && 1 <= library.agreementText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__agreement', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 304
                        }
                      },
                      Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["c" /* getComponents */])(library.agreementText)
                    ) : null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dl',
                      { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list-dl', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 306
                        }
                      },
                      library.linkArea && library.linkArea !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dt',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 308
                          }
                        },
                        library.linkArea
                      ) : null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dd',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 310
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'ul',
                          { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list-ul', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 311
                            }
                          },
                          function () {
                            if (library.href1 && library.href1 !== '' && library.title1 && library.title1 !== '') {
                              var props = {};
                              var icon = void 0,
                                  iconHover = void 0,
                                  linkType = void 0;
                              switch (library.icon1) {
                                case 'PDF':
                                  icon = __WEBPACK_IMPORTED_MODULE_16__icon_pdf_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'E-Book':
                                  icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'Link':
                                  icon = __WEBPACK_IMPORTED_MODULE_14__icon_link_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_13__icon_link_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                default:
                                  icon = null;
                                  iconHover = null;
                                  linkType = 'Button';
                              }
                              props = {
                                ctaType: 'Free',
                                href: library.href1,
                                text: library.title1,
                                targetBlank: library.external1,
                                linkType: linkType,
                                iconSrc: icon,
                                hoverIconSrc: iconHover,
                                color: 'Dark',
                                buttonStyle: 'Standard'
                              };
                              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 349
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cta__["a" /* default */], _extends({}, props, {
                                  __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 350
                                  }
                                })),
                                library.updateDate1 && library.updateDate1 !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'p',
                                  { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 351
                                    }
                                  },
                                  '\u66F4\u65B0\u65E5\uFF1A',
                                  _this2.formatReleaseDate(library.updateDate1)
                                ) : null
                              );
                            }
                          }(),
                          function () {
                            if (library.href2 && library.href2 !== '' && library.title2 && library.title2 !== '') {
                              var props = {};
                              var icon = void 0,
                                  iconHover = void 0,
                                  linkType = void 0;
                              switch (library.icon2) {
                                case 'PDF':
                                  icon = __WEBPACK_IMPORTED_MODULE_16__icon_pdf_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_15__icon_pdf_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'E-Book':
                                  icon = __WEBPACK_IMPORTED_MODULE_12__icon_catalog_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_11__icon_catalog_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'Link':
                                  icon = __WEBPACK_IMPORTED_MODULE_14__icon_link_dark_png___default.a;
                                  iconHover = __WEBPACK_IMPORTED_MODULE_13__icon_link_light_png___default.a;
                                  linkType = 'Button-With-Icon';
                                  break;
                                default:
                                  icon = null;
                                  iconHover = null;
                                  linkType = 'Button';
                              }
                              props = {
                                ctaType: 'Free',
                                href: library.href2,
                                text: library.title2,
                                targetBlank: library.external2,
                                linkType: linkType,
                                iconSrc: icon,
                                hoverIconSrc: iconHover,
                                color: 'Dark',
                                buttonStyle: 'Standard'
                              };
                              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 393
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__cta__["a" /* default */], _extends({}, props, {
                                  __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 394
                                  }
                                })),
                                library.updateDate2 && library.updateDate2 !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'p',
                                  { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 395
                                    }
                                  },
                                  '\u66F4\u65B0\u65E5\uFF1A',
                                  _this2.formatReleaseDate(library.updateDate2)
                                ) : null
                              );
                            }
                          }()
                        )
                      )
                    ),
                    library.lowerDescription && library.lowerDescription !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AccessoryDetailContent__ModalWindow__modal-item__container__content__description Wysiwyg', dangerouslySetInnerHTML: { __html: library.lowerDescription }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 404
                      }
                    }) : null
                  )
                )
              )
            );
          }
        }()
      )
    );
  };

  // YYYYMMをYYYY年M月D日にフォーマト


  return AccessoryDetailContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  descriptionOfBasePrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detailTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  variationTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ctaButtons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  library: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    function: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    title1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    icon1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    updateDate1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    title2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    icon2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    updateDate2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    releaseDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    titleAndPreText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    agreementText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    linkArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    lowerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  accessoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  variations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    accessoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    subCateogry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  })),
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  descriptionOfBasePrice: null,
  detailTitle: null,
  variationTitle: null,
  ctaButtons: null,
  library: null,
  accessoryId: null,
  category: null,
  subCategory: null,
  title: null,
  description: null,
  price: null,
  images: null,
  modelName: null,
  bodyTypeModel: null,
  href: null,
  variations: null,
  info: null
}, _temp);
AccessoryDetailContent.displayName = 'AccessoryDetailContent';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryDetailContent);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accessory_info_item__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-info-container\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  AccessoryInfoContainer
 */
var AccessoryInfoContainer = (_temp = _class = function (_Component) {
  _inherits(AccessoryInfoContainer, _Component);

  function AccessoryInfoContainer(props) {
    _classCallCheck(this, AccessoryInfoContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  AccessoryInfoContainer.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        items = _props.items;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AccessoryInfoContainer', __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccessoryInfoContainer__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            }
          },
          items.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__accessory_info_item__["a" /* default */], _extends({}, item.props, { key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 52
              }
            }));
          })
        )
      )
    );
  };

  return AccessoryInfoContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  items: null
}, _temp);
AccessoryInfoContainer.displayName = 'AccessoryInfoContainer';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryInfoContainer);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__video__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__presentation__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__four_column_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-info-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















/**
 *  AccessoryInfoItem
 */
var AccessoryInfoItem = (_temp = _class = function (_Component) {
  _inherits(AccessoryInfoItem, _Component);

  function AccessoryInfoItem(props) {
    _classCallCheck(this, AccessoryInfoItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  AccessoryInfoItem.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        components = _props.components;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AccessoryInfoItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccessoryInfoItem__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          components.map(function (component, index) {
            if (component.name === 'Wysiwyg') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__wysiwyg__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 62
                }
              }));
            } else if (component.name === 'Promo') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__promo__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 67
                }
              }));
            } else if (component.name === 'Video') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__video__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 72
                }
              }));
            } else if (component.name === 'Presentation') {
              var Block = __WEBPACK_IMPORTED_MODULE_12__blocks__[component.name];
              if (Block) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Block, _extends({}, component.props, { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 78
                  }
                }));
              }
            } else if (component.name === 'Picker') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 83
                }
              }));
            } else if (component.name === 'OneColumnLayout') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__one_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 88
                }
              }));
            } else if (component.name === 'TwoColumnLayout') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__two_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 93
                }
              }));
            } else if (component.name === 'ThreeColumnLayout') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__three_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 98
                }
              }));
            } else if (component.name === 'FourColumnLayout') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__four_column_layout__["a" /* default */], _extends({}, component.props, { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 103
                }
              }));
            }
          })
        )
      )
    );
  };

  return AccessoryInfoItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  components: null
}, _temp);
AccessoryInfoItem.displayName = 'AccessoryInfoItem';


/* harmony default export */ __webpack_exports__["a"] = (AccessoryInfoItem);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_interior360_item__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\interior360-item\\index.jsx';





var Interior360ItemBlock = function Interior360ItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_interior360_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
Interior360ItemBlock.displayName = 'Interior360ItemBlock';
Interior360ItemBlock.displayName = 'Interior360Item';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(Interior360ItemBlock));

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_sub_navigation__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_estimation_history__ = __webpack_require__(330);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\sub-navigation\\index.jsx';





var SubNavigationBlock = function SubNavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_sub_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
SubNavigationBlock.displayName = 'SubNavigationBlock';
SubNavigationBlock.displayName = 'SubNavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_estimation_history__["a" /* default */]],
  mapInputToOutput: [['estimationHistory', 'estimationHistory']]
})(SubNavigationBlock));

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_full_width__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\full-width\\index.jsx';





var FullWidthBlock = function FullWidthBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_full_width__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
FullWidthBlock.displayName = 'FullWidthBlock';
FullWidthBlock.displayName = 'FullWidth';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(FullWidthBlock));

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_exterior_view__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_exterior_view_accessories__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\exterior-view\\index.jsx';





var ExteriorViewBlock = function ExteriorViewBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_exterior_view__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
ExteriorViewBlock.displayName = 'ExteriorViewBlock';
ExteriorViewBlock.displayName = 'ExteriorView';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_exterior_view_accessories__["a" /* default */]],
  mapInputToOutput: [['accessories', 'accessories']]
})(ExteriorViewBlock));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_spec_comparison__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\spec-comparison\\index.jsx';





var SpecComparisonBlock = function SpecComparisonBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_spec_comparison__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
SpecComparisonBlock.displayName = 'SpecComparisonBlock';
SpecComparisonBlock.displayName = 'SpecComparison';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_cta__["a" /* default */]],
  mapInputToOutput: [['cta', 'cta']]
})(SpecComparisonBlock));

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14).document && document.documentElement;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9)
  , document = __webpack_require__(14).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(32)
  , toLength  = __webpack_require__(27)
  , toIndex   = __webpack_require__(63);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(32)
  , getNames  = __webpack_require__(7).getNames
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return getNames(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.get = function getOwnPropertyNames(it){
  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
  return getNames(toIObject(it));
};

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(9)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(7)
  , descriptor     = __webpack_require__(44)
  , setToStringTag = __webpack_require__(64)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(35)(IteratorPrototype, __webpack_require__(12)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(9)
  , cof      = __webpack_require__(40)
  , MATCH    = __webpack_require__(12)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(62)
  , defined   = __webpack_require__(37);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(65)
  , ITERATOR   = __webpack_require__(12)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(83)
  , ITERATOR  = __webpack_require__(12)('iterator')
  , Iterators = __webpack_require__(65);
module.exports = __webpack_require__(34).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(51)
  , step             = __webpack_require__(199)
  , Iterators        = __webpack_require__(65)
  , toIObject        = __webpack_require__(32);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(128)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(11);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(36)
  , invoke             = __webpack_require__(80)
  , html               = __webpack_require__(184)
  , cel                = __webpack_require__(185)
  , global             = __webpack_require__(14)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listner = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(40)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listner;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listner, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $            = __webpack_require__(7)
  , hide         = __webpack_require__(35)
  , redefineAll  = __webpack_require__(88)
  , ctx          = __webpack_require__(36)
  , strictNew    = __webpack_require__(87)
  , defined      = __webpack_require__(37)
  , forOf        = __webpack_require__(66)
  , $iterDefine  = __webpack_require__(128)
  , step         = __webpack_require__(199)
  , ID           = __webpack_require__(49)('id')
  , $has         = __webpack_require__(26)
  , isObject     = __webpack_require__(9)
  , setSpecies   = __webpack_require__(85)
  , DESCRIPTORS  = __webpack_require__(30)
  , isExtensible = Object.isExtensible || isObject
  , SIZE         = DESCRIPTORS ? '_s' : 'size'
  , id           = 0;

var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!$has(it, ID)){
    // can't set id to frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add id
    if(!create)return 'E';
    // add missing object id
    hide(it, ID, ++id);
  // return object id with prefix
  } return 'O' + it[ID];
};

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      strictNew(that, C, NAME);
      that._i = $.create(null); // index
      that._f = undefined;      // first entry
      that._l = undefined;      // last entry
      that[SIZE] = 0;           // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide              = __webpack_require__(35)
  , redefineAll       = __webpack_require__(88)
  , anObject          = __webpack_require__(11)
  , isObject          = __webpack_require__(9)
  , strictNew         = __webpack_require__(87)
  , forOf             = __webpack_require__(66)
  , createArrayMethod = __webpack_require__(82)
  , $has              = __webpack_require__(26)
  , WEAK              = __webpack_require__(49)('weak')
  , isExtensible      = Object.isExtensible || isObject
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for frozen keys
var frozenStore = function(that){
  return that._l || (that._l = new FrozenStore);
};
var FrozenStore = function(){
  this.a = [];
};
var findFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
FrozenStore.prototype = {
  get: function(key){
    var entry = findFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findFrozen(this, key);
  },
  set: function(key, value){
    var entry = findFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      strictNew(that, C, NAME);
      that._i = id++;      // collection id
      that._l = undefined; // leak store for frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        if(!isExtensible(key))return frozenStore(this)['delete'](key);
        return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        if(!isExtensible(key))return frozenStore(this).has(key);
        return $has(key, WEAK) && $has(key[WEAK], this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    if(!isExtensible(anObject(key))){
      frozenStore(that).set(key, value);
    } else {
      $has(key, WEAK) || hide(key, WEAK, {});
      key[WEAK][that._i] = value;
    } return that;
  },
  frozenStore: frozenStore,
  WEAK: WEAK
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var $        = __webpack_require__(7)
  , anObject = __webpack_require__(11)
  , Reflect  = __webpack_require__(14).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = $.getNames(anObject(it))
    , getSymbols = $.getSymbols;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-string-pad-left-right
var toLength = __webpack_require__(27)
  , repeat   = __webpack_require__(194)
  , defined  = __webpack_require__(37);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength)return S;
  if(fillStr == '')fillStr = ' ';
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(4)
  , $re     = __webpack_require__(460)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var $         = __webpack_require__(7)
  , toIObject = __webpack_require__(32)
  , isEnum    = $.isEnum;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = $.getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var forOf   = __webpack_require__(66)
  , classof = __webpack_require__(83);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    var arr = [];
    forOf(this, false, arr.push, arr);
    return arr;
  };
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export split */
/* unused harmony export trim */
/* unused harmony export upperCase */
/* unused harmony export lowerCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeLeadingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeTrailingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return upperFirst; });
/* unused harmony export titleCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertPipeToBrTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertKataToRome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(210);



var split = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (sep, str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.split) ? str.split(sep) : [];
});

var trim = function trim(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.trim) ? str.trim() : '';
};

var upperCase = function upperCase(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.toUpperCase) ? str.toUpperCase() : '';
};

var lowerCase = function lowerCase(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.toLowerCase) ? str.toLowerCase() : '';
};

var removeLeadingWhitespace = function removeLeadingWhitespace(string) {
  return string.replace(/^\s+/i, '');
};

var removeTrailingWhitespace = function removeTrailingWhitespace(string) {
  return string.replace(/\s+$/i, '');
};

var upperFirst = function upperFirst(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(str && str.slice) ? '' + upperCase(str.slice(0, 1)) + lowerCase(str.slice(1)) : '';
};

var titleCase = Object(__WEBPACK_IMPORTED_MODULE_0__function__["h" /* pipe */])(split(/\s/g), Object(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* compactMap */])(Object(__WEBPACK_IMPORTED_MODULE_0__function__["h" /* pipe */])(trim, upperFirst)), Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* join */])(' '));

/**
 * |（パイプ）を<br />に変換してHTMLテキストとして返す
 * @param str
 * @returns {string}
 */
var convertPipeToBrTag = function convertPipeToBrTag() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!str || str === '') return '';
  // HTMLコードを削除
  str = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
  // BRタグに変換
  return str.replace(/[|]/g, '<br />');
};

/**
 * 日付（YYYYMMDDもしくはYYYYMM）を2018/01/01のフォーマットに変換
 * @param YYYYMMDD
 * @returns {*}
 */
var formatDate = function formatDate() {
  var YYYYMMDD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';

  if (YYYYMMDD && typeof YYYYMMDD === 'string') {
    var length = YYYYMMDD.length;
    var date = null;
    if (4 <= length) {
      date = YYYYMMDD.substr(0, 4);
    }
    if (6 <= length) {
      date = date + char + YYYYMMDD.substr(4, 2);
    }
    if (8 <= length) {
      date = date + char + YYYYMMDD.substr(6, 2);
    }
    return date;
  } else {
    return null;
  }
};

/**
 * カタカナグレード名称をフォルダ使用可能名称に変換
 * @param str
 * @returns {string}
 */
var convertKataToRome = function convertKataToRome(str) {
  // 全角スペースを半角スペースに変換
  str = (str + '').replace(/　/g, ' ');
  // 大文字を小文字にスペースをハイフンに変換
  str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  // ひらがなを全角カタカナに
  str = str.replace(/[\u3041-\u3096]/g, function (match) {
    var chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });
  // 全角カタカナをローマ字に
  var strArr = [];
  var i = void 0,
      max = void 0;
  for (i = 0, max = str.length; i < max; i = i + 1) {
    var charCode = str.charCodeAt(i);
    if (charCode === 12450) {
      strArr.push('a');
    } else if (charCode === 12452) {
      strArr.push('i');
    } else if (charCode === 12454) {
      strArr.push('u');
    } else if (charCode === 12456) {
      strArr.push('e');
    } else if (charCode === 12458) {
      strArr.push('o');
    } else if (charCode === 12459) {
      strArr.push('ka');
    } else if (charCode === 12461) {
      strArr.push('ki');
    } else if (charCode === 12463) {
      strArr.push('ku');
    } else if (charCode === 12465) {
      strArr.push('ke');
    } else if (charCode === 12467) {
      strArr.push('ko');
    } else if (charCode === 12469) {
      strArr.push('sa');
    } else if (charCode === 12471) {
      strArr.push('si');
    } else if (charCode === 12473) {
      strArr.push('su');
    } else if (charCode === 12475) {
      strArr.push('se');
    } else if (charCode === 12477) {
      strArr.push('so');
    } else if (charCode === 12479) {
      strArr.push('ta');
    } else if (charCode === 12481) {
      strArr.push('ti');
    } else if (charCode === 12484) {
      strArr.push('tu');
    } else if (charCode === 12486) {
      strArr.push('te');
    } else if (charCode === 12488) {
      strArr.push('to');
    } else if (charCode === 12490) {
      strArr.push('na');
    } else if (charCode === 12491) {
      strArr.push('ni');
    } else if (charCode === 12492) {
      strArr.push('nu');
    } else if (charCode === 12493) {
      strArr.push('ne');
    } else if (charCode === 12494) {
      strArr.push('no');
    } else if (charCode === 12495) {
      strArr.push('ha');
    } else if (charCode === 12498) {
      strArr.push('hi');
    } else if (charCode === 12501) {
      strArr.push('fu');
    } else if (charCode === 12504) {
      strArr.push('he');
    } else if (charCode === 12507) {
      strArr.push('ho');
    } else if (charCode === 12510) {
      strArr.push('ma');
    } else if (charCode === 12511) {
      strArr.push('mi');
    } else if (charCode === 12512) {
      strArr.push('mu');
    } else if (charCode === 12513) {
      strArr.push('me');
    } else if (charCode === 12514) {
      strArr.push('mo');
    } else if (charCode === 12516) {
      strArr.push('ya');
    } else if (charCode === 12518) {
      strArr.push('yu');
    } else if (charCode === 12520) {
      strArr.push('yo');
    } else if (charCode === 12521) {
      strArr.push('ra');
    } else if (charCode === 12522) {
      strArr.push('ri');
    } else if (charCode === 12523) {
      strArr.push('ru');
    } else if (charCode === 12524) {
      strArr.push('re');
    } else if (charCode === 12525) {
      strArr.push('ro');
    } else if (charCode === 12527) {
      strArr.push('wa');
    } else if (charCode === 12530) {
      strArr.push('wo');
    } else if (charCode === 12531) {
      strArr.push('n');
    } else if (charCode === 12460) {
      strArr.push('ga');
    } else if (charCode === 12462) {
      strArr.push('gi');
    } else if (charCode === 12464) {
      strArr.push('gi');
    } else if (charCode === 12466) {
      strArr.push('ge');
    } else if (charCode === 12468) {
      strArr.push('go');
    } else if (charCode === 12470) {
      strArr.push('za');
    } else if (charCode === 12472) {
      strArr.push('zi');
    } else if (charCode === 12474) {
      strArr.push('zi');
    } else if (charCode === 12476) {
      strArr.push('ze');
    } else if (charCode === 12478) {
      strArr.push('zo');
    } else if (charCode === 12480) {
      strArr.push('da');
    } else if (charCode === 12482) {
      strArr.push('di');
    } else if (charCode === 12485) {
      strArr.push('du');
    } else if (charCode === 12487) {
      strArr.push('de');
    } else if (charCode === 12489) {
      strArr.push('do');
    } else if (charCode === 12496) {
      strArr.push('ba');
    } else if (charCode === 12499) {
      strArr.push('bi');
    } else if (charCode === 12502) {
      strArr.push('bu');
    } else if (charCode === 12505) {
      strArr.push('be');
    } else if (charCode === 12508) {
      strArr.push('bo');
    } else if (charCode === 12497) {
      strArr.push('pa');
    } else if (charCode === 12500) {
      strArr.push('pi');
    } else if (charCode === 12503) {
      strArr.push('pu');
    } else if (charCode === 12506) {
      strArr.push('pe');
    } else if (charCode === 12509) {
      strArr.push('po');
    } else if (charCode === 12532) {
      strArr.push('va');
    } else if (charCode === 12540) {
      strArr.push('-');
    } else if (charCode === 12449) {
      strArr.push('a');
    } else if (charCode === 12451) {
      strArr.push('i');
    } else if (charCode === 12453) {
      strArr.push('u');
    } else if (charCode === 12455) {
      strArr.push('e');
    } else if (charCode === 12457) {
      strArr.push('o');
    } else if (charCode === 12515) {
      strArr.push('ya');
    } else if (charCode === 12517) {
      strArr.push('yu');
    } else if (charCode === 12519) {
      strArr.push('yo');
    } else if (charCode === 12483) {
      strArr.push('tu');
    } else {
      strArr.push(str[i]);
    }
  }
  str = strArr.join('');
  // できるだけ半角にする
  str = (str + '').replace(/[！-～]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  // 全角を削除
  str = (str + '').replace(/[^!-~\s]/g, '');
  // 半角英数以外を削除
  //str = (str + '').replace(/[^0-9a-zA-Z-//._]/g, '');
  // 先頭と末尾の空白と改行を削除
  str = (str + '').replace(/^[\s]*/, '').replace(/[\s]*$/, '');
  //
  return str;
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export head */
/* unused harmony export last */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return join; });
/* unused harmony export map */
/* unused harmony export filter */
/* unused harmony export compact */
/* unused harmony export take */
/* unused harmony export range */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compactMap; });
/* unused harmony export flatMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareArrays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(45);


var head = function head(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? arr[0] : undefined;
};

var last = function last(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? arr[arr.length - 1] : undefined;
};

var join = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (joiner, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.join) ? arr.join(joiner) : '';
});

var map = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.map) ? arr.map(Object(__WEBPACK_IMPORTED_MODULE_0__function__["i" /* unary */])(fn)) : [];
});

var filter = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.filter) ? arr.filter(Object(__WEBPACK_IMPORTED_MODULE_0__function__["i" /* unary */])(fn)) : [];
});

var compact = filter(Object(__WEBPACK_IMPORTED_MODULE_0__function__["h" /* pipe */])(__WEBPACK_IMPORTED_MODULE_0__function__["d" /* identity */], Boolean));

var take = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (n, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.slice) ? n < 0 ? arr.slice(n) : arr.slice(0, n) : [];
});

var range = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (min, max) {
  return Array(max - min).fill().map(function (_, idx) {
    return min + idx;
  });
});

var compactMap = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.reduce) ? arr.reduce(function (out, val) {
    var fnResult = fn(val);
    if (fnResult) out.push(fnResult);
    return out;
  }, []) : [];
});

var flatMap = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (fn, arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(arr && arr.reduce) ? arr.reduce(function (out, val) {
    return out.concat(fn(val));
  }, []) : [];
});

var compareArrays = function compareArrays(arr1, arr2) {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;

  for (var i = 0, l = arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArrays(arr1[i], arr2[i])) return false;
    } else if (arr1[i] !== arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_general_style__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__ = __webpack_require__(225);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\missing-component\\index.jsx';





/**
 * Missing Component is rendered when a CMS component cannot be found on the frontend
 * (Since it is imported from HOC folder imports from folder indexs won't resolve. Hence /configured-radium)
 */
var MissingComponent = function MissingComponent(_ref) {
  var expectedComponentName = _ref.expectedComponentName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: style.base, __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: style.copy, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      expectedComponentName || 'Component',
      ' not found'
    )
  );
};

MissingComponent.displayName = 'MissingComponent';
var style = {
  base: {
    background: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].RED,
    display: 'inline-block',
    padding: '1em',
    margin: '0.5em'
  },
  copy: _extends({}, __WEBPACK_IMPORTED_MODULE_2_constants_general_style__["a" /* BASE_COPY */], {
    color: __WEBPACK_IMPORTED_MODULE_3_constants_color_palette__["a" /* default */].WHITE,
    fontWeight: 600
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components_configured_radium__["a" /* default */])(MissingComponent));

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enhancer = __webpack_require__(213);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _plugins = __webpack_require__(223);

var _plugins2 = _interopRequireDefault(_plugins);

var _style = __webpack_require__(524);

var _style2 = _interopRequireDefault(_style);

var _styleRoot = __webpack_require__(525);

var _styleRoot2 = _interopRequireDefault(_styleRoot);

var _getState = __webpack_require__(221);

var _getState2 = _interopRequireDefault(_getState);

var _keyframes = __webpack_require__(527);

var _keyframes2 = _interopRequireDefault(_keyframes);

var _resolveStyles = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radium(ComposedComponent) {
  return (0, _enhancer2.default)(ComposedComponent);
}

Radium.Plugins = _plugins2.default;
Radium.Style = _style2.default;
Radium.StyleRoot = _styleRoot2.default;
Radium.getState = _getState2.default;
Radium.keyframes = _keyframes2.default;

if (false) {
  Radium.TestMode = {
    clearState: _resolveStyles.__clearStateForTests,
    disable: _resolveStyles.__setTestMode.bind(null, false),
    enable: _resolveStyles.__setTestMode.bind(null, true)
  };
}

exports.default = Radium;
module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = enhanceWithRadium;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleKeeper = __webpack_require__(134);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _resolveStyles = __webpack_require__(214);

var _resolveStyles2 = _interopRequireDefault(_resolveStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];

function copyProperties(source, target) {
  Object.getOwnPropertyNames(source).forEach(function (key) {
    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
      var descriptor = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, descriptor);
    }
  });
}

function isStateless(component) {
  return !component.render && !(component.prototype && component.prototype.render);
}

// Check if value is a real ES class in Native / Node code.
// See: https://stackoverflow.com/a/30760236
function isNativeClass(component) {
  return typeof component === 'function' && /^\s*class\s+/.test(component.toString());
}

// Manually apply babel-ish class inheritance.
function inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (superClass) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(subClass, superClass);
    } else {
      subClass.__proto__ = superClass; // eslint-disable-line no-proto
    }
  }
}

function enhanceWithRadium(configOrComposedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof configOrComposedComponent !== 'function') {
    var newConfig = _extends({}, config, configOrComposedComponent);
    return function (configOrComponent) {
      return enhanceWithRadium(configOrComponent, newConfig);
    };
  }

  var component = configOrComposedComponent;
  var ComposedComponent = component;

  // Handle Native ES classes.
  if (isNativeClass(ComposedComponent)) {
    // Manually approximate babel's class transpilation, but _with_ a real `new` call.
    ComposedComponent = function (OrigComponent) {
      function NewComponent() {
        // Ordinarily, babel would produce something like:
        //
        // ```
        // return _possibleConstructorReturn(this, OrigComponent.apply(this, arguments));
        // ```
        //
        // Instead, we just call `new` directly without the `_possibleConstructorReturn` wrapper.
        var source = new (Function.prototype.bind.apply(OrigComponent, [null].concat(Array.prototype.slice.call(arguments))))();

        // Then we manually update context with properties.
        copyProperties(source, this);

        return this;
      }

      inherits(NewComponent, OrigComponent);

      return NewComponent;
    }(ComposedComponent);
  }

  // Handle stateless components
  if (isStateless(ComposedComponent)) {
    ComposedComponent = function (_Component) {
      _inherits(ComposedComponent, _Component);

      function ComposedComponent() {
        _classCallCheck(this, ComposedComponent);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ComposedComponent.prototype.render = function render() {
        return component(this.props, this.context);
      };

      return ComposedComponent;
    }(_react.Component);

    ComposedComponent.displayName = component.displayName || component.name;
  }

  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
    _inherits(RadiumEnhancer, _ComposedComponent);

    function RadiumEnhancer() {
      _classCallCheck(this, RadiumEnhancer);

      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));

      _this2.state = _this2.state || {};
      _this2.state._radiumStyleState = {};
      _this2._radiumIsMounted = true;
      return _this2;
    }

    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (_ComposedComponent.prototype.componentWillUnmount) {
        _ComposedComponent.prototype.componentWillUnmount.call(this);
      }

      this._radiumIsMounted = false;

      if (this._radiumMouseUpListener) {
        this._radiumMouseUpListener.remove();
      }

      if (this._radiumMediaQueryListenersByQuery) {
        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
          this._radiumMediaQueryListenersByQuery[query].remove();
        }, this);
      }
    };

    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};

      if (!this.props.radiumConfig) {
        return superChildContext;
      }

      var newContext = _extends({}, superChildContext);

      if (this.props.radiumConfig) {
        newContext._radiumConfig = this.props.radiumConfig;
      }

      return newContext;
    };

    RadiumEnhancer.prototype.render = function render() {
      var renderedElement = _ComposedComponent.prototype.render.call(this);
      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;

      if (config && currentConfig !== config) {
        currentConfig = _extends({}, config, currentConfig);
      }

      return (0, _resolveStyles2.default)(this, renderedElement, currentConfig);
    };

    return RadiumEnhancer;
  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-

  copyProperties(component, RadiumEnhancer);

  if (false) {
    // This also fixes React Hot Loader by exposing the original components top
    // level prototype methods on the Radium enhanced prototype as discussed in
    // https://github.com/FormidableLabs/radium/issues/219.
    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
  }

  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
      style: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
    });
  }

  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';

  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
    _radiumConfig: _propTypes2.default.object,
    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
  });

  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
    _radiumConfig: _propTypes2.default.object,
    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
  });

  return RadiumEnhancer;
}
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _appendImportantToEachValue = __webpack_require__(484);

var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);

var _cssRuleSetToString = __webpack_require__(91);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _getState = __webpack_require__(221);

var _getState2 = _interopRequireDefault(_getState);

var _getStateKey = __webpack_require__(222);

var _getStateKey2 = _interopRequireDefault(_getStateKey);

var _hash = __webpack_require__(137);

var _hash2 = _interopRequireDefault(_hash);

var _mergeStyles = __webpack_require__(513);

var _plugins = __webpack_require__(223);

var _plugins2 = _interopRequireDefault(_plugins);

var _exenv = __webpack_require__(523);

var _exenv2 = _interopRequireDefault(_exenv);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CONFIG = {
  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
};

// Gross
var globalState = {};

// Declare early for recursive helpers.
var resolveStyles = null;

var _shouldResolveStyles = function _shouldResolveStyles(component) {
  return component.type && !component.type._isRadiumEnhanced;
};

var _resolveChildren = function _resolveChildren(_ref) {
  var children = _ref.children,
      component = _ref.component,
      config = _ref.config,
      existingKeyMap = _ref.existingKeyMap;

  if (!children) {
    return children;
  }

  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (childrenType === 'string' || childrenType === 'number') {
    // Don't do anything with a single primitive child
    return children;
  }

  if (childrenType === 'function') {
    // Wrap the function, resolving styles on the result
    return function () {
      var result = children.apply(this, arguments);
      if (_react2.default.isValidElement(result)) {
        return resolveStyles(component, result, config, existingKeyMap, true);
      }
      return result;
    };
  }

  if (_react2.default.Children.count(children) === 1 && children.type) {
    // If a React Element is an only child, don't wrap it in an array for
    // React.Children.map() for React.Children.only() compatibility.
    var onlyChild = _react2.default.Children.only(children);
    return resolveStyles(component, onlyChild, config, existingKeyMap, true);
  }

  return _react2.default.Children.map(children, function (child) {
    if (_react2.default.isValidElement(child)) {
      return resolveStyles(component, child, config, existingKeyMap, true);
    }

    return child;
  });
};

// Recurse over props, just like children
var _resolveProps = function _resolveProps(_ref2) {
  var component = _ref2.component,
      config = _ref2.config,
      existingKeyMap = _ref2.existingKeyMap,
      props = _ref2.props;

  var newProps = props;

  Object.keys(props).forEach(function (prop) {
    // We already recurse over children above
    if (prop === 'children') {
      return;
    }

    var propValue = props[prop];
    if (_react2.default.isValidElement(propValue)) {
      newProps = _extends({}, newProps);
      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap, true);
    }
  });

  return newProps;
};

var _buildGetKey = function _buildGetKey(_ref3) {
  var componentName = _ref3.componentName,
      existingKeyMap = _ref3.existingKeyMap,
      renderedElement = _ref3.renderedElement;

  // We need a unique key to correlate state changes due to user interaction
  // with the rendered element, so we know to apply the proper interactive
  // styles.
  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
  var key = (0, _getStateKey2.default)(originalKey);

  var alreadyGotKey = false;
  var getKey = function getKey() {
    if (alreadyGotKey) {
      return key;
    }

    alreadyGotKey = true;

    if (existingKeyMap[key]) {
      var elementName = void 0;
      if (typeof renderedElement.type === 'string') {
        elementName = renderedElement.type;
      } else if (renderedElement.type.constructor) {
        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
      }

      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
    }

    existingKeyMap[key] = true;

    return key;
  };

  return getKey;
};

var _setStyleState = function _setStyleState(component, key, stateKey, value) {
  if (!component._radiumIsMounted) {
    return;
  }

  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};

  var state = { _radiumStyleState: _extends({}, existing) };
  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
  state._radiumStyleState[key][stateKey] = value;

  component._lastRadiumState = state._radiumStyleState;
  component.setState(state);
};

var _runPlugins = function _runPlugins(_ref4) {
  var component = _ref4.component,
      config = _ref4.config,
      existingKeyMap = _ref4.existingKeyMap,
      props = _ref4.props,
      renderedElement = _ref4.renderedElement;

  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
  // no style.
  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
    return props;
  }

  var newProps = props;

  var plugins = config.plugins || DEFAULT_CONFIG.plugins;

  var componentName = component.constructor.displayName || component.constructor.name;
  var getKey = _buildGetKey({
    renderedElement: renderedElement,
    existingKeyMap: existingKeyMap,
    componentName: componentName
  });
  var getComponentField = function getComponentField(key) {
    return component[key];
  };
  var getGlobalState = function getGlobalState(key) {
    return globalState[key];
  };
  var componentGetState = function componentGetState(stateKey, elementKey) {
    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
  };
  var setState = function setState(stateKey, value, elementKey) {
    return _setStyleState(component, elementKey || getKey(), stateKey, value);
  };

  var addCSS = function addCSS(css) {
    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
    if (!styleKeeper) {
      if (__isTestModeEnabled) {
        return {
          remove: function remove() {}
        };
      }

      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
    }

    return styleKeeper.addCSS(css);
  };

  var newStyle = props.style;

  plugins.forEach(function (plugin) {
    var result = plugin({
      ExecutionEnvironment: _exenv2.default,
      addCSS: addCSS,
      appendImportantToEachValue: _appendImportantToEachValue2.default,
      componentName: componentName,
      config: config,
      cssRuleSetToString: _cssRuleSetToString2.default,
      getComponentField: getComponentField,
      getGlobalState: getGlobalState,
      getState: componentGetState,
      hash: _hash2.default,
      mergeStyles: _mergeStyles.mergeStyles,
      props: newProps,
      setState: setState,
      isNestedStyle: _mergeStyles.isNestedStyle,
      style: newStyle
    }) || {};

    newStyle = result.style || newStyle;

    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;

    var newComponentFields = result.componentFields || {};
    Object.keys(newComponentFields).forEach(function (fieldName) {
      component[fieldName] = newComponentFields[fieldName];
    });

    var newGlobalState = result.globalState || {};
    Object.keys(newGlobalState).forEach(function (key) {
      globalState[key] = newGlobalState[key];
    });
  });

  if (newStyle !== props.style) {
    newProps = _extends({}, newProps, { style: newStyle });
  }

  return newProps;
};

// Wrapper around React.cloneElement. To avoid processing the same element
// twice, whenever we clone an element add a special prop to make sure we don't
// process this element again.
var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
  // Only add flag if this is a normal DOM element
  if (typeof renderedElement.type === 'string') {
    newProps = _extends({}, newProps, { 'data-radium': true });
  }

  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
};

//
// The nucleus of Radium. resolveStyles is called on the rendered elements
// before they are returned in render. It iterates over the elements and
// children, rewriting props to add event handlers required to capture user
// interactions (e.g. mouse over). It also replaces the style prop because it
// adds in the various interaction styles (e.g. :hover).
//
resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
renderedElement) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
  var existingKeyMap = arguments[3];
  var shouldCheckBeforeResolve = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // ReactElement
  existingKeyMap = existingKeyMap || {};
  if (!renderedElement ||
  // Bail if we've already processed this element. This ensures that only the
  // owner of an element processes that element, since the owner's render
  // function will be called first (which will always be the case, since you
  // can't know what else to render until you render the parent component).
  renderedElement.props && renderedElement.props['data-radium'] ||
  // Bail if this element is a radium enhanced element, because if it is,
  // then it will take care of resolving its own styles.
  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
    return renderedElement;
  }

  var newChildren = _resolveChildren({
    children: renderedElement.props.children,
    component: component,
    config: config,
    existingKeyMap: existingKeyMap
  });

  var newProps = _resolveProps({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    props: renderedElement.props
  });

  newProps = _runPlugins({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    props: newProps,
    renderedElement: renderedElement
  });

  // If nothing changed, don't bother cloning the element. Might be a bit
  // wasteful, as we add the sentinal to stop double-processing when we clone.
  // Assume benign double-processing is better than unneeded cloning.
  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
    return renderedElement;
  }

  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
};

// Only for use by tests
var __isTestModeEnabled = false;
if (false) {
  resolveStyles.__clearStateForTests = function () {
    globalState = {};
  };
  resolveStyles.__setTestMode = function (isEnabled) {
    __isTestModeEnabled = isEnabled;
  };
}

exports.default = resolveStyles;
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendPxIfNeeded;


// Copied from https://github.com/facebook/react/blob/
// 102cd291899f9942a76c40a0e78920a6fe544dc1/
// src/renderers/dom/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

function appendPxIfNeeded(propertyName, value) {
  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
  return needsPxSuffix ? value + 'px' : value;
}
module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapObject;
function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}
module.exports = exports["default"];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortPrefixedStyle;

var _isPrefixedProperty = __webpack_require__(488);

var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sortPrefixedStyle(style) {
  return Object.keys(style).sort(function (left, right) {
    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
      return -1;
    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
      return 1;
    }
    return 0;
  }).reduce(function (sortedStyle, prop) {
    sortedStyle[prop] = style[prop];
    return sortedStyle;
  }, {});
}
module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(499)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getStateKey = __webpack_require__(222);

var _getStateKey2 = _interopRequireDefault(_getStateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(state, elementKey, value) {
  var key = (0, _getStateKey2.default)(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

exports.default = getState;
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getStateKey = function getStateKey(elementKey) {
  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
};

exports.default = getStateKey;
module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkPropsPlugin = __webpack_require__(514);

var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);

var _keyframesPlugin = __webpack_require__(515);

var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);

var _mergeStyleArrayPlugin = __webpack_require__(516);

var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);

var _prefixPlugin = __webpack_require__(517);

var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);

var _removeNestedStylesPlugin = __webpack_require__(518);

var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);

var _resolveInteractionStylesPlugin = __webpack_require__(519);

var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);

var _resolveMediaQueriesPlugin = __webpack_require__(521);

var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);

var _visitedPlugin = __webpack_require__(522);

var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  checkProps: _checkPropsPlugin2.default,
  keyframes: _keyframesPlugin2.default,
  mergeStyleArray: _mergeStyleArrayPlugin2.default,
  prefix: _prefixPlugin2.default,
  removeNestedStyles: _removeNestedStylesPlugin2.default,
  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
  visited: _visitedPlugin2.default
};
/* eslint-disable block-scoped-const */

module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_layout__ = __webpack_require__(67);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var style = _ref.style;

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["e" /* IS_IFRAME */]) return { style: style };

  var replaceVH = function replaceVH(match, number, unit, offset, string) {
    var fixed = Number(number) * (__WEBPACK_IMPORTED_MODULE_1__constants_layout__["a" /* DEFAULT_IFRAME_HEIGHT */] / 100);
    return fixed + 'px';
  };
  var replaceStyles = function replaceStyles(style) {
    // Somehow in iframe we have an error with this style equal to null
    // So we added this condition below for checking the style
    var cloneStyle = style || {};
    return Object.keys(cloneStyle).reduce(function (newStyle, key) {
      var value = cloneStyle[key];
      var matchVH = /(\d+)(vh)/i;
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = replaceStyles(value);
      } else if (typeof value === 'string') {
        value = value.replace(matchVH, replaceVH);
      }
      newStyle[key] = value;
      return newStyle;
    }, {});
  };
  var rs = replaceStyles(style);
  return { style: rs };
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  BLUE: '#0082C7',
  ORANGE: '#ff8d2e',
  BLACK: '#101010',
  GRAY_DARKER: '#2E2E2E',
  GRAY_DARK: '#999999',
  GRAY: '#D5D5D5',
  GRAY_LIGHT: '#E7E7E7',
  GRAY_LIGHTER: '#F5F5F5',
  WHITE: '#FFFFFF',
  GREEN: '#7dbe38',
  RED: '#DD0000'
});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(534);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(535);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(138);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var options = { log: console.log };

exports.default = options;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(567);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(237);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(140);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_location__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\connect-location.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * Higher order component for connecting to Redux location state. Now a convenience thing
 * more than anything
 * @param {Object} options - Initial config options.
 * @param {String} options.exposeState - Name of the props object that contains state attributes.
 * @param {String} options.exposeActions - Name of the props object that contains actions which modify state.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$exposeState = _ref.exposeState,
      exposeState = _ref$exposeState === undefined ? 'locationState' : _ref$exposeState,
      _ref$exposeActions = _ref.exposeActions,
      exposeActions = _ref$exposeActions === undefined ? 'locationActions' : _ref$exposeActions;

  return function (Wrapped) {
    var _class, _temp;

    var ConnectLocation = (_temp = _class = function (_Component) {
      _inherits(ConnectLocation, _Component);

      function ConnectLocation() {
        _classCallCheck(this, ConnectLocation);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ConnectLocation.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        }));
      };

      return ConnectLocation;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
      locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
    }, _class.defaultProps = {
      locationActions: {
        requestPostcodeInput: __WEBPACK_IMPORTED_MODULE_4__utils__["v" /* noop */]
      }
    }, _temp);
    ConnectLocation.displayName = 'ConnectLocation';


    ConnectLocation.displayName = 'ConnectLocation(' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    var mapStateToProps = function mapStateToProps(state) {
      var _ref2;

      return _ref2 = {}, _ref2[exposeState] = __WEBPACK_IMPORTED_MODULE_3__store_actions_location__["c" /* selectors */].getLocation(state), _ref2;
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      var _ref3;

      return _ref3 = {}, _ref3[exposeActions] = Object.keys(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */]).reduce(function (actions, key) {
        actions[key] = function () {
          return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */][key].apply(__WEBPACK_IMPORTED_MODULE_3__store_actions_location__["a" /* actionCreators */], arguments));
        };
        return actions;
      }, {}), _ref3;
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ConnectLocation);
  };
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_layout__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_environment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\detect-thresholds.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var resolveThresholds = function resolveThresholds(thresholds, win, rect) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["u" /* mapValues */])(function (thresh) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7__utils__["r" /* isFunction */])(thresh)) return Boolean(thresh(win, rect));
    if (Array.isArray(thresh)) {
      return thresh.map(function (breakPoint) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* isFinite */])(breakPoint) ? win.innerWidth < breakPoint : false;
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["q" /* isFinite */])(thresh) ? win.innerWidth < thresh : false;
  }, thresholds);
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$thresholds = _ref.thresholds,
      thresholds = _ref$thresholds === undefined ? {
    compact: function compact(_ref2) {
      var innerWidth = _ref2.innerWidth;
      return innerWidth < __WEBPACK_IMPORTED_MODULE_5__constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */];
    },
    wide: function wide(_ref3) {
      var innerWidth = _ref3.innerWidth;
      return innerWidth >= __WEBPACK_IMPORTED_MODULE_5__constants_layout__["c" /* DEFAULT_THRESHOLD_WIDE */];
    }
  } : _ref$thresholds,
      _ref$defaultThreshold = _ref.defaultThresholds,
      defaultThresholds = _ref$defaultThreshold === undefined ? {
    compact: true,
    wide: false
  } : _ref$defaultThreshold,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_7__utils__["v" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? 'thresholds' : _ref$expose;

  return function (Wrapped) {
    var DetectThresholds = function (_PureComponent) {
      _inherits(DetectThresholds, _PureComponent);

      function DetectThresholds(props) {
        var _this$state;

        _classCallCheck(this, DetectThresholds);

        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

        var initState = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["u" /* mapValues */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* constant */])(false), thresholds), Object(__WEBPACK_IMPORTED_MODULE_7__utils__["y" /* pick */])(Object.keys(thresholds), defaultThresholds || {}));

        _this.state = (_this$state = {}, _this$state[expose] = initState, _this$state);
        return _this;
      }

      DetectThresholds.prototype.stateFromProps = function stateFromProps(props) {
        var next = resolveThresholds(thresholds, props._WINDOW_SIZE_, this.domNode ? this.domNode.getBoundingClientRect() : {});

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils__["F" /* shallowEq */])(this.state[expose], next) || !Object(__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* compareArrays */])(Object.values(this.state[expose]), Object.values(next))) {
          var _setState;

          this.setState((_setState = {}, _setState[expose] = next, _setState));
          onChange(next);
        }
      };

      DetectThresholds.prototype.componentDidMount = function componentDidMount() {
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */]) this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this); // TODO: some other way
        this.stateFromProps(this.props);
      };

      DetectThresholds.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.stateFromProps(nextProps);
      };

      DetectThresholds.prototype.render = function render() {
        var _extends2;

        var innerProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils__["x" /* omit */])(['_WINDOW_SIZE_'], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, innerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87
          }
        }));
      };

      return DetectThresholds;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

    DetectThresholds.displayName = 'DetectThresholds';


    DetectThresholds.propTypes = {
      _WINDOW_SIZE_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
      })
    };

    DetectThresholds.displayName = 'DetectThresholds(' + Object(__WEBPACK_IMPORTED_MODULE_7__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    var mapStateToProps = function mapStateToProps(state) {
      return {
        _WINDOW_SIZE_: __WEBPACK_IMPORTED_MODULE_6__store_actions_environment__["c" /* selectors */].getWindowSize(state)
      };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(DetectThresholds);
  };
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchMJOData; });
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchMJOData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params) {
    var options, response, json, success, data, errorMsg, errorCode, error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(params)
            };
            _context.prev = 1;
            _context.next = 4;
            return fetch(url, options);

          case 4:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 7;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            json = _context.sent;
            success = json.success, data = json.data, errorMsg = json.errorMsg, errorCode = json.errorCode;

            if (success) {
              _context.next = 15;
              break;
            }

            error = new Error(errorMsg || errorCode);


            if (data) error.data = data;

            throw error;

          case 15:

            if (!data) console.warn('No data returned.', json);

            return _context.abrupt('return', data || undefined);

          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](1);

            console.warn('MJO fetch failed', _context.t0, url, params);
            throw _context.t0;

          case 23:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 19]]);
  }));

  return function fetchMJOData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(243);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(100);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionTypes; });
/* unused harmony export actionCreators */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Action Types

var actionTypes = {
  INIT_OUTLET_STORE: 'INIT_OUTLET_STORE',
  LOAD_OUTLET_STORE: 'LOAD_OUTLET_STORE',
  STEP_CHANGE: 'STEP_CHANGE',
  DEALER_RESET: 'DEALER_RESET',
  DEALER_CONFIRM: 'DELAER_CONFIRM',
  DEALER_CHANGE_REQUEST: 'DEALER_CHANGE_REQUEST',
  DEALER_CHANGE_SUCCESS: 'DEALER_CHANGE_SUCCESS',
  DEALER_CHANGE_NO_RESULTS: 'DEALER_CHANGE_NO_RESULTS',
  DEALER_FETCH_START: 'DEALER_FETCH_START',
  DEALER_FETCH_CANNOT_RESOLVE: 'DEALER_FETCH_CANNOT_RESOLVE',
  DEALER_FETCH_SUCCESS: 'DEALER_FETCH_SUCCESS',
  DEALER_FETCH_ERROR: 'DEALER_FETCH_ERROR',
  NAMEPLATE_CHANGE: 'NAMEPLATE_CHANGE',
  OUTLET_STOCKS_FETCH_REQUEST: 'OUTLET_STOCKS_FETCH_REQUEST',
  OUTLET_STOCKS_FETCH_START: 'OUTLET_STOCKS_FETCH_START',
  OUTLET_STOCKS_FETCH_SUCCESS: 'OUTLET_STOCKS_FETCH_SUCCESS',
  OUTLET_STOCKS_FETCH_ERROR: 'OUTLET_STOCKS_FETCH_ERROR',
  UPDATE_SORT: 'UPDATE_SORT',
  UPDATE_FILTER: 'UPDATE_FILTER'

  // Action Creators

};var initOutletStore = function initOutletStore(_ref) {
  var outletStockEndpoint = _ref.outletStockEndpoint;
  return {
    type: actionTypes.INIT_OUTLET_STORE,
    payload: { outletStockEndpoint: outletStockEndpoint }
  };
};

var dealerReset = function dealerReset() {
  return {
    type: actionTypes.DEALER_RESET
  };
};

var dealerConfirm = function dealerConfirm() {
  return {
    type: actionTypes.DEALER_CONFIRM,
    payload: { dealerConfirm: true }
  };
};

var dealerChangeRequest = function dealerChangeRequest(_ref2) {
  var dealerCode = _ref2.dealerCode,
      id = _ref2.id;
  return {
    type: actionTypes.DEALER_CHANGE_REQUEST,
    payload: { dealer: { dealerCode: dealerCode, id: id }, dealerConfirm: false }
  };
};

var stepChange = function stepChange(payload) {
  return {
    type: actionTypes.STEP_CHANGE,
    payload: payload
  };
};

var nameplateChange = function nameplateChange(payload) {
  return {
    type: actionTypes.NAMEPLATE_CHANGE,
    payload: payload
  };
};

var fetchRequest = function fetchRequest(params) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_REQUEST,
    payload: _extends({}, params)
  };
};

var fetchSuccess = function fetchSuccess(result) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_SUCCESS,
    payload: _extends({}, result)
  };
};

var fetchError = function fetchError(error) {
  return {
    type: actionTypes.OUTLET_STOCKS_FETCH_ERROR,
    payload: _extends({}, error)
  };
};

var updateSort = function updateSort(_ref3) {
  var key = _ref3.key,
      dir = _ref3.dir,
      gtmID = _ref3.gtmID,
      gtmPayload = _ref3.gtmPayload;
  return {
    type: actionTypes.UPDATE_SORT,
    payload: { sort: { key: key, dir: dir }, gtmID: gtmID, gtmPayload: gtmPayload }
  };
};

var updateFilters = function updateFilters(filter) {
  return {
    type: actionTypes.UPDATE_FILTER,
    payload: { filter: filter }
  };
};

var actionCreators = {
  initOutletStore: initOutletStore,
  dealerReset: dealerReset,
  dealerChangeRequest: dealerChangeRequest,
  nameplateChange: nameplateChange,
  fetchRequest: fetchRequest,
  dealerConfirm: dealerConfirm,
  fetchSuccess: fetchSuccess,
  fetchError: fetchError,
  stepChange: stepChange,
  updateSort: updateSort,
  updateFilters: updateFilters

  // Selectors

};var getOutlet = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('outlet');

var selectors = {
  getOutlet: getOutlet
};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(616),
    isObjectLike = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(102),
    isObject = __webpack_require__(251);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(254),
    setCacheAdd = __webpack_require__(649),
    setCacheHas = __webpack_require__(650);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(632),
    mapCacheDelete = __webpack_require__(644),
    mapCacheGet = __webpack_require__(646),
    mapCacheHas = __webpack_require__(647),
    mapCacheSet = __webpack_require__(648);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(250),
    isLength = __webpack_require__(259);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE: 'COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE] = function (_ref) {
  var model1 = _ref.model1,
      model2 = _ref.model2;
  return {
    type: gtmEventTypes.CLICK_COMPARE,
    event: 'reactjs.event',
    eventID: 'FED001',
    pageCategory: 'Compare Tool',
    pageAction: 'Compare Home - Clicked Compare Cars "' + model1.toUpperCase() + '" and "' + model2.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

// Action types
var gtmEventTypes = {
  COMPARE_TOOL_CHANGE_SELECTION: 'COMPARE_TOOL_CHANGE_SELECTION',
  COMPARE_TOOL_TOGGLE_ACCORDION: 'COMPARE_TOOL_TOGGLE_ACCORDION',
  COMPARE_TOOL_CLICK_CTA: 'COMPARE_TOOL_CLICK_CTA',
  COMPARE_TOOL_CLICK_PRICE_DISCLAIMER: 'COMPARE_TOOL_CLICK_PRICE_DISCLAIMER'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CHANGE_SELECTION] = function (_ref) {
  var eventID = _ref.eventID,
      actionMessage = _ref.actionMessage;
  return {
    type: gtmEventTypes.CHANGE_SELECTION,
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_TOGGLE_ACCORDION] = function (_ref2) {
  var eventID = _ref2.eventID,
      actionMessage = _ref2.actionMessage;
  return {
    type: gtmEventTypes.TOGGLE_ACCORDION,
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CLICK_CTA] = function (_ref3) {
  var eventID = _ref3.eventID,
      actionMessage = _ref3.actionMessage;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage
  };
}, _gtmEvents[gtmEventTypes.COMPARE_TOOL_CLICK_PRICE_DISCLAIMER] = function (_ref4) {
  var eventID = _ref4.eventID,
      actionMessage = _ref4.actionMessage;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage
  };
}, _gtmEvents);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  ITB_CLICK: 'ITB_CLICK'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.ITB_CLICK] = function (_ref) {
  var name = _ref.name,
      id = _ref.id,
      category = _ref.category,
      actionMessage = _ref.actionMessage,
      customValue = _ref.customValue,
      version = _ref.version;
  return {
    type: gtmEventTypes.ITB_CLICK,
    event: gtmEventTypes.ITB_CLICK,
    eventID: id,
    pageCategory: category,
    customValue: customValue,
    version: version
  };
}, _gtmEvents);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  CLICK_LINK: 'WYSIWYG_CLICK_LINK'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_LINK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE: 'BOOK_TESTDRIVE_BTDF_CLICK_BOOK_TEST_DRIVE',
  BOOK_TESTDRIVE_CLICK_SUBMIT: 'BOOK_TESTDRIVE_BTDF_CLICK_SUBMIT',
  BOOK_TESTDRIVE_SELECT_MODEL: 'BOOK_TESTDRIVE_BTDF_SELECT_MODEL',
  BOOK_TESTDRIVE_SELECT_TITLE: 'BOOK_TESTDRIVE_BTDF_SELECT_TITLE',
  BOOK_TESTDRIVE_ENTER_FIRSTNAME: 'BOOK_TESTDRIVE_BTDF_ENTER_FIRSTNAME',
  BOOK_TESTDRIVE_ENTER_LASTNAME: 'BOOK_TESTDRIVE_BTDF_ENTER_LASTNAME',
  BOOK_TESTDRIVE_ENTER_PHONE: 'BOOK_TESTDRIVE_BTDF_ENTER_PHONE',
  BOOK_TESTDRIVE_ENTER_EMAIL: 'BOOK_TESTDRIVE_BTDF_ENTER_EMAIL',
  BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB: 'BOOK_TESTDRIVE_BTDF_SELECT_POSTCODE_SUBURB',
  BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_ADDRESS',
  BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_WEBSITE',
  BOOK_TESTDRIVE_DEALER_CLICK_PHONE: 'BOOK_TESTDRIVE_BTDF_DEALER_CLICK_PHONE',
  BOOK_TESTDRIVE_ENTER_COMMENTS: 'BOOK_TESTDRIVE_BTDF_ENTER_COMMENTS',
  BOOK_TESTDRIVE_CHECK_OPTIN: 'BOOK_TESTDRIVE_BTDF_CHECK_OPTIN',
  BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY: 'BOOK_TESTDRIVE_BTDF_CHECK_PRIVACY_POLICY',
  BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY: 'BOOK_TESTDRIVE_BTDF_CLICK_PRIVACY_POLICY',
  BOOK_TESTDRIVE_CLICK_GO_BACK: 'BOOK_TESTDRIVE_BTDF_CLICK_GO_BACK'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE] = function (_ref) {
  var _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === undefined ? '' : _ref$buttonText;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_BOOK_TEST_DRIVE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-001',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? '' : _ref2$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-002',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked Submitted - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? '' : _ref3$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_MODEL,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-003',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Selected "MODEL - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE] = function (_ref4) {
  var _ref4$model = _ref4.model,
      model = _ref4$model === undefined ? '' : _ref4$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_TITLE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-004',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Selected "TITLE" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-005',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "FIRSTNAME"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-006',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "LASTNAME"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-007',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "PHONE"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-008',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "EMAIL"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB] = function (_ref5) {
  var _ref5$model = _ref5.model,
      model = _ref5$model === undefined ? '' : _ref5$model;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_SELECT_POSTCODE_SUBURB,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-009',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Selected "POSTCODE/SUBURB" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      address = _ref6.address;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-010',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - ' + dealerName + ' - Address "' + address + '" - Clicked "ADDRESS"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      address = _ref7.address,
      website = _ref7.website;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-011',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - ' + dealerName + ' - Address "' + address + '" - Clicked "WEBSITE ' + website + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE] = function (_ref8) {
  var dealerName = _ref8.dealerName,
      address = _ref8.address,
      phone = _ref8.phone;
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_DEALER_CLICK_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-012',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - ' + dealerName + ' - Address ' + address + ' - Clicked "PHONE ' + phone + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_ENTER_COMMENTS,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-013',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Entered "COMMENTS"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_OPTIN,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-014',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Checked "OPTIN"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-015',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Checked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-016',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.BOOK_TESTDRIVE_CLICK_GO_BACK,
    event: 'reactjs.event',
    eventID: 'FED-BTDF-017',
    pageCategory: 'Book A Test Drive Form',
    pageAction: 'Book A Test Drive Form - Clicked "GO BACK"'
  };
}, _gtmEvents);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  CONTACT_US_SELECT_TOPIC: 'CONTACT_US_GITF_SELECT_TOPIC',
  CONTACT_US_SELECT_TITLE: 'CONTACT_US_GITF_SELECT_TITLE',
  CONTACT_US_ENTER_FIRSTNAME: 'CONTACT_US_GITF_ENTER_FIRSTNAME',
  CONTACT_US_ENTER_LASTNAME: 'CONTACT_US_GITF_ENTER_LASTNAME',
  CONTACT_US_ENTER_PHONE: 'CONTACT_US_GITF_ENTER_PHONE',
  CONTACT_US_ENTER_EMAIL: 'CONTACT_US_GITF_ENTER_EMAIL',
  CONTACT_US_ENTER_ENQUIRY: 'CONTACT_US_GITF_ENTER_ENQUIRY',
  CONTACT_US_ENTER_REGISTRATION_OR_VIN: 'CONTACT_US_GITF_ENTER_REGISTRATION_OR_VIN',
  CONTACT_US_ENTER_ADDRESS: 'CONTACT_US_GITF_ENTER_ADDRESS',
  CONTACT_US_SELECT_POSTCODE_SUBURB: 'CONTACT_US_GITF_SELECT_POSTCODE_SUBURB',
  CONTACT_US_ENTER_OLD_VIN_REGO: 'CONTACT_US_GITF_ENTER_OLD_VIN_REGO',
  CONTACT_US_ENTER_CURRENT_VIN_REGO: 'CONTACT_US_GITF_ENTER_CURRENT_VIN_REGO',
  CONTACT_US_CHECK_PRIVACY_POLICY: 'CONTACT_US_GITF_CHECK_PRIVACY_POLICY',
  CONTACT_US_CLICK_PRIVACY_POLICY: 'CONTACT_US_GITF_CLICK_PRIVACY_POLICY',
  CONTACT_US_CLICK_GO_BACK: 'CONTACT_US_GITF_CLICK_GO_BACK',
  CONTACT_US_CLICK_SUBMIT: 'CONTACT_US_GITF_CLICK_SUBMIT'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_TOPIC] = function (_ref) {
  var _ref$model = _ref.model,
      model = _ref$model === undefined ? '' : _ref$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_TOPIC,
    event: 'reactjs.event',
    eventID: 'FED-GITF-001',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Selected "TOPIC" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_TITLE] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? '' : _ref2$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_TITLE,
    event: 'reactjs.event',
    eventID: 'FED-GITF-002',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Selected "TITLE" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: 'FED-GITF-003',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "FIRSTNAME"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: 'FED-GITF-004',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "LASTNAME"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-GITF-005',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "PHONE"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: 'FED-GITF-006',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "EMAIL"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_ENQUIRY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_ENQUIRY,
    event: 'reactjs.event',
    eventID: 'FED-GITF-007',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "ENQUIRY"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_REGISTRATION_OR_VIN,
    event: 'reactjs.event',
    eventID: 'FED-GITF-008',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "REGISTRATION OR VIN"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_ADDRESS] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_ADDRESS,
    event: 'reactjs.event',
    eventID: 'FED-GITF-009',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "ADDRESS"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? '' : _ref3$model;
  return {
    type: gtmEventTypes.CONTACT_US_SELECT_POSTCODE_SUBURB,
    event: 'reactjs.event',
    eventID: 'FED-GITF-010',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Selected "POSTCODE/SUBURB" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_OLD_VIN_REGO,
    event: 'reactjs.event',
    eventID: 'FED-GITF-011',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "OLDVINREGO"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_ENTER_CURRENT_VIN_REGO,
    event: 'reactjs.event',
    eventID: 'FED-GITF-012',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Entered "CURRENTVINREGO"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-GITF-013',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Checked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-GITF-014',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Clicked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_SUBMIT] = function (_ref4) {
  var _ref4$model = _ref4.model,
      model = _ref4$model === undefined ? '' : _ref4$model;
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: 'FED-GITF-015',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Clicked "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CONTACT_US_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.CONTACT_US_CLICK_GO_BACK,
    event: 'reactjs.event',
    eventID: 'FED-GITF-016',
    pageCategory: 'Get In Touch Form',
    pageAction: 'Get In Touch Form - Clicked "GO BACK"'
  };
}, _gtmEvents);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
var gtmEventTypes = {
  BOOK_SERVICE_ENTER_MODEL: 'BOOK_SERVICE_RASF_ENTER_MODEL',
  BOOK_SERVICE_ENTER_VIN_REGO: 'BOOK_SERVICE_RASF_ENTER_VIN_REGO',
  BOOK_SERVICE_ENTER_ODOMETER: 'BOOK_SERVICE_RASF_ENTER_ODOMETER',
  BOOK_SERVICE_SELECT_TITLE: 'BOOK_SERVICE_RASF_SELECT_TITLE',
  BOOK_SERVICE_ENTER_FIRSTNAME: 'BOOK_SERVICE_RASF_ENTER_FIRSTNAME',
  BOOK_SERVICE_ENTER_LASTNAME: 'BOOK_SERVICE_RASF_ENTER_LASTNAME',
  BOOK_SERVICE_ENTER_PHONE: 'BOOK_SERVICE_RASF_ENTER_PHONE',
  BOOK_SERVICE_ENTER_EMAIL: 'BOOK_SERVICE_RASF_ENTER_EMAIL',
  BOOK_SERVICE_SELECT_POSTCODE_SUBURB: 'BOOK_SERVICE_RASF_SELECT_POSTCODE_SUBURB',
  BOOK_SERVICE_DEALER_CLICK_ADDRESS: 'BOOK_SERVICE_RASF_DEALER_CLICK_ADDRESS',
  BOOK_SERVICE_DEALER_CLICK_WEBSITE: 'BOOK_SERVICE_RASF_DEALER_CLICK_WEBSITE',
  BOOK_SERVICE_DEALER_CLICK_PHONE: 'BOOK_SERVICE_RASF_DEALER_CLICK_PHONE',
  BOOK_SERVICE_ENTER_DATE_INPUT: 'BOOK_SERVICE_RASF_ENTER_DATE_INPUT',
  BOOK_SERVICE_SELECT_DROP_OFF_TIME: 'BOOK_SERVICE_RASF_SELECT_DROP_OFF_TIME',
  BOOK_SERVICE_SELECT_PICK_UP_TIME: 'BOOK_SERVICE_RASF_SELECT_PICK_UP_TIME',
  BOOK_SERVICE_ENTER_ENQUIRY: 'BOOK_SERVICE_RASF_ENTER_ENQUIRY',
  BOOK_SERVICE_CHECK_PRIVACY_POLICY: 'BOOK_SERVICE_RASF_CHECK_PRIVACY_POLICY',
  BOOK_SERVICE_CLICK_PRIVACY_POLICY: 'BOOK_SERVICE_RASF_CLICK_PRIVACY_POLICY',
  BOOK_SERVICE_CLICK_SUBMIT: 'BOOK_SERVICE_RASF_CLICK_SUBMIT',
  BOOK_SERVICE_CLICK_GO_BACK: 'BOOK_SERVICE_RASF_CLICK_GO_BACK',
  BOOK_SERVICE_CLICK_EDIT_SERVICE: 'BOOK_SERVICE_RASF_CLICK_EDIT_SERVICE' // Service summary section


  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_MODEL] = function (_ref) {
  var _ref$model = _ref.model,
      model = _ref$model === undefined ? '' : _ref$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_MODEL,
    event: 'reactjs.event',
    eventID: 'FED-RASF-001',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO,
    event: 'reactjs.event',
    eventID: 'FED-RASF-002',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "VINREGO"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER,
    event: 'reactjs.event',
    eventID: 'FED-RASF-003',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "ODOMETER"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_TITLE] = function (_ref2) {
  var _ref2$model = _ref2.model,
      model = _ref2$model === undefined ? '' : _ref2$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_TITLE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-004',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "TITLE" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-005',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "FIRSTNAME"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-006',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "LASTNAME"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-007',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "PHONE"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: 'FED-RASF-008',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "EMAIL"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB] = function (_ref3) {
  var _ref3$model = _ref3.model,
      model = _ref3$model === undefined ? '' : _ref3$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB,
    event: 'reactjs.event',
    eventID: 'FED-RASF-009',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Selected "POSTCODE/SUBURB" - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      address = _ref4.address;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: 'FED-RASF-010',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - ' + dealerName + ' - Address "' + address + '" - Clicked "ADDRESS"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      address = _ref5.address,
      website = _ref5.website;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-011',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - ' + dealerName + ' - Address "' + address + '" - Clicked "WEBSITE ' + website + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      address = _ref6.address,
      phone = _ref6.phone;
  return {
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-012',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - ' + dealerName + ' - Address ' + address + ' - Clicked "PHONE ' + phone + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT,
    event: 'reactjs.event',
    eventID: 'FED-RASF-013',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "_DATE_INPUT"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME] = function (_ref7) {
  var _ref7$model = _ref7.model,
      model = _ref7$model === undefined ? '' : _ref7$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-014',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Submitted Preferred Drop Off Time - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME] = function (_ref8) {
  var _ref8$model = _ref8.model,
      model = _ref8$model === undefined ? '' : _ref8$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-015',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Submitted Preferred Pick Up Time - "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-016',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "ENQUIRY"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-017',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Checked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-018',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT] = function (_ref9) {
  var _ref9$model = _ref9.model,
      model = _ref9$model === undefined ? '' : _ref9$model;
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: 'FED-RASF-019',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "' + model.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK,
    event: 'reactjs.event',
    eventID: 'FED-RASF-020',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "GO BACK"'
  };
}, _gtmEvents[gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE] = function () {
  return {
    type: gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-021',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "EDIT SERVICE"'
  };
}, _gtmEvents);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
var _gtmEvents;

// Event types
var gtmEventTypes = {
  PCPU_ENTER_POSTCODE: 'PCPU_ENTER_POSTCODE'

  // Event creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.PCPU_ENTER_POSTCODE] = function (_ref) {
  var postcode = _ref.postcode;
  return {
    type: gtmEventTypes.PCPU_ENTER_POSTCODE,
    event: 'reactjs.event',
    eventID: 'FED-PCPU-001',
    pageCategory: 'Postcode Pop-up',
    pageAction: 'Postcode Pop-up - Entered "' + postcode + '"'
  };
}, _gtmEvents);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  NO_STOCK_FOR_MODEL: 'NOT-IMPLEMENTED',
  ENTER_LOCATION: 'FED-OL-001',
  SELECT_DEALER_NAME: 'FED-OL-002',
  CLICK_ADDRESS: 'FED-OL-003',
  CLICK_WEBSITE: 'FED-OL-004',
  CLICK_PHONE: 'FED-OL-005',
  EDIT_DEALER: 'FED-OL-006',
  CONFIRM_DEALER: 'FED-OL-007',
  SELECT_NAMEPLATE: 'FED-OL-008',
  CLICK_NO_STOCK_CHANGE: 'FED-OL-009',
  CLICK_NO_STOCK_BUILD: 'FED-OL-010',
  SELECT_STOCK_TILE: 'FED-OL-011',
  CLEARANCE_UNCHECKED: 'FED-OL-012',
  DEMO_UNCHECKED: 'FED-OL-013',
  CLEARANCE_CHECKED: 'FED-OL-014',
  DEMO_CHECKED: 'FED-OL-015',
  EDIT_MODEL: 'FED-OL-016',
  CLICK_INFO: 'FED-OL-017',
  CLICK_SORT_OPTION: 'FED-OL-018',
  CLICK_PRICE_DISCLAIMER: 'FED-OL-019',
  SLIDESHOW_INTERACTION_DETAIL: 'FED-OL-020',
  CLICK_PRICE_DISCLAIMER_DETAIL: 'FED-OL-021',
  EXPAND_ACCORDION_DETAIL: 'FED-OL-022',
  COLLAPSE_ACCORDION_DETAIL: 'FED-OL-023',
  CLICK_FULL_SPECS_DETAIL: 'FED-OL-024',
  CLICK_BACK_DETAIL: 'FED-OL-025',
  CLICK_NEXT_DETAIL: 'FED-OL-026'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.NO_STOCK_FOR_MODEL] = function (_ref) {
  var dealerName = _ref.dealerName,
      nameplate = _ref.nameplate,
      buttonText = _ref.buttonText;
  return {
    type: gtmEventTypes.NO_STOCK_FOR_MODEL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.NO_STOCK_FOR_MODEL,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Model - No Stock Available - ' + dealerName.toUpperCase() + ' - ' + nameplate.toUpperCase() + ' - Clicked - "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref2) {
  var location = _ref2.location;
  return {
    type: gtmEventTypes.ENTER_LOCATION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - Entered "' + location.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref3) {
  var dealerName = _ref3.dealerName;
  return {
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - Selected "' + dealerName + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      address = _ref4.address;
  return {
    type: gtmEventTypes.CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - ' + dealerName + ' - Clicked "ADDRESS ' + address.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      website = _ref5.website;
  return {
    type: gtmEventTypes.CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - ' + dealerName + ' - Clicked "WEBSITE ' + website.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      phone = _ref6.phone;
  return {
    type: gtmEventTypes.CLICK_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - ' + dealerName + ' - Clicked "PHONE ' + phone + '"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref7) {
  var location = _ref7.location;
  return {
    type: gtmEventTypes.ENTER_LOCATION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - Entered "' + location.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.EDIT_DEALER] = function (_ref8) {
  var buttonText = _ref8.buttonText,
      dealerName = _ref8.dealerName;
  return {
    type: gtmEventTypes.EDIT_DEALER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EDIT_DEALER,
    pageCategory: 'Outlet Store',
    pageAction: 'Footer Nav - Clicked "' + buttonText.toUpperCase() + '" - "' + dealerName.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CONFIRM_DEALER] = function (_ref9) {
  var buttonText = _ref9.buttonText,
      dealerAddress = _ref9.dealerAddress;
  return {
    type: gtmEventTypes.CONFIRM_DEALER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CONFIRM_DEALER,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Dealer - Clicked "' + buttonText.toUpperCase() + '" - ' + dealerAddress.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.SELECT_NAMEPLATE] = function (_ref10) {
  var nameplate = _ref10.nameplate,
      dealerName = _ref10.dealerName;
  return {
    type: gtmEventTypes.SELECT_NAMEPLATE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_NAMEPLATE,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Model - Selected "' + nameplate.toUpperCase() + '" - "' + dealerName.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_NO_STOCK_CHANGE] = function (_ref11) {
  var buttonText = _ref11.buttonText,
      dealerName = _ref11.dealerName;
  return {
    type: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Model - No Stock Available - ' + dealerName.toUpperCase() + ' - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_NO_STOCK_BUILD] = function (_ref12) {
  var buttonText = _ref12.buttonText,
      nameplate = _ref12.nameplate,
      dealerName = _ref12.dealerName;
  return {
    type: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    pageCategory: 'Outlet Store',
    pageAction: 'Select Your Model - No Stock Available - ' + dealerName.toUpperCase() + ' - ' + nameplate.toUpperCase() + ' - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.SELECT_STOCK_TILE] = function (_ref13) {
  var storeTypeCategory = _ref13.storeTypeCategory,
      nameplate = _ref13.nameplate,
      bodyStyle = _ref13.bodyStyle,
      grade = _ref13.grade,
      engineSize = _ref13.engineSize,
      transmissionType = _ref13.transmissionType,
      fuelType = _ref13.fuelType,
      fittedAccessories = _ref13.fittedAccessories,
      price = _ref13.price,
      odometer = _ref13.odometer,
      generation = _ref13.generation,
      interiorTitle = _ref13.interiorTitle,
      dealerName = _ref13.dealerName;
  return {
    type: gtmEventTypes.SELECT_STOCK_TILE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_STOCK_TILE,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Selected "' + storeTypeCategory.toUpperCase() + '" - ' + [nameplate, bodyStyle, grade, engineSize, transmissionType, fuelType, fittedAccessories, '$' + price.toLocaleString('au'), odometer, generation, interiorTitle].map(function (string) {
      return '"' + String(string).toUpperCase() + '"';
    }).join(',') + ' - "' + dealerName.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLEARANCE_UNCHECKED] = function (_ref14) {
  var label = _ref14.label;
  return {
    type: gtmEventTypes.CLEARANCE_UNCHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLEARANCE_UNCHECKED,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Unchecked "' + label.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.DEMO_UNCHECKED] = function (_ref15) {
  var label = _ref15.label;
  return {
    type: gtmEventTypes.DEMO_UNCHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.DEMO_UNCHECKED,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Unchecked "' + label.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLEARANCE_CHECKED] = function (_ref16) {
  var label = _ref16.label;
  return {
    type: gtmEventTypes.CLEARANCE_CHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLEARANCE_CHECKED,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Checked "' + label.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.DEMO_CHECKED] = function (_ref17) {
  var label = _ref17.label;
  return {
    type: gtmEventTypes.DEMO_CHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.DEMO_CHECKED,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Checked "' + label.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.EDIT_MODEL] = function (_ref18) {
  var buttonText = _ref18.buttonText,
      nameplate = _ref18.nameplate;
  return {
    type: gtmEventTypes.EDIT_MODEL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EDIT_MODEL,
    pageCategory: 'Outlet Store',
    pageAction: 'Footer Nav - Clicked "' + buttonText.toUpperCase() + '" - "' + nameplate.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_INFO] = function (_ref19) {
  var buttonText = _ref19.buttonText;
  return {
    type: gtmEventTypes.CLICK_INFO,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_INFO,
    pageCategory: 'Outlet Store',
    pageAction: 'Footer Nav - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_SORT_OPTION] = function (_ref20) {
  var label = _ref20.label;
  return {
    type: gtmEventTypes.CLICK_SORT_OPTION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SORT_OPTION,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - Sort Results Dropdown - Selected "' + label.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRICE_DISCLAIMER] = function (_ref21) {
  var nameplate = _ref21.nameplate,
      storeTypeCategory = _ref21.storeTypeCategory,
      grade = _ref21.grade;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    pageCategory: 'Outlet Store',
    pageAction: 'Search Result - "' + nameplate.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '" "' + grade.toUpperCase() + '" - Clicked "PRICE DISCLAIMER"'
  };
}, _gtmEvents[gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL] = function (_ref22) {
  var nameplate = _ref22.nameplate,
      bodyStyle = _ref22.bodyStyle,
      storeTypeCategory = _ref22.storeTypeCategory,
      grade = _ref22.grade,
      imageLabel = _ref22.imageLabel;
  return {
    type: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Engaged Carousel "' + imageLabel.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL] = function (_ref23) {
  var nameplate = _ref23.nameplate,
      bodyStyle = _ref23.bodyStyle,
      storeTypeCategory = _ref23.storeTypeCategory,
      grade = _ref23.grade;
  return {
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Clicked "PRICE DISCLAIMER"'
  };
}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION_DETAIL] = function (_ref24) {
  var nameplate = _ref24.nameplate,
      bodyStyle = _ref24.bodyStyle,
      storeTypeCategory = _ref24.storeTypeCategory,
      grade = _ref24.grade,
      sectionTitle = _ref24.sectionTitle;
  return {
    type: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Expanded "' + sectionTitle.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION_DETAIL] = function (_ref25) {
  var nameplate = _ref25.nameplate,
      bodyStyle = _ref25.bodyStyle,
      storeTypeCategory = _ref25.storeTypeCategory,
      grade = _ref25.grade,
      sectionTitle = _ref25.sectionTitle;
  return {
    type: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Collapsed "' + sectionTitle.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_FULL_SPECS_DETAIL] = function (_ref26) {
  var nameplate = _ref26.nameplate,
      bodyStyle = _ref26.bodyStyle,
      storeTypeCategory = _ref26.storeTypeCategory,
      grade = _ref26.grade,
      buttonText = _ref26.buttonText;
  return {
    type: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '" "' + storeTypeCategory.toUpperCase() + '", "' + grade.toUpperCase() + '" - Clicked ' + buttonText.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.CLICK_BACK_DETAIL] = function (_ref27) {
  var buttonText = _ref27.buttonText;
  return {
    type: gtmEventTypes.CLICK_BACK_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_BACK_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - Footer Nav - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_NEXT_DETAIL] = function (_ref28) {
  var nameplate = _ref28.nameplate,
      bodyStyle = _ref28.bodyStyle,
      storeTypeCategory = _ref28.storeTypeCategory,
      grade = _ref28.grade,
      hasAccessories = _ref28.hasAccessories,
      fittedAccessories = _ref28.fittedAccessories,
      dealerName = _ref28.dealerName,
      buttonText = _ref28.buttonText;
  return {
    type: gtmEventTypes.CLICK_NEXT_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NEXT_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Vehicle Details Page - Footer Nav - Clicked "' + buttonText.toUpperCase() + '" - "' + storeTypeCategory.toUpperCase() + '", "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + grade.toUpperCase() + '", ACCESSORIES "' + hasAccessories.toUpperCase() + '", "' + fittedAccessories.toUpperCase() + '" - ' + dealerName.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// GTM event driven by the CMS
var gtmEventTypes = {
  BADGE_CLICK: 'CMS-GLH-001',
  CLICK_ICON: 'CMS-GLH-002',
  NAV_LINK_CLICK: 'CMS-GLH-003',
  NAV_LINK_SECONDARY_CLICK: 'CMS-GLH-004',
  HAMBURGER_EXPAND: 'CMS-GLH-005',
  HAMBURGER_COLLAPSE: 'CMS-GLH-006',
  OVERLAY_CLOSED: 'CMS-GLH-007',
  CLOSED_MORE: 'CMS-GLH-008'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BADGE_CLICK] = function () {
  return {
    type: gtmEventTypes.BADGE_CLICK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BADGE_CLICK,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Clicked home badge'
  };
}, _gtmEvents[gtmEventTypes.CLICK_ICON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      itemName = _ref.itemName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_ICON,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + itemName.toUpperCase() + '"'
  });
}, _gtmEvents[gtmEventTypes.NAV_LINK_CLICK] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.NAV_LINK_CLICK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.NAV_LINK_SECONDARY_CLICK] = function (_ref3) {
  var CMSGroupGTM = _ref3.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.NAV_LINK_SECONDARY_CLICK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.HAMBURGER_EXPAND] = function () {
  return {
    type: gtmEventTypes.HAMBURGER_EXPAND,
    event: 'reactjs.event',
    eventID: gtmEventTypes.HAMBURGER_EXPAND,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Expanded hamburger menu'
  };
}, _gtmEvents[gtmEventTypes.HAMBURGER_COLLAPSE] = function () {
  return {
    type: gtmEventTypes.HAMBURGER_COLLAPSE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.HAMBURGER_COLLAPSE,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Collapsed hamburger menu'
  };
}, _gtmEvents[gtmEventTypes.OVERLAY_CLOSED] = function (_ref4) {
  var CMSGroupGTM = _ref4.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.OVERLAY_CLOSED,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents[gtmEventTypes.CLOSED_MORE] = function () {
  return {
    type: gtmEventTypes.CLOSED_MORE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLOSED_MORE,
    pageCategory: 'Header Nav',
    pageAction: 'Nav  - Closed "MORE"'
  };
}, _gtmEvents);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Action types
var gtmEventTypes = {
  SOCIAL_ICON_CLICK: 'FED-GLF-001',
  CLICKED_EDIT_POSTCODE: 'FED-GLF-002',
  CLICKED_FOOTER_LINK: 'CMS-GLF-003'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SOCIAL_ICON_CLICK] = function (_ref) {
  var platform = _ref.platform;
  return {
    type: gtmEventTypes.SOCIAL_ICON_CLICK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SOCIAL_ICON_CLICK,
    pageCategory: 'Footer Nav',
    pageAction: 'Footer - Clicked "' + platform.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICKED_EDIT_POSTCODE] = function () {
  return {
    type: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    pageCategory: 'Footer Nav',
    pageAction: 'Footer - Selected Change Postcode'
  };
}, _gtmEvents[gtmEventTypes.CLICKED_FOOTER_LINK] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICKED_FOOTER_LINK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  SELECT_TITLE: 'FED-OL-ENQ-001',
  ENTER_FIRSTNAME: 'FED-OL-ENQ-002',
  ENTER_LASTNAME: 'FED-OL-ENQ-003',
  ENTER_PHONE: 'FED-OL-ENQ-004',
  ENTER_EMAIL: 'FED-OL-ENQ-005',
  ENTER_COMMENTS: 'FED-OL-ENQ-006',
  CHECK_OPTIN: 'FED-OL-ENQ-007',
  CHECK_PRIVACY_POLICY: 'FED-OL-ENQ-008',
  CLICK_PRIVACY_POLICY: 'FED-OL-ENQ-009',
  CLICK_SUBMIT: 'FED-OL-ENQ-010',
  CLICK_SUBMIT_WITH_DATA: 'FED-OL-ENQ-011',
  CLICK_BACK: 'FED-OL-ENQ-012'

  // Action creators
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SELECT_TITLE] = function (_ref) {
  var selection = _ref.selection;
  return {
    type: gtmEventTypes.SELECT_TITLE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_TITLE,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Selected "TITLE" - "' + selection.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_FIRSTNAME] = function () {
  return {
    type: gtmEventTypes.ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_FIRSTNAME,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "FIRSTNAME"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_LASTNAME] = function () {
  return {
    type: gtmEventTypes.ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LASTNAME,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "LASTNAME"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_PHONE] = function () {
  return {
    type: gtmEventTypes.ENTER_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_PHONE,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "PHONE"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_EMAIL] = function () {
  return {
    type: gtmEventTypes.ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "EMAIL"'
  };
}, _gtmEvents[gtmEventTypes.ENTER_COMMENTS] = function () {
  return {
    type: gtmEventTypes.ENTER_COMMENTS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_COMMENTS,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "COMMENTS"'
  };
}, _gtmEvents[gtmEventTypes.CHECK_OPTIN] = function () {
  return {
    type: gtmEventTypes.CHECK_OPTIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CHECK_OPTIN,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Form - Checked "OPTIN"'
  };
}, _gtmEvents[gtmEventTypes.CHECK_PRIVACY_POLICY] = function () {
  return {
    type: gtmEventTypes.CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CHECK_PRIVACY_POLICY,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Form - Checked "PRIVACYPOLICY"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_PRIVACY_POLICY] = function (_ref2) {
  var buttonText = _ref2.buttonText;
  return {
    type: gtmEventTypes.CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRIVACY_POLICY,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Clicked ' + buttonText.toUpperCase()
  };
}, _gtmEvents[gtmEventTypes.CLICK_SUBMIT] = function (_ref3) {
  var buttonText = _ref3.buttonText;
  return {
    type: gtmEventTypes.CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUBMIT,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_SUBMIT_WITH_DATA] = function (_ref4) {
  var nameplate = _ref4.nameplate,
      bodyStyle = _ref4.bodyStyle,
      storeTypeCategory = _ref4.storeTypeCategory,
      grade = _ref4.grade,
      hasAccessories = _ref4.hasAccessories,
      fittedAccessories = _ref4.fittedAccessories,
      dealerName = _ref4.dealerName;
  return {
    type: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Clicked Submitted - "' + storeTypeCategory.toUpperCase() + '", "' + nameplate.toUpperCase() + ' ' + bodyStyle.toUpperCase() + '", "' + grade.toUpperCase() + '", ACCESSORIES "' + hasAccessories.toUpperCase() + '", "' + fittedAccessories.toUpperCase() + '" - ' + dealerName.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_BACK] = function (_ref5) {
  var buttonText = _ref5.buttonText;
  return {
    type: gtmEventTypes.CLICK_BACK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_BACK,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Form - Clicked - Clicked "' + buttonText.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  ENTER_LOCATION: 'FED-FAD-001',
  event: 'reactjs.event',
  CLICK_CTA: 'FED-FAD-008',
  CHECK_DEALERTYPE: 'FED-FAD-CHECK_DEALERTYPE',
  CLICK_ADDRESS: 'FED-FAD-009',
  CLICK_PHONE: 'FED-FAD-010',
  CLICK_WEBSITE: 'FED-FAD-011',
  SELECT_DEALER_NAME: 'FED-FAD-012',
  SELECT_DEALER_DEPARTMENT: 'FED-FAD-013'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.ENTER_LOCATION] = function (_ref) {
  var location = _ref.location;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - Entered "' + location.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CHECK_DEALERTYPE] = function (_ref2) {
  var dealerType = _ref2.dealerType,
      eventID = _ref2.eventID;
  return {
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - Checked "' + dealerType.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref3) {
  var dealerName = _ref3.dealerName,
      ctaName = _ref3.ctaName,
      departments = _ref3.departments,
      address = _ref3.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - ' + dealerName + ' - Clicked "CTA BUTTON ' + ctaName.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      departments = _ref4.departments,
      address = _ref4.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - ' + dealerName + ' - Clicked "ADDRESS ' + address.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      phone = _ref5.phone,
      departments = _ref5.departments,
      address = _ref5.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - ' + dealerName + ' - Clicked "PHONE ' + phone + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      website = _ref6.website,
      departments = _ref6.departments,
      address = _ref6.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - ' + dealerName + ' - Clicked "WEBSITE ' + website.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      department = _ref7.department,
      address = _ref7.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - Selected "' + dealerName + '" - ' + department.toUpperCase() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_DEPARTMENT] = function (_ref8) {
  var dealerName = _ref8.dealerName,
      department = _ref8.department,
      address = _ref8.address;
  return {
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: 'Find a Dealer',
    pageAction: 'Find a Dealer - ' + dealerName + ' - Clicked "DEPARTMENT MENU - ' + department.toUpperCase() + '" - ' + address
  };
}, _gtmEvents);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  SELECT_FILTER_OPTION: 'FED-MCB-001',
  CLICK_ADDRESS: 'FED-MCB-002',
  CLICK_PHONE: 'FED-MCB-003',
  CLICK_WEBSITE: 'FED-MCB-004',
  SELECT_DEALER_NAME: 'FED-MCB-005',
  SELECT_DEALER_DEPARTMENT: 'FED-MCB-006',
  CLICK_CTA: 'FED-MCB-007'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SELECT_FILTER_OPTION] = function (_ref) {
  var option = _ref.option;
  return {
    type: gtmEventTypes.SELECT_FILTER_OPTION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_FILTER_OPTION,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - Selected "' + option.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_ADDRESS] = function (_ref2) {
  var dealerName = _ref2.dealerName,
      departments = _ref2.departments,
      address = _ref2.address;
  return {
    type: gtmEventTypes.CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - ' + dealerName + ' - Clicked "ADDRESS ' + address.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_PHONE] = function (_ref3) {
  var dealerName = _ref3.dealerName,
      phone = _ref3.phone,
      departments = _ref3.departments,
      address = _ref3.address;
  return {
    type: gtmEventTypes.CLICK_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - ' + dealerName + ' - Clicked "PHONE ' + phone + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_WEBSITE] = function (_ref4) {
  var dealerName = _ref4.dealerName,
      website = _ref4.website,
      departments = _ref4.departments,
      address = _ref4.address;
  return {
    type: gtmEventTypes.CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - ' + dealerName + ' - Clicked "WEBSITE ' + website.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_NAME] = function (_ref5) {
  var dealerName = _ref5.dealerName,
      department = _ref5.department,
      address = _ref5.address;
  return {
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - Selected "' + dealerName + '" - ' + department.toUpperCase() + ' - ' + address
  };
}, _gtmEvents[gtmEventTypes.SELECT_DEALER_DEPARTMENT] = function (_ref6) {
  var dealerName = _ref6.dealerName,
      department = _ref6.department,
      address = _ref6.address;
  return {
    type: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - ' + dealerName + ' - Clicked "DEPARTMENT MENU - ' + department.toUpperCase() + '" - ' + address
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref7) {
  var dealerName = _ref7.dealerName,
      ctaName = _ref7.ctaName,
      departments = _ref7.departments,
      address = _ref7.address;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Dealer Map Block',
    pageAction: 'Dealer Map Block - ' + dealerName + ' - Clicked "CTA BUTTON ' + ctaName.toUpperCase() + '" - ' + departments.toString() + ' - ' + address
  };
}, _gtmEvents);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  CLICK_SUB_NAV_LINK: 'FED-OFFERS-001',
  EXPAND_ACCORDION: 'FED-OFFERS-002',
  COLLAPSE_ACCORDION: 'FED-OFFERS-003',
  CLICK_CTA: 'FED-OFFERS-004',
  CLICK_RECOMMENDED_CONTENT: 'FED-OFFERS_005'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_LINK] = function (_ref) {
  var itemName = _ref.itemName;
  return {
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUB_NAV_LINK,
    pageCategory: 'Offers',
    pageAction: 'Offers - Sub Nav - Clicked "' + itemName.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION] = function (_ref2) {
  var modelName = _ref2.modelName,
      bodyGradeTitle = _ref2.bodyGradeTitle,
      offerPrice = _ref2.offerPrice,
      expandedText = _ref2.expandedText;
  return {
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EXPAND_ACCORDION,
    pageCategory: 'Offers',
    pageAction: 'Offers - "' + modelName.toUpperCase() + '/' + bodyGradeTitle.toUpperCase() + '/' + offerPrice + '" - "' + expandedText + '"'
  };
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION] = function (_ref3) {
  var modelName = _ref3.modelName,
      bodyGradeTitle = _ref3.bodyGradeTitle,
      offerPrice = _ref3.offerPrice,
      collapsedText = _ref3.collapsedText;
  return {
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.COLLAPSE_ACCORDION,
    pageCategory: 'Offers',
    pageAction: 'Offers - "' + modelName.toUpperCase() + '/' + bodyGradeTitle.toUpperCase() + '/' + offerPrice + '" - "' + collapsedText + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref4) {
  var modelName = _ref4.modelName,
      bodyGradeTitle = _ref4.bodyGradeTitle,
      offerPrice = _ref4.offerPrice,
      ctaLabel = _ref4.ctaLabel;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Offers',
    pageAction: 'Offers - "' + modelName.toUpperCase() + '/' + bodyGradeTitle.toUpperCase() + '/' + offerPrice + '" - Clicked CTA - "' + ctaLabel.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_RECOMMENDED_CONTENT] = function (_ref5) {
  var sectionTitle = _ref5.sectionTitle,
      tileTitle = _ref5.tileTitle,
      tileLabel = _ref5.tileLabel;
  return {
    type: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_RECOMMENDED_CONTENT,
    pageCategory: 'Offers',
    pageAction: 'Offers - "' + sectionTitle.toUpperCase() + '" - Clicked "' + tileTitle.toUpperCase() + '" - "' + tileLabel.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  SUBMIT_LOGIN: 'FED-MYMAZDA-001',
  FAIL_LOGIN: 'FED-MYMAZDA-002'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.SUBMIT_LOGIN] = function (_ref) {
  var isVin = _ref.isVin;
  return {
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: 'MyMazda',
    pageAction: 'MyMazda Login - Enter VIN/Rego - Submitted "' + (isVin ? 'VIN' : 'REGO') + '"'
  };
}, _gtmEvents[gtmEventTypes.FAIL_LOGIN] = function (_ref2) {
  var isVin = _ref2.isVin;
  return {
    type: gtmEventTypes.FAIL_LOGIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.FAIL_LOGIN,
    pageCategory: 'MyMazda',
    pageAction: 'MyMazda Login - Enter VIN/Rego - Failed Login "' + (isVin ? 'VIN' : 'REGO') + '"'
  };
}, _gtmEvents);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  CHECK_VIN: 'FED-RECALLS-001',
  CLICK_CTA: 'FED-RECALLS-002'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CHECK_VIN] = function (_ref) {
  var result = _ref.result;
  return {
    type: gtmEventTypes.CHECK_VIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CHECK_VIN,
    pageCategory: 'Recalls',
    pageAction: 'Recalls - Enter VIN - Recall Status "' + result.toUpperCase() + '"'
  };
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref2) {
  var ctaName = _ref2.ctaName,
      result = _ref2.result;
  return {
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Recalls',
    pageAction: 'Recalls - Recall Status "' + result + '" - Clicked "' + ctaName.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  CLICK_SPECS_CTA: 'FED-MYMAZDA-003'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SPECS_CTA] = function (_ref) {
  var ctaName = _ref.ctaName;
  return {
    type: gtmEventTypes.CLICK_SPECS_CTA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SPECS_CTA,
    pageCategory: 'MyMazda',
    pageAction: 'MyMazda Home - Specifications - Clicked "' + ctaName.toUpperCase() + '"'
  };
}, _gtmEvents);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var gtmEventTypes = {
  CLICK_PLAY_WATCH_VIDEO: 'YB_CLICK_PLAY_WATCH_VIDEO'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_PLAY_WATCH_VIDEO] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      isPlay = _ref.isPlay,
      videoName = _ref.videoName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_PLAY_WATCH_VIDEO,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked ' + (isPlay ? 'PLAY' : 'WATCH VIDEO') + ' "' + videoName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// This is GTM events for Accordion block in the CMS

var gtmEventTypes = {
  EXPAND_ACCORDION: 'CMS-ACCORDION-001',
  COLLAPSE_ACCORDION: 'CMS-ACCORDION-002'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.EXPAND_ACCORDION] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      accordionName = _ref.accordionName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Expanded "' + accordionName.toUpperCase() + '"'
  });
}, _gtmEvents[gtmEventTypes.COLLAPSE_ACCORDION] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      accordionName = _ref2.accordionName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Collapsed "' + accordionName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var gtmEventTypes = {
  CLICK_BUTTON: 'ACCESSORY_LIST_CLICK_BUTTON'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_BUTTON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      ctaName = _ref.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_BUTTON,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + ctaName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var gtmEventTypes = {
  CLICK_SUB_NAV_LINK: 'FED-IPN-001',
  CLICK_SUB_NAV_BUTTON: 'FED-IPN-002'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      itemName = _ref.itemName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: 'reactjs.event',
    pageAction: 'Clicked Sub Nav Link - "' + itemName.toUpperCase() + '"'
  });
}, _gtmEvents[gtmEventTypes.CLICK_SUB_NAV_BUTTON] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      ctaName = _ref2.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_SUB_NAV_BUTTON,
    event: 'reactjs.event',
    pageAction: 'Clicked Sub Nav Button - "' + ctaName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// CMS GTM event for color picker
var gtmEventTypes = {
  CLICK_COLOR: 'CMS-MINICONFIGURATOR-001',
  CLICK_CTA: 'CMS-MINICONFIGURATOR-002'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_COLOR] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      color = _ref.color;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_COLOR,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + color.toUpperCase() + '"'
  });
}, _gtmEvents[gtmEventTypes.CLICK_CTA] = function (_ref2) {
  var CMSGroupGTM = _ref2.CMSGroupGTM,
      ctaLabel = _ref2.ctaLabel;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + ctaLabel.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// CMS GTM for button
var gtmEventTypes = {
  CLICK_BUTTON: 'CMS-BUTTON-001'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_BUTTON] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      buttonName = _ref.buttonName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_BUTTON,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + buttonName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// CMS GTM for Backgroun Image Selector
var gtmEventTypes = {
  CLICK_IMAGE: 'CMS-BACKGROUNDIMAGESELECTOR-001'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_IMAGE] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      imageName = _ref.imageName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_IMAGE,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action + ' - Clicked "' + imageName.toUpperCase() + '"'
  });
}, _gtmEvents);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// CMS GTM for Icon Tout Block
var gtmEventTypes = {
  CLICK_LINK: 'CMS-ICONTOUTBLOCK-001'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_LINK] = function (_ref) {
  var CMSGroupGTM = _ref.CMSGroupGTM,
      _ref$blockTitle = _ref.blockTitle,
      blockTitle = _ref$blockTitle === undefined ? '' : _ref$blockTitle,
      ctaName = _ref.ctaName;
  return _extends({}, CMSGroupGTM, {
    type: gtmEventTypes.CLICK_LINK,
    event: 'reactjs.event',
    pageAction: ctaName ? CMSGroupGTM.action + ' "' + (blockTitle && blockTitle.toUpperCase()) + '" - Clicked "' + ctaName.toUpperCase() + '"' : CMSGroupGTM.action
  });
}, _gtmEvents);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

var gtmEventTypes = {
  FED_BUILDTOOL_002: 'FED_BUILDTOOL_002',
  BUILDTOOL_LOAD_CONFIG: 'FED-BUILDTOOL-003',
  BUILDTOOL_STEP_BODY_CHANGE: 'FED-BUILDTOOL-004',
  BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-005',
  BUILDTOOL_CLICKED_SIDE_NAV: 'FED-BUILDTOOL-006',
  BUILDTOOL_STEP_DRIVE_CHANGE: 'FED-BUILDTOOL-007',
  BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON: 'FED-BUILDTOOL-008',
  BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-009',
  BUILDTOOL_STEP_GRADE_CHANGE: 'FED-BUILDTOOL-010',
  BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-011',
  BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON: 'FED-BUILDTOOL-012',
  BUILDTOOL_STEP_COLOR_CHANGE: 'FED-BUILDTOOL-013',
  BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR: 'FED-BUILDTOOL-014',
  BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR: 'FED-BUILDTOOL-015',
  BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS: 'FED-BUILDTOOL-016',
  BUILDTOOL_STEP_COLOR_CLICKED_NEXT: 'FED-BUILDTOOL-017',
  BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS: 'FED-BUILDTOOL-018',
  BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE: 'FED-BUILDTOOL-019',
  BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON: 'FED-BUILDTOOL-020',
  BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS: 'FED-BUILDTOOL-021',
  FED_BUILDTOOL_022: 'FED-BUILDTOOL-022',
  FED_BUILDTOOL_023: 'FED-BUILDTOOL-023',
  FED_BUILDTOOL_024: 'FED-BUILDTOOL-024',
  BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST: 'FED-BUILDTOOL-025',
  BUILDTOOL_CLICKED_PRICE_DISCLAIMER: 'FED-BUILDTOOL-026',
  BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER: 'FED-BUILDTOOL-027',
  BUILDTOOL_CLICKED_SAVE: 'FED-BUILDTOOL-028',
  BUILDTOOL_SEND_SAVE_FORM: 'FED-BUILDTOOL-029',
  BUILDTOOL_CLICKED_COPY_URL: 'FED-BUILDTOOL-030',
  BUILDTOOL_CLICKED_SHARE: 'FED-BUILDTOOL-031',
  BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT: 'FED-BUILDTOOL-032',
  BUILDTOOL_SEND_SHARE_FORM: 'FED-BUILDTOOL-033'

  // Action creators -> EventsMap
};var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.BUILDTOOL_LOAD_CONFIG] = function (_ref) {
  var _ref$modelName = _ref.modelName,
      modelName = _ref$modelName === undefined ? '' : _ref$modelName,
      _ref$stepNumber = _ref.stepNumber,
      stepNumber = _ref$stepNumber === undefined ? '' : _ref$stepNumber,
      _ref$stepName = _ref.stepName,
      stepName = _ref$stepName === undefined ? '' : _ref$stepName,
      _ref$bodyName = _ref.bodyName,
      bodyName = _ref$bodyName === undefined ? '' : _ref$bodyName,
      _ref$driveName = _ref.driveName,
      driveName = _ref$driveName === undefined ? '' : _ref$driveName,
      _ref$gradeName = _ref.gradeName,
      gradeName = _ref$gradeName === undefined ? '' : _ref$gradeName,
      _ref$colorName = _ref.colorName,
      colorName = _ref$colorName === undefined ? '' : _ref$colorName,
      _ref$interiorName = _ref.interiorName,
      interiorName = _ref$interiorName === undefined ? '' : _ref$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' ' + stepName + ' - "' + bodyName + '" - "' + driveName + '" - "' + gradeName + '" - "' + colorName + '" - "' + interiorName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV] = function (_ref2) {
  var _ref2$modelName = _ref2.modelName,
      modelName = _ref2$modelName === undefined ? '' : _ref2$modelName,
      _ref2$stepNumber = _ref2.stepNumber,
      stepNumber = _ref2$stepNumber === undefined ? '' : _ref2$stepNumber,
      _ref2$stepName = _ref2.stepName,
      stepName = _ref2$stepName === undefined ? '' : _ref2$stepName,
      _ref2$newStepName = _ref2.newStepName,
      newStepName = _ref2$newStepName === undefined ? '' : _ref2$newStepName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" Step ' + stepNumber + ' ' + stepName + ' - Clicked side step nav "' + newStepName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE] = function (_ref3) {
  var _ref3$modelName = _ref3.modelName,
      modelName = _ref3$modelName === undefined ? '' : _ref3$modelName,
      _ref3$stepNumber = _ref3.stepNumber,
      stepNumber = _ref3$stepNumber === undefined ? '' : _ref3$stepNumber,
      _ref3$bodyName = _ref3.bodyName,
      bodyName = _ref3$bodyName === undefined ? '' : _ref3$bodyName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" Step ' + stepNumber + ' BODY - Clicked "' + bodyName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON] = function (_ref4) {
  var _ref4$modelName = _ref4.modelName,
      modelName = _ref4$modelName === undefined ? '' : _ref4$modelName,
      _ref4$stepNumber = _ref4.stepNumber,
      stepNumber = _ref4$stepNumber === undefined ? '' : _ref4$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' BODY - Clicked "NEXT STEP"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE] = function (_ref5) {
  var _ref5$modelName = _ref5.modelName,
      modelName = _ref5$modelName === undefined ? '' : _ref5$modelName,
      _ref5$stepNumber = _ref5.stepNumber,
      stepNumber = _ref5$stepNumber === undefined ? '' : _ref5$stepNumber,
      _ref5$driveName = _ref5.driveName,
      driveName = _ref5$driveName === undefined ? '' : _ref5$driveName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' DRIVE - Clicked drive"' + driveName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON] = function (_ref6) {
  var _ref6$modelName = _ref6.modelName,
      modelName = _ref6$modelName === undefined ? '' : _ref6$modelName,
      _ref6$stepNumber = _ref6.stepNumber,
      stepNumber = _ref6$stepNumber === undefined ? '' : _ref6$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' DRIVE - Clicked "PREVIOUS"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON] = function (_ref7) {
  var _ref7$modelName = _ref7.modelName,
      modelName = _ref7$modelName === undefined ? '' : _ref7$modelName,
      _ref7$stepNumber = _ref7.stepNumber,
      stepNumber = _ref7$stepNumber === undefined ? '' : _ref7$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' DRIVE - Clicked "NEXT STEP"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE] = function (_ref8) {
  var _ref8$modelName = _ref8.modelName,
      modelName = _ref8$modelName === undefined ? '' : _ref8$modelName,
      _ref8$stepNumber = _ref8.stepNumber,
      stepNumber = _ref8$stepNumber === undefined ? '' : _ref8$stepNumber,
      _ref8$gradeName = _ref8.gradeName,
      gradeName = _ref8$gradeName === undefined ? '' : _ref8$gradeName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' GRADE - Clicked grade "' + gradeName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON] = function (_ref9) {
  var _ref9$modelName = _ref9.modelName,
      modelName = _ref9$modelName === undefined ? '' : _ref9$modelName,
      _ref9$stepNumber = _ref9.stepNumber,
      stepNumber = _ref9$stepNumber === undefined ? '' : _ref9$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' GRADE - Clicked "NEXT STEP"\t"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON] = function (_ref10) {
  var _ref10$modelName = _ref10.modelName,
      modelName = _ref10$modelName === undefined ? '' : _ref10$modelName,
      _ref10$stepNumber = _ref10.stepNumber,
      stepNumber = _ref10$stepNumber === undefined ? '' : _ref10$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' GRADE - Clicked "PREVIOUS"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE] = function (_ref11) {
  var _ref11$modelName = _ref11.modelName,
      modelName = _ref11$modelName === undefined ? '' : _ref11$modelName,
      _ref11$stepNumber = _ref11.stepNumber,
      stepNumber = _ref11$stepNumber === undefined ? '' : _ref11$stepNumber,
      _ref11$colorName = _ref11.colorName,
      colorName = _ref11$colorName === undefined ? '' : _ref11$colorName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' COLOUR - Clicked "' + colorName + '"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR] = function (_ref12) {
  var _ref12$modelName = _ref12.modelName,
      modelName = _ref12$modelName === undefined ? '' : _ref12$modelName,
      _ref12$stepNumber = _ref12.stepNumber,
      stepNumber = _ref12$stepNumber === undefined ? '' : _ref12$stepNumber,
      _ref12$typeName = _ref12.typeName,
      typeName = _ref12$typeName === undefined ? '' : _ref12$typeName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' COLOUR - Clicked "' + typeName + '"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR] = function (_ref13) {
  var _ref13$modelName = _ref13.modelName,
      modelName = _ref13$modelName === undefined ? '' : _ref13$modelName,
      _ref13$stepNumber = _ref13.stepNumber,
      stepNumber = _ref13$stepNumber === undefined ? '' : _ref13$stepNumber,
      _ref13$interiorName = _ref13.interiorName,
      interiorName = _ref13$interiorName === undefined ? '' : _ref13$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' INTERIOR COLOUR - Clicked "' + interiorName + '"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS] = function (_ref14) {
  var _ref14$modelName = _ref14.modelName,
      modelName = _ref14$modelName === undefined ? '' : _ref14$modelName,
      _ref14$stepNumber = _ref14.stepNumber,
      stepNumber = _ref14$stepNumber === undefined ? '' : _ref14$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' COLOUR - Clicked "PREVIOUS"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT] = function (_ref15) {
  var _ref15$modelName = _ref15.modelName,
      modelName = _ref15$modelName === undefined ? '' : _ref15$modelName,
      _ref15$stepNumber = _ref15.stepNumber,
      stepNumber = _ref15$stepNumber === undefined ? '' : _ref15$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' COLOUR - Clicked "NEXT STEP"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS] = function (_ref16) {
  var _ref16$modelName = _ref16.modelName,
      modelName = _ref16$modelName === undefined ? '' : _ref16$modelName,
      _ref16$stepNumber = _ref16.stepNumber,
      stepNumber = _ref16$stepNumber === undefined ? '' : _ref16$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - Clicked "PREVIOUS"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE] = function (_ref17) {
  var _ref17$modelName = _ref17.modelName,
      modelName = _ref17$modelName === undefined ? '' : _ref17$modelName,
      _ref17$stepNumber = _ref17.stepNumber,
      stepNumber = _ref17$stepNumber === undefined ? '' : _ref17$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - Clicked "BOOK A TEST DRIVE"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON] = function (_ref18) {
  var _ref18$modelName = _ref18.modelName,
      modelName = _ref18$modelName === undefined ? '' : _ref18$modelName,
      _ref18$stepNumber = _ref18.stepNumber,
      stepNumber = _ref18$stepNumber === undefined ? '' : _ref18$stepNumber,
      newStepNumber = _ref18.newStepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - Clicked "EDIT SUMMARY ITEM STEP ' + newStepNumber + '"\t'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS] = function (_ref19) {
  var _ref19$modelName = _ref19.modelName,
      modelName = _ref19$modelName === undefined ? '' : _ref19$modelName,
      _ref19$stepNumber = _ref19.stepNumber,
      stepNumber = _ref19$stepNumber === undefined ? '' : _ref19$stepNumber,
      _ref19$newStatusName = _ref19.newStatusName,
      newStatusName = _ref19$newStatusName === undefined ? '' : _ref19$newStatusName;
  return {
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - ' + newStatusName
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER] = function (_ref20) {
  var _ref20$modelName = _ref20.modelName,
      modelName = _ref20$modelName === undefined ? '' : _ref20$modelName,
      _ref20$stepNumber = _ref20.stepNumber,
      stepNumber = _ref20$stepNumber === undefined ? '' : _ref20$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - Clicked "FEATURE SPECS DISCLAIMER"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST] = function (_ref21) {
  var _ref21$modelName = _ref21.modelName,
      modelName = _ref21$modelName === undefined ? '' : _ref21$modelName,
      _ref21$stepNumber = _ref21.stepNumber,
      stepNumber = _ref21$stepNumber === undefined ? '' : _ref21$stepNumber;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' SUMMARY - Clicked "EXPLORE FULL ' + modelName + ' SPECIFICATION"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER] = function (_ref22) {
  var _ref22$modelName = _ref22.modelName,
      modelName = _ref22$modelName === undefined ? '' : _ref22$modelName,
      _ref22$stepNumber = _ref22.stepNumber,
      stepNumber = _ref22$stepNumber === undefined ? '' : _ref22$stepNumber,
      _ref22$stepName = _ref22.stepName,
      stepName = _ref22$stepName === undefined ? '' : _ref22$stepName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '" - Step ' + stepNumber + ' ' + stepName + ' - Clicked "PRICE DISCLAIMER"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SAVE] = function (_ref23) {
  var _ref23$modelName = _ref23.modelName,
      modelName = _ref23$modelName === undefined ? '' : _ref23$modelName,
      _ref23$stepNumber = _ref23.stepNumber,
      stepNumber = _ref23$stepNumber === undefined ? '' : _ref23$stepNumber,
      _ref23$stepName = _ref23.stepName,
      stepName = _ref23$stepName === undefined ? '' : _ref23$stepName,
      _ref23$bodyName = _ref23.bodyName,
      bodyName = _ref23$bodyName === undefined ? '' : _ref23$bodyName,
      _ref23$driveName = _ref23.driveName,
      driveName = _ref23$driveName === undefined ? '' : _ref23$driveName,
      _ref23$gradeName = _ref23.gradeName,
      gradeName = _ref23$gradeName === undefined ? '' : _ref23$gradeName,
      _ref23$colorName = _ref23.colorName,
      colorName = _ref23$colorName === undefined ? '' : _ref23$colorName,
      _ref23$interiorName = _ref23.interiorName,
      interiorName = _ref23$interiorName === undefined ? '' : _ref23$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '", "' + bodyName + '", "' + driveName + '", "' + gradeName + '", "' + colorName + '", "' + interiorName + '" - Step "' + stepNumber + ' ' + stepName + '" - Clicked "SAVE"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM] = function (_ref24) {
  var _ref24$modelName = _ref24.modelName,
      modelName = _ref24$modelName === undefined ? '' : _ref24$modelName,
      _ref24$stepNumber = _ref24.stepNumber,
      stepNumber = _ref24$stepNumber === undefined ? '' : _ref24$stepNumber,
      _ref24$stepName = _ref24.stepName,
      stepName = _ref24$stepName === undefined ? '' : _ref24$stepName,
      _ref24$bodyName = _ref24.bodyName,
      bodyName = _ref24$bodyName === undefined ? '' : _ref24$bodyName,
      _ref24$driveName = _ref24.driveName,
      driveName = _ref24$driveName === undefined ? '' : _ref24$driveName,
      _ref24$gradeName = _ref24.gradeName,
      gradeName = _ref24$gradeName === undefined ? '' : _ref24$gradeName,
      _ref24$colorName = _ref24.colorName,
      colorName = _ref24$colorName === undefined ? '' : _ref24$colorName,
      _ref24$interiorName = _ref24.interiorName,
      interiorName = _ref24$interiorName === undefined ? '' : _ref24$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '", "' + bodyName + '", "' + driveName + '", "' + gradeName + '", "' + colorName + '", "' + interiorName + '" - Step "' + stepNumber + ' ' + stepName + '" - Clicked "SEND"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL] = function (_ref25) {
  var _ref25$modelName = _ref25.modelName,
      modelName = _ref25$modelName === undefined ? '' : _ref25$modelName,
      _ref25$stepNumber = _ref25.stepNumber,
      stepNumber = _ref25$stepNumber === undefined ? '' : _ref25$stepNumber,
      _ref25$stepName = _ref25.stepName,
      stepName = _ref25$stepName === undefined ? '' : _ref25$stepName,
      _ref25$bodyName = _ref25.bodyName,
      bodyName = _ref25$bodyName === undefined ? '' : _ref25$bodyName,
      _ref25$driveName = _ref25.driveName,
      driveName = _ref25$driveName === undefined ? '' : _ref25$driveName,
      _ref25$gradeName = _ref25.gradeName,
      gradeName = _ref25$gradeName === undefined ? '' : _ref25$gradeName,
      _ref25$colorName = _ref25.colorName,
      colorName = _ref25$colorName === undefined ? '' : _ref25$colorName,
      _ref25$interiorName = _ref25.interiorName,
      interiorName = _ref25$interiorName === undefined ? '' : _ref25$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '", "' + bodyName + '", "' + driveName + '", "' + gradeName + '", "' + colorName + '", "' + interiorName + '" - Step "' + stepNumber + ' ' + stepName + '" - Clicked "COPY URL"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_SHARE] = function (_ref26) {
  var _ref26$modelName = _ref26.modelName,
      modelName = _ref26$modelName === undefined ? '' : _ref26$modelName,
      _ref26$stepNumber = _ref26.stepNumber,
      stepNumber = _ref26$stepNumber === undefined ? '' : _ref26$stepNumber,
      _ref26$stepName = _ref26.stepName,
      stepName = _ref26$stepName === undefined ? '' : _ref26$stepName,
      _ref26$bodyName = _ref26.bodyName,
      bodyName = _ref26$bodyName === undefined ? '' : _ref26$bodyName,
      _ref26$driveName = _ref26.driveName,
      driveName = _ref26$driveName === undefined ? '' : _ref26$driveName,
      _ref26$gradeName = _ref26.gradeName,
      gradeName = _ref26$gradeName === undefined ? '' : _ref26$gradeName,
      _ref26$colorName = _ref26.colorName,
      colorName = _ref26$colorName === undefined ? '' : _ref26$colorName,
      _ref26$interiorName = _ref26.interiorName,
      interiorName = _ref26$interiorName === undefined ? '' : _ref26$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build "' + modelName + '", "' + bodyName + '", "' + driveName + '", "' + gradeName + '", "' + colorName + '", "' + interiorName + '" - Step "' + stepNumber + ' ' + stepName + '" - Clicked "SHARE"'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT] = function (_ref27) {
  var _ref27$modelName = _ref27.modelName,
      modelName = _ref27$modelName === undefined ? '' : _ref27$modelName;
  return {
    type: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build Share "' + modelName + '", Share - Clicked "Add another recipient"\n'
  };
}, _gtmEvents[gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM] = function (_ref28) {
  var _ref28$modelName = _ref28.modelName,
      modelName = _ref28$modelName === undefined ? '' : _ref28$modelName,
      _ref28$stepNumber = _ref28.stepNumber,
      stepNumber = _ref28$stepNumber === undefined ? '' : _ref28$stepNumber,
      _ref28$stepName = _ref28.stepName,
      stepName = _ref28$stepName === undefined ? '' : _ref28$stepName,
      _ref28$bodyName = _ref28.bodyName,
      bodyName = _ref28$bodyName === undefined ? '' : _ref28$bodyName,
      _ref28$driveName = _ref28.driveName,
      driveName = _ref28$driveName === undefined ? '' : _ref28$driveName,
      _ref28$gradeName = _ref28.gradeName,
      gradeName = _ref28$gradeName === undefined ? '' : _ref28$gradeName,
      _ref28$colorName = _ref28.colorName,
      colorName = _ref28$colorName === undefined ? '' : _ref28$colorName,
      _ref28$interiorName = _ref28.interiorName,
      interiorName = _ref28$interiorName === undefined ? '' : _ref28$interiorName;
  return {
    type: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    pageCategory: 'Build Tool "' + modelName + '"',
    pageAction: 'Build Share "' + modelName + '", "' + bodyName + '", "' + driveName + '", "' + gradeName + '", "' + colorName + '", "' + interiorName + '" - Step "' + stepNumber + ' ' + stepName + '" - Clicked "SEND"'
  };
}, _gtmEvents);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  REGISTER_YOUR_INTEREST_FORM: 'RYIF-001'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.REGISTER_YOUR_INTEREST_FORM] = function (_ref) {
  var nameplate = _ref.nameplate;
  return {
    type: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.REGISTER_YOUR_INTEREST_FORM,
    pageCategory: 'Register Your Interest Form',
    pageAction: 'Register Your Interest Form - "' + nameplate + '" - Clicked "KEEP ME INFORMED".'
  };
}, _gtmEvents);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gtmEventTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmEvents; });
var _gtmEvents;

var gtmEventTypes = {
  CLICK_SEARCH_ICON: 'FED-SEARCH-001',
  SITE_SEARCH_BAR_SEARCHED: 'FED-SEARCH-002',
  SITE_SEARCH_RESULTS: 'FED-SEARCH-003',
  SITE_SEARCH_RESULTS_CLICKED: 'FED-SEARCH-004'
};

var gtmEvents = (_gtmEvents = {}, _gtmEvents[gtmEventTypes.CLICK_SEARCH_ICON] = function (_ref) {
  var pageName = _ref.pageName;
  return {
    type: gtmEventTypes.CLICK_SEARCH_ICON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SEARCH_ICON,
    pageCategory: 'Site Search Bar',
    pageAction: 'Site Search Bar - Search icon clicked on ' + pageName + ' page'
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_BAR_SEARCHED] = function (_ref2) {
  var query = _ref2.query;
  return {
    type: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_BAR_SEARCHED,
    pageCategory: 'Site Search Bar',
    pageAction: 'Site Search Bar - Searched "' + query + '"'
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_RESULTS] = function (_ref3) {
  var query = _ref3.query;
  return {
    type: gtmEventTypes.SITE_SEARCH_RESULTS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS,
    pageCategory: 'Site Search Results',
    pageAction: 'Site Search Results - Searched "' + query + '"'
  };
}, _gtmEvents[gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED] = function (_ref4) {
  var query = _ref4.query,
      clicked = _ref4.clicked;
  return {
    type: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SITE_SEARCH_RESULTS_CLICKED,
    pageCategory: 'Site Search Results',
    pageAction: 'Site Search Results - Searched "' + query + '" and clicked "' + clicked + '"'
  };
}, _gtmEvents);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheApiResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persist__ = __webpack_require__(53);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var hourToMs = function hourToMs(ms) {
  return ms * 3600000;
};

var expireAfterHours = function expireAfterHours(time) {
  return function (_ref) {
    var timestamp = _ref.timestamp;

    var cacheLife = hourToMs(time); // 30 minute cache
    timestamp = parseInt(timestamp);
    var now = new Date().getTime();
    return now - timestamp > cacheLife;
  };
};

var cacheApiResponse = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cacheKey, api) {
    var invalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : expireAfterHours(0.5);

    var cache, _JSON$parse, timestamp, _data, _ref3, data, _timestamp;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */] && Object(__WEBPACK_IMPORTED_MODULE_1__persist__["b" /* isLocalStorageSupported */])())) {
              _context.next = 6;
              break;
            }

            cache = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].localStorage.getItem(cacheKey);

            if (!cache) {
              _context.next = 6;
              break;
            }

            _JSON$parse = JSON.parse(cache), timestamp = _JSON$parse.timestamp, _data = _JSON$parse.data;

            if (invalidateCache({ timestamp: timestamp, storedData: _data })) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', { response: _data });

          case 6:
            _context.next = 8;
            return api();

          case 8:
            _ref3 = _context.sent;
            data = _ref3.data;

            if (__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */] && Object(__WEBPACK_IMPORTED_MODULE_1__persist__["b" /* isLocalStorageSupported */])()) {
              _timestamp = new Date().getTime();

              __WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */].localStorage.setItem(cacheKey, JSON.stringify({ data: data, timestamp: _timestamp }));
            }
            return _context.abrupt('return', { response: data });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function cacheApiResponse(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function registerEvents(events, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var action = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var logger = extensions.logger,
      offlineStorage = extensions.offlineStorage;


  var ifLoggerLog = function ifLoggerLog() {
    if (typeof logger === 'function') {
      logger.apply(undefined, arguments);
    }
  };

  if (offlineStorage === undefined) {
    target(events);
    ifLoggerLog(events, action, state);
  } else if (offlineStorage.isConnected(state)) {
    target(events);
    ifLoggerLog(events, action, state);
    offlineStorage.purgeEvents(function (oldEvents) {
      if (Array.isArray(oldEvents) && oldEvents.length > 0) {
        target(oldEvents);
        ifLoggerLog(oldEvents, null, null, false, true);
      }
    });
  } else {
    offlineStorage.saveEvents(events);
    ifLoggerLog(events, action, state, true, false);
  }
}

exports.default = registerEvents;

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hyperlink__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-footer-navigation\\index.jsx';







/**
 * SubFooterNavigation
 */
var SubFooterNavigation = function SubFooterNavigation(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      items = _ref.items;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubFooterNavigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        }
      },
      items !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubFooterNavigation__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SubFooterNavigation__layout', __source: {
              fileName: _jsxFileName,
              lineNumber: 24
            }
          },
          items.map(function (item, index) {
            return item.links !== null && item.title !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubFooterNavigation__layout-item',
                key: index,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 28
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__components_accordion__["a" /* default */],
                {
                  pageName: item.title,
                  pcText: item.title,
                  mbText: item.title,
                  open: false,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 31
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Linklist, { links: item.links, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 37
                  }
                })
              )
            ) : null;
          })
        )
      ) : null
    )
  );
};
SubFooterNavigation.displayName = 'SubFooterNavigation';
SubFooterNavigation.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
    }))
  }))
};
SubFooterNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  items: null
};
/* harmony default export */ __webpack_exports__["a"] = (SubFooterNavigation);

/**
 *  Linklist
 */
var Linklist = function Linklist(_ref2) {
  var links = _ref2.links;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: 'SubFooterNavigation__list-ul', __source: {
        fileName: _jsxFileName,
        lineNumber: 78
      }
    },
    links.map(function (link, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { key: index, __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_hyperlink__["a" /* default */], { href: link.href,
          pageName: link.pageName,
          pcText: link.pcText,
          mbText: link.mbText,
          external: link.external,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        })
      );
    })
  );
};
Linklist.displayName = 'Linklist';

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_scroll_top__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\home-page\\index.jsx';






/**
 * HomePage
 */
var HomePage = function HomePage(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      hideScrollTop = _ref.hideScrollTop,
      pageName = _ref.pageName,
      pcHeading = _ref.pcHeading,
      mbHeading = _ref.mbHeading,
      header = _ref.header,
      hero = _ref.hero,
      children = _ref.children,
      footer = _ref.footer,
      ctaNavi = _ref.ctaNavi,
      anchorNavi = _ref.anchorNavi,
      cookieEditor = _ref.cookieEditor;

  var getPcHeading = function getPcHeading() {
    if (pcHeading !== null) {
      return pcHeading;
    } else {
      if (mbHeading !== null) {
        return mbHeading;
      }
    }
    return pageName !== null ? pageName : '';
  };
  var getMbHeading = function getMbHeading() {
    if (pcHeading !== null) {
      if (mbHeading !== null) {
        return mbHeading;
      } else {
        return pcHeading;
      }
    } else {
      if (mbHeading !== null) {
        return mbHeading;
      }
    }
    return pageName !== null ? pageName : '';
  };
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HomePage', __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        }
      },
      header !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: 'HomePage__header', __source: {
            fileName: _jsxFileName,
            lineNumber: 56
          }
        },
        header
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'main',
        { className: 'HomePage__main', __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        hero !== null ? hero : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: 'HomePage__heading', __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'HomePage__heading-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getPcHeading()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 61
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'HomePage__heading-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getMbHeading()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            })
          )
        ),
        children !== null ? children : null
      ),
      footer !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        { className: 'HomePage__footer', __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          }
        },
        footer
      ) : null,
      hideScrollTop === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_scroll_top__["a" /* default */], {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      }) : null,
      ctaNavi !== null ? ctaNavi : null,
      anchorNavi !== null ? anchorNavi : null,
      cookieEditor !== null ? cookieEditor : null
    )
  );
};
HomePage.displayName = 'HomePage';
HomePage.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideScrollTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  hero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  ctaNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  anchorNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  cookieEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
};
HomePage.defaultProps = {
  containerId: null,
  containerClass: null,
  hideScrollTop: null,
  pageName: null,
  pcHeading: null,
  mbHeading: null,
  header: null,
  hero: null,
  children: null,
  footer: null,
  ctaNavi: null,
  anchorNavi: null,
  cookieEditor: null
};
/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\primary-navigation\\index.jsx';






/**
 * PrimaryNavigation
 */
var PrimaryNavigation = function PrimaryNavigation(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      links = _ref.links;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'PrimaryNavigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'PrimaryNavigation__heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        },
        'Primary navigation'
      ),
      function () {
        if (links !== null) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'PrimaryNavigation__list-ul', __source: {
                fileName: _jsxFileName,
                lineNumber: 25
              }
            },
            links.map(function (link, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 28
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link, { pageName: link.pageName,
                  pcText: link.pcText,
                  mbText: link.mbText,
                  href: link.href,
                  external: link.external,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 29
                  }
                })
              );
            })
          );
        }
      }()
    )
  );
};
PrimaryNavigation.displayName = 'PrimaryNavigation';
PrimaryNavigation.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
};
PrimaryNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  links: null
};
/* harmony default export */ __webpack_exports__["a"] = (PrimaryNavigation);

var Link = function Link(_ref2) {
  var pageName = _ref2.pageName,
      pcText = _ref2.pcText,
      mbText = _ref2.mbText,
      href = _ref2.href,
      external = _ref2.external;

  //
  var getPcText = function getPcText() {
    if (pcText && pcText !== '') {
      return pcText;
    }
    return pageName;
  };
  var getMbText = function getMbText() {
    if (mbText && mbText !== '') {
      return mbText;
    } else {
      if (pcText && pcText !== '') {
        return pcText;
      }
    }
    return pageName;
  };
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { className: 'PrimaryNavigation__link' + (external !== null && external === true ? ' blank' : ''),
      href: href,
      target: external !== null && external === true ? '_blank' : null,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'PrimaryNavigation__link-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'PrimaryNavigation__link-mb', __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        }
      })
    )
  );
};
Link.displayName = 'Link';

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo-navigation\\index.jsx';






/**
 * PromoNavigation
 */
var PromoNavigation = function PromoNavigation(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      link = _ref.link,
      children = _ref.children;

  //
  var getPcText = function getPcText() {
    if (link) {
      if (link.pcText && link.pcText !== '') {
        return link.pcText;
      }
      return link.pageName;
    } else {
      return '';
    }
  };
  var getMbText = function getMbText() {
    if (link) {
      if (link.mbText && link.mbText !== '') {
        return link.mbText;
      } else {
        if (link.pcText && link.pcText !== '') {
          return link.pcText;
        }
      }
      return link.pageName;
    } else {
      return '';
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'PromoNavigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PromoNavigation__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        },
        function () {
          if (link && link.href) {
            // リンクの設定があった場合
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'PromoNavigation__heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 52
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PromoNavigation__link',
                  href: link.href,
                  target: link !== null && link.targetBlank !== null && link.targetBlank === true ? '_blank' : null,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 53
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigation__heading-pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 57
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 58
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigation__heading-mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 60
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 61
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigation__heading-text', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 63
                    }
                  },
                  'TOP'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PromoNavigation__link-border', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 64
                  }
                })
              )
            );
          } else {
            // リンクの設定がなかった場合
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 71
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'PromoNavigation__heading', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 72
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigation__heading-pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 73
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 74
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigation__heading-mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 76
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 77
                    }
                  })
                )
              )
            );
          }
        }(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'PromoNavigation__list-ul', __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          children !== null ? children.map(function (child, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 88
                }
              },
              child
            );
          }) : null
        )
      )
    )
  );
};
PromoNavigation.displayName = 'PromoNavigation';
PromoNavigation.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
};
PromoNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  link: null,
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (PromoNavigation);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo-navigation-container\\index.jsx';







/**
 * PromoNavigationContainer
 */
var PromoNavigationContainer = function PromoNavigationContainer(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      pcHeading = _ref.pcHeading,
      mbHeading = _ref.mbHeading,
      href = _ref.href,
      targetBlank = _ref.targetBlank,
      children = _ref.children;

  var settings = null;
  //
  var getPcHeading = function getPcHeading() {
    if (pcHeading && pcHeading !== '') {
      return pcHeading;
    } else {
      return null;
    }
  };
  var getMbHeading = function getMbHeading() {
    if (mbHeading && mbHeading !== '') {
      return mbHeading;
    } else {
      if (pcHeading && pcHeading !== '') {
        return pcHeading;
      } else {
        return null;
      }
    }
  };
  //console.log('debugmode');
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'PromoNavigationContainer', __source: {
          fileName: _jsxFileName,
          lineNumber: 47
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'PromoNavigationContainer__heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        },
        function () {
          if (pcHeading !== null && pcHeading !== '' || mbHeading !== null && mbHeading !== '') {
            if (href !== null && href !== '') {
              // リンクの設定があった場合
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'PromoNavigationContainer__link',
                  href: href !== null ? href : null,
                  target: targetBlank !== null && targetBlank === true ? '_blank' : null,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 54
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigationContainer__heading-pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 58
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* convertPipeToBrTag */])(getPcHeading() || '') }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 59
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigationContainer__heading-mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 61
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* convertPipeToBrTag */])(getMbHeading() || '') }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 62
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigationContainer__heading-text', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 64
                    }
                  },
                  'TOP'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PromoNavigationContainer__link-border', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 65
                  }
                })
              );
            } else {
              // リンクの設定がなかった場合
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 71
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigationContainer__heading-pc', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 72
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* convertPipeToBrTag */])(getPcHeading() || '') }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 73
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'PromoNavigationContainer__heading-mb', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 75
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* convertPipeToBrTag */])(getMbHeading() || '') }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 76
                    }
                  })
                )
              );
              // return (
              //   <div>
              //     {(pcHeading !== null && pcHeading !== '') ?
              //       <span className="PromoNavigationContainer__heading-pc">
              //         <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading() || '')}}/>
              //       </span>
              //       : null}
              //     {(mbHeading !== null && mbHeading !== '') ?
              //       <span className="PromoNavigationContainer__heading-mb">
              //         <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading() || '')}}/>
              //       </span>
              //       : null}
              //   </div>
              // )
            }
          } else {
            return null;
          }
        }()
      ),
      function () {
        if (children !== null) {
          if (children.length <= 4) {
            // 4個以下の場合はパディングを広げる
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'PromoNavigationContainer__list-ul', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 105
                }
              },
              children.map(function (child, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 108
                    }
                  },
                  child
                );
              })
            );
            // } else if (children.length === 5) {
            //     // 5個の場合はパディングを狭める
            //     return (
            //         <ul className="PromoNavigationContainer__list-ul col5">
            //             {children.map((child, index)=> {
            //                 return (
            //                     <li key={index}>{child}</li>
            //                 )
            //             })}
            //         </ul>
            //     )
          } else {
            // 5個以上の場合はスライドにする
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PromoNavigationContainer__slider', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 127
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__components_slider__["a" /* default */],
                { settings: settings, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                  }
                },
                children.map(function (child, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 131
                      }
                    },
                    child
                  );
                })
              )
            );
          }
        } else {
          return null;
        }
      }()
    )
  );
};
PromoNavigationContainer.displayName = 'PromoNavigationContainer';
PromoNavigationContainer.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
};
PromoNavigationContainer.defaultProps = {
  containerId: null,
  containerClass: null,
  pcHeading: null,
  mbHeading: null,
  href: null,
  targetBlank: null,
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (PromoNavigationContainer);

/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_image_loader__ = __webpack_require__(152);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo-navigation-item\\index.jsx';







/**
 * PromoNavigationItem
 */
var PromoNavigationItem = function PromoNavigationItem(_ref) {
  var containerId = _ref.containerId,
      containerClass = _ref.containerClass,
      src = _ref.src,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      targetBlank = _ref.targetBlank;

  //
  var getPcText = function getPcText() {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return '';
    }
  };
  var getMbText = function getMbText() {
    if (mbText && mbText !== '') {
      return mbText;
    } else {
      return getPcText();
    }
  };
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
    {
      containerId: containerId,
      containerClass: containerClass,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'article',
      { className: 'PromoNavigationItem', __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'PromoNavigationItem__link',
          href: href !== null ? href : null,
          target: targetBlank !== null && targetBlank === true ? '_blank' : null,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PromoNavigationItem__image', __source: {
              fileName: _jsxFileName,
              lineNumber: 47
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_image_loader__["a" /* default */], {
            width: '100%',
            ratio: 0.5,
            src: src,
            backgroundSize: 'cover',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h5',
          { className: 'PromoNavigationItem__heading', __source: {
              fileName: _jsxFileName,
              lineNumber: 60
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'PromoNavigationItem__heading-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 61
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 62
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'PromoNavigationItem__heading-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'PromoNavigationItem__border', __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        })
      )
    )
  );
};
PromoNavigationItem.displayName = 'PromoNavigationItem';
PromoNavigationItem.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
PromoNavigationItem.defaultProps = {
  containerId: null,
  containerClass: null,
  src: null,
  pcText: null,
  mbText: null,
  href: null,
  targetBlank: null
};
/* harmony default export */ __webpack_exports__["a"] = (PromoNavigationItem);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_navigation_container__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__car_navigation__ = __webpack_require__(153);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\global-navigation\\index.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











//import {HAS_TOUCH} from '../../constants/environment';

/**
 * GlobalNavigation
 */
var GlobalNavigation = (_temp = _class = function (_Component) {
  _inherits(GlobalNavigation, _Component);

  function GlobalNavigation(props) {
    _classCallCheck(this, GlobalNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getItemPositions = function () {
      var arr = [0];
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.items.length; i < max; i = i + 1) {
        var width = _this.refs[_this.items[i]].clientWidth;
        total = total + width;
        arr.push(total);
      }
      return arr;
    };

    _this.getCurrentItemPosition = function () {
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.items.length; i < max; i = i + 1) {
        var width = _this.refs[_this.items[i]].clientWidth;
        if (_this.refs[_this.items[i]].dataset.current === 'current') {
          return total + width / 2;
        }
        total = total + width;
      }
      return 0;
    };

    _this.handleClick = function (index) {
      if (_this.intervalId) clearTimeout(_this.intervalId);
      _this.dropDownLinkIndexArr.map(function (i) {
        if (i === index) {
          _this.intervalId = setTimeout(function () {
            _this.refs[i].toggle();
          }, 100);
        } else {
          _this.refs[i].close();
        }
      });
    };

    _this.handleResize = function (index) {
      _this.dropDownLinkIndexArr.map(function (i) {
        if (i === index) {
          setTimeout(function () {
            _this.refs[i].handleResize();
          }, 100);
        }
      });
    };

    _this.props = props;
    _this.state = {};
    _this.items = [];
    _this.dropDownLinkIndexArr = [];
    _this.isTablet = false;
    _this.intervalId = null;
    //
    // const ua = window.navigator.userAgent.toLowerCase();
    // //const ua = navigator.userAgent;
    // if (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0) {
    //     // スマートフォン用コード
    // } else if (ua.indexOf('ipad') > 0 || ua.indexOf('android') > 0) {
    //     // タブレット用コード
    //     this.isTablet = true;
    // } else {
    //     // PC用コード
    // }
    return _this;
  }

  GlobalNavigation.prototype.render = function render() {
    var _this2 = this;

    this.items = [];
    this.dropDownLinkIndexArr = [];
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'nav',
        { className: 'GlobalNavigation' + (this.isTablet === true ? ' tablet' : ''), __source: {
            fileName: _jsxFileName,
            lineNumber: 58
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'GlobalNavigation__heading', __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          },
          'Global navigation'
        ),
        function () {
          if (_this2.props.children !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__components_navigation_container__["a" /* default */],
              {
                getItemPositions: _this2.getItemPositions,
                getCurrentItemPosition: _this2.getCurrentItemPosition,
                excludedWidth: 148,
                opacity: 1,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 63
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'GlobalNavigation__list-ul', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 69
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 70
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { 'class': 'GlobalNavigation__link', href: 'https://www2.mazda.co.jp/brand/', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 70
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { 'class': 'GlobalNavigation__link-container', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 70
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 70
                          }
                        },
                        '\u30D6\u30E9\u30F3\u30C9'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { 'class': 'GlobalNavigation__link-border', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 70
                      }
                    })
                  )
                ),
                _this2.props.children.map(function (child, index) {
                  // if (child.type.displayName === 'withDynamicComponents(PromoNavigation)') {
                  if (0 <= child.type.displayName.indexOf('withDynamicComponents(PromoNavigation)')) {
                    _this2.items.push('item' + index);
                    _this2.dropDownLinkIndexArr.push(index);
                    // PromoNavigation
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { key: index, ref: 'item' + index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 78
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        DropDownList,
                        { ref: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 79
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropDownLink, {
                          href: child.props.link && child.props.link.href !== null ? child.props.link.href : null,
                          external: child.props.link && child.props.link.targetBlank !== null ? child.props.link.targetBlank : null,
                          pageName: child.props.link && child.props.link.pageName !== null ? child.props.link.pageName : null,
                          pcText: child.props.link && child.props.link.pcText !== null ? child.props.link.pcText : null,
                          mbText: child.props.link && child.props.link.mbText !== null ? child.props.link.mbText : null,
                          current: child.props.link && child.props.link.current !== null ? child.props.link.current : null,
                          index: index,
                          onClick: function onClick(index) {
                            _this2.handleClick(index);
                          },
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 80
                          }
                        }),
                        child
                      )
                    );
                  } else if (child.type.displayName === 'GlobalNavigationLink') {
                    _this2.items.push('item' + index);
                    // GlobalNavigationLink
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { key: index, ref: 'item' + index, 'data-current': child.props.current ? 'current' : '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 100
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__link__["a" /* default */], {
                        href: child.props.href,
                        external: child.props.external,
                        pageName: child.props.pageName,
                        pcText: child.props.pcText,
                        mbText: child.props.mbText,
                        current: child.props.current,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 101
                        }
                      })
                    );
                    // } else if (child.type.displayName === 'withDynamicComponents(CarNavigation)') {
                  } else if (0 <= child.type.displayName.indexOf('withDynamicComponents(CarNavigation)')) {
                    _this2.items.push('item' + index);
                    _this2.dropDownLinkIndexArr.push(index);
                    // CarNavigation
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { key: index, ref: 'item' + index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 117
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        DropDownList,
                        { ref: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 118
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropDownLink, {
                          href: child.props.link && child.props.link.href !== null ? child.props.link.href : null,
                          external: child.props.link && child.props.link.targetBlank !== null ? child.props.link.targetBlank : null,
                          pageName: child.props.link && child.props.link.pageName !== null ? child.props.link.pageName : null,
                          pcText: child.props.link && child.props.link.pcText !== null ? child.props.link.pcText : null,
                          mbText: child.props.link && child.props.link.mbText !== null ? child.props.link.mbText : null,
                          current: child.props.link && child.props.link.current !== null ? child.props.link.current : null,
                          index: index,
                          onClick: function onClick(index) {
                            _this2.handleClick(index);
                          },
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 119
                          }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__car_navigation__["a" /* default */], _extends({}, child.props, {
                          parentIndex: index,
                          onChange: function onChange(index) {
                            _this2.handleResize(index);
                          },
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 131
                          }
                        }))
                      )
                    );
                  } else {
                    return null;
                  }
                })
              )
            );
          } else {
            return null;
          }
        }()
      )
    );
  };

  //


  //


  //


  //


  return GlobalNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  children: null
}, _temp);
GlobalNavigation.displayName = 'GlobalNavigation';


/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigation);

// プロモナビゲーションとカーナビゲーション用のドロップダウン
var DropDownList = (_temp2 = _class2 = function (_Component2) {
  _inherits(DropDownList, _Component2);

  function DropDownList(props) {
    _classCallCheck(this, DropDownList);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.toggle = function () {
      if (_this3.state.open === true) {
        _this3.close();
      } else {
        _this3.open();
      }
    };

    _this3.open = function () {
      if (_this3.state.open === true) return;
      _this3.setState({
        append: true
      });
      // BODYのスクロール無効化
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].setUnScrollPc();
      if (_this3.intervalId) clearTimeout(_this3.intervalId);
      if (_this3.intervalId2) clearTimeout(_this3.intervalId2);
      if (_this3.intervalId3) clearTimeout(_this3.intervalId3);
      _this3.intervalId = setTimeout(function () {
        _this3.setState({
          open: true,
          height: _this3.getHeight()
        });
      }, 100);
      _this3.intervalId3 = setInterval(function () {
        _this3.setState({
          height: _this3.getHeight()
        });
      }, 500);
    };

    _this3.close = function () {
      if (_this3.state.open === false) return;
      _this3.setState({
        height: 0,
        open: false
      });
      // BODYのスクロール無効化を解除
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].clearUnScroll();
      if (_this3.intervalId) clearTimeout(_this3.intervalId);
      if (_this3.intervalId2) clearTimeout(_this3.intervalId2);
      if (_this3.intervalId3) clearTimeout(_this3.intervalId3);
      _this3.intervalId2 = setTimeout(function () {
        _this3.setState({
          append: false
        });
      }, 1000);
    };

    _this3.handleResize = function () {
      if (_this3.state.open === false) return;
      _this3.setState({ height: _this3.getHeight() });
    };

    _this3.getHeight = function () {
      if (768 <= window.innerWidth) {
        return window.innerHeight - 50;
      } else {
        return _this3.refs.content.clientHeight;
      }
    };

    _this3.props = props;
    _this3.state = {
      append: false,
      open: _this3.props.open,
      height: 0
    };
    _this3.intervalId = null;
    _this3.intervalId2 = null;
    _this3.intervalId3 = null;
    return _this3;
  }

  DropDownList.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  DropDownList.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  DropDownList.prototype.render = function render() {
    var _this4 = this;

    if (this.state.append === true) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'dl',
        { className: 'GlobalNavigation__list-dl' + (this.state.open === true ? ' open' : ''), __source: {
            fileName: _jsxFileName,
            lineNumber: 249
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dt',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 250
            }
          },
          this.props.children[0]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dd',
          { style: { height: this.state.height }, __source: {
              fileName: _jsxFileName,
              lineNumber: 253
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'GlobalNavigation__box', ref: 'content', __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            },
            this.props.children[1]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'GlobalNavigation__link-close', href: '#', onClick: function onClick(e) {
              e.preventDefault();
              _this4.close();
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 256
            }
          },
          'Close'
        )
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'dl',
        { className: 'GlobalNavigation__list-dl' + (this.state.open === true ? ' open' : ''), __source: {
            fileName: _jsxFileName,
            lineNumber: 264
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dt',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 265
            }
          },
          this.props.children[0]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dd',
          { style: { height: this.state.height }, __source: {
              fileName: _jsxFileName,
              lineNumber: 268
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'GlobalNavigation__box', ref: 'content', __source: {
              fileName: _jsxFileName,
              lineNumber: 269
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'GlobalNavigation__link-close', href: '#', onClick: function onClick(e) {
              e.preventDefault();
              _this4.close();
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 271
            }
          },
          'Close'
        )
      );
    }
  };
  // render() {
  //   return (
  //     <dl className={'GlobalNavigation__list-dl' + ((this.state.open === true) ? ' open': '')}>
  //       <dt>
  //         {this.props.children[0]}
  //       </dt>
  //       <dd style={{height: this.state.height}}>
  //         <div className="GlobalNavigation__box" ref="content">{this.props.children[1]}</div>
  //       </dd>
  //       <a className="GlobalNavigation__link-close" href="#" onClick={(e) => {
  //         e.preventDefault();
  //         this.close()
  //       }}>Close</a>
  //     </dl>
  //   )
  // }

  //


  //

  // open = () => {
  //   if (this.state.open === true) return;
  //   this.setState({
  //     open: true,
  //     height: this.getHeight(),
  //   });
  //   // BODYのスクロール無効化
  //   BodyControl.setUnScrollPc();
  // };

  //

  // close = () => {
  //   if (this.state.open === false) return;
  //   this.setState({
  //     open: false,
  //     height: 0,
  //   });
  //   // BODYのスクロール無効化を解除
  //   BodyControl.clearUnScroll();
  // };

  //


  //


  return DropDownList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
}, _class2.defaultProps = {
  open: false,
  children: null
}, _temp2);
DropDownList.displayName = 'DropDownList';


// リンク
var DropDownLink = function DropDownLink(_ref) {
  var href = _ref.href,
      external = _ref.external,
      pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      index = _ref.index,
      onClick = _ref.onClick,
      current = _ref.current;

  var handleClick = function handleClick(e) {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(index);
    }
  };
  //
  var getPcText = function getPcText() {
    if (pcText !== null) {
      return pcText;
    } else if (pageName !== null) {
      return pageName;
    } else {
      return '';
    }
  };
  var getMbText = function getMbText() {
    if (mbText !== null) {
      return mbText;
    } else if (pcText !== null) {
      return pcText;
    } else if (pageName !== null) {
      return pageName;
    } else {
      return '';
    }
  };
  //
  if (!href) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'GlobalNavigation__link',
        href: href !== null ? href : '',
        target: external === true ? '_blank' : '',
        onClick: function onClick(e) {
          handleClick(e);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 424
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'GlobalNavigation__link-container', __source: {
            fileName: _jsxFileName,
            lineNumber: 431
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GlobalNavigation__link-pc', __source: {
              fileName: _jsxFileName,
              lineNumber: 432
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 433
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GlobalNavigation__link-mb', __source: {
              fileName: _jsxFileName,
              lineNumber: 435
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 436
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-icon', __source: {
            fileName: _jsxFileName,
            lineNumber: 438
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-icon2', __source: {
            fileName: _jsxFileName,
            lineNumber: 439
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-border', __source: {
          fileName: _jsxFileName,
          lineNumber: 441
        }
      })
    );
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'GlobalNavigation__link' + (current === true ? ' current' : ''),
        href: '#',
        onClick: function onClick(e) {
          handleClick(e);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 446
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'GlobalNavigation__link-container', __source: {
            fileName: _jsxFileName,
            lineNumber: 452
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GlobalNavigation__link-pc', __source: {
              fileName: _jsxFileName,
              lineNumber: 453
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 454
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GlobalNavigation__link-mb', __source: {
              fileName: _jsxFileName,
              lineNumber: 456
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 457
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-icon', __source: {
            fileName: _jsxFileName,
            lineNumber: 459
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-icon2', __source: {
            fileName: _jsxFileName,
            lineNumber: 460
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-border', __source: {
          fileName: _jsxFileName,
          lineNumber: 462
        }
      })
    );
  }
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\global-navigation\\link\\index.jsx';




/**
 * GlobalNavigationLink
 */
var GlobalNavigationLink = function GlobalNavigationLink(_ref) {
  var pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      external = _ref.external,
      current = _ref.current;

  //
  var getPcText = function getPcText() {
    if (pcText !== null) {
      return pcText;
    }
    return pageName;
  };
  var getMbText = function getMbText() {
    if (mbText !== null) {
      return mbText;
    } else {
      if (pcText !== null) {
        return pcText;
      }
    }
    return pageName;
  };
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { className: 'GlobalNavigation__link' + (current === true ? ' current' : ''),
      href: href !== null ? href : '',
      target: external === true ? '_blank' : null,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'GlobalNavigation__link-container', __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'GlobalNavigation__link-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'GlobalNavigation__link-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 44
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-icon3', __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'GlobalNavigation__link-border', __source: {
        fileName: _jsxFileName,
        lineNumber: 48
      }
    })
  );
};
GlobalNavigationLink.displayName = 'GlobalNavigationLink';
GlobalNavigationLink.propTypes = {
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
GlobalNavigationLink.defaultProps = {
  pageName: null,
  pcText: null,
  mbText: null,
  href: null,
  external: null
};
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigationLink);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_site_search__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_my_mazda__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\header\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 *  Header
 */
var Header = (_temp = _class = function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onOpenedMyMazda = function () {
      _this.setState({
        myMazdaOpened: true
      });
    };

    _this.onClosedMyMazda = function () {
      _this.setState({
        myMazdaOpened: false
      });
    };

    _this.scrollToSearchTop = function (targetTop) {
      var scrollTop = _this.refs.layoutRight.scrollTop;
      _this.refs.layoutRight.scrollTo(0, targetTop + scrollTop);
    };

    _this.easing = function (t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    };

    _this.handleClick = function (e) {
      e.preventDefault();

      //
      if (_this.state.myMazdaOpened) {
        if (_this.refs.myMazdaMb) {
          _this.refs.myMazdaMb.close();
        }
        if (_this.refs.myMazdaPc) {
          _this.refs.myMazdaPc.close();
        }
        _this.setState({
          myMazdaOpened: false
        });
        //
        _this.setState({
          height: 'auto'
        });
        // BODYのスクロール無効化を解除
        __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].clearUnScroll();
        return;
      }

      //
      if (_this.open === true) {
        _this.open = false;
        _this.setState({
          open: false,
          close: true
        });
        //
        _this.setState({
          height: 'auto'
        });
        // BODYのスクロール無効化を解除
        __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].clearUnScroll();
      } else {
        _this.open = true;
        _this.setState({
          open: true,
          close: false
        });
        window.scrollTo(0, 0);
        //
        _this.handleResize();
        // BODYのスクロール無効化
        __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].setUnScrollMb();
      }
    };

    _this.handleResize = function () {
      if (_this.open === false) return;
      //
      if (window.matchMedia('(min-width:768px)').matches) {
        _this.setState({
          height: 'auto'
        });
      } else {
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        var height = window.innerHeight - _this.refs.heading.clientHeight - top;
        _this.setState({
          height: height
        });
      }
    };

    _this.apiAccessLoginUserName = function (uid) {
      return new Promise(function (resolve, reject) {
        if (!_this.hostname || 0 <= String(_this.hostname).indexOf('localhost')) {
          setTimeout(function () {
            resolve('０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０');
            // resolve('０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９');
            // resolve('山田 太郎');
          }, 1000);
        } else {
          var url = void 0;
          // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
          if (_this.hostname && (0 <= String(_this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(_this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(_this.hostname).indexOf('.test.mazda.jp'))) {
            url = 'https://my-mazda-co-jp.test.mazda.jp/api/v1/loginUserName';
          } else {
            url = 'https://my.mazda.co.jp/api/v1/loginUserName';
          }
          //
          var params = new URLSearchParams();
          params.set('id', uid);
          //
          console.log('apiAccessLoginUserName', url + '?' + params.toString());
          fetch(url + '?' + params.toString(), {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded'
              // 'Content-Type': 'application/json',
            },
            method: 'GET',
            mode: 'cors',
            credentials: 'include'
          }).then(function (response) {
            return response.json();
          }).then(function (json) {
            console.log('success', json);
            if (json.status === 'LOGIN' || json.status === 'APP_LOGIN') {
              resolve(json.lastName + ' ' + json.firstName);
            } else {
              reject();
            }
          }).catch(function (e) {
            console.log('error', e.message);
            reject();
          });
        }
      });
    };

    _this.getUserId = function () {
      if (!__WEBPACK_IMPORTED_MODULE_7__constants_environment__["a" /* DOCUMENT */] || !__WEBPACK_IMPORTED_MODULE_7__constants_environment__["a" /* DOCUMENT */].cookie) {
        return false;
      }
      var cookies = document.cookie;
      var arr = cookies.split(';');
      for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var c = _ref;

        var arr2 = c.split('=');
        if (arr2[0].match(/\mmuid/)) {
          return arr2[1];
        }
      }
    };

    _this.props = props;
    _this.state = {
      close: _this.props.close,
      open: _this.props.open,
      height: 0,
      myMazdaOpened: null,
      myMazdaName: null
    };
    _this.open = _this.props.open;
    //
    _this.hostname = null;
    _this.href = null;
    if (__WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */].location && __WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */].location.hostname && __WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */].location.href) {
      _this.hostname = __WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */].location.hostname || null;
      _this.href = __WEBPACK_IMPORTED_MODULE_7__constants_environment__["k" /* WINDOW */].location.href || null;
    }
    return _this;
  }

  Header.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    //
    if (this.props.myMazda !== null && 1 <= this.props.myMazda.length) {
      if (!this.props.myMazda[0].props.myMazdaLink.hideName) {
        // MyMazda ユーザID取得
        var uid = this.getUserId();
        if (uid && uid !== '') {
          // MyMazda Webログインユーザー氏名取得
          this.apiAccessLoginUserName(uid).then(function (value) {
            _this2.setState({
              myMazdaName: value
            });
          });
        }
      }
    }
  };

  Header.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  Header.prototype.render = function render() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Header', __source: {
            fileName: _jsxFileName,
            lineNumber: 84
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Header__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 85
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Header__layout', __source: {
                fileName: _jsxFileName,
                lineNumber: 86
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Header__layout-left', ref: 'heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 87
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Header__heading', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 88
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: '/', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 89
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Header__heading-image',
                    src: Header.logoSrc,
                    alt: 'MAZDA',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 90
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'Header__link-menu' + (this.state.open === true || this.state.myMazdaOpened === true ? ' open' : '') + (this.state.close === true || this.state.myMazdaOpened === false ? ' close' : ''),
                  href: '#',
                  onClick: function onClick(e) {
                    _this3.handleClick(e);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 96
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 103
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 104
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 105
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 106
                    }
                  })
                )
              ),
              this.props.myMazda !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Header__my-mazda-mb' + (this.state.open === true ? ' hide' : ''), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 110
                  }
                },
                this.props.myMazda.map(function (myMazda, index) {
                  if (myMazda.type.displayName === 'MyMazda') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_my_mazda__["a" /* default */], _extends({}, myMazda.props, {
                      key: index,
                      onOpened: _this3.onOpenedMyMazda,
                      onClosed: _this3.onClosedMyMazda,
                      ref: 'myMazdaMb',
                      myMazdaName: _this3.state.myMazdaName || null,
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 114
                      }
                    }));
                  } else {
                    return null;
                  }
                })
              ) : null
            ),
            function () {
              if (_this3.props.globalNavigation !== null || _this3.props.primaryNavigation !== null || _this3.props.siteSearch !== null || _this3.props.myMazda !== null) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Header__layout-right' + (_this3.state.open === true ? ' open' : ''),
                    style: { height: _this3.state.height },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 132
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Header__layout-right-inner',
                      ref: 'layoutRight',
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 135
                      }
                    },
                    _this3.props.globalNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Header__box', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 139
                        }
                      },
                      _this3.props.globalNavigation
                    ) : null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Header__layout2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 143
                        }
                      },
                      _this3.props.primaryNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Header__layout2-left', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 145
                          }
                        },
                        _this3.props.primaryNavigation
                      ) : null,
                      _this3.props.siteSearch !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Header__layout2-center', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 150
                          }
                        },
                        _this3.props.siteSearch.map(function (siteSearch, index) {
                          if (siteSearch.type.displayName === 'SiteSearch') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_site_search__["a" /* default */], _extends({}, siteSearch.props, {
                              scrollToSearchTop: _this3.scrollToSearchTop,
                              key: index,
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 154
                              }
                            }));
                          } else {
                            return null;
                          }
                        })
                      ) : null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Header__layout2-right', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 165
                          }
                        },
                        _this3.props.myMazda !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'Header__my-mazda-pc', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 167
                            }
                          },
                          _this3.props.myMazda.map(function (myMazda, index) {
                            if (myMazda.type.displayName === 'MyMazda') {
                              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_my_mazda__["a" /* default */], _extends({}, myMazda.props, {
                                key: index,
                                onOpened: _this3.onOpenedMyMazda,
                                onClosed: _this3.onClosedMyMazda,
                                ref: 'myMazdaPc',
                                myMazdaName: _this3.state.myMazdaName || null,
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 171
                                }
                              }));
                            } else {
                              return null;
                            }
                          })
                        ) : null
                      )
                    )
                  )
                );
              } else {
                return null;
              }
            }()
          )
        )
      )
    );
  };

  //


  //


  //


  //


  //


  //


  // MyMazda Webログインユーザー氏名取得


  // ユーザID取得


  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.logoSrc = 'data:image/png;base64,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', _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  primaryNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  siteSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  globalNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  myMazda: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  primaryNavigation: null,
  siteSearch: null,
  globalNavigation: null,
  myMazda: null
}, _temp);
Header.displayName = 'Header';


/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pc__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tb__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mb__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lower__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_environment__ = __webpack_require__(5);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * SubNavigation
 */
var SubNavigation = (_temp = _class = function (_Component) {
  _inherits(SubNavigation, _Component);

  function SubNavigation(props) {
    _classCallCheck(this, SubNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleScroll = function () {
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      var fixed = _this.state.fixed;
      var fixedTop = 0;
      if (_this.isExistHeader) {
        if (window.matchMedia('(min-width:768px)').matches) {
          fixedTop = 94;
        } else {
          fixedTop = 60;
        }
      }
      if (fixedTop <= top) {
        if (fixed === true) return;
        _this.setState({
          fixed: true
        });
      } else {
        if (fixed === false) return;
        _this.setState({
          fixed: false
        });
      }
    };

    _this.onScrollEpiPreview = function () {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var top = wrapperElement.scrollTop;
        var fixed = _this.state.fixed;
        var fixedTop = 0;
        if (_this.isExistHeader) {
          if (window.matchMedia('(min-width:768px)').matches) {
            fixedTop = 94;
          } else {
            fixedTop = 60;
          }
        }
        if (fixedTop <= top) {
          _this.setState({
            fixed: true,
            top: top - fixedTop
          });
        } else {
          if (fixed === false) return;
          _this.setState({
            fixed: false,
            top: 0
          });
        }
      }
    };

    _this.getStepsClass = function () {
      var stepsClass = ' one-steps';
      if (_this.props.links !== null && 1 <= _this.props.links.length) {
        _this.props.links.map(function (link, index) {
          if (link.current === true) {
            if (link.nestedNavigation !== null) {
              if (link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
                stepsClass = ' two-steps';
              }
            }
          }
        });
      }
      return stepsClass;
    };

    _this.getHierarchy = function (pathname) {
      var hierarchy = 1;
      if (_this.props.links !== null && 1 <= _this.props.links.length) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.props.links.length; i < max; i = i + 1) {
          var link = _this.props.links[i];
          if (link.current === true) {
            hierarchy = 2;
            if (link.nestedNavigation !== null) {
              if (link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {

                // 下階層のTOPリンクのURLと現在のページのURLが一致していた場合に下線を表示しない処理
                if (pathname && link.nestedNavigation.topLink && link.nestedNavigation.topLink.href) {
                  if (link.nestedNavigation.topLink.href === pathname) {
                    return 3;
                  }
                }

                var j = void 0,
                    max2 = void 0;
                for (j = 0, max2 = link.nestedNavigation.links.length; j < max2; j = j + 1) {
                  var link2 = link.nestedNavigation.links[j];
                  if (link2.current === true) {
                    hierarchy = 3;
                    if (link2.nestedNavigation !== null) {
                      if (link2.nestedNavigation.links !== null && 1 <= link2.nestedNavigation.links.length) {
                        var k = void 0,
                            max3 = void 0;
                        for (k = 0, max3 = link2.nestedNavigation.links.length; k < max3; k = k + 1) {
                          var link3 = link2.nestedNavigation.links[k];
                          if (link3.current === true) {
                            hierarchy = 4;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return hierarchy;
    };

    _this.props = props;
    _this.state = {
      fixed: false,
      hierarchy: _this.getHierarchy(),
      top: 0
    };
    // PCでの段表示
    _this.stepsClass = _this.getStepsClass();

    _this.isExistHeader = true;
    return _this;
  }

  SubNavigation.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["a" /* DOCUMENT */].querySelector('.Header')) {
      this.isExistHeader = true;
    } else {
      this.isExistHeader = false;
    }

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    // 階層
    this.setState({
      hierarchy: this.getHierarchy(location.pathname)
    });

    // EPIServerのプレビュー時のモーダルの位置調整
    // if (WINDOW && WINDOW.epi && WINDOW.parent && !IS_MOBILE) {
    if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent && window.matchMedia('(min-width:768px)').matches) {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        setInterval(function () {
          _this2.onScrollEpiPreview();
        }, 200);
      }
    }
  };

  SubNavigation.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };

  SubNavigation.prototype.render = function render() {
    var _this3 = this;

    if (this.props.display === true) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
        {
          containerId: this.props.containerId,
          containerClass: this.props.containerClass,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 104
          }
        },
        function () {
          if (_this3.props.position === false) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'section',
              { className: 'SubNavigation' + (_this3.state.fixed === true ? ' fixed' : '') + _this3.stepsClass, ref: 'self', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 111
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SubNavigation__container', style: function () {
                    if (0 < _this3.state.top) {
                      return {
                        position: 'absolute',
                        top: _this3.state.top + 'px'
                      };
                    }
                    return null;
                  }(), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 112
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pc__["a" /* default */], {
                  pcTitle: _this3.props.pcTitle,
                  mbTitle: _this3.props.mbTitle,
                  carsTitle: _this3.props.carsTitle,
                  rootLink: _this3.props.rootLink,
                  estimationHistory: _this3.props.estimationHistory,
                  links: _this3.props.links,
                  hierarchy: _this3.state.hierarchy,
                  subNavigation: _this3.refs.self,
                  deleteRootPageLink: _this3.props.deleteRootPageLink,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 121
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tb__["a" /* default */], {
                  pcTitle: _this3.props.pcTitle,
                  mbTitle: _this3.props.mbTitle,
                  carsTitle: _this3.props.carsTitle,
                  rootLink: _this3.props.rootLink,
                  estimationHistory: _this3.props.estimationHistory,
                  links: _this3.props.links,
                  hierarchy: _this3.state.hierarchy,
                  deleteRootPageLink: _this3.props.deleteRootPageLink,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 132
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__mb__["a" /* default */], {
                  pcTitle: _this3.props.pcTitle,
                  mbTitle: _this3.props.mbTitle,
                  carsTitle: _this3.props.carsTitle,
                  rootLink: _this3.props.rootLink,
                  estimationHistory: _this3.props.estimationHistory,
                  links: _this3.props.links,
                  hierarchy: _this3.state.hierarchy,
                  deleteRootPageLink: _this3.props.deleteRootPageLink,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 142
                  }
                })
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'section',
              { className: 'SubNavigation' + (_this3.props.position === true ? ' lower' : ''), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 157
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__lower__["a" /* default */], {
                pcTitle: _this3.props.pcTitle,
                mbTitle: _this3.props.mbTitle,
                carsTitle: _this3.props.carsTitle,
                rootLink: _this3.props.rootLink,
                estimationHistory: _this3.props.estimationHistory,
                links: _this3.props.links,
                hierarchy: _this3.state.hierarchy,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 158
                }
              })
            );
          }
        }()
      );
    } else {
      return null;
    }
  };

  //


  // EPIServerのプレビュー時のモーダルの位置調整


  // PCでの段表示


  // 階層


  return SubNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carsTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  deleteRootPageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  estimationHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    nestedNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })),
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcTitle: null,
  mbTitle: null,
  carsTitle: null,
  deleteRootPageLink: false,
  rootLink: null,
  estimationHistory: null,
  links: null,
  position: null,
  display: null
}, _temp);
SubNavigation.displayName = 'SubNavigation';


/* harmony default export */ __webpack_exports__["a"] = (SubNavigation);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(253),
    arraySome = __webpack_require__(755),
    cacheHas = __webpack_require__(256);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(768);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(770),
    baseUnary = __webpack_require__(771),
    nodeUtil = __webpack_require__(772);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hero_image__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hero_video__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__related_video__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\hero-carousel\\index.jsx',
    _class,
    _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---
// import ReactSlider from './react-slick'

// ---

// ---





// import Html from '../html';
// import Slider from '../../containers/slider';
// ---



/**
 * slick slider 拡張 Slider
 * @param {Array<Component>} children child component list
 * @param {*} settings react-slick option
 * @param {function} photoInfoWillOpen {@link PhotoInfo} open callback
 * @param {function} photoInfoWillClose {@link PhotoInfo} close callback
 * @param {function} modalWillOpen {@link HeroVideo} modal open callback
 * @param {function} modalWillClose {@link HeroVideo} modal close callback
 * @param {boolean} inHeroCarousel parent {@link HeroCarousel} flag - `HeroVideo` autoPlay 振舞いが異なるために使用します
 * @param {string} heroCarouselSlideId 現在カレントの slider ID - `containerId`
 * @param {Array<string>} idList slider child 識別子リスト
 * @param {function} sendMessage figureBlock rect を通知する関数
 * @returns {ReactElement} react-slick slider component
 * @see https://github.com/akiran/react-slick
 */
var Slider = function Slider(_ref) {
  var children = _ref.children,
      settings = _ref.settings,
      photoInfoWillOpen = _ref.photoInfoWillOpen,
      photoInfoWillClose = _ref.photoInfoWillClose,
      modalWillOpen = _ref.modalWillOpen,
      modalWillClose = _ref.modalWillClose,
      inHeroCarousel = _ref.inHeroCarousel,
      heroCarouselSlideId = _ref.heroCarouselSlideId,
      idList = _ref.idList,
      sendMessage = _ref.sendMessage;
  return (
    // props 拡張するために component を生成する
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
      _extends({}, settings, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        }
      }),
      children.map(function (child, i) {
        // clone 作成
        var props = Object.assign({}, child.props);
        // console.log('ReactSlider props ', i, idList[i]);
        // PhotoInfo component 作成
        if (Array.isArray(props.photoInfo)) {
          props.photoInfo = props.photoInfo.map(function (photoInfo) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__photo_info__["a" /* default */], _extends({
              key: 'HeroCarousel-' + photoInfo.props.containerId
            }, photoInfo.props, {
              photoInfoWillOpen: photoInfoWillOpen,
              photoInfoWillClose: photoInfoWillClose,
              inHeroCarousel: inHeroCarousel,
              heroCarouselSlideId: heroCarouselSlideId,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 58
              }
            }));
          });
        }
        // check displayName
        // if (child.type.displayName === 'withDynamicComponents(HeroImage)') {
        if (0 <= child.type.displayName.indexOf('withDynamicComponents(HeroImage)')) {
          // HeroImage
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hero_image__["a" /* default */], _extends({
            key: 'HeroCarousel-HeroImage-' + props.containerId
          }, props, {
            photoInfoWillOpen: photoInfoWillOpen,
            photoInfoWillClose: photoInfoWillClose,
            modalWillOpen: modalWillOpen,
            modalWillClose: modalWillClose,
            inHeroCarousel: inHeroCarousel,
            heroCarouselSlideId: heroCarouselSlideId,
            heroCarouselUniqueId: idList[i],
            sendMessage: sendMessage,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          }));
          // } else if (child.type.displayName === 'withDynamicComponents(HeroVideo)') {
        } else if (0 <= child.type.displayName.indexOf('withDynamicComponents(HeroVideo)')) {
          // HeroVideo > RelatedVideo
          if (Array.isArray(props.relatedVideo)) {
            props.relatedVideo = props.relatedVideo.map(function (relatedVideo, index) {
              // console.log('props.relatedVideo', relatedVideo);
              if (relatedVideo.name === 'RelatedVideo') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__related_video__["a" /* default */], _extends({
                  key: 'HeroCarousel-HeroVideo-relatedVideo-' + relatedVideo.props.containerId
                }, relatedVideo.props, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 92
                  }
                }));
              }
              return null;
            }).filter(function (component) {
              return component !== null;
            });
          }
          // HeroVideo
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hero_video__["a" /* default */], _extends({
            key: 'HeroCarousel-HeroVideo-' + props.containerId
          }, props, {
            photoInfoWillOpen: photoInfoWillOpen,
            photoInfoWillClose: photoInfoWillClose,
            modalWillOpen: modalWillOpen,
            modalWillClose: modalWillClose,
            inHeroCarousel: inHeroCarousel,
            heroCarouselSlideId: heroCarouselSlideId,
            heroCarouselUniqueId: idList[i],
            sendMessage: sendMessage,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 102
            }
          }));
        }
        return null;
      })
    )
  );
};

Slider.displayName = 'Slider';
Slider.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired).isRequired,
  // compact: PropTypes.bool.isRequired,
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  photoInfoWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  photoInfoWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  modalWillOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  modalWillClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inHeroCarousel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  heroCarouselSlideId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  sendMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["d" /* withRadium */])(Object(__WEBPACK_IMPORTED_MODULE_3__higher_order_components__["a" /* DetectCompact */])())(Slider);

/**
 * HeroCarousel - carousel 実装します
 * - {@link Slider}
 * - `react-slick` - `slick` 依存します
 * @see https://github.com/akiran/react-slick
 * @see http://kenwheeler.github.io/slick/
 */
var HeroCarousel = (_temp = _class = function (_Component) {
  _inherits(HeroCarousel, _Component);

  function HeroCarousel(props) {
    _classCallCheck(this, HeroCarousel);

    // ---
    // const { children } = props;
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var children = Array.isArray(props.children) ? props.children : [];
    var length = children.length;
    // console.log('HeroCarousel', children, length);
    var index = 0;
    /**
     * slider children `containerId` list
     * @type {string[]}
     */
    _this.idList = children.map(function (child, i) {
      return 'HeroCarousel-' + i;
    });
    // console.log('HeroCarousel', this.idList, children);
    // ---
    /**
     * children length
     * @type {number}
     */
    _this.length = length;
    /**
     * slick object - mount 後に設定されます
     * @type {?slick}
     */
    _this.slider = null;
    var buttons = Array(length).fill('');
    // const buttons = Array(length).keys().map(() => (''));
    buttons[index] = 'is-active';
    /**
     * bound onClickPager - pager click handler
     * @type {bound|any}
     */
    _this.onClickPager = _this.onClickPager.bind(_this);
    /**
     * bound onClickNext - next button click handler
     * @type {bound|any}
     */
    _this.onClickNext = _this.onClickNext.bind(_this);
    /**
     * bound onClickPrev - prev button click handler
     * @type {bound|any}
     */
    _this.onClickPrev = _this.onClickPrev.bind(_this);
    // /**
    //  * bound onAfterChange - slick afterChange callback
    //  * @type {bound|any}
    //  */
    // this.onAfterChange = this.onAfterChange.bind(this);
    /**
     * bound onBeforeChange - slick beforeChange callback
     * @type {bound|any}
     */
    _this.onBeforeChange = _this.onBeforeChange.bind(_this);
    /**
     * 現在 slide No.
     * @type {number}
     */
    _this.index = index;
    /**
     * `.slick-track` > slide nodes
     * @type {Array.<Element>}
     */
    _this.children = children;
    /**
     * modal open class
     * @type {string}
     */
    _this.modalOpened = 'HeroVideo__modal__opened';
    /**
     * photo info open 時に body へ設定される class - `.PhotoInfo__opened`
     */
    _this.infoOpened = 'PhotoInfo__opened';
    /**
     * autoPlay flag
     * @type {boolean}
     */
    _this.isAutoPlay = !!props.autoplay;
    /**
     * `requestAnimationFrame` id - cancel 時に使用します
     * @type {number}
     */
    _this.cycleId = 0;
    /**
     * carousel pause flag
     * @type {boolean}
     */
    _this.paused = false;
    // /**
    //  * bound onCycle
    //  * @type {bound|any}
    //  */
    // this.onCycle = this.onCycle.bind(this);
    /**
     * bind photoInfoWillOpen - {@link PhotoInfo} open callback
     * @type {bound|any}
     */
    _this.photoInfoWillOpen = _this.photoInfoWillOpen.bind(_this);
    /**
     * bind photoInfoWillClose - {@link PhotoInfo} close callback
     * @type {bound|any}
     */
    _this.photoInfoWillClose = _this.photoInfoWillClose.bind(_this);
    /**
     * bind modalWillOpen - {@link HeroVideo} modal open callback
     * @type {bound|any}
     */
    _this.modalWillOpen = _this.modalWillOpen.bind(_this);
    /**
     * bind modalWillClose - {@link HeroVideo} modal close callback
     * @type {bound|any}
     */
    _this.modalWillClose = _this.modalWillClose.bind(_this);
    // this.onSwipe = this.onSwipe.bind(this);
    /**
     * bind onTouchStart
     * @type {bound|any}
     */
    _this.onTouchStart = _this.onTouchStart.bind(_this);
    // this.onTouchMove = this.onTouchMove.bind(this);
    /**
     * bind onTouchEnd
     * @type {bound|any}
     */
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    /**
     * bind onTouchCancel
     * @type {bound|any}
     */
    _this.onTouchCancel = _this.onTouchCancel.bind(_this);
    /**
     * swipe 判定用の touch position values
     * @type {{start: Vectors, end: Vectors}}
     */
    _this.vectors = {
      start: new __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* Vectors */](),
      end: new __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* Vectors */]()
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    _this.swipeThreshold = 5;
    _this.modalIsOpen = false;
    _this.slick = {
      speed: 1000,
      // speed: 0,
      autoSpeedSecond: 5
    };
    // this.onArrowPrevTransitionEnd = this.onArrowPrevTransitionEnd.bind(this);
    // this.onArrowNextTransitionEnd = this.onArrowNextTransitionEnd.bind(this);
    // this.onMaskTransitionEnd = this.onMaskTransitionEnd.bind(this);
    _this.transitionClasses = {
      mask: 'HeroCarousel__mask__fadein',
      maskFaster: 'HeroCarousel__mask__fadein__faster',
      maskOut: 'HeroCarousel__mask__fadeout',
      maskGone: '',
      click: 'HeroCarousel__btn__clicked',
      blink: 'HeroCarousel__btn__blink'
    };
    _this.timer = {
      mask: 0,
      maskOut: 0,
      lazy: 0,
      slick: 0,
      arrow: 0,
      state: 0,
      intro: 0
    };
    // this.onLazyLoad = this.onLazyLoad.bind(this);
    /**
     * React.state
     * - buttons - {string[]} - pager state - current 時に `is-active` 設定します
     * @type {{
     *  buttons: any[],
     *  heroCarouselSlideId: string,
     *  maskClass: string,
     *  arrowPrevClass: string,
     *  arrowNextClass: string,
     *  transitionStart: boolean,
     *  transitionMaskStart: boolean,
     * }}
     */
    _this.state = {
      buttons: buttons,
      heroCarouselSlideId: _this.idList[0] || '',
      // ---
      transitionStart: false,
      transitionMaskStart: false,
      maskClass: _this.transitionClasses.maskGone,
      arrowPrevClass: '',
      arrowNextClass: '',
      introClass: '',
      figureHeight: 0,
      // ---
      requestMessageFlag: false
    };
    _this.slickStarted = false;
    _this.buttons = buttons;
    _this.heroCarouselSlideId = _this.state.heroCarouselSlideId;
    _this.transitionDelay = 480;
    /**
     * intro 終わるまで click 無効にする flag
     * @type {boolean}
     */
    _this.enableUi = true;
    // this.enableUi = false;
    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.figureList = {};
    return _this;
  }

  // --------------------------------------
  /**
   * mask へ `figure-block` の高さを設定するための callback
   * - {@link HeroImage} / {@link HeroVideo} から通知されます
   * - `heroCarouselSlideId` をもとに {@link HeroCarousel.figureList} へ設定します
   * @param {string} heroCarouselSlideId carousel id
   * @param {*} rect ClientRect
   */


  HeroCarousel.prototype.receiveMessage = function receiveMessage(heroCarouselSlideId, rect) {
    this.figureList[heroCarouselSlideId] = rect;
    // console.log('HeroCarousel.receiveMessage', heroCarouselSlideId, rect, this.figureList);
  };

  /**
   * state value へ {@link HeroCarousel.figureList} から height value を取り出し設定し返します
   * @param {*} state React.state
   * @returns {*} React.state
   */


  HeroCarousel.prototype.updateStateFigureHeight = function updateStateFigureHeight(state) {
    var rect = this.figureList[this.heroCarouselSlideId];
    state.figureHeight = rect && rect.height ? rect.height : 0;
    return state;
  };

  // --------------------------------------
  /**
   * {@link PhotoInfo} open callback
   * - auto play flag On -> pause
   */


  HeroCarousel.prototype.photoInfoWillOpen = function photoInfoWillOpen() {
    this.autoPlayWithPause();
  };

  /**
   * {@link PhotoInfo} close callback
   * - auto play flag On -> play
   */


  HeroCarousel.prototype.photoInfoWillClose = function photoInfoWillClose() {
    this.autoPlayWithPlay();
  };

  /**
   * {@link HeroVideo} modal open callback
   * - auto play flag On -> pause
   */


  HeroCarousel.prototype.modalWillOpen = function modalWillOpen() {
    this.autoPlayWithPause();
    this.modalIsOpen = true;
  };

  /**
   * {@link HeroVideo} modal close callback
   * - auto play flag On -> play
   */


  HeroCarousel.prototype.modalWillClose = function modalWillClose() {
    this.autoPlayWithPlay();
    this.modalIsOpen = false;
  };

  // --------------------------------------
  /**
   * autoPlay flag true の時に slick pause します
   */


  HeroCarousel.prototype.autoPlayWithPause = function autoPlayWithPause() {
    if (this.isAutoPlay) {
      // console.log('HeroCarousel.autoPlayWithPause', this.isAutoPlay, Date.now());
      this.slickPause();
    }
  };

  /**
   * autoPlay flag true の時に slick play します
   */


  HeroCarousel.prototype.autoPlayWithPlay = function autoPlayWithPlay() {
    if (this.isAutoPlay) {
      // console.log('HeroCarousel.autoPlayWithPlay', this.isAutoPlay, Date.now());
      this.slickPlay();
    }
  };

  /**
   * slick slider pause
   */


  HeroCarousel.prototype.slickPause = function slickPause() {
    this.paused = true;
    if (this.slider) {
      this.slider.slickPause();
    }
  };

  /**
   * slick slider play
   */


  HeroCarousel.prototype.slickPlay = function slickPlay() {
    this.paused = false;
    if (this.slider) {
      this.slider.slickPlay();
    }
  };

  // --------------------------------------
  /**
   * touch move value を初期化します
   */


  HeroCarousel.prototype.resetMove = function resetMove() {
    var _vectors = this.vectors,
        start = _vectors.start,
        end = _vectors.end;

    start.reset();
    end.reset();
  };

  /**
   * touchstart event handler
   * @param {Event} event touch event
   */


  HeroCarousel.prototype.onTouchStart = function onTouchStart(event) {
    // console.log('HeroCarousel.onTouchStart', this.enableUi);
    if (!this.modalIsOpen) {
      this.resetMove();
      this.vectors.start.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["j" /* eventWithPoint */])(event));
    }
  };
  // onTouchMove(event) {
  //     console.log('HeroCarousel.onTouchMove', event);
  //     // this.vectors.end = eventWithPoint(event);
  //     // const distanceX = this.vectors.end.distanceX(this.vectors.start);
  // }
  /**
   * touchend event handler
   * - swipe 実行判定します
   * @param {Event} event touch event
   */


  HeroCarousel.prototype.onTouchEnd = function onTouchEnd(event) {
    // console.log('HeroCarousel.onTouchEnd', event);
    if (!this.modalIsOpen) {
      this.vectors.end.updateWithVectors(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["j" /* eventWithPoint */])(event));
      var distanceX = this.vectors.end.distanceX(this.vectors.start);
      // console.log('HeroCarousel.onTouchEnd', distanceX);
      if (Math.abs(distanceX) >= this.swipeThreshold) {
        if (distanceX < 0) {
          // left
          this.slickNext();
        } else {
          // right
          this.slickPrev();
        }
      }
      this.resetMove();
    }
  };

  /**
   * touchCancel event handler
   */


  HeroCarousel.prototype.onTouchCancel = function onTouchCancel() {
    // console.log('HeroCarousel.onTouchCancel');
    this.resetMove();
  };

  // --------------------------------------
  /**
   * slick beforeChange callback
   * - pager current class を設定します
   * - slick - afterChange callback 不定期にしか来ないので使わない <- bug?
   * @param {number|string} current 変更前のスライド番号 - always `undefined` <- bug?
   * @param {number|string} next 変更後のスライド番号 - pager current に使用します
   */


  HeroCarousel.prototype.onBeforeChange = function onBeforeChange(current, next) {
    // const {
    //   transitionMaskStart,
    // } = this.state;
    // if (!transitionMaskStart) {
    //   this.transitionMaskFadeInOut(true);
    // }
    this.isTransitionMaskFadeInOut(true);
    this.resetTransitionTimer();
    // ---
    var index = parseInt(next, 10);
    var result = this.currentIndex(index);
    // console.log('HeroCarousel.onBeforeChange', current, next, result, index, this.heroCarouselSlideId);
    if (result) {
      // // this.enableUi = false;
      // const state = {
      //   buttons: this.buttons,
      //   heroCarouselSlideId: this.heroCarouselSlideId,
      //   requestMessageFlag: !this.state.requestMessageFlag,
      // };
      // // for mask height
      // // refresh state
      // this.setState(this.updateStateFigureHeight(state));
      this.slickChangeWithStateUpdate();
    }
  };

  HeroCarousel.prototype.slickChangeWithStateUpdate = function slickChangeWithStateUpdate() {
    // this.enableUi = false;
    var state = {
      buttons: this.buttons,
      heroCarouselSlideId: this.heroCarouselSlideId,
      requestMessageFlag: !this.state.requestMessageFlag
    };
    // for mask height
    // refresh state
    this.setState(this.updateStateFigureHeight(state));
  };

  HeroCarousel.prototype.isTransitionMaskFadeInOut = function isTransitionMaskFadeInOut() {
    var faster = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var transitionMaskStart = this.state.transitionMaskStart;

    if (!transitionMaskStart) {
      this.transitionMaskFadeInOut(faster);
    }
  };

  HeroCarousel.prototype.transitionMaskFadeInOut = function transitionMaskFadeInOut() {
    var faster = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    // this.enableUi = false;
    // ---
    this.resetTransitionTimer();
    // ---
    this.setState({
      transitionStart: false,
      transitionMaskStart: true,
      arrowNextClass: this.transitionClasses.click,
      arrowPrevClass: this.transitionClasses.blink,
      maskClass: faster ? this.transitionClasses.maskFaster : this.transitionClasses.mask
    });
    var delay = (faster ? 480 : 1000) + 32;
    this.delayFadeoutMaskClass(delay);
    this.delayClearArrowClass();
  };

  /**
   * `button.HeroCarousel__pager__dot` click event handler
   * - slick.slickGoTo 実行し slide を移動します
   * @param {Event} event click Event
   */


  HeroCarousel.prototype.onClickPager = function onClickPager(event) {
    event.preventDefault();
    // // ---
    // if (!this.enableUi) {
    //   return;
    // }
    // this.enableUi = false;
    // ---
    var target = event.target.nodeName.toLowerCase() === 'button' ? event.target : event.target.parentNode;
    var index = parseInt(target.dataset.index, 10);
    var result = this.currentIndex(index);
    // index 更新していない時は移動しない
    // console.log('HeroCarousel.onClickPager', result, index, this.index);
    if (result) {
      this.isTransitionMaskFadeInOut(true);
      this.resetTransitionTimer();
      this.slickGoTo(index);
    }
  };

  /**
   * `button.HeroCarousel__next` click event handler
   * - slick.slickNext を実行し next slide に移動します
   * @param {Event} event click Event
   */


  HeroCarousel.prototype.onClickNext = function onClickNext(event) {
    event.preventDefault();
    // console.log('HeroCarousel.onClickNext', this.enableUi);
    // if (!this.enableUi) {
    //   return;
    // }
    // ---
    this.slickNext();
  };

  /**
   * `button.HeroCarousel__prev` click event handler
   * - slick.slickPrev を実行し prev slide に移動します
   * @param {Event} event click Event
   */


  HeroCarousel.prototype.onClickPrev = function onClickPrev(event) {
    event.preventDefault();
    // if (!this.enableUi) {
    //   return;
    // }
    // ---
    this.slickPrev();
  };

  HeroCarousel.prototype.slickGoTo = function slickGoTo(index) {
    var _this2 = this;

    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.transitionDelay;

    this.resetTransitionTimer();
    var slider = this.slider;
    if (slider) {
      clearTimeout(this.timer.slick);
      // this.enableUi = false;
      this.timer.slick = setTimeout(function () {
        slider.slickGoTo(index);
        _this2.setState({ heroCarouselSlideId: _this2.heroCarouselSlideId });
      }, delay);
      // slider.slickGoTo(index);
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickGoTo', index);
      var state = {
        transitionStart: false,
        transitionMaskStart: true,
        arrowNextClass: this.transitionClasses.blink,
        arrowPrevClass: this.transitionClasses.blink,
        maskClass: this.transitionClasses.mask,
        buttons: this.buttons,
        requestMessageFlag: !this.state.requestMessageFlag
        // heroCarouselSlideId: this.heroCarouselSlideId,
      };
      this.setState(this.updateStateFigureHeight(state));
      this.delayFadeoutMaskClass();
      this.delayClearArrowClass();
    }
  };

  /**
   * slick.slickNext を実行し next slide に移動します
   * @param {number} [delay=this.transitionDelay] delay ms
   */


  HeroCarousel.prototype.slickNext = function slickNext() {
    var _this3 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.transitionDelay;

    // console.log('HeroCarousel.slickNext +++', delay);
    this.resetTransitionTimer();
    this.clearArrowClass();
    var slider = this.slider;
    if (slider) {
      // this.enableUi = false;
      this.timer.slick = setTimeout(function () {
        slider.slickNext();
      }, delay);
      // slider.slickNext();
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickNext');
      this.timer.state = setTimeout(function () {
        var state = {
          transitionStart: true,
          transitionMaskStart: true,
          arrowNextClass: _this3.transitionClasses.click,
          arrowPrevClass: _this3.transitionClasses.blink,
          maskClass: _this3.transitionClasses.mask,
          requestMessageFlag: !_this3.state.requestMessageFlag
        };
        _this3.setState(_this3.updateStateFigureHeight(state));
        _this3.delayFadeoutMaskClass();
        _this3.delayClearArrowClass();
      }, 32);
    }
  };

  /**
   * slick.slickPrev を実行し prev slide に移動します
   * @param {number} [delay=this.transitionDelay] delay ms
   */


  HeroCarousel.prototype.slickPrev = function slickPrev() {
    var _this4 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.transitionDelay;

    // console.log('HeroCarousel.slickPrev ---');
    this.resetTransitionTimer();
    this.clearArrowClass();
    var slider = this.slider;
    if (slider) {
      // this.enableUi = false;
      this.timer.slick = setTimeout(function () {
        slider.slickPrev();
      }, delay);
      // slider.slickPrev();
      this.photoInfoRemove();
      // ---
      // console.log('HeroCarousel.slickPrev');
      this.timer.state = setTimeout(function () {
        var state = {
          transitionStart: true,
          transitionMaskStart: true,
          arrowNextClass: _this4.transitionClasses.blink,
          arrowPrevClass: _this4.transitionClasses.click,
          maskClass: _this4.transitionClasses.mask,
          requestMessageFlag: !_this4.state.requestMessageFlag
        };
        _this4.setState(_this4.updateStateFigureHeight(state));
        _this4.delayFadeoutMaskClass();
        _this4.delayClearArrowClass();
      }, 32);
    }
  };

  // --------------------------------------
  /**
   * transition mask fadeout class を付与します
   * - use - {@link HeroCarousel.transitionClasses.maskOut}
   * - reserve - {@link HeroCarousel.delayGoneMaskClass}
   * @param {number} [delay=1032] fadein time 1000ms + 2frame
   */


  HeroCarousel.prototype.delayFadeoutMaskClass = function delayFadeoutMaskClass() {
    var _this5 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1032;

    // console.log('HeroCarousel.delayFadeoutMaskClass', delay, this.timer);
    clearTimeout(this.timer.mask);
    this.timer.mask = setTimeout(function () {
      _this5.setState({
        maskClass: _this5.transitionClasses.maskOut,
        transitionMaskStart: false
      });
      _this5.delayGoneMaskClass();
    }, delay);
  };

  /**
   * transition mask class remove
   * @param {number} [delay=1000] 遅延 time
   */


  HeroCarousel.prototype.delayGoneMaskClass = function delayGoneMaskClass() {
    var _this6 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

    clearTimeout(this.timer.maskOut);
    this.timer.maskOut = setTimeout(function () {
      // this.enableUi = true;
      _this6.setState({
        maskClass: _this6.transitionClasses.maskGone,
        transitionMaskStart: false,
        figureHeight: 0
      });
    }, delay);
  };

  HeroCarousel.prototype.clearArrowClass = function clearArrowClass() {
    // console.log('HeroCarousel.clearArrowClass');
    // clearTimeout(this.timer.arrow);
    // this.timeoutAll();
    this.setState({ transitionStart: false, arrowPrevClass: '', arrowNextClass: '' });
  };

  HeroCarousel.prototype.delayClearArrowClass = function delayClearArrowClass() {
    var _this7 = this;

    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1750;

    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(function () {
      _this7.clearArrowClass();
    }, delay);
  };

  // --------------------------------------
  /**
   * body から `.PhotoInfo__opened` 削除します
   */


  HeroCarousel.prototype.photoInfoRemove = function photoInfoRemove() {
    document.body.classList.remove(this.infoOpened);
  };

  /**
   * index を更新し pager current を設定します
   * - 現在 index と違う時のみ更新処理を行います
   * - state.buttons 更新します
   * @param {number} index slide index
   * @returns {boolean} true: 更新可能
   */


  HeroCarousel.prototype.currentIndex = function currentIndex(index) {
    // console.log('HeroCarousel.currentIndex', index, this.index);
    // 現在 index と違う時のみ更新処理を行います
    if (index === this.index) {
      return false;
    }
    this.index = index;
    var buttons = Array(this.length).fill('');
    buttons[index] = 'is-active';
    // ---
    // slider id を update し child component へ通知する
    var heroCarouselSlideId = this.idList[index];
    // ---
    // this.setState({ buttons, heroCarouselSlideId });
    this.buttons = buttons;
    this.heroCarouselSlideId = heroCarouselSlideId;
    return true;
  };

  // --------------------------------------
  // /**
  //  * @deprecated instead use dispose or timeOut each
  //  */
  // timeoutAll() {
  //   Object.values(this.timer).map(id => (setTimeout(id)));
  // }

  HeroCarousel.prototype.resetTransitionTimer = function resetTransitionTimer() {
    this.dispose();
  };
  /**
   * memory clear
   * - timerId clear all
   */


  HeroCarousel.prototype.dispose = function dispose() {
    Object.values(this.timer).map(function (id) {
      return setTimeout(id);
    });
  };
  // --------------------------------------


  HeroCarousel.prototype.shouldSlickAutoPlay = function shouldSlickAutoPlay() {
    // console.log('HeroCarousel.shouldSlickAutoPlay');
    this.autoPlayWithPlay();
    // this.enableUi = true;
  };

  // --------------------------------------
  /**
   * delegate - will unmount
   * - onCycle cancel します
   */


  HeroCarousel.prototype.componentWillUnmount = function componentWillUnmount() {
    // this.timeoutAll();
    this.dispose();
  };

  /**
   * delegate - after mount
   */


  HeroCarousel.prototype.componentDidMount = function componentDidMount() {
    var _this8 = this;

    this.autoPlayWithPause();
    this.setState({ introClass: 'HeroCarousel__started' });
    this.timer.intro = setTimeout(function () {
      _this8.shouldSlickAutoPlay();
    }, 3160);
  };

  // --------------------------------------
  /**
   * pager button を作成します
   * @returns {?Element[]} `button.HeroCarousel__pager__dot` list を返します
   */


  HeroCarousel.prototype.renderPagerButtons = function renderPagerButtons() {
    var _this9 = this;

    return Array(this.length).fill(0).map(function (value, index) {
      var key = 'pager-' + index;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          key: key,
          type: 'button',
          className: 'HeroCarousel__pager__dot ' + _this9.state.buttons[index],
          'data-index': index,
          onClick: _this9.onClickPager,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 894
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 901
          }
        })
      );
    });
  };

  /**
   * `div.HeroCarousel__pager__wrap` + `button.HeroCarousel__pager__dot` 作成します
   * @returns {?Element} pager - `div.HeroCarousel__pager__wrap`
   */


  HeroCarousel.prototype.renderPager = function renderPager() {
    if (this.length <= 1) {
      return null;
    }
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroCarousel__pager__wrap', __source: {
          fileName: _jsxFileName,
          lineNumber: 917
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'HeroCarousel__pager__block', __source: {
            fileName: _jsxFileName,
            lineNumber: 918
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'HeroCarousel__pager', __source: {
              fileName: _jsxFileName,
              lineNumber: 919
            }
          },
          this.renderPagerButtons()
        )
      )
    );
  };

  /**
   * prev / next arrow buttons 作成します
   * @returns {?Element} `.HeroCarousel__controls` container
   */


  HeroCarousel.prototype.renderControls = function renderControls() {
    if (this.length <= 1) {
      return null;
    }
    // ---
    var _state = this.state,
        arrowPrevClass = _state.arrowPrevClass,
        arrowNextClass = _state.arrowNextClass;
    // console.log('HeroCarousel.renderControls', arrowPrevClass, arrowNextClass);
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HeroCarousel__controls', __source: {
          fileName: _jsxFileName,
          lineNumber: 942
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'HeroCarousel__btn HeroCarousel__prev ' + arrowPrevClass,
          onClick: this.onClickPrev,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 943
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 948
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          type: 'button',
          className: 'HeroCarousel__btn HeroCarousel__next ' + arrowNextClass,
          onClick: this.onClickNext,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 950
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 955
          }
        })
      )
    );
  };

  HeroCarousel.prototype.renderMask = function renderMask() {
    var _state2 = this.state,
        maskClass = _state2.maskClass,
        figureHeight = _state2.figureHeight;

    var styles = figureHeight ? { style: { height: figureHeight + 'px' } } : null;
    // console.log('HeroCarousel.renderMask', maskClass, figureHeight);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({
      className: 'HeroCarousel__mask ' + maskClass
    }, styles, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 965
      }
    }));
  };

  // /**
  //  * `.slick-track` children を取得し {@link HeroCarousel.children} へ設定します
  //  * @returns {boolean} true: 取得成功
  //  */
  // choseChildren() {
  //     const slider = this.slider;
  //     console.log('HeroCarousel.choseChildren', slider);
  //     // const innerSlider = slider.innerSlider || {};
  //     // const list = innerSlider.list || {};
  //     // const childNodes = list.childNodes || [];
  //     // if (!childNodes.length) {
  //     //     return false;
  //     // }
  //     // const nodes = childNodes[0];
  //     // if (!nodes || !nodes.childNodes || !nodes.childNodes.length) {
  //     //     return false;
  //     // }
  //     // // this.childNodes = nodes.childNodes;
  //     // this.children = Array.from(nodes.childNodes);
  //     // return true;
  // }
  /**
   * carousel container - `.HeroCarousel` を作成します
   * - `react-slick` で carousel を作成します
   * @returns {?Element} HeroCarousel container を返します
   * @see https://github.com/akiran/react-slick
   */


  HeroCarousel.prototype.render = function render() {
    var _this10 = this;

    // ---
    if (!this.length) {
      return null;
    }
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        autoplay = _props.autoplay,
        duration = _props.duration,
        pcSize = _props.pcSize,
        mbSize = _props.mbSize,
        scrollToSlug = _props.scrollToSlug,
        children = _props.children;
    // ---
    // react-slick - @see https://react-slick.neostack.com/docs/api/
    // autoplaySpeed - カルーセルのオートプレイの秒数設定（秒）
    // @see https://react-slick.neostack.com/docs/api/#autoplaySpeed
    // milli seconds convert - default 3sec.

    var autoplaySpeed = (parseFloat(duration) || this.slick.autoSpeedSecond) * 1000;
    // autoplay - カルーセルのオートプレイ設定
    // @see https://react-slick.neostack.com/docs/api/#autoplay
    var settings = {
      // 1000
      speed: this.slick.speed,
      lazyLoad: 'progressive',
      arrows: false,
      autoplay: !!autoplay,
      // autoplay: false,
      ref: function ref(component) {
        return _this10.slider = component;
      },
      // afterChange: this.onAfterChange,
      beforeChange: this.onBeforeChange,
      // onLazyLoad: this.onLazyLoad,
      // ---
      onSwipe: this.onSwipe,
      // ---
      adaptiveHeight: true,
      slidesToShow: 1,
      fade: true,
      initialSlide: 0,
      // ---
      // swipeToSlide: true,
      // swipe: true,
      // touchMove: true,
      // useTransform: true,
      // ---
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      useTransform: false,
      // ---
      variableWidth: false,
      className: 'slick-fade',
      // ---
      autoplaySpeed: autoplaySpeed,
      // useCSS: false,
      waitForAnimate: false
    };
    // ---
    // size setting
    var sizePc = pcSize !== null && pcSize ? pcSize.toLowerCase() + 'Size-pc' : '';
    var sizeMb = mbSize !== null && mbSize ? mbSize.toLowerCase() + 'Size-mb' : '';
    // ---
    // scrollToSlug
    var scrollSlugClass = scrollToSlug === null || !scrollToSlug ? 'is-hide-scroll_btn' : 'is-show-scroll_btn';
    // ---
    // console.log('HeroCarousel.render idList', this.idList);
    // ---
    var introClass = this.state.introClass;
    // ---
    // output

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1071
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'HeroCarousel ' + sizePc + ' ' + sizeMb + ' ' + scrollSlugClass + ' ' + introClass, __source: {
            fileName: _jsxFileName,
            lineNumber: 1075
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'HeroCarousel__slick',
            onTouchStart: this.onTouchStart,
            onTouchEnd: this.onTouchEnd,
            onTouchCancel: this.onTouchCancel,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1076
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slider, {
            settings: settings,
            children: children,
            photoInfoWillOpen: this.photoInfoWillOpen,
            photoInfoWillClose: this.photoInfoWillClose,
            modalWillOpen: this.modalWillOpen,
            modalWillClose: this.modalWillClose,
            heroCarouselSlideId: this.state.heroCarouselSlideId,
            idList: this.idList,
            inHeroCarousel: true,
            sendMessage: this.receiveMessage,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1082
            }
          })
        ),
        this.renderMask(),
        this.renderControls(),
        this.renderPager()
      )
    );
  };

  return HeroCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  pcSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scrollToSlug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  autoplay: null,
  duration: null,
  pcSize: null,
  mbSize: null,
  scrollToSlug: null,
  components: null
}, _temp);
HeroCarousel.displayName = 'HeroCarousel';


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_top__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\standard-page\\index.jsx';






/**
 * StandardPage
 */
var StandardPage = function StandardPage(_ref) {
  var hideScrollTop = _ref.hideScrollTop,
      pcHeading = _ref.pcHeading,
      mbHeading = _ref.mbHeading,
      header = _ref.header,
      upperPageNavigation = _ref.upperPageNavigation,
      hero = _ref.hero,
      children = _ref.children,
      lowerPageNavigation = _ref.lowerPageNavigation,
      footer = _ref.footer,
      ctaNavi = _ref.ctaNavi,
      anchorNavi = _ref.anchorNavi,
      cookieEditor = _ref.cookieEditor;

  var getPcHeading = function getPcHeading() {
    if (pcHeading && pcHeading !== '') {
      return pcHeading;
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null;
  };
  var getMbHeading = function getMbHeading() {
    if (pcHeading && pcHeading !== '') {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      } else {
        return pcHeading;
      }
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'StandardPage', __source: {
        fileName: _jsxFileName,
        lineNumber: 49
      }
    },
    header !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'StandardPage__header', __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      header
    ) : null,
    upperPageNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: 'StandardPage__navigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      upperPageNavigation
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'main',
      { className: 'StandardPage__main', __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      },
      hero !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'hero', __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        hero
      ) : null,
      getPcHeading() !== null && getMbHeading() !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        { className: 'StandardPage__heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'StandardPage__heading-pc', __source: {
              fileName: _jsxFileName,
              lineNumber: 58
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getPcHeading()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 59
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'StandardPage__heading-mb', __source: {
              fileName: _jsxFileName,
              lineNumber: 61
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(getMbHeading()) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            }
          })
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          }
        },
        children !== null ? children : null
      )
    ),
    lowerPageNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: 'StandardPage__bottom-navigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        }
      },
      lowerPageNavigation
    ) : null,
    footer !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'StandardPage__footer', __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        }
      },
      footer
    ) : null,
    hideScrollTop === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: '#', className: 'js-StandardPageScrollTop StandardPage__scroll-top show with-cta-navigation', style: { bottom: 'calc(75px + env(safe-area-inset-bottom)' }, __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73
          }
        },
        'TOP'
      )
    ) : null,
    ctaNavi !== null ? ctaNavi : null,
    anchorNavi !== null ? anchorNavi : null,
    cookieEditor !== null ? cookieEditor : null
  );
};
StandardPage.displayName = 'StandardPage';
StandardPage.propTypes = {
  hideScrollTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showPageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  upperPageNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  lowerPageNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  ctaNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  anchorNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  cookieEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
StandardPage.defaultProps = {
  hideScrollTop: null,
  pageName: null,
  pcHeading: null,
  mbHeading: null,
  showPageTitle: null,
  header: null,
  upperPageNavigation: null,
  hero: null,
  children: null,
  lowerPageNavigation: null,
  footer: null,
  ctaNavi: null,
  anchorNavi: null,
  cookieEditor: null
};
/* harmony default export */ __webpack_exports__["a"] = (StandardPage);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\full-width\\index.jsx',
    _class,
    _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// ---

// ---

// ---



// ---------------------------------------
/**
 * description 出力タグを作成します
 * @param {?string} description HTML description
 * @param {string} [suffix=''] pc | mb
 * @param {string} [baseClass=FullWidth__wysiwyg] 基準 class name
 * @returns {?ReactElement} `div.FullWidth__wysiwyg-[pc|mn]`
 * @constructor
 */
var DescriptionTag = function DescriptionTag(_ref) {
  var description = _ref.description,
      suffix = _ref.suffix,
      baseClass = _ref.baseClass;

  if (!description) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: '' + baseClass + (suffix ? '-' : '') + suffix + ' Wysiwyg',
    dangerouslySetInnerHTML: { __html: description },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    }
  });
};

DescriptionTag.displayName = 'DescriptionTag';
DescriptionTag.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

DescriptionTag.defaultProps = {
  description: null,
  suffix: '',
  baseClass: 'FullWidth__wysiwyg'
};
// ---------------------------------------
var FullWidth = (_temp = _class = function (_Component) {
  _inherits(FullWidth, _Component);

  /**
   * opacity 0 にする class name
   * @type {string}
   */

  /**
   * parallax fixed class - `FullWidth__parallax__fixed`
   * @type {string}
   */
  function FullWidth(props) {
    _classCallCheck(this, FullWidth);

    // ---
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.videos = {
      pc: null,
      mb: null
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.ended = {
      pc: false,
      mb: false
    };
    /**
     * bound onPcPlay - pc.video.play event handler
     * @type {bound|any}
     */
    _this.onPcPlay = _this.onPcPlay.bind(_this);
    /**
     * bound onMbPlay - mb.video.play event handler
     * @type {bound|any}
     */
    _this.onMbPlay = _this.onMbPlay.bind(_this);

    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.playing = {
      pc: false,
      mb: false
    };
    // timer id
    _this.timer = {
      pc: 0,
      mb: 0,
      opacityComplete: 0
    };
    /**
     * bind onScroll - window.onscroll\onresize event handler
     * @type {bound|any}
     */
    _this.onScroll = _this.onScroll.bind(_this);
    /**
     * window.onresize event handler
     * @type {bound|any}
     */
    _this.onResize = _this.onResize.bind(_this);

    var pcVideoSrc = props.pcVideoSrc,
        mbVideoSrc = props.mbVideoSrc;

    var pcSrc = pcVideoSrc || '';
    var mbSrc = mbVideoSrc || pcSrc;
    /**
     * React.state
     * - visiblePc {boolean} - pc video visible flag
     * - visibleMb {boolean} - mb video visible flag
     * - fixed {string} - parallax fixed class
     * - bottom {string} - parallax bottom class
     * @type {{
     *  visiblePc: boolean,
     *  visibleMb: boolean,
     *  fixed: string,
     *  bottom: string,
     *  opacity: number,
     *  translateY: number,
     *  mbAspect: Object,
     *  opacityZero: ?string,
     *  parallaxAction: ?string,
     *  directionChange: boolean,
     * }}
     */
    _this.state = {
      visiblePc: !!pcSrc,
      visibleMb: !!mbSrc,
      fixed: '',
      bottom: '',
      // overlay opacity 0 to .77
      // opacity: 0,
      // `.FullWidth__figure` transform
      translateY: 0,
      // ---
      mbAspect: { opacity: 0 },
      // ===
      opacityZero: FullWidth.OPACITY_ZERO,
      parallaxAction: '',
      // ---
      scrollDirection: FullWidth.SCROLL_DOWN
    };
    _this.figureBlock = null;
    _this.isParallax = props.parallax;
    /**
     * element reference
     * - figure - `.FullWidth__figure`
     * - container - `.FullWidth__container`
     * @type {{figure: ?Element, container: ?Element}}
     */
    _this.elements = {
      figure: null,
      container: null
      // root: null,
    };
    /**
     * scroll 監視開始 flag
     * @type {boolean}
     */
    _this.watched = false;
    /**
     * 前回 scroll 位置
     * @type {number}
     */
    _this.y = -1;
    /**
     * offset value - future need
     * @type {number}
     */
    _this.offset = 0;
    /**
     * 定数 - 最大透明度
     * @type {number}
     */
    _this.opacityMax = 1 / 1.5;
    _this.onShouldPlay = _this.onShouldPlay.bind(_this);
    /**
     * PC - video.onCanPlay handler - 未使用
     * @deprecated - 使用しない
     * @type {bound|any}
     */
    _this.onPcCanPlay = _this.onPcCanPlay.bind(_this);
    /**
     * MB - video.onCanPlay handler
     * @type {bound|any}
     */
    _this.onMbCanPlay = _this.onMbCanPlay.bind(_this);
    /**
     * video.onCanPlay flag
     * - pc - 未使用
     * @type {{pc: boolean, mb: boolean}}
     */
    _this.canPlay = {
      pc: false,
      mb: false
    };
    // ---
    /**
     * default opacity 0 - 表示位置で fadein の duration 3000ms
     * - .FullWidth__parallax__action - transition-duration: 3000ms;
     * @type {number}
     * @default 3000
     */
    _this.fadeInDuration = 3000;
    /**
     * default opacity 0 - 表示位置で fadein complete flag
     * - fadein complete まで props.effect 発動しない
     * @type {boolean}
     * @default false
     */
    _this.fadeInCompleted = false;
    // ---
    // Dark-To-Light / Light-To-Dark - effect class name
    // scroll down - prop.effect || Light-To-Dark
    // scroll up - prop.effect ではない方
    /**
     * scroll direction flag - effect class select に使用します
     * - false: scroll down
     * - true: scroll up
     * @type {boolean}
     */
    _this.reversed = false;
    var defaultEffectClass = 'Light-To-Dark';
    var reverseClasses = {
      'Dark-To-Light': 'FullWidth__' + defaultEffectClass.toLowerCase(),
      'Light-To-Dark': 'FullWidth__' + 'Dark-to-Light'.toLowerCase()
    };
    /**
     * props.effect を元に設定 scroll down class name を作成します
     * @type {string}
     */
    _this.effectClass = 'FullWidth__' + (props.effect || defaultEffectClass).toLowerCase();
    /**
     * props.effect を元に設定 scroll up class name を作成します
     * @type {string}
     */
    _this.reverseClass = reverseClasses[props.effect] || reverseClasses[defaultEffectClass];
    // console.log('FullWidth', props.containerId, this.effectClass, this.reverseClass);
    _this.scrollDirection = FullWidth.SCROLL_DOWN;
    _this.scrolled = 0;
    // // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];
    // ---
    /**
     * CMS iframe flag
     * @type {boolean}
     * @default false
     */
    _this.inEpi = false;
    return _this;
  }
  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   // const video = this.videos.mb;
  //   // const playing = this.playing.mb;
  //   // if (video && !playing && this.hitTest()) {
  //   //   // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //   //   this.playVideo(false);
  //   // }
  //   // console.log('FullWidth.onTouchTriggerPlayVideo', this.videos.mb.paused, this.playing.mb);
  //   if (this.videos.mb.paused) {
  //     this.playVideo(false);
  //   }
  // }
  /**
   * @deprecated - not use
   */


  /**
   * props.effect を起動する class name
   * @type {string}
   */

  /**
   * parallax 背景 bottom class - `FullWidth__parallax__bottom`
   * @type {string}
   */

  /**
   * parallax flag true: class - `FullWidth__parallax`
   * @type {string}
   */


  FullWidth.prototype.onPcCanPlay = function onPcCanPlay() {
    if (this.isParallax || this.canPlay.pc) {
      return;
    }
    this.canPlay.pc = true;
    this.videoDimensions(true);
  };

  /**
   * mb - video.onCanPlay handler
   * - {@link FullWidth.isParallax}.mb を true 設定します
   * - {@link FullWidth.videoDimensions} 実行します
   */


  FullWidth.prototype.onMbCanPlay = function onMbCanPlay() {
    if (this.isParallax || this.canPlay.mb) {
      return;
    }
    this.canPlay.mb = true;
    this.videoDimensions(false);
  };

  /**
   * pc: video.play event handler
   * - timer clear
   * - playing flag true
   */


  FullWidth.prototype.onPcPlay = function onPcPlay() {
    clearTimeout(this.timer.pc);
    this.playing.pc = true;
  };

  /**
   * mb: video.play event handler
   * - timer clear
   * - playing flag true
   */


  FullWidth.prototype.onMbPlay = function onMbPlay() {
    clearTimeout(this.timer.mb);
    this.playing.mb = true;
    // this.disposeTouches();
  };

  // ---------------------------------------
  /**
   * window.onresize|onscroll event handler
   * - {@link FullWidth.checkShouldPlay} を実行します - 見えたら再生を判定後実行します
   */


  FullWidth.prototype.onShouldPlay = function onShouldPlay() {
    this.checkShouldPlay();
  };

  /**
   * 見えたら再生のための event watch
   */


  FullWidth.prototype.activateShouldPlay = function activateShouldPlay() {
    this.disposeShouldPlay();
    window.addEventListener('resize', this.onShouldPlay, false);
    window.addEventListener('scroll', this.onShouldPlay, false);
  };

  /**
   * 見えたら再生のための event unwatch
   */


  FullWidth.prototype.disposeShouldPlay = function disposeShouldPlay() {
    window.removeEventListener('resize', this.onShouldPlay);
    window.removeEventListener('scroll', this.onShouldPlay);
  };
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  /**
   * 見えたら再生範囲に入っているかをチェックします
   */


  FullWidth.prototype.checkShouldPlay = function checkShouldPlay() {
    var figure = this.elements.figure;

    if (!figure) {
      return;
    }
    var rect = figure.getBoundingClientRect();
    var top = rect.top,
        bottom = rect.bottom;

    var innerHeight = window.innerHeight;
    // console.log('FullWidth.checkShouldPlay', this.props.containerId, top, bottom, innerHeight);
    if (top >= 0 && top <= innerHeight || bottom >= 0 && bottom <= innerHeight) {
      // 表示エリアに入った
      this.playVideos();
    } else if (bottom < 0 || top > innerHeight) {
      // 見切れている
      // pause + rewind
      this.pauseVideos();
      this.rewindVideos();
    }
  };

  // ---------------------------------------
  /**
   * window.onresize event handler
   * - {@link FullWidth.scrolling} scroll ip / down 判定を行います
   */


  FullWidth.prototype.onResize = function onResize() {
    this.scrolling();
  };

  /**
   * window.onscroll event handler
   * - {@link FullWidth.scrolling} scroll ip / down 判定を行います
   */


  FullWidth.prototype.onScroll = function onScroll() {
    this.scrolling();
  };

  /**
   * scroll 監視を始めます
   * - {@link FullWidth.scrolling} 実行します
   */


  FullWidth.prototype.watchScroll = function watchScroll() {
    if (this.watched) {
      return;
    }
    this.watched = true;
    window.addEventListener('scroll', this.onScroll, false);
    this.scrolling();
  };

  /**
   * scroll 監視を止めます
   */


  FullWidth.prototype.unwatchScroll = function unwatchScroll() {
    window.removeEventListener('scroll', this.onScroll);
    this.watched = false;
  };

  /**
   * container / figure ClientRect を取得します
   * @returns {{container: ({bottom, height, left, right, top, width}|*|ClientRect|DOMRect), figure: ({bottom, height, left, right, top, width}|*|ClientRect|DOMRect)}}
   */


  FullWidth.prototype.getRectContainerWithFigure = function getRectContainerWithFigure() {
    var _elements = this.elements,
        container = _elements.container,
        figure = _elements.figure;

    return {
      container: container.getBoundingClientRect() || null,
      figure: figure.getBoundingClientRect() || null
    };
  };

  /**
   * container ClientRect を取得します - `.FullWidth__container`
   * @returns {{bottom, height, left, right, top, width}|*|ClientRect|DOMRect}
   */


  FullWidth.prototype.getContainerRect = function getContainerRect() {
    if (this.elements && this.elements.container && this.elements.container.getBoundingClientRect) {
      return this.elements.container.getBoundingClientRect();
    } else {
      return null;
    }
  };

  // /**
  //  * scroll 監視が必要かをチェックします
  //  * - container height が小さいと何もしなくて構わない
  //  * @returns {boolean} true: 必要
  //  */
  // checkActivationParallax() {
  //   const { parallax } = this.props;
  //   if (!parallax) {
  //     return false;
  //   }
  //   const { container, figure } = this.elements;
  //   if (!container || !figure) {
  //     return false;
  //   }
  //   const rect = this.getRectContainerWithFigure();
  //   // contents container が大きいことが条件
  //   return rect.figure.height <= rect.container.height;
  // }

  // containerBiggerThanFigure() {
  //   const { container, figure } = this.elements;
  //   if (!container || !figure) {
  //     return false;
  //   }
  //   const rect = this.getRectContainerWithFigure();
  //   // contents container が大きいことが条件
  //   return rect.figure.height <= rect.container.height;
  // }

  /**
   * scroll 処理 - up / down で分岐します
   * - down - {@link FullWidth.parallaxScrollDown}
   * - up - {@link FullWidth.parallaxScrollUp}
   */


  FullWidth.prototype.scrolling = function scrolling() {
    // const activateParallax = this.checkActivationParallax();
    var y = window.pageYOffset;
    var move = this.y - y;
    if (!move) {
      return;
    }
    this.y = y;
    // console.log('FullWidth.scrolling - move', this.props.containerId, move);
    if (move < 0) {
      this.parallaxScrollDown(move);
    } else {
      this.parallaxScrollUp(move);
    }
    this.checkFullWidthFadeIn(move);
  };

  /**
   * fadein duration 後の timeout 処理で {@link FullWidth.fadeInCompleted} flag を true にします
   * - {@link FullWidth.fadeInCompleted} が true になるまで `props.effect` action は実行されません
   */


  FullWidth.prototype.fadeInStart = function fadeInStart() {
    var _this2 = this;

    clearTimeout(this.timer.opacityComplete);
    this.setState({ opacityZero: '' });
    this.timer.opacityComplete = setTimeout(function () {
      _this2.fadeInCompleted = true;
    }, this.fadeInDuration);
  };

  /**
   * {@link FullWidth.getContainerRect} `.FullWidth__container`.clientRect を取得し fade 開始するか否かを判断し実行します
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */


  FullWidth.prototype.checkFullWidthFadeIn = function checkFullWidthFadeIn(move) {
    if (!this.state.opacityZero) {
      return;
    }
    var height = window.innerHeight;
    var half = height * 0.5;
    var containerRect = this.getContainerRect();
    if (!containerRect) return;
    var middle = containerRect.height * 0.5;
    if (move < 0) {
      // scroll up
      if ((containerRect.top <= half || containerRect.top + middle <= height) && containerRect.bottom > 0) {
        this.fadeInStart();
      }
    } else if (containerRect.bottom >= half && containerRect.top < height) {
      // scroll down
      this.fadeInStart();
    }
  };

  // /**
  //  * `.FullWidth__figure__parallax__overlay` opacity を計算します
  //  * @param {ClientRect} container `div.FullWidth__container` bounding box values
  //  */
  // overlayOpacityByScroll(container) {
  //   const { top, height } = container;
  //   const distance = (Math.abs(top) - this.offset) / height * 3.333;
  //   const opacity = (distance < this.opacityMax) ? distance: this.opacityMax;
  //   if (this.state.opacity !== opacity) {
  //     this.setState({ opacity });
  //   }
  // }

  /**
   * `.FullWidth__figure` parallax delay scroll down
   * @param {ClientRect} container `div.FullWidth__container` bounding box values
   * @param {number} innerHeight window.innerHeight
   */


  FullWidth.prototype.slowParallaxScrollDown = function slowParallaxScrollDown(container, innerHeight) {
    var bottom = container.bottom;

    var translateY = (innerHeight - bottom) * 0.5;
    if (this.state.translateY !== translateY) {
      this.setState({ translateY: translateY });
    }
  };

  /**
   * `.FullWidth__figure` parallax delay scroll up
   * @param {ClientRect} container `div.FullWidth__container` bounding box values
   * @param {number} innerHeight window.innerHeight
   */


  FullWidth.prototype.slowParallaxScrollUp = function slowParallaxScrollUp(container, innerHeight) {
    var bottom = container.bottom;

    var translateY = (innerHeight - bottom) * 0.5;
    // console.log('FullWidth.slowParallaxScrollUp', translateY);
    if (translateY >= 0) {
      if (this.state.translateY !== translateY) {
        this.setState({ translateY: translateY });
      }
    } else if (this.state.translateY) {
      this.setState({ translateY: 0 });
    }
  };

  /**
   * parallax light-to-dark / dark-to-light transition クラスを `state` に追加し開始します
   */


  FullWidth.prototype.activateParallaxAction = function activateParallaxAction() {
    if (this.state.parallaxAction) {
      return;
    }
    this.setState({ parallaxAction: FullWidth.PARALLAX_ACTION });
  };

  /**
   * parallax light-to-dark / dark-to-light off にします
   */


  FullWidth.prototype.abortParallaxAction = function abortParallaxAction() {
    if (!this.state.parallaxAction) {
      return;
    }
    this.setState({ parallaxAction: '' });
  };

  /**
   * @deprecated instead use {@link FullWidth.parallaxScrollColorTransition}
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} height - window.innerHeight
   */


  FullWidth.prototype.parallaxScrollDownAction = function parallaxScrollDownAction(containerRect, height) {
    var half = height * 0.5;
    var middle = containerRect.height * 0.5;
    if ((containerRect.top <= half || containerRect.top + middle <= height) && containerRect.bottom > 0) {
      this.activateParallaxAction();
    } else if (containerRect.bottom < 0) {
      this.abortParallaxAction();
    }
  };
  /**
   * @deprecated instead use {@link FullWidth.parallaxScrollColorTransition}
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} height - window.innerHeight
   */


  FullWidth.prototype.parallaxScrollUpAction = function parallaxScrollUpAction(containerRect, height) {
    var half = height * 0.5;
    if (containerRect.bottom >= half && containerRect.top < height) {
      this.activateParallaxAction();
    } else if (containerRect.top > height) {
      this.abortParallaxAction();
    }
  };

  FullWidth.prototype.parallaxScrollColorTransitionScrollDown = function parallaxScrollColorTransitionScrollDown(containerRect, innerHeight) {
    var top = containerRect.top;

    var middle = innerHeight * 0.5;
    var absTop = Math.abs(top);
    if (top < 0 && absTop >= middle) {
      this.activateParallaxAction();
    }
  };

  FullWidth.prototype.parallaxScrollColorTransitionScrollUp = function parallaxScrollColorTransitionScrollUp(containerRect, innerHeight) {
    var bottom = containerRect.bottom;

    var middle = innerHeight * 0.5;
    if (bottom >= innerHeight + middle) {
      this.activateParallaxAction();
    }
  };
  /**
   * ▽FullWidthブロック自体のフェードイン効果
   * ・FullWidthブロックはデフォルト非表示（visibility:hidden (or/and opacity:0)で領域は確保したまま。ブロック全体を透過させて、親要素の背景色が反映されるようにする）
   * ・特定位置までスクロールすると（すでに実装いただいている動画開始と同じところで）フェードイン開始
   * ・はじめに背景イメージがフェードイン、少し遅れてテキストやボタン等の要素がフェードイン
   *
   * ▽背景画像が暗く／明るくなる効果
   * ・スクロール量に合わせて明度が変わるのではなく、一定の高さになったらフェードする（on/offする）ように変更いただきたいです
   * ・一定の高さ：FullWidthブロックが画面状態に達してから、ウィンドウの高さの半分がスクロールされたら
   *
   *
   * 背景が明るく/暗くなるのは、FullWidthがフェードインして、画面上端でロックされて、さらに一定量のスクロールを行った後、になります。
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} innerHeight - window.innerHeight
   * @param {boolean} [up=false] scroll direction - true: scroll up
   */


  FullWidth.prototype.parallaxScrollColorTransition = function parallaxScrollColorTransition(containerRect, innerHeight) {
    var up = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var top = containerRect.top,
        bottom = containerRect.bottom;
    // const middle = innerHeight * 0.5;
    // const absTop = Math.abs(top);

    if (bottom < 0 || top > innerHeight || !this.fadeInCompleted) {
      // 見切れている
      // fadein transition が終わっていない
      if (bottom < 0) {
        this.reversed = true;
      } else if (top > innerHeight) {
        this.reversed = false;
      }
      this.abortParallaxAction();
    } else if (!up) {
      this.parallaxScrollColorTransitionScrollDown(containerRect, innerHeight);
    } else if (up) {
      this.parallaxScrollColorTransitionScrollUp(containerRect, innerHeight);
    }
    // else if (!up && top < 0 && (absTop >= middle)) {
    //   // scroll down
    //   // console.log('FullWidth.parallaxScrollColorTransition --- scroll down', this.props.containerId, up, absTop, innerHeight, middle, containerRect);
    //   this.activateParallaxAction();
    // } else if (up && (bottom >= (innerHeight + middle))) {
    //   // scroll up
    //   // console.log('FullWidth.parallaxScrollColorTransition --- scroll up', this.props.containerId, up, bottom, innerHeight, middle, containerRect);
    //   this.activateParallaxAction();
    // }
  };
  /**
   * scroll down 処理
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */


  FullWidth.prototype.parallaxScrollDown = function parallaxScrollDown(move) {
    var parallax = this.props.parallax;

    if (!parallax) {
      return;
    }
    var containerRect = this.getContainerRect();
    if (!containerRect) return;
    var height = window.innerHeight;
    var threshold = height * 0.5;
    // ---
    // scroll 量
    if (this.scrollDirection !== FullWidth.SCROLL_DOWN) {
      this.scrollDirection = FullWidth.SCROLL_DOWN;
      this.scrolled = 0;
    }
    this.scrolled += Math.abs(move);
    if (this.scrolled >= threshold && this.state.scrollDirection !== this.scrollDirection) {
      this.reversed = false;
      this.setState({ scrollDirection: this.scrollDirection });
    }
    // ---
    this.parallaxScrollColorTransition(containerRect, height, false);
    // container bottom が window height より小さい -> 上に来ている -> container bottom へ貼り付ける
    var needBottom = containerRect.bottom <= height;
    var needUpdateBottom = needBottom && this.state.bottom !== FullWidth.BOTTOM;
    // console.log('FullWidth.parallaxScrollDown', height, containerRect, needBottom, needUpdateBottom);
    if (needUpdateBottom) {
      return this.setState({ fixed: '', bottom: FullWidth.BOTTOM });
    } else if (needBottom) {
      if (containerRect.bottom >= 0) {
        this.slowParallaxScrollDown(containerRect, height);
      } else {
        this.setState({ translateY: null });
      }
      return;
    }
    // -------------------------------------------

    // ------ window.top(0) + this.offset
    //
    //   ****** container.top
    //
    // ------ window.bottom - window.innerHeight
    // ---
    // this.overlayOpacityByScroll(container);
    // ---
    var needFixed = containerRect.top <= this.offset;
    var needUpdateFixed = needFixed && this.state.fixed !== FullWidth.FIXED;
    // console.log('FullWidth.parallaxScrollDown', height, rect, needBottom, needUpdateBottom);
    if (needUpdateFixed) {
      this.setState({ fixed: FullWidth.FIXED, bottom: '' });
    }
  };

  /**
   * scroll up 処理
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */


  FullWidth.prototype.parallaxScrollUp = function parallaxScrollUp(move) {
    var parallax = this.props.parallax;

    if (!parallax) {
      return;
    }
    var containerRect = this.getContainerRect();
    if (!containerRect) return;
    var height = window.innerHeight;
    var threshold = height * 0.5;
    // ---
    // scroll 量
    if (this.scrollDirection !== FullWidth.SCROLL_UP) {
      this.scrollDirection = FullWidth.SCROLL_UP;
      this.scrolled = 0;
    }
    this.scrolled += Math.abs(move);
    if (this.scrolled >= threshold && this.state.scrollDirection !== this.scrollDirection) {
      this.reversed = true;
      this.setState({ scrollDirection: this.scrollDirection });
    }
    // ---
    // this.parallaxScrollUpAction(containerRect, height);
    this.parallaxScrollColorTransition(containerRect, height, true);
    // ---
    var needFree = containerRect.top >= this.offset;
    var needUpdateFree = needFree && (this.state.bottom !== '' || this.state.fixed !== '');
    // console.log('FullWidth.parallaxScrollUp', needUpdateFree, needFree);
    if (needUpdateFree) {
      var nextState = { fixed: '', bottom: '' };
      if (this.state.translateY) {
        nextState.translateY = 0;
      }
      return this.setState(nextState);
    } else if (needFree) {
      return;
    }
    // ---
    if (containerRect.bottom >= 0) {
      this.slowParallaxScrollUp(containerRect, height);
    }
    // ---
    var needFixed = containerRect.bottom >= height;
    var needUpdateFixed = needFixed && this.state.fixed !== FullWidth.FIXED;
    if (needUpdateFixed) {
      this.setState({ fixed: FullWidth.FIXED, bottom: '' });
    }
  };
  /**
   * 強制実行します
   */


  FullWidth.prototype.fireScrollEvent = function fireScrollEvent() {
    this.parallaxScrollDown();
  };
  // ---------------------------------------
  /**
   * alignment - position class name を生成します
   * @returns {{pc: string, mb: string}} alignment - position class name
   */


  FullWidth.prototype.alignmentPosition = function alignmentPosition() {
    var _props = this.props,
        pcPosition = _props.pcPosition,
        mbPosition = _props.mbPosition;

    var pc = 'pcPosition__' + (pcPosition || 'Center-Upper').toLowerCase();
    var mb = 'mbPosition__' + (mbPosition || 'Upper').toLowerCase();
    return { pc: pc, mb: mb };
  };
  /**
   * vertical size class name を生成します
   * @returns {{pc: string, mb: string, parallax: string}} vertical size class name
   */


  FullWidth.prototype.verticalSizeClassName = function verticalSizeClassName() {
    var _props2 = this.props,
        pcVerticalSize = _props2.pcVerticalSize,
        mbVerticalSize = _props2.mbVerticalSize,
        parallax = _props2.parallax;

    var pc = 'pcVerticalSize__' + (pcVerticalSize || 'Medium').toLowerCase();
    var mb = 'mbVerticalSize__' + (mbVerticalSize || 'Medium').toLowerCase();
    return {
      pc: pc,
      mb: mb,
      parallax: parallax && !this.inEpi ? FullWidth.PARALLAX : ''
    };
  };
  // --------------------------------------------------------
  // video control
  /**
   * video tag muted property を true 設定します
   * - video.mute が有効にならないので property 設定します
   */


  FullWidth.prototype.videoMute = function videoMute() {
    Object.values(this.videos).map(function (video) {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  };
  /**
   * video.play success 処理
   * - playing flag true
   * @param {boolean} pc video file select flag - true: PC
   */


  FullWidth.prototype.playSuccess = function playSuccess(pc) {
    if (pc) {
      this.playing.pc = true;
    } else {
      this.playing.mb = true;
    }
  };
  // -----------------------------------------------------
  /**
   * error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} error video play error message
   * @returns {boolean} true - 非表示実行
   */


  FullWidth.prototype.needHideVideo = function needHideVideo(pc, error) {
    if (!error || !error.message) {
      // console.warn('FullWidth.needHideVideo error not found', pc, error);
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    var massages = ['no supported source', 'interact with'];
    var result = massages.some(function (message) {
      return error.message.indexOf(message) !== -1;
    });
    // console.log('FullWidth.needHideVideo result', pc, result, error.message);
    if (result) {
      var state = pc ? { visiblePc: false } : { visibleMb: false };
      this.setState(state);
      return true;
    }
    return false;
  };
  /**
   * {@link FullWidth.needHideVideo} - error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} [error=null] video play error message
   */


  FullWidth.prototype.playFaultAlternateImage = function playFaultAlternateImage(pc) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }
    this.pauseVideo(pc);
    this.rewindVideo(pc);
  };
  /**
   * video.play fault 処理
   * - visible flag を false にし非表示にします
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} [error=null] video play error message
   */


  FullWidth.prototype.playFault = function playFault(pc) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    this.playFaultAlternateImage(pc, error);
  };
  /**
   * HTML5 video 再生します
   * - 再生失敗した時は非表示実行します
   * @param {boolean} pc desktop flag
   */


  FullWidth.prototype.playVideo = function playVideo(pc) {
    var _this3 = this;

    var video = pc ? this.videos.pc : this.videos.mb;
    // const playing = (pc) ? this.playing.pc: this.playing.mb;
    var ended = pc ? this.ended.pc : this.ended.mb;
    var _state = this.state,
        visiblePc = _state.visiblePc,
        visibleMb = _state.visibleMb;

    var visible = pc ? visiblePc : visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !visible || ended) {
      return;
    }
    if (!video.paused) {
      return;
    }
    var playPromise = null;
    try {
      playPromise = video.play();
      this.playSuccess(pc);
    } catch (e) {
      console.warn('[FullWidth] play video fault - pc: ' + pc + ', ' + error);
      this.playFault(pc, e);
    }
    if (playPromise) {
      playPromise.catch(function (error) {
        console.warn('[FullWidth] play video fault in Promise - pc: ' + pc + ', ' + error);
        _this3.playFault(pc, error);
      });
    }
  };
  /**
   * video 再生します
   */


  FullWidth.prototype.playVideos = function playVideos() {
    // pc
    this.playVideo(true);
    // mb
    this.playVideo(false);
  };
  /**
   * video tag - pause 実行します
   * @param {boolean} pc desktop flag
   */


  FullWidth.prototype.pauseVideo = function pauseVideo(pc) {
    var video = pc ? this.videos.pc : this.videos.mb;
    var playing = pc ? this.playing.pc : this.playing.mb;
    var _state2 = this.state,
        visiblePc = _state2.visiblePc,
        visibleMb = _state2.visibleMb;

    var visible = pc ? visiblePc : visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !playing || !visible) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // ---
    try {
      video.pause();
    } catch (error) {
      console.warn('[FullWidth].pauseVideo fault - pc: ' + pc + ', ' + error, video.src);
      // this.playFault(pc);
    }
    // if (pc) {
    //   this.playing.pc = false;
    // } else {
    //   this.playing.mb = false;
    // }
  };
  /**
   * video pause - (pc / mb)
   */


  FullWidth.prototype.pauseVideos = function pauseVideos() {
    // pc
    this.pauseVideo(true);
    // mb
    this.pauseVideo(false);
  };
  /**
   * rewind します
   * @param {boolean} pc desktop flag
   */


  FullWidth.prototype.rewindVideo = function rewindVideo(pc) {
    var video = pc ? this.videos.pc : this.videos.mb;
    var _state3 = this.state,
        visiblePc = _state3.visiblePc,
        visibleMb = _state3.visibleMb;

    var visible = pc ? visiblePc : visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !visible) {
      return;
    }
    // 再生中は rewind しない
    if (!video.paused) {
      return;
    }
    // ---
    try {
      video.currentTime = 0;
    } catch (e) {
      console.warn('[FullWidth].rewindVideo', pc, video.src, e);
    }
  };
  /**
   * 1 frame 目に戻す(rewind) - (pc / mb)
   */


  FullWidth.prototype.rewindVideos = function rewindVideos() {
    // pc
    this.rewindVideo(true);
    // mb
    this.rewindVideo(false);
  };
  // --------------------------------------------------------
  /**
   * event を unbind します - parallax
   */


  FullWidth.prototype.abortWatchResize = function abortWatchResize() {
    window.removeEventListener('resize', this.onResize);
  };

  /**
   * event 監視を有効にします - parallax
   */


  FullWidth.prototype.activateWatchResize = function activateWatchResize() {
    this.abortWatchResize();
    window.addEventListener('resize', this.onResize, false);
  };
  // --------------------------------------------------------
  /**
   * video size が css だけでは制御不可能なので JS で補助します
   * - mb だけ使用します
   * @param {boolean} mode pc / mb flag, true: pc
   */


  FullWidth.prototype.videoDimensions = function videoDimensions(mode) {
    var video = mode ? this.videos.pc : this.videos.mb;
    var block = this.figureBlock.getBoundingClientRect();
    var x = block.width / video.videoWidth;
    var y = block.height / video.videoHeight;
    if (x < y) {
      this.setState({ mbAspect: { height: '100%' } });
    } else {
      this.setState({ mbAspect: { width: '100%' } });
    }
  };

  // --------------------------------------------------------
  // CMS preview 用に parallax ON / OFF する


  FullWidth.prototype.activateNormalParallax = function activateNormalParallax() {
    this.activateWatchResize();
    this.watchScroll();
    this.fireScrollEvent();
    // -----------------------
    // 見えたら再生
    this.activateShouldPlay();
    // first check
    this.checkShouldPlay();
  };

  FullWidth.prototype.inIframeShowAll = function inIframeShowAll() {
    // this.inEpi = true;
    this.setState({ opacityZero: '', parallaxAction: FullWidth.PARALLAX_ACTION });
    this.playVideos();
  };

  // --------------------------------------------------------
  /**
   * delegate after mount
   * - playing
   */


  FullWidth.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    this.videoMute();
    // CMS - iframe preview へ対応する
    // ref: https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-269#comment-9536200
    if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.EPi) {
      // 編集プレビュー時の処理
      //・パララックスをOFFにする（レイアウト崩れ対応）
      //・初期非表示をOFFにする（表示されない問題対応）
      setTimeout(function () {
        _this4.inIframeShowAll();
      }, 200);
      // this.inIframeShowAll();
    } else {
      setTimeout(function () {
        _this4.activateNormalParallax();
      }, 200);
      // this.activateNormalParallax();
    }
    // ---
    // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  };
  /**
   * delegate - before unmount
   * - timer clear する
   */


  FullWidth.prototype.componentWillUnmount = function componentWillUnmount() {
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
    this.abortWatchResize();
    this.unwatchScroll();
    this.disposeShouldPlay();
    // this.disposeTouches();
  };
  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=FullWidth__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.FullWidth__video` tag を返します
   */


  FullWidth.prototype.renderVideo = function renderVideo(src) {
    var poster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _this5 = this;

    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var baseClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'FullWidth__video';

    // 制御に必要な property が無い時は null を返す
    if (src === null || !src || !suffix) {
      return null;
    }
    // state - visible
    var _state4 = this.state,
        visiblePc = _state4.visiblePc,
        visibleMb = _state4.visibleMb,
        mbAspect = _state4.mbAspect;
    // ---

    var isPc = suffix === 'pc';
    var visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // ---
    // class name
    var className = baseClass + ' ' + baseClass + (suffix ? '-' : '') + suffix;
    // video tag
    var attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: true,
      playsInline: true,
      muted: true,
      loop: true,
      src: src,
      className: className,
      type: 'video/' + src.split('.').pop().split('?').shift()
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    if (suffix === 'pc') {
      attributes.ref = function (component) {
        return _this5.videos.pc = component;
      };
      attributes.onPlay = this.onPcPlay;
      attributes.style = visiblePc ? null : { display: 'none' };
      // attributes.onCanPlay = this.onPcCanPlay;
    } else if (suffix === 'mb') {
      var style = {};
      if (!this.isParallax) {
        style = Object.assign({}, mbAspect);
        attributes.onCanPlay = this.onMbCanPlay;
      }
      if (!visibleMb) {
        style.display = 'none';
      }
      attributes.ref = function (component) {
        return _this5.videos.mb = component;
      };
      attributes.onPlay = this.onMbPlay;
      attributes.style = style;
    }
    // tag
    // console.log('FullWidth.renderVideo attributes', suffix, attributes);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({}, attributes, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1247
      }
    }));
  };

  FullWidth.prototype.renderFigureOverlay = function renderFigureOverlay() {
    var parallax = this.props.parallax;
    // const { opacity } = this.state;

    return parallax ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'FullWidth__figure__parallax__overlay', __source: {
        fileName: _jsxFileName,
        lineNumber: 1252
      }
    }) : null;
  };

  FullWidth.prototype.renderFigureVideo = function renderFigureVideo() {
    var _props3 = this.props,
        pcVideoSrc = _props3.pcVideoSrc,
        mbVideoSrc = _props3.mbVideoSrc,
        pcImageSrc = _props3.pcImageSrc,
        mbImageSrc = _props3.mbImageSrc;

    var pcSrc = pcVideoSrc || '';
    var mbSrc = mbVideoSrc || pcSrc;
    if (!pcSrc && !mbSrc) {
      return null;
    }
    var posterPc = pcImageSrc || '';
    var posterMb = mbImageSrc || posterPc;
    var pc = this.renderVideo(pcSrc, posterPc, 'pc');
    var mb = this.renderVideo(mbSrc, posterMb, 'mb');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FullWidth__figure__videos', __source: {
          fileName: _jsxFileName,
          lineNumber: 1272
        }
      },
      pc,
      mb
    );
  };

  FullWidth.prototype.renderFigureImg = function renderFigureImg() {
    var _props4 = this.props,
        pcImageSrc = _props4.pcImageSrc,
        mbImageSrc = _props4.mbImageSrc;

    var posterMb = mbImageSrc || pcImageSrc;

    if (!pcImageSrc && !posterMb) {
      return null;
    }
    // const pcSrc = pcVideoSrc || '';
    // const mbSrc = mbVideoSrc || pcSrc;
    // state - visible
    var _state5 = this.state,
        visiblePc = _state5.visiblePc,
        visibleMb = _state5.visibleMb;


    var pc = pcImageSrc && !visiblePc ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'FullWidth__figure__img FullWidth__figure__img-pc',
      style: { backgroundImage: 'url(' + pcImageSrc + ')' },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1297
      }
    }) : null;
    var mb = posterMb && !visibleMb ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'FullWidth__figure__img FullWidth__figure__img-mb',
      style: { backgroundImage: 'url(' + posterMb + ')' },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 1303
      }
    }) : null;
    if (!pc && !mb) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FullWidth__figure__images', __source: {
          fileName: _jsxFileName,
          lineNumber: 1312
        }
      },
      pc,
      mb
    );
  };

  FullWidth.prototype.renderFigure = function renderFigure() {
    var _this6 = this;

    var videos = this.renderFigureVideo();
    var images = this.renderFigureImg();
    if (!videos && !images) {
      return null;
    }
    var photoInfo = this.props.photoInfo;
    // photoInfo - arrayOf だけど出力は1件

    var PhotoInfo = photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length ? photoInfo : [];
    var overlay = this.renderFigureOverlay();
    // ---
    var translateY = this.state.translateY;

    var figureArguments = translateY ? { style: { transform: 'translateY(' + translateY + 'px)' } } : null;
    // ---
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FullWidth__figure__block',
        ref: function ref(component) {
          return _this6.figureBlock = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1336
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: 'FullWidth__figure',
          ref: function ref(component) {
            return _this6.elements.figure = component;
          }
        }, figureArguments, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1340
          }
        }),
        videos,
        images,
        overlay
      ),
      PhotoInfo
    );
  };

  FullWidth.prototype.renderDescription = function renderDescription() {
    var _this7 = this;

    var _props5 = this.props,
        pcDescription = _props5.pcDescription,
        mbDescription = _props5.mbDescription;
    // mb - description, use pc when empty

    var mbHtml = mbDescription || pcDescription;
    var pc = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescriptionTag, { description: pcDescription, suffix: 'pc', __source: {
        fileName: _jsxFileName,
        lineNumber: 1361
      }
    });
    var mb = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DescriptionTag, { description: mbHtml, suffix: 'mb', __source: {
        fileName: _jsxFileName,
        lineNumber: 1362
      }
    });
    // const pc = FullWidth.descriptionTag(pcDescription, 'pc');
    // const mb = FullWidth.descriptionTag(mbHtml, 'mb');
    if (!pc && !mb) {
      return null;
    }
    var alignment = this.alignmentPosition();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FullWidth__container ' + alignment.pc + ' ' + alignment.mb,
        ref: function ref(component) {
          return _this7.elements.container = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1370
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FullWidth__wysiwyg', __source: {
            fileName: _jsxFileName,
            lineNumber: 1374
          }
        },
        pc,
        mb
      )
    );
  };

  FullWidth.prototype.render = function render() {
    var _props6 = this.props,
        containerId = _props6.containerId,
        containerClass = _props6.containerClass,
        anchorPoint = _props6.anchorPoint,
        anchorName = _props6.anchorName,
        link = _props6.link;
    // ---

    var description = this.renderDescription();
    var figure = this.renderFigure();
    // require check
    if (!description && !figure) {
      return null;
    }

    var _verticalSizeClassNam = this.verticalSizeClassName(),
        pc = _verticalSizeClassNam.pc,
        mb = _verticalSizeClassNam.mb,
        parallax = _verticalSizeClassNam.parallax;

    var _state6 = this.state,
        fixed = _state6.fixed,
        bottom = _state6.bottom,
        opacityZero = _state6.opacityZero,
        parallaxAction = _state6.parallaxAction;

    var effectClass = !this.reversed ? this.effectClass : this.reverseClass;
    if (link && link.href && link.href !== '' && !this.props.parallax) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
        {
          containerId: containerId,
          containerClass: containerClass,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1402
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: anchorPoint, 'data-anchor-name': anchorName, __source: {
              fileName: _jsxFileName,
              lineNumber: 1406
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_scroll_loader__["a" /* default */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1407
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'FullWidth ' + pc + ' ' + mb + ' ' + parallax + ' ' + fixed + ' ' + bottom + ' ' + opacityZero + ' ' + parallaxAction + ' ' + effectClass, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1408
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'FullWidth__wrapped-link', href: link.href, target: link.targetBlank ? '_blank' : '_self', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1409
                  }
                },
                figure,
                description
              )
            )
          )
        )
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
        {
          containerId: containerId,
          containerClass: containerClass,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1420
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: anchorPoint, 'data-anchor-name': anchorName, __source: {
              fileName: _jsxFileName,
              lineNumber: 1424
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_scroll_loader__["a" /* default */],
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1425
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'FullWidth ' + pc + ' ' + mb + ' ' + parallax + ' ' + fixed + ' ' + bottom + ' ' + opacityZero + ' ' + parallaxAction + ' ' + effectClass,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1426
                }
              },
              figure,
              description
            )
          )
        )
      );
    }
  };

  return FullWidth;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcVideoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbVideoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcVerticalSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbVerticalSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  parallax: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  effect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcImageSrc: null,
  mbImageSrc: null,
  pcVideoSrc: null,
  mbVideoSrc: null,
  pcVerticalSize: null,
  mbVerticalSize: null,
  parallax: null,
  effect: 'Light-To-Dark',
  pcDescription: null,
  mbDescription: null,
  pcPosition: null,
  mbPosition: null,
  photoInfo: null,
  link: null
}, _class.PARALLAX = 'FullWidth__parallax', _class.FIXED = 'FullWidth__parallax__fixed', _class.BOTTOM = 'FullWidth__parallax__bottom', _class.OPACITY_ZERO = 'FullWidth__opacity__zero', _class.PARALLAX_ACTION = 'FullWidth__parallax__action', _class.SCROLL_DOWN = 'scrollDown', _class.SCROLL_UP = 'scrollUp', _temp);
FullWidth.displayName = 'FullWidth';


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_loader__ = __webpack_require__(25);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\slideshow\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  Slideshow
 */
var Slideshow = (_temp = _class = function (_Component) {
  _inherits(Slideshow, _Component);

  function Slideshow(props) {
    _classCallCheck(this, Slideshow);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  Slideshow.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        pcDescription = _props.pcDescription,
        mbDescription = _props.mbDescription,
        mbBackgroundColor = _props.mbBackgroundColor,
        position = _props.position,
        pcSrc = _props.pcSrc,
        mbSrc = _props.mbSrc,
        pcSize = _props.pcSize,
        mbSize = _props.mbSize,
        duration = _props.duration,
        loop = _props.loop,
        photoInfo = _props.photoInfo;

    var settings = {
      autoplay: true,
      autoplaySpeed: duration + 3000,
      pauseOnHover: false,
      speed: 3000,
      ease: 'linear',
      fade: true,
      infinite: loop,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      draggable: false,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      centerMode: false,
      centerPadding: 0,
      lazyLoad: 'progressive'
      //lazyLoad: 'ondemand',
    };

    //
    var getPcDescription = function getPcDescription() {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };

    //
    var getMbDescription = function getMbDescription() {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    //
    var getPcSrc = function getPcSrc(index) {
      if (pcSrc && Array.isArray(pcSrc) && 1 <= pcSrc.length && pcSrc[index]) {
        return pcSrc[index];
      } else {
        return null;
      }
    };

    //
    var getMbSrc = function getMbSrc(index) {
      if (mbSrc && Array.isArray(mbSrc) && 1 <= mbSrc.length && mbSrc[index]) {
        return mbSrc[index];
      } else {
        return getPcSrc(index);
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'Slideshow' + (pcSize && pcSize !== '' ? ' ' + pcSize + '_pc' : '') + (mbSize && mbSize !== '' ? ' ' + mbSize + '_mb' : ''),
            style: { backgroundColor: mbBackgroundColor && mbBackgroundColor !== '' ? mbBackgroundColor : '#101010' },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 135
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Slideshow__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 139
              }
            },
            function () {
              if (getPcDescription()) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Slideshow__description' + (position && position !== '' ? ' ' + position : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 143
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Slideshow__description-inner', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 144
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Slideshow__description-inner2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 145
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slideshow__description-pc Wysiwyg',
                        dangerouslySetInnerHTML: { __html: getPcDescription() },
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 146
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slideshow__description-mb Wysiwyg',
                        dangerouslySetInnerHTML: { __html: getMbDescription() },
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 149
                        }
                      })
                    )
                  )
                );
              }
            }(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__components_slider__["a" /* default */],
              {
                className: 'Slideshow__carousel',
                settings: settings,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 158
                }
              },
              pcSrc.map(function (child, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Slideshow__carousel-item',
                    key: index,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 164
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slideshow__carousel-item-inner_pc',
                    style: { backgroundImage: 'url(' + getPcSrc(index) + ')' },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 167
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slideshow__carousel-item-inner_mb',
                    style: { backgroundImage: 'url(' + getMbSrc(index) + ')' },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 170
                    }
                  })
                );
              })
            )
          ),
          photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length ? photoInfo : null
        )
      )
    );
  };

  return Slideshow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbBackgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  pcSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  loop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcDescription: null,
  mbDescription: null,
  mbBackgroundColor: null,
  position: null,
  pcSrc: null,
  mbSrc: null,
  pcSize: null,
  mbSize: null,
  duration: null,
  loop: null,
  photoInfo: null
}, _temp);
Slideshow.displayName = 'Slideshow';


/* harmony default export */ __webpack_exports__["a"] = (Slideshow);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\presentation-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  PresentationItem
 */
var PresentationItem = (_temp = _class = function (_Component) {
  _inherits(PresentationItem, _Component);

  function PresentationItem(props) {
    _classCallCheck(this, PresentationItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  PresentationItem.prototype.test = function test() {
    //console.log(this.props.containerId);
  };

  PresentationItem.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        pcDescription = _props.pcDescription,
        mbDescription = _props.mbDescription,
        imageSrc = _props.imageSrc,
        videoSrc = _props.videoSrc,
        displayOnTop = _props.displayOnTop;

    //

    var getPcDescription = function getPcDescription() {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };

    //
    var getMbDescription = function getMbDescription() {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    //
    var getDescription = function getDescription() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PresentationItem__description', __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PresentationItem__description-pc Wysiwyg',
          dangerouslySetInnerHTML: { __html: getPcDescription() },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'PresentationItem__description-mb Wysiwyg',
          dangerouslySetInnerHTML: { __html: getMbDescription() },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74
          }
        })
      );
    };
    //
    var getMedia = function getMedia() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PresentationItem__media', __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        },
        function () {
          if (imageSrc) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              onLoad: handleImageLoaded.bind(_this2),
              className: 'PresentationItem__image',
              src: imageSrc + "?t=" + new Date().getTime(),
              alt: '',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 87
              }
            });
          } else if (videoSrc) {
            var attributes = {
              preload: 'none',
              controls: false,
              autoPlay: true,
              playsInline: true,
              muted: true,
              loop: true,
              src: videoSrc,
              poster: imageSrc,
              width: '100%'
            };
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', _extends({}, attributes, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            }));
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              onLoad: handleImageLoaded.bind(_this2),
              className: 'PresentationItem__image',
              src: imageSrc + "?t=" + new Date().getTime(),
              alt: '',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 112
              }
            });
          }
        }()
      );
    };

    var handleImageLoaded = function handleImageLoaded(e) {
      var elem = e.target;
      elem.style.maxWidth = elem.naturalWidth + 'px';
    };
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PresentationItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 135
          }
        },
        function () {
          if (displayOnTop === true) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 139
                }
              },
              getMedia(),
              getDescription()
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 146
                }
              },
              getDescription(),
              getMedia()
            );
          }
        }()
      )
    );
  };

  return PresentationItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  videoSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  displayOnTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcDescription: null,
  mbDescription: null,
  imageSrc: null,
  videoSrc: null,
  displayOnTop: null
}, _temp);
PresentationItem.displayName = 'PresentationItem';


/* harmony default export */ __webpack_exports__["a"] = (PresentationItem);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Photogallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photogallery_layout__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_youtube_player__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_layout__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cta_icon_next_dark_png__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cta_icon_next_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__cta_icon_next_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\photogallery\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// import BodyControl from "../../components/body";


var Photogallery = (_temp = _class = function (_Component) {
  _inherits(Photogallery, _Component);

  function Photogallery(props) {
    _classCallCheck(this, Photogallery);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function () {
      var windowWidth = window.innerWidth;

      _this.setState({
        windowWidth: windowWidth
      });
    };

    _this.onClickMore = function (event) {
      // スクロール位置を固定
      document.activeElement.blur();
      event.preventDefault();
      _this.setState(function (state) {
        return { page: state.page + 1 };
      });
    };

    _this.openModal = function (index) {

      // // EPIServerのプレビュー時のモーダルの位置調整
      // if (WINDOW && WINDOW.epi && WINDOW.parent) {
      //   const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      //   if (wrapperElement) {
      //     const wrapperHeight = wrapperElement.clientHeight;
      //     this.wrapperScrollTop = wrapperElement.scrollTop;
      //     const iframe = wrapperElement.querySelector('iframe');
      //     if (iframe) {
      //       DOCUMENT.body.style.position = 'absolute';
      //       DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
      //       const headerElement = WINDOW.document.querySelector('header') || null;
      //       if (headerElement) {
      //         headerElement.style.zIndex = 0;
      //       }
      //       iframe.style.height = wrapperHeight + 'px';
      //     }
      //   }
      // }

      _this.refs.modalItems.slickGoTo(index, true);
      //
      if (_this.itemsProps[index].youtubeId !== null && _this.itemsProps[index].youtubeId !== '') {
        _this.refs.modalWindow.open('Dark', 'Dark');
      } else {
        if (_this.itemsProps[index].modalWindowLayout === 'Image-On-Top') {
          _this.refs.modalWindow.open('Light', 'Dark');
        } else {
          _this.refs.modalWindow.open('Light', 'Light');
        }
      }

      // BODYのスクロール無効化
      // BodyControl.openModal();
    };

    _this.onCloseModal = function () {

      // // EPIServerのプレビュー時のモーダルの位置調整
      // if (WINDOW && WINDOW.epi && WINDOW.parent) {
      //   const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      //   if (wrapperElement) {
      //     const iframe = wrapperElement.querySelector('iframe');
      //     if (iframe) {
      //       DOCUMENT.body.style.position = 'static';
      //       DOCUMENT.body.style.top = 'auto';
      //       const headerElement = WINDOW.document.querySelector('header') || null;
      //       if (headerElement) {
      //         headerElement.style.zIndex = 3000;
      //       }
      //       iframe.style.height = DOCUMENT.body.clientHeight + 'px';
      //       wrapperElement.scrollTop = this.wrapperScrollTop;
      //     }
      //   }
      // }

      _this.refs.modalItems.clearCurrentAll();

      // BODYのスクロール無効化を解除
      // BodyControl.closeModal();
    };

    _this.onChangeModal = function (index) {
      if (_this.itemsProps[index].youtubeId !== null && _this.itemsProps[index].youtubeId !== '') {
        _this.refs.modalWindow.setType('Dark', 'Dark');
      } else {
        if (_this.itemsProps[index].modalWindowLayout === 'Image-On-Top') {
          _this.refs.modalWindow.setType('Light', 'Dark');
        } else {
          _this.refs.modalWindow.setType('Light', 'Light');
        }
      }
    };

    _this.itemCount = 0;
    _this.itemLength = _this.props.photogalleryItem.length;
    _this.itemsProps = [];
    _this.state = {
      page: 1
    };

    // EPIServerのプレビュー時のモーダルの位置調整
    // this.wrapperScrollTop = 0;

    return _this;
  }

  Photogallery.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  Photogallery.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  Photogallery.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        photogalleryItem = _props.photogalleryItem,
        photogalleryLayout = _props.photogalleryLayout,
        readMoreButtonText = _props.readMoreButtonText,
        readMoreMbColumn = _props.readMoreMbColumn,
        deleteMarginOnPc = _props.deleteMarginOnPc,
        pcDisplayLine = _props.pcDisplayLine,
        mbDisplayLine = _props.mbDisplayLine;
    // モーダル用データ整形

    this.itemsProps = [];
    this.itemCount = 0;
    photogalleryItem.map(function (item, index) {
      _this2.itemsProps.push({
        pcDescription: item.props.pcDescription ? item.props.pcDescription : null,
        mbDescription: item.props.mbDescription ? item.props.mbDescription : null,
        modalWindowLayout: item.props.modalWindowLayout ? item.props.modalWindowLayout : null,
        pcModalImageSrc: item.props.pcModalImageSrc ? item.props.pcModalImageSrc : null,
        mbModalImageSrc: item.props.mbModalImageSrc ? item.props.mbModalImageSrc : null,
        imageSrc: item.props.imageSrc ? item.props.imageSrc : null,
        youtubeId: item.props.youtubeId ? item.props.youtubeId : null,
        autoPlay: item.props.autoPlay ? item.props.autoPlay : null,
        photoInfo: item.props.photoInfo ? item.props.photoInfo : null
      });
    });

    var plainLargeLayout = { props: { layout: 'Large' } };
    var plainMediumLayout = { props: { layout: 'Medium' } };

    var mbColumn = readMoreMbColumn === 'Two-Column' ? 2 : 1;

    var isPc = this.state.windowWidth >= __WEBPACK_IMPORTED_MODULE_9__constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */];
    var isEnabledReadMore = !!readMoreButtonText;

    var needMore = false;
    var showingPhotogalleryLayout = [];

    if (isEnabledReadMore) {
      // モバイル用Layoutの成形
      var mbFirstDisplayLayout = new Array(photogalleryItem.length < mbDisplayLine ? photogalleryItem.length : mbDisplayLine).fill(null).map(function (_) {
        return plainLargeLayout;
      });
      var mbPhotogalleryLayout = mbFirstDisplayLayout.concat(new Array(Math.floor((photogalleryItem.length - mbFirstDisplayLayout.length) / mbColumn)).fill(null).map(function (_) {
        return readMoreMbColumn === 'Two-Column' ? plainMediumLayout : plainLargeLayout;
      })).concat((photogalleryItem.length - mbFirstDisplayLayout.length) % mbColumn ? [plainLargeLayout] : []);

      showingPhotogalleryLayout = isPc ? photogalleryLayout.filter(function (_, i) {
        return i < _this2.state.page * pcDisplayLine;
      }) : mbPhotogalleryLayout.filter(function (_, i) {
        return i < _this2.state.page * mbDisplayLine;
      });

      needMore = isPc ? showingPhotogalleryLayout.length < photogalleryLayout.length : showingPhotogalleryLayout.length < mbPhotogalleryLayout.length;
    } else {
      var _mbPhotogalleryLayout = new Array(Math.floor(photogalleryItem.length)).fill(null).map(function (_) {
        return plainLargeLayout;
      });

      showingPhotogalleryLayout = isPc ? photogalleryLayout : _mbPhotogalleryLayout;
    }

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName, __source: {
          fileName: _jsxFileName,
          lineNumber: 153
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 158
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Photogallery', __source: {
              fileName: _jsxFileName,
              lineNumber: 159
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Photogallery__container ' + (deleteMarginOnPc && 'deleteMarginOnPc'), __source: {
                fileName: _jsxFileName,
                lineNumber: 160
              }
            },
            showingPhotogalleryLayout.map(function (layout, index) {
              var items = [];
              var length = 0;
              if (layout.props.layout === 'Large') {
                length = 1;
              } else if (layout.props.layout === 'Medium') {
                length = 2;
              } else if (layout.props.layout === '2-Small-Left-Medium-Right' || layout.props.layout === 'Medium-Left-2-Small-Right') {
                length = 3;
              }
              for (var i = 0; i < length; i += 1) {
                if (_this2.itemCount + i <= _this2.itemLength - 1) {
                  items.push(photogalleryItem[_this2.itemCount + i]);
                }
              }
              _this2.itemCount = _this2.itemCount + length;
              if (items.length >= 1 && items.length === length) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__containers_photogallery_layout__["a" /* default */],
                  _extends({}, layout.props, {
                    key: index,
                    index: _this2.itemCount - length,
                    openModal: _this2.openModal, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 179
                    }
                  }),
                  items
                );
              }
              return null;
            }),
            needMore && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'Photogallery__container__btn__more', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 191
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__cta__["a" /* default */], {
                ctaType: 'Free',
                text: readMoreButtonText,
                linkType: 'Text-With-Icon',
                color: 'Dark',
                iconSrc: __WEBPACK_IMPORTED_MODULE_11__cta_icon_next_dark_png___default.a,
                hoverIconSrc: __WEBPACK_IMPORTED_MODULE_11__cta_icon_next_dark_png___default.a,
                handleClick: this.onClickMore, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 193
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__components_modal_window__["a" /* default */],
            {
              ref: 'modalWindow',
              type: 'Light',
              onClose: this.onCloseModal, __source: {
                fileName: _jsxFileName,
                lineNumber: 204
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItems, {
              ref: 'modalItems',
              index: 0,
              itemsProps: this.itemsProps,
              onChange: this.onChangeModal, __source: {
                fileName: _jsxFileName,
                lineNumber: 208
              }
            })
          )
        )
      )
    );
  };

  //


  //


  //


  return Photogallery;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photogalleryItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  photogalleryLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  readMoreButtonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  readMoreMbColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deleteMarginOnPc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  photogalleryItem: null,
  photogalleryLayout: null,
  readMoreButtonText: null,
  readMoreMbColumn: null,
  deleteMarginOnPc: null,
  pcDisplayLine: 1,
  mbDisplayLine: 1
}, _temp);
Photogallery.displayName = 'Photogallery';

var ModalItems = (_temp2 = _class2 = function (_Component2) {
  _inherits(ModalItems, _Component2);

  function ModalItems(props) {
    _classCallCheck(this, ModalItems);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.onChange = function (index) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.modalItemArr.length; i < max; i = i + 1) {
        var item = _this3.refs[_this3.modalItemArr[i]] || null;
        if (item) {
          if (i === index) {
            item.setCurrent();
          } else {
            item.clearCurrent();
          }
        }
      }
      //
      if (_this3.props.onChange !== null) _this3.props.onChange(index);
    };

    _this3.slickGoTo = function (index, dontAnimate) {
      _this3.refs.slider.slickGoTo(index, dontAnimate);
      setTimeout(function () {
        _this3.onChange(index);
      }, 100);
    };

    _this3.modalItemArr = [];
    return _this3;
  }

  //


  ModalItems.prototype.clearCurrentAll = function clearCurrentAll() {
    var i = void 0,
        max = void 0;
    for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
      var item = this.refs[this.modalItemArr[i]] || null;
      if (item) {
        item.clearCurrent();
      }
    }
  };

  ModalItems.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        itemsProps = _props2.itemsProps,
        index = _props2.index;
    //

    this.modalItemArr = [];
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__components_slider__["a" /* default */],
      {
        ref: 'slider',
        settings: {
          autoplay: false,
          speed: 3000,
          ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
          fade: true,
          infinite: true,
          initialSlide: index,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          draggable: false,
          arrows: true,
          dots: false,
          adaptiveHeight: false,
          //lazyLoad: 'progressive',
          lazyLoad: 'ondemand',
          waitForAnimate: false,
          beforeChange: function beforeChange(old, current) {
            setTimeout(function () {
              _this4.onChange(current);
            }, 100);
            _this4.refs.slider.beforeChange(old, current);
          },
          responsive: [{
            breakpoint: 767,
            settings: {
              arrows: false,
              dots: true
            }
          }]
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 337
        }
      },
      itemsProps.map(function (itemProps, index) {
        _this4.modalItemArr.push('modalItem' + index);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, {
          ref: 'modalItem' + index,
          key: index,
          pcDescription: itemProps.pcDescription ? itemProps.pcDescription : null,
          mbDescription: itemProps.mbDescription ? itemProps.mbDescription : null,
          modalWindowLayout: itemProps.modalWindowLayout ? itemProps.modalWindowLayout : null,
          pcModalImageSrc: itemProps.pcModalImageSrc ? itemProps.pcModalImageSrc : null,
          mbModalImageSrc: itemProps.mbModalImageSrc ? itemProps.mbModalImageSrc : null,
          imageSrc: itemProps.imageSrc ? itemProps.imageSrc : null,
          youtubeId: itemProps.youtubeId ? itemProps.youtubeId : null,
          autoPlay: itemProps.autoPlay ? itemProps.autoPlay : null,
          photoInfo: itemProps.photoInfo ? itemProps.photoInfo : null,
          index: index,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 376
          }
        });
      })
    );
  };

  //


  //


  return ModalItems;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  itemsProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  itemsProps: null,
  index: null,
  onChange: null
}, _temp2);
ModalItems.displayName = 'ModalItems';
var ModalItem = (_temp3 = _class3 = function (_Component3) {
  _inherits(ModalItem, _Component3);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this5 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this5.handleResize = function () {
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      //
      var videoWidth = 0;
      var videoHeight = 0;
      if (_this5.props.modalWindowLayout === 'Image-On-Top') {
        videoWidth = 1040;
        videoHeight = 585;
      } else if (_this5.props.modalWindowLayout === 'Image-On-Left') {
        videoWidth = windowWidth * 0.67;
        videoHeight = windowWidth * 0.67 / 16 * 9;
      }

      // EPIServerのプレビュー時のモーダルの位置調整
      if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent) {
        var wrapperElement = __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          windowHeight = wrapperElement.clientHeight;
        }
      }

      //
      _this5.setState({
        videoWidth: videoWidth,
        videoHeight: videoHeight,
        windowWidth: windowWidth,
        windowHeight: windowHeight
      });
    };

    var type = props.youtubeId !== null && props.youtubeId !== '' ? ' dark' : ' light';
    _this5.state = {
      type: type,
      current: false,
      videoWidth: 1040,
      videoHeight: 585
    };
    // this.intervalId = null;
    return _this5;
  }

  ModalItem.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   if (this.intervalId) clearInterval();
    //   this.intervalId = setInterval(()=> {
    //     this.handleResize();
    //   }, 500);
    // }
  };

  ModalItem.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   if (this.intervalId) clearInterval();
    // }
  };

  //


  ModalItem.prototype.setCurrent = function setCurrent() {
    if (this.state.current === true) return;
    //
    this.setState({
      current: true
    });

    if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */] !== __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent && __WEBPACK_IMPORTED_MODULE_8__constants_environment__["k" /* WINDOW */].parent.EPi) {
      window.scrollTo(0, 0);
    }
  };

  //
  ModalItem.prototype.clearCurrent = function clearCurrent() {
    if (this.state.current === false) return;
    //
    this.setState({
      current: false
    });
  };

  ModalItem.prototype.render = function render() {
    var _this6 = this;

    var _props3 = this.props,
        pcDescription = _props3.pcDescription,
        mbDescription = _props3.mbDescription,
        modalWindowLayout = _props3.modalWindowLayout,
        imageSrc = _props3.imageSrc,
        pcModalImageSrc = _props3.pcModalImageSrc,
        mbModalImageSrc = _props3.mbModalImageSrc,
        youtubeId = _props3.youtubeId,
        autoPlay = _props3.autoPlay,
        photoInfo = _props3.photoInfo;
    //

    var getPcDescription = function getPcDescription() {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return '';
      }
    };
    //
    var getMbDescription = function getMbDescription() {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };
    //
    var getPcImageSrc = function getPcImageSrc() {
      if (pcModalImageSrc && pcModalImageSrc !== '') {
        return pcModalImageSrc;
      } else if (imageSrc && imageSrc !== '') {
        return imageSrc;
      } else {
        return '';
      }
    };
    //
    var getMbImageSrc = function getMbImageSrc() {
      if (mbModalImageSrc && mbModalImageSrc !== '') {
        return mbModalImageSrc;
      } else {
        return getPcImageSrc();
      }
    };
    //
    var layoutClass = null;
    var description = getPcDescription();
    if (description && description !== '') {
      if (modalWindowLayout === 'Image-On-Top') {
        layoutClass = ' imageOnTop';
      } else if (modalWindowLayout === 'Image-On-Left') {
        layoutClass = ' imageOnLeft';
      }
    } else {
      layoutClass = ' fullSize';
    }
    //
    var pcImageSrc = getPcImageSrc();
    var mbImageSrc = getMbImageSrc();
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'Photogallery__modal' + this.state.type + (layoutClass ? layoutClass : '') + (this.state.current === true ? ' current' : ''),
        style: { height: this.state.windowHeight },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 569
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Photogallery__modal-container',
          style: { height: this.state.windowHeight },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 573
          }
        },
        function () {
          if (youtubeId && youtubeId !== '') {
            if (_this6.state.current === true) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Photogallery__modal-container-left-pc', ref: 'videoWrapper', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 580
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_youtube_player__["a" /* default */], {
                  height: _this6.state.videoHeight,
                  width: _this6.state.videoWidth,
                  autoplay: autoPlay ? 1 : 0,
                  controls: 0,
                  youtubeId: youtubeId,
                  onReady: function onReady(e) {
                    //console.log('onReady');
                  },
                  onStateChange: function onStateChange(e) {
                    //console.log('onStateChange');
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 581
                  }
                }),
                photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_photo_info__["a" /* default */], _extends({}, photoInfo[0].props, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 600
                  }
                })) : null
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Photogallery__modal-container-left-pc', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 606
                }
              });
            }
          } else if (pcImageSrc && pcImageSrc !== '') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Photogallery__modal-container-left-pc',
                style: { backgroundImage: 'url(' + pcImageSrc + ')' },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 611
                }
              },
              photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_photo_info__["a" /* default */], _extends({}, photoInfo[0].props, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 615
                }
              })) : null
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Photogallery__modal-container-left-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 621
              }
            });
          }
        }(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Photogallery__modal-container-left-mb', __source: {
              fileName: _jsxFileName,
              lineNumber: 625
            }
          },
          function () {
            if (youtubeId && youtubeId !== '') {
              if (_this6.state.current === true) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Photogallery__modal-movie-wrapper', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 630
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_youtube_player__["a" /* default */], {
                    height: '100%',
                    width: '100%',
                    autoplay: autoPlay ? 1 : 0,
                    controls: 0,
                    youtubeId: youtubeId,
                    onReady: function onReady(e) {
                      //console.log('onReady');
                    },
                    onStateChange: function onStateChange(e) {
                      //console.log('onStateChange');
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 631
                    }
                  })
                );
              } else {
                return null;
              }
            } else if (mbImageSrc && mbImageSrc !== '') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 656
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Photogallery__modal-image',
                  src: mbImageSrc,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 657
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Photogallery__modal-image-cover', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 660
                  }
                })
              );
            } else {
              return null;
            }
          }(),
          photoInfo && Array.isArray(photoInfo) && 1 <= photoInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_photo_info__["a" /* default */], _extends({}, photoInfo[0].props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 668
            }
          })) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Photogallery__modal-container-right', __source: {
              fileName: _jsxFileName,
              lineNumber: 671
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Photogallery__modal-inner', __source: {
                fileName: _jsxFileName,
                lineNumber: 672
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Photogallery__modal-description-pc Wysiwyg'
              //style={{height: this.state.windowHeight}}
              , dangerouslySetInnerHTML: { __html: getPcDescription() },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 673
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Photogallery__modal-description-mb Wysiwyg',
              dangerouslySetInnerHTML: { __html: getMbDescription() },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 677
              }
            })
          )
        )
      )
    );
  };

  //


  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  pcDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalWindowLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  imageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcModalImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbModalImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class3.defaultProps = {
  pcDescription: null,
  mbDescription: null,
  imageSrc: null,
  modalWindowLayout: null,
  pcModalImageSrc: null,
  mbModalImageSrc: null,
  youtubeId: null,
  autoPlay: null,
  photoInfo: null,
  index: null
}, _temp3);
ModalItem.displayName = 'ModalItem';

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_slidegallery_item__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\slidegallery\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 *  Slidegallery
 */
var Slidegallery = (_temp = _class = function (_Component) {
  _inherits(Slidegallery, _Component);

  function Slidegallery(props) {
    _classCallCheck(this, Slidegallery);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {
      current: 0,
      openThumb: false
    };
    _this.dots = [];
    _this.components = [];
    return _this;
  }

  Slidegallery.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        slidegalleryItem = _props.slidegalleryItem,
        thumbnail = _props.thumbnail;
    //

    var srcArr = [];
    this.props.slidegalleryItem.map(function (item, index) {
      var src = null;
      var type = null;
      if (item.props.youtubeId && item.props.youtubeId !== null && item.props.youtubeId !== '') {
        if (item.props.thumbnailSrc && item.props.thumbnailSrc !== null && item.props.thumbnailSrc !== '') {
          src = item.props.thumbnailSrc;
        } else {
          src = 'https://i.ytimg.com/vi/' + item.props.youtubeId + '/mqdefault.jpg';
        }
        type = 'movie';
      } else if (item.props.thumbnailSrc && item.props.thumbnailSrc !== null && item.props.thumbnailSrc !== '') {
        src = item.props.thumbnailSrc;
        type = 'image';
      } else if (item.props.pcSrc && item.props.pcSrc !== null && item.props.pcSrc !== '') {
        src = item.props.pcSrc;
        type = 'image';
      }
      srcArr.push({
        src: src,
        type: type
      });
    });
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Slidegallery', __source: {
              fileName: _jsxFileName,
              lineNumber: 84
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Slidegallery__main', __source: {
                fileName: _jsxFileName,
                lineNumber: 85
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__components_slider__["a" /* default */],
              {
                ref: 'slider',
                settings: {
                  autoplay: false,
                  // speed: 1000,
                  speed: 1000,
                  // ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                  // ease: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                  ease: 'linear',
                  fade: true,
                  infinite: true,
                  initialSlide: 0,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  swipe: false,
                  draggable: false,
                  arrows: true,
                  dots: false,
                  adaptiveHeight: false,
                  //lazyLoad: 'progressive',
                  lazyLoad: 'ondemand',
                  waitForAnimate: false,
                  focusOnSelect: true,
                  beforeChange: function beforeChange(old, current) {
                    if (_this2.refs.thumbnail) _this2.refs.thumbnail.slickGoTo(current);
                    setTimeout(function () {
                      _this2.setState({
                        current: current
                      });
                    }, 100);
                    _this2.dots.map(function (dot, index) {
                      if (index === current) {
                        _this2.refs[dot].classList.add('current');
                      } else {
                        _this2.refs[dot].classList.remove('current');
                      }
                    });

                    var slickList = _this2.refs.slider.refs.slide.getElementsByClassName('slick-list')[0];
                    slickList.classList.add('open');
                    setTimeout(function () {
                      slickList.classList.remove('open');
                    }, 500);
                    _this2.refs.slider.beforeChange(old, current);

                    // スライド初期化
                    var i = void 0,
                        max = void 0;
                    for (i = 0, max = _this2.components.length; i < max; i = i + 1) {
                      _this2.components[i].initialize();
                    }
                  },
                  responsive: [{
                    breakpoint: 767,
                    settings: {
                      swipe: true,
                      arrows: false,
                      prevArrow: '<div></div>',
                      nextArrow: '<div></div>'
                    }
                  }]
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 86
                }
              },
              this.props.slidegalleryItem.map(function (child, index) {
                // if (child.type.displayName === 'withDynamicComponents(SlidegalleryItem)') {
                if (0 <= child.type.displayName.indexOf('withDynamicComponents(SlidegalleryItem)')) {
                  var current = false;
                  if (index === _this2.state.current) current = true;
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks_slidegallery_item__["a" /* default */], _extends({}, child.props, {
                    key: index,
                    current: current,
                    getRef: function getRef(ref) {
                      ref ? _this2.components.push(ref) : null;
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 157
                    }
                  }));
                } else {
                  return null;
                }
              })
            )
          ),
          function () {
            _this2.dots = [];
            if (thumbnail === true) {
              if (8 <= srcArr.length) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Slidegallery__thumbnail' + (_this2.state.openThumb === true ? ' open' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 177
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slidegallery__thumbnail-link-close',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.setState({
                        openThumb: false
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 178
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Slidegallery__thumbnail-container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 186
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Slidegallery__thumbnail-container2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 187
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3__components_slider__["a" /* default */],
                        { ref: 'thumbnail',
                          settings: {
                            autoplay: false,
                            speed: 500,
                            ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                            fade: false,
                            infinite: true,
                            initialSlide: 0,
                            slidesToShow: 8,
                            slidesToScroll: 1,
                            swipe: true,
                            draggable: false,
                            arrows: true,
                            dots: false,
                            adaptiveHeight: false,
                            centerMode: false,
                            centerPadding: 0,
                            focusOnSelect: true,
                            //lazyLoad: 'progressive',
                            lazyLoad: 'ondemand',
                            beforeChange: function beforeChange(old, current) {
                              if (_this2.refs.slider) _this2.refs.slider.slickGoTo(current);
                            }
                          },
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 188
                          }
                        },
                        srcArr.map(function (src, index) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { className: 'Slidegallery__thumbnail-item' + (src.type === 'movie' ? ' movie' : ''),
                              key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 215
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Slidegallery__thumbnail-item-inner',
                              style: { backgroundImage: 'url(' + src.src + ')' },
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 217
                              }
                            })
                          );
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'Slidegallery__dots', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 226
                      }
                    },
                    _this2.props.slidegalleryItem.map(function (child, index) {
                      _this2.dots.push('dot' + index);
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 230
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'Slidegallery__dots-link' + (index === 0 ? ' current' : ''),
                            href: 'javascript:void(0)',
                            onClick: function onClick(e) {
                              e.preventDefault();
                              if (_this2.refs.slider) _this2.refs.slider.slickGoTo(index);
                            },
                            ref: 'dot' + index,
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 231
                            }
                          },
                          index
                        )
                      );
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                      className: 'Slidegallery__thumbnail-link-open',
                      href: 'javascript:void(0)',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        if (_this2.state.openThumb === true) {
                          _this2.setState({
                            openThumb: false
                          });
                        } else {
                          _this2.setState({
                            openThumb: true
                          });
                        }
                      },
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 245
                      }
                    },
                    'OPEN'
                  )
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Slidegallery__thumbnail noSlider' + (_this2.state.openThumb === true ? ' open' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 267
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Slidegallery__thumbnail-link-close',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.setState({
                        openThumb: false
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 268
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Slidegallery__thumbnail-container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 276
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Slidegallery__thumbnail-container2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 277
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'Slidegallery__thumbnail-list', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 278
                          }
                        },
                        srcArr.map(function (src, index) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 281
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'a',
                              { className: 'Slidegallery__thumbnail-item' + (src.type === 'movie' ? ' movie' : '') + (index === _this2.state.current ? ' current' : ''),
                                href: 'javascript:void(0)',
                                onClick: function onClick(e) {
                                  e.preventDefault();
                                  if (_this2.refs.slider) _this2.refs.slider.slickGoTo(index);
                                },
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 282
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Slidegallery__thumbnail-item-inner',
                                style: { backgroundImage: 'url(' + src.src + ')' },
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 289
                                }
                              })
                            )
                          );
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'Slidegallery__dots', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 299
                      }
                    },
                    _this2.props.slidegalleryItem.map(function (child, index) {
                      _this2.dots.push('dot' + index);
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 303
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'Slidegallery__dots-link' + (index === 0 ? ' current' : ''),
                            href: 'javascript:void(0)',
                            onClick: function onClick(e) {
                              e.preventDefault();
                              if (_this2.refs.slider) _this2.refs.slider.slickGoTo(index);
                            },
                            ref: 'dot' + index,
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 304
                            }
                          },
                          index
                        )
                      );
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'Slidegallery__thumbnail-link-open',
                      href: 'javascript:void(0)',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        if (_this2.state.openThumb === true) {
                          _this2.setState({
                            openThumb: false
                          });
                        } else {
                          _this2.setState({
                            openThumb: true
                          });
                        }
                      },
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 318
                      }
                    },
                    'OPEN'
                  )
                );
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'Slidegallery__dots', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 341
                  }
                },
                _this2.props.slidegalleryItem.map(function (child, index) {
                  _this2.dots.push('dot' + index);
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 345
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { className: 'Slidegallery__dots-link' + (index === 0 ? ' current' : ''),
                        href: 'javascript:void(0)',
                        onClick: function onClick(e) {
                          e.preventDefault();
                          if (_this2.refs.slider) _this2.refs.slider.slickGoTo(index);
                        },
                        ref: 'dot' + index,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 346
                        }
                      },
                      index
                    )
                  );
                })
              );
            }
          }()
        )
      )
    );
  };

  return Slidegallery;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  slidegalleryItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  thumbnail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  slidegalleryItem: null,
  thumbnail: null
}, _temp);
Slidegallery.displayName = 'Slidegallery';


/* harmony default export */ __webpack_exports__["a"] = (Slidegallery);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlidegalleryItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_youtube_player__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\slidegallery-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SlidegalleryItem = (_temp = _class = function (_Component) {
  _inherits(SlidegalleryItem, _Component);

  function SlidegalleryItem(props) {
    _classCallCheck(this, SlidegalleryItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.initialize = function () {
      if (_this.photoInfo) {
        _this.setState({
          isOpenPhotoInfo: false
        });
      }
    };

    _this.photoInfo = null;
    if (_this.props.getRef) _this.props.getRef(_this);
    //
    _this.state = {
      isOpenPhotoInfo: false
    };
    return _this;
  }

  SlidegalleryItem.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        pcSrc = _props.pcSrc,
        mbSrc = _props.mbSrc,
        youtubeId = _props.youtubeId,
        thumbnailSrc = _props.thumbnailSrc,
        photoInfo = _props.photoInfo;
    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SlidegalleryItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 57
          }
        },
        function () {
          if (youtubeId !== null && youtubeId !== '') {
            if (_this2.props.current === true) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SlidegalleryItem__video-wrapper', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 62
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_youtube_player__["a" /* default */], {
                  height: 585,
                  width: 1040,
                  autoplay: 0,
                  controls: 0,
                  youtubeId: youtubeId,
                  onReady: function onReady(e) {
                    //console.log('onReady');
                  },
                  onStateChange: function onStateChange(e) {
                    //console.log('onStateChange');
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 63
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SlidegalleryItem__photo-info-wrapper', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 76
                    }
                  },
                  photoInfo !== null && 1 <= photoInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__photo_info__["a" /* default */], _extends({}, photoInfo[0].props, {
                    isOpen: _this2.state.isOpenPhotoInfo,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 79
                    }
                  })) : null
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'SlidegalleryItem__video-wrapper', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 88
                }
              });
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SlidegalleryItem__image-wrapper', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 93
                }
              },
              function () {
                if (pcSrc !== null && pcSrc !== '') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'SlidegalleryItem__image-pc',
                    style: { backgroundImage: 'url(' + pcSrc + ')' },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 97
                    }
                  });
                }
              }(),
              function () {
                var src = null;
                if (mbSrc !== null && mbSrc !== '') {
                  src = mbSrc;
                } else {
                  src = pcSrc;
                }
                if (src !== null && src !== '') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'SlidegalleryItem__image-mb',
                    style: { backgroundImage: 'url(' + src + ')' },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 112
                    }
                  });
                }
              }(),
              photoInfo !== null && 1 <= photoInfo.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__photo_info__["a" /* default */], _extends({}, photoInfo[0].props, {
                isOpen: _this2.state.isOpenPhotoInfo,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 120
                }
              })) : null
            );
          }
        }()
      )
    );
  };

  return SlidegalleryItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  youtubeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  thumbnailSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcSrc: null,
  mbSrc: null,
  videoSrc: null,
  youtubeId: null,
  thumbnailSrc: null,
  photoInfo: null,
  getRef: null
}, _temp);
SlidegalleryItem.displayName = 'SlidegalleryItem';


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureCategories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweet_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feature_category_container__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__picker_container__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_loader__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\feature-categories\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// ---


// ---






// カテゴリのデフォルトコンテント設定に使用する
var DEFAULT_FILTER_ID = 'first-0';

// ---------------------------------------------------------------
// const handlers = [];
// const tick = () => {
//   const tickId = requestAnimationFrame(tick);
//   handlers.map(handle => (handle.call(this, tickId)));
// };
//
// class FilterScrollSmooth {
//   constructor(element) {
//     this.element = element;
//     this.update = this.update.bind(this);
//     this.step = 0;
//     this.targetLeft = 0;
//     this.goal = 0;
//     this.option = {};
//     this.prevLeft = -1;
//   }
//   init() {
//     tick();
//   }
//   add() {
//     handlers.push(this.update);
//   }
//   remove() {
//     handlers.shift();
//   }
//   to(scrollLeft, option) {
//     this.remove();
//     const currentLeft = this.element.scrollLeft;
//     let targetLeft = scrollLeft;
//     this.goal = Math.floor(targetLeft);
//     if (this.goal < 0) {
//       targetLeft -= this.goal;
//       this.goal = 0;
//     }
//     this.targetLeft = targetLeft;
//     this.option = option;
//     this.step = (targetLeft - currentLeft) * 0.1;
//     this.prevLeft = -1;
//     this.add();
//   }
//   update() {
//     const currentLeft = this.element.scrollLeft;
//     // const willLeft = currentLeft + ((this.targetLeft - currentLeft) * (1 / 10));
//     const willLeft = currentLeft + ((this.targetLeft - currentLeft) * (1 / 6));
//     const absSub = Math.abs(currentLeft - this.prevLeft);
//     // if (absSub < 15) {
//     //   this.almostComplete();
//     // }
//     if (absSub < 1) {
//       this.complete();
//     } else if (this.prevLeft === currentLeft) {
//       this.complete();
//     } else if (this.step > 0) {
//       if (this.goal <= willLeft) {
//         this.complete();
//       } else {
//         this.refresh(willLeft);
//       }
//     } else if (this.goal >= willLeft) {
//       this.complete();
//     } else {
//       this.refresh(willLeft);
//     }
//     this.prevLeft = currentLeft;
//   }
//   almostComplete() {
//     if (typeof this.option.almostComplete === 'function') {
//       this.option.almostComplete.call(this);
//     }
//   }
//   complete() {
//     this.remove();
//     this.element.scrollLeft = this.goal;
//     if (typeof this.option.complete === 'function') {
//       this.option.complete.call(this);
//     }
//   }
//   refresh(scrollLeft) {
//     this.element.scrollLeft = scrollLeft;
//   }
// }
// ---------------------------------------------------------------
/**
 *  FeatureCategories
 */
var FeatureCategories = (_temp = _class = function (_Component) {
  _inherits(FeatureCategories, _Component);

  /**
   *  filter - parent / child
   *  - child 選択時 他の child も同一グループなのをチェックする
   *  @param {string} parentName - 親名称 `first-0`
   *  @param {string} currentFilterId - 子名称 `first-0-second0`
   */
  FeatureCategories.secondFilterContains = function secondFilterContains(parentName, currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    var divideId = parentName.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  };

  /**
   * second filter id name 判定します ex. `first-0-second0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true second filter id
   */


  FeatureCategories.isSecondFilterId = function isSecondFilterId(currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 3;
  };

  /**
   * first filter id name 判定します ex. `first-0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true first filter id
   */


  FeatureCategories.isFirstFilterId = function isFirstFilterId(currentFilterId) {
    var divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 2;
  };

  /**
   * second filter の先頭の ID check
   * @param {string} id 調査対象 ID
   * @returns {boolean} true: second first
   */


  FeatureCategories.isFirstSecondFilterId = function isFirstSecondFilterId(id) {
    if (!FeatureCategories.isSecondFilterId(id)) {
      return false;
    }
    // console.log('FeatureCategories.isFirstFilterId', id, id.split('-').pop(), id.split('-').pop().replace('second', ''));
    return parseInt(id.split('-').pop().replace('second', ''), 10) === 0;
  };

  FeatureCategories.analyzeFilterId = function analyzeFilterId(id) {
    var firstFilterId = FeatureCategories.isFirstFilterId(id);
    var secondFilterId = FeatureCategories.isFirstFilterId(id);
    var secondFirstFilter = FeatureCategories.isSecondFilterId(id);
    return {
      firstFilterId: firstFilterId,
      secondFilterId: secondFilterId,
      secondFirstFilter: secondFirstFilter
    };
  };

  function FeatureCategories(props) {
    _classCallCheck(this, FeatureCategories);

    // ---
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.opacityZeroClassName = __WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */].OPACITY_ZERO_CLASS_NAME;

    _this.state = {
      currentFilterId: 'first-0',
      currentFilterMarkedId: 'first-0',
      containerIndex: 0,
      // for mb filter title
      filterTitle: '',
      filterSecondOpen: false,
      filterChangeOpacityClassName: _this.opacityZeroClassName,
      //
      slickTransitionClassName: ''
    };
    // ---
    /**
     * props.categories を `FeatureCategoryContainer` のみ抽出し list する
     * @type {{first: Array, second: Array, concat: ?Array}}
     */
    _this.containers = {
      first: [],
      second: [],
      concat: []
    };
    _this.timer = {
      titleCenter: 0,
      titleCenterSequence: 0
    };
    /**
     * props.categories を {@link getComponents} を通す - props.categories 使用しない
     * @type {Array<*>}
     */
    // this.categories = this.convertPropsCategories();
    _this.categories = props.categories || [];
    // カテゴリのデフォルトコンテント設定を行う
    _this.parseDefaultCategoryContent(_this.categories, DEFAULT_FILTER_ID);

    _this.onTitleClickCaller = _this.onTitleClickCaller.bind(_this);
    _this.resetSliderCount = 0;
    // ---
    _this.abortSlickTransitionClassName = __WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */].ABORT_SLICK_TRANSITION;
    // this.slickTransitionZero = false;
    _this.slickThumbnailChangedCallback = _this.slickThumbnailChangedCallback.bind(_this);
    // ---
    _this.refFilterFirst = null;
    _this.refFilterFirstWrap = null;
    _this.filterFirstTitles = {};
    _this.abortOpacityZero = _this.abortOpacityZero.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.currentFilterId = _this.state.currentFilterId;
    // this.changeState = null;
    _this.changedFilter = false;
    // this.filterScrollSmooth = null;
    // this.onBlur = this.onBlur.bind(this);
    // this.filterComplete = false;
    return _this;
  }

  FeatureCategories.prototype.onResize = function onResize() {
    // console.log('FeatureCategories.onResize', this.currentFilterId);
    this.titleMoveCenter(this.currentFilterId);
  };
  // onBlur() {
  //   if (this.filterScrollSmooth) {
  //     this.filterScrollSmooth.complete();
  //   }
  // }
  // --------------------------------------------------
  /**
   * filter title click callback
   * 各カテゴリをクリックしたときに呼ばれる
   * - 更新が必要なときは
   *   1. opacity: 0 します
   *   1. {@link FeatureCategories.titleMoveCenter} - mobile current を center 移動します
   * @param {string} id filter id - 現在 id と比較し更新が必要か判断します
   * @param {string} title filter title - mobile で current 表示に使用します
   */


  FeatureCategories.prototype.onTitleClickCaller = function onTitleClickCaller(id, title) {
    var _this2 = this;

    var isFirstSecondFilterId = FeatureCategories.isFirstSecondFilterId(this.state.currentFilterId);
    var argIdIsFirst = FeatureCategories.isFirstFilterId(id);
    var currentFilterIdContainsId = FeatureCategories.secondFilterContains(id, this.state.currentFilterId);
    this.changedFilter = false;
    if (argIdIsFirst && currentFilterIdContainsId && isFirstSecondFilterId) {
      return;
    }
    // console.log('FeatureCategories.onTitleClickCaller', this.state.currentFilterId, id, this.state.currentFilterId !== id, 'arg, contains, first', argIdIsFirst, currentFilterIdContainsId, isFirstSecondFilterId);
    if (this.state.currentFilterId !== id) {
      this.changedFilter = true;
      // ---
      this.currentFilterId = id;
      // this.enableOpacityZero();
      // ---
      // this.titleMoveCenter(id);
      // ---
      var changeState = {
        currentFilterId: id,
        easing: 'easeOutCubic',
        filterTitle: FeatureCategories.isSecondFilterId(id) ? title : '',
        filterSecondOpen: false,
        slickTransitionClassName: this.abortSlickTransitionClassName,
        filterChangeOpacityClassName: this.opacityZeroClassName
      };
      // if (!this.state.filterChangeOpacityClassName) {
      //   changeState.filterChangeOpacityClassName = this.opacityZeroClassName;
      // }
      // this.setState(changeState);
      this.refreshStateWhenChangeFilterOnlyFilterCurrent(id, changeState);
      this.abortOpacityZero();
      // this.titleMoveCenter(id, changeState);
      setTimeout(function () {
        _this2.titleMoveCenter(id, changeState);
      }, 16);
    }
  };
  // --------------------------------------------------
  /**
   *
   * @param {string} id filter id - 位置を取得するのに使用します {@link FeatureCategories.filterFirstTitles}
   * @param {*} [changeState=null] 移動後に更新する state
   * @returns {*} 戻り値使用しない
   */


  FeatureCategories.prototype.titleMoveCenter = function titleMoveCenter(id) {
    var changeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // ---
    var innerWidth = window.innerWidth;
    if (innerWidth >= 768 || !this.refFilterFirst) {
      // 768 以上 desktop 処理
      return this.refreshStateWhenChangeFilter(changeState);
    }
    // -------------
    // 767 以下 MB 処理
    // ---
    var component = this.filterFirstTitles[id];
    if (!component || !component.getTitleClientRect) {
      return this.refreshStateWhenChangeFilter(changeState);
    }
    var rect = component.getTitleClientRect();
    if (!rect) {
      return this.refreshStateWhenChangeFilter(changeState);
    }
    var scrollLeft = this.refFilterFirst.scrollLeft;
    var center = innerWidth * 0.5;
    var middle = rect.left + rect.width * 0.5;
    // console.log('FeatureCategories.titleMoveCenter', id, innerWidth, scrollLeft, center, middle, changeState);
    clearTimeout(this.timer.titleCenter);
    clearTimeout(this.timer.titleCenterSequence);
    this.sequenceTitleMoveCenter(center, middle, scrollLeft, changeState, rect);
  };

  /**
   * mobile - current title を center へ移動します
   * @param {number} center title container center 位置
   * @param {number} middle window center 位置
   * @param {number} scrollLeft scroll 位置
   * @param {ClientRect} rect component rectangular
   * @param {?*} changeState 移動後に更新する state
   */


  FeatureCategories.prototype.sequenceTitleMoveCenter = function sequenceTitleMoveCenter(center, middle, scrollLeft, changeState, rect) {
    var subtract = middle - center;
    var expectMove = scrollLeft + subtract;
    var wrapRect = this.refFilterFirstWrap.getBoundingClientRect();
    var wrapWidth = wrapRect.width;
    // const duration = 320;
    // 移動距離で duration 増減させる - 基準値 320ms per 140px
    var duration = Math.floor(Math.abs(scrollLeft - expectMove) / 140 * 320);
    // const duration = 960 * Math.sin(expectMove / window.innerWidth);
    var option = {
      duration: duration,
      // easing: 'easeOutCubic',
      easing: 'easeOutSine',
      horizontal: true,
      horizontalScroll: true,
      cancellable: false,
      stopPropagation: false
    };
    // // scroll 判定
    // if ((expectMove + scrollLeft) < wrapWidth) {
    //   option.completeScroll = () => {
    //     this.refreshStateWhenChangeFilter(changeState);
    //   };
    // } else {
    //   // 右端で移動できないときはすぐに更新させる
    //   this.refreshStateWhenChangeFilter(changeState);
    // }
    this.refreshStateWhenChangeFilter(changeState);
    // ------------------------------------------------
    var sweetScroll = new __WEBPACK_IMPORTED_MODULE_2_sweet_scroll___default.a(option, this.refFilterFirst);
    sweetScroll.toLeft(expectMove);
    // ------------------------------------------------
    // original code での scroll - カクつくので使用しない
    // this.filterComplete = false;
    // this.filterScrollSmooth.to(
    //   expectMove,
    //   {
    //     // almostComplete: () => {
    //     //   if (!this.filterComplete) {
    //     //     this.filterComplete = true;
    //     //     this.refreshStateWhenChangeFilter(changeState);
    //     //     console.log('FeatureCategories.sequenceTitleMoveCenter.almostComplete');
    //     //   }
    //     // },
    //     complete: () => {
    //       this.refreshStateWhenChangeFilter(changeState);
    //       console.log('FeatureCategories.sequenceTitleMoveCenter.complete');
    //     },
    //   },
    // );
    // ------------------------------------------------
  };

  /**
   * カテゴリをクリックしたときに、onTitleClickCaller 関数内で呼ばれる
   * filter title `current` を下表示切り替えより先行させる state 切替
   * @param {string} id current filter id
   * @param {*} changeState React.state
   */


  FeatureCategories.prototype.refreshStateWhenChangeFilterOnlyFilterCurrent = function refreshStateWhenChangeFilterOnlyFilterCurrent(id, changeState) {
    if (changeState) {
      // console.log('FeatureCategories.refreshStateWhenChangeFilterOnlyFilterCurrent', id);
      this.setState({ currentFilterMarkedId: id });
    }
  };
  /**
   * filter change 時に state 更新処理を行います
   * @param {*} changeState React.state
   */


  FeatureCategories.prototype.refreshStateWhenChangeFilter = function refreshStateWhenChangeFilter(changeState) {
    if (changeState) {
      this.setState(changeState);
    }
  };
  // --------------------------------------------------


  FeatureCategories.prototype.enableOpacityZero = function enableOpacityZero() {
    // document.body.classList.add(this.opacityZeroClassName);
    if (!this.state.filterChangeOpacityClassName) {
      this.setState({ filterChangeOpacityClassName: this.opacityZeroClassName });
    }
  };

  FeatureCategories.prototype.abortOpacityZero = function abortOpacityZero() {
    // document.body.classList.remove(this.opacityZeroClassName);
    // console.log('FeatureCategories.abortOpacityZero', this.currentFilterId, this.state.filterChangeOpacityClassName);
    if (this.state.filterChangeOpacityClassName === this.opacityZeroClassName) {
      this.setState({ filterChangeOpacityClassName: '' });
    }
  };
  // --------------------------------------------------
  /**
   * {@link FeatureCategoryContainer} から callback されます
   * - {@link FeatureCategories.abortSlickTransition} `.slick-track` transition-duration: 0s を解除します
   */


  FeatureCategories.prototype.slickThumbnailChangedCallback = function slickThumbnailChangedCallback() {
    this.abortSlickTransition();
  };

  FeatureCategories.prototype.enableSlickTransition = function enableSlickTransition() {
    // document.body.classList.remove(this.abortTransitionClassName);
    // this.slickTransitionZero = true;
    if (!this.state.slickTransitionClassName) {
      this.setState({ slickTransitionClassName: this.abortSlickTransitionClassName });
    }
  };
  /**
   * `.slick-track` transition-duration: 0s を解除します
   */


  FeatureCategories.prototype.abortSlickTransition = function abortSlickTransition() {
    // this.slickTransitionZero = false;
    if (this.state.slickTransitionClassName === this.abortSlickTransitionClassName) {
      this.setState({ slickTransitionClassName: '' });
    }
  };
  // --------------------------------------------------
  // /**
  //  * {@link getComponents} を通し `null` 除外します
  //  * @returns {Array} filter 後の categories
  //  */
  // convertPropsCategories() {
  //     const { categories } = this.props;
  //     return Array.isArray(categories) ? getComponents(categories).filter(component => (component !== null)) : [];
  // }
  /**
   * props.categories をパースします
   * - 第一階層は `FeatureCategoryContainer` のみ
   * - 第二回層は `FeatureCategoryContainer` / ...etc - `FeatureCategoryContainer` のみに filter する
   */


  FeatureCategories.prototype.parseDefaultCategoryContent = function parseDefaultCategoryContent() {
    var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filterId = arguments[1];

    var list = {
      first: [],
      second: [],
      concat: null
    };
    categories.map(function (category, index) {
      var step0 = 'first-' + index;
      // 第一階層は `FeatureCategoriesContainer` のみ
      list.first.push({
        name: step0,
        parent: null,
        category: category
      });
      var components = Array.isArray(category.props.components) ? category.props.components : [];
      // 第二回層は `FeatureCategoriesContainer` / `...etc`
      // `FeatureCategoriesContainer` のみに filter する
      components.map(function (component, count) {
        // console.log('FeatureCategories.parseCategoriesList.map', component);
        if (component.name === 'FeatureCategoryContainer') {
          var step1 = step0 + '-second' + count;
          list.second.push({
            name: step1,
            parent: step0,
            category: component
          });
        }
        return component;
      });
      return category;
    });

    // 初期ロード時のデフォルトコンテントを配列にする
    var defaultContent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(list.first, function (_ref) {
      var name = _ref.name;
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(filterId, name) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(name, filterId);
    });

    // 選択したカレントカテゴリのコンテントを配列にする
    var selectedContent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(list.second, function (_ref2) {
      var parent = _ref2.parent;
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(filterId, parent) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(parent, filterId);
    });

    var syncedSelectedContent = selectedContent || [];
    list.concat = [].concat(defaultContent, syncedSelectedContent);

    this.containers = list;
  };

  /**
   * 選択したメニューに応じて、カレントカテゴリを切り替える
   */


  FeatureCategories.prototype.getCurrentCategoryContent = function getCurrentCategoryContent(categories, filterId) {
    // 選択したカレントカテゴリのコンテントを配列にする
    var selectedContent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.containers.second, function (_ref3) {
      var parent = _ref3.parent;
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(filterId, parent) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(parent, filterId);
    });

    var syncedSelectedContent = selectedContent || [];
    this.containers.concat = [].concat(this.containers.first, syncedSelectedContent);
  };

  /**
   * filter id が second list を持つか判定し index を返します
   * @param currentFilterID
   * @returns {{result: boolean, index: number}}
   */


  FeatureCategories.prototype.hasSecondItems = function hasSecondItems(currentFilterID) {
    var index = -1;
    if (!FeatureCategories.isFirstFilterId(currentFilterID)) {
      return { result: false, index: index };
    }
    var second = this.containers.second;

    var result = second.some(function (data, i) {
      if (data.parent === currentFilterID) {
        index = i;
        return true;
      }
      return false;
    });
    return { result: result, index: index };
  };

  /**
   * first filter selected - second filter exist の時は second filter first を active にするための対応
   * */


  FeatureCategories.prototype.shouldSecondFirstActivate = function shouldSecondFirstActivate() {
    // 選択 filter id が first で second が存在するかのチェック
    var _hasSecondItems = this.hasSecondItems(this.state.currentFilterId),
        result = _hasSecondItems.result,
        index = _hasSecondItems.index;

    if (!result) {
      return;
    }
    var data = this.containers.second[index];
    if (data.name !== this.state.currentFilterId) {
      // console.log('FeatureCategories.shouldSecondFirstActivate changed', result, index, data.name, this.state.currentFilterId);
      this.setState({ currentFilterId: data.name, currentFilterMarkedId: data.name });
      return true;
    }
    return false;
  };

  // --------------------------------------------------


  FeatureCategories.prototype.componentDidUpdate = function componentDidUpdate() {
    this.shouldSecondFirstActivate();
  };

  FeatureCategories.prototype.componentDidMount = function componentDidMount() {
    this.shouldSecondFirstActivate();
    window.addEventListener('resize', this.onResize, false);
    // window.addEventListener('blur', this.onBlur, false);
  };

  FeatureCategories.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    // window.removeEventListener('blur', this.onBlur);
    Object.values(this.timer).map(function (id) {
      return clearTimeout(id);
    });
  };

  // --------------------------------------------------
  /**
   * 各カテゴリのコンテントを表示するための DOM 要素を返す
   */


  FeatureCategories.prototype.renderContainers = function renderContainers() {
    var currentFilterId = this.state.currentFilterId;

    var _hasSecondItems2 = this.hasSecondItems(currentFilterId),
        result = _hasSecondItems2.result,
        index = _hasSecondItems2.index;

    this.getCurrentCategoryContent(this.categories, currentFilterId);
    var current = result ? [this.containers.second[index]] : this.containers.concat.filter(function (data) {
      return data.name === currentFilterId;
    });
    // @type {array} filter id に該当する `PickerContainer` を探す
    // const current = this.containers.concat.filter(data => (data.parent === currentFilterId || data.name === currentFilterId));
    if (!current.length) {
      return null;
    }
    // ---
    var _props = this.props,
        layout = _props.layout,
        pcDisplayLine = _props.pcDisplayLine,
        mbDisplayLine = _props.mbDisplayLine,
        readMoreLabel = _props.readMoreLabel,
        selectTextColor = _props.selectTextColor;
    // ---
    // 配列から data を取り出す

    var data = current.shift();
    // const divided = currentFilterId.split('-');
    // const [ keyName, parentIndex, childName ] = divided;
    var component = data.category;
    var _state = this.state,
        containerIndex = _state.containerIndex,
        filterChangeOpacityClassName = _state.filterChangeOpacityClassName;

    var currentContainerIndex = containerIndex < 0 ? 0 : parseInt(containerIndex, 10);
    // console.log(`FeatureCategories.renderContainers filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, currentFilterId, current);
    // ---
    var props = Object.assign({}, component.props);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */], _extends({}, props, {
      showTitle: false,
      currentFilterId: currentFilterId,
      filterId: currentFilterId,
      currentContainerIndex: currentContainerIndex,
      layout: layout,
      pcDisplayLine: pcDisplayLine,
      mbDisplayLine: mbDisplayLine,
      hasSecond: false,
      readMoreLabel: readMoreLabel,
      selectTextColor: selectTextColor
      // filterChangeOpacityClassName={filterChangeOpacityClassName}
      , abortOpacityZero: this.abortOpacityZero,
      changedFilter: this.changedFilter,
      slickThumbnailChangedCallback: this.slickThumbnailChangedCallback,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 630
      }
    }));
  };

  // --------------------------------------------------
  // filter
  /**
   * 各カテゴリーを表示するための DOM 要素を返す
   */


  FeatureCategories.prototype.renderFilterFirst = function renderFilterFirst() {
    var _this3 = this;

    var first = this.containers.first;
    // title 不正値除く

    var firstTitles = first.filter(function (data) {
      return !!data.category.props.title;
    });
    if (!firstTitles.length) {
      return null;
    }
    if (!first.length) {
      return null;
    }
    var _state2 = this.state,
        currentFilterId = _state2.currentFilterId,
        currentFilterMarkedId = _state2.currentFilterMarkedId;

    this.filterFirstTitles = {};
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: 'FeatureCategories__filter__first',
        ref: function ref(component) {
          return _this3.refFilterFirst = component;
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 668
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'FeatureCategories__filter__first__title__wrap',
          ref: function ref(component) {
            return _this3.refFilterFirstWrap = component;
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 672
          }
        },
        firstTitles.map(function (data, index) {
          var component = data.category;
          // console.log('FeatureCategories.renderFilterFirst.map', index, component);
          var id = data.name;

          var _hasSecondItems3 = _this3.hasSecondItems(id),
              result = _hasSecondItems3.result;

          var props = Object.assign({}, component.props);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */], _extends({
            key: id
          }, props, {
            showTitle: true,
            currentFilterId: currentFilterId,
            currentFilterMarkedId: currentFilterMarkedId,
            filterId: id,
            filterIndex: index,
            titleClickCaller: _this3.onTitleClickCaller,
            hasSecond: result,
            ref: function ref(component) {
              return _this3.filterFirstTitles[id] = component;
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 684
            }
          }));
        })
      )
    );
  };
  /**
   * filter second PC
   * @returns {ReactElement} `div.FeatureCategories__filter__second-pc`
   */


  FeatureCategories.prototype.renderFilterSecondPc = function renderFilterSecondPc() {
    var _this4 = this;

    var second = this.containers.second;
    var _state3 = this.state,
        currentFilterId = _state3.currentFilterId,
        currentFilterMarkedId = _state3.currentFilterMarkedId;
    // console.log('FeatureCategories.renderFilterSecondPc', currentFilterId, second, this.state);

    var filtered = second.filter(function (data) {
      return data.parent === currentFilterId || data.name === currentFilterId || FeatureCategories.secondFilterContains(data.parent, currentFilterId);
    })
    // title 不正値除く
    .filter(function (data) {
      return !!data.category.props.title;
    });
    if (!filtered.length) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategories__filter__second-pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 719
        }
      },
      filtered.map(function (data, index) {
        var component = data.category;
        var id = data.name;
        var props = Object.assign({}, component.props);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */], _extends({
          key: id
        }, props, {
          showTitle: true,
          currentFilterId: currentFilterId,
          currentFilterMarkedId: currentFilterMarkedId,
          filterId: id,
          filterIndex: index,
          titleClickCaller: _this4.onTitleClickCaller,
          hasSecond: false,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 726
          }
        }));
      })
    );
  };
  /**
   * filter second MB
   * @returns {ReactElement} `div.FeatureCategories__filter__second-mb`
   */


  FeatureCategories.prototype.renderFilterSecondMb = function renderFilterSecondMb() {
    var _this5 = this;

    var second = this.containers.second;
    var _state4 = this.state,
        currentFilterId = _state4.currentFilterId,
        filterTitle = _state4.filterTitle,
        filterSecondOpen = _state4.filterSecondOpen,
        currentFilterMarkedId = _state4.currentFilterMarkedId;
    // ---

    var filtered = second.filter(function (data) {
      return data.parent === currentFilterId || data.name === currentFilterId || FeatureCategories.secondFilterContains(data.parent, currentFilterId);
    })
    // title 不正値除く
    .filter(function (data) {
      return !!data.category.props.title;
    });
    if (!filtered.length) {
      return null;
    }
    var openedClass = filterSecondOpen ? 'FeatureCategories__filter__second__opened' : '';
    var filterSelectedTitle = filterTitle || filtered[0].category.props.title;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategories__filter__second-mb ' + openedClass, __source: {
          fileName: _jsxFileName,
          lineNumber: 766
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategories__filter__second__heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 767
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'FeatureCategories__filter__second__heading__title__set',
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(filterSelectedTitle) },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 768
          }
        }),
        filtered.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'FeatureCategories__filter__second__heading__btn',
          type: 'button',
          onClick: function onClick(event) {
            event.preventDefault();
            // const opposite = !filterSecondOpen;
            // toggle open / close
            _this5.setState({ filterSecondOpen: !filterSecondOpen });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 774
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'FeatureCategories__filter__second__heading__btn__margin', __source: {
            fileName: _jsxFileName,
            lineNumber: 784
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'FeatureCategories__filter__second__title__list', __source: {
            fileName: _jsxFileName,
            lineNumber: 787
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FeatureCategories__filter__second__title__wrap', __source: {
              fileName: _jsxFileName,
              lineNumber: 788
            }
          },
          filtered.map(function (data, index) {
            var component = data.category;
            var id = data.name;
            var props = Object.assign({}, component.props);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__feature_category_container__["a" /* default */], _extends({
              key: id
            }, props, {
              showTitle: true,
              currentFilterId: currentFilterId,
              currentFilterMarkedId: currentFilterMarkedId,
              filterId: id,
              filterIndex: index,
              titleClickCaller: _this5.onTitleClickCaller,
              parentFilter: data.parent,
              hasSecond: false,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 795
              }
            }));
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: 'FeatureCategories__filter__second__title__list__btn__close',
          type: 'button',
          onClick: function onClick(event) {
            event.preventDefault();
            _this5.setState({ filterSecondOpen: false });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 811
          }
        })
      )
    );
  };

  // render filter


  FeatureCategories.prototype.renderFilterSecond = function renderFilterSecond() {
    var pc = this.renderFilterSecondPc();
    var mb = this.renderFilterSecondMb();
    if (!pc && !mb) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'filter__seconds__root', __source: {
          fileName: _jsxFileName,
          lineNumber: 832
        }
      },
      pc,
      mb
    );
  };

  FeatureCategories.prototype.renderFilters = function renderFilters() {
    var filterFirst = this.renderFilterFirst();
    var filterSecond = this.renderFilterSecond();
    if (!filterFirst && !filterSecond) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'FeatureCategories__filter', __source: {
          fileName: _jsxFileName,
          lineNumber: 846
        }
      },
      filterFirst,
      filterSecond
    );
  };

  // --------------------------------------------------


  FeatureCategories.prototype.render = function render() {
    var _props2 = this.props,
        containerId = _props2.containerId,
        containerClass = _props2.containerClass,
        anchorPoint = _props2.anchorPoint,
        anchorName = _props2.anchorName,
        selectTextColor = _props2.selectTextColor,
        layout = _props2.layout;
    // ---

    var categories = this.categories;
    // console.log('FeatureCategories.render', categories);
    if (!categories.length) {
      return null;
    }
    // ---
    var textColorClass = 'selectTextColor__' + (selectTextColor || 'Dark').toLowerCase();
    var layoutClass = 'layout__' + (layout || 'Horizontal').toLowerCase();
    // const slickTransitionClass = this.slickTransitionZero ? this.abortSlickTransitionClassName : '';
    var _state5 = this.state,
        slickTransitionClassName = _state5.slickTransitionClassName,
        filterChangeOpacityClassName = _state5.filterChangeOpacityClassName;
    // ---

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 876
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 882
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FeatureCategories ' + textColorClass + ' ' + layoutClass + ' ' + slickTransitionClassName + ' ' + filterChangeOpacityClassName, __source: {
              fileName: _jsxFileName,
              lineNumber: 883
            }
          },
          this.renderFilters(),
          this.renderContainers()
        )
      )
    );
  };

  return FeatureCategories;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  selectTextColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mbDisplayLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  readMoreLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  categories: [],
  selectTextColor: 'Dark',
  layout: 'Horizontal',
  pcDisplayLine: 4,
  mbDisplayLine: 4,
  readMoreLabel: null
}, _temp);
FeatureCategories.displayName = 'FeatureCategories';


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(96)(module)))

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_exterior_view_BodyTypeSelector__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_exterior_view_GradeSelector__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_exterior_view_ColorSelector__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_exterior_view_ColorInfo__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_exterior_view_EstimateLink__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_exterior_view_AccessorySelector__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_exterior_view_Viewer__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scroll_loader__ = __webpack_require__(25);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













//import * as model from "../../utils";






/**
 *  ExteriorView
 */
var ExteriorView = (_temp = _class = function (_Component) {
  _inherits(ExteriorView, _Component);

  function ExteriorView(props) {
    _classCallCheck(this, ExteriorView);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      if (!_this.refs.content || !_this.refs.navigation) return;
      _this.setState({
        gradeSelectorHeight: _this.refs.content.offsetHeight - _this.refs.navigation.offsetTop - 55
      });
    };

    _this.getBodyTypeInfo = function () {
      if (_this.props.models[0].bodyTypes && Array.isArray(_this.props.models[0].bodyTypes) && 1 <= _this.props.models[0].bodyTypes.length) {
        return _this.props.models[0].bodyTypes;
      }
      return [];
    };

    _this.getBodyTypeId = function (currentBodyTypeId) {
      var bodyTypeInfo = _this.getBodyTypeInfo();
      var i = void 0,
          max = void 0;
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(bodyTypeInfo[i].carId, currentBodyTypeId)) {
          return bodyTypeInfo[i].carId;
        }
      }
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (bodyTypeInfo[i].default === true) {
          return bodyTypeInfo[i].carId;
        }
      }
      return bodyTypeInfo[0].carId;
    };

    _this.getGradeInfo = function (currentBodyTypeId) {
      var bodyTypeInfo = _this.getBodyTypeInfo();
      var i = void 0,
          max = void 0;
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        // if (bodyTypeInfo[i].carId === currentBodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(bodyTypeInfo[i].carId, currentBodyTypeId)) {
          return bodyTypeInfo[i].generations[0].grades;
        }
      }
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (bodyTypeInfo[i].default === true) {
          return bodyTypeInfo[i].generations[0].grades;
        }
      }
      return bodyTypeInfo[0].generations[0].grades;
    };

    _this.getGradeName = function (currentBodyTypeId, currentGradeId) {
      var gradeInfo = _this.getGradeInfo(currentBodyTypeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === currentGradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, currentGradeId)) {
          // 特別仕様車の場合はgradeIdを採用する
          if (gradeInfo[i].specialCar === true) {
            return gradeInfo[i].gradeId;
          } else {
            return gradeInfo[i].gradeName && gradeInfo[i].gradeName !== '' ? gradeInfo[i].gradeName : gradeInfo[i].gradeId;
          }
        }
      }
      return null;
    };

    _this.getColorInfo = function (currentBodyTypeId, currentGradeId) {
      var gradeInfo = _this.getGradeInfo(currentBodyTypeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === currentGradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, currentGradeId)) {
          return gradeInfo[i].colors;
        }
      }
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          return gradeInfo[i].colors;
        }
      }
      return gradeInfo[0].colors;
    };

    _this.getEstimateInfo = function (currentBodyTypeId, currentGradeId) {
      var gradeInfo = _this.getGradeInfo(currentBodyTypeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === currentGradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, currentGradeId)) {
          return {
            gradeId: gradeInfo[i].gradeId,
            gradeCode: gradeInfo[i].gradeCode,
            engine: gradeInfo[i].engine,
            drive: gradeInfo[i].defaultDrive,
            mission: gradeInfo[i].defaultMission
          };
        }
      }
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          return {
            gradeId: gradeInfo[i].gradeId,
            gradeCode: gradeInfo[i].gradeCode,
            engine: gradeInfo[i].engine,
            drive: gradeInfo[i].defaultDrive,
            mission: gradeInfo[i].defaultMission
          };
        }
      }
      return {
        gradeId: gradeInfo[0].gradeId,
        gradeCode: gradeInfo[0].gradeCode,
        engine: gradeInfo[0].engine,
        drive: gradeInfo[0].defaultDrive,
        mission: gradeInfo[0].defaultMission
      };
    };

    _this.getCarTypeCode = function (currentBodyTypeId) {
      var bodyTypeInfo = _this.getBodyTypeInfo();
      var i = void 0,
          max = void 0;
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        // if (bodyTypeInfo[i].carId === currentBodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(bodyTypeInfo[i].carId, currentBodyTypeId)) {
          return bodyTypeInfo[i].generations[0].carTypeCode;
        }
      }
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (bodyTypeInfo[i].default === true) {
          return bodyTypeInfo[i].generations[0].carTypeCode;
        }
      }
      return bodyTypeInfo[0].generations[0].carTypeCode;
    };

    _this.getDefaultModel = function () {
      if (_this.props.models[0]) {
        return _this.props.models[0];
      }
      return null;
    };

    _this.getDefaultGeneration = function () {
      var bodyTypeInfo = _this.getBodyTypeInfo();
      var i = void 0,
          max = void 0;
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (bodyTypeInfo[i].default === true) {
          return bodyTypeInfo[i].generations[0];
        }
      }
      return bodyTypeInfo[0].generations[0];
    };

    _this.getDefaultBodyType = function () {
      var bodyTypeInfo = _this.getBodyTypeInfo();
      var i = void 0,
          max = void 0;
      for (i = 0, max = bodyTypeInfo.length; i < max; i = i + 1) {
        if (bodyTypeInfo[i].default === true) {
          return bodyTypeInfo[i];
        }
      }
      return bodyTypeInfo[0];
    };

    _this.getDefaultGrade = function () {
      var gradeInfo = _this.getGradeInfo(_this.getDefaultBodyType().models);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          return gradeInfo[i];
        }
      }
      return gradeInfo[0];
    };

    _this.getDefaultColor = function () {
      var models = _this.getDefaultBodyType().models;
      var gradeId = _this.getGradeInfo(models).gradeId;
      var colorInfo = _this.getColorInfo(models, gradeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
        if (colorInfo[i].default === true) {
          return colorInfo[i];
        }
      }
      return colorInfo[0];
    };

    _this.setCurrentByParams = function () {

      if (_this.props.format === 'Single-Grade') return;

      var setCurrent = function setCurrent(bodyTypeId) {
        var gradeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


        // BodyType情報取得
        var getBodyTypeInfo = function getBodyTypeInfo() {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this.props.models.length; i < max; i = i + 1) {
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = _this.props.models[i].bodyTypes.length; j < max2; j = j + 1) {
              // if (this.props.models[i].bodyTypes[j].carId === bodyTypeId) {
              if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(_this.props.models[i].bodyTypes[j].carId, bodyTypeId)) {
                return _this.props.models[i].bodyTypes[j];
              }
            }
          }
          return null;
        };
        var bodyTypeInfo = getBodyTypeInfo();

        if (bodyTypeInfo && gradeId) {

          // グレード情報取得
          var getGradeInfo = function getGradeInfo() {
            var i = void 0,
                max = void 0;
            for (i = 0, max = bodyTypeInfo.generations.length; i < max; i = i + 1) {
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = bodyTypeInfo.generations[i].grades.length; j < max2; j = j + 1) {
                // if (bodyTypeInfo.generations[i].grades[j].gradeId === gradeId) {
                if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(bodyTypeInfo.generations[i].grades[j].gradeId, gradeId)) {
                  return bodyTypeInfo.generations[i].grades[j];
                }
              }
            }
            return null;
          };
          var gradeInfo = getGradeInfo();
          if (gradeInfo) {

            // BodyType及びグレードが存在した場合
            _this.changeBodyType(bodyTypeId);
            _this.changeGrade(bodyTypeId, gradeId);
          } else {

            // BodyTypeのみ存在した場合
            _this.changeBodyType(bodyTypeId);
          }
        } else {

          // BodyTypeのみ存在した場合
          _this.changeBodyType(bodyTypeId);
        }
      };

      if (_this.props.format === 'Select-Bodytype') {

        // URLパラメータでカレント変更
        var carId = __WEBPACK_IMPORTED_MODULE_13__components_body__["a" /* default */].getUrlParameter('car_id');
        if (carId) {
          setCurrent(carId);
        } else {
          // ブロックのCookieに保温されている値でカレント変更
          carId = Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["d" /* getCookie */])('mj_360bt');
          if (carId) {
            setCurrent(carId);
          } else {
            // 車種サイトのCookieに保温されている値でカレント変更
            carId = Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["d" /* getCookie */])('mjcarid');
            if (carId) {
              setCurrent(carId);
            }
          }
        }
      } else {

        // URLパラメータでカレント変更
        var _carId = __WEBPACK_IMPORTED_MODULE_13__components_body__["a" /* default */].getUrlParameter('car_id');
        var gradeId = __WEBPACK_IMPORTED_MODULE_13__components_body__["a" /* default */].getUrlParameter('grade');
        if (_carId || gradeId) {
          if (_carId && gradeId) {
            setCurrent(_carId, gradeId);
          } else if (_carId) {
            setCurrent(_carId);
          }
        } else {
          // ブロックのCookieに保温されている値でカレント変更
          _carId = Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["d" /* getCookie */])('mj_360bt');
          gradeId = Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["d" /* getCookie */])('mj_360gr');
          if (_carId || gradeId) {
            if (_carId && gradeId) {
              setCurrent(_carId, gradeId);
            } else if (_carId) {
              setCurrent(_carId);
            }
          } else {
            // 車種サイトのCookieに保温されている値でカレント変更
            _carId = Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["d" /* getCookie */])('mjcarid');
            if (_carId) {
              setCurrent(_carId);
            }
          }
        }
      }
    };

    _this.props = props;
    if (!_this.props.models) return _possibleConstructorReturn(_this);
    //
    //console.log(JSON.stringify(this.props));
    //console.log(this.props);
    //
    var defaultModel = _this.getDefaultModel();
    var defaultBodyType = _this.getDefaultBodyType();
    var defaultGeneration = _this.getDefaultGeneration();
    var defaultGrade = _this.getDefaultGrade();
    var defaultColor = _this.getDefaultColor();
    //
    _this.state = {
      currentModelId: defaultModel ? defaultModel.name : null,
      currentBodyTypeId: defaultBodyType ? defaultBodyType.carId : null,
      currentGenerationId: defaultGeneration ? defaultGeneration.carTypeCode : null,
      currentGradeId: defaultGrade ? defaultGrade.gradeId : null,
      //currentGradeCode: defaultGrade.gradeCode,
      currentColorId: defaultColor ? defaultColor.code : null,
      //angle: 0,
      colorPrice: defaultColor ? defaultColor.price : null,
      colorTaxPrice: defaultColor ? defaultColor.taxPrice : null,
      colorName: defaultColor ? defaultColor.name : null,
      selectedAccessoryIndexList: '',
      selectedAccessoryIdList: [],
      isOpenedGradeSelector: false,
      isOpenedAccessorySelector: false,
      gradeSelectorHeight: 0,
      backgroundSrc: _this.props.backgroundSrc
    };

    //
    _this.accessorySelectorRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();

    return _this;
  }

  ExteriorView.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.props.models) return;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    //console.log('ExteriorView : componentDidMount');
    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this2.handleResize();
    }, 500);
    // 背景
    if (__WEBPACK_IMPORTED_MODULE_14__constants_environment__["g" /* IS_MOBILE */] === true && this.props.mbBackgroundSrc && this.props.mbBackgroundSrc !== '') {
      this.setState({
        backgroundSrc: this.props.mbBackgroundSrc
      });
    }

    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();
  };

  ExteriorView.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.models) return;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    window.removeEventListener('resize', this.handleResize);
  };

  ExteriorView.prototype.changeBodyType = function changeBodyType(model) {

    model = this.getBodyTypeId(model);

    //console.log('changeBodyType: ' + model);
    this.setState({
      currentBodyTypeId: model,
      currentGenerationId: this.getCarTypeCode(model)
    });
    // ボディータイプを切り替えた際に選択済みグレードがボディータイプにない場合の処理
    var gradeInfo = this.getGradeInfo(model);
    if (this.props.format === 'Select-Bodytype') {
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // if (gradeInfo[i].gradeId === this.state.currentGradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, this.state.currentGradeId)) {
          this.changeGrade(model, gradeInfo[i].gradeId);
          return;
        }
      }
    } else {
      var _i = void 0,
          _max = void 0;
      for (_i = 0, _max = gradeInfo.length; _i < _max; _i = _i + 1) {
        // if (gradeInfo[i].gradeId === this.state.currentGradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_15__utilities__["f" /* isEqualId */])(gradeInfo[_i].gradeId, this.state.currentGradeId)) {
          this.changeGrade(model, gradeInfo[_i].gradeId);
          return;
        }
      }
      for (_i = 0, _max = gradeInfo.length; _i < _max; _i = _i + 1) {
        if (gradeInfo[_i].default === true) {
          this.changeGrade(model, gradeInfo[_i].gradeId);
          return;
        }
      }
    }
    this.changeGrade(model, gradeInfo[0].gradeId);
  };

  ExteriorView.prototype.changeGrade = function changeGrade(model, gradeId) {
    //console.log('changeGrade: ' + gradeId);
    this.setState({
      currentGradeId: gradeId
    });
    // グレードを切り替えた際に選択済みカラーがボディタイプない場合の処理
    var colorInfo = this.getColorInfo(model, gradeId);
    var i = void 0,
        max = void 0;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === this.state.currentColorId) {
        this.changeColor(model, gradeId, colorInfo[i].code);
        return;
      }
    }
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].default === true) {
        this.changeColor(model, gradeId, colorInfo[i].code);
        return;
      }
    }
    this.changeColor(model, gradeId, colorInfo[0].code);
  };

  ExteriorView.prototype.changeColor = function changeColor(model, gradeId, code) {
    //console.log('changeColor: ' + code);
    var colorPrice = null;
    var colorTaxPrice = null;
    var colorName = null;
    var colorInfo = this.getColorInfo(model, gradeId);
    var i = void 0,
        max = void 0;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === code) {
        colorPrice = colorInfo[i].price;
        colorTaxPrice = colorInfo[i].taxPrice;
        colorName = colorInfo[i].name;
        break;
      }
    }
    //
    this.setState({
      currentColorId: code,
      colorPrice: colorPrice,
      colorTaxPrice: colorTaxPrice,
      colorName: colorName
    });
  };

  ExteriorView.prototype.changeAccessories = function changeAccessories(indexList, idList) {
    //console.log('changeAccessories');
    this.setState({
      selectedAccessoryIndexList: indexList.join(','),
      selectedAccessoryIdList: idList
    });
  };

  ExteriorView.prototype.showColorInfo = function showColorInfo(model, gradeId, code) {
    //console.log('showColorInfo');
    var colorInfo = this.getColorInfo(model, gradeId);
    var i = void 0,
        max = void 0;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === code) {
        this.setState({
          colorPrice: colorInfo[i].price,
          colorTaxPrice: colorInfo[i].taxPrice,
          colorName: colorInfo[i].name
        });
        break;
      }
    }
  };

  ExteriorView.prototype.hideColorInfo = function hideColorInfo() {
    //console.log('hideColorInfo');
    var colorInfo = this.getColorInfo(this.state.currentBodyTypeId, this.state.currentGradeId);
    var i = void 0,
        max = void 0;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      if (colorInfo[i].code === this.state.currentColorId) {
        this.setState({
          colorPrice: colorInfo[i].price,
          colorTaxPrice: colorInfo[i].taxPrice,
          colorName: colorInfo[i].name
        });
        break;
      }
    }
  };

  ExteriorView.prototype.openAccessoryDetail = function openAccessoryDetail() {
    //console.log('openAccessoryDetail');
    this.refs.modalWindow.open();
  };

  ExteriorView.prototype.closeAccessoryDetail = function closeAccessoryDetail() {
    //console.log('closeAccessoryDetail');
    this.refs.modalWindow.close();
  };

  ExteriorView.prototype.openGradeSelector = function openGradeSelector() {
    //console.log('openGradeSelector');
    this.setState({
      isOpenedGradeSelector: true
    });
  };

  ExteriorView.prototype.closeGradeSelector = function closeGradeSelector() {
    //console.log('closeGradeSelector');
    this.setState({
      isOpenedGradeSelector: false
    });
  };

  ExteriorView.prototype.openAccessorySelector = function openAccessorySelector() {
    this.setState({
      isOpenedAccessorySelector: true
    });
    //
    __WEBPACK_IMPORTED_MODULE_13__components_body__["a" /* default */].scrollToNode(this.refs.accessory);
  };

  ExteriorView.prototype.closeAccessorySelector = function closeAccessorySelector() {
    this.setState({
      isOpenedAccessorySelector: false
    });
    //
    __WEBPACK_IMPORTED_MODULE_13__components_body__["a" /* default */].scrollToNode(this.refs.heading);
  };

  ExteriorView.prototype.render = function render() {
    var _this3 = this;

    if (!this.props.models) return null;
    if (!this.state.currentModelId || !this.state.currentBodyTypeId || !this.state.currentGenerationId || !this.state.currentGradeId || !this.state.currentColorId) return null;
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        format = _props.format,
        hideEstimationButton = _props.hideEstimationButton,
        title = _props.title,
        colorInformation = _props.colorInformation,
        backgroundSrc = _props.backgroundSrc,
        mbBackgroundSrc = _props.mbBackgroundSrc,
        estimationDisplay = _props.estimationDisplay,
        description = _props.description,
        accessoryLabel = _props.accessoryLabel,
        accessoryDetail = _props.accessoryDetail,
        accessories = _props.accessories,
        models = _props.models;

    // タイトル

    var renderTitle = function renderTitle() {
      if (title && title !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ExteriorView__heading Wysiwyg',
          ref: 'heading',
          dangerouslySetInnerHTML: { __html: title },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 366
          }
        });
      } else {
        return null;
      }
    };

    // ナビゲーション
    var renderNavigation = function renderNavigation() {
      if (format === 'Select-Grade') {
        // 全て選択可能
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorView__navigation',
            ref: 'navigation',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 381
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_exterior_view_BodyTypeSelector__["a" /* default */], {
            bodyTypeInfo: _this3.getBodyTypeInfo(),
            currentBodyTypeId: _this3.state.currentBodyTypeId,
            changeBodyType: function changeBodyType(model) {
              _this3.changeBodyType(model);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 384
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_exterior_view_GradeSelector__["a" /* default */], {
            open: _this3.state.isOpenedGradeSelector,
            gradeInfo: _this3.getGradeInfo(_this3.state.currentBodyTypeId),
            currentGradeId: _this3.state.currentGradeId,
            changeGrade: function changeGrade(gradeId) {
              _this3.changeGrade(_this3.state.currentBodyTypeId, gradeId);
            },
            openGradeSelector: function openGradeSelector() {
              _this3.openGradeSelector();
            },
            closeGradeSelector: function closeGradeSelector() {
              _this3.closeGradeSelector();
            },
            contentHeight: _this3.state.gradeSelectorHeight,
            currentBodyTypeId: _this3.state.currentBodyTypeId,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 391
            }
          })
        );
      } else if (format === 'Select-Bodytype') {
        // ボディタイプのみ選択可能
        var gradeName = _this3.getGradeName(_this3.state.currentBodyTypeId, _this3.state.currentGradeId);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorView__navigation',
            ref: 'navigation',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 413
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_exterior_view_BodyTypeSelector__["a" /* default */], {
            bodyTypeInfo: _this3.getBodyTypeInfo(),
            currentBodyTypeId: _this3.state.currentBodyTypeId,
            changeBodyType: function changeBodyType(model) {
              _this3.changeBodyType(model);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 416
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'ExteriorView__navigation__paragraph', __source: {
                fileName: _jsxFileName,
                lineNumber: 423
              }
            },
            gradeName
          )
        );
      } else if (format === 'Single-Grade') {
        var _gradeName = _this3.getGradeName(_this3.state.currentBodyTypeId, _this3.state.currentGradeId);
        // グレード固定
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorView__navigation',
            ref: 'navigation',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 431
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'ExteriorView__navigation__paragraph', __source: {
                fileName: _jsxFileName,
                lineNumber: 434
              }
            },
            _gradeName
          )
        );
      } else {
        return null;
      }
    };

    // ビューアー
    var renderViewer = function renderViewer() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__containers_exterior_view_Viewer__["a" /* default */], {
        modelId: _this3.state.currentModelId,
        bodyTypeId: _this3.state.currentBodyTypeId,
        generationId: _this3.state.currentGenerationId,
        gradeId: _this3.state.currentGradeId,
        colorId: _this3.state.currentColorId,
        accessoryIndexList: _this3.state.selectedAccessoryIndexList
        //angle={this.state.angle}
        , __source: {
          fileName: _jsxFileName,
          lineNumber: 447
        }
      });
    };

    // アクセサリ選択
    var renderAccessorySelector = function renderAccessorySelector() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__containers_exterior_view_AccessorySelector__["a" /* default */],
        {
          open: _this3.state.isOpenedAccessorySelector,
          accessoryLabel: accessoryLabel,
          colorInfo: _this3.getColorInfo(_this3.state.currentBodyTypeId, _this3.state.currentGradeId),
          currentColorId: _this3.state.currentColorId,
          openAccessoryDetail: function openAccessoryDetail() {
            _this3.openAccessoryDetail();
          },
          closeAccessoryDetail: function closeAccessoryDetail() {
            _this3.closeAccessoryDetail();
          },
          openAccessorySelector: function openAccessorySelector() {
            _this3.openAccessorySelector();
          },
          closeAccessorySelector: function closeAccessorySelector() {
            _this3.closeAccessorySelector();
          },
          changeAccessories: function changeAccessories(indexList, idList) {
            _this3.changeAccessories(indexList, idList);
          },
          ref: _this3.accessorySelectorRef,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 462
          }
        },
        accessories
      );
    };

    // カラー選択
    var renderColorSelector = function renderColorSelector() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_exterior_view_ColorSelector__["a" /* default */], {
        colorInfo: _this3.getColorInfo(_this3.state.currentBodyTypeId, _this3.state.currentGradeId),
        currentColorId: _this3.state.currentColorId,
        changeColor: function changeColor(code) {
          _this3.changeColor(_this3.state.currentBodyTypeId, _this3.state.currentGradeId, code);
        },
        showColorInfo: function showColorInfo(code) {
          _this3.showColorInfo(_this3.state.currentBodyTypeId, _this3.state.currentGradeId, code);
        },
        hideColorInfo: function hideColorInfo() {
          _this3.hideColorInfo();
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 492
        }
      });
    };

    // カラー情報
    var renderColorInfo = function renderColorInfo() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_exterior_view_ColorInfo__["a" /* default */], {
        name: _this3.state.colorName,
        colorInformation: colorInformation,
        price: _this3.state.colorPrice,
        taxPrice: _this3.state.colorTaxPrice,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 511
        }
      });
    };

    // 見積もりボタン
    var renderEstimationLink = function renderEstimationLink() {
      if (hideEstimationButton === false) {
        var estimateInfo = _this3.getEstimateInfo(_this3.state.currentBodyTypeId, _this3.state.currentGradeId);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers_exterior_view_EstimateLink__["a" /* default */], {
          carId: _this3.state.currentBodyTypeId,
          carTypeCode: _this3.getCarTypeCode(_this3.state.currentBodyTypeId),
          estimationDisplay: estimationDisplay,
          gradeId: _this3.state.currentGradeId,
          gradeCode: estimateInfo.gradeCode,
          engine: estimateInfo.engine,
          drive: estimateInfo.drive,
          mission: estimateInfo.mission,
          colorId: _this3.state.currentColorId,
          accessoryIdList: _this3.state.selectedAccessoryIdList,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 525
          }
        });
      } else {
        return null;
      }
    };

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 545
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 551
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'ExteriorView',
            ref: 'content',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 552
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ExteriorView__container',
              style: this.state.backgroundSrc && this.state.backgroundSrc !== '' ? { backgroundImage: 'url(' + this.state.backgroundSrc + ')' } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 556
              }
            },
            renderTitle(),
            renderNavigation(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { ref: 'viewer', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 564
                }
              },
              renderViewer()
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ExteriorView__container2', ref: 'accessory', __source: {
                fileName: _jsxFileName,
                lineNumber: 571
              }
            },
            this.state.isOpenedAccessorySelector === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'ExteriorView__link-close',
                href: '#',
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this3.closeAccessorySelector();
                  _this3.accessorySelectorRef.current.clearAccessoryIndex();
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 573
                }
              },
              'CLOSE'
            ) : null,
            renderAccessorySelector()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ExteriorView__container3',
              style: this.state.isOpenedAccessorySelector === true ? { display: 'none' } : null,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 585
              }
            },
            renderColorSelector(),
            renderColorInfo(),
            renderEstimationLink(),
            description && description !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'ExteriorView__description Wysiwyg', dangerouslySetInnerHTML: { __html: description }, __source: {
                fileName: _jsxFileName,
                lineNumber: 596
              }
            }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: 'ExteriorView__overlay' + (this.state.isOpenedAccessorySelector === true || this.state.isOpenedGradeSelector === true ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 600
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__components_modal_window__["a" /* default */],
            {
              type: 'Light',
              ref: 'modalWindow',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 602
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ExteriorView__accessory-detail Wysiwyg',
              dangerouslySetInnerHTML: { __html: accessoryDetail }, __source: {
                fileName: _jsxFileName,
                lineNumber: 606
              }
            })
          )
        )
      )
    );
  };

  //


  //


  //


  //


  //


  //


  //


  //


  // デフォルトモデル取得


  // デフォルト世代取得


  // デフォルトボディタイプ取得


  // デフォルトグレード取得


  // デフォルトカラー取得


  // URLパラメータでダイレクト遷移


  return ExteriorView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideEstimationButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorInformation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbBackgroundSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  estimationDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessoryLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessoryDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    nameJa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      tabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      generations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        exteriorViewDefaultGradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        grades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
          fuel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          defaultDrive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          defaultMission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            taxPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            rgb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }))
        }))
      })) })) }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  format: null,
  hideEstimationButton: null,
  title: null,
  colorInformation: null,
  backgroundSrc: null,
  mbBackgroundSrc: null,
  estimationDisplay: null,
  description: null,
  accessoryLabel: null,
  accessoryDetail: null,
  accessories: null,
  models: null
}, _temp);
ExteriorView.displayName = 'ExteriorView';


/* harmony default export */ __webpack_exports__["a"] = (ExteriorView);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\promo-slider\\index.jsx';





/**
 * PromoSlider
 */
var PromoSlider = function PromoSlider(_ref) {
  var children = _ref.children;

  var settings = {
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    fade: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    swipe: true,
    draggable: false,
    arrows: true,
    dots: true,
    adaptiveHeight: false,
    centerMode: false,
    centerPadding: 0,
    lazyLoad: 'progressive'
  };
  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'PromoSlider', __source: {
        fileName: _jsxFileName,
        lineNumber: 32
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_slick___default.a,
      _extends({}, settings, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        }
      }),
      children.map(function (child, index) {
        return child;
      })
    )
  );
};
PromoSlider.displayName = 'PromoSlider';
PromoSlider.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
};
PromoSlider.defaultProps = {
  children: null
};
/* harmony default export */ __webpack_exports__["a"] = (PromoSlider);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scroll_loader__ = __webpack_require__(25);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\equipment\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 *  Equipment
 */
var Equipment = (_temp = _class = function (_Component) {
  _inherits(Equipment, _Component);

  function Equipment(props) {
    _classCallCheck(this, Equipment);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getModalItemInfo = function () {
      var arr = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.equipmentContainer.length; i < max; i = i + 1) {
        var equipmentContainer = _this.props.equipmentContainer[i].props;
        var j = void 0,
            max2 = void 0;
        for (j = 0, max2 = equipmentContainer.equipmentItem.length; j < max2; j = j + 1) {
          var equipmentItem = equipmentContainer.equipmentItem[j].props;
          arr.push({
            containerIndex: i,
            itemIndex: j,
            detail: equipmentItem.detail,
            mbDetail: equipmentItem.mbDetail,
            itemImageSrc: equipmentItem.itemImageSrc
          });
        }
      }
      return arr;
    };

    _this.openModal = function (containerIndex, itemIndex) {
      var getIndex = function getIndex(containerIndex, itemIndex) {
        var index = 0;
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.props.equipmentContainer.length; i < max; i = i + 1) {
          var equipmentContainer = _this.props.equipmentContainer[i].props;
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = equipmentContainer.equipmentItem.length; j < max2; j = j + 1) {
            if (i === containerIndex && j === itemIndex) {
              return index;
            }
            index = index + 1;
          }
        }
        return 0;
      };
      //this.refs.modalItems.slickGoTo(getIndex(containerIndex, itemIndex), true);
      _this.refs.modalItems.onChange(getIndex(containerIndex, itemIndex));
      _this.refs.modalWindow.open('Light', 'Light');
      // BODYのスクロール無効化
      //BodyControl.openModal();
    };

    _this.onCloseModal = function () {
      //this.refs.modalItems.clearCurrentAll();
      // BODYのスクロール無効化を解除
      //BodyControl.closeModal();
    };

    _this.props = props;
    _this.state = {};
    return _this;
  }

  Equipment.prototype.render = function render() {
    var _this2 = this;

    // 詳細
    var renderDescription = function renderDescription() {
      var getDescriptionPc = function getDescriptionPc() {
        if (_this2.props.description && _this2.props.description !== '') {
          return _this2.props.description;
        } else {
          return null;
        }
      };
      var getDescriptionMb = function getDescriptionMb() {
        if (_this2.props.mbDescription && _this2.props.mbDescription !== '') {
          return _this2.props.mbDescription;
        } else {
          return getDescriptionPc();
        }
      };
      var description = getDescriptionPc();
      var descriptionMb = getDescriptionMb();
      if (description && descriptionMb) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Equipment__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 64
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Equipment__description__content-pc',
            dangerouslySetInnerHTML: { __html: description }, __source: {
              fileName: _jsxFileName,
              lineNumber: 65
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Equipment__description__content-mb',
            dangerouslySetInnerHTML: { __html: descriptionMb }, __source: {
              fileName: _jsxFileName,
              lineNumber: 67
            }
          })
        );
      } else {
        return null;
      }
    };

    // コンテナ
    var renderContainer = function renderContainer() {
      if (_this2.props.equipmentContainer && 1 <= _this2.props.equipmentContainer.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Equipment__items', __source: {
              fileName: _jsxFileName,
              lineNumber: 82
            }
          },
          _this2.props.equipmentContainer.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Equipment__items__item', key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 85
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["c" /* getComponents */])([item], {
                openModalWindow: function openModalWindow(e) {
                  e = Object.assign(e, { containerIndex: index });
                  _this2.openModal(e.containerIndex, e.itemIndex);
                }
              })
            );
          })
        );
      } else {
        return null;
      }
    };

    // 注釈
    var renderNotice = function renderNotice() {
      if (_this2.props.notice && _this2.props.notice !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Equipment__notice Wysiwyg',
          dangerouslySetInnerHTML: { __html: _this2.props.notice }, __source: {
            fileName: _jsxFileName,
            lineNumber: 106
          }
        });
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Equipment', __source: {
              fileName: _jsxFileName,
              lineNumber: 122
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Equipment__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 123
              }
            },
            renderDescription(),
            renderContainer(),
            renderNotice()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_modal_window__["a" /* default */],
            { ref: 'modalWindow', type: 'Light', onClose: this.onCloseModal, __source: {
                fileName: _jsxFileName,
                lineNumber: 128
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItems, { ref: 'modalItems', index: 0, itemsProps: this.getModalItemInfo(), onChange: this.onChangeModal, __source: {
                fileName: _jsxFileName,
                lineNumber: 129
              }
            })
          )
        )
      )
    );
  };

  return Equipment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  equipmentContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  description: null,
  mbDescription: null,
  notice: null,
  equipmentContainer: null
}, _temp);
Equipment.displayName = 'Equipment';


/* harmony default export */ __webpack_exports__["a"] = (Equipment);

var ModalItems = (_temp2 = _class2 = function (_Component2) {
  _inherits(ModalItems, _Component2);

  function ModalItems(props) {
    _classCallCheck(this, ModalItems);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.onChange = function (index) {
      // let i, max;
      // for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
      //   const item = this.refs[this.modalItemArr[i]] || null;
      //   if (item) {
      //     if (i === index) {
      //       item.setCurrent();
      //     } else {
      //       item.clearCurrent();
      //     }
      //   }
      // }
      //
      _this3.setState({
        currentIndex: index
      });
      //
      if (_this3.props.onChange !== null) _this3.props.onChange(index);
    };

    _this3.state = {
      currentIndex: 0
    };
    _this3.modalItemArr = [];
    return _this3;
  }

  // clearCurrentAll() {
  //   let i, max;
  //   for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
  //     const item = this.refs[this.modalItemArr[i]] || null;
  //     if (item) {
  //       item.clearCurrent();
  //     }
  //   }
  // }

  //
  // slickGoTo = (index, dontAnimate) => {
  //   this.refs.slider.slickGoTo(index, dontAnimate);
  //   setTimeout(() => {
  //     this.onChange(index);
  //   }, 100);
  // }

  ModalItems.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        itemsProps = _props.itemsProps,
        index = _props.index;
    //

    this.modalItemArr = [];
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ModalItems', __source: {
          fileName: _jsxFileName,
          lineNumber: 230
        }
      },
      itemsProps.map(function (itemProps, index) {
        _this4.modalItemArr.push('modalItem' + index);
        if (_this4.state.currentIndex === index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, {
            ref: 'modalItem' + index,
            key: index,
            detail: itemProps.detail ? itemProps.detail : null,
            mbDetail: itemProps.mbDetail ? itemProps.mbDetail : null
            //itemImageSrc={(itemProps.itemImageSrc) ? itemProps.itemImageSrc: null}
            , index: index,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 235
            }
          });
        } else {
          return null;
        }
      })
    );
  };

  //


  return ModalItems;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  itemsProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  itemsProps: null,
  index: null,
  onChange: null
}, _temp2);
ModalItems.displayName = 'ModalItems';
var ModalItem = (_temp3 = _class3 = function (_Component3) {
  _inherits(ModalItem, _Component3);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this5 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this5.handleResize = function () {
      var windowHeight = window.innerHeight;
      //
      _this5.setState({
        windowHeight: windowHeight
      });
    };

    _this5.state = {
      //current: false,
      windowHeight: null
    };
    return _this5;
  }

  ModalItem.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  ModalItem.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  //
  // setCurrent() {
  //   if (this.state.current === true) return;
  //   //
  //   this.setState({
  //     current: true,
  //   });
  // };
  //
  // //
  // clearCurrent() {
  //   if (this.state.current === false) return;
  //   //
  //   this.setState({
  //     current: false,
  //   });
  // }

  ModalItem.prototype.render = function render() {
    var _props2 = this.props,
        detail = _props2.detail,
        mbDetail = _props2.mbDetail;


    var getDetailPc = function getDetailPc() {
      if (detail && detail !== '') {
        return detail;
      } else {
        return null;
      }
    };
    var getDetailMb = function getDetailMb() {
      if (mbDetail && mbDetail !== '') {
        return mbDetail;
      } else {
        return getDetailPc();
      }
    };

    detail = getDetailPc();
    mbDetail = getDetailMb();

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Equipment__modal-item', style: 0 < this.state.windowHeight ? { height: this.state.windowHeight } : null, __source: {
          fileName: _jsxFileName,
          lineNumber: 420
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Equipment__modal-item__box', style: 0 < this.state.windowHeight ? { height: this.state.windowHeight } : null, __source: {
            fileName: _jsxFileName,
            lineNumber: 421
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Equipment__modal-item__box-full', __source: {
              fileName: _jsxFileName,
              lineNumber: 422
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'Equipment__modal-item__detail Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 423
              }
            },
            detail && detail !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Equipment__modal-item__detail-pc', dangerouslySetInnerHTML: { __html: detail }, __source: {
                fileName: _jsxFileName,
                lineNumber: 425
              }
            }) : null,
            mbDetail && mbDetail !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Equipment__modal-item__detail-mb', dangerouslySetInnerHTML: { __html: mbDetail }, __source: {
                fileName: _jsxFileName,
                lineNumber: 428
              }
            }) : null
          )
        )
      )
    );
    // return (
    //   <div className="Equipment__modal-item" style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight} : null}>
    //     <div className="Equipment__modal-item__box" style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight} : null}>
    //       <div className="Equipment__modal-item__box-left">
    //         <img className="Equipment__modal-item__image" src={itemImageSrc} alt=""/>
    //       </div>
    //       <div className="Equipment__modal-item__box-right">
    //         <p className="Equipment__modal-item__detail Wysiwyg">
    //           {(detail && detail !== '') ?
    //             <span className="Equipment__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
    //           : null}
    //           {(mbDetail && mbDetail !== '') ?
    //             <span className="Equipment__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
    //           : null}
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // );
  };

  //


  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //itemImageSrc: PropTypes.string,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class3.defaultProps = {
  detail: null,
  mbDetail: null,
  //itemImageSrc: null,
  index: null
}, _temp3);
ModalItem.displayName = 'ModalItem';

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accordion__ = __webpack_require__(28);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\equipment-container\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  EquipmentContainer
 */
var EquipmentContainer = (_temp = _class = function (_Component) {
  _inherits(EquipmentContainer, _Component);

  function EquipmentContainer(props) {
    _classCallCheck(this, EquipmentContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {};
    return _this;
  }

  EquipmentContainer.prototype.render = function render() {
    var _this2 = this;

    // カテゴリ
    var renderCategory = function renderCategory() {
      if (_this2.props.categoryTitle && _this2.props.categoryTitle !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_accordion__["a" /* default */],
          {
            pcText: _this2.props.categoryTitle,
            open: false,
            current: false,
            simpleAnimation: false,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 43
            }
          },
          renderItems()
        );
      } else {
        return renderItems();
      }
    };

    // アイテム
    var renderItems = function renderItems() {
      if (_this2.props.equipmentItem && 1 <= _this2.props.equipmentItem.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'EquipmentContainer__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          },
          _this2.props.equipmentItem.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 66
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["c" /* getComponents */])([item], {
                openModalWindow: function openModalWindow(e) {
                  if (_this2.props.openModalWindow !== null) {
                    _this2.props.openModalWindow(Object.assign(e, { itemIndex: index }));
                  }
                }
              })
            );
          })
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'EquipmentContainer', __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          }
        },
        renderCategory()
      )
    );
  };

  return EquipmentContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  categoryTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  equipmentItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  openModalWindow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  categoryTitle: null,
  equipmentItem: null,
  openModalWindow: null
}, _temp);
EquipmentContainer.displayName = 'EquipmentContainer';


/* harmony default export */ __webpack_exports__["a"] = (EquipmentContainer);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_window__ = __webpack_require__(29);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\equipment-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  EquipmentItem
 */
var EquipmentItem = (_temp = _class = function (_Component) {
  _inherits(EquipmentItem, _Component);

  function EquipmentItem(props) {
    _classCallCheck(this, EquipmentItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {};
    return _this;
  }

  EquipmentItem.prototype.render = function render() {
    var _this2 = this;

    // 画像
    var renderImage = function renderImage() {
      if (_this2.props.itemImageSrc && _this2.props.itemImageSrc !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'EquipmentItem__image', src: _this2.props.itemImageSrc, __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        });
      } else {
        return null;
      }
    };

    // タイトル
    var renderTitle = function renderTitle() {
      if (_this2.props.title && _this2.props.title !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'EquipmentItem__heading',
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(_this2.props.title) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        });
      } else {
        return null;
      }
    };

    // 詳細
    var renderDetail = function renderDetail() {
      var getDetailPc = function getDetailPc() {
        if (_this2.props.detail && _this2.props.detail !== '') {
          return _this2.props.detail;
        } else {
          return null;
        }
      };
      var getDetailMb = function getDetailMb() {
        if (_this2.props.mbDetail && _this2.props.mbDetail !== '') {
          return _this2.props.mbDetail;
        } else {
          return getDetailPc();
        }
      };
      var detail = getDetailPc();
      var detailMb = getDetailMb();
      if (detail && detailMb) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EquipmentItem__detail', __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'EquipmentItem__detail__link',
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                if (_this2.props.openModalWindow !== null) {
                  _this2.props.openModalWindow({
                    detail: detail,
                    detailMb: detailMb
                  });
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            _this2.props.detailLinkLabel && _this2.props.detailLinkLabel !== '' ? _this2.props.detailLinkLabel : null
          )
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'EquipmentItem', __source: {
            fileName: _jsxFileName,
            lineNumber: 119
          }
        },
        renderImage(),
        renderTitle(),
        renderDetail()
      )
    );
  };

  return EquipmentItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  itemImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detailLinkLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openModalWindow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  title: null,
  itemImageSrc: null,
  detailLinkLabel: null,
  detail: null,
  mbDetail: null,
  openModalWindow: null
}, _temp);
EquipmentItem.displayName = 'EquipmentItem';


/* harmony default export */ __webpack_exports__["a"] = (EquipmentItem);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__maker_set_option_more_info_item__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\maker-set-option\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/**
 *  MakerSetOption
 */
var MakerSetOption = (_temp = _class = function (_Component) {
  _inherits(MakerSetOption, _Component);

  function MakerSetOption(props) {
    _classCallCheck(this, MakerSetOption);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      var maxHeight = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.components.length; i < max; i = i + 1) {
        var component = _this.refs[_this.components[i]];
        if (component && component.getHeight) {
          var height = component.getHeight();
          if (maxHeight < height) {
            maxHeight = height;
          }
        }
      }
      //
      for (i = 0, max = _this.components.length; i < max; i = i + 1) {
        var _component = _this.refs[_this.components[i]];
        if (_component && _component.setHeight) {
          _component.setHeight(maxHeight);
        }
      }
    };

    _this.getModalItemInfo = function () {
      if (_this.props.makerSetOptionMoreInfoItems) {
        var arr = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.props.makerSetOptionMoreInfoItems.length; i < max; i = i + 1) {
          var makerSetOptionMoreInfoItem = _this.props.makerSetOptionMoreInfoItems[i].props;
          arr.push({
            index: i,
            detail: makerSetOptionMoreInfoItem.detail,
            mbDetail: makerSetOptionMoreInfoItem.mbDetail,
            makerSetOptionImageSrc: makerSetOptionMoreInfoItem.makerSetOptionImageSrc,
            mbMakerSetOptionImageSrc: makerSetOptionMoreInfoItem.mbMakerSetOptionImageSrc
          });
        }
        return arr;
      } else {
        return [];
      }
    };

    _this.openModal = function (index) {
      //this.refs.modalItems.slickGoTo(index, true);
      _this.refs.modalItems.onChange(index);
      _this.refs.modalWindow.open('Light', 'Light');
      // BODYのスクロール無効化
      //BodyControl.openModal();
    };

    _this.onCloseModal = function () {
      //this.refs.modalItems.clearCurrentAll();
      // BODYのスクロール無効化を解除
      //BodyControl.closeModal();
    };

    _this.props = props;
    _this.state = {};
    _this.components = [];
    _this.intervalId = null;
    return _this;
  }

  MakerSetOption.prototype.render = function render() {
    var _this2 = this;

    this.components = [];

    // 詳細
    var renderDescription = function renderDescription() {
      var getDescriptionPc = function getDescriptionPc() {
        if (_this2.props.description && _this2.props.description !== '') {
          return _this2.props.description;
        } else {
          return null;
        }
      };
      var getDescriptionMb = function getDescriptionMb() {
        if (_this2.props.mbDescription && _this2.props.mbDescription !== '') {
          return _this2.props.mbDescription;
        } else {
          return getDescriptionPc();
        }
      };
      var description = getDescriptionPc();
      var descriptionMb = getDescriptionMb();
      if (description && descriptionMb) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOption__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'MakerSetOption__description__content-pc',
            dangerouslySetInnerHTML: { __html: description }, __source: {
              fileName: _jsxFileName,
              lineNumber: 70
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'MakerSetOption__description__content-mb',
            dangerouslySetInnerHTML: { __html: descriptionMb }, __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          })
        );
      } else {
        return null;
      }
    };

    // アイテム
    var renderItems = function renderItems() {
      if (_this2.props.makerSetOptionMoreInfoItems && 1 <= _this2.props.makerSetOptionMoreInfoItems.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOption__items', __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          _this2.props.makerSetOptionMoreInfoItems.map(function (item, index) {
            _this2.components.push('item' + index);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'MakerSetOption__items__item', key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 91
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__maker_set_option_more_info_item__["a" /* default */], _extends({}, item.props, { ref: 'item' + index,
                openModalWindow: function openModalWindow(e) {
                  e = Object.assign(e, { containerIndex: index });
                  _this2.openModal(e.containerIndex, e.itemIndex);
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 92
                }
              }))
            );
          })
        );
      } else {
        return null;
      }
    };

    // 注釈
    var renderNotice = function renderNotice() {
      if (_this2.props.notice && _this2.props.notice !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'MakerSetOption__notice Wysiwyg',
          dangerouslySetInnerHTML: { __html: _this2.props.notice }, __source: {
            fileName: _jsxFileName,
            lineNumber: 112
          }
        });
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'MakerSetOption', __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOption__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          },
          renderDescription(),
          renderItems(),
          renderNotice()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__components_modal_window__["a" /* default */],
          { ref: 'modalWindow', type: 'Light', onClose: this.onCloseModal, __source: {
              fileName: _jsxFileName,
              lineNumber: 133
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItems, { ref: 'modalItems', index: 0, itemsProps: this.getModalItemInfo(), onChange: this.onChangeModal, __source: {
              fileName: _jsxFileName,
              lineNumber: 134
            }
          })
        )
      )
    );
  };

  MakerSetOption.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this3.handleResize();
    }, 500);
  };

  MakerSetOption.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  return MakerSetOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  makerSetOptionMoreInfoItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  description: null,
  mbDescription: null,
  notice: null,
  makerSetOptionMoreInfoItems: null
}, _temp);
MakerSetOption.displayName = 'MakerSetOption';


/* harmony default export */ __webpack_exports__["a"] = (MakerSetOption);

var ModalItems = (_temp2 = _class2 = function (_Component2) {
  _inherits(ModalItems, _Component2);

  function ModalItems(props) {
    _classCallCheck(this, ModalItems);

    var _this4 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this4.onChange = function (index) {
      // let i, max;
      // for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
      //   const item = this.refs[this.modalItemArr[i]] || null;
      //   if (item) {
      //     if (i === index) {
      //       item.setCurrent();
      //     } else {
      //       item.clearCurrent();
      //     }
      //   }
      // }
      //
      _this4.setState({
        currentIndex: index
      });
      //
      if (_this4.props.onChange !== null) _this4.props.onChange(index);
    };

    _this4.state = {
      currentIndex: 0
    };
    _this4.modalItemArr = [];
    return _this4;
  }

  // clearCurrentAll() {
  //   let i, max;
  //   for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
  //     const item = this.refs[this.modalItemArr[i]] || null;
  //     if (item) {
  //       item.clearCurrent();
  //     }
  //   }
  // }

  //
  // slickGoTo = (index, dontAnimate) => {
  //   this.refs.slider.slickGoTo(index, dontAnimate);
  //   setTimeout(() => {
  //     this.onChange(index);
  //   }, 100);
  // }

  ModalItems.prototype.render = function render() {
    var _this5 = this;

    var _props = this.props,
        itemsProps = _props.itemsProps,
        index = _props.index;
    //

    this.modalItemArr = [];
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ModalItems', __source: {
          fileName: _jsxFileName,
          lineNumber: 252
        }
      },
      itemsProps.map(function (itemProps, index) {
        _this5.modalItemArr.push('modalItem' + index);
        if (_this5.state.currentIndex === index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, {
            ref: 'modalItem' + index,
            key: index,
            detail: itemProps.detail ? itemProps.detail : null,
            mbDetail: itemProps.mbDetail ? itemProps.mbDetail : null
            //makerSetOptionImageSrc={(itemProps.makerSetOptionImageSrc) ? itemProps.makerSetOptionImageSrc: null}
            //mbMakerSetOptionImageSrc={(itemProps.mbMakerSetOptionImageSrc) ? itemProps.mbMakerSetOptionImageSrc: null}
            , index: index,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 257
            }
          });
        } else {
          return null;
        }
      })
    );
  };

  //


  return ModalItems;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  itemsProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  itemsProps: null,
  index: null,
  onChange: null
}, _temp2);
ModalItems.displayName = 'ModalItems';
var ModalItem = (_temp3 = _class3 = function (_Component3) {
  _inherits(ModalItem, _Component3);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this6 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this6.handleResize = function () {
      var windowHeight = window.innerHeight;
      //
      _this6.setState({
        windowHeight: windowHeight
      });
    };

    _this6.state = {
      //current: false,
      windowHeight: null
    };
    return _this6;
  }

  ModalItem.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  ModalItem.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  //
  // setCurrent() {
  //   if (this.state.current === true) return;
  //   //
  //   this.setState({
  //     current: true,
  //   });
  // };
  //
  // //
  // clearCurrent() {
  //   if (this.state.current === false) return;
  //   //
  //   this.setState({
  //     current: false,
  //   });
  // }

  ModalItem.prototype.render = function render() {
    var _props2 = this.props,
        detail = _props2.detail,
        mbDetail = _props2.mbDetail;


    var getDetailPc = function getDetailPc() {
      if (detail && detail !== '') {
        return detail;
      } else {
        return null;
      }
    };
    var getDetailMb = function getDetailMb() {
      if (mbDetail && mbDetail !== '') {
        return mbDetail;
      } else {
        return getDetailPc();
      }
    };

    //
    // const getMakerSetOptionImageSrc = ()=> {
    //   if (makerSetOptionImageSrc && makerSetOptionImageSrc !== '') {
    //     return makerSetOptionImageSrc;
    //   } else {
    //     return null;
    //   }
    // };

    //
    // const getMbMakerSetOptionImageSrc = ()=> {
    //   if (mbMakerSetOptionImageSrc && mbMakerSetOptionImageSrc !== '') {
    //     return mbMakerSetOptionImageSrc;
    //   } else {
    //     return getMakerSetOptionImageSrc();
    //   }
    // };

    detail = getDetailPc();
    mbDetail = getDetailMb();

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'MakerSetOption__modal-item',
        style: 0 < this.state.windowHeight ? { height: this.state.windowHeight } : null, __source: {
          fileName: _jsxFileName,
          lineNumber: 465
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'MakerSetOption__modal-item__box',
          style: 0 < this.state.windowHeight ? { height: this.state.windowHeight } : null, __source: {
            fileName: _jsxFileName,
            lineNumber: 467
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MakerSetOption__modal-item__box-full', __source: {
              fileName: _jsxFileName,
              lineNumber: 469
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'MakerSetOption__modal-item__detail Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 470
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'MakerSetOption__modal-item__detail-pc', dangerouslySetInnerHTML: { __html: detail }, __source: {
                fileName: _jsxFileName,
                lineNumber: 471
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'MakerSetOption__modal-item__detail-mb', dangerouslySetInnerHTML: { __html: mbDetail }, __source: {
                fileName: _jsxFileName,
                lineNumber: 472
              }
            })
          )
        )
      )
    );
    // return (
    //   <div className="MakerSetOption__modal-item"
    //        style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //     {(() => {
    //       if (makerSetOptionImageSrc && makerSetOptionImageSrc !== '') {
    //         return (
    //           <div className="MakerSetOption__modal-item__box"
    //                style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //             <div className="MakerSetOption__modal-item__box-left">
    //               <div className="MakerSetOption__modal-item__image" >
    //                 <img className="MakerSetOption__modal-item__image-pc" src={getMakerSetOptionImageSrc()} alt=""/>
    //                 <img className="MakerSetOption__modal-item__image-mb" src={getMbMakerSetOptionImageSrc()} alt=""/>
    //               </div>
    //             </div>
    //             <div className="MakerSetOption__modal-item__box-right">
    //               <p className="MakerSetOption__modal-item__detail Wysiwyg">
    //                 {(detail && detail !== '') ?
    //                   <span className="MakerSetOption__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
    //                   : null}
    //                 {(mbDetail && mbDetail !== '') ?
    //                   <span className="MakerSetOption__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
    //                   : null}
    //               </p>
    //             </div>
    //           </div>
    //         )
    //       } else {
    //         return (
    //           <div className="MakerSetOption__modal-item__box"
    //                style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //             <div className="MakerSetOption__modal-item__box-full">
    //               <p className="MakerSetOption__modal-item__detail Wysiwyg">
    //                 <span className="MakerSetOption__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
    //                 <span className="MakerSetOption__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
    //               </p>
    //             </div>
    //           </div>
    //         )
    //       }
    //     })()}
    //   </div>
    // );
  };

  //


  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  //makerSetOptionImageSrc: PropTypes.string,
  //mbMakerSetOptionImageSrc: PropTypes.string,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class3.defaultProps = {
  detail: null,
  mbDetail: null,
  //makerSetOptionImageSrc: null,
  //mbMakerSetOptionImageSrc: null,
  index: null
}, _temp3);
ModalItem.displayName = 'ModalItem';

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\spec-comparison\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 *  SpecComparison
 */
var SpecComparison = (_temp = _class = function (_Component) {
  _inherits(SpecComparison, _Component);

  function SpecComparison(props) {
    _classCallCheck(this, SpecComparison);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      var windowTop = window.pageYOffset;
      _this.navigationTop = _this.refs.navigation.getBoundingClientRect().top + windowTop;
      _this.navigationHeight = _this.refs.navigation.getBoundingClientRect().height;
      _this.specTop = _this.refs.spec.getBoundingClientRect().top + windowTop;
      _this.specHeight = _this.refs.spec.getBoundingClientRect().height;
      _this.subNavigationHeight = __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].getSubNavigationHeight();
      //
      _this.setState({
        subNavigationHeight: _this.subNavigationHeight
      });
    };

    _this.handleScroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (_this.specTop + _this.specHeight - (_this.subNavigationHeight + _this.navigationHeight) <= scrollTop) {
        if (_this.state.fixed === true) {
          _this.setState({
            fixed: false
          });
        }
      } else {
        if (_this.navigationTop <= _this.subNavigationHeight + scrollTop) {
          if (_this.state.fixed === false) {
            _this.setState({
              fixed: true
            });
          }
        } else {
          if (_this.state.fixed === true) {
            _this.setState({
              fixed: false
            });
          }
        }
      }
    };

    _this.changeVariant = function (drive, transmission) {
      _this.setState({
        openAccordion: false,
        currentDrive: drive,
        currentTransmission: transmission
      });
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.accordionRefs.length; i < max; i = i + 1) {
        if (i <= 0) {
          _this.refs[_this.accordionRefs[i]].open();
        } else {
          _this.refs[_this.accordionRefs[i]].close();
        }
      }
      if (_this.state.openAccordion === true) {
        _this.setState({
          openAccordion: false
        });
      }
      // フェードインアニメーション
      _this.refs.changeVariant.classList.remove('open');
      setTimeout(function () {
        _this.refs.changeVariant.classList.add('open');
      }, 100);
    };

    _this.changeAccordionView = function () {
      if (_this.state.openAccordion === true) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.accordionRefs.length; i < max; i = i + 1) {
          _this.refs[_this.accordionRefs[i]].close();
        }
        _this.setState({
          openAccordion: false
        });
      } else {
        var _i = void 0,
            _max = void 0;
        for (_i = 0, _max = _this.accordionRefs.length; _i < _max; _i = _i + 1) {
          _this.refs[_this.accordionRefs[_i]].open();
        }
        _this.setState({
          openAccordion: true
        });
      }
    };

    _this.formatPrice = function (num) {
      return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    _this.getDefaultVariantInfo = function () {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.compareGrades[0].variants.length; i < max; i = i + 1) {
        var variant = _this.props.compareGrades[0].variants[i];
        if (variant.default === true) {
          return variant;
        }
      }
      return _this.props.compareGrades[0].variants[0];
    };

    _this.props = props;
    //
    var defaultVariantInfo = _this.getDefaultVariantInfo();
    //
    _this.state = {
      currentCarId: _this.props.compareGrades[0] && _this.props.compareGrades[0].carId ? _this.props.compareGrades[0].carId : null,
      currentCarTypeCode: _this.props.compareGrades[0] && _this.props.compareGrades[0].carTypeCode ? _this.props.compareGrades[0].carTypeCode : null,
      currentGradeId: _this.props.compareGrades[0] && _this.props.compareGrades[0].gradeId ? _this.props.compareGrades[0].gradeId : null,
      currentGradeCode: _this.props.compareGrades[0] && _this.props.compareGrades[0].gradeCode ? _this.props.compareGrades[0].gradeCode : null,
      currentDrive: defaultVariantInfo.drive,
      currentTransmission: defaultVariantInfo.transmission,
      // currentDrive: this.props.compareGrades[0].variants[0].drive,
      // currentTransmission: this.props.compareGrades[0].variants[0].transmission,
      //openAccordion: true,
      //
      openAccordion: false,
      isMounted: false,
      openPulldown: false,
      fixed: false,
      subNavigationHeight: null
    };
    _this.subNavigationHeight = null;
    _this.navigationTop = null;
    _this.navigationHeight = null;
    _this.specTop = null;
    _this.specHeight = null;
    _this.intervalId = null;
    _this.accordionRefs = [];
    _this.isCurrent = false;
    return _this;
  }

  SpecComparison.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      isMounted: true
    });
    //
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    //
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(function () {
      _this2.specHeight = _this2.refs.spec.getBoundingClientRect().height;
      _this2.handleScroll();
      _this2.handleResize();
    }, 500);
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  SpecComparison.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    // GTMイベント
    if (nextProps.isCurrent !== this.isCurrent) {
      this.isCurrent = nextProps.isCurrent;
      if (nextProps.isCurrent) {
        __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].setGTMEvent({
          trackvariant: this.state.currentDrive + '(' + this.state.currentTransmission + ')',
          event: 'SpecComparisonSelect'
        });
      }
    }
  };

  SpecComparison.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  };

  SpecComparison.prototype.render = function render() {
    var _this3 = this;

    // グレード情報取得
    var getGradeInfo = function getGradeInfo(gradeId) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.props.compareGrades.length; i < max; i = i + 1) {
        var compareGrade = _this3.props.compareGrades[i];
        if (compareGrade.gradeId === gradeId) {
          return compareGrade;
        }
      }
      return null;
    };

    // 機種情報取得
    var getVariantInfo = function getVariantInfo(gradeId, drive, transmission) {
      var gradeInfo = getGradeInfo(gradeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.variants.length; i < max; i = i + 1) {
        var variant = gradeInfo.variants[i];
        if (variant.drive === drive && variant.transmission === transmission) {
          return variant;
        }
      }
      return null;
    };

    // マスタースペックカテゴリ取得
    var __getMasterSpecCategory = function __getMasterSpecCategory(drive, transmission) {

      // 比較している全ての機種の情報を取得
      var _getVariantsInfo = function _getVariantsInfo() {
        var variants = [];
        _this3.props.compareGrades.map(function (compareGrade, index) {
          variants.push(getVariantInfo(compareGrade.gradeId, drive, transmission));
        });
        return variants;
      };

      // カテゴリー一覧取得
      var _getCategories = function _getCategories(variantsInfo) {
        var categories = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
          var variantInfo = variantsInfo[i];
          if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
            var _i2 = void 0,
                _max2 = void 0;
            for (_i2 = 0, _max2 = variantInfo.specs.length; _i2 < _max2; _i2 = _i2 + 1) {
              categories.push(variantInfo.specs[_i2].category);
            }
          }
        }

        // 配列から重複している値を削除
        categories = function (arr) {
          return arr.filter(function (val, i, self) {
            return self.indexOf(val) === i;
          });
        }(categories);

        // 値が存在しているカテゴリのみ抽出
        var arr = [];
        for (i = 0, max = categories.length; i < max; i = i + 1) {
          var isExistUnit = function (category) {
            var i = void 0,
                max = void 0;
            for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
              var _variantInfo = variantsInfo[i];
              if (_variantInfo && _variantInfo.specs && 1 <= _variantInfo.specs.length) {
                var j = void 0,
                    max2 = void 0;
                for (j = 0, max2 = _variantInfo.specs.length; j < max2; j = j + 1) {
                  var spec = _variantInfo.specs[j];
                  if (spec.category === category && spec.unit !== 'blank') {
                    return true;
                  }
                }
              }
            }
            return false;
          }(categories[i]);
          if (isExistUnit) {
            arr.push(categories[i]);
          }
        }
        categories = arr;

        return categories;
      };

      // カテゴリーのスペック情報を取得
      var _getSpecsInfo = function _getSpecsInfo(variantsInfo, category) {
        var arr = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
          var variantInfo = variantsInfo[i];
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = variantInfo.specs.length; j < max2; j = j + 1) {
            var spec = variantInfo.specs[j];
            if (spec.category === category) {
              // 重複しているかチェック
              var flg = true;
              var k = void 0,
                  max3 = void 0;
              for (k = 0, max3 = arr.length; k < max3; k = k + 1) {
                if ((arr[k].name || '') === (spec.name || '') && (arr[k].description || '') === (spec.description || '')) {
                  flg = false;
                  break;
                }
              }
              // 重複していなければ追加
              if (flg === true && spec.unit !== 'blank') {
                arr.push({
                  name: spec.name || null,
                  description: spec.description || null
                });
              }
            }
          }
        }
        return arr;
      };

      // 比較している全ての機種の情報を取得
      var variantsInfo = _getVariantsInfo();

      // カテゴリー一覧取得
      var categoryArr = _getCategories(variantsInfo);

      // カテゴリー一覧を元に全てのスペック情報を取得
      var masterSpecCategory = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        masterSpecCategory.push({
          category: categoryArr[i],
          specs: _getSpecsInfo(variantsInfo, categoryArr[i])
        });
      }

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    var _getMasterSpecCategory = function _getMasterSpecCategory(drive, transmission) {

      var removeDuplicateValue = function removeDuplicateValue(arr) {
        return arr.filter(function (val, i, self) {
          return self.indexOf(val) === i;
        });
      };

      // カテゴリー一覧
      var categoryArr = [];
      _this3.props.compareGrades.map(function (compareGrade, index) {
        var variantInfo = getVariantInfo(compareGrade.gradeId, drive, transmission);
        if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
          var _i3 = void 0,
              _max3 = void 0;
          for (_i3 = 0, _max3 = variantInfo.specs.length; _i3 < _max3; _i3 = _i3 + 1) {
            if (variantInfo.specs[_i3].unit !== 'blank') {
              categoryArr.push(variantInfo.specs[_i3].category);
            }
          }
        }
      });
      categoryArr = removeDuplicateValue(categoryArr);

      // カテゴリー一覧を元に全てのスペック情報を取得
      var masterSpecCategory = [];

      //
      var i = void 0,
          max = void 0;

      var _loop = function _loop() {
        var category = categoryArr[i];
        var arr = [];

        //
        _this3.props.compareGrades.map(function (compareGrade, index) {
          var variantInfo = getVariantInfo(compareGrade.gradeId, drive, transmission);
          if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {

            //
            var _i4 = void 0,
                _max4 = void 0;
            for (_i4 = 0, _max4 = variantInfo.specs.length; _i4 < _max4; _i4 = _i4 + 1) {
              var specs = variantInfo.specs[_i4];
              if (specs.category === category) {

                // 重複しているかチェック
                var flg = true;
                var j = void 0,
                    max2 = void 0;
                for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
                  if ((arr[j].name || '') === (specs.name || '') && (arr[j].description || '') === (specs.description || '')) {
                    flg = false;
                    break;
                  }
                }

                // 重複していなければ追加
                if (flg === true && specs.unit !== 'blank') {
                  arr.push({
                    name: specs.name || null,
                    description: specs.description || null
                  });
                }
              }
            }
          }
        });

        masterSpecCategory.push({
          category: categoryArr[i],
          specs: arr
        });
      };

      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        _loop();
      }

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    var getMasterSpecCategory = function getMasterSpecCategory(drive, transmission) {
      if (window.MZD_SPEC_DATA_CATEGORY_LIST) {
        return window.MZD_SPEC_DATA_CATEGORY_LIST;
      } else {
        return _getMasterSpecCategory(drive, transmission);
      }
    };

    // スペック情報取得
    var getSpecInfo = function getSpecInfo(gradeId, drive, transmission) {

      var removeDuplicateValue = function removeDuplicateValue(arr) {
        return arr.filter(function (val, i, self) {
          return self.indexOf(val) === i;
        });
      };

      var variantInfo = getVariantInfo(gradeId, drive, transmission);
      if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
        // フォーマット
        var categoryArr = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = variantInfo.specs.length; i < max; i = i + 1) {
          categoryArr.push(variantInfo.specs[i].category);
        }
        categoryArr = removeDuplicateValue(categoryArr);
        //
        var specs = [];
        for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
          var _category = categoryArr[i];
          var obj = {
            category: _category,
            specs: []
          };
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = variantInfo.specs.length; j < max2; j = j + 1) {
            var spec = variantInfo.specs[j];
            if (_category === spec.category) {
              obj.specs.push({
                name: spec.name || null,
                value: spec.value || null,
                unit: spec.unit || null,
                description: spec.description || null,
                seatImageSrc: spec.seatImageSrc || null
              });
            }
          }
          specs.push(obj);
        }
        return specs;
      } else {
        return null;
      }
    };

    // 機種スペックデータからnameが一致するデータを取得
    var getVariantSpec = function getVariantSpec(variantSpecs, category, name, description) {
      if (variantSpecs && 1 <= variantSpecs.length) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = variantSpecs.length; i < max; i = i + 1) {
          if (variantSpecs[i].category === category) {
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = variantSpecs[i].specs.length; j < max2; j = j + 1) {
              if (variantSpecs[i].specs[j].name === name && (variantSpecs[i].specs[j].description || '') === (description || '')) {
                return variantSpecs[i].specs[j];
              }
            }
          }
        }
      } else {
        return null;
      }
    };

    // スペックが存在するか
    var getIsExistSpecValue = function getIsExistSpecValue(drive, transmission, category, name, description) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.props.compareGrades.length; i < max; i = i + 1) {
        var compareGrade = _this3.props.compareGrades[i];
        var specInfo = getSpecInfo(compareGrade.gradeId, drive, transmission);
        var j = void 0,
            max2 = void 0;
        if (specInfo) {
          for (j = 0, max2 = specInfo.length; j < max2; j = j + 1) {
            if (category === specInfo[j].category) {
              var k = void 0,
                  max3 = void 0;
              for (k = 0, max3 = specInfo[j].specs.length; k < max3; k = k + 1) {
                var spec = specInfo[j].specs[k];
                if (name === spec.name && description === spec.description) {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true;
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true;
                    }
                  }
                }
              }
            }
          }
        }
      }
      return false;
    };

    // ------ Render ----- //

    // タイトル表示
    var renderDescription = function renderDescription() {

      var getDescription = function getDescription() {
        if (_this3.props.description && _this3.props.description !== '') {
          return _this3.props.description;
        } else {
          return null;
        }
      };

      var getMbDescription = function getMbDescription() {
        if (_this3.props.mbDescription && _this3.props.mbDescription !== '') {
          return _this3.props.mbDescription;
        } else {
          return getDescription();
        }
      };

      var description = getDescription();
      var mbDescription = getMbDescription();

      if (description || mbDescription) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 495
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SpecComparison__description-pc',
            dangerouslySetInnerHTML: { __html: description !== null ? description : '' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 496
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SpecComparison__description-mb',
            dangerouslySetInnerHTML: { __html: mbDescription !== null ? mbDescription : '' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 498
            }
          })
        );
      } else {
        return null;
      }
    };

    // ナビ表示
    var renderNavigation = function renderNavigation() {

      // 車種比較リンク
      var getModelComparisonHref = function getModelComparisonHref() {
        var href = '/purchase/compare/';
        var params = '';
        params = params + '?car_id1=' + encodeURIComponent(_this3.state.currentCarId);
        params = params + '&car_type_code1=' + encodeURIComponent(_this3.state.currentCarTypeCode);
        params = params + '&grade1=' + encodeURIComponent(_this3.state.currentGradeId);
        if (_this3.props.compareGrades[1]) {
          params += _this3.props.compareGrades[1].carId ? '&car_id2=' + encodeURIComponent(_this3.props.compareGrades[1].carId) : '';
          params += _this3.props.compareGrades[1].carTypeCode ? '&car_type_code2=' + encodeURIComponent(_this3.props.compareGrades[1].carTypeCode) : '';
          params += _this3.props.compareGrades[1].gradeId ? '&grade2=' + encodeURIComponent(_this3.props.compareGrades[1].gradeId) : '';
        }
        if (_this3.props.compareGrades[2]) {
          params += _this3.props.compareGrades[2].carId ? '&car_id3=' + encodeURIComponent(_this3.props.compareGrades[2].carId) : '';
          params += _this3.props.compareGrades[2].carTypeCode ? '&car_type_code3=' + encodeURIComponent(_this3.props.compareGrades[2].carTypeCode) : '';
          params += _this3.props.compareGrades[2].gradeId ? '&grade3=' + encodeURIComponent(_this3.props.compareGrades[2].gradeId) : '';
        }
        return href + params;
      };

      // ------ Render ----- //

      // 比較軸グレード表示
      var renderMainVariant = function renderMainVariant(gradeId) {

        // MBでのプルダウンアイテム表示
        var renderPulldown = function renderPulldown() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SpecComparison__pulldown', __source: {
                fileName: _jsxFileName,
                lineNumber: 539
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                className: 'SpecComparison__pulldown__link-variant' + (_this3.state.openPulldown === true ? ' open' : ''),
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  if (_this3.state.openPulldown === true) {
                    _this3.setState({
                      openPulldown: false
                    });
                  } else {
                    _this3.setState({
                      openPulldown: true
                    });
                  }
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 540
                }
              },
              currentVariantInfo && currentVariantInfo.drive && currentVariantInfo.transmission ? currentVariantInfo.drive + ' ' + currentVariantInfo.transmission : ''
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'SpecComparison__pulldown__container' + (_this3.state.openPulldown === true ? ' open' : ''), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 558
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SpecComparison__pulldown__box', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 560
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'SpecComparison__pulldown__link-close',
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this3.setState({
                        openPulldown: false
                      });
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 561
                    }
                  },
                  'CLOSE'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'SpecComparison__pulldown__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 570
                    }
                  },
                  gradeInfo.variants.map(function (variant, index) {
                    var variantInfo = getVariantInfo(gradeId, variant.drive, variant.transmission);
                    if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 575
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          {
                            className: 'SpecComparison__pulldown__link-item' + (_this3.state.currentDrive === variantInfo.drive && _this3.state.currentTransmission === variantInfo.transmission ? ' current' : ''),
                            href: 'javascript:void(0);',
                            onClick: function onClick(e) {
                              e.preventDefault();
                              // 機種変更
                              _this3.changeVariant(variantInfo.drive, variantInfo.transmission);
                              _this3.setState({
                                openPulldown: false
                              });

                              // GTMイベント
                              __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].setGTMEvent({
                                trackvariant: variantInfo.drive + '(' + variantInfo.transmission + ')',
                                event: 'SpecComparisonSelect'
                              });
                            },
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 576
                            }
                          },
                          variantInfo.drive + ' ' + variantInfo.transmission
                        )
                      );
                    } else {
                      return null;
                    }
                  })
                )
              )
            )
          );
        };

        // PCでのセレクター表示
        var renderSelect = function renderSelect() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { name: 'SpecComparisonForm', __source: {
                fileName: _jsxFileName,
                lineNumber: 613
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              {
                className: 'SpecComparison__navigation__select',
                name: gradeInfo.gradeId,
                value: currentVariantInfo && currentVariantInfo.drive && currentVariantInfo.transmission ? currentVariantInfo.drive + ',' + currentVariantInfo.transmission : '',
                onChange: function onChange(e) {
                  //const gradeId = e.currentTarget.getAttribute('name');
                  //const arr = document.forms.SpecComparisonForm[gradeId].value.split(',');
                  var arr = e.currentTarget.value.split(',');
                  // 機種変更
                  if (arr && arr[0] && arr[0] !== '' && arr[1] && arr[1] !== '') {
                    _this3.changeVariant(arr[0], arr[1]);
                  }

                  // GTMイベント
                  __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].setGTMEvent({
                    trackvariant: arr[0] + '(' + arr[1] + ')',
                    event: 'SpecComparisonSelect'
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 614
                }
              },
              gradeInfo.variants.map(function (variant, index) {
                var variantInfo = getVariantInfo(gradeId, variant.drive, variant.transmission);
                if (variantInfo && variantInfo.specs && 1 <= variantInfo.specs.length) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { key: index, value: variantInfo.drive + ',' + variantInfo.transmission, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 639
                      }
                    },
                    variantInfo.drive + ' ' + variantInfo.transmission
                  );
                } else {
                  return null;
                }
              })
            )
          );
        };

        var gradeInfo = getGradeInfo(gradeId);
        var getGradeName = function getGradeName(gradeInfo) {
          if (gradeInfo.specialCar === true) {
            return gradeInfo.gradeId;
          } else {
            return gradeInfo.gradeName && gradeInfo.gradeName !== '' ? gradeInfo.gradeName : gradeInfo.gradeId;
          }
        };
        var currentVariantInfo = getVariantInfo(gradeId, _this3.state.currentDrive, _this3.state.currentTransmission);

        // console.log('----------');
        // console.log(gradeInfo);
        // console.log('gradeId: ' + gradeId);
        // console.log('currentDrive: ' + this.state.currentDrive);
        // console.log('currentTransmission: ' + this.state.currentTransmission);
        // console.log(currentVariantInfo);
        // console.log('----------');

        // 100th Anniversary Special Edition > 100周年特別記念車
        var convert100th = function convert100th(text) {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (gradeInfo) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 698
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__navigation__grade', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 699
                }
              },
              convert100th(getGradeName(gradeInfo))
            ),
            renderPulldown(),
            renderSelect(),
            currentVariantInfo && 0 < currentVariantInfo.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: 'SpecComparison__navigation__price', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 706
                }
              },
              _this3.formatPrice(currentVariantInfo.price),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 707
                  }
                },
                '(\u6D88\u8CBB\u7A0E\u8FBC)'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'SpecComparison__navigation__price', __source: {
                fileName: _jsxFileName,
                lineNumber: 708
              }
            })
          );
        } else {
          return null;
        }
      };

      // 比較対象グレード表示
      var renderSubVariant = function renderSubVariant(gradeId, gradeName, specialCar, drive, transmission) {
        var getGradeName = function getGradeName() {
          if (specialCar === true) {
            return gradeId;
          } else {
            return gradeName && gradeName !== '' ? gradeName : gradeId;
          }
        };
        var variantInfo = getVariantInfo(gradeId, drive, transmission);

        // 100th Anniversary Special Edition > 100周年特別記念車
        var convert100th = function convert100th(text) {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (variantInfo) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 755
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__navigation__grade', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 756
                }
              },
              convert100th(getGradeName())
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: 'SpecComparison__navigation__variant', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 758
                }
              },
              variantInfo.drive + ' ' + variantInfo.transmission
            ),
            0 < variantInfo.price ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__navigation__price', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 761
                }
              },
              _this3.formatPrice(variantInfo.price),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 761
                  }
                },
                '(\u6D88\u8CBB\u7A0E\u8FBC)'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'SpecComparison__navigation__price', __source: {
                fileName: _jsxFileName,
                lineNumber: 762
              }
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'relative' }, __source: {
                fileName: _jsxFileName,
                lineNumber: 768
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: 'SpecComparison__navigation__grade', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 769
                }
              },
              gradeName && gradeName !== '' ? convert100th(gradeName) : convert100th(gradeId)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 772
                }
              },
              '\u6307\u5B9A\u3055\u308C\u305F\u99C6\u52D5\u30FB\u30DF\u30C3\u30B7\u30E7\u30F3\u306E',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 772
                }
              }),
              '\u7D44\u5408\u305B\u306F\u8A2D\u5B9A\u3042\u308A\u307E\u305B\u3093'
            )
          )
          // <div>
          //   <p className="SpecComparison__navigation__grade">{(gradeName && gradeName !== '') ? gradeName : gradeId}</p>
          //   <p className="SpecComparison__navigation__variant"><span className="SpecComparison__blank">-</span></p>
          //   {/*<p className="SpecComparison__navigation__variant">{drive + ' ' + transmission}</p>*/}
          //   <p className="SpecComparison__navigation__price"><span className="SpecComparison__blank">-</span></p>
          // </div>
          ;
        }
      };

      var count = 0;
      var count2 = 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SpecComparison__navigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 789
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__navigation__box', __source: {
              fileName: _jsxFileName,
              lineNumber: 790
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks__["Cta"], _extends({
            ctaType: 'Free',
            href: getModelComparisonHref(),
            text: '他のグレード・車種で比較',
            targetBlank: false,
            linkType: 'Text-With-Icon',
            color: 'Dark',
            iconSrc: 'data:image/png;base64,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',
            //iconSrc: '/assets-dev/icon-next-black.png',
            additionalClass: 'SpecComparison__navigation__link-comparison'
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 791
            }
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__navigation__box2', ref: 'navigation', __source: {
              fileName: _jsxFileName,
              lineNumber: 805
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'SpecComparison__navigation__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 806
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 807
              }
            }),
            _this3.props.compareGrades.map(function (compareGrade, index) {
              count = count + 1;
              if (index <= 0) {
                // 比較軸グレード
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 813
                    }
                  },
                  renderMainVariant(compareGrade.gradeId)
                );
              } else {
                // 比較対象グレード表示
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 820
                    }
                  },
                  renderSubVariant(compareGrade.gradeId, compareGrade.gradeName, compareGrade.specialCar, _this3.state.currentDrive, _this3.state.currentTransmission)
                );
              }
            }),
            function () {
              if (count <= 2) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 829
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'SpecComparison__blank', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 829
                      }
                    },
                    '-'
                  )
                );
              }
            }()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__navigation__box3' + (_this3.state.fixed === true ? ' open' : ''),
            style: { 'top': _this3.state.subNavigationHeight }, __source: {
              fileName: _jsxFileName,
              lineNumber: 835
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'SpecComparison__navigation__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 837
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 838
              }
            }),
            _this3.props.compareGrades.map(function (compareGrade, index) {
              count2 = count2 + 1;
              if (index <= 0) {
                // 比較軸グレード
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 844
                    }
                  },
                  renderMainVariant(compareGrade.gradeId)
                );
              } else {
                // 比較対象グレード表示
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 851
                    }
                  },
                  renderSubVariant(compareGrade.gradeId, compareGrade.gradeName, compareGrade.specialCar, _this3.state.currentDrive, _this3.state.currentTransmission)
                );
              }
            }),
            function () {
              if (count2 <= 2) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 860
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'SpecComparison__blank', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 860
                      }
                    },
                    '-'
                  )
                );
              }
            }()
          )
        )
      );
    };

    // スペック表示
    var renderSpecs = function renderSpecs() {

      // ------ Render ----- //

      // スペックカテゴリ表示
      var renderSpecCategory = function renderSpecCategory() {
        // マスタースペックカテゴリ取得
        var masterSpecCategory = getMasterSpecCategory(_this3.state.currentDrive, _this3.state.currentTransmission);
        _this3.accordionRefs = [];
        return masterSpecCategory.map(function (info, index) {

          // スペックデータが有るか無しか
          var flg = false;
          var i = void 0,
              max = void 0;
          for (i = 0, max = info.specs.length; i < max; i = i + 1) {
            var spec = info.specs[i];
            if (getIsExistSpecValue(_this3.state.currentDrive, _this3.state.currentTransmission, info.category, spec.name, spec.description)) {
              flg = true;
            }
          }
          if (!flg) return null;

          _this3.accordionRefs.push('accordion' + index);
          var isOpen = index <= 0 ? true : false;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_accordion__["a" /* default */],
            {
              ref: 'accordion' + index,
              pageName: info.category,
              pcText: info.category,
              mbText: info.category,
              open: isOpen
              // open={this.state.openAccordion}
              , enabled: true,
              key: index,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 898
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'SpecComparison__spec__table', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 908
                }
              },
              renderSpecName(info.category, info.specs)
            )
          );
        });
      };

      // スペック名表示
      var renderSpecName = function renderSpecName(category, masterSpecs) {
        return masterSpecs.map(function (masterSpec, index) {

          // スペックデータが有るか無しか
          if (!getIsExistSpecValue(_this3.state.currentDrive, _this3.state.currentTransmission, category, masterSpec.name, masterSpec.description)) return null;

          var count = 0;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: 'SpecComparison__spec__table-row', key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 927
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'SpecComparison__spec__table-cell', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 928
                }
              },
              masterSpec.name + ' ' + (masterSpec.description ? masterSpec.description : '')
            ),
            _this3.props.compareGrades.map(function (compareGrade, index2) {
              count = count + 1;
              var variantSpecs = getSpecInfo(compareGrade.gradeId, _this3.state.currentDrive, _this3.state.currentTransmission);
              if (variantSpecs && 1 <= variantSpecs.length) {
                var variantSpec = getVariantSpec(variantSpecs, category, masterSpec.name, masterSpec.description);
                if (variantSpec) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SpecComparison__spec__table-cell',
                      key: index2, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 937
                      }
                    },
                    renderVariantsSpecValue(category, variantSpec, compareGrade)
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SpecComparison__spec__table-cell', key: index2, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 942
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      {
                        className: 'SpecComparison__blank', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 942
                        }
                      },
                      '-'
                    )
                  );
                }
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SpecComparison__spec__table-cell', key: index2, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 948
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      className: 'SpecComparison__blank', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 948
                      }
                    },
                    '-'
                  )
                )
                // <div className="SpecComparison__spec__table-cell" key={index2}>該当する駆動・ミッションは<br/>存在しません</div>
                ;
              }
            }),
            function () {
              if (count <= 2) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SpecComparison__spec__table-cell', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 957
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'SpecComparison__blank', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 957
                      }
                    },
                    '-'
                  )
                );
              }
            }()
          );
        });
      };

      // 機種スペック値表示
      var renderVariantsSpecValue = function renderVariantsSpecValue(category, spec, compareGrade) {

        // メディアディレクトリ取得
        var getMediaDirectory = function getMediaDirectory() {
          if (_this3.state.isMounted === false) return '/assets-dev/';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            return '/assets-dev/';
          } else {
            return '/globalassets/';
          }
        };

        var formatSrc = function formatSrc(src) {
          if (_this3.state.isMounted === false) return src;
          if (0 <= String(location.hostname).indexOf('localhost')) {
            return src;
          } else {
            return src.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          }
        };

        if (category === 'シート' && spec.name === 'シート材質') {
          var directory = 'assets/cars/';
          directory = directory + compareGrade.modelName + '/';
          directory = directory + compareGrade.carId + '/';
          directory = directory + compareGrade.carTypeCode + '/';
          directory = directory + Object(__WEBPACK_IMPORTED_MODULE_7__utils__["g" /* convertKataToRome */])(compareGrade.gradeId) + '/';
          directory = directory + 'seat/';
          directory = directory.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 999
              }
            },
            _this3.state.isMounted === true && spec.unit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SpecComparison__spec__seat-image',
              src: formatSrc(getMediaDirectory() + directory + spec.unit + '.png'), __source: {
                fileName: _jsxFileName,
                lineNumber: 1000
              }
            }) : '',
            spec.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__spec__value', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1002
                }
              },
              spec.value.join(' | ')
            ) : ''
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1007
              }
            },
            _this3.state.isMounted === true && spec.unit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1008
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SpecComparison__spec__unit-image',
                src: formatSrc(getMediaDirectory() + 'assets/home/common/icon/' + spec.unit + '.png'), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1008
                }
              })
            ) : '',
            spec.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'SpecComparison__spec__value', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1011
                }
              },
              spec.value.join(' | ')
            ) : ''
          );
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SpecComparison__spec', __source: {
            fileName: _jsxFileName,
            lineNumber: 1018
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__spec__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 1019
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { ref: 'spec', __source: {
                fileName: _jsxFileName,
                lineNumber: 1020
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SpecComparison__spec__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1021
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'SpecComparison__spec__link-open' + (_this3.state.openAccordion ? ' open' : ''),
                  href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    // アコーディオンを閉じる、開く
                    _this3.changeAccordionView();
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1022
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'SpecComparison__spec__link-open__open', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1030
                    }
                  },
                  '\u3059\u3079\u3066\u898B\u308B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'SpecComparison__spec__link-open__close', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1031
                    }
                  },
                  '\u3059\u3079\u3066\u9589\u3058\u308B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SpecComparison__spec__link-open__icon', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1032
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SpecComparison__spec__link-open__icon2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1033
                  }
                })
              )
            ),
            renderSpecCategory()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'SpecComparison__spec__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 1039
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1040
              }
            },
            '\u6A19\u6E96\u88C5\u5099'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1041
              }
            },
            '\u30E1\u30FC\u30AB\u30FC\u30AA\u30D7\u30B7\u30E7\u30F3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1042
              }
            },
            '\u8A2D\u5B9A\u7121\u3057'
          )
        )
      );
    };

    // 注釈表示
    var renderNotice = function renderNotice() {
      if (_this3.props.notice && _this3.props.notice !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'SpecComparison__notice Wysiwyg', dangerouslySetInnerHTML: { __html: _this3.props.notice }, __source: {
            fileName: _jsxFileName,
            lineNumber: 1053
          }
        });
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 1061
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SpecComparison', __source: {
            fileName: _jsxFileName,
            lineNumber: 1067
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 1068
            }
          },
          renderDescription()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__container2', __source: {
              fileName: _jsxFileName,
              lineNumber: 1071
            }
          },
          renderNavigation()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SpecComparison__container3', __source: {
              fileName: _jsxFileName,
              lineNumber: 1074
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SpecComparison__fade-in-container open', ref: 'changeVariant', __source: {
                fileName: _jsxFileName,
                lineNumber: 1075
              }
            },
            renderSpecs(),
            renderNotice(),
            this.props.cta
          )
        )
      )
    );
  };

  //


  //


  // 機種変更


  // アコーディオンを閉じる、開く


  // 金額フォーマット


  // デフォルト機種情報取得


  return SpecComparison;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  compareGrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    variants: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      variantId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      specs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        seatImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      }))
    }))
  })),
  notice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  description: null,
  mbDescription: null,
  compareGrades: null
}, _temp);
SpecComparison.displayName = 'SpecComparison';


/* harmony default export */ __webpack_exports__["a"] = (SpecComparison);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_estimate_link__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spacer_image_png__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spacer_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__spacer_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_accordion__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\grade-and-spec-data\\index.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/**
 *  GradeAndSpecData
 */
var GradeAndSpecData = (_temp = _class = function (_Component) {
  _inherits(GradeAndSpecData, _Component);

  function GradeAndSpecData(props) {
    _classCallCheck(this, GradeAndSpecData);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getVariantInfo = function () {
      var arr = [];
      _this.props.variants.map(function (variant, index) {
        var tax = [];
        if (variant.kankyowari === true) {
          tax.push('環境性能割 非課税');
        }
        if (variant.subsidy === true) {
          tax.push('CEV補助金');
          // tax.push('クリーンディーゼル補助金');
        }
        if (variant.taxInfo) {
          if (100 <= variant.taxInfo.weightTaxRate) {
            tax.push('重量税 免税');
          } else if (1 <= variant.taxInfo.weightTaxRate) {
            tax.push('重量税 減税');
          }
        }
        arr.push({
          name: variant.drive + '(' + variant.transmission + ')',
          price: '¥' + variant.price.toLocaleString(),
          tax: tax
        });
      });
      return arr;
    };

    _this.handleResize = function () {
      _this.setState({
        variantsWidth: _this.refs.variants.clientWidth
      });
    };

    _this.props = props;
    //
    _this.state = {
      isMounted: false,
      background: null,
      variantsWidth: null
    };
    //this.isCurrent = false;
    _this.timeoutId = null;
    return _this;
  }

  GradeAndSpecData.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isCurrent) {
      return true;
    } else {
      return false;
    }
  };

  GradeAndSpecData.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        modelName = _props.modelName,
        bodyTypeModel = _props.bodyTypeModel,
        carTypeCode = _props.carTypeCode,
        gradeId = _props.gradeId,
        gradeCode = _props.gradeCode,
        gradeName = _props.gradeName,
        engine = _props.engine,
        description = _props.description,
        mbDescription = _props.mbDescription,
        supportCar = _props.supportCar,
        backgroundSrc = _props.backgroundSrc,
        mbBackgroundSrc = _props.mbBackgroundSrc,
        interiorImage = _props.interiorImage,
        interiorImage2 = _props.interiorImage2,
        hideEstimationButton = _props.hideEstimationButton,
        defaultDrive = _props.defaultDrive,
        defaultMission = _props.defaultMission,
        displacement = _props.displacement,
        variants = _props.variants,
        gradeImageSrc = _props.gradeImageSrc,
        specialCar = _props.specialCar;


    if (!this.props.isCurrent) return null;

    // エンジン名
    var getEngineName = function getEngineName() {
      if (engine && engine.name) {
        return engine.name;
      } else {
        return '';
      }
    };
    // const getEngineName = () => {
    //   let engineName = '';
    //   let i, max;
    //   for (i = 0, max = engine.length; i < max; i = i + 1) {
    //     const name = engine[i].name;
    //     if (engineName === '') {
    //       engineName = name;
    //     } else {
    //       engineName = engineName + '/' + name;
    //     }
    //   }
    //   // 重複をとる
    //   engineName = engineName.split('/').filter((x, i, self) => self.indexOf(x) === i).join('/');
    //   return engineName;
    // };

    // 詳細テキスト
    var getPcDescription = function getPcDescription() {
      if (description && description !== '') {
        return description;
      }
      return '';
    };
    var getMbDescription = function getMbDescription() {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    // グレード名称
    var getGradeName = function getGradeName() {
      if (gradeName && gradeName !== '') {
        return gradeName;
      } else if (gradeId && gradeId !== '') {
        return gradeId;
      } else {
        return '';
      }
    };

    // PC用PhotoInfoブロック表示
    var renderPcPhotoInfo = function renderPcPhotoInfo() {
      if (_this2.state.isMounted === true) {
        if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["g" /* IS_MOBILE */] === false) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 221
              }
            },
            _this2.props.photoInfo
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    // MB用PhotoInfoブロック表示
    var renderMbPhotoInfo = function renderMbPhotoInfo() {
      if (_this2.state.isMounted === true) {
        if (__WEBPACK_IMPORTED_MODULE_8__constants_environment__["g" /* IS_MOBILE */] === true) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 238
              }
            },
            _this2.props.photoInfo
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    // 100th Anniversary Special Edition > 100周年特別記念車
    var convert100th = function convert100th(text) {
      if (text && text !== '') {
        text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
        text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
        text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
        text = text.replace('RF 35th SV', '35周年記念車');
        text = text.replace('35th SV', '35周年記念車');
        text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
        text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
        text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
        text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
        text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
        text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
        text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
        text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
        text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
        text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
        text = text.replace('15 SPORT Plus', '15 SPORT＋');
        text = text.replace('XD SPORT Plus', 'XD SPORT＋');
        return text;
      } else {
        return text;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 277
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'GradeAndSpecData', __source: {
            fileName: _jsxFileName,
            lineNumber: 281
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'GradeAndSpecData__container',
            style: this.state.background && this.state.background !== '' ? { backgroundImage: 'url(' + this.state.background + ')' } : null,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 282
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'GradeAndSpecData__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 285
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpecData__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 286
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpecData__box2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 287
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'GradeAndSpecData__heading', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 288
                    }
                  },
                  function () {
                    if (specialCar) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(convert100th(gradeId)) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 292
                        }
                      })
                      // <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(gradeId) }} />
                      ;
                    } else {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* convertPipeToBrTag */])(convert100th(getGradeName())) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 297
                        }
                      })
                      // <span dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(getGradeName()) }} />
                      ;
                    }
                  }()
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'GradeAndSpecData__engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 305
                    }
                  },
                  getEngineName()
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'GradeAndSpecData__description', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 306
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'GradeAndSpecData__description-pc', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 307
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: getPcDescription() }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 308
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'GradeAndSpecData__description-mb', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 311
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: getMbDescription() }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 312
                      }
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'GradeAndSpecData__car-image__wrapper', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 316
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpecData__car-image', src: gradeImageSrc, alt: '', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 317
                    }
                  }),
                  renderMbPhotoInfo()
                )
              ),
              function () {
                if (interiorImage && interiorImage !== '' || interiorImage2 && interiorImage2 !== '') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'GradeAndSpecData__interior', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 324
                      }
                    },
                    interiorImage && interiorImage !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpecData__interior__image', src: interiorImage, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 326
                      }
                    }) : null,
                    interiorImage2 && interiorImage2 !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpecData__interior__image', src: interiorImage2, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 328
                      }
                    }) : null
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'GradeAndSpecData__interior', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 333
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpecData__interior__image', src: __WEBPACK_IMPORTED_MODULE_9__spacer_image_png___default.a, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 334
                      }
                    })
                  );
                }
              }(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpecData__variants', ref: 'variants', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 339
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'GradeAndSpecData__variants__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 340
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { style: 2 <= this.getVariantInfo().length ? { width: '50%' } : { width: '100%' }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 341
                      }
                    },
                    this.getVariantInfo().map(function (variant, index) {
                      if (index % 2) {
                        return null;
                      } else {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GradeAndSpecDataVariant, { variantName: variant.name, variantPrice: variant.price, variantTax: variant.tax, variantsWidth: 2 <= _this2.getVariantInfo().length ? _this2.state.variantsWidth / 2 - 20 : null, key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 347
                          }
                        })
                        // <div className="GradeAndSpecData__variants__container" key={index} ref="container">
                        //   <span style={{display: 'inline-block'}} ref="names">
                        //     <span className="GradeAndSpecData__variants__name">{variant.name}</span>
                        //     <span className="GradeAndSpecData__variants__price">{variant.price}<span> (消費税込)</span></span>
                        //   </span>
                        //   {(() => {
                        //     if (variant.tax && 1 <= variant.tax.length) {
                        //       return (
                        //         <span className="GradeAndSpecData__variants__tax test" ref="taxes">
                        //           {variant.tax.map((tax, index2) => {
                        //             return (
                        //               <span className="GradeAndSpecData__variants__tax-item" key={index2}>{tax}</span>
                        //             )
                        //           })}
                        //         </span>
                        //       )
                        //     } else {
                        //       return null;
                        //     }
                        //   })()}
                        // </div>
                        ;
                      }
                    })
                  ),
                  function () {
                    if (2 <= _this2.getVariantInfo().length) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 376
                          }
                        },
                        _this2.getVariantInfo().map(function (variant, index) {
                          if (index % 2) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GradeAndSpecDataVariant, { variantName: variant.name, variantPrice: variant.price, variantTax: variant.tax, variantsWidth: _this2.state.variantsWidth / 2 - 20, key: index, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 380
                              }
                            })
                            // <div className="GradeAndSpecData__variants__container" key={index}>
                            //   <span>
                            //     <span className="GradeAndSpecData__variants__name">{variant.name}</span>
                            //     <span className="GradeAndSpecData__variants__price">{variant.price}<span> (消費税込)</span></span>
                            //   </span>
                            //   {(() => {
                            //     if (variant.tax && 1 <= variant.tax.length) {
                            //       return (
                            //         <span className="GradeAndSpecData__variants__tax">
                            //           {variant.tax.map((tax, index2) => {
                            //             return (
                            //               <span className="GradeAndSpecData__variants__tax-item" key={index2}>{tax}</span>
                            //             )
                            //           })}
                            //         </span>
                            //       )
                            //     } else {
                            //       return null;
                            //     }
                            //   })()}
                            // </div>
                            ;
                          } else {
                            return null;
                          }
                        })
                      );
                    } else {
                      return null;
                    }
                  }()
                )
              ),
              hideEstimationButton === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpecData__estimate', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 416
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_estimate_link__["a" /* default */], _extends({
                  label: '見積りシミュレーション',
                  targetBlank: false,
                  color: 'Light',
                  buttonStyle: 'Action',
                  linkType: 'Button',
                  carId: bodyTypeModel,
                  carTypeCode: carTypeCode,
                  gradeCode: gradeCode,
                  drive: defaultDrive,
                  mission: defaultMission,
                  engine: variants[0].engine,
                  ecode: null,
                  soptions: null,
                  //direct: 'Result',
                  direct: 'Color-And-Sheet'
                }, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 418
                  }
                }))
              ) : null
            )
          ),
          renderPcPhotoInfo()
        ),
        this.props.freeContentArea && 1 <= this.props.freeContentArea.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.freeContentArea) : null,
        this.props.bodySize && 1 <= this.props.bodySize.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.bodySize, {
          modelName: modelName,
          bodyTypeModel: bodyTypeModel,
          carTypeCode: carTypeCode,
          gradeId: gradeId
        }) : null,
        this.props.equipment && 1 <= this.props.equipment.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.equipment) : null,
        this.props.makerOption && 1 <= this.props.makerOption.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.makerOption) : null,
        this.props.specComparison && 1 <= this.props.specComparison.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.specComparison, { isCurrent: this.props.isCurrent }) : null,
        this.props.freeContentArea2 && 1 <= this.props.freeContentArea2.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.freeContentArea2) : null,
        this.props.ownerLibraryContainer && 1 <= this.props.ownerLibraryContainer.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.ownerLibraryContainer) : null,
        this.props.freeContentArea3 && 1 <= this.props.freeContentArea3.length ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["c" /* getComponents */])(this.props.freeContentArea3) : null
      )
    );
  };

  GradeAndSpecData.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true,
      background: __WEBPACK_IMPORTED_MODULE_8__constants_environment__["g" /* IS_MOBILE */] === false ? this.props.backgroundSrc : this.props.mbBackgroundSrc
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  GradeAndSpecData.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {

    // グレスペ用アンカーリンクの設定
    if (nextProps.isCurrent !== this.props.isCurrent && nextProps.isCurrent === true) {
      if (window.MZD_SET_ANCHOR_LINK && typeof window.MZD_SET_ANCHOR_LINK == 'function') window.MZD_SET_ANCHOR_LINK();
    }

    // if (nextProps.isCurrent) {
    //   if (this.timeoutId) clearTimeout(this.timeoutId);
    //   this.timeoutId = setTimeout(()=> {
    //     // GTMイベント
    //     BodyControl.setGTMEvent({
    //       selectedgrade: nextProps.gradeName,
    //       selectedbodytype: nextProps.bodyTypeTabName,
    //       event: 'loadgrade',
    //     });
    //     // if (this.props.specComparison && 1 <= this.props.specComparison.length) {
    //     //   // GTMイベント
    //     //   BodyControl.setGTMEvent({
    //     //     trackcartype: variantInfo.drive + '(' + variantInfo.transmission + ')',
    //     //     event: 'SpecComparisonSelect',
    //     //   });
    //     // }
    //   }, 200);
    // }

    //if (nextProps.isCurrent !== this.isCurrent) {
    //this.isCurrent = nextProps.isCurrent;
    if (nextProps.isCurrent) {
      // GTMイベント
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].setGTMEvent({
        selectedgrade: nextProps.gradeName || nextProps.gradeId,
        selectedbodytype: nextProps.bodyTypeTabName || nextProps.bodyTypeModel,
        event: 'loadgrade'
      });
    }
    //}
  };

  GradeAndSpecData.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });

    window.removeEventListener('resize', this.handleResize);
  };

  // バリエーション情報取得


  return GradeAndSpecData;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fuelTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  specialCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  welfareCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  welfareCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeSpecUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  supportCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backgroundSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbBackgroundSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interiorImage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interiorImage2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideEstimationButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultDrive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultMission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  displacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  freeContentArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  bodySize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  equipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  makerOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  specComparison: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  freeContentArea2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  ownerLibraryContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  freeContentArea3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  variants: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    taxInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      acquisitionTaxIsActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      acquisitionTaxPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      acquisitionTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      weightTaxPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      weightTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      taxCut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    }),
    kankyowari: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    subsidy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })),
  gradeImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  modelName: null,
  bodyTypeModel: null,
  carTypeCode: null,
  gradeId: null,
  gradeCode: null,
  gradeName: null,
  fuelTabName: null,
  specialCar: null,
  specialCarTabName: null,
  welfareCar: null,
  welfareCarTabName: null,
  gradeSpecUrl: null,
  supportCar: null,
  description: null,
  mbDescription: null,
  backgroundSrc: null,
  mbBackgroundSrc: null,
  interiorImage: null,
  interiorImage2: null,
  hideEstimationButton: null,
  defaultDrive: null,
  defaultMission: null,
  displacement: null,
  photoInfo: null,
  freeContentArea: null,
  bodySize: null,
  equipment: null,
  makerOption: null,
  specComparison: null,
  freeContentArea2: null,
  ownerLibraryContainer: null,
  freeContentArea3: null,
  engine: null,
  variants: null,
  gradeImageSrc: null
}, _temp);
GradeAndSpecData.displayName = 'GradeAndSpecData';


/* harmony default export */ __webpack_exports__["a"] = (GradeAndSpecData);

/**
 *  GradeAndSpecDataVariant
 */
var GradeAndSpecDataVariant = (_temp2 = _class2 = function (_Component2) {
  _inherits(GradeAndSpecDataVariant, _Component2);

  function GradeAndSpecDataVariant(props) {
    _classCallCheck(this, GradeAndSpecDataVariant);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.handleResize = function () {
      if (_this3.state.isMounted === false) return;
      if (_this3.props.variantsWidth === null) return;
      //
      var container2Width = _this3.refs.container2.clientWidth;
      var taxesWidth = 0;
      if (_this3.refs.taxes && _this3.refs.taxes.clientWidth) {
        taxesWidth = _this3.refs.taxes.clientWidth;
      }
      if (_this3.refs.container3 && _this3.refs.container3.style) {
        if (_this3.props.variantsWidth < container2Width + taxesWidth) {
          _this3.refs.container3.style.display = 'block';
        } else {
          _this3.refs.container3.style.display = 'inline-block';
        }
      }
    };

    _this3.props = props;
    //
    _this3.state = {
      isMounted: false
    };
    _this3.intervalId = null;
    return _this3;
  }

  GradeAndSpecDataVariant.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {};

  GradeAndSpecDataVariant.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    this.setState({
      isMounted: true
    });

    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this4.handleResize();
    }, 100);
  };

  GradeAndSpecDataVariant.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });

    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  GradeAndSpecDataVariant.prototype.render = function render() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'GradeAndSpecData__variants__container', __source: {
          fileName: _jsxFileName,
          lineNumber: 613
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'GradeAndSpecData__variants__container2', ref: 'container2', __source: {
            fileName: _jsxFileName,
            lineNumber: 614
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GradeAndSpecData__variants__name', __source: {
              fileName: _jsxFileName,
              lineNumber: 615
            }
          },
          this.props.variantName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'GradeAndSpecData__variants__price', __source: {
              fileName: _jsxFileName,
              lineNumber: 616
            }
          },
          this.props.variantPrice,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 616
              }
            },
            ' (\u6D88\u8CBB\u7A0E\u8FBC)'
          )
        )
      ),
      function () {
        if (_this5.props.variantTax && 1 <= _this5.props.variantTax.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'GradeAndSpecData__variants__container3', ref: 'container3', __source: {
                fileName: _jsxFileName,
                lineNumber: 621
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'GradeAndSpecData__variants__tax', ref: 'taxes', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 622
                }
              },
              _this5.props.variantTax.map(function (tax, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpecData__variants__tax-item', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 625
                    }
                  },
                  tax
                );
              })
            )
          );
        } else {
          return null;
        }
      }()
    );
  };

  return GradeAndSpecDataVariant;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  variantName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  variantPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  variantTax: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  variantsWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class2.defaultProps = {
  variantName: null,
  variantPrice: null,
  variantTax: null,
  variantsWidth: null
}, _temp2);
GradeAndSpecDataVariant.displayName = 'GradeAndSpecDataVariant';

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(3);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\grade-and-spec\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/**
 *  GradeAndSpec
 */
var GradeAndSpec = (_temp = _class = function (_Component) {
  _inherits(GradeAndSpec, _Component);

  function GradeAndSpec(props) {
    _classCallCheck(this, GradeAndSpec);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      var maxHeight = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.navItems.length; i < max; i = i + 1) {
        var navItem = _this.navItems[i].current || null;
        // const navItem = this.refs[this.navItems[i]] || null;
        if (navItem) {
          if (maxHeight < navItem.clientHeight) {
            maxHeight = navItem.clientHeight;
          }
        }
      }
      if (!maxHeight) {
        maxHeight = "auto";
      }
      _this.setState({
        navItemHeight: maxHeight
      });
    };

    _this.getEngineFuel = function (gradeInfo) {
      if (gradeInfo.welfareCar === true) {
        if (gradeInfo.welfareCarEngines && gradeInfo.welfareCarEngines !== '') {
          return gradeInfo.welfareCarEngines.split(',')[0];
        } else {
          return null;
        }
      } else {
        if (gradeInfo.engine && gradeInfo.engine.fuel) {
          return gradeInfo.engine.fuel;
        } else {
          return null;
        }
      }
    };

    _this.narrowBodyTypeInfo = function (gradeInfo) {
      var engineName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var vehicleType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      //
      var i = void 0,
          max = void 0;
      // 燃料で絞り込み
      if (engineName && engineName !== '') {
        var arr = [];
        for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
          if (gradeInfo[i].welfareCar === true) {
            if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
              var arr2 = gradeInfo[i].welfareCarEngines.split(',');
              var flg = false;
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = arr2.length; j < max2; j = j + 1) {
                if (arr2[j] === engineName) {
                  flg = true;
                }
              }
              if (flg) {
                arr.push(gradeInfo[i]);
              }
            }
          } else {
            if (_this.getEngineFuel(gradeInfo[i]) === engineName) {
              arr.push(gradeInfo[i]);
            }
          }
        }
        gradeInfo = arr;
      } else if (_this.defaultEngineName && _this.defaultEngineName !== '') {
        var _arr = [];
        for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
          if (_this.getEngineFuel(gradeInfo[i]) === _this.defaultEngineName) {
            _arr.push(gradeInfo[i]);
          }
        }
        gradeInfo = _arr;
      }
      // タイプで絞り込み
      if (vehicleType && vehicleType !== '' && vehicleType !== 'ALL') {
        var _arr2 = [];
        for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
          if (gradeInfo[i].specialCar === true && gradeInfo[i].specialCarTabName === vehicleType) {
            _arr2.push(gradeInfo[i]);
          } else if (gradeInfo[i].welfareCar === true && gradeInfo[i].welfareCarTabName === vehicleType) {
            _arr2.push(gradeInfo[i]);
          }
        }
        gradeInfo = _arr2;
      }
      return gradeInfo;
    };

    _this.getDefaultBodyTypeId = function () {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        if (bodyType.default === true) {
          return bodyType.carId;
        }
      }
      return _this.props.models[0].bodyTypes[0].carId;
    };

    _this.getGradeInfo = function (bodyTypeId) {
      var info = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        // if (bodyType.carId === bodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyType.carId, bodyTypeId)) {
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
            var gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
            info.push(gradeAndSpecData.props);
          }
          return info;
        }
      }
      for (i = 0, max = _this.props.models[0].bodyTypes[0].generations[0].gradeAndSpecData.length; i < max; i = i + 1) {
        var _gradeAndSpecData = _this.props.models[0].bodyTypes[0].generations[0].gradeAndSpecData[i];
        info.push(_gradeAndSpecData.props);
      }
      return info;
    };

    _this.getGradsInfo = function () {
      var info = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        var bodyTypeId = bodyType.carId;
        var j = void 0,
            max2 = void 0;
        for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
          var gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
          info.push({
            name: gradeAndSpecData.name,
            props: gradeAndSpecData.props,
            bodyTypeId: bodyTypeId
          });
        }
      }
      return info;
    };

    _this.getDefaultEngineName = function (bodyTypeId) {
      var gradeInfo = _this.getGradeInfo(bodyTypeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          return _this.getEngineFuel(gradeInfo[i]);
        }
      }
      return _this.getEngineFuel(gradeInfo[0]);
    };

    _this.getDefaultVehicleType = function (bodyTypeId, engineName) {
      return 'ALL';
    };

    _this.getDefaultGradeId = function (bodyTypeId) {
      var engineName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var vehicleType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      //console.log('getDefaultGradeId : ' + bodyTypeId + '@' + engineName + '@' + vehicleType);
      var gradeInfo = _this.getGradeInfo(bodyTypeId);
      //  燃料とタイプで絞り込む
      gradeInfo = _this.narrowBodyTypeInfo(gradeInfo, engineName, vehicleType);
      //
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].default === true) {
          return gradeInfo[i].gradeId;
        }
      }
      return gradeInfo[0].gradeId;
    };

    _this.getBodyTypeNavInfo = function () {
      var info = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        info.push({
          id: bodyType.carId,
          bodyTypeTabName: bodyType.bodyTypeTabName
        });
      }
      return info;
    };

    _this.getEngineNavInfo = function (bodyTypeId) {
      var gradeInfo = _this.getGradeInfo(bodyTypeId);
      var info = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        // 福祉車両はwelfareCarEnginesで判別
        if (gradeInfo[i].welfareCar === true) {
          if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
            info = info.concat(gradeInfo[i].welfareCarEngines.split(','));
          }
        } else {
          if (gradeInfo[i].engine && gradeInfo[i].engine.fuel) {
            info.push(gradeInfo[i].engine.fuel);
          }
        }
      }
      return info.filter(function (x, i, self) {
        return self.indexOf(x) === i;
      });
    };

    _this.getFuelTabName = function (gradeInfo, engineName) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].welfareCar !== true) {
          if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
            return gradeInfo[i].fuelTabName;
          }
        }
      }
      return engineName;
    };

    _this.getVehicleTypeInfo = function (bodyTypeId, engineName) {
      var gradeInfo = _this.getGradeInfo(bodyTypeId);
      var flg = false;
      var info = [null, null, null];
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].specialCar === true) {
          if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
            info[1] = gradeInfo[i].specialCarTabName || '特別仕様車';
          }
        } else if (gradeInfo[i].welfareCar === true) {
          if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
            gradeInfo[i].welfareCarEngines.split(',').map(function (engine, index) {
              if (engine === engineName) {
                info[2] = gradeInfo[i].welfareCarTabName || '福祉車両';
              }
            });
          }
        } else {
          if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
            flg = true;
          }
        }
      }
      if (flg && (info[1] !== null || info[2] !== null)) {
        info[0] = 'ALL';
      }
      var info2 = [];
      for (i = 0, max = info.length; i < max; i = i + 1) {
        if (info[i] !== null) info2.push(info[i]);
      }
      return info2;
    };

    _this.getGradeNavInfo = function (bodyTypeId) {
      var gradeInfo = _this.getGradeInfo(bodyTypeId);
      //  燃料とタイプで絞り込む
      gradeInfo = _this.narrowBodyTypeInfo(gradeInfo, _this.currentEngineName, _this.currentVehicleType);
      //
      var info = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        var drives = '';
        var transmissions = '';
        if (gradeInfo[i].variants) {
          var k = void 0,
              max3 = void 0;
          for (k = 0, max3 = gradeInfo[i].variants.length; k < max3; k = k + 1) {
            var variant = gradeInfo[i].variants[k];
            if (drives === '') {
              drives = variant.drive;
            } else {
              drives = drives + '/' + variant.drive;
            }
            if (transmissions === '') {
              transmissions = variant.transmission;
            } else {
              transmissions = transmissions + '/' + variant.transmission;
            }
          }
        }
        info.push({
          id: gradeInfo[i].gradeId,
          gradeId: gradeInfo[i].gradeId,
          gradeName: gradeInfo[i].gradeName,
          //engineName: this.getEngineFuel(gradeInfo[i]),
          specialCar: gradeInfo[i].specialCar,
          specialCarTabName: gradeInfo[i].specialCarTabName,
          welfareCar: gradeInfo[i].welfareCar,
          welfareCarTabName: gradeInfo[i].welfareCarTabName,
          gradeSpecUrl: gradeInfo[i].gradeSpecUrl,
          drive: drives.split('/').filter(function (x, i, self) {
            return self.indexOf(x) === i;
          }).join('/'),
          transmission: transmissions.split('/').filter(function (x, i, self) {
            return self.indexOf(x) === i;
          }).join('/')
        });
      }
      return info;
    };

    _this.getCarTypeCode = function (bodyTypeId) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        //if (bodyType.carId === bodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyType.carId, bodyTypeId)) {
          return bodyType.generations[0].carTypeCode;
        }
      }
      return '';
    };

    _this.getCurrentGrade = function (bodyTypeId, gradeId) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        //if (bodyType.carId === bodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyType.carId, bodyTypeId)) {
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
            var gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
            //if (gradeAndSpecData.props.gradeId === gradeId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(gradeAndSpecData.props.gradeId, gradeId)) {
              return gradeAndSpecData;
            }
          }
        }
      }
      return null;
    };

    _this.getGradeImageDirectory = function (bodyTypeId, gradeId) {
      //let str = '/globalassets/assets/cars/';
      var str = '';
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/';
      } else {
        str = '/globalassets/assets/cars/';
      }
      str = str + _this.props.models[0].modelName + '/';
      //
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
        var bodyType = _this.props.models[0].bodyTypes[i];
        //if (bodyType.carId === bodyTypeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyType.carId, bodyTypeId)) {
          str = str + bodyType.carId + '/';
          str = str + bodyType.generations[0].carTypeCode + '/';
          //
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
            var gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
            // if (gradeAndSpecData.props.gradeId === gradeId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(gradeAndSpecData.props.gradeId, gradeId)) {
              str = str + Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* convertKataToRome */])(gradeAndSpecData.props.gradeId) + '/common/';
              str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
              return str;
            }
          }
        }
      }
      return '';
    };

    _this.getGradeImageName = function (vehicleType, bodyTypeId, gradeId, size) {
      var str = '';
      if (vehicleType === 'Commercial Car') {
        str = str + 'commercial_';
      } else if (_this.getCurrentGrade(bodyTypeId, gradeId).props.welfareCar === true) {
        str = str + 'welfare_';
      }
      str = str + Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* convertKataToRome */])(gradeId) + '_default_' + size + '.png';
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
    };

    _this.changeBodyType = function (bodyTypeId) {
      //console.log('changeBodyType : ' + bodyTypeId);
      _this.currentBodyTypeId = bodyTypeId;
      _this.currentEngineName = _this.getDefaultEngineName(_this.currentBodyTypeId);
      _this.currentVehicleType = _this.getDefaultVehicleType(_this.currentBodyTypeId, _this.currentEngineName);
      _this.currentGradeId = _this.getDefaultGradeId(_this.currentBodyTypeId, _this.currentEngineName, _this.currentVehicleType);
      _this.setState({
        bodyTypeId: _this.currentBodyTypeId,
        engineName: _this.currentEngineName,
        vehicleType: _this.currentVehicleType,
        gradeId: _this.currentGradeId
      });
      // フェードインアニメーション
      _this.refs.engineNav.classList.remove('open');
      setTimeout(function () {
        _this.refs.engineNav.classList.add('open');
      }, 100);
    };

    _this.setEngineNameRefine = function (engineName) {
      //console.log('setEngineNameRefine : ' + engineName);
      _this.currentEngineName = engineName;
      _this.currentVehicleType = _this.getDefaultVehicleType(_this.currentBodyTypeId, _this.currentEngineName);
      _this.currentGradeId = _this.getDefaultGradeId(_this.currentBodyTypeId, _this.currentEngineName, _this.currentVehicleType);
      _this.setState({
        engineName: _this.currentEngineName,
        vehicleType: _this.currentVehicleType,
        gradeId: _this.currentGradeId
      });
      // フェードインアニメーション
      _this.refs.vehicleTypeNav.classList.remove('open');
      setTimeout(function () {
        _this.refs.vehicleTypeNav.classList.add('open');
      }, 100);
    };

    _this.setVehicleTypeRefine = function (vehicleType) {
      //console.log('setVehicleTypeRefine : ' + vehicleType);
      _this.currentVehicleType = vehicleType;
      _this.currentGradeId = _this.getDefaultGradeId(_this.currentBodyTypeId, _this.currentEngineName, _this.currentVehicleType);
      _this.setState({
        vehicleType: _this.currentVehicleType,
        gradeId: _this.currentGradeId
      });
      // フェードインアニメーション
      _this.refs.gradeNav.classList.remove('open');
      setTimeout(function () {
        _this.refs.gradeNav.classList.add('open');
      }, 100);
    };

    _this.changeGrade = function (gradeId) {
      // if (this.currentGradeId === gradeId) return;
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this.currentGradeId, gradeId)) return;
      //
      _this.currentGradeId = gradeId;
      _this.setState({
        gradeId: _this.currentGradeId
      });
      // フェードインアニメーション
      _this.refs.grade.classList.remove('open');
      setTimeout(function () {
        _this.refs.grade.classList.add('open');
      }, 100);
    };

    _this.setCurrentByParams = function () {

      var setCurrent = function setCurrent(bodyTypeId, gradeId) {

        // BodyTypeが存在するか否か
        var getIsExistBodyType = function getIsExistBodyType(bodyTypeId) {
          if (!bodyTypeId || bodyTypeId === '') return false;
          //
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
            var bodyType = _this.props.models[0].bodyTypes[i];
            //if (bodyType.carId === bodyTypeId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyType.carId, bodyTypeId)) {
              return true;
            }
          }
          return false;
        };

        // Gradeが存在するか否か
        var getIsExistGrade = function getIsExistGrade(bodyTypeId, gradeId) {
          if (!gradeId || gradeId === '') return false;
          //
          var gradeInfo = _this.getGradeInfo(bodyTypeId);
          var i = void 0,
              max = void 0;
          for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
            //if (gradeInfo[i].gradeId === gradeId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, gradeId)) {
              return true;
            }
          }
          return false;
        };

        var isExistBodyType = getIsExistBodyType(bodyTypeId);
        var isExistGrade = false;
        if (isExistBodyType) {
          isExistGrade = getIsExistGrade(bodyTypeId, gradeId);
        }

        if (isExistBodyType && isExistGrade) {
          _this.currentBodyTypeId = bodyTypeId;
          //
          var gradeInfo = _this.getGradeInfo(bodyTypeId);
          var i = void 0,
              max = void 0;
          for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
            //if (gradeInfo[i].gradeId === gradeId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(gradeInfo[i].gradeId, gradeId)) {
              _this.currentEngineName = _this.getEngineFuel(gradeInfo[i]);
            }
          }
          //
          _this.currentVehicleType = _this.getDefaultVehicleType(_this.currentBodyTypeId, _this.currentEngineName);
          _this.currentGradeId = gradeId;
          _this.setState({
            bodyTypeId: _this.currentBodyTypeId,
            engineName: _this.currentEngineName,
            vehicleType: _this.currentVehicleType,
            gradeId: _this.currentGradeId
          });
        } else if (isExistBodyType) {
          _this.changeBodyType(bodyTypeId);
        }
      };

      // URLパラメータでカレント変更
      var carId = __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].getUrlParameter('car_id');
      var gradeId = __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].getUrlParameter('grade');
      if (carId || gradeId) {
        if (carId && gradeId) {
          setCurrent(carId, gradeId);
        } else if (carId) {
          setCurrent(carId);
        }
      } else {

        // ブロックのCookieに保温されている値でカレント変更
        carId = Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["d" /* getCookie */])('mj_gsbt');
        gradeId = Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["d" /* getCookie */])('mj_gsgr');
        if (carId || gradeId) {
          if (carId && gradeId) {
            setCurrent(carId, gradeId);
          } else if (carId) {
            setCurrent(carId);
          }
        } else {

          // 車種サイトのCookieに保温されている値でカレント変更
          carId = Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["d" /* getCookie */])('mjcarid');
          gradeId = Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["d" /* getCookie */])('mjgrade');
          if (carId || gradeId) {
            if (carId && gradeId) {
              setCurrent(carId, gradeId);
            } else if (carId) {
              setCurrent(carId);
            }
          }
        }
      }
      // setCookie('mj_gsbt', 'CarId002');
      // setCookie('mj_gsgr', 'Grade008');
    };

    _this.props = props;
    //
    _this.currentBodyTypeId = _this.getDefaultBodyTypeId();
    _this.currentEngineName = _this.getDefaultEngineName(_this.currentBodyTypeId);
    _this.currentVehicleType = _this.getDefaultVehicleType(_this.currentBodyTypeId, _this.currentEngineName);
    _this.currentGradeId = _this.getDefaultGradeId(_this.currentBodyTypeId, _this.currentEngineName, _this.currentVehicleType);
    //
    _this.state = {
      bodyTypeId: _this.currentBodyTypeId,
      engineName: _this.currentEngineName,
      vehicleType: _this.currentVehicleType,
      gradeId: _this.currentGradeId,
      isMounted: false,
      //fuelNavScrolled: false,
      navItemHeight: 'auto'
    };
    //
    _this.gradesInfo = _this.getGradsInfo();
    _this.navItems = [];
    _this.intervalId = null;
    return _this;
  }

  GradeAndSpec.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        models = _props.models;


    this.navItems = [];

    // ボディタイプナビゲーション
    var renderBodyTypeNav = function renderBodyTypeNav() {
      var bodyTypeNavInfo = _this2.getBodyTypeNavInfo();
      if (2 <= bodyTypeNavInfo.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'GradeAndSpec__body-type-nav', __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          },
          bodyTypeNavInfo.map(function (info, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 90
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'GradeAndSpec__body-type-nav__link' + (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.state.bodyTypeId, info.id) ? ' current' : '')
                  // className={'GradeAndSpec__body-type-nav__link' + ((this.state.bodyTypeId === info.id ? ' current': ''))}
                  , href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.changeBodyType(info.id);

                    // ブロックのCookieに保存
                    Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsbt', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(info.id));
                    Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["g" /* removeCookie */])('mj_gsgr');
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 91
                  }
                },
                info.bodyTypeTabName
              )
            );
          })
        );
      } else {
        return null;
      }
    };

    // エンジンナビゲーション
    var renderEngineNav = function renderEngineNav() {
      var engineNavInfo = _this2.getEngineNavInfo(_this2.state.bodyTypeId);
      var gradeInfo = _this2.getGradeInfo(_this2.state.bodyTypeId);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'GradeAndSpec__engine-nav', ref: 'engineNav', __source: {
            fileName: _jsxFileName,
            lineNumber: 122
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'GradeAndSpec__engine-nav__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'GradeAndSpec__engine-nav__list', ref: 'engineNavList', __source: {
                fileName: _jsxFileName,
                lineNumber: 124
              }
            },
            engineNavInfo.map(function (info, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 127
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'GradeAndSpec__engine-nav__link' + (_this2.state.engineName === info ? ' current' : ''),
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      // 絞り込み条件設定
                      _this2.setEngineNameRefine(info);

                      // ブロックのCookieに保存
                      Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsbt', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(_this2.currentBodyTypeId));
                      Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsgr', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(_this2.currentGradeId));
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 128
                    }
                  },
                  _this2.getFuelTabName(gradeInfo, info)
                )
              );
            })
          )
        )
      );
    };

    // 車両タイプナビゲーション
    var renderVehicleTypeNav = function renderVehicleTypeNav() {
      var vehicleType = _this2.getVehicleTypeInfo(_this2.state.bodyTypeId, _this2.state.engineName);
      if (2 <= vehicleType.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'GradeAndSpec__vehicle-type', __source: {
              fileName: _jsxFileName,
              lineNumber: 158
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'GradeAndSpec__vehicle-type__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 159
              }
            },
            vehicleType.map(function (info, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 162
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'GradeAndSpec__vehicle-type__link' + (_this2.state.vehicleType === info ? ' current' : ''),
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      // 絞り込み条件設定
                      _this2.setVehicleTypeRefine(info);

                      // ブロックのCookieに保存
                      //setCookie('mj_gsbt', formatId(this.currentBodyTypeId));
                      //setCookie('mj_gsgr', formatId(this.currentGradeId));
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 163
                    }
                  },
                  info
                )
              );
            })
          )
        );
      } else {
        return null;
      }
    };

    // グレードナビゲーション
    var renderGradeNav = function renderGradeNav() {
      if (_this2.state.isMounted === true) {
        var gradeNavInfo = _this2.getGradeNavInfo(_this2.state.bodyTypeId);
        if ((__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] === true ? 2 : 7) <= gradeNavInfo.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'GradeAndSpec__grade-nav', __source: {
                fileName: _jsxFileName,
                lineNumber: 196
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'GradeAndSpec__grade-nav__list', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 197
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__components_slider__["a" /* default */],
                { settings: {
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                    fade: false,
                    infinite: true,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    swipe: true,
                    draggable: false,
                    arrows: true,
                    dots: false,
                    adaptiveHeight: false,
                    centerMode: false,
                    centerPadding: 0,
                    //waitForAnimate: false,
                    lazyLoad: 'progressive',
                    responsive: [{
                      breakpoint: 767,
                      settings: {
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                        dots: true,
                        centerMode: false
                        //centerPadding: '10%',
                      }
                    }]
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 198
                  }
                },
                gradeNavInfo.map(function (info, index) {
                  return renderGradeNavItem(info, index);
                })
              )
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'GradeAndSpec__grade-nav', __source: {
                fileName: _jsxFileName,
                lineNumber: 242
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'GradeAndSpec__grade-nav__list fixed', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 243
                }
              },
              gradeNavInfo.map(function (info, index) {
                return renderGradeNavItem(info, index);
              })
            )
          );
        }
      } else {
        return null;
      }
    };

    // グレードナビゲーションアイテム
    var renderGradeNavItem = function renderGradeNavItem(info, index) {
      var getGradeName = function getGradeName() {
        if (info.gradeName && info.gradeName !== '') {
          return info.gradeName;
        } else if (info.gradeId && info.gradeId !== '') {
          return info.gradeId;
        } else {
          return '';
        }
      };

      // 100th Anniversary Special Edition > 100周年特別記念車
      var convert100th = function convert100th(text) {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          return text;
        } else {
          return text;
        }
      };

      //
      var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
      // const ref = 'item' + index;
      _this2.navItems.push(ref);
      //
      if (info.specialCar === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: 'GradeAndSpec__grade-nav__list-item', key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 303
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'GradeAndSpec__grade-nav__link' + (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.state.gradeId, info.id) ? ' current' : '')
              //href={(info.gradeSpecUrl) ? info.gradeSpecUrl: 'javascript:void(0);'}
              , href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                _this2.changeGrade(info.id);

                // ブロックのCookieに保存
                Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsbt', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(_this2.currentBodyTypeId));
                Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsgr', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(info.id));
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 305
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__text-wrapper', style: { height: _this2.state.navItemHeight }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 318
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: ref, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 319
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'GradeAndSpec__grade-nav__vehicle-type', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 320
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 321
                      }
                    },
                    info.specialCarTabName && info.specialCarTabName !== '' ? info.specialCarTabName : '特別仕様車'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__grade', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 323
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: info.gradeId && info.gradeId !== '' ? convert100th(info.gradeId) : '' }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 324
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 327
                    }
                  },
                  info.drive,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 327
                    }
                  }),
                  info.transmission
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__image-wrapper', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 331
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpec__grade-nav__image-wrapper2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 332
                  }
                },
                _this2.state.isMounted === true ?
                // <img className="GradeAndSpec__grade-nav__image a" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-proactive-smart-edition/common/15s-proactive-smart-edition_default_s.png"/>
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpec__grade-nav__image', src: _this2.getGradeImageDirectory(_this2.state.bodyTypeId, info.id) + _this2.getGradeImageName(_this2.props.models[0].vehicleType, _this2.state.bodyTypeId, info.id, 's'), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 335
                  }
                }) : null
              )
            )
          )
        );
      } else if (info.welfareCar === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: 'GradeAndSpec__grade-nav__list-item', key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 344
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'GradeAndSpec__grade-nav__link' + (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.state.gradeId, info.id) ? ' current' : ''),
              href: info.gradeSpecUrl ? info.gradeSpecUrl : 'javascript:void(0);',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 346
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__text-wrapper', style: { height: _this2.state.navItemHeight }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 349
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: ref, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 350
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'GradeAndSpec__grade-nav__vehicle-type', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 351
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 352
                      }
                    },
                    info.welfareCarTabName && info.welfareCarTabName !== '' ? info.welfareCarTabName : '福祉車両'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__grade', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 354
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["h" /* convertPipeToBrTag */])(convert100th(getGradeName())) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 355
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 358
                    }
                  },
                  info.drive,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 358
                    }
                  }),
                  info.transmission
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__image-wrapper', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 362
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpec__grade-nav__image-wrapper2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 363
                  }
                },
                _this2.state.isMounted === true ?
                // <img className="GradeAndSpec__grade-nav__image a" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-smart-edition/common/15s-smart-edition_default_s.png" />
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpec__grade-nav__image', src: _this2.getGradeImageDirectory(_this2.state.bodyTypeId, info.id) + _this2.getGradeImageName(_this2.props.models[0].vehicleType, _this2.state.bodyTypeId, info.id, 's'), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 366
                  }
                }) : null
              )
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: 'GradeAndSpec__grade-nav__list-item', key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 375
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'GradeAndSpec__grade-nav__link' + (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.state.gradeId, info.id) ? ' current' : ''),
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                _this2.changeGrade(info.id);

                // ブロックのCookieに保存
                Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsbt', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(_this2.currentBodyTypeId));
                Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["h" /* setCookie */])('mj_gsgr', Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["b" /* formatId */])(info.id));
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 377
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__text-wrapper', style: { height: _this2.state.navItemHeight }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 389
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: ref, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 390
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'GradeAndSpec__grade-nav__vehicle-type', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 391
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__grade', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 392
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["h" /* convertPipeToBrTag */])(convert100th(getGradeName())) }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 393
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'GradeAndSpec__grade-nav__engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 396
                    }
                  },
                  info.drive,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 396
                    }
                  }),
                  info.transmission
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__grade-nav__image-wrapper', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 400
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpec__grade-nav__image-wrapper2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 401
                  }
                },
                _this2.state.isMounted === true ?
                // <img className="GradeAndSpec__grade-nav__image k" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-smart-edition/common/15s-smart-edition_default_s.png" />
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'GradeAndSpec__grade-nav__image', src: _this2.getGradeImageDirectory(_this2.state.bodyTypeId, info.id) + _this2.getGradeImageName(_this2.props.models[0].vehicleType, _this2.state.bodyTypeId, info.id, 's'), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 404
                  }
                }) : null
              )
            )
          )
        );
      }
    };

    // グレード
    var renderGrade = function renderGrade() {
      if (!_this2.state.isMounted) return;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 418
          }
        },
        _this2.gradesInfo.map(function (gradeInfo, index) {
          if (gradeInfo.props.welfareCar === true) {
            return null;
          } else {
            if (_this2.state.isMounted === true) {
              // const isCurrent = (this.currentBodyTypeId === gradeInfo.bodyTypeId && this.currentGradeId === gradeInfo.props.gradeId) ? true : false;
              var isCurrent = Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.currentBodyTypeId, gradeInfo.bodyTypeId) && Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(_this2.currentGradeId, gradeInfo.props.gradeId) ? true : false;

              // GTMイベントで利用するボディータイプ
              var getBodyTypeTabName = function getBodyTypeTabName(bodyTypeId) {
                var i = void 0,
                    max = void 0;
                for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
                  var model = _this2.props.models[i];
                  var j = void 0,
                      max2 = void 0;
                  for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                    var bodyType = model.bodyTypes[j];
                    if (Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["f" /* isEqualId */])(bodyTypeId, bodyType.carId)) {
                      return bodyType.bodyTypeTabName;
                    }
                  }
                }
                return null;
              };

              // return (
              //   <div className="GradeAndSpec__grade" style={(isCurrent) ? {display: 'block'} : {display: 'none'}} key={index}>
              //     {getComponents([gradeInfo], {
              //       modelName: this.props.models[0].modelName,
              //       gradeImageSrc: this.getGradeImageDirectory(gradeInfo.bodyTypeId, gradeInfo.props.gradeId) + this.getGradeImageName(this.props.models[0].vehicleType, gradeInfo.bodyTypeId, gradeInfo.props.gradeId, 'l'),
              //       bodyTypeModel: gradeInfo.bodyTypeId,
              //       carTypeCode: this.getCarTypeCode(gradeInfo.bodyTypeId),
              //       isCurrent: isCurrent,
              //       bodyTypeTabName: getBodyTypeTabName(gradeInfo.bodyTypeId)
              //     })}
              //   </div>
              // );

              if (isCurrent) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'GradeAndSpec__grade', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 458
                    }
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_4__utilities__["c" /* getComponents */])([gradeInfo], {
                    modelName: _this2.props.models[0].modelName,
                    gradeImageSrc: _this2.getGradeImageDirectory(gradeInfo.bodyTypeId, gradeInfo.props.gradeId) + _this2.getGradeImageName(_this2.props.models[0].vehicleType, gradeInfo.bodyTypeId, gradeInfo.props.gradeId, 'l'),
                    bodyTypeModel: gradeInfo.bodyTypeId,
                    carTypeCode: _this2.getCarTypeCode(gradeInfo.bodyTypeId),
                    isCurrent: isCurrent,
                    bodyTypeTabName: getBodyTypeTabName(gradeInfo.bodyTypeId)
                  })
                );
              }
            } else {
              return null;
            }
          }
        })
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 481
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'GradeAndSpec', __source: {
            fileName: _jsxFileName,
            lineNumber: 487
          }
        },
        renderBodyTypeNav(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'GradeAndSpec__fade-in-container open', ref: 'engineNav', __source: {
              fileName: _jsxFileName,
              lineNumber: 489
            }
          },
          renderEngineNav(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'GradeAndSpec__fade-in-container open', ref: 'vehicleTypeNav', __source: {
                fileName: _jsxFileName,
                lineNumber: 491
              }
            },
            renderVehicleTypeNav(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'GradeAndSpec__fade-in-container open', ref: 'gradeNav', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 493
                }
              },
              renderGradeNav(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'GradeAndSpec__fade-in-container open', ref: 'grade', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 495
                  }
                },
                renderGrade()
              )
            )
          )
        )
      )
    );
  };

  GradeAndSpec.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    this.setState({
      isMounted: true
    });

    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();

    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this3.handleResize();
    }, 100);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(function () {
      _this3.handleResize();
    }, 200);
  };

  GradeAndSpec.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
    //
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  };

  GradeAndSpec.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {}
  // if (prevState.isMounted !== this.state.isMounted) {
  //   const carId = BodyControl.getUrlParameter('car_id');
  //   const gradeId = BodyControl.getUrlParameter('grade_id');
  //   if (carId && carId !== '') {
  //     this.currentBodyTypeId = carId;
  //     this.currentengineName = this.getDefaultengineName(this.currentBodyTypeId);
  //     this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentengineName);
  //     if (gradeId && gradeId !== '') {
  //       this.currentGradeId = gradeId;
  //     } else {
  //       this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentengineName, this.currentVehicleType);
  //     }
  //   }
  //   console.log(carId);
  //   console.log(this.currentGradeId);
  // }


  // リサイズ
  ;

  // ボディタイプ情報を燃料とタイプで絞り込む


  /* ----- デフォルト取得 ----- */

  // デフォルトボディタイプ取得


  // グレード情報


  // 全てのグレード情報


  // デフォルト燃料取得


  // デフォルト車両タイプ


  // デフォルトグレード取得


  /* ----- 情報取得 ----- */

  // ボディタイプナビゲーション情報取得


  // 燃料リスト取得


  // 燃料タブ取得


  // 車両タイプ情報取得


  // グレードナビゲーション情報取得


  // CarTypeCode取得


  // カレントグレード取得


  // グレード画像ディレクトリ取得


  // グレード画像名取得


  /* ----- 選択・変更 ----- */

  // ボディタイプ変更


  // 絞り込み条件設定


  // 絞り込み条件設定


  // グレード変更


  // URLパラメータでダイレクト遷移


  return GradeAndSpec;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vehicleTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      generations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeAndSpecData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
      }))
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  vehicleType: null,
  vehicleTabName: null,
  models: null
}, _temp);
GradeAndSpec.displayName = 'GradeAndSpec';


/* harmony default export */ __webpack_exports__["a"] = (GradeAndSpec);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__car_lineup_filter__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_body__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\car-lineup\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 *  CarLineup
 */
var CarLineup = (_temp = _class = function (_PureComponent) {
  _inherits(CarLineup, _PureComponent);

  function CarLineup(props) {
    _classCallCheck(this, CarLineup);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.setDefaultState = function () {
      // URLパラメータのvehicle_typeから初期状態を設定
      var query_vehicle_type = _this.getQuery('vehicle_type');
      if (query_vehicle_type !== false) {
        // 文字列整形
        var vehicleTextArr = query_vehicle_type.split('-');
        vehicleTextArr.forEach(function (text, index) {
          vehicleTextArr[index] = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        });
        query_vehicle_type = vehicleTextArr.join(' ');

        // セット
        _this.tmpState.vehicle = query_vehicle_type;
        _this.setState({
          vehicle: query_vehicle_type
        });
      }
    };

    _this.getQuery = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location) {
        return false;
      }
      var params = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location.search.substring(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var param = params[i].split('=');
        if (param[0].trim() === key) {
          return param[1].trim();
        }
      }
      return false;
    };

    _this.onChangeVehicle = function (e) {
      _this.setState({
        vehicle: e.target.value,
        view: e.target.value === 'Passenger Car' ? _this.tmpState.view : 'Grid'
      });

      _this.applyFilter();

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */]) {
        _this.slideVehicleNavi();
      }
    };

    _this.slideVehicleNavi = function () {
      var checkedRadio = _this.refs.vehiclesFilter.querySelector("input[type='radio']:checked");
      var current = checkedRadio.parentNode.parentNode;
      var parent = current.parentNode;
      var currentRect = current.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();

      var children = parent.children;
      var child = void 0;
      var currentLeft = 0;
      var totalWidth = 0;
      for (var i = 0; i < parent.children.length; i++) {
        child = parent.children[i];
        totalWidth += child.getBoundingClientRect().width;
      }
      for (var _i = 0; _i < parent.children.length; _i++) {
        child = parent.children[_i];
        if (child === current) {
          break;
        }
        currentLeft += child.getBoundingClientRect().width;
      }

      var scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2;
      scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;

      if (totalWidth - scrollLeft < parentRect.width) {
        scrollLeft = totalWidth - parentRect.width;
      }

      scrollLeft = Math.floor(scrollLeft);

      clearInterval(_this.vehicleIntervalId);
      _this.vehicleIntervalId = setInterval(function () {
        if (scrollLeft - parent.scrollLeft < 0) {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1;
        } else {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1);
        }

        if (Math.abs(scrollLeft - parent.scrollLeft) < 1) {
          parent.scrollLeft = scrollLeft;
          clearInterval(_this.vehicleIntervalId);
        }
        // console.log(parent.scrollLeft, scrollLeft);
      }, 1000 / 60);
    };

    _this.onChangeView = function (e) {
      _this.setState({
        view: e.target.value
      });

      if (_this.state.vehicle === 'Passenger Car') {
        _this.tmpState.view = e.target.value;
      }

      _this.applyFilter();
    };

    _this.onChangeFilter = function (e) {
      _this.applyFilter();
    };

    _this.onResetFilter = function (e) {
      setTimeout(_this.applyFilter, 10);
    };

    _this.onClickRadio = function (e) {
      if (e.target.type === 'radio') {
        _this.applyFilter();
        e.stopPropagation();
      }
    };

    _this.onChangeRadio = function (e) {
      if (e.target.type === 'radio' && e.target.checked === true) {
        var label = e.target.parentNode;
        var text = e.target.name + ':' + label.innerText.trim();
        _this.sendGTM(text);
        e.stopPropagation();
      }
    };

    _this.onChangeCheckbox = function (e) {
      if (e.target.type === 'checkbox' && e.target.checked === true) {
        var label = e.target.parentNode;
        var text = e.target.name + ':' + label.innerText.trim();
        _this.sendGTM(text);
        e.stopPropagation();
      }
    };

    _this.onChangeSelect = function (e) {
      var selectedIndex = e.target.selectedIndex;
      var text = e.target.name + ':' + e.target.options[selectedIndex].text.trim();
      _this.sendGTM(text);
      e.stopPropagation();
      _this.applyFilter();
    };

    _this.onClickRefineOpen = function (e) {
      var filter = _this.refs.filter;
      filter.classList.remove('CarLineup__FiltersForm--close');
      filter.classList.add('CarLineup__FiltersForm--open');

      _this.refs.cars.classList.add('fadein-mb');

      // document.body.classList.add('un-scroll-mb');
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].setUnScrollMb();
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].openModal();

      e.preventDefault();

      // 一時記録
      _this.tmpState.filter = {
        bodyType: filter.bodyType.value,
        engineType: filter.engineType.value,
        mission: filter.mission.value,
        drive: filter.drive.value,
        capacity: filter.capacity.value,
        price: filter.price.value,
        minDisplacement: filter.minDisplacement.value,
        maxDisplacement: filter.maxDisplacement.value,
        bodySizeLength: filter.bodySizeLength.value,
        bodySizeWidth: filter.bodySizeWidth.value,
        bodySizeHeight: filter.bodySizeHeight.value,
        othersSv: filter.othersSv.checked,
        // othersSupportCar: filter.othersSupportCar.checked,
        othersSupportCar: [],
        othersEcoTax: filter.othersEcoTax.checked,
        othersSubsidy: filter.othersSubsidy.checked
      };

      for (var i = 0; i < filter.othersSupportCar.length; i++) {
        _this.tmpState.filter.othersSupportCar[i] = filter.othersSupportCar[i].checked;
      }
    };

    _this.onClickRefineClose = function (e) {
      var filter = _this.refs.filter;
      filter.classList.remove('CarLineup__FiltersForm--open');
      filter.classList.add('CarLineup__FiltersForm--close');

      _this.refs.cars.classList.remove('fadein-mb');

      // document.body.classList.remove('un-scroll-mb');
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].clearUnScroll();
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].closeModal();

      e.preventDefault();

      // 復帰前にフォーム内容をクリア
      filter.reset();

      // 一時記録から復帰
      filter.bodyType.value = _this.tmpState.filter.bodyType;
      filter.engineType.value = _this.tmpState.filter.engineType;
      filter.mission.value = _this.tmpState.filter.mission;
      filter.drive.value = _this.tmpState.filter.drive;
      filter.capacity.value = _this.tmpState.filter.capacity;
      filter.price.value = _this.tmpState.filter.price;
      filter.minDisplacement.value = _this.tmpState.filter.minDisplacement;
      filter.maxDisplacement.value = _this.tmpState.filter.maxDisplacement;
      filter.bodySizeLength.value = _this.tmpState.filter.bodySizeLength;
      filter.bodySizeWidth.value = _this.tmpState.filter.bodySizeWidth;
      filter.bodySizeHeight.value = _this.tmpState.filter.bodySizeHeight;
      filter.othersSv.checked = _this.tmpState.filter.othersSv;
      // filter.othersSupportCar.checked = this.tmpState.filter.othersSupportCar;
      filter.othersEcoTax.checked = _this.tmpState.filter.othersEcoTax;
      filter.othersSubsidy.checked = _this.tmpState.filter.othersSubsidy;

      for (var i = 0; i < filter.othersSupportCar.length; i++) {
        filter.othersSupportCar[i].checked = Boolean(_this.tmpState.filter.othersSupportCar[i]);
      }

      _this.tmpState.filter = {};

      _this.applyFilter();
    };

    _this.onClickRefineSubmit = function (e) {
      var filter = _this.refs.filter;
      filter.classList.remove('CarLineup__FiltersForm--open');
      filter.classList.add('CarLineup__FiltersForm--close');

      _this.refs.cars.classList.remove('fadein-mb');

      // document.body.classList.remove('un-scroll-mb');
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].clearUnScroll();
      __WEBPACK_IMPORTED_MODULE_7__components_body__["a" /* default */].closeModal();

      e.preventDefault();

      _this.applyFilter();
    };

    _this.onClickCarLink = function (e) {
      // let date = new Date();
      // date.setTime(date.getTime() + 24 * 60 * 60 * 1000); //24h
      // let expires = date.toGMTString();

      // if(DOCUMENT){
      //   if(e.currentTarget.dataset.car_id){
      //     DOCUMENT.cookie = "mj_carid=" + e.currentTarget.dataset.car_id + ";expires=" + expires + ";path=/";
      //   }
      //   if(e.currentTarget.dataset.grade_id){
      //     DOCUMENT.cookie = "mj_grade=" + e.currentTarget.dataset.grade_id + ";expires=" + expires + ";path=/";
      //   }
      // }

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */]) {
        __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location.href = e.currentTarget.href;
      }

      e.preventDefault();
      return false;
    };

    _this.getVehicleTabNames = function (models) {
      // Passenger Car/Light Car/Special Car/Commercial Car/Welfare Car/
      var vehicles = {
        'Passenger Car': [],
        'Light Car': [],
        'Special Car': [],
        'Commercial Car': [],
        'Welfare Car': []
      };

      if (models) {
        models.map(function (model, index) {
          if (model.vehicleType === 'Passenger Car' && model.vehicleTabName !== '') {
            vehicles['Passenger Car'].push(model.vehicleTabName);
          } else if (model.vehicleType === 'Light Car' && model.vehicleTabName !== '') {
            vehicles['Light Car'].push(model.vehicleTabName);
          } else if (model.vehicleType === 'Commercial Car' && model.vehicleTabName !== '') {
            vehicles['Commercial Car'].push(model.vehicleTabName);
          }

          if (model.bodyTypes && Array.isArray(model.bodyTypes)) {
            model.bodyTypes.map(function (bodyType, index) {
              if (bodyType.grades && Array.isArray(bodyType.grades)) {
                bodyType.grades.map(function (grade, index) {
                  if (grade.specialCar === true && grade.specialCarTabName && grade.specialCarTabName !== '') {
                    vehicles['Special Car'].push(grade.specialCarTabName);
                  } else if (grade.welfareCar === true && grade.welfareCarTabName && grade.welfareCarTabName !== '') {
                    vehicles['Welfare Car'].push(grade.welfareCarTabName);
                  }
                });
              }
            });
          }
        });
      }

      for (var vehicleType in vehicles) {
        if (vehicles.hasOwnProperty(vehicleType)) {
          // 重複を削除
          vehicles[vehicleType] = vehicles[vehicleType].filter(function (x, i, self) {
            return self.indexOf(x) === i;
          });
        }
      }

      return vehicles;
    };

    _this.sendGTM = function (text) {
      dataLayer = dataLayer || [];
      dataLayer.push({
        trackfliter: text,
        event: 'CarLineupFilterSelect'
      });
    };

    _this.applyFilter = function () {
      var vehicles = _this.refs.vehiclesFilter;
      var filter = _this.refs.filter;

      if (_this.refs.cars != null && _this.refs.cars.classList != null) {
        _this.refs.cars.classList.remove('fadein');
        _this.refs.cars.style.opacity = 0;
        setTimeout(function () {
          _this.refs.cars.classList.add('fadein');
          _this.refs.cars.style.opacity = 1;
        }, 10);
      }

      var currentVehicleType = '';
      for (var i = 0; i < vehicles.vehicle.length; i++) {
        if (vehicles.vehicle[i].checked) {
          currentVehicleType = vehicles.vehicle[i].value;
          break;
        }
      }

      var models = JSON.parse(JSON.stringify(_this.props.models));
      if (models && models.length > 0) {
        var _i2 = models.length;
        while (_i2--) {
          // 車種（Passenger Car/Light Car/Commercial Car）
          if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/) && models[_i2].vehicleType !== currentVehicleType) {
            models.splice(_i2, 1);
            continue;
          }

          if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/)) {
            var bodyTypes = models[_i2].bodyTypes;
            if (bodyTypes && bodyTypes.length > 0) {
              var j = bodyTypes.length;
              loopBodyType: while (j--) {
                var bodyType = bodyTypes[j];

                var hasSv = _this.hasSpecialVehicle(bodyType.carId);

                if (filter && currentVehicleType.match(/Passenger Car/)) {
                  if (filter.othersSv != null && filter.othersSv.checked) {
                    if (!hasSv && bodyType.grades == null) {
                      bodyTypes.splice(j, 1);
                      continue;
                    }
                  }
                }

                if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
                  var k = bodyType.grades.length;
                  while (k--) {
                    var grade = bodyType.grades[k];
                    if (grade.welfareCar === true) {
                      bodyTypes.splice(j, 1);
                      continue loopBodyType;
                    }
                    if (grade.specialCar === true) {
                      bodyTypes.splice(j, 1);
                      continue loopBodyType;
                    }
                  }
                }
              }
            }
          }

          if (true) {
            var _bodyTypes = models[_i2].bodyTypes;
            if (_bodyTypes && _bodyTypes.length > 0) {
              var _j = _bodyTypes.length;
              loopBodyType: while (_j--) {
                var _bodyType = _bodyTypes[_j];
                if (_bodyType.grades && Array.isArray(_bodyType.grades) && _bodyType.grades.length > 0) {
                  var _k = _bodyType.grades.length;
                  while (_k--) {
                    var _grade = _bodyType.grades[_k];
                    // 特別仕様車チェック
                    if (currentVehicleType.match(/Special Car/) && (_grade === null || _grade.specialCar !== true || _grade.specialCarDefaultGrade !== true)) {
                      _bodyType.grades.splice(_k, 1);
                      continue;
                    }
                    // 福祉車両チェック
                    else if (currentVehicleType.match(/Welfare Car/) && (_grade === null || _grade.welfareCar !== true || _grade.welfareCarDefaultGrade !== true)) {
                        _bodyType.grades.splice(_k, 1);
                        continue;
                      }
                  }
                  if (_bodyType.grades.length === 0) {
                    delete _bodyType.grades;
                  }
                }
                if (currentVehicleType.match(/Special Car/) || currentVehicleType.match(/Welfare Car/)) {
                  if (!_bodyType.grades || _bodyType.grades.length === 0) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }

                // filterが無い（narrowPassengerCarCategory が true）の時は検索フィルタをかけない
                if (!filter) {
                  continue;
                }

                // 「Passenger Car（乗用車）」の時のみ検索フィルタをかける
                if (currentVehicleType !== 'Passenger Car') {
                  continue;
                }
                // 以下、検索フィルタ
                var _bodyTypeValue = _this.getFilterValue(filter, 'bodyType');
                if (_bodyTypeValue != null && _bodyTypeValue !== '') {
                  if (_bodyType.bodyTypeCategory !== _bodyTypeValue) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                var _engineTypeValue = _this.getFilterValue(filter, 'engineType');
                if (_engineTypeValue != null && _engineTypeValue !== '') {
                  if (!_this.inArray(_bodyType.fuels, _engineTypeValue)) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                var _missionValue = _this.getFilterValue(filter, 'mission');
                if (_missionValue != null && _missionValue !== '') {
                  if (!_this.inArray(_bodyType.transmissions, _missionValue)) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                var _driveValue = _this.getFilterValue(filter, 'drive');
                if (_driveValue != null && _driveValue !== '') {
                  if (!_this.inArray(_bodyType.drives, _driveValue)) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                var _capacityValue = _this.getFilterValue(filter, 'capacity');
                if (_capacityValue != null && Number(_capacityValue) > 0) {
                  var value = 0;
                  var operator = '';
                  var isMatch = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.passengers == null || !Array.isArray(_bodyType.specSummary.passengers)) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  for (var _k2 = 0; _k2 < filter.capacity.length; _k2++) {
                    if (filter.capacity[_k2].checked) {
                      value = filter.capacity[_k2].value;
                      operator = filter.capacity[_k2].dataset.operator;
                    }
                  }

                  var minCapacity = void 0,
                      maxCapacity = void 0;
                  for (var _k3 = 0; _k3 < _bodyType.specSummary.passengers.length; _k3++) {
                    if (minCapacity == null) {
                      minCapacity = Number(_bodyType.specSummary.passengers[_k3]);
                    }
                    if (maxCapacity == null) {
                      maxCapacity = Number(_bodyType.specSummary.passengers[_k3]);
                    }
                    minCapacity = Math.min(_bodyType.specSummary.passengers[_k3], minCapacity);
                    maxCapacity = Math.max(_bodyType.specSummary.passengers[_k3], maxCapacity);
                  }
                  switch (operator) {
                    case '=':
                      isMatch = !!(Number(minCapacity) === Number(value) && Number(maxCapacity) === Number(value));
                      break;
                    case '<':
                      isMatch = Number(maxCapacity) < Number(value);
                      break;
                    case '<=':
                      isMatch = Number(maxCapacity) <= Number(value);
                      break;
                    case '>':
                      isMatch = Number(minCapacity) > Number(value);
                      break;
                    case '>=':
                      isMatch = Number(minCapacity) >= Number(value);
                      break;
                    default:
                      isMatch = !!(Number(minCapacity) === Number(value) && Number(maxCapacity) === Number(value));
                  }
                  if (!isMatch) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.price != null && filter.price.value != null && Number(filter.price.value) > 0) {
                  var _operator = filter.price.options[filter.price.options.selectedIndex].dataset.operator;
                  var _isMatch = false;
                  if (_bodyType.minPrice == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator) {
                    case '=':
                      _isMatch = Number(_bodyType.minPrice) === Number(filter.price.value);
                      break;
                    case '<':
                      _isMatch = Number(_bodyType.minPrice) < Number(filter.price.value);
                      break;
                    case '<=':
                      _isMatch = Number(_bodyType.minPrice) <= Number(filter.price.value);
                      break;
                    case '>':
                      _isMatch = Number(_bodyType.minPrice) > Number(filter.price.value);
                      break;
                    case '>=':
                      _isMatch = Number(_bodyType.minPrice) >= Number(filter.price.value);
                      break;
                    default:
                      _isMatch = Number(_bodyType.minPrice) === Number(filter.price.value);
                  }
                  if (!_isMatch) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.minDisplacement != null && filter.minDisplacement.value != null && Number(filter.minDisplacement.value) > 0) {
                  var _operator2 = filter.minDisplacement.options[filter.minDisplacement.options.selectedIndex].dataset.operator;
                  var _isMatch2 = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.minDisplacement == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator2) {
                    case '=':
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) === Number(filter.minDisplacement.value);
                      break;
                    case '<':
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) < Number(filter.minDisplacement.value);
                      break;
                    case '<=':
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) <= Number(filter.minDisplacement.value);
                      break;
                    case '>':
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) > Number(filter.minDisplacement.value);
                      break;
                    case '>=':
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) >= Number(filter.minDisplacement.value);
                      break;
                    default:
                      _isMatch2 = Number(_bodyType.specSummary.minDisplacement) === Number(filter.minDisplacement.value);
                  }
                  if (!_isMatch2) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.maxDisplacement != null && filter.maxDisplacement.value != null && Number(filter.maxDisplacement.value) > 0) {
                  var _operator3 = filter.maxDisplacement.options[filter.maxDisplacement.options.selectedIndex].dataset.operator;
                  var _isMatch3 = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.maxDisplacement == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator3) {
                    case '=':
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) === Number(filter.maxDisplacement.value);
                      break;
                    case '<':
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) < Number(filter.maxDisplacement.value);
                      break;
                    case '<=':
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) <= Number(filter.maxDisplacement.value);
                      break;
                    case '>':
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) > Number(filter.maxDisplacement.value);
                      break;
                    case '>=':
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) >= Number(filter.maxDisplacement.value);
                      break;
                    default:
                      _isMatch3 = Number(_bodyType.specSummary.maxDisplacement) === Number(filter.maxDisplacement.value);
                  }
                  if (!_isMatch3) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.bodySizeLength != null && filter.bodySizeLength.value != null && Number(filter.bodySizeLength.value) > 0) {
                  var _operator4 = filter.bodySizeLength.options[filter.bodySizeLength.options.selectedIndex].dataset.operator;
                  var _isMatch4 = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.minLength == null || _bodyType.specSummary.maxLength == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator4) {
                    case '=':
                      _isMatch4 = !!(Number(_bodyType.specSummary.minLength) === Number(filter.bodySizeLength.value) || Number(_bodyType.specSummary.maxLength) === Number(filter.bodySizeLength.value));
                      break;
                    case '<':
                      // isMatch = (Number(bodyType.specSummary.minLength) < Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) < Number(filter.bodySizeLength.value)) ? true : false;
                      _isMatch4 = Number(_bodyType.specSummary.minLength) < Number(filter.bodySizeLength.value);
                      break;
                    case '<=':
                      // isMatch = (Number(bodyType.specSummary.minLength) <= Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) <= Number(filter.bodySizeLength.value)) ? true : false;
                      _isMatch4 = Number(_bodyType.specSummary.minLength) <= Number(filter.bodySizeLength.value);
                      break;
                    case '>':
                      // isMatch = (Number(bodyType.specSummary.minLength) > Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) > Number(filter.bodySizeLength.value)) ? true : false;
                      _isMatch4 = Number(_bodyType.specSummary.minLength) > Number(filter.bodySizeLength.value);
                      break;
                    case '>=':
                      // isMatch = (Number(bodyType.specSummary.minLength) >= Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) >= Number(filter.bodySizeLength.value)) ? true : false;
                      _isMatch4 = Number(_bodyType.specSummary.minLength) >= Number(filter.bodySizeLength.value);
                      break;
                    default:
                      _isMatch4 = !!(Number(_bodyType.specSummary.minLength) === Number(filter.bodySizeLength.value) || Number(_bodyType.specSummary.maxLength) === Number(filter.bodySizeLength.value));
                  }
                  if (!_isMatch4) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.bodySizeWidth != null && filter.bodySizeWidth.value != null && Number(filter.bodySizeWidth.value) > 0) {
                  var _operator5 = filter.bodySizeWidth.options[filter.bodySizeWidth.options.selectedIndex].dataset.operator;
                  var _isMatch5 = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.minWidth == null || _bodyType.specSummary.maxWidth == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator5) {
                    case '=':
                      _isMatch5 = !!(Number(_bodyType.specSummary.minWidth) === Number(filter.bodySizeWidth.value) || Number(_bodyType.specSummary.maxWidth) === Number(filter.bodySizeWidth.value));
                      break;
                    case '<':
                      // isMatch = (Number(bodyType.specSummary.minWidth) < Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) < Number(filter.bodySizeWidth.value)) ? true : false;
                      _isMatch5 = Number(_bodyType.specSummary.minWidth) < Number(filter.bodySizeWidth.value);
                      break;
                    case '<=':
                      // isMatch = (Number(bodyType.specSummary.minWidth) <= Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) <= Number(filter.bodySizeWidth.value)) ? true : false;
                      _isMatch5 = Number(_bodyType.specSummary.minWidth) <= Number(filter.bodySizeWidth.value);
                      break;
                    case '>':
                      // isMatch = (Number(bodyType.specSummary.minWidth) > Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) > Number(filter.bodySizeWidth.value)) ? true : false;
                      _isMatch5 = Number(_bodyType.specSummary.minWidth) > Number(filter.bodySizeWidth.value);
                      break;
                    case '>=':
                      // isMatch = (Number(bodyType.specSummary.minWidth) >= Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) >= Number(filter.bodySizeWidth.value)) ? true : false;
                      _isMatch5 = Number(_bodyType.specSummary.minWidth) >= Number(filter.bodySizeWidth.value);
                      break;
                    default:
                      _isMatch5 = !!(Number(_bodyType.specSummary.minWidth) === Number(filter.bodySizeWidth.value) || Number(_bodyType.specSummary.maxWidth) === Number(filter.bodySizeWidth.value));
                  }
                  if (!_isMatch5) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                if (filter.bodySizeHeight != null && filter.bodySizeHeight.value != null && Number(filter.bodySizeHeight.value) > 0) {
                  var _operator6 = filter.bodySizeHeight.options[filter.bodySizeHeight.options.selectedIndex].dataset.operator;
                  var _isMatch6 = false;
                  if (_bodyType.specSummary == null || _bodyType.specSummary.minHeight == null || _bodyType.specSummary.maxHeight == null) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                  switch (_operator6) {
                    case '=':
                      _isMatch6 = !!(Number(_bodyType.specSummary.minHeight) === Number(filter.bodySizeHeight.value) || Number(_bodyType.specSummary.maxHeight) === Number(filter.bodySizeHeight.value));
                      break;
                    case '<':
                      // isMatch = (Number(bodyType.specSummary.minHeight) < Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) < Number(filter.bodySizeHeight.value)) ? true : false;
                      _isMatch6 = Number(_bodyType.specSummary.minHeight) < Number(filter.bodySizeHeight.value);
                      break;
                    case '<=':
                      // isMatch = (Number(bodyType.specSummary.minHeight) <= Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) <= Number(filter.bodySizeHeight.value)) ? true : false;
                      _isMatch6 = Number(_bodyType.specSummary.minHeight) <= Number(filter.bodySizeHeight.value);
                      break;
                    case '>':
                      // isMatch = (Number(bodyType.specSummary.minHeight) > Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) > Number(filter.bodySizeHeight.value)) ? true : false;
                      _isMatch6 = Number(_bodyType.specSummary.minHeight) > Number(filter.bodySizeHeight.value);
                      break;
                    case '>=':
                      // isMatch = (Number(bodyType.specSummary.minHeight) >= Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) >= Number(filter.bodySizeHeight.value)) ? true : false;
                      _isMatch6 = Number(_bodyType.specSummary.minHeight) >= Number(filter.bodySizeHeight.value);
                      break;
                    default:
                      _isMatch6 = !!(Number(_bodyType.specSummary.minHeight) === Number(filter.bodySizeHeight.value) || Number(_bodyType.specSummary.maxHeight) === Number(filter.bodySizeHeight.value));
                  }
                  if (!_isMatch6) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                // if( filter.othersSv != null && filter.othersSv.checked ){
                //   let isMatch = false;
                //   if(bodyType.grades != null && Array.isArray(bodyType.grades) && bodyType.grades.length > 0){
                //     let k = bodyType.grades.length;
                //     loopGrade:while(k--) {
                //       let grade = bodyType.grades[k];
                //       if(grade != null && grade.specialCar === true){
                //         isMatch = true;
                //         break loopGrade;
                //       }
                //     }
                //   }
                //   if(!isMatch){
                //     bodyTypes.splice(j, 1);
                //     continue loopBodyType;
                //   }
                // }
                // if (filter.othersSupportCar != null) {
                //   // ひとつのみ（配列ではない）
                //   if (isNaN(filter.othersSupportCar.length)) {
                //     if (bodyType.supportCar != null && !this.inArray(bodyType.supportCar, filter.othersSupportCar.value) && filter.othersSupportCar.checked) {
                //       bodyTypes.splice(j, 1)
                //       continue
                //     }
                //     if (bodyType.supportCar == null && filter.othersSupportCar.checked) {
                //       bodyTypes.splice(j, 1)
                //       continue
                //     }
                //   }
                //   // ふたつ以上（配列である）
                //   else {
                //     const len = filter.othersSupportCar.length
                //     let val = ''
                //     for (let l = 0; l < len; l++) {
                //       val = filter.othersSupportCar[l].value
                //       if (bodyType.supportCar != null && !this.inArray(bodyType.supportCar, val) && filter.othersSupportCar[l].checked) {
                //         bodyTypes.splice(j, 1)
                //         continue loopBodyType
                //       }
                //       if (bodyType.supportCar == null && filter.othersSupportCar.checked) {
                //         bodyTypes.splice(j, 1)
                //         continue loopBodyType
                //       }
                //     }
                //   }
                // }
                // 環境性能割 非課税
                if (filter.othersKankyowari != null && filter.othersKankyowari.checked) {
                  if (_bodyType.kankyowari !== true) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                // 重量税 減税
                if (filter.othersEcoTax != null && filter.othersEcoTax.checked) {
                  if (_bodyType.weightTaxRate == null || _bodyType.weightTaxRate === 0) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
                // グリーンディーゼル補助金
                if (filter.othersSubsidy != null && filter.othersSubsidy.checked) {
                  if (_bodyType.subsidy !== true) {
                    _bodyTypes.splice(_j, 1);
                    continue;
                  }
                }
              }
            }
          }
        }
      }

      // bodyTypesが[]であればmodelを削除する
      if (models && models.length > 0) {
        var _i3 = models.length;
        while (_i3--) {
          var _bodyTypes2 = models[_i3].bodyTypes;
          if (_bodyTypes2.length === 0) {
            models.splice(_i3, 1);
          }
        }
      }

      _this.setState({
        models: models
      });

      setTimeout(_this.setNamePlateHeight, 200);
    };

    _this.getFilterValue = function (form, name) {
      var value = null;

      if (form[name] == null) {
        return null;
      }

      // select
      if (form[name].type === 'select-one') {
        return form[name].value;
      }

      // radio
      for (var i = 0; i < form[name].length; i++) {
        if (form[name][i].checked) {
          value = form[name][i].value;
          return value;
        }
      }

      return value;
    };

    _this.onResize = function (e) {
      _this.setNamePlateHeight();
    };

    _this.setNamePlateHeight = function () {
      var cars = void 0;
      var namePlates = void 0;
      var namePlate = void 0;
      var namePlatesNum = void 0;
      var heights = [];
      var maxHeight = 0;
      var columnNum = void 0;

      cars = _this.refs.cars;

      if (!__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] || !cars) {
        return false;
      }

      columnNum = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */] ? 2 : 5;

      namePlates = cars.querySelectorAll('.CarLineup__Cars__Body__Item__List__Item--name__title');

      if (!namePlates) {
        return false;
      }

      namePlatesNum = namePlates.length;

      // 全ネームプレートの高さ取得＆初期化
      for (var i = 0; i < namePlatesNum; i++) {
        namePlate = namePlates[i];
        namePlate.style.height = ''; // リサイズイベントに対応するために初期化
        // heights[i] = namePlate.getBoundingClientRect().height;
        heights[i] = namePlate.offsetHeight;
      }

      if (_this.state.view !== 'Grid') {
        return false;
      }

      // 行ごとのネームプレートの高さを最大値に揃える
      for (var _i4 = 0; _i4 < namePlatesNum; _i4++) {
        if (_i4 % columnNum === 0) {
          maxHeight = 0;
        }
        if (heights[_i4] > maxHeight) {
          maxHeight = heights[_i4];
        }

        var j = _i4;
        do {
          heights[j] = maxHeight;
          if (j % columnNum === 0) {
            break;
          }
        } while (j--);
      }

      // ネームプレートの高さをセットする
      for (var _i5 = 0; _i5 < namePlatesNum; _i5++) {
        namePlate = namePlates[_i5];
        namePlate.style.height = heights[_i5] + 'px';
      }

      // console.log(heights)
    };

    _this.hasSpecialVehicle = function (carId) {
      var models = _this.props.models;

      if (models && Array.isArray(models) && models.length > 0) {
        var i = models.length;
        while (i--) {
          var bodyTypes = models[i].bodyTypes;
          if (bodyTypes && Array.isArray(bodyTypes) && bodyTypes.length > 0) {
            var j = bodyTypes.length;
            while (j--) {
              var bodyType = bodyTypes[j];
              if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
                var k = bodyType.grades.length;
                while (k--) {
                  var grade = bodyType.grades[k];
                  if (grade.specialCar === true && bodyType.carId === carId) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }

      return false;
    };

    _this.format = function (str) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(String(str).toLowerCase().split(' ').join('-'));
    };

    _this.inArray = function (array, val) {
      if (!Array.isArray(array)) {
        return false;
      }
      if (array.indexOf(val) >= 0) {
        return true;
      }

      return false;
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var _evt = document.createEvent('HTMLEvents');
        _evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return !element.dispatchEvent(_evt);
      }

      // IE
      var evt = document.createEventObject();
      return element.fireEvent('on' + event, evt);
    };

    _this.props = props;
    _this.state = {
      vehicle: 'Passenger Car',
      view: _this.props.narrowPassengerCarCategory ? 'List' : 'Grid', // Grid or List
      models: null
    };
    _this.tmpState = {
      vehicle: _this.state.vehicle,
      view: _this.state.view,
      filter: {}
    };
    _this.onChangeVehicle = _this.onChangeVehicle.bind(_this);
    _this.onChangeFilter = _this.onChangeFilter.bind(_this);
    _this.onResetFilter = _this.onResetFilter.bind(_this);

    _this.vehicleIntervalId;
    return _this;
  }

  CarLineup.prototype.componentWillUnmount = function componentWillUnmount() {};

  CarLineup.prototype.componentDidMount = function componentDidMount() {
    if (this.refs.filter) {
      var radios = this.refs.filter.querySelectorAll("input[type='radio']");
      for (var i = 0; i < radios.length; i++) {
        var label = radios[i].parentNode;
        label.onclick = this.onClickRadio;
        radios[i].addEventListener('change', this.onChangeRadio);
      }

      var checkboxes = this.refs.filter.querySelectorAll("input[type='checkbox']");
      for (var _i6 = 0; _i6 < checkboxes.length; _i6++) {
        checkboxes[_i6].addEventListener('change', this.onChangeCheckbox);
      }

      var selects = this.refs.filter.querySelectorAll('select');
      for (var _i7 = 0; _i7 < selects.length; _i7++) {
        selects[_i7].addEventListener('change', this.onChangeSelect);
      }
    }

    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].onresize = this.onResize;

    this.state = {
      vehicle: 'Passenger Car',
      view: this.props.narrowPassengerCarCategory ? 'List' : 'Grid',
      models: null
    };
    this.tmpState = {
      vehicle: this.state.vehicle,
      view: this.state.view,
      filter: {}
    };

    this.setDefaultState();

    this.applyFilter();

    if (!this.props.narrowPassengerCarCategory) {
      this.triggerEvent(this.refs.filter, 'reset');
    } else {
      setTimeout(this.applyFilter, 10);
    }

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   console.log('[EPiServer][preview] yes');
    // }
    // else{
    //   console.log('[EPiServer][preview] no');
    // }
  };

  CarLineup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        narrowPassengerCarCategory = _props.narrowPassengerCarCategory,
        passengerCarFilters = _props.passengerCarFilters,
        models = _props.models;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName, __source: {
          fileName: _jsxFileName,
          lineNumber: 202
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarLineup', ref: 'CarLineup', __source: {
            fileName: _jsxFileName,
            lineNumber: 207
          }
        },
        function () {
          var vehicles = _this2.getVehicleTabNames(models);

          if (vehicles) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { className: 'CarLineup__VehiclesForm' + (narrowPassengerCarCategory ? ' CarLineup__VehiclesForm--hide' : ''), name: 'vehiclesFilter', ref: 'vehiclesFilter', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 213
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'CarLineup__VehiclesForm__List', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 214
                  }
                },
                function () {
                  if (vehicles['Passenger Car'] && Array.isArray(vehicles['Passenger Car'])) {
                    return vehicles['Passenger Car'].map(function (name, index) {
                      {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__VehiclesForm__List__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 221
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'CarLineup__VehiclesForm__List__Item__Label', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 221
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Passenger Car', checked: _this2.state.vehicle === 'Passenger Car', onChange: _this2.onChangeVehicle, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 221
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'CarLineup__VehiclesForm__List__Item__Label__Text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 221
                                }
                              },
                              name
                            )
                          )
                        );
                      }
                    });
                  }
                }(),
                function () {
                  if (vehicles['Light Car'] && Array.isArray(vehicles['Light Car'])) {
                    return vehicles['Light Car'].map(function (name, index) {
                      {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__VehiclesForm__List__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 234
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'CarLineup__VehiclesForm__List__Item__Label', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 234
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Light Car', checked: _this2.state.vehicle === 'Light Car', onChange: _this2.onChangeVehicle, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 234
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'CarLineup__VehiclesForm__List__Item__Label__Text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 234
                                }
                              },
                              name
                            )
                          )
                        );
                      }
                    });
                  }
                }(),
                function () {
                  if (vehicles['Special Car'] && Array.isArray(vehicles['Special Car'])) {
                    return vehicles['Special Car'].map(function (name, index) {
                      {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__VehiclesForm__List__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 247
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'CarLineup__VehiclesForm__List__Item__Label', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 247
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Special Car', checked: _this2.state.vehicle === 'Special Car', onChange: _this2.onChangeVehicle, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 247
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'CarLineup__VehiclesForm__List__Item__Label__Text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 247
                                }
                              },
                              name
                            )
                          )
                        );
                      }
                    });
                  }
                }(),
                function () {
                  if (vehicles['Commercial Car'] && Array.isArray(vehicles['Commercial Car'])) {
                    return vehicles['Commercial Car'].map(function (name, index) {
                      {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__VehiclesForm__List__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 260
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'CarLineup__VehiclesForm__List__Item__Label', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 260
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Commercial Car', checked: _this2.state.vehicle === 'Commercial Car', onChange: _this2.onChangeVehicle, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 260
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'CarLineup__VehiclesForm__List__Item__Label__Text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 260
                                }
                              },
                              name
                            )
                          )
                        );
                      }
                    });
                  }
                }(),
                function () {
                  if (vehicles['Welfare Car'] && Array.isArray(vehicles['Welfare Car'])) {
                    return vehicles['Welfare Car'].map(function (name, index) {
                      {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__VehiclesForm__List__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 273
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            { className: 'CarLineup__VehiclesForm__List__Item__Label', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 273
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__VehiclesForm__List__Item__Label__Radio', type: 'radio', name: 'vehicle', value: 'Welfare Car', checked: _this2.state.vehicle === 'Welfare Car', onChange: _this2.onChangeVehicle, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 273
                              }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'CarLineup__VehiclesForm__List__Item__Label__Text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 273
                                }
                              },
                              name
                            )
                          )
                        );
                      }
                    });
                  }
                }()
              )
            );
          }
        }(),
        function () {
          if (!narrowPassengerCarCategory) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarLineup__View CarLineup__View--' + (_this2.state.vehicle === 'Passenger Car' ? 'show' : 'hide'), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 289
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarLineup__View__Refine', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 290
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'javascript:void(0)', onClick: _this2.onClickRefineOpen, className: 'CarLineup__View__Refine__Button', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 291
                    }
                  },
                  '\u7D5E\u8FBC\u6761\u4EF6'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarLineup__View__Container', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 293
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'CarLineup__View__Title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 294
                    }
                  },
                  '\u8868\u793A\u5207\u66FF'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'form',
                  { className: 'CarLineup__View__Form', name: 'viewFilter', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 295
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'CarLineup__View__Form__List', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 296
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarLineup__View__Form__List__Item CarLineup__View__Form__List__Item--Grid', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 297
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        { className: 'CarLineup__View__Form__List__Item__Label', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 297
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__View__Form__List__Item__Label__RadioButton', type: 'radio', name: 'view', value: 'Grid', checked: _this2.state.view === 'Grid', onChange: _this2.onChangeView, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 297
                          }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { className: 'CarLineup__View__Form__List__Item__Label__Text', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 297
                            }
                          },
                          'Grid'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarLineup__View__Form__List__Item CarLineup__View__Form__List__Item--List', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 298
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        { className: 'CarLineup__View__Form__List__Item__Label', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 298
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'CarLineup__View__Form__List__Item__Label__RadioButton', type: 'radio', name: 'view', value: 'List', checked: _this2.state.view === 'List', onChange: _this2.onChangeView, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 298
                          }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { className: 'CarLineup__View__Form__List__Item__Label__Text', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 298
                            }
                          },
                          'List'
                        )
                      )
                    )
                  )
                )
              )
            );
          }
        }(),
        function () {
          if (passengerCarFilters && !narrowPassengerCarCategory) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { className: 'CarLineup__FiltersForm CarLineup__FiltersForm--close CarLineup__FiltersForm--' + (_this2.state.vehicle === 'Passenger Car' ? 'show' : 'hide'), onChange: _this2.onChangeFilter, onReset: _this2.onResetFilter, name: 'carLineupFilter', ref: 'filter', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 310
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarLineup__FiltersForm__scroll', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 311
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'CarLineup__FiltersForm__Container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 312
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CarLineup__FiltersForm__Close', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 313
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { href: 'javascript:void(0)', onClick: _this2.onClickRefineClose, className: 'CarLineup__FiltersForm__Close__Button', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 314
                        }
                      },
                      'close'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CarLineup__FiltersForm__Title', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 316
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'CarLineup__FiltersForm__Title__Text', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 317
                        }
                      },
                      '\u7D5E\u8FBC\u6761\u4EF6'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CarLineup__FiltersForm__Reset CarLineup__FiltersForm__Reset--top', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 319
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'reset', value: '\u6761\u4EF6\u3092\u30EA\u30BB\u30C3\u30C8', className: 'CarLineup__FiltersForm__Reset__Button', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 320
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CarLineup__FiltersForm__Body', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 322
                      }
                    },
                    passengerCarFilters.map(function (data, index) {
                      var props = Object.assign({}, data.props);
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__car_lineup_filter__["a" /* default */], _extends({}, props, {
                        key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 327
                        }
                      }));
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CarLineup__FiltersForm__Reset CarLineup__FiltersForm__Reset--bottom', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 334
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'reset', value: '\u6761\u4EF6\u30EA\u30BB\u30C3\u30C8', className: 'CarLineup__FiltersForm__Reset__Button', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 335
                      }
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarLineup__FiltersForm__Submit', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 339
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'javascript:void(0)', onClick: _this2.onClickRefineSubmit, className: 'CarLineup__FiltersForm__Submit__Button', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 340
                    }
                  },
                  '\u6307\u5B9A\u3057\u305F\u6761\u4EF6\u3067\u7D5E\u8FBC\u3080'
                )
              )
            );
          }
        }(),
        function () {
          if (_this2.state.models && _this2.state.models.length !== 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'CarLineup__Cars' + ' CarLineup__Cars--' + _this2.state.view,
                ref: 'cars',
                onTransitionEnd: function onTransitionEnd(e) {
                  e.currentTarget.classList.remove('fadein');
                  e.currentTarget.style.opacity = '';
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 350
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'CarLineup__Cars__Heading', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 360
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--name', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 361
                    }
                  },
                  '\u540D\u79F0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 362
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 362
                      }
                    },
                    '\u539F\u52D5\u6A5F'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 362
                      }
                    },
                    '\uFF08\u30A8\u30F3\u30B8\u30F3\uFF09'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 362
                      }
                    },
                    '\u30BF\u30A4\u30D7'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--price', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 363
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 363
                      }
                    },
                    '\u4FA1\u683C'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 363
                      }
                    },
                    '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--supportCar', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 364
                    }
                  },
                  '\u30A8\u30B3\u30AB\u30FC'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--fuelEco', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 365
                    }
                  },
                  '\u71C3\u8CBB'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--passengers', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 366
                    }
                  },
                  '\u4E57\u8ECA\u4EBA\u6570'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--displacement', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 367
                    }
                  },
                  '\u6392\u6C17\u91CF'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--drive', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 368
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 368
                      }
                    },
                    '\u99C6\u52D5/'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 368
                      }
                    },
                    '\u30DF\u30C3\u30B7\u30E7\u30F3'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: 'CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--bodySize', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 369
                    }
                  },
                  '\u30DC\u30C7\u30A3\u30B5\u30A4\u30BA'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'CarLineup__Cars__Body', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 371
                  }
                },
                _this2.state.models.map(function (model, index) {
                  if (model.bodyTypes) {
                    return model.bodyTypes.map(function (bodyType, index) {
                      var carName = void 0;
                      var carCategory = void 0;
                      var carPrice = void 0;
                      var carImageSrc = void 0;
                      var carLinkUrl = void 0;

                      switch (_this2.state.vehicle) {
                        case 'Passenger Car':
                        case 'Light Car':
                          carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                          carName = carName || bodyType.carId;
                          carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                          carPrice = bodyType.minPrice ? bodyType.minPrice : null;
                          carImageSrc = '/globalassets/assets/cars/' + _this2.format(model.modelName) + '/' + _this2.format(bodyType.carId) + '/' + _this2.format(bodyType.carTypeCode) + '/common/default_s.png';
                          // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                          carLinkUrl = '/cars/' + _this2.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/?car_id=' + _this2.format(bodyType.carId);
                          break;
                        case 'Commercial Car':
                          carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                          carName = carName || bodyType.carId;
                          carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                          carPrice = null;
                          carImageSrc = '/globalassets/assets/cars/' + _this2.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/' + _this2.format(bodyType.carId) + '/' + _this2.format(bodyType.carTypeCode) + '/common/commercial_default_s.png';
                          carLinkUrl = '/cars/' + _this2.format(model.modelName) + '/';
                          break;
                        default:
                      }

                      if (_this2.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'CarLineup__Cars__Body__Item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 407
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'ul',
                            { className: 'CarLineup__Cars__Body__Item__List', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 408
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--name', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 409
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                {
                                  href: carLinkUrl,
                                  className: 'CarLineup__Cars__Body__Item__Link',
                                  onClick: _this2.onClickCarLink,
                                  'data-car_id': bodyType.carId, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 410
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 415
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: carImageSrc, alt: carName, className: 'CarLineup__Cars__Body__Item__List__Item--name__image', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 416
                                    }
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 418
                                    }
                                  },
                                  carName ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarLineup__Cars__Body__Item__List__Item--name__title', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(carName) }, __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 419
                                    }
                                  }) : null,
                                  carCategory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--name__category', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 420
                                      }
                                    },
                                    carCategory
                                  ) : null,
                                  carPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--name__price', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 421
                                      }
                                    },
                                    '\xA5',
                                    Number(carPrice).toLocaleString(),
                                    '\u301C\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                                  ) : null
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--engine', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 425
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 426
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 427
                                    }
                                  },
                                  '\u539F\u52D5\u6A5F\uFF08\u30A8\u30F3\u30B8\u30F3\uFF09\u30BF\u30A4\u30D7'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 429
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 430
                                    }
                                  },
                                  function () {
                                    if (bodyType.fuels && bodyType.fuels.length > 0) {
                                      bodyType.fuels.sort();
                                      return bodyType.fuels.map(function (fuel, index) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          { className: 'CarLineup__Cars__Body__Item__List__Item--engine__Item', key: index, __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 436
                                            }
                                          },
                                          fuel
                                        );
                                      });
                                    }
                                  }()
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--price', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 444
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 445
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 446
                                    }
                                  },
                                  '\u4FA1\u683C'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 448
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 449
                                    }
                                  },
                                  bodyType.minPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    {
                                      __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 450
                                      }
                                    },
                                    '\xA5',
                                    Number(bodyType.minPrice).toLocaleString(),
                                    '\u301C',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { className: 'tax', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 450
                                        }
                                      },
                                      '\uFF08\u7A0E\u8FBC\uFF09'
                                    )
                                  ) : null
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--supportCar', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 454
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 455
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 456
                                    }
                                  },
                                  '\u30A8\u30B3\u30AB\u30FC'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 458
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 459
                                    }
                                  },
                                  bodyType.kankyowari && bodyType.kankyowari === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--supportCar__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 460
                                      }
                                    },
                                    '\u74B0\u5883\u6027\u80FD\u5272 \u975E\u8AB2\u7A0E'
                                  ) : null,
                                  bodyType.subsidy && bodyType.subsidy === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--supportCar__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 462
                                      }
                                    },
                                    'CEV\u88DC\u52A9\u91D1'
                                  ) : null,
                                  function () {
                                    if (bodyType.weightTaxRate == null || bodyType.weightTaxRate === 0) {
                                      return null;
                                    } else if (bodyType.weightTaxRate === 100) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--supportCar__Item', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 467
                                          }
                                        },
                                        '\u91CD\u91CF\u7A0E \u514D\u7A0E'
                                      );
                                    } else if (bodyType.weightTaxRate < 100) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--supportCar__Item', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 469
                                          }
                                        },
                                        '\u91CD\u91CF\u7A0E \u6E1B\u7A0E'
                                      );
                                    }
                                  }()
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--fuelEco', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 475
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 476
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 477
                                    }
                                  },
                                  '\u71C3\u8CBB'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 479
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 480
                                    }
                                  },
                                  function () {
                                    if (bodyType.specSummary && bodyType.specSummary.minWLTC && bodyType.specSummary.minWLTC > 0 && bodyType.specSummary.maxWLTC && bodyType.specSummary.maxWLTC > 0 && bodyType.specSummary.minWLTC === bodyType.specSummary.maxWLTC) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 488
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          { className: 'CarLineup__Cars__Body__Item__List__Item--fuelEco__Title', __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 489
                                            }
                                          },
                                          'WLTC\u30E2\u30FC\u30C9'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 490
                                            }
                                          },
                                          bodyType.specSummary.minWLTC
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 491
                                            }
                                          },
                                          'km/L'
                                        )
                                      );
                                    }

                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                      {
                                        __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 497
                                        }
                                      },
                                      bodyType.specSummary && (bodyType.specSummary.minWLTC || bodyType.specSummary.maxWLTC) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--fuelEco__Title', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 498
                                          }
                                        },
                                        'WLTC\u30E2\u30FC\u30C9'
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.minWLTC && bodyType.specSummary.minWLTC > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 499
                                          }
                                        },
                                        bodyType.specSummary.minWLTC
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.maxWLTC && bodyType.specSummary.maxWLTC > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 500
                                          }
                                        },
                                        '\u301C',
                                        bodyType.specSummary.maxWLTC
                                      ) : null,
                                      bodyType.specSummary && (bodyType.specSummary.minWLTC || bodyType.specSummary.maxWLTC) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 501
                                          }
                                        },
                                        'km/L'
                                      ) : null
                                    );
                                  }(),
                                  function () {
                                    if (bodyType.specSummary && bodyType.specSummary.minJC08 && bodyType.specSummary.minJC08 > 0 && bodyType.specSummary.maxJC08 && bodyType.specSummary.maxJC08 > 0 && bodyType.specSummary.minJC08 === bodyType.specSummary.maxJC08) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 512
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          { className: 'CarLineup__Cars__Body__Item__List__Item--fuelEco__Title', __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 513
                                            }
                                          },
                                          'JC08\u30E2\u30FC\u30C9'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 514
                                            }
                                          },
                                          bodyType.specSummary.minJC08
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 515
                                            }
                                          },
                                          'km/L'
                                        )
                                      );
                                    }

                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                      {
                                        __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 521
                                        }
                                      },
                                      bodyType.specSummary && (bodyType.specSummary.minJC08 || bodyType.specSummary.maxJC08) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--fuelEco__Title', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 522
                                          }
                                        },
                                        'JC08\u30E2\u30FC\u30C9'
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.minJC08 && bodyType.specSummary.minJC08 > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 523
                                          }
                                        },
                                        bodyType.specSummary.minJC08
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.maxJC08 && bodyType.specSummary.maxJC08 > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 524
                                          }
                                        },
                                        '\u301C',
                                        bodyType.specSummary.maxJC08
                                      ) : null,
                                      bodyType.specSummary && (bodyType.specSummary.minJC08 || bodyType.specSummary.maxJC08) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 525
                                          }
                                        },
                                        'km/L'
                                      ) : null
                                    );
                                  }()
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                                __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 531
                                }
                              })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--passengers', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 533
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 534
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 535
                                    }
                                  },
                                  '\u4E57\u8ECA\u4EBA\u6570'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 537
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 538
                                    }
                                  },
                                  bodyType.specSummary && bodyType.specSummary.passengers && Array.isArray(bodyType.specSummary.passengers) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    {
                                      __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 539
                                      }
                                    },
                                    bodyType.specSummary.passengers.join(' | '),
                                    '\u540D'
                                  ) : null
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--displacement', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 543
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 544
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 545
                                    }
                                  },
                                  '\u6392\u6C17\u91CF'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 547
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 548
                                    }
                                  },
                                  function () {
                                    if (bodyType.specSummary && bodyType.specSummary.minDisplacement && bodyType.specSummary.minDisplacement > 0 && bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0 && bodyType.specSummary.minDisplacement === bodyType.specSummary.maxDisplacement) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 556
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 557
                                            }
                                          },
                                          Number(bodyType.specSummary.minDisplacement).toLocaleString()
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 558
                                            }
                                          },
                                          'L'
                                        )
                                      );
                                    }

                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                      {
                                        __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 564
                                        }
                                      },
                                      bodyType.specSummary && bodyType.specSummary.minDisplacement && bodyType.specSummary.minDisplacement > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 565
                                          }
                                        },
                                        Number(bodyType.specSummary.minDisplacement).toLocaleString()
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'tilde', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 566
                                          }
                                        },
                                        '\u301C'
                                      ) : null,
                                      bodyType.specSummary && bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 567
                                          }
                                        },
                                        Number(bodyType.specSummary.maxDisplacement).toLocaleString()
                                      ) : null,
                                      bodyType.specSummary && (bodyType.specSummary.minDisplacement || bodyType.specSummary.maxDisplacement) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 568
                                          }
                                        },
                                        'L'
                                      ) : null
                                    );
                                  }()
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--drive', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 575
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 576
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 577
                                    }
                                  },
                                  '\u99C6\u52D5/\u30DF\u30C3\u30B7\u30E7\u30F3'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 579
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 580
                                    }
                                  },
                                  bodyType.drives ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--drive__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 581
                                      }
                                    },
                                    Array.isArray(bodyType.drives) ? bodyType.drives.sort().join('/') : null
                                  ) : null,
                                  bodyType.transmissions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--drive__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 582
                                      }
                                    },
                                    Array.isArray(bodyType.transmissions) ? bodyType.transmissions.sort().join('/') : null
                                  ) : null
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--bodySize', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 586
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 587
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'span',
                                  {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 588
                                    }
                                  },
                                  '\u30DC\u30C7\u30A3\u30B5\u30A4\u30BA'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 590
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item__dd__wrap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 591
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--bodySize__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 592
                                      }
                                    },
                                    function () {
                                      if (bodyType.specSummary && bodyType.specSummary.minLength && bodyType.specSummary.maxLength && bodyType.specSummary.minLength === bodyType.specSummary.maxLength) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 600
                                            }
                                          },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 601
                                              }
                                            },
                                            '\u5168\u9577\uFF1A'
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 602
                                              }
                                            },
                                            Number(bodyType.specSummary.minLength).toLocaleString()
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 603
                                              }
                                            },
                                            'mm'
                                          )
                                        );
                                      }

                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 609
                                          }
                                        },
                                        bodyType.specSummary && (bodyType.specSummary.minLength || bodyType.specSummary.maxLength) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 610
                                            }
                                          },
                                          '\u5168\u9577\uFF1A'
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.minLength ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 611
                                            }
                                          },
                                          Number(bodyType.specSummary.minLength).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.maxLength ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 612
                                            }
                                          },
                                          '\u301C',
                                          Number(bodyType.specSummary.maxLength).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && (bodyType.specSummary.minLength || bodyType.specSummary.maxLength) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 613
                                            }
                                          },
                                          'mm'
                                        ) : null
                                      );
                                    }()
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--bodySize__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 618
                                      }
                                    },
                                    function () {
                                      if (bodyType.specSummary && bodyType.specSummary.minWidth && bodyType.specSummary.maxWidth && bodyType.specSummary.minWidth === bodyType.specSummary.maxWidth) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 626
                                            }
                                          },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 627
                                              }
                                            },
                                            '\u5168\u5E45\uFF1A'
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 628
                                              }
                                            },
                                            Number(bodyType.specSummary.minWidth).toLocaleString()
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 629
                                              }
                                            },
                                            'mm'
                                          )
                                        );
                                      }

                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 635
                                          }
                                        },
                                        bodyType.specSummary && (bodyType.specSummary.minWidth || bodyType.specSummary.maxWidth) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 636
                                            }
                                          },
                                          '\u5168\u5E45\uFF1A'
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.minWidth ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 637
                                            }
                                          },
                                          Number(bodyType.specSummary.minWidth).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.maxWidth ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 638
                                            }
                                          },
                                          '\u301C',
                                          Number(bodyType.specSummary.maxWidth).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && (bodyType.specSummary.minWidth || bodyType.specSummary.maxWidth) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 639
                                            }
                                          },
                                          'mm'
                                        ) : null
                                      );
                                    }()
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'CarLineup__Cars__Body__Item__List__Item--bodySize__Item', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 644
                                      }
                                    },
                                    function () {
                                      if (bodyType.specSummary && bodyType.specSummary.minHeight && bodyType.specSummary.maxHeight && bodyType.specSummary.minHeight === bodyType.specSummary.maxHeight) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 652
                                            }
                                          },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 653
                                              }
                                            },
                                            '\u5168\u9AD8\uFF1A'
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 654
                                              }
                                            },
                                            Number(bodyType.specSummary.minHeight).toLocaleString()
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 655
                                              }
                                            },
                                            'mm'
                                          )
                                        );
                                      }

                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 661
                                          }
                                        },
                                        bodyType.specSummary && (bodyType.specSummary.minHeight || bodyType.specSummary.maxHeight) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 662
                                            }
                                          },
                                          '\u5168\u9AD8\uFF1A'
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.minHeight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 663
                                            }
                                          },
                                          Number(bodyType.specSummary.minHeight).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && bodyType.specSummary.maxHeight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 664
                                            }
                                          },
                                          '\u301C',
                                          Number(bodyType.specSummary.maxHeight).toLocaleString()
                                        ) : null,
                                        bodyType.specSummary && (bodyType.specSummary.minHeight || bodyType.specSummary.maxHeight) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'span',
                                          {
                                            __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 665
                                            }
                                          },
                                          'mm'
                                        ) : null
                                      );
                                    }()
                                  )
                                )
                              )
                            )
                          )
                        );
                      } else if (_this2.state.vehicle.match(/Special Car|Welfare Car/)) {
                        if (bodyType.grades) {
                          return bodyType.grades.map(function (grade, index) {
                            switch (_this2.state.vehicle) {
                              case 'Special Car':
                                carName = grade && grade.gradeName ? grade.gradeName : null;
                                carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                                carPrice = grade && grade.minPrice ? grade.minPrice : null;
                                carImageSrc = '/globalassets/assets/cars/' + _this2.format(model.modelName) + '/' + _this2.format(bodyType.carId) + '/' + _this2.format(bodyType.carTypeCode) + '/' + _this2.format(grade.gradeId) + '/common/' + _this2.format(grade.gradeId) + '_default_s.png';
                                // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                                carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                                break;
                              case 'Welfare Car':
                                carName = grade && grade.gradeName ? grade.gradeName : null;
                                carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null;
                                carPrice = null;
                                carImageSrc = '/globalassets/assets/cars/' + _this2.format(model.modelName) + '/' + _this2.format(bodyType.carId) + '/' + _this2.format(bodyType.carTypeCode) + '/' + _this2.format(grade.gradeId) + '/common/welfare_' + _this2.format(grade.gradeId) + '_default_s.png';
                                // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                                carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                                break;
                              default:
                            }

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'CarLineup__Cars__Body__Item', key: index, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 702
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'ul',
                                { className: 'CarLineup__Cars__Body__Item__List', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 703
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'li',
                                  { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--name', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 704
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    {
                                      href: carLinkUrl,
                                      className: 'CarLineup__Cars__Body__Item__Link' + (!carLinkUrl ? ' CarLineup__Cars__Body__Item__Link--disabled' : ''),
                                      onClick: _this2.onClickCarLink,
                                      'data-car_id': bodyType.carId,
                                      'data-grade_id': grade.gradeId,
                                      disabled: !carLinkUrl ? 'disabled' : null, __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 705
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'div',
                                      { className: 'CarLineup__Cars__Body__Item__List__Item__dd', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 712
                                        }
                                      },
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: carImageSrc, alt: carName, className: 'CarLineup__Cars__Body__Item__List__Item--name__image', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 713
                                        }
                                      })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'div',
                                      { className: 'CarLineup__Cars__Body__Item__List__Item__dt', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 715
                                        }
                                      },
                                      carName ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarLineup__Cars__Body__Item__List__Item--name__title', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(carName) }, __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 716
                                        }
                                      }) : null,
                                      carCategory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--name__category', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 717
                                          }
                                        },
                                        carCategory
                                      ) : null,
                                      carPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'CarLineup__Cars__Body__Item__List__Item--name__price', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 718
                                          }
                                        },
                                        '\xA5',
                                        Number(carPrice).toLocaleString(),
                                        '\u301C\uFF08\u7A0E\u8FBC\uFF09'
                                      ) : null
                                    )
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--engine', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 722
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--price', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 723
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--supportCar', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 724
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--fuelEco', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 725
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--passengers', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 726
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--displacement', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 727
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--drive', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 728
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--bodySize', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 729
                                  }
                                })
                              )
                            );
                          });
                        }
                      }
                    });
                  }
                })
              )
            );
          } else if (_this2.state.models && _this2.state.models.length === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'CarLineup__Cars' + ' CarLineup__Cars--' + _this2.state.view,
                ref: 'cars',
                onTransitionEnd: function onTransitionEnd(e) {
                  e.currentTarget.classList.remove('fadein');
                  e.currentTarget.style.opacity = '';
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 747
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarLineup__Cars__noResult', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 757
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 758
                    }
                  },
                  '\u8A72\u5F53\u3059\u308B\u8ECA\u304C\u3042\u308A\u307E\u305B\u3093\u3002',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { className: 'br', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 758
                    }
                  }),
                  '\u6761\u4EF6\u3092\u5909\u3048\u3066\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044\u3002'
                )
              )
            );
          }
        }()
      )
    );
  };

  return CarLineup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  narrowPassengerCarCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  passengerCarFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    modelNameJa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vehicleType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vehicleTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      fuels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      fuelTabNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      drives: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      transmissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      minPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      maxPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      specSummary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        minWLTC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxWLTC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minJC08: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxJC08: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        passengers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
        minDisplacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxDisplacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        maxHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      }),
      acquisitionTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      weightTaxRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      taxCut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      subsidy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      supportCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      grades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        specialCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        welfareCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        welfareCarTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        welfareCarTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        specialCarDefaultGrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        welfareCarDefaultGrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        carLineupUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
      }))
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  narrowPassengerCarCategory: null,
  passengerCarFilters: null,
  models: null
}, _temp);
CarLineup.displayName = 'CarLineup';


/* harmony default export */ __webpack_exports__["a"] = (CarLineup);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_estimate_link__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\credit-plan\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 *  BodySize
 */
var CreditPlan = (_temp = _class = function (_Component) {
  _inherits(CreditPlan, _Component);

  function CreditPlan(props) {
    _classCallCheck(this, CreditPlan);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.openModal = function (ref) {
      _this.refs[ref].open('Light', 'Light');
      // BODYのスクロール無効化
      //BodyControl.openModal();
    };

    _this.onCloseModal = function () {
      // BODYのスクロール無効化を解除
      //BodyControl.closeModal();
    };

    _this.formatPrice = function (num) {
      return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    _this.props = props;
    _this.state = {};
    _this.modalWindowRefs = [];
    return _this;
  }

  CreditPlan.prototype.componentDidMount = function componentDidMount() {};

  CreditPlan.prototype.componentWillUnmount = function componentWillUnmount() {};

  CreditPlan.prototype.render = function render() {
    var _this2 = this;

    this.modalWindowRefs = [];

    // ヘッダー表示
    var renderHeader = function renderHeader() {

      var getHeader = function getHeader() {
        if (_this2.props.titleAndDescription && _this2.props.titleAndDescription !== '') {
          return _this2.props.titleAndDescription;
        } else {
          return '';
        }
      };
      var getMbHeader = function getMbHeader() {
        if (_this2.props.mbTitleAndDescription && _this2.props.mbTitleAndDescription !== '') {
          return _this2.props.mbTitleAndDescription;
        } else {
          return getHeader();
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CreditPlan__header Wysiwyg', __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'CreditPlan__header-pc', dangerouslySetInnerHTML: { __html: getHeader() }, __source: {
            fileName: _jsxFileName,
            lineNumber: 133
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'CreditPlan__header-mb', dangerouslySetInnerHTML: { __html: getMbHeader() }, __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        })
      );
    };

    // 車種情報表示
    var renderCarInfo = function renderCarInfo() {

      var getImages = function getImages() {
        if (_this2.props.images && _this2.props.images instanceof Array && 1 <= _this2.props.images.length) {
          return _this2.props.images;
        } else {
          return null;
        }
      };
      var getMbImages = function getMbImages() {
        if (_this2.props.mbImages && _this2.props.mbImages instanceof Array && 1 <= _this2.props.mbImages.length) {
          return _this2.props.mbImages;
        } else {
          return getImages();
        }
      };

      // BodyType表示
      var renderBodyType = function renderBodyType() {
        if (_this2.props.hideBodyTypeModelName === true) return null;
        //
        if (_this2.props.bodyType.bodyTypeModel && _this2.props.bodyType.bodyTypeModel !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'CreditPlan__car-info__body-type', __source: {
                fileName: _jsxFileName,
                lineNumber: 163
              }
            },
            _this2.props.bodyType.bodyTypeModel
          );
        } else {
          return null;
        }
      };

      // Grade表示
      var renderGrade = function renderGrade() {
        //
        var getGradeName = function getGradeName() {
          var gradeInfo = _this2.props.bodyType.carType.grade;
          if (gradeInfo.specialCar === true) {
            return gradeInfo.gradeId;
          } else {
            if (gradeInfo.gradeName && gradeInfo.gradeName !== '') {
              return gradeInfo.gradeName;
            } else {
              return gradeInfo.gradeId;
            }
          }
        };
        //
        if (_this2.props.hideGradeDriveAndMission === true) return null;
        //
        if (_this2.props.bodyType.carType) {
          if (_this2.props.bodyType.carType.grade) {
            if (_this2.props.bodyType.carType.grade.gradeId && _this2.props.bodyType.carType.grade.gradeId !== '') {
              if (_this2.props.bodyType.carType.grade.variant) {
                if (_this2.props.bodyType.carType.grade.variant.drive && _this2.props.bodyType.carType.grade.variant.drive !== '' && _this2.props.bodyType.carType.grade.variant.transmission && _this2.props.bodyType.carType.grade.variant.transmission !== '') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CreditPlan__car-info__grade', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 194
                      }
                    },
                    getGradeName() + '(' + _this2.props.bodyType.carType.grade.variant.drive + ' ' + _this2.props.bodyType.carType.grade.variant.transmission + ')'
                  )
                  // <span className="CreditPlan__car-info__grade">{((this.props.bodyType.carType.grade.gradeName && this.props.bodyType.carType.grade.gradeName !== '') ? this.props.bodyType.carType.grade.gradeName : this.props.bodyType.carType.grade.gradeId) + '(' + this.props.bodyType.carType.grade.variant.drive + ' ' + this.props.bodyType.carType.grade.variant.transmission + ')'}</span>
                  ;
                }
              }
            }
          }
        }
        return null;
      };

      // Engine表示
      var renderEngine = function renderEngine() {
        if (_this2.props.hideEngineName === true) return null;
        //
        if (_this2.props.bodyType.carType) {
          if (_this2.props.bodyType.carType.grade) {
            if (_this2.props.bodyType.carType.grade.engine) {
              if (_this2.props.bodyType.carType.grade.engine.fuel && _this2.props.bodyType.carType.grade.engine.fuel !== '') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CreditPlan__car-info__engine', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 214
                    }
                  },
                  _this2.props.bodyType.carType.grade.engine.fuel
                );
              }
            }
          }
        }
        return null;
      };
      // const renderEngine = ()=> {
      //   if (this.props.hideEngineName === true) return null;
      //   //
      //   if (this.props.bodyType.carType) {
      //     if (this.props.bodyType.carType.grade) {
      //       if (this.props.bodyType.carType.grade.variant) {
      //         if (this.props.bodyType.carType.grade.variant.engine && this.props.bodyType.carType.grade.variant.engine !== '') {
      //           return (
      //             <span className="CreditPlan__car-info__engine">{this.props.bodyType.carType.grade.variant.engine}</span>
      //           )
      //         }
      //       }
      //     }
      //   }
      //   return null;
      // };

      // Price表示
      var renderPrice = function renderPrice() {
        if (_this2.props.hidePrice === true) return null;
        //
        if (_this2.props.bodyType.carType) {
          if (_this2.props.bodyType.carType.grade) {
            if (_this2.props.bodyType.carType.grade.variant) {
              if (_this2.props.bodyType.carType.grade.variant.price && _this2.props.bodyType.carType.grade.variant.price !== '') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'CreditPlan__car-info__price', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 248
                    }
                  },
                  '\u8ECA\u4E21\u672C\u4F53\u4FA1\u683C\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09',
                  _this2.formatPrice(_this2.props.bodyType.carType.grade.variant.price)
                );
              }
            }
          }
        }
        return null;
      };

      if (_this2.props.bodyType) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CreditPlan__car-info', __source: {
              fileName: _jsxFileName,
              lineNumber: 259
            }
          },
          renderBodyType(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CreditPlan__car-info__box', __source: {
                fileName: _jsxFileName,
                lineNumber: 263
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'CreditPlan__car-info__paragraph', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 265
                }
              },
              renderGrade(),
              renderEngine()
            ),
            renderPrice()
          ),
          getImages() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CreditPlan__car-info__images-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 278
              }
            },
            getImages()
          ) : null,
          getMbImages() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CreditPlan__car-info__images-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 284
              }
            },
            getMbImages()
          ) : null
        );
      } else {
        return null;
      }
    };

    // クレジット情報表示
    var renderCreditData = function renderCreditData() {

      // 各クレジット情報表示
      var renderCreditDataInfo = function renderCreditDataInfo(vehicleCreditData, index) {

        // クレジットタイトル表示
        var renderCreditDataHeading = function renderCreditDataHeading() {

          var getPlanName = function getPlanName() {
            if (vehicleCreditData.planName && vehicleCreditData.planName !== '') {
              return vehicleCreditData.planName;
            } else {
              return null;
            }
          };

          var getMbPlanName = function getMbPlanName() {
            if (vehicleCreditData.mbPlanName && vehicleCreditData.mbPlanName !== '') {
              return vehicleCreditData.mbPlanName;
            } else {
              return getPlanName();
            }
          };

          var planName = getPlanName();
          var mbPlanName = getMbPlanName();
          if (_this2.props.titleHeader && _this2.props.titleHeader !== '' && planName) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              { className: 'CreditPlan__credit-data__heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 325
                }
              },
              _this2.props.titleHeader,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CreditPlan__credit-data__heading-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(planName) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 327
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CreditPlan__credit-data__heading-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(mbPlanName) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 328
                }
              })
            );
          }
        };

        // 上部クレジット情報表示
        var renderLargeItems = function renderLargeItems() {
          if (vehicleCreditData.largeItems && vehicleCreditData.largeItems instanceof Array && 1 <= vehicleCreditData.largeItems.length) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CreditPlan__credit-data__large-item', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 338
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CreditPlan__credit-data__large-item__items', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 339
                  }
                },
                vehicleCreditData.largeItems.map(function (largeItems, index) {
                  if (index < 3) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dl',
                      { className: 'CreditPlan__credit-data__large-item__item', key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 343
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dt',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 344
                          }
                        },
                        largeItems.title ? largeItems.title : ''
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dd',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 345
                          }
                        },
                        largeItems.data ? largeItems.data : ''
                      )
                    );
                  } else {
                    return null;
                  }
                })
              )
            );
          } else {
            return null;
          }
        };

        // 下部クレジット情報表示
        var renderSmallItems = function renderSmallItems() {

          var renderSmallItem = function renderSmallItem(smallItem, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dl',
              { className: 'CreditPlan__credit-data__small-item__item', key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 365
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dt',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 366
                  }
                },
                smallItem.title ? smallItem.title : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dd',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 367
                  }
                },
                smallItem.data ? smallItem.data : ''
              )
            );
          };

          if (vehicleCreditData.smallItems && vehicleCreditData.smallItems instanceof Array && 1 <= vehicleCreditData.smallItems.length) {

            var length = vehicleCreditData.smallItems.length;
            if (10 < length) length = 10;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CreditPlan__credit-data__small-item', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 378
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CreditPlan__credit-data__small-item__items', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 379
                  }
                },
                vehicleCreditData.smallItems.map(function (smallItem, index) {
                  if (index < 10) {
                    if (index + 1 <= Math.ceil(length / 2)) {
                      return renderSmallItem(smallItem, index);
                    } else {
                      return null;
                    }
                  } else {
                    return null;
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CreditPlan__credit-data__small-item__items', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 394
                  }
                },
                vehicleCreditData.smallItems.map(function (smallItem, index) {
                  if (index < 10) {
                    if (Math.ceil(length / 2) < index + 1) {
                      return renderSmallItem(smallItem, index);
                    } else {
                      return null;
                    }
                  } else {
                    return null;
                  }
                })
              )
            );
          } else {
            return null;
          }
        };

        // 注釈表示
        var renderNote = function renderNote() {

          var renderDescription = function renderDescription() {
            if (vehicleCreditData.description && vehicleCreditData.description !== '') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CreditPlan__credit-data__note__description Wysiwyg', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 422
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: vehicleCreditData.description }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 423
                  }
                })
              );
            } else {
              return null;
            }
          };

          var renderMoreInfo = function renderMoreInfo() {
            if (vehicleCreditData.moreInfo && vehicleCreditData.moreInfo !== '') {
              var ref = 'modalWindow' + index;
              _this2.modalWindowRefs.push(ref);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CreditPlan__credit-data__note__more-info', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 436
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'CreditPlan__credit-data__note__more-info__link',
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.openModal(ref);
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 437
                    }
                  },
                  vehicleCreditData.moreInfoLink ? vehicleCreditData.moreInfoLink : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__components_modal_window__["a" /* default */],
                  { ref: ref, type: 'Light', onClose: _this2.onCloseModal, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 444
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'CreditPlan__credit-data__note__more-info__container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 445
                      }
                    },
                    vehicleCreditData.moreInfo && vehicleCreditData.moreInfo instanceof Array && 1 <= vehicleCreditData.moreInfo.length ? Object(__WEBPACK_IMPORTED_MODULE_8__utilities__["c" /* getComponents */])(vehicleCreditData.moreInfo) : null
                  )
                )
              );
            } else {
              return null;
            }
          };

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CreditPlan__credit-data__note', __source: {
                fileName: _jsxFileName,
                lineNumber: 460
              }
            },
            renderDescription(),
            renderMoreInfo()
          );
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'CreditPlan__credit-data', key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 469
            }
          },
          renderCreditDataHeading(),
          renderLargeItems(),
          renderSmallItems(),
          renderNote()
        );
      };

      if (_this2.props.bodyType.carType) {
        if (_this2.props.bodyType.carType.grade) {
          if (_this2.props.bodyType.carType.grade.variant) {
            if (_this2.props.bodyType.carType.grade.variant.vehicleCreditData && _this2.props.bodyType.carType.grade.variant.vehicleCreditData instanceof Array && 1 <= _this2.props.bodyType.carType.grade.variant.vehicleCreditData.length) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 488
                  }
                },
                _this2.props.bodyType.carType.grade.variant.vehicleCreditData.map(function (vehicleCreditData, index) {
                  return renderCreditDataInfo(vehicleCreditData, index);
                })
              );
            }
          }
        }
      }
      return null;
    };

    // ナビゲーション表示
    var renderNavigation = function renderNavigation() {

      var getEstimationHeading = function getEstimationHeading() {
        if (_this2.props.estimationTitle && _this2.props.estimationTitle !== '') {
          return _this2.props.estimationTitle;
        } else {
          return null;
        }
      };
      var getMbEstimationHeading = function getMbEstimationHeading() {
        if (_this2.props.mbEstimationTitle && _this2.props.mbEstimationTitle !== '') {
          return _this2.props.mbEstimationTitle;
        } else {
          return getEstimationHeading();
        }
      };

      // 見積シミュレーションリンク表示
      var renderEstimationLink = function renderEstimationLink() {
        if (_this2.props.estimationLinkLabel && _this2.props.estimationLinkLabel !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CreditPlan__navigation__estimation-link', __source: {
                fileName: _jsxFileName,
                lineNumber: 523
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_estimate_link__["a" /* default */], _extends({
              label: _this2.props.estimationLinkLabel || '見積りシミュレーションする',
              targetBlank: false,
              color: 'Dark',
              buttonStyle: 'Action',
              linkType: 'Button',
              carId: _this2.props.bodyType.carId,
              carTypeCode: _this2.props.bodyType.carType.carTypeCode
            }, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 524
              }
            }))
          );
        } else {
          return null;
        }
      };

      var estimationHeading = getEstimationHeading();
      var mbEstimationHeading = getMbEstimationHeading();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CreditPlan__navigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 544
          }
        },
        estimationHeading !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h6',
          { className: 'CreditPlan__navigation__heading', __source: {
              fileName: _jsxFileName,
              lineNumber: 546
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CreditPlan__navigation__heading-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(estimationHeading) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 547
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CreditPlan__navigation__heading-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(mbEstimationHeading) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 548
            }
          })
        ) : null,
        renderEstimationLink(),
        _this2.props.lowerInformation && _this2.props.lowerInformation !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'CreditPlan__navigation__lower-information Wysiwyg', dangerouslySetInnerHTML: { __html: _this2.props.lowerInformation }, __source: {
            fileName: _jsxFileName,
            lineNumber: 555
          }
        }) : null
      );
    };

    var tableStyle = null;
    if (this.props.tableColorSelector && this.props.tableColorSelector === 'Table-on-White') {
      tableStyle = ' tableOnWhite';
    } else if (this.props.tableColorSelector && this.props.tableColorSelector === 'Table-on-Gray') {
      tableStyle = ' tableOnGray';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 569
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CreditPlan' + (tableStyle ? tableStyle : ''), __source: {
            fileName: _jsxFileName,
            lineNumber: 575
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CreditPlan__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 576
            }
          },
          renderHeader(),
          renderCarInfo(),
          renderCreditData(),
          renderNavigation()
        )
      )
    );
  };

  // モーダルウィンドウ開く


  // 金額フォーマット


  return CreditPlan;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  titleAndDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitleAndDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideBodyTypeModelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideGradeDriveAndMission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideEngineName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hidePrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  mbImages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  titleHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  estimationTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbEstimationTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  estimationLinkLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lowerInformation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tableColorSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      grade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        specialCar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          fuel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        }),
        variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          transmission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
          vehicleCreditData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            planName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            mbPlanName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            moreInfoLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            moreInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
            largeItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
              title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
              data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
            })),
            smallItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
              title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
              data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
            }))
          }))
        })
      })
    })
  })
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  titleAndDescription: null,
  mbTitleAndDescription: null,
  hideBodyTypeModelName: null,
  hideGradeDriveAndMission: null,
  hideEngineName: null,
  hidePrice: null,
  images: null,
  mbImages: null,
  titleHeader: null,
  estimationTitle: null,
  mbEstimationTitle: null,
  estimationLinkLabel: null,
  lowerInformation: null,
  tableColorSelector: null,
  modelName: null,
  bodyType: null
}, _temp);
CreditPlan.displayName = 'CreditPlan';


/* harmony default export */ __webpack_exports__["a"] = (CreditPlan);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accordion_item__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accordion-container\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  AccordionContainer
 */
var AccordionContainer = (_temp = _class = function (_Component) {
  _inherits(AccordionContainer, _Component);

  function AccordionContainer(props) {
    _classCallCheck(this, AccordionContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  AccordionContainer.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        pcText = _props.pcText,
        mbText = _props.mbText,
        items = _props.items,
        color = _props.color;


    var containerPcText = void 0,
        containerMbText = void 0;
    containerPcText = pcText != null && pcText !== '' ? pcText : '';
    containerMbText = mbText != null && mbText !== '' ? mbText : pcText != null && pcText !== '' ? pcText : '';

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AccordionContainer', __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AccordionContainer__container AccordionContainer__container--' + color, __source: {
              fileName: _jsxFileName,
              lineNumber: 63
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: "AccordionContainer__container__title", __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            },
            containerPcText && containerPcText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(containerPcText) },
              className: 'AccordionContainer__container__title__text--pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 65
              }
            }) : null,
            containerMbText && containerMbText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(containerMbText) },
              className: 'AccordionContainer__container__title__text--mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: "AccordionContainer__container__list", __source: {
                fileName: _jsxFileName,
                lineNumber: 70
              }
            },
            items.map(function (item, index) {
              var itemPcText = void 0,
                  itemMbText = void 0;
              itemPcText = item.props.pcText;
              itemMbText = item.props.mbText;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                {
                  key: index,
                  ref: 'item' + index,
                  className: "AccordionContainer__container__list__item",
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 76
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: "AccordionContainer__container__list__item__content", __source: {
                      fileName: _jsxFileName,
                      lineNumber: 81
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__accordion_item__["a" /* default */], _extends({}, item.props, {
                    color: color,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 82
                    }
                  }))
                )
              );
            })
          )
        )
      )
    );
  };

  return AccordionContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcText: null,
  mbText: null,
  items: null,
  color: null
}, _temp);
AccordionContainer.displayName = 'AccordionContainer';


/* harmony default export */ __webpack_exports__["a"] = (AccordionContainer);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweet_scroll__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweet_scroll__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\anchor-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 *  AnchorNavigation
 */
var AnchorNavigation = (_temp = _class = function (_Component) {
  _inherits(AnchorNavigation, _Component);

  function AnchorNavigation(props) {
    _classCallCheck(this, AnchorNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.init = function (e) {
      // ナビゲーションリスト生成
      var blocks = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].querySelectorAll('[data-anchor-name]');
      var links = [];
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var id = block.id && block.id !== '' ? block.id : block.dataset.id && block.dataset.id !== '' ? block.dataset.id : null;
        var anchorName = block.dataset.anchorName;
        if (id && id !== '' && anchorName && anchorName !== '') {
          links.push({
            id: id,
            anchorName: anchorName
          });
        }
      }
      _this.setState({
        links: links
      });

      //タッチデバイスか否か（タブレット対応）
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        _this.setState({
          hasTouch: true
        });
      }

      // ナビゲーション上下中央
      // setTimeout(
      //   () => {
      //     const anchorNav = this.refs.anchorNavigation;
      //     const navHeight = anchorNav.getBoundingClientRect().height;
      //     anchorNav.style.marginTop = -Math.floor(navHeight / 2) + 'px';
      //     anchorNav.classList.add('show');
      //   },
      // 100);

      setTimeout(function () {
        var anchorNav = _this.refs.anchorNavigation;
        anchorNav.style.height = anchorNav.querySelector('.AnchorNavigation__container').clientHeight + 'px';
        anchorNav.classList.add('show');
      }, 100);

      setTimeout(function () {
        if (!_this.state.open) {
          _this.setState({
            open: true
          });
        }
      }, 200);

      // EPIServerのプレビュー時のモーダルの位置調整
      var isEpiServerPreview = false;
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent) {
        var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          isEpiServerPreview = true;
          setInterval(function () {
            _this.onScrollEpiPreview();
          }, 200);
          setTimeout(function () {
            if (_this.state.open) {
              _this.setState({
                open: false
              });
            }
          }, 3000);
        }
      }
      if (!isEpiServerPreview) {
        //スクロールイベント
        __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].addEventListener('scroll', _this.onScroll);
        _this.triggerEvent(__WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */], 'scroll');
      }
    };

    _this.getSubNavigationHeight = function (e) {
      var navigation = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.getElementsByClassName('StandardPage__navigation')[0] || null;
      if (!navigation) {
        return 0;
      } else {
        return navigation.clientHeight;
      }
    };

    _this.onClick = function (e) {
      var targetNode = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].getElementById(e.currentTarget.dataset.id);
      //console.log(targetNode);
      // BodyControl.scrollToNode(targetNode);

      // ScrollLoaderコンポーネントの影響で正常に動かなくなったので自前でスクロール実装
      var navigationHeight = _this.getSubNavigationHeight();
      if (_this.intervalId) clearInterval(_this.intervalId);
      _this.intervalId = setInterval(function () {
        var windowTop = window.pageYOffset;
        var clientRect = targetNode.getBoundingClientRect();
        var targetTop = windowTop + clientRect.top - navigationHeight;
        var currentTop = windowTop + (targetTop - windowTop) * 0.15;
        if (Math.abs(targetTop - windowTop) <= 10) {
          if (_this.intervalId) clearInterval(_this.intervalId);
          // window.scrollTo(0, targetTop);
          // console.log('complete');
        } else {
          window.scrollTo(0, currentTop);
        }
      }, 1000 / 30);

      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        _this.setState({
          open: false
        });
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    _this.onMouseOver = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        return false;
      }
      if (!_this.state.open) {
        _this.setState({
          open: true
        });
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    _this.onMouseOut = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        return false;
      }
      if (_this.state.open) {
        _this.setState({
          open: false
        });
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    _this.onClickHandle = function (e) {
      if (!__WEBPACK_IMPORTED_MODULE_3__constants_environment__["b" /* HAS_TOUCH */]) {
        return false;
      }
      _this.setState({
        open: !_this.state.open
      });
      return false;
    };

    _this.onScroll = function () {

      var currentBlock = void 0;

      var blocks = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].querySelectorAll('[data-anchor-name]');

      var anchorNav = _this.refs.anchorNavigation;

      for (var i = blocks.length - 1; i >= 0; i--) {
        var offsetTop = blocks[i].getBoundingClientRect().top;
        var height = blocks[i].getBoundingClientRect().height;
        if (offsetTop < __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].innerHeight * 0.2 && //対象ブロックが画面の半部より上にある
        // offsetTop <= 0  && //対象ブロックが画面の上端にある
        offsetTop + height > 0 // 画面内に一部でも残っている
        ) {
            currentBlock = blocks[i];
            break;
          }
      }

      var anchorNavLinks = anchorNav.querySelectorAll('[data-id]');
      for (var _i = 0; _i < anchorNavLinks.length; _i++) {
        var anchorNavLink = anchorNavLinks[_i];
        anchorNavLink.classList.remove('current');
        if (currentBlock != null && (anchorNavLink.dataset.id === currentBlock.dataset.id || anchorNavLink.dataset.id === currentBlock.id)) {
          anchorNavLink.classList.add('current');
        }
      }

      if (_this.state.open) {
        _this.setState({
          open: false
        });
      }
    };

    _this.getRemain = function () {
      // 垂直スクロール量を取得する
      var scrollTop = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.scrollTop || __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].documentElement.scrollTop;

      // 表示領域の高さを取得する
      var clientHeight = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight;

      // スクロールバーで隠れた領域を含むコンテンツ領域の高さを取得する
      var scrollHeight = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.scrollHeight || __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].docomentElement.scrollHeight;

      // Firefox・Chrome対応
      if (scrollHeight === clientHeight) {
        clientHeight = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].innerHeight;
      }

      // コンテンツ領域の底までの残り領域
      var remain = scrollHeight - clientHeight - scrollTop;

      return remain;
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
      } else {
        // IE
        var evt = document.createEventObject();
        return element.fireEvent("on" + event, evt);
      }
    };

    _this.onScrollEpiPreview = function () {
      var wrapperElement = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        var wrapperHeight = wrapperElement.clientHeight;
        var wrapperScrollTop = wrapperElement.scrollTop;
        //
        var currentBlock = void 0;
        var blocks = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].querySelectorAll('[data-anchor-name]');
        var anchorNav = _this.refs.anchorNavigation;
        for (var i = blocks.length - 1; i >= 0; i--) {
          var offsetTop = blocks[i].getBoundingClientRect().top - wrapperScrollTop;
          // let offsetTop = blocks[i].getBoundingClientRect().top;
          var height = blocks[i].getBoundingClientRect().height;
          if (offsetTop < wrapperHeight * 0.2 && //対象ブロックが画面の半部より上にある
          // offsetTop < WINDOW.innerHeight * 0.2  && //対象ブロックが画面の半部より上にある
          offsetTop + height > 0 // 画面内に一部でも残っている
          ) {
              currentBlock = blocks[i];
              break;
            }
        }
        var anchorNavLinks = anchorNav.querySelectorAll('[data-id]');
        for (var _i2 = 0; _i2 < anchorNavLinks.length; _i2++) {
          var anchorNavLink = anchorNavLinks[_i2];
          anchorNavLink.classList.remove('current');
          if (currentBlock != null && (anchorNavLink.dataset.id === currentBlock.dataset.id || anchorNavLink.dataset.id === currentBlock.id)) {
            anchorNavLink.classList.add('current');
          }
        }
        // if(this.state.open){
        //   this.setState({
        //     open: false
        //   });
        // }
        //
        var bottom = function () {
          if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["g" /* IS_MOBILE */]) {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight);
          } else {
            return __WEBPACK_IMPORTED_MODULE_3__constants_environment__["a" /* DOCUMENT */].body.clientHeight - (wrapperScrollTop + wrapperHeight - 100);
          }
        }();
        _this.setState({
          bottom: bottom
        });
      }
    };

    _this.props = props;
    _this.state = {
      links: [],
      open: false,
      hasTouch: false,
      bottom: 0
    };
    _this.intervalId = null;
    return _this;
  }

  AnchorNavigation.prototype.componentDidMount = function componentDidMount() {
    if (this.props.invisible) return;
    setTimeout(this.init, 100);
  };

  // サブナビゲーションの高さ取得


  // EPIServerのプレビュー時のモーダルの位置調整


  AnchorNavigation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass;


    if (this.props.invisible) return null;

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 333
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'AnchorNavigation',
          ref: 'anchorNavigation',
          style: __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].parent ? { position: 'fixed', bottom: this.state.bottom } : null,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 337
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'AnchorNavigation__container' + (this.state.open ? ' open' : '') + (this.state.hasTouch ? ' hasTouch' : ''), onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut, __source: {
              fileName: _jsxFileName,
              lineNumber: 342
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'AnchorNavigation__container__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 343
              }
            },
            this.state.links.map(function (link, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'AnchorNavigation__container__list__item', key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 346
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    href: 'javascript:void(0)',
                    'data-id': link.id,
                    onClick: _this2.onClick,
                    className: 'AnchorNavigation__container__list__item__link',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 347
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'AnchorNavigation__container__list__item__link__text', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 353
                      }
                    },
                    link.anchorName
                  )
                )
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'AnchorNavigation__container__handle', onClick: this.onClickHandle, __source: {
              fileName: _jsxFileName,
              lineNumber: 361
            }
          })
        )
      )
    );
  };

  return AnchorNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null
}, _temp);
AnchorNavigation.displayName = 'AnchorNavigation';


/* harmony default export */ __webpack_exports__["a"] = (AnchorNavigation);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_top__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\accessory-detail-page\\index.jsx';






/**
 * AccessoryDetailPage
 */
var AccessoryDetailPage = function AccessoryDetailPage(_ref) {
  var hideScrollTop = _ref.hideScrollTop,
      pcHeading = _ref.pcHeading,
      mbHeading = _ref.mbHeading,
      header = _ref.header,
      upperPageNavigation = _ref.upperPageNavigation,
      hero = _ref.hero,
      children = _ref.children,
      lowerPageNavigation = _ref.lowerPageNavigation,
      footer = _ref.footer,
      ctaNavi = _ref.ctaNavi,
      anchorNavi = _ref.anchorNavi,
      cookieEditor = _ref.cookieEditor;

  var getPcHeading = function getPcHeading() {
    if (pcHeading && pcHeading !== '') {
      return pcHeading;
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null;
  };
  var getMbHeading = function getMbHeading() {
    if (pcHeading && pcHeading !== '') {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      } else {
        return pcHeading;
      }
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'StandardPage', __source: {
        fileName: _jsxFileName,
        lineNumber: 49
      }
    },
    header !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'StandardPage__header', __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      header
    ) : null,
    upperPageNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: 'StandardPage__navigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        }
      },
      upperPageNavigation
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'main',
      { className: 'StandardPage__main', __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        }
      },
      children !== null ? children : null
    ),
    lowerPageNavigation !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: 'StandardPage__bottom-navigation', __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      },
      lowerPageNavigation
    ) : null,
    footer !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'StandardPage__footer', __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      },
      footer
    ) : null,
    hideScrollTop === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_scroll_top__["a" /* default */], {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71
      }
    }) : null,
    ctaNavi !== null ? ctaNavi : null,
    anchorNavi !== null ? anchorNavi : null,
    cookieEditor !== null ? cookieEditor : null
  );
};
AccessoryDetailPage.displayName = 'AccessoryDetailPage';
AccessoryDetailPage.propTypes = {
  hideScrollTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showPageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  upperPageNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  lowerPageNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  ctaNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  anchorNavi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  cookieEditor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
AccessoryDetailPage.defaultProps = {
  hideScrollTop: null,
  pageName: null,
  pcHeading: null,
  mbHeading: null,
  showPageTitle: null,
  header: null,
  upperPageNavigation: null,
  hero: null,
  children: null,
  lowerPageNavigation: null,
  footer: null,
  ctaNavi: null,
  anchorNavi: null,
  cookieEditor: null
};
/* harmony default export */ __webpack_exports__["a"] = (AccessoryDetailPage);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hyperlink__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigation_container__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll_top__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__youtube_player__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__missing_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__estimate_link__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__map__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__image_loader__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scroll_loader__ = __webpack_require__(25);
/* unused harmony reexport Accordion */
/* unused harmony reexport Hyperlink */
/* unused harmony reexport ModalWindow */
/* unused harmony reexport NavigationContainer */
/* unused harmony reexport ScrollTop */
/* unused harmony reexport Slider */
/* unused harmony reexport Wrapper */
/* unused harmony reexport YoutubePlayer */
/* unused harmony reexport MissingComponent */
/* unused harmony reexport EstimateLink */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__map__["a"]; });
/* unused harmony reexport ImageLoader */
/* unused harmony reexport ScrollLoader */
















/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_estimate_dark_png__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_estimate_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__icon_estimate_dark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_estimate_light_png__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_estimate_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__icon_estimate_light_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\estimation-history\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/**
 *  EstimationHistory
 */
var EstimationHistory = (_temp = _class = function (_Component) {
  _inherits(EstimationHistory, _Component);

  function EstimationHistory(props) {
    _classCallCheck(this, EstimationHistory);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.setData = function () {

      console.log('[debug]');

      var obj = {
        saved: [],
        unsaved: []
      };

      var sample = {
        id: [2.09154E+15],
        name: ['見積り2'],
        aic: ['25D'],
        aic_l: ['https://ssl.mazda.co.jp/purchase/estimate/img/demio/ext/1/25D_l.png'],
        aic_s: ['https://ssl.mazda.co.jp/purchase/estimate/img/demio/ext/1/25D_s.png'],
        car_name: ['デミオ'],
        grade_name: ['XD Mist Maroon(2WD 6AT)'],
        engine: ['SKYACTIV-D 1.5', 'SKYACTIV-G', 'SKYACTIV-X'],
        fuel: ['ディーゼル', 'ガソリン', 'ハイブリッド'],
        drive: ['6EC-AT', '6MT', '5MT', '電気式無段変速機'],
        mission: ['4WD', '2WD'],
        body_color: ['スノーフレイクホワイトパールマイカ'],
        seat_color: ['ディープレッド/ブラック（グランリュクス/クロス）'],
        estimated_amount: [2331743],
        retail_prices: [2095200],
        moption_prices: [32400],
        soption_prices: [76433],
        total_expenses: [127710],
        moption_list: ['CD/DVDプレーヤー＋地上デジタルTVチューナー（フルセグ）<br />あああああああああああああ'],
        moption_explaininfo: ['ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。'],
        grade_id: ['XD L Package'],
        car_id: ['atenza-sedan', 'atenza-wagon', 'axela-hybrid', 'axela-sport', 'axela-sedan', 'demio', 'cx-3', 'cx-5', 'cx-8', 'roadster', 'roadsterrf', 'flair', 'flair-wagon', 'flair-crossover', 'carol', 'scrum-wagon'],
        car_type_code: ['DE8', 'GJ7', 'GJ8'],
        grade_code: [1, 2, 3],
        ecode: ['W'],
        icode: ['W'],
        moption_select_list: [1E+11],
        soption_sel_index: [84],
        soptions: ['50:1:50:5000'],
        rgb: ['192a46'],
        model_name: ['demio']
      };

      for (var i = 0; i < 6; i++) {
        var data = {
          aic: sample.aic[Math.floor(Math.random() * sample.aic.length)],
          aic_s: sample.aic_s[Math.floor(Math.random() * sample.aic_s.length)],
          engine: sample.engine[Math.floor(Math.random() * sample.engine.length)],
          fuel: sample.fuel[Math.floor(Math.random() * sample.fuel.length)],
          drive: sample.drive[Math.floor(Math.random() * sample.drive.length)],
          mission: sample.mission[Math.floor(Math.random() * sample.mission.length)],
          body_color: sample.body_color[Math.floor(Math.random() * sample.body_color.length)],
          seat_color: sample.seat_color[Math.floor(Math.random() * sample.seat_color.length)],
          estimated_amount: Math.floor(Math.random() * 9999999),
          retail_prices: Math.floor(Math.random() * 9999999),
          moption_prices: Math.floor(Math.random() * 9999999),
          soption_prices: Math.floor(Math.random() * 9999999),
          total_expenses: Math.floor(Math.random() * 9999999),
          moption_list: sample.moption_list[Math.floor(Math.random() * sample.moption_list.length)],
          moption_explaininfo: sample.moption_explaininfo[Math.floor(Math.random() * sample.moption_explaininfo.length)],
          grade_id: sample.grade_id[Math.floor(Math.random() * sample.grade_id.length)],
          car_id: sample.car_id[Math.floor(Math.random() * sample.car_id.length)],
          car_type_code: sample.car_type_code[Math.floor(Math.random() * sample.car_type_code.length)],
          grade_code: sample.grade_code[Math.floor(Math.random() * sample.grade_code.length)],
          ecode: sample.ecode[Math.floor(Math.random() * sample.ecode.length)],
          icode: sample.icode[Math.floor(Math.random() * sample.icode.length)],
          moption_select_list: sample.moption_select_list[Math.floor(Math.random() * sample.moption_select_list.length)],
          soption_sel_index: sample.soption_sel_index[Math.floor(Math.random() * sample.soption_sel_index.length)],
          soptions: sample.soptions[Math.floor(Math.random() * sample.soptions.length)],
          rgb: Math.floor(Math.random() * 16777215).toString(16),
          model_name: sample.model_name[Math.floor(Math.random() * sample.model_name.length)]
        };
        if (obj.saved.length < 3) {
          obj.saved.push(data);
        } else {
          obj.unsaved.push(data);
        }
      }

      //test
      // delete　obj.saved;
      // delete　obj.unsaved;
      // obj.saved.pop();
      // obj.saved.pop();
      // obj.unsaved.pop();
      // obj.unsaved.pop();
      // obj.saved = [];
      // obj.unsaved = [];

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.setItem) {
        var json = JSON.stringify(obj);
        __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.removeItem('mj_est');
        __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.setItem('mj_est', json);
      }
    };

    _this.getData = function () {
      var obj = {};

      if (!_this.validEstimateJson()) {
        return {};
      }

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        obj = JSON.parse(json);
      }
      return obj;
    };

    _this.existEst = function (estType) {
      var est = _this.getData();
      if (est && Object.keys(est).length > 0 && estType in est && Array.isArray(est[estType]) && est[estType].length > 0) {
        return true;
      }
      return false;
    };

    _this.onChangeEstType = function (e) {
      _this.tmp.estType = e.target.value;
      _this.setState({
        estType: e.target.value
      });

      //fadein
      _this.refs.ests.classList.remove('fadein');
      _this.refs.detail.classList.remove('fadein');
      _this.refs.ests.style.opacity = 0;
      _this.refs.detail.style.opacity = 0;
      setTimeout(function () {
        _this.refs.ests.classList.add('fadein');
        _this.refs.detail.classList.add('fadein');
        _this.refs.ests.style.opacity = 1;
        _this.refs.detail.style.opacity = 1;
      }, 10);
    };

    _this.onChangeEstSlide = function () {
      //fadein
      _this.refs.detail.classList.remove('fadein');
      _this.refs.detail.style.opacity = 0;
      setTimeout(function () {
        _this.refs.detail.classList.add('fadein');
        _this.refs.detail.style.opacity = 1;
      }, 10);
    };

    _this.convertCarIdToModelName = function (carInfo, carId) {

      var modelName = void 0;

      if (!carInfo || !Array.isArray(carInfo) || carInfo.length === 0 || !carId || carId === '') {
        return '';
      }

      for (var i = 0; i < carInfo.length; i++) {
        if ('CarId' in carInfo[i] && 'ModelName' in carInfo[i] && carInfo[i].CarId === carId) {
          modelName = carInfo[i].ModelName;
          return modelName;
        }
      }

      return '';
    };

    _this.convertCarIdToBodyTypeModel = function (carInfo, carId) {

      var bodyTypeModel = void 0;

      if (!carInfo || !Array.isArray(carInfo) || carInfo.length === 0 || !carId || carId === '') {
        return '';
      }

      for (var i = 0; i < carInfo.length; i++) {
        if ('CarId' in carInfo[i] && 'BodyTypeModel' in carInfo[i] && carInfo[i].CarId === carId) {
          bodyTypeModel = carInfo[i].BodyTypeModel;
          return bodyTypeModel;
        }
      }

      return '';
    };

    _this.getTargetEst = function () {
      var est = _this.getData();
      var estType = _this.tmp.estType && _this.tmp.estType !== '' ? _this.tmp.estType : '';
      var estIndex = null;
      var targetEst = null;

      if ((_this.existEst('unsaved') || _this.existEst('saved')) && estType) {
        estIndex = _this.tmp[estType + 'Index'];
        targetEst = est[_this.tmp.estType][estIndex];
      }

      return targetEst;
    };

    _this.onClickEstimate = function (e) {
      var estimateParam = _this.props.estimateParam;

      var query_car_id = _this.getQuery('car_id');

      var cookie_car_id = _this.getCookie('mjcarid');

      var car_id = query_car_id ? query_car_id : cookie_car_id ? cookie_car_id : estimateParam && estimateParam !== '' ? estimateParam : null;

      // let href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';

      // if(car_id != null){
      //   href += car_id !== '' ? ('edit.html?car_id=' + car_id) : '';
      // }

      var href = 'https://www.mazda.co.jp/purchase/estimate/';

      if (car_id != null) {
        href += car_id !== '' ? '?car_id=' + car_id : '';
      }

      location.href = href;

      e.preventDefault();
    };

    _this.onClickEstimateSimulate = function (e) {
      var est = _this.getTargetEst();

      // let href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';

      // href += 'edit.html?' +
      //         'direct=id_contents_estimate&' +
      //         'car_id=' + (est.car_id != null ? est.car_id : '') + '&' +
      //         'car_type_code=' + (est.car_type_code != null ? est.car_type_code : '') + '&' +
      //         'drive=' + (est.drive != null ? est.drive : '') + '&' +
      //         'aic=' + (est.aic != null ? est.aic : '') + '&' +
      //         'icode=' + (est.icode != null ? est.icode : '') + '&' +
      //         'engine=' + (est.engine != null ? est.engine : '') + '&' +
      //         'grade_code=' + (est.grade_code != null ? est.grade_code : '') + '&' +
      //         'mission=' + (est.mission != null ? est.mission : '') + '&' +
      //         'moption_select_list=' + (est.moption_select_list != null ? est.moption_select_list : '') + '&' +
      //         'soption_sel_index=' + (est.soption_sel_index != null ? est.soption_sel_index : '') + '&' +
      //         'soptions=' + (est.soptions != null ? est.soptions : '');

      var href = 'https://www.mazda.co.jp/purchase/estimate/';

      href += '?' + 'direct=id_contents_estimate&' + 'car_id=' + (est.car_id != null ? est.car_id : '') + '&' + 'car_type_code=' + (est.car_type_code != null ? est.car_type_code : '') + '&' + 'drive=' + (est.drive != null ? est.drive : '') + '&' + 'aic=' + (est.aic != null ? est.aic : '') + '&' + 'icode=' + (est.icode != null ? est.icode : '') + '&' + 'engine=' + (est.engine != null ? est.engine : '') + '&' + 'grade_code=' + (est.grade_code != null ? est.grade_code : '') + '&' + 'mission=' + (est.mission != null ? est.mission : '') + '&' + 'moption_select_list=' + (est.moption_select_list != null ? est.moption_select_list : '') + '&' + 'soption_sel_index=' + (est.soption_sel_index != null ? est.soption_sel_index : '') + '&' + 'soptions=' + (est.soptions != null ? est.soptions : '');

      location.href = href;

      e.preventDefault();
    };

    _this.onClickMoption = function (e) {
      var moption = _this.refs.moption;
      if (moption && moption.classList.contains('touch')) {
        moption.classList.toggle('showInfo');
      }
    };

    _this.getQuery = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] || !__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location) {
        return false;
      }
      var params = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].location.search.substring(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var param = params[i].split('=');
        if (param[0].trim() === key) {
          return param[1].trim();
        }
      }
      return false;
    };

    _this.getCookie = function (key) {
      if (!__WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */] || !__WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].cookie) {
        return false;
      }
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].split('=');
        if (cookie[0].trim() === key) {
          return cookie[1].trim();
        }
      }

      return false;
    };

    _this.format = function (str) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(String(str).toLowerCase().split(' ').join('-'));
    };

    _this.validEstimateJson = function () {
      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        try {
          JSON.parse(json);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };

    _this.props = props;

    _this.state = {
      estType: '',
      unsavedIndex: 0,
      savedIndex: 0,
      carInfo: [],
      estExists: false
    };

    _this.tmp = {
      estType: '',
      unsavedIndex: 0,
      savedIndex: 0,
      carInfo: []
    };
    return _this;
  }

  EstimationHistory.prototype.componentDidMount = function componentDidMount() {

    // WINDOW.MZD_CARINFO_SETTINGS = new Array(
    //   {ModelName: "atenza", CarId: "atenza-sedan", CarTypeCode: "GJ7"},
    //   {ModelName: "atenza", CarId: "atenza-wagon", CarTypeCode: "GJ8"},
    //   {ModelName: "axela", CarId: "axela-hybrid", CarTypeCode: "BY3"},
    //   {ModelName: "axela", CarId: "axela-sport", CarTypeCode: "BM5"},
    //   {ModelName: "axela", CarId: "axela-sedan", CarTypeCode: "BM6"},
    //   {ModelName: "demio", CarId: "demio", CarTypeCode: "DE8"},
    //   {ModelName: "cx-3", CarId: "cx-3", CarTypeCode: "DK4"},
    //   {ModelName: "cx-5", CarId: "cx-5", CarTypeCode: "KF4"},
    //   {ModelName: "cx-8", CarId: "cx-8", CarTypeCode: "GK2"},
    //   {ModelName: "roadster", CarId: "roadster", CarTypeCode: "RS2"},
    //   {ModelName: "roadsterrf", CarId: "roadsterrf", CarTypeCode: "RF2"},
    //   {ModelName: "flair", CarId: "flair", CarTypeCode: "MJ6"},
    //   {ModelName: "flair-wagon", CarId: "flair-wagon", CarTypeCode: "MM6"},
    //   {ModelName: "flair-crossover", CarId: "flair-crossover", CarTypeCode: "ZK4"},
    //   {ModelName: "carol", CarId: "carol", CarTypeCode: "HB1"},
    //   {ModelName: "scrum-wagon", CarId: "scrum-wagon", CarTypeCode: "DG1"},
    //   {}
    // );

    if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS && Array.isArray(__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS) && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS.length > 0) {
      this.tmp.carInfo = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS;
      this.setState({
        carInfo: __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].MZD_CARINFO_SETTINGS
      });
    }

    this.tmp.estType = this.existEst('unsaved') ? 'unsaved' : this.existEst('saved') ? 'saved' : '';
    this.setState({
      estType: this.existEst('unsaved') ? 'unsaved' : this.existEst('saved') ? 'saved' : ''
    });

    this.setState({
      estExists: this.existEst('unsaved') || this.existEst('saved') ? true : false
    });

    // for debug
    // if(new URLSearchParams(WINDOW.location.search).has('debug')){
    //   this.setData();
    // }
  };

  EstimationHistory.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        navigationTitle = _props.navigationTitle,
        navigationIcon = _props.navigationIcon,
        unsavedItemTabName = _props.unsavedItemTabName,
        savedItemTabName = _props.savedItemTabName,
        priceTitle = _props.priceTitle,
        bodyColorTitle = _props.bodyColorTitle,
        seatColorTitle = _props.seatColorTitle,
        makerOptionTitle = _props.makerOptionTitle,
        pcRecommendText = _props.pcRecommendText,
        mbRecommendText = _props.mbRecommendText,
        modelName = _props.modelName,
        carId = _props.carId,
        carTypeCode = _props.carTypeCode,
        gradeId = _props.gradeId,
        estimateParam = _props.estimateParam;


    var est = this.getData();

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'EstimationHistory', __source: {
            fileName: _jsxFileName,
            lineNumber: 150
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'EstimationHistory__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 151
            }
          },
          function () {
            if (_this2.existEst('unsaved') || _this2.existEst('saved')) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { className: 'EstimationHistory__container__estType', ref: 'estType', onChange: _this2.onChangeEstType, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 155
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'EstimationHistory__container__estType__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 156
                    }
                  },
                  function () {
                    if (_this2.existEst('unsaved')) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { className: 'EstimationHistory__container__estType__list__item', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 160
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          { className: "EstimationHistory__container__estType__list__item__label" + (!_this2.existEst('saved') ? ' disabled' : ''), __source: {
                              fileName: _jsxFileName,
                              lineNumber: 161
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'EstimationHistory__container__estType__list__item__label__radio', type: 'radio', name: 'estType', value: 'unsaved', checked: _this2.state.estType === 'unsaved', onChange: _this2.onChangeEstType, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 162
                            }
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'EstimationHistory__container__estType__list__item__label__text', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 163
                              }
                            },
                            unsavedItemTabName && unsavedItemTabName !== '' ? unsavedItemTabName : ''
                          )
                        )
                      );
                    }
                  }(),
                  function () {
                    if (_this2.existEst('saved')) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { className: 'EstimationHistory__container__estType__list__item', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 172
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          { className: "EstimationHistory__container__estType__list__item__label" + (!_this2.existEst('unsaved') ? ' disabled' : ''), __source: {
                              fileName: _jsxFileName,
                              lineNumber: 173
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'EstimationHistory__container__estType__list__item__label__radio', type: 'radio', name: 'estType', value: 'saved', checked: _this2.state.estType === 'saved', onChange: _this2.onChangeEstType, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 174
                            }
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'EstimationHistory__container__estType__list__item__label__text', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 175
                              }
                            },
                            savedItemTabName && savedItemTabName !== '' ? savedItemTabName : ''
                          )
                        )
                      );
                    }
                  }()
                )
              );
            }
          }(),
          function () {
            if (_this2.state.estExists === true) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'EstimationHistory__container__ests',
                  ref: 'ests',
                  onTransitionEnd: function onTransitionEnd(e) {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 189
                  }
                },
                function () {
                  var sliders = [];

                  var _loop = function _loop(estType) {
                    if (!Array.isArray(est[estType]) || est[estType].length === 0) {
                      return 'continue';
                    }
                    sliders.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        className: 'EstimationHistory__container__ests__slider' + (estType === _this2.tmp.estType && _this2.tmp.estType !== '' ? ' show' : ''),
                        key: estType,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 204
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6__components_slider__["a" /* default */],
                        {
                          ref: 'slider_' + estType,
                          settings: {
                            autoplay: false,
                            autoplaySpeed: 3000,
                            speed: 1000,
                            ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                            fade: false,
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            swipe: true,
                            draggable: false,
                            arrows: true,
                            dots: true,
                            adaptiveHeight: false,
                            centerMode: false,
                            centerPadding: 0,
                            waitForAnimate: false,
                            lazyLoad: 'progressive',
                            beforeChange: function beforeChange(old, current) {
                              if (estType === 'unsaved') {
                                _this2.tmp.unsavedIndex = current;
                                _this2.setState({
                                  unsavedIndex: current
                                });
                              } else if (estType === 'saved') {
                                _this2.tmp.savedIndex = current;
                                _this2.setState({
                                  savedIndex: current
                                });
                              }
                              //
                              _this2.refs['slider_' + estType].beforeChange(old, current);
                              _this2.onChangeEstSlide();
                              //
                              var moption = _this2.refs.moption;
                              if (moption && moption.classList.contains('touch')) {
                                moption.classList.remove('showInfo');
                              }
                            },
                            responsive: [{
                              breakpoint: 767,
                              settings: {
                                arrows: false
                              }
                            }]
                          }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 211
                          }
                        },
                        function () {

                          // 100th Anniversary Special Edition > 100周年特別記念車
                          var convert100th = function convert100th(text) {
                            if (text && text !== '') {
                              text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
                              text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
                              text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
                              text = text.replace('RF 35th SV', '35周年記念車');
                              text = text.replace('35th SV', '35周年記念車');
                              text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
                              text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
                              text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
                              text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
                              text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
                              text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
                              text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
                              text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
                              text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
                              text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
                              text = text.replace('15 SPORT Plus', '15 SPORT＋');
                              text = text.replace('XD SPORT Plus', 'XD SPORT＋');
                              return text;
                            } else {
                              return text;
                            }
                          };

                          // 15S business use package > 15S＜ビジネスユースパッケージ付＞
                          var convertBusinessUsePackage = function convertBusinessUsePackage(text) {
                            if (text && text !== '') {
                              return text.replace('15S business use package', '15S＜ビジネスユースパッケージ付＞');
                            } else {
                              return text;
                            }
                          };

                          var estArr = est[estType];
                          if (Array.isArray(estArr) && estArr.length > 0) {
                            return estArr.map(function (estData, index) {
                              var carImageSrc = estData.aic_s;
                              // let carImageSrc = '/globalassets/assets/cars/' + this.format(this.convertCarIdToModelName(this.state.carInfo, estData.car_id)) + '/' + this.format(estData.car_id) + '/' + this.format(estData.car_type_code) + '/' + this.format(estData.grade_id) +  '/common/' + this.format(estData.grade_id) + '_' + estData.aic + '_s.png';
                              // let carImageSrc = '/assets-dev/left.png';
                              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'EstimationHistory__container__ests__slider__item', key: index, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 307
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'EstimationHistory__container__ests__slider__item__name', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 308
                                    }
                                  },
                                  _this2.convertCarIdToBodyTypeModel(_this2.state.carInfo, estData.car_id)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'EstimationHistory__container__ests__slider__item__title', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 309
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'EstimationHistory__container__ests__slider__item__title__gradeId', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 310
                                      }
                                    },
                                    convertBusinessUsePackage(convert100th(estData.grade_id))
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'EstimationHistory__container__ests__slider__item__title__fuel', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 311
                                      }
                                    },
                                    estData.fuel
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'EstimationHistory__container__ests__slider__item__title__drive', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 312
                                      }
                                    },
                                    estData.drive
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'EstimationHistory__container__ests__slider__item__title__mission', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 313
                                      }
                                    },
                                    estData.mission
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'EstimationHistory__container__ests__slider__item__image', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 315
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: carImageSrc, className: 'EstimationHistory__container__ests__slider__item__image__img', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 316
                                    }
                                  })
                                )
                              );
                            });
                          }
                        }()
                      )
                    ));
                  };

                  for (var estType in est) {
                    var _ret = _loop(estType);

                    if (_ret === 'continue') continue;
                  }
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 329
                      }
                    },
                    sliders
                  );
                }()
              );
            } else {
              var carImageSrc = '/globalassets/assets/cars/' + _this2.format(modelName) + '/' + _this2.format(carId) + '/' + _this2.format(carTypeCode) + '/' + _this2.format(gradeId) + '/common/' + _this2.format(gradeId) + '_default_s.png';
              // let carImageSrc = '/assets-dev/atenza-sedan_gj7_default_s.png';
              var pcText = pcRecommendText && pcRecommendText !== '' ? pcRecommendText : '';
              var mbText = mbRecommendText && mbRecommendText !== '' ? mbRecommendText : pcRecommendText && pcRecommendText !== '' ? pcRecommendText : '';

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'EstimationHistory__container__no-ests', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 344
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'EstimationHistory__container__no-ests__content', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 345
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'EstimationHistory__container__no-ests__content__image', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 346
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: carImageSrc, className: 'EstimationHistory__container__no-ests__content__image__img', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 347
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'EstimationHistory__container__no-ests__content__recommendText', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 349
                      }
                    },
                    pcText && pcText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'EstimationHistory__container__no-ests__content__recommendText--pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(pcText) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 350
                      }
                    }) : null,
                    mbText && mbText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'EstimationHistory__container__no-ests__content__recommendText--mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 351
                      }
                    }) : null
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'EstimationHistory__container__no-ests__content__button', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 353
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__cta__["a" /* default */], _extends({
                      ctaType: 'Free',
                      text: 'カンタン見積り',
                      linkType: 'Button-With-Icon',
                      iconSrc: __WEBPACK_IMPORTED_MODULE_8__icon_estimate_dark_png___default.a,
                      hoverIconSrc: __WEBPACK_IMPORTED_MODULE_9__icon_estimate_light_png___default.a,
                      color: 'Light',
                      buttonStyle: 'Action',
                      handleClick: _this2.onClickEstimate
                    }, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 354
                      }
                    }))
                  )
                )
              );
            }
          }(),
          function () {
            var targetEst = _this2.getTargetEst();
            if (targetEst != null) {
              var colorTipColor = targetEst.rgb ? '#' + targetEst.rgb : null;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'EstimationHistory__container__detail',
                  ref: 'detail',
                  onTransitionEnd: function onTransitionEnd(e) {
                    e.currentTarget.classList.remove('fadein');
                    e.currentTarget.style.opacity = "";
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 378
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'EstimationHistory__container__detail__prices', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 386
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'EstimationHistory__container__detail__prices__title', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 387
                      }
                    },
                    'PRICE'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dl',
                    { className: 'EstimationHistory__container__detail__prices__list', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 388
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dt',
                      { className: 'EstimationHistory__container__detail__prices__list__title header', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 389
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'text', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 390
                          }
                        },
                        priceTitle && priceTitle !== '' ? priceTitle : ''
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { className: 'EstimationHistory__container__detail__prices__list__data header', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 392
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'text', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 393
                          }
                        },
                        '\xA5',
                        Number(targetEst.estimated_amount).toLocaleString()
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'tax', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 394
                          }
                        },
                        '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dt',
                      { className: 'EstimationHistory__container__detail__prices__list__title', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 396
                        }
                      },
                      '\u8ECA\u4E21\u672C\u4F53\u4FA1\u683C'
                    ),
                    function () {
                      if (targetEst.car_id === 'cx-8') {
                        if (targetEst.grade_id === '25S Exclusive Mode' || targetEst.grade_id === 'XD Exclusive Mode') {
                          if (targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ブラック）' || targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ピュアホワイト）') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'dd',
                              { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 405
                                }
                              },
                              '\xA5',
                              Number(targetEst.retail_prices + 165000).toLocaleString()
                            );
                          }
                        }
                        if (targetEst.seat_color === '6人乗り レザー(レッド)' || targetEst.seat_color === '7人乗り レザー(レッド)') {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dd',
                            { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 411
                              }
                            },
                            '\xA5',
                            Number(targetEst.retail_prices + 44000).toLocaleString()
                          );
                        } else if (targetEst.seat_color === '6人乗り ナッパレザー(ピュアホワイト)' || targetEst.seat_color === '6人乗り ナッパレザー(オーバーン)') {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dd',
                            { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 415
                              }
                            },
                            '\xA5',
                            Number(targetEst.retail_prices + 165000).toLocaleString()
                          );
                        }
                      } else if (targetEst.car_id === 'cx-80') {
                        if (targetEst.grade_id === 'XD Exclusive Mode' || targetEst.grade_id === 'XD-HYBRID Exclusive Sports') {
                          if (targetEst.seat_color === '【6人乗り】キャプテンシート（ブラック・ナッパレザー）') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'dd',
                              { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 425
                                }
                              },
                              '\xA5',
                              Number(targetEst.retail_prices + 143000).toLocaleString()
                            );
                          }
                        }
                      }
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dd',
                        { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 431
                          }
                        },
                        '\xA5',
                        Number(targetEst.retail_prices).toLocaleString()
                      );
                    }(),
                    function () {
                      /* カンタン見積もり特別処理 No166
                         car_id: mazda2, car_type_code: DJ5, grade_code: 10, moption_list: ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）
                         car_id: mazda2, car_type_code: DJ5, grade_code: 21, moption_list: ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）
                         上記条件の場合、メーカーセットオプション価格を非表示 (本体価格にMOPの価格が含まれているため)
                       */
                      if (targetEst.car_id === 'mazda2') {
                        if (targetEst.car_type_code === 'DJ5') {
                          if (targetEst.grade_code == 10 || targetEst.grade_code == 21) {
                            if (targetEst.moption_list === 'ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）') {
                              return null;
                            }
                          }
                        } else if (targetEst.car_type_code === 'DJ6') {
                          if (targetEst.grade_code == 25) {
                            if (targetEst.moption_list === 'ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）') {
                              return null;
                            }
                          }
                        }
                      }
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 457
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'dt',
                          { className: 'EstimationHistory__container__detail__prices__list__title special_no166', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 458
                            }
                          },
                          '\u30E1\u30FC\u30AB\u30FC\u30BB\u30C3\u30C8\u30AA\u30D7\u30B7\u30E7\u30F3\u4FA1\u683C'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'dd',
                          { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 459
                            }
                          },
                          '\xA5',
                          Number(targetEst.moption_prices).toLocaleString()
                        )
                      );
                    }(),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dt',
                      { className: 'EstimationHistory__container__detail__prices__list__title', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 465
                        }
                      },
                      '\u30B7\u30E7\u30C3\u30D7\u30AA\u30D7\u30B7\u30E7\u30F3\u4FA1\u683C'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 466
                        }
                      },
                      '\xA5',
                      Number(targetEst.soption_prices).toLocaleString()
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dt',
                      { className: 'EstimationHistory__container__detail__prices__list__title', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 467
                        }
                      },
                      '\u8AF8\u8CBB\u7528\u5408\u8A08'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { className: 'EstimationHistory__container__detail__prices__list__data', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 468
                        }
                      },
                      targetEst.total_expenses && !isNaN(targetEst.total_expenses) && targetEst.total_expenses > 0 ? '¥' + Number(targetEst.total_expenses).toLocaleString() : '-'
                    ),
                    function () {
                      if (!targetEst.total_expenses || isNaN(targetEst.total_expenses) || targetEst.total_expenses === 0) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'EstimationHistory__container__detail__prices__total-expenses-remarks', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 472
                            }
                          },
                          '\u203B\u8AF8\u8CBB\u7528\u306F\u898B\u7A4D\u7D50\u679C\u753B\u9762\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002'
                        );
                      }
                    }(),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dt',
                      { className: 'EstimationHistory__container__detail__prices__list__title footer', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 476
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'text', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 477
                          }
                        },
                        priceTitle && priceTitle !== '' ? priceTitle : ''
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { className: 'EstimationHistory__container__detail__prices__list__data footer', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 479
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'text', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 480
                          }
                        },
                        '\xA5',
                        Number(targetEst.estimated_amount).toLocaleString()
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'tax', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 481
                          }
                        },
                        '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'EstimationHistory__container__detail__prices__button', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 484
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__cta__["a" /* default */], _extends({
                      ctaType: 'Free',
                      text: '見積りシミュレーション',
                      linkType: 'Button-With-Icon',
                      iconSrc: __WEBPACK_IMPORTED_MODULE_8__icon_estimate_dark_png___default.a,
                      hoverIconSrc: __WEBPACK_IMPORTED_MODULE_9__icon_estimate_light_png___default.a,
                      color: 'Light',
                      buttonStyle: 'Action',
                      handleClick: _this2.onClickEstimateSimulate
                    }, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 485
                      }
                    }))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'EstimationHistory__container__detail__colors', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 499
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dl',
                    { className: 'EstimationHistory__container__detail__colors__list', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 500
                      }
                    },
                    function () {
                      if (targetEst.body_color && targetEst.body_color !== '') {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'EstimationHistory__container__detail__colors__list__group body-color', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 504
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dt',
                            { className: 'EstimationHistory__container__detail__colors__list__title', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 505
                              }
                            },
                            bodyColorTitle && bodyColorTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 506
                                }
                              },
                              bodyColorTitle
                            ) : null
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dd',
                            { className: 'EstimationHistory__container__detail__colors__list__data', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 508
                              }
                            },
                            colorTipColor && colorTipColor !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'colortip', style: { backgroundColor: colorTipColor }, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 509
                              }
                            }) : null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 510
                                }
                              },
                              targetEst.body_color
                            )
                          )
                        );
                      }
                    }(),
                    function () {
                      if (targetEst.seat_color && targetEst.seat_color !== '') {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'EstimationHistory__container__detail__colors__list__group seat-color', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 519
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dt',
                            { className: 'EstimationHistory__container__detail__colors__list__title', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 520
                              }
                            },
                            seatColorTitle && seatColorTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'span',
                              { className: 'text', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 521
                                }
                              },
                              seatColorTitle
                            ) : null
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'dd',
                            { className: 'EstimationHistory__container__detail__colors__list__data', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 523
                              }
                            },
                            function () {
                              if (targetEst.car_id === 'cx-8') {
                                if (targetEst.grade_id === '25S Exclusive Mode' || targetEst.grade_id === 'XD Exclusive Mode') {
                                  if (targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ブラック）' || targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ピュアホワイト）') {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { className: 'text', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 532
                                        }
                                      },
                                      targetEst.seat_color + ' ',
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { display: 'inline-block' }, __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 532
                                          }
                                        },
                                        '+ \xA5165,000'
                                      )
                                    );
                                  }
                                }
                                if (targetEst.seat_color === '6人乗り レザー(レッド)' || targetEst.seat_color === '7人乗り レザー(レッド)') {
                                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'text', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 538
                                      }
                                    },
                                    targetEst.seat_color + ' ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { style: { display: 'inline-block' }, __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 538
                                        }
                                      },
                                      '+ \xA544,000'
                                    )
                                  );
                                } else if (targetEst.seat_color === '6人乗り ナッパレザー(ピュアホワイト)' || targetEst.seat_color === '6人乗り ナッパレザー(オーバーン)') {
                                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'text', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 542
                                      }
                                    },
                                    targetEst.seat_color + ' ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { style: { display: 'inline-block' }, __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 542
                                        }
                                      },
                                      '+ \xA5165,000'
                                    )
                                  );
                                }
                              } else if (targetEst.car_id === 'cx-80') {
                                if (targetEst.grade_id === 'XD Exclusive Mode' || targetEst.grade_id === 'XD-HYBRID Exclusive Sports') {
                                  if (targetEst.seat_color === '【6人乗り】キャプテンシート（ブラック・ナッパレザー）') {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { className: 'text', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 552
                                        }
                                      },
                                      targetEst.seat_color + ' ',
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { display: 'inline-block' }, __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 552
                                          }
                                        },
                                        '+ \xA5143,000'
                                      )
                                    );
                                  }
                                }
                              }
                              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'text', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 558
                                  }
                                },
                                targetEst.seat_color
                              );
                            }()
                          )
                        );
                      }
                    }()
                  )
                ),
                function () {
                  if (targetEst.moption_list && targetEst.moption_list !== '') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'EstimationHistory__container__detail__options', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 571
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dl',
                        { className: 'EstimationHistory__container__detail__options__list', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 572
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'dt',
                          { className: 'EstimationHistory__container__detail__options__list__title', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 573
                            }
                          },
                          makerOptionTitle && makerOptionTitle !== '' ? makerOptionTitle : ''
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'dd',
                          { className: 'EstimationHistory__container__detail__options__list__data', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 574
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
                            ref: 'moption',
                            className: 'EstimationHistory__container__detail__options__list__data__moption' + (targetEst.moption_explaininfo && targetEst.moption_explaininfo !== '' ? ' hasInfo' : '') + (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].ontouchstart === null ? ' touch' : ' mouse'),
                            onClick: _this2.onClickMoption,
                            dangerouslySetInnerHTML: { __html: targetEst.moption_list },
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 575
                            }
                          }),
                          targetEst.moption_explaininfo && targetEst.moption_explaininfo !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'EstimationHistory__container__detail__options__list__data__explain', dangerouslySetInnerHTML: { __html: targetEst.moption_explaininfo }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 585
                            }
                          }) : null
                        )
                      )
                    );
                  }
                }()
              );
            }
          }()
        )
      )
    );
  };

  return EstimationHistory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  navigationTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  navigationIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  unsavedItemTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  savedItemTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  priceTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyColorTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  seatColorTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  makerOptionTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcRecommendText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbRecommendText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  estimateParam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  navigationTitle: null,
  navigationIcon: null,
  unsavedItemTabName: null,
  savedItemTabName: null,
  priceTitle: null,
  bodyColorTitle: null,
  seatColorTitle: null,
  makerOptionTitle: null,
  pcRecommendText: null,
  mbRecommendText: null,
  modelName: null,
  carId: null,
  carTypeCode: null,
  gradeId: null,
  estimateParam: null
}, _temp);
EstimationHistory.displayName = 'EstimationHistory';


/* harmony default export */ __webpack_exports__["a"] = (EstimationHistory);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_preloader__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scroll_loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interior360Items__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pannellum_css__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pannellum_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pannellum_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _initialiseProps,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\interior360\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











//
/**
 *  Interior360
 */
var Interior360 = (_temp = _class = function (_Component) {
  _inherits(Interior360, _Component);

  function Interior360(props) {
    _classCallCheck(this, Interior360);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _initialiseProps.call(_this);

    _this.props = props;
    //
    var categories = function () {
      var categories = [];
      _this.props.interior360Item.forEach(function (e) {
        if (e.props.categories && e.props.categories !== '') {
          categories.push(e.props.categories);
        }
      });
      return Array.from(new Set(categories));
      // return categories;
    }();
    var isMultipleLines = function () {
      var flg = false;
      _this.props.interior360Item.forEach(function (e) {
        var pcInteriorName = e.props.pcInteriorName;
        // const mbInteriorName = e.props.mbInteriorName;
        if (pcInteriorName && pcInteriorName !== '') {
          if (0 <= pcInteriorName.indexOf('|')) {
            flg = true;
          }
        } else {
          // if (mbInteriorName && mbInteriorName !== '') {
          //   if (0 <= mbInteriorName.indexOf('|')) {
          //     flg = true;
          //   }
          // }
        }
      });
      return flg;
    }();
    var isSingleLines = function () {
      var flg = false;
      _this.props.interior360Item.forEach(function (e) {
        var pcInteriorName = e.props.pcInteriorName;
        if (pcInteriorName && pcInteriorName !== '') {
          flg = true;
        }
      });
      return flg;
    }();
    // チップが1つのときはアイコンは表示しない、各カテゴリに2つ以上のアイコンがある場合は表示する
    var isViewIcons = function () {
      var arr = [];
      _this.props.interior360Item.forEach(function (e) {
        var flg = true;
        var i = void 0,
            max = void 0;
        for (i = 0, max = arr.length; i < max; i = i + 1) {
          if (arr[i].categories === e.props.categories) {
            flg = false;
            arr[i].count += 1;
          }
        }
        if (flg) {
          arr.push({
            categories: e.props.categories,
            count: 1
          });
        }
      });
      var i = void 0,
          max = void 0;
      for (i = 0, max = arr.length; i < max; i = i + 1) {
        if (2 <= arr[i].count) {
          return true;
        }
      }
      return false;
    }();
    var items = function () {
      if (!categories || categories.length <= 0) return _this.props.interior360Item;
      var arr = [];
      _this.props.interior360Item.forEach(function (child, index) {
        if (child.props.categories === categories[0]) {
          arr.push(child);
        }
      });
      return arr;
    }();
    var variations = function () {
      var arr = [];
      var src = items[0].props.interiorViewImageSrc || null;
      var name = items[0].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name
        });
      }
      var subSrc = items[0].props.subInteriorViewImageSrc || null;
      var subName = items[0].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName
        });
      }
      return arr;
    }();
    //
    _this.state = {
      currentCategoryIndex: 0,
      currentItemIndex: 0,
      currentVariationIndex: 0,
      isMultipleLines: isMultipleLines,
      isSingleLines: isSingleLines,
      isViewIcons: isViewIcons,
      categories: categories,
      items: items,
      variations: variations,
      loading: false,
      isScrollEnabled: false
    };
    //
    _this._intervalId = null;
    _this._intervalId2 = null;
    _this._intervalId3 = null;
    _this._ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this._container3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this._categories = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this._id = 'panorama' + Math.floor(Math.random() * 1000);

    _this._viewer = null;
    return _this;
  }

  Interior360.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // 360ライブラリ読み込む
    if (0 <= String(location.hostname).indexOf('localhost') || 0 <= String(location.host).indexOf('3199')) {
      // https://pannellum.org/documentation/reference/
      var script = document.createElement('script');
      script.src = '/assets-dev/pannellum.js';
      script.async = true;
      document.body.appendChild(script);
    }

    if (this._intervalId) clearInterval(this._intervalId);
    this._intervalId = setInterval(function () {
      if (window.pannellum && _this2._ref.current) {
        clearInterval(_this2._intervalId);
        _this2.setImage(function () {
          var data = _this2.state.items[0].props;
          return data.interiorViewImageSrc;
        }());
      }
    }, 500);
  };

  // カテゴリ変更


  // アイテム変更


  // バリエーション変更


  // イメージ変更


  Interior360.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        pcTitleText = _props.pcTitleText,
        mbTitleText = _props.mbTitleText,
        text360 = _props.text360,
        icon360Src = _props.icon360Src;

    // タイトル表示

    var renderPcTitle = function renderPcTitle() {
      var text = pcTitleText && pcTitleText !== '' ? pcTitleText : null;
      if (text) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Interior360__title pc', dangerouslySetInnerHTML: { __html: text }, __source: {
            fileName: _jsxFileName,
            lineNumber: 380
          }
        });
      } else {
        return null;
      }
    };

    // タイトル表示
    var renderMbTitle = function renderMbTitle() {
      var text = null;
      if (mbTitleText && mbTitleText !== '') {
        text = mbTitleText;
      } else if (pcTitleText && pcTitleText !== '') {
        text = pcTitleText;
      }
      if (text) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Interior360__title mb', dangerouslySetInnerHTML: { __html: text }, __source: {
            fileName: _jsxFileName,
            lineNumber: 397
          }
        });
      } else {
        return null;
      }
    };

    // カテゴリ表示
    var renderCategories = function renderCategories() {
      if (!_this3.state.categories || _this3.state.categories.length <= 1) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__categories', ref: _this3._categories, __source: {
            fileName: _jsxFileName,
            lineNumber: 408
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'Interior360__categories__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 409
            }
          },
          function () {
            return _this3.state.categories.map(function (val, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: i, className: _this3.state.currentCategoryIndex === i ? 'current' : '', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 412
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'Interior360__categories__link', href: 'javascript:void(0)', onClick: function onClick(e) {
                    e.preventDefault();
                    // カテゴリ変更
                    _this3.changeCategory(i);
                  }, dangerouslySetInnerHTML: { __html: val.replace('|', '<br />') }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 413
                  }
                })
              )
              // <li key={i}>
              //   <a className={'Interior360__categories__link' + (this.state.currentCategoryIndex === i ? ' current' : '')} href="" onClick={(e)=> {
              //     e.preventDefault();
              //     // カテゴリ変更
              //     this.changeCategory(i);
              //   }}>{val}</a>
              // </li>
              ;
            });
          }()
        )
      );
    };

    // アイテム表示
    var renderItems = function renderItems() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__container3 opened', ref: _this3._container3, __source: {
            fileName: _jsxFileName,
            lineNumber: 436
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Interior360Items__["a" /* default */], {
          currentItemIndex: _this3.state.currentItemIndex,
          items: _this3.state.items,
          isMultipleLines: _this3.state.isMultipleLines,
          isSingleLines: _this3.state.isSingleLines,
          onChangeItem: function onChangeItem(index) {
            _this3.onChangeItem(index);
          },
          isViewIcons: _this3.state.isViewIcons,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 437
          }
        })
      );
    };

    // ビューアー表示
    var renderViewer = function renderViewer() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Interior360__viewer', id: _this3._id, __source: {
          fileName: _jsxFileName,
          lineNumber: 454
        }
      });
      // const data = this.state.items[this.state.currentItemIndex].props;
      // return (
      //   <div className="Interior360__viewer">
      //     <img src={(()=> {
      //       if (this.state.currentVariationIndex === 0) {
      //         return data.interiorViewImageSrc;
      //       } else if (this.state.currentVariationIndex === 1) {
      //         return data.subInteriorViewImageSrc;
      //       } else {
      //         return data.interiorViewImageSrc;
      //       }
      //     })()} alt=""/>
      //   </div>
      // )
    };

    // アイコン表示
    var renderIcon = function renderIcon() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'Interior360__icon', __source: {
            fileName: _jsxFileName,
            lineNumber: 475
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: icon360Src, alt: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 475
          }
        }),
        text360
      );
    };

    // バリエーション表示
    var renderVariation = function renderVariation() {
      if (!_this3.state.variations || _this3.state.variations.length <= 1) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__variation', __source: {
            fileName: _jsxFileName,
            lineNumber: 483
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'Interior360__variation__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 484
            }
          },
          function () {
            return _this3.state.variations.map(function (e, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: i, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 488
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'Interior360__variation__link' + (_this3.state.currentVariationIndex === i ? ' current' : ''), href: '', onClick: function onClick(e) {
                      e.preventDefault();
                      // バリエーション変更
                      _this3.changeVariation(i);
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 489
                    }
                  },
                  e.name
                )
              );
            });
          }()
        )
      );
    };

    // バリエーション表示
    var renderVariationMb = function renderVariationMb() {
      if (!_this3.state.variations || _this3.state.variations.length <= 1) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__variation-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 507
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'Interior360__variation-mb__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 508
            }
          },
          function () {
            return _this3.state.variations.map(function (e, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: i, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 512
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'Interior360__variation-mb__link' + (_this3.state.currentVariationIndex === i ? ' current' : ''), href: '', onClick: function onClick(e) {
                      e.preventDefault();
                      // バリエーション変更
                      _this3.changeVariation(i);
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 513
                    }
                  },
                  e.name
                )
              );
            });
          }()
        )
      );
    };

    // PhotoInfo表示
    var renderPhotoInfo = function renderPhotoInfo() {
      var data = _this3.state.items[_this3.state.currentItemIndex].props;
      if (!data.photoInfo || !data.photoInfo[0] || !data.photoInfo[0].props) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__photo-info', __source: {
            fileName: _jsxFileName,
            lineNumber: 532
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_photo_info__["a" /* default */], _extends({}, data.photoInfo[0].props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 533
          }
        }))
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 539
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 543
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'Interior360', ref: this._ref, __source: {
              fileName: _jsxFileName,
              lineNumber: 544
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Interior360__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 545
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Wysiwyg', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 546
                }
              },
              renderPcTitle(),
              renderMbTitle()
            ),
            renderCategories(),
            renderItems(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Interior360__container2', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 552
                }
              },
              renderViewer(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_preloader__["a" /* default */], { loading: this.state.loading, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 554
                }
              }),
              renderVariation(),
              renderIcon(),
              renderPhotoInfo()
            ),
            renderVariationMb()
          )
        )
      )
    );
  };

  return Interior360;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTitleText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitleText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interior360Item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  text360: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon360Src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  pcTitleText: null,
  mbTitleText: null,
  interior360Item: null,
  text360: null,
  icon360Src: null
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.changeCategory = function (index) {
    //
    var items = function () {
      if (!_this4.state.categories || _this4.state.categories.length <= 0) return _this4.props.interior360Item;
      var arr = [];
      _this4.props.interior360Item.forEach(function (child) {
        if (child.props.categories === _this4.state.categories[index]) {
          arr.push(child);
        }
      });
      return arr;
    }();
    //
    var variations = function () {
      var arr = [];
      var src = items[0].props.interiorViewImageSrc || null;
      var name = items[0].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name
        });
      }
      var subSrc = items[0].props.subInteriorViewImageSrc || null;
      var subName = items[0].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName
        });
      }
      return arr;
    }();
    //
    _this4.setState({
      currentCategoryIndex: index,
      currentItemIndex: 0,
      currentVariationIndex: 0,
      items: items,
      variations: variations
    });
    // イメージ変更
    _this4.setImage(function () {
      var data = items[0].props;
      // const data = this.state.items[0].props;
      return data.interiorViewImageSrc;
    }());

    // フェードイン
    _this4._container3.current.classList.remove('opened');
    setTimeout(function () {
      _this4._container3.current.classList.add('opened');
    }, 200);

    // スクロール
    if (_this4._categories.current) {
      var easing = function easing(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
      };
      var time = 0;
      var li = _this4._categories.current.getElementsByTagName('li')[index];
      var target = li.offsetLeft + li.offsetWidth / 2 - _this4._categories.current.clientWidth / 2;
      var current = _this4._categories.current.scrollLeft;
      var sub = target - current;
      if (_this4._intervalId3) clearInterval(_this4._intervalId3);
      _this4._intervalId3 = setInterval(function () {
        time = time + 1 / 30 * 2;
        if (1 < time) {
          clearInterval(_this4._intervalId3);
        } else {
          _this4._categories.current.scrollLeft = current + easing(time, 0, 1, 1) * sub;
        }
      }, 1000 / 30);
    }
  };

  this.onChangeItem = function (index) {
    //
    var variations = function () {
      var arr = [];
      var src = _this4.state.items[index].props.interiorViewImageSrc || null;
      var name = _this4.state.items[index].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name
        });
      }
      var subSrc = _this4.state.items[index].props.subInteriorViewImageSrc || null;
      var subName = _this4.state.items[index].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName
        });
      }
      return arr;
    }();

    //
    _this4.setState({
      currentItemIndex: index,
      currentVariationIndex: 0,
      variations: variations
    });

    // イメージ変更
    _this4.setImage(function () {
      var data = _this4.state.items[index].props;
      return data.interiorViewImageSrc;
    }());
  };

  this.changeVariation = function (index) {
    _this4.setState({
      currentVariationIndex: index
    });
    // イメージ変更
    _this4.setImage(function () {
      var data = _this4.state.items[_this4.state.currentItemIndex].props;
      if (index === 0) {
        return data.interiorViewImageSrc;
      } else if (index === 1) {
        return data.subInteriorViewImageSrc;
      }
      return data.interiorViewImageSrc;
    }());
  };

  this.setImage = function (src) {
    _this4.setState({
      loading: true
    });

    // 要素を削除
    var parent = document.getElementById(_this4._id);
    while (parent.lastChild) {
      parent.removeChild(parent.lastChild);
    }

    // 初期化
    if (_this4._viewer) {
      _this4._viewer.destroy();
    }

    _this4._viewer = pannellum.viewer(_this4._id, {
      type: 'equirectangular',
      autoLoad: true,
      showZoomCtrl: false,
      showFullscreenCtrl: false,
      showControls: false,
      yaw: -90,
      pitch: -14,
      panorama: src,
      // mouseZoom: true,
      mouseZoom: false
    }).on('load', function () {

      // GTMイベント
      __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].dataLayer = __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].dataLayer || [];
      __WEBPACK_IMPORTED_MODULE_9__constants_environment__["k" /* WINDOW */].dataLayer.push({
        interior360_img: src,
        // interior360_img: '[' + src + ']',
        event: 'interior360_load'
      });

      setTimeout(function () {
        _this4.setState({
          loading: false
        });
      }, 500);
    });
  };
}, _temp);
Interior360.displayName = 'Interior360';


/* harmony default export */ __webpack_exports__["a"] = (Interior360);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wrapper__ = __webpack_require__(2);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\interior360-item\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  Interior360Item
 */
var Interior360Item = (_temp = _class = function (_Component) {
  _inherits(Interior360Item, _Component);

  function Interior360Item(props) {
    _classCallCheck(this, Interior360Item);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  Interior360Item.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        iconSrc = _props.iconSrc,
        pcInteriorName = _props.pcInteriorName,
        index = _props.index,
        _onMouseOver = _props.onMouseOver,
        _onMouseOut = _props.onMouseOut,
        _onClick = _props.onClick,
        isCurrent = _props.isCurrent;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360Item', __source: {
            fileName: _jsxFileName,
            lineNumber: 71
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'Interior360Item__link' + (isCurrent ? ' current' : ''), href: 'javascript:void(0)',
            onMouseOver: function onMouseOver(e) {
              e.preventDefault();
              _onMouseOver(index);
            },
            onMouseOut: function onMouseOut(e) {
              e.preventDefault();
              _onMouseOut(index);
            },
            onClick: function onClick(e) {
              e.preventDefault();
              _onClick(index);
            },
            style: { backgroundImage: 'url(' + iconSrc + ')' }, __source: {
              fileName: _jsxFileName,
              lineNumber: 72
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Interior360Item__box', __source: {
                fileName: _jsxFileName,
                lineNumber: 86
              }
            },
            pcInteriorName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Interior360Item__border', __source: {
                fileName: _jsxFileName,
                lineNumber: 87
              }
            },
            '\xA0'
          )
        )
      )
    );
  };

  return Interior360Item;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcInteriorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbInteriorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  categories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interiorViewImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  interiorViewName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subInteriorViewImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subInteriorViewName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  photoInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  iconSrc: null,
  pcInteriorName: null,
  mbInteriorName: null,
  categories: null,
  interiorViewImageSrc: null,
  interiorViewName: null,
  subInteriorViewImageSrc: null,
  subInteriorViewName: null,
  photoInfo: null,
  index: null,
  onMouseOver: null,
  onMouseOut: null,
  onClick: null,
  isCurrent: false
}, _temp);
Interior360Item.displayName = 'Interior360Item';


/* harmony default export */ __webpack_exports__["a"] = (Interior360Item);

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Interior360":"Interior360","Interior360__container":"Interior360__container","Interior360__title":"Interior360__title","pc":"pc","mb":"mb","Interior360__categories":"Interior360__categories","Interior360__categories__list":"Interior360__categories__list","Interior360__categories__link":"Interior360__categories__link","current":"current","Interior360__items":"Interior360__items","Interior360__items__list":"Interior360__items__list","Interior360__interior-name":"Interior360__interior-name","singleline":"singleline","multiline":"multiline","Interior360__container2":"Interior360__container2","Interior360__container3":"Interior360__container3","opened":"opened","Interior360__viewer":"Interior360__viewer","Interior360__icon":"Interior360__icon","Interior360__variation":"Interior360__variation","Interior360__variation__list":"Interior360__variation__list","Interior360__variation__link":"Interior360__variation__link","Interior360__variation-mb":"Interior360__variation-mb","Interior360__photo-info":"Interior360__photo-info","scrollEnabled":"scrollEnabled","Interior360__variation-mb__list":"Interior360__variation-mb__list","Interior360__variation-mb__link":"Interior360__variation-mb__link","PhotoInfo":"PhotoInfo","PhotoInfo__btn__open":"PhotoInfo__btn__open","pnlm-container":"pnlm-container","pnlm-load-box":"pnlm-load-box","pnlm-about-msg":"pnlm-about-msg"};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_global_navigation__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_promo_navigation__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_car_navigation__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_global_navigation_link__ = __webpack_require__(299);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\global-navigation\\index.jsx';




// import CarNavigation from '../../containers/html';




var GlobalNavigationBlock = function GlobalNavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_global_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};
GlobalNavigationBlock.displayName = 'GlobalNavigationBlock';
GlobalNavigationBlock.displayName = 'GlobalNavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_promo_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_car_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__containers_global_navigation_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_html__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(GlobalNavigationBlock));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_promo_navigation__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_promo_navigation_container__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\promo-navigation\\index.jsx';








var PromoNavigationBlock = function PromoNavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_promo_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    }
  }));
};
PromoNavigationBlock.displayName = 'PromoNavigationBlock';
PromoNavigationBlock.displayName = 'PromoNavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_promo_navigation_container__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__containers_wysiwyg__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(PromoNavigationBlock));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_promo_navigation_container__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_promo_navigation_item__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\promo-navigation-container\\index.jsx';








var PromoNavigationContainerBlock = function PromoNavigationContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_promo_navigation_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    }
  }));
};
PromoNavigationContainerBlock.displayName = 'PromoNavigationContainerBlock';
PromoNavigationContainerBlock.displayName = 'PromoNavigationContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_promo_navigation_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__containers_wysiwyg__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(PromoNavigationContainerBlock));

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_car_navigation__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_car_navigation_link_item__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\car-navigation\\index.jsx';






var CarNavigationBlock = function CarNavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_car_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
CarNavigationBlock.displayName = 'CarNavigationBlock';
CarNavigationBlock.displayName = 'CarNavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_car_navigation_link_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_cta__["a" /* default */]],
  mapInputToOutput: [['pageLinks', 'pageLinks'], ['commonLinks', 'commonLinks']]
})(CarNavigationBlock));

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_car_navigation_link_item__ = __webpack_require__(154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\car-navigation-link-item\\index.jsx';




var CarNavigationLinkItemBlock = function CarNavigationLinkItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_car_navigation_link_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    }
  }));
};
CarNavigationLinkItemBlock.displayName = 'CarNavigationLinkItemBlock';
CarNavigationLinkItemBlock.displayName = 'CarNavigationLinkItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [],
  mapInputToOutput: [
    // ['passengerCarFilters', 'passengerCarFilters'],
    // ['models', 'models'],
  ]
})(CarNavigationLinkItemBlock));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\photogallery-item\\index.jsx';





var PhotogalleryItemBlock = function PhotogalleryItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_photogallery_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
PhotogalleryItemBlock.displayName = 'PhotogalleryItemBlock';
PhotogalleryItemBlock.displayName = 'PhotogalleryItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(PhotogalleryItemBlock));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_feature_category_container__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\feature-category-container\\index.jsx';








var FeatureCategoryContainerBlock = function FeatureCategoryContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_feature_category_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    }
  }));
};
FeatureCategoryContainerBlock.displayName = 'FeatureCategoryContainerBlock';
FeatureCategoryContainerBlock.displayName = 'FeatureCategoryContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_2__containers_feature_category_container__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__containers_wysiwyg__["a" /* default */]],
  mapInputToOutput: [['components', 'components']]
})(FeatureCategoryContainerBlock));

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_picker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_picker_container__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_promo_and_button_modal_window__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\picker\\index.jsx';







var PickerBlock = function PickerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_picker__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    }
  }));
};
PickerBlock.displayName = 'PickerBlock';
PickerBlock.displayName = 'Picker';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_picker_container__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_cta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_promo_and_button_modal_window__["a" /* default */]],
  mapInputToOutput: [['categories', 'categories'], ['cta', 'cta']]
})(PickerBlock));

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_picker_container__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_picker_item__ = __webpack_require__(343);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\picker-container\\index.jsx';





var PickerContainerBlock = function PickerContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_picker_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
PickerContainerBlock.displayName = 'PickerContainerBlock';
PickerContainerBlock.displayName = 'PickerContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_2__containers_picker_container__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__blocks_picker_item__["a" /* default */]],
  mapInputToOutput: [['components', 'components']]
})(PickerContainerBlock));

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_picker_item__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\picker-item\\index.jsx';





var PickerItemBlock = function PickerItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_picker_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
PickerItemBlock.displayName = 'PickerItemBlock';
PickerItemBlock.displayName = 'PickerItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(PickerItemBlock));

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_equipment_container__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_equipment_item__ = __webpack_require__(319);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\equipment-container\\index.jsx';





var EquipmentContainerBlock = function EquipmentContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_equipment_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
EquipmentContainerBlock.displayName = 'EquipmentContainerBlock';
EquipmentContainerBlock.displayName = 'EquipmentContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_equipment_item__["a" /* default */]],
  mapInputToOutput: [['equipmentItem', 'equipmentItem']]
})(EquipmentContainerBlock));

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_grade_and_spec_data__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\grade-and-spec-data\\index.jsx';




// import BodySize from '../../containers/body-size';
// import Equipment from '../../blocks/equipment';
// import MakerSetOption from '../../blocks/maker-set-option';
// import SpecComparison from '../../blocks/spec-comparison';
// import OwnerLibraryContainer from '../../containers/owner-library-container';
// import Html from '../../containers/html';
// import Wysiwyg from '../../containers/wysiwyg';

var GradeAndSpecDataBlock = function GradeAndSpecDataBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_grade_and_spec_data__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    }
  }));
};
GradeAndSpecDataBlock.displayName = 'GradeAndSpecDataBlock';
GradeAndSpecDataBlock.displayName = 'GradeAndSpecData';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['photoInfo', 'photoInfo']]
})(GradeAndSpecDataBlock));

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_car_lineup_filter__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_car_lineup_filter_item__ = __webpack_require__(347);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\car-lineup-filter\\index.jsx';





var CarLineupFilterBlock = function CarLineupFilterBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_car_lineup_filter__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
CarLineupFilterBlock.displayName = 'CarLineupFilterBlock';
CarLineupFilterBlock.displayName = 'CarLineupFilter';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_car_lineup_filter_item__["a" /* default */]],
  mapInputToOutput: []
})(CarLineupFilterBlock));

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_car_lineup_filter_item__ = __webpack_require__(168);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\car-lineup-filter-item\\index.jsx';




var CarLineupFilterItemBlock = function CarLineupFilterItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_car_lineup_filter_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    }
  }));
};
CarLineupFilterItemBlock.displayName = 'CarLineupFilterItemBlock';
CarLineupFilterItemBlock.displayName = 'CarLineupFilterItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [],
  mapInputToOutput: []
})(CarLineupFilterItemBlock));

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\one-column-layout\\index.jsx';



//import TwoColumnLayout from '../../blocks/two-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';









var OneColumnLayoutBlock = function OneColumnLayoutBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_one_column_layout__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    }
  }));
};
OneColumnLayoutBlock.displayName = 'OneColumnLayoutBlock';
OneColumnLayoutBlock.displayName = 'OneColumnLayout';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [
  //OneColumnLayout,
  //ThreeColumnLayout,
  //FourColumnLayout,
  __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__containers_html__["a" /* default */]],
  mapInputToOutput: [['components', 'components']]
})(OneColumnLayoutBlock));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\two-column-layout\\index.jsx';



//import OneColumnLayout from '../../blocks/one-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';









var TwoColumnLayoutBlock = function TwoColumnLayoutBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_two_column_layout__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    }
  }));
};
TwoColumnLayoutBlock.displayName = 'TwoColumnLayoutBlock';
TwoColumnLayoutBlock.displayName = 'TwoColumnLayout';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [
  //OneColumnLayout,
  //ThreeColumnLayout,
  //FourColumnLayout,
  __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__containers_html__["a" /* default */]],
  mapInputToOutput: [['firstContent', 'firstContent'], ['secondContent', 'secondContent']]
})(TwoColumnLayoutBlock));

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\three-column-layout\\index.jsx';



//import OneColumnLayout from '../../blocks/one-column-layout';
//import TwoColumnLayout from '../../blocks/two-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';









var ThreeColumnLayoutBlock = function ThreeColumnLayoutBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_three_column_layout__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    }
  }));
};
ThreeColumnLayoutBlock.displayName = 'ThreeColumnLayoutBlock';
ThreeColumnLayoutBlock.displayName = 'ThreeColumnLayout';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [
  //OneColumnLayout,
  //TwoColumnLayout,
  //FourColumnLayout,
  __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__containers_html__["a" /* default */]],
  mapInputToOutput: [['firstContent', 'firstContent'], ['secondContent', 'secondContent'], ['thirdContent', 'thirdContent']]
})(ThreeColumnLayoutBlock));

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_four_column_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\four-column-layout\\index.jsx';



//import OneColumnLayout from '../../blocks/one-column-layout';
//import TwoColumnLayout from '../../blocks/two-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';









var FourColumnLayoutBlock = function FourColumnLayoutBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_four_column_layout__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    }
  }));
};
FourColumnLayoutBlock.displayName = 'FourColumnLayoutBlock';
FourColumnLayoutBlock.displayName = 'FourColumnLayout';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [
  //OneColumnLayout,
  //TwoColumnLayout,
  //ThreeColumnLayout,
  __WEBPACK_IMPORTED_MODULE_3__blocks_photogallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_presentation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_slideshow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_slidegallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__containers_html__["a" /* default */]],
  mapInputToOutput: [['firstContent', 'firstContent'], ['secondContent', 'secondContent'], ['thirdContent', 'thirdContent'], ['fourthContent', 'fourthContent']]
})(FourColumnLayoutBlock));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accordion_item__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_four_column_layout__ = __webpack_require__(59);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accordion-item\\index.jsx';










var AccordionItemBlock = function AccordionItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accordion_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    }
  }));
};
AccordionItemBlock.displayName = 'AccordionItemBlock';
AccordionItemBlock.displayName = 'AccordionItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__containers_one_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__containers_two_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_three_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__containers_four_column_layout__["a" /* default */]],
  mapInputToOutput: []
})(AccordionItemBlock));

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_body_type_tab_name__ = __webpack_require__(172);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-body-type-tab-name\\index.jsx';




var AccessoryBodyTypeTabNameBlock = function AccessoryBodyTypeTabNameBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_body_type_tab_name__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    }
  }));
};
AccessoryBodyTypeTabNameBlock.displayName = 'AccessoryBodyTypeTabNameBlock';
AccessoryBodyTypeTabNameBlock.displayName = 'AccessoryBodyTypeTabName';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [],
  mapInputToOutput: []
})(AccessoryBodyTypeTabNameBlock));

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_info_container__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_accessory_info_item__ = __webpack_require__(355);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-info-container\\index.jsx';





var AccessoryInfoContainerBlock = function AccessoryInfoContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_info_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
AccessoryInfoContainerBlock.displayName = 'AccessoryInfoContainerBlock';
AccessoryInfoContainerBlock.displayName = 'AccessoryInfoContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_accessory_info_item__["a" /* default */]],
  mapInputToOutput: []
})(AccessoryInfoContainerBlock));

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_info_item__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_presentation__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_picker__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_one_column_layout__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_two_column_layout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__blocks_three_column_layout__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__blocks_four_column_layout__ = __webpack_require__(351);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-info-item\\index.jsx';













var AccessoryInfoItemBlock = function AccessoryInfoItemBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_info_item__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    }
  }));
};
AccessoryInfoItemBlock.displayName = 'AccessoryInfoItemBlock';
AccessoryInfoItemBlock.displayName = 'AccessoryInfoItem';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_wysiwyg__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_promo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_presentation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__blocks_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_one_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__blocks_two_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__blocks_three_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__blocks_four_column_layout__["a" /* default */]],
  mapInputToOutput: []
})(AccessoryInfoItemBlock));

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_MAPS_API_KEY; });
/* unused harmony export CAPTCHA_SITE_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RELEASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SENTRY_URL; });
var GOOGLE_MAPS_API_KEY = String("production").toUpperCase() === 'PRODUCTION' ? 'AIzaSyCI3qSid1Q04ev8gjZppt5BF_VZRo3FUGk' : 'AIzaSyCIkf0IT3lgjAfv22-6Dx6hRhnBCRSIY2E';
var CAPTCHA_SITE_KEY = String("production").toUpperCase() === 'PRODUCTION' ? '6LfFThYUAAAAAOMWuwswAT9GXSOpLX564H-zqags' : '6LdUTRYUAAAAANcs33Se2VJtbpiofYry4dMCyENJ';
var RELEASE = '2.5';
var SENTRY_URL = 'https://95a0afc8ae6344d4a5e2f81f44fd7c51@sentry.io/137626';

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(358);

__webpack_require__(472);

__webpack_require__(473);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(359);
__webpack_require__(361);
__webpack_require__(364);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(198);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(423);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(206);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(470);
__webpack_require__(471);
module.exports = __webpack_require__(34);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $                 = __webpack_require__(7)
  , $export           = __webpack_require__(4)
  , DESCRIPTORS       = __webpack_require__(30)
  , createDesc        = __webpack_require__(44)
  , html              = __webpack_require__(184)
  , cel               = __webpack_require__(185)
  , has               = __webpack_require__(26)
  , cof               = __webpack_require__(40)
  , invoke            = __webpack_require__(80)
  , fails             = __webpack_require__(19)
  , anObject          = __webpack_require__(11)
  , aFunction         = __webpack_require__(50)
  , isObject          = __webpack_require__(9)
  , toObject          = __webpack_require__(41)
  , toIObject         = __webpack_require__(32)
  , toInteger         = __webpack_require__(62)
  , toIndex           = __webpack_require__(63)
  , toLength          = __webpack_require__(27)
  , IObject           = __webpack_require__(81)
  , IE_PROTO          = __webpack_require__(49)('__proto__')
  , createArrayMethod = __webpack_require__(82)
  , arrayIndexOf      = __webpack_require__(187)(false)
  , ObjectProto       = Object.prototype
  , ArrayProto        = Array.prototype
  , arraySlice        = ArrayProto.slice
  , arrayJoin         = ArrayProto.join
  , defineProperty    = $.setDesc
  , getOwnDescriptor  = $.getDesc
  , defineProperties  = $.setDescs
  , factories         = {}
  , IE8_DOM_DEFINE;

if(!DESCRIPTORS){
  IE8_DOM_DEFINE = !fails(function(){
    return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
  });
  $.setDesc = function(O, P, Attributes){
    if(IE8_DOM_DEFINE)try {
      return defineProperty(O, P, Attributes);
    } catch(e){ /* empty */ }
    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
    if('value' in Attributes)anObject(O)[P] = Attributes.value;
    return O;
  };
  $.getDesc = function(O, P){
    if(IE8_DOM_DEFINE)try {
      return getOwnDescriptor(O, P);
    } catch(e){ /* empty */ }
    if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
  };
  $.setDescs = defineProperties = function(O, Properties){
    anObject(O);
    var keys   = $.getKeys(Properties)
      , length = keys.length
      , i = 0
      , P;
    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
    return O;
  };
}
$export($export.S + $export.F * !DESCRIPTORS, 'Object', {
  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $.getDesc,
  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  defineProperty: $.setDesc,
  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
  defineProperties: defineProperties
});

  // IE 8- don't enum bug keys
var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
            'toLocaleString,toString,valueOf').split(',')
  // Additional keys for getOwnPropertyNames
  , keys2 = keys1.concat('length', 'prototype')
  , keysLen1 = keys1.length;

// Create object with `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = cel('iframe')
    , i      = keysLen1
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write('<script>document.F=Object</script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict.prototype[keys1[i]];
  return createDict();
};
var createGetKeys = function(names, length){
  return function(object){
    var O      = toIObject(object)
      , i      = 0
      , result = []
      , key;
    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(length > i)if(has(O, key = names[i++])){
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };
};
var Empty = function(){};
$export($export.S, 'Object', {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  getPrototypeOf: $.getProto = $.getProto || function(O){
    O = toObject(O);
    if(has(O, IE_PROTO))return O[IE_PROTO];
    if(typeof O.constructor == 'function' && O instanceof O.constructor){
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectProto : null;
  },
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  create: $.create = $.create || function(O, /*?*/Properties){
    var result;
    if(O !== null){
      Empty.prototype = anObject(O);
      result = new Empty();
      Empty.prototype = null;
      // add "__proto__" for Object.getPrototypeOf shim
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : defineProperties(result, Properties);
  },
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
});

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }
  return factories[len](F, args);
};

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
$export($export.P, 'Function', {
  bind: function bind(that /*, args... */){
    var fn       = aFunction(this)
      , partArgs = arraySlice.call(arguments, 1);
    var bound = function(/* args... */){
      var args = partArgs.concat(arraySlice.call(arguments));
      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
    };
    if(isObject(fn.prototype))bound.prototype = fn.prototype;
    return bound;
  }
});

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * fails(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});
$export($export.P + $export.F * (IObject != Object), 'Array', {
  join: function join(separator){
    return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
  }
});

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
$export($export.S, 'Array', {isArray: __webpack_require__(122)});

var createArrayReduce = function(isRight){
  return function(callbackfn, memo){
    aFunction(callbackfn);
    var O      = IObject(this)
      , length = toLength(O.length)
      , index  = isRight ? length - 1 : 0
      , i      = isRight ? -1 : 1;
    if(arguments.length < 2)for(;;){
      if(index in O){
        memo = O[index];
        index += i;
        break;
      }
      index += i;
      if(isRight ? index < 0 : length <= index){
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
      memo = callbackfn(memo, O[index], index, this);
    }
    return memo;
  };
};

var methodize = function($fn){
  return function(arg1/*, arg2 = undefined */){
    return $fn(this, arg1, arguments[1]);
  };
};

$export($export.P, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: $.each = $.each || methodize(createArrayMethod(0)),
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: methodize(createArrayMethod(1)),
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: methodize(createArrayMethod(2)),
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: methodize(createArrayMethod(3)),
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: methodize(createArrayMethod(4)),
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: createArrayReduce(false),
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: createArrayReduce(true),
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: methodize(arrayIndexOf),
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
    if(index < 0)index = toLength(length + index);
    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
    return -1;
  }
});

// 20.3.3.1 / 15.9.4.4 Date.now()
$export($export.S, 'Date', {now: function(){ return +new Date; }});

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(this))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var isObject = __webpack_require__(9)
  , isArray  = __webpack_require__(122)
  , SPECIES  = __webpack_require__(12)('species');
module.exports = function(original, length){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return new (C === undefined ? Array : C)(length);
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var $              = __webpack_require__(7)
  , global         = __webpack_require__(14)
  , has            = __webpack_require__(26)
  , DESCRIPTORS    = __webpack_require__(30)
  , $export        = __webpack_require__(4)
  , redefine       = __webpack_require__(31)
  , $fails         = __webpack_require__(19)
  , shared         = __webpack_require__(186)
  , setToStringTag = __webpack_require__(64)
  , uid            = __webpack_require__(49)
  , wks            = __webpack_require__(12)
  , keyOf          = __webpack_require__(362)
  , $names         = __webpack_require__(188)
  , enumKeys       = __webpack_require__(363)
  , isArray        = __webpack_require__(122)
  , anObject       = __webpack_require__(11)
  , toIObject      = __webpack_require__(32)
  , createDesc     = __webpack_require__(44)
  , getDesc        = $.getDesc
  , setDesc        = $.setDesc
  , _create        = $.create
  , getNames       = $names.get
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , setter         = false
  , HIDDEN         = wks('_hidden')
  , isEnum         = $.isEnum
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , useNative      = typeof $Symbol == 'function'
  , ObjectProto    = Object.prototype;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(setDesc({}, 'a', {
    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = getDesc(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  setDesc(it, key, D);
  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
} : setDesc;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol.prototype);
  sym._k = tag;
  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
    configurable: true,
    set: function(value){
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    }
  });
  return sym;
};

var isSymbol = function(it){
  return typeof it == 'symbol';
};

var $defineProperty = function defineProperty(it, key, D){
  if(D && has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return setDesc(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key);
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
    ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  var D = getDesc(it = toIObject(it), key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
  return result;
};
var $stringify = function stringify(it){
  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
  var args = [it]
    , i    = 1
    , $$   = arguments
    , replacer, $replacer;
  while($$.length > i)args.push($$[i++]);
  replacer = args[1];
  if(typeof replacer == 'function')$replacer = replacer;
  if($replacer || !isArray(replacer))replacer = function(key, value){
    if($replacer)value = $replacer.call(this, key, value);
    if(!isSymbol(value))return value;
  };
  args[1] = replacer;
  return _stringify.apply($JSON, args);
};
var buggyJSON = $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
});

// 19.4.1.1 Symbol([description])
if(!useNative){
  $Symbol = function Symbol(){
    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
  };
  redefine($Symbol.prototype, 'toString', function toString(){
    return this._k;
  });

  isSymbol = function(it){
    return it instanceof $Symbol;
  };

  $.create     = $create;
  $.isEnum     = $propertyIsEnumerable;
  $.getDesc    = $getOwnPropertyDescriptor;
  $.setDesc    = $defineProperty;
  $.setDescs   = $defineProperties;
  $.getNames   = $names.get = $getOwnPropertyNames;
  $.getSymbols = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(123)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
}

var symbolStatics = {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    return keyOf(SymbolRegistry, key);
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
};
// 19.4.2.2 Symbol.hasInstance
// 19.4.2.3 Symbol.isConcatSpreadable
// 19.4.2.4 Symbol.iterator
// 19.4.2.6 Symbol.match
// 19.4.2.8 Symbol.replace
// 19.4.2.9 Symbol.search
// 19.4.2.10 Symbol.species
// 19.4.2.11 Symbol.split
// 19.4.2.12 Symbol.toPrimitive
// 19.4.2.13 Symbol.toStringTag
// 19.4.2.14 Symbol.unscopables
$.each.call((
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
  'species,split,toPrimitive,toStringTag,unscopables'
).split(','), function(it){
  var sym = wks(it);
  symbolStatics[it] = useNative ? sym : wrap(sym);
});

setter = true;

$export($export.G + $export.W, {Symbol: $Symbol});

$export($export.S, 'Symbol', symbolStatics);

$export($export.S + $export.F * !useNative, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});

// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var $         = __webpack_require__(7)
  , toIObject = __webpack_require__(32);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = $.getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var $ = __webpack_require__(7);
module.exports = function(it){
  var keys       = $.getKeys(it)
    , getSymbols = $.getSymbols;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = $.isEnum
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
  }
  return keys;
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(365)});

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.1 Object.assign(target, source, ...)
var $        = __webpack_require__(7)
  , toObject = __webpack_require__(41)
  , IObject  = __webpack_require__(81);

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = __webpack_require__(19)(function(){
  var a = Object.assign
    , A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , $$    = arguments
    , $$len = $$.length
    , index = 1
    , getKeys    = $.getKeys
    , getSymbols = $.getSymbols
    , isEnum     = $.isEnum;
  while($$len > index){
    var S      = IObject($$[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  }
  return T;
} : Object.assign;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(4);
$export($export.S, 'Object', {is: __webpack_require__(189)});

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(124).set});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(83)
  , test    = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(31)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(it) : it;
  };
});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(it) : it;
  };
});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
  };
});

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(9);

__webpack_require__(33)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(32);

__webpack_require__(33)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(41);

__webpack_require__(33)('getPrototypeOf', function($getPrototypeOf){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(41);

__webpack_require__(33)('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(33)('getOwnPropertyNames', function(){
  return __webpack_require__(188).get;
});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var setDesc    = __webpack_require__(7).setDesc
  , createDesc = __webpack_require__(44)
  , has        = __webpack_require__(26)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';
// 19.2.4.2 name
NAME in FProto || __webpack_require__(30) && setDesc(FProto, NAME, {
  configurable: true,
  get: function(){
    var match = ('' + this).match(nameRE)
      , name  = match ? match[1] : '';
    has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
    return name;
  }
});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $             = __webpack_require__(7)
  , isObject      = __webpack_require__(9)
  , HAS_INSTANCE  = __webpack_require__(12)('hasInstance')
  , FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = $.getProto(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $           = __webpack_require__(7)
  , global      = __webpack_require__(14)
  , has         = __webpack_require__(26)
  , cof         = __webpack_require__(40)
  , toPrimitive = __webpack_require__(382)
  , fails       = __webpack_require__(19)
  , $trim       = __webpack_require__(84).trim
  , NUMBER      = 'Number'
  , $Number     = global[NUMBER]
  , Base        = $Number
  , proto       = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF  = cof($.create(proto)) == NUMBER
  , TRIM        = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? new Base(toNumber(it)) : toNumber(it);
  };
  $.each.call(__webpack_require__(30) ? $.getNames(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), function(key){
    if(has(Base, key) && !has($Number, key)){
      $.setDesc($Number, key, $.getDesc(Base, key));
    }
  });
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(31)(global, NUMBER, $Number);
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(4);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(4)
  , _isFinite = __webpack_require__(14).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {isInteger: __webpack_require__(190)});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(4)
  , isInteger = __webpack_require__(190)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.12 Number.parseFloat(string)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {parseFloat: parseFloat});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.13 Number.parseInt(string, radix)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {parseInt: parseInt});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(4)
  , log1p   = __webpack_require__(191)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

// V8 bug https://code.google.com/p/v8/issues/detail?id=3509
$export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(4);

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

$export($export.S, 'Math', {asinh: asinh});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(4)
  , sign    = __webpack_require__(125);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(4)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {expm1: __webpack_require__(126)});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(4)
  , sign      = __webpack_require__(125)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(4)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum   = 0
      , i     = 0
      , $$    = arguments
      , $$len = $$.length
      , larg  = 0
      , arg, div;
    while(i < $$len){
      arg = abs($$[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(4)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(19)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {log1p: __webpack_require__(191)});

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {sign: __webpack_require__(125)});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(4)
  , expm1   = __webpack_require__(126)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(19)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(4)
  , expm1   = __webpack_require__(126)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(4)
  , toIndex        = __webpack_require__(63)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res   = []
      , $$    = arguments
      , $$len = $$.length
      , i     = 0
      , code;
    while($$len > i){
      code = +$$[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(4)
  , toIObject = __webpack_require__(32)
  , toLength  = __webpack_require__(27);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl   = toIObject(callSite.raw)
      , len   = toLength(tpl.length)
      , $$    = arguments
      , $$len = $$.length
      , res   = []
      , i     = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < $$len)res.push(String($$[i]));
    } return res.join('');
  }
});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(84)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(127)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(128)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4)
  , $at     = __webpack_require__(127)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(4)
  , toLength  = __webpack_require__(27)
  , context   = __webpack_require__(129)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(130)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , $$   = arguments
      , endPosition = $$.length > 1 ? $$[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(4)
  , context  = __webpack_require__(129)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(130)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(194)
});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(4)
  , toLength    = __webpack_require__(27)
  , context     = __webpack_require__(129)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(130)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , $$     = arguments
      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx         = __webpack_require__(36)
  , $export     = __webpack_require__(4)
  , toObject    = __webpack_require__(41)
  , call        = __webpack_require__(195)
  , isArrayIter = __webpack_require__(196)
  , toLength    = __webpack_require__(27)
  , getIterFn   = __webpack_require__(197);
$export($export.S + $export.F * !__webpack_require__(131)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , $$      = arguments
      , $$len   = $$.length
      , mapfn   = $$len > 1 ? $$[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        result[index] = mapping ? mapfn(O[index], index) : O[index];
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(19)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , $$     = arguments
      , $$len  = $$.length
      , result = new (typeof this == 'function' ? this : Array)($$len);
    while($$len > index)result[index] = $$[index++];
    result.length = $$len;
    return result;
  }
});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85)('Array');

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', {copyWithin: __webpack_require__(422)});

__webpack_require__(51)('copyWithin');

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(41)
  , toIndex  = __webpack_require__(63)
  , toLength = __webpack_require__(27);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , $$    = arguments
    , end   = $$.length > 2 ? $$[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', {fill: __webpack_require__(424)});

__webpack_require__(51)('fill');

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(41)
  , toIndex  = __webpack_require__(63)
  , toLength = __webpack_require__(27);
module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , $$     = arguments
    , $$len  = $$.length
    , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
    , end    = $$len > 2 ? $$[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(4)
  , $find   = __webpack_require__(82)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(51)(KEY);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(4)
  , $find   = __webpack_require__(82)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(51)(KEY);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $        = __webpack_require__(7)
  , global   = __webpack_require__(14)
  , isRegExp = __webpack_require__(193)
  , $flags   = __webpack_require__(200)
  , $RegExp  = global.RegExp
  , Base     = $RegExp
  , proto    = $RegExp.prototype
  , re1      = /a/g
  , re2      = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW = new $RegExp(re1) !== re1;

if(__webpack_require__(30) && (!CORRECT_NEW || __webpack_require__(19)(function(){
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
      : CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
  };
  $.each.call($.getNames(Base), function(key){
    key in $RegExp || $.setDesc($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  });
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(31)(global, 'RegExp', $RegExp);
}

__webpack_require__(85)('RegExp');

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
var $ = __webpack_require__(7);
if(__webpack_require__(30) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(200)
});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(86)('match', 1, function(defined, MATCH){
  // 21.1.3.11 String.prototype.match(regexp)
  return function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  };
});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(86)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  };
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(86)('search', 1, function(defined, SEARCH){
  // 21.1.3.15 String.prototype.search(regexp)
  return function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  };
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(86)('split', 2, function(defined, SPLIT, $split){
  // 21.1.3.17 String.prototype.split(separator, limit)
  return function split(separator, limit){
    'use strict';
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined
      ? fn.call(separator, O, limit)
      : $split.call(String(O), separator, limit);
  };
});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $          = __webpack_require__(7)
  , LIBRARY    = __webpack_require__(123)
  , global     = __webpack_require__(14)
  , ctx        = __webpack_require__(36)
  , classof    = __webpack_require__(83)
  , $export    = __webpack_require__(4)
  , isObject   = __webpack_require__(9)
  , anObject   = __webpack_require__(11)
  , aFunction  = __webpack_require__(50)
  , strictNew  = __webpack_require__(87)
  , forOf      = __webpack_require__(66)
  , setProto   = __webpack_require__(124).set
  , same       = __webpack_require__(189)
  , SPECIES    = __webpack_require__(12)('species')
  , speciesConstructor = __webpack_require__(434)
  , asap       = __webpack_require__(435)
  , PROMISE    = 'Promise'
  , process    = global.process
  , isNode     = classof(process) == 'process'
  , P          = global[PROMISE]
  , empty      = function(){ /* empty */ }
  , Wrapper;

var testResolve = function(sub){
  var test = new P(empty), promise;
  if(sub)test.constructor = function(exec){
    exec(empty, empty);
  };
  (promise = P.resolve(test))['catch'](empty);
  return promise === test;
};

var USE_NATIVE = function(){
  var works = false;
  function P2(x){
    var self = new P(x);
    setProto(self, P2.prototype);
    return self;
  }
  try {
    works = P && P.resolve && testResolve();
    setProto(P2, P);
    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
    // actual Firefox has broken subclass support, test that
    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
      works = false;
    }
    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
    if(works && __webpack_require__(30)){
      var thenableThenGotten = false;
      P.resolve($.setDesc({}, 'then', {
        get: function(){ thenableThenGotten = true; }
      }));
      works = thenableThenGotten;
    }
  } catch(e){ works = false; }
  return works;
}();

// helpers
var sameConstructor = function(a, b){
  // library wrapper special case
  if(LIBRARY && a === P && b === Wrapper)return true;
  return same(a, b);
};
var getConstructor = function(C){
  var S = anObject(C)[SPECIES];
  return S != undefined ? S : C;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var PromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve),
  this.reject  = aFunction(reject)
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(record, isReject){
  if(record.n)return;
  record.n = true;
  var chain = record.c;
  asap(function(){
    var value = record.v
      , ok    = record.s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , result, then;
      try {
        if(handler){
          if(!ok)record.h = true;
          result = handler === true ? value : handler(value);
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    chain.length = 0;
    record.n = false;
    if(isReject)setTimeout(function(){
      var promise = record.p
        , handler, console;
      if(isUnhandled(promise)){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      } record.a = undefined;
    }, 1);
  });
};
var isUnhandled = function(promise){
  var record = promise._d
    , chain  = record.a || record.c
    , i      = 0
    , reaction;
  if(record.h)return false;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var $reject = function(value){
  var record = this;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  record.v = value;
  record.s = 2;
  record.a = record.c.slice();
  notify(record, true);
};
var $resolve = function(value){
  var record = this
    , then;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  try {
    if(record.p === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      asap(function(){
        var wrapper = {r: record, d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      record.v = value;
      record.s = 1;
      notify(record, false);
    }
  } catch(e){
    $reject.call({r: record, d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  P = function Promise(executor){
    aFunction(executor);
    var record = this._d = {
      p: strictNew(this, P, PROMISE),         // <- promise
      c: [],                                  // <- awaiting reactions
      a: undefined,                           // <- checked in isUnhandled reactions
      s: 0,                                   // <- state
      d: false,                               // <- done
      v: undefined,                           // <- value
      h: false,                               // <- handled rejection
      n: false                                // <- notify
    };
    try {
      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
    } catch(err){
      $reject.call(record, err);
    }
  };
  __webpack_require__(88)(P.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction = new PromiseCapability(speciesConstructor(this, P))
        , promise  = reaction.promise
        , record   = this._d;
      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      record.c.push(reaction);
      if(record.a)record.a.push(reaction);
      if(record.s)notify(record, false);
      return promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
__webpack_require__(64)(P, PROMISE);
__webpack_require__(85)(PROMISE);
Wrapper = __webpack_require__(34)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = new PromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof P && sameConstructor(x.constructor, this))return x;
    var capability = new PromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(131)(function(iter){
  P.all(iter)['catch'](function(){});
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject
      , values     = [];
    var abrupt = perform(function(){
      forOf(iterable, false, values.push, values);
      var remaining = values.length
        , results   = Array(remaining);
      if(remaining)$.each.call(values, function(promise, index){
        var alreadyCalled = false;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled = true;
          results[index] = value;
          --remaining || resolve(results);
        }, reject);
      });
      else resolve(results);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(11)
  , aFunction = __webpack_require__(50)
  , SPECIES   = __webpack_require__(12)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(14)
  , macrotask = __webpack_require__(201).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(40)(process) == 'process'
  , head, last, notify;

var flush = function(){
  var parent, domain, fn;
  if(isNode && (parent = process.domain)){
    process.domain = null;
    parent.exit();
  }
  while(head){
    domain = head.domain;
    fn     = head.fn;
    if(domain)domain.enter();
    fn(); // <- currently we use it only for Promise - try / catch not required
    if(domain)domain.exit();
    head = head.next;
  } last = undefined;
  if(parent)parent.enter();
};

// Node.js
if(isNode){
  notify = function(){
    process.nextTick(flush);
  };
// browsers with MutationObserver
} else if(Observer){
  var toggle = 1
    , node   = document.createTextNode('');
  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
  notify = function(){
    node.data = toggle = -toggle;
  };
// environments with maybe non-completely correct, but existent Promise
} else if(Promise && Promise.resolve){
  notify = function(){
    Promise.resolve().then(flush);
  };
// for other environments - macrotask based on:
// - setImmediate
// - MessageChannel
// - window.postMessag
// - onreadystatechange
// - setTimeout
} else {
  notify = function(){
    // strange IE + webpack dev server bug - use .call(global)
    macrotask.call(global, flush);
  };
}

module.exports = function asap(fn){
  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
  if(last)last.next = task;
  if(!head){
    head = task;
    notify();
  } last = task;
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(202);

// 23.1 Map Objects
__webpack_require__(89)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(202);

// 23.2 Set Objects
__webpack_require__(89)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $            = __webpack_require__(7)
  , redefine     = __webpack_require__(31)
  , weak         = __webpack_require__(203)
  , isObject     = __webpack_require__(9)
  , has          = __webpack_require__(26)
  , frozenStore  = weak.frozenStore
  , WEAK         = weak.WEAK
  , isExtensible = Object.isExtensible || isObject
  , tmp          = {};

// 23.3 WeakMap Objects
var $WeakMap = __webpack_require__(89)('WeakMap', function(get){
  return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      if(!isExtensible(key))return frozenStore(this).get(key);
      if(has(key, WEAK))return key[WEAK][this._i];
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
}, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  $.each.call(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on leaky map
      if(isObject(a) && !isExtensible(a)){
        var result = frozenStore(this)[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(203);

// 23.4 WeakSet Objects
__webpack_require__(89)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export  = __webpack_require__(4)
  , _apply   = Function.apply
  , anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    return _apply.call(target, thisArgument, anObject(argumentsList));
  }
});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $         = __webpack_require__(7)
  , $export   = __webpack_require__(4)
  , aFunction = __webpack_require__(50)
  , anObject  = __webpack_require__(11)
  , isObject  = __webpack_require__(9)
  , bind      = Function.bind || __webpack_require__(34).Function.prototype.bind;

// MS Edge supports only 2 arguments
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
$export($export.S + $export.F * __webpack_require__(19)(function(){
  function F(){}
  return !(Reflect.construct(function(){}, [], F) instanceof F);
}), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = $.create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var $        = __webpack_require__(7)
  , $export  = __webpack_require__(4)
  , anObject = __webpack_require__(11);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(19)(function(){
  Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    try {
      $.setDesc(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(4)
  , getDesc  = __webpack_require__(7).getDesc
  , anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = getDesc(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(4)
  , anObject = __webpack_require__(11);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(192)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var $        = __webpack_require__(7)
  , has      = __webpack_require__(26)
  , $export  = __webpack_require__(4)
  , isObject = __webpack_require__(9)
  , anObject = __webpack_require__(11);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var $        = __webpack_require__(7)
  , $export  = __webpack_require__(4)
  , anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return $.getDesc(anObject(target), propertyKey);
  }
});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(4)
  , getProto = __webpack_require__(7).getProto
  , anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(4)
  , anObject      = __webpack_require__(11)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(204)});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(4)
  , anObject           = __webpack_require__(11)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var $          = __webpack_require__(7)
  , has        = __webpack_require__(26)
  , $export    = __webpack_require__(4)
  , createDesc = __webpack_require__(44)
  , anObject   = __webpack_require__(11)
  , isObject   = __webpack_require__(9);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = $.getDesc(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = $.getProto(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    $.setDesc(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(4)
  , setProto = __webpack_require__(124);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(4)
  , $includes = __webpack_require__(187)(true);

$export($export.P, 'Array', {
  // https://github.com/domenic/Array.prototype.includes
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(51)('includes');

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(4)
  , $at     = __webpack_require__(127)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4)
  , $pad    = __webpack_require__(205);

$export($export.P, 'String', {
  padLeft: function padLeft(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4)
  , $pad    = __webpack_require__(205);

$export($export.P, 'String', {
  padRight: function padRight(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
});

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/WebReflection/9353781
var $          = __webpack_require__(7)
  , $export    = __webpack_require__(4)
  , ownKeys    = __webpack_require__(204)
  , toIObject  = __webpack_require__(32)
  , createDesc = __webpack_require__(44);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , setDesc = $.setDesc
      , getDesc = $.getDesc
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key, D;
    while(keys.length > i){
      D = getDesc(O, key = keys[i++]);
      if(key in result)setDesc(result, key, createDesc(0, D));
      else result[key] = D;
    } return result;
  }
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// http://goo.gl/XkBrjD
var $export = __webpack_require__(4)
  , $values = __webpack_require__(207)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// http://goo.gl/XkBrjD
var $export  = __webpack_require__(4)
  , $entries = __webpack_require__(207)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(4);

$export($export.P, 'Map', {toJSON: __webpack_require__(208)('Map')});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(4);

$export($export.P, 'Set', {toJSON: __webpack_require__(208)('Set')});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// JavaScript 1.6 / Strawman array statics shim
var $       = __webpack_require__(7)
  , $export = __webpack_require__(4)
  , $ctx    = __webpack_require__(36)
  , $Array  = __webpack_require__(34).Array || Array
  , statics = {};
var setStatics = function(keys, length){
  $.each.call(keys.split(','), function(key){
    if(length == undefined && key in $Array)statics[key] = $Array[key];
    else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
  });
};
setStatics('pop,reverse,shift,keys,values,entries', 1);
setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
           'reduce,reduceRight,copyWithin,fill');
$export($export.S, 'Array', statics);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(14)
  , $export    = __webpack_require__(4)
  , invoke     = __webpack_require__(80)
  , partial    = __webpack_require__(468)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(469)
  , invoke    = __webpack_require__(80)
  , aFunction = __webpack_require__(50);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that  = this
      , $$    = arguments
      , $$len = $$.length
      , j = 0, k = 0, args;
    if(!holder && !$$len)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
    while($$len > k)args.push($$[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4)
  , $task   = __webpack_require__(201);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
var global      = __webpack_require__(14)
  , hide        = __webpack_require__(35)
  , Iterators   = __webpack_require__(65)
  , ITERATOR    = __webpack_require__(12)('iterator')
  , NL          = global.NodeList
  , HTC         = global.HTMLCollection
  , NLProto     = NL && NL.prototype
  , HTCProto    = HTC && HTC.prototype
  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = __webpack_require__(34).RegExp.escape;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(924);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export optional */
/* unused harmony export required */
/* unused harmony export validateName */
/* unused harmony export validateDealersField */
/* unused harmony export validateVinRego */
/* unused harmony export validateFirstName */
/* unused harmony export validateCaptcha */
/* unused harmony export validateTime */
/* unused harmony export validateOdometer */
/* unused harmony export validatePostcodeSuggest */
/* unused harmony export validateLastName */
/* unused harmony export validatePhoneNumber */
/* unused harmony export validateMobileeNumber */
/* unused harmony export validateVin */
/* unused harmony export validateRego */
/* unused harmony export validateEmail */
/* unused harmony export postcodeValidation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_errors__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var isValidEmail = function isValidEmail(email) {
  // Thanks to:
  // http://fightingforalostcause.net/misc/2006/compare-email-regex.php
  // http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
  // http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
  // https://github.com/Sembiance/email-validator
  var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  if (!email) {
    return false;
  }

  if (email.length > 254) {
    return false;
  }

  var valid = tester.test(email);
  if (!valid) {
    return false;
  }
  // Further checking of some things regex can't handle
  var parts = email.split('@');
  if (parts[0].length > 64) {
    return false;
  }

  var domainParts = parts[1].split('.');
  if (domainParts.some(function (part) {
    return part.length > 63;
  })) {
    return false;
  }
  return true;
};

/**
 * Test for no special characters other than space, hyphen and apostrophe.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if no special characters other than space, hyphen and apostrophe are found.
 */
var limitedSpecialCharacters = function limitedSpecialCharacters(string) {
  return !string.match(/([^\w\- ']|_)/gi);
};

/**
 * Strict test for special characters. Checks for limitedSpecialCharacters
 * then checks that permitted special characters are not found more than once.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if no special characters and that there isn't more than 1 permitted special character.
 */
var strictSpecialCharacters = function strictSpecialCharacters(string) {
  var match = string.match(/('|-|\.| )/gi) || [];
  return !limitedSpecialCharacters(string) || match.length > 1;
};

/**
 * Test for whitespace at beginning of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string begins with whitespace
 */
var beginsWithWhitespace = function beginsWithWhitespace(string) {
  return string.match(/^\s+/i);
};

/**
 * Test for whitespace at the end of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string ends with whitespace
 */
var endsWithWhitespace = function endsWithWhitespace(string) {
  return string.match(/\s+$/i);
};

/**
 * Test for special character at the start of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string begins with a special character.
 */
var beginsWithSpecial = function beginsWithSpecial(string) {
  return !string.match(/^[A-Za-z]/i);
};

/**
 * Tests for special character at the end of string
 * @param {String} string - String to test
 * @returns {String} - Returns true if string ends with special character
 */
var endsWithSpecial = function endsWithSpecial(string) {
  return !string.match(/[A-Za-z]$/i);
};

/**
 * Test for capital at beginning of string.
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true if string begins with capital letter.
 */
var beginsWithCapital = function beginsWithCapital(string) {
  var test = /^[A-Z]/;
  return Boolean(string.match(test));
};

/**
 * Test for numbers in string
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true string contains numbers.
 */
var containsNumbers = function containsNumbers(string) {
  var test = /[0-9]/;
  return Boolean(string.match(test));
};

/**
 * Test for valid Australian area code
 * @param {String} string - String to test
 * @returns {Boolean} - Returns true for valid Australian area codes
 */
var australianAreaCode = function australianAreaCode(string) {
  var test = /^0(2|3|4|7|8)\d+$/;
  var subject = typeof string === 'string' ? string : String(string);
  return Boolean(subject.match(test));
};

var australianMobileNumber = function australianMobileNumber(string) {
  var test = /^04\d+$/;
  var subject = typeof string === 'string' ? string : String(string);
  return Boolean(subject.match(test));
};

/**
 * Clears whitespace before and after value.
 * Trailing whitespace will only be cleared when context is onBlur
 * @param {String} value - Input string to sanitize
 * @param {Object} context - Validation context
 * @returns {String} - Returns true if string ends with whitespace
 */
var sanitizeValue = function sanitizeValue(value, _ref) {
  var onBlur = _ref.onBlur;

  if (beginsWithWhitespace(value)) {
    value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["d" /* removeLeadingWhitespace */])(value);
  }
  if (onBlur && endsWithWhitespace(value)) {
    value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["e" /* removeTrailingWhitespace */])(value);
  }
  return value;
};

var optional = function optional(validation) {
  return function (value) {
    validation = typeof validation === 'undefined' ? function () {
      return { isValid: true };
    } : validation;
    var result = validation(value);
    var status = result.status,
        attributes = result.attributes;

    if (!value) {
      return {
        status: {
          isValid: true
        }
      };
    }
    return {
      status: status || result,
      attributes: attributes
    };
  };
};
var required = function required(validation, message) {
  return function (value, context) {
    validation = typeof validation === 'undefined' ? function () {
      return { isValid: true };
    } : validation;
    var result = validation(value, context);
    var status = result.status,
        attributes = result.attributes;

    var requiredAttributes = {
      required: true
    };
    if (!value) {
      return {
        status: {
          isValid: false,
          message: message
        },
        attributes: _extends({}, attributes, requiredAttributes)
      };
    }
    return {
      status: status || result,
      attributes: _extends({}, attributes, requiredAttributes)
    };
  };
};

var validateName = function validateName(v) {
  return {
    isValid: true
  };
};

var validateDealersField = function validateDealersField(value) {
  return {
    isValid: Boolean(value.code)
  };
};

var validateVinRego = function validateVinRego(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref2.onBlur;

  var validVin = function validVin(value) {
    return value.match(/^[0-9a-zA-Z]*$/);
  };
  var isValid = true;
  var message = void 0;
  if (value) {
    value = sanitizeValue(value, { onBlur: onBlur });

    if (!validVin(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].REGO_OR_VIN_REQUIRED;
    }
  }
  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 17
    }
  };
};

/**
 * Firstname field validation.
 * Only special characters allowed are space, hyphen and apostrophe;
 * first letter must be capitalised;
 * Shouldn't be longer than 30 characters
 */
var validateFirstName = function validateFirstName(value) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref3.onBlur;

  var isValid = true;
  var message = void 0;

  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, { onBlur: onBlur });
    if (!beginsWithCapital(value)) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["f" /* upperFirst */])(value);
    }
    if (value.length > 30) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].FIRSTNAME_MAXLENGTH;
    }
    if (beginsWithSpecial(value) || endsWithSpecial(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].FIRSTNAME_SPECIAL_CHARACTERS_POSITION;
    }
    if (strictSpecialCharacters(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].FIRSTNAME_SPECIAL_CHARACTERS;
    }
    if (containsNumbers(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].FIRSTNAME_NUMBERS;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 30
    }
  };
};

var validateCaptcha = function validateCaptcha(value) {
  var isValid = value !== null;
  return {
    isValid: isValid
  };
};

var validateTime = function validateTime(value) {
  var isValid = value && value.match && value.match(/^[01]?[0-9]\/[0-5][0-9]$/);
  return {
    isValid: !!isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].TIME_INVALID
  };
};

var validateOdometer = function validateOdometer(value) {
  var number = +value;
  var positive = number > 0;
  var integer = value && value.indexOf('.') === -1;
  var isValid = positive && integer;
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].ODOMETER_INVALID
  };
};

/**
 * PostcodeSuggest / Location field validation.
 * User must select a suggestion (populating postcode, state and suburb).
 * Sometimes Google Map doesn't return a suburb name, so we only validate
 * postcode and state before throwing error.
 */
var validatePostcodeSuggest = function validatePostcodeSuggest(value) {
  if (value && !(value.postcode && value.state)) {
    return {
      isValid: false,
      message: __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].LOCATION_INVALID
    };
  }
  return {
    isValid: true
  };
};

/**
 * LastName field validation.
 * Only special characters allowed are space, hyphen and apostrophe;
 * first letter must be capitalised;
 * Shouldn't be longer than 50 characters
 */
var validateLastName = function validateLastName(value) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref4.onBlur;

  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, { onBlur: onBlur });

    if (!beginsWithCapital(value)) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__string__["f" /* upperFirst */])(value);
    }
    if (value.length > 50) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].LASTNAME_MAXLENGTH;
    }
    if (beginsWithSpecial(value) || endsWithSpecial(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].LASTNAME_SPECIAL_CHARACTERS_POSITION;
    }
    if (strictSpecialCharacters(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].LASTNAME_SPECIAL_CHARACTERS;
    }
    if (containsNumbers(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].LASTNAME_NUMBERS;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 50
    }
  };
};
/**
 * Phone number field validation.
 * Valid landline or mobile phone number by prefix i.e. 02, 03, 04, etc (i.e Australian phone numbers);
 * This field will be used by MA IT dedup tool to populate the Mobile Phone/Home Phone fields in the Prospect DB;
 */
var validatePhoneNumber = function validatePhoneNumber(value) {
  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    if (value.length !== 10) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].PHONE_NUMBER_INVALID;
    }
    if (!australianAreaCode(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].PHONE_NUMBER_AREACODE_INVALID;
    }
  }
  return {
    status: {
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 10
    }
  };
};

var validateMobileeNumber = function validateMobileeNumber(value) {
  var isValid = true;
  var message = void 0;
  if (!value) {
    isValid = false;
  } else {
    if (value.length !== 10) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].MOBILE_NUMBER_INVALID;
    }
    if (!australianMobileNumber(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].MOBILE_NUMBER_INVALID;
    }
  }
  return {
    status: {
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 10
    }
  };
};

var validateVin = function validateVin(v) {
  v = ('' + v).toUpperCase();
  var transliterate = function transliterate(c) {
    return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
  };
  var checkDigit = function checkDigit(vin) {
    var map = '0123456789X';
    var weights = '8765432X098765432';
    var sum = 0;
    for (var i = 0; i < 17; ++i) {
      sum += transliterate(vin[i]) * map.indexOf(weights[i]);
    }
    return map[sum % 11];
  };
  // https://en.wikipedia.org/wiki/Vehicle_identification_number#Check-digit_calculation
  // but it seems that check digit not used in Australia
  // const isValid = (v.length === 17) && v[8] === checkDigit(v)
  var isValid = Boolean(/[A-HJ-NPR-Z0-9]{13}[0-9]{4}/.exec(v));
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].VIN_INVALID
  };
};

var validateRego = function validateRego(v) {
  var isValid = Boolean(/[A-Za-z0-9]{1,6}/.exec(v));
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].REGISTRATION_INVALID
  };
};

var validateEmail = function validateEmail(value) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onBlur = _ref5.onBlur;

  var isValid = true;
  var message = void 0;

  if (!value) {
    isValid = false;
  } else {
    value = sanitizeValue(value, { onBlur: onBlur });
    if (value.length > 60) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].EMAIL_MAXLENGTH;
    }
    if (!isValidEmail(value)) {
      isValid = false;
      message = __WEBPACK_IMPORTED_MODULE_1__constants_errors__["b" /* FORM_ERRORS */].EMAIL_INVALID;
    }
  }

  return {
    status: {
      modifiedValue: value,
      isValid: isValid,
      message: message
    },
    attributes: {
      maxLength: 60
    }
  };
};

var postcodeValidation = function postcodeValidation(value) {
  var test = new RegExp('^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$');
  var isValid = value.length <= 4 && !!test.exec(value);
  return {
    isValid: isValid,
    message: isValid ? undefined : __WEBPACK_IMPORTED_MODULE_1__constants_errors__["a" /* ERRORS */].POSTCODE_INVALID
  };
};

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findColorFromCombinations */
/* unused harmony export findInteriorsFromCombinations */
/* unused harmony export parseMJOData */
var findColorFromCombinations = function findColorFromCombinations(options, colorReferances) {
  var foundColors = [];
  // If there are colors at engine level, use those, otherwise fall back to
  // ones at grade level
  var matchRef = function matchRef(ref) {
    for (var _iterator = colorReferances, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var combination = _ref;

      if (ref === combination.colorRef) return combination;
    }
  };
  var level = options.engine.colors.length > 0 ? 'engine' : 'grade';
  for (var _iterator2 = options[level].colors, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var color = _ref2;

    if (!color.ref) {
      throw new Error('Color ref should not be null.');
    }
    var match = matchRef(color.ref);
    if (match) {
      foundColors.push(Object.assign(color, {
        children: match.children,
        default: match.default
      }));
    }
  }
  return foundColors;
};

var findInteriorsFromCombinations = function findInteriorsFromCombinations(options, interiorReferences) {
  var foundInteriors = [];
  for (var _iterator3 = interiorReferences, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var interiorReference = _ref3;

    for (var _iterator4 = options.grade.interiorDesigns, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var interiorDesign = _ref4;

      if (!interiorDesign.ref) {
        throw new Error('Grade level interiorDesign ref should not be null.');
      }
      if (interiorDesign.ref === interiorReference.interiorDesignRef) {
        foundInteriors.push(Object.assign(interiorDesign, { default: interiorReference.default }));
      }
    }
  }
  return foundInteriors;
};

/** Recursively update options from data tree based on selection
 * @param {Object} newSelection - New selection object.
 * @returns {Object} new options object.
 */
var parseMJOData = function parseMJOData(data) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      newSelection = _ref5.newSelection,
      stateOptions = _ref5.stateOptions,
      type = _ref5.type;

  var configNames = [{
    groupName: 'bodyStyles',
    itemName: 'bodyStyle'
  }, {
    groupName: 'drivetrains',
    itemName: 'drivetrain'
  }, {
    groupName: 'grades',
    itemName: 'grade'
  }, {
    groupName: 'transmissions',
    itemName: 'transmission'
  }, {
    groupName: 'engines',
    itemName: 'engine'
  }, {
    groupName: 'colors',
    itemName: 'color'
  }, {
    groupName: 'interiorDesigns',
    itemName: 'interiorDesign'
  }];

  var compareNames = [{
    groupName: 'bodyStyles',
    itemName: 'bodyStyle'
  }, {
    groupName: 'grades',
    itemName: 'grade'
  }, {
    groupName: 'engines',
    itemName: 'engine'
  }];

  var optionNames = type === 'compare' ? compareNames : configNames;

  /** Choose item from array based on selection / fallback hierarchy
   * @param {Array} items - Array of objects to select from.
   * @param {Object} selection - New selection object.
   * @returns {Object} selected object.
   */
  var selectItem = function selectItem(items, selection) {
    var compareObjects = function compareObjects(object1, object2) {
      return object1.type === object2.type && object1.name === object2.name;
    };
    // Return item if it matches selection
    for (var _iterator5 = items, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref6 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref6 = _i5.value;
      }

      var _item = _ref6;

      if (selection && compareObjects(selection, _item)) {
        return _item;
      }
    }
    // Return item in state if it exists
    if (stateOptions) {
      for (var _iterator6 = items, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray6) {
          if (_i6 >= _iterator6.length) break;
          _ref7 = _iterator6[_i6++];
        } else {
          _i6 = _iterator6.next();
          if (_i6.done) break;
          _ref7 = _i6.value;
        }

        var item = _ref7;

        if (stateOptions[item.type] && compareObjects(stateOptions[item.type], item)) {
          return item;
        }
      }
    }
    // Return item marked default
    for (var _iterator7 = items, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray7) {
        if (_i7 >= _iterator7.length) break;
        _ref8 = _iterator7[_i7++];
      } else {
        _i7 = _iterator7.next();
        if (_i7.done) break;
        _ref8 = _i7.value;
      }

      var _item2 = _ref8;

      if (_item2.default) {
        return _item2;
      }
    }
    // Return first item in array (failsafe)
    return items[0];
  };
  var options = {};
  options.nameplate = data;
  var buildStateOptions = function buildStateOptions(previousItem, optionIndex) {
    if (typeof optionIndex === 'undefined') optionIndex = 0;
    var option = optionNames[optionIndex || 0];
    if (!previousItem.children || !previousItem.children.length) return;
    if (option.itemName === 'color') {
      options[option.groupName] = findColorFromCombinations(options, previousItem.children);
    } else if (option.itemName === 'interiorDesign') {
      options[option.groupName] = findInteriorsFromCombinations(options, previousItem.children);
    } else {
      options[option.groupName] = previousItem.children;
    }
    options[option.itemName] = selectItem(options[option.groupName], newSelection);
    if (typeof options[option.itemName] === 'undefined') {
      throw new Error('Option name ' + option.itemName + ' does not exist in options.');
    }
    if (options[option.itemName].type !== option.itemName) {
      throw new Error('Option type (' + options[option.itemName].type + ') does not match expected type. (' + option.itemName + ')');
    }
    buildStateOptions(options[option.itemName], optionIndex + 1);
  };
  try {
    buildStateOptions(data);
  } catch (error) {
    console.warn(error, options);
  }
  return options;
};

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFinite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function__ = __webpack_require__(45);


var inRange = Object(__WEBPACK_IMPORTED_MODULE_0__function__["c" /* curry */])(function (min, max, val) {
  return val >= min && val < max;
});

var isFinite = function isFinite(val) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__function__["f" /* isFunction */])(Number.isFinite)) return Number.isFinite(val);
  return typeof val === 'number' ? !isNaN(val) && val !== -Infinity && val !== Infinity : false;
};

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rafThrottle; });
/* unused harmony export applyTransform */
/* unused harmony export clearTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__function__ = __webpack_require__(45);



var TRANSFORM_PROP = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */] ? function () {
  var _DOCUMENT$createEleme = __WEBPACK_IMPORTED_MODULE_0__constants_environment__["a" /* DOCUMENT */].createElement('div'),
      style = _DOCUMENT$createEleme.style;

  var prefixed = ['msTransform', 'mozTransform', 'webkitTransform'].find(function (key) {
    return key in style;
  });
  return prefixed || 'transform';
}() : 'transform';

/**
 * Throttles a function using window.requestAnimationFrame.
 * @see https://github.com/wuct/raf-throttle
 * @param {function} callback - Callback to run no more than once per animation frame.
 * @returns {function} A throttled callback function suitable for a listener.
 */
var rafThrottle = function rafThrottle() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__function__["g" /* noop */];

  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */]) return { cancel: __WEBPACK_IMPORTED_MODULE_1__function__["g" /* noop */] };

  var requestId = void 0;
  var later = function later(args) {
    return function () {
      requestId = null;
      callback.apply(undefined, args);
    };
  };
  var throttled = function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (requestId == null) requestId = window.requestAnimationFrame(later(args));
  };
  throttled.cancel = function () {
    return window.cancelAnimationFrame(requestId);
  };
  return throttled;
};

var applyTransform = Object(__WEBPACK_IMPORTED_MODULE_1__function__["c" /* curry */])(function (transform, el) {
  el.style[TRANSFORM_PROP] = transform;
});

// IE 11 does not appreciate null when clearing transform styles
var clearTransform = applyTransform('');

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return nullCheckProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constructOutputProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComponentDisplayName; });
/* unused harmony export matchComponentName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jsonToComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_missing_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\utils\\component.js';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Handle null values from backend as undefined to make default assignment work proerly
 */
var nullCheckProps = function nullCheckProps(props) {
  var newProps = props;
  Object.entries(props).forEach(function (_ref) {
    var key = _ref[0],
        val = _ref[1];

    if (val === null) {
      newProps[key] = undefined; // change all null values to undefined
    }
  });
  return newProps;
};

/**
 * Constructs transformed output props excluding inputs.
 * Executes outputFunc on each input-output mapping.
 */
var constructOutputProps = function constructOutputProps(props) {
  var mapInputToOutput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [['components', 'children']];
  var outputFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (outputProps) {
    return outputProps;
  };
  var initialProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_utils__["x" /* omit */])(mapInputToOutput.reduce(function (prev, _ref2) {
    var input = _ref2[0];
    return [].concat(prev, [input]);
  }, []), props), mapInputToOutput.reduce(function (prev, _ref3) {
    var _extends2;

    var input = _ref3[0],
        output = _ref3[1];
    return _extends({}, prev, (_extends2 = {}, _extends2[output] = outputFunc(props[input]), _extends2));
  }, initialProps));
};

var getComponentDisplayName = function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var matchComponentName = function matchComponentName(name, list) {
  return list.find(function (comp) {
    return getComponentDisplayName(comp) === name;
  }) || // Try first to derive exact component name
  list.find(function (comp) {
    return getComponentDisplayName(comp).indexOf('(' + name + ')') > -1;
  });
}; // try next partial match - this occurs when a component is wrapped in HOCs

/**
 * Constructs transformed output props excluding inputs.
 */
var jsonToComponents = function jsonToComponents(componentWhitelist) {
  var mapInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (comp) {
    return comp;
  };
  var wrappedComponentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'wrappedComponent';
  return function () {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (json == null) return null;
    return json.map(mapInput).map(function (_ref4, index) {
      var name = _ref4.name,
          props = _ref4.props;

      if (componentWhitelist.some(function (Comp) {
        return typeof Comp === 'undefined';
      })) {
        throw Error('Some componentWhitelist items are undefined for ' + wrappedComponentName + ' component. Check your imports.');
      }
      var Component = matchComponentName(name, componentWhitelist);

      var newProps = props;
      Object.entries(props).forEach(function (_ref5) {
        var key = _ref5[0],
            val = _ref5[1];

        if (val === null) {
          newProps[key] = undefined; // change all null values to undefined
        }
      });

      if (!Component) {
        console.error('"' + name + '" component was not found in componentWhitelist for ' + wrappedComponentName + '.');
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_missing_component__["a" /* default */], _extends({}, nullCheckProps(props), { key: index, expectedComponentName: name, __source: {
            fileName: _jsxFileName,
            lineNumber: 76
          }
        }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ key: index }, nullCheckProps(props), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        }
      }));
    });
  };
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(79),n=__webpack_require__(181),p=__webpack_require__(182),q=__webpack_require__(183),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(483);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendImportantToEachValue;

var _appendPxIfNeeded = __webpack_require__(215);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _mapObject = __webpack_require__(216);

var _mapObject2 = _interopRequireDefault(_mapObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function appendImportantToEachValue(style) {
  return (0, _mapObject2.default)(style, function (result, key) {
    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
  });
}
module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _camelCaseRegex = /([a-z])?([A-Z])/g;

var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
  return (p1 || '') + '-' + p2.toLowerCase();
};

var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
  return s.replace(_camelCaseRegex, _camelCaseReplacer);
};

var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
  // Since prefix is expected to work on inline style objects, we must
  // translate the keys to dash case for rendering to CSS.
  return Object.keys(prefixedStyle).reduce(function (result, key) {
    var dashCaseKey = _camelCaseToDashCase(key);

    // Fix IE vendor prefix
    if (/^ms-/.test(dashCaseKey)) {
      dashCaseKey = '-' + dashCaseKey;
    }

    result[dashCaseKey] = prefixedStyle[key];
    return result;
  }, {});
};

exports.default = camelCasePropsToDashCase;
module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// special flexbox specifications


var _prefixAll2 = __webpack_require__(487);

var _prefixAll3 = _interopRequireDefault(_prefixAll2);

var _getBrowserInformation = __webpack_require__(498);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(500);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(135);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(218);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _prefixProps = __webpack_require__(501);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _position = __webpack_require__(502);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(503);

var _calc2 = _interopRequireDefault(_calc);

var _zoomCursor = __webpack_require__(504);

var _zoomCursor2 = _interopRequireDefault(_zoomCursor);

var _grabCursor = __webpack_require__(505);

var _grabCursor2 = _interopRequireDefault(_grabCursor);

var _flex = __webpack_require__(506);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(507);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(508);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(509);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(511);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(512);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
// this must be run AFTER the flexbox specs
_flex2.default];

var Prefixer = function () {
  /**
   * Instantiante a new prefixer
   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
   * @param {string} keepUnprefixed - keeps unprefixed properties and values
   */

  function Prefixer() {
    var _this = this;

    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Prefixer);

    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

    this._userAgent = options.userAgent || defaultUserAgent;
    this._keepUnprefixed = options.keepUnprefixed || false;

    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);

    // Checks if the userAgent was resolved correctly
    if (this._browserInfo && this._browserInfo.prefix) {
      // set additional prefix information
      this.cssPrefix = this._browserInfo.prefix.css;
      this.jsPrefix = this._browserInfo.prefix.inline;
      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
    } else {
      this._usePrefixAllFallback = true;
      return false;
    }

    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
    if (data) {
      this._requiresPrefix = Object.keys(data).filter(function (key) {
        return data[key] >= _this._browserInfo.version;
      }).reduce(function (result, name) {
        result[name] = true;
        return result;
      }, {});
      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
    } else {
      this._usePrefixAllFallback = true;
    }
  }

  /**
   * Returns a prefixed version of the style object
   * @param {Object} styles - Style object that gets prefixed properties added
   * @returns {Object} - Style object with prefixed properties and values
   */


  _createClass(Prefixer, [{
    key: 'prefix',
    value: function prefix(styles) {
      var _this2 = this;

      // use prefixAll as fallback if userAgent can not be resolved
      if (this._usePrefixAllFallback) {
        return (0, _prefixAll3.default)(styles);
      }

      // only add prefixes if needed
      if (!this._hasPropsRequiringPrefix) {
        return styles;
      }

      Object.keys(styles).forEach(function (property) {
        var value = styles[property];
        if (value instanceof Object && !Array.isArray(value)) {
          // recurse through nested style objects
          styles[property] = _this2.prefix(value);
        } else {
          // add prefixes if needed
          if (_this2._requiresPrefix[property]) {
            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
            if (!_this2._keepUnprefixed) {
              delete styles[property];
            }
          }
        }
      });

      Object.keys(styles).forEach(function (property) {
        [].concat(styles[property]).forEach(function (value) {
          // resolve plugins
          plugins.forEach(function (plugin) {
            // generates a new plugin interface with current data
            assignStyles(styles, plugin({
              property: property,
              value: value,
              styles: styles,
              browserInfo: _this2._browserInfo,
              prefix: {
                js: _this2.jsPrefix,
                css: _this2.cssPrefix,
                keyframes: _this2.prefixedKeyframes
              },
              keepUnprefixed: _this2._keepUnprefixed,
              requiresPrefix: _this2._requiresPrefix
            }), value, _this2._keepUnprefixed);
          });
        });
      });

      return (0, _sortPrefixedStyle2.default)(styles);
    }

    /**
     * Returns a prefixed version of the style object using all vendor prefixes
     * @param {Object} styles - Style object that gets prefixed properties added
     * @returns {Object} - Style object with prefixed properties and values
     */

  }], [{
    key: 'prefixAll',
    value: function prefixAll(styles) {
      return (0, _prefixAll3.default)(styles);
    }
  }]);

  return Prefixer;
}();

exports.default = Prefixer;


function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var value = arguments[2];
  var keepUnprefixed = arguments[3];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (val) {
        if (base[property].indexOf(val) === -1) {
          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
        }
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = __webpack_require__(217);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = __webpack_require__(135);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(218);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _position = __webpack_require__(489);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(490);

var _calc2 = _interopRequireDefault(_calc);

var _cursor = __webpack_require__(491);

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = __webpack_require__(492);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(493);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(494);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(495);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(496);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(497);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// special flexbox specifications


var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    [].concat(styles[property]).forEach(function (value, index) {
      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return assignStyles(styles, plugin(property, value));
      });
    });
  });

  return (0, _sortPrefixedStyle2.default)(styles);
}

function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (value) {
        var valueIndex = baseValue.indexOf(value);
        if (valueIndex > -1) {
          base[property].splice(valueIndex, 1);
        }
        base[property].push(value);
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return { position: ['-webkit-sticky', 'sticky'] };
  }
}
module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _joinPrefixedValue = __webpack_require__(93);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(136);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _joinPrefixedValue = __webpack_require__(93);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _joinPrefixedValue = __webpack_require__(93);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _joinPrefixedValue = __webpack_require__(93);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(136);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateStyleName = __webpack_require__(219);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _capitalizeString = __webpack_require__(135);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _isPrefixedValue = __webpack_require__(136);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _prefixProps = __webpack_require__(217);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);

        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection' && typeof value === 'string') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bowser = __webpack_require__(220);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendorPrefixes = {
  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
  Moz: ['firefox', 'seamonkey', 'sailfish'],
  ms: ['msie', 'msedge']
};
var browsers = {
  chrome: [['chrome'], ['chromium']],
  safari: [['safari']],
  firefox: [['firefox']],
  edge: [['msedge']],
  opera: [['opera'], ['vivaldi']],
  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
  ie: [['msie']],
  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
  and_uc: [['android', 'mobile'], ['android', 'tablet']],
  android: [['android', 'mobile'], ['android', 'tablet']]
};

var browserByInfo = function browserByInfo(info) {
  if (info.firefox) {
    return 'firefox';
  }
  var name = '';

  Object.keys(browsers).forEach(function (browser) {
    browsers[browser].forEach(function (condition) {
      var match = 0;
      condition.forEach(function (single) {
        if (info[single]) {
          match += 1;
        }
      });
      if (condition.length === match) {
        name = browser;
      }
    });
  });

  return name;
};

/**
 * Uses bowser to get default browser information such as version and name
 * Evaluates bowser info and adds vendorPrefix information
 * @param {string} userAgent - userAgent that gets evaluated
 */

exports.default = function (userAgent) {
  if (!userAgent) {
    return false;
  }
  var info = _bowser2.default._detect(userAgent);

  Object.keys(vendorPrefixes).forEach(function (prefix) {
    vendorPrefixes[prefix].forEach(function (browser) {
      if (info[browser]) {
        info.prefix = {
          inline: prefix,
          css: '-' + prefix.toLowerCase() + '-'
        };
      }
    });
  });

  info.browser = browserByInfo(info);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
  info.osversion = parseFloat(info.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (info.browser === 'ios_saf' && info.version > info.osversion) {
    info.version = info.osversion;
    info.safari = true;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (info.browser === 'android' && info.chrome && info.version > 37) {
    info.browser = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (info.browser === 'android' && info.osversion < 5) {
    info.version = info.osversion;
  }

  return info;
};

module.exports = exports['default'];

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var browser = _ref.browser;
  var version = _ref.version;
  var prefix = _ref.prefix;

  var prefixedKeyframes = 'keyframes';

  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
    prefixedKeyframes = prefix.css + prefixedKeyframes;
  }
  return prefixedKeyframes;
};

module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
module.exports = exports["default"];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function position(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var browser = _ref.browserInfo.browser;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calc(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = zoomCursor;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { 'zoom-in': true, 'zoom-out': true };

function zoomCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = grabCursor;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { grab: true, grabbing: true };

function grabCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var browser = _ref.browserInfo.browser;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { flex: true, 'inline-flex': true };

function flex(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
    return {
      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties[property] && values[value]) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = transition;

var _hyphenateStyleName = __webpack_require__(219);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _unprefixProperty = __webpack_require__(510);

var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = { transition: true, transitionProperty: true };

function transition(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var requiresPrefix = _ref.requiresPrefix;
  var keepUnprefixed = _ref.keepUnprefixed;

  // also check for already prefixed transitions
  var unprefixedProperty = (0, _unprefixProperty2.default)(property);

  if (typeof value === 'string' && properties[unprefixedProperty]) {
    var _ret = function () {
      // TODO: memoize this array
      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateStyleName2.default)(prop);
      });

      // only split multi values, not cubic beziers
      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

      requiresPrefixDashCased.forEach(function (prop) {
        multipleValues.forEach(function (val, index) {
          if (val.indexOf(prop) > -1 && prop !== 'order') {
            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
          }
        });
      });

      return {
        v: _defineProperty({}, property, multipleValues.join(','))
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
}
module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
};

module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      return {
        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
      };
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isNestedStyle = isNestedStyle;
exports.mergeStyles = mergeStyles;
function isNestedStyle(value) {
  // Don't merge objects overriding toString, since they should be converted
  // to string values.
  return value && value.constructor === Object && value.toString === Object.prototype.toString;
}

// Merge style objects. Deep merge plain object values.
function mergeStyles(styles) {
  var result = {};

  styles.forEach(function (style) {
    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
      return;
    }

    if (Array.isArray(style)) {
      style = mergeStyles(style);
    }

    Object.keys(style).forEach(function (key) {
      // Simple case, nothing nested
      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
        result[key] = style[key];
        return;
      }

      // If nested media, don't merge the nested styles, append a space to the
      // end (benign when converted to CSS). This way we don't end up merging
      // media queries that appear later in the chain with those that appear
      // earlier.
      if (key.indexOf('@media') === 0) {
        var newKey = key;
        // eslint-disable-next-line no-constant-condition
        while (true) {
          newKey += ' ';
          if (!result[newKey]) {
            result[newKey] = style[key];
            return;
          }
        }
      }

      // Merge all other nested styles recursively
      result[key] = mergeStyles([result[key], style[key]]);
    });
  });

  return result;
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _checkProps = function checkProps() {};

if (false) {
  // Warn if you use longhand and shorthand properties in the same style
  // object.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties

  var shorthandPropertyExpansions = {
    background: ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
    border: ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
    borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
    borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
    font: ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
    listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
    margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
    padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
    transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
  };

  _checkProps = function checkProps(config) {
    var componentName = config.componentName,
        style = config.style;

    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
      return;
    }

    var styleKeys = Object.keys(style);
    styleKeys.forEach(function (styleKey) {
      if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
        return styleKeys.indexOf(sp) !== -1;
      })) {
        if (process.env.NODE_ENV !== 'production') {
          /* eslint-disable no-console */
          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
          /* eslint-enable no-console */
        }
      }
    });

    styleKeys.forEach(function (k) {
      return _checkProps(_extends({}, config, { style: style[k] }));
    });
    return;
  };
}

exports.default = _checkProps;
module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframesPlugin;
function keyframesPlugin(_ref) {
  var addCSS = _ref.addCSS,
      config = _ref.config,
      style = _ref.style;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === 'animationName' && value && value.__radiumKeyframes) {
      var keyframesValue = value;

      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent),
          animationName = _keyframesValue$__pro.animationName,
          css = _keyframesValue$__pro.css;

      addCSS(css);
      value = animationName;
    }

    newStyleInProgress[key] = value;
    return newStyleInProgress;
  }, {});
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
  var style = _ref.style,
      mergeStyles = _ref.mergeStyles;

  // eslint-disable-line no-shadow
  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
  return { style: newStyle };
};

exports.default = mergeStyleArrayPlugin;
module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixPlugin;

var _prefixer = __webpack_require__(92);

function prefixPlugin(_ref) {
  var config = _ref.config,
      style = _ref.style;

  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeNestedStyles;
function removeNestedStyles(_ref) {
  var isNestedStyle = _ref.isNestedStyle,
      style = _ref.style;

  // eslint-disable-line no-shadow
  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (!isNestedStyle(value)) {
      newStyleInProgress[key] = value;
    }
    return newStyleInProgress;
  }, {});

  return {
    style: newStyle
  };
}

module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mouseUpListener = __webpack_require__(520);

var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
};

var resolveInteractionStyles = function resolveInteractionStyles(config) {
  var ExecutionEnvironment = config.ExecutionEnvironment,
      getComponentField = config.getComponentField,
      getState = config.getState,
      mergeStyles = config.mergeStyles,
      props = config.props,
      setState = config.setState,
      style = config.style;


  var newComponentFields = {};
  var newProps = {};

  // Only add handlers if necessary
  if (style[':hover']) {
    // Always call the existing handler if one is already defined.
    // This code, and the very similar ones below, could be abstracted a bit
    // more, but it hurts readability IMO.
    var existingOnMouseEnter = props.onMouseEnter;
    newProps.onMouseEnter = function (e) {
      existingOnMouseEnter && existingOnMouseEnter(e);
      setState(':hover', true);
    };

    var existingOnMouseLeave = props.onMouseLeave;
    newProps.onMouseLeave = function (e) {
      existingOnMouseLeave && existingOnMouseLeave(e);
      setState(':hover', false);
    };
  }

  if (style[':active']) {
    var existingOnMouseDown = props.onMouseDown;
    newProps.onMouseDown = function (e) {
      existingOnMouseDown && existingOnMouseDown(e);
      newComponentFields._lastMouseDown = Date.now();
      setState(':active', 'viamousedown');
    };

    var existingOnKeyDown = props.onKeyDown;
    newProps.onKeyDown = function (e) {
      existingOnKeyDown && existingOnKeyDown(e);
      if (e.key === ' ' || e.key === 'Enter') {
        setState(':active', 'viakeydown');
      }
    };

    var existingOnKeyUp = props.onKeyUp;
    newProps.onKeyUp = function (e) {
      existingOnKeyUp && existingOnKeyUp(e);
      if (e.key === ' ' || e.key === 'Enter') {
        setState(':active', false);
      }
    };
  }

  if (style[':focus']) {
    var existingOnFocus = props.onFocus;
    newProps.onFocus = function (e) {
      existingOnFocus && existingOnFocus(e);
      setState(':focus', true);
    };

    var existingOnBlur = props.onBlur;
    newProps.onBlur = function (e) {
      existingOnBlur && existingOnBlur(e);
      setState(':focus', false);
    };
  }

  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
        if (getState(':active', key) === 'viamousedown') {
          setState(':active', false, key);
        }
      });
    });
  }

  // Merge the styles in the order they were defined
  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
    return _isInteractiveStyleField(name) && getState(name);
  }).map(function (name) {
    return style[name];
  });

  var newStyle = mergeStyles([style].concat(interactionStyles));

  // Remove interactive styles
  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
      styleWithoutInteractions[name] = newStyle[name];
    }
    return styleWithoutInteractions;
  }, {});

  return {
    componentFields: newComponentFields,
    props: newProps,
    style: newStyle
  };
};

exports.default = resolveInteractionStyles;
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _callbacks = [];
var _mouseUpListenerIsActive = false;

function _handleMouseUp() {
  _callbacks.forEach(function (callback) {
    callback();
  });
}

var subscribe = function subscribe(callback) {
  if (_callbacks.indexOf(callback) === -1) {
    _callbacks.push(callback);
  }

  if (!_mouseUpListenerIsActive) {
    window.addEventListener('mouseup', _handleMouseUp);
    _mouseUpListenerIsActive = true;
  }

  return {
    remove: function remove() {
      var index = _callbacks.indexOf(callback);
      _callbacks.splice(index, 1);

      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
        window.removeEventListener('mouseup', _handleMouseUp);
        _mouseUpListenerIsActive = false;
      }
    }
  };
};

exports.default = {
  subscribe: subscribe,
  __triggerForTests: _handleMouseUp
};
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = resolveMediaQueries;
var _windowMatchMedia = void 0;
function _getWindowMatchMedia(ExecutionEnvironment) {
  if (_windowMatchMedia === undefined) {
    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
      return window.matchMedia(mediaQueryString);
    } || null;
  }
  return _windowMatchMedia;
}

function _filterObject(obj, predicate) {
  return Object.keys(obj).filter(function (key) {
    return predicate(obj[key], key);
  }).reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

function _removeMediaQueries(style) {
  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
    if (key.indexOf('@media') !== 0) {
      styleWithoutMedia[key] = style[key];
    }
    return styleWithoutMedia;
  }, {});
}

function _topLevelRulesToCSS(_ref) {
  var addCSS = _ref.addCSS,
      appendImportantToEachValue = _ref.appendImportantToEachValue,
      cssRuleSetToString = _ref.cssRuleSetToString,
      hash = _ref.hash,
      isNestedStyle = _ref.isNestedStyle,
      style = _ref.style,
      userAgent = _ref.userAgent;

  var className = '';
  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
      return !isNestedStyle(value);
    }));

    if (!Object.keys(topLevelRules).length) {
      return;
    }

    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);

    // CSS classes cannot start with a number
    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';

    addCSS(css);

    className += (className ? ' ' : '') + mediaQueryClassName;
  });
  return className;
}

function _subscribeToMediaQuery(_ref2) {
  var listener = _ref2.listener,
      listenersByQuery = _ref2.listenersByQuery,
      matchMedia = _ref2.matchMedia,
      mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery,
      query = _ref2.query;

  query = query.replace('@media ', '');

  var mql = mediaQueryListsByQuery[query];
  if (!mql && matchMedia) {
    mediaQueryListsByQuery[query] = mql = matchMedia(query);
  }

  if (!listenersByQuery || !listenersByQuery[query]) {
    mql.addListener(listener);

    listenersByQuery[query] = {
      remove: function remove() {
        mql.removeListener(listener);
      }
    };
  }
  return mql;
}

function resolveMediaQueries(_ref3) {
  var ExecutionEnvironment = _ref3.ExecutionEnvironment,
      addCSS = _ref3.addCSS,
      appendImportantToEachValue = _ref3.appendImportantToEachValue,
      config = _ref3.config,
      cssRuleSetToString = _ref3.cssRuleSetToString,
      getComponentField = _ref3.getComponentField,
      getGlobalState = _ref3.getGlobalState,
      hash = _ref3.hash,
      isNestedStyle = _ref3.isNestedStyle,
      mergeStyles = _ref3.mergeStyles,
      props = _ref3.props,
      setState = _ref3.setState,
      style = _ref3.style;

  // eslint-disable-line no-shadow
  var newStyle = _removeMediaQueries(style);
  var mediaQueryClassNames = _topLevelRulesToCSS({
    addCSS: addCSS,
    appendImportantToEachValue: appendImportantToEachValue,
    cssRuleSetToString: cssRuleSetToString,
    hash: hash,
    isNestedStyle: isNestedStyle,
    style: style,
    userAgent: config.userAgent
  });

  var newProps = mediaQueryClassNames ? {
    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
  } : null;

  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);

  if (!matchMedia) {
    return {
      props: newProps,
      style: newStyle
    };
  }

  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};

  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var nestedRules = _filterObject(style[query], isNestedStyle);

    if (!Object.keys(nestedRules).length) {
      return;
    }

    var mql = _subscribeToMediaQuery({
      listener: function listener() {
        return setState(query, mql.matches, '_all');
      },
      listenersByQuery: listenersByQuery,
      matchMedia: matchMedia,
      mediaQueryListsByQuery: mediaQueryListsByQuery,
      query: query
    });

    // Apply media query states
    if (mql.matches) {
      newStyle = mergeStyles([newStyle, nestedRules]);
    }
  });

  return {
    componentFields: {
      _radiumMediaQueryListenersByQuery: listenersByQuery
    },
    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
    props: newProps,
    style: newStyle
  };
}
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = visited;
function visited(_ref) {
  var addCSS = _ref.addCSS,
      appendImportantToEachValue = _ref.appendImportantToEachValue,
      config = _ref.config,
      cssRuleSetToString = _ref.cssRuleSetToString,
      hash = _ref.hash,
      props = _ref.props,
      style = _ref.style;

  // eslint-disable-line no-shadow
  var className = props.className;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === ':visited') {
      value = appendImportantToEachValue(value);
      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
      var visitedClassName = 'rad-' + hash(ruleCSS);
      var css = '.' + visitedClassName + ':visited' + ruleCSS;

      addCSS(css);
      className = (className ? className + ' ' : '') + visitedClassName;
    } else {
      newStyleInProgress[key] = value;
    }

    return newStyleInProgress;
  }, {});

  return {
    props: className === props.className ? null : { className: className },
    style: newStyle
  };
}

module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _class, _temp;

var _cssRuleSetToString = __webpack_require__(91);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Style = (_temp = _class = function (_PureComponent) {
  _inherits(Style, _PureComponent);

  function Style() {
    _classCallCheck(this, Style);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Style.prototype._buildStyles = function _buildStyles(styles) {
    var _this2 = this;

    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;

    var scopeSelector = this.props.scopeSelector;

    var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
      if (_typeof(styles[selector]) !== 'object') {
        accumulator[selector] = styles[selector];
      }

      return accumulator;
    }, {});
    var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';

    return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
      var rules = styles[selector];

      if (selector === 'mediaQueries') {
        accumulator += _this2._buildMediaQueryString(rules);
      } else if (_typeof(styles[selector]) === 'object') {
        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
          return scopeSelector + ' ' + part.trim();
        }).join(',') : selector;

        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
      }

      return accumulator;
    }, '');
  };

  Style.prototype._buildMediaQueryString = function _buildMediaQueryString(stylesByMediaQuery) {
    var _this3 = this;

    var mediaQueryString = '';

    Object.keys(stylesByMediaQuery).forEach(function (query) {
      mediaQueryString += '@media ' + query + '{' + _this3._buildStyles(stylesByMediaQuery[query]) + '}';
    });

    return mediaQueryString;
  };

  Style.prototype.render = function render() {
    if (!this.props.rules) {
      return null;
    }

    var styles = this._buildStyles(this.props.rules);

    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
  };

  return Style;
}(_react.PureComponent), _class.propTypes = {
  radiumConfig: _propTypes2.default.object,
  rules: _propTypes2.default.object,
  scopeSelector: _propTypes2.default.string
}, _class.contextTypes = {
  _radiumConfig: _propTypes2.default.object
}, _class.defaultProps = {
  scopeSelector: ''
}, _temp);
exports.default = Style;
module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _enhancer = __webpack_require__(213);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _styleKeeper = __webpack_require__(134);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _styleSheet = __webpack_require__(526);

var _styleSheet2 = _interopRequireDefault(_styleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _getStyleKeeper(instance) {
  if (!instance._radiumStyleKeeper) {
    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
  }

  return instance._radiumStyleKeeper;
}

var StyleRoot = function (_PureComponent) {
  _inherits(StyleRoot, _PureComponent);

  function StyleRoot() {
    _classCallCheck(this, StyleRoot);

    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));

    _getStyleKeeper(_this);
    return _this;
  }

  StyleRoot.prototype.getChildContext = function getChildContext() {
    return { _radiumStyleKeeper: _getStyleKeeper(this) };
  };

  StyleRoot.prototype.render = function render() {
    /* eslint-disable no-unused-vars */
    // Pass down all props except config to the rendered div.
    var _props = this.props,
        radiumConfig = _props.radiumConfig,
        otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
    /* eslint-enable no-unused-vars */

    return _react2.default.createElement(
      'div',
      otherProps,
      this.props.children,
      _react2.default.createElement(_styleSheet2.default, null)
    );
  };

  return StyleRoot;
}(_react.PureComponent);

StyleRoot.contextTypes = {
  _radiumConfig: _propTypes2.default.object,
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
};

StyleRoot.childContextTypes = {
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
};

StyleRoot = (0, _enhancer2.default)(StyleRoot);

exports.default = StyleRoot;
module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleKeeper = __webpack_require__(134);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyleSheet = (_temp = _class = function (_PureComponent) {
  _inherits(StyleSheet, _PureComponent);

  function StyleSheet() {
    _classCallCheck(this, StyleSheet);

    var _this = _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));

    _this._onChange = function () {
      setTimeout(function () {
        _this._isMounted && _this.setState(_this._getCSSState());
      }, 0);
    };

    _this.state = _this._getCSSState();
    return _this;
  }

  StyleSheet.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
    this._onChange();
  };

  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    if (this._subscription) {
      this._subscription.remove();
    }
  };

  StyleSheet.prototype._getCSSState = function _getCSSState() {
    return { css: this.context._radiumStyleKeeper.getCSS() };
  };

  StyleSheet.prototype.render = function render() {
    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
  };

  return StyleSheet;
}(_react.PureComponent), _class.contextTypes = {
  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
}, _temp);
exports.default = StyleSheet;
module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframes;

var _cssRuleSetToString = __webpack_require__(91);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _hash = __webpack_require__(137);

var _hash2 = _interopRequireDefault(_hash);

var _prefixer = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function keyframes(keyframeRules, name) {
  return {
    __radiumKeyframes: true,
    __process: function __process(userAgent) {
      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
      var rules = Object.keys(keyframeRules).map(function (percentage) {
        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
      }).join('\n');
      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
      return { css: css, animationName: animationName };
    }
  };
}

module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium_lib_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vh_px_plugin_js__ = __webpack_require__(224);





function keyframes(keyframeRules, name) {
  return {
    __radiumKeyframes: true,
    __process: function __process(userAgent) {
      var keyframesPrefixed = Object(__WEBPACK_IMPORTED_MODULE_2_radium_lib_prefixer__["getPrefixedKeyframes"])(userAgent);
      var rules = Object.keys(keyframeRules).map(function (percentage) {
        var newKeyframeRules = Object(__WEBPACK_IMPORTED_MODULE_3__vh_px_plugin_js__["a" /* default */])({
          style: keyframeRules[percentage]
        });
        return __WEBPACK_IMPORTED_MODULE_0_radium_lib_css_rule_set_to_string___default()(percentage, newKeyframeRules.style, userAgent);
      }).join('\n');
      var animationName = (name ? name + '-' : '') + 'radium-animation-' + __WEBPACK_IMPORTED_MODULE_1_radium_lib_hash___default()(rules);
      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
      return { css: css, animationName: animationName };
    }
  };
}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GENERAL_STYLE */
/* unused harmony export GENERAL_STYLE_HEADING */
/* unused harmony export GENERAL_STYLE_COPY */
/* unused harmony export BASE_HEADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_COPY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_palette__ = __webpack_require__(225);


var GENERAL_STYLE = {
  OPACITY_HOVER: '0.6'
};

var GENERAL_STYLE_HEADING = {
  COLOR: __WEBPACK_IMPORTED_MODULE_0__color_palette__["a" /* default */].BLACK,
  LETTER_SPACING: '0.2em',
  FONT_WEIGHT: 600,
  LINE_HEIGHT: 1.2
};

var GENERAL_STYLE_COPY = {
  COLOR: __WEBPACK_IMPORTED_MODULE_0__color_palette__["a" /* default */].BLACK,
  FONT_WEIGHT: 200,
  LINE_HEIGHT: 1.4
};

var BASE_HEADING = {
  color: GENERAL_STYLE_HEADING.COLOR,
  letterSpacing: GENERAL_STYLE_HEADING.LETTER_SPACING,
  fontWeight: GENERAL_STYLE_HEADING.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_HEADING.LINE_HEIGHT,
  textTransform: 'uppercase'
};

var BASE_COPY = {
  color: GENERAL_STYLE_COPY.COLOR,
  fontWeight: GENERAL_STYLE_COPY.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_COPY.LINE_HEIGHT
};

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isOldBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__object__ = __webpack_require__(132);




var oldBrowser = function oldBrowser(browserList) {
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["d" /* IS_BROWSER */]) return false;
  // Check if the browser is NOT NEW
  return !Object.keys(browserList).some(function (key) {
    var browser = Object(__WEBPACK_IMPORTED_MODULE_2__object__["b" /* get */])(key, __WEBPACK_IMPORTED_MODULE_0_bowser___default.a);
    if (typeof __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version !== 'undefined') {
      return browser && __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version >= browserList[key];
    }
    // Show browser as supported if browser version cannot be determined but browser name exists on browserList
    return browser;
  });
};

var isOldBrowser = function isOldBrowser() {
  return oldBrowser(__WEBPACK_IMPORTED_MODULE_1__constants_environment__["i" /* MIN_BROWSERS */]);
};

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveAfter */
/* unused harmony export makeCancelable */
var resolveAfter = function resolveAfter(duration, resolveWith) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(resolveWith);
    }, duration);
  });
};

/**
 * Make a given promise cancelable. Taken from:
 * http://stackoverflow.com/a/37492399
 * https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
 * NOTE: calling cancel() will not immediately reject the promise. If there are no other errors
 * in execution, the promise will run the duration until then is called, and reject if the
 * canceled flag was set.
 *
 * @param {Promise} promise - Promise to convert
 * @returns {Object} Contains the wrapped promise and a cancel function
 * */
var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;

  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
    });
    promise.catch(function (error) {
      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
    });
  });

  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHash; });
/* unused harmony export updateHash */
/* unused harmony export removeHash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__history__ = __webpack_require__(94);



var getHash = function getHash() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])().hash.slice(1);
};

var updateHash = function updateHash(hash, affectHistory) {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */]) return;
  // Keep search params when pushing hash

  var _getLocation = Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])(),
      search = _getLocation.search;

  if (affectHistory) {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].push({ search: search, hash: hash });
  } else {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].replace({ search: search, hash: hash });
  }
};

// remove hash in url without affecting history or forcing reload
var removeHash = function removeHash() {
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_environment__["k" /* WINDOW */]) return;
  // Keep search params when pushing hash

  var _getLocation2 = Object(__WEBPACK_IMPORTED_MODULE_1__history__["a" /* getLocation */])(),
      search = _getLocation2.search;

  if (getHash().length) {
    __WEBPACK_IMPORTED_MODULE_1__history__["b" /* history */].replace({ search: search, hash: '' });
  }
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(138);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(226);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(227);

var _PathUtils = __webpack_require__(139);

var _createTransitionManager = __webpack_require__(228);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(138);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(139);

var _LocationUtils = __webpack_require__(227);

var _createTransitionManager = __webpack_require__(228);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export focusWithoutScroll */
/* unused harmony export getScrollTop */
/* unused harmony export getElementOffset */
/* unused harmony export doesElementContainScrollTop */
/* unused harmony export checkLocationRelevance */
/* unused harmony export checkElementRelevance */
/* unused harmony export getBestAnchorGivenScrollLocation */
/* unused harmony export scrollToElementId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollToOffset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_scroll__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweet_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var focusWithoutScroll = function focusWithoutScroll(element) {
  var x = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].scrollX;
  var y = __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].scrollY;
  element.focus();
  __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */].scrollTo(x, y);
};

var getScrollTop = function getScrollTop() {
  return document.body.scrollTop || document.documentElement.scrollTop;
};

// get vertical offsets of element, taking scrollTop into consideration
var getElementOffset = function getElementOffset(element) {
  var scrollTop = getScrollTop();

  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      bottom = _element$getBoundingC.bottom;

  return {
    top: Math.floor(top + scrollTop),
    bottom: Math.floor(bottom + scrollTop)
  };
};

// does scrollTop live within element bounds?
var doesElementContainScrollTop = function doesElementContainScrollTop(element) {
  var extraOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var scrollTop = getScrollTop();
  var offsetTop = getElementOffset(element).top + extraOffset;
  return scrollTop >= offsetTop && scrollTop < offsetTop + element.offsetHeight;
};

// is el2's location more relevant than el2,
// parent-child relationship aside?
var checkLocationRelevance = function checkLocationRelevance(el1, el2) {
  var _getElementOffset = getElementOffset(el1),
      top1 = _getElementOffset.top,
      bottom1 = _getElementOffset.bottom;

  var _getElementOffset2 = getElementOffset(el2),
      top2 = _getElementOffset2.top,
      bottom2 = _getElementOffset2.bottom;

  if (top1 === top2) {
    if (bottom1 === bottom2) {
      // top and bottom of compared elements are the same,
      // so return one randomly in a deterministic way
      return el1 < el2;
    }
    // top of compared elements is the same, so return whichever
    // element has its bottom higher on the page
    return bottom2 < bottom1;
  }
  // top of compared elements differ, so return true
  // if tested element has its top lower on the page
  return top2 > top1;
};

// check if el2 is more relevant than el1, considering child-parent
// relationships as well as node location.
var checkElementRelevance = function checkElementRelevance(el1, el2) {
  if (el1.contains(el2)) {
    // el2 is child, so it gains relevance priority
    return true;
  } else if (!el2.contains(el1) && checkLocationRelevance(el1, el2)) {
    // el1 and el2 are unrelated, but el2 has a better location,
    // so it gains relevance priority
    return true;
  }
  return false;
};

// given a set of anchors, find which one is, given the following logic:
// 1. children nodes are more relevant than parent nodes
// 2. if neither node contains the other, and their top locations differ,
//    the node with the top lower on the page is more relevant
// 3. if neither node contains the other, and their top locations are the same,
//    the node with the bottom higher on the page is more relevant
// 4. if neither node contains the other, and their top and bottom locations
//    are the same, a node is chosen at random, in a deterministic way,
//    to be more relevant.
var getBestAnchorGivenScrollLocation = function getBestAnchorGivenScrollLocation(anchors, offset) {
  var bestId = void 0,
      bestElement = void 0;

  Object.keys(anchors).forEach(function (id) {
    var element = anchors[id];
    if (doesElementContainScrollTop(element, offset)) {
      if (!bestElement || checkElementRelevance(bestElement, element)) {
        bestElement = element;
        bestId = id;
      }
    }
  });
  return bestId;
};

var scrollToElementId = function scrollToElementId(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var element = document.querySelector('[data-id="' + id + '"]');
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["d" /* IS_BROWSER */] || !id || !element) {} else {
    scrollToNode(element, _extends({}, options), callBack);
  }
};

var scrollToNode = function scrollToNode(target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1000 : _ref$duration,
      _ref$container = _ref.container,
      container = _ref$container === undefined ? 'body, html' : _ref$container,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["d" /* IS_BROWSER */] || !target) return;
  var sweetScroll = new __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default.a({
    duration: duration,
    offset: offset,
    stopPropagation: false,
    afterScroll: callback
  }, container);
  sweetScroll.toElement(target);
};

var scrollToOffset = function scrollToOffset() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === undefined ? 1000 : _ref2$duration,
      _ref2$container = _ref2.container,
      container = _ref2$container === undefined ? 'body, html' : _ref2$container;

  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!__WEBPACK_IMPORTED_MODULE_1__constants_environment__["d" /* IS_BROWSER */]) return;
  var sweetScroll = new __WEBPACK_IMPORTED_MODULE_0_sweet_scroll___default.a({
    duration: duration,
    stopPropagation: false,
    afterScroll: callback
  }, container);
  sweetScroll.to(offset);
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pushParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pushQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filteredParamsFromLocation; });
/* unused harmony export paramsFromLocation */
/* unused harmony export filterParams */
/* unused harmony export paramsToString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallow_equals__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallow_equals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shallow_equals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






// pushParam will merge supplied params with current url params and push them to url
var pushParam = function pushParam(param) {
  var trackParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var exposeParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currentParams = paramsFromLocation(location);
  var params = _extends({}, currentParams, param);
  var omitParams = Object.keys(params).filter(function (key) {
    return params[key] === false || typeof params[key] === 'undefined';
  });
  var sanitizedParams = Object(__WEBPACK_IMPORTED_MODULE_3__object__["d" /* omit */])(omitParams, params);
  pushQuery(sanitizedParams, trackParams, exposeParams);
};

// pushQuery will push a new query string from query object supplied
var pushQuery = function pushQuery(query) {
  var trackParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var exposeParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currentParams = filteredParamsFromLocation(location, exposeParams);
  if (__WEBPACK_IMPORTED_MODULE_1_shallow_equals___default()(currentParams, query)) return;
  var push = Object.keys(query).some(function (key) {
    return trackParams.some(function (param) {
      return param === key && String(currentParams[key]) !== String(query[key]);
    });
  });
  var search = paramsToString(query);
  if (push) {
    __WEBPACK_IMPORTED_MODULE_2__history__["b" /* history */].push({ search: search, breakLoop: true });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__history__["b" /* history */].replace({ search: search, breakLoop: true });
  }
};

var filteredParamsFromLocation = function filteredParamsFromLocation(location) {
  var exposeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return filterParams(paramsFromLocation(location), exposeParams);
};

var paramsFromLocation = function paramsFromLocation(location) {
  return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location && location.search);
};

var filterParams = function filterParams(params) {
  var exposeParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var filderedParams = exposeParams.reduce(function (accepted, param) {
    var _extends2;

    return _extends({}, accepted, (_extends2 = {}, _extends2[param] = Object(__WEBPACK_IMPORTED_MODULE_3__object__["b" /* get */])(param, params), _extends2));
  }, {});
  Object.keys(filderedParams).forEach(function (key) {
    return filderedParams[key] === undefined && delete filderedParams[key];
  });
  return filderedParams;
};

var paramsToString = function paramsToString(params) {
  /**
   * This kind of content specific function does not belong here.
   * @todo - Allow search params to be ordered.
   */

  // step should be always first in QueryParam because of GTM
  if (params.step === undefined) {
    return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
  }
  var step = params.step;
  delete params.step;
  var newParams = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
  newParams = 'step=' + step + '&' + newParams;
  return newParams;
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = shallow

function shallow(a, b, compare) {
  var aIsNull = a === null
  var bIsNull = b === null

  if (aIsNull !== bIsNull) return false

  var aIsArray = Array.isArray(a)
  var bIsArray = Array.isArray(b)

  if (aIsArray !== bIsArray) return false

  var aTypeof = typeof a
  var bTypeof = typeof b

  if (aTypeof !== bTypeof) return false
  if (flat(aTypeof)) return compare
    ? compare(a, b)
    : a === b

  return aIsArray
    ? shallowArray(a, b, compare)
    : shallowObject(a, b, compare)
}

function shallowArray(a, b, compare) {
  var l = a.length
  if (l !== b.length) return false

  if (compare) {
    for (var i = 0; i < l; i++)
      if (!compare(a[i], b[i])) return false
  } else {
    for (var i = 0; i < l; i++) {
      if (a[i] !== b[i]) return false
    }
  }

  return true
}

function shallowObject(a, b, compare) {
  var ka = 0
  var kb = 0

  if (compare) {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        !compare(a[key], b[key])
      ) return false

      ka++
    }
  } else {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        a[key] !== b[key]
      ) return false

      ka++
    }
  }

  for (var key in b) {
    if (b.hasOwnProperty(key)) kb++
  }

  return ka === kb
}

function flat(type) {
  return (
    type !== 'function' &&
    type !== 'object'
  )
}


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPageName */
var getPageName = function getPageName() {
  var pageName = window.location.pathname || '';
  if (pageName === '/') pageName = 'Home';
  return pageName.charAt(0).toUpperCase() + pageName.slice(1);
};

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventWithPoint; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * touch event helper
 * - touch event 座標を管理します
 * */

/**
 * x, y position を管理します
 */
var Vectors = function () {
  function Vectors() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Vectors);

    this.x = x;
    this.y = y;
  }

  /**
   * 初期化します
   */


  Vectors.prototype.reset = function reset() {
    this.x = 0;
    this.y = 0;
  };

  /**
   * 更新します
   * @param {number} x
   * @param {number} y
   */


  Vectors.prototype.update = function update(x, y) {
    this.x = x;
    this.y = y;
  };

  Vectors.prototype.updateWithVectors = function updateWithVectors(_ref) {
    var x = _ref.x,
        y = _ref.y;

    this.x = x;
    this.y = y;
  };

  Vectors.prototype.distance = function distance(vectors) {
    var distanceX = this.x - vectors.x;
    var distanceY = this.y - vectors.y;
    var sqrt = distanceX * distanceX + distanceY * distanceY;
    return Math.sqrt(sqrt);
  };

  /**
   * 引数 vectors との X 値を減算します
   * @param {Vectors} vectors 計測したい対象 Vectors instance
   * @returns {number} X 値を減算し返します
   */


  Vectors.prototype.distanceX = function distanceX(vectors) {
    return this.x - vectors.x;
  };

  /**
   * 引数 vectors との Y 値を減算します
   * @param {Vectors} vectors 計測したい対象 Vectors instance
   * @returns {number} Y 値を減算し返します
   */


  Vectors.prototype.distanceY = function distanceY(vectors) {
    return this.y - vectors.y;
  };

  return Vectors;
}();

/**
 * touch event から x, y を取得します
 * @param {Event} event TouchEvent
 * @returns {Vectors} instance を返します
 */
var eventWithPoint = function eventWithPoint(event) {
  var x = event.pageX;
  var y = event.pageY;
  // event.pageX / pageY があればそのまま値を返します
  // Android で pageX / pageY 存在しても 0, 0 しか返さない端末あり
  var numX = parseFloat(x);
  var numY = parseFloat(y);
  if (!isNaN(numX) && !isNaN(numY) && numX !== 0 && numY !== 0) {
    return new Vectors(x, y);
  }
  // event.pageX / pageY がない時は TouchEvent の changedTouches から取得します
  // touch event
  // @type {TouchList}
  var touches = event.changedTouches || event.touches;
  // touches が取得できない時は 0 をセットし返します
  if (!touches || touches.length === 0) {
    return new Vectors(0, 0);
  }
  // changedTouches list の先頭データを取り出し pageX / pageY を取得します
  // @type {Touch}
  var touch = touches[0];
  return new Vectors(touch.pageX, touch.pageY);
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["React"] = __webpack_require__(0);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["ReactDOM"] = __webpack_require__(95);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(181),ca=__webpack_require__(0),m=__webpack_require__(548),p=__webpack_require__(79),v=__webpack_require__(183),da=__webpack_require__(549),ea=__webpack_require__(550),fa=__webpack_require__(551),ha=__webpack_require__(182);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(552);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(553);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["MJO"] = __webpack_require__(17);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation_sample__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_navigation__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__social_icons_container_block__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sub_footer_navigation__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_page__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__site_search__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__primary_navigation__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__promo_navigation__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__promo_navigation_container__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__promo_navigation_item__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_navigation__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__header__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sub_navigation__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hero_carousel__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hero_image__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hero_video__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__standard_page__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__full_width__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__video__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__related_video__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__promo__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__wysiwyg__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__four_column_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__slideshow__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__presentation__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__presentation_item__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__photogallery__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__photogallery_item__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__photogallery_layout__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__slidegallery__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__slidegallery_item__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__tab_navigation__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__feature_categories__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__feature_category_container__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__picker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__picker_container__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__picker_item__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__exterior_view__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__exterior_view_accessories__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__promo_slider__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__body_size__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__equipment__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__equipment_container__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__equipment_item__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__maker_set_option_more_info_item__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__maker_set_option__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__spec_comparison__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__owner_library_container__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__grade_and_spec_data__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__grade_and_spec__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__eco_tax__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__car_lineup__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__car_lineup_filter__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__car_lineup_filter_item__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pagenation__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__car_navigation__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__car_navigation_link_item__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__notification__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__credit_plan__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__owner_library__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__accordion_container__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__accordion_item__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__anchor_navigation__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__breadcrumb_navigation__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__cta_navigation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__drivers_voice__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__accessory_list__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__accessory_body_type_tab_name__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__accessory_detail_page__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__accessory_detail_content__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__accessory_info_container__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__accessory_info_item__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__cars_comparison__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__dealer_detail_content__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__sitemap__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__estimation_history__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__promo_and_button_modal_window__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__my_mazda__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__interior360__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__interior360_item__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__animation_sample__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__html__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__footer_navigation__["a"]; });
/* unused harmony reexport SubFooterNavigation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__social_icons_container_block__["a"]; });
/* unused harmony reexport HomePage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__site_search__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__primary_navigation__["a"]; });
/* unused harmony reexport Header */
/* unused harmony reexport GlobalNavigation */
/* unused harmony reexport SubNavigation */
/* unused harmony reexport PromoNavigation */
/* unused harmony reexport PromoNavigationContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_11__promo_navigation_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_15__photo_info__["a"]; });
/* unused harmony reexport HeroCarousel */
/* unused harmony reexport HeroImage */
/* unused harmony reexport HeroVideo */
/* unused harmony reexport StandardPage */
/* unused harmony reexport FullWidth */
/* unused harmony reexport Video */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_23__promo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_22__related_video__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_25__one_column_layout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_26__two_column_layout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__three_column_layout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_28__four_column_layout__["a"]; });
/* unused harmony reexport Slideshow */
/* unused harmony reexport Slidegallery */
/* unused harmony reexport SlidegalleryItem */
/* unused harmony reexport Presentation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_31__presentation_item__["a"]; });
/* unused harmony reexport Photogallery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_34__photogallery_layout__["a"]; });
/* unused harmony reexport PhotogalleryItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_24__wysiwyg__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_38__cta__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_37__tab_navigation__["a"]; });
/* unused harmony reexport FeatureCategories */
/* unused harmony reexport FeatureCategoryContainer */
/* unused harmony reexport Picker */
/* unused harmony reexport PickerContainer */
/* unused harmony reexport PickerItem */
/* unused harmony reexport ExteriorView */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_45__exterior_view_accessories__["a"]; });
/* unused harmony reexport PromoSlider */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_47__body_size__["a"]; });
/* unused harmony reexport Equipment */
/* unused harmony reexport EquipmentContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_50__equipment_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_51__maker_set_option_more_info_item__["a"]; });
/* unused harmony reexport MakerSetOption */
/* unused harmony reexport SpecComparison */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_54__owner_library_container__["a"]; });
/* unused harmony reexport GradeAndSpecData */
/* unused harmony reexport GradeAndSpec */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_57__eco_tax__["a"]; });
/* unused harmony reexport CarLineup */
/* unused harmony reexport CarLineupFilter */
/* unused harmony reexport CarLineupFilterItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_61__pagenation__["a"]; });
/* unused harmony reexport CarNavigation */
/* unused harmony reexport CarNavigationLinkItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_64__notification__["a"]; });
/* unused harmony reexport CreditPlan */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_66__owner_library__["a"]; });
/* unused harmony reexport AccordionContainer */
/* unused harmony reexport AccordionItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_69__anchor_navigation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_70__breadcrumb_navigation__["a"]; });
/* unused harmony reexport CTANavigation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_72__drivers_voice__["a"]; });
/* unused harmony reexport AccessoryList */
/* unused harmony reexport AccessoryBodyTypeTabName */
/* unused harmony reexport AccessoryDetailPage */
/* unused harmony reexport AccessoryDetailContent */
/* unused harmony reexport AccessoryInfoContainer */
/* unused harmony reexport AccessoryInfoItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_79__cars_comparison__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_80__dealer_detail_content__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_81__sitemap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_82__estimation_history__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_83__promo_and_button_modal_window__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_84__my_mazda__["a"]; });
/* unused harmony reexport Interior360 */
/* unused harmony reexport Interior360Item */



// WP1






// WP2














// WP3


















// WP4











// WP5















// WP6







// WP7















//WP8



// 2020/09


// 2021/06


// 2021/08





/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fix_it__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fix_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fix_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mjo_global_css__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mjo_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mjo_global_css__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\app\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// import './app.global.css'

var store = Object(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */])();

/** Top Level Application Component.
 * Embedding the popup here could be unsafe but redux-saga dispatch control, and the fact that
 * the popup fires off a toast component which manages its own instances, should both mitigate
 * issues. KIV though, might have to embed the popup into a single page wrap in episerver.
 * */

var App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  /**
   * @param {Array} items - Array of Components.
   * @returns {ReactElement} React Component
   */
  App.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
      { store: store, __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_radium__["StyleRoot"],
        { radiumConfig: { userAgent: 'all' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        },
        Object(__WEBPACK_IMPORTED_MODULE_5_containers_utilities__["a" /* childParser */])(this.props)
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

App.displayName = 'App';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_higher_order_components__["d" /* withRadium */])(__WEBPACK_IMPORTED_MODULE_1_react_fix_it___default.a)(App));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fixIt = __webpack_require__(558);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fixIt).default;
  }
});

var _options = __webpack_require__(229);

Object.defineProperty(exports, 'options', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_options).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactComponentErrors = __webpack_require__(559);

var _reactComponentErrors2 = _interopRequireDefault(_reactComponentErrors);

var _options = __webpack_require__(229);

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_reactComponentErrors.config.errorHandler = function (errorReport) {
  var message = errorReport.error.message.replace(/'/g, '\\\'');

  var test = 'test(\'' + errorReport.component + ' should not throw "' + message + '" on ' + errorReport.method + '\', () => {\n  const props = ' + JSON.stringify(errorReport.props) + '\n  const wrapper = shallow(<' + errorReport.component + ' {...props} />)\n  const instance = wrapper.instance()\n  const args = ' + JSON.stringify(errorReport.arguments ? [].concat(_toConsumableArray(errorReport.arguments)) : []) + '\n\n  expect(() => instance.' + errorReport.method + '(...args)).not.toThrowError(\'' + message + '\')\n})';

  _options2.default.log(test);

  throw errorReport.error;
};

var fixIt = function fixIt(Component) {
  (0, _reactComponentErrors2.default)(Component);

  return Component;
};

exports.default = fixIt;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * Configuration that allows overriding default behavior.
 * @type {Object}
 */
var config = {
  /**
   * If enabled=false then this essentially disables the try/catch monkey-patch
   * @type {Boolean}
   */
  enabled: true,

  /**
   * Currently thif is configured to console.error a useful message if one of you
   * Component lifecycle methos throws an error. You can override the implementation
   * to integrate with you'r eown error logging.
   * @param  {[Object]} errorReport The report metadata including component, method, error thrown.
   * @return {[void]}
   */
  errorHandler: function errorHandler(errorReport) {
    console.error('Error in ' + errorReport.component + '.' + errorReport.method + '(' + (errorReport.arguments ? '...' : '') + '): ' + errorReport.error, errorReport);
  }
};

exports.config = config;
/**
 * Implementation of the try/catch wrapper
 * @param  {[React.Component]} component The ES6 React.Component.prototype that contains the React lifecycle method.
 * @param  {[string]} method             The name of the method to wrap ex: "render"
 * @return {[React.Component]}           Returns the same React.Component.prototype method monkey-patched with the specified method wrapped with a try/catch
 */
var wrapWithTryCatch = function wrapWithTryCatch(component, method) {
  var unsafe = component[method];

  component[method] = function () {
    if (!config.enabled) {
      return;
    }
    try {
      return unsafe.apply(this, arguments);
    } catch (err) {
      var errorReport = {
        component: component.constructor.name,
        method: method,
        props: this.props,
        error: err
      };
      if (arguments.length > 0) {
        errorReport.arguments = arguments;
      }
      config.errorHandler(errorReport);
    }
  };

  if (method === "constructor") {
    console.log(component[method]);
  }
};

/**
 * Wraps each React.Component lifecycle method with a try/catch that enables easier development diagnostics of errors throwin within each method
 * Methods wrapped include: `render, componentWillMount, componentDidMount, componentWillReceiveProps, shouldComponentUpdate, componentWillUpdate, componentDidUpdate, componentWillUnmount`
 * @param  {[React.Component]} ComponentConstructor The React.Component you want to wrap lifecycle methods with a try/catch and error handler.
 * @return {[void]}                      [description]
 */
var wrapReactLifecycleMethodsWithTryCatch = function wrapReactLifecycleMethodsWithTryCatch(ComponentConstructor) {
  [
    'render',
    'componentWillMount',
    'componentDidMount',
    'componentWillReceiveProps',
    'shouldComponentUpdate',
    'componentWillUpdate',
    'componentDidUpdate',
    'componentWillUnmount'
  ].forEach(function (method) {
    if (ComponentConstructor.prototype[method]) {
      wrapWithTryCatch(ComponentConstructor.prototype, method);
    }
  });
};

exports.wrapReactLifecycleMethodsWithTryCatch = wrapReactLifecycleMethodsWithTryCatch;
exports['default'] = wrapReactLifecycleMethodsWithTryCatch;


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(140);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(582);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(236);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(570);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(568);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(572);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(575);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(576);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(96)(module)))

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(234);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(235);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(236);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(237);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(583);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(140);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_layout__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detect_thresholds__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\detect-compact.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === undefined ? __WEBPACK_IMPORTED_MODULE_2_constants_layout__["b" /* DEFAULT_THRESHOLD_NORMAL */] : _ref$threshold,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_3_utils__["v" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? 'compact' : _ref$expose;

  return function (Wrapped) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__detect_thresholds__["a" /* default */])({
      thresholds: { compact: threshold },
      defaultThresholds: {
        compact: Array.isArray(threshold) ? threshold.map(function () {
          return true;
        }) : true
      },
      expose: '_THRESH_',
      onChange: Object(__WEBPACK_IMPORTED_MODULE_3_utils__["z" /* pipe */])(Object(__WEBPACK_IMPORTED_MODULE_3_utils__["m" /* get */])('compact'), onChange)
    })(function () {
      var DetectCompact = function (_PureComponent) {
        _inherits(DetectCompact, _PureComponent);

        function DetectCompact(props) {
          var _this$state;

          _classCallCheck(this, DetectCompact);

          var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

          var compactProp = _this.props._THRESH_.compact;
          _this.state = (_this$state = {}, _this$state[expose] = Array.isArray(compactProp) ? compactProp : !!compactProp, _this$state);
          return _this;
        }

        DetectCompact.prototype.stateFromProps = function stateFromProps(props) {
          var next = props.hasOwnProperty(expose) ? props[expose] : Array.isArray(props._THRESH_.compact) ? props._THRESH_.compact : !!props._THRESH_.compact;

          if (this.state[expose] !== next) {
            var _setState;

            this.setState((_setState = {}, _setState[expose] = next, _setState));
            onChange(next);
          }
        };

        DetectCompact.prototype.componentDidMount = function componentDidMount() {
          this.stateFromProps(this.props);
        };

        DetectCompact.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          this.stateFromProps(nextProps);
        };

        DetectCompact.prototype.render = function render() {
          var _extends2, _ref2;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_utils__["x" /* omit */])(['_THRESH_'], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2), this.props.hasOwnProperty(expose) ? (_ref2 = {}, _ref2[expose] = this.props[expose], _ref2) : {}), {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          }));
        };

        return DetectCompact;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

      DetectCompact.displayName = 'DetectCompact';


      DetectCompact.propTypes = {
        _THRESH_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          compact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool)])
        })
      };

      DetectCompact.displayName = 'DetectCompact(' + Object(__WEBPACK_IMPORTED_MODULE_3_utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

      return DetectCompact;
    }());
  };
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_history__ = __webpack_require__(94);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\search-params.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var pushQueryTracked = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* curry */])(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* pushQuery */]);
var pushParamTracked = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* curry */])(__WEBPACK_IMPORTED_MODULE_1__utils__["A" /* pushParam */]);

/**
 * Higher order component for Fetching and determining price based on geographical location.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains price data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? 'search' : _ref$expose,
      _ref$trackParams = _ref.trackParams,
      trackParams = _ref$trackParams === undefined ? [] : _ref$trackParams,
      _ref$exposeParams = _ref.exposeParams,
      exposeParams = _ref$exposeParams === undefined ? [] : _ref$exposeParams;

  return function (Wrapped) {
    var SearchParams = function (_Component) {
      _inherits(SearchParams, _Component);

      function SearchParams(props) {
        _classCallCheck(this, SearchParams);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.update = true;
        _this.state = {
          searchParams: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* filteredParamsFromLocation */])(Object(__WEBPACK_IMPORTED_MODULE_2_utils_history__["a" /* getLocation */])(), exposeParams)
        };
        return _this;
      }

      SearchParams.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        this.hashHistoryListener = __WEBPACK_IMPORTED_MODULE_2_utils_history__["b" /* history */].listen(function (location) {
          if (location.breakLoop) _this2.update = false;
          _this2.setState({ searchParams: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* filteredParamsFromLocation */])(location, exposeParams) }, function () {
            _this2.update = true;
          });
        });
      };

      SearchParams.prototype.componentWillUnmount = function componentWillUnmount() {
        this.hashHistoryListener();
      };

      SearchParams.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.update; // Only update component on url pop
      };

      SearchParams.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = {
          query: this.state.searchParams,
          pushQuery: pushQueryTracked(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* PLACEHOLDER */], trackParams, exposeParams),
          pushParam: pushParamTracked(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* PLACEHOLDER */], trackParams, exposeParams),
          queryString: Object(__WEBPACK_IMPORTED_MODULE_2_utils_history__["a" /* getLocation */])().search // TO DO: Remove this it's not always up to date
        }, _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          }
        }));
      };

      return SearchParams;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    SearchParams.displayName = 'SearchParams';


    SearchParams.displayName = 'SearchParams(' + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return SearchParams;
  };
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_environment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\detect-window-scroll.jsx';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? __WEBPACK_IMPORTED_MODULE_4__utils__["v" /* noop */] : _ref$onChange,
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? 'windowScroll' : _ref$expose;

  return function (Wrapped) {
    var DetectWindowScroll = function (_PureComponent) {
      _inherits(DetectWindowScroll, _PureComponent);

      function DetectWindowScroll(props) {
        var _this$state;

        _classCallCheck(this, DetectWindowScroll);

        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

        _this.state = (_this$state = {}, _this$state[expose] = _extends({}, _this.props._WINDOW_SCROLL_), _this$state);
        return _this;
      }

      DetectWindowScroll.prototype.componentDidMount = function componentDidMount() {
        var _setState;

        this.setState((_setState = {}, _setState[expose] = _extends({}, this.props._WINDOW_SCROLL_), _setState));
      };

      DetectWindowScroll.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
        var next = nextProps._WINDOW_SCROLL_;

        if (!Object(__WEBPACK_IMPORTED_MODULE_4__utils__["F" /* shallowEq */])(this.state[expose], next)) {
          var _setState2;

          this.setState((_setState2 = {}, _setState2[expose] = next, _setState2));
          onChange(next);
        }
      };

      DetectWindowScroll.prototype.render = function render() {
        var _extends2;

        var innerProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["x" /* omit */])(['_WINDOW_SCROLL_'], this.props), (_extends2 = {}, _extends2[expose] = this.state[expose], _extends2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, innerProps, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }));
      };

      return DetectWindowScroll;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

    DetectWindowScroll.displayName = 'DetectWindowScroll';


    DetectWindowScroll.propTypes = {
      _WINDOW_SCROLL_: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ scrollY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number })
    };

    DetectWindowScroll.displayName = 'DetectWindowScroll(' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    var mapStateToProps = function mapStateToProps(state) {
      return {
        _WINDOW_SCROLL_: __WEBPACK_IMPORTED_MODULE_3__store_actions_environment__["c" /* selectors */].getWindowScroll(state)
      };
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DetectWindowScroll);
  };
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_errors__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apis_mjo__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configured_radium__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__connect_location__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\price.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PriceUnavailable = Object(__WEBPACK_IMPORTED_MODULE_5__configured_radium__["a" /* default */])(function (_ref) {
  var _ref$currentState = _ref.currentState,
      currentState = _ref$currentState === undefined ? '' : _ref$currentState,
      _ref$locationError = _ref.locationError,
      locationError = _ref$locationError === undefined ? '' : _ref$locationError,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? __WEBPACK_IMPORTED_MODULE_4_utils__["v" /* noop */] : _ref$onClick;

  if (!currentState) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { style: priceStyles.button, onClick: onClick, __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      'Enter your ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: priceStyles.highlight, __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        },
        'postcode'
      ),
      ' to see accurate pricing in your area.'
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    { style: priceStyles.button, onClick: onClick, __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    },
    __WEBPACK_IMPORTED_MODULE_2_constants_errors__["d" /* PRICE_ERRORS */].LAST_RESORT
  );
});

var priceStyles = {
  button: {
    letterSpacing: '0.1em',
    outline: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 1.4,
    color: 'inherit',
    cursor: 'pointer',
    textTransform: 'inherit',
    ':hover': {
      outline: 'none'
    },
    ':active': {
      outline: 'none'
    },
    ':focus': {
      outline: 'none'
    }
  },
  highlight: {
    color: '#ab0000',
    borderBottom: '1px solid #999'
  }

  /**
   * Higher order component for Fetching and determining price based on geographical location.
   * @param {Object} options - Initial config options.
   * @param {String} options.expose - Name of the prop object that contains price data & methods.
   * @returns {Function} The configured higher order component, which in turn will return a component class.
   */
};/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$expose = _ref2.expose,
      expose = _ref2$expose === undefined ? 'price' : _ref2$expose;

  return function (Wrapped) {
    var Price = function (_Component) {
      _inherits(Price, _Component);

      function Price(props) {
        _classCallCheck(this, Price);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
          currentState: _this.props.locationState.state,
          data: [false],
          fetchURL: false,
          fetch: false,
          mapping: {}
        };

        Object(__WEBPACK_IMPORTED_MODULE_4_utils__["c" /* bindAll */])(['setOptions', 'fetchPrice', 'renderPriceUnavailable', 'updatePriceLocation', 'updatePriceLocationToState', 'updatePriceStaticData', 'testMapping', 'updatePrice', 'priceMode'], _this);
        return _this;
      }

      /**
       * Set options for specs api on componentDidMount() / componentWillMount()
       * @param {Object} options - Options object.
       * @param {String} options.fetchURL - Url for spec api endpoint.
       * @param {Function} options.mapping - A mapping function between api values and state.
       * @param {Function} [callback] - Callback when new options have been updated in state.
       */


      Price.prototype.setOptions = function setOptions(options, callback) {
        var fetchURL = options.fetchURL,
            mapping = options.mapping;

        this.setState({
          fetchURL: fetchURL,
          mapping: mapping,
          fetch: true
        }, function () {
          if (typeof callback === 'function') callback();
        });
      };

      Price.prototype.fetchPrice = function fetchPrice(stateOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_apis_mjo__["a" /* fetchMJOData */])(this.state.fetchURL, this.state.mapping(stateOptions));
      };

      /**
       * Applys business logic to array of state prices
       * @param {Array} priceArray - Array of objects containing geographic state prices.
       * @returns {Array} - Objects containing price or error messages
       */


      Price.prototype.updatePriceLocation = function updatePriceLocation(priceArray) {
        var _this2 = this;

        var currentState = this.state.currentState;

        if (!Array.isArray(priceArray)) priceArray = [priceArray];
        return priceArray.map(function (priceStateArray) {
          if (!priceStateArray) return false;
          var locationPrice = priceStateArray.find(function (item) {
            return item.state.toUpperCase() === currentState.toUpperCase();
          });

          return locationPrice && locationPrice.price ? locationPrice : { message: _this2.renderPriceUnavailable() };
        });
      };

      /**
       * Update price when connect-location HOC receives the current state
       */


      Price.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {
        var _this3 = this;

        var locationState = _ref3.locationState;
        var currentState = this.state.currentState;


        if (locationState.state && locationState.state !== currentState) {
          this.setState({ currentState: locationState.state }, function () {
            return _this3.updatePriceLocationToState(_this3.rawPriceArray);
          });
        }
      };

      Price.prototype.updatePriceStaticData = function updatePriceStaticData(priceArray) {
        this.rawPriceArray = priceArray;
        this.updatePriceLocationToState(this.rawPriceArray);
      };

      /**
       * Takes array of prices by state and saves the current states price to state
       * @param {Array} priceArray - Array of objects containing geographic state prices.
       */


      Price.prototype.updatePriceLocationToState = function updatePriceLocationToState(priceArray) {
        var data = this.state.data;

        var newData = this.updatePriceLocation(priceArray).map(function (price, index) {
          return price || data[index];
        });
        this.setState({ data: newData });
      };

      Price.prototype.testMapping = function testMapping(stateOptions) {
        var test = void 0;
        try {
          test = this.state.mapping(stateOptions);
        } catch (error) {
          return false;
        }
        return Object.keys(test).every(function (key) {
          return typeof test[key] !== 'undefined';
        });
      };

      /**
       * Take state object & maps it to API values then makes fetch request & updates state.
       * @param {Object} stateOptions - Options stored in state
       */


      Price.prototype.updatePrice = function updatePrice(stateOptions) {
        var _this4 = this;

        if (!this.state.fetch) throw new Error('Set setOptions() before update()');
        if (!Array.isArray(stateOptions)) stateOptions = [stateOptions];

        var data = this.state.data;

        var newData = stateOptions.map(function (opt, index) {
          return opt ? { message: __WEBPACK_IMPORTED_MODULE_2_constants_errors__["d" /* PRICE_ERRORS */].LOADING } : data[index];
        });

        this.setState({ data: newData }, function () {
          Promise.all(stateOptions.map(function (optionSet) {
            var resp = _this4.testMapping(optionSet);
            return resp && _this4.fetchPrice(optionSet);
          })).then(function (priceArray) {
            // Store this so that it can be re-parsed when postcode is received.
            _this4.rawPriceArray = priceArray || [];
            _this4.updatePriceLocationToState(_this4.rawPriceArray);
          }).catch(function (error) {
            return console.warn(error);
          });
        });
      };

      Price.prototype.priceMode = function priceMode() {
        return this.state.fetch ? { update: this.updatePrice } : { update: this.updatePriceStaticData };
      };

      Price.prototype.renderPriceUnavailable = function renderPriceUnavailable() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceUnavailable, {
          currentState: this.state.currentState,
          locationError: this.props.locationState.fetchError,
          onClick: this.props.locationActions.requestPostcodeInput, __source: {
            fileName: _jsxFileName,
            lineNumber: 203
          }
        });
      };

      Price.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = _extends({
          data: this.state.data,
          setOptions: this.setOptions,
          renderPriceUnavailable: this.renderPriceUnavailable
        }, this.priceMode()), _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 212
          }
        }));
      };

      return Price;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Price.displayName = 'Price';


    Price.propTypes = {
      locationState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      locationActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Price.displayName = 'Price(' + Object(__WEBPACK_IMPORTED_MODULE_4_utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return Object(__WEBPACK_IMPORTED_MODULE_6__connect_location__["a" /* default */])({
      exposeState: 'locationState',
      exposeActions: 'locationActions'
    })(Price);
  };
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_mjo__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\specs.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * Higher order component for Fetching specs.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains spec data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$expose = _ref.expose,
      expose = _ref$expose === undefined ? 'specs' : _ref$expose;

  return function (Wrapped) {
    var Specs = function (_Component) {
      _inherits(Specs, _Component);

      function Specs(props) {
        _classCallCheck(this, Specs);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
          data: false,
          fetchURL: false,
          loading: true
        };

        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* bindAll */])(['setOptions', 'testMapping', 'fetchSpecs', 'update'], _this);
        return _this;
      }

      /**
       * Set options for specs api on componentDidMount() / componentWillMount()
       * @param {Object} options - Options object.
       * @param {String} options.fetchURL - Url for spec api endpoint.
       * @param {Object} [options.initial] - Initial value for returned data object.
       * @param {Function} options.mapping - A mapping function between api values and state.
       * @param {Function} [callback] - Callback when new options have been updated in state.
       */


      Specs.prototype.setOptions = function setOptions(options, callback) {
        var fetchURL = options.fetchURL,
            initial = options.initial,
            mapping = options.mapping,
            loading = options.loading;

        this.setState({
          fetchURL: fetchURL,
          data: initial,
          mapping: mapping,
          loading: loading
        }, function () {
          if (typeof callback === 'function') callback();
        });
      };

      Specs.prototype.testMapping = function testMapping(stateOptions) {
        var test = void 0;
        try {
          test = this.state.mapping(stateOptions);
        } catch (error) {
          return false;
        }
        return Object.keys(test).every(function (key) {
          return typeof test[key] !== 'undefined';
        });
      };

      Specs.prototype.fetchSpecs = function fetchSpecs(fetchOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__apis_mjo__["a" /* fetchMJOData */])(this.state.fetchURL, fetchOptions);
      };

      /**
       * Take state object & maps it to API values then makes fetch request & updates state.
       * @param {Object} stateOptions - Options stored in state
       */


      Specs.prototype.update = function update(stateOptions) {
        var _this2 = this;

        this.setState({ loading: true, data: false });
        if (!this.state.fetchURL) return;
        var mapping = this.state.mapping;

        var fetchOptions = void 0;
        if (!Array.isArray(stateOptions)) {
          fetchOptions = this.testMapping(stateOptions) && mapping(stateOptions) || {};
        } else {
          fetchOptions = stateOptions.map(function (optionSet) {
            return _this2.testMapping(optionSet) && mapping(optionSet) || {};
          });
        }

        return this.fetchSpecs(fetchOptions).then(function (specs) {
          _this2.setState({ data: specs || false, loading: false });
        }).catch(function (error) {
          return console.warn(error);
        });
      };

      Specs.prototype.render = function render() {
        var _extends2;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, (_extends2 = {}, _extends2[expose] = {
          data: this.state.data,
          setOptions: this.setOptions,
          update: this.update,
          loading: this.state.loading
        }, _extends2)), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          }
        }));
      };

      return Specs;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Specs.displayName = 'Specs';


    Specs.displayName = 'Specs(' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return Specs;
  };
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_gtm__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\gtm-event.jsx';






/* harmony default export */ __webpack_exports__["a"] = (function () {
  return function (Wrapped) {
    var GtmEvent = function GtmEvent(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, props), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 8
        }
      }));
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ gtmEvent: __WEBPACK_IMPORTED_MODULE_3__store_actions_gtm__["a" /* gtmEvent */] }, dispatch);
    };

    GtmEvent.displayName = 'GtmEvent(' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined, mapDispatchToProps)(GtmEvent);
  };
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apis_persist__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\local-vehicle.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LOCALKEY = 'LOCALVEHICLE';

// This higher order component is used for saving vehicle options to cookie and read it somewhere else
/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return function (Wrapped) {
    var _class, _temp;

    var LocalVehicle = (_temp = _class = function (_Component) {
      _inherits(LocalVehicle, _Component);

      function LocalVehicle(props) {
        _classCallCheck(this, LocalVehicle);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.getVehicle = function (nameplate) {
          if (_this.localStorageSupported) {
            var vehicles = _this.getVehicles() || {};
            var vehicle = vehicles[nameplate.toUpperCase()];
            if (vehicle) return vehicle;
          }
        };

        _this.getVehicles = function () {
          var data = Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["a" /* getLocal */])(LOCALKEY);
          if (typeof data === 'string') {
            return JSON.parse(data);
          }
        };

        _this.setVehicle = function (value) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["e" /* setLocal */])(LOCALKEY, JSON.stringify(value));
        };

        _this.updateVehicle = function (nameplate, params) {
          var _this$setVehicle;

          return _this.setVehicle((_this$setVehicle = {}, _this$setVehicle[nameplate.toUpperCase()] = params, _this$setVehicle));
        };

        _this.localStorageSupported = Object(__WEBPACK_IMPORTED_MODULE_2_apis_persist__["b" /* isLocalStorageSupported */])();

        _this.state = {
          details: _this.getVehicle(props.nameplate || '')
        };
        return _this;
      }

      LocalVehicle.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, {
          localVehicle: {
            details: this.state.details,
            updateVehicle: this.updateVehicle
          }
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        }));
      };

      return LocalVehicle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
      nameplate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }, _class.defaultProps = {
      nameplate: ''
    }, _temp);
    LocalVehicle.displayName = 'LocalVehicle';


    LocalVehicle.displayName = 'LocalVehicle(' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return LocalVehicle;
  };
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(592);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(593);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(79);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(594);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.changeListeners = [];

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }

      this._emitChange({ name: name, value: value, options: options });
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }

      this._emitChange({ name: name, value: undefined, options: options });
    }
  }, {
    key: '_emitChange',
    value: function _emitChange(params) {
      for (var i = 0; i < this.changeListeners.length; ++i) {
        this.changeListeners[i](params);
      }
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(callback) {
      this.changeListeners.push(callback);
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      var idx = this.changeListeners.indexOf(callback);
      if (idx >= 0) {
        this.changeListeners.splice(idx, 1);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\with-hash.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return function (Wrapped) {
    var withHash = function (_Component) {
      _inherits(withHash, _Component);

      function withHash(props) {
        _classCallCheck(this, withHash);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.updateHash = function (hash) {
          _this.setState({ currentHash: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* getHash */])() });
        };

        _this.state = {
          currentHash: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* getHash */])()
        };
        return _this;
      }

      withHash.prototype.componentDidMount = function componentDidMount() {
        __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* history */].listen(this.updateHash);
      };

      withHash.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, _extends({}, this.props, {
          currentHash: this.state.currentHash
        }), {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        }));
      };

      return withHash;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    withHash.displayName = 'withHash';


    withHash.displayName = 'withHash(' + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return withHash;
  };
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_search__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\with-search.jsx';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  return function (Wrapped) {
    var withSearch = function (_Component) {
      _inherits(withSearch, _Component);

      function withSearch(props) {
        _classCallCheck(this, withSearch);

        // Populate search store from initialSearchApiData
        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        props.loadInitialData();
        // Parse query from initialQueryString from backend for server-side render
        if (!__WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] && props.initialQueryString) {
          var _queryString$parse = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(props.initialQueryString),
              q = _queryString$parse.q;

          _this.serverSideQuery = q;
        }
        return _this;
      }

      withSearch.prototype.render = function render() {
        var _props = this.props,
            _props$initialSearchA = _props.initialSearchApiData,
            hits = _props$initialSearchA.hits,
            page = _props$initialSearchA.page,
            initialQueryString = _props.initialQueryString,
            _props$siteSearch = _props.siteSearch,
            query = _props$siteSearch.query,
            siteSearch = _objectWithoutProperties(_props$siteSearch, ['query']),
            props = _objectWithoutProperties(_props, ['initialSearchApiData', 'initialQueryString', 'siteSearch']);
        // Get searchResults directly from initialSearchProps on server side


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, props, {
          query: query || '',
          searchResultsData: __WEBPACK_IMPORTED_MODULE_6__constants_environment__["k" /* WINDOW */] ? siteSearch : { results: hits }, __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }));
      };

      return withSearch;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    withSearch.displayName = 'withSearch';


    withSearch.propTypes = {
      initialSearchApiData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
      initialQueryString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      injestSearchData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };

    var mapStateToProps = function mapStateToProps(state) {
      return {
        siteSearch: _extends({}, __WEBPACK_IMPORTED_MODULE_5__store_actions_search__["c" /* selectors */].getCurrentPageData(state), __WEBPACK_IMPORTED_MODULE_5__store_actions_search__["c" /* selectors */].getSiteStatus(state))
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_5__store_actions_search__["a" /* actionCreators */], dispatch);
    };

    withSearch.displayName = 'withSearch(' + Object(__WEBPACK_IMPORTED_MODULE_7__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(withSearch);
  };
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_accessory__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\with-dynamic-components.jsx';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/**
 * Higher order component for parsing (json) CMS components from to react children
 * @param {Object} options - Initial config options.
 * @param {Array} options.componentWhiteList -
 * Array of components that can be used as children.
 * @param {Array} options.mapInputToOutput -
 * Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component,
 * which in turn will return a component class.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$componentWhiteli = _ref.componentWhitelist,
      componentWhitelist = _ref$componentWhiteli === undefined ? [] : _ref$componentWhiteli,
      _ref$mapInputToOutput = _ref.mapInputToOutput,
      mapInputToOutput = _ref$mapInputToOutput === undefined ? [['components', 'children']] : _ref$mapInputToOutput,
      _ref$mapInput = _ref.mapInput,
      mapInput = _ref$mapInput === undefined ? function (comp) {
    return comp;
  } : _ref$mapInput;

  return function (Wrapped) {
    var withDynamicComponents = function withDynamicComponents(_ref2) {
      var children = _ref2.children,
          props = _objectWithoutProperties(_ref2, ['children']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* constructOutputProps */])(props, mapInputToOutput, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["t" /* jsonToComponents */])(componentWhitelist, mapInput, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["n" /* getComponentDisplayName */])(Wrapped), {
        children: children
      })), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        }
      }));
    };
    withDynamicComponents.displayName = 'withDynamicComponents(' + Object(__WEBPACK_IMPORTED_MODULE_5__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    withDynamicComponents.propTypes = {
      components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    };

    var mapStateToProps = function mapStateToProps(state) {
      return {
        isCountable: state.accessory.isCountable,
        everySixteenAccessories: state.accessory.everySixteenAccessories
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_4__store_actions_accessory__["a" /* actionCreators */], dispatch);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(withDynamicComponents);
  };
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\higher-order-components\\with-data-components.jsx';




var jsonToData = function jsonToData(expectedComponent) {
  return function (json) {
    return json.map(function (_ref) {
      var name = _ref.name,
          props = _ref.props;

      if (!expectedComponent) {
        throw Error('jsonToData expectedComponent not provided.');
      } else if (expectedComponent !== name) {
        console.warn('jsonToData expecting ' + expectedComponent + ' but recieved ' + name);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["w" /* nullCheckProps */])(props);
    });
  };
};

/**
 * Higher order component for parsing cms components to data components
 *
 * input: [{
 *    name: 'DataComponent',
 *    props: {
 *      someData: 1000
 *    }
 * } ...]
 * becomes
 * output: [{
 *    someData: 1000
 * } ...]
 *
 * @param {Object} options - Initial config options.
 * @param {Array} options.mapInputToOutput - Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      expectedComponent = _ref2.expectedComponent,
      _ref2$mapInputToOutpu = _ref2.mapInputToOutput,
      mapInputToOutput = _ref2$mapInputToOutpu === undefined ? [['components', 'data']] : _ref2$mapInputToOutpu;

  return function (Wrapped) {
    var withDataComponents = function withDataComponents(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapped, _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* constructOutputProps */])(props, mapInputToOutput, jsonToData(expectedComponent)), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        }
      }));
    };
    withDataComponents.displayName = 'withDataComponents(' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* getComponentDisplayName */])(Wrapped) + ')';

    withDataComponents.propTypes = {
      components: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    };

    return withDataComponents;
  };
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export configureStore */
/* harmony export (immutable) */ __webpack_exports__["a"] = getStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_reducers__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_actions__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_gtm_events_index_main__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_beacon__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_beacon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_beacon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__);









// GTM






// Dirty global to hold ref to store so that all mount points get the same instance
var store = null;
// For futire if we want to develop offiline mode (state) => isConnected
var offlineStorage = Object(__WEBPACK_IMPORTED_MODULE_11_redux_beacon_extensions_offline_web__["offlineWeb"])(function () {
  return true;
});
var googleTagManagerMiddleware = Object(__WEBPACK_IMPORTED_MODULE_8_redux_beacon__["createMiddleware"])(__WEBPACK_IMPORTED_MODULE_7_store_gtm_events_index_main__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_10_redux_beacon_targets_google_tag_manager__["GoogleTagManager"])(), {
  logger: __WEBPACK_IMPORTED_MODULE_3_constants_environment__["h" /* IS_TEST */] ? null : __WEBPACK_IMPORTED_MODULE_9_redux_beacon_extensions_logger__["logger"], // Disable logging for unit tests
  offlineStorage: offlineStorage
});
// const googleTagManagerMiddleware = createMiddleware(gtmEventMap, GoogleTagManager())
var sagaMiddleware = Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["a" /* default */])();
var composeEnhancers = Object(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_extension_developmentOnly__["composeWithDevTools"])({
  name: 'MJO',
  actionCreators: __WEBPACK_IMPORTED_MODULE_5_store_actions__["b" /* locationActions */]
});
var enhancer = composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(sagaMiddleware, googleTagManagerMiddleware));

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4_store_reducers__["a" /* default */], initialState, enhancer);
}

function getStore() {
  if (store) {
    return store;
  }

  // dbg && console.trace('Configuring new store') // eslint-disable-line
  store = configureStore();

  if (__WEBPACK_IMPORTED_MODULE_3_constants_environment__["d" /* IS_BROWSER */] && __WEBPACK_IMPORTED_MODULE_3_constants_environment__["k" /* WINDOW */]) {
    sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_5_store_actions__["c" /* rootSagas */]);

    /*
     // Initiate a location fetch always regardless of the presence of location aware components
     const { state, locationConfirmed } = locationSelectors.getLocation(store.getState())
     
     if (!state) store.dispatch(locationActions.fetchLocation())
     else if (!locationConfirmed) {
     store.dispatch(locationActions.requestPostcodeInput())
     }
     */

    // Handle resize and scroll in one spot
    var pickDimensions = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["y" /* pick */])(['innerWidth', 'innerHeight']);
    var pickScroll = Object(__WEBPACK_IMPORTED_MODULE_6_utils__["y" /* pick */])(['scrollY']);

    store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowSize(pickDimensions(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["k" /* WINDOW */])));
    store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowScroll(pickScroll(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["k" /* WINDOW */])));

    __WEBPACK_IMPORTED_MODULE_3_constants_environment__["k" /* WINDOW */].addEventListener('resize', Object(__WEBPACK_IMPORTED_MODULE_6_utils__["C" /* rafThrottle */])(function () {
      return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_store_actions__["a" /* environmentActions */].updateWindowSize(pickDimensions(__WEBPACK_IMPORTED_MODULE_3_constants_environment__["k" /* WINDOW */])));
    }));
  }

  return store;
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(43).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(242);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(54);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(100);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(244);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(24);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(46);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(606);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(242);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(54);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["i" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(54);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["i" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(24);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["i" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["c" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(24);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(46);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(243);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__outlet__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environment__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessory__ = __webpack_require__(660);







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  location: __WEBPACK_IMPORTED_MODULE_1__location__["a" /* default */],
  outlet: __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* default */],
  environment: __WEBPACK_IMPORTED_MODULE_3__environment__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */],
  accessory: __WEBPACK_IMPORTED_MODULE_5__accessory__["a" /* default */]
}));

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = location;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_persist__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_location__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Reducer

var initialState = {
  latitude: Number(Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('latitude')) || undefined,
  longitude: Number(Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('longitude')) || undefined,
  postcode: Number(Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('postcode')) || undefined,
  state: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('state') || '',
  locality: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('locality') || '',
  locationConfirmed: Object(__WEBPACK_IMPORTED_MODULE_0__apis_persist__["c" /* load */])('locationConfirmed') === 'true',
  isFetching: false,
  fetchError: '',
  postcodePopupOpen: false
};

function location() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_START:
      return _extends({}, state, { fetchError: '', isFetching: true });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_ERROR:
      return _extends({}, state, { fetchError: payload.error, isFetching: false });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_FETCH_SUCCESS:
      return _extends({}, state, payload, { fetchError: '', isFetching: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].POSTCODE_POPUP_SHOW:
      return _extends({}, state, { postcodePopupOpen: true });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].POSTCODE_POPUP_HIDE:
      return _extends({}, state, { postcodePopupOpen: false });
    case __WEBPACK_IMPORTED_MODULE_1__actions_location__["b" /* actionTypes */].LOCATION_CONFIRMED:
      return _extends({}, state, { locationConfirmed: true });
    default:
      return state;
  }
}

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = outlet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_persist__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_outlet__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var canShowResultsReducer = function canShowResultsReducer(_ref, payload) {
  var nameplate = _ref.nameplate,
      dealerConfirm = _ref.dealerConfirm,
      _ref$dealer = _ref.dealer,
      dealer = _ref$dealer === undefined ? {} : _ref$dealer,
      results = _ref.results,
      isFetchingStock = _ref.isFetchingStock;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('fetched', dealer) && nameplate ? results && results.length > 0 && dealerConfirm || isFetchingStock : false;
};

var stepChangeReducer = function stepChangeReducer(_ref2, _ref3) {
  var dealer = _ref2.dealer,
      nameplate = _ref2.nameplate,
      canShowResults = _ref2.canShowResults;
  var step = _ref3.step;

  switch (step) {
    case 'SELECT_DEALER':
      break;
    case 'SELECT_NAMEPLATE':
      if (!dealer || !dealer.fetched) return 'SELECT_DEALER';
      if (!nameplate) return 'SELECT_NAMEPLATE';
      break;
    case 'SHOW_RESULTS':
      if (!dealer || !dealer.fetched) return 'SELECT_DEALER';
      if (!nameplate) return 'SELECT_NAMEPLATE';
      if (!canShowResults) return 'SELECT_NAMEPLATE';
      break;
    default:
      return step;
  }
  return step;
};

var queryDealer = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('dealerCode');
var queryLocationId = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('locationId');

var initialState = {
  step: 'SELECT_DEALER',
  storeLoading: true,
  previousDealer: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('previousDealer') || '',
  nameplate: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('nameplate'),
  isFetchingDealer: false,
  isFetchingStock: false,
  canShowResults: false,
  dealerConfirm: false,
  noResultMessages: {},
  dealer: queryDealer && { dealerCode: queryDealer, id: queryLocationId } || Object(__WEBPACK_IMPORTED_MODULE_1__apis_persist__["c" /* load */])('localDealer') || {},
  copyMode: 'WELCOME',
  outletStockEndpoint: false,
  fetchError: '',
  results: [],
  availability: [],
  sort: { key: 'storeType', dir: 'DESC' },
  filter: ['DEMO', 'RUNOUT']
};

function outlet() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].INIT_OUTLET_STORE:
      return _extends({}, state, payload, { storeLoading: true });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].LOAD_OUTLET_STORE:
      return _extends({}, state, payload, { storeLoading: false });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_CHANGE_REQUEST:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_CHANGE_SUCCESS:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_CHANGE_NO_RESULTS:
      return _extends({}, state, payload, {
        canShowResults: canShowResultsReducer(state, payload),
        noResultMessages: _extends({}, state.noResultMessages, payload.noResultMessage)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_CONFIRM:
      return _extends({}, state, {
        dealerConfirm: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_RESET:
      return _extends({}, state, {
        previousDealer: state.dealer.name,
        dealer: false,
        dealerConfirm: false,
        availability: [],
        results: []
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].NAMEPLATE_CHANGE:
      return _extends({}, state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_FETCH_START:
      return _extends({}, state, { isFetchingDealer: true });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_FETCH_SUCCESS:
      return _extends({}, state, payload, { fetchError: '', isFetchingDealer: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_FETCH_ERROR:
      return _extends({}, state, { fetchError: payload.error, isFetchingDealer: false });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].DEALER_FETCH_CANNOT_RESOLVE:
      return _extends({}, state, {
        isFetchingDealer: false,
        canShowResults: canShowResultsReducer(state, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_START:
      return _extends({}, state, { isFetchingStock: true });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_SUCCESS:
      return _extends({}, state, payload, { fetchError: '', isFetchingStock: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_ERROR:
      return _extends({}, state, { fetchError: payload.error, isFetchingStock: false });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].STEP_CHANGE:
      var canShowResults = canShowResultsReducer(state, payload);
      return _extends({}, state, {
        copyMode: 'NORMAL'
      }, payload, {
        canShowResults: canShowResults,
        step: stepChangeReducer(_extends({}, state, { canShowResults: canShowResults }), payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].UPDATE_FILTER:
      return _extends({}, state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_outlet__["a" /* actionTypes */].UPDATE_SORT:
      return _extends({}, state, { sort: _extends({}, state.sort, payload.sort) });
    default:
      return state;
  }
}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = location;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_environment__ = __webpack_require__(97);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// Reducer

var initialState = {
  globalHeaderHeight: 0,
  inPageNavHeight: 0,
  footerHeight: 0,
  isBrowser: __WEBPACK_IMPORTED_MODULE_0__constants_environment__["d" /* IS_BROWSER */],
  window: { innerWidth: 0, innerHeight: 0, scrollY: 0 },
  isOldBrowser: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["s" /* isOldBrowser */])()
};

function location() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_GLOBAL_HEADER_HEIGHT:
      return _extends({}, state, { globalHeaderHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_FOOTER_HEIGHT:
      return _extends({}, state, { footerHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_IN_PAGE_NAV_HEIGHT:
      return _extends({}, state, { inPageNavHeight: payload.height });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_WINDOW_SIZE:
      return _extends({}, state, {
        window: _extends({}, state.window || {}, __WEBPACK_IMPORTED_MODULE_2__actions_environment__["c" /* selectors */].pickDimensions(payload))
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_environment__["b" /* actionTypes */].UPDATE_WINDOW_SCROLL:
      return _extends({}, state, {
        window: _extends({}, state.window || {}, __WEBPACK_IMPORTED_MODULE_2__actions_environment__["c" /* selectors */].pickScroll(payload))
      });
    default:
      return state;
  }
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paginate__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_search__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var initialState = {
  currentPage: Number(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('page')) || 1,
  resultsPerPage: 25,
  error: false,
  totalHits: 0,
  totalPage: 0,
  query: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getInitialFromQuery */])('q') || '',
  navQuery: '' // This needs its own reducer when developed further
};

var pages = Object(__WEBPACK_IMPORTED_MODULE_1__paginate__["a" /* default */])({
  mapActionToKey: function mapActionToKey(action) {
    return String(action.payload.page);
  },
  types: [__WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].REQUEST], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].SUCCESS], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].FAILURE], __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY]
});

var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY:
      return _extends({}, state, { currentPage: 1, query: payload });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].UPDATE_NAV_SEARCH_QUERY:
      return _extends({}, state, { navQuery: payload });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].REQUEST]:
      return _extends({}, state, { error: false });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].SUCCESS]:
      var totalHits = payload.totalHits,
          totalPage = payload.totalPage;

      return _extends({}, state, { error: false, totalHits: totalHits, totalPage: totalPage
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* requestTypes */].FAILURE]:
      return _extends({}, state, { error: payload.error });
    case __WEBPACK_IMPORTED_MODULE_2__actions_search__["b" /* actionTypes */].CHANGE_PAGE:
      return _extends({}, state, { currentPage: payload });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  status: status,
  pages: pages
}));

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_union__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_union__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var paginate = function paginate(_ref) {
  var types = _ref.types,
      mapActionToKey = _ref.mapActionToKey;

  if (!Array.isArray(types) || types.length !== 4) {
    throw new Error('Expected types to be an array of four elements.');
  }
  if (!types.every(function (t) {
    return typeof t === 'string';
  })) {
    throw new Error('Expected types to be strings.');
  }
  if (typeof mapActionToKey !== 'function') {
    throw new Error('Expected mapActionToKey to be a function.');
  }

  var requestType = types[0],
      successType = types[1],
      failureType = types[2],
      clearType = types[3];


  var initialPaginationState = {
    isFetching: false,
    pageCount: 0,
    results: []
  };

  var updatePagination = function updatePagination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPaginationState;
    var action = arguments[1];

    switch (action.type) {
      case requestType:
        return _extends({}, state, {
          isFetching: true
        });
      case successType:
        return _extends({}, state, {
          isFetching: false,
          results: action.payload.hits
        });
      case failureType:
        return _extends({}, state, {
          isFetching: false
        });
      default:
        return state;
    }
  };

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 1: initialPaginationState };
    var action = arguments[1];

    // Update pagination by key
    if (action.type === requestType || action.type === successType || action.type === failureType) {
      var _extends2;

      var key = mapActionToKey(action);
      if (typeof key !== 'string') {
        throw new Error('Expected key to be a string.');
      }
      return _extends({}, state, (_extends2 = {}, _extends2[key] = updatePagination(state[key], action), _extends2));
    } else if (action.type === clearType) {
      return {
        1: initialPaginationState
      };
    }
    return state;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (paginate);

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(614),
    baseRest = __webpack_require__(619),
    baseUniq = __webpack_require__(631),
    isArrayLikeObject = __webpack_require__(659);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(246),
    isFlattenable = __webpack_require__(615);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(101),
    isArguments = __webpack_require__(248),
    isArray = __webpack_require__(103);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(102),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(101);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(249),
    overRest = __webpack_require__(620),
    setToString = __webpack_require__(622);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(621);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(623),
    shortOut = __webpack_require__(630);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(624),
    defineProperty = __webpack_require__(625),
    identity = __webpack_require__(249);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(250),
    isMasked = __webpack_require__(627),
    isObject = __webpack_require__(251),
    toSource = __webpack_require__(252);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(628);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(253),
    arrayIncludes = __webpack_require__(651),
    arrayIncludesWith = __webpack_require__(656),
    cacheHas = __webpack_require__(256),
    createSet = __webpack_require__(657),
    setToArray = __webpack_require__(146);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(633),
    ListCache = __webpack_require__(105),
    Map = __webpack_require__(145);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(634),
    hashDelete = __webpack_require__(635),
    hashGet = __webpack_require__(636),
    hashHas = __webpack_require__(637),
    hashSet = __webpack_require__(638);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 635 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(652);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(653),
    baseIsNaN = __webpack_require__(654),
    strictIndexOf = __webpack_require__(655);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(257),
    noop = __webpack_require__(658),
    setToArray = __webpack_require__(146);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(258),
    isObjectLike = __webpack_require__(70);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_accessory__ = __webpack_require__(99);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  isCountable: true,
  everySixteenAccessories: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_accessory__["b" /* actionTypes */].UPDATE_COUNTER_CLICKED_TIME:
      return _extends({}, state, {
        isCountable: payload.isCountable,
        everySixteenAccessories: payload.everySixteenAccessories
      });
    default:
      return state;
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rootSagas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_async__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__outlet_async__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_async__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accessory_async__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__location__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__environment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessory__ = __webpack_require__(99);
/* unused harmony reexport locationTypes */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__location__["a"]; });
/* unused harmony reexport locationSelectors */
/* unused harmony reexport environmentTypes */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__environment__["a"]; });
/* unused harmony reexport environmentSelectors */
/* unused harmony reexport accessoryTypes */
/* unused harmony reexport accessoryActions */
var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSagas);












/** Root saga for state side effect management.
 * https://redux-saga.github.io/redux-saga/docs/introduction/index.html
 * */
function rootSagas() {
  return regeneratorRuntime.wrap(function rootSagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return [Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_1__location_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__outlet_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_3__search_async__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_4__accessory_async__["a" /* updateCounterClickedTimeTask */])];

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}



/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gtm__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gtm_events__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_geo__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_persist__ = __webpack_require__(53);
var _marked = /*#__PURE__*/regeneratorRuntime.mark(updatePostcode),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchLocation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(requestPostcodeInput),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(cancelPostcodeInput),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(_callee5);








var LOCATION_FETCH_START = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_START,
    LOCATION_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_SUCCESS,
    LOCATION_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_ERROR,
    LOCATION_FETCH_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_FETCH_REQUEST,
    UPDATE_POSTCODE_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].UPDATE_POSTCODE_REQUEST,
    UPDATE_POSTCODE_SUCCESS = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].UPDATE_POSTCODE_SUCCESS,
    POSTCODE_INPUT_REQUEST = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_INPUT_REQUEST,
    POSTCODE_INPUT_CANCEL = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_INPUT_CANCEL,
    POSTCODE_POPUP_SHOW = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_POPUP_SHOW,
    POSTCODE_POPUP_HIDE = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].POSTCODE_POPUP_HIDE,
    LOCATION_CONFIRMED = __WEBPACK_IMPORTED_MODULE_1__location__["b" /* actionTypes */].LOCATION_CONFIRMED;


function updatePostcode(_ref) {
  var payload = _ref.payload;

  var _ref2, state, locality, newPostcode;

  return regeneratorRuntime.wrap(function updatePostcode$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOCATION_FETCH_START });

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4__apis_geo__["b" /* fetchGeoDataFromPostcode */], payload.postcode);

        case 5:
          _ref2 = _context.sent;
          state = _ref2.state;
          locality = _ref2.locality;
          newPostcode = _ref2.postcode;


          Object(__WEBPACK_IMPORTED_MODULE_5__apis_persist__["d" /* persist */])({
            postcode: newPostcode,
            state: state,
            locality: locality,
            localDealer: ''
          });

          _context.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: UPDATE_POSTCODE_SUCCESS });

        case 12:
          _context.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__gtm__["a" /* gtmEvent */])({
            gtmID: __WEBPACK_IMPORTED_MODULE_3__gtm_events__["c" /* postcodeActionTypes */].PCPU_ENTER_POSTCODE,
            gtmPayload: { postcode: newPostcode }
          }));

        case 14:
          _context.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: LOCATION_FETCH_SUCCESS,
            payload: {
              state: state,
              locality: locality,
              postcode: newPostcode
            }
          });

        case 16:
          _context.next = 23;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context['catch'](2);

          console.warn(_context.t0);
          _context.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOCATION_FETCH_ERROR, payload: { error: _context.t0 } });

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[2, 18]]);
}

function fetchLocation() {
  var _ref3, latitude, longitude, _ref4, coords, _ref5, postcode, locality, state, _ref6, locationConfirmed, _ref7, _state, _locationConfirmed;

  return regeneratorRuntime.wrap(function fetchLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 2:
          _ref3 = _context2.sent;
          latitude = _ref3.latitude;
          longitude = _ref3.longitude;
          _context2.prev = 5;

          if (Number(latitude) && Number(longitude)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_4__apis_geo__["c" /* getCurrentPosition */])();

        case 9:
          _ref4 = _context2.sent;
          coords = _ref4.coords;

          latitude = coords.latitude;
          longitude = coords.longitude;

        case 13:

          Object(__WEBPACK_IMPORTED_MODULE_5__apis_persist__["d" /* persist */])({ latitude: latitude, longitude: longitude });

          _context2.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOCATION_FETCH_START });

        case 16:
          _context2.next = 18;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4__apis_geo__["a" /* fetchGeoDataFromPosition */], {
            latitude: latitude,
            longitude: longitude
          });

        case 18:
          _ref5 = _context2.sent;
          postcode = _ref5.postcode;
          locality = _ref5.locality;
          state = _ref5.state;

          Object(__WEBPACK_IMPORTED_MODULE_5__apis_persist__["d" /* persist */])({
            postcode: postcode,
            state: state,
            locality: locality,
            localDealer: ''
          });

          _context2.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 25:
          _ref6 = _context2.sent;
          locationConfirmed = _ref6.locationConfirmed;
          _context2.next = 29;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: LOCATION_FETCH_SUCCESS,
            payload: {
              state: state,
              locality: locality,
              postcode: postcode
            }
          });

        case 29:
          if (locationConfirmed) {
            _context2.next = 32;
            break;
          }

          _context2.next = 32;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(requestPostcodeInput);

        case 32:
          _context2.next = 47;
          break;

        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2['catch'](5);

          console.warn(_context2.t0);
          _context2.next = 39;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 39:
          _ref7 = _context2.sent;
          _state = _ref7.state;
          _locationConfirmed = _ref7.locationConfirmed;
          _context2.next = 44;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOCATION_FETCH_ERROR, payload: { error: _context2.t0 } });

        case 44:
          if (!(!_state && !_locationConfirmed)) {
            _context2.next = 47;
            break;
          }

          _context2.next = 47;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(requestPostcodeInput);

        case 47:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[5, 34]]);
}

function requestPostcodeInput() {
  var _ref8, postcodePopupOpen, _ref9, gotPostcode, closed;

  return regeneratorRuntime.wrap(function requestPostcodeInput$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 2:
          _ref8 = _context3.sent;
          postcodePopupOpen = _ref8.postcodePopupOpen;

          if (postcodePopupOpen) {
            _context3.next = 19;
            break;
          }

          _context3.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: POSTCODE_POPUP_SHOW });

        case 7:
          _context3.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* race */])({
            gotPostcode: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(UPDATE_POSTCODE_SUCCESS),
            closed: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(POSTCODE_POPUP_HIDE)
          });

        case 9:
          _ref9 = _context3.sent;
          gotPostcode = _ref9.gotPostcode;
          closed = _ref9.closed;

          if (!(gotPostcode || closed)) {
            _context3.next = 19;
            break;
          }

          Object(__WEBPACK_IMPORTED_MODULE_5__apis_persist__["d" /* persist */])({ locationConfirmed: true });
          _context3.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOCATION_CONFIRMED });

        case 16:
          if (closed) {
            _context3.next = 19;
            break;
          }

          _context3.next = 19;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: POSTCODE_POPUP_HIDE });

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function cancelPostcodeInput() {
  return regeneratorRuntime.wrap(function cancelPostcodeInput$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: POSTCODE_POPUP_HIDE });

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function _callee5() {
  return regeneratorRuntime.wrap(function _callee5$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return [Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(LOCATION_FETCH_REQUEST, fetchLocation);

                  case 2:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(UPDATE_POSTCODE_REQUEST, updatePostcode);

                  case 2:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(POSTCODE_INPUT_REQUEST, requestPostcodeInput);

                  case 2:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee3, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(POSTCODE_INPUT_CANCEL, cancelPostcodeInput);

                  case 2:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee4, this);
          }))];

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getErrorMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGeoDataFromPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGeoDataFromPosition; });
/* unused harmony export fetchGeoDataFromAddress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_errors__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__google_maps__ = __webpack_require__(664);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var firstOfType = function firstOfType(type, arr) {
  return arr.find(function (_ref) {
    var types = _ref.types;
    return types.indexOf(type) !== -1;
  });
};

var parseGeocoderResults = function parseGeocoderResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref2 = firstOfType('postal_code', results) || {},
      _ref2$address_compone = _ref2.address_components,
      addressComponents = _ref2$address_compone === undefined ? [] : _ref2$address_compone;

  var locality = firstOfType('locality', addressComponents);
  var state = firstOfType('administrative_area_level_1', addressComponents);
  var postcode = firstOfType('postal_code', addressComponents);

  return _extends({}, state ? {
    state: state.short_name
  } : {}, locality ? {
    locality: locality.short_name
  } : {}, postcode ? {
    postcode: postcode.short_name
  } : {});
};

var geolocation = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* get */])('navigator.geolocation', __WEBPACK_IMPORTED_MODULE_1__constants_environment__["k" /* WINDOW */] || {});

var getErrorMessage = function getErrorMessage(error) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_errors__["c" /* GEO_ERRORS */][error.message || error] || __WEBPACK_IMPORTED_MODULE_2__constants_errors__["c" /* GEO_ERRORS */].default;
};

var geocode = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var geocoder, statusCodes, googleGeocode;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            geocoder = void 0;
            statusCodes = void 0;
            _context.prev = 2;
            _context.next = 5;
            return Object(__WEBPACK_IMPORTED_MODULE_3__google_maps__["a" /* getGeocoder */])();

          case 5:
            googleGeocode = _context.sent;

            geocoder = googleGeocode.geocoder;
            statusCodes = googleGeocode.statusCodes;
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](2);
            throw new Error('NO_GEOCODER');

          case 13:
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              var _geocoder;

              (_geocoder = geocoder).geocode.apply(_geocoder, args.concat([function (results, status) {
                if (status !== statusCodes.OK) reject('GEOCODER_' + status);
                resolve(results);
              }]));
            }));

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[2, 10]]);
  }));

  return function geocode() {
    return _ref3.apply(this, arguments);
  };
}();

var getCurrentPosition = function getCurrentPosition(options) {
  if (!geolocation) throw new Error('NO_GEOLOCATION');

  return new Promise(function (resolve, reject) {
    geolocation.getCurrentPosition(resolve, function (_ref4) {
      var code = _ref4.code;
      return reject('GEOLOCATION_' + code);
    }, options);
  });
};

var fetchGeoDataFromPostcode = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(postcode) {
    var results, _parseGeocoderResults, state, locality, newPostcode;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return geocode({
              address: postcode + ', Australia',
              componentRestrictions: {
                country: 'AU'
              }
            });

          case 3:
            results = _context2.sent;
            _parseGeocoderResults = parseGeocoderResults(results), state = _parseGeocoderResults.state, locality = _parseGeocoderResults.locality, newPostcode = _parseGeocoderResults.postcode;

            if (state) {
              _context2.next = 7;
              break;
            }

            throw new Error('POSTCODE_NOT_FOUND');

          case 7:
            return _context2.abrupt('return', {
              state: state,
              locality: locality,
              postcode: newPostcode
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](0);
            throw _context2.t0;

          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 10]]);
  }));

  return function fetchGeoDataFromPostcode(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchGeoDataFromPosition = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7) {
    var latitude = _ref7.latitude,
        longitude = _ref7.longitude;

    var results, _parseGeocoderResults2, state, locality, postcode;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return geocode({
              location: {
                lat: Number(latitude),
                lng: Number(longitude)
              }
            });

          case 3:
            results = _context3.sent;
            _parseGeocoderResults2 = parseGeocoderResults(results), state = _parseGeocoderResults2.state, locality = _parseGeocoderResults2.locality, postcode = _parseGeocoderResults2.postcode;

            if (!(!state || !postcode)) {
              _context3.next = 7;
              break;
            }

            throw new Error('LOCATION_NOT_FOUND');

          case 7:
            return _context3.abrupt('return', {
              state: state,
              locality: locality,
              postcode: postcode
            });

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](0);
            throw _context3.t0;

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 10]]);
  }));

  return function fetchGeoDataFromPosition(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchGeoDataFromAddress = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(address) {
    var getAddressComponent, _ref11, place;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            getAddressComponent = function getAddressComponent(components, componentType) {
              for (var _iterator = components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray) {
                  if (_i >= _iterator.length) break;
                  _ref9 = _iterator[_i++];
                } else {
                  _i = _iterator.next();
                  if (_i.done) break;
                  _ref9 = _i.value;
                }

                var component = _ref9;

                for (var _iterator2 = component.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                  var _ref10;

                  if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref10 = _iterator2[_i2++];
                  } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref10 = _i2.value;
                  }

                  var type = _ref10;

                  if (type === componentType) return component.short_name;
                }
              }
            };

            _context4.prev = 1;
            _context4.next = 4;
            return geocode(address);

          case 4:
            _ref11 = _context4.sent;
            place = _ref11[0];
            return _context4.abrupt('return', {
              addressDetails: {
                state: getAddressComponent(place.address_components, 'administrative_area_level_1'),
                postcode: getAddressComponent(place.address_components, 'postal_code'),
                suburb: getAddressComponent(place.address_components, 'locality'),
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              },
              placeId: place.place_id
            });

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4['catch'](1);
            throw _context4.t0;

          case 12:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[1, 9]]);
  }));

  return function fetchGeoDataFromAddress(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getGoogleMapsApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGeocoder; });
/* unused harmony export getAutocompleteService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_utils_loaders_google_map_loader__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_utils_loaders_google_map_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_utils_loaders_google_map_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_config__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Use exisiting loader util from google-map-react so we avoid conflicts in maps api load




var defaultMapsConfig = { key: __WEBPACK_IMPORTED_MODULE_1__constants_config__["a" /* GOOGLE_MAPS_API_KEY */], libraries: ['places'] };
var defaultKeys = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* pick */])(Object.keys(defaultMapsConfig));

var cachedGeocoder = null;
var cachedAutocompleteService = null;

var getGoogleMapsApi = function getGoogleMapsApi() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultMapsConfig$co = _extends({}, defaultMapsConfig, config),
      key = _defaultMapsConfig$co.key,
      libraries = _defaultMapsConfig$co.libraries;

  return __WEBPACK_IMPORTED_MODULE_0_google_map_react_lib_utils_loaders_google_map_loader___default()({ key: key, libraries: libraries.join(',') });
};

var getGeocoder = function getGeocoder() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (cachedGeocoder) return Promise.resolve(_extends({}, cachedGeocoder));
  return getGoogleMapsApi(defaultKeys(config)).then(function (_ref) {
    var Geocoder = _ref.Geocoder,
        GeocoderLocationTypes = _ref.GeocoderLocationTypes,
        GeocoderStatus = _ref.GeocoderStatus;

    cachedGeocoder = {
      geocoder: new Geocoder(),
      locationTypes: GeocoderLocationTypes,
      statusCodes: GeocoderStatus
    };
    return _extends({}, cachedGeocoder);
  });
};

var getAutocompleteService = function getAutocompleteService() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (cachedAutocompleteService) return Promise.resolve(_extends({}, cachedAutocompleteService));
  return getGoogleMapsApi(defaultKeys(config)).then(function (_ref2) {
    var places = _ref2.places;

    cachedAutocompleteService = {
      autocompleteService: new places.AutocompleteService(),
      statusCodes: places.PlacesServiceStatus
    };

    return _extends({}, cachedAutocompleteService);
  });
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = googleMapLoader;
/* eslint-disable no-console */
var $script_ = null;

var loadPromise_ = void 0;

var resolveCustomPromise_ = void 0;
var _customPromise = new Promise(function (resolve) {
  resolveCustomPromise_ = resolve;
});

// TODO add libraries language and other map options
function googleMapLoader(bootstrapURLKeys) {
  if (!$script_) {
    $script_ = __webpack_require__(666); // eslint-disable-line
  }

  // call from outside google-map-react
  // will be as soon as loadPromise_ resolved
  if (!bootstrapURLKeys) {
    return _customPromise;
  }

  if (loadPromise_) {
    return loadPromise_;
  }

  loadPromise_ = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(new Error('google map cannot be loaded outside browser env'));
      return;
    }

    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
      reject(new Error('google map initialization error'));
    }

    window._$_google_map_initialize_$_ = function () {
      delete window._$_google_map_initialize_$_;
      resolve(window.google.maps);
    };

    if (false) {
      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
        console.error('"callback" key in bootstrapURLKeys is not allowed, ' + // eslint-disable-line
        'use onGoogleApiLoaded property instead');
        throw new Error('"callback" key in bootstrapURLKeys is not allowed, ' + 'use onGoogleApiLoaded property instead');
      }
    }

    var queryString = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
      return r + '&' + key + '=' + bootstrapURLKeys[key];
    }, '');

    $script_('https://maps.googleapis.com/maps/api/js?callback=_$_google_map_initialize_$_' + queryString, function () {
      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
    });
  });

  resolveCustomPromise_(loadPromise_);

  return loadPromise_;
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchStock */
/* unused harmony export fetchDealerInfo */
/* unused harmony export dealerChangeRequest */
/* unused harmony export refreshStock */
/* unused harmony export initOutletStore */
/* unused harmony export nameplateChange */
/* unused harmony export showResults */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__outlet__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_persist__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_dealer_search__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_outlet__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gtm_events__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gtm__ = __webpack_require__(142);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchStock),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchDealerInfo),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(dealerChangeRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(refreshStock),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(initOutletStore),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(nameplateChange),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(dealerConfirm),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(showResults),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(_callee5);










var INIT_OUTLET_STORE = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].INIT_OUTLET_STORE,
    LOAD_OUTLET_STORE = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].LOAD_OUTLET_STORE,
    STEP_CHANGE = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].STEP_CHANGE,
    DEALER_CHANGE_REQUEST = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_CHANGE_REQUEST,
    DEALER_CHANGE_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_CHANGE_SUCCESS,
    DEALER_CHANGE_NO_RESULTS = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_CHANGE_NO_RESULTS,
    DEALER_CONFIRM = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_CONFIRM,
    DEALER_FETCH_START = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_FETCH_START,
    DEALER_FETCH_CANNOT_RESOLVE = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_FETCH_CANNOT_RESOLVE,
    DEALER_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_FETCH_SUCCESS,
    DEALER_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].DEALER_FETCH_ERROR,
    NAMEPLATE_CHANGE = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].NAMEPLATE_CHANGE,
    OUTLET_STOCKS_FETCH_START = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_START,
    OUTLET_STOCKS_FETCH_SUCCESS = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_SUCCESS,
    OUTLET_STOCKS_FETCH_ERROR = __WEBPACK_IMPORTED_MODULE_2__outlet__["a" /* actionTypes */].OUTLET_STOCKS_FETCH_ERROR;


function fetchStock() {
  var dealerCode, id, _ref, dealer, nameplate, outletStockEndpoint, _ref2, response, error, availability, _ref4, _ref4$stock, stock;

  return regeneratorRuntime.wrap(function fetchStock$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          dealerCode = void 0, id = void 0;
          _context.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: OUTLET_STOCKS_FETCH_START });

        case 3:
          _context.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* selectors */].getOutlet);

        case 5:
          _ref = _context.sent;
          dealer = _ref.dealer;
          nameplate = _ref.nameplate;
          outletStockEndpoint = _ref.outletStockEndpoint;

          if (dealer) {
            dealerCode = dealer.dealerCode;
            id = dealer.id;
          }
          _context.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_5__apis_outlet__["b" /* fetchStockData */], {
            dealerCode: dealerCode,
            locationId: id,
            nameplate: nameplate,
            outletStockEndpoint: outletStockEndpoint
          });

        case 12:
          _ref2 = _context.sent;
          response = _ref2.response;
          error = _ref2.error;

          if (!error) {
            _context.next = 18;
            break;
          }

          _context.next = 18;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: OUTLET_STOCKS_FETCH_ERROR, payload: { error: error } });

        case 18:
          if (!response) {
            _context.next = 23;
            break;
          }

          availability = response.map(function (_ref3) {
            var nameplate = _ref3.nameplate,
                inStock = _ref3.inStock;
            return {
              nameplate: nameplate,
              inStock: inStock
            };
          });
          _ref4 = response.find(function (stock) {
            return stock.nameplate === nameplate;
          }) || {}, _ref4$stock = _ref4.stock, stock = _ref4$stock === undefined ? [] : _ref4$stock;
          _context.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: OUTLET_STOCKS_FETCH_SUCCESS,
            payload: {
              availability: availability,
              results: Array.isArray(stock) ? stock : []
            }
          });

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchDealerInfo(_ref5) {
  var _ref5$payload = _ref5.payload,
      dealer = _ref5$payload.dealer,
      postcode = _ref5$payload.postcode;

  var search, _ref6, response, error, singleDealerInfo, _dealer, dealerCode, id;

  return regeneratorRuntime.wrap(function fetchDealerInfo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(dealer && postcode)) {
            _context2.next = 2;
            break;
          }

          throw new Error('Can only update local dealer from postcode or dealercode');

        case 2:
          if (!(dealer && dealer.fetched)) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt('return');

        case 4:
          _context2.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: DEALER_FETCH_START });

        case 6:
          search = dealer ? { dealerCode: dealer.dealerCode } : { postcode: postcode };
          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4__apis_dealer_search__["a" /* dealerInfo */], _extends({
            dealerTypes: ['sales']
          }, search));

        case 9:
          _ref6 = _context2.sent;
          response = _ref6.response;
          error = _ref6.error;

          if (!response) {
            _context2.next = 27;
            break;
          }

          singleDealerInfo = void 0;

          if (response.length !== 1) {
            if (dealer && dealer.id) {
              singleDealerInfo = response.find(function (_ref7) {
                var id = _ref7.id;
                return id === dealer.id;
              });
            }
          } else {
            singleDealerInfo = response[0];
          }

          if (!singleDealerInfo) {
            _context2.next = 23;
            break;
          }

          _dealer = _extends({}, singleDealerInfo, { fetched: true });
          dealerCode = _dealer.dealerCode, id = _dealer.id;

          Object(__WEBPACK_IMPORTED_MODULE_3__apis_persist__["d" /* persist */])({ localDealer: { dealerCode: dealerCode, id: id } });
          _context2.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: DEALER_FETCH_SUCCESS, payload: { dealer: _dealer } });

        case 21:
          _context2.next = 25;
          break;

        case 23:
          _context2.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: DEALER_FETCH_CANNOT_RESOLVE });

        case 25:
          _context2.next = 29;
          break;

        case 27:
          _context2.next = 29;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: DEALER_FETCH_ERROR, payload: { error: error } });

        case 29:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function dealerChangeRequest(_ref8) {
  var payload = _ref8.payload;
  return regeneratorRuntime.wrap(function dealerChangeRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(fetchDealerInfo, { payload: payload });

        case 2:
          _context3.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(refreshStock);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function refreshStock() {
  var autoConfirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref9, results, dealer, nameplate, _ref10, noResultMessage;

  return regeneratorRuntime.wrap(function refreshStock$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(fetchStock);

        case 2:
          _context4.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* selectors */].getOutlet);

        case 4:
          _ref9 = _context4.sent;
          results = _ref9.results;
          dealer = _ref9.dealer;
          nameplate = _ref9.nameplate;

          if (!(results && results.length > 0 || !nameplate)) {
            _context4.next = 13;
            break;
          }

          _context4.next = 11;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: DEALER_CHANGE_SUCCESS,
            payload: { dealer: dealer, dealerConfirm: autoConfirm }
          });

        case 11:
          _context4.next = 16;
          break;

        case 13:
          noResultMessage = dealer && dealer.fetched ? (_ref10 = {}, _ref10[Object(__WEBPACK_IMPORTED_MODULE_5__apis_outlet__["a" /* cacheKeyGen */])(dealer, nameplate)] = true, _ref10) : {};
          _context4.next = 16;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: DEALER_CHANGE_NO_RESULTS,
            payload: { noResultMessage: noResultMessage, dealerConfirm: autoConfirm }
          });

        case 16:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function initOutletStore() {
  var _ref11, _ref11$dealer, dealer, _ref12, postcode, _dealer2, dealerCode, _ref13;

  return regeneratorRuntime.wrap(function initOutletStore$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* selectors */].getOutlet);

        case 2:
          _ref11 = _context5.sent;
          _ref11$dealer = _ref11.dealer;
          dealer = _ref11$dealer === undefined ? {} : _ref11$dealer;
          _context5.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__location__["c" /* selectors */].getLocation);

        case 7:
          _ref12 = _context5.sent;
          postcode = _ref12.postcode;
          _dealer2 = dealer, dealerCode = _dealer2.dealerCode;

          if (!(!dealerCode && postcode || dealerCode && !dealer.fetched)) {
            _context5.next = 17;
            break;
          }

          _context5.next = 13;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(fetchDealerInfo, {
            payload: dealerCode ? { dealer: dealer } : { postcode: postcode }
          });

        case 13:
          _context5.next = 15;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* selectors */].getOutlet);

        case 15:
          _ref13 = _context5.sent;
          dealer = _ref13.dealer;

        case 17:
          _context5.next = 19;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(refreshStock, true);

        case 19:
          _context5.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: STEP_CHANGE,
            payload: { step: 'SHOW_RESULTS', copyMode: 'WELCOME' }
          });

        case 21:
          _context5.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({ type: LOAD_OUTLET_STORE });

        case 23:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function nameplateChange() {
  return regeneratorRuntime.wrap(function nameplateChange$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(refreshStock, true);

        case 2:
          _context6.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(showResults);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function dealerConfirm() {
  var _ref14, name;

  return regeneratorRuntime.wrap(function dealerConfirm$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_2__outlet__["b" /* selectors */].getOutlet);

        case 2:
          _ref14 = _context7.sent;
          name = _ref14.dealer.name;
          _context7.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__gtm__["a" /* gtmEvent */])({
            gtmID: __WEBPACK_IMPORTED_MODULE_6__gtm_events__["b" /* gtmOutletStoreActionTypes */].SELECT_DEALER_NAME,
            gtmPayload: { dealerName: name }
          }));

        case 6:
          _context7.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(showResults);

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function showResults() {
  return regeneratorRuntime.wrap(function showResults$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: STEP_CHANGE,
            payload: { step: 'SHOW_RESULTS' }
          });

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function _callee5() {
  return regeneratorRuntime.wrap(function _callee5$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return [Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(INIT_OUTLET_STORE, initOutletStore);

                  case 2:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(DEALER_CHANGE_REQUEST, dealerChangeRequest);

                  case 2:
                  case 'end':
                    return _context10.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(NAMEPLATE_CHANGE, nameplateChange);

                  case 2:
                  case 'end':
                    return _context11.stop();
                }
              }
            }, _callee3, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(DEALER_CONFIRM, dealerConfirm);

                  case 2:
                  case 'end':
                    return _context12.stop();
                }
              }
            }, _callee4, this);
          }))];

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked9, this);
}

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dealerInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MJO__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_cache__ = __webpack_require__(289);
var fetchFromApi = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dealersAPI, options) {
    var dealers;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__MJO__["a" /* fetchMJOData */])(dealersAPI, options);

          case 2:
            dealers = _context2.sent;
            return _context2.abrupt('return', { data: dealers });

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var dealersAPI = '/api/dealers';

var dealerInfo = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var dealerCode = _ref2.dealerCode,
        postcode = _ref2.postcode,
        _ref2$dealerTypes = _ref2.dealerTypes,
        dealerTypes = _ref2$dealerTypes === undefined ? ['sales'] : _ref2$dealerTypes;

    var sortedDealerTypes, apiOptions, dealers, cacheKey, _ref3, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sortedDealerTypes = dealerTypes.sort();
            apiOptions = {
              DealerCode: dealerCode || null,
              postcode: postcode || null,
              DealerType: sortedDealerTypes.join(',')
            };
            dealers = void 0;
            _context.prev = 3;

            if (!(dealerCode || postcode)) {
              _context.next = 13;
              break;
            }

            cacheKey = 'localdealer_' + (dealerCode || postcode) + '_' + (sortedDealerTypes.join('_') || 'none');
            _context.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_cache__["a" /* cacheApiResponse */])(cacheKey, function () {
              return fetchFromApi(dealersAPI, apiOptions);
            });

          case 8:
            _ref3 = _context.sent;
            response = _ref3.response;

            dealers = response;
            _context.next = 14;
            break;

          case 13:
            throw new Error('Cannot complete dealer search without dealerCode or postcode');

          case 14:
            return _context.abrupt('return', { response: dealers });

          case 17:
            _context.prev = 17;
            _context.t0 = _context['catch'](3);
            return _context.abrupt('return', { error: _context.t0 });

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 17]]);
  }));

  return function dealerInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchMJOData; });
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchMJOData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params) {
    var options, response, json, success, data, errorMsg, errorCode, error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(params)
            };
            _context.prev = 1;
            _context.next = 4;
            return fetch(url, options);

          case 4:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 7;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            json = _context.sent;
            success = json.success, data = json.data, errorMsg = json.errorMsg, errorCode = json.errorCode;

            if (success) {
              _context.next = 15;
              break;
            }

            error = new Error(errorMsg || errorCode);


            if (data) error.data = data;

            throw error;

          case 15:

            if (!data) console.warn('No data returned.', json);

            return _context.abrupt('return', data || undefined);

          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](1);

            console.warn('MJO fetch failed', _context.t0, url, params);
            throw _context.t0;

          case 23:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 19]]);
  }));

  return function fetchMJOData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchStockData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheKeyGen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_cache__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
var fetchFromApi = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, { method: 'GET' });

          case 2:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 5:
            return _context2.abrupt('return', response.json());

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var getRequestURL = function getRequestURL(endpoint, params) {
  return endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
};

var fetchStockData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        nameplate = _ref2.nameplate,
        locationId = _ref2.locationId,
        dealerCode = _ref2.dealerCode,
        outletStockEndpoint = _ref2.outletStockEndpoint;

    var checksum, getRequestedNameplateData, invalidateCache, cacheKey, cache, _JSON$parse, _data, _getRequestedNameplat2, lastModified, count, url, data, _ref4, response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(!nameplate && !dealerCode)) {
              _context.next = 3;
              break;
            }

            throw new Error('A nameplate or dealercode is required to fetch stock');

          case 3:
            if (dealerCode && locationId) {
              _context.next = 5;
              break;
            }

            throw new Error('DealerCode should be used in combination with location locationId');

          case 5:
            if (!(nameplate && !dealerCode)) {
              _context.next = 7;
              break;
            }

            throw new Error('Nameplate results without dealer is not supported');

          case 7:
            if (outletStockEndpoint) {
              _context.next = 9;
              break;
            }

            throw new Error('Cannot fetch without endpoint');

          case 9:
            checksum = 0;

            getRequestedNameplateData = function getRequestedNameplateData(data) {
              return data.find(function (savedNameplate) {
                return savedNameplate.nameplate === nameplate;
              });
            };

            invalidateCache = function invalidateCache(_ref3) {
              var data = _ref3.data;
              return function () {
                if (!nameplate) return true; // If the query is for all stock always invalidate the cache

                var _getRequestedNameplat = getRequestedNameplateData(data),
                    lastModified = _getRequestedNameplat.lastModified,
                    count = _getRequestedNameplat.count;

                return checksum !== checksumGen({ lastModified: lastModified, count: count });
              };
            };

            cacheKey = cacheKeyGen({ dealerCode: dealerCode, id: locationId }, nameplate);
            cache = __WEBPACK_IMPORTED_MODULE_2__constants_environment__["k" /* WINDOW */].localStorage.getItem(cacheKey);


            if (cache && nameplate) {
              _JSON$parse = JSON.parse(cache), _data = _JSON$parse.data;
              _getRequestedNameplat2 = getRequestedNameplateData(_data), lastModified = _getRequestedNameplat2.lastModified, count = _getRequestedNameplat2.count;

              checksum = checksumGen({ lastModified: lastModified, count: count });
            }
            url = getRequestURL(outletStockEndpoint, {
              nameplate: nameplate,
              locationId: locationId,
              dealerCode: dealerCode,
              checksum: checksum
            });
            _context.next = 18;
            return fetchFromApi(url);

          case 18:
            data = _context.sent;
            _context.next = 21;
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_cache__["a" /* cacheApiResponse */])(cacheKey, function () {
              return data;
            }, invalidateCache(data));

          case 21:
            _ref4 = _context.sent;
            response = _ref4.response;
            return _context.abrupt('return', { response: response });

          case 26:
            _context.prev = 26;
            _context.t0 = _context['catch'](0);

            console.warn('OUTLET FETCH', _context.t0);
            return _context.abrupt('return', { error: _context.t0 });

          case 30:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 26]]);
  }));

  return function fetchStockData() {
    return _ref.apply(this, arguments);
  };
}();

var checksumGen = function checksumGen(_ref6) {
  var lastModified = _ref6.lastModified,
      count = _ref6.count;

  if (lastModified && count) return String(lastModified) + String(count);
  return 0;
};

var cacheKeyGen = function cacheKeyGen(dealer, nameplate) {
  return ((nameplate || 0) + '_' + (dealer.dealerCode || 0) + '_' + (dealer.id || 0)).replace(/-|\s/g, '');
};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadInitialData */
/* unused harmony export updateCurrentSearchResults */
/* unused harmony export updatePageData */
/* unused harmony export updateCurrentPage */
/* unused harmony export fetchPageData */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_site_search__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_errors__ = __webpack_require__(90);
var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadInitialData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(updateCurrentSearchResults),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updatePageData),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(updateCurrentPage),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchPageData),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(_callee4);








var LOAD_INITIAL_DATA = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].LOAD_INITIAL_DATA,
    FETCH_SEARCH = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].FETCH_SEARCH,
    UPDATE_SEARCH_QUERY = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].UPDATE_SEARCH_QUERY,
    REQUEST_PAGE = __WEBPACK_IMPORTED_MODULE_1__search__["b" /* actionTypes */].REQUEST_PAGE;


function loadInitialData() {
  var currentPage;
  return regeneratorRuntime.wrap(function loadInitialData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getCurrentPage);

        case 2:
          currentPage = _context.sent;
          _context.next = 5;
          return updateCurrentPage({ payload: currentPage });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function updateCurrentSearchResults(_ref) {
  var payload = _ref.payload;
  var currentPage;
  return regeneratorRuntime.wrap(function updateCurrentSearchResults$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getCurrentPage);

        case 2:
          currentPage = _context2.sent;
          _context2.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__utils__["A" /* pushParam */], { q: payload });

        case 5:
          _context2.next = 7;
          return updatePageData(currentPage);

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// handle request for new data on specific page.
function updatePageData(page) {
  var currentQuery;
  return regeneratorRuntime.wrap(function updatePageData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getQuery);

        case 2:
          currentQuery = _context3.sent;
          _context3.next = 5;
          return fetchPageData(page, currentQuery);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

// handle navigation between result pages
function updateCurrentPage(_ref2) {
  var page = _ref2.payload;

  var pageData, _ref3, failure, pageCount, nextPageData;

  return regeneratorRuntime.wrap(function updateCurrentPage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPage(page));

        case 2:
          pageData = _context4.sent;

          if (!(!pageData || !pageData.results.length)) {
            _context4.next = 12;
            break;
          }

          _context4.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updatePageData, page);

        case 6:
          _context4.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* race */])({
            success: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* requestTypes */].SUCCESS]),
            failure: Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* take */])(FETCH_SEARCH[__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* requestTypes */].FAILURE])
          });

        case 8:
          _ref3 = _context4.sent;
          failure = _ref3.failure;

          if (!failure) {
            _context4.next = 12;
            break;
          }

          return _context4.abrupt('return');

        case 12:
          _context4.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPageCount);

        case 14:
          pageCount = _context4.sent;

          if (!(page !== 1 && page > pageCount)) {
            _context4.next = 19;
            break;
          }

          _context4.next = 18;
          return updateCurrentPage({ payload: 1 });

        case 18:
          return _context4.abrupt('return');

        case 19:
          _context4.next = 21;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__utils__["A" /* pushParam */], { page: page });

        case 21:
          _context4.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(window.scrollTo, 0, 0);

        case 23:
          _context4.next = 25;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].changePage(page));

        case 25:
          _context4.next = 27;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getPage(page + 1));

        case 27:
          nextPageData = _context4.sent;

          if (nextPageData) {
            _context4.next = 30;
            break;
          }

          return _context4.delegateYield(updatePageData(page + 1), 't0', 30);

        case 30:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function fetchPageData(page, query) {
  var pageSize, _ref4, response, error;

  return regeneratorRuntime.wrap(function fetchPageData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* select */])(__WEBPACK_IMPORTED_MODULE_1__search__["c" /* selectors */].getResultsPerPage);

        case 2:
          pageSize = _context5.sent;
          _context5.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.request(page, query));

        case 5:
          _context5.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2__apis_site_search__["a" /* default */], {
            q: query,
            page: page,
            pageSize: pageSize
          });

        case 7:
          _ref4 = _context5.sent;
          response = _ref4.response;
          error = _ref4.error;

          if (!error) {
            _context5.next = 15;
            break;
          }

          _context5.next = 13;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.failure(page, __WEBPACK_IMPORTED_MODULE_5__constants_errors__["e" /* SEARCH_ERRORS */].API_ERROR));

        case 13:
          _context5.next = 17;
          break;

        case 15:
          _context5.next = 17;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1__search__["a" /* actionCreators */].fetchSearch.success(page, response));

        case 17:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function _callee4() {
  return regeneratorRuntime.wrap(function _callee4$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return [Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(LOAD_INITIAL_DATA, loadInitialData);

                  case 2:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(UPDATE_SEARCH_QUERY, updateCurrentSearchResults);

                  case 2:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee2, this);
          })), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* takeLatest */])(REQUEST_PAGE, updateCurrentPage);

                  case 2:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee3, this);
          }))];

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked6, this);
}

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var fetchFromApi = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, { method: 'GET' });

          case 2:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 5;
              break;
            }

            throw new Error('Failed with status ' + response.status);

          case 5:
            _context2.next = 7;
            return response.json();

          case 7:
            return _context2.abrupt('return', _context2.sent);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchFromApi(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var siteSearchEndpoint = '/api/search';

var getRequestURL = function getRequestURL(endpoint, params) {
  return endpoint + '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);
};

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var q = _ref2.q,
        page = _ref2.page,
        pageSize = _ref2.pageSize;

    var url, _ref3, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = getRequestURL(siteSearchEndpoint, {
              q: q,
              page: page,
              pageSize: pageSize
            });
            _context.next = 4;
            return fetchFromApi(url);

          case 4:
            _ref3 = _context.sent;
            data = _ref3.data;
            return _context.abrupt('return', { response: data });

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', { error: _context.t0 });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));

  function fetchSiteSearch(_x) {
    return _ref.apply(this, arguments);
  }

  return fetchSiteSearch;
})());

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateCounterClickedTimeTask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessory__ = __webpack_require__(99);
var _marked = /*#__PURE__*/regeneratorRuntime.mark(updateCounterClickedTimeTask);




var UPDATE_COUNTER_CLICKED_TIME = __WEBPACK_IMPORTED_MODULE_1__accessory__["b" /* actionTypes */].UPDATE_COUNTER_CLICKED_TIME;


function updateCounterClickedTimeTask(isCountable, everySixteenAccessories) {
  return regeneratorRuntime.wrap(function updateCounterClickedTimeTask$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
            type: UPDATE_COUNTER_CLICKED_TIME, payload: { isCountable: isCountable, everySixteenAccessories: everySixteenAccessories }
          });

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__book_testdrive_duck__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compare_tool_duck__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compare_vehicle_selector_duck__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contact_us_duck__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accessory_list_duck__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accordion_duck__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__background_image_selector_duck__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_duck__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__button_duck__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__feature_youtube_duck__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__map_search_duck__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_footer_duck__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_nav_duck__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_tout_block_duck__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__in_page_navigation_duck__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__map_select_state_duck__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mini_configurator_duck__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mymazda_login_duck__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mymazda_summary_duck__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__offers_duck__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__outlet_store_duck__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__outlet_store_enquiry_form_duck__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__recalls_block_duck__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__register_interest_duck__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__search_duck__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__image_tout_block_duck__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__postcode_popup_duck__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__book_service_duck__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__wysiwyg_content_duck__ = __webpack_require__(263);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };































/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_0__book_testdrive_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_1__compare_tool_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_2__compare_vehicle_selector_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_3__contact_us_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_4__accessory_list_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_5__accordion_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_6__background_image_selector_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_7__build_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_8__button_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_9__feature_youtube_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_10__map_search_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_11__global_footer_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_12__global_nav_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_13__icon_tout_block_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_14__in_page_navigation_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_15__map_select_state_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_16__mini_configurator_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_17__mymazda_login_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_18__mymazda_summary_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_19__offers_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_20__outlet_store_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_21__outlet_store_enquiry_form_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_22__recalls_block_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_23__register_interest_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_24__search_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_25__image_tout_block_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_26__postcode_popup_duck__["b" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_27__book_service_duck__["a" /* gtmEvents */], __WEBPACK_IMPORTED_MODULE_28__wysiwyg_content_duck__["a" /* gtmEvents */]));

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEvents = exports.createMetaReducer = exports.createMiddleware = undefined;

var _createMiddleware = __webpack_require__(676);

var _createMiddleware2 = _interopRequireDefault(_createMiddleware);

var _createMetaReducer = __webpack_require__(677);

var _createMetaReducer2 = _interopRequireDefault(_createMetaReducer);

var _createEvents = __webpack_require__(148);

var _createEvents2 = _interopRequireDefault(_createEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createMiddleware = _createMiddleware2.default;
exports.createMetaReducer = _createMetaReducer2.default;
exports.createEvents = _createEvents2.default;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createEvents = __webpack_require__(148);

var _createEvents2 = _interopRequireDefault(_createEvents);

var _registerEvents = __webpack_require__(290);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMiddleware(eventDefinitionsMap, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (store) {
    return function (next) {
      return function (action) {
        if (!eventDefinitionsMap[action.type]) {
          return next(action);
        }

        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();

        var events = (0, _createEvents2.default)(eventDefinitionsMap[action.type], prevState, action, nextState);

        (0, _registerEvents2.default)(events, target, extensions, prevState, action);

        return result;
      };
    };
  };
}

exports.default = createMiddleware;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createEvents = __webpack_require__(148);

var _createEvents2 = _interopRequireDefault(_createEvents);

var _registerEvents = __webpack_require__(290);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMetaReducer(eventDefinitionsMap, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  /* Why not arrow functions? AOT... */
  /* eslint-disable func-names */
  return function (reducer) {
    return function (prevState, action) {
      if (!eventDefinitionsMap[action.type]) {
        return reducer(prevState, action);
      }

      var nextState = reducer(prevState, action);
      var events = (0, _createEvents2.default)(eventDefinitionsMap[action.type], prevState, action, nextState);

      (0, _registerEvents2.default)(events, target, extensions, prevState, action);

      return nextState;
    };
  };
}

exports.default = createMetaReducer;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.logger = undefined;

var _logger = __webpack_require__(679);

exports.logger = _logger.logger;
exports.getTimestamp = _logger.getTimestamp;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getTimestamp(sinceEpoch) {
  var date = new Date(sinceEpoch);
  return date.toTimeString().match(/^\d\d:\d\d:\d\d/g).concat(date.getTime().toString().slice(-3)).join('.');
}

var styles = {
  title: {
    primary: 'color: #1da1f2; font-weight: bold;',
    danger: 'color: #D63230; font-weight: bold;',
    warning: 'color: #F39237; font-weight: bold;'
  },
  label: 'color: #93748A; font-weight: bold;'
};

/* eslint-disable no-console */
var groups = [];
var hr = '-'.repeat(80); // 80 dashes row line

if (!console.group) {
  console.group = function logGroupStart(label) {
    groups.push(label);
    console.log('%c \nBEGIN GROUP: %c', hr, label);
  };
}
if (!console.groupEnd) {
  console.groupEnd = function logGroupEnd() {
    console.log('END GROUP: %c\n%c', groups.pop(), hr);
  };
}

function logEvents(events) {
  if (events.length > 1) {
    console.group('%c Events:', styles.label);
    events.forEach(function (event, index) {
      console.log('%c (' + (index + 1) + ')', styles.label, event);
    });
    console.groupEnd('Events');
  } else if (events.length === 1) {
    console.log('%c Event:', styles.label, events[0]);
  }
}

function logAction(action) {
  console.log('%c Action:', styles.label, action);
}

function logger(events, action, state, isSavedOffline, wasSavedOffline) {
  var timestamp = getTimestamp(Date.now());
  var title = 'Analytics events @ ' + timestamp + ' ' + (action ? action.type : '');

  if (events.length > 0) {
    if (isSavedOffline) {
      console.group('%c ' + title + ' (saved offline)', styles.title.danger);
      logAction(action);
      logEvents(events);
      console.groupEnd();
    } else if (wasSavedOffline) {
      console.group('%c ' + title + ' (was offline)', styles.title.warning);
      logEvents(events);
      console.groupEnd();
    } else {
      console.group('%c ' + title, styles.title.primary);
      logAction(action);
      logEvents(events);
      console.groupEnd();
    }
  }
}

exports.logger = logger;
exports.getTimestamp = getTimestamp;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(681);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GoogleTagManager = function GoogleTagManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$dataLayerName = _ref.dataLayerName,
      dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName;

  return function (events) {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window[dataLayerName] || typeof window[dataLayerName].push !== 'function') {
      throw new Error('redux-beacon error: window.' + dataLayerName + ' is not defined. Have you forgotten to include Google Tag Manager and dataLayer?');
    }
    events.forEach(function (event) {
      var eventToPush = function () {
        if (event.event === undefined && event.hitType !== undefined) {
          return Object.assign({}, event, { event: event.hitType });
        }
        return event;
      }();
      window[dataLayerName].push(eventToPush);
    });
  };
};

module.exports = { GoogleTagManager: GoogleTagManager };

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(683);

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(684),
    addTimestamp = _require.addTimestamp;

var DB_NAME = 'AnalyticsEvents';
var DB_VERSION = 1;

function openDB(dbName, version) {
  return new Promise(function (resolve, reject) {
    var request = window.indexedDB.open(dbName, version);

    request.onsuccess = function (event) {
      var db = event.target.result;
      resolve(db);
    };
    request.onupgradeneeded = function (event) {
      /* Runs if the db hasn't been created yet, or if the requested db
       * version is greater than the existing db version.  This will run
       * before onsuccess */
      var db = event.target.result;
      db.createObjectStore('EventsStore', { autoIncrement: true });
    };
    request.onerror = reject;
  });
}

function save(events, db) {
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction(['EventsStore'], 'readwrite');
    var objectStore = transaction.objectStore('EventsStore');

    var addEvents = objectStore.add(addTimestamp(events));
    addEvents.onsuccess = function () {
      return resolve(events);
    };
    addEvents.onerror = reject;
  });
}

function purge(db) {
  return new Promise(function (resolve, reject) {
    var transaction = db.transaction(['EventsStore'], 'readwrite');
    var objectStore = transaction.objectStore('EventsStore');
    var openCursor = objectStore.openCursor();

    var oldEvents = [];
    openCursor.onsuccess = function (event) {
      var cursor = event.target.result;
      if (cursor) {
        oldEvents = oldEvents.concat(cursor.value);
        objectStore.delete(cursor.key);
        cursor.continue();
      } else {
        resolve(oldEvents);
      }
    };
    openCursor.onerror = reject;
  });
}

function offlineWeb(isConnected) {
  return {
    saveEvents: function saveEvents(events) {
      return openDB(DB_NAME, DB_VERSION).then(function (db) {
        return save(events, db);
      });
    },
    purgeEvents: function purgeEvents(handlePurgedEvents) {
      return openDB(DB_NAME, DB_VERSION).then(purge).then(handlePurgedEvents);
    },

    isConnected: isConnected
  };
}

module.exports = { offlineWeb: offlineWeb, addTimestamp: addTimestamp };

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function addTimestamp(events) {
  return events.map(function (event) {
    return Object.assign({}, event, { timeSaved: Date.now() });
  });
}

module.exports = {
  addTimestamp: addTimestamp
};

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_png__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\animation-sample\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  AnimationSample
 */
var AnimationSample = (_temp = _class = function (_PureComponent) {
  _inherits(AnimationSample, _PureComponent);

  function AnimationSample(props) {
    _classCallCheck(this, AnimationSample);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.renderTextLinkBlack = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'TextLinkBlack', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 150
          }
        },
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF'
      );
    };

    _this.renderTextLinkBlack_current = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'TextLinkBlack current', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 155
          }
        },
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF \u30AB\u30EC\u30F3\u30C8\u72B6\u614B'
      );
    };

    _this.renderTextLinkWhite = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'TextLinkWhite', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 162
          }
        },
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF'
      );
    };

    _this.renderTextLinkWhite_current = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'TextLinkWhite current', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 167
          }
        },
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF \u30AB\u30EC\u30F3\u30C8\u72B6\u614B'
      );
    };

    _this.renderButtonStandardBlack = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ButtonStandardBlack', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 174
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'ButtonStandardBlack__text', __source: {
              fileName: _jsxFileName,
              lineNumber: 175
            }
          },
          '\u30DC\u30BF\u30F3\u30EA\u30F3\u30AF'
        )
      );
    };

    _this.renderButtonStandardWhite = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ButtonStandardWhite', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 183
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'ButtonStandardWhite__text', __source: {
              fileName: _jsxFileName,
              lineNumber: 184
            }
          },
          '\u30DC\u30BF\u30F3\u30EA\u30F3\u30AF'
        )
      );
    };

    _this.renderButtonActionBlack = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ButtonActionBlack', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'ButtonActionBlack__text', __source: {
              fileName: _jsxFileName,
              lineNumber: 193
            }
          },
          '\u30DC\u30BF\u30F3\u30EA\u30F3\u30AF'
        )
      );
    };

    _this.renderButtonActionWhite = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ButtonActionWhite', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 201
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'ButtonActionWhite__text', __source: {
              fileName: _jsxFileName,
              lineNumber: 202
            }
          },
          '\u30DC\u30BF\u30F3\u30EA\u30F3\u30AF'
        )
      );
    };

    _this.renderImageLinkWhite = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ImageLinkWhite', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 210
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ImageLinkWhite__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 211
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'ImageLinkWhite__image', src: __WEBPACK_IMPORTED_MODULE_4__image_png___default.a, __source: {
              fileName: _jsxFileName,
              lineNumber: 212
            }
          })
        ),
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u753B\u50CF\u6709\u308A\u30EA\u30F3\u30AF'
      );
    };

    _this.renderImageLinkWhite_current = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ImageLinkWhite current', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 220
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ImageLinkWhite__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 221
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'ImageLinkWhite__image', src: __WEBPACK_IMPORTED_MODULE_4__image_png___default.a, __source: {
              fileName: _jsxFileName,
              lineNumber: 222
            }
          })
        ),
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u753B\u50CF\u6709\u308A\u30EA\u30F3\u30AF \u30AB\u30EC\u30F3\u30C8\u72B6\u614B'
      );
    };

    _this.renderImageLinkBlack = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ImageLinkBlack', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 232
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ImageLinkBlack__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 233
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'ImageLinkBlack__image', src: __WEBPACK_IMPORTED_MODULE_4__image_png___default.a, __source: {
              fileName: _jsxFileName,
              lineNumber: 234
            }
          })
        ),
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u753B\u50CF\u6709\u308A\u30EA\u30F3\u30AF'
      );
    };

    _this.renderImageLinkBlack_current = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'ImageLinkBlack current', href: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 242
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ImageLinkBlack__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 243
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'ImageLinkBlack__image', src: __WEBPACK_IMPORTED_MODULE_4__image_png___default.a, __source: {
              fileName: _jsxFileName,
              lineNumber: 244
            }
          })
        ),
        '\u4E0B\u7DDA\u4ED8\u304D\u306E\u753B\u50CF\u6709\u308A\u30EA\u30F3\u30AF \u30AB\u30EC\u30F3\u30C8\u72B6\u614B'
      );
    };

    _this.renderToggleContents = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ToggleContents', __source: {
            fileName: _jsxFileName,
            lineNumber: 254
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'ToggleContents__list-nav', __source: {
              fileName: _jsxFileName,
              lineNumber: 255
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 256
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'TextLinkBlack' + (_this.state.currentContentId === 'content01' ? ' current' : ''),
                href: 'javascript:void(0)',
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this.setState({
                    currentContentId: 'content01'
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 257
                }
              },
              '\u30B3\u30F3\u30C6\u30F3\u30C4 01'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 267
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'TextLinkBlack' + (_this.state.currentContentId === 'content02' ? ' current' : ''),
                href: 'javascript:void(0)',
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this.setState({
                    currentContentId: 'content02'
                  });
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 268
                }
              },
              '\u30B3\u30F3\u30C6\u30F3\u30C4 02'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ToggleContents__content' + (_this.state.currentContentId === 'content01' ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 279
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'ToggleContents__list-contents', __source: {
                fileName: _jsxFileName,
                lineNumber: 280
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 281
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 1-1</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 282
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 292
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 1-2</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 293
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 303
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 1-3</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 304
                }
              }))
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ToggleContents__content' + (_this.state.currentContentId === 'content02' ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 316
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'ToggleContents__list-contents multiple-lines', __source: {
                fileName: _jsxFileName,
                lineNumber: 317
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 318
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-1</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 319
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 329
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-2</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 330
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 340
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-3</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 341
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 351
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-4</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 352
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 362
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-5</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 363
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 373
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__blocks__["Promo"], _extends({
                pcDescription: '<p>Promoブロック 2-6</p>',
                pcSrc: '/assets-dev/slideshow-image.jpg',
                link: {
                  href: 'http://www.mazda.co.jp/',
                  targetBlank: false
                },
                pcLayout: 'Image-On-Top'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 374
                }
              }))
            )
          )
        )
      );
    };

    _this.renderLinkArrowIcon = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'LinkArrowIcon' + (_this.state.isOpened ? ' open' : ''),
          href: 'javascript:void(0)',
          onClick: function onClick(e) {
            e.preventDefault();
            _this.setState({
              isOpened: !_this.state.isOpened
            });
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 393
          }
        },
        '\u958B\u304F\u30FB\u9589\u3058\u308B\u30EA\u30F3\u30AF'
      );
    };

    _this.renderPullDown = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 408
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'LinkArrowIcon' + (_this.state.isOpened2 ? ' open' : ''),
            href: 'javascript:void(0)',
            onClick: function onClick(e) {
              e.preventDefault();
              _this.setState({
                isOpened2: !_this.state.isOpened2
              });
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 409
            }
          },
          '\u958B\u304F\u30FB\u9589\u3058\u308B\u30EA\u30F3\u30AF'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PullDown' + (_this.state.isOpened2 ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 418
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PullDown__container',
              style: _this.state.isOpened2 ? { height: _this.refs.contents.clientHeight } : null,
              onTransitionEnd: function onTransitionEnd(e) {
                e.currentTarget.style.height = 'auto';
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 419
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PullDown__contents', ref: 'contents', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 425
                }
              },
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 426
                }
              }),
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 427
                }
              }),
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 428
                }
              }),
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 429
                }
              }),
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 430
                }
              }),
              '\u30D7\u30EB\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 431
                }
              })
            )
          )
        )
      );
    };

    _this.renderSlickDots = function () {
      var arr = ['dot01', 'dot02', 'dot03', 'dot04', 'dot05'];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'slick-dots', __source: {
            fileName: _jsxFileName,
            lineNumber: 443
          }
        },
        arr.map(function (id, index) {
          if (id === _this.state.currentSlickDotId) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { className: 'slick-active', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 447
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: function onClick(e) {
                  e.preventDefault();
                  _this.setState({
                    currentSlickDotId: id
                  });
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 448
                }
              })
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 458
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', { onClick: function onClick(e) {
                  e.preventDefault();
                  _this.setState({
                    currentSlickDotId: id
                  });
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 459
                }
              })
            );
          }
        })
      );
    };

    _this.props = props;
    _this.state = {
      currentContentId: 'content01',
      isOpened: false,
      currentSlickDotId: 'dot01'
    };
    return _this;
  }

  AnimationSample.prototype.componentDidMount = function componentDidMount() {};

  AnimationSample.prototype.componentWillUnmount = function componentWillUnmount() {};

  AnimationSample.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AnimationSample', __source: {
            fileName: _jsxFileName,
            lineNumber: 43
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: 'AnimationSample__heading', __source: {
              fileName: _jsxFileName,
              lineNumber: 44
            }
          },
          'Animation Sample'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 46
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 47
              }
            },
            '\u25BC Text Link'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 48
              }
            },
            'TextLinkBlack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 49
              }
            },
            this.renderTextLinkBlack()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 52
              }
            },
            'TextLinkBlack current'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 53
              }
            },
            this.renderTextLinkBlack_current()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 56
              }
            },
            'TextLinkWhite'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 57
              }
            },
            this.renderTextLinkWhite()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 60
              }
            },
            'TextLinkWhite current'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 61
              }
            },
            this.renderTextLinkWhite_current()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 66
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 67
              }
            },
            '\u25BC Button'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 68
              }
            },
            'ButtonStandardBlack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 69
              }
            },
            this.renderButtonStandardBlack()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 72
              }
            },
            'ButtonStandardWhite'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 73
              }
            },
            this.renderButtonStandardWhite()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 76
              }
            },
            'ButtonActionBlack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 77
              }
            },
            this.renderButtonActionBlack()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 80
              }
            },
            'ButtonActionWhite'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 81
              }
            },
            this.renderButtonActionWhite()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 87
              }
            },
            '\u25BC Image Link'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 88
              }
            },
            'ImageLinkWhite'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box2-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 89
              }
            },
            this.renderImageLinkWhite()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 92
              }
            },
            'ImageLinkWhite current'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box2-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 93
              }
            },
            this.renderImageLinkWhite_current()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 96
              }
            },
            'ImageLinkBlack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box2-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 97
              }
            },
            this.renderImageLinkBlack()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 100
              }
            },
            'ImageLinkBlack current'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box2-black', __source: {
                fileName: _jsxFileName,
                lineNumber: 101
              }
            },
            this.renderImageLinkBlack_current()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 106
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 107
              }
            },
            '\u25BC Toggle Contents'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 108
              }
            },
            'ToggleContents'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 109
              }
            },
            this.renderToggleContents()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 115
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            },
            '\u25BC Link Arrow Icon'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 117
              }
            },
            'LinkArrowIcon'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 118
              }
            },
            this.renderLinkArrowIcon()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 124
              }
            },
            '\u25BC Pull Down'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'AnimationSample__heading3', __source: {
                fileName: _jsxFileName,
                lineNumber: 125
              }
            },
            'PullDown'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 126
              }
            },
            this.renderPullDown()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'AnimationSample__section', __source: {
              fileName: _jsxFileName,
              lineNumber: 131
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'AnimationSample__heading2', __source: {
                fileName: _jsxFileName,
                lineNumber: 132
              }
            },
            '\u25BC Slick Dots'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AnimationSample__box-white', __source: {
                fileName: _jsxFileName,
                lineNumber: 133
              }
            },
            this.renderSlickDots()
          )
        )
      )
    );
  };

  // TextLinkBlack


  // TextLinkWhite


  // ButtonStandardBlack


  // ButtonStandardWhite


  // ButtonActionBlack


  // ButtonActionWhite


  // ImageLinkWhite


  // ImageLinkBlack


  // Toggle Contents


  // Link Arrow Icon


  // Pull Down


  // Slick Dots


  return AnimationSample;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null
}, _temp);
AnimationSample.displayName = 'AnimationSample';


/* harmony default export */ __webpack_exports__["a"] = (AnimationSample);

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AnimationSample":"AnimationSample","AnimationSample__heading":"AnimationSample__heading","AnimationSample__heading2":"AnimationSample__heading2","AnimationSample__heading3":"AnimationSample__heading3","AnimationSample__section":"AnimationSample__section","AnimationSample__box-white":"AnimationSample__box-white","AnimationSample__box-black":"AnimationSample__box-black","AnimationSample__box2-white":"AnimationSample__box2-white","AnimationSample__box2-black":"AnimationSample__box2-black","TextLinkBlack":"TextLinkBlack","current":"current","TextLinkWhite":"TextLinkWhite","ButtonStandardBlack":"ButtonStandardBlack","ButtonStandardBlack__text":"ButtonStandardBlack__text","ButtonStandardWhite":"ButtonStandardWhite","ButtonStandardWhite__text":"ButtonStandardWhite__text","ButtonActionBlack":"ButtonActionBlack","ButtonActionBlack__text":"ButtonActionBlack__text","ButtonActionWhite":"ButtonActionWhite","ButtonActionWhite__text":"ButtonActionWhite__text","ImageLinkBlack":"ImageLinkBlack","ImageLinkBlack__image":"ImageLinkBlack__image","ImageLinkBlack__container":"ImageLinkBlack__container","ImageLinkWhite":"ImageLinkWhite","ImageLinkWhite__image":"ImageLinkWhite__image","ToggleContents":"ToggleContents","ToggleContents__list-nav":"ToggleContents__list-nav","ToggleContents__list-contents":"ToggleContents__list-contents","multiple-lines":"multiple-lines","ToggleContents__content":"ToggleContents__content","open":"open","LinkArrowIcon":"LinkArrowIcon","PullDown":"PullDown","PullDown__container":"PullDown__container","PullDown__contents":"PullDown__contents","slick-dots":"slick-dots","slick-active":"slick-active"};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "246355df4c951c94e667e0379a4cf9ff.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();var _react = __webpack_require__(0);var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(1);var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

function replaceScriptElementsRecursive(node, acc) {
  if (node.tagName === 'SCRIPT' && (!node.id || node.id.indexOf('script-') !== 0)) {
    var script = document.createElement('script');

    script.id = 'script-' + Math.random().
    toString(16).
    slice(2);
    script.innerHTML = node.innerHTML;

    var attrs = node.attributes;

    for (var i = 0; i < attrs.length; i += 1) {var _attrs$i =
      attrs[i],name = _attrs$i.name,value = _attrs$i.value;

      script.setAttribute(name, value);
    }

    acc.push(script);
    node.parentElement.replaceChild(script, node);
  } else {
    var _i = 0;
    var children = node.childNodes;

    while (_i < children.length) {
      replaceScriptElementsRecursive(children[_i], acc);
      _i += 1;
    }
  }
}

function removeScriptElements(scriptElements) {
  var i = 0;

  while (i < scriptElements.length) {
    var parentEl = scriptElements[i].parentElement;

    if (parentEl) {
      parentEl.removeChild(scriptElements[i]);
    }

    i += 1;
  }

  return [];
}var

DangerousHTML = function (_React$Component) {_inherits(DangerousHTML, _React$Component);function DangerousHTML() {var _ref;var _temp, _this, _ret;_classCallCheck(this, DangerousHTML);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DangerousHTML.__proto__ || Object.getPrototypeOf(DangerousHTML)).call.apply(_ref, [this].concat(args))), _this), _this.











    state = {
      canRenderHTML: true }, _this.













































    element = null, _this.
    scriptElements = [], _temp), _possibleConstructorReturn(_this, _ret);}_createClass(DangerousHTML, [{ key: 'componentWillMount', value: function componentWillMount() {// Do not render html with scripts on server side
      if (this.props.html.indexOf('script') > -1) {this.setState({ canRenderHTML: false });}} }, { key: 'componentDidMount', value: function componentDidMount() {var _this2 = this; /* eslint-disable react/no-did-mount-set-state */this.setState({ canRenderHTML: true }, function () {_this2.insertScriptsIfNeeded();_this2.prepareAnchors();}); /* eslint-enable react/no-did-mount-set-state */} }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {if (nextProps.html !== this.props.html) {this.scriptElements = removeScriptElements(this.scriptElements);}} }, { key: 'shouldComponentUpdate', value: function shouldComponentUpdate(nextProps, nextState) {return nextProps.html !== this.props.html || nextState.canRenderHTML !== this.state.canRenderHTML;} }, { key: 'componentDidUpdate', value: function componentDidUpdate(prevProps, prevState) {if (prevProps.html !== this.props.html || !prevState.canRenderHTML && this.state.canRenderHTML) {this.insertScriptsIfNeeded();this.prepareAnchors();}} }, { key: 'componentWillUnmount', value: function componentWillUnmount() {this.scriptElements = removeScriptElements(this.scriptElements);} }, { key: 'insertScriptsIfNeeded', value: function insertScriptsIfNeeded()
    {var
      html = this.props.html;

      if (html.indexOf('script') > -1 && this.element) {
        this.element.innerHTML = html;

        replaceScriptElementsRecursive(this.element, this.scriptElements);
      }
    } }, { key: 'prepareAnchors', value: function prepareAnchors()

    {
      if (!this.element) {
        return;
      }

      var anchors = [].slice.call(this.element.querySelectorAll('a'), 0);

      anchors.forEach(function (a) {
        a.setAttribute('target', '_blank');
      });
    } }, { key: 'render', value: function render()

    {var _this3 = this;var _props =
      this.props,html = _props.html,className = _props.className,TagName = _props.tagName;var
      canRenderHTML = this.state.canRenderHTML;

      if (!canRenderHTML) {
        return null;
      }

      return (
        _react2.default.createElement(TagName, {
          ref: function ref(element) {
            _this3.element = element;
          },
          className: className,
          dangerouslySetInnerHTML: { __html: html } }));


    } }]);return DangerousHTML;}(_react2.default.Component);DangerousHTML.propTypes = { html: _propTypes2.default.string.isRequired, tagName: _propTypes2.default.string, className: _propTypes2.default.string };DangerousHTML.defaultProps = { tagName: 'div', className: '' };exports.default =


DangerousHTML;
//# sourceMappingURL=DangerousHTML.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Hyperlink":"Hyperlink","Hyperlink__text-pc":"Hyperlink__text-pc","Hyperlink__text-mb":"Hyperlink__text-mb"};

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FooterNavigation":"FooterNavigation","FooterNavigation__container":"FooterNavigation__container","FooterNavigation__layout":"FooterNavigation__layout","FooterNavigation__layout-left":"FooterNavigation__layout-left","FooterNavigation__layout-right":"FooterNavigation__layout-right","FooterNavigation__list":"FooterNavigation__list","FooterNavigation__list-item":"FooterNavigation__list-item","Hyperlink":"Hyperlink","Hyperlink__text-pc":"Hyperlink__text-pc","Hyperlink__text-mb":"Hyperlink__text-mb","FooterNavigation__copyright":"FooterNavigation__copyright"};

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SocialIconsContainerBlock":"SocialIconsContainerBlock","SocialIconsContainerBlock__container":"SocialIconsContainerBlock__container","SocialIconsContainerBlock__list-ul":"SocialIconsContainerBlock__list-ul","SocialIconsContainerBlock__link":"SocialIconsContainerBlock__link","SocialIconsContainerBlock__box":"SocialIconsContainerBlock__box","SocialIconsContainerBlock__text":"SocialIconsContainerBlock__text","SocialIconsContainerBlock__image":"SocialIconsContainerBlock__image"};

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-pc":"Accordion__title-pc","Accordion__title-mb":"Accordion__title-mb","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","Accordion__contents":"Accordion__contents","Accordion--enabled":"Accordion--enabled","simpleAnimation":"simpleAnimation","open":"open"};

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SubFooterNavigation":"SubFooterNavigation","SubFooterNavigation__container":"SubFooterNavigation__container","SubFooterNavigation__layout":"SubFooterNavigation__layout","SubFooterNavigation__layout-item":"SubFooterNavigation__layout-item","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","SubFooterNavigation__list-ul":"SubFooterNavigation__list-ul","Hyperlink":"Hyperlink","Hyperlink__text-pc":"Hyperlink__text-pc","Hyperlink__text-mb":"Hyperlink__text-mb","Accordion__container":"Accordion__container","open":"open"};

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ScrollTop":"ScrollTop","open":"open"};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\site-search\\pc.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 *  SiteSearchPc
 */
var SiteSearchPc = (_temp = _class = function (_Component) {
  _inherits(SiteSearchPc, _Component);

  function SiteSearchPc(props) {
    _classCallCheck(this, SiteSearchPc);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleClick = function (e) {
      e.preventDefault();
      //
      var search_input = null;
      var formElement = _this.refs.code.getElementsByClassName('js-SearchForm')[0] || null;
      if (formElement) {
        search_input = formElement.querySelector('.js-SearchForm_kw');
      }
      if (_this.state.open === true) {
        if (search_input) {
          search_input.blur();
        }
        //
        _this.setState({
          open: false,
          left: 0,
          width: 80
        });
      } else {
        if (search_input) {
          search_input.focus();
        }
        _this.windowWidth = window.innerWidth;
        if (1360 < _this.windowWidth) _this.windowWidth = 1360;
        if (_this.windowWidth < 1064) _this.windowWidth = 1064;
        //
        _this.setState({
          open: true,
          left: -_this.windowWidth + (340 + 80),
          width: _this.windowWidth - 340
        });
      }
    };

    _this.props = props;
    _this.state = {
      open: false,
      left: 0,
      width: 80
    };
    _this.windowWidth = null;
    return _this;
  }

  SiteSearchPc.prototype.componentDidMount = function componentDidMount() {};

  SiteSearchPc.prototype.componentWillUnmount = function componentWillUnmount() {};

  SiteSearchPc.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SiteSearch pc' + (this.state.open === true ? ' open' : ''), __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SiteSearch__container',
          style: { left: this.state.left - 21, width: this.state.width },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SiteSearch__inner', __source: {
              fileName: _jsxFileName,
              lineNumber: 39
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SiteSearch__code',
              ref: 'code',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 40
              }
            },
            this.props.searchCode !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.searchCode }, __source: {
                fileName: _jsxFileName,
                lineNumber: 44
              }
            }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SiteSearch__border', __source: {
                fileName: _jsxFileName,
                lineNumber: 46
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'SiteSearch__link-close',
              href: '#',
              onClick: function onClick(e) {
                _this2.handleClick(e);
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 47
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'SiteSearch__link-open',
        href: '#',
        onClick: function onClick(e) {
          _this2.handleClick(e);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        }
      })
    );
  };

  //


  return SiteSearchPc;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  searchCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  searchCode: null
}, _temp);
SiteSearchPc.displayName = 'SiteSearchPc';


/* harmony default export */ __webpack_exports__["a"] = (SiteSearchPc);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\site-search\\mb.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 *  SiteSearchMb
 */
var SiteSearchMb = (_temp = _class = function (_Component) {
  _inherits(SiteSearchMb, _Component);

  function SiteSearchMb(props) {
    _classCallCheck(this, SiteSearchMb);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleClick = function (e) {
      e.preventDefault();
      //
      var search_input = null;
      var formElement = _this.refs.code.getElementsByClassName('js-SearchForm')[0] || null;
      if (formElement) {
        search_input = formElement.querySelector('.js-SearchForm_kw');
      }
      if (_this.state.open === true) {
        if (search_input) {
          search_input.blur();
        }
        //
        _this.setState({
          open: false,
          height: 0
        });
      } else {
        if (search_input) {
          search_input.focus();
        }
        //
        _this.setState({
          open: true,
          height: window.innerHeight - 80
        });
        //
        setTimeout(function () {
          if (_this.props.scrollToSearchTop !== null) _this.props.scrollToSearchTop(_this.refs.content.getBoundingClientRect().top - 80);
        }, 100);
      }
    };

    _this.props = props;
    _this.state = {
      open: false,
      height: 0
    };
    return _this;
  }

  SiteSearchMb.prototype.componentDidMount = function componentDidMount() {};

  SiteSearchMb.prototype.componentWillUnmount = function componentWillUnmount() {};

  SiteSearchMb.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SiteSearch mb' + (this.state.open === true ? ' open' : ''),
        ref: 'content',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SiteSearch__container',
          style: { height: this.state.height },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SiteSearch__inner', __source: {
              fileName: _jsxFileName,
              lineNumber: 41
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SiteSearch__code',
              ref: 'code',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 42
              }
            },
            this.props.searchCode !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.searchCode }, __source: {
                fileName: _jsxFileName,
                lineNumber: 46
              }
            }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'SiteSearch__link-close',
            href: '#',
            onClick: this.handleClick,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 48
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'SiteSearch__link-open',
        href: '#',
        onClick: this.handleClick,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        }
      })
    );
  };

  //


  return SiteSearchMb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  searchCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scrollToSearchTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  searchCode: null,
  scrollToSearchTop: null
}, _temp);
SiteSearchMb.displayName = 'SiteSearchMb';


/* harmony default export */ __webpack_exports__["a"] = (SiteSearchMb);

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PrimaryNavigation":"PrimaryNavigation","PrimaryNavigation__heading":"PrimaryNavigation__heading","PrimaryNavigation__list-ul":"PrimaryNavigation__list-ul","PrimaryNavigation__link":"PrimaryNavigation__link","blank":"blank","PrimaryNavigation__link-pc":"PrimaryNavigation__link-pc","PrimaryNavigation__link-mb":"PrimaryNavigation__link-mb"};

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PromoNavigation":"PromoNavigation","PromoNavigation__container":"PromoNavigation__container","PromoNavigation__heading":"PromoNavigation__heading","PromoNavigation__heading-pc":"PromoNavigation__heading-pc","PromoNavigation__heading-mb":"PromoNavigation__heading-mb","PromoNavigation__heading-text":"PromoNavigation__heading-text","PromoNavigation__layout":"PromoNavigation__layout","PromoNavigation__layout-left":"PromoNavigation__layout-left","PromoNavigation__layout-right":"PromoNavigation__layout-right","PromoNavigation__link":"PromoNavigation__link","PromoNavigation__link-border":"PromoNavigation__link-border","PromoNavigation__list-ul":"PromoNavigation__list-ul"};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(701);

var _json2mq = __webpack_require__(708);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(710);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(711);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(95);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(702);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(703);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(111);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(112);

var _track = __webpack_require__(704);

var _dots = __webpack_require__(705);

var _arrows = __webpack_require__(706);

var _resizeObserverPolyfill = __webpack_require__(707);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          currentSlide = _this$props.currentSlide,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(111);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(111);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(111);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if (ctx === void 0) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties(anonymous.prototype, prototypeAccessors);

        return anonymous;
    }();
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function ResizeObserverController() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */

/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */

/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
        return observer.broadcastActive();
    });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
    var propertyName = ref.propertyName;if (propertyName === void 0) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [],
        len = arguments.length - 1;
    while (len-- > 0) {
        positions[len] = arguments[len + 1];
    }return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function ResizeObservation(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */

/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */

/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function ResizeObserverSPI(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */

/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */

/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
    var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(709);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(712);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(713);
var Util = __webpack_require__(296);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(714);
var each = __webpack_require__(296).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 714 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"slick-slider","slick-list":"slick-list","dragging":"dragging","slick-track":"slick-track","slick-loading":"slick-loading","slick-slide":"slick-slide","slick-initialized":"slick-initialized","slick-vertical":"slick-vertical","slick-arrow":"slick-arrow","slick-hidden":"slick-hidden","Slide":"Slide","slick-prev":"slick-prev","prev":"prev","Slide__prev":"Slide__prev","change":"change","Slide__change":"Slide__change","slick-next":"slick-next","next":"next","Slide__next":"Slide__next","slick-dots":"slick-dots","slick-active":"slick-active"};

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PromoNavigationContainer":"PromoNavigationContainer","PromoNavigationContainer__heading":"PromoNavigationContainer__heading","PromoNavigationContainer__heading-pc":"PromoNavigationContainer__heading-pc","PromoNavigationContainer__heading-mb":"PromoNavigationContainer__heading-mb","PromoNavigationContainer__heading-text":"PromoNavigationContainer__heading-text","PromoNavigationContainer__link":"PromoNavigationContainer__link","PromoNavigationContainer__link-border":"PromoNavigationContainer__link-border","PromoNavigationContainer__list-ul":"PromoNavigationContainer__list-ul","PromoNavigationItem":"PromoNavigationItem","PromoNavigationContainer__slider":"PromoNavigationContainer__slider","slick-slide":"slick-slide","slick-dots":"slick-dots"};

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PromoNavigationItem":"PromoNavigationItem","PromoNavigationItem__link":"PromoNavigationItem__link","PromoNavigationItem__image":"PromoNavigationItem__image","PromoNavigationItem__border":"PromoNavigationItem__border","PromoNavigationItem__heading":"PromoNavigationItem__heading","PromoNavigationItem__heading-pc":"PromoNavigationItem__heading-pc","PromoNavigationItem__heading-mb":"PromoNavigationItem__heading-mb"};

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image-loader":"image-loader","opened":"opened","ratio100":"ratio100","ratio90":"ratio90","ratio80":"ratio80","ratio70":"ratio70","ratio60":"ratio60","ratio50":"ratio50","ratio40":"ratio40","ratio30":"ratio30","ratio20":"ratio20","ratio10":"ratio10","image-loader__box":"image-loader__box"};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NavigationContainer":"NavigationContainer","opened":"opened","NavigationContainer__content":"NavigationContainer__content","NavigationContainer__container-left":"NavigationContainer__container-left","NavigationContainer__container-center":"NavigationContainer__container-center","NavigationContainer__container-right":"NavigationContainer__container-right","NavigationContainer__link-prev":"NavigationContainer__link-prev","enabled":"enabled","disabled":"disabled","NavigationContainer__link-next":"NavigationContainer__link-next","tablet":"tablet"};

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GlobalNavigation":"GlobalNavigation","GlobalNavigation__heading":"GlobalNavigation__heading","GlobalNavigation__list-ul":"GlobalNavigation__list-ul","GlobalNavigation__list-dl":"GlobalNavigation__list-dl","GlobalNavigation__box":"GlobalNavigation__box","open":"open","GlobalNavigation__link":"GlobalNavigation__link","GlobalNavigation__link-border":"GlobalNavigation__link-border","GlobalNavigation__link-close":"GlobalNavigation__link-close","current":"current","GlobalNavigation__link-container":"GlobalNavigation__link-container","GlobalNavigation__link-pc":"GlobalNavigation__link-pc","GlobalNavigation__link-mb":"GlobalNavigation__link-mb","NavigationContainer__container-center":"NavigationContainer__container-center","NavigationContainer__link-prev":"NavigationContainer__link-prev","NavigationContainer__link-next":"NavigationContainer__link-next","GlobalNavigation__link-icon":"GlobalNavigation__link-icon","GlobalNavigation__link-icon2":"GlobalNavigation__link-icon2","GlobalNavigation__link-icon3":"GlobalNavigation__link-icon3","fadeIn":"fadeIn","fadeOut":"fadeOut"};

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"un-scroll":"un-scroll","un-scroll-pc":"un-scroll-pc","modal-open":"modal-open","HomePage__main":"HomePage__main","StandardPage__main":"StandardPage__main","modal-open-item":"modal-open-item","un-scroll-mb":"un-scroll-mb"};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Cta":"Cta","Cta__container":"Cta__container","Cta__container--Dark":"Cta__container--Dark","Cta__button":"Cta__button","Cta__button--linkType--Button":"Cta__button--linkType--Button","Cta__button__text":"Cta__button__text","Cta__button--linkType--Button-With-Icon":"Cta__button--linkType--Button-With-Icon","Cta__button__icon":"Cta__button__icon","Cta__button__icon--hover":"Cta__button__icon--hover","Cta__button--buttonStyle--Action":"Cta__button--buttonStyle--Action","Cta__button--linkType--Text":"Cta__button--linkType--Text","Cta__button--linkType--Text-With-Icon":"Cta__button--linkType--Text-With-Icon","Cta__container--Light":"Cta__container--Light","Cta__button__icon__container":"Cta__button__icon__container","show":"show","Cta__button--buttonStyle--CTA-Navi":"Cta__button--buttonStyle--CTA-Navi","CTANavigation":"CTANavigation","Cta__button--buttonLength--1":"Cta__button--buttonLength--1","Cta__button__container":"Cta__button__container","Cta__button--buttonLength--2":"Cta__button--buttonLength--2","Cta__button--buttonLength--3":"Cta__button--buttonLength--3","isAndroid":"isAndroid","Cta__button--buttonLength--4":"Cta__button--buttonLength--4","Cta__button--buttonLength--5":"Cta__button--buttonLength--5"};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3218eac30c4636337ca2d09fb685d31d.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e8f2424137f72305ecc2b6ff5b629ba4.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3347dde007b010d50a31d784c347b729.png";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f07736b919ec306f9792f3206d6bdb2.png";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1d0bc4b60f1dbf2bbfa28b16f8bac882.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b956fe61ea1c81caa738f459fd1ced6d.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "419ce9c250395fc9639e49cce3670f54.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "490d85a3be6826a974d972c9cdbcd2cb.png";

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80db17f8b3143950e9878a87c5e00583.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0372cf53132a0c3b5d7892df209a5acd.png";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarNavigationLinkItem":"CarNavigationLinkItem","CarNavigationLinkItem__container":"CarNavigationLinkItem__container","CarNavigationLinkItem__container__link":"CarNavigationLinkItem__container__link","CarNavigationLinkItem__container--image":"CarNavigationLinkItem__container--image","CarNavigationLinkItem__container__link__image__container":"CarNavigationLinkItem__container__link__image__container","CarNavigationLinkItem__container__link__image":"CarNavigationLinkItem__container__link__image","CarNavigationLinkItem__container__link__image--mb":"CarNavigationLinkItem__container__link__image--mb","CarNavigationLinkItem__container--noimage":"CarNavigationLinkItem__container--noimage","CarNavigationLinkItem__container__link__label":"CarNavigationLinkItem__container__link__label","CarNavigationLinkItem__container__link__label__text":"CarNavigationLinkItem__container__link__label__text","CarNavigationLinkItem__container__link__image--pc":"CarNavigationLinkItem__container__link__image--pc"};

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarNavigation":"CarNavigation","CarNavigation__container":"CarNavigation__container","CarNavigation__VehiclesForm":"CarNavigation__VehiclesForm","CarNavigation__VehiclesForm--hide":"CarNavigation__VehiclesForm--hide","CarNavigation__VehiclesForm__List":"CarNavigation__VehiclesForm__List","CarNavigation__VehiclesForm__List__Item":"CarNavigation__VehiclesForm__List__Item","CarNavigation__VehiclesForm__List__Item__Label":"CarNavigation__VehiclesForm__List__Item__Label","CarNavigation__VehiclesForm__List__Item__Label__Radio":"CarNavigation__VehiclesForm__List__Item__Label__Radio","CarNavigation__VehiclesForm__List__Item__Label__Text":"CarNavigation__VehiclesForm__List__Item__Label__Text","CarNavigation__Cars":"CarNavigation__Cars","fadein":"fadein","CarNavigation__Cars__Body":"CarNavigation__Cars__Body","CarNavigation__Cars__Body__Item":"CarNavigation__Cars__Body__Item","CarNavigation__Cars__Body__Item__Link":"CarNavigation__Cars__Body__Item__Link","CarNavigation__Cars__Body__Item__Link__dd":"CarNavigation__Cars__Body__Item__Link__dd","CarNavigation__Cars__Body__Item__Link--disabled":"CarNavigation__Cars__Body__Item__Link--disabled","CarNavigation__Cars--Grid":"CarNavigation__Cars--Grid","CarNavigation__Cars__Body__Item--blank":"CarNavigation__Cars__Body__Item--blank","CarNavigation__Cars__Body__Item__Link__dt":"CarNavigation__Cars__Body__Item__Link__dt","CarNavigation__Cars__Body__Item__Link__image":"CarNavigation__Cars__Body__Item__Link__image","CarNavigation__Cars__Body__Item__Link__title":"CarNavigation__Cars__Body__Item__Link__title","CarNavigation__Cars__Body__Item__Link__category":"CarNavigation__Cars__Body__Item__Link__category","CarNavigation__Cars__Body__Item__Link__price":"CarNavigation__Cars__Body__Item__Link__price","CarNavigation__Cars__Body__Item__Link__free-text":"CarNavigation__Cars__Body__Item__Link__free-text","CarNavigation__commonLinks":"CarNavigation__commonLinks","CarNavigation__commonLinks__list":"CarNavigation__commonLinks__list","CarNavigation__commonLinks__list__item":"CarNavigation__commonLinks__list__item","Cta":"Cta","Cta__container":"Cta__container","Cta__button--linkType--Text-With-Icon":"Cta__button--linkType--Text-With-Icon","Cta__button__text":"Cta__button__text"};

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MyMazda":"MyMazda","MyMazda__status":"MyMazda__status","MyMazda__link":"MyMazda__link","MyMazda__icon":"MyMazda__icon","MyMazda__no-links-pc":"MyMazda__no-links-pc","MyMazda__no-text-pc":"MyMazda__no-text-pc","MyMazda__no-icon-pc":"MyMazda__no-icon-pc","MyMazda__container":"MyMazda__container","opened":"opened","MyMazda__link2":"MyMazda__link2","MyMazda__icon2":"MyMazda__icon2","MyMazda__link2--my-mazda":"MyMazda__link2--my-mazda","MyMazda__hide-name":"MyMazda__hide-name","MyMazda__list":"MyMazda__list","MyMazda__bg":"MyMazda__bg","MyMazda__text-pc":"MyMazda__text-pc","MyMazda__text-mb":"MyMazda__text-mb","MyMazda__icon-pc":"MyMazda__icon-pc","MyMazda__icon-mb":"MyMazda__icon-mb","hide":"hide","MyMazda__no-links-mb":"MyMazda__no-links-mb","MyMazda__no-text-mb":"MyMazda__no-text-mb","MyMazda__no-icon-mb":"MyMazda__no-icon-mb","MyMazda__link2--white":"MyMazda__link2--white","MyMazda__list-item--my-mazda":"MyMazda__list-item--my-mazda"};

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header","Header__container":"Header__container","Header__heading":"Header__heading","Header__heading-image":"Header__heading-image","Header__link-menu":"Header__link-menu","Header__layout":"Header__layout","Header__layout-left":"Header__layout-left","Header__layout-right":"Header__layout-right","Header__layout2":"Header__layout2","Header__layout2-left":"Header__layout2-left","Header__layout2-center":"Header__layout2-center","Header__layout2-right":"Header__layout2-right","Header__box":"Header__box","Header__my-mazda-pc":"Header__my-mazda-pc","Header__my-mazda-mb":"Header__my-mazda-mb","close":"close","menuBarOut":"menuBarOut","menuBar2Out":"menuBar2Out","menuBar3Out":"menuBar3Out","open":"open","menuBar":"menuBar","menuBar2":"menuBar2","menuBar3":"menuBar3","Header__layout-right-inner":"Header__layout-right-inner","hide":"hide"};

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navigation_container__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-navigation\\pc.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * SubNavigationPc
 */

var SubNavigationPc = (_temp = _class = function (_Component) {
  _inherits(SubNavigationPc, _Component);

  function SubNavigationPc(props) {
    _classCallCheck(this, SubNavigationPc);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onResize = function (e) {
      _this.fit();
    };

    _this.onScroll = function (e) {
      _this.fit();
    };

    _this.fit = function () {
      var scrollTop = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].documentElement.scrollTop || __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].body.scrollTop;
      var subNavigation = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.SubNavigation');

      var subNavigationHeight = subNavigation.clientHeight;
      var headerHeight = 0;

      if (subNavigation.classList.contains('fixed')) {
        headerHeight = 0;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header') && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight) {
          headerHeight = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight - scrollTop;
        }
      }

      var estimationHistory = _this.refs.estimationHistory;

      if (estimationHistory && _this.validEstimateJson()) {
        //
        var height = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].innerHeight - headerHeight - subNavigationHeight;

        // EPIServerのプレビュー時のモーダルの位置調整
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].parent) {
          var wrapperElement = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
          if (wrapperElement) {
            height = wrapperElement.clientHeight;
          }
        }

        //
        estimationHistory.style.height = height + 'px';
        //
        var no_ests = estimationHistory.querySelector('.EstimationHistory__container__no-ests');
        if (no_ests) {
          no_ests.style.height = height - 25 + 'px';
        }
        //
        var est = {};
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
          var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
          est = JSON.parse(json);
        }
        if (no_ests && est && Object.keys(est).length > 0 && ('saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0 || 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0)) {
          no_ests.style.height = '';
        }
      }
    };

    _this.onClickEstimationHistory = function (e) {
      _this.setState({
        estimationHistoryOpen: !_this.state.estimationHistoryOpen
      });
    };

    _this.validEstimateJson = function () {
      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        try {
          JSON.parse(json);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
      } else {
        // IE
        var evt = document.createEventObject();
        return element.fireEvent("on" + event, evt);
      }
    };

    _this.getPcHeading = function () {
      if (_this.props.pcTitle !== null) {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink !== null) {
          if (_this.props.rootLink.pcText !== null) {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName !== null) {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.getMbHeading = function () {
      if (_this.props.mbTitle !== null) {
        return _this.props.mbTitle;
      } else if (_this.props.pcTitle !== null) {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink !== null) {
          if (_this.props.rootLink.mbText !== null) {
            return _this.props.rootLink.mbText;
          } else if (_this.props.rootLink.pcText !== null) {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName !== null) {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.setEstimateCount = function () {
      var cnt = 0;
      var est = {};

      if (!_this.validEstimateJson()) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        est = JSON.parse(json);
      }
      if (est && Object.keys(est).length > 0 && 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0) {
        cnt += est['unsaved'].length;
      }
      if (est && Object.keys(est).length > 0 && 'saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) {
        cnt += est['saved'].length;
      }

      var estimationCount = _this.refs.estimationCount;
      if (estimationCount) {
        estimationCount.classList.add('n' + cnt);
      }
    };

    _this.props = props;
    _this.state = {
      estimationHistoryOpen: false
    };
    return _this;
  }

  SubNavigationPc.prototype.componentDidMount = function componentDidMount() {
    this.setEstimateCount();
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.onScroll);
    this.triggerEvent(__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */], 'scroll');
  };

  SubNavigationPc.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.onScroll);
  };

  SubNavigationPc.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        pcTitle = _props.pcTitle,
        mbTitle = _props.mbTitle,
        carsTitle = _props.carsTitle,
        rootLink = _props.rootLink,
        estimationHistory = _props.estimationHistory,
        links = _props.links,
        hierarchy = _props.hierarchy,
        subNavigation = _props.subNavigation,
        deleteRootPageLink = _props.deleteRootPageLink;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubNavigation__pc', __source: {
          fileName: _jsxFileName,
          lineNumber: 238
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubNavigation__container2', __source: {
            fileName: _jsxFileName,
            lineNumber: 239
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SubNavigation__layout', __source: {
              fileName: _jsxFileName,
              lineNumber: 240
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SubNavigation__layout-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 241
              }
            },
            function () {
              // 第1階層タイトル
              if (rootLink !== null && rootLink.href !== null) {
                if (deleteRootPageLink) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : '') + (hierarchy <= 1 ? ' current' : ''), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 247
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'SubNavigation__heading-link', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 248
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-pc', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 249
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 250
                          }
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-mb', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 252
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 253
                          }
                        })
                      )
                    )
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : '') + (hierarchy <= 1 ? ' current' : ''), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 260
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { className: 'SubNavigation__heading-link', href: rootLink.href,
                        target: rootLink.external === true ? '_blank' : '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 261
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-pc', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 263
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 264
                          }
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-mb', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 266
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 267
                          }
                        })
                      )
                    )
                  );
                }
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 275
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'SubNavigation__heading-pc', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 276
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 277
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'SubNavigation__heading-mb', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 279
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 280
                      }
                    })
                  )
                );
              }
            }()
          ),
          function () {
            // 第2階層リンク
            if (links !== null && 1 <= links.length) {
              var end = false;
              if (hierarchy === 2) end = true;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SubNavigation__layout-center', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 293
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationItem, {
                  topLink: null,
                  links: links,
                  excludedWidth: 400,
                  end: end,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 294
                  }
                })
              );
            } else {
              return null;
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SubNavigation__layout-right', __source: {
                fileName: _jsxFileName,
                lineNumber: 306
              }
            },
            function () {
              if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
                var text = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationTitle && estimationHistory[0].props.navigationTitle !== '' ? estimationHistory[0].props.navigationTitle : '';
                var icon = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationIcon && estimationHistory[0].props.navigationIcon !== '' ? estimationHistory[0].props.navigationIcon : '';
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__estimation-history__button', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 312
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: 'javascript:void(0)', className: 'SubNavigation__estimation-history__button__link',
                      onClick: _this2.onClickEstimationHistory, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 313
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'SubNavigation__estimation-history__button__link__label', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 315
                        }
                      },
                      text
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'SubNavigation__estimation-history__button__link__icon-container', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 316
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SubNavigation__estimation-history__button__link__icon', src: icon, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 317
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__estimation-history__button__link__count',
                        ref: 'estimationCount', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 318
                        }
                      })
                    )
                  )
                );
              }
            }()
          )
        ),
        function () {
          if (links !== null && 1 <= links.length) {
            return links.map(function (link, index) {
              // 第3階層リンク
              if (link.current === true && link.nestedNavigation !== null) {
                var end = false;
                if (hierarchy === 3) end = true;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__layout2', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 337
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationItem, {
                    topLink: link.nestedNavigation.topLink,
                    links: link.nestedNavigation.links,
                    excludedWidth: 0,
                    end: end,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 338
                    }
                  })
                );
              } else {
                return null;
              }
            });
          } else {
            return null;
          }
        }()
      ),
      function () {
        if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: "SubNavigation__estimation-history" + (_this2.state.estimationHistoryOpen === true ? ' open' : ''),
              ref: 'estimationHistory',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 359
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 366
                }
              },
              estimationHistory
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__close', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 369
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'javascript:void(0)', onClick: _this2.onClickEstimationHistory,
                  className: 'SubNavigation__estimation-history__close__button', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 370
                  }
                },
                'close'
              )
            )
          );
        }
      }()
    );
  };

  return SubNavigationPc;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carsTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  estimationHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    nestedNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })),
  hierarchy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  subNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  deleteRootPageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  pcTitle: null,
  mbTitle: null,
  carsTitle: null,
  rootLink: null,
  estimationHistory: null,
  links: null,
  hierarchy: null,
  subNavigation: null,
  deleteRootPageLink: false
}, _temp);
SubNavigationPc.displayName = 'SubNavigationPc';


/* harmony default export */ __webpack_exports__["a"] = (SubNavigationPc);

/**
 * SubNavigationItem
 */
var SubNavigationItem = (_temp2 = _class2 = function (_Component2) {
  _inherits(SubNavigationItem, _Component2);

  function SubNavigationItem(props) {
    _classCallCheck(this, SubNavigationItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.getItemPositions = function () {
      //console.log(this.items);
      var arr = [0];
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.items.length; i < max; i = i + 1) {
        var width = _this3.refs[_this3.items[i]].clientWidth;
        total = total + width;
        arr.push(total);
      }
      return arr;
    };

    _this3.getCurrentItemPosition = function () {
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.items.length; i < max; i = i + 1) {
        var width = _this3.refs[_this3.items[i]].clientWidth;
        if (_this3.refs[_this3.items[i]].dataset.current === 'current') {
          return total + width / 2;
        }
        total = total + width;
      }
      return 0;
    };

    _this3.props = props;
    _this3.items = [];
    _this3.state = {
      isMounted: false
    };
    return _this3;
  }

  SubNavigationItem.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  SubNavigationItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  SubNavigationItem.prototype.render = function render() {
    var _this4 = this;

    this.items = [];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubNavigation__item', __source: {
          fileName: _jsxFileName,
          lineNumber: 425
        }
      },
      function () {
        if (_this4.props.links !== null) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__components_navigation_container__["a" /* default */],
            {
              getItemPositions: _this4.getItemPositions,
              getCurrentItemPosition: _this4.getCurrentItemPosition,
              excludedWidth: _this4.props.excludedWidth,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 429
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'SubNavigation__list-ul', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 434
                }
              },
              function () {
                if (_this4.props.topLink !== null && _this4.props.topLink.display === true) {
                  // TOPリンク
                  _this4.items.push('itemTop');
                  if (_this4.state.isMounted) {

                    // 下層にcurrentがある場合はTOPリンクはcurrentにしない
                    var current = _this4.props.topLink.href === location.pathname ? true : _this4.props.topLink.current;
                    var i = void 0,
                        max = void 0;
                    for (i = 0, max = _this4.props.links.length; i < max; i = i + 1) {
                      if (_this4.props.links[i].current === true) {
                        current = false;
                        break;
                      }
                    }

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { ref: 'itemTop', 'data-current': '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 452
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                        pageName: _this4.props.topLink.pageName ? _this4.props.topLink.pageName + ' TOP' : null,
                        pcText: _this4.props.topLink.pcText ? _this4.props.topLink.pcText + ' TOP' : null,
                        mbText: _this4.props.topLink.mbText ? _this4.props.topLink.mbText + ' TOP' : null,
                        href: _this4.props.topLink.href,
                        external: _this4.props.topLink.external,
                        current: current,
                        current2: current,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 453
                        }
                      })
                    );
                  } else {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { ref: 'itemTop', 'data-current': '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 466
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                        pageName: _this4.props.topLink.pageName ? _this4.props.topLink.pageName + ' TOP' : null,
                        pcText: _this4.props.topLink.pcText ? _this4.props.topLink.pcText + ' TOP' : null,
                        mbText: _this4.props.topLink.mbText ? _this4.props.topLink.mbText + ' TOP' : null,
                        href: _this4.props.topLink.href,
                        external: _this4.props.topLink.external,
                        current: _this4.props.topLink.current,
                        current2: _this4.props.topLink.current,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 467
                        }
                      })
                    );
                  }
                } else {
                  return null;
                }
              }(),
              _this4.props.links.map(function (link, index) {
                // 第2階層リンク、第3階層リンク
                _this4.items.push('item' + index);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, ref: 'item' + index, 'data-current': link.current ? 'current' : '', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 487
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                    pageName: link.pageName,
                    pcText: link.pcText,
                    mbText: link.mbText,
                    href: link.href,
                    external: link.external,
                    current: link.current,
                    current2: _this4.props.end,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 488
                    }
                  })
                );
              })
            )
          );
        } else {
          return null;
        }
      }()
    );
  };

  //


  //


  return SubNavigationItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  topLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  excludedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  end: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  topLink: null,
  links: null,
  excludedWidth: 0,
  end: false
}, _temp2);
SubNavigationItem.displayName = 'SubNavigationItem';


/**
 * SubNavigationLink
 */
var SubNavigationLink = function SubNavigationLink(_ref) {
  var pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      external = _ref.external,
      current = _ref.current,
      current2 = _ref.current2;

  var getPcText = function getPcText() {
    if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  var getMbText = function getMbText() {
    if (mbText !== null) {
      return mbText;
    } else if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: 'SubNavigation__link' + (current === true ? ' current' : '') + (current2 === true ? ' current2' : ''),
      href: href, target: external === true ? '_blank' : '', __source: {
        fileName: _jsxFileName,
        lineNumber: 570
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'SubNavigation__link-container', __source: {
          fileName: _jsxFileName,
          lineNumber: 573
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 574
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 575
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 577
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 578
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__link-border', __source: {
          fileName: _jsxFileName,
          lineNumber: 580
        }
      })
    )
  );
};
SubNavigationLink.displayName = 'SubNavigationLink';

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navigation_container__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-navigation\\tb.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * SubNavigationTb
 */

var SubNavigationTb = (_temp = _class = function (_Component) {
  _inherits(SubNavigationTb, _Component);

  function SubNavigationTb(props) {
    _classCallCheck(this, SubNavigationTb);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onResize = function (e) {
      _this.fit();
    };

    _this.onScroll = function (e) {
      _this.fit();
    };

    _this.fit = function () {
      var scrollTop = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].documentElement.scrollTop || __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].body.scrollTop;
      var subNavigation = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.SubNavigation');

      var subNavigationHeight = subNavigation.clientHeight;
      var headerHeight = 0;

      if (subNavigation.classList.contains('fixed')) {
        headerHeight = 0;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header') && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight) {
          headerHeight = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight - scrollTop;
        }
      }

      var estimationHistory = _this.refs.estimationHistory;

      if (estimationHistory && _this.validEstimateJson()) {
        //
        var height = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].innerHeight - headerHeight - subNavigationHeight;

        // EPIServerのプレビュー時のモーダルの位置調整
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].epi && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].parent) {
          var wrapperElement = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
          if (wrapperElement) {
            height = wrapperElement.clientHeight;
          }
        }

        //
        estimationHistory.style.height = height + 'px';
        //
        var no_ests = estimationHistory.querySelector('.EstimationHistory__container__no-ests');
        if (no_ests) {
          no_ests.style.height = height - 25 + 'px';
        }
        //
        var est = {};
        if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
          var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
          est = JSON.parse(json);
        }
        if (no_ests && est && Object.keys(est).length > 0 && ('saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0 || 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0)) {
          no_ests.style.height = '';
        }
      }
    };

    _this.onClickEstimationHistory = function (e) {
      _this.setState({
        estimationHistoryOpen: !_this.state.estimationHistoryOpen
      });
    };

    _this.validEstimateJson = function () {
      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        try {
          JSON.parse(json);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
      } else {
        // IE
        var evt = document.createEventObject();
        return element.fireEvent("on" + event, evt);
      }
    };

    _this.getPcHeading = function () {
      if (_this.props.pcTitle !== null) {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink !== null) {
          if (_this.props.rootLink.pcText !== null) {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName !== null) {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.getMbHeading = function () {
      if (_this.props.mbTitle !== null) {
        return _this.props.mbTitle;
      } else if (_this.props.pcTitle !== null) {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink !== null) {
          if (_this.props.rootLink.mbText !== null) {
            return _this.props.rootLink.mbText;
          } else if (_this.props.rootLink.pcText !== null) {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName !== null) {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.setEstimateCount = function () {
      var cnt = 0;
      var est = {};

      if (!_this.validEstimateJson()) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        est = JSON.parse(json);
      }
      if (est && Object.keys(est).length > 0 && 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0) {
        cnt += est['unsaved'].length;
      }
      if (est && Object.keys(est).length > 0 && 'saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) {
        cnt += est['saved'].length;
      }
      var estimationCount = _this.refs.estimationCount;
      if (estimationCount) {
        estimationCount.classList.add('n' + cnt);
      }
    };

    _this.props = props;
    _this.state = {
      estimationHistoryOpen: false
    };
    return _this;
  }

  SubNavigationTb.prototype.componentDidMount = function componentDidMount() {
    this.setEstimateCount();
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.onScroll);
    this.triggerEvent(__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */], 'scroll');
  };

  SubNavigationTb.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.onScroll);
  };

  SubNavigationTb.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        pcTitle = _props.pcTitle,
        mbTitle = _props.mbTitle,
        carsTitle = _props.carsTitle,
        rootLink = _props.rootLink,
        estimationHistory = _props.estimationHistory,
        links = _props.links,
        hierarchy = _props.hierarchy,
        subNavigation = _props.subNavigation,
        deleteRootPageLink = _props.deleteRootPageLink;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubNavigation__tb', __source: {
          fileName: _jsxFileName,
          lineNumber: 236
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubNavigation__container2', __source: {
            fileName: _jsxFileName,
            lineNumber: 237
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SubNavigation__layout', __source: {
              fileName: _jsxFileName,
              lineNumber: 238
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SubNavigation__layout-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 239
              }
            },
            function () {
              // 第1階層タイトル
              if (rootLink !== null && rootLink.href !== null) {
                if (deleteRootPageLink) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : '') + (hierarchy <= 1 ? ' current' : ''), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 245
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'SubNavigation__heading-link', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 246
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-pc', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 247
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 248
                          }
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-mb', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 250
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 251
                          }
                        })
                      )
                    )
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : '') + (hierarchy <= 1 ? ' current' : ''), __source: {
                        fileName: _jsxFileName,
                        lineNumber: 258
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { className: 'SubNavigation__heading-link', href: rootLink.href,
                        target: rootLink.external === true ? '_blank' : '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 259
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-pc', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 261
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 262
                          }
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'SubNavigation__heading-mb', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 264
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 265
                          }
                        })
                      )
                    )
                  );
                }
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__heading' + (carsTitle === true ? ' carsTitle' : ''), __source: {
                      fileName: _jsxFileName,
                      lineNumber: 273
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'SubNavigation__heading-pc', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 274
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getPcHeading()) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 275
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'SubNavigation__heading-mb', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 277
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading()) }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 278
                      }
                    })
                  )
                );
              }
            }()
          ),
          function () {
            // 第2階層リンク
            if (links !== null && 1 <= links.length) {
              var end = false;
              if (hierarchy === 2) end = true;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SubNavigation__layout-center', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 291
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationItem, {
                  topLink: null,
                  links: links,
                  excludedWidth: 400,
                  end: end,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 292
                  }
                })
              );
            } else {
              return null;
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SubNavigation__layout-right', __source: {
                fileName: _jsxFileName,
                lineNumber: 304
              }
            },
            function () {
              if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
                var text = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationTitle && estimationHistory[0].props.navigationTitle !== '' ? estimationHistory[0].props.navigationTitle : '';
                var icon = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationIcon && estimationHistory[0].props.navigationIcon !== '' ? estimationHistory[0].props.navigationIcon : '';
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__estimation-history__button', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 310
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: 'javascript:void(0)', className: 'SubNavigation__estimation-history__button__link',
                      onClick: _this2.onClickEstimationHistory, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 311
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'SubNavigation__estimation-history__button__link__label', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 313
                        }
                      },
                      text
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'SubNavigation__estimation-history__button__link__icon-container', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 314
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SubNavigation__estimation-history__button__link__icon', src: icon, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 315
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__estimation-history__button__link__count', ref: 'estimationCount', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 316
                        }
                      })
                    )
                  )
                );
              }
            }()
          )
        ),
        function () {
          if (links !== null && 1 <= links.length) {
            return links.map(function (link, index) {
              // 第3階層リンク
              if (link.current === true && link.nestedNavigation !== null) {
                var end = false;
                if (hierarchy === 3) end = true;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'SubNavigation__layout2', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 334
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationItem, {
                    topLink: link.nestedNavigation.topLink,
                    links: link.nestedNavigation.links,
                    excludedWidth: 0,
                    end: end,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 335
                    }
                  })
                );
              } else {
                return null;
              }
            });
          } else {
            return null;
          }
        }()
      ),
      function () {
        if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: "SubNavigation__estimation-history" + (_this2.state.estimationHistoryOpen === true ? ' open' : ''),
              ref: 'estimationHistory', __source: {
                fileName: _jsxFileName,
                lineNumber: 356
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 359
                }
              },
              estimationHistory
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__close', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 362
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'javascript:void(0)', onClick: _this2.onClickEstimationHistory,
                  className: 'SubNavigation__estimation-history__close__button', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 363
                  }
                },
                'close'
              )
            )
          );
        }
      }()
    );
  };

  return SubNavigationTb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carsTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  estimationHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    nestedNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })),
  hierarchy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  subNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  deleteRootPageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  pcTitle: null,
  mbTitle: null,
  carsTitle: null,
  rootLink: null,
  estimationHistory: null,
  links: null,
  hierarchy: null,
  subNavigation: null,
  deleteRootPageLink: false
}, _temp);
SubNavigationTb.displayName = 'SubNavigationTb';


/* harmony default export */ __webpack_exports__["a"] = (SubNavigationTb);

/**
 * SubNavigationItem
 */
var SubNavigationItem = (_temp2 = _class2 = function (_Component2) {
  _inherits(SubNavigationItem, _Component2);

  function SubNavigationItem(props) {
    _classCallCheck(this, SubNavigationItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.getItemPositions = function () {
      var arr = [0];
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.items.length; i < max; i = i + 1) {
        var width = _this3.refs[_this3.items[i]].clientWidth;
        total = total + width;
        arr.push(total);
      }
      return arr;
    };

    _this3.getCurrentItemPosition = function () {
      var total = 0;
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this3.items.length; i < max; i = i + 1) {
        var width = _this3.refs[_this3.items[i]].clientWidth;
        if (_this3.refs[_this3.items[i]].dataset.current === 'current') {
          return total + width / 2;
        }
        total = total + width;
      }
      return 0;
    };

    _this3.props = props;
    _this3.items = [];
    _this3.state = {
      isMounted: false
    };
    return _this3;
  }

  SubNavigationItem.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  SubNavigationItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  SubNavigationItem.prototype.render = function render() {
    var _this4 = this;

    this.items = [];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubNavigation__item', __source: {
          fileName: _jsxFileName,
          lineNumber: 418
        }
      },
      function () {
        if (_this4.props.links !== null) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__components_navigation_container__["a" /* default */],
            {
              getItemPositions: _this4.getItemPositions,
              getCurrentItemPosition: _this4.getCurrentItemPosition,
              excludedWidth: _this4.props.excludedWidth,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 422
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'SubNavigation__list-ul', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 427
                }
              },
              function () {
                if (_this4.props.topLink !== null && _this4.props.topLink.display === true) {
                  // TOPリンク
                  _this4.items.push('itemTop');
                  if (_this4.state.isMounted) {

                    // 下層にcurrentがある場合はTOPリンクはcurrentにしない
                    var current = _this4.props.topLink.href === location.pathname ? true : _this4.props.topLink.current;
                    var i = void 0,
                        max = void 0;
                    for (i = 0, max = _this4.props.links.length; i < max; i = i + 1) {
                      if (_this4.props.links[i].current === true) {
                        current = false;
                        break;
                      }
                    }

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { ref: 'itemTop', 'data-current': '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 445
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                        pageName: _this4.props.topLink.pageName ? _this4.props.topLink.pageName + ' TOP' : null,
                        pcText: _this4.props.topLink.pcText ? _this4.props.topLink.pcText + ' TOP' : null,
                        mbText: _this4.props.topLink.mbText ? _this4.props.topLink.mbText + ' TOP' : null,
                        href: _this4.props.topLink.href,
                        external: _this4.props.topLink.external,
                        current: current,
                        current2: current,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 446
                        }
                      })
                    );
                  } else {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { ref: 'itemTop', 'data-current': '', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 459
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                        pageName: _this4.props.topLink.pageName ? _this4.props.topLink.pageName + ' TOP' : null,
                        pcText: _this4.props.topLink.pcText ? _this4.props.topLink.pcText + ' TOP' : null,
                        mbText: _this4.props.topLink.mbText ? _this4.props.topLink.mbText + ' TOP' : null,
                        href: _this4.props.topLink.href,
                        external: _this4.props.topLink.external,
                        current: _this4.props.topLink.current,
                        current2: _this4.props.topLink.current,
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 460
                        }
                      })
                    );
                  }
                } else {
                  return null;
                }
              }(),
              _this4.props.links.map(function (link, index) {
                // 第2階層リンク、第3階層リンク
                _this4.items.push('item' + index);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, ref: 'item' + index, 'data-current': link.current ? 'current' : '', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 480
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                    pageName: link.pageName,
                    pcText: link.pcText,
                    mbText: link.mbText,
                    href: link.href,
                    external: link.external,
                    current: link.current,
                    current2: _this4.props.end,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 481
                    }
                  })
                );
              })
            )
          );
        } else {
          return null;
        }
      }()
    );
  };

  //


  //


  return SubNavigationItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  topLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  excludedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  end: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  topLink: null,
  links: null,
  excludedWidth: 0,
  end: false
}, _temp2);
SubNavigationItem.displayName = 'SubNavigationItem';


/**
 * SubNavigationLink
 */
var SubNavigationLink = function SubNavigationLink(_ref) {
  var pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      external = _ref.external,
      current = _ref.current,
      current2 = _ref.current2;

  var getPcText = function getPcText() {
    if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  var getMbText = function getMbText() {
    if (mbText !== null) {
      return mbText;
    } else if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: 'SubNavigation__link' + (current === true ? ' current' : '') + (current2 === true ? ' current2' : ''),
      href: href, target: external === true ? '_blank' : '', __source: {
        fileName: _jsxFileName,
        lineNumber: 562
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'SubNavigation__link-container', __source: {
          fileName: _jsxFileName,
          lineNumber: 565
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 566
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 567
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 569
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 570
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__link-border', __source: {
          fileName: _jsxFileName,
          lineNumber: 572
        }
      })
    )
  );
};
SubNavigationLink.displayName = 'SubNavigationLink';

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_environment__ = __webpack_require__(5);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-navigation\\mb.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * SubNavigationMb
 */
var SubNavigationMb = (_temp = _class = function (_Component) {
  _inherits(SubNavigationMb, _Component);

  function SubNavigationMb(props) {
    _classCallCheck(this, SubNavigationMb);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onResize = function (e) {
      _this.handleResize();
      _this.fit();
    };

    _this.onScroll = function (e) {
      _this.fit();
    };

    _this.onTouchMove = function (e) {
      e.preventDefault();
    };

    _this.fit = function () {
      var scrollTop = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].documentElement.scrollTop || __WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].body.scrollTop;
      var subNavigation = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].querySelector('.SubNavigation');

      var subNavigationHeight = subNavigation.clientHeight;
      var headerHeight = 0;

      if (subNavigation.classList.contains('fixed')) {
        headerHeight = 0;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].querySelector('.Header') && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight) {
          headerHeight = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].querySelector('.Header').clientHeight - scrollTop;
        }
      }

      var estimationHistory = _this.refs.estimationHistory;

      if (estimationHistory && _this.validEstimateJson()) {
        estimationHistory.style.height = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].innerHeight - headerHeight + 'px';
      }
    };

    _this.onClickEstimationHistory = function (e) {
      var isOpen = !_this.state.estimationHistoryOpen;
      _this.setState({
        estimationHistoryOpen: isOpen
      });
    };

    _this.validEstimateJson = function () {
      if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        try {
          JSON.parse(json);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
      } else {
        // IE
        var evt = document.createEventObject();
        return element.fireEvent("on" + event, evt);
      }
    };

    _this.handleResize = function () {
      if (_this.open === false) return;
      //
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      var height = window.innerHeight - _this.refs.heading.clientHeight;
      //let height = screen.availHeight - this.refs.heading.clientHeight;
      if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["a" /* DOCUMENT */].querySelector('.Header')) {
        if (top < 60) {
          height = height - (60 - top);
        }
      }
      _this.setState({
        height: height
      });
    };

    _this.getPcHeading = function () {
      if (_this.props.pcTitle && _this.props.pcTitle !== '') {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink && _this.props.rootLink !== '') {
          if (_this.props.rootLink.pcText && _this.props.rootLink.pcText !== '') {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName && _this.props.rootLink.pageName !== '') {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.getMbHeading = function () {
      if (_this.props.mbTitle && _this.props.mbTitle !== '') {
        return _this.props.mbTitle;
      } else if (_this.props.pcTitle && _this.props.pcTitle !== '') {
        return _this.props.pcTitle;
      } else {
        if (_this.props.rootLink !== null) {
          if (_this.props.rootLink.mbText && _this.props.rootLink.mbText !== '') {
            return _this.props.rootLink.mbText;
          } else if (_this.props.rootLink.pcText && _this.props.rootLink.pcText !== '') {
            return _this.props.rootLink.pcText;
          } else if (_this.props.rootLink.pageName && _this.props.rootLink.pageName !== '') {
            return _this.props.rootLink.pageName;
          }
        }
      }
      return null;
    };

    _this.changeOpenClose = function (e) {
      e.preventDefault();
      if (_this.open === true) {
        _this.open = false;
        _this.setState({
          open: false
        });
        // BODYのスクロール無効化を解除
        __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].clearUnScroll();
        //
        if (_this.props.onClosed) _this.props.onClosed();
      } else {
        _this.open = true;
        _this.setState({
          open: true
        });
        //
        _this.handleResize();
        // BODYのスクロール無効化
        __WEBPACK_IMPORTED_MODULE_4__components_body__["a" /* default */].setUnScrollMb();
        //
        if (_this.props.onOpened) _this.props.onOpened();
      }
    };

    _this.setEstimateCount = function () {
      var cnt = 0;
      var est = {};

      if (!_this.validEstimateJson()) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */] && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage && __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage.getItem) {
        var json = __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].localStorage.getItem('mj_est');
        est = JSON.parse(json);
      }
      if (est && Object.keys(est).length > 0 && 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0) {
        cnt += est['unsaved'].length;
      }
      if (est && Object.keys(est).length > 0 && 'saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) {
        cnt += est['saved'].length;
      }
      var estimationCount = _this.refs.estimationCount;
      if (estimationCount) {
        estimationCount.classList.add('n' + cnt);
      }
    };

    _this.props = props;
    _this.state = {
      open: false,
      height: 0,
      estimationHistoryOpen: false
    };
    _this.open = false;
    //this.bodyControl = new BodyControl();
    return _this;
  }

  SubNavigationMb.prototype.componentDidMount = function componentDidMount() {
    this.setEstimateCount();
    __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].addEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].addEventListener('scroll', this.onScroll);
    this.triggerEvent(__WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */], 'scroll');
  };

  SubNavigationMb.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].removeEventListener('resize', this.onResize);
    __WEBPACK_IMPORTED_MODULE_5__constants_environment__["k" /* WINDOW */].removeEventListener('scroll', this.onScroll);
  };

  SubNavigationMb.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SubNavigation__mb' + (this.state.open === true ? ' open' : ''), __source: {
          fileName: _jsxFileName,
          lineNumber: 244
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubNavigation__heading' + (this.props.carsTitle === true ? ' carsTitle' : ''), ref: 'heading', __source: {
            fileName: _jsxFileName,
            lineNumber: 245
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'SubNavigation__heading-link', href: '#',
            onClick: function onClick(e) {
              _this2.changeOpenClose(e);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 246
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'SubNavigation__heading-pc', __source: {
                fileName: _jsxFileName,
                lineNumber: 251
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(this.getPcHeading()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 252
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'SubNavigation__heading-mb', __source: {
                fileName: _jsxFileName,
                lineNumber: 254
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(this.getMbHeading()) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 255
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__heading-icon', __source: {
              fileName: _jsxFileName,
              lineNumber: 257
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'SubNavigation__heading-text', __source: {
                fileName: _jsxFileName,
                lineNumber: 258
              }
            },
            'MENU'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubNavigation__pull-down', style: { height: this.state.height }, ref: 'pulldown', __source: {
            fileName: _jsxFileName,
            lineNumber: 261
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'SubNavigation__pull-down-inner', __source: {
              fileName: _jsxFileName,
              lineNumber: 262
            }
          },
          function () {
            // Rootページへのリンク
            if (!_this2.props.deleteRootPageLink && _this2.props.rootLink !== null && _this2.props.rootLink.href !== null) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'SubNavigation__link-root' + (_this2.props.carsTitle === true ? ' carsTitle' : '') + (_this2.props.hierarchy <= 1 ? ' current' : ''),
                  href: _this2.props.rootLink.href,
                  target: _this2.props.rootLink.external === true ? '_blank' : '',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 267
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(_this2.getMbHeading() + ' TOP') }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 271
                  }
                })
              );
            } else {
              return null;
            }
          }(),
          function () {
            // 第2階層リンク以降
            if (_this2.props.links !== null && 1 <= _this2.props.links.length) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'SubNavigation__list-ul', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 282
                  }
                },
                _this2.props.links.map(function (link, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 285
                      }
                    },
                    function () {
                      if (link.nestedNavigation !== null && link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_2__components_accordion__["a" /* default */],
                          { pageName: link.pageName,
                            pcText: link.pcText,
                            mbText: link.mbText,
                            open: link.current,
                            current: link.current,
                            simpleAnimation: true,
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 289
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLinks, { topLink: link.nestedNavigation.topLink,
                            links: link.nestedNavigation.links,
                            current: link.current,
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 296
                            }
                          })
                        );
                      } else {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, { pageName: link.pageName,
                          pcText: link.pcText,
                          mbText: link.mbText,
                          href: link.href,
                          external: link.external,
                          current: link.current,
                          onClick: null,
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 304
                          }
                        });
                      }
                    }()
                  );
                })
              );
            } else {
              return null;
            }
          }(),
          function () {
            var estimationHistory = _this2.props.estimationHistory;
            if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
              var text = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationTitle && estimationHistory[0].props.navigationTitle !== '' ? estimationHistory[0].props.navigationTitle : '';
              var icon = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationIcon && estimationHistory[0].props.navigationIcon !== '' ? estimationHistory[0].props.navigationIcon : '';
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'SubNavigation__estimation-history__button', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 330
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'javascript:void(0)', className: 'SubNavigation__estimation-history__button__link',
                    onClick: _this2.onClickEstimationHistory,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 331
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'SubNavigation__estimation-history__button__link__label', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 334
                      }
                    },
                    text
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'SubNavigation__estimation-history__button__link__icon-container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 335
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'SubNavigation__estimation-history__button__link__icon', src: icon, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 336
                      }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__estimation-history__button__link__count', ref: 'estimationCount', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 337
                      }
                    })
                  )
                )
              );
            }
          }()
        )
      ),
      function () {
        var estimationHistory = _this2.props.estimationHistory;
        if (estimationHistory != null && estimationHistory.length > 0 && _this2.validEstimateJson()) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: "SubNavigation__estimation-history" + (_this2.state.estimationHistoryOpen === true ? ' open' : ''),
              ref: 'estimationHistory', __source: {
                fileName: _jsxFileName,
                lineNumber: 350
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 353
                }
              },
              estimationHistory
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'SubNavigation__estimation-history__close', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 356
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'javascript:void(0)',
                  onClick: _this2.onClickEstimationHistory,
                  className: 'SubNavigation__estimation-history__close__button',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 357
                  }
                },
                'close'
              )
            )
          );
        }
      }()
    );
  };

  return SubNavigationMb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carsTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  estimationHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    nestedNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })),
  hierarchy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deleteRootPageLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  pcTitle: null,
  mbTitle: null,
  carsTitle: null,
  rootLink: null,
  estimationHistory: null,
  links: null,
  hierarchy: null,
  deleteRootPageLink: false
}, _temp);
SubNavigationMb.displayName = 'SubNavigationMb';


/* harmony default export */ __webpack_exports__["a"] = (SubNavigationMb);

/**
 * SubNavigationLinks
 */

var SubNavigationLinks = function (_Component2) {
  _inherits(SubNavigationLinks, _Component2);

  function SubNavigationLinks(props) {
    _classCallCheck(this, SubNavigationLinks);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.props = props;
    _this3.state = {
      isMounted: false
    };
    return _this3;
  }

  SubNavigationLinks.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  SubNavigationLinks.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  SubNavigationLinks.prototype.render = function render() {
    var _this4 = this;

    var topLink = this.props.topLink;
    var links = this.props.links;
    var current = this.props.current;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: 'SubNavigation__list-ul2', __source: {
          fileName: _jsxFileName,
          lineNumber: 406
        }
      },
      function () {
        if (topLink !== null) {
          // TOPリンク
          if (_this4.state.isMounted) {

            // 下層にcurrentがある場合はTOPリンクはcurrentにしない
            var _current = topLink.href === location.pathname ? true : topLink.current;
            var i = void 0,
                max = void 0;
            for (i = 0, max = links.length; i < max; i = i + 1) {
              if (links[i].current === true) {
                _current = false;
                break;
              }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 423
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                pageName: topLink.pageName !== null ? topLink.pageName + ' TOP' : null,
                pcText: topLink.pcText !== null ? topLink.pcText + ' TOP' : null,
                mbText: topLink.mbText !== null ? topLink.mbText + ' TOP' : null,
                href: topLink.href,
                external: topLink.external,
                current: _current,
                onClick: null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 424
                }
              })
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 437
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                pageName: topLink.pageName !== null ? topLink.pageName + ' TOP' : null,
                pcText: topLink.pcText !== null ? topLink.pcText + ' TOP' : null,
                mbText: topLink.mbText !== null ? topLink.mbText + ' TOP' : null,
                href: topLink.href,
                external: topLink.external,
                current: topLink.current,
                onClick: null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 438
                }
              })
            );
          }
        } else {
          return null;
        }
      }(),
      links.map(function (link, index) {
        // リンク
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 457
            }
          },
          function () {
            if (link.nestedNavigation !== null && link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__components_accordion__["a" /* default */],
                {
                  pageName: link.pageName,
                  pcText: link.pcText,
                  mbText: link.mbText,
                  open: link.current,
                  current: link.current,
                  simpleAnimation: true,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 461
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLinks, {
                  topLink: link.nestedNavigation.topLink,
                  links: link.nestedNavigation.links,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 469
                  }
                })
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                pageName: link.pageName,
                pcText: link.pcText,
                mbText: link.mbText,
                href: link.href,
                external: link.external,
                current: link.current,
                onClick: null,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 477
                }
              });
            }
          }()
        );
      })
    );
  };

  return SubNavigationLinks;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SubNavigationLinks.displayName = 'SubNavigationLinks';
;

/**
 * SubNavigationLink
 */
var SubNavigationLink = function SubNavigationLink(_ref) {
  var pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      external = _ref.external,
      current = _ref.current,
      onClick = _ref.onClick;

  var getPcText = function getPcText() {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  var getMbText = function getMbText() {
    if (mbText && mbText !== '') {
      return mbText;
    } else if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  var handleClick = function handleClick(e) {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(e);
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { className: 'SubNavigation__link' + (current === true ? ' current' : ''), href: href,
      target: external === true ? '_blank' : '',
      onClick: function onClick(e) {
        handleClick(e);
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 533
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'SubNavigation__link-container', __source: {
          fileName: _jsxFileName,
          lineNumber: 539
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 540
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getPcText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 541
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 543
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(getMbText()) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 544
          }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__link-border', __source: {
        fileName: _jsxFileName,
        lineNumber: 547
      }
    })
  );
};
SubNavigationLink.displayName = 'SubNavigationLink';

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accordion__ = __webpack_require__(28);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sub-navigation\\lower.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * SubNavigationLower
 */
var SubNavigationLower = (_temp = _class = function (_Component) {
  _inherits(SubNavigationLower, _Component);

  function SubNavigationLower(props) {
    _classCallCheck(this, SubNavigationLower);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getLinks = function () {
      var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (links === null) return null;
      var i = void 0,
          max = void 0;
      for (i = 0, max = links.length; i < max; i = i + 1) {
        if (links[i].current === true) {
          if (links[i].nestedNavigation !== null && links[i].nestedNavigation.links !== null && 1 <= links[i].nestedNavigation.links.length) {
            var flg = false;
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = links[i].nestedNavigation.links.length; j < max2; j = j + 1) {
              if (links[i].nestedNavigation.links[j].current === true) {
                flg = true;
              }
            }
            if (!flg) {
              return links;
            } else {
              return _this.getLinks(links[i].nestedNavigation.links);
            }
          }
        }
      }
      return links;
    };

    _this.props = props;
    return _this;
  }

  //


  SubNavigationLower.prototype.render = function render() {
    if (this.props.hierarchy <= 1) return null;
    // リンク情報取得
    var links = this.getLinks(this.props.links);
    // HTML出力
    if (links !== null && 1 <= links.length) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SubNavigation__lower', __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'SubNavigation__list-ul', __source: {
              fileName: _jsxFileName,
              lineNumber: 55
            }
          },
          links.map(function (link, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 58
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavigationLink, {
                pageName: link.pageName,
                pcText: link.pcText,
                mbText: link.mbText,
                href: link.href,
                external: link.external,
                current: link.current,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 59
                }
              })
            );
          })
        )
      );
    } else {
      return null;
    }
  };

  return SubNavigationLower;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carsTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  estimationHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    nestedNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })),
  hierarchy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  pcTitle: null,
  mbTitle: null,
  carsTitle: null,
  rootLink: null,
  estimationHistory: null,
  links: null,
  hierarchy: 0
}, _temp);
SubNavigationLower.displayName = 'SubNavigationLower';


/* harmony default export */ __webpack_exports__["a"] = (SubNavigationLower);

/**
 * SubNavigationLink
 */
var SubNavigationLink = function SubNavigationLink(_ref) {
  var pageName = _ref.pageName,
      pcText = _ref.pcText,
      mbText = _ref.mbText,
      href = _ref.href,
      external = _ref.external,
      current = _ref.current;


  //
  var getPcText = function getPcText() {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };

  //
  var getMbText = function getMbText() {
    if (mbText && mbText !== '') {
      return mbText;
    } else if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };

  //
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { className: 'SubNavigation__link' + (current === true ? ' current' : ''),
      href: href,
      target: external === true ? '_blank' : '',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-pc', __source: {
            fileName: _jsxFileName,
            lineNumber: 145
          }
        },
        getPcText().replace('|', '')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'SubNavigation__link-mb', __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          }
        },
        getMbText().replace('|', '')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'SubNavigation__link-border', __source: {
          fileName: _jsxFileName,
          lineNumber: 147
        }
      })
    )
  );
};
SubNavigationLink.displayName = 'SubNavigationLink';

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SubNavigation":"SubNavigation","fixed":"fixed","SubNavigation__container":"SubNavigation__container","one-steps":"one-steps","two-steps":"two-steps","lower":"lower","SubNavigation__pc":"SubNavigation__pc","SubNavigation__container2":"SubNavigation__container2","SubNavigation__layout":"SubNavigation__layout","SubNavigation__heading":"SubNavigation__heading","current":"current","SubNavigation__layout-left":"SubNavigation__layout-left","SubNavigation__layout-center":"SubNavigation__layout-center","SubNavigation__layout-right":"SubNavigation__layout-right","SubNavigation__layout2":"SubNavigation__layout2","SubNavigation__heading-link":"SubNavigation__heading-link","carsTitle":"carsTitle","SubNavigation__heading-pc":"SubNavigation__heading-pc","SubNavigation__heading-mb":"SubNavigation__heading-mb","SubNavigation__list-ul":"SubNavigation__list-ul","SubNavigation__link":"SubNavigation__link","current2":"current2","SubNavigation__link-border":"SubNavigation__link-border","SubNavigation__link-pc":"SubNavigation__link-pc","SubNavigation__link-mb":"SubNavigation__link-mb","SubNavigation__link-container":"SubNavigation__link-container","SubNavigation__estimation-history__button":"SubNavigation__estimation-history__button","SubNavigation__estimation-history__button__link":"SubNavigation__estimation-history__button__link","SubNavigation__estimation-history__button__link__label":"SubNavigation__estimation-history__button__link__label","SubNavigation__estimation-history__button__link__icon-container":"SubNavigation__estimation-history__button__link__icon-container","SubNavigation__estimation-history__button__link__icon":"SubNavigation__estimation-history__button__link__icon","SubNavigation__estimation-history__button__link__count":"SubNavigation__estimation-history__button__link__count","n0":"n0","n1":"n1","n2":"n2","n3":"n3","n4":"n4","n5":"n5","n6":"n6","n7":"n7","n8":"n8","n9":"n9","SubNavigation__estimation-history":"SubNavigation__estimation-history","open":"open","SubNavigation__estimation-history__inner":"SubNavigation__estimation-history__inner","SubNavigation__estimation-history__close":"SubNavigation__estimation-history__close","SubNavigation__estimation-history__close__button":"SubNavigation__estimation-history__close__button","SubNavigation__tb":"SubNavigation__tb","SubNavigation__mb":"SubNavigation__mb","SubNavigation__lower":"SubNavigation__lower","SubNavigation__heading-icon":"SubNavigation__heading-icon","SubNavigation__pull-down":"SubNavigation__pull-down","SubNavigation__pull-down-inner":"SubNavigation__pull-down-inner","SubNavigation__heading-text":"SubNavigation__heading-text","SubNavigation__list-ul2":"SubNavigation__list-ul2","SubNavigation__link-root":"SubNavigation__link-root","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","NavigationContainer":"NavigationContainer"};

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PhotoInfo":"PhotoInfo","PhotoInfo__btn__open__wrap":"PhotoInfo__btn__open__wrap","PhotoInfo__btn__open":"PhotoInfo__btn__open","PhotoInfo__content":"PhotoInfo__content","is-open":"is-open","PhotoInfo__container":"PhotoInfo__container","PhotoInfo__text":"PhotoInfo__text","PhotoInfo__btn__close":"PhotoInfo__btn__close","link__color__dark":"link__color__dark","link__color__light":"link__color__light","is-show-scroll_btn":"is-show-scroll_btn","is-hide-scroll_btn":"is-hide-scroll_btn"};

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeroVideo":"HeroVideo","HeroVideo__figure__block":"HeroVideo__figure__block","HeroVideo__figure__img":"HeroVideo__figure__img","HeroVideo__figure__img-mb":"HeroVideo__figure__img-mb","HeroVideo__video__block":"HeroVideo__video__block","HeroVideo__video-mb":"HeroVideo__video-mb","HeroVideo__video__poster":"HeroVideo__video__poster","HeroVideo__video__poster-mb":"HeroVideo__video__poster-mb","HeroVideo__imageLink":"HeroVideo__imageLink","HeroVideo__videoFilter-pc":"HeroVideo__videoFilter-pc","HeroVideo__videoFilter-mb":"HeroVideo__videoFilter-mb","HeroVideo__Youtube__link":"HeroVideo__Youtube__link","HeroVideo__container":"HeroVideo__container","align-left-pc":"align-left-pc","HeroVideo__heading":"HeroVideo__heading","align-center-pc":"align-center-pc","align-right-pc":"align-right-pc","left-upper":"left-upper","center-upper":"center-upper","right-upper":"right-upper","left-middle":"left-middle","center-middle":"center-middle","right-middle":"right-middle","left-lower":"left-lower","has-btn__link":"has-btn__link","center-lower":"center-lower","right-lower":"right-lower","HeroVideo__heading__pcPreHeading":"HeroVideo__heading__pcPreHeading","HeroVideo__heading__mbPreHeading":"HeroVideo__heading__mbPreHeading","HeroVideo__heading__pcHeading":"HeroVideo__heading__pcHeading","HeroVideo__heading__mbHeading":"HeroVideo__heading__mbHeading","HeroVideo__heading__pcDescription":"HeroVideo__heading__pcDescription","HeroVideo__heading__mbDescription":"HeroVideo__heading__mbDescription","HeroVideo__btn__link":"HeroVideo__btn__link","Standard":"Standard","Action":"Action","Feature":"Feature","HeroVideo__btn__scroll":"HeroVideo__btn__scroll","HeroVideo__btn__scroll__clicked":"HeroVideo__btn__scroll__clicked","scrollTo":"scrollTo","is-show-scroll_btn":"is-show-scroll_btn","is-hide-scroll_btn":"is-hide-scroll_btn","fullSize-pc":"fullSize-pc","halfSize-pc":"halfSize-pc","HeroVideo__modal":"HeroVideo__modal","is-open":"is-open","HeroVideo__modal__overlay":"HeroVideo__modal__overlay","HeroVideo__modal__btn__close":"HeroVideo__modal__btn__close","HeroVideo__modal__content":"HeroVideo__modal__content","HeroVideo__modal__content__inner":"HeroVideo__modal__content__inner","HeroVideo__modal__movie__block":"HeroVideo__modal__movie__block","HeroVideo__modal__movie":"HeroVideo__modal__movie","ImageLink__entered":"ImageLink__entered","HeroImage__figure__img":"HeroImage__figure__img","HeroVideo__figure__img-pc":"HeroVideo__figure__img-pc","HeroVideo__video-pc":"HeroVideo__video-pc","HeroVideo__video__poster-pc":"HeroVideo__video__poster-pc","align-left-mb":"align-left-mb","align-center-mb":"align-center-mb","align-right-mb":"align-right-mb","fullSize-mb":"fullSize-mb","halfSize-mb":"halfSize-mb","verticalSize-mb":"verticalSize-mb","upper-mb":"upper-mb","middle-mb":"middle-mb","lower-mb":"lower-mb"};

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RelatedVideo__container":"RelatedVideo__container","RelatedVideo__main_title":"RelatedVideo__main_title","RelatedVideo__wrap":"RelatedVideo__wrap","RelatedVideo":"RelatedVideo","RelatedVideo__link":"RelatedVideo__link","RelatedVideo__thumb":"RelatedVideo__thumb","RelatedVideo__thumb__block":"RelatedVideo__thumb__block","RelatedVideo__text":"RelatedVideo__text","RelatedVideo__pcTitle":"RelatedVideo__pcTitle","RelatedVideo__pcDescription":"RelatedVideo__pcDescription","RelatedVideo__mbTitle":"RelatedVideo__mbTitle","RelatedVideo__mbDescription":"RelatedVideo__mbDescription"};

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id === props.id || prevProps.className === props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
          return;
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        _this.props.id ? iframe.setAttribute('id', _this.props.id) : iframe.removeAttribute('id');
        _this.props.className ? iframe.setAttribute('class', _this.props.className) : iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["a"] = (YouTube);

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(747);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(748),
    isObjectLike = __webpack_require__(70);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(749),
    equalArrays = __webpack_require__(302),
    equalByTag = __webpack_require__(756),
    equalObjects = __webpack_require__(759),
    getTag = __webpack_require__(777),
    isArray = __webpack_require__(103),
    isBuffer = __webpack_require__(303),
    isTypedArray = __webpack_require__(304);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105),
    stackClear = __webpack_require__(750),
    stackDelete = __webpack_require__(751),
    stackGet = __webpack_require__(752),
    stackHas = __webpack_require__(753),
    stackSet = __webpack_require__(754);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105),
    Map = __webpack_require__(145),
    MapCache = __webpack_require__(254);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(101),
    Uint8Array = __webpack_require__(757),
    eq = __webpack_require__(255),
    equalArrays = __webpack_require__(302),
    mapToArray = __webpack_require__(758),
    setToArray = __webpack_require__(146);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(760);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(761),
    getSymbols = __webpack_require__(762),
    keys = __webpack_require__(765);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(246),
    isArray = __webpack_require__(103);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(763),
    stubArray = __webpack_require__(764);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(766),
    baseKeys = __webpack_require__(773),
    isArrayLike = __webpack_require__(258);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(767),
    isArguments = __webpack_require__(248),
    isArray = __webpack_require__(103),
    isBuffer = __webpack_require__(303),
    isIndex = __webpack_require__(769),
    isTypedArray = __webpack_require__(304);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(102),
    isLength = __webpack_require__(259),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(247);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(774),
    nativeKeys = __webpack_require__(775);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(776);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(778),
    Map = __webpack_require__(145),
    Promise = __webpack_require__(779),
    Set = __webpack_require__(257),
    WeakMap = __webpack_require__(780),
    baseGetTag = __webpack_require__(102),
    toSource = __webpack_require__(252);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(47),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(782);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(783);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(785);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param elementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if (typeof maybeElementId === 'string' || maybeElementId instanceof HTMLElement) {
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    } else if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      throw new TypeError('Unexpected state.');
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(784);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

  (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
    if (error) {
      emitter.trigger('error', error);
    }
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 784 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(786);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(790);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(791);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(792);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(788);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(787)))

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(789);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(793);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"YoutubePlayer":"YoutubePlayer","YoutubePlayer__btn-mute":"YoutubePlayer__btn-mute"};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeroImage":"HeroImage","HeroImage__figure__block":"HeroImage__figure__block","HeroImage__figure__img":"HeroImage__figure__img","HeroImage__figure__img-mb":"HeroImage__figure__img-mb","HeroImage__imageLink":"HeroImage__imageLink","HeroImage__container":"HeroImage__container","align-left-pc":"align-left-pc","HeroImage__heading":"HeroImage__heading","align-center-pc":"align-center-pc","align-right-pc":"align-right-pc","left-upper":"left-upper","center-upper":"center-upper","right-upper":"right-upper","left-middle":"left-middle","center-middle":"center-middle","right-middle":"right-middle","left-lower":"left-lower","has-btn__link":"has-btn__link","center-lower":"center-lower","right-lower":"right-lower","HeroImage__heading__pcPreHeading":"HeroImage__heading__pcPreHeading","HeroImage__heading__mbPreHeading":"HeroImage__heading__mbPreHeading","HeroImage__heading__pcHeading":"HeroImage__heading__pcHeading","HeroImage__heading__mbHeading":"HeroImage__heading__mbHeading","HeroImage__heading__pcDescription":"HeroImage__heading__pcDescription","HeroImage__heading__mbDescription":"HeroImage__heading__mbDescription","HeroImage__btn__link":"HeroImage__btn__link","Standard":"Standard","Action":"Action","Feature":"Feature","HeroImage__btn__scroll":"HeroImage__btn__scroll","HeroImage__btn__scroll__clicked":"HeroImage__btn__scroll__clicked","scrollTo":"scrollTo","is-show-scroll_btn":"is-show-scroll_btn","is-hide-scroll_btn":"is-hide-scroll_btn","fullSize-pc":"fullSize-pc","halfSize-pc":"halfSize-pc","ImageLink__entered":"ImageLink__entered","HeroImage__figure__img-pc":"HeroImage__figure__img-pc","align-left-mb":"align-left-mb","align-center-mb":"align-center-mb","align-right-mb":"align-right-mb","fullSize-mb":"fullSize-mb","halfSize-mb":"halfSize-mb","verticalSize-mb":"verticalSize-mb","upper-mb":"upper-mb","middle-mb":"middle-mb","lower-mb":"lower-mb"};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeroCarousel":"HeroCarousel","HeroCarousel__slick":"HeroCarousel__slick","slick-slider":"slick-slider","slick-track":"slick-track","slick-list":"slick-list","slick-fade":"slick-fade","slick-slide":"slick-slide","slick-current":"slick-current","HeroCarousel__mask":"HeroCarousel__mask","HeroCarousel__mask__fadein":"HeroCarousel__mask__fadein","mask-fadeIn":"mask-fadeIn","HeroCarousel__mask__fadein__faster":"HeroCarousel__mask__fadein__faster","HeroCarousel__mask__fadeout":"HeroCarousel__mask__fadeout","mask-fadeOut":"mask-fadeOut","HeroCarousel__btn":"HeroCarousel__btn","HeroCarousel__btn__blink":"HeroCarousel__btn__blink","arrowBlink":"arrowBlink","HeroCarousel__prev":"HeroCarousel__prev","HeroCarousel__btn__clicked":"HeroCarousel__btn__clicked","arrowLeft":"arrowLeft","HeroCarousel__next":"HeroCarousel__next","arrowRight":"arrowRight","HeroCarousel__pager__block":"HeroCarousel__pager__block","pager-fadeIn":"pager-fadeIn","HeroCarousel__pager":"HeroCarousel__pager","HeroCarousel__pager__dot":"HeroCarousel__pager__dot","is-active":"is-active","is-show-scroll_btn":"is-show-scroll_btn","is-hide-scroll_btn":"is-hide-scroll_btn","HeroImage__btn__scroll":"HeroImage__btn__scroll","HeroVideo__btn__scroll":"HeroVideo__btn__scroll","fullSize-pc":"fullSize-pc","halfSize-pc":"halfSize-pc","HeroImage__figure__block":"HeroImage__figure__block","HeroVideo__figure__block":"HeroVideo__figure__block","HeroImage__container":"HeroImage__container","left-upper":"left-upper","HeroImage__heading":"HeroImage__heading","center-upper":"center-upper","right-upper":"right-upper","left-lower":"left-lower","has-btn__link":"has-btn__link","center-lower":"center-lower","right-lower":"right-lower","HeroImage__btn__link":"HeroImage__btn__link","HeroVideo__container":"HeroVideo__container","HeroVideo__heading":"HeroVideo__heading","HeroVideo__btn__link":"HeroVideo__btn__link","HeroCarousel__started":"HeroCarousel__started","HeroVideo__modal__opened":"HeroVideo__modal__opened","HeroCarousel__controls":"HeroCarousel__controls","HeroCarousel__pager__wrap":"HeroCarousel__pager__wrap","PhotoInfo__opened":"PhotoInfo__opened","pager-fadeOut":"pager-fadeOut","fullSize-mb":"fullSize-mb","halfSize-mb":"halfSize-mb","verticalSize-mb":"verticalSize-mb","HeroImage__figure":"HeroImage__figure","HeroVideo__figure":"HeroVideo__figure","HeroImage__figure__img":"HeroImage__figure__img","HeroVideo__figure__img":"HeroVideo__figure__img","lower-mb":"lower-mb","Standard":"Standard","Action":"Action","upper-mb":"upper-mb","middle-mb":"middle-mb"};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StandardPage":"StandardPage","StandardPage__header":"StandardPage__header","StandardPage__navigation":"StandardPage__navigation","StandardPage__heading-pc":"StandardPage__heading-pc","StandardPage__heading-mb":"StandardPage__heading-mb","StandardPage__main":"StandardPage__main","StandardPage__bottom-navigation":"StandardPage__bottom-navigation","StandardPage__footer":"StandardPage__footer"};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FullWidth":"FullWidth","FullWidth__wrapped-link":"FullWidth__wrapped-link","FullWidth__figure__block":"FullWidth__figure__block","FullWidth__figure":"FullWidth__figure","FullWidth__figure__img":"FullWidth__figure__img","FullWidth__figure__img-mb":"FullWidth__figure__img-mb","FullWidth__video":"FullWidth__video","FullWidth__video-mb":"FullWidth__video-mb","FullWidth__container":"FullWidth__container","pcPosition__left-upper":"pcPosition__left-upper","FullWidth__wysiwyg":"FullWidth__wysiwyg","pcPosition__center-upper":"pcPosition__center-upper","pcPosition__right-upper":"pcPosition__right-upper","pcPosition__left-middle":"pcPosition__left-middle","pcPosition__center-middle":"pcPosition__center-middle","pcPosition__right-middle":"pcPosition__right-middle","pcPosition__left-lower":"pcPosition__left-lower","pcPosition__center-lower":"pcPosition__center-lower","pcPosition__right-lower":"pcPosition__right-lower","FullWidth__wysiwyg-mb":"FullWidth__wysiwyg-mb","pcVerticalSize__compact":"pcVerticalSize__compact","pcVerticalSize__medium":"pcVerticalSize__medium","pcVerticalSize__tall":"pcVerticalSize__tall","pcVerticalSize__extra-tall":"pcVerticalSize__extra-tall","pcVerticalSize__wide-screen":"pcVerticalSize__wide-screen","FullWidth__figure__parallax__overlay":"FullWidth__figure__parallax__overlay","FullWidth__parallax":"FullWidth__parallax","FullWidth__opacity__zero":"FullWidth__opacity__zero","PhotoInfo":"PhotoInfo","FullWidth__parallax__fixed":"FullWidth__parallax__fixed","FullWidth__parallax__bottom":"FullWidth__parallax__bottom","FullWidth__light-to-dark":"FullWidth__light-to-dark","FullWidth__parallax__action":"FullWidth__parallax__action","FullWidth__dark-to-light":"FullWidth__dark-to-light","FullWidth__figure__img-pc":"FullWidth__figure__img-pc","FullWidth__video-pc":"FullWidth__video-pc","mbPosition__upper":"mbPosition__upper","mbPosition__middle":"mbPosition__middle","mbPosition__lower":"mbPosition__lower","FullWidth__wysiwyg-pc":"FullWidth__wysiwyg-pc","mbVerticalSize__compact":"mbVerticalSize__compact","mbVerticalSize__medium":"mbVerticalSize__medium","mbVerticalSize__tall":"mbVerticalSize__tall","mbVerticalSize__extra-tall":"mbVerticalSize__extra-tall","mbVerticalSize__wide-screen":"mbVerticalSize__wide-screen"};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ScrollLoader":"ScrollLoader","opened":"opened"};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Video":"Video","Video__link":"Video__link","Video__Youtube__link":"Video__Youtube__link","Video__figure__block":"Video__figure__block","Video__video__block":"Video__video__block","Video__video-mb":"Video__video-mb","Video__video__poster":"Video__video__poster","Video__video__poster-pc":"Video__video__poster-pc","Video__video__poster-mb":"Video__video__poster-mb","Video__videoFilter-pc":"Video__videoFilter-pc","Video__videoFilter-mb":"Video__videoFilter-mb","Video__btn__play__video":"Video__btn__play__video","Video__btn__play__video__out":"Video__btn__play__video__out","Video__container":"Video__container","Video__wysiwyg-mb":"Video__wysiwyg-mb","size__standard":"size__standard","size__cinema":"size__cinema","Video__video__poster__youtube":"Video__video__poster__youtube","Video__modal":"Video__modal","is-open":"is-open","Video__modal__overlay":"Video__modal__overlay","Video__modal__btn__close":"Video__modal__btn__close","Video__modal__content":"Video__modal__content","Video__modal__content__inner":"Video__modal__content__inner","Video__modal__movie__block":"Video__modal__movie__block","Video__modal__movie":"Video__modal__movie","hasBackground":"hasBackground","oneColumnLayout":"oneColumnLayout","twoColumnLayout":"twoColumnLayout","threeColumnLayout":"threeColumnLayout","fourColumnLayout":"fourColumnLayout","Video__figure__img":"Video__figure__img","Video__figure__img-pc":"Video__figure__img-pc","Video__video-pc":"Video__video-pc","Video__wysiwyg-pc":"Video__wysiwyg-pc"};

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Promo":"Promo","Promo__link":"Promo__link","Promo__wrapper":"Promo__wrapper","Promo__image":"Promo__image","Promo__container":"Promo__container","Promo__image__block":"Promo__image__block","Promo__image-mb":"Promo__image-mb","Promo__wysiwyg-mb":"Promo__wysiwyg-mb","pcLayout__image-on-top":"pcLayout__image-on-top","Promo__text__block":"Promo__text__block","pcLayout__image-on-left-50_50":"pcLayout__image-on-left-50_50","pcLayout__image-on-right-50_50":"pcLayout__image-on-right-50_50","pcLayout__image-on-left-60_40":"pcLayout__image-on-left-60_40","pcLayout__image-on-right-40_60":"pcLayout__image-on-right-40_60","hasBackground":"hasBackground","oneColumnLayout":"oneColumnLayout","twoColumnLayout":"twoColumnLayout","threeColumnLayout":"threeColumnLayout","fourColumnLayout":"fourColumnLayout","Promo__image-pc":"Promo__image-pc","Promo__wysiwyg-pc":"Promo__wysiwyg-pc","mbLayout__image-on-top":"mbLayout__image-on-top","mbLayout__image-on-left-50_50":"mbLayout__image-on-left-50_50","Promo__wysiwyg":"Promo__wysiwyg","mbLayout__image-on-left-60_40":"mbLayout__image-on-left-60_40","mbLayout__image-on-right-50_50":"mbLayout__image-on-right-50_50","mbLayout__image-on-right-40_60":"mbLayout__image-on-right-40_60"};

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Wysiwyg":"Wysiwyg","vertical-align-middle":"vertical-align-middle","vertical-align-middle__container":"vertical-align-middle__container","vertical-align-bottom":"vertical-align-bottom","vertical-align-bottom__container":"vertical-align-bottom__container","column-layout":"column-layout","badge":"badge","font-size-1":"font-size-1","font-size-2":"font-size-2","font-size-3":"font-size-3","font-size-4":"font-size-4","font-size-5":"font-size-5","mazda-type-medium":"mazda-type-medium","mazda-type-bold":"mazda-type-bold","font-color-red":"font-color-red","font-color-white":"font-color-white","font-color-black":"font-color-black","font-color-gray":"font-color-gray","line-black":"line-black","line-white":"line-white","margin-top-0":"margin-top-0","margin-top-10":"margin-top-10","margin-top-20":"margin-top-20","margin-top-30":"margin-top-30","margin-top-40":"margin-top-40","margin-top-50":"margin-top-50","margin-top-60":"margin-top-60","margin-top-70":"margin-top-70","margin-top-80":"margin-top-80","margin-top-100":"margin-top-100","margin-top-160":"margin-top-160","margin-bottom-0":"margin-bottom-0","margin-bottom-10":"margin-bottom-10","margin-bottom-20":"margin-bottom-20","margin-bottom-30":"margin-bottom-30","margin-bottom-40":"margin-bottom-40","margin-bottom-50":"margin-bottom-50","margin-bottom-60":"margin-bottom-60","margin-bottom-70":"margin-bottom-70","margin-bottom-80":"margin-bottom-80","margin-bottom-100":"margin-bottom-100","margin-bottom-160":"margin-bottom-160","box-white":"box-white","box-gray":"box-gray","box-darkgray":"box-darkgray","box-black":"box-black","width-960":"width-960","link-black":"link-black","link-white":"link-white","link-inner":"link-inner","icon-next-black":"icon-next-black","icon-next-white":"icon-next-white","icon-prev-black":"icon-prev-black","icon-prev-white":"icon-prev-white","icon-pagetop-black":"icon-pagetop-black","icon-pagetop-white":"icon-pagetop-white","icon-anchor-black":"icon-anchor-black","icon-anchor-white":"icon-anchor-white","icon-external-black":"icon-external-black","icon-external-white":"icon-external-white","icon-pdf-black":"icon-pdf-black","icon-pdf-white":"icon-pdf-white","icon-download-black":"icon-download-black","icon-download-white":"icon-download-white","icon-document-black":"icon-document-black","icon-document-white":"icon-document-white","icon-tel-black":"icon-tel-black","icon-tel-white":"icon-tel-white","icon-info-black":"icon-info-black","icon-info-white":"icon-info-white","icon-login-black":"icon-login-black","icon-login-white":"icon-login-white","icon-estimate-black":"icon-estimate-black","icon-estimate-white":"icon-estimate-white","icon-catalog-black":"icon-catalog-black","icon-catalog-white":"icon-catalog-white","icon-testdrive-black":"icon-testdrive-black","icon-testdrive-white":"icon-testdrive-white","icon-dealer-black":"icon-dealer-black","icon-dealer-white":"icon-dealer-white","icon-mail-black":"icon-mail-black","icon-mail-white":"icon-mail-white","icon-compare-black":"icon-compare-black","icon-compare-white":"icon-compare-white","icon-voice-black":"icon-voice-black","icon-voice-white":"icon-voice-white","button-standard-white":"button-standard-white","button-standard-black":"button-standard-black","button-action-white":"button-action-white","button-action-black":"button-action-black","button-feature-white":"button-feature-white","button-feature-black":"button-feature-black","table-border-white":"table-border-white","table-border-black":"table-border-black","table-bg-white":"table-bg-white","table-bg-black":"table-bg-black","table-scroll-container":"table-scroll-container","more-info-black":"more-info-black","more-info-open":"more-info-open","more-info-open-btn":"more-info-open-btn","more-info-close-btn":"more-info-close-btn","more-info-detail":"more-info-detail","more-info-detail-opened":"more-info-detail-opened","more-info-white":"more-info-white","effect-hover":"effect-hover","mbLayout__horizontal":"mbLayout__horizontal","table-border-black-scroll":"table-border-black-scroll","table-border-white-scroll":"table-border-white-scroll","table-bg-black-scroll":"table-bg-black-scroll","table-bg-white-scroll":"table-bg-white-scroll","txt-indent-1":"txt-indent-1","txt-indent-2":"txt-indent-2"};

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OneColumnLayout":"OneColumnLayout","OneColumnLayout__resetUpperMargin":"OneColumnLayout__resetUpperMargin","OneColumnLayout__setLowerMargin":"OneColumnLayout__setLowerMargin","OneColumnLayout__nested":"OneColumnLayout__nested","OneColumnLayout__container":"OneColumnLayout__container","OneColumnLayout__column":"OneColumnLayout__column","size__divider":"size__divider","size__gutter":"size__gutter","size__vertical-padding":"size__vertical-padding","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","_modal-open":"_modal-open"};

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PromoAndButtonModalWindow":"PromoAndButtonModalWindow","PromoAndButtonModalWindow__list":"PromoAndButtonModalWindow__list","multiple":"multiple","PromoAndButtonModalWindow__box":"PromoAndButtonModalWindow__box","linkType__Button":"linkType__Button","Cta__button":"Cta__button","linkType__Button-With-Icon":"linkType__Button-With-Icon","withArrowIcon":"withArrowIcon","Cta__button__text":"Cta__button__text","linkType__Text":"linkType__Text","color__Dark":"color__Dark","color__Light":"color__Light","_linkType__Button":"_linkType__Button","buttonStyle__Standard":"buttonStyle__Standard","buttonStyle__Feature":"buttonStyle__Feature","buttonStyle__Action":"buttonStyle__Action","PromoAndButtonModalWindow-Promo":"PromoAndButtonModalWindow-Promo","PromoAndButtonModalWindow-Promo__link":"PromoAndButtonModalWindow-Promo__link","PromoAndButtonModalWindow-Promo__wrapper":"PromoAndButtonModalWindow-Promo__wrapper","PromoAndButtonModalWindow-Promo__image":"PromoAndButtonModalWindow-Promo__image","PromoAndButtonModalWindow-Promo__video":"PromoAndButtonModalWindow-Promo__video","PromoAndButtonModalWindow-Promo__container":"PromoAndButtonModalWindow-Promo__container","PromoAndButtonModalWindow-Promo__image__block":"PromoAndButtonModalWindow-Promo__image__block","opened":"opened","PromoAndButtonModalWindow-Promo__image__blank":"PromoAndButtonModalWindow-Promo__image__blank","PromoAndButtonModalWindow-Promo__image-mb":"PromoAndButtonModalWindow-Promo__image-mb","PromoAndButtonModalWindow-Promo__wysiwyg-mb":"PromoAndButtonModalWindow-Promo__wysiwyg-mb","deleteIcon":"deleteIcon","pcLayout__image-on-top":"pcLayout__image-on-top","PromoAndButtonModalWindow-Promo__text__block":"PromoAndButtonModalWindow-Promo__text__block","pcLayout__image-on-left-50_50":"pcLayout__image-on-left-50_50","PromoAndButtonModalWindow-Promo__video__block":"PromoAndButtonModalWindow-Promo__video__block","pcLayout__image-on-left-60_40":"pcLayout__image-on-left-60_40","hasBackground":"hasBackground","oneColumnLayout":"oneColumnLayout","twoColumnLayout":"twoColumnLayout","threeColumnLayout":"threeColumnLayout","fourColumnLayout":"fourColumnLayout","PromoAndButtonModalWindow-Promo__image-pc":"PromoAndButtonModalWindow-Promo__image-pc","PromoAndButtonModalWindow-Promo__wysiwyg-pc":"PromoAndButtonModalWindow-Promo__wysiwyg-pc","mbLayout__image-on-top":"mbLayout__image-on-top","mbLayout__image-on-left-50_50":"mbLayout__image-on-left-50_50","PromoAndButtonModalWindow-Promo__wysiwyg":"PromoAndButtonModalWindow-Promo__wysiwyg","mbLayout__image-on-left-60_40":"mbLayout__image-on-left-60_40","PromoAndButtonModalWindow-Cta":"PromoAndButtonModalWindow-Cta","PromoAndButtonModalWindow-Cta__container":"PromoAndButtonModalWindow-Cta__container","PromoAndButtonModalWindow-Cta__container--Dark":"PromoAndButtonModalWindow-Cta__container--Dark","PromoAndButtonModalWindow-Cta__button":"PromoAndButtonModalWindow-Cta__button","PromoAndButtonModalWindow-Cta__button--linkType--Button":"PromoAndButtonModalWindow-Cta__button--linkType--Button","PromoAndButtonModalWindow-Cta__button__text":"PromoAndButtonModalWindow-Cta__button__text","PromoAndButtonModalWindow-Cta__button__icon":"PromoAndButtonModalWindow-Cta__button__icon","PromoAndButtonModalWindow-Cta__button__icon--hover":"PromoAndButtonModalWindow-Cta__button__icon--hover","PromoAndButtonModalWindow-Cta__button--buttonStyle--Action":"PromoAndButtonModalWindow-Cta__button--buttonStyle--Action","PromoAndButtonModalWindow-Cta__button--linkType--Text":"PromoAndButtonModalWindow-Cta__button--linkType--Text","PromoAndButtonModalWindow-Cta__container--Light":"PromoAndButtonModalWindow-Cta__container--Light","PromoAndButtonModalWindow-Cta__button__icon__container":"PromoAndButtonModalWindow-Cta__button__icon__container","PromoAndButtonModalWindow-Modal":"PromoAndButtonModalWindow-Modal","PromoAndButtonModalWindow-Modal__rule":"PromoAndButtonModalWindow-Modal__rule","PromoAndButtonModalWindow-Modal__container":"PromoAndButtonModalWindow-Modal__container","PromoAndButtonModalWindow-Modal__container2":"PromoAndButtonModalWindow-Modal__container2","PromoAndButtonModalWindow-Modal__container3":"PromoAndButtonModalWindow-Modal__container3","PromoAndButtonModalWindow-Modal__link-close":"PromoAndButtonModalWindow-Modal__link-close","PromoAndButtonModalWindow-Modal__link-close2":"PromoAndButtonModalWindow-Modal__link-close2","PromoAndButtonModalWindow-Modal__link-close3":"PromoAndButtonModalWindow-Modal__link-close3","PromoAndButtonModalWindow-Modal__link-close4":"PromoAndButtonModalWindow-Modal__link-close4","PromoAndButtonModalWindow-Modal__link-close5":"PromoAndButtonModalWindow-Modal__link-close5","PromoAndButtonModalWindow-Modal__contents":"PromoAndButtonModalWindow-Modal__contents","isOpened":"isOpened","AccordionContainer":"AccordionContainer","Promo__text__block":"Promo__text__block"};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57965a383e0ccee658cb43c999603c42.png";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "912bd0fda664613609bead385f96fc11.png";

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TwoColumnLayout":"TwoColumnLayout","TwoColumnLayout__resetUpperMargin":"TwoColumnLayout__resetUpperMargin","TwoColumnLayout__setLowerMargin":"TwoColumnLayout__setLowerMargin","TwoColumnLayout__nested":"TwoColumnLayout__nested","TwoColumnLayout__container":"TwoColumnLayout__container","TwoColumnLayout__column":"TwoColumnLayout__column","size__full-width":"size__full-width","size__divider":"size__divider","size__vertical-padding":"size__vertical-padding","size__gutter":"size__gutter","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","_modal-open":"_modal-open","mbLayout__horizontal":"mbLayout__horizontal","mbLayout__vertical":"mbLayout__vertical","Video__link":"Video__link","Promo__wrapper":"Promo__wrapper","PromoAndButtonModalWindow-Promo__wrapper":"PromoAndButtonModalWindow-Promo__wrapper"};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ThreeColumnLayout":"ThreeColumnLayout","ThreeColumnLayout__resetUpperMargin":"ThreeColumnLayout__resetUpperMargin","ThreeColumnLayout__setLowerMargin":"ThreeColumnLayout__setLowerMargin","ThreeColumnLayout__nested":"ThreeColumnLayout__nested","ThreeColumnLayout__container":"ThreeColumnLayout__container","ThreeColumnLayout__column":"ThreeColumnLayout__column","size__full-width":"size__full-width","size__divider":"size__divider","size__vertical-padding":"size__vertical-padding","size__gutter":"size__gutter","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","_modal-open":"_modal-open","mbLayout__horizontal":"mbLayout__horizontal","mbLayout__vertical":"mbLayout__vertical","Video__link":"Video__link","Promo__wrapper":"Promo__wrapper","PromoAndButtonModalWindow-Promo__wrapper":"PromoAndButtonModalWindow-Promo__wrapper","mbLayout__two-line":"mbLayout__two-line"};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FourColumnLayout":"FourColumnLayout","FourColumnLayout__resetUpperMargin":"FourColumnLayout__resetUpperMargin","FourColumnLayout__setLowerMargin":"FourColumnLayout__setLowerMargin","FourColumnLayout__nested":"FourColumnLayout__nested","FourColumnLayout__container":"FourColumnLayout__container","FourColumnLayout__column":"FourColumnLayout__column","button-standard-white":"button-standard-white","button-standard-black":"button-standard-black","button-action-white":"button-action-white","button-action-black":"button-action-black","button-feature-white":"button-feature-white","button-feature-black":"button-feature-black","size__full-width":"size__full-width","size__divider":"size__divider","size__vertical-padding":"size__vertical-padding","size__gutter":"size__gutter","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","_modal-open":"_modal-open","mbLayout__horizontal":"mbLayout__horizontal","mbLayout__vertical":"mbLayout__vertical","Video__link":"Video__link","Promo__wrapper":"Promo__wrapper","PromoAndButtonModalWindow-Promo__wrapper":"PromoAndButtonModalWindow-Promo__wrapper","mbLayout__two-line":"mbLayout__two-line"};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Slideshow":"Slideshow","Compact_pc":"Compact_pc","Slideshow__carousel-item":"Slideshow__carousel-item","Medium_pc":"Medium_pc","Tall_pc":"Tall_pc","Extra-Tall_pc":"Extra-Tall_pc","Wide-Screen_pc":"Wide-Screen_pc","Slideshow__container":"Slideshow__container","Slideshow__description":"Slideshow__description","Center-Upper":"Center-Upper","Slideshow__description-inner2":"Slideshow__description-inner2","Center-Middle":"Center-Middle","Center-Lower":"Center-Lower","Left-Upper":"Left-Upper","Left-Middle":"Left-Middle","Left-Lower":"Left-Lower","Right-Upper":"Right-Upper","Right-Middle":"Right-Middle","Right-Lower":"Right-Lower","Slideshow__description-inner":"Slideshow__description-inner","Slideshow__description-pc":"Slideshow__description-pc","Slideshow__description-mb":"Slideshow__description-mb","Slideshow__carousel-item-inner_pc":"Slideshow__carousel-item-inner_pc","Slideshow__carousel-item-inner_mb":"Slideshow__carousel-item-inner_mb","Compact_mb":"Compact_mb","Medium_mb":"Medium_mb","Tall_mb":"Tall_mb","Extra-Tall_mb":"Extra-Tall_mb","Wide-Screen_mb":"Wide-Screen_mb","Slide":"Slide","slick-track":"slick-track"};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Presentation":"Presentation","Presentation__container":"Presentation__container","Presentation__description":"Presentation__description","Presentation__description-pc":"Presentation__description-pc","Presentation__description-mb":"Presentation__description-mb","Presentation__carousel":"Presentation__carousel","bulletsBelow":"bulletsBelow","slick-dots":"slick-dots","Presentation__carousel-item":"Presentation__carousel-item","Presentation__cta":"Presentation__cta","Presentation__pager":"Presentation__pager","Slide":"Slide","slick-list":"slick-list","slick-track":"slick-track","slick-prev":"slick-prev","slick-next":"slick-next","PhotoInfo__text":"PhotoInfo__text"};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PresentationItem":"PresentationItem","PresentationItem__description":"PresentationItem__description","PresentationItem__description-pc":"PresentationItem__description-pc","PresentationItem__description-mb":"PresentationItem__description-mb","PresentationItem__media":"PresentationItem__media","PresentationItem__image":"PresentationItem__image"};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ModalWindow":"ModalWindow","open":"open","dark":"dark","ModalWindow__link-close":"ModalWindow__link-close","light":"light"};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PhotogalleryItem":"PhotogalleryItem","PhotogalleryItem__link":"PhotogalleryItem__link","PhotogalleryItem__image":"PhotogalleryItem__image","PhotogalleryItem__video":"PhotogalleryItem__video","PhotogalleryItem__icon-open":"PhotogalleryItem__icon-open","PhotogalleryItem__icon-play":"PhotogalleryItem__icon-play","loaded":"loaded","mbTwoColumn":"mbTwoColumn","showLeft":"showLeft","showRight":"showRight"};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PhotogalleryLayout":"PhotogalleryLayout","PhotogalleryLayout__td":"PhotogalleryLayout__td","PhotogalleryLayout__td2":"PhotogalleryLayout__td2","PhotogalleryLayout__td3":"PhotogalleryLayout__td3","PhotogalleryLayout__td4":"PhotogalleryLayout__td4","PhotogalleryLayout__box":"PhotogalleryLayout__box","PhotogalleryLayout__box2":"PhotogalleryLayout__box2"};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79e674aa3331a119b733a1d1aabb4afe.png";

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Photogallery":"Photogallery","Photogallery__container":"Photogallery__container","deleteMarginOnPc":"deleteMarginOnPc","Photogallery__container__btn__more":"Photogallery__container__btn__more","Photogallery__modal":"Photogallery__modal","dark":"dark","light":"light","current":"current","fullSize":"fullSize","Photogallery__modal-container":"Photogallery__modal-container","Photogallery__modal-container-left-pc":"Photogallery__modal-container-left-pc","YoutubePlayer":"YoutubePlayer","Photogallery__modal-container-left-mb":"Photogallery__modal-container-left-mb","Photogallery__modal-container-right":"Photogallery__modal-container-right","imageOnTop":"imageOnTop","Photogallery__modal-inner":"Photogallery__modal-inner","imageOnLeft":"imageOnLeft","Photogallery__modal-description-pc":"Photogallery__modal-description-pc","Photogallery__modal-description-mb":"Photogallery__modal-description-mb","ModalWindow":"ModalWindow","open":"open","Slide":"Slide","ModalWindow__link-close":"ModalWindow__link-close","slick-next":"slick-next","slick-prev":"slick-prev","PhotoInfo":"PhotoInfo","PhotoInfo__container":"PhotoInfo__container","PhotoInfo__content":"PhotoInfo__content","PhotoInfo__btn__open__wrap":"PhotoInfo__btn__open__wrap","PhotoInfo__btn__open":"PhotoInfo__btn__open","Photogallery__modal-image":"Photogallery__modal-image","Photogallery__modal-image-cover":"Photogallery__modal-image-cover","Photogallery__modal-movie-wrapper":"Photogallery__modal-movie-wrapper","ModalWindow__container":"ModalWindow__container","slick-dots":"slick-dots"};

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SlidegalleryItem":"SlidegalleryItem","SlidegalleryItem__video-wrapper":"SlidegalleryItem__video-wrapper","YoutubePlayer":"YoutubePlayer","SlidegalleryItem__photo-info-wrapper":"SlidegalleryItem__photo-info-wrapper","SlidegalleryItem__image-wrapper":"SlidegalleryItem__image-wrapper","SlidegalleryItem__image-pc":"SlidegalleryItem__image-pc","SlidegalleryItem__image-mb":"SlidegalleryItem__image-mb","PhotoInfo":"PhotoInfo"};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Slidegallery":"Slidegallery","Slidegallery__main":"Slidegallery__main","Slide":"Slide","slick-list":"slick-list","slick-slide":"slick-slide","slick-current":"slick-current","slick-next":"slick-next","slick-prev":"slick-prev","slick-dots":"slick-dots","open":"open","noSlider":"noSlider","Slidegallery__dots":"Slidegallery__dots","Slidegallery__dots-link":"Slidegallery__dots-link","current":"current","Slidegallery__thumbnail":"Slidegallery__thumbnail","Slidegallery__thumbnail-link-close":"Slidegallery__thumbnail-link-close","Slidegallery__thumbnail-link-open":"Slidegallery__thumbnail-link-open","Slidegallery__thumbnail-container":"Slidegallery__thumbnail-container","Slidegallery__thumbnail-list":"Slidegallery__thumbnail-list","Slidegallery__thumbnail-item":"Slidegallery__thumbnail-item","Slidegallery__thumbnail-item-inner":"Slidegallery__thumbnail-item-inner","Slidegallery__thumbnail-container2":"Slidegallery__thumbnail-container2","movie":"movie","PhotoInfo__opened":"PhotoInfo__opened"};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TabNavigation":"TabNavigation","TabNavigation__container":"TabNavigation__container","TabNavigation__list":"TabNavigation__list","TabNavigation__list--1":"TabNavigation__list--1","TabNavigation__list--2":"TabNavigation__list--2","TabNavigation__list--3":"TabNavigation__list--3","TabNavigation__list--4":"TabNavigation__list--4","TabNavigation__list__item":"TabNavigation__list__item","TabNavigation__list__item__link":"TabNavigation__list__item__link","TabNavigation__list__item__link__text--pc":"TabNavigation__list__item__link__text--pc","TabNavigation__list__item__link__text--mb":"TabNavigation__list__item__link__text--mb","TabNavigation__list--5":"TabNavigation__list--5","TabNavigation__list--6":"TabNavigation__list--6","TabNavigation__list--7":"TabNavigation__list--7","TabNavigation__list--8":"TabNavigation__list--8","TabNavigation__list--9":"TabNavigation__list--9","TabNavigation__list--10":"TabNavigation__list--10","TabNavigation__container--Light":"TabNavigation__container--Light","TabNavigation__list__item--current":"TabNavigation__list__item--current","TabNavigation__container--Dark":"TabNavigation__container--Dark","TabNavigation__container--bottom":"TabNavigation__container--bottom","tabnavi_white-white":"tabnavi_white-white","tabnavi_gray-white":"tabnavi_gray-white","tabnavi_white-gray":"tabnavi_white-gray","tabnavi_gray-darkgray":"tabnavi_gray-darkgray"};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FeatureCategories":"FeatureCategories","slick-slide":"slick-slide","FeatureCategories__filter":"FeatureCategories__filter","FeatureCategories__filter__first__title__wrap":"FeatureCategories__filter__first__title__wrap","FeatureCategoryContainer__title":"FeatureCategoryContainer__title","FeatureCategoryContainer__title__selected":"FeatureCategoryContainer__title__selected","FeatureCategoryContainer__title__has_child":"FeatureCategoryContainer__title__has_child","FeatureCategories__filter__second-pc":"FeatureCategories__filter__second-pc","FeatureCategories__filter__second-mb":"FeatureCategories__filter__second-mb","FeatureCategories__FeatureCategoryContainer":"FeatureCategories__FeatureCategoryContainer","layout__horizontal":"layout__horizontal","FeatureCategoryContainer__content-pc":"FeatureCategoryContainer__content-pc","FeatureCategoryContainer__content__btn__more-pc":"FeatureCategoryContainer__content__btn__more-pc","layout__vertical":"layout__vertical","FeatureCategoryContainer__content__controls":"FeatureCategoryContainer__content__controls","FeatureCategoryContainer__content__pager__block":"FeatureCategoryContainer__content__pager__block","FeatureCategoryContainer__content__item__wrap":"FeatureCategoryContainer__content__item__wrap","FeatureCategoryContainer__content__item__wrap__current":"FeatureCategoryContainer__content__item__wrap__current","FeatureCategoryContainer__content__item":"FeatureCategoryContainer__content__item","selectTextColor__dark":"selectTextColor__dark","selectTextColor__light":"selectTextColor__light","Promo":"Promo","Video__article":"Video__article","Video__link":"Video__link","Video":"Video","hasBackground":"hasBackground","Video__container":"Video__container","Promo__text__block":"Promo__text__block","PromoAndButtonModalWindow-Promo":"PromoAndButtonModalWindow-Promo","PromoAndButtonModalWindow-Promo__text__block":"PromoAndButtonModalWindow-Promo__text__block","OneColumnLayout":"OneColumnLayout","size__divider":"size__divider","size__vertical-padding":"size__vertical-padding","size__gutter":"size__gutter","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","FeatureCategories__filter__first":"FeatureCategories__filter__first","FeatureCategories__filter__second__opened":"FeatureCategories__filter__second__opened","FeatureCategories__filter__second__heading__btn":"FeatureCategories__filter__second__heading__btn","FeatureCategories__filter__second__title__list":"FeatureCategories__filter__second__title__list","FeatureCategories__filter__second__heading__title__set":"FeatureCategories__filter__second__heading__title__set","FeatureCategories__filter__second__heading__btn__margin":"FeatureCategories__filter__second__heading__btn__margin","FeatureCategories__filter__second__title__wrap":"FeatureCategories__filter__second__title__wrap","FeatureCategories__filter__second__title__list__btn__close":"FeatureCategories__filter__second__title__list__btn__close","FeatureCategoryContainer__content__btn__more-mb":"FeatureCategoryContainer__content__btn__more-mb","FeatureCategoryContainer__content-mb":"FeatureCategoryContainer__content-mb","Promo__wrapper":"Promo__wrapper","PromoAndButtonModalWindow-Promo__wrapper":"PromoAndButtonModalWindow-Promo__wrapper"};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FeatureCategoryContainer":"FeatureCategoryContainer","slick-slider":"slick-slider","slick-track":"slick-track","slick-list":"slick-list","FeatureCategoryContainer__content-pc":"FeatureCategoryContainer__content-pc","not__carousel-pc":"not__carousel-pc","FeatureCategoryContainer__content__controls":"FeatureCategoryContainer__content__controls","FeatureCategoryContainer__content__pager__block":"FeatureCategoryContainer__content__pager__block","FeatureCategoryContainer__content__item__wrap":"FeatureCategoryContainer__content__item__wrap","FeatureCategoryContainer__content__item":"FeatureCategoryContainer__content__item","FeatureCategoryContainer__content__btn":"FeatureCategoryContainer__content__btn","FeatureCategoryContainer__content__btn__blink":"FeatureCategoryContainer__content__btn__blink","arrowBlink":"arrowBlink","FeatureCategoryContainer__content__prev":"FeatureCategoryContainer__content__prev","FeatureCategoryContainer__content__btn__clicked":"FeatureCategoryContainer__content__btn__clicked","arrowLeft":"arrowLeft","FeatureCategoryContainer__content__next":"FeatureCategoryContainer__content__next","arrowRight":"arrowRight","pager-fadeIn":"pager-fadeIn","FeatureCategoryContainer__content__pager":"FeatureCategoryContainer__content__pager","FeatureCategoryContainer__content__pager__dot":"FeatureCategoryContainer__content__pager__dot","is-active":"is-active","FeatureCategoryContainer__content__btn__more-pc":"FeatureCategoryContainer__content__btn__more-pc","FeatureCategoryContainer__content__btn__more__hide":"FeatureCategoryContainer__content__btn__more__hide","FeatureCategoryContainer__content-mb":"FeatureCategoryContainer__content-mb","FeatureCategoryContainer__slick-track__transition__none":"FeatureCategoryContainer__slick-track__transition__none","FeatureCategoryContainer__content__opacity_0":"FeatureCategoryContainer__content__opacity_0","filterChangeFade":"filterChangeFade","FeatureCategoryContainer__content__Horizontal":"FeatureCategoryContainer__content__Horizontal","FeatureCategoryContainer__no__slick__transition":"FeatureCategoryContainer__no__slick__transition","Promo":"Promo","pcLayout__image-on-top":"pcLayout__image-on-top","Promo__text__block":"Promo__text__block","not__carousel-mb":"not__carousel-mb","FeatureCategoryContainer__content__btn__more-mb":"FeatureCategoryContainer__content__btn__more-mb","FeatureCategoryContainer__content__mobile":"FeatureCategoryContainer__content__mobile"};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PickerContainer":"PickerContainer","slick-slider":"slick-slider","slick-track":"slick-track","PickerContainer__thumb__controls":"PickerContainer__thumb__controls","PickerContainer__thumb__btn":"PickerContainer__thumb__btn","PickerContainer__thumb__btn__blink":"PickerContainer__thumb__btn__blink","arrowBlink":"arrowBlink","PickerContainer__thumb__prev":"PickerContainer__thumb__prev","PickerContainer__thumb__btn__clicked":"PickerContainer__thumb__btn__clicked","arrowLeft":"arrowLeft","PickerContainer__thumb__next":"PickerContainer__thumb__next","arrowRight":"arrowRight","PickerContainer__thumb__container-pc":"PickerContainer__thumb__container-pc","PickerContainer__thumb__carousel":"PickerContainer__thumb__carousel","slick-initialized":"slick-initialized","slick-slide":"slick-slide","PickerContainer__thumb__item__wrap":"PickerContainer__thumb__item__wrap","PickerItem__thumb__item":"PickerItem__thumb__item","PickerContainer__thumb__container-mb":"PickerContainer__thumb__container-mb","PickerContainer__thumb__block":"PickerContainer__thumb__block","is-active":"is-active","PickerContainer__view":"PickerContainer__view","PickerContainer__slick-track__transition__none":"PickerContainer__slick-track__transition__none","OneColumnLayout":"OneColumnLayout","size__divider":"size__divider","size__vertical-padding":"size__vertical-padding","size__gutter":"size__gutter","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","PickerContainer__content__opacity_0":"PickerContainer__content__opacity_0","slick-list":"slick-list"};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PickerItem":"PickerItem","PickerItem__Description":"PickerItem__Description","PickerItem__mbDescription":"PickerItem__mbDescription","PickerItem__photo__block":"PickerItem__photo__block","PickerItem__photo__image":"PickerItem__photo__image","PickerItem__photo__image-mb":"PickerItem__photo__image-mb","PickerItem__pcDescription":"PickerItem__pcDescription","PickerItem__photo__image-pc":"PickerItem__photo__image-pc"};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Picker":"Picker","Picker__filter":"Picker__filter","Picker__filter__first__title__wrap":"Picker__filter__first__title__wrap","PickerContainer__title":"PickerContainer__title","PickerContainer__title__selected":"PickerContainer__title__selected","PickerContainer__title__has_child":"PickerContainer__title__has_child","Picker__filter__second-pc":"Picker__filter__second-pc","Picker__filter__second-mb":"Picker__filter__second-mb","Picker__cta":"Picker__cta","layout__article":"layout__article","PickerContainer__view":"PickerContainer__view","layout__full-width":"layout__full-width","textColor__dark":"textColor__dark","Picker__filter__line1":"Picker__filter__line1","Picker__filter__first":"Picker__filter__first","PickerContainer":"PickerContainer","PickerItem__thumb__item":"PickerItem__thumb__item","is-active":"is-active","PickerItem":"PickerItem","PickerItem__Description":"PickerItem__Description","textColor__light":"textColor__light","thumbnail__hide":"thumbnail__hide","PickerContainer__thumb__container-pc":"PickerContainer__thumb__container-pc","Picker__filter__second__opened":"Picker__filter__second__opened","Picker__filter__second__heading__btn":"Picker__filter__second__heading__btn","Picker__filter__second__title__list":"Picker__filter__second__title__list","Picker__filter__second__heading__title__set":"Picker__filter__second__heading__title__set","Picker__filter__second__heading__btn__margin":"Picker__filter__second__heading__btn__margin","Picker__filter__second__title__wrap":"Picker__filter__second__title__wrap","Picker__filter__second__title__list__btn__close":"Picker__filter__second__title__list__btn__close","Cta":"Cta","PickerContainer__thumb__container-mb":"PickerContainer__thumb__container-mb"};

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__(15);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\BodyTypeSelector.jsx';




var BodyTypeSelector = function BodyTypeSelector(_ref) {
  var bodyTypeInfo = _ref.bodyTypeInfo,
      currentBodyTypeId = _ref.currentBodyTypeId,
      changeBodyType = _ref.changeBodyType;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'ExteriorView__body-type-selector', __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: 'ExteriorView__body-type-selector__list', __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      },
      bodyTypeInfo.map(function (bodyType, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 15
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              // className={'ExteriorView__body-type-selector__link' + ((currentBodyTypeId === bodyType.carId) ? ' current': '')}
              className: 'ExteriorView__body-type-selector__link' + (Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["f" /* isEqualId */])(currentBodyTypeId, bodyType.carId) ? ' current' : ''),
              href: 'javascript:void(0)',
              onClick: function onClick(e) {
                e.preventDefault();
                if (changeBodyType) {
                  changeBodyType(bodyType.carId);

                  // ブロックのCookieに保存
                  Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["h" /* setCookie */])('mj_360bt', Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["b" /* formatId */])(bodyType.carId));
                  Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["g" /* removeCookie */])('mj_360gr');
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 16
              }
            },
            bodyType.tabName
          )
        );
      })
    )
  );
};
BodyTypeSelector.displayName = 'BodyTypeSelector';
BodyTypeSelector.propTypes = {
  bodyTypeInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    tabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  currentBodyTypeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeBodyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
BodyTypeSelector.defaultProps = {
  bodyTypeInfo: null,
  currentBodyTypeId: null,
  changeBodyType: null
};

/* harmony default export */ __webpack_exports__["a"] = (BodyTypeSelector);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__(15);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\GradeSelector.jsx';




var GradeSelector = function GradeSelector(_ref) {
  var open = _ref.open,
      gradeInfo = _ref.gradeInfo,
      currentGradeId = _ref.currentGradeId,
      changeGrade = _ref.changeGrade,
      openGradeSelector = _ref.openGradeSelector,
      closeGradeSelector = _ref.closeGradeSelector,
      contentHeight = _ref.contentHeight,
      currentBodyTypeId = _ref.currentBodyTypeId;


  // エンジン一覧
  var fuelArr = [];
  var i = void 0,
      max = void 0;
  for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
    var grade = gradeInfo[i];
    var flg = true;
    var j = void 0,
        max2 = void 0;
    for (j = 0, max2 = fuelArr.length; j < max2; j = j + 1) {
      if (grade.fuel === fuelArr[j]) {
        flg = false;
        break;
      }
    }
    if (flg) fuelArr.push(grade.fuel);
  }

  var getGradeName = function getGradeName(gradeInfo) {
    if (gradeInfo.specialCar === true) {
      return gradeInfo.gradeId;
    } else {
      return gradeInfo.gradeName && gradeInfo.gradeName !== '' ? gradeInfo.gradeName : gradeInfo.gradeId;
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'ExteriorView__grade-selector' + (open === true ? ' open' : ''), __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__grade-selector__container', __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        }
      },
      gradeInfo.map(function (grade, index) {
        // if (currentGradeId === grade.gradeId) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["f" /* isEqualId */])(currentGradeId, grade.gradeId)) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'ExteriorView__grade-selector__link-current' + (open === true ? ' open' : ''),
              href: 'javascript:void(0)',
              onClick: function onClick(e) {
                e.preventDefault();
                if (open === true) {
                  if (closeGradeSelector) closeGradeSelector();
                } else {
                  if (openGradeSelector) openGradeSelector();
                }
              },
              key: index,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 47
              }
            },
            getGradeName(grade)
          );
        } else {
          return null;
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__grade-selector__container2', __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ExteriorView__grade-selector__container3', __source: {
            fileName: _jsxFileName,
            lineNumber: 68
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'ExteriorView__grade-selector__link-close',
            href: 'javascript:void(0)',
            onClick: function onClick(e) {
              e.preventDefault();
              //
              if (closeGradeSelector) closeGradeSelector();
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            }
          },
          'CLOSE'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'ExteriorView__grade-selector__list-ul' + (3 <= fuelArr.length ? ' single-line' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 77
            }
          },
          fuelArr.map(function (fuel, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'ExteriorView__grade-selector__list-dl', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 81
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 82
                    }
                  },
                  fuel
                ),
                gradeInfo.map(function (grade, index) {
                  if (fuel === grade.fuel) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dd',
                      { key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 86
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        {
                          // className={'ExteriorView__grade-selector__link' + ((currentGradeId === grade.gradeId) ? ' current': '')}
                          className: 'ExteriorView__grade-selector__link' + (Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["f" /* isEqualId */])(currentGradeId, grade.gradeId) ? ' current' : ''),
                          href: '#' + grade.gradeId,
                          onClick: function onClick(e) {
                            e.preventDefault();
                            if (closeGradeSelector) closeGradeSelector();
                            if (changeGrade) {
                              changeGrade(grade.gradeId);

                              // ブロックのCookieに保存
                              Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["h" /* setCookie */])('mj_360bt', Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["b" /* formatId */])(currentBodyTypeId));
                              Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["h" /* setCookie */])('mj_360gr', Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["b" /* formatId */])(grade.gradeId));
                            }
                          },
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 87
                          }
                        },
                        getGradeName(grade)
                      )
                    );
                  } else {
                    return null;
                  }
                })
              )
            );
          })
        )
      )
    )
  );
};
GradeSelector.displayName = 'GradeSelector';
GradeSelector.propTypes = {
  gradeInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    fuel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  currentGradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeGrade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
GradeSelector.defaultProps = {
  gradeInfo: null,
  currentGradeId: null,
  changeGrade: null
};

/* harmony default export */ __webpack_exports__["a"] = (GradeSelector);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\ColorSelector.jsx';



var ColorSelector = function ColorSelector(_ref) {
  var colorInfo = _ref.colorInfo,
      currentColorId = _ref.currentColorId,
      changeColor = _ref.changeColor,
      showColorInfo = _ref.showColorInfo,
      hideColorInfo = _ref.hideColorInfo;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'ExteriorView__color-selector', __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: 'ExteriorView__color-selector__list', __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      colorInfo.map(function (color, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 16
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'ExteriorView__color-selector__link' + (currentColorId === color.code ? ' current' : ''),
              style: { backgroundColor: '#' + color.rgb },
              href: 'javascript:void(0)',
              onClick: function onClick(e) {
                e.preventDefault();
                if (changeColor) changeColor(color.code);
              },
              onMouseEnter: function onMouseEnter(e) {
                e.preventDefault();
                if (showColorInfo) showColorInfo(color.code);
              },
              onMouseLeave: function onMouseLeave(e) {
                e.preventDefault();
                if (hideColorInfo) hideColorInfo();
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 17
              }
            },
            color.name,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 34
              }
            })
          )
        );
      })
    )
  );
};
ColorSelector.displayName = 'ColorSelector';
ColorSelector.propTypes = {
  colorInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    rgb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  currentColorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  changeColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showColorInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideColorInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ColorSelector.defaultProps = {
  colorInfo: null,
  currentColorId: null,
  changeColor: null,
  showColorInfo: null,
  hideColorInfo: null
};

/* harmony default export */ __webpack_exports__["a"] = (ColorSelector);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\ColorInfo.jsx';




var ColorInfo = function ColorInfo(_ref) {
  var name = _ref.name,
      colorInformation = _ref.colorInformation,
      price = _ref.price,
      taxPrice = _ref.taxPrice;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'ExteriorView__color-info', __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'ExteriorView__color-info__paragraph', __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        }
      },
      name
    ),
    function () {
      if (!colorInformation || colorInformation === '') return null;
      if (null != price && '0' != price || null != taxPrice && '0' != taxPrice) {
        price = Number(price).toLocaleString();
        taxPrice = Number(taxPrice).toLocaleString();
        var text = colorInformation.replace(/{¥}/g, taxPrice).replace(/{¥¥}/g, price);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'ExteriorView__color-info__paragraph2',
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ExteriorView__color-info__paragraph2', __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        });
      }
    }()
  );
};
ColorInfo.displayName = 'ColorInfo';
ColorInfo.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorInformation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  taxPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
ColorInfo.defaultProps = {
  name: null,
  colorInformation: null,
  price: null,
  taxPrice: null
};

/* harmony default export */ __webpack_exports__["a"] = (ColorInfo);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\EstimateLink.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EstimateLink = (_temp = _class = function (_PureComponent) {
  _inherits(EstimateLink, _PureComponent);

  function EstimateLink(props) {
    _classCallCheck(this, EstimateLink);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.props = props;
    _this.state = {
      href: '/purchase/estimate/'
      // href: 'https://ssl.mazda.co.jp/sp/purchase/estimate/',
    };
    return _this;
  }

  EstimateLink.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__estimate', __source: {
          fileName: _jsxFileName,
          lineNumber: 45
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__blocks__["Cta"], _extends({
        ctaType: 'Free',
        href: this.state.href,
        text: 'このモデルの見積もりシミュレーション',
        targetBlank: false,
        linkType: 'Button',
        color: 'Light',
        buttonStyle: 'Standard'
      }, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        }
      }))
    );
  };

  EstimateLink.prototype.componentDidMount = function componentDidMount() {
    var href = '/purchase/estimate/';
    href = href + '?car_id=' + this.props.carId;
    href = href + '&car_type_code=' + this.props.carTypeCode;
    href = href + '&grade_code=' + this.props.gradeCode;
    href = href + '&aic=' + this.props.colorId;
    href = href + '&drive=' + this.props.drive;
    href = href + '&engine=' + this.props.engine;
    href = href + '&mission=' + this.props.mission;
    // ショップオプション
    var str = '';
    this.props.accessoryIdList.map(function (accessoryId, index) {
      str = str + accessoryId + ':';
    });
    if (str !== '') {
      href = href + '&soptions=' + str.slice(0, -1);
    }
    // 遷移画面
    if (this.props.estimationDisplay === 'Grade') {
      href = href + '&direct=id_contents_grade';
    } else if (this.props.estimationDisplay === 'Color-And-Sheet') {
      href = href + '&direct=id_contents_color';
    } else if (this.props.estimationDisplay === 'Maker-Set-Option') {
      href = href + '&direct=id_contents_maker';
    } else if (this.props.estimationDisplay === 'Shop-Option') {
      href = href + '&direct=id_contents_shop';
    } else if (this.props.estimationDisplay === 'Result') {
      href = href + '&direct=id_contents_estimate';
    }
    this.setState({
      href: href
    });
  };

  EstimateLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var href = '/purchase/estimate/';
    href = href + '?car_id=' + nextProps.carId;
    href = href + '&car_type_code=' + nextProps.carTypeCode;
    href = href + '&grade_code=' + nextProps.gradeCode;
    href = href + '&aic=' + nextProps.colorId;
    href = href + '&drive=' + nextProps.drive;
    href = href + '&engine=' + nextProps.engine;
    href = href + '&mission=' + nextProps.mission;

    // ショップオプション
    var str = '';
    nextProps.accessoryIdList.map(function (accessoryId, index) {
      str = str + accessoryId + ':';
    });
    if (str !== '') {
      href = href + '&soptions=' + str.slice(0, -1);
    }

    // 遷移画面
    if (nextProps.estimationDisplay === 'Grade') {
      href = href + '&direct=id_contents_grade';
    } else if (nextProps.estimationDisplay === 'Color-And-Sheet') {
      href = href + '&direct=id_contents_color';
    } else if (nextProps.estimationDisplay === 'Maker-Set-Option') {
      href = href + '&direct=id_contents_maker';
    } else if (nextProps.estimationDisplay === 'Shop-Option') {
      href = href + '&direct=id_contents_shop';
    } else if (nextProps.estimationDisplay === 'Result') {
      href = href + '&direct=id_contents_estimate';
    }

    this.setState({
      href: href
    });
  };

  return EstimateLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  estimationDisplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  engine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  drive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessoryIdList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}, _class.defaultProps = {
  carId: null,
  carTypeCode: null,
  estimationDisplay: null,
  gradeId: null,
  gradeCode: null,
  engine: null,
  drive: null,
  mission: null,
  colorId: null,
  accessoryIdList: null
}, _temp);
EstimateLink.displayName = 'EstimateLink';


/* harmony default export */ __webpack_exports__["a"] = (EstimateLink);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_exterior_view_accessories_index__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\AccessorySelector.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AccessorySelector = (_temp = _class = function (_Component) {
  _inherits(AccessorySelector, _Component);

  function AccessorySelector(props) {
    _classCallCheck(this, AccessorySelector);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      _this.setState({
        contentHeight: _this.refs.container2.offsetHeight
      });
    };

    _this.setAccessoryIndex = function (step, index, id) {
      //console.log('setAccessoryIndex: step=' + step + ', index=' + index);
      var arr = _this.state.selectedAccessoryIndexList;
      var arr2 = _this.state.selectedAccessoryIdList;
      arr[step] = index;
      arr2[step] = id;
      if (_this.props.children.length - 1 <= step || 4 <= step) {
        _this.setState({
          currentStep: 0,
          selectedAccessoryIndexList: arr,
          selectedAccessoryIdList: arr2
        });
        if (_this.props.closeAccessorySelector) _this.props.closeAccessorySelector();
        if (_this.props.changeAccessories) _this.props.changeAccessories(arr, arr2);
        //}
      } else {
        _this.setState({
          currentStep: step + 1,
          selectedAccessoryIndexList: arr,
          selectedAccessoryIdList: arr2
        });
      }
    };

    _this.clearAccessoryIndex = function () {
      _this.setState({
        currentStep: 0,
        selectedAccessoryIndexList: [],
        selectedAccessoryIdList: []
      });
      //if (this.props.closeAccessorySelector) this.props.closeAccessorySelector();
      //if (this.props.changeAccessories) this.props.changeAccessories([], []);
    };

    _this.goToStep = function (step) {
      var pastStep = _this.state.currentStep;
      _this.setState({
        currentStep: step,
        pastStep: pastStep
      });
    };

    _this.props = props;
    //
    _this.state = {
      selectedAccessoryIndexList: [],
      selectedAccessoryIdList: [],
      currentStep: 0,
      contentHeight: 0,
      pastStep: 0
    };
    return _this;
  }

  AccessorySelector.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        open = _props.open,
        accessoryLabel = _props.accessoryLabel,
        colorInfo = _props.colorInfo,
        currentColorId = _props.currentColorId,
        openAccessoryDetail = _props.openAccessoryDetail,
        closeAccessoryDetail = _props.closeAccessoryDetail,
        openAccessorySelector = _props.openAccessorySelector,
        _closeAccessorySelector = _props.closeAccessorySelector,
        changeAccessories = _props.changeAccessories,
        children = _props.children;

    //

    var rgb = 'transparent';
    var i = void 0,
        max = void 0;
    for (i = 0, max = colorInfo.length; i < max; i = i + 1) {
      var info = colorInfo[i];
      if (info.code === currentColorId) {
        rgb = info.rgb;
        break;
      }
    }
    //
    var stepCount = 0;
    var stepCount2 = 0;

    // ナビゲーション
    var renderNav = function renderNav() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'ExteriorView__accessory-selector__navigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 83
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'ExteriorView__accessory-selector__link-color' + (open === false ? ' current' : ''),
              href: 'javascript:void(0)',
              onClick: function onClick(e) {
                e.preventDefault();
                if (_closeAccessorySelector) _closeAccessorySelector();
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 84
              }
            },
            'BODY COLOR'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 94
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'ExteriorView__accessory-selector__link-accessory' + (open === true ? ' current' : ''),
              href: 'javascript:void(0)',
              onClick: function onClick(e) {
                e.preventDefault();
                if (open === true) {
                  if (_closeAccessorySelector) _closeAccessorySelector();
                } else {
                  if (openAccessorySelector) openAccessorySelector();
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 95
              }
            },
            'ACCESSORY'
          )
        )
      );
    };

    // ステップ
    var renderStep = function renderStep() {
      if (children && 2 <= children.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'ExteriorView__accessory-selector__list-step', __source: {
              fileName: _jsxFileName,
              lineNumber: 117
            }
          },
          children.map(function (child, index) {
            if (child.type.displayName === 'ExteriorViewAccessories') {
              if (4 <= stepCount2) return null;
              stepCount2 += 1;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: _this2.state.currentStep + 1 >= stepCount2 ? 'current' : '',
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 123
                  }
                },
                stepCount2
              );
            } else {
              return null;
            }
          })
        );
      } else {
        return null;
      }
    };

    // アクセサリー
    var renderAccessory = function renderAccessory() {
      if (children && 1 <= children.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ol',
          { className: 'ExteriorView__accessory-selector__list-accessory', __source: {
              fileName: _jsxFileName,
              lineNumber: 141
            }
          },
          children.map(function (child, index) {
            if (child.type.displayName === 'ExteriorViewAccessories') {
              if (4 <= stepCount) return null;
              var currentStep = stepCount;
              var accessoryIndex = null;
              if (currentStep <= _this2.state.selectedAccessoryIndexList.length - 1) accessoryIndex = _this2.state.selectedAccessoryIndexList[currentStep];
              stepCount += 1;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_exterior_view_accessories_index__["a" /* default */], _extends({}, child.props, {
                open: currentStep === _this2.state.currentStep ? true : false,
                isFirst: index <= 0 ? true : false,
                isLast: children.length - 1 <= index ? true : false,
                step: currentStep,
                selectedIndex: accessoryIndex,
                selectAccessoryIndex: function selectAccessoryIndex(step, index, id) {
                  _this2.setAccessoryIndex(step, index, id);
                },
                goToStep: function goToStep(step) {
                  _this2.goToStep(step);
                },
                closeAccessorySelector: function closeAccessorySelector() {
                  _closeAccessorySelector();
                },
                clearAccessoryIndex: function clearAccessoryIndex() {
                  _this2.clearAccessoryIndex();
                },
                isPrev: _this2.state.currentStep < _this2.state.pastStep ? true : false,
                key: index,
                accessoryLabel: accessoryLabel,
                openAccessoryDetail: openAccessoryDetail,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 150
                }
              }));
            } else {
              return null;
            }
          })
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__accessory-selector' + (open === true ? ' open' : '') + (!this.props.children || this.props.children.length <= 0 ? ' empty' : ''), __source: {
          fileName: _jsxFileName,
          lineNumber: 186
        }
      },
      renderNav(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ExteriorView__accessory-selector__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 190
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ExteriorView__accessory-selector__container2',
            ref: 'container2',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 191
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ExteriorView__accessory-selector__container3', __source: {
                fileName: _jsxFileName,
                lineNumber: 194
              }
            },
            renderStep()
          ),
          renderAccessory()
        )
      )
    );
  };

  AccessorySelector.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this3.handleResize();
    }, 500);
  };

  AccessorySelector.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  //


  return AccessorySelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accessoryLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    rgb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })),
  currentColorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  openAccessoryDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  closeAccessoryDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openAccessorySelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  closeAccessorySelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  changeAccessories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
}, _class.defaultProps = {
  open: null,
  accessoryLabel: null,
  colorInfo: null,
  currentColorId: null,
  openAccessoryDetail: null,
  closeAccessoryDetail: null,
  openAccessorySelector: null,
  closeAccessorySelector: null,
  changeAccessories: null,
  children: null
}, _temp);
AccessorySelector.displayName = 'AccessorySelector';


/* harmony default export */ __webpack_exports__["a"] = (AccessorySelector);

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ExteriorViewAccessories":"ExteriorViewAccessories","open":"open","ExteriorViewAccessories__list":"ExteriorViewAccessories__list","prev":"prev","ExteriorViewAccessories__prev":"ExteriorViewAccessories__prev","next":"next","ExteriorViewAccessories__next":"ExteriorViewAccessories__next","ExteriorViewAccessories__container":"ExteriorViewAccessories__container","ExteriorViewAccessories__description":"ExteriorViewAccessories__description","ExteriorViewAccessories__information":"ExteriorViewAccessories__information","ExteriorViewAccessories__list-nav":"ExteriorViewAccessories__list-nav","ExteriorViewAccessories__paragraph":"ExteriorViewAccessories__paragraph","ExteriorViewAccessories__link":"ExteriorViewAccessories__link","unselected":"unselected","selected":"selected","ExteriorViewAccessories__image-wrapper":"ExteriorViewAccessories__image-wrapper","ExteriorViewAccessories__image-wrapper2":"ExteriorViewAccessories__image-wrapper2","ExteriorViewAccessories__link-close":"ExteriorViewAccessories__link-close","ExteriorViewAccessories__link-prev":"ExteriorViewAccessories__link-prev","ExteriorViewAccessories__link-next":"ExteriorViewAccessories__link-next","active":"active","ExteriorViewAccessories__link-clear":"ExteriorViewAccessories__link-clear","ExteriorViewAccessories__link-detail":"ExteriorViewAccessories__link-detail","ExteriorViewAccessories__image":"ExteriorViewAccessories__image"};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3616baddaf8897ababd96245d85b7692.png";

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\exterior-view\\Viewer.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Viewer = (_temp = _class = function (_PureComponent) {
  _inherits(Viewer, _PureComponent);

  //static DEFAULT_ANGLE = 270;

  function Viewer(props) {
    _classCallCheck(this, Viewer);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.touchStartHandler = function (e) {
      _this.startX = e.changedTouches[0].clientX;
      _this.startY = e.changedTouches[0].clientY;
      _this.isFirst = true;
      _this.refs.viewer.classList.add('start');
      _this.refs.viewer.classList.add('mouse-move');
      //
      //this.refs.canvas.addEventListener('touchmove', this.touchMoveHandler, {passive: false});
      _this.refs.canvas.addEventListener('touchmove', _this.touchMoveHandler);
      _this.refs.canvas.addEventListener('touchend', _this.touchEndHandler, { passive: true });
    };

    _this.touchMoveHandler = function (e) {
      var clientX = e.changedTouches[0].clientX;
      var clientY = e.changedTouches[0].clientY;
      if (_this.isFirst) {
        _this.isFirst = false;
        var rot = Math.atan2(_this.startY - clientY, _this.startX - clientX) * 180 / Math.PI;
        if (60 <= rot && rot <= 120 || -120 <= rot && rot <= -60) {
          _this.refs.canvas.removeEventListener('touchmove', _this.touchMoveHandler);
          _this.refs.canvas.removeEventListener('touchend', _this.touchEndHandler);
          return;
        }
      }

      // ローディング中はドラッグ出来なくする
      if (_this.state.loading === true) return;

      //e.preventDefault();
      _this.moveX = clientX - _this.startX;
      _this.drawImage(_this.formatAngle(_this.moveX + _this.angle));
    };

    _this.touchEndHandler = function (e) {
      _this.angle = _this.formatAngle(_this.moveX + _this.angle);
      _this.refs.canvas.removeEventListener('touchmove', _this.touchMoveHandler);
      _this.refs.canvas.removeEventListener('touchend', _this.touchEndHandler);
    };

    _this.mouseDownHandler = function (clientX) {
      _this.startX = clientX;
      _this.onRotate = true;
      _this.refs.viewer.classList.add('start');
      _this.refs.viewer.classList.add('mouse-move');
    };

    _this.mouseMoveHandler = function (clientX) {
      if (!_this.onRotate) return;

      // ローディング中はドラッグ出来なくする
      if (_this.state.loading === true) return;

      _this.moveX = clientX - _this.startX;
      _this.drawImage(_this.formatAngle(_this.moveX / Viewer.ROTATION_SPEED + _this.angle));
    };

    _this.mouseUpHandler = function () {
      _this.angle = _this.formatAngle(_this.moveX / Viewer.ROTATION_SPEED + _this.angle);
      _this.onRotate = false;
    };

    _this.preLoadImages = function () {
      // console.log('preLoadImages');
      // console.log('angle', this.angle);
      // Canvasクリア
      _this.clearImage();
      // 要素削除
      while (_this.refs.stocker.firstChild) {
        _this.refs.stocker.removeChild(_this.refs.stocker.firstChild);
      } //
      var directory = _this.getDirectory();
      // 1枚目ローディング
      var img = new Image();
      img.onload = function () {
        _this.refs.stocker.appendChild(img);
        // console.log('loaded', img);
        setTimeout(function () {
          _this.drawImage(_this.angle);
          _this.refs.viewer.classList.remove('pre-loading');
          _this.refs.viewer.classList.add('stand-by');
          setTimeout(function () {
            // 2枚目以降読み込み開始
            _this.loadImages();
          }, 500);
        }, 500);
      };
      img.src = directory + _this.getAngleToImageName(_this.angle);
    };

    _this.loadImages = function () {
      // console.log('loadImages');
      _this.refs.viewer.classList.remove('stand-by');
      _this.refs.viewer.classList.add('loading');
      // 要素削除
      while (_this.refs.stocker.firstChild) {
        _this.refs.stocker.removeChild(_this.refs.stocker.firstChild);
      } //
      var directory = _this.getDirectory();
      var loadedCount = 0;
      var count = 0;
      var i = void 0,
          max = void 0;

      var _loop = function _loop() {
        var img = new Image();
        img.onload = function () {
          _this.refs.stocker.appendChild(img);
          loadedCount += 1;
          // console.log('loadedCount', loadedCount);
          if (Viewer.ROTATION_IMAGE_NUM <= loadedCount) {
            // console.log('complete');
            setTimeout(function () {
              _this.drawImage(_this.angle);
              _this.refs.viewer.classList.remove('loading');
              _this.refs.viewer.classList.remove('mouse-move');
              if (_this.state.loading === true) {
                _this.setState({
                  loading: false
                });
              }
            }, 500);
          }
        };
        setTimeout(function () {
          img.src = directory + _this.getAngleToImageName(count * (360 / Viewer.ROTATION_IMAGE_NUM));
          count += 1;
        }, 50 * i);
      };

      for (i = 0, max = Viewer.ROTATION_IMAGE_NUM; i < max; i = i + 1) {
        _loop();
      }
    };

    _this.drawImage = function (angle) {
      // console.log('drawImage', angle);
      var src = _this.getDirectory() + _this.getAngleToImageName(angle);
      if (src === _this.src) return;
      _this.src = src;
      var img = new Image();
      var ctx = _this.refs.canvas.getContext('2d');
      img.onload = function () {
        ctx.clearRect(0, 0, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT);
        //ctx.drawImage(img, 0, 0);
        ctx.drawImage(img, 0, -50, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT + 50);
      };
      img.src = src;
    };

    _this.clearImage = function () {
      var ctx = _this.refs.canvas.getContext('2d');
      ctx.clearRect(0, 0, Viewer.CANVAS_WIDTH, Viewer.CANVAS_HEIGHT);
    };

    _this.getDirectory = function () {
      var arr = [];
      if (_this.props.accessoryIndexList && _this.props.accessoryIndexList !== '') {
        arr = _this.props.accessoryIndexList.split(',');
      }
      //let str = '/globalassets/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + this.props.gradeId + '/360/';
      //let str = '/assets-dev/assets/cars/' + this.props.modelId + '/' + this.props.bodyTypeId + '/' + this.props.generationId + '/' + this.props.gradeId + '/360/';
      var str = null;
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/' + _this.props.modelId + '/' + _this.props.bodyTypeId + '/' + _this.props.generationId + '/' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(_this.props.gradeId) + '/360/';
      } else {
        str = '/globalassets/assets/cars/' + _this.props.modelId + '/' + _this.props.bodyTypeId + '/' + _this.props.generationId + '/' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(_this.props.gradeId) + '/360/';
      }
      if (arr && Array.isArray(arr) && 1 <= arr.length) {
        str = str + 'accessories/' + _this.props.colorId + '/';
        var i = void 0,
            max = void 0;
        for (i = 0, max = arr.length; i < max; i = i + 1) {
          if (i === 0) {
            str = str + 'a' + (Number(arr[i]) + 1);
          } else if (i === 1) {
            str = str + 'b' + (Number(arr[i]) + 1);
          } else if (i === 2) {
            str = str + 'c' + (Number(arr[i]) + 1);
          } else if (i === 3) {
            str = str + 'd' + (Number(arr[i]) + 1);
          }
        }
        str = str + '/';
      } else {
        str = str + 'cars/' + _this.props.colorId + '/';
      }
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
    };

    _this.formatAngle = function (angle) {
      angle = angle % 360;
      if (angle < 0) {
        angle = 360 + angle;
      }
      return angle;
    };

    _this.getAngleToImageName = function (angle) {
      angle = angle % 360;
      if (angle < 0) {
        angle = 360 + angle;
      }
      var count = Math.floor(angle / (360 / Viewer.ROTATION_IMAGE_NUM));
      return 'l_' + (Array(4).join('0') + count).slice(-4) + '.png';
    };

    _this.props = props;
    //
    _this.onRotate = false;
    _this.angle = Viewer.DEFAULT_ANGLE;
    _this.startX = 0;
    _this.startY = 0;
    _this.moveX = 0;
    _this.isFirst = false;
    _this.src = null;
    _this.state = {
      loading: false
    };
    //
    _this.intervalId = null;
    _this.intervalId2 = null;
    //this.isFirstLoaded = true;
    return _this;
  }
  // static CANVAS_HEIGHT = 600;


  Viewer.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        modelId = _props.modelId,
        bodyTypeId = _props.bodyTypeId,
        generationId = _props.generationId,
        gradeId = _props.gradeId,
        colorId = _props.colorId,
        accessoryIndexList = _props.accessoryIndexList;
    //
    //this.traceProps();

    this.startX = 0;
    this.moveX = 0;
    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__viewer', ref: 'viewer', __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
        className: 'ExteriorView__viewer__canvas',
        width: Viewer.CANVAS_WIDTH,
        height: Viewer.CANVAS_HEIGHT,
        ref: 'canvas',
        onMouseDown: function onMouseDown(e) {
          _this2.mouseDownHandler(e.clientX);
          _this2.refs.canvas.classList.add('press');
        },
        onMouseMove: function onMouseMove(e) {
          _this2.mouseMoveHandler(e.clientX);
        },
        onMouseUp: function onMouseUp(e) {
          _this2.mouseUpHandler();
          _this2.refs.canvas.classList.remove('press');
        },
        onMouseLeave: function onMouseLeave(e) {
          if (_this2.onRotate) {
            _this2.mouseUpHandler();
            _this2.refs.canvas.classList.remove('press');
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { display: 'none' }, ref: 'stocker', __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Preloader, { loading: this.state.loading, __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ExteriorView__viewer__attention', __source: {
            fileName: _jsxFileName,
            lineNumber: 93
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 94
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 94
            }
          }),
          '360\xB0View'
        )
      )
    );
  };

  Viewer.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    // console.log('componentDidMount');
    this.refs.viewer.classList.add('pre-loading');
    this.refs.viewer.classList.remove('mouse-move');
    // this.refs.viewer.classList.add('loading');
    if (this.state.loading === false) {
      this.setState({
        loading: true
      });
    }
    //
    if (this.intervalId2) clearInterval(this.intervalId2);
    this.intervalId2 = setTimeout(function () {
      _this3.preLoadImages();
      // this.loadImages();
    }, 500);
    //
    if (__WEBPACK_IMPORTED_MODULE_2__constants_environment__["b" /* HAS_TOUCH */]) {
      this.refs.canvas.addEventListener('touchstart', this.touchStartHandler, { passive: true });
    }
  };

  Viewer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // this.props = nextProps;
  };

  Viewer.prototype.componentWillUpdate = function componentWillUpdate(prevProps, prevState) {
    // console.log('componentWillUpdate', this.props, prevProps);
    if (JSON.stringify(prevProps) === JSON.stringify(this.props)) return;
    // if (JSON.stringify(prevProps) == JSON.stringify(prevState)) return;
    this.refs.viewer.classList.add('pre-loading');
    this.refs.viewer.classList.remove('mouse-move');
    // this.refs.viewer.classList.add('loading');
    if (this.state.loading === false) {
      this.setState({
        loading: true
      });
    }
    //
    if (this.intervalId2) clearInterval(this.intervalId2);
    this.preLoadImages();
    // this.loadImages();
  };

  return Viewer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = {
  modelId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  generationId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accessoryIndexList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  modelId: null,
  bodyTypeId: null,
  generationId: null,
  gradeId: null,
  colorId: null,
  accessoryIndexList: null
}, _class.CANVAS_WIDTH = 1300, _class.CANVAS_HEIGHT = 550, _class.ROTATION_SPEED = 3, _class.ROTATION_IMAGE_NUM = 24, _class.DEFAULT_ANGLE = 60, _temp);
Viewer.displayName = 'Viewer';


/* harmony default export */ __webpack_exports__["a"] = (Viewer);

var Preloader = (_temp2 = _class2 = function (_PureComponent2) {
  _inherits(Preloader, _PureComponent2);

  function Preloader(props) {
    _classCallCheck(this, Preloader);

    var _this4 = _possibleConstructorReturn(this, _PureComponent2.call(this));

    _this4.initAnimation = function () {
      _this4.currentFrame = 0;
      _this4.setState({
        top: 0,
        left: 0
      });
    };

    _this4.startAnimation = function () {
      _this4.intervalId = setInterval(function () {
        _this4.setState({
          top: -Math.floor(_this4.currentFrame / Preloader.ROW_MAX) * Preloader.IMAGE_HEIGHT,
          left: -(_this4.currentFrame % Preloader.ROW_MAX) * Preloader.IMAGE_WIDTH
        });
        //
        _this4.currentFrame = _this4.currentFrame + 1;
        if (Preloader.TOTAL_FRAMES <= _this4.currentFrame) {
          _this4.currentFrame = 0;
        }
      }, 1000 / 30);
    };

    _this4.stopAnimation = function () {
      if (_this4.intervalId) clearInterval(_this4.intervalId);
    };

    _this4.props = props;
    _this4.intervalId = null;
    _this4.currentFrame = 0;
    _this4.state = {
      top: 0,
      left: 0,
      loading: false
    };
    return _this4;
  }

  Preloader.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'ExteriorView__viewer__preloader', __source: {
          fileName: _jsxFileName,
          lineNumber: 367
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 368
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { backgroundPosition: this.state.left + 'px ' + this.state.top + 'px' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 369
          }
        })
      )
    );
  };

  Preloader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.loading === nextProps.loading) return;
    this.setState({
      loading: nextProps.loading
    });
    if (nextProps.loading === true) {
      this.stopAnimation();
      this.initAnimation();
      this.startAnimation();
    }
  };

  Preloader.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopAnimation();
  };

  return Preloader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class2.IMAGE_WIDTH = 150, _class2.IMAGE_HEIGHT = 150, _class2.ROW_MAX = 6, _class2.TOTAL_FRAMES = 40, _temp2);
Preloader.displayName = 'Preloader';

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ExteriorView":"ExteriorView","ExteriorView__container":"ExteriorView__container","ExteriorView__container2":"ExteriorView__container2","ExteriorView__container3":"ExteriorView__container3","ExteriorView__heading":"ExteriorView__heading","ExteriorView__navigation":"ExteriorView__navigation","ExteriorView__navigation__paragraph":"ExteriorView__navigation__paragraph","ExteriorView__body-type-selector":"ExteriorView__body-type-selector","ExteriorView__body-type-selector__list":"ExteriorView__body-type-selector__list","ExteriorView__body-type-selector__link":"ExteriorView__body-type-selector__link","current":"current","ExteriorView__grade-selector":"ExteriorView__grade-selector","open":"open","ExteriorView__grade-selector__container2":"ExteriorView__grade-selector__container2","ExteriorView__grade-selector__container":"ExteriorView__grade-selector__container","ExteriorView__grade-selector__container3":"ExteriorView__grade-selector__container3","ExteriorView__grade-selector__link-close":"ExteriorView__grade-selector__link-close","ExteriorView__grade-selector__link-current":"ExteriorView__grade-selector__link-current","ExteriorView__grade-selector__list-ul":"ExteriorView__grade-selector__list-ul","ExteriorView__grade-selector__list-dl":"ExteriorView__grade-selector__list-dl","ExteriorView__grade-selector__link":"ExteriorView__grade-selector__link","ExteriorView__viewer":"ExteriorView__viewer","pre-loading":"pre-loading","ExteriorView__viewer__canvas":"ExteriorView__viewer__canvas","ExteriorView__viewer__preloader":"ExteriorView__viewer__preloader","_ExteriorView__viewer__preloader":"_ExteriorView__viewer__preloader","stand-by":"stand-by","loading":"loading","mouse-move":"mouse-move","start":"start","ExteriorView__viewer__attention":"ExteriorView__viewer__attention","press":"press","spin":"spin","ExteriorView__spin":"ExteriorView__spin","ExteriorView__spin2":"ExteriorView__spin2","ExteriorView__viewer__images":"ExteriorView__viewer__images","ExteriorView__color-selector":"ExteriorView__color-selector","ExteriorView__color-selector__list":"ExteriorView__color-selector__list","ExteriorView__color-selector__link":"ExteriorView__color-selector__link","ExteriorView__color-info":"ExteriorView__color-info","ExteriorView__color-info__paragraph":"ExteriorView__color-info__paragraph","ExteriorView__color-info__paragraph2":"ExteriorView__color-info__paragraph2","ExteriorView__estimate":"ExteriorView__estimate","ExteriorView__estimate-link":"ExteriorView__estimate-link","ExteriorView__description":"ExteriorView__description","ExteriorView__accessory-selector":"ExteriorView__accessory-selector","ExteriorView__accessory-selector__container":"ExteriorView__accessory-selector__container","empty":"empty","ExteriorView__accessory-selector__navigation":"ExteriorView__accessory-selector__navigation","ExteriorView__accessory-selector__link-color":"ExteriorView__accessory-selector__link-color","ExteriorView__accessory-selector__container2":"ExteriorView__accessory-selector__container2","ExteriorView__accessory-selector__container3":"ExteriorView__accessory-selector__container3","ExteriorView__accessory-selector__link-color-icon":"ExteriorView__accessory-selector__link-color-icon","ExteriorView__accessory-selector__link-accessory":"ExteriorView__accessory-selector__link-accessory","ExteriorView__accessory-selector__list-accessory":"ExteriorView__accessory-selector__list-accessory","ExteriorView__accessory-selector__list-step":"ExteriorView__accessory-selector__list-step","ExteriorView__overlay":"ExteriorView__overlay","ExteriorView__accessory-detail":"ExteriorView__accessory-detail","ModalWindow":"ModalWindow","ModalWindow__link-close":"ModalWindow__link-close","dataViewer":"dataViewer","ExteriorView__link-close":"ExteriorView__link-close","single-line":"single-line","Cta__button--linkType--Button":"Cta__button--linkType--Button"};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PromoSlider":"PromoSlider","PromoSlider__item":"PromoSlider__item","slick-slide":"slick-slide","slick-prev":"slick-prev","slick-next":"slick-next","slick-dots":"slick-dots"};

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scroll_loader__ = __webpack_require__(25);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\body-size\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  BodySize
 */
var BodySize = (_temp = _class = function (_Component) {
  _inherits(BodySize, _Component);

  function BodySize(props) {
    _classCallCheck(this, BodySize);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    _this.state = {
      isMounted: false
    };
    return _this;
  }

  BodySize.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  BodySize.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  BodySize.prototype.render = function render() {
    var _this2 = this;

    // タイトル・詳細
    var renderDescription = function renderDescription() {
      var getPcDescription = function getPcDescription() {
        if (_this2.props.description && _this2.props.description !== '') {
          return _this2.props.description;
        } else {
          return '';
        }
      };
      var getMbDescription = function getMbDescription() {
        if (_this2.props.mbDescription && _this2.props.mbDescription !== '') {
          return _this2.props.mbDescription;
        } else {
          return getPcDescription();
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'BodySize__description', __source: {
            fileName: _jsxFileName,
            lineNumber: 99
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'BodySize__description__text-pc Wysiwyg',
          dangerouslySetInnerHTML: { __html: getPcDescription() !== null ? getPcDescription() : '' },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 100
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'BodySize__description__text-mb Wysiwyg',
          dangerouslySetInnerHTML: { __html: getMbDescription() !== null ? getMbDescription() : '' },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          }
        })
      );
    };

    // 画像
    var renderImage = function renderImage() {
      var getImageDirectory = function getImageDirectory() {
        var modelName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var bodyTypeModel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var carTypeCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var gradeId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        if (modelName && bodyTypeModel && carTypeCode && gradeId) {
          var str = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            str = '/assets-dev/assets/cars/';
          } else {
            str = '/globalassets/assets/cars/';
          }
          str = str + modelName + '/';
          str = str + bodyTypeModel + '/';
          str = str + carTypeCode + '/';
          //str = str + gradeId + '/';
          str = str + 'common/';
          str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          return str;
        } else {
          return null;
        }
      };
      if (_this2.state.isMounted === true) {
        var imageDirectory = getImageDirectory(_this2.props.modelName, _this2.props.bodyTypeModel, _this2.props.carTypeCode, _this2.props.gradeId);
        if (imageDirectory) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'BodySize__image', __source: {
                fileName: _jsxFileName,
                lineNumber: 135
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'BodySize__image__image-pc',
              src: imageDirectory + 'bodysize_pc.png',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'BodySize__image__image-mb',
              src: imageDirectory + 'bodysize_mb.png',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 139
              }
            })
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    };

    // 注釈
    var renderNotice = function renderNotice() {
      if (_this2.props.notice && _this2.props.notice !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'BodySize__notice Wysiwyg',
          dangerouslySetInnerHTML: { __html: _this2.props.notice !== null ? _this2.props.notice : '' },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 156
          }
        });
      } else {
        return null;
      }
    };

    // モデル名称
    // const renderModelName = ()=> {
    //   if (this.props.modelName && this.props.modelName !== '') {
    //     return (
    //       <div className="BodySize__model-name">{this.props.modelName}</div>
    //     )
    //   } else {
    //     return null;
    //   }
    // };

    // スペック詳細
    var renderSpecSummary = function renderSpecSummary() {
      var getSpecText = function getSpecText(min, max) {
        if (min && min !== '' && max && max !== '') {
          if (min === max) {
            return Number(min).toLocaleString();
          } else {
            return Number(min).toLocaleString() + '〜' + Number(max).toLocaleString();
          }
        } else if (min && min !== '') {
          return Number(min).toLocaleString();
        } else if (max && max !== '') {
          return Number(max).toLocaleString();
        } else {
          return null;
        }
      };

      var getPassengersText = function getPassengersText(arr) {
        if (arr && arr instanceof Array && 1 <= arr.length) {
          if (arr.length === 1) {
            return arr[0];
          } else {
            return arr.join(' | ');
          }
        } else {
          return null;
        }
      };

      //
      if (_this2.props.specSummary && _this2.props.specSummary !== '') {
        var length = getSpecText(_this2.props.specSummary.minLength, _this2.props.specSummary.maxLength);
        var width = getSpecText(_this2.props.specSummary.minWidth, _this2.props.specSummary.maxWidth);
        var height = getSpecText(_this2.props.specSummary.minHeight, _this2.props.specSummary.maxHeight);
        var wheelBase = getSpecText(_this2.props.specSummary.wheelBase);
        var passengers = getPassengersText(_this2.props.specSummary.passengers);
        var weight = getSpecText(_this2.props.specSummary.minWeight, _this2.props.specSummary.maxWeight);
        var thStyle = { textAlign: 'left', padding: '10px' };
        var tdStyle = { textAlign: 'left', color: '#101010', padding: '10px' };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 217
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { style: { width: '100%' }, border: '0', __source: {
                fileName: _jsxFileName,
                lineNumber: 218
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 219
                }
              },
              length && length !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 221
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 222
                    }
                  },
                  '\u5168\u9577(mm)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 223
                    }
                  },
                  length
                )
              ) : null,
              width && width !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 227
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 228
                    }
                  },
                  '\u5168\u5E45(mm)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 229
                    }
                  },
                  width
                )
              ) : null,
              height && height !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 233
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 234
                    }
                  },
                  '\u5168\u9AD8(mm)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 235
                    }
                  },
                  height
                )
              ) : null,
              wheelBase && wheelBase !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 239
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 240
                    }
                  },
                  '\u30DB\u30A4\u30FC\u30EB\u30D9\u30FC\u30B9(mm)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 241
                    }
                  },
                  wheelBase
                )
              ) : null,
              passengers && passengers !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 245
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 246
                    }
                  },
                  '\u4E57\u8ECA\u5B9A\u54E1(\u540D)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 247
                    }
                  },
                  passengers
                )
              ) : null,
              weight && weight !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 251
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 252
                    }
                  },
                  '\u8ECA\u4E21\u91CD\u91CF(kg)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 253
                    }
                  },
                  weight
                )
              ) : null,
              _this2.props.specSummary.tireSizes && _this2.props.specSummary.tireSizes !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 257
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: thStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 258
                    }
                  },
                  '\u30BF\u30A4\u30E4\u30B5\u30A4\u30BA'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: tdStyle, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 259
                    }
                  },
                  _this2.props.specSummary.tireSizes.map(function (size, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 262
                        }
                      },
                      size
                    );
                  })
                )
              ) : null
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'BodySize__spec-summary Wysiwyg',
          dangerouslySetInnerHTML: { __html: _this2.props.bodySize !== null ? _this2.props.bodySize : '' },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 274
          }
        });
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 282
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_scroll_loader__["a" /* default */],
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 288
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'BodySize', __source: {
              fileName: _jsxFileName,
              lineNumber: 289
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'BodySize__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 290
              }
            },
            renderDescription(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'BodySize__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 296
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'BodySize__box-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 297
                  }
                },
                renderImage()
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'BodySize__box-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 302
                  }
                },
                renderSpecSummary()
              )
            ),
            renderNotice()
          )
        )
      )
    );
  };

  return BodySize;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelNameJa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodySize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specSummary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    //passengers: PropTypes.array,
    minLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    minWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    minHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    minWeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxWeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    wheelBase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    tireSizes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),
  //modelName: PropTypes.string,
  //bodyTypeModel: PropTypes.string,
  carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  description: null,
  mbDescription: null,
  notice: null,
  bodySize: null,
  bodyTypeModel: null,
  specSummary: null,
  imageDirectory: null,
  modelNameJa: null,
  modelName: null,
  //bodyTypeModel: null,
  carTypeCode: null,
  gradeId: null
}, _temp);
BodySize.displayName = 'BodySize';


/* harmony default export */ __webpack_exports__["a"] = (BodySize);

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BodySize":"BodySize","BodySize__container":"BodySize__container","BodySize__box":"BodySize__box","BodySize__box-left":"BodySize__box-left","BodySize__box-right":"BodySize__box-right","BodySize__description":"BodySize__description","BodySize__description__text-pc":"BodySize__description__text-pc","BodySize__description__text-mb":"BodySize__description__text-mb","BodySize__image":"BodySize__image","BodySize__image__image-pc":"BodySize__image__image-pc","BodySize__image__image-mb":"BodySize__image__image-mb","BodySize__notice":"BodySize__notice","BodySize__body-type-model":"BodySize__body-type-model"};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Equipment":"Equipment","Equipment__container":"Equipment__container","Equipment__description":"Equipment__description","Equipment__description__content-pc":"Equipment__description__content-pc","Equipment__description__content-mb":"Equipment__description__content-mb","Equipment__items":"Equipment__items","Equipment__items__item":"Equipment__items__item","Equipment__modal-item":"Equipment__modal-item","Equipment__modal-item__box":"Equipment__modal-item__box","Equipment__modal-item__box-left":"Equipment__modal-item__box-left","Equipment__modal-item__box-right":"Equipment__modal-item__box-right","Equipment__modal-item__box-full":"Equipment__modal-item__box-full","Equipment__modal-item__detail":"Equipment__modal-item__detail","Equipment__modal-item__detail-pc":"Equipment__modal-item__detail-pc","Equipment__modal-item__detail-mb":"Equipment__modal-item__detail-mb","Equipment__modal-item__image":"Equipment__modal-item__image","ModalWindow":"ModalWindow","open":"open","Slide":"Slide","ModalWindow__link-close":"ModalWindow__link-close","slick-next":"slick-next","slick-prev":"slick-prev","ModalItems":"ModalItems","_ModalItems__list-dots":"_ModalItems__list-dots","_ModalWindow":"_ModalWindow","ModalWindow__container":"ModalWindow__container","slick-dots":"slick-dots","current":"current","ModalItems__link":"ModalItems__link"};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EquipmentContainer":"EquipmentContainer","EquipmentContainer__heading":"EquipmentContainer__heading","EquipmentContainer__list":"EquipmentContainer__list","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-pc":"Accordion__title-pc","Accordion__title-mb":"Accordion__title-mb"};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EquipmentItem":"EquipmentItem","EquipmentItem__image":"EquipmentItem__image","EquipmentItem__heading":"EquipmentItem__heading","EquipmentItem__detail":"EquipmentItem__detail","EquipmentItem__detail__link":"EquipmentItem__detail__link"};

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MakerSetOptionMoreInfoItem":"MakerSetOptionMoreInfoItem","MakerSetOptionMoreInfoItem__container":"MakerSetOptionMoreInfoItem__container","MakerSetOptionMoreInfoItem__container2":"MakerSetOptionMoreInfoItem__container2","MakerSetOptionMoreInfoItem__box":"MakerSetOptionMoreInfoItem__box","MakerSetOptionMoreInfoItem__items":"MakerSetOptionMoreInfoItem__items","MakerSetOptionMoreInfoItem__items__list":"MakerSetOptionMoreInfoItem__items__list","MakerSetOptionMoreInfoItem__image":"MakerSetOptionMoreInfoItem__image","MakerSetOptionMoreInfoItem__image__box":"MakerSetOptionMoreInfoItem__image__box","MakerSetOptionMoreInfoItem__image-pc":"MakerSetOptionMoreInfoItem__image-pc","MakerSetOptionMoreInfoItem__image-mb":"MakerSetOptionMoreInfoItem__image-mb","MakerSetOptionMoreInfoItem__detail":"MakerSetOptionMoreInfoItem__detail","MakerSetOptionMoreInfoItem__detail__link":"MakerSetOptionMoreInfoItem__detail__link","MakerSetOptionMoreInfoItem__more-info":"MakerSetOptionMoreInfoItem__more-info","MakerSetOptionMoreInfoItem__more-info__link":"MakerSetOptionMoreInfoItem__more-info__link","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-mb":"Accordion__title-mb"};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MakerSetOption":"MakerSetOption","MakerSetOption__container":"MakerSetOption__container","MakerSetOption__description":"MakerSetOption__description","MakerSetOption__description__content-pc":"MakerSetOption__description__content-pc","MakerSetOption__description__content-mb":"MakerSetOption__description__content-mb","MakerSetOption__items":"MakerSetOption__items","MakerSetOption__items__item":"MakerSetOption__items__item","MakerSetOption__modal-item":"MakerSetOption__modal-item","MakerSetOption__modal-item__box":"MakerSetOption__modal-item__box","MakerSetOption__modal-item__box-left":"MakerSetOption__modal-item__box-left","MakerSetOption__modal-item__box-right":"MakerSetOption__modal-item__box-right","MakerSetOption__modal-item__box-full":"MakerSetOption__modal-item__box-full","MakerSetOption__modal-item__detail":"MakerSetOption__modal-item__detail","MakerSetOption__modal-item__detail-pc":"MakerSetOption__modal-item__detail-pc","MakerSetOption__modal-item__detail-mb":"MakerSetOption__modal-item__detail-mb","MakerSetOption__modal-item__image":"MakerSetOption__modal-item__image","MakerSetOption__modal-item__image-pc":"MakerSetOption__modal-item__image-pc","MakerSetOption__modal-item__image-mb":"MakerSetOption__modal-item__image-mb","ModalWindow":"ModalWindow","open":"open","Slide":"Slide","ModalWindow__link-close":"ModalWindow__link-close","_Slide":"_Slide","slick-next":"slick-next","slick-prev":"slick-prev","_ModalItems":"_ModalItems","ModalItems__list-dots":"ModalItems__list-dots","_ModalWindow":"_ModalWindow","ModalWindow__container":"ModalWindow__container","slick-dots":"slick-dots","ModalItems":"ModalItems","_ModalItems__list-dots":"_ModalItems__list-dots","current":"current","ModalItems__link":"ModalItems__link"};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SpecComparison":"SpecComparison","SpecComparison__fade-in-container":"SpecComparison__fade-in-container","open":"open","SpecComparison__container":"SpecComparison__container","SpecComparison__container2":"SpecComparison__container2","SpecComparison__container3":"SpecComparison__container3","SpecComparison__blank":"SpecComparison__blank","SpecComparison__description":"SpecComparison__description","SpecComparison__description-pc":"SpecComparison__description-pc","SpecComparison__description-mb":"SpecComparison__description-mb","SpecComparison__navigation":"SpecComparison__navigation","SpecComparison__navigation__box":"SpecComparison__navigation__box","Cta":"Cta","SpecComparison__navigation__box2":"SpecComparison__navigation__box2","SpecComparison__navigation__box3":"SpecComparison__navigation__box3","SpecComparison__navigation__list":"SpecComparison__navigation__list","SpecComparison__navigation__link-comparison":"SpecComparison__navigation__link-comparison","SpecComparison__navigation__grade":"SpecComparison__navigation__grade","SpecComparison__navigation__link-variant":"SpecComparison__navigation__link-variant","SpecComparison__pulldown":"SpecComparison__pulldown","SpecComparison__navigation__variant":"SpecComparison__navigation__variant","SpecComparison__navigation__blank":"SpecComparison__navigation__blank","SpecComparison__navigation__select":"SpecComparison__navigation__select","SpecComparison__navigation__price":"SpecComparison__navigation__price","SpecComparison__spec":"SpecComparison__spec","SpecComparison__spec__container":"SpecComparison__spec__container","SpecComparison__spec__box":"SpecComparison__spec__box","SpecComparison__spec__link-open":"SpecComparison__spec__link-open","SpecComparison__spec__link-open__open":"SpecComparison__spec__link-open__open","SpecComparison__spec__link-open__close":"SpecComparison__spec__link-open__close","SpecComparison__spec__link-open__icon":"SpecComparison__spec__link-open__icon","SpecComparison__spec__link-open__icon2":"SpecComparison__spec__link-open__icon2","SpecComparison__spec__table":"SpecComparison__spec__table","SpecComparison__spec__table-row":"SpecComparison__spec__table-row","SpecComparison__spec__table-cell":"SpecComparison__spec__table-cell","SpecComparison__spec__unit-image":"SpecComparison__spec__unit-image","SpecComparison__spec__seat-image":"SpecComparison__spec__seat-image","SpecComparison__spec__value":"SpecComparison__spec__value","SpecComparison__spec__list":"SpecComparison__spec__list","SpecComparison__notice":"SpecComparison__notice","Accordion--enabled":"Accordion--enabled","Accordion__title":"Accordion__title","Accordion__contents":"Accordion__contents","Accordion__container":"Accordion__container","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","SpecComparison__pulldown__link-variant":"SpecComparison__pulldown__link-variant","SpecComparison__pulldown__container":"SpecComparison__pulldown__container","SpecComparison__pulldown__box":"SpecComparison__pulldown__box","SpecComparison__pulldown__link-close":"SpecComparison__pulldown__link-close","SpecComparison__pulldown__list":"SpecComparison__pulldown__list","SpecComparison__pulldown__link-item":"SpecComparison__pulldown__link-item","current":"current"};

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\owner-library-container\\index.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 *  OwnerLibraryContainer
 */
var OwnerLibraryContainer = (_temp = _class = function (_Component) {
  _inherits(OwnerLibraryContainer, _Component);

  function OwnerLibraryContainer(props) {
    _classCallCheck(this, OwnerLibraryContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.openModal = function (vehicleLibraryItem) {
      _this.setState({
        vehicleLibraryItem: vehicleLibraryItem
      });
      //
      _this.refs.modalWindow.open('Light', 'Light');
      // BODYのスクロール無効化
      //BodyControl.openModal();
    };

    _this.onCloseModal = function () {
      // BODYのスクロール無効化を解除
      //BodyControl.closeModal();
    };

    _this.props = props;
    _this.state = {
      vehicleLibraryItem: null
    };
    return _this;
  }

  OwnerLibraryContainer.prototype.render = function render() {
    var _this2 = this;

    // ヘッダー表示
    var renderHeader = function renderHeader() {
      var titleAndDescription = '';
      if (_this2.props.titleAndDescription && _this2.props.titleAndDescription !== '') {
        titleAndDescription = _this2.props.titleAndDescription;
      }
      var mbTitleAndDescription = '';
      if (_this2.props.mbTitleAndDescription && _this2.props.mbTitleAndDescription !== '') {
        mbTitleAndDescription = _this2.props.mbTitleAndDescription;
      } else {
        mbTitleAndDescription = titleAndDescription;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'OwnerLibraryContainer__header Wysiwyg', __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'OwnerLibraryContainer__header-pc', dangerouslySetInnerHTML: { __html: titleAndDescription }, __source: {
            fileName: _jsxFileName,
            lineNumber: 97
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'OwnerLibraryContainer__header-mb', dangerouslySetInnerHTML: { __html: mbTitleAndDescription }, __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        })
      );
    };

    // ライブラリ表示
    var renderLibraries = function renderLibraries() {

      // ライブラリ表示
      var renderLibrary = function renderLibrary(vehicleLibraryCategory, index) {

        var getVehicleLibraryItem = function getVehicleLibraryItem() {
          var vehicleLibraryItems = vehicleLibraryCategory.vehicleLibraryItems || null;
          if (vehicleLibraryItems && vehicleLibraryItems instanceof Array && 1 <= vehicleLibraryItems.length) {
            // releaseDateでソート
            vehicleLibraryItems.sort(function (a, b) {
              if (a.releaseDate > b.releaseDate) return -1;
              if (a.releaseDate < b.releaseDate) return 1;
              return 0;
            });
            return vehicleLibraryItems[0];
            // if (vehicleLibraryItems[0].linkItem1 && vehicleLibraryItems[0].linkItem1 !== '') {
            //   return vehicleLibraryItems[0];
            // }
          }
          return null;
        };

        var vehicleLibraryItem = getVehicleLibraryItem();
        if (vehicleLibraryItem) {
          var text = vehicleLibraryCategory.manualCategory || '';
          var href = vehicleLibraryItem.linkItem1;
          var targetBlank = vehicleLibraryItem.linkTarget1 === 'External' ? true : false;
          var iconSrc = null;
          var linkType = 'Button';
          if (vehicleLibraryItem.linkIcon1 === 'PDF') {
            iconSrc = null;
            linkType = 'Button';
          } else if (vehicleLibraryItem.linkIcon1 === 'E-Book') {
            iconSrc = null;
            linkType = 'Button';
          } else if (vehicleLibraryItem.linkIcon1 === 'Link') {
            if (vehicleLibraryItem.linkFunction === 'Direct-Link' && targetBlank) {
              iconSrc = OwnerLibraryContainer.iconBlankWhite;
              linkType = 'Button-With-Icon';
            } else {
              iconSrc = null;
              linkType = 'Button';
            }
          }
          var handleClick = vehicleLibraryItem.linkFunction === 'Modal-Agreement-Window' ? function (e) {
            e.preventDefault();
            _this2.openModal(vehicleLibraryItem);
          } : null;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: index, __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks__["Cta"], _extends({
              ctaType: 'Free',
              href: href,
              text: text,
              targetBlank: targetBlank,
              linkType: linkType,
              color: 'Dark',
              buttonStyle: 'Action',
              iconSrc: iconSrc,
              handleClick: handleClick
            }, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 156
              }
            }))
          );
        } else {
          return null;
        }
      };

      if (_this2.props.bodyType && _this2.props.bodyType.generation && _this2.props.bodyType.generation.vehicleLibraryData) {
        if (_this2.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory && _this2.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory instanceof Array && 1 <= _this2.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'OwnerLibraryContainer__libraries', __source: {
                fileName: _jsxFileName,
                lineNumber: 179
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'OwnerLibraryContainer__libraries__list', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 180
                }
              },
              _this2.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory.map(function (vehicleLibraryCategory, index) {
                return renderLibrary(vehicleLibraryCategory, index);
              })
            )
          );
        }
      }
      return null;
    };

    // 注釈表示
    var renderNotice = function renderNotice() {
      if (_this2.props.notice && _this2.props.notice !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibraryContainer__notice Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 198
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: _this2.props.notice }, __source: {
              fileName: _jsxFileName,
              lineNumber: 199
            }
          })
        );
      } else {
        return null;
      }
    };

    // モーダル内アイテム表示
    var renderModalItem = function renderModalItem() {
      if (_this2.state.vehicleLibraryItem) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, _extends({
          linkItem1: _this2.state.vehicleLibraryItem.linkItem1 || null,
          linkTarget1: _this2.state.vehicleLibraryItem.linkTarget1 || null,
          linkButtonTitle1: _this2.state.vehicleLibraryItem.linkButtonTitle1 || null,
          linkIcon1: _this2.state.vehicleLibraryItem.linkIcon1 || null,
          linkUpdatedate1: _this2.state.vehicleLibraryItem.linkUpdatedate1 || null,
          linkItem2: _this2.state.vehicleLibraryItem.linkItem2 || null,
          linkTarget2: _this2.state.vehicleLibraryItem.linkTarget2 || null,
          linkButtonTitle2: _this2.state.vehicleLibraryItem.linkButtonTitle2 || null,
          linkIcon2: _this2.state.vehicleLibraryItem.linkIcon2 || null,
          linkUpdatedate2: _this2.state.vehicleLibraryItem.linkUpdatedate2 || null,
          titleAndPreText: _this2.state.vehicleLibraryItem.titleAndPreText || null,
          agreementText: _this2.state.vehicleLibraryItem.agreementText || null,
          linkAreaTitle: _this2.state.vehicleLibraryItem.linkAreaTitle || null,
          lowerDescription: _this2.state.vehicleLibraryItem.lowerDescription || null
        }, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211
          }
        }));
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 234
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'OwnerLibraryContainer', __source: {
            fileName: _jsxFileName,
            lineNumber: 240
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibraryContainer__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 241
            }
          },
          renderHeader(),
          renderLibraries(),
          renderNotice()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_modal_window__["a" /* default */],
          { ref: 'modalWindow', type: 'Light', onClose: this.onCloseModal, __source: {
              fileName: _jsxFileName,
              lineNumber: 250
            }
          },
          renderModalItem()
        )
      )
    );
  };

  // モーダルウィンドウ開く


  return OwnerLibraryContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.iconCatalogWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAhFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fWf706wAAAAK3RSTlMALSLWiO4XEQj48ubgy6+klY+BWEME+9HCm3xybGBNKAzcuKpqST85MCkcqGTk5QAAAMhJREFUOMvt08cOwjAMgOG06d57L/bw+78fAYOE1NKaI+O/RHK+Qw4x++iGiJsw3cjqHDAKDuANbAMEJ3ncbgqLWcImkl5gHhtkLLLKPRFjq0omYU9FX7TDMpaM2MvwOX6yiMWh1TnccpR+AeN1aKN3m3mMpd0Gv8kixvTGpWOh/viLsQoQpVTsi6FaJikJaw5cs8MDATM9VB87cnzCmqIobCKj8y30POoRzyZW1kSfB4jn09t1BvcYIW1bEDF2rl3ExOSKsx/rApVXQcsPEbyfAAAAAElFTkSuQmCC', _class.iconCatalogBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAeFBMVEUAAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBALOulEAAAAJ3RSTlMALSIT+NaI7JQG8eXLr6SBa1hMQigZ/ODRwpuOfHJgDQncuKo+OSFdjNTAAAAAxUlEQVQ4y+3TRw7DIBBAURwbDO69t1Tuf8OYTBaRTMJkmfKX8ISQBshHN8fUkfo21qYSwmAu38C+lLzYbct0eF3LiSbrCabpgsUqrzshMbQfLigcuuDbaTZjS6QhzMWJciNWsxkbON5nhQHDdu+CDxITVonsCNcxYshOAjRW6o+/GLtSxgKLo3XR7XIcLmt48/yMwMTuPXmrZtYDLhljRJPIoruncQH4ZQt82bWGK2zKng4VeMBGn7QVYFzlGABGthso+bGuhwk7oDpyF+gAAAAASUVORK5CYII=', _class.iconPdfWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAWlBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVogrzXAAAAHXRSTlMAf4dLlvvn3/HuYhLZ0nwi9XQ6Hg3FwKprWVNFM5Cqxq4AAAC4SURBVDjL5dTHDoNADEXRR5lCCYSSnvf/v5kBCSabwbBIkbhL6ywsWTJ2Exf6PJb7LiapTjVSkjoGYg4FsTKWZ4e1JiOHtTEmiA/oFIuUCRpqhxMAC7hX7AZckEVMm2V5ENtLyRID7mXsMs8R5/IaZV0DDmtDVvLOGDFpKrzhPz63hMMzTv0cY2wjjlZhb62MvW1FPNtjCxHP9iEfarIqgYS9vUPC3t4gYG+Zb3i5V6zHDdbjCrvrBVmbLH2hjickAAAAAElFTkSuQmCC', _class.iconPdfBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAXVBMVEUAAAAICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAhtHcNnAAAAHnRSTlMAf0qWh/vn3vEg7mIS2dL1fXQ1DQLFwKqKa1lTPgRZ37mdAAAAu0lEQVQ4y+XUyQ6DMAxF0QclCWFomTq37/8/swkSpBswLDpI3KV1FpYsGZuJM30ey30Xk1RHix1JfemQ0DeJlUl5clhrMnJYG2Mm8R5WsdgxRk3tcAxgBreK1uOCLBKmWZZP4vRcsoTHrYxdpulxLq9RWvuEw9qQlbwz4DFpou4N//G5BTwz49DPMfpW4mgRDjaVcbCNiEd7eEDEo43lQw1WxZBwsHdIONgbBBws8xUv94rluMZyXGFzvQDdBi4JXvW1vAAAAABJRU5ErkJggg==', _class.iconBlankWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC', _class.iconBlankBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC', _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  titleAndDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitleAndDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    generation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      vehicleLibraryData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        vehicleLibraryCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          manualCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          vehicleLibraryItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            linkFunction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkItem1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkTarget1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkIcon1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            releaseDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkButtonTitle1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkUpdatedate1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkItem2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkTarget2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkButtonTitle2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkIcon2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkUpdatedate2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            titleAndPreText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            agreementText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
            linkAreaTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            lowerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }))
        }))
      })
    })
  })
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  titleAndDescription: null,
  mbTitleAndDescription: null,
  notice: null,
  modelName: null,
  bodyType: null
}, _temp);
OwnerLibraryContainer.displayName = 'OwnerLibraryContainer';


/* harmony default export */ __webpack_exports__["a"] = (OwnerLibraryContainer);

var ModalItem = (_temp2 = _class2 = function (_Component2) {
  _inherits(ModalItem, _Component2);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.formatReleaseDate = function () {
      var YYYYMMDD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!YYYYMMDD || YYYYMMDD === '') return '';
      var str = String(YYYYMMDD).substr(0, 4) + '年';
      str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
      str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
      return str;
    };

    _this3.props = props;
    return _this3;
  }

  ModalItem.prototype.render = function render() {
    var _this4 = this;

    var renderLink = function renderLink(linkItem, linkTarget, linkButtonTitle, linkIcon, linkUpdatedate) {
      if (linkItem && linkItem !== '' && linkButtonTitle && linkButtonTitle !== '') {
        var iconSrc = null;
        var hoverIconSrc = null;
        var linkType = 'Button';
        var targetBlank = linkTarget === 'External' ? true : false;
        if (linkIcon === 'PDF') {
          iconSrc = OwnerLibraryContainer.iconPdfBlack;
          hoverIconSrc = OwnerLibraryContainer.iconPdfWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'E-Book') {
          iconSrc = OwnerLibraryContainer.iconCatalogBlack;
          hoverIconSrc = OwnerLibraryContainer.iconCatalogWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'Link') {
          if (targetBlank) {
            iconSrc = OwnerLibraryContainer.iconBlankBlack;
            hoverIconSrc = OwnerLibraryContainer.iconBlankWhite;
            linkType = 'Button-With-Icon';
          } else {
            iconSrc = null;
            hoverIconSrc = null;
            linkType = 'Button';
          }
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 347
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks__["Cta"], _extends({
            ctaType: 'Free',
            href: linkItem,
            text: linkButtonTitle,
            targetBlank: linkTarget === 'External' ? true : false,
            linkType: linkType,
            color: 'Dark',
            buttonStyle: 'Standard',
            iconSrc: iconSrc,
            hoverIconSrc: hoverIconSrc
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 348
            }
          })),
          linkUpdatedate && linkUpdatedate !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'OwnerLibraryContainer__modal-item__update', __source: {
                fileName: _jsxFileName,
                lineNumber: 361
              }
            },
            '\u66F4\u65B0\u65E5\uFF1A',
            _this4.formatReleaseDate(linkUpdatedate)
          ) : null
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'OwnerLibraryContainer__modal-item', __source: {
          fileName: _jsxFileName,
          lineNumber: 370
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'OwnerLibraryContainer__modal-item__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 371
          }
        },
        this.props.titleAndPreText && this.props.titleAndPreText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'OwnerLibraryContainer__modal-item__header Wysiwyg', dangerouslySetInnerHTML: { __html: this.props.titleAndPreText }, __source: {
            fileName: _jsxFileName,
            lineNumber: 373
          }
        }) : null,
        this.props.agreementText && this.props.agreementText instanceof Array && 1 <= this.props.agreementText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibraryContainer__modal-item__agreement', __source: {
              fileName: _jsxFileName,
              lineNumber: 376
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_7__utilities__["c" /* getComponents */])(this.props.agreementText)
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'OwnerLibraryContainer__modal-item__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 378
            }
          },
          this.props.linkAreaTitle && this.props.linkAreaTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 380
              }
            },
            this.props.linkAreaTitle
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 382
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'OwnerLibraryContainer__modal-item__list-ul', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 383
                }
              },
              renderLink(this.props.linkItem1, this.props.linkTarget1, this.props.linkButtonTitle1, this.props.linkIcon1, this.props.linkUpdatedate1),
              renderLink(this.props.linkItem2, this.props.linkTarget2, this.props.linkButtonTitle2, this.props.linkIcon2, this.props.linkUpdatedate2)
            )
          )
        ),
        this.props.lowerDescription && this.props.lowerDescription !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'OwnerLibraryContainer__modal-item__description Wysiwyg', dangerouslySetInnerHTML: { __html: this.props.lowerDescription }, __source: {
            fileName: _jsxFileName,
            lineNumber: 390
          }
        }) : null
      )
    );
  };

  // YYYYMMをYYYY年M月D日にフォーマト


  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  linkItem1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkTarget1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkButtonTitle1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkIcon1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkUpdatedate1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkItem2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkTarget2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkButtonTitle2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkIcon2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkUpdatedate2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  titleAndPreText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  agreementText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  linkAreaTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lowerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class2.defaultProps = {
  linkItem1: null,
  linkTarget1: null,
  linkButtonTitle1: null,
  linkIcon1: null,
  linkUpdatedate1: null,
  linkItem2: null,
  linkTarget2: null,
  linkButtonTitle2: null,
  linkIcon2: null,
  linkUpdatedate2: null,
  titleAndPreText: null,
  agreementText: null,
  linkAreaTitle: null,
  lowerDescription: null
}, _temp2);
ModalItem.displayName = 'ModalItem';

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OwnerLibraryContainer":"OwnerLibraryContainer","OwnerLibraryContainer__container":"OwnerLibraryContainer__container","OwnerLibraryContainer__header":"OwnerLibraryContainer__header","OwnerLibraryContainer__header-pc":"OwnerLibraryContainer__header-pc","OwnerLibraryContainer__header-mb":"OwnerLibraryContainer__header-mb","OwnerLibraryContainer__libraries":"OwnerLibraryContainer__libraries","OwnerLibraryContainer__libraries__list":"OwnerLibraryContainer__libraries__list","OwnerLibraryContainer__notice":"OwnerLibraryContainer__notice","OwnerLibraryContainer__modal-item":"OwnerLibraryContainer__modal-item","OwnerLibraryContainer__modal-item__container":"OwnerLibraryContainer__modal-item__container","OwnerLibraryContainer__modal-item__header":"OwnerLibraryContainer__modal-item__header","OwnerLibraryContainer__modal-item__agreement":"OwnerLibraryContainer__modal-item__agreement","OwnerLibraryContainer__modal-item__list-dl":"OwnerLibraryContainer__modal-item__list-dl","OwnerLibraryContainer__modal-item__list-ul":"OwnerLibraryContainer__modal-item__list-ul","OwnerLibraryContainer__modal-item__update":"OwnerLibraryContainer__modal-item__update","OwnerLibraryContainer__modal-item__description":"OwnerLibraryContainer__modal-item__description","ModalWindow":"ModalWindow","open":"open","ModalWindow__link-close":"ModalWindow__link-close"};

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GradeAndSpecData":"GradeAndSpecData","GradeAndSpecData__container":"GradeAndSpecData__container","GradeAndSpecData__container2":"GradeAndSpecData__container2","GradeAndSpecData__car-image":"GradeAndSpecData__car-image","GradeAndSpecData__box":"GradeAndSpecData__box","GradeAndSpecData__heading":"GradeAndSpecData__heading","GradeAndSpecData__engine":"GradeAndSpecData__engine","GradeAndSpecData__description":"GradeAndSpecData__description","GradeAndSpecData__description-pc":"GradeAndSpecData__description-pc","GradeAndSpecData__description-mb":"GradeAndSpecData__description-mb","GradeAndSpecData__interior":"GradeAndSpecData__interior","GradeAndSpecData__interior__image":"GradeAndSpecData__interior__image","GradeAndSpecData__variants":"GradeAndSpecData__variants","GradeAndSpecData__variants__list":"GradeAndSpecData__variants__list","GradeAndSpecData__variants__container":"GradeAndSpecData__variants__container","GradeAndSpecData__variants__container2":"GradeAndSpecData__variants__container2","GradeAndSpecData__variants__container3":"GradeAndSpecData__variants__container3","GradeAndSpecData__variants__name":"GradeAndSpecData__variants__name","GradeAndSpecData__variants__price":"GradeAndSpecData__variants__price","GradeAndSpecData__variants__tax":"GradeAndSpecData__variants__tax","GradeAndSpecData__variants__tax-item":"GradeAndSpecData__variants__tax-item","GradeAndSpecData__estimate":"GradeAndSpecData__estimate","GradeAndSpecData__estimate__link":"GradeAndSpecData__estimate__link","ExteriorView":"ExteriorView","ExteriorView__navigation":"ExteriorView__navigation","GradeAndSpecData__car-image__wrapper":"GradeAndSpecData__car-image__wrapper","GradeAndSpecData__box2":"GradeAndSpecData__box2","PhotoInfo":"PhotoInfo","PhotoInfo__btn__open":"PhotoInfo__btn__open"};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EstimateLink":"EstimateLink","Cta":"Cta","Cta__container--Light":"Cta__container--Light","Cta__button":"Cta__button","Cta__button__text":"Cta__button__text","Cta__container--Dark":"Cta__container--Dark"};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e596a1db342ca4c75e8bc0955b6adf29.png";

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GradeAndSpec":"GradeAndSpec","GradeAndSpec__fade-in-container":"GradeAndSpec__fade-in-container","open":"open","GradeAndSpec__body-type-nav":"GradeAndSpec__body-type-nav","GradeAndSpec__body-type-nav__link":"GradeAndSpec__body-type-nav__link","current":"current","GradeAndSpec__engine-nav":"GradeAndSpec__engine-nav","GradeAndSpec__engine-nav__list":"GradeAndSpec__engine-nav__list","GradeAndSpec__engine-nav__link":"GradeAndSpec__engine-nav__link","GradeAndSpec__vehicle-type":"GradeAndSpec__vehicle-type","GradeAndSpec__vehicle-type__list":"GradeAndSpec__vehicle-type__list","GradeAndSpec__vehicle-type__link":"GradeAndSpec__vehicle-type__link","GradeAndSpec__grade-nav":"GradeAndSpec__grade-nav","GradeAndSpec__grade-nav__list":"GradeAndSpec__grade-nav__list","fixed":"fixed","GradeAndSpec__grade-nav__list-item":"GradeAndSpec__grade-nav__list-item","GradeAndSpec__grade-nav__link":"GradeAndSpec__grade-nav__link","GradeAndSpec__grade-nav__text-wrapper":"GradeAndSpec__grade-nav__text-wrapper","GradeAndSpec__grade-nav__image":"GradeAndSpec__grade-nav__image","GradeAndSpec__grade-nav__vehicle-type":"GradeAndSpec__grade-nav__vehicle-type","GradeAndSpec__grade-nav__grade":"GradeAndSpec__grade-nav__grade","GradeAndSpec__grade-nav__engine":"GradeAndSpec__grade-nav__engine","GradeAndSpec__grade-nav__image-wrapper":"GradeAndSpec__grade-nav__image-wrapper","GradeAndSpec__grade-nav__image-wrapper2":"GradeAndSpec__grade-nav__image-wrapper2","GradeAndSpec__grade":"GradeAndSpec__grade","Slide":"Slide","slick-arrow":"slick-arrow","GradeAndSpec__engine-nav__container":"GradeAndSpec__engine-nav__container","scroll":"scroll","slick-dots":"slick-dots"};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EcoTax":"EcoTax","EcoTax__body-type-selector":"EcoTax__body-type-selector","EcoTax__body-type-selector__link":"EcoTax__body-type-selector__link","current":"current","EcoTax__variants":"EcoTax__variants","fixed":"fixed","EcoTax__variants__item":"EcoTax__variants__item","EcoTax__variants__container":"EcoTax__variants__container","EcoTax__variants__pager":"EcoTax__variants__pager","EcoTax__variants__box":"EcoTax__variants__box","EcoTax__variants__box-inner":"EcoTax__variants__box-inner","EcoTax__variants__box2":"EcoTax__variants__box2","EcoTax__variants__box3":"EcoTax__variants__box3","EcoTax__variants__box4":"EcoTax__variants__box4","EcoTax__variants__grade":"EcoTax__variants__grade","EcoTax__variants__spec":"EcoTax__variants__spec","EcoTax__variants__heading":"EcoTax__variants__heading","EcoTax__variants__subsidy":"EcoTax__variants__subsidy","EcoTax__variants__subsidy-excluded":"EcoTax__variants__subsidy-excluded","EcoTax__variants__tax-cut":"EcoTax__variants__tax-cut","EcoTax__variants__tax-cut-excluded":"EcoTax__variants__tax-cut-excluded","EcoTax__variants__list-tax":"EcoTax__variants__list-tax","EcoTax__variants__icon":"EcoTax__variants__icon","EcoTax__variants__icon--100":"EcoTax__variants__icon--100","EcoTax__variants__icon--inactive":"EcoTax__variants__icon--inactive","Slide":"Slide","slick-arrow":"slick-arrow","slick-dots":"slick-dots","Cta":"Cta","Cta__button":"Cta__button","middle":"middle","EcoTax__description":"EcoTax__description","slick-slider":"slick-slider","slick-next":"slick-next","slick-prev":"slick-prev","slick-list":"slick-list"};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarLineupFilterItem":"CarLineupFilterItem","CarLineupFilterItem__Label":"CarLineupFilterItem__Label","CarLineupFilterItem__Label__Radio":"CarLineupFilterItem__Label__Radio","CarLineupFilterItem__Label__Icon":"CarLineupFilterItem__Label__Icon","CarLineupFilterItem__Label__Text":"CarLineupFilterItem__Label__Text","CarLineupFilterItem__Label__Checkbox":"CarLineupFilterItem__Label__Checkbox"};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarLineupFilter":"CarLineupFilter","CarLineupFilter__Column":"CarLineupFilter__Column","CarLineupFilter__Column__List__Item":"CarLineupFilter__Column__List__Item","CarLineupFilter__Column--bodyType":"CarLineupFilter__Column--bodyType","CarLineupFilter__Column__List":"CarLineupFilter__Column__List","CarLineupFilter__Column--engineType":"CarLineupFilter__Column--engineType","CarLineupFilter__Column--mission":"CarLineupFilter__Column--mission","CarLineupFilter__Column--drive":"CarLineupFilter__Column--drive","CarLineupFilter__Column--capacity":"CarLineupFilter__Column--capacity","CarLineupFilter__Column--price-displacement":"CarLineupFilter__Column--price-displacement","CarLineupFilter__Column--price":"CarLineupFilter__Column--price","CarLineupFilter__Column--displacement":"CarLineupFilter__Column--displacement","CarLineupFilter__Column__Container":"CarLineupFilter__Column__Container","CarLineupFilter__Column--displacement__range":"CarLineupFilter__Column--displacement__range","CarLineupFilter__Column--bodySize":"CarLineupFilter__Column--bodySize","CarLineupFilter__Column__FormTitle":"CarLineupFilter__Column__FormTitle","CarLineupFilter__Column--others":"CarLineupFilter__Column--others","CarLineupFilter__Column__Title":"CarLineupFilter__Column__Title","CarLineupFilter__Column__Select":"CarLineupFilter__Column__Select"};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarLineup":"CarLineup","CarLineup__VehiclesForm":"CarLineup__VehiclesForm","CarLineup__VehiclesForm--hide":"CarLineup__VehiclesForm--hide","CarLineup__VehiclesForm__List":"CarLineup__VehiclesForm__List","CarLineup__VehiclesForm__List__Item":"CarLineup__VehiclesForm__List__Item","CarLineup__VehiclesForm__List__Item__Label":"CarLineup__VehiclesForm__List__Item__Label","CarLineup__VehiclesForm__List__Item__Label__Radio":"CarLineup__VehiclesForm__List__Item__Label__Radio","CarLineup__VehiclesForm__List__Item__Label__Text":"CarLineup__VehiclesForm__List__Item__Label__Text","CarLineup__View":"CarLineup__View","CarLineup__View--show":"CarLineup__View--show","CarLineup__View--hide":"CarLineup__View--hide","CarLineup__View__Refine":"CarLineup__View__Refine","CarLineup__View__Container":"CarLineup__View__Container","CarLineup__View__Title":"CarLineup__View__Title","CarLineup__View__Form":"CarLineup__View__Form","CarLineup__View__Form__List":"CarLineup__View__Form__List","CarLineup__View__Form__List__Item":"CarLineup__View__Form__List__Item","CarLineup__View__Form__List__Item__Label":"CarLineup__View__Form__List__Item__Label","CarLineup__View__Form__List__Item__Label__RadioButton":"CarLineup__View__Form__List__Item__Label__RadioButton","CarLineup__View__Form__List__Item__Label__Text":"CarLineup__View__Form__List__Item__Label__Text","CarLineup__View__Form__List__Item--Grid":"CarLineup__View__Form__List__Item--Grid","CarLineup__View__Form__List__Item--List":"CarLineup__View__Form__List__Item--List","CarLineup__FiltersForm":"CarLineup__FiltersForm","CarLineup__FiltersForm--show":"CarLineup__FiltersForm--show","CarLineup__FiltersForm--hide":"CarLineup__FiltersForm--hide","CarLineup__FiltersForm__Close":"CarLineup__FiltersForm__Close","CarLineup__FiltersForm__Title":"CarLineup__FiltersForm__Title","CarLineup__FiltersForm__Reset--top":"CarLineup__FiltersForm__Reset--top","CarLineup__FiltersForm__Submit":"CarLineup__FiltersForm__Submit","CarLineup__FiltersForm__Reset":"CarLineup__FiltersForm__Reset","CarLineup__FiltersForm__Reset__Button":"CarLineup__FiltersForm__Reset__Button","CarLineup__Cars":"CarLineup__Cars","fadein":"fadein","CarLineup__Cars__Heading":"CarLineup__Cars__Heading","CarLineup__Cars__Heading__Item":"CarLineup__Cars__Heading__Item","CarLineup__Cars__Heading__Item--name":"CarLineup__Cars__Heading__Item--name","CarLineup__Cars__Heading__Item--engine":"CarLineup__Cars__Heading__Item--engine","CarLineup__Cars__Heading__Item--price":"CarLineup__Cars__Heading__Item--price","CarLineup__Cars__Heading__Item--supportCar":"CarLineup__Cars__Heading__Item--supportCar","CarLineup__Cars__Heading__Item--fuelEco":"CarLineup__Cars__Heading__Item--fuelEco","CarLineup__Cars__Heading__Item--passengers":"CarLineup__Cars__Heading__Item--passengers","CarLineup__Cars__Heading__Item--displacement":"CarLineup__Cars__Heading__Item--displacement","CarLineup__Cars__Heading__Item--drive":"CarLineup__Cars__Heading__Item--drive","CarLineup__Cars__Heading__Item--bodySize":"CarLineup__Cars__Heading__Item--bodySize","CarLineup__Cars__noResult":"CarLineup__Cars__noResult","br":"br","CarLineup__Cars__Body":"CarLineup__Cars__Body","CarLineup__Cars__Body__Item":"CarLineup__Cars__Body__Item","CarLineup__Cars__Body__Item__Link":"CarLineup__Cars__Body__Item__Link","CarLineup__Cars__Body__Item__List__Item__dd":"CarLineup__Cars__Body__Item__List__Item__dd","CarLineup__Cars__Body__Item__Link--disabled":"CarLineup__Cars__Body__Item__Link--disabled","CarLineup__Cars__Body__Item__List":"CarLineup__Cars__Body__Item__List","CarLineup__Cars__Body__Item__List__Item__dt":"CarLineup__Cars__Body__Item__List__Item__dt","CarLineup__Cars--Grid":"CarLineup__Cars--Grid","CarLineup__Cars__Body__Item__List__Item":"CarLineup__Cars__Body__Item__List__Item","CarLineup__Cars__Body__Item__List__Item--name":"CarLineup__Cars__Body__Item__List__Item--name","CarLineup__Cars__Body__Item__List__Item--name__image":"CarLineup__Cars__Body__Item__List__Item--name__image","CarLineup__Cars__Body__Item__List__Item--name__title":"CarLineup__Cars__Body__Item__List__Item--name__title","CarLineup__Cars__Body__Item__List__Item--name__category":"CarLineup__Cars__Body__Item__List__Item--name__category","CarLineup__Cars__Body__Item__List__Item--name__price":"CarLineup__Cars__Body__Item__List__Item--name__price","CarLineup__Cars__Body__Item__List__Item--engine":"CarLineup__Cars__Body__Item__List__Item--engine","CarLineup__Cars__Body__Item__List__Item--price":"CarLineup__Cars__Body__Item__List__Item--price","CarLineup__Cars__Body__Item__List__Item--supportCar":"CarLineup__Cars__Body__Item__List__Item--supportCar","CarLineup__Cars__Body__Item__List__Item--fuelEco":"CarLineup__Cars__Body__Item__List__Item--fuelEco","CarLineup__Cars__Body__Item__List__Item--passengers":"CarLineup__Cars__Body__Item__List__Item--passengers","CarLineup__Cars__Body__Item__List__Item--displacement":"CarLineup__Cars__Body__Item__List__Item--displacement","CarLineup__Cars__Body__Item__List__Item--drive":"CarLineup__Cars__Body__Item__List__Item--drive","CarLineup__Cars__Body__Item__List__Item--bodySize":"CarLineup__Cars__Body__Item__List__Item--bodySize","CarLineup__Cars--List":"CarLineup__Cars--List","CarLineup__Cars__Body__Item__List__Item__dd__wrap":"CarLineup__Cars__Body__Item__List__Item__dd__wrap","CarLineup__Cars__Body__Item__List__Item--engine__Item":"CarLineup__Cars__Body__Item__List__Item--engine__Item","tax":"tax","CarLineup__Cars__Body__Item__List__Item--supportCar__Item":"CarLineup__Cars__Body__Item__List__Item--supportCar__Item","CarLineup__Cars__Body__Item__List__Item--supportCar__Item--supportCar":"CarLineup__Cars__Body__Item__List__Item--supportCar__Item--supportCar","CarLineup__Cars__Body__Item__List__Item--fuelEco__Title":"CarLineup__Cars__Body__Item__List__Item--fuelEco__Title","tilde":"tilde","CarLineup__Cars__Body__Item__List__Item--drive__Item":"CarLineup__Cars__Body__Item__List__Item--drive__Item","CarLineup__Cars__Body__Item__List__Item--bodySize__Item":"CarLineup__Cars__Body__Item__List__Item--bodySize__Item","CarLineup__View__Refine__Button":"CarLineup__View__Refine__Button","CarLineup__FiltersForm__scroll":"CarLineup__FiltersForm__scroll","CarLineup__FiltersForm__Container":"CarLineup__FiltersForm__Container","CarLineup__FiltersForm--close":"CarLineup__FiltersForm--close","CarLineup__FiltersForm--open":"CarLineup__FiltersForm--open","CarLineup__FiltersForm__Close__Button":"CarLineup__FiltersForm__Close__Button","CarLineup__FiltersForm__Reset--bottom":"CarLineup__FiltersForm__Reset--bottom","CarLineup__FiltersForm__Body":"CarLineup__FiltersForm__Body","CarLineup__FiltersForm__Submit__Button":"CarLineup__FiltersForm__Submit__Button","fadein-mb":"fadein-mb"};

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\pagenation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  Pagenation
 */
var Pagenation = (_temp = _class = function (_Component) {
  _inherits(Pagenation, _Component);

  function Pagenation(props) {
    _classCallCheck(this, Pagenation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  Pagenation.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        links = _props.links,
        linkColor = _props.linkColor;


    var currentIndex = void 0,
        prevHref = void 0,
        nextHref = void 0;

    if (links && Array.isArray(links) && links.length > 0) {
      for (var i = 0; i < links.length; i++) {
        if (links[i].current) {
          currentIndex = i;
          break;
        }
      }
    }

    if (links.length === 0) {
      prevHref = '#';
      nextHref = '#';
    } else if (links.length === 1) {
      prevHref = links[currentIndex].href;
      nextHref = links[currentIndex].href;
    } else {
      prevHref = currentIndex - 1 >= 0 ? links[currentIndex - 1].href : links[links.length - 1].href;
      nextHref = currentIndex + 1 < links.length ? links[currentIndex + 1].href : links[0].href;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Pagenation', __source: {
            fileName: _jsxFileName,
            lineNumber: 77
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'Pagenation__container' + ' Pagenation__container--' + linkColor + (links.length >= 6 ? ' Pagenation__container--over6' : ''),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 78
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Pagenation__container__arrow Pagenation__container__arrow--prev' + (currentIndex === 0 ? ' hide' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 85
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: prevHref, className: 'Pagenation__container__arrow__link', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 86
                }
              },
              'prev'
            )
          ),
          function () {
            if (links && Array.isArray(links) && links.length > 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'Pagenation__container__list', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 91
                  }
                },
                links.map(function (linkItem, index) {
                  {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'Pagenation__container__list__item', key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 96
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        {
                          href: linkItem.href,
                          target: linkItem.external ? '_blank' : '',
                          className: 'Pagenation__container__list__item__link' + (linkItem.current ? ' Pagenation__container__list__item__link--current' : ''),
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 97
                          }
                        },
                        index + 1
                      )
                    );
                  }
                })
              );
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Pagenation__container__arrow Pagenation__container__arrow--next' + (currentIndex === links.length - 1 ? ' hide' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 116
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: nextHref, className: 'Pagenation__container__arrow__link', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 117
                }
              },
              'next'
            )
          )
        )
      )
    );
  };

  return Pagenation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })),
  linkColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  links: null,
  linkColor: null
}, _temp);
Pagenation.displayName = 'Pagenation';


/* harmony default export */ __webpack_exports__["a"] = (Pagenation);

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Pagenation":"Pagenation","Pagenation__container":"Pagenation__container","Pagenation__container__arrow":"Pagenation__container__arrow","hide":"hide","Pagenation__container__arrow__link":"Pagenation__container__arrow__link","Pagenation__container__arrow--prev":"Pagenation__container__arrow--prev","Pagenation__container__arrow--next":"Pagenation__container__arrow--next","Pagenation__container__list":"Pagenation__container__list","Pagenation__container__list__item":"Pagenation__container__list__item","Pagenation__container__list__item__link":"Pagenation__container__list__item__link","Pagenation__container__list__item__link--current":"Pagenation__container__list__item__link--current","Pagenation__container--Dark":"Pagenation__container--Dark","Pagenation__container--Light":"Pagenation__container--Light","Pagenation__container--over6":"Pagenation__container--over6"};

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_accordion__ = __webpack_require__(28);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\notification\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Notification = (_temp = _class = function (_Component) {
  _inherits(Notification, _Component);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function () {
      var maxHeight = 0;
      var items = _this.refs.items ? _this.refs.items.getElementsByClassName('Notification__area__link-content') || null : null;
      if (items && 1 <= items.length) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = items.length; i < max; i = i + 1) {
          var height = items[i].clientHeight;
          if (maxHeight < height) {
            maxHeight = height;
          }
        }
      }
      _this.setState({
        linkHeight: maxHeight
      });
    };

    _this.state = {
      isMounted: false,
      linkHeight: 'auto'
    };
    _this.timeoutId = null;
    return _this;
  }

  Notification.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.setState({
      isMounted: true
    });
    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this2.handleResize();
    }, 100);
  };

  Notification.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  Notification.prototype.render = function render() {
    var _this3 = this;

    // ------ Render ----- //

    // タイトル表示
    var renderTitle = function renderTitle() {

      var getTitle = function getTitle() {
        if (_this3.props.title && _this3.props.title !== '') {
          return _this3.props.title;
        } else {
          return '';
        }
      };

      var getMbTitle = function getMbTitle() {
        if (_this3.props.mbTitle && _this3.props.mbTitle !== '') {
          return _this3.props.mbTitle;
        } else {
          return getTitle();
        }
      };

      var title = getTitle();
      var mbTitle = getMbTitle();

      if (title && title !== '' || mbTitle && mbTitle !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'Notification__heading Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 109
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Notification__heading-pc', dangerouslySetInnerHTML: { __html: title }, __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Notification__heading-mb', dangerouslySetInnerHTML: { __html: mbTitle }, __source: {
              fileName: _jsxFileName,
              lineNumber: 111
            }
          })
        );
      } else {
        return null;
      }
    };

    // Notification Area
    var renderNotificationArea = function renderNotificationArea() {
      if (_this3.props.function !== 'Notification-Area') return null;

      var getText = function getText(notificationAreaItem) {
        if (notificationAreaItem.pageTitle && notificationAreaItem.pageTitle !== '') {
          return notificationAreaItem.pageTitle;
        } else if (notificationAreaItem.pageName && notificationAreaItem.pageName !== '') {
          return notificationAreaItem.pageName;
        } else {
          return null;
        }
      };

      var getMbText = function getMbText(notificationAreaItem) {
        if (notificationAreaItem.mbPageTitle && notificationAreaItem.mbPageTitle !== '') {
          return notificationAreaItem.mbPageTitle;
        } else {
          return getText(notificationAreaItem);
        }
      };

      var getNotificationAreaItems = function getNotificationAreaItems() {
        var items = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this3.props.notificationAreaItems.length; i < max; i = i + 1) {
          var item = _this3.props.notificationAreaItems[i];
          var date = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["l" /* formatDate */])(item.publishedDate, '.');
          if (date) {
            items.push(item);
          }
        }
        return items;
      };

      var renderItems = function renderItems(notificationAreaItems) {
        if (notificationAreaItems && notificationAreaItems instanceof Array) {
          return notificationAreaItems.map(function (notificationAreaItem, index) {
            var date = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["l" /* formatDate */])(notificationAreaItem.publishedDate, '.');
            if (!date) return null;
            //
            var src = null;
            if (!_this3.props.hideImages && notificationAreaItem.smallImageSrc && notificationAreaItem.smallImageSrc !== '') {
              src = notificationAreaItem.smallImageSrc;
            }
            var text = getText(notificationAreaItem);
            var mbText = getMbText(notificationAreaItem);
            // リンクかどうかの出し分け
            if (notificationAreaItem.href && notificationAreaItem.href !== '') {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 170
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Notification__area__container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 171
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'Notification__area__link' + (notificationAreaItem.targetBlank === true ? ' blank' : ''),
                      href: notificationAreaItem.href ? notificationAreaItem.href : '',
                      target: notificationAreaItem.targetBlank === true ? '_blank' : '',
                      style: { height: _this3.state.linkHeight },
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 172
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Notification__area__link-content', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 177
                        }
                      },
                      src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Notification__area__image-wrapper', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 178
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Notification__area__image', src: src, onLoad: function onLoad() {
                            if (_this3.timeoutId) clearTimeout(_this3.timeoutId);
                            _this3.timeoutId = setTimeout(function () {
                              _this3.handleResize();
                            }, 200);
                          }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 178
                          }
                        })
                      ) : null,
                      text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__area__text-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 184
                        }
                      }) : null,
                      mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__area__text-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 185
                        }
                      }) : null,
                      date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'Notification__area__date', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 186
                          }
                        },
                        date
                      ) : null
                    )
                  )
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 194
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'Notification__area__container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 195
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Notification__area__link disabled', style: { height: _this3.state.linkHeight }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 196
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'Notification__area__link-content', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 197
                        }
                      },
                      src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'Notification__area__image-wrapper', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 198
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Notification__area__image', src: src, onLoad: function onLoad() {
                            if (_this3.timeoutId) clearTimeout(_this3.timeoutId);
                            _this3.timeoutId = setTimeout(function () {
                              _this3.handleResize();
                            }, 200);
                          }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 198
                          }
                        })
                      ) : null,
                      text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__area__text-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 204
                        }
                      }) : null,
                      mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__area__text-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 205
                        }
                      }) : null,
                      date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'Notification__area__date', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 206
                          }
                        },
                        date
                      ) : null
                    )
                  )
                )
              );
            }
          });
        } else {
          return null;
        }
      };

      var notificationAreaItems = getNotificationAreaItems();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Notification__area', __source: {
            fileName: _jsxFileName,
            lineNumber: 223
          }
        },
        function () {
          if (!_this3.state.isMounted) return null;

          var IS_BROWSER2 = typeof window !== 'undefined';
          var WINDOW2 = IS_BROWSER2 && window;
          var NAVIGATOR2 = WINDOW2 && WINDOW2.navigator;
          var IS_IOS2 = NAVIGATOR2 && /iPhone|iPad|iPod/i.test(NAVIGATOR2.userAgent || '');
          var IS_ANDROID2 = NAVIGATOR2 && /Android/i.test(NAVIGATOR2.userAgent || '');
          var IS_MOBILE2 = NAVIGATOR2 && /iPhone|iPod|Android/i.test(NAVIGATOR2.userAgent);
          // console.log('IS_BROWSER: ', IS_BROWSER2);
          // console.log('WINDOW: ', WINDOW2);
          // console.log('NAVIGATOR: ', NAVIGATOR2);
          // console.log('IS_IOS: ', IS_IOS2);
          // console.log('IS_ANDROID: ', IS_ANDROID2);
          // console.log('IS_MOBILE2: ', IS_MOBILE2);
          // console.log('IS_MOBILE: ', IS_MOBILE);

          if (notificationAreaItems && notificationAreaItems.length <= (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] === true ? 2 : 4)) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'Notification__area__items fixed', ref: 'items', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 243
                }
              },
              renderItems(notificationAreaItems)
            );
          } else if (notificationAreaItems && (__WEBPACK_IMPORTED_MODULE_6__constants_environment__["g" /* IS_MOBILE */] === true ? 3 : 5) <= notificationAreaItems.length) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'Notification__area__items', ref: 'items', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 249
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__components_slider__["a" /* default */],
                { settings: {
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                    fade: false,
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    swipe: true,
                    draggable: false,
                    arrows: true,
                    dots: true,
                    adaptiveHeight: false,
                    centerMode: false,
                    centerPadding: 0,
                    waitForAnimate: false,
                    lazyLoad: 'progressive',
                    responsive: [{
                      breakpoint: 767,
                      settings: {
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false
                      }
                    }]
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 250
                  }
                },
                renderItems(notificationAreaItems)
              )
            );
          } else {
            return null;
          }
        }()
      );
    };

    // Notification List
    var renderNotificationList = function renderNotificationList() {
      if (_this3.props.function !== 'Notification-List') return null;

      var getText = function getText(notificationItem) {
        if (notificationItem.pageTitle && notificationItem.pageTitle !== '') {
          return notificationItem.pageTitle;
        } else if (notificationItem.pageName && notificationItem.pageName !== '') {
          return notificationItem.pageName;
        } else {
          return null;
        }
      };

      var getMbText = function getMbText(notificationListItem) {
        if (notificationListItem.mbPageTitle && notificationListItem.mbPageTitle !== '') {
          return notificationListItem.mbPageTitle;
        } else {
          return getText(notificationListItem);
        }
      };

      var renderItem = function renderItem(notificationItem) {
        var date = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["l" /* formatDate */])(notificationItem.publishedDate, '.');
        if (!date) return null;
        //
        var src = null;
        if (!_this3.props.hideImages && notificationItem.smallImageSrc && notificationItem.smallImageSrc !== '') {
          src = notificationItem.smallImageSrc;
        }
        var text = getText(notificationItem);
        var mbText = getMbText(notificationItem);
        // リンクかどうかの出し分け
        if (notificationItem.href && notificationItem.href !== '') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'Notification__list__link' + (notificationItem.targetBlank === true ? ' blank' : '') + (_this3.props.hideImages === true || src === null ? ' hideImage' : ''),
              href: notificationItem.href ? notificationItem.href : '',
              target: notificationItem.targetBlank === true ? '_blank' : '',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 328
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Notification__list__box3', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 332
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Notification__list__box3-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 333
                  }
                },
                src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Notification__list__image', src: src, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 334
                  }
                }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Notification__list__box3-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 336
                  }
                },
                date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'Notification__list__date', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 337
                    }
                  },
                  date
                ) : null,
                text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__list__text-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 338
                  }
                }) : null,
                mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__list__text-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 339
                  }
                }) : null
              )
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Notification__list__link disabled' + (_this3.props.hideImages === true || src === null ? ' hideImage' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 346
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Notification__list__box3', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 347
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Notification__list__box3-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 348
                  }
                },
                src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'Notification__list__image', src: src, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 349
                  }
                }) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Notification__list__box3-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 351
                  }
                },
                date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'Notification__list__date', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 352
                    }
                  },
                  date
                ) : null,
                text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__list__text-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(text) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 353
                  }
                }) : null,
                mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'Notification__list__text-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 354
                  }
                }) : null
              )
            )
          );
        }
      };

      if (_this3.props.notificationListItems && _this3.props.notificationListItems instanceof Array) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Notification__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 364
            }
          },
          _this3.props.notificationListTitle && _this3.props.notificationListTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'Notification__list__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 366
              }
            },
            _this3.props.notificationListTitle
          ) : null,
          _this3.props.notificationListItems.map(function (notificationListItem, index) {
            var isOpen = index <= 0 ? true : false;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'Notification__list__box', key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 371
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__components_accordion__["a" /* default */],
                {
                  pageName: notificationListItem.pageName,
                  pcText: notificationListItem.pageName,
                  mbText: notificationListItem.pageName,
                  open: isOpen,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 372
                  }
                },
                notificationListItem.notificationItems.map(function (notificationItem, index2) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'Notification__list__box2', key: index2, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 380
                      }
                    },
                    renderItem(notificationItem)
                  );
                })
              )
            );
          })
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 397
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Notification', __source: {
            fileName: _jsxFileName,
            lineNumber: 403
          }
        },
        renderTitle(),
        renderNotificationArea(),
        renderNotificationList()
      )
    );
  };

  //


  return Notification;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  function: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideImages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  notificationAreaItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    smallImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    publishedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbPageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })),
  notificationListTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  notificationListItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    notificationItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      smallImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      publishedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      pageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      mbPageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      targetBlank: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  function: null,
  title: null,
  mbTitle: null,
  hideImages: null,
  notificationAreaItems: null,
  notificationListTitle: null,
  notificationListItems: null
}, _temp);
Notification.displayName = 'Notification';


/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Notification":"Notification","Notification__heading":"Notification__heading","Notification__heading-pc":"Notification__heading-pc","Notification__heading-mb":"Notification__heading-mb","Notification__area":"Notification__area","Notification__area__items":"Notification__area__items","fixed":"fixed","Notification__area__container":"Notification__area__container","Notification__area__link-content":"Notification__area__link-content","Notification__area__link":"Notification__area__link","disabled":"disabled","Notification__area__image":"Notification__area__image","blank":"blank","Notification__area__text-pc":"Notification__area__text-pc","Notification__area__image-wrapper":"Notification__area__image-wrapper","Notification__area__text-mb":"Notification__area__text-mb","Notification__area__date":"Notification__area__date","Notification__list":"Notification__list","Notification__list__heading":"Notification__list__heading","Notification__list__link":"Notification__list__link","Notification__list__text-pc":"Notification__list__text-pc","Notification__list__image":"Notification__list__image","hideImage":"hideImage","Notification__list__box3":"Notification__list__box3","Notification__list__box3-left":"Notification__list__box3-left","Notification__list__box3-right":"Notification__list__box3-right","Notification__list__date":"Notification__list__date","Notification__list__text-mb":"Notification__list__text-mb","Notification__list__box":"Notification__list__box","Notification__list__box2":"Notification__list__box2","Accordion":"Accordion","Accordion__title":"Accordion__title","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","Slide":"Slide","slick-next":"slick-next","slick-prev":"slick-prev","slick-dots":"slick-dots","Accordion__container":"Accordion__container","open":"open","slick-slider":"slick-slider","slick-arrow":"slick-arrow","slick-list":"slick-list"};

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CreditPlan":"CreditPlan","tableOnGray":"tableOnGray","CreditPlan__credit-data__large-item__item":"CreditPlan__credit-data__large-item__item","CreditPlan__credit-data__small-item__item":"CreditPlan__credit-data__small-item__item","tableOnWhite":"tableOnWhite","CreditPlan__container":"CreditPlan__container","CreditPlan__header":"CreditPlan__header","CreditPlan__header-pc":"CreditPlan__header-pc","CreditPlan__header-mb":"CreditPlan__header-mb","CreditPlan__car-info":"CreditPlan__car-info","CreditPlan__car-info__box":"CreditPlan__car-info__box","CreditPlan__car-info__paragraph":"CreditPlan__car-info__paragraph","CreditPlan__car-info__images-pc":"CreditPlan__car-info__images-pc","CreditPlan__car-info__images-mb":"CreditPlan__car-info__images-mb","CreditPlan__car-info__grade":"CreditPlan__car-info__grade","CreditPlan__car-info__engine":"CreditPlan__car-info__engine","CreditPlan__car-info__body-type":"CreditPlan__car-info__body-type","CreditPlan__car-info__price":"CreditPlan__car-info__price","CreditPlan__credit-data":"CreditPlan__credit-data","CreditPlan__credit-data__heading":"CreditPlan__credit-data__heading","CreditPlan__credit-data__heading-pc":"CreditPlan__credit-data__heading-pc","CreditPlan__credit-data__heading-mb":"CreditPlan__credit-data__heading-mb","CreditPlan__credit-data__large-item":"CreditPlan__credit-data__large-item","CreditPlan__credit-data__large-item__items":"CreditPlan__credit-data__large-item__items","CreditPlan__credit-data__small-item":"CreditPlan__credit-data__small-item","CreditPlan__credit-data__small-item__items":"CreditPlan__credit-data__small-item__items","CreditPlan__credit-data__note":"CreditPlan__credit-data__note","CreditPlan__credit-data__note__description":"CreditPlan__credit-data__note__description","CreditPlan__credit-data__note__more-info":"CreditPlan__credit-data__note__more-info","CreditPlan__credit-data__note__more-info__link":"CreditPlan__credit-data__note__more-info__link","CreditPlan__credit-data__note__more-info__container":"CreditPlan__credit-data__note__more-info__container","CreditPlan__navigation":"CreditPlan__navigation","CreditPlan__navigation__heading":"CreditPlan__navigation__heading","CreditPlan__navigation__heading-pc":"CreditPlan__navigation__heading-pc","CreditPlan__navigation__heading-mb":"CreditPlan__navigation__heading-mb","CreditPlan__navigation__estimation-link":"CreditPlan__navigation__estimation-link","CreditPlan__navigation__lower-information":"CreditPlan__navigation__lower-information","ModalWindow":"ModalWindow","ModalWindow__link-close":"ModalWindow__link-close"};

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\owner-library\\index.jsx',
    _class2,
    _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














/**
 *  OwnerLibrary
 */
var OwnerLibrary = (_temp = _class = function (_Component) {
  _inherits(OwnerLibrary, _Component);

  function OwnerLibrary(props) {
    _classCallCheck(this, OwnerLibrary);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getBodyTypeImageSrc = function (vehicleType, modelName, carId, carTypeCode) {
      var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 's';
      var slanting = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var past = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

      //return '/assets-dev/assets/cars/atenza/atenza-sedan/gj12/common/default_' + size + '.png';
      //
      var str = '';
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/';
      } else {
        str = '/globalassets/assets/cars/';
      }
      str = str + modelName + '/';
      str = str + carId + '/';
      str = str + carTypeCode + '/';
      str = str + 'common/';
      //
      if (slanting) {
        if (past) {
          str = str + carId + '_past_chart_' + size + '.png';
        } else {
          str = str + carId + '_chart_' + size + '.png';
        }
      } else {
        if (vehicleType === 'Commercial Car') {
          str = str + 'commercial_default_' + size + '.png';
        } else {
          str = str + 'default_' + size + '.png';
        }
      }
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
    };

    _this.formatReleaseDate = function () {
      var YYYYMM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!YYYYMM || YYYYMM === '') return '';
      var str = String(YYYYMM).substr(0, 4) + '年';
      str = str + Number(String(YYYYMM).substr(4, 2)) + '月';
      return str;
    };

    _this.changeVehicleType = function (vehicleType) {
      _this.setState({
        currentVehicleType: vehicleType
      });
      // フェードインアニメーション
      _this.refs.changeBodyType.classList.remove('open');
      setTimeout(function () {
        _this.refs.changeBodyType.classList.add('open');
      }, 100);
    };

    _this.changeBodyType = function () {
      var modelName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var carId = arguments[1];

      var currentCarTypeCode = null;
      if (modelName) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.props.models.length; i < max; i = i + 1) {
          var model = _this.props.models[i];
          if (model.modelName === modelName) {
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
              var bodyType = model.bodyTypes[j];
              if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(bodyType.carId, carId)) {
                currentCarTypeCode = bodyType.defaultGeneration && bodyType.defaultGeneration !== '' ? bodyType.defaultGeneration : bodyType.defaultCarTypeCode || null;
              }
            }
          }
        }
      } else {
        var _i = void 0,
            _max = void 0;
        for (_i = 0, _max = _this.props.models.length; _i < _max; _i = _i + 1) {
          var _model = _this.props.models[_i];
          var modelNameTemp = _model.modelName;
          var _j = void 0,
              _max2 = void 0;
          for (_j = 0, _max2 = _model.bodyTypes.length; _j < _max2; _j = _j + 1) {
            var _bodyType = _model.bodyTypes[_j];
            // if (bodyType.carId === carId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(_bodyType.carId, carId)) {
              modelName = modelNameTemp;
              currentCarTypeCode = _bodyType.defaultGeneration && _bodyType.defaultGeneration !== '' ? _bodyType.defaultGeneration : _bodyType.defaultCarTypeCode || null;
            }
          }
        }
      }
      //
      _this.setState({
        currentStep: 1,
        currentModelName: modelName,
        currentCarId: carId,
        currentCarTypeCode: currentCarTypeCode
      });
      // フェードインアニメーション
      _this.refs.changeStep.classList.remove('open');
      setTimeout(function () {
        _this.refs.changeStep.classList.add('open');
      }, 100);
    };

    _this.backToSelectBodyType = function () {
      //
      _this.setState({
        currentStep: 0,
        currentVehicleType: 'Passenger Car',
        currentModelName: null,
        currentCarId: null,
        currentCarTypeCode: null
      });
      // フェードインアニメーション
      _this.refs.changeStep.classList.remove('open');
      setTimeout(function () {
        _this.refs.changeStep.classList.add('open');
      }, 100);
    };

    _this.changeGeneration = function (carTypeCode) {
      _this.setState({
        currentCarTypeCode: carTypeCode
      });
      // フェードインアニメーション
      _this.refs.changeGeneration.classList.remove('open');
      setTimeout(function () {
        _this.refs.changeGeneration.classList.add('open');
      }, 100);
      // アコーディオン閉じる
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.refsAccordionArr.length; i < max; i = i + 1) {
        var ref = _this.refsAccordionArr[i];
        if (ref && _this.refs[ref]) _this.refs[ref].close();
      }
      // if (this.refs.accordion) this.refs.accordion.close();
      // setTimeout(() => {
      //   if (this.refs.accordion) {
      //     this.refs.accordion.close();
      //   }
      // }, 1000);
      //
    };

    _this.openModal = function (vehicleLibraryItem) {
      _this.setState({
        vehicleLibraryItem: vehicleLibraryItem
      });
      //
      _this.refs.modalWindow.open('Light', 'Light');
      // BODYのスクロール無効化
      //BodyControl.openModal();
    };

    _this.onCloseModal = function () {
      // BODYのスクロール無効化を解除
      //BodyControl.closeModal();
    };

    _this.setCurrentByParams = function () {

      var setCurrent = function setCurrent(bodyTypeId, carTypeCode) {

        // BodyType情報取得
        var getBodyTypeInfo = function getBodyTypeInfo() {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this.props.models.length; i < max; i = i + 1) {
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = _this.props.models[i].bodyTypes.length; j < max2; j = j + 1) {
              // if (this.props.models[i].bodyTypes[j].carId === bodyTypeId) {
              if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(_this.props.models[i].bodyTypes[j].carId, bodyTypeId)) {
                return _this.props.models[i].bodyTypes[j];
              }
            }
          }
          return null;
        };
        var bodyTypeInfo = getBodyTypeInfo();
        if (bodyTypeInfo && carTypeCode) {

          // 世代情報取得
          var getGenerationInfo = function getGenerationInfo() {
            var i = void 0,
                max = void 0;
            for (i = 0, max = bodyTypeInfo.generation.length; i < max; i = i + 1) {
              // if (bodyTypeInfo.generation[i].carTypeCode === carTypeCode) {
              if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(bodyTypeInfo.generation[i].carTypeCode, carTypeCode)) {
                return bodyTypeInfo.generation[i];
              }
            }
            return null;
          };
          var generationInfo = getGenerationInfo();
          if (generationInfo) {
            // BodyType及び世代が存在した場合
            // ボディタイプ変更
            _this.changeBodyType(null, bodyTypeId);
            // 世代選択
            _this.changeGeneration(carTypeCode);
          } else {
            // BodyTypeのみ存在した場合
            // ボディタイプ変更
            _this.changeBodyType(null, bodyTypeId);
          }
        } else {
          // BodyTypeのみ存在した場合
          // ボディタイプ変更
          _this.changeBodyType(null, bodyTypeId);
        }
      };

      // URLパラメータでカレント変更
      var carId = __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].getUrlParameter('car_id');
      var carTypeCode = __WEBPACK_IMPORTED_MODULE_6__components_body__["a" /* default */].getUrlParameter('car_type_code');
      if (carId || carTypeCode) {
        if (carId && carTypeCode) {
          setCurrent(carId, carTypeCode);
        } else if (carId) {
          setCurrent(carId);
        }
      } else {

        // ブロックのCookieに保温されている値でカレント変更
        carId = Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["d" /* getCookie */])('mj_ombt');
        carTypeCode = Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["d" /* getCookie */])('mj_omgen');
        if (carId || carTypeCode) {
          if (carId && carTypeCode) {
            setCurrent(carId, carTypeCode);
          } else if (carId) {
            setCurrent(carId);
          }
        }
      }
      // setCookie('mj_ombt', 'CarId002');
      // setCookie('mj_omgen', 'Grade008');
    };

    _this.props = props;
    _this.state = {
      currentStep: 0,
      currentVehicleType: 'Passenger Car',
      currentModelName: null,
      currentCarId: null,
      currentCarTypeCode: null,
      vehicleLibraryItem: null,
      isMounted: false
    };
    _this.refsAccordionArr = [];
    _this.index = 0;
    return _this;
  }

  OwnerLibrary.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });

    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();
  };

  OwnerLibrary.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  OwnerLibrary.prototype.render = function render() {
    var _this2 = this;

    // ナビゲーション表示
    var renderNavigation = function renderNavigation() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'OwnerLibrary__navigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 119
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ol',
          { className: 'OwnerLibrary__navigation__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 120
            }
          },
          function () {
            if (_this2.state.currentStep === 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'current', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 124
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 125
                    }
                  },
                  '1'
                ),
                _this2.props.carSelectorLabel && _this2.props.carSelectorLabel !== '' ? _this2.props.carSelectorLabel : '車種選択'
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 131
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'OwnerLibrary__navigation__link',
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      // 車種選択に戻る
                      _this2.backToSelectBodyType();
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 132
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 140
                      }
                    },
                    '1'
                  ),
                  _this2.props.carSelectorLabel && _this2.props.carSelectorLabel !== '' ? _this2.props.carSelectorLabel : '車種選択'
                )
              );
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: _this2.state.currentStep === 1 ? 'current' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 147
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 148
                }
              },
              '2'
            ),
            _this2.props.generationSelectorLabel && _this2.props.generationSelectorLabel !== '' ? _this2.props.generationSelectorLabel : '発売年月選択'
          )
        ),
        function () {
          if (1 <= _this2.state.currentStep) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'OwnerLibrary__navigation__link-back',
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  // 車種選択に戻る
                  _this2.backToSelectBodyType();
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 155
                }
              },
              '\u8ECA\u7A2E\u9078\u629E\u306B\u623B\u308B'
            );
          } else {
            return null;
          }
        }()
      );
    };

    // 車種選択表示
    var renderVehicleTypeSelect = function renderVehicleTypeSelect() {
      if (_this2.state.currentStep === 0) {

        var getVehicleTypeArr = function getVehicleTypeArr() {
          var arr = [];
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
            var flg = true;
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
              if (arr[j].vehicleType === _this2.props.models[i].vehicleType) {
                flg = false;
              }
            }
            if (flg) {
              arr.push({
                vehicleType: _this2.props.models[i].vehicleType,
                vehicleTabName: _this2.props.models[i].vehicleTabName
              });
            }
          }
          return arr;
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__vehicle-type-select', __source: {
              fileName: _jsxFileName,
              lineNumber: 197
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'OwnerLibrary__vehicle-type-select__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 198
              }
            },
            getVehicleTypeArr().map(function (vehicleType, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 201
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'OwnerLibrary__vehicle-type-select__link' + (_this2.state.currentVehicleType === vehicleType.vehicleType ? ' current' : ''),
                    href: 'javascript:void(0);',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      // 車種変更
                      _this2.changeVehicleType(vehicleType.vehicleType);
                    },
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 202
                    }
                  },
                  vehicleType.vehicleTabName
                )
              );
            })
          )
        );
      } else {
        return null;
      }
    };

    // ボディタイプ選択表示
    var renderBodyTypeSelect = function renderBodyTypeSelect() {
      if (_this2.state.currentStep === 0) {

        var getBodyTypeArr = function getBodyTypeArr() {

          // いずれかの世代にPastLibraryURLかLibraryDataが存在しているか否か
          var isExistLibraryDate = function isExistLibraryDate(bodyType) {
            var i = void 0,
                max = void 0;
            for (i = 0, max = bodyType.generation.length; i < max; i = i + 1) {
              var generation = bodyType.generation[i];
              if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '') {
                return true;
              } else if (generation.vehicleLibraryData) {
                return true;
              }
            }
            return false;
          };

          // 全てのGenerationにPastLibraryUrlが設定されていたら、直接リンクにする
          var getPastLibraryUrl = function getPastLibraryUrl(bodyType) {
            var arr = [];
            var i = void 0,
                max = void 0;
            for (i = 0, max = bodyType.generation.length; i < max; i = i + 1) {
              var generation = bodyType.generation[i];
              if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '') {
                arr.push({
                  releaseDate: generation.releaseDate,
                  pastLibraryUrl: generation.pastLibraryUrl
                });
              } else {
                return null;
              }
            }
            // releaseDateでソート
            arr.sort(function (a, b) {
              if (a.releaseDate > b.releaseDate) return -1;
              if (a.releaseDate < b.releaseDate) return 1;
              return 0;
            });
            return arr[0].pastLibraryUrl;
          };

          var arr = [];
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
            var model = _this2.props.models[i];
            if (_this2.state.currentVehicleType === model.vehicleType) {
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                var bodyType = model.bodyTypes[j];

                // すべての世代にPastLibraryURLもLibraryDataもなければ一覧に表示しない
                if (isExistLibraryDate(bodyType) === true) {
                  arr.push({
                    modelName: model.modelName,
                    vehicleType: model.vehicleType,
                    carId: bodyType.carId,
                    bodyTypeModel: bodyType.bodyTypeModelShort || bodyType.bodyTypeModelJa || bodyType.bodyTypeModel,
                    carTypeCode: bodyType.defaultGeneration && bodyType.defaultGeneration !== '' ? bodyType.defaultGeneration : bodyType.defaultCarTypeCode || null,
                    pastLibraryUrl: getPastLibraryUrl(bodyType) // 全てのGenerationにPastLibraryUrlが設定されていたら、直接リンクにする
                  });
                }
              }
            }
          }
          return arr;
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__body-type-select', __source: {
              fileName: _jsxFileName,
              lineNumber: 293
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'OwnerLibrary__body-type-select__list', __source: {
                fileName: _jsxFileName,
                lineNumber: 294
              }
            },
            getBodyTypeArr().map(function (bodyType, index) {
              if (bodyType.pastLibraryUrl && bodyType.pastLibraryUrl !== '') {
                // すべてのGenerationにこれが設定されていたら直接リンクとする。
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 299
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'OwnerLibrary__body-type-select__link', href: bodyType.pastLibraryUrl, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 300
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'OwnerLibrary__body-type-select__image-wrapper', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 301
                        }
                      },
                      _this2.state.isMounted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'OwnerLibrary__body-type-select__image',
                        src: _this2.getBodyTypeImageSrc(bodyType.vehicleType, bodyType.modelName, bodyType.carId, bodyType.carTypeCode), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 303
                        }
                      }) : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'OwnerLibrary__body-type-select__text-wrapper', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 307
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_11__utils__["h" /* convertPipeToBrTag */])(bodyType.bodyTypeModel) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 307
                        }
                      })
                    )
                  )
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 313
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'OwnerLibrary__body-type-select__link',
                      href: 'javascript:void(0);',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        // ボディタイプ変更
                        _this2.changeBodyType(bodyType.modelName, bodyType.carId);

                        // ブロックのCookieに保存
                        Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["h" /* setCookie */])('mj_ombt', Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["b" /* formatId */])(bodyType.carId));
                        Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["g" /* removeCookie */])('mj_omgen');
                      },
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 314
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'OwnerLibrary__body-type-select__image-wrapper', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 327
                        }
                      },
                      _this2.state.isMounted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'OwnerLibrary__body-type-select__image',
                        src: _this2.getBodyTypeImageSrc(bodyType.vehicleType, bodyType.modelName, bodyType.carId, bodyType.carTypeCode), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 329
                        }
                      }) : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'OwnerLibrary__body-type-select__text-wrapper', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 333
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_11__utils__["h" /* convertPipeToBrTag */])(bodyType.bodyTypeModel) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 333
                        }
                      })
                    )
                  )
                );
              }
            })
          )
        );
      } else {
        return null;
      }
    };

    // 世代選択表示
    var renderGenerationSelect = function renderGenerationSelect() {
      if (_this2.state.isMounted === true && _this2.state.currentStep === 1) {

        var getCurrentBodyTypeModel = function getCurrentBodyTypeModel() {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
            var model = _this2.props.models[i];
            if (model.modelName === _this2.state.currentModelName) {
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                var bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(bodyType.carId, _this2.state.currentCarId)) {
                  return bodyType.bodyTypeModelShort || bodyType.bodyTypeModelJa || bodyType.bodyTypeModel;
                }
              }
            }
          }
          return '';
        };

        var getGenerationArr = function getGenerationArr() {
          var arr = [];
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
            var model = _this2.props.models[i];
            if (model.modelName === _this2.state.currentModelName) {
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                var bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(bodyType.carId, _this2.state.currentCarId)) {
                  var k = void 0,
                      max3 = void 0;
                  for (k = 0, max3 = bodyType.generation.length; k < max3; k = k + 1) {
                    var generation = bodyType.generation[k];
                    arr.push({
                      carTypeCode: generation.carTypeCode,
                      releaseDate: generation.releaseDate ? generation.releaseDate : null,
                      pastLibraryUrl: generation.pastLibraryUrl ? generation.pastLibraryUrl : null
                    });
                  }
                }
              }
            }
          }
          // releaseDateでソート
          arr.sort(function (a, b) {
            if (a.releaseDate > b.releaseDate) return -1;
            if (a.releaseDate < b.releaseDate) return 1;
            return 0;
          });
          // 一番初めのPastLibraryURL以外をまとめる
          var arr2 = [];
          for (i = 0, max = arr.length; i < max; i = i + 1) {
            arr2.push(arr[i]);
            if (arr[i].pastLibraryUrl && arr[i].pastLibraryUrl !== '') {
              break;
            }
          }
          arr = arr2;
          //
          return arr;
        };

        // 世代アイテム表示
        var renderGenerationItem = function renderGenerationItem(generation) {
          if (generation.pastLibraryUrl && generation.pastLibraryUrl !== '') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'OwnerLibrary__generation-select__link-generation' + (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(_this2.state.currentCarTypeCode, generation.carTypeCode) ? ' current' : ''),
                href: generation.pastLibraryUrl,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 416
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 419
                  }
                },
                _this2.formatReleaseDate(generation.releaseDate),
                '\u4EE5\u524D'
              ),
              _this2.state.isMounted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'OwnerLibrary__generation-select__image-generation',
                src: _this2.getBodyTypeImageSrc(_this2.state.currentVehicleType, _this2.state.currentModelName, _this2.state.currentCarId, generation.carTypeCode, 's', true, true), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 421
                }
              }) : null
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'OwnerLibrary__generation-select__link-generation' + (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(_this2.state.currentCarTypeCode, generation.carTypeCode) ? ' current' : ''),
                href: 'javascript:void(0);',
                onClick: function onClick(e) {
                  e.preventDefault();
                  // 世代選択
                  _this2.changeGeneration(generation.carTypeCode);

                  // ブロックのCookieに保存
                  Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["h" /* setCookie */])('mj_ombt', Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["b" /* formatId */])(_this2.state.currentCarId));
                  Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["h" /* setCookie */])('mj_omgen', Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["b" /* formatId */])(generation.carTypeCode));
                },
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 428
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 441
                  }
                },
                _this2.formatReleaseDate(generation.releaseDate),
                '\u301C'
              ),
              _this2.state.isMounted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'OwnerLibrary__generation-select__image-generation',
                src: _this2.getBodyTypeImageSrc(_this2.state.currentVehicleType, _this2.state.currentModelName, _this2.state.currentCarId, generation.carTypeCode, 's', true), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 443
                }
              }) : null
            );
          }
        };

        var generationArr = getGenerationArr();

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__generation-select', __source: {
              fileName: _jsxFileName,
              lineNumber: 454
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'OwnerLibrary__generation-select__heading', __source: {
                fileName: _jsxFileName,
                lineNumber: 455
              }
            },
            getCurrentBodyTypeModel()
          ),
          function () {
            if ((__WEBPACK_IMPORTED_MODULE_9__constants_environment__["g" /* IS_MOBILE */] === true ? 3 : 7) <= generationArr.length) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__components_slider__["a" /* default */],
                { settings: {
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 1000,
                    ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                    fade: false,
                    infinite: true,
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    swipe: true,
                    draggable: false,
                    arrows: true,
                    dots: false,
                    adaptiveHeight: false,
                    centerMode: false,
                    centerPadding: 0,
                    //waitForAnimate: false,
                    lazyLoad: 'progressive',
                    responsive: [{
                      breakpoint: 767,
                      settings: {
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                        dots: true,
                        centerMode: false
                        //centerPadding: '10%',
                      }
                    }]
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 459
                  }
                },
                generationArr.map(function (generation, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'OwnerLibrary__generation-select__box', key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 494
                      }
                    },
                    renderGenerationItem(generation)
                  );
                })
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'OwnerLibrary__generation-select__list-generation', style: { width: generationArr.length * 16.5 + '%' }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 503
                  }
                },
                generationArr.map(function (generation, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 506
                      }
                    },
                    renderGenerationItem(generation)
                  );
                })
              );
            }
          }()
        );
      } else {
        return null;
      }
    };

    // ライブラリデータ表示
    var renderLibraryData = function renderLibraryData() {
      if (_this2.state.currentStep === 1) {

        var getCurrentGenerationInfo = function getCurrentGenerationInfo() {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
            var model = _this2.props.models[i];
            if (model.modelName === _this2.state.currentModelName) {
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                var bodyType = model.bodyTypes[j];
                // if (bodyType.carId === this.state.currentCarId) {
                if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(bodyType.carId, _this2.state.currentCarId)) {
                  var k = void 0,
                      max3 = void 0;
                  for (k = 0, max3 = bodyType.generation.length; k < max3; k = k + 1) {
                    var generation = bodyType.generation[k];
                    // if (generation.carTypeCode === this.state.currentCarTypeCode) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["f" /* isEqualId */])(generation.carTypeCode, _this2.state.currentCarTypeCode)) {
                      return generation;
                    }
                  }
                }
              }
            }
          }
          return null;
        };

        var generationInfo = getCurrentGenerationInfo();
        var vinData = generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.vinData ? generationInfo.vehicleLibraryData.vinData : null;
        var information = generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.information ? generationInfo.vehicleLibraryData.information : null;
        var freeArea = generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.freeArea ? generationInfo.vehicleLibraryData.freeArea : null;
        var releaseDate = generationInfo && generationInfo.releaseDate ? generationInfo.releaseDate : null;
        var libraryCategory = generationInfo && generationInfo.vehicleLibraryData && generationInfo.vehicleLibraryData.vehicleLibraryCategory ? generationInfo.vehicleLibraryData.vehicleLibraryCategory : null;

        // ライブラリカテゴリ表示
        var renderLibraryCategory = function renderLibraryCategory() {
          if (libraryCategory && 1 <= libraryCategory.length) {

            // アコーディオン表示
            var renderAccordion = function renderAccordion(category) {
              // 日付でソート
              category.vehicleLibraryItems.sort(function (a, b) {
                if (a.releaseDate > b.releaseDate) return -1;
                if (a.releaseDate < b.releaseDate) return 1;
                return 0;
              });

              _this2.index = _this2.index + 1;
              var ref = 'accordion' + _this2.index;
              _this2.refsAccordionArr.push(ref);

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__components_accordion__["a" /* default */],
                {
                  pageName: category.manualCategory,
                  pcText: category.manualCategory,
                  mbText: category.manualCategory,
                  enabled: true,
                  ref: ref,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 576
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'OwnerLibrary__library-data__list-ul', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 583
                    }
                  },
                  category.vehicleLibraryItems.map(function (vehicleLibraryItem, index) {
                    if (vehicleLibraryItem.linkFunction === 'Direct-Link') {
                      var iconClass = '';
                      if (vehicleLibraryItem.linkIcon1 === 'PDF') {
                        iconClass = ' pdf';
                      } else if (vehicleLibraryItem.linkIcon1 === 'E-Book') {
                        iconClass = ' e-book';
                      } else if (vehicleLibraryItem.linkIcon1 === 'Link') {
                        if (vehicleLibraryItem.linkTarget1 === true) {
                          iconClass = ' blank';
                        } else {
                          iconClass = ' link';
                        }
                      }
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 599
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'OwnerLibrary__library-data__link-modal2' + iconClass,
                            href: vehicleLibraryItem.linkItem1,
                            target: vehicleLibraryItem.linkTarget1 === true ? '_blank' : '',
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 600
                            }
                          },
                          _this2.formatReleaseDate(vehicleLibraryItem.releaseDate),
                          '\u301C'
                        )
                      );
                    } else {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 608
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'OwnerLibrary__library-data__link-modal2',
                            href: 'javascript:void(0);',
                            onClick: function onClick(e) {
                              e.preventDefault();
                              // モーダル開く
                              _this2.openModal(vehicleLibraryItem);
                            },
                            __source: {
                              fileName: _jsxFileName,
                              lineNumber: 609
                            }
                          },
                          _this2.formatReleaseDate(vehicleLibraryItem.releaseDate),
                          '\u301C'
                        )
                      );
                    }
                  })
                )
              );
            };

            // 直接リンク表示
            var renderDirectLink = function renderDirectLink(category) {
              var item = category.vehicleLibraryItems[0];
              var iconClass = '';
              if (item.linkIcon1 === 'PDF') {
                iconClass = ' pdf';
              } else if (item.linkIcon1 === 'E-Book') {
                iconClass = ' e-book';
              } else if (item.linkIcon1 === 'Link') {
                if (item.linkTarget1 === true) {
                  iconClass = ' blank';
                } else {
                  iconClass = ' link';
                }
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'OwnerLibrary__library-data__link-direct' + iconClass,
                  href: item.linkItem1,
                  target: item.linkTarget1 === true ? '_blank' : '',
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 642
                  }
                },
                category.manualCategory
              );
            };

            // 規約同意リンク表示
            var renderModalLink = function renderModalLink(category) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'OwnerLibrary__library-data__link-modal',
                  href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    // モーダル開く
                    _this2.openModal(category.vehicleLibraryItems[0]);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 652
                  }
                },
                category.manualCategory
              );
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'OwnerLibrary__library-data__category', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 664
                }
              },
              libraryCategory.map(function (category, index) {
                if (category.useVersionControl === true) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 668
                      }
                    },
                    renderAccordion(category)
                  );
                } else {
                  if (category.vehicleLibraryItems[0].linkFunction === 'Direct-Link') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 677
                        }
                      },
                      renderDirectLink(category)
                    );
                  } else if (category.vehicleLibraryItems[0].linkFunction === 'Modal-Agreement-Window') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 685
                        }
                      },
                      renderModalLink(category)
                    );
                  } else {
                    return null;
                  }
                }
              })
            );
          } else {
            return null;
          }
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__library-data', __source: {
              fileName: _jsxFileName,
              lineNumber: 704
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'OwnerLibrary__library-data__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 705
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'OwnerLibrary__library-data__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 706
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'OwnerLibrary__library-data__box-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 707
                  }
                },
                _this2.state.isMounted === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'OwnerLibrary__library-data__image-generation',
                  src: _this2.getBodyTypeImageSrc(_this2.state.currentVehicleType, _this2.state.currentModelName, _this2.state.currentCarId, _this2.state.currentCarTypeCode, 'l', true), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 709
                  }
                }) : null,
                releaseDate && releaseDate !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'OwnerLibrary__library-data__release-date', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 713
                    }
                  },
                  '\u767A\u58F2\u5E74\u6708 : ',
                  _this2.formatReleaseDate(generationInfo.releaseDate),
                  '\u301C'
                ) : null,
                vinData && vinData !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'OwnerLibrary__library-data__vin-data Wysiwyg', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 716
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: vinData }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 717
                    }
                  })
                ) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'OwnerLibrary__library-data__box-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 721
                  }
                },
                _this2.props.libraryTitle && _this2.props.libraryTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h5',
                  { className: 'OwnerLibrary__library-data__heading', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 723
                    }
                  },
                  _this2.props.libraryTitle
                ) : null,
                renderLibraryCategory(),
                information && information !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'OwnerLibrary__library-data__information Wysiwyg', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 729
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: information }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 730
                    }
                  })
                ) : null
              )
            )
          ),
          freeArea && 1 <= freeArea.length ? Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["c" /* getComponents */])(freeArea) : null
        );
      } else {
        return null;
      }
    };

    // モーダル内アイテム表示
    var renderModalItem = function renderModalItem() {
      if (_this2.state.vehicleLibraryItem) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalItem, _extends({
          linkItem1: _this2.state.vehicleLibraryItem.linkItem1 || null,
          linkTarget1: _this2.state.vehicleLibraryItem.linkTarget1 || null,
          linkButtonTitle1: _this2.state.vehicleLibraryItem.linkButtonTitle1 || null,
          linkIcon1: _this2.state.vehicleLibraryItem.linkIcon1 || null,
          linkUpdatedate1: _this2.state.vehicleLibraryItem.linkUpdatedate1 || null,
          linkItem2: _this2.state.vehicleLibraryItem.linkItem2 || null,
          linkTarget2: _this2.state.vehicleLibraryItem.linkTarget2 || null,
          linkButtonTitle2: _this2.state.vehicleLibraryItem.linkButtonTitle2 || null,
          linkIcon2: _this2.state.vehicleLibraryItem.linkIcon2 || null,
          linkUpdatedate2: _this2.state.vehicleLibraryItem.linkUpdatedate2 || null,
          titleAndPreText: _this2.state.vehicleLibraryItem.titleAndPreText || null,
          agreementText: _this2.state.vehicleLibraryItem.agreementText || null,
          linkAreaTitle: _this2.state.vehicleLibraryItem.linkAreaTitle || null,
          lowerDescription: _this2.state.vehicleLibraryItem.lowerDescription || null
        }, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 748
          }
        }));
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 771
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'OwnerLibrary', __source: {
            fileName: _jsxFileName,
            lineNumber: 777
          }
        },
        renderNavigation(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__fade-in-container open', ref: 'changeStep', __source: {
              fileName: _jsxFileName,
              lineNumber: 782
            }
          },
          renderVehicleTypeSelect(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'OwnerLibrary__fade-in-container open', ref: 'changeBodyType', __source: {
                fileName: _jsxFileName,
                lineNumber: 786
              }
            },
            renderBodyTypeSelect(),
            renderGenerationSelect(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'OwnerLibrary__fade-in-container open', ref: 'changeGeneration', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 792
                }
              },
              renderLibraryData()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__components_modal_window__["a" /* default */],
          { ref: 'modalWindow', type: 'Light', onClose: this.onCloseModal, __source: {
              fileName: _jsxFileName,
              lineNumber: 799
            }
          },
          renderModalItem()
        )
      )
    );
  };

  // ボディタイプ画像パス取得


  // YYYYMMをYYYY年M月〜にフォーマト


  // 車種変更


  // ボディタイプ変更


  // 車種選択に戻る


  // 世代選択


  // モーダルウィンドウ開く


  // モーダルウィンドウ閉じる


  // URLパラメータでダイレクト遷移


  return OwnerLibrary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.iconCatalogWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAhFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fWf706wAAAAK3RSTlMALSLWiO4XEQj48ubgy6+klY+BWEME+9HCm3xybGBNKAzcuKpqST85MCkcqGTk5QAAAMhJREFUOMvt08cOwjAMgOG06d57L/bw+78fAYOE1NKaI+O/RHK+Qw4x++iGiJsw3cjqHDAKDuANbAMEJ3ncbgqLWcImkl5gHhtkLLLKPRFjq0omYU9FX7TDMpaM2MvwOX6yiMWh1TnccpR+AeN1aKN3m3mMpd0Gv8kixvTGpWOh/viLsQoQpVTsi6FaJikJaw5cs8MDATM9VB87cnzCmqIobCKj8y30POoRzyZW1kSfB4jn09t1BvcYIW1bEDF2rl3ExOSKsx/rApVXQcsPEbyfAAAAAElFTkSuQmCC', _class.iconCatalogBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAeFBMVEUAAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBALOulEAAAAJ3RSTlMALSIT+NaI7JQG8eXLr6SBa1hMQigZ/ODRwpuOfHJgDQncuKo+OSFdjNTAAAAAxUlEQVQ4y+3TRw7DIBBAURwbDO69t1Tuf8OYTBaRTMJkmfKX8ISQBshHN8fUkfo21qYSwmAu38C+lLzYbct0eF3LiSbrCabpgsUqrzshMbQfLigcuuDbaTZjS6QhzMWJciNWsxkbON5nhQHDdu+CDxITVonsCNcxYshOAjRW6o+/GLtSxgKLo3XR7XIcLmt48/yMwMTuPXmrZtYDLhljRJPIoruncQH4ZQt82bWGK2zKng4VeMBGn7QVYFzlGABGthso+bGuhwk7oDpyF+gAAAAASUVORK5CYII=', _class.iconPdfWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAWlBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVogrzXAAAAHXRSTlMAf4dLlvvn3/HuYhLZ0nwi9XQ6Hg3FwKprWVNFM5Cqxq4AAAC4SURBVDjL5dTHDoNADEXRR5lCCYSSnvf/v5kBCSabwbBIkbhL6ywsWTJ2Exf6PJb7LiapTjVSkjoGYg4FsTKWZ4e1JiOHtTEmiA/oFIuUCRpqhxMAC7hX7AZckEVMm2V5ENtLyRID7mXsMs8R5/IaZV0DDmtDVvLOGDFpKrzhPz63hMMzTv0cY2wjjlZhb62MvW1FPNtjCxHP9iEfarIqgYS9vUPC3t4gYG+Zb3i5V6zHDdbjCrvrBVmbLH2hjickAAAAAElFTkSuQmCC', _class.iconPdfBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAXVBMVEUAAAAICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAhtHcNnAAAAHnRSTlMAf0qWh/vn3vEg7mIS2dL1fXQ1DQLFwKqKa1lTPgRZ37mdAAAAu0lEQVQ4y+XUyQ6DMAxF0QclCWFomTq37/8/swkSpBswLDpI3KV1FpYsGZuJM30ey30Xk1RHix1JfemQ0DeJlUl5clhrMnJYG2Mm8R5WsdgxRk3tcAxgBreK1uOCLBKmWZZP4vRcsoTHrYxdpulxLq9RWvuEw9qQlbwz4DFpou4N//G5BTwz49DPMfpW4mgRDjaVcbCNiEd7eEDEo43lQw1WxZBwsHdIONgbBBws8xUv94rluMZyXGFzvQDdBi4JXvW1vAAAAABJRU5ErkJggg==', _class.iconBlankWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC', _class.iconBlankBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC', _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carSelectorLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  generationSelectorLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  libraryTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    generation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      pastLibraryUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      releaseDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      vehicleLibraryData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        vinData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        information: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        freeArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
        vehicleLibraryCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          manualCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
          vehicleLibraryItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            linkFunction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkItem1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkTarget1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
            linkIcon1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            releaseDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkButtonTitle1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkUpdatedate1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkItem2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkTarget2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
            linkButtonTitle2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkIcon2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            linkUpdatedate2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            titleAndPreText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            agreementText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
            linkAreaTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            lowerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
          }))
        }))
      })
    })
  })
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  carSelectorLabel: null,
  generationSelectorLabel: null,
  libraryTitle: null,
  modelName: null,
  bodyType: null
}, _temp);
OwnerLibrary.displayName = 'OwnerLibrary';


/* harmony default export */ __webpack_exports__["a"] = (OwnerLibrary);

var ModalItem = (_temp2 = _class2 = function (_Component2) {
  _inherits(ModalItem, _Component2);

  function ModalItem(props) {
    _classCallCheck(this, ModalItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.formatReleaseDate = function () {
      var YYYYMMDD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!YYYYMMDD || YYYYMMDD === '') return '';
      var str = String(YYYYMMDD).substr(0, 4) + '年';
      str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
      str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
      return str;
    };

    _this3.props = props;
    return _this3;
  }

  ModalItem.prototype.render = function render() {
    var _this4 = this;

    var renderLink = function renderLink(linkItem, linkTarget, linkButtonTitle, linkIcon, linkUpdatedate) {
      if (linkItem && linkItem !== '' && linkButtonTitle && linkButtonTitle !== '') {
        var iconSrc = null;
        var hoverIconSrc = null;
        var linkType = 'Button';
        if (linkIcon === 'PDF') {
          iconSrc = OwnerLibrary.iconPdfBlack;
          hoverIconSrc = OwnerLibrary.iconPdfWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'E-Book') {
          iconSrc = OwnerLibrary.iconCatalogBlack;
          hoverIconSrc = OwnerLibrary.iconCatalogWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'Link') {
          if (linkTarget === true) {
            iconSrc = OwnerLibrary.iconBlankBlack;
            hoverIconSrc = OwnerLibrary.iconBlankWhite;
            linkType = 'Button-With-Icon';
          } else {
            iconSrc = null;
            hoverIconSrc = null;
            linkType = 'Button';
          }
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1118
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks__["Cta"], _extends({
            ctaType: 'Free',
            href: linkItem,
            text: linkButtonTitle,
            targetBlank: linkTarget === true ? true : false,
            linkType: linkType,
            color: 'Dark',
            buttonStyle: 'Standard',
            iconSrc: iconSrc,
            hoverIconSrc: hoverIconSrc
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1119
            }
          })),
          linkUpdatedate && linkUpdatedate !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'OwnerLibrary__modal-item__update', __source: {
                fileName: _jsxFileName,
                lineNumber: 1132
              }
            },
            '\u66F4\u65B0\u65E5\uFF1A',
            _this4.formatReleaseDate(linkUpdatedate)
          ) : null
        );
      } else {
        return null;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'OwnerLibrary__modal-item', __source: {
          fileName: _jsxFileName,
          lineNumber: 1141
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'OwnerLibrary__modal-item__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 1142
          }
        },
        this.props.titleAndPreText && this.props.titleAndPreText !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'OwnerLibrary__modal-item__header Wysiwyg', dangerouslySetInnerHTML: { __html: this.props.titleAndPreText }, __source: {
            fileName: _jsxFileName,
            lineNumber: 1144
          }
        }) : null,
        this.props.agreementText && this.props.agreementText instanceof Array && 1 <= this.props.agreementText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'OwnerLibrary__modal-item__agreement', __source: {
              fileName: _jsxFileName,
              lineNumber: 1147
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_10__utilities__["c" /* getComponents */])(this.props.agreementText)
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'OwnerLibrary__modal-item__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 1149
            }
          },
          this.props.linkAreaTitle && this.props.linkAreaTitle !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1151
              }
            },
            this.props.linkAreaTitle
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1153
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'OwnerLibrary__modal-item__list-ul', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1154
                }
              },
              renderLink(this.props.linkItem1, this.props.linkTarget1, this.props.linkButtonTitle1, this.props.linkIcon1, this.props.linkUpdatedate1),
              renderLink(this.props.linkItem2, this.props.linkTarget2, this.props.linkButtonTitle2, this.props.linkIcon2, this.props.linkUpdatedate2)
            )
          )
        ),
        this.props.lowerDescription && this.props.lowerDescription !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'OwnerLibrary__modal-item__description Wysiwyg', dangerouslySetInnerHTML: { __html: this.props.lowerDescription }, __source: {
            fileName: _jsxFileName,
            lineNumber: 1161
          }
        }) : null
      )
    );
  };

  // YYYYMMをYYYY年M月D日にフォーマト


  return ModalItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  linkItem1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkTarget1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  linkButtonTitle1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkIcon1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkUpdatedate1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkItem2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkTarget2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  linkButtonTitle2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkIcon2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkUpdatedate2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  titleAndPreText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  agreementText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  linkAreaTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lowerDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class2.defaultProps = {
  linkItem1: null,
  linkTarget1: false,
  linkButtonTitle1: null,
  linkIcon1: null,
  linkUpdatedate1: null,
  linkItem2: null,
  linkTarget2: false,
  linkButtonTitle2: null,
  linkIcon2: null,
  linkUpdatedate2: null,
  titleAndPreText: null,
  agreementText: null,
  linkAreaTitle: null,
  lowerDescription: null
}, _temp2);
ModalItem.displayName = 'ModalItem';

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OwnerLibrary":"OwnerLibrary","OwnerLibrary__fade-in-container":"OwnerLibrary__fade-in-container","open":"open","OwnerLibrary__navigation":"OwnerLibrary__navigation","OwnerLibrary__navigation__list":"OwnerLibrary__navigation__list","current":"current","OwnerLibrary__navigation__link":"OwnerLibrary__navigation__link","OwnerLibrary__navigation__link-back":"OwnerLibrary__navigation__link-back","OwnerLibrary__vehicle-type-select":"OwnerLibrary__vehicle-type-select","OwnerLibrary__vehicle-type-select__list":"OwnerLibrary__vehicle-type-select__list","OwnerLibrary__vehicle-type-select__link":"OwnerLibrary__vehicle-type-select__link","OwnerLibrary__body-type-select":"OwnerLibrary__body-type-select","OwnerLibrary__body-type-select__list":"OwnerLibrary__body-type-select__list","OwnerLibrary__body-type-select__link":"OwnerLibrary__body-type-select__link","OwnerLibrary__body-type-select__image-wrapper":"OwnerLibrary__body-type-select__image-wrapper","OwnerLibrary__body-type-select__image":"OwnerLibrary__body-type-select__image","OwnerLibrary__generation-select":"OwnerLibrary__generation-select","OwnerLibrary__generation-select__heading":"OwnerLibrary__generation-select__heading","OwnerLibrary__generation-select__list-generation":"OwnerLibrary__generation-select__list-generation","OwnerLibrary__generation-select__link-generation":"OwnerLibrary__generation-select__link-generation","OwnerLibrary__generation-select__image-generation":"OwnerLibrary__generation-select__image-generation","OwnerLibrary__generation-select__box":"OwnerLibrary__generation-select__box","OwnerLibrary__library-data":"OwnerLibrary__library-data","OwnerLibrary__library-data__container":"OwnerLibrary__library-data__container","OwnerLibrary__library-data__box":"OwnerLibrary__library-data__box","OwnerLibrary__library-data__box-left":"OwnerLibrary__library-data__box-left","OwnerLibrary__library-data__box-right":"OwnerLibrary__library-data__box-right","OwnerLibrary__library-data__vin-data":"OwnerLibrary__library-data__vin-data","OwnerLibrary__library-data__heading":"OwnerLibrary__library-data__heading","OwnerLibrary__library-data__image-generation":"OwnerLibrary__library-data__image-generation","OwnerLibrary__library-data__release-date":"OwnerLibrary__library-data__release-date","OwnerLibrary__library-data__list-ul":"OwnerLibrary__library-data__list-ul","OwnerLibrary__library-data__category":"OwnerLibrary__library-data__category","OwnerLibrary__library-data__link-direct":"OwnerLibrary__library-data__link-direct","link":"link","blank":"blank","pdf":"pdf","e-book":"e-book","OwnerLibrary__library-data__link-modal":"OwnerLibrary__library-data__link-modal","OwnerLibrary__library-data__link-modal2":"OwnerLibrary__library-data__link-modal2","OwnerLibrary__library-data__information":"OwnerLibrary__library-data__information","OwnerLibrary__modal-item":"OwnerLibrary__modal-item","OwnerLibrary__modal-item__container":"OwnerLibrary__modal-item__container","OwnerLibrary__modal-item__header":"OwnerLibrary__modal-item__header","OwnerLibrary__modal-item__agreement":"OwnerLibrary__modal-item__agreement","OwnerLibrary__modal-item__list-dl":"OwnerLibrary__modal-item__list-dl","OwnerLibrary__modal-item__list-ul":"OwnerLibrary__modal-item__list-ul","OwnerLibrary__modal-item__update":"OwnerLibrary__modal-item__update","OwnerLibrary__modal-item__description":"OwnerLibrary__modal-item__description","ModalWindow":"ModalWindow","ModalWindow__link-close":"ModalWindow__link-close","Accordion--enabled":"Accordion--enabled","Accordion__title":"Accordion__title","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","Accordion__container":"Accordion__container","Accordion__contents":"Accordion__contents","Slide":"Slide","slick-arrow":"slick-arrow","OwnerLibrary__heading":"OwnerLibrary__heading","OwnerLibrary__body-type-select__text-wrapper":"OwnerLibrary__body-type-select__text-wrapper","slick-slider":"slick-slider","slick-next":"slick-next","slick-prev":"slick-prev","slick-list":"slick-list","slick-dots":"slick-dots"};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccordionItem":"AccordionItem","AccordionItem__container":"AccordionItem__container","AccordionItem__container__title":"AccordionItem__container__title","AccordionItem__container__title__icon":"AccordionItem__container__title__icon","AccordionItem__container__title__icon__v":"AccordionItem__container__title__icon__v","AccordionItem__container__title__icon__h":"AccordionItem__container__title__icon__h","AccordionItem__container__title__text--mb":"AccordionItem__container__title__text--mb","AccordionItem__container__content":"AccordionItem__container__content","AccordionItem__container__inner":"AccordionItem__container__inner","AccordionItem__container--Dark":"AccordionItem__container--Dark","AccordionItem__container--Light":"AccordionItem__container--Light","AccordionItem__container--open":"AccordionItem__container--open","AccordionItem__container--close":"AccordionItem__container--close","AccordionItem__container__title__text--pc":"AccordionItem__container__title__text--pc"};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccordionContainer":"AccordionContainer","AccordionContainer__container":"AccordionContainer__container","AccordionContainer__container__title":"AccordionContainer__container__title","AccordionContainer__container__title__text--pc":"AccordionContainer__container__title__text--pc","AccordionContainer__container__title__text--mb":"AccordionContainer__container__title__text--mb","AccordionContainer__container__list":"AccordionContainer__container__list","AccordionContainer__container__list__item":"AccordionContainer__container__list__item","AccordionContainer__container--Dark":"AccordionContainer__container--Dark","AccordionContainer__container--Light":"AccordionContainer__container--Light","TwoColumnLayout__column":"TwoColumnLayout__column","TwoColumnLayout__firstContent":"TwoColumnLayout__firstContent","TwoColumnLayout__secondContent":"TwoColumnLayout__secondContent"};

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AnchorNavigation":"AnchorNavigation","show":"show","AnchorNavigation__container":"AnchorNavigation__container","AnchorNavigation__container__list":"AnchorNavigation__container__list","AnchorNavigation__container__list__item":"AnchorNavigation__container__list__item","AnchorNavigation__container__list__item__link":"AnchorNavigation__container__list__item__link","current":"current","AnchorNavigation__container__list__item__link__text":"AnchorNavigation__container__list__item__link__text","AnchorNavigation__container__handle":"AnchorNavigation__container__handle","open":"open","hasTouch":"hasTouch","DammyBlock":"DammyBlock","DammyBlock--blank":"DammyBlock--blank"};

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\breadcrumb-navigation\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 *  BreadcrumbNavigation
 */
var BreadcrumbNavigation = (_temp = _class = function (_Component) {
  _inherits(BreadcrumbNavigation, _Component);

  function BreadcrumbNavigation(props) {
    _classCallCheck(this, BreadcrumbNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onResize = function (e) {
      _this.setPosition();
    };

    _this.setPosition = function () {
      var container = _this.refs.container;
      var list = _this.refs.list;
      var containerWidth = container.getBoundingClientRect().width;
      var totalWidth = 0;

      for (var i = 0; i < list.childNodes.length; i++) {
        var child = list.childNodes[i];
        totalWidth += child.getBoundingClientRect().width;
      }

      container.classList.remove('BreadcrumbNavigation__container--overflow');
      if (containerWidth < totalWidth) {
        container.classList.add('BreadcrumbNavigation__container--overflow');
      }
    };

    _this.setDevice = function () {
      if (__WEBPACK_IMPORTED_MODULE_3__constants_environment__["j" /* NAVIGATOR */]) {
        var ua = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["j" /* NAVIGATOR */].userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
          return;
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
          var container = _this.refs.container;
          var list = _this.refs.list;
          var containerWidth = container.getBoundingClientRect().width;
          var totalWidth = 0;

          for (var i = 0; i < list.childNodes.length; i++) {
            var child = list.childNodes[i];
            totalWidth += child.getBoundingClientRect().width;
          }

          container.classList.add('BreadcrumbNavigation__container--tablet');

          if (containerWidth < totalWidth) {
            container.scrollLeft = totalWidth - containerWidth;
          }
        }
      }
    };

    _this.props = props;

    _this.state = {
      didMount: false
    };
    return _this;
  }

  BreadcrumbNavigation.prototype.componentDidMount = function componentDidMount() {

    __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].onresize = this.onResize;

    this.setPosition();

    this.setDevice();

    this.setState({
      didMount: true
    });
  };

  BreadcrumbNavigation.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        links = _props.links;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'BreadcrumbNavigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 119
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'BreadcrumbNavigation__container', ref: 'container', __source: {
              fileName: _jsxFileName,
              lineNumber: 120
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'BreadcrumbNavigation__container__list', ref: 'list', __source: {
                fileName: _jsxFileName,
                lineNumber: 121
              }
            },
            links.map(function (link, index) {
              var pcText = void 0;
              // let pcText, mbText;
              pcText = link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName;
              // mbText = link.mbText != null && link.mbText !== '' ? link.mbText : (link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName);
              pcText = pcText.split('|').join('');
              // mbText = mbText.split('|').join('');
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                {
                  key: index,
                  className: "BreadcrumbNavigation__container__list__item",
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 130
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'BreadcrumbNavigation__container__list__item__link', href: link.href, target: link.external === true ? '_blank' : null, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 134
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'BreadcrumbNavigation__container__list__item__link__text', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 135
                      }
                    },
                    pcText
                  )
                )
              );
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'script',
        { type: 'application/ld+json', __source: {
            fileName: _jsxFileName,
            lineNumber: 145
          }
        },
        function () {
          if (_this2.state.didMount) {
            var json = {
              "@context": "http://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": []
            };
            var list = [];
            for (var i = 0; i < links.length; i++) {
              var link = links[i];
              var text = link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName;
              text = text.split('|').join('');
              var url = __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location.protocol + '//' + __WEBPACK_IMPORTED_MODULE_3__constants_environment__["k" /* WINDOW */].location.hostname + link.href;
              var obj = {
                "@type": "ListItem",
                "position": i + 1,
                "item": {
                  "@id": url,
                  "name": text
                }
              };
              list.push(obj);
            }
            json["itemListElement"] = list;
            return JSON.stringify(json);
          }
        }()
      )
    );
  };

  return BreadcrumbNavigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  links: null
}, _temp);
BreadcrumbNavigation.displayName = 'BreadcrumbNavigation';


/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbNavigation);

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BreadcrumbNavigation":"BreadcrumbNavigation","BreadcrumbNavigation__container":"BreadcrumbNavigation__container","BreadcrumbNavigation__container__list":"BreadcrumbNavigation__container__list","BreadcrumbNavigation__container__list__item":"BreadcrumbNavigation__container__list__item","BreadcrumbNavigation__container__list__item__link":"BreadcrumbNavigation__container__list__item__link","BreadcrumbNavigation__container__list__item__link__text":"BreadcrumbNavigation__container__list__item__link__text","BreadcrumbNavigation__container__list__item__link__text--mb":"BreadcrumbNavigation__container__list__item__link__text--mb","BreadcrumbNavigation__container--overflow":"BreadcrumbNavigation__container--overflow","BreadcrumbNavigation__container--tablet":"BreadcrumbNavigation__container--tablet"};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CTANavigation":"CTANavigation","CTANavigation__container":"CTANavigation__container","CTANavigation__container__wrap":"CTANavigation__container__wrap","CTANavigation__container__wrap__list":"CTANavigation__container__wrap__list","CTANavigation__container__wrap__list__item":"CTANavigation__container__wrap__list__item","Cta__button__text":"Cta__button__text","open":"open","hasTouch":"hasTouch","CTANavigation__container__wrap__handle":"CTANavigation__container__wrap__handle"};

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cta__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_window__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mask_stars_png__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mask_stars_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__mask_stars_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_blank_png__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_blank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__icon_blank_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\drivers-voice\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















/**
 *  DriversVoice
 */
var DriversVoice = (_temp = _class = function (_Component) {
  _inherits(DriversVoice, _Component);

  function DriversVoice(props) {
    _classCallCheck(this, DriversVoice);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.getTabNames = function (bodyTypes) {
      var tabNames = [];
      if (bodyTypes && Array.isArray(bodyTypes)) {
        bodyTypes.map(function (bodyType, index) {
          if (bodyType.bodyTypeTabName && bodyType.bodyTypeTabName !== '') {
            tabNames.push(bodyType.bodyTypeTabName);
          } else {
            tabNames.push('');
          }
        });
      }
      return tabNames;
    };

    _this.getBodyType = function (bodyTypes) {
      var currentBodyType = null;
      if (bodyTypes && Array.isArray(bodyTypes)) {
        bodyTypes.map(function (bodyType, index) {
          if (bodyType.bodyTypeTabName && bodyType.bodyTypeTabName === _this.tmp.bodyTypeName) {
            currentBodyType = bodyType;
          }
        });
      }
      if (_this.tmp.bodyTypeName === '') {
        currentBodyType = bodyTypes[0];
      }
      return currentBodyType;
    };

    _this.onChangeForm = function (e) {};

    _this.onChangeBodyTypeName = function (e) {

      _this.tmp.bodyTypeName = e.target.value;
      _this.setState({
        bodyTypeName: e.target.value
      });

      var bodyTypes = _this.props.bodyTypes;
      if (bodyTypes && Array.isArray(bodyTypes)) {
        bodyTypes.map(function (bodyType, index) {
          if (bodyType.bodyTypeTabName && bodyType.bodyTypeTabName === _this.tmp.bodyTypeName) {
            _this.currentTabIndex = index;
          }
        });
      }

      //fadein
      _this.refs.voiceData.classList.remove('fadein');
      _this.refs.voiceData.style.opacity = 0;
      setTimeout(function () {
        _this.refs.voiceData.classList.add('fadein');
        _this.refs.voiceData.style.opacity = 1;
      }, 1);
    };

    _this.openModal = function () {
      _this.isOpenModal = true;
      _this.refs.modalWindow.open('Light', 'Light');
      //BodyControl.openModal();
    };

    _this.closeModal = function () {
      _this.isOpenModal = false;
      //BodyControl.closeModal();
    };

    _this.onScroll = function (e) {
      // console.log('scroll');
    };

    _this.onClickTwitter = function (e) {
      // console.log('twitter');
      var url = e.target.dataset['shareurl'];
      var href = "https://twitter.com/intent/tweet?url=" + url;
      window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
      e.preventDefault();
    };

    _this.onClickFacebook = function (e) {
      // console.log('facebook');
      var url = e.target.dataset['shareurl'];
      var href = "https://www.facebook.com/sharer.php?src=bm&u=" + url;
      window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
      e.preventDefault();
    };

    _this.onClickGoogle = function (e) {
      // console.log('google');
      var url = e.target.dataset['shareurl'];
      var href = "https://plus.google.com/share?url=" + url;
      window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
      e.preventDefault();
    };

    _this.onClickLine = function (e) {
      // console.log('line');
      var url = e.target.dataset['shareurl'];
      var href = "https://line.me/R/msg/text/?" + url;
      window.open(href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
      e.preventDefault();
    };

    _this.applyFilter = function () {};

    _this.format = function (str) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* convertKataToRome */])(String(str).toLowerCase().split(' ').join('-'));
    };

    _this.triggerEvent = function (element, event) {
      if (document.createEvent) {
        // IE以外
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true); // event type, bubbling, cancelable
        return element.dispatchEvent(evt);
      } else {
        // IE
        var evt = document.createEventObject();
        return element.fireEvent("on" + event, evt);
      }
    };

    _this.replaceCarName = function (str) {
      if (!str) {
        return '';
      }

      var _str = str;
      return _str.replace(/(atenza|axela)\-[a-zA-Z0-9]+/g, function (match) {
        return match.split('-').join('_');
      });
    };

    _this.nl2br = function (str) {
      var _str = str;
      return _str.split('¥n').join('<br />').split('\n').join('<br />');
    };

    _this.props = props;

    _this.state = {
      bodyTypeName: '',
      currentIndex: 1
    };

    _this.tmp = {
      bodyTypeName: ''
    };

    _this.isOpenModal = false;

    _this.currentTabIndex = 0;
    return _this;
  }

  DriversVoice.prototype.componentDidMount = function componentDidMount() {
    if (this.refs.form) {
      var firstBodyTypeName = this.refs.form.querySelector('input[name="bodyTypeName"]');
      if (firstBodyTypeName) {
        var value = firstBodyTypeName.value;
        this.tmp.bodyTypeName = value;
        this.setState({
          bodyTypeName: value
        });
      }
    }

    //モバイル用の初期表示セット
    var i = 0;
    while (true) {
      var voiceListMb = this.refs['voiceListMb_' + i];
      if (!voiceListMb) {
        break;
      }
      var voices = voiceListMb.querySelectorAll('.DriversVoice__modal__voiceList__voices__voice');
      if (voices && voices.length > 0) {
        voices[0].classList.add('show');
      }
      i++;
    }

    //JSON+LD
    if (this.refs.jsonld) {
      var json = {
        "@context": "http://schema.org",
        "@type": "Product",
        name: String(this.props.modelName),
        "description": String(this.props.snippet.description),
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": String(this.props.snippet.totalRate),
          "bestRating": "5",
          "worstRating": "1",
          "ratingCount": String(this.props.snippet.ratingCount)
        }
      };
      this.refs.jsonld.innerHTML = JSON.stringify(json);
    }

    //IE only
    if (__WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].navigator.userAgent && this.refs.driversvoice) {
      var ua = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["k" /* WINDOW */].navigator.userAgent.toLowerCase();
      if (ua.match(/msie/) || ua.match(/trident/)) {
        var slickPrevs = this.refs.driversvoice.querySelectorAll('.slick-prev');
        var slickNexts = this.refs.driversvoice.querySelectorAll('.slick-next');
        var itemLinks = this.refs.driversvoice.querySelectorAll('.DriversVoice__container__voiceList__item__link');
        if (slickPrevs && slickPrevs.length > 0) {
          for (var _i = 0; _i < slickPrevs.length; _i++) {
            slickPrevs[_i].classList.add('hover-disabled');
          }
        }
        if (slickNexts && slickNexts.length > 0) {
          for (var _i2 = 0; _i2 < slickNexts.length; _i2++) {
            slickNexts[_i2].classList.add('hover-disabled');
          }
        }
        if (itemLinks && itemLinks.length > 0) {
          for (var _i3 = 0; _i3 < itemLinks.length; _i3++) {
            itemLinks[_i3].classList.add('hover-disabled');
          }
        }
      }
    }

    //スクロールイベント
    // WINDOW.addEventListener('scroll', this.onScroll);
    // this.triggerEvent(WINDOW, 'scroll');

    // this.openModal();
  };

  DriversVoice.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        pcTitle = _props.pcTitle,
        mbTitle = _props.mbTitle,
        ownerSrc = _props.ownerSrc,
        testDriveSrc = _props.testDriveSrc,
        snippet = _props.snippet,
        shareButtons = _props.shareButtons,
        modelName = _props.modelName,
        bodyTypes = _props.bodyTypes;


    if (bodyTypes == null) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 191
        }
      });
    }

    var _bodyType = this.getBodyType(bodyTypes);

    var pcTitleText = pcTitle && pcTitle !== '' ? pcTitle : null;
    var mbTitleText = mbTitle && mbTitle !== '' ? mbTitle : pcTitle && pcTitle !== '' ? pcTitle : null;

    var carImageSrc = '/globalassets/assets/cars/' + this.format(modelName) + '/' + this.format(_bodyType.carId) + '/' + this.format(_bodyType.carTypeCode) + '/common/default_s.png';
    // carImageSrc = '/assets-dev/atenza-sedan_gj7_default_s.png';

    //
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        anchorPoint: anchorPoint,
        anchorName: anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DriversVoice', ref: 'driversvoice', __source: {
            fileName: _jsxFileName,
            lineNumber: 210
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DriversVoice__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 211
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DriversVoice__container__title', __source: {
                fileName: _jsxFileName,
                lineNumber: 212
              }
            },
            pcTitleText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DriversVoice__container__title__text--pc Wysiwyg', dangerouslySetInnerHTML: { __html: pcTitleText }, __source: {
                fileName: _jsxFileName,
                lineNumber: 213
              }
            }) : null,
            mbTitleText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DriversVoice__container__title__text--mb Wysiwyg', dangerouslySetInnerHTML: { __html: mbTitleText }, __source: {
                fileName: _jsxFileName,
                lineNumber: 214
              }
            }) : null
          ),
          function () {
            var tabNames = _this2.getTabNames(bodyTypes);
            if (tabNames.length > 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                {
                  className: 'DriversVoice__container__form' + (tabNames.length === 1 ? ' hide' : ''),
                  ref: 'form',
                  onChange: _this2.onChangeForm,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 220
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'DriversVoice__container__form__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 228
                    }
                  },
                  tabNames.map(function (tabName, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'DriversVoice__container__form__list__item', key: index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 232
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        { className: 'DriversVoice__container__form__list__item__label', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 233
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'DriversVoice__container__form__list__item__label__radio', type: 'radio', name: 'bodyTypeName', value: tabName, checked: _this2.state.bodyTypeName === tabName, onChange: _this2.onChangeBodyTypeName, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 234
                          }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { className: 'DriversVoice__container__form__list__item__label__text', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 235
                            }
                          },
                          tabName
                        )
                      )
                    );
                  })
                )
              );
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DriversVoice__container__voiceData', ref: 'voiceData', __source: {
                fileName: _jsxFileName,
                lineNumber: 246
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DriversVoice__container__satisfaction', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 247
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DriversVoice__container__satisfaction__total', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 248
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DriversVoice__container__satisfaction__total__title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 249
                    }
                  },
                  '\u7DCF\u5408\u6E80\u8DB3\u5EA6'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DriversVoice__container__satisfaction__total__container', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 250
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DriversVoice__container__satisfaction__total__container__image-container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 251
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: carImageSrc, className: 'DriversVoice__container__satisfaction__total__container__image-container__image', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 252
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DriversVoice__container__satisfaction__total__container__rate-container', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 254
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stars, _extends({
                      prefix: '',
                      suffix: 'POINT',
                      rate: parseFloat(_bodyType.totalRate),
                      animation: true
                    }, {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 255
                      }
                    }))
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DriversVoice__container__satisfaction__point', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 266
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DriversVoice__container__satisfaction__point__title', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 267
                    }
                  },
                  '\u6E80\u8DB3\u30DD\u30A4\u30F3\u30C8 \u30C8\u30C3\u30D7\uFF13'
                ),
                function () {
                  // let points = this.getSatisfactionPoints(bodyTypes);
                  var points = _bodyType.satisfactions;
                  if (points && points.length > 0) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'ul',
                      { className: 'DriversVoice__container__satisfaction__point__list', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 273
                        }
                      },
                      points.map(function (point, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { className: 'DriversVoice__container__satisfaction__point__list__item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 277
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 278
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PieChart, _extends({
                              suffix: '%',
                              rate: parseFloat(point.rate),
                              animation: true
                            }, {
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 279
                              }
                            }))
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'DriversVoice__container__satisfaction__point__list__item__title', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 287
                              }
                            },
                            point.title
                          )
                        );
                      })
                    );
                  }
                }()
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DriversVoice__container__voices', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 298
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DriversVoice__container__voices__container', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 299
                  }
                },
                bodyTypes.map(function (bodyType, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 303
                      }
                    },
                    function () {
                      if (bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          {
                            className: 'DriversVoice__container__voiceList' + (bodyType.bodyTypeTabName === _this2.tmp.bodyTypeName || bodyTypes.length === 1 ? ' show' : ''),
                            key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 307
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6__components_slider__["a" /* default */],
                            { ref: 'mainSlider_' + index, settings: {
                                autoplay: false,
                                autoplaySpeed: 3000,
                                speed: 1000,
                                ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                                fade: false,
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                swipe: true,
                                draggable: false,
                                arrows: true,
                                dots: true,
                                adaptiveHeight: false,
                                centerMode: false,
                                centerPadding: 0,
                                waitForAnimate: false,
                                lazyLoad: 'progressive',
                                // appendDots: (dots)=> {
                                //   return (
                                //     <ol>{dots}</ol>
                                //   )
                                // },
                                beforeChange: function beforeChange(oldIndex, newIndex) {
                                  if (!_this2.isOpenModal) {
                                    var currentModalSlider = _this2.refs['modalSlider_' + _this2.currentTabIndex];
                                    if (currentModalSlider) {
                                      currentModalSlider.slickGoTo(newIndex);
                                    }
                                  }
                                  _this2.refs['mainSlider_' + index].beforeChange(oldIndex, newIndex);
                                },
                                responsive: [{
                                  breakpoint: 767,
                                  settings: {
                                    arrows: false
                                  }
                                }]
                                // responsive: [
                                //   {
                                //     breakpoint: 767,
                                //     settings: {
                                //       speed: 500,
                                //       slidesToShow: 1,
                                //       slidesToScroll: 1,
                                //       centerMode: true,
                                //       centerPadding: '10%',
                                //       dots: false,
                                //     },
                                //   },
                                // ],
                              }, __source: {
                                fileName: _jsxFileName,
                                lineNumber: 313
                              }
                            },
                            function () {
                              if (bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0) {
                                return bodyType.lists.map(function (voice, index) {
                                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'DriversVoice__container__voiceList__item', key: index, __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 372
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'a',
                                      { href: 'javascript:void(0)', className: 'DriversVoice__container__voiceList__item__link', onClick: _this2.openModal, __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 373
                                        }
                                      },
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'DriversVoice__container__voiceList__item__title', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 374
                                          }
                                        },
                                        voice.title
                                      ),
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'DriversVoice__container__voiceList__item__name', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 375
                                          }
                                        },
                                        voice.name,
                                        '\uFF08',
                                        voice.age,
                                        '/',
                                        voice.sex === '1' ? '男性' : voice.sex === '2' ? '女性' : '',
                                        '\uFF09'
                                      ),
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'DriversVoice__container__voiceList__item__star', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 376
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stars, _extends({
                                          rate: parseFloat(voice.rate),
                                          animation: false,
                                          showTitle: false
                                        }, {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 377
                                          }
                                        }))
                                      ),
                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'DriversVoice__container__voiceList__item__comment', __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 385
                                          }
                                        },
                                        '\u30B3\u30E1\u30F3\u30C8\u3092\u898B\u308B'
                                      )
                                    )
                                  );
                                });
                              }
                            }()
                          )
                        );
                      }
                    }()
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'DriversVoice__container__button' + (_bodyType.lists && Array.isArray(_bodyType.lists) && _bodyType.lists.length > 0 ? '' : ' no-voice'),
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 404
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__cta__["a" /* default */], _extends({
                ctaType: 'Free',
                href: this.replaceCarName(_bodyType.href),
                targetBlank: true,
                text: 'ドライバーズボイス一覧',
                linkType: 'Button',
                color: 'Dark',
                buttonStyle: 'Standard'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 410
                }
              }))
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__components_modal_window__["a" /* default */],
          { ref: 'modalWindow', type: 'Light', onClose: this.closeModal, __source: {
              fileName: _jsxFileName,
              lineNumber: 424
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DriversVoice__modal', __source: {
                fileName: _jsxFileName,
                lineNumber: 425
              }
            },
            bodyTypes.map(function (bodyType, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'DriversVoice__modal__voiceList' + (bodyType.bodyTypeTabName === _this2.tmp.bodyTypeName || bodyTypes.length === 1 ? ' show' : ''),
                  key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 429
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6__components_slider__["a" /* default */],
                  { ref: 'modalSlider_' + index, settings: {
                      autoplay: false,
                      autoplaySpeed: 3000,
                      speed: 1000,
                      ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                      fade: false,
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      swipe: true,
                      draggable: false,
                      arrows: true,
                      dots: true,
                      adaptiveHeight: false,
                      centerMode: false,
                      centerPadding: 0,
                      waitForAnimate: false,
                      lazyLoad: 'progressive',
                      // appendDots: (dots)=> {
                      //   return (
                      //     <ol>{dots}</ol>
                      //   )
                      // },
                      beforeChange: function beforeChange(oldIndex, newIndex) {
                        if (_this2.isOpenModal) {
                          var currentMainSlider = _this2.refs['mainSlider_' + _this2.currentTabIndex];
                          if (currentMainSlider) {
                            currentMainSlider.slickGoTo(newIndex);
                          }
                        }

                        //モバイル用の表示切り替え
                        var currentVoiceListMb = _this2.refs['voiceListMb_' + _this2.currentTabIndex];
                        if (currentVoiceListMb) {
                          var voices = currentVoiceListMb.querySelectorAll('.DriversVoice__modal__voiceList__voices__voice');
                          if (voices && voices.length > 0) {
                            for (var i = 0; i < voices.length; i++) {
                              var voice = voices[i];
                              voice.classList.remove('show');
                              if (i === newIndex) {
                                voice.classList.add('show');
                              }
                            }
                          }
                          // fadein
                          currentVoiceListMb.classList.remove('fadein');
                          currentVoiceListMb.style.opacity = 0;
                          setTimeout(function () {
                            currentVoiceListMb.classList.add('fadein');
                            currentVoiceListMb.style.opacity = 1;
                          }, 10);
                        }

                        // console.log(this.refs['modalSlider_'+index])
                        if (_this2.refs['modalSlider_' + index].props.children) {
                          _this2.refs['modalSlider_' + index].beforeChange(oldIndex, newIndex);
                        }
                      },
                      responsive: [{
                        breakpoint: 767,
                        settings: {
                          arrows: false
                        }
                      }]
                      // responsive: [
                      //   {
                      //     breakpoint: 767,
                      //     settings: {
                      //       speed: 500,
                      //       slidesToShow: 1,
                      //       slidesToScroll: 1,
                      //       centerMode: true,
                      //       centerPadding: '10%',
                      //       dots: false,
                      //     },
                      //   },
                      // ],
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 435
                    }
                  },
                  function () {
                    if (bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0) {
                      return bodyType.lists.map(function (voice, index) {
                        var iconSrc = voice.kind === 'o' ? ownerSrc : testDriveSrc;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'DriversVoice__modal__voiceList__item', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 524
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'DriversVoice__modal__voiceList__item__container', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 525
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'DriversVoice__modal__voiceList__item__owner', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 526
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'DriversVoice__modal__voiceList__item__owner__container', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 527
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__owner__kind-icon', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 528
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: iconSrc, className: 'DriversVoice__modal__voiceList__item__owner__kind-icon__image', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 529
                                    }
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__owner__kind-title', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 531
                                    }
                                  },
                                  voice.kind === 'o' ? 'オーナー' : voice.kind === 't' ? '試乗' : '',
                                  '\u30B3\u30E1\u30F3\u30C8'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__owner__title', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 532
                                    }
                                  },
                                  voice.title
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__owner__infoContainer', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 533
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'DriversVoice__modal__voiceList__item__owner__star', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 534
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stars, _extends({
                                      prefix: '総合満足度',
                                      suffix: 'POINT',
                                      rate: parseFloat(voice.rate),
                                      animation: false
                                    }, {
                                      __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 535
                                      }
                                    }))
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'DriversVoice__modal__voiceList__item__owner__name', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 544
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'span',
                                      { className: 'DriversVoice__modal__voiceList__item__owner__name__text', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 545
                                        }
                                      },
                                      voice.name
                                    ),
                                    '\u3055\u3093'
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'DriversVoice__modal__voiceList__item__owner__carInfo', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 547
                                      }
                                    },
                                    voice.carName,
                                    '/',
                                    voice.gradeName,
                                    '/',
                                    voice.bodyColor
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'DriversVoice__modal__voiceList__item__owner__info', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 552
                                      }
                                    },
                                    voice.age,
                                    '/',
                                    voice.sex === '1' ? '男性' : voice.sex === '2' ? '女性' : '',
                                    '/',
                                    voice.address,
                                    '/',
                                    voice.family
                                  )
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'DriversVoice__modal__voiceList__item__voice', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 561
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'DriversVoice__modal__voiceList__item__voice__scroll', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 562
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DriversVoice__modal__voiceList__item__voice__comment', dangerouslySetInnerHTML: { __html: _this2.nl2br(voice.comment) }, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 563
                                  }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__voice__readmore', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 564
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__cta__["a" /* default */], _extends({
                                    ctaType: 'Free',
                                    href: 'https://www2.mazda.co.jp' + _this2.replaceCarName(voice.href),
                                    targetBlank: true,
                                    text: '続きを見る',
                                    linkType: 'Button-With-Icon',
                                    iconSrc: __WEBPACK_IMPORTED_MODULE_11__icon_blank_png___default.a,
                                    hoverIconSrc: __WEBPACK_IMPORTED_MODULE_11__icon_blank_png___default.a,
                                    color: 'Dark',
                                    buttonStyle: 'Action'
                                  }, {
                                    __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 565
                                    }
                                  }))
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__voice__remarks', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 579
                                    }
                                  },
                                  'Driver\'s Voice\u30B5\u30A4\u30C8\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002'
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'DriversVoice__modal__voiceList__item__voice__footer', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 581
                                  }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__voice__footer__clap', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 582
                                    }
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'DriversVoice__modal__voiceList__item__voice__footer__clap__number', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 583
                                      }
                                    },
                                    voice.clap
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'DriversVoice__modal__voiceList__item__voice__footer__clap__unit', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 584
                                      }
                                    },
                                    '\u4EBA'
                                  ),
                                  '\u306E\u65B9\u304C\u3001\u3053\u306E\u30EC\u30D3\u30E5\u30FC\u306B\u62CD\u624B\u3057\u3066\u3044\u307E\u3059\u3002'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { className: 'DriversVoice__modal__voiceList__item__voice__footer__share', __source: {
                                      fileName: _jsxFileName,
                                      lineNumber: 586
                                    }
                                  },
                                  function () {
                                    if (shareButtons && Array.isArray(shareButtons) && shareButtons.length > 0) {
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        {
                                          __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 590
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'DriversVoice__modal__voiceList__item__voice__footer__share__title', __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 591
                                            }
                                          },
                                          '\u30B7\u30A7\u30A2\u3059\u308B'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'ul',
                                          { className: 'DriversVoice__modal__voiceList__item__voice__footer__share__list', __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 592
                                            }
                                          },
                                          shareButtons.map(function (snsName, index) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                              'li',
                                              { className: 'DriversVoice__modal__voiceList__item__voice__footer__share__list__item', key: index, __source: {
                                                  fileName: _jsxFileName,
                                                  lineNumber: 596
                                                }
                                              },
                                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'a',
                                                {
                                                  href: 'javascript:void(0)',
                                                  'data-shareurl': _this2.replaceCarName(voice.href),
                                                  className: 'DriversVoice__modal__voiceList__item__voice__footer__share__list__item__link' + (snsName === 'Twitter' ? ' twitter' : '') + (snsName === 'Facebook' ? ' facebook' : '') + (snsName === 'Line' ? ' line' : '') + (snsName === 'Google+' ? ' google' : ''),
                                                  onClick: (snsName === 'Twitter' ? _this2.onClickTwitter : null) || (snsName === 'Facebook' ? _this2.onClickFacebook : null) || (snsName === 'Line' ? _this2.onClickLine : null) || (snsName === 'Google+' ? _this2.onClickGoogle : null),
                                                  __source: {
                                                    fileName: _jsxFileName,
                                                    lineNumber: 597
                                                  }
                                                },
                                                snsName
                                              )
                                            );
                                          })
                                        )
                                      );
                                    }
                                  }()
                                )
                              )
                            )
                          )
                        );
                      });
                    }
                  }()
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DriversVoice__modal__voiceList__voices--mb', ref: 'voiceListMb_' + index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 636
                    }
                  },
                  function () {
                    if (bodyType.lists && Array.isArray(bodyType.lists) && bodyType.lists.length > 0) {
                      return bodyType.lists.map(function (voice, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'DriversVoice__modal__voiceList__voices__voice', key: index, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 642
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DriversVoice__modal__voiceList__voices__voice__comment', dangerouslySetInnerHTML: { __html: _this2.nl2br(voice.comment) }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 643
                            }
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'DriversVoice__modal__voiceList__voices__voice__readmore', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 644
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__cta__["a" /* default */], _extends({
                              ctaType: 'Free',
                              href: 'https://www2.mazda.co.jp' + _this2.replaceCarName(voice.href),
                              targetBlank: true,
                              text: '続きを見る',
                              linkType: 'Button-With-Icon',
                              iconSrc: __WEBPACK_IMPORTED_MODULE_11__icon_blank_png___default.a,
                              hoverIconSrc: __WEBPACK_IMPORTED_MODULE_11__icon_blank_png___default.a,
                              color: 'Dark',
                              buttonStyle: 'Action'
                            }, {
                              __source: {
                                fileName: _jsxFileName,
                                lineNumber: 645
                              }
                            }))
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'DriversVoice__modal__voiceList__voices__voice__remarks', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 659
                              }
                            },
                            'Driver\'s Voice\u30B5\u30A4\u30C8\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'DriversVoice__modal__voiceList__voices__voice__footer', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 660
                              }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'DriversVoice__modal__voiceList__voices__voice__footer__clap', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 661
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'DriversVoice__modal__voiceList__voices__voice__footer__clap__number', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 662
                                  }
                                },
                                voice.clap
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'DriversVoice__modal__voiceList__voices__voice__footer__clap__unit', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 663
                                  }
                                },
                                '\u4EBA'
                              ),
                              '\u306E\u65B9\u304C\u3001\u3053\u306E\u30EC\u30D3\u30E5\u30FC\u306B\u62CD\u624B\u3057\u3066\u3044\u307E\u3059\u3002'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'DriversVoice__modal__voiceList__voices__voice__footer__share', __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 665
                                }
                              },
                              function () {
                                if (shareButtons && Array.isArray(shareButtons) && shareButtons.length > 0) {
                                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                    {
                                      __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 669
                                      }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'div',
                                      { className: 'DriversVoice__modal__voiceList__voices__voice__footer__share__title', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 670
                                        }
                                      },
                                      '\u30B7\u30A7\u30A2\u3059\u308B'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                      'ul',
                                      { className: 'DriversVoice__modal__voiceList__voices__voice__footer__share__list', __source: {
                                          fileName: _jsxFileName,
                                          lineNumber: 671
                                        }
                                      },
                                      shareButtons.map(function (snsName, index) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'li',
                                          { className: 'DriversVoice__modal__voiceList__voices__voice__footer__share__list__item', key: index, __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 675
                                            }
                                          },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            {
                                              href: 'javascript:void(0)',
                                              'data-shareurl': voice.href,
                                              className: 'DriversVoice__modal__voiceList__voices__voice__footer__share__list__item__link' + (snsName === 'Twitter' ? ' twitter' : '') + (snsName === 'Facebook' ? ' facebook' : '') + (snsName === 'Line' ? ' line' : '') + (snsName === 'Google+' ? ' google' : ''),
                                              onClick: (snsName === 'Twitter' ? _this2.onClickTwitter : null) || (snsName === 'Facebook' ? _this2.onClickFacebook : null) || (snsName === 'Line' ? _this2.onClickLine : null) || (snsName === 'Google+' ? _this2.onClickGoogle : null),
                                              __source: {
                                                fileName: _jsxFileName,
                                                lineNumber: 676
                                              }
                                            },
                                            snsName
                                          )
                                        );
                                      })
                                    )
                                  );
                                }
                              }()
                            )
                          )
                        );
                      });
                    }
                  }()
                )
              );
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'script',
        { type: 'application/ld+json', ref: 'jsonld', __source: {
            fileName: _jsxFileName,
            lineNumber: 720
          }
        },
        function () {
          // let json = {
          //   "@context": "http://schema.org",
          //   "@type": "Product",
          //   name: modelName,
          //   "description": snippet.description,
          //   "aggregateRating": {
          //     "@type": "AggregateRating",
          //     "ratingValue": snippet.totalRate,
          //     "bestRating": "5",
          //     "worstRating": "1",
          //     "ratingCount": snippet.ratingCount
          //   }
          // };
          // return(JSON.stringify(json))
        }()
      )
    );
  };

  return DriversVoice;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pcTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ownerSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  testDriveSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  snippet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    totalRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ratingCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  shareButtons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    BodyTypeTabName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    totalRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    satisfactions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      rate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })),
    lists: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      kind: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      rate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      age: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      sex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      family: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      carName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      gradeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      clap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  pcTitle: null,
  mbTitle: null,
  ownerSrc: null,
  testDriveSrc: null,
  snippet: null,
  shareButtons: null,
  modelName: null,
  bodyTypes: null
}, _temp);
DriversVoice.displayName = 'DriversVoice';


/* harmony default export */ __webpack_exports__["a"] = (DriversVoice);

var Stars = (_temp2 = _class2 = function (_Component2) {
  _inherits(Stars, _Component2);

  function Stars(props) {
    _classCallCheck(this, Stars);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.start = function () {
      _this3.draw();
    };

    _this3.stop = function () {
      if (cancelAnimationFrame) {
        cancelAnimationFrame(_this3.animationId);
      }
    };

    _this3.draw = function () {

      //アニメーションなし
      if (!_this3.props.animation) {
        _this3.currentRate = _this3.props.rate;
      }

      _this3.setState({
        currentRate: Math.floor(_this3.currentRate * 10) / 10
      });

      var starsTotalWidth = 285; // 57 * 5

      var starsMargin = parseInt(_this3.currentRate) * 16;

      // let width = this.canvas.width * this.currentRate / 5;
      var width = starsTotalWidth * _this3.currentRate / 5;
      width += starsMargin;
      width = parseInt(width * 10) / 10;

      _this3.ctx.save();

      _this3.ctx.clearRect(0, 0, _this3.canvas.width, _this3.canvas.height);

      _this3.ctx.beginPath();
      _this3.ctx.fillStyle = 'rgb(231, 231, 231)';
      _this3.ctx.fillRect(0, 0, _this3.canvas.width, _this3.canvas.height);
      _this3.ctx.fill();

      _this3.ctx.beginPath();
      _this3.ctx.fillStyle = 'rgb(16, 16, 16)';
      _this3.ctx.fillRect(0, 0, width, _this3.canvas.height);
      _this3.ctx.fill();

      _this3.ctx.globalCompositeOperation = 'destination-in';
      _this3.ctx.drawImage(_this3.maskImage, 0, 0, _this3.canvas.width, _this3.canvas.height);

      _this3.ctx.restore();

      _this3.currentRate += (_this3.props.rate - _this3.currentRate) * 0.05;
      if (Math.abs(_this3.props.rate - _this3.currentRate) < 0.05) {
        _this3.currentRate = _this3.props.rate;
      }

      if (requestAnimationFrame && _this3.props.animation) {
        _this3.animationId = requestAnimationFrame(_this3.draw);
      }
    };

    _this3.state = {
      currentRate: 0
    };

    _this3.canvas = null;
    _this3.ctx = null;
    _this3.animationId = null;

    _this3.maskImage = null;
    _this3.currentRate = 0;
    return _this3;
  }

  Stars.prototype.componentDidMount = function componentDidMount() {
    this.canvas = this.refs.canvas;
    this.ctx = this.canvas.getContext('2d');

    this.maskImage = new Image();
    this.maskImage.addEventListener("load", this.start, false);
    this.maskImage.src = __WEBPACK_IMPORTED_MODULE_10__mask_stars_png___default.a;

    // this.start();
  };

  Stars.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.currentRate = 0;
  };

  Stars.prototype.render = function render() {
    var _props2 = this.props,
        prefix = _props2.prefix,
        suffix = _props2.suffix,
        rate = _props2.rate,
        width = _props2.width,
        height = _props2.height,
        animation = _props2.animation,
        showTitle = _props2.showTitle;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Stars', __source: {
          fileName: _jsxFileName,
          lineNumber: 953
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Stars__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 954
          }
        },
        showTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Stars__container__title', __source: {
              fileName: _jsxFileName,
              lineNumber: 956
            }
          },
          prefix && prefix !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Stars__container__title__prefix', __source: {
                fileName: _jsxFileName,
                lineNumber: 957
              }
            },
            prefix
          ) : null,
          rate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Stars__container__title__rate', __source: {
                fileName: _jsxFileName,
                lineNumber: 958
              }
            },
            this.state.currentRate.toFixed(1)
          ) : null,
          suffix && suffix !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'Stars__container__title__suffix', __source: {
                fileName: _jsxFileName,
                lineNumber: 959
              }
            },
            suffix
          ) : null
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { width: width, height: height, className: 'Stars__container__canvas', ref: 'canvas', __source: {
            fileName: _jsxFileName,
            lineNumber: 962
          }
        })
      )
    );
  };

  return Stars;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  prefix: null,
  suffix: null,
  rate: null,
  width: 350,
  height: 54,
  animation: false,
  showTitle: true
}, _temp2);
Stars.displayName = 'Stars';
var PieChart = (_temp3 = _class3 = function (_Component3) {
  _inherits(PieChart, _Component3);

  function PieChart(props) {
    _classCallCheck(this, PieChart);

    var _this4 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this4.start = function () {
      _this4.draw();
    };

    _this4.stop = function () {
      if (cancelAnimationFrame) {
        cancelAnimationFrame(_this4.animationId);
      }
    };

    _this4.draw = function () {

      //アニメーションなし
      if (!_this4.props.animation) {
        _this4.currentRate = _this4.props.rate;
      }

      _this4.setState({
        currentRate: parseInt(_this4.currentRate)
      });

      var angle = 360 * (_this4.currentRate / 100);

      var centerX = _this4.canvas.width / 2;
      var centerY = _this4.canvas.height / 2;
      var radius = _this4.props.radius;
      var innerRadius = __WEBPACK_IMPORTED_MODULE_4__constants_environment__["g" /* IS_MOBILE */] ? _this4.props.innerRadius : 90;

      _this4.ctx.save();

      _this4.ctx.clearRect(0, 0, _this4.canvas.width, _this4.canvas.height);

      _this4.ctx.beginPath();
      _this4.ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
      _this4.ctx.fillStyle = 'rgb(231, 231, 231)';
      _this4.ctx.fill();

      _this4.ctx.beginPath();
      _this4.ctx.arc(centerX, centerY, radius, (0 - 90) * Math.PI / 180, (angle - 90) * Math.PI / 180, false);
      _this4.ctx.lineTo(centerX, centerY);
      _this4.ctx.fillStyle = 'rgb(16, 16, 16)';
      _this4.ctx.fill();

      _this4.ctx.globalCompositeOperation = 'destination-out';
      _this4.ctx.beginPath();
      _this4.ctx.arc(centerX, centerY, innerRadius, 0, Math.PI * 2, false);
      _this4.ctx.fillStyle = 'rgb(231, 231, 231)';
      _this4.ctx.fill();

      _this4.ctx.restore();

      _this4.currentRate += (_this4.props.rate - _this4.currentRate) * 0.05;
      if (Math.abs(_this4.props.rate - _this4.currentRate) < 0.2) {
        _this4.currentRate = _this4.props.rate;
      }

      if (requestAnimationFrame && _this4.props.animation) {
        _this4.animationId = requestAnimationFrame(_this4.draw);
      }
    };

    _this4.state = {
      currentRate: 0
    };

    _this4.canvas = null;
    _this4.ctx = null;
    _this4.animationId = null;

    _this4.maskImage = null;
    _this4.currentRate = 0;
    return _this4;
  }

  PieChart.prototype.componentDidMount = function componentDidMount() {
    this.canvas = this.refs.canvas;
    this.ctx = this.canvas.getContext('2d');
    this.start();
  };

  PieChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.currentRate = 0;
  };

  PieChart.prototype.render = function render() {
    var _props3 = this.props,
        prefix = _props3.prefix,
        suffix = _props3.suffix,
        rate = _props3.rate,
        width = _props3.width,
        height = _props3.height,
        radius = _props3.radius,
        innerRadius = _props3.innerRadius,
        animation = _props3.animation;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'PieChart', __source: {
          fileName: _jsxFileName,
          lineNumber: 1087
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'PieChart__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 1088
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PieChart__container__title', __source: {
              fileName: _jsxFileName,
              lineNumber: 1089
            }
          },
          prefix && prefix !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'PieChart__container__title__prefix', __source: {
                fileName: _jsxFileName,
                lineNumber: 1090
              }
            },
            prefix
          ) : null,
          rate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'PieChart__container__title__rate', __source: {
                fileName: _jsxFileName,
                lineNumber: 1091
              }
            },
            this.state.currentRate
          ) : null,
          suffix && suffix !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'PieChart__container__title__suffix', __source: {
                fileName: _jsxFileName,
                lineNumber: 1092
              }
            },
            suffix
          ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { width: width, height: height, className: 'PieChart__container__canvas', ref: 'canvas', __source: {
            fileName: _jsxFileName,
            lineNumber: 1094
          }
        })
      )
    );
  };

  return PieChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class3.defaultProps = {
  prefix: null,
  suffix: null,
  rate: null,
  width: 194,
  height: 194,
  radius: 97,
  innerRadius: 87,
  animation: false
}, _temp3);
PieChart.displayName = 'PieChart';

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DriversVoice":"DriversVoice","DriversVoice__container":"DriversVoice__container","DriversVoice__container__title":"DriversVoice__container__title","DriversVoice__container__title__text--pc":"DriversVoice__container__title__text--pc","DriversVoice__container__title__text--mb":"DriversVoice__container__title__text--mb","DriversVoice__container__form":"DriversVoice__container__form","hide":"hide","DriversVoice__container__form__list":"DriversVoice__container__form__list","DriversVoice__container__form__list__item":"DriversVoice__container__form__list__item","DriversVoice__container__form__list__item__label":"DriversVoice__container__form__list__item__label","DriversVoice__container__form__list__item__label__radio":"DriversVoice__container__form__list__item__label__radio","DriversVoice__container__form__list__item__label__text":"DriversVoice__container__form__list__item__label__text","DriversVoice__container__voiceData":"DriversVoice__container__voiceData","fadein":"fadein","DriversVoice__container__satisfaction":"DriversVoice__container__satisfaction","DriversVoice__container__satisfaction__total":"DriversVoice__container__satisfaction__total","DriversVoice__container__satisfaction__total__title":"DriversVoice__container__satisfaction__total__title","DriversVoice__container__satisfaction__total__container":"DriversVoice__container__satisfaction__total__container","DriversVoice__container__satisfaction__total__container__image-container":"DriversVoice__container__satisfaction__total__container__image-container","DriversVoice__container__satisfaction__total__container__image-container__image":"DriversVoice__container__satisfaction__total__container__image-container__image","DriversVoice__container__satisfaction__total__container__rate-container":"DriversVoice__container__satisfaction__total__container__rate-container","Stars":"Stars","Stars__container":"Stars__container","Stars__container__title":"Stars__container__title","Stars__container__title__rate":"Stars__container__title__rate","Stars__container__title__suffix":"Stars__container__title__suffix","Stars__container__canvas":"Stars__container__canvas","DriversVoice__container__satisfaction__point":"DriversVoice__container__satisfaction__point","DriversVoice__container__satisfaction__point__title":"DriversVoice__container__satisfaction__point__title","DriversVoice__container__satisfaction__point__list":"DriversVoice__container__satisfaction__point__list","DriversVoice__container__satisfaction__point__list__item":"DriversVoice__container__satisfaction__point__list__item","PieChart":"PieChart","PieChart__container":"PieChart__container","PieChart__container__title":"PieChart__container__title","PieChart__container__title__rate":"PieChart__container__title__rate","PieChart__container__title__suffix":"PieChart__container__title__suffix","PieChart__container__canvas":"PieChart__container__canvas","DriversVoice__container__satisfaction__point__list__item__title":"DriversVoice__container__satisfaction__point__list__item__title","DriversVoice__container__voices":"DriversVoice__container__voices","DriversVoice__container__voices__container":"DriversVoice__container__voices__container","DriversVoice__container__voiceList":"DriversVoice__container__voiceList","show":"show","Slide":"Slide","slick-prev":"slick-prev","hover-disabled":"hover-disabled","slick-next":"slick-next","DriversVoice__container__voiceList__item":"DriversVoice__container__voiceList__item","DriversVoice__container__voiceList__item__link":"DriversVoice__container__voiceList__item__link","DriversVoice__container__voiceList__item__title":"DriversVoice__container__voiceList__item__title","DriversVoice__container__voiceList__item__name":"DriversVoice__container__voiceList__item__name","DriversVoice__container__voiceList__item__star":"DriversVoice__container__voiceList__item__star","DriversVoice__container__voiceList__item__comment":"DriversVoice__container__voiceList__item__comment","DriversVoice__container__button":"DriversVoice__container__button","no-voice":"no-voice","ModalWindow":"ModalWindow","ModalWindow__container":"ModalWindow__container","DriversVoice__modal":"DriversVoice__modal","DriversVoice__modal__voiceList":"DriversVoice__modal__voiceList","slick-slider":"slick-slider","slick-dots":"slick-dots","slick-list":"slick-list","slick-track":"slick-track","slick-slide":"slick-slide","DriversVoice__modal__voiceList__item":"DriversVoice__modal__voiceList__item","DriversVoice__modal__voiceList__item__container":"DriversVoice__modal__voiceList__item__container","DriversVoice__modal__voiceList__item__owner":"DriversVoice__modal__voiceList__item__owner","DriversVoice__modal__voiceList__item__owner__container":"DriversVoice__modal__voiceList__item__owner__container","DriversVoice__modal__voiceList__item__owner__kind-icon":"DriversVoice__modal__voiceList__item__owner__kind-icon","DriversVoice__modal__voiceList__item__owner__kind-icon__image":"DriversVoice__modal__voiceList__item__owner__kind-icon__image","DriversVoice__modal__voiceList__item__owner__kind-title":"DriversVoice__modal__voiceList__item__owner__kind-title","DriversVoice__modal__voiceList__item__owner__title":"DriversVoice__modal__voiceList__item__owner__title","DriversVoice__modal__voiceList__item__owner__infoContainer":"DriversVoice__modal__voiceList__item__owner__infoContainer","DriversVoice__modal__voiceList__item__owner__star":"DriversVoice__modal__voiceList__item__owner__star","Stars__container__title__prefix":"Stars__container__title__prefix","DriversVoice__modal__voiceList__item__owner__name":"DriversVoice__modal__voiceList__item__owner__name","DriversVoice__modal__voiceList__item__owner__name__text":"DriversVoice__modal__voiceList__item__owner__name__text","DriversVoice__modal__voiceList__item__owner__carInfo":"DriversVoice__modal__voiceList__item__owner__carInfo","DriversVoice__modal__voiceList__item__owner__info":"DriversVoice__modal__voiceList__item__owner__info","DriversVoice__modal__voiceList__item__voice":"DriversVoice__modal__voiceList__item__voice","DriversVoice__modal__voiceList__item__voice__scroll":"DriversVoice__modal__voiceList__item__voice__scroll","DriversVoice__modal__voiceList__item__voice__comment":"DriversVoice__modal__voiceList__item__voice__comment","DriversVoice__modal__voiceList__item__voice__readmore":"DriversVoice__modal__voiceList__item__voice__readmore","DriversVoice__modal__voiceList__item__voice__remarks":"DriversVoice__modal__voiceList__item__voice__remarks","DriversVoice__modal__voiceList__item__voice__footer":"DriversVoice__modal__voiceList__item__voice__footer","DriversVoice__modal__voiceList__item__voice__footer__clap":"DriversVoice__modal__voiceList__item__voice__footer__clap","DriversVoice__modal__voiceList__item__voice__footer__clap__number":"DriversVoice__modal__voiceList__item__voice__footer__clap__number","DriversVoice__modal__voiceList__item__voice__footer__clap__unit":"DriversVoice__modal__voiceList__item__voice__footer__clap__unit","DriversVoice__modal__voiceList__item__voice__footer__share":"DriversVoice__modal__voiceList__item__voice__footer__share","DriversVoice__modal__voiceList__item__voice__footer__share__title":"DriversVoice__modal__voiceList__item__voice__footer__share__title","DriversVoice__modal__voiceList__item__voice__footer__share__list":"DriversVoice__modal__voiceList__item__voice__footer__share__list","DriversVoice__modal__voiceList__item__voice__footer__share__list__item":"DriversVoice__modal__voiceList__item__voice__footer__share__list__item","DriversVoice__modal__voiceList__item__voice__footer__share__list__item__link":"DriversVoice__modal__voiceList__item__voice__footer__share__list__item__link","twitter":"twitter","facebook":"facebook","google":"google","line":"line","DriversVoice__modal__voiceList__voices--mb":"DriversVoice__modal__voiceList__voices--mb","ModalWindow__link-close":"ModalWindow__link-close","DriversVoice__modal__voiceList__voices__voice":"DriversVoice__modal__voiceList__voices__voice","DriversVoice__modal__voiceList__voices__voice__comment":"DriversVoice__modal__voiceList__voices__voice__comment","DriversVoice__modal__voiceList__voices__voice__readmore":"DriversVoice__modal__voiceList__voices__voice__readmore","DriversVoice__modal__voiceList__voices__voice__remarks":"DriversVoice__modal__voiceList__voices__voice__remarks","DriversVoice__modal__voiceList__voices__voice__footer":"DriversVoice__modal__voiceList__voices__voice__footer","DriversVoice__modal__voiceList__voices__voice__footer__clap":"DriversVoice__modal__voiceList__voices__voice__footer__clap","DriversVoice__modal__voiceList__voices__voice__footer__clap__number":"DriversVoice__modal__voiceList__voices__voice__footer__clap__number","DriversVoice__modal__voiceList__voices__voice__footer__clap__unit":"DriversVoice__modal__voiceList__voices__voice__footer__clap__unit","DriversVoice__modal__voiceList__voices__voice__footer__share":"DriversVoice__modal__voiceList__voices__voice__footer__share","DriversVoice__modal__voiceList__voices__voice__footer__share__title":"DriversVoice__modal__voiceList__voices__voice__footer__share__title","DriversVoice__modal__voiceList__voices__voice__footer__share__list":"DriversVoice__modal__voiceList__voices__voice__footer__share__list","DriversVoice__modal__voiceList__voices__voice__footer__share__list__item":"DriversVoice__modal__voiceList__voices__voice__footer__share__list__item","DriversVoice__modal__voiceList__voices__voice__footer__share__list__item__link":"DriversVoice__modal__voiceList__voices__voice__footer__share__list__item__link"};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "42487a9066b015ecd10baf5f7819fa9c.png";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ea6ba61308f6d3c48b7514ac51f19516.png";

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryBodyTypeTabName":"AccessoryBodyTypeTabName"};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryList":"AccessoryList","AccessoryList__container":"AccessoryList__container","AccessoryList__container__form":"AccessoryList__container__form","AccessoryList__container__form__bodyTypeName":"AccessoryList__container__form__bodyTypeName","AccessoryList__container__form__bodyTypeName__list":"AccessoryList__container__form__bodyTypeName__list","AccessoryList__container__form__bodyTypeName__list__item":"AccessoryList__container__form__bodyTypeName__list__item","AccessoryList__container__form__bodyTypeName__list__item__label":"AccessoryList__container__form__bodyTypeName__list__item__label","AccessoryList__container__form__bodyTypeName__list__item__label__radio":"AccessoryList__container__form__bodyTypeName__list__item__label__radio","AccessoryList__container__form__bodyTypeName__list__item__label__text":"AccessoryList__container__form__bodyTypeName__list__item__label__text","AccessoryList__container__form__category":"AccessoryList__container__form__category","fadein":"fadein","AccessoryList__container__form__category__list":"AccessoryList__container__form__category__list","AccessoryList__container__form__category__list__item":"AccessoryList__container__form__category__list__item","AccessoryList__container__form__category__list__item__label":"AccessoryList__container__form__category__list__item__label","AccessoryList__container__form__category__list__item__label__radio":"AccessoryList__container__form__category__list__item__label__radio","AccessoryList__container__form__category__list__item__label__text":"AccessoryList__container__form__category__list__item__label__text","AccessoryList__container__form__subCategory":"AccessoryList__container__form__subCategory","hide":"hide","open":"open","AccessoryList__container__form__subCategory__title":"AccessoryList__container__form__subCategory__title","AccessoryList__container__form__subCategory__title__link":"AccessoryList__container__form__subCategory__title__link","AccessoryList__container__form__subCategory__pulldown":"AccessoryList__container__form__subCategory__pulldown","AccessoryList__container__form__subCategory__pulldown__container":"AccessoryList__container__form__subCategory__pulldown__container","AccessoryList__container__form__subCategory__pulldown__list":"AccessoryList__container__form__subCategory__pulldown__list","AccessoryList__container__form__subCategory__pulldown__list__item":"AccessoryList__container__form__subCategory__pulldown__list__item","AccessoryList__container__form__subCategory__pulldown__list__item__label":"AccessoryList__container__form__subCategory__pulldown__list__item__label","AccessoryList__container__form__subCategory__pulldown__list__item__label__radio":"AccessoryList__container__form__subCategory__pulldown__list__item__label__radio","AccessoryList__container__form__subCategory__pulldown__list__item__label__text":"AccessoryList__container__form__subCategory__pulldown__list__item__label__text","AccessoryList__container__form__subCategory__pulldown__close":"AccessoryList__container__form__subCategory__pulldown__close","AccessoryList__container__accessories":"AccessoryList__container__accessories","AccessoryList__container__accessories__category":"AccessoryList__container__accessories__category","AccessoryList__container__accessories__category__title":"AccessoryList__container__accessories__category__title","AccessoryList__container__accessories__category__list":"AccessoryList__container__accessories__category__list","AccessoryList__container__accessories__category__list__item":"AccessoryList__container__accessories__category__list__item","show":"show","AccessoryList__container__accessories__category__list__item__link":"AccessoryList__container__accessories__category__list__item__link","AccessoryList__container__accessories__category__list__item__link__content__image__wrap":"AccessoryList__container__accessories__category__list__item__link__content__image__wrap","AccessoryList__container__accessories__category__list__item__link__content__title":"AccessoryList__container__accessories__category__list__item__link__content__title","AccessoryList__container__accessories__category__list__item__link__content__price":"AccessoryList__container__accessories__category__list__item__link__content__price","AccessoryList__container__accessories__category__list__item__link__content":"AccessoryList__container__accessories__category__list__item__link__content","AccessoryList__container__accessories__category__list__item__link__content__image":"AccessoryList__container__accessories__category__list__item__link__content__image","AccessoryList__container__accessories__category__more":"AccessoryList__container__accessories__category__more","AccessoryList__container__accessories__category__less":"AccessoryList__container__accessories__category__less","AccessoryList__container--Light":"AccessoryList__container--Light"};

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StandardPage":"StandardPage","StandardPage__header":"StandardPage__header","StandardPage__navigation":"StandardPage__navigation","StandardPage__heading-pc":"StandardPage__heading-pc","StandardPage__heading-mb":"StandardPage__heading-mb","StandardPage__main":"StandardPage__main","StandardPage__bottom-navigation":"StandardPage__bottom-navigation","StandardPage__footer":"StandardPage__footer"};

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryInfoItem":"AccessoryInfoItem"};

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryInfoContainer":"AccessoryInfoContainer"};

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AccessoryDetailContent":"AccessoryDetailContent","AccessoryDetailContent__container":"AccessoryDetailContent__container","AccessoryDetailContent__container__header":"AccessoryDetailContent__container__header","AccessoryDetailContent__container__header__content":"AccessoryDetailContent__container__header__content","AccessoryDetailContent__container__header__content__text-container":"AccessoryDetailContent__container__header__content__text-container","AccessoryDetailContent__container__header__content__text-container__title":"AccessoryDetailContent__container__header__content__text-container__title","AccessoryDetailContent__container__header__content__text-container__price":"AccessoryDetailContent__container__header__content__text-container__price","AccessoryDetailContent__container__header__content__text-container__price__tax":"AccessoryDetailContent__container__header__content__text-container__price__tax","AccessoryDetailContent__container__header__content__text-container__description-of-base-price":"AccessoryDetailContent__container__header__content__text-container__description-of-base-price","AccessoryDetailContent__container__header__content__image-container":"AccessoryDetailContent__container__header__content__image-container","AccessoryDetailContent__container__header__content__image-container__wrap":"AccessoryDetailContent__container__header__content__image-container__wrap","AccessoryDetailContent__container__header__content__image-container__wrap__image":"AccessoryDetailContent__container__header__content__image-container__wrap__image","AccessoryDetailContent__container__back":"AccessoryDetailContent__container__back","AccessoryDetailContent__container__back__link":"AccessoryDetailContent__container__back__link","AccessoryDetailContent__container__body":"AccessoryDetailContent__container__body","AccessoryDetailContent__container__body__detail":"AccessoryDetailContent__container__body__detail","AccessoryDetailContent__container__body__detail__title":"AccessoryDetailContent__container__body__detail__title","AccessoryDetailContent__container__body__detail__description":"AccessoryDetailContent__container__body__detail__description","AccessoryDetailContent__container__body__buttons":"AccessoryDetailContent__container__body__buttons","AccessoryDetailContent__container__body__buttons__list":"AccessoryDetailContent__container__body__buttons__list","AccessoryDetailContent__container__body__buttons__list__item":"AccessoryDetailContent__container__body__buttons__list__item","Cta__button":"Cta__button","AccessoryDetailContent__container__variations":"AccessoryDetailContent__container__variations","AccessoryDetailContent__container__body__variations__title":"AccessoryDetailContent__container__body__variations__title","AccessoryDetailContent__container__body__variations__list":"AccessoryDetailContent__container__body__variations__list","AccessoryDetailContent__container__body__variations__list__item":"AccessoryDetailContent__container__body__variations__list__item","AccessoryDetailContent__container__body__variations__list__item__link":"AccessoryDetailContent__container__body__variations__list__item__link","AccessoryDetailContent__container__body__variations__list__item__image__wrap":"AccessoryDetailContent__container__body__variations__list__item__image__wrap","AccessoryDetailContent__container__body__variations__list__item__title":"AccessoryDetailContent__container__body__variations__list__item__title","AccessoryDetailContent__container__body__variations__list__item__price":"AccessoryDetailContent__container__body__variations__list__item__price","AccessoryDetailContent__container__body__variations__list__item__image":"AccessoryDetailContent__container__body__variations__list__item__image","AccessoryDetailContent__container__info":"AccessoryDetailContent__container__info","ModalWindow":"ModalWindow","open":"open","ModalWindow__link-close":"ModalWindow__link-close","AccessoryDetailContent__ModalWindow__modal-item":"AccessoryDetailContent__ModalWindow__modal-item","AccessoryDetailContent__ModalWindow__modal-item__container":"AccessoryDetailContent__ModalWindow__modal-item__container","AccessoryDetailContent__ModalWindow__modal-item__container__content":"AccessoryDetailContent__ModalWindow__modal-item__container__content","AccessoryDetailContent__ModalWindow__modal-item__container__content__header":"AccessoryDetailContent__ModalWindow__modal-item__container__content__header","AccessoryDetailContent__ModalWindow__modal-item__container__content__agreement":"AccessoryDetailContent__ModalWindow__modal-item__container__content__agreement","AccessoryDetailContent__ModalWindow__modal-item__container__content__list-dl":"AccessoryDetailContent__ModalWindow__modal-item__container__content__list-dl","AccessoryDetailContent__ModalWindow__modal-item__container__content__list-ul":"AccessoryDetailContent__ModalWindow__modal-item__container__content__list-ul","AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update":"AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update","AccessoryDetailContent__ModalWindow__modal-item__container__content__description":"AccessoryDetailContent__ModalWindow__modal-item__container__content__description","embeded-est":"embeded-est"};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a417895d93560dba7a2d5db0174efa5.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da274af8f834f98d0219a5bc05251fad.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79ff655614cfc10fce6f248fd58d5e39.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c905f6e41fa694eb49f547ce421d63bc.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4a23fd8a8c717cc842dac2cd903c8bd8.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "745c825c7e8a0b53a86bc40aca29adb4.png";

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_estimate_link__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_accordion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__demio_DE8_axela_sport_BM5_json__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__demio_DE8_axela_sport_BM5_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__demio_DE8_axela_sport_BM5_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axela_sedan_BM6_json__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axela_sedan_BM6_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__axela_sedan_BM6_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__demio_DE7_json__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__demio_DE7_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__demio_DE7_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atenza_sedan_GJ7_json__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atenza_sedan_GJ7_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atenza_sedan_GJ7_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\cars-comparison\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3,
    _class4,
    _temp4;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








//
 //https://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carid=demio&cartypecode=DE8&carid2=axela-sport&cartypecode2=BM5
 //http://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carId=axela-sedan&carTypeCode=BM6
 //https://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carid=demio&cartypecode=DE7
 //http://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carId=atenza-sedan&carTypeCode=GJ7





/**
 *  CarsComparison
 */
var CarsComparison = (_temp = _class = function (_Component) {
  _inherits(CarsComparison, _Component);

  function CarsComparison(props) {
    _classCallCheck(this, CarsComparison);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.selectCars = function (carId, carId2, carId3) {
      //console.log('車種選択: ' + carId + ', ' + carId2 + ', ' + carId3);
      _this.selectedCarId = carId;
      _this.selectedCarId2 = carId2;
      _this.selectedCarId3 = carId3;
      // this.setState({
      //   currentStep: 1,
      // });
      _this.setState({
        isOpened: false
      });
      setTimeout(function () {
        _this.setState({
          currentStep: 1,
          isOpened: true
        });
      }, 100);
      //
      __WEBPACK_IMPORTED_MODULE_12__components_body__["a" /* default */].scrollToNode(_this.refs.main);
    };

    _this.formatPrice = function (num) {
      return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    _this.getBodyTypeImageSrc = function (modelName, carId, carTypeCode) {
      var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 's';
      var slanting = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var past = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      var str = '';
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/';
      } else {
        str = '/globalassets/assets/cars/';
      }
      str = str + modelName + '/';
      str = str + carId + '/';
      str = str + carTypeCode + '/';
      str = str + 'common/';
      if (slanting) {
        if (past) {
          str = str + carId + '_past_chart_' + size + '.png';
        } else {
          str = str + carId + '_chart_' + size + '.png';
        }
      } else {
        str = str + 'default_' + size + '.png';
      }
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
    };

    _this.props = props;
    //
    _this.state = {
      currentStep: 0,
      isOpened: true
    };
    //
    _this.selectedCarId = null;
    _this.selectedCarId2 = null;
    _this.selectedCarId3 = null;
    _this.selectedCarTypeCode = null;
    _this.selectedCarTypeCode2 = null;
    _this.selectedCarTypeCode3 = null;
    _this.selectedGradeId = null;
    _this.selectedGradeId2 = null;
    _this.selectedGradeId3 = null;
    return _this;
  }

  CarsComparison.prototype.componentDidMount = function componentDidMount() {

    // 初期選択パラメータ
    var params = Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["e" /* getParams */])();
    if (params) {
      var carId = params.car_id1 && params.car_id1 !== '' ? params.car_id1 : null;
      var carId2 = params.car_id2 && params.car_id2 !== '' ? params.car_id2 : null;
      var carId3 = params.car_id3 && params.car_id3 !== '' ? params.car_id3 : null;
      this.selectedCarTypeCode = params.car_type_code1 && params.car_type_code1 !== '' ? params.car_type_code1 : null;
      this.selectedCarTypeCode2 = params.car_type_code2 && params.car_type_code2 !== '' ? params.car_type_code2 : null;
      this.selectedCarTypeCode3 = params.car_type_code3 && params.car_type_code3 !== '' ? params.car_type_code3 : null;
      this.selectedGradeId = params.grade1 && params.grade1 !== '' ? params.grade1 : null;
      this.selectedGradeId2 = params.grade2 && params.grade2 !== '' ? params.grade2 : null;
      this.selectedGradeId3 = params.grade3 && params.grade3 !== '' ? params.grade3 : null;
      if (carId || carId2 || carId3) {
        this.selectCars(carId, carId2, carId3);
      }
    }

    this.setState({
      isMounted: true
    });
  };

  CarsComparison.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  CarsComparison.prototype.render = function render() {
    var _this2 = this;

    // ----- Render ----- //

    // ステップ
    var renderStep = function renderStep() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__step', __source: {
            fileName: _jsxFileName,
            lineNumber: 134
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ol',
          { className: 'CarsComparison__step__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 135
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: _this2.state.currentStep === 0 ? 'current' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 137
                }
              },
              _this2.props.step1Text && _this2.props.step1Text !== '' ? _this2.props.step1Text : ''
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: _this2.state.currentStep === 1 ? 'current' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 138
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 139
                }
              },
              _this2.props.step2Text && _this2.props.step2Text !== '' ? _this2.props.step2Text : ''
            )
          )
        )
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: this.props.containerId,
        containerClass: this.props.containerClass,
        anchorPoint: this.props.anchorPoint,
        anchorName: this.props.anchorName,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison', ref: 'main', __source: {
            fileName: _jsxFileName,
            lineNumber: 152
          }
        },
        renderStep(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__container' + (this.state.isOpened === true ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 154
            }
          },
          function () {
            if (_this2.state.isMounted === true) {
              if (_this2.state.currentStep === 0) {
                var getModelsInfo = function getModelsInfo() {
                  var getMinPrice = function getMinPrice(carTypeCode, generations) {
                    var i = void 0,
                        max = void 0;
                    for (i = 0, max = generations.length; i < max; i = i + 1) {
                      var generation = generations[i];
                      // if (generation.carTypeCode === carTypeCode) {
                      if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(generation.carTypeCode, carTypeCode)) {
                        return generation.minPrice;
                      }
                    }
                  };
                  var info = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
                  var i = void 0,
                      max = void 0;
                  for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
                    var model = _this2.props.models[i];
                    var j = void 0,
                        max2 = void 0;
                    for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                      var bodyType = model.bodyTypes[j];
                      info[bodyType.carNavigationNumber - 1] = {
                        modelName: model.modelName,
                        carId: bodyType.carId,
                        carTypeCode: bodyType.defaultCarTypeCode,
                        model: bodyType.bodyTypeModel,
                        category: bodyType.bodyTypeCategory,
                        price: _this2.formatPrice(getMinPrice(bodyType.defaultCarTypeCode, bodyType.generations)) + ' 〜（消費税込）',
                        src: _this2.getBodyTypeImageSrc(model.modelName, bodyType.carId, bodyType.defaultCarTypeCode)
                      };
                    }
                  }
                  return info;
                };
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarSelector, _extends({
                  description: _this2.props.carSelectorDescription,
                  mbDescription: _this2.props.mbCarSelectorDescription,
                  buttonLabel: _this2.props.comparisonButtonLabel,
                  models: getModelsInfo(),
                  selectCars: function selectCars(carId, carId2, carId3) {
                    _this2.selectCars(carId, carId2, carId3);
                  }
                }, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 190
                  }
                }));
              } else if (_this2.state.currentStep === 1) {
                var _getModelsInfo = function _getModelsInfo() {
                  var info = [];
                  var i = void 0,
                      max = void 0;
                  for (i = 0, max = _this2.props.models.length; i < max; i = i + 1) {
                    var model = _this2.props.models[i];
                    var j = void 0,
                        max2 = void 0;
                    for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                      var bodyType = model.bodyTypes[j];
                      //
                      info.push({
                        modelName: model.modelName,
                        carId: bodyType.carId,
                        carTypeCode: bodyType.defaultCarTypeCode,
                        bodyTypeModel: bodyType.bodyTypeModel,
                        src: _this2.getBodyTypeImageSrc(model.modelName, bodyType.carId, bodyType.defaultCarTypeCode),
                        generations: bodyType.generations
                      });
                    }
                  }
                  return info;
                };
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarComparison, _extends({
                  description: _this2.props.carSelectorDescription2,
                  mbDescription: _this2.props.mbCarSelectorDescription2,
                  backToCarSelectorText: _this2.props.backToCarSelectorText,
                  specDescription: _this2.props.specDescription,
                  mbSpecDescription: _this2.props.mbSpecDescription,
                  freeArea: _this2.props.freeArea,
                  endOfSaleText: _this2.props.endOfSaleText,
                  models: _getModelsInfo(),
                  selectedCarId: _this2.selectedCarId,
                  selectedCarId2: _this2.selectedCarId2,
                  selectedCarId3: _this2.selectedCarId3,
                  selectedCarTypeCode: _this2.selectedCarTypeCode,
                  selectedCarTypeCode2: _this2.selectedCarTypeCode2,
                  selectedCarTypeCode3: _this2.selectedCarTypeCode3,
                  selectedGradeId: _this2.selectedGradeId,
                  selectedGradeId2: _this2.selectedGradeId2,
                  selectedGradeId3: _this2.selectedGradeId3
                }, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 225
                  }
                }));
              } else {
                return null;
              }
            } else {
              return null;
            }
          }()
        )
      )
    );
  };

  // 車種選択


  // 金額フォーマット


  // ボディタイプ画像パス取得


  return CarsComparison;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  step1Text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  step2Text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carSelectorDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbCarSelectorDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carSelectorDescription2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbCarSelectorDescription2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  comparisonButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backToCarSelectorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSpecDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  endOfSaleText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  freeArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    modelNameJa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      bodyTypeCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      carNavigationNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      defaultCarTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      generations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        minPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        releaseDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        endOfSale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
      }))
    }))
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  step1Text: null,
  step2Text: null,
  carSelectorDescription: null,
  mbCarSelectorDescription: null,
  carSelectorDescription2: null,
  mbCarSelectorDescription2: null,
  comparisonButtonLabel: null,
  backToCarSelectorText: null,
  specDescription: null,
  mbSpecDescription: null,
  endOfSaleText: null,
  freeArea: null,
  models: null
}, _temp);
CarsComparison.displayName = 'CarsComparison';


/* harmony default export */ __webpack_exports__["a"] = (CarsComparison);

/**
 *  CarSelector
 */
var CarSelector = (_temp2 = _class2 = function (_Component2) {
  _inherits(CarSelector, _Component2);

  function CarSelector(props) {
    _classCallCheck(this, CarSelector);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this));

    _this3.startAddAnimation = function (target, target2, src, cb) {
      var clientRect = target.getBoundingClientRect();
      var startX = clientRect.left;
      var startY = clientRect.top;
      _this3.refs.addAnimation.style.transform = 'translate(' + startX + 'px, ' + startY + 'px)';
      target.getElementsByTagName('img')[0].classList.add('drag');
      _this3.setState({
        addAnimationImageSrc: src
      });
      //
      if (_this3.pastTarget) _this3.pastTarget.classList.remove('drag');
      _this3.pastTarget = target.getElementsByTagName('img')[0];
      _this3.refs.addAnimation.classList.remove('play');
      if (_this3.intervalId2) clearTimeout(_this3.intervalId2);
      _this3.intervalId2 = setTimeout(function () {
        _this3.refs.addAnimation.classList.add('play');
        var clientRect = target2.getElementsByTagName('img')[0].getBoundingClientRect();
        // const clientRect = target2.getBoundingClientRect();
        var targetX = clientRect.left;
        var targetY = clientRect.top;
        _this3.refs.addAnimation.style.transform = 'translate(' + targetX + 'px, ' + targetY + 'px)';
        //
        //if (this.intervalId2) clearTimeout(this.intervalId2);
        _this3.intervalId2 = setTimeout(function () {
          _this3.refs.addAnimation.classList.remove('play');
          target.getElementsByTagName('img')[0].classList.remove('drag');
          if (cb) cb();
        }, 750);
      }, 100);
    };

    _this3.handleResize = function () {
      var windowTop = window.pageYOffset;
      _this3.windowHeight = window.innerHeight;
      _this3.contentTop = _this3.refs.content.getBoundingClientRect().top + windowTop;
      _this3.dropAreaTop = _this3.refs.dropArea.getBoundingClientRect().top + windowTop;
      _this3.setState({
        dropAreaHeight: _this3.refs.dropAreaContainer.getBoundingClientRect().height
      });
    };

    _this3.handleScroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (_this3.contentTop + 200 <= scrollTop + _this3.windowHeight) {
        if (_this3.dropAreaTop + _this3.state.dropAreaHeight <= scrollTop + _this3.windowHeight) {
          _this3.setState({
            dropAreaOpened: true,
            dropAreaFixed: false
          });
        } else {
          _this3.setState({
            dropAreaOpened: true,
            dropAreaFixed: true
          });
        }
      } else {
        _this3.setState({
          dropAreaOpened: false,
          dropAreaFixed: false
        });
      }
    };

    _this3.props = props;
    //
    //this.dropAreaText = '車種を選択';
    _this3.dropAreaText = '車種を選択してください';
    //
    _this3.state = {
      selectedCarId: null,
      selectedCarId2: null,
      selectedCarId3: null,
      dropAreaImageSrc: CarSelector.imageCar,
      dropAreaText: _this3.dropAreaText,
      //dropAreaText: '車種を選択してください',
      dropArea2ImageSrc: CarSelector.imageCar,
      dropArea2Text: _this3.dropAreaText,
      //dropArea2Text: '車種を選択してください',
      dropArea3ImageSrc: CarSelector.imageCar,
      dropArea3Text: _this3.dropAreaText,
      //dropArea3Text: '車種を選択してください',
      isMounted: false,
      dropAreaOpened: false,
      dropAreaFixed: false,
      dropAreaHeight: null,
      addAnimationImageSrc: CarSelector.imageCar
    };
    _this3.dragTargetRefs = [];
    _this3.dropAreaRefs = [];
    _this3.dragTargetSrc = null;
    _this3.dragTargetText = null;
    _this3.dropAreaIndex = null;
    //
    _this3.windowHeight = null;
    _this3.contentTop = null;
    _this3.dropAreaTop = null;
    _this3.intervalId = null;
    _this3.intervalId2 = null;
    _this3.pastTarget = null;
    return _this3;
  }

  CarSelector.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    // ドラッグ&ドロップイベント追加
    var setDragAndDropEvent = function setDragAndDropEvent() {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this4.dragTargetRefs.length; i < max; i = i + 1) {
        var dragTarget = _this4.refs[_this4.dragTargetRefs[i]];
        dragTarget.addEventListener('dragstart', function (e) {
          _this4.selectedCarId = e.target.dataset.carid;
          _this4.dragTargetSrc = e.target.src;
          _this4.dragTargetText = e.target.dataset.model;
        }, false);
        dragTarget.addEventListener('drag', function (e) {
          e.target.classList.add('drag');
        }, false);
        dragTarget.addEventListener('dragend', function (e) {
          if (_this4.dropAreaIndex !== null) {
            if (2 <= _this4.dropAreaIndex) {
              _this4.setState({
                selectedCarId3: _this4.selectedCarId,
                dropArea3ImageSrc: _this4.dragTargetSrc,
                dropArea3Text: _this4.dragTargetText
              });
            } else if (1 <= _this4.dropAreaIndex) {
              _this4.setState({
                selectedCarId2: _this4.selectedCarId,
                dropArea2ImageSrc: _this4.dragTargetSrc,
                dropArea2Text: _this4.dragTargetText
              });
            } else if (0 <= _this4.dropAreaIndex) {
              _this4.setState({
                selectedCarId: _this4.selectedCarId,
                dropAreaImageSrc: _this4.dragTargetSrc,
                dropAreaText: _this4.dragTargetText
              });
            }
          }
          e.target.classList.remove('drag');
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this4.dropAreaRefs.length; i < max; i = i + 1) {
            _this4.refs[_this4.dropAreaRefs[i]].classList.remove('drag-enter');
          }
        }, false);
      }
      //
      for (i = 0, max = _this4.dropAreaRefs.length; i < max; i = i + 1) {
        var dropArea = _this4.refs[_this4.dropAreaRefs[i]];
        dropArea.addEventListener('dragenter', function (e) {
          setTimeout(function () {
            _this4.dropAreaIndex = e.target.dataset.index;
            e.target.classList.add('drag-enter');
          }, 100);
        }, false);
        dropArea.addEventListener('dragleave', function (e) {
          _this4.dropAreaIndex = null;
          e.target.classList.remove('drag-enter');
        }, false);
        dropArea.addEventListener('dragover', function (e) {
          e.preventDefault();
        }, false);
      }
    };
    setDragAndDropEvent();
    //
    if (__WEBPACK_IMPORTED_MODULE_13__constants_environment__["g" /* IS_MOBILE */]) {
      this.dropAreaText = '車種を選択';
      this.setState({
        isMounted: true,
        dropAreaText: this.dropAreaText,
        dropArea2Text: this.dropAreaText,
        dropArea3Text: this.dropAreaText
      });
    } else {
      this.setState({
        isMounted: true
      });
    }
    //
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(function () {
      _this4.handleScroll();
      _this4.handleResize();
    }, 500);
  };

  CarSelector.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  };

  CarSelector.prototype.render = function render() {
    var _this5 = this;

    // ----- Render ----- //

    // 詳細
    var renderDescription = function renderDescription() {
      var getDescription = function getDescription() {
        if (_this5.props.description && _this5.props.description !== '') {
          return _this5.props.description;
        } else {
          return '';
        }
      };
      var getMbDescription = function getMbDescription() {
        if (_this5.props.mbDescription && _this5.props.mbDescription !== '') {
          return _this5.props.mbDescription;
        } else {
          return getDescription();
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-selector__description', __source: {
            fileName: _jsxFileName,
            lineNumber: 511
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'CarsComparison__car-selector__description__paragraph Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 512
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-selector__description__paragraph-pc',
            dangerouslySetInnerHTML: { __html: getDescription() }, __source: {
              fileName: _jsxFileName,
              lineNumber: 513
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-selector__description__paragraph-mb',
            dangerouslySetInnerHTML: { __html: getMbDescription() }, __source: {
              fileName: _jsxFileName,
              lineNumber: 515
            }
          })
        )
      );
    };

    // 車種選択
    var renderBodyTypes = function renderBodyTypes() {
      _this5.dragTargetRefs = [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-selector__body-types', __source: {
            fileName: _jsxFileName,
            lineNumber: 526
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'CarsComparison__car-selector__body-types__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 527
            }
          },
          _this5.props.models.map(function (bodyTypeInfo, index) {
            if (bodyTypeInfo) {
              var ref = 'bodyTypeLink' + index;
              _this5.dragTargetRefs.push(ref);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 533
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'CarsComparison__car-selector__body-types__link',
                    href: 'javascript:void(0);',
                    'data-src': bodyTypeInfo.src,
                    'data-model': bodyTypeInfo.model,
                    'data-carid': bodyTypeInfo.carId,
                    ref: ref,
                    onDragStart: function onDragStart(e) {
                      if (e.target.tagName.toUpperCase() !== 'IMG') {
                        e.preventDefault();
                        return false;
                      }
                    },
                    onClick: function onClick(e) {
                      e.preventDefault();
                      e.persist();
                      //
                      var target = e.currentTarget;
                      var src = e.currentTarget.dataset.src;
                      var carId = e.currentTarget.dataset.carid;
                      var model = e.currentTarget.dataset.model;
                      if (_this5.state.selectedCarId === null) {
                        _this5.startAddAnimation(target, _this5.refs[_this5.dropAreaRefs[0]], src, function () {
                          _this5.setState({
                            selectedCarId: carId,
                            dropAreaImageSrc: src,
                            dropAreaText: model
                          });
                        });
                      } else if (_this5.state.selectedCarId2 === null) {
                        _this5.startAddAnimation(target, _this5.refs[_this5.dropAreaRefs[1]], src, function () {
                          _this5.setState({
                            selectedCarId2: carId,
                            dropArea2ImageSrc: src,
                            dropArea2Text: model
                          });
                        });
                      } else if (_this5.state.selectedCarId3 === null) {
                        _this5.startAddAnimation(target, _this5.refs[_this5.dropAreaRefs[2]], src, function () {
                          _this5.setState({
                            selectedCarId3: carId,
                            dropArea3ImageSrc: src,
                            dropArea3Text: model
                          });
                        });
                      } else {
                        target.classList.add('attention');
                        setTimeout(function () {
                          target.classList.remove('attention');
                        }, 1000);
                      }
                    },
                    draggable: 'true',
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 534
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative' }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 587
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'CarsComparison__car-selector__body-types__box', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 588
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'CarsComparison__car-selector__body-types__box-inner', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 589
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-selector__body-types__image',
                          src: bodyTypeInfo.src,
                          'data-src': bodyTypeInfo.src,
                          'data-model': bodyTypeInfo.model,
                          'data-carid': bodyTypeInfo.carId,
                          alt: '',
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 590
                          }
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'CarsComparison__car-selector__body-types__attention', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 599
                        }
                      },
                      '\u9078\u629E\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CarsComparison__car-selector__body-types__name', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 601
                      }
                    },
                    bodyTypeInfo.model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CarsComparison__car-selector__body-types__category', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 602
                      }
                    },
                    bodyTypeInfo.category
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CarsComparison__car-selector__body-types__price', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 603
                      }
                    },
                    bodyTypeInfo.price
                  )
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'blank', key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 609
                }
              });
            }
          })
        )
      );
    };

    // ドラックアンドドロップのおき先
    var renderDropTarget = function renderDropTarget() {
      var renderDropArea = function renderDropArea(src, text) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-selector__drop-area__box', __source: {
              fileName: _jsxFileName,
              lineNumber: 622
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-selector__drop-area__box2', __source: {
                fileName: _jsxFileName,
                lineNumber: 623
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-selector__drop-area__box2-inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 624
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-selector__drop-area__image', src: src, alt: '', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 625
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'CarsComparison__car-selector__drop-area__paragraph' + (text !== _this5.dropAreaText ? ' selected' : ''), __source: {
                fileName: _jsxFileName,
                lineNumber: 628
              }
            },
            text
          )
        );
      };
      var renderLinkClose = function renderLinkClose(index) {
        if (index === 0) {
          if (_this5.state.selectedCarId === null) return;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'CarsComparison__car-selector__drop-area__link-close',
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                _this5.setState({
                  selectedCarId: null,
                  dropAreaImageSrc: CarSelector.imageCar,
                  dropAreaText: _this5.dropAreaText
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 636
              }
            },
            'CLOSE'
          );
        } else if (index === 1) {
          if (_this5.state.selectedCarId2 === null) return;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'CarsComparison__car-selector__drop-area__link-close',
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                _this5.setState({
                  selectedCarId2: null,
                  dropArea2ImageSrc: CarSelector.imageCar,
                  dropArea2Text: _this5.dropAreaText
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 651
              }
            },
            'CLOSE'
          );
        } else if (index === 2) {
          if (_this5.state.selectedCarId3 === null) return;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'CarsComparison__car-selector__drop-area__link-close',
              href: 'javascript:void(0);',
              onClick: function onClick(e) {
                e.preventDefault();
                _this5.setState({
                  selectedCarId3: null,
                  dropArea3ImageSrc: CarSelector.imageCar,
                  dropArea3Text: _this5.dropAreaText
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 666
              }
            },
            'CLOSE'
          );
        }
      };
      var renderCta = function renderCta() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 682
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { action: 'get', name: 'formSelectBodyType', __source: {
                fileName: _jsxFileName,
                lineNumber: 683
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'selectedCarId',
              value: _this5.state.selectedCarId ? _this5.state.selectedCarId : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 684
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'selectedCarId2',
              value: _this5.state.selectedCarId2 ? _this5.state.selectedCarId2 : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 686
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'selectedCarId3',
              value: _this5.state.selectedCarId3 ? _this5.state.selectedCarId3 : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 688
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__blocks__["Cta"], _extends({
            ctaType: 'Free',
            href: null,
            text: _this5.props.buttonLabel,
            targetBlank: false,
            linkType: 'Button-With-Icon',
            color: 'Dark',
            buttonStyle: 'Standard',
            handleClick: function handleClick(e) {
              e.preventDefault();
              var carId = document.forms.formSelectBodyType.selectedCarId.value && document.forms.formSelectBodyType.selectedCarId.value !== '' ? document.forms.formSelectBodyType.selectedCarId.value : null;
              var carId2 = document.forms.formSelectBodyType.selectedCarId2.value && document.forms.formSelectBodyType.selectedCarId2.value !== '' ? document.forms.formSelectBodyType.selectedCarId2.value : null;
              var carId3 = document.forms.formSelectBodyType.selectedCarId3.value && document.forms.formSelectBodyType.selectedCarId3.value !== '' ? document.forms.formSelectBodyType.selectedCarId3.value : null;
              if (_this5.props.selectCars) _this5.props.selectCars(carId, carId2, carId3);
            },
            iconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAEVJREFUGNNjIAEwQijmBjDFfgBCPYAIfoAo+QFR8wdC1UEoewglD9HIT6RGBPUHqgSqAaodbhjCaHuitCEcz9wA9RhJAADuWRclp68w/wAAAABJRU5ErkJggg==',
            hoverIconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAEVJREFUGNNjIAEwQijmBjDFfgBCPYAIfoAo+QFR8wdC1UEoewglD9HIT6RGBPUHqgSqAaodbhjCaHuitCEcz9wA9RhJAADuWRclp68w/wAAAABJRU5ErkJggg==',
            additionalClass: _this5.state.selectedCarId || _this5.state.selectedCarId2 || _this5.state.selectedCarId3 ? 'CarsComparison__car-selector__drop-area__link active' : 'CarsComparison__car-selector__drop-area__link'
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 691
            }
          }))
        );
      };
      _this5.dropAreaRefs = ['dropArea1', 'dropArea2', 'dropArea3'];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-selector__drop-area',
          style: 0 <= _this5.state.dropAreaHeight ? { height: _this5.state.dropAreaHeight } : null, ref: 'dropArea', __source: {
            fileName: _jsxFileName,
            lineNumber: 717
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'CarsComparison__car-selector__drop-area__container' + (_this5.state.dropAreaOpened === true ? ' opened' : '') + (_this5.state.dropAreaFixed === true ? ' fixed' : ''),
            ref: 'dropAreaContainer', __source: {
              fileName: _jsxFileName,
              lineNumber: 719
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-selector__drop-area__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 722
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'CarsComparison__car-selector__drop-area__list', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 723
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { ref: _this5.dropAreaRefs[0], 'data-index': '0', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 724
                  }
                },
                renderDropArea(_this5.state.dropAreaImageSrc, _this5.state.dropAreaText, 0),
                renderLinkClose(0)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { ref: _this5.dropAreaRefs[1], 'data-index': '1', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 728
                  }
                },
                renderDropArea(_this5.state.dropArea2ImageSrc, _this5.state.dropArea2Text, 1),
                renderLinkClose(1)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { ref: _this5.dropAreaRefs[2], 'data-index': '2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 732
                  }
                },
                renderDropArea(_this5.state.dropArea3ImageSrc, _this5.state.dropArea3Text, 2),
                renderLinkClose(2)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 736
                  }
                },
                renderCta()
              )
            )
          )
        )
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'CarsComparison__car-selector', __source: {
          fileName: _jsxFileName,
          lineNumber: 747
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-selector__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 748
          }
        },
        renderDescription()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: 'content', __source: {
            fileName: _jsxFileName,
            lineNumber: 751
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-selector__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 752
            }
          },
          renderBodyTypes()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-selector__container2', __source: {
              fileName: _jsxFileName,
              lineNumber: 755
            }
          },
          renderDropTarget()
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-selector__add-animation', ref: 'addAnimation', __source: {
            fileName: _jsxFileName,
            lineNumber: 759
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          src: this.state.addAnimationImageSrc, alt: '', __source: {
            fileName: _jsxFileName,
            lineNumber: 759
          }
        })
      )
    );
  };

  // 追加アニメーション開始


  //


  //


  return CarSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.imageCar = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAMAAAD0WI85AAAAdVBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkLL5WPAAAAJnRSTlMAQUjoB8qH4NjUeiyvV080Jg/Q+O6/urRgPcSjaxiolyDbgJ6TdMPCA7gAAAIeSURBVHja7dpnj+IwEAbgwem9906Z//8Tj12J094BqyQ4MKB5PiVSlNGraBzLNjDGGGOMMcYYY4wxxhhjjDHG3oTaBX67PzZuXsfWl1jLimbYt37QqfAewnLILCXBexLFrHtbdEDZ2OYGzmTUR49mmqjMcKHEGvwIaNm5Ka6SanoAVES2iY8wep/CEBAeUnyYUngvzlIV+O3Ns4gaZVJcAa/gayidcQjgd28R45ulhyo8jdBwQ6kR1+5ge9W4caQqwydRJne7LE6Dz+SAXJHjt7p+OrkxPpcHcnRVqQ99Zib4Ii48yin1Q3EO8GLJ+EiGdigMJKJcG8LuTaTEgRWqo4bEKNGK+XiN9JiLY+gKkhTCInaKRPWwQEWuNVb+Ei2kbITZSqQsh9l2SJkCs52QMgNm05EyC2YbkDINZmuQMhdmK5Ay/VN6xIbZbKSs+ZQvEsNse6RMfEgQG+Zrka4YFihfvlhynwfvPmilWmaaUw0LuEiGnuMXJT5UKixX9VSWscDJCt1zVFgtsPPLVr8ZmHiboaEU2r33TLIOXzjCM7CB9nYMXQXhi7OdE4ZhIHa/EOLHdXB+3LncVULzIHDxFh/ksYsRwMRrkwqS+P6dxsxAthGvJB3IZeH/FBWk210VCUEyNcN/GR1sIJjwpzwC+fbblrg4pnhhlrCJsf9bI/ZgM1GbT0qqxI2AzURlU8davqdztoYxxhhjjDG2lT8n6TZcxH8BKgAAAABJRU5ErkJggg==', _class2.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })])),
  selectCars: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  description: null,
  mbDescription: null,
  buttonLabel: null,
  models: null,
  selectCars: null
}, _temp2);
CarSelector.displayName = 'CarSelector';


/**
 *  CarComparison
 */
var CarComparison = (_temp3 = _class3 = function (_Component3) {
  _inherits(CarComparison, _Component3);

  function CarComparison(props) {
    _classCallCheck(this, CarComparison);

    var _this6 = _possibleConstructorReturn(this, _Component3.call(this));

    _this6.handleResize = function () {
      var windowTop = window.pageYOffset;
      _this6.navigationTop = _this6.refs.navigation.getBoundingClientRect().top + windowTop;
      _this6.navigationHeight = _this6.refs.navigation.getBoundingClientRect().height;
      _this6.specTop = _this6.refs.spec.getBoundingClientRect().top + windowTop;
      _this6.specHeight = _this6.refs.spec.getBoundingClientRect().height;
      _this6.subNavigationHeight = __WEBPACK_IMPORTED_MODULE_12__components_body__["a" /* default */].getSubNavigationHeight();

      //
      var maxHeight = _this6.refs.fixedNavigationBodyType.getBoundingClientRect().height;
      var h = _this6.refs.fixedNavigationBodyType2.getBoundingClientRect().height;
      if (0 < h && maxHeight < h) maxHeight = h;
      h = _this6.refs.fixedNavigationBodyType3.getBoundingClientRect().height;
      if (0 < h && maxHeight < h) maxHeight = h;
      maxHeight = 0 < maxHeight ? maxHeight + 5 : 'auto';

      //
      _this6.setState({
        subNavigationHeight: _this6.subNavigationHeight,
        windowWidth: window.innerWidth,
        fixedNavigationBodyTypeHeight: maxHeight
      });
    };

    _this6.handleScroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (_this6.specTop - _this6.subNavigationHeight <= scrollTop) {
        if (scrollTop + (_this6.navigationHeight + _this6.subNavigationHeight) <= _this6.specTop + _this6.specHeight) {
          if (_this6.state.fixedNavigationOpened === false) {
            _this6.setState({
              fixedNavigationOpened: true
            });
          }
        } else {
          if (_this6.state.fixedNavigationOpened === true) {
            _this6.setState({
              fixedNavigationOpened: false
            });
          }
        }
      } else {
        if (_this6.state.fixedNavigationOpened === true) {
          _this6.setState({
            fixedNavigationOpened: false
          });
        }
      }
    };

    _this6.accessApi = function (data) {

      //console.log('APIアクセス');
      //console.log(data);

      // ローディング表現
      var setLoading = function setLoading() {
        if (data[0] && data[0].carId) data[0].carId = data[0].carId.toLowerCase();
        if (data[1] && data[1].carId) data[1].carId = data[1].carId.toLowerCase();
        if (data[2] && data[2].carId) data[2].carId = data[2].carId.toLowerCase();
        var isLoading = false;
        if (data[0] && data[0].carId && data[0].carTypeCode) {
          isLoading = true;
        }
        var isLoading2 = false;
        if (data[1] && data[1].carId && data[1].carTypeCode) {
          isLoading2 = true;
        }
        var isLoading3 = false;
        if (data[2] && data[2].carId && data[2].carTypeCode) {
          isLoading3 = true;
        }
        _this6.setState({
          isLoading: isLoading,
          isLoading2: isLoading2,
          isLoading3: isLoading3
        });
      };

      // 静的JSONファイルを取得
      var accessApiStatic = function accessApiStatic() {
        //console.log('静的JSONファイルを取得');
        setTimeout(function () {
          //console.log('APIレスポンス');
          var bodyTypes = null;
          if (data[0] && data[0].carId === 'demio' && data[0].carTypeCode === 'DE8' && data[1] && data[1].carId === 'axela-sport' && data[1].carTypeCode === 'BM5') {
            bodyTypes = __WEBPACK_IMPORTED_MODULE_7__demio_DE8_axela_sport_BM5_json___default.a.bodyTypes;
          } else if (data[1] && data[1].carId === 'axela-sedan' && data[1].carTypeCode === 'BM6') {
            bodyTypes = __WEBPACK_IMPORTED_MODULE_8__axela_sedan_BM6_json___default.a.bodyTypes;
          } else if (data[0] && data[0].carId === 'demio' && data[0].carTypeCode === 'DE7') {
            bodyTypes = __WEBPACK_IMPORTED_MODULE_9__demio_DE7_json___default.a.bodyTypes;
          } else if (data[0] && data[0].carId === 'atenze-sadan' && data[0].carTypeCode === 'GJ7') {
            bodyTypes = __WEBPACK_IMPORTED_MODULE_10__atenza_sedan_GJ7_json___default.a.bodyTypes;
          }
          //
          if (bodyTypes) {
            // 1つ目変更
            if (data[0] && data[0].carId && data[0].carTypeCode) {
              var i = void 0,
                  max = void 0;
              for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
                var bodyType = bodyTypes[i];
                if (data[0].carId === bodyType.carId && data[0].carTypeCode === bodyType.generation.carTypeCode) {
                  _this6.bodyTypeInfo = bodyType;
                  var defaultGradeId = _this6.getDefaultGradeId(bodyType);
                  var defaultVariantId = _this6.getDefaultVariantId(bodyType, defaultGradeId);
                  _this6.setState({
                    selectedCarId: data[0].carId,
                    selectedCarTypeCode: data[0].carTypeCode,
                    selectedGradeId: defaultGradeId,
                    selectedVariantId: defaultVariantId,
                    isLoading: false
                  });
                }
              }
            }
            // 2つ目変更
            if (data[1] && data[1].carId && data[1].carTypeCode) {
              var _i = void 0,
                  _max = void 0;
              for (_i = 0, _max = bodyTypes.length; _i < _max; _i = _i + 1) {
                var _bodyType = bodyTypes[_i];
                if (data[1].carId === _bodyType.carId && data[1].carTypeCode === _bodyType.generation.carTypeCode) {
                  _this6.bodyTypeInfo2 = _bodyType;
                  var _defaultGradeId = _this6.getDefaultGradeId(_bodyType);
                  var _defaultVariantId = _this6.getDefaultVariantId(_bodyType, _defaultGradeId);
                  _this6.setState({
                    selectedCarId2: data[1].carId,
                    selectedCarTypeCode2: data[1].carTypeCode,
                    selectedGradeId2: _defaultGradeId,
                    selectedVariantId2: _defaultVariantId,
                    isLoading2: false
                  });
                }
              }
            }
            // 3つ目変更
            if (data[2] && data[2].carId && data[2].carTypeCode) {
              var _i2 = void 0,
                  _max2 = void 0;
              for (_i2 = 0, _max2 = bodyTypes.length; _i2 < _max2; _i2 = _i2 + 1) {
                var _bodyType2 = bodyTypes[_i2];
                if (data[2].carId === _bodyType2.carId && data[2].carTypeCode === _bodyType2.generation.carTypeCode) {
                  _this6.bodyTypeInfo3 = _bodyType2;
                  var _defaultGradeId2 = _this6.getDefaultGradeId(_bodyType2);
                  var _defaultVariantId2 = _this6.getDefaultVariantId(_bodyType2, _defaultGradeId2);
                  _this6.setState({
                    selectedCarId3: data[2].carId,
                    selectedCarTypeCode3: data[2].carTypeCode,
                    selectedGradeId3: _defaultGradeId2,
                    selectedVariantId3: _defaultVariantId2,
                    isLoading3: false
                  });
                }
              }
            }
          }
          // スペック変更
          _this6.refs.carComparisonDetail.changeSpecs();
        }, 3000);
      };

      // 動的JSONファイルを取得
      var accessApiDynamic = function accessApiDynamic() {
        //console.log('動的JSONファイルを取得');
        var params = new URLSearchParams();
        if (data[0] && data[0].carId && data[0].carTypeCode) {
          params.set('carId', data[0].carId);
          params.set('carTypeCode', data[0].carTypeCode);
        }
        if (data[1] && data[1].carId && data[1].carTypeCode) {
          params.set('carId2', data[1].carId);
          params.set('carTypeCode2', data[1].carTypeCode);
        }
        if (data[2] && data[2].carId && data[2].carTypeCode) {
          params.set('carId3', data[2].carId);
          params.set('carTypeCode3', data[2].carTypeCode);
        }
        //params.set('carId', 'atenza-sedan');
        //params.set('carTypeCode', 'GJ7');

        //let apiUrl = '/api/mjo/automotive/cars-comparison?';
        var apiUrl = null;
        if (0 <= String(location.hostname).indexOf('localhost')) {
          // apiUrl = 'http://uat.mazda.co.jp/api/mjo/automotive/cars-comparison?';
          apiUrl = 'http://dev.mazda.co.jp/api/mjo/automotive/cars-comparison?';
        } else {
          apiUrl = '/api/mjo/automotive/cars-comparison?';
        }

        /*
        // let xhr = new XMLHttpRequest();
        this.xhr.onreadystatechange = (e, e2) => {
          if (this.xhr.readyState === 4 && this.xhr.status === 200) {
            // 本番
            console.log('本番');
            console.log(this.xhr.responseText);
          } else if (this.xhr.readyState === 4 && this.xhr.status === 0) {
            // ローカル
            console.log('ローカル');
            console.log(this.xhr.responseText);
          } else {
          }
        };
        this.xhr.open('GET', apiUrl + params.toString(), true);
        this.xhr.setRequestHeader('Accept', 'application/json');
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        // this.xhr.setRequestHeader('Content-Type', 'application/json');
        this.xhr.send();
        this.xhr.abort();
        return;
        */

        //fetch('/api/mjo/automotive/cars-comparison?' + params.toString(), {
        fetch(apiUrl + params.toString(), {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
            // 'Content-Type': 'application/json',
          },
          method: 'GET',
          mode: 'cors'
          // mode: 'same-origin',
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          // console.log('APIレスポンス');
          // console.log(json);
          //
          var bodyTypes = json.bodyTypes || null;
          if (bodyTypes) {
            // 1つ目変更
            if (data[0] && data[0].carId && data[0].carTypeCode) {
              var i = void 0,
                  max = void 0;
              for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
                var bodyType = bodyTypes[i];
                if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[0].carId, bodyType.carId) && Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[0].carTypeCode, bodyType.generation.carTypeCode)) {
                  _this6.bodyTypeInfo = bodyType;
                  //const defaultGradeId = this.getDefaultGradeId(bodyType);

                  // 初期パラメータによってデフォルトグレードを変更
                  var defaultGradeId = null;
                  if (_this6.selectedGradeId) {
                    defaultGradeId = _this6.selectedGradeId;
                    _this6.selectedGradeId = null;
                  } else {
                    defaultGradeId = _this6.getDefaultGradeId(bodyType);
                  }

                  var defaultVariantId = _this6.getDefaultVariantId(bodyType, defaultGradeId);
                  _this6.setState({
                    selectedCarId: data[0].carId,
                    selectedCarTypeCode: data[0].carTypeCode,
                    selectedGradeId: defaultGradeId,
                    selectedVariantId: defaultVariantId,
                    isLoading: false
                  });

                  break;
                }
              }
            }
            // 2つ目変更
            if (data[1] && data[1].carId && data[1].carTypeCode) {
              var _i3 = void 0,
                  _max3 = void 0;
              for (_i3 = 0, _max3 = bodyTypes.length; _i3 < _max3; _i3 = _i3 + 1) {
                var _bodyType3 = bodyTypes[_i3];
                if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[1].carId, _bodyType3.carId) && Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[1].carTypeCode, _bodyType3.generation.carTypeCode)) {
                  _this6.bodyTypeInfo2 = _bodyType3;
                  //const defaultGradeId = this.getDefaultGradeId(bodyType);

                  // 初期パラメータによってデフォルトグレードを変更
                  var _defaultGradeId3 = null;
                  if (_this6.selectedGradeId2) {
                    _defaultGradeId3 = _this6.selectedGradeId2;
                    _this6.selectedGradeId2 = null;
                  } else {
                    _defaultGradeId3 = _this6.getDefaultGradeId(_bodyType3);
                  }

                  var _defaultVariantId3 = _this6.getDefaultVariantId(_bodyType3, _defaultGradeId3);
                  _this6.setState({
                    selectedCarId2: data[1].carId,
                    selectedCarTypeCode2: data[1].carTypeCode,
                    selectedGradeId2: _defaultGradeId3,
                    selectedVariantId2: _defaultVariantId3,
                    isLoading2: false
                  });

                  break;
                }
              }
            }
            // 3つ目変更
            if (data[2] && data[2].carId && data[2].carTypeCode) {
              var _i4 = void 0,
                  _max4 = void 0;
              for (_i4 = 0, _max4 = bodyTypes.length; _i4 < _max4; _i4 = _i4 + 1) {
                var _bodyType4 = bodyTypes[_i4];
                if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[2].carId, _bodyType4.carId) && Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(data[2].carTypeCode, _bodyType4.generation.carTypeCode)) {
                  _this6.bodyTypeInfo3 = _bodyType4;
                  //const defaultGradeId = this.getDefaultGradeId(bodyType);

                  // 初期パラメータによってデフォルトグレードを変更
                  var _defaultGradeId4 = null;
                  if (_this6.selectedGradeId3) {
                    _defaultGradeId4 = _this6.selectedGradeId3;
                    _this6.selectedGradeId3 = null;
                  } else {
                    _defaultGradeId4 = _this6.getDefaultGradeId(_bodyType4);
                  }

                  var _defaultVariantId4 = _this6.getDefaultVariantId(_bodyType4, _defaultGradeId4);
                  _this6.setState({
                    selectedCarId3: data[2].carId,
                    selectedCarTypeCode3: data[2].carTypeCode,
                    selectedGradeId3: _defaultGradeId4,
                    selectedVariantId3: _defaultVariantId4,
                    isLoading3: false
                  });

                  break;
                }
              }
            }
          }
          // スペック変更
          _this6.refs.carComparisonDetail.changeSpecs();
        });
      };

      // ローディング表現
      setLoading();

      // 静的JSONファイルを取得
      // accessApiStatic();

      // 動的JSONファイルを取得
      // accessApiDynamic();

      if (0 <= String(location.hostname).indexOf('localhost')) {
        // 静的JSONファイルを取得
        accessApiStatic();
      } else {
        // 動的JSONファイルを取得
        accessApiDynamic();
      }
    };

    _this6.changeGrade = function (gradeId, index) {
      if (index === 0) {
        _this6.setState({
          selectedGradeId: gradeId,
          selectedVariantId: _this6.getDefaultVariantId(_this6.bodyTypeInfo, gradeId)
        });
      } else if (index === 1) {
        _this6.setState({
          selectedGradeId2: gradeId,
          selectedVariantId2: _this6.getDefaultVariantId(_this6.bodyTypeInfo2, gradeId)
        });
      } else if (index === 2) {
        _this6.setState({
          selectedGradeId3: gradeId,
          selectedVariantId3: _this6.getDefaultVariantId(_this6.bodyTypeInfo3, gradeId)
        });
      }
      // スペック変更
      _this6.refs.carComparisonDetail.changeSpecs();
    };

    _this6.changeVariant = function (variantId, index) {
      if (index === 0) {
        _this6.setState({
          selectedVariantId: variantId
        });
      } else if (index === 1) {
        _this6.setState({
          selectedVariantId2: variantId
        });
      } else if (index === 2) {
        _this6.setState({
          selectedVariantId3: variantId
        });
      }
      // スペック変更
      _this6.refs.carComparisonDetail.changeSpecs();
    };

    _this6.getModelInfo = function (carId) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this6.props.models.length; i < max; i = i + 1) {
        var model = _this6.props.models[i];
        if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(model.carId, carId)) {
          return model;
        }
      }
      return null;
    };

    _this6.getGenerationInfo = function (carId, carTypeCode) {
      var model = _this6.getModelInfo(carId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = model.generations.length; i < max; i = i + 1) {
        var generation = model.generations[i];
        if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(generation.carTypeCode, carTypeCode)) {
          return generation;
        }
      }
      return null;
    };

    _this6.getGradesInfo = function (bodyTypeInfo) {
      return bodyTypeInfo.generation.grades;
    };

    _this6.getGradeInfo = function (bodyTypeInfo, gradeId) {
      var gradesInfo = _this6.getGradesInfo(bodyTypeInfo);
      var i = void 0,
          max = void 0;
      for (i = 0, max = gradesInfo.length; i < max; i = i + 1) {
        var gradeInfo = gradesInfo[i];
        if (gradeInfo.gradeId === gradeId) {
          return gradeInfo;
        }
      }
      return null;
    };

    _this6.getDefaultGradeId = function (bodyTypeInfo) {
      var gradeId = bodyTypeInfo.generation.defaultGradeId;
      if (gradeId) {
        return gradeId;
      } else {
        return bodyTypeInfo.generation.grades[0].gradeId;
      }
    };

    _this6.getVariantsInfo = function (bodyTypeInfo, gradeId) {
      var gradeInfo = _this6.getGradeInfo(bodyTypeInfo, gradeId);
      return gradeInfo.variants;
    };

    _this6.getVariantInfo = function (bodyTypeInfo, gradeId, variantId) {
      var variantsInfo = _this6.getVariantsInfo(bodyTypeInfo, gradeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
        var variantInfo = variantsInfo[i];
        if (variantInfo.variantId === variantId) {
          return variantInfo;
        }
      }
      return null;
    };

    _this6.getDefaultVariantId = function (bodyTypeInfo, gradeId) {
      var gradeInfo = _this6.getGradeInfo(bodyTypeInfo, gradeId);
      var variantsInfo = _this6.getVariantsInfo(bodyTypeInfo, gradeId);
      var i = void 0,
          max = void 0;
      for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
        var variantInfo = variantsInfo[i];
        if (variantInfo.drive === gradeInfo.defaultDrive && variantInfo.transmission === gradeInfo.defaultMission) {
          return variantInfo.variantId;
        }
      }
      return variantsInfo[0].variantId;
    };

    _this6.getSpecComparisonProps = function () {

      var getModelNameByCarId = function getModelNameByCarId(carId) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this6.props.models.length; i < max; i = i + 1) {
          var model = _this6.props.models[i];
          if (Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(model.carId, carId)) {
            return model.modelName;
          }
        }
        return null;
      };

      var gradeInfo = null;
      var gradeInfo2 = null;
      var gradeInfo3 = null;
      if (_this6.bodyTypeInfo) {
        var variantInfo = _this6.getVariantInfo(_this6.bodyTypeInfo, _this6.state.selectedGradeId, _this6.state.selectedVariantId);
        gradeInfo = {
          modelName: getModelNameByCarId(_this6.state.selectedCarId),
          carId: _this6.state.selectedCarId,
          carTypeCode: _this6.state.selectedCarTypeCode,
          gradeId: _this6.state.selectedGradeId,
          specs: variantInfo.specs
        };
      }
      if (_this6.bodyTypeInfo2) {
        var _variantInfo = _this6.getVariantInfo(_this6.bodyTypeInfo2, _this6.state.selectedGradeId2, _this6.state.selectedVariantId2);
        gradeInfo2 = {
          modelName: getModelNameByCarId(_this6.state.selectedCarId2),
          carId: _this6.state.selectedCarId2,
          carTypeCode: _this6.state.selectedCarTypeCode2,
          gradeId: _this6.state.selectedGradeId2,
          specs: _variantInfo.specs
        };
      }
      if (_this6.bodyTypeInfo3) {
        var _variantInfo2 = _this6.getVariantInfo(_this6.bodyTypeInfo3, _this6.state.selectedGradeId3, _this6.state.selectedVariantId3);
        gradeInfo3 = {
          modelName: getModelNameByCarId(_this6.state.selectedCarId3),
          carId: _this6.state.selectedCarId3,
          carTypeCode: _this6.state.selectedCarTypeCode3,
          gradeId: _this6.state.selectedGradeId3,
          specs: _variantInfo2.specs
        };
      }
      return { compareGrades: [gradeInfo, gradeInfo2, gradeInfo3] };
    };

    _this6.formatReleaseDate = function () {
      var YYYYMMDD = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!YYYYMMDD || YYYYMMDD === '') return '';
      var str = String(YYYYMMDD).substr(0, 4) + '年';
      str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
      return str;
    };

    _this6.formatPrice = function (num) {
      return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    _this6.props = props;
    //
    _this6.state = {
      isLoading: false,
      isLoading2: false,
      isLoading3: false,
      selectedCarId: _this6.props.selectedCarId,
      selectedCarId2: _this6.props.selectedCarId2,
      selectedCarId3: _this6.props.selectedCarId3,
      selectedCarTypeCode: null,
      selectedCarTypeCode2: null,
      selectedCarTypeCode3: null,
      selectedGradeId: null,
      selectedGradeId2: null,
      selectedGradeId3: null,
      selectedVariantId: null,
      selectedVariantId2: null,
      selectedVariantId3: null,
      //
      isMounted: false,
      fixedNavigationOpened: false,
      subNavigationHeight: null,
      windowWidth: null,
      fixedNavigationBodyTypeHeight: 'auto',
      //
      openLeftCondition: false,
      openCenterCondition: false,
      openRightCondition: false
    };

    // 初期URLパラメータ
    _this6.selectedGradeId = _this6.props.selectedGradeId;
    _this6.selectedGradeId2 = _this6.props.selectedGradeId2;
    _this6.selectedGradeId3 = _this6.props.selectedGradeId3;

    _this6.bodyTypeInfo = null;
    _this6.bodyTypeInfo2 = null;
    _this6.bodyTypeInfo3 = null;
    //
    _this6.subNavigationHeight = null;
    _this6.navigationTop = null;
    _this6.navigationHeight = null;
    _this6.specTop = null;
    _this6.specHeight = null;
    _this6.intervalId = null;
    _this6.xhr = new XMLHttpRequest();
    return _this6;
  }

  CarComparison.prototype.componentDidMount = function componentDidMount() {
    var _this7 = this;

    //
    this.setState({
      isMounted: true
    });

    // APIアクセス
    var params = [];
    // URLパラメータからAPIのパラメータを取得
    if (this.state.selectedCarId && this.props.selectedCarTypeCode) {
      params.push({
        carId: this.state.selectedCarId ? this.state.selectedCarId : null,
        carTypeCode: this.props.selectedCarTypeCode
      });
    }
    if (this.state.selectedCarId2 && this.props.selectedCarTypeCode2) {
      params.push({
        carId: this.state.selectedCarId2 ? this.state.selectedCarId2 : null,
        carTypeCode: this.props.selectedCarTypeCode2
      });
    }
    if (this.state.selectedCarId3 && this.props.selectedCarTypeCode3) {
      params.push({
        carId: this.state.selectedCarId3 ? this.state.selectedCarId3 : null,
        carTypeCode: this.props.selectedCarTypeCode3
      });
    }
    if (1 <= params.length) {
      // URLパラメータで指定されていた場合
      this.accessApi(params);
    } else {
      // URLパラメータの指定がない場合
      this.accessApi([{
        carId: this.state.selectedCarId ? this.state.selectedCarId : null,
        carTypeCode: this.state.selectedCarId ? this.getModelInfo(this.state.selectedCarId).carTypeCode : null
      }, {
        carId: this.state.selectedCarId2 ? this.state.selectedCarId2 : null,
        carTypeCode: this.state.selectedCarId2 ? this.getModelInfo(this.state.selectedCarId2).carTypeCode : null
      }, {
        carId: this.state.selectedCarId3 ? this.state.selectedCarId3 : null,
        carTypeCode: this.state.selectedCarId3 ? this.getModelInfo(this.state.selectedCarId3).carTypeCode : null
      }]);
    }

    //
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this7.handleScroll();
      _this7.handleResize();
    }, 200);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(function () {
      _this7.specHeight = _this7.refs.spec.getBoundingClientRect().height;
      _this7.handleScroll();
      _this7.handleResize();
    }, 500);
  };

  CarComparison.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  };

  CarComparison.prototype.render = function render() {
    var _this8 = this;

    // ----- Render ----- //

    // 詳細
    var renderDescription = function renderDescription() {
      var getDescription = function getDescription() {
        if (_this8.props.description && _this8.props.description !== '') {
          return _this8.props.description;
        } else {
          return '';
        }
      };
      var getMbDescription = function getMbDescription() {
        if (_this8.props.mbDescription && _this8.props.mbDescription !== '') {
          return _this8.props.mbDescription;
        } else {
          return getDescription();
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison__description', __source: {
            fileName: _jsxFileName,
            lineNumber: 1025
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'CarsComparison__car-comparison__description__paragraph Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 1026
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison__description__paragraph-pc',
            dangerouslySetInnerHTML: { __html: getDescription() }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1027
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison__description__paragraph-mb',
            dangerouslySetInnerHTML: { __html: getMbDescription() }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1029
            }
          })
        )
      );
    };

    // 車種アウトライン
    var renderNavigation = function renderNavigation() {

      // 車種画像
      var renderImage = function renderImage() {
        var renderImageItem = function renderImageItem(carId) {
          if (carId) {
            var modelInfo = _this8.getModelInfo(carId);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison__navigation__car-image', src: modelInfo.src, __source: {
                fileName: _jsxFileName,
                lineNumber: 1045
              }
            });
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison__navigation__car-image', src: CarSelector.imageCar, __source: {
                fileName: _jsxFileName,
                lineNumber: 1049
              }
            });
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl car-image', __source: {
              fileName: _jsxFileName,
              lineNumber: 1054
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1055
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { visibility: 'hidden' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1055
                }
              },
              '\u8ECA\u7A2E\u753B\u50CF'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openLeftCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1056
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1057
                }
              },
              renderImageItem(_this8.state.selectedCarId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openCenterCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1061
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1062
                }
              },
              renderImageItem(_this8.state.selectedCarId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openRightCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1066
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1067
                }
              },
              renderImageItem(_this8.state.selectedCarId3)
            )
          )
        );
      };

      // グレード
      var renderGrade2 = function renderGrade2() {
        var renderGradeItem = function renderGradeItem(bodyTypeInfo, carId, gradeId) {

          // 100th Anniversary Special Edition > 100周年特別記念車
          var convert100th = function convert100th(text) {
            if (text && text !== '') {
              text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
              text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
              text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
              text = text.replace('RF 35th SV', '35周年記念車');
              text = text.replace('35th SV', '35周年記念車');
              text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
              text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
              text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
              text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
              text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
              text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
              text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
              text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
              text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
              text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
              text = text.replace('15 SPORT Plus', '15 SPORT＋');
              text = text.replace('XD SPORT Plus', 'XD SPORT＋');
              return text;
            } else {
              return text;
            }
          };

          if (bodyTypeInfo) {
            var modelInfo = _this8.getModelInfo(carId);
            var bodyTypeModel = null;
            if (modelInfo) {
              bodyTypeModel = modelInfo.bodyTypeModel;
            }
            var gradeInfo = _this8.getGradeInfo(bodyTypeInfo, gradeId);
            var specialCar = null;
            var gradeName = null;
            if (gradeInfo) {
              specialCar = gradeInfo.specialCar;
              gradeName = gradeInfo.gradeName;
            }
            var label = gradeName || gradeId;
            if (specialCar === 'true' || specialCar === true) {
              label = gradeId;
            }
            if (label) {
              label = label.replace(/[|]/g, ' ');
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__grade', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1126
                }
              },
              convert100th(bodyTypeModel),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1128
                }
              }),
              convert100th(label)
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1134
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1134
                  }
                },
                '-'
              )
            );
          }
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl grade2', __source: {
              fileName: _jsxFileName,
              lineNumber: 1140
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1141
              }
            },
            '\u30B0\u30EC\u30FC\u30C9'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openLeftCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1143
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1144
                }
              },
              renderGradeItem(_this8.bodyTypeInfo, _this8.state.selectedCarId, _this8.state.selectedGradeId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openCenterCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1149
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1150
                }
              },
              renderGradeItem(_this8.bodyTypeInfo2, _this8.state.selectedCarId2, _this8.state.selectedGradeId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openRightCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1155
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1156
                }
              },
              renderGradeItem(_this8.bodyTypeInfo3, _this8.state.selectedCarId3, _this8.state.selectedGradeId3)
            )
          )
        );
      };

      // 価格
      var renderPrice2 = function renderPrice2() {
        var renderPriceItem = function renderPriceItem(carId, carTypeCode, bodyTypeInfo, gradeId, variantId) {
          if (bodyTypeInfo) {
            var generationInfo = _this8.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              var variantInfo = _this8.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__price', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1172
                  }
                },
                _this8.formatPrice(variantInfo.price),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1174
                    }
                  },
                  '\u301C',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1174
                    }
                  }),
                  '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__end-of-sale', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1179
                  }
                },
                '\u751F\u7523\u7D42\u4E86'
              );
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1184
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1184
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl price2', __source: {
              fileName: _jsxFileName,
              lineNumber: 1189
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1190
              }
            },
            '\u4FA1\u683C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openLeftCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1192
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1193
                }
              },
              renderPriceItem(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openCenterCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1198
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1199
                }
              },
              renderPriceItem(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openRightCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1204
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1205
                }
              },
              renderPriceItem(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3)
            )
          )
        );
      };

      // 車種
      var renderBodyType = function renderBodyType() {
        var renderBodyTypeItem = function renderBodyTypeItem(carId, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            { className: 'CarsComparison__car-comparison__navigation__select',
              onChange: function onChange(e) {
                if (!e.currentTarget.value || e.currentTarget.value === '') {
                  if (index === 0) {
                    _this8.bodyTypeInfo = null;
                    _this8.setState({
                      selectedCarId: null,
                      selectedCarTypeCode: null,
                      selectedGradeId: null,
                      selectedVariantId: null
                    });
                  } else if (index === 1) {
                    _this8.bodyTypeInfo2 = null;
                    _this8.setState({
                      selectedCarId2: null,
                      selectedCarTypeCode2: null,
                      selectedGradeId2: null,
                      selectedVariantId2: null
                    });
                  } else if (index === 2) {
                    _this8.bodyTypeInfo3 = null;
                    _this8.setState({
                      selectedCarId3: null,
                      selectedCarTypeCode3: null,
                      selectedGradeId3: null,
                      selectedVariantId3: null
                    });
                  }
                } else {
                  var _carId = e.currentTarget.value;
                  var carTypeCode = _this8.getModelInfo(_carId).carTypeCode;
                  if (index === 0) {
                    // APIアクセス
                    _this8.accessApi([{
                      carId: _carId,
                      carTypeCode: carTypeCode
                    }]);
                  } else if (index === 1) {
                    // APIアクセス
                    _this8.accessApi([null, {
                      carId: _carId,
                      carTypeCode: carTypeCode
                    }]);
                  } else if (index === 2) {
                    // APIアクセス
                    _this8.accessApi([null, null, {
                      carId: _carId,
                      carTypeCode: carTypeCode
                    }]);
                  }

                  // GTMイベント
                  __WEBPACK_IMPORTED_MODULE_12__components_body__["a" /* default */].setGTMEvent({
                    trackcartype: _this8.getModelInfo(_carId).bodyTypeModel,
                    event: 'CarsComparisonSelect'
                  });
                }
              },
              defaultValue: carId,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1217
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { value: '', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1278
                }
              },
              '\u8ECA\u7A2E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044'
            ),
            _this8.props.models.map(function (model, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: index, value: model.carId, selected: Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(carId, model.carId) ? true : false, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1281
                  }
                },
                model.bodyTypeModel
              );
            })
          );
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 1290
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1291
              }
            },
            '\u8ECA\u7A2E'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1293
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1294
                }
              },
              renderBodyTypeItem(_this8.state.selectedCarId, 0)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1299
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1300
                }
              },
              renderBodyTypeItem(_this8.state.selectedCarId2, 1)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1305
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1306
                }
              },
              renderBodyTypeItem(_this8.state.selectedCarId3, 2)
            )
          )
        );
      };

      // 発売年月
      var renderReleaseDate = function renderReleaseDate() {
        var renderReleaseDateItem = function renderReleaseDateItem(carId, carTypeCode, index) {
          if (carId) {
            var modelInfo = _this8.getModelInfo(carId);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { className: 'CarsComparison__car-comparison__navigation__select',
                onChange: function onChange(e) {
                  var carId = carId;
                  var carTypeCode = e.currentTarget.value;
                  if (index === 0) {
                    // APIアクセス
                    _this8.accessApi([{
                      carId: _this8.state.selectedCarId,
                      carTypeCode: carTypeCode
                    }]);
                  } else if (index === 1) {
                    // APIアクセス
                    _this8.accessApi([null, {
                      carId: _this8.state.selectedCarId2,
                      carTypeCode: carTypeCode
                    }]);
                  } else if (index === 2) {
                    // APIアクセス
                    _this8.accessApi([null, null, {
                      carId: _this8.state.selectedCarId3,
                      carTypeCode: carTypeCode
                    }]);
                  }
                },
                defaultValue: modelInfo.carTypeCode,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1320
                }
              },
              modelInfo.generations.map(function (generation, index) {
                if (generation.endOfSale === true) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { key: index, value: generation.carTypeCode, selected: Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(generation.carTypeCode, carTypeCode) ? true : false, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1349
                      }
                    },
                    _this8.formatReleaseDate(generation.releaseDate) + '(' + _this8.props.endOfSaleText + ')'
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { key: index, value: generation.carTypeCode, selected: Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(generation.carTypeCode, carTypeCode) ? true : false, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1355
                      }
                    },
                    _this8.formatReleaseDate(generation.releaseDate)
                  );
                }
              })
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1365
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1365
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 1370
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1371
              }
            },
            '\u767A\u8868\u30FB\u767A\u58F2\u5E74\u6708'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1373
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1374
                }
              },
              renderReleaseDateItem(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, 0)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1379
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1380
                }
              },
              renderReleaseDateItem(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, 1)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1385
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1386
                }
              },
              renderReleaseDateItem(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, 2)
            )
          )
        );
      };

      // グレード
      var renderGrade = function renderGrade() {
        var renderGradeItem = function renderGradeItem(bodyTypeInfo, gradeId, index) {

          // 100th Anniversary Special Edition > 100周年特別記念車
          var convert100th = function convert100th(text) {
            if (text && text !== '') {
              text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
              text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
              text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
              text = text.replace('RF 35th SV', '35周年記念車');
              text = text.replace('35th SV', '35周年記念車');
              text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
              text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
              text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
              text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
              text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
              text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
              text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
              text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
              text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
              text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
              text = text.replace('15 SPORT Plus', '15 SPORT＋');
              text = text.replace('XD SPORT Plus', 'XD SPORT＋');
              return text;
            } else {
              return text;
            }
          };

          if (gradeId) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { className: 'CarsComparison__car-comparison__navigation__select',
                onChange: function onChange(e) {
                  // グレード変更
                  _this8.changeGrade(e.currentTarget.value, index);
                },
                defaultValue: gradeId,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1426
                }
              },
              _this8.getGradesInfo(bodyTypeInfo).map(function (grade, index) {
                var label = grade.gradeName;
                if (grade.specialCar === 'true' || grade.specialCar === true) {
                  label = grade.gradeId;
                } else {
                  if (!label || label === '') {
                    label = grade.gradeId;
                  }
                }
                label = label.replace(/[|]/g, ' ');
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { key: index, value: grade.gradeId, selected: Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["f" /* isEqualId */])(grade.gradeId, gradeId) ? true : false, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1444
                    }
                  },
                  convert100th(label)
                );
              })
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1454
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1454
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 1459
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1460
              }
            },
            '\u30B0\u30EC\u30FC\u30C9'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1462
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1463
                }
              },
              renderGradeItem(_this8.bodyTypeInfo, _this8.state.selectedGradeId, 0)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1468
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1469
                }
              },
              renderGradeItem(_this8.bodyTypeInfo2, _this8.state.selectedGradeId2, 1)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1474
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1475
                }
              },
              renderGradeItem(_this8.bodyTypeInfo3, _this8.state.selectedGradeId3, 2)
            )
          )
        );
      };

      // 機種
      var renderVariant = function renderVariant() {
        var renderVariantItem = function renderVariantItem(bodyTypeInfo, gradeId, variantId, index) {
          if (bodyTypeInfo) {
            var variantsInfo = _this8.getVariantsInfo(bodyTypeInfo, gradeId);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { className: 'CarsComparison__car-comparison__navigation__select',
                onChange: function onChange(e) {
                  // 機種変更
                  _this8.changeVariant(e.currentTarget.value, index);
                },
                defaultValue: variantId,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1489
                }
              },
              variantsInfo.map(function (variant, index2) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { key: index2, value: variant.variantId, selected: variant.variantId === variantId ? true : false, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1498
                    }
                  },
                  variant.drive + ' / ' + variant.transmission
                );
              })
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1507
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1507
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 1512
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1513
              }
            },
            '\u99C6\u52D5/\u30DF\u30C3\u30B7\u30E7\u30F3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1515
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1516
                }
              },
              renderVariantItem(_this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId, 0)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1521
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1522
                }
              },
              renderVariantItem(_this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2, 1)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1527
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1528
                }
              },
              renderVariantItem(_this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3, 2)
            )
          )
        );
      };

      // 価格
      var renderPrice = function renderPrice() {
        var renderPriceItem = function renderPriceItem(carId, carTypeCode, bodyTypeInfo, gradeId, variantId) {
          if (bodyTypeInfo) {
            var generationInfo = _this8.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              var variantInfo = _this8.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__price', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1544
                  }
                },
                _this8.formatPrice(variantInfo.price),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1546
                    }
                  },
                  '\u301C',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1546
                    }
                  }),
                  '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__end-of-sale', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1551
                  }
                },
                '\u751F\u7523\u7D42\u4E86'
              );
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1556
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1556
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl price', __source: {
              fileName: _jsxFileName,
              lineNumber: 1561
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1562
              }
            },
            '\u4FA1\u683C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1564
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1565
                }
              },
              renderPriceItem(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1570
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1571
                }
              },
              renderPriceItem(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1576
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1577
                }
              },
              renderPriceItem(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3)
            )
          )
        );
      };

      // エコカー
      var renderTaxInfo = function renderTaxInfo() {
        var renderTaxInfoItem = function renderTaxInfoItem(carId, carTypeCode, bodyTypeInfo, gradeId, variantId) {
          if (bodyTypeInfo) {
            var generationInfo = _this8.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              // const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
              var variantInfo = _this8.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              var renderKankyowari = function renderKankyowari() {
                if (variantInfo) {
                  if (variantInfo.kankyowari === true || variantInfo.kankyowari === 'true') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarsComparison__car-comparison__navigation__tax-item', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1597
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1598
                          }
                        },
                        '環境性能割 ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1600
                          }
                        }),
                        '非課税'
                      )
                    );
                    // } else if (variantInfo.kankyowari === false || variantInfo.kankyowari === 'false') {
                    //   return (
                    //     <li className="CarsComparison__car-comparison__navigation__tax-item">
                    //       <span>
                    //         {'環境性能割 '}
                    //         <br/>
                    //         {'課税対象'}
                    //       </span>
                    //     </li>
                    //   )
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              var renderSubsidy = function renderSubsidy() {
                if (variantInfo) {
                  if (variantInfo.subsidy === true || variantInfo.subsidy === 'true') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarsComparison__car-comparison__navigation__tax-item', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1626
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1632
                          }
                        },
                        'CEV補助金'
                      )
                    );
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              var renderTax = function renderTax() {
                if (variantInfo) {
                  var weightTaxRate = Number(variantInfo.taxInfo.weightTaxRate);
                  if (100 <= weightTaxRate) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarsComparison__car-comparison__navigation__tax-item', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1649
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1650
                          }
                        },
                        '重量税 ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1652
                          }
                        }),
                        '免税'
                      )
                    );
                  } else if (1 <= weightTaxRate) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'CarsComparison__car-comparison__navigation__tax-item', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1659
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1660
                          }
                        },
                        '重量税 ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                          __source: {
                            fileName: _jsxFileName,
                            lineNumber: 1662
                          }
                        }),
                        '減税'
                      )
                    );
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1675
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'CarsComparison__car-comparison__navigation__tax', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1676
                    }
                  },
                  renderKankyowari(),
                  renderSubsidy(),
                  renderTax()
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1685
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1685
                    }
                  },
                  '-'
                )
              );
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1690
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1690
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl tax-info', __source: {
              fileName: _jsxFileName,
              lineNumber: 1695
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1696
              }
            },
            '\u30A8\u30B3\u30AB\u30FC'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1698
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1699
                }
              },
              renderTaxInfoItem(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1704
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1705
                }
              },
              renderTaxInfoItem(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1710
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1711
                }
              },
              renderTaxInfoItem(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3)
            )
          )
        );
      };

      // 見積もりシミュレーション
      var renderCta = function renderCta() {
        var renderCtaItem = function renderCtaItem(carId, carTypeCode, bodyTypeInfo, gradeId, variantId) {
          if (bodyTypeInfo) {
            var generationInfo = _this8.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              //const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
              var variantInfo = _this8.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1728
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_estimate_link__["a" /* default */], _extends({
                  label: '見積りシミュレーション',
                  targetBlank: false,
                  color: 'Dark',
                  buttonStyle: 'Action',
                  linkType: 'Button',
                  carId: carId,
                  carTypeCode: carTypeCode,
                  //gradeCode: gradeInfo.gradeCode,
                  gradeCode: variantInfo.gradeCode,
                  drive: variantInfo.drive,
                  mission: variantInfo.transmission,
                  engine: variantInfo.engine,
                  ecode: null,
                  soptions: null,
                  direct: 'Result'
                }, {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1729
                  }
                }))
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1750
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1750
                    }
                  },
                  '-'
                )
              );
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__blank', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1755
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1755
                  }
                },
                '-'
              )
            );
          }
        };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl last cta', __source: {
              fileName: _jsxFileName,
              lineNumber: 1760
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 1761
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { visibility: 'hidden' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1761
                }
              },
              '\u898B\u7A4D\u308A\u30B7\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openLeftCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1763
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1764
                }
              },
              renderCtaItem(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openCenterCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1769
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1770
                }
              },
              renderCtaItem(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openRightCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1775
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1776
                }
              },
              renderCtaItem(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3)
            )
          )
        );
      };

      // 条件を変更ボタン（SP）
      var renderCondition = function renderCondition() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'CarsComparison__car-comparison__navigation__list-dl condition', __source: {
              fileName: _jsxFileName,
              lineNumber: 1787
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1788
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openLeftCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1789
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1790
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'CarsComparison__car-comparison__navigation__link-condition' + (_this8.state.openLeftCondition === true ? ' open' : ''),
                  href: 'javascript:void(0);', onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this8.setState({
                      openLeftCondition: !_this8.state.openLeftCondition,
                      openCenterCondition: false,
                      openRightCondition: false
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1791
                  }
                },
                '\u6761\u4EF6\u3092\u5909\u66F4'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openCenterCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1804
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1805
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'CarsComparison__car-comparison__navigation__link-condition' + (_this8.state.openCenterCondition === true ? ' open' : ''),
                  href: 'javascript:void(0);', onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this8.setState({
                      openLeftCondition: false,
                      openCenterCondition: !_this8.state.openCenterCondition,
                      openRightCondition: false
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1806
                  }
                },
                '\u6761\u4EF6\u3092\u5909\u66F4'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { style: _this8.state.openRightCondition === true ? { backgroundColor: '#ffffff' } : null, __source: {
                fileName: _jsxFileName,
                lineNumber: 1819
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1820
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'CarsComparison__car-comparison__navigation__link-condition' + (_this8.state.openRightCondition === true ? ' open' : ''),
                  href: 'javascript:void(0);', onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this8.setState({
                      openLeftCondition: false,
                      openCenterCondition: false,
                      openRightCondition: !_this8.state.openRightCondition
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1821
                  }
                },
                '\u6761\u4EF6\u3092\u5909\u66F4'
              )
            )
          )
        );
      };

      var cls = '';
      if (_this8.state.openLeftCondition === true) cls = ' open-left';
      if (_this8.state.openCenterCondition === true) cls = ' open-center';
      if (_this8.state.openRightCondition === true) cls = ' open-right';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison__navigation', __source: {
            fileName: _jsxFileName,
            lineNumber: 1844
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'CarsComparison__car-comparison__navigation__container' + (_this8.state.isLoading === true || _this8.state.isLoading2 === true || _this8.state.isLoading3 === true ? ' loading' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 1845
            }
          },
          renderImage(),
          renderGrade2(),
          renderPrice2(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-comparison__navigation__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 1850
              }
            },
            renderCondition(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__navigation__container3' + cls,
                style: { width: _this8.state.windowWidth }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1852
                }
              },
              renderBodyType(),
              renderReleaseDate(),
              renderGrade(),
              renderVariant(),
              renderPrice(),
              renderTaxInfo(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'CarsComparison__car-comparison__navigation__link-close', href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this8.setState({
                      openLeftCondition: false,
                      openCenterCondition: false,
                      openRightCondition: false
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1860
                  }
                },
                '\u9589\u3058\u308B'
              )
            )
          ),
          renderCta()
        )
      );
    };

    // 詳細
    var renderSpecDescription = function renderSpecDescription() {
      var getDescription = function getDescription() {
        if (_this8.props.specDescription && _this8.props.specDescription !== '') {
          return _this8.props.specDescription;
        } else {
          return '';
        }
      };
      var getMbDescription = function getMbDescription() {
        if (_this8.props.mbSpecDescription && _this8.props.mbSpecDescription !== '') {
          return _this8.props.mbSpecDescription;
        } else {
          return getDescription();
        }
      };
      var description = getDescription();
      var mbDescription = getMbDescription();
      if (description && description !== "") {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-comparison__spec-description', __source: {
              fileName: _jsxFileName,
              lineNumber: 1898
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'CarsComparison__car-comparison__spec-description__paragraph Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 1899
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison__spec-description__paragraph-pc',
              dangerouslySetInnerHTML: { __html: description }, __source: {
                fileName: _jsxFileName,
                lineNumber: 1900
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison__spec-description__paragraph-mb',
              dangerouslySetInnerHTML: { __html: mbDescription }, __source: {
                fileName: _jsxFileName,
                lineNumber: 1902
              }
            })
          )
        );
      } else {
        return null;
      }
    };

    // 固定ナビゲーション
    var renderFixedNavigation = function renderFixedNavigation() {

      var renderImage = function renderImage(carId) {
        if (carId) {
          var modelInfo = _this8.getModelInfo(carId);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison__fixed-navigation__car-image', src: modelInfo.src, __source: {
              fileName: _jsxFileName,
              lineNumber: 1919
            }
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison__fixed-navigation__car-image', src: CarSelector.imageCar,
            alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 1923
            }
          });
        }
      };

      var renderBodyType = function renderBodyType(carId, carTypeCode, bodyTypeInfo, gradeId) {

        // 100th Anniversary Special Edition > 100周年特別記念車
        var convert100th = function convert100th(text) {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (carId) {
          var modelInfo = _this8.getModelInfo(carId);
          if (bodyTypeInfo && gradeId) {
            var gradeInfo = _this8.getGradeInfo(bodyTypeInfo, gradeId);
            var label = gradeInfo.gradeName;
            if (gradeInfo.specialCar === 'true' || gradeInfo.specialCar === true) {
              label = gradeInfo.gradeId;
            } else {
              if (!label || label === '') {
                label = gradeInfo.gradeId;
              }
            }
            label = label.replace(/[|]/g, ' ');
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'CarsComparison__car-comparison__fixed-navigation__body-type', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1971
                }
              },
              convert100th(modelInfo.bodyTypeModel),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1973
                }
              }),
              convert100th(label)
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'CarsComparison__car-comparison__fixed-navigation__body-type', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1980
                }
              },
              convert100th(modelInfo.bodyTypeModel)
            );
          }
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-comparison__fixed-navigation__blank', __source: {
                fileName: _jsxFileName,
                lineNumber: 1987
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1987
                }
              },
              '-'
            )
          );
        }
      };

      var renderPrice = function renderPrice(carId, carTypeCode, bodyTypeInfo, gradeId, variantId) {
        if (bodyTypeInfo) {
          var generationInfo = _this8.getGenerationInfo(carId, carTypeCode);
          if (generationInfo.endOfSale === false) {
            var variantInfo = _this8.getVariantInfo(bodyTypeInfo, gradeId, variantId);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'CarsComparison__car-comparison__fixed-navigation__price', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1998
                }
              },
              _this8.formatPrice(variantInfo.price),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2000
                  }
                },
                '\u301C',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2000
                  }
                }),
                '\uFF08\u6D88\u8CBB\u7A0E\u8FBC\uFF09'
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__fixed-navigation__end-of-sale', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 2005
                }
              },
              '\u751F\u7523\u7D42\u4E86'
            );
          }
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-comparison__fixed-navigation__blank', __source: {
                fileName: _jsxFileName,
                lineNumber: 2010
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 2010
                }
              },
              '-'
            )
          );
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'CarsComparison__car-comparison__fixed-navigation' + (_this8.state.fixedNavigationOpened === true ? ' open' : ''),
          style: { 'top': _this8.state.subNavigationHeight }, __source: {
            fileName: _jsxFileName,
            lineNumber: 2016
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-comparison__fixed-navigation__container', ref: 'navigation', __source: {
              fileName: _jsxFileName,
              lineNumber: 2019
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-comparison__fixed-navigation__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 2020
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison__fixed-navigation__container3', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 2021
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'CarsComparison__car-comparison__fixed-navigation__link2', href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    __WEBPACK_IMPORTED_MODULE_12__components_body__["a" /* default */].scrollToNode(_this8.refs.condition);
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2022
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2028
                    }
                  },
                  '\u6BD4\u8F03\u6761\u4EF6\u3092\u5909\u66F4\u3059\u308B'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'CarsComparison__car-comparison__fixed-navigation__list', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2029
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2030
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'CarsComparison__car-comparison__fixed-navigation__link', href: 'javascript:void(0);',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        //
                        __WEBPACK_IMPORTED_MODULE_12__components_body__["a" /* default */].scrollToNode(_this8.refs.condition);
                      }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2031
                      }
                    },
                    '\u6BD4\u8F03\u6761\u4EF6\u3092\u5909\u66F4\u3059\u308B'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2038
                    }
                  },
                  renderImage(_this8.state.selectedCarId),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { height: _this8.state.fixedNavigationBodyTypeHeight }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2040
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { ref: 'fixedNavigationBodyType', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2041
                        }
                      },
                      renderBodyType(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId)
                    )
                  ),
                  renderPrice(_this8.state.selectedCarId, _this8.state.selectedCarTypeCode, _this8.bodyTypeInfo, _this8.state.selectedGradeId, _this8.state.selectedVariantId)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2047
                    }
                  },
                  renderImage(_this8.state.selectedCarId2),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { height: _this8.state.fixedNavigationBodyTypeHeight }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2049
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { ref: 'fixedNavigationBodyType2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2050
                        }
                      },
                      renderBodyType(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2)
                    )
                  ),
                  renderPrice(_this8.state.selectedCarId2, _this8.state.selectedCarTypeCode2, _this8.bodyTypeInfo2, _this8.state.selectedGradeId2, _this8.state.selectedVariantId2)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2056
                    }
                  },
                  renderImage(_this8.state.selectedCarId3),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { height: _this8.state.fixedNavigationBodyTypeHeight }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2058
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { ref: 'fixedNavigationBodyType3', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2059
                        }
                      },
                      renderBodyType(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3)
                    )
                  ),
                  renderPrice(_this8.state.selectedCarId3, _this8.state.selectedCarTypeCode3, _this8.bodyTypeInfo3, _this8.state.selectedGradeId3, _this8.state.selectedVariantId3)
                )
              )
            )
          )
        )
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'CarsComparison__car-comparison', __source: {
          fileName: _jsxFileName,
          lineNumber: 2074
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison__container', __source: {
            fileName: _jsxFileName,
            lineNumber: 2075
          }
        },
        renderDescription()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison__container2', ref: 'condition', __source: {
            fileName: _jsxFileName,
            lineNumber: 2078
          }
        },
        renderNavigation()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison__container', ref: 'spec', __source: {
            fileName: _jsxFileName,
            lineNumber: 2081
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarComparisonDetail, _extends({}, this.getSpecComparisonProps(), { ref: 'carComparisonDetail', __source: {
            fileName: _jsxFileName,
            lineNumber: 2082
          }
        })),
        renderSpecDescription()
      ),
      this.props.freeArea && 1 <= this.props.freeArea.length ? Object(__WEBPACK_IMPORTED_MODULE_11__utilities__["c" /* getComponents */])(this.props.freeArea) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 2086
          }
        },
        renderFixedNavigation()
      )
    );
  };

  //


  //


  // APIアクセス


  // グレード変更


  // 機種変更


  // CarIdを元にModel情報を取得


  // CarIdとCarTypeCodeを元にGeneration情報を取得


  // グレード情報


  // グレード情報


  // デフォルトグレードID


  // 機種情報


  // 機種情報


  // デフォルト機種ID


  // スペック比較情報取得


  // YYYYMMをYYYY年M月D日にフォーマト


  // 金額フォーマット


  return CarComparison;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backToCarSelectorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  specDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbSpecDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  endOfSaleText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  freeArea: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  models: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bodyTypeModel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    generations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  })),
  selectedCarId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedCarId2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedCarId3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedCarTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedCarTypeCode2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedCarTypeCode3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedGradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedGradeId2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedGradeId3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class3.defaultProps = {
  description: null,
  mbDescription: null,
  backToCarSelectorText: null,
  specDescription: null,
  mbSpecDescription: null,
  endOfSaleText: null,
  freeArea: null,
  models: null,
  selectedCarId: null,
  selectedCarId2: null,
  selectedCarId3: null,
  selectedCarTypeCode: null,
  selectedCarTypeCode2: null,
  selectedCarTypeCode3: null,
  selectedGradeId: null,
  selectedGradeId2: null,
  selectedGradeId3: null
}, _temp3);
CarComparison.displayName = 'CarComparison';


/**
 *  CarComparisonDetail
 */
var CarComparisonDetail = (_temp4 = _class4 = function (_Component4) {
  _inherits(CarComparisonDetail, _Component4);

  function CarComparisonDetail(props) {
    _classCallCheck(this, CarComparisonDetail);

    var _this9 = _possibleConstructorReturn(this, _Component4.call(this));

    _this9.changeSpecs = function () {
      _this9.setState({
        openAccordion: false
      });
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this9.accordionRefs.length; i < max; i = i + 1) {
        if (i <= 0) {
          _this9.refs[_this9.accordionRefs[i]].open();
          _this9.refs[_this9.accordionRefs[i]].onResize();
        } else {
          _this9.refs[_this9.accordionRefs[i]].close();
        }
      }
      // if (this.state.openAccordion === true) {
      //   let i, max;
      //   for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
      //     if (i <= 0) {
      //       this.refs[this.accordionRefs[i]].open();
      //     } else {
      //       this.refs[this.accordionRefs[i]].close();
      //     }
      //   }
      //   this.setState({
      //     openAccordion: false,
      //   })
      // }
      // フェードインアニメーション
      _this9.refs.changeVariant.classList.remove('open');
      setTimeout(function () {
        _this9.refs.changeVariant.classList.add('open');
      }, 100);
    };

    _this9.changeAccordionView = function () {
      if (_this9.state.openAccordion === true) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this9.accordionRefs.length; i < max; i = i + 1) {
          _this9.refs[_this9.accordionRefs[i]].close();
        }
        _this9.setState({
          openAccordion: false
        });
      } else {
        var _i5 = void 0,
            _max5 = void 0;
        for (_i5 = 0, _max5 = _this9.accordionRefs.length; _i5 < _max5; _i5 = _i5 + 1) {
          _this9.refs[_this9.accordionRefs[_i5]].open();
        }
        _this9.setState({
          openAccordion: true
        });
      }
    };

    _this9.props = props;
    //
    _this9.state = {
      openAccordion: false,
      isMounted: false
    };
    _this9.accordionRefs = [];
    return _this9;
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  CarComparisonDetail.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    //console.log(nextProps);
  };

  CarComparisonDetail.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isMounted: true
    });
  };

  CarComparisonDetail.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  };

  CarComparisonDetail.prototype.render = function render() {
    var _this10 = this;

    // マスタースペックカテゴリ取得
    var _getMasterSpecCategory = function _getMasterSpecCategory() {

      var removeDuplicateValue = function removeDuplicateValue(arr) {
        return arr.filter(function (val, i, self) {
          return self.indexOf(val) === i;
        });
      };

      // カテゴリー一覧
      var categoryArr = [];
      _this10.props.compareGrades.map(function (compareGrade, index) {
        if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {
          var _i6 = void 0,
              _max6 = void 0;
          for (_i6 = 0, _max6 = compareGrade.specs.length; _i6 < _max6; _i6 = _i6 + 1) {
            if (compareGrade.specs[_i6].unit && compareGrade.specs[_i6].unit !== '' && compareGrade.specs[_i6].unit !== 'blank') {
              categoryArr.push(compareGrade.specs[_i6].category);
            } else {
              if (compareGrade.specs[_i6].value && compareGrade.specs[_i6].value[0] && compareGrade.specs[_i6].value[0] !== '') {
                categoryArr.push(compareGrade.specs[_i6].category);
              }
            }
          }
        }
      });
      categoryArr = removeDuplicateValue(categoryArr);

      // カテゴリー一覧を元に全てのスペック情報を取得
      var masterSpecCategory = [];

      //
      var i = void 0,
          max = void 0;

      var _loop = function _loop() {
        var category = categoryArr[i];
        var arr = [];

        //
        _this10.props.compareGrades.map(function (compareGrade, index) {
          if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {

            //
            var _i7 = void 0,
                _max7 = void 0;
            for (_i7 = 0, _max7 = compareGrade.specs.length; _i7 < _max7; _i7 = _i7 + 1) {
              var specs = compareGrade.specs[_i7];
              if (specs.category === category) {

                // 重複しているかチェック
                var flg = true;
                var j = void 0,
                    max2 = void 0;
                for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
                  if ((arr[j].name || '') === (specs.name || '') && (arr[j].description || '') === (specs.description || '')) {
                    flg = false;
                    break;
                  }
                }

                // 重複していなければ追加
                if (flg === true) {
                  if (specs.unit && specs.unit !== '' && specs.unit !== 'blank') {
                    arr.push({
                      name: specs.name || null,
                      description: specs.description || null
                    });
                  } else {
                    if (specs.value && specs.value[0] && specs.value[0] !== '') {
                      arr.push({
                        name: specs.name || null,
                        description: specs.description || null
                      });
                    }
                  }
                }
              }
            }
          }
        });

        masterSpecCategory.push({
          category: categoryArr[i],
          specs: arr
        });
      };

      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        _loop();
      }

      //console.log(JSON.stringify(masterSpecCategory));

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    var getMasterSpecCategory = function getMasterSpecCategory() {
      if (window.MZD_SPEC_DATA_CATEGORY_LIST) {
        return window.MZD_SPEC_DATA_CATEGORY_LIST;
      } else {
        return _getMasterSpecCategory();
      }
    };

    // スペック情報取得
    var getSpecsInfo = function getSpecsInfo(index) {

      var removeDuplicateValue = function removeDuplicateValue(arr) {
        return arr.filter(function (val, i, self) {
          return self.indexOf(val) === i;
        });
      };

      var compareGrade = _this10.props.compareGrades[index] || null;
      var specs = null;
      if (compareGrade) {
        specs = compareGrade.specs || null;
      }

      if (specs && 1 <= specs.length) {
        // フォーマット
        var categoryArr = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = specs.length; i < max; i = i + 1) {
          categoryArr.push(specs[i].category);
        }
        categoryArr = removeDuplicateValue(categoryArr);
        //
        var specs2 = [];
        for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
          var _category = categoryArr[i];
          var obj = {
            category: _category,
            specs: []
          };
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = specs.length; j < max2; j = j + 1) {
            var spec = specs[j];
            if (_category === spec.category) {
              obj.specs.push({
                name: spec.name || null,
                value: spec.value || null,
                unit: spec.unit || null,
                description: spec.description || null,
                seatImageSrc: spec.seatImageSrc || null
              });
            }
          }
          specs2.push(obj);
        }
        return specs2;
      } else {
        return null;
      }
    };

    // 機種スペックデータからnameが一致するデータを取得
    var getSpecInfo = function getSpecInfo(specsInfo, category, name, description) {
      if (specsInfo && 1 <= specsInfo.length) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = specsInfo.length; i < max; i = i + 1) {
          if (specsInfo[i].category === category) {
            var j = void 0,
                max2 = void 0;
            for (j = 0, max2 = specsInfo[i].specs.length; j < max2; j = j + 1) {
              if (specsInfo[i].specs[j].name === name && (specsInfo[i].specs[j].description || '') === (description || '')) {
                return specsInfo[i].specs[j];
              }
            }
          }
        }
      } else {
        return null;
      }
    };

    // スペックが存在するか
    var getIsExistSpecValue = function getIsExistSpecValue(category, name, description) {
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this10.props.compareGrades.length; i < max; i = i + 1) {
        var compareGrade = _this10.props.compareGrades[i];
        if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = compareGrade.specs.length; j < max2; j = j + 1) {
            var spec = compareGrade.specs[j];
            if (category === spec.category && name === spec.name) {
              if (description) {
                if (description === spec.description) {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true;
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true;
                    }
                  }
                }
              } else {
                if (spec.description === '') {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true;
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true;
                    }
                  }
                }
              }
            }
            // if (category === spec.category && name === spec.name && description === spec.description) {
            //   if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
            //     return true
            //   } else {
            //     if (spec.value && spec.value[0] && spec.value[0] !== '') {
            //       return true
            //     }
            //   }
            // }
          }
        }
      }
      return false;
    };

    // ------ Render ----- //

    // スペックカテゴリ表示
    var renderSpecCategory = function renderSpecCategory() {
      var masterSpecCategory = getMasterSpecCategory();
      _this10.accordionRefs = [];
      return masterSpecCategory.map(function (info, index) {

        // スペックデータが有るか無しか
        var flg = false;
        var i = void 0,
            max = void 0;
        for (i = 0, max = info.specs.length; i < max; i = i + 1) {
          var spec = info.specs[i];
          if (getIsExistSpecValue(info.category, spec.name, spec.description)) {
            flg = true;
          }
        }
        if (!flg) return null;

        _this10.accordionRefs.push('accordion' + index);
        var isOpen = index <= 0 ? true : false;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__components_accordion__["a" /* default */],
          {
            ref: 'accordion' + index,
            pageName: info.category,
            pcText: info.category,
            mbText: info.category,
            open: isOpen,
            enabled: true,
            key: index,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 2944
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'CarsComparison__car-comparison-detail__table', __source: {
                fileName: _jsxFileName,
                lineNumber: 2953
              }
            },
            renderSpecName(info.category, info.specs)
          )
        );
      });
    };

    // スペック名表示
    var renderSpecName = function renderSpecName(category, masterSpecs) {
      return masterSpecs.map(function (masterSpec, index) {

        // スペックデータが有るか無しか
        if (!getIsExistSpecValue(category, masterSpec.name, masterSpec.description)) return null;

        var count = 0;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: 'CarsComparison__car-comparison-detail__table-row', key: index, __source: {
              fileName: _jsxFileName,
              lineNumber: 2974
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'CarsComparison__car-comparison-detail__table-cell', __source: {
                fileName: _jsxFileName,
                lineNumber: 2975
              }
            },
            masterSpec.name + ' ' + (masterSpec.description ? masterSpec.description : '')
          ),
          _this10.props.compareGrades.map(function (compareGrade, index2) {
            count = count + 1;
            var specsInfo = getSpecsInfo(index2);
            if (specsInfo && 1 <= specsInfo.length) {
              var specInfo = getSpecInfo(specsInfo, category, masterSpec.name, masterSpec.description);
              if (specInfo) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'CarsComparison__car-comparison-detail__table-cell', key: index2, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2985
                    }
                  },
                  renderSpecValue(category, specInfo, compareGrade)
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'CarsComparison__car-comparison-detail__table-cell', key: index2, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2991
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'CarsComparison__car-comparison-detail__blank', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2991
                      }
                    },
                    '-'
                  )
                );
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison-detail__table-cell', key: index2, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2996
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarsComparison__car-comparison-detail__blank', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2996
                    }
                  },
                  '-'
                )
              );
            }
          }),
          function () {
            if (count <= 2) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'CarsComparison__car-comparison-detail__table-cell', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 3003
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarsComparison__car-comparison-detail__blank', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 3003
                    }
                  },
                  '-'
                )
              );
            }
          }()
        );
      });
    };

    // 機種スペック値表示
    var renderSpecValue = function renderSpecValue(category, spec, compareGrade) {

      // メディアディレクトリ取得
      var getMediaDirectory = function getMediaDirectory() {
        if (_this10.state.isMounted === false) return '/assets-dev/';
        if (0 <= String(location.hostname).indexOf('localhost')) {
          return '/assets-dev/';
        } else {
          return '/globalassets/';
        }
      };

      var formatSrc = function formatSrc(src) {
        if (_this10.state.isMounted === false) return src;
        if (0 <= String(location.hostname).indexOf('localhost')) {
          return src;
        } else {
          return src.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        }
      };

      if (category === 'シート' && spec.name === 'シート材質') {
        var directory = 'assets/cars/';
        directory = directory + compareGrade.modelName + '/';
        directory = directory + compareGrade.carId + '/';
        directory = directory + compareGrade.carTypeCode + '/';
        directory = directory + Object(__WEBPACK_IMPORTED_MODULE_14__utils__["g" /* convertKataToRome */])(compareGrade.gradeId) + '/';
        directory = directory + 'seat/';
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 3043
            }
          },
          _this10.state.isMounted === true && spec.unit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison-detail__seat-image',
            src: formatSrc(getMediaDirectory() + directory + spec.unit + '.png'), __source: {
              fileName: _jsxFileName,
              lineNumber: 3045
            }
          }) : '',
          spec.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'CarsComparison__car-comparison-detail__value', __source: {
                fileName: _jsxFileName,
                lineNumber: 3048
              }
            },
            spec.value.join(' | ')
          ) : ''
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 3053
            }
          },
          _this10.state.isMounted === true && spec.unit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 3055
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'CarsComparison__car-comparison-detail__unit-image',
              src: formatSrc(getMediaDirectory() + 'assets/home/common/icon/' + spec.unit + '.png'), __source: {
                fileName: _jsxFileName,
                lineNumber: 3055
              }
            })
          ) : '',
          spec.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'CarsComparison__car-comparison-detail__value', __source: {
                fileName: _jsxFileName,
                lineNumber: 3059
              }
            },
            spec.value.join(' | ')
          ) : ''
        );
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'CarsComparison__car-comparison-detail', __source: {
          fileName: _jsxFileName,
          lineNumber: 3066
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CarsComparison__car-comparison-detail__fade-in-container', ref: 'changeVariant', __source: {
            fileName: _jsxFileName,
            lineNumber: 3067
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'CarsComparison__car-comparison-detail__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 3068
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { ref: 'spec', __source: {
                fileName: _jsxFileName,
                lineNumber: 3069
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'CarsComparison__car-comparison-detail__box', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 3070
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'CarsComparison__car-comparison-detail__link-open' + (this.state.openAccordion ? ' open' : ''),
                  href: 'javascript:void(0);',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    // アコーディオンを閉じる、開く
                    _this10.changeAccordionView();
                  },
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 3071
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarsComparison__car-comparison-detail__link-open__open', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 3080
                    }
                  },
                  '\u3059\u3079\u3066\u898B\u308B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'CarsComparison__car-comparison-detail__link-open__close', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 3081
                    }
                  },
                  '\u3059\u3079\u3066\u9589\u3058\u308B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison-detail__link-open__icon', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 3082
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'CarsComparison__car-comparison-detail__link-open__icon2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 3083
                  }
                })
              )
            ),
            renderSpecCategory()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'CarsComparison__car-comparison-detail__list', __source: {
              fileName: _jsxFileName,
              lineNumber: 3089
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 3090
              }
            },
            '\u6A19\u6E96\u88C5\u5099'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 3091
              }
            },
            '\u30E1\u30FC\u30AB\u30FC\u30AA\u30D7\u30B7\u30E7\u30F3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 3092
              }
            },
            '\u8A2D\u5B9A\u7121\u3057'
          )
        )
      )
    );
  };

  // スペック変更


  // アコーディオンを閉じる、開く


  return CarComparisonDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class4.propTypes = {
  compareGrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carTypeCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    gradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    specs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
      unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      seatImageSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  }))
}, _class4.defaultProps = {
  compareGrades: []
}, _temp4);
CarComparisonDetail.displayName = 'CarComparisonDetail';

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CarsComparison":"CarsComparison","CarsComparison__container":"CarsComparison__container","open":"open","CarsComparison__step":"CarsComparison__step","CarsComparison__step__list":"CarsComparison__step__list","current":"current","CarsComparison__car-selector":"CarsComparison__car-selector","CarsComparison__car-selector__container":"CarsComparison__car-selector__container","CarsComparison__car-selector__container2":"CarsComparison__car-selector__container2","CarsComparison__car-selector__description":"CarsComparison__car-selector__description","CarsComparison__car-selector__description__paragraph":"CarsComparison__car-selector__description__paragraph","CarsComparison__car-selector__description__paragraph-pc":"CarsComparison__car-selector__description__paragraph-pc","CarsComparison__car-selector__description__paragraph-mb":"CarsComparison__car-selector__description__paragraph-mb","CarsComparison__car-selector__body-types":"CarsComparison__car-selector__body-types","CarsComparison__car-selector__body-types__link":"CarsComparison__car-selector__body-types__link","CarsComparison__car-selector__body-types__box":"CarsComparison__car-selector__body-types__box","attention":"attention","CarsComparison__car-selector__body-types__attention":"CarsComparison__car-selector__body-types__attention","CarsComparison__car-selector__body-types__box-inner":"CarsComparison__car-selector__body-types__box-inner","CarsComparison__car-selector__body-types__image":"CarsComparison__car-selector__body-types__image","drag":"drag","CarsComparison__car-selector__body-types__list":"CarsComparison__car-selector__body-types__list","blank":"blank","CarsComparison__car-selector__body-types__name":"CarsComparison__car-selector__body-types__name","CarsComparison__car-selector__body-types__category":"CarsComparison__car-selector__body-types__category","CarsComparison__car-selector__body-types__price":"CarsComparison__car-selector__body-types__price","CarsComparison__car-selector__drop-area":"CarsComparison__car-selector__drop-area","CarsComparison__car-selector__drop-area__container":"CarsComparison__car-selector__drop-area__container","fixed":"fixed","opened":"opened","CarsComparison__car-selector__drop-area__container2":"CarsComparison__car-selector__drop-area__container2","CarsComparison__car-selector__drop-area__list":"CarsComparison__car-selector__drop-area__list","drag-enter":"drag-enter","CarsComparison__car-selector__drop-area__link-close":"CarsComparison__car-selector__drop-area__link-close","CarsComparison__car-selector__drop-area__box":"CarsComparison__car-selector__drop-area__box","CarsComparison__car-selector__drop-area__box2":"CarsComparison__car-selector__drop-area__box2","CarsComparison__car-selector__drop-area__box2-inner":"CarsComparison__car-selector__drop-area__box2-inner","CarsComparison__car-selector__drop-area__image":"CarsComparison__car-selector__drop-area__image","CarsComparison__car-selector__drop-area__paragraph":"CarsComparison__car-selector__drop-area__paragraph","selected":"selected","CarsComparison__car-selector__drop-area__link":"CarsComparison__car-selector__drop-area__link","active":"active","CarsComparison__car-selector__add-animation":"CarsComparison__car-selector__add-animation","play":"play","CarsComparison__car-comparison":"CarsComparison__car-comparison","CarsComparison__car-comparison__container":"CarsComparison__car-comparison__container","CarsComparison__car-comparison__container2":"CarsComparison__car-comparison__container2","CarsComparison__car-comparison__description":"CarsComparison__car-comparison__description","CarsComparison__car-comparison__description__paragraph":"CarsComparison__car-comparison__description__paragraph","CarsComparison__car-comparison__description__paragraph-pc":"CarsComparison__car-comparison__description__paragraph-pc","CarsComparison__car-comparison__description__paragraph-mb":"CarsComparison__car-comparison__description__paragraph-mb","CarsComparison__car-comparison__navigation":"CarsComparison__car-comparison__navigation","CarsComparison__car-comparison__navigation__container":"CarsComparison__car-comparison__navigation__container","loading":"loading","CarsComparison__car-comparison__navigation__container3":"CarsComparison__car-comparison__navigation__container3","CarsComparison__car-comparison__navigation__car-image":"CarsComparison__car-comparison__navigation__car-image","CarsComparison__car-comparison__navigation__list-dl":"CarsComparison__car-comparison__navigation__list-dl","CarsComparison__car-comparison__navigation__box":"CarsComparison__car-comparison__navigation__box","last":"last","condition":"condition","grade2":"grade2","price2":"price2","CarsComparison__car-comparison__navigation__blank":"CarsComparison__car-comparison__navigation__blank","CarsComparison__car-comparison__navigation__end-of-sale":"CarsComparison__car-comparison__navigation__end-of-sale","CarsComparison__car-comparison__navigation__select":"CarsComparison__car-comparison__navigation__select","CarsComparison__car-comparison__navigation__price":"CarsComparison__car-comparison__navigation__price","CarsComparison__car-comparison__navigation__tax":"CarsComparison__car-comparison__navigation__tax","CarsComparison__car-comparison__navigation__tax-item":"CarsComparison__car-comparison__navigation__tax-item","CarsComparison__car-comparison__spec-description":"CarsComparison__car-comparison__spec-description","CarsComparison__car-comparison__spec-description__paragraph":"CarsComparison__car-comparison__spec-description__paragraph","CarsComparison__car-comparison__spec-description__paragraph-pc":"CarsComparison__car-comparison__spec-description__paragraph-pc","CarsComparison__car-comparison__spec-description__paragraph-mb":"CarsComparison__car-comparison__spec-description__paragraph-mb","CarsComparison__car-comparison__fixed-navigation":"CarsComparison__car-comparison__fixed-navigation","CarsComparison__car-comparison__fixed-navigation__container":"CarsComparison__car-comparison__fixed-navigation__container","CarsComparison__car-comparison__fixed-navigation__container2":"CarsComparison__car-comparison__fixed-navigation__container2","CarsComparison__car-comparison__fixed-navigation__container3":"CarsComparison__car-comparison__fixed-navigation__container3","CarsComparison__car-comparison__fixed-navigation__link":"CarsComparison__car-comparison__fixed-navigation__link","CarsComparison__car-comparison__fixed-navigation__link2":"CarsComparison__car-comparison__fixed-navigation__link2","CarsComparison__car-comparison__fixed-navigation__list":"CarsComparison__car-comparison__fixed-navigation__list","CarsComparison__car-comparison__fixed-navigation__blank":"CarsComparison__car-comparison__fixed-navigation__blank","CarsComparison__car-comparison__fixed-navigation__car-image":"CarsComparison__car-comparison__fixed-navigation__car-image","CarsComparison__car-comparison__fixed-navigation__body-type":"CarsComparison__car-comparison__fixed-navigation__body-type","CarsComparison__car-comparison__fixed-navigation__price":"CarsComparison__car-comparison__fixed-navigation__price","CarsComparison__car-comparison__navigation__link-close":"CarsComparison__car-comparison__navigation__link-close","CarsComparison__car-comparison-detail":"CarsComparison__car-comparison-detail","CarsComparison__car-comparison-detail__fade-in-container":"CarsComparison__car-comparison-detail__fade-in-container","CarsComparison__car-comparison-detail__blank":"CarsComparison__car-comparison-detail__blank","CarsComparison__car-comparison-detail__container":"CarsComparison__car-comparison-detail__container","CarsComparison__car-comparison-detail__box":"CarsComparison__car-comparison-detail__box","CarsComparison__car-comparison-detail__link-open":"CarsComparison__car-comparison-detail__link-open","CarsComparison__car-comparison-detail__link-open__open":"CarsComparison__car-comparison-detail__link-open__open","CarsComparison__car-comparison-detail__link-open__close":"CarsComparison__car-comparison-detail__link-open__close","CarsComparison__car-comparison-detail__link-open__icon":"CarsComparison__car-comparison-detail__link-open__icon","CarsComparison__car-comparison-detail__link-open__icon2":"CarsComparison__car-comparison-detail__link-open__icon2","CarsComparison__car-comparison-detail__table":"CarsComparison__car-comparison-detail__table","CarsComparison__car-comparison-detail__table-row":"CarsComparison__car-comparison-detail__table-row","CarsComparison__car-comparison-detail__table-cell":"CarsComparison__car-comparison-detail__table-cell","CarsComparison__car-comparison-detail__seat-image":"CarsComparison__car-comparison-detail__seat-image","CarsComparison__car-comparison-detail__unit-image":"CarsComparison__car-comparison-detail__unit-image","CarsComparison__car-comparison-detail__value":"CarsComparison__car-comparison-detail__value","CarsComparison__car-comparison-detail__list":"CarsComparison__car-comparison-detail__list","Cta":"Cta","Cta__button--linkType--Button-With-Icon":"Cta__button--linkType--Button-With-Icon","Cta__button--linkType--Button":"Cta__button--linkType--Button","Accordion--enabled":"Accordion--enabled","Accordion__title":"Accordion__title","Accordion__contents":"Accordion__contents","Accordion__container":"Accordion__container","Accordion__title-icon":"Accordion__title-icon","Accordion__title-icon2":"Accordion__title-icon2","CarsComparison__car-comparison__navigation__container2":"CarsComparison__car-comparison__navigation__container2","open-left":"open-left","open-center":"open-center","open-right":"open-right","car-image":"car-image","cta":"cta","tax-info":"tax-info","price":"price","CarsComparison__car-comparison__navigation__grade":"CarsComparison__car-comparison__navigation__grade","CarsComparison__car-comparison__navigation__link-condition":"CarsComparison__car-comparison__navigation__link-condition","CarsComparison__car-comparison__fixed-navigation__end-of-sale":"CarsComparison__car-comparison__fixed-navigation__end-of-sale","Cta__container":"Cta__container","Cta__button":"Cta__button","Cta__button__text":"Cta__button__text"};

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = {"bodyTypes":[{"carId":"demio","generation":{"carTypeCode":"DE8","defaultGradeId":"15S","grades":[{"gradeId":"15S","gradeName":"15S GradeName","specialCar":"true","defaultDrive":"2WD","defaultMission":"6MT","supportCar":"サポカーSベーシック","variants":[{"variantId":"V25B10","price":"1490400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"kankyowari":"true","subsidy":"false"},{"variantId":"V24B11","price":"1490401","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"kankyowari":"true","subsidy":"true","specs":[{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"}]},{"variantId":"V2EB12","price":"1695602","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"kankyowari":"true","subsidy":"false","specs":[{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"XD Touring L Package","gradeName":"XD Touring L Package GradeName","specialCar":"false","variants":[{"variantId":"VC5DA0","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VC4D10","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VCEDA0","price":"2278800","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"XD","specialCar":"true","variants":[{"variantId":"VA5B10","price":"1814400","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VA4B10","price":"1814400","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VAEB10","price":"2019600","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"XD Mist Maroon","gradeName":"MAZDA DEMIO|Mist Maroon","variants":[{"variantId":"VD5E10","price":"2062800","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VDEE10","price":"2268000","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"XD Touring","variants":[{"variantId":"VB5C10","price":"2014200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VB4C10","price":"2014200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VBEC10","price":"2219400","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15C","gradeName":"15C","variants":[{"variantId":"V15A10","price":"1393200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V1EA10","price":"1598400","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S Touring L Package","supportCar":"サポカーS","variants":[{"variantId":"V45DA0","price":"1814400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V44D10","price":"1814400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V4ED10","price":"2019600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S Touring","supportCar":"サポカーSワイド","variants":[{"variantId":"V35C10","price":"1733400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V34C10","price":"1733400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V3EC10","price":"1938600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"XD Noble Crimson","gradeName":"MAZDA DEMIO|Noble Crimson","supportCar":"サポカーS+","variants":[{"variantId":"VE5F20","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"VEEF20","price":"2278800","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S Mist Maroon","gradeName":"MAZDA DEMIO|Mist Maroon","supportCar":"サポカーS","variants":[{"variantId":"V55E10","price":"1782000","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V5EE10","price":"1987200","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S Noble Crimson","gradeName":"MAZDA DEMIO|Noble Crimson","supportCar":"サポカーSワイド","variants":[{"variantId":"V65F20","price":"1792800","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":[""],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"V6EF20","price":"1998000","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]}]}},{"carId":"axela-sport","generation":{"carTypeCode":"BM5","defaultGradeId":"15XD","grades":[{"gradeId":"15XD L Package","variants":[{"variantId":"FN3F10","price":"2689200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15XD PROACTIVE","variants":[{"variantId":"FN2D10","price":"2440800","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15XD","variants":[{"variantId":"FN1C10","price":"2338200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"22XD L Package","variants":[{"variantId":"FP4FA0","price":"3088800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FP3FA0","price":"3088800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"30"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FPDF10","price":"3310200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FPCF10","price":"3310200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"22XD PROACTIVE","variants":[{"variantId":"FP2E10","price":"2791800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FPBE10","price":"3013200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S","variants":[{"variantId":"FK2B10","price":"1954800","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FK1B10","price":"1954800","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FKBB10","price":"2176200","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"60"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S PROACTIVE","variants":[{"variantId":"FL2D10","price":"2149200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FL1D10","price":"2149200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"60"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FLBD10","price":"2370600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15C","variants":[{"variantId":"FJ2A10","price":"1825200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FJ1A10","price":"1825200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FJBA10","price":"2046600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]},{"gradeId":"15S L Package","variants":[{"variantId":"FM2F10","price":"2397600","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FM1F10","price":"2397600","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","gradeCode":"19","taxInfo":{"weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]},{"variantId":"FMBFA0","price":"2619000","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","gradeCode":"19","taxInfo":{"weightTaxRate":"50"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全高(mm)","value":["4470"],"unit":"standard","description":"KW<PS>/rpm"},{"category":"主要諸元","name":"全幅(mm)","value":["1795"],"unit":"maker-option","description":"KW<PS>/rpm"},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1"},{"category":"シート","name":"フロントシート 運転席 パワーシート","unit":"seat1"},{"category":"セーフティー","name":"セーフティー","value":["1000","2000"]}]}]}]}}]}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = {"bodyTypes":[{"carId":"axela-sedan","generation":{"carTypeCode":"BM6","defaultGradeId":"15C","grades":[{"gradeId":"22XD PROACTIVE","gradeCode":"16","variants":[{"variantId":"FF2E10","price":"2791800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"FFBE10","price":"3013200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"100"},"subsidy":"true"}]},{"gradeId":"15XD","gradeCode":"13","variants":[{"variantId":"FE1C10","price":"2338200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"}]},{"gradeId":"15XD PROACTIVE","gradeCode":"14","variants":[{"variantId":"FE2D10","price":"2440800","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"50","weightTaxRate":"50"},"subsidy":"true"}]},{"gradeId":"axela-sedan-welfare","gradeName":"MAZDA AXELA|手動運転装置付車"},{"gradeId":"15XD L Package","gradeCode":"15","variants":[{"variantId":"FE3F10","price":"2689200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"100"},"subsidy":"true"}]},{"gradeId":"15C","gradeCode":"1","variants":[{"variantId":"FA2A10","price":"1825200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"20","weightTaxRate":"25"},"subsidy":"false"},{"variantId":"FA1A10","price":"1825200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"false"},{"variantId":"FABA10","price":"2046600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"false"}]}]}}]}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = {"bodyTypes":[{"carId":"demio","generation":{"carTypeCode":"DE7","defaultGradeId":"XD Noble Crimson","grades":[{"gradeId":"XD Touring L Package","gradeCode":"13","variants":[{"variantId":"VC5DA0","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"VC4D10","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"VCEDA0","price":"2278800","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"XD","gradeCode":"9","variants":[{"variantId":"VA5B10","price":"1814400","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"VA4B10","price":"1814400","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"VAEB10","price":"2019600","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"XD Mist Maroon","gradeCode":"1","variants":[{"variantId":"VD5E10","price":"2062800","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"VDEE10","price":"2268000","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"XD Touring","gradeCode":"11","variants":[{"variantId":"VB5C10","price":"2014200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"VB4C10","price":"2014200","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"VBEC10","price":"2219400","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15C","gradeCode":"18","variants":[{"variantId":"V15A10","price":"1393200","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"V1EA10","price":"1598400","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15S Mist Maroon","gradeName":"Mist Maroon","gradeCode":"3","variants":[{"variantId":"V55E10","price":"1782000","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"V5EE10","price":"1987200","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15S Touring L Package","gradeCode":"23","variants":[{"variantId":"V45DA0","price":"1814400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"V44D10","price":"1814400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"V4ED10","price":"2019600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15S Touring","gradeCode":"21","variants":[{"variantId":"V35C10","price":"1733400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"V34C10","price":"1733400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"V3EC10","price":"1938600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"XD Noble Crimson","gradeCode":"5","variants":[{"variantId":"VE5F20","price":"2073600","engine":"SKYACTIV-D 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"VEEF20","price":"2278800","engine":"SKYACTIV-D 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15S","gradeCode":"19","variants":[{"variantId":"V25B10","price":"1490400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","subsidy":"false"},{"variantId":"V24B10","price":"1490400","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6MT","subsidy":"false"},{"variantId":"V2EB10","price":"1695600","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","subsidy":"false"}]},{"gradeId":"15S Noble Crimson","gradeCode":"7","variants":[{"variantId":"V65F20","price":"1792800","engine":"SKYACTIV-G 1.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"false"},{"variantId":"V6EF20","price":"1998000","engine":"SKYACTIV-G 1.5","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"false"}]}]}}]}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = {"bodyTypes":[{"carId":"atenza-sedan","generation":{"carTypeCode":"GJ7","defaultGradeId":"25S L Package","grades":[{"gradeId":"XD","gradeName":"XD","gradeCode":"4","defaultDrive":"4WD","defaultMission":"6EC-AT","variants":[{"variantId":"C42110","price":"3240000","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"30","weightTaxRate":"30"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["5000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["2000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"SKYACTIV-DRIVE","value":[""],"unit":"maker-option","description":""},{"category":"シート","name":"シート材質","value":["クロス（ブラック）"],"unit":"seat1","description":""}]},{"variantId":"C41111","price":"3294000","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C4B110","price":"3477600","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C4A111","price":"3531600","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"}]},{"gradeId":"XD L Package","gradeName":"XD L Packageaa","gradeCode":"8","variants":[{"variantId":"C63310","price":"3952800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"100"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["5,222"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["2,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["2,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"ホイールベース","value":["1,830"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"乗車定員","value":["8"],"unit":"","description":"（名）"},{"category":"主要諸元","name":"車両重量","value":["1190"],"unit":"","description":"（kg）"},{"category":"主要諸元","name":"タイヤサイズ","value":["250／65R15"],"unit":"","description":""},{"category":"主要諸元","name":"ホイールタイプ","value":["アルミ"],"unit":"","description":""},{"category":"主要諸元","name":"最小回転半径","value":["9.5"],"unit":"","description":"（m）"},{"category":"主要諸元","name":"サスペンション","value":["マクファーソンストラット式"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"ブレーキ","value":["ベンチレーテッドディスク"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"エンジンタイプ","value":["SKYACTIV-G　1.5"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン種類","value":["水冷直列4気筒DOHC16バルブ"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン総排気量","value":["1.496"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"エンジン最高出力","value":["81〈110〉／6,000"],"unit":"","description":"（kW＜PS＞／rpm）"},{"category":"主要諸元","name":"エンジン最大トルク","value":["141〈14.4〉／4,000"],"unit":"","description":"（N・m＜kgf・m＞／rpm）"},{"category":"主要諸元","name":"使用燃料","value":["無鉛レギュラーガソリン"],"unit":"","description":""},{"category":"主要諸元","name":"タンク容量","value":["44"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"JC08モード燃費","value":[""],"unit":"blank","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.0"],"unit":"","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["15.0"],"unit":"","description":"市街地モード（WLTC-L）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.4"],"unit":"","description":"郊外モード（WLTC-M）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["21.2"],"unit":"","description":"高速道路モード（WLTC-H）　（km／L）"},{"category":"セーフティ","name":"エマージェンシー・シグナル・システム（ESS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"SRSエアバッグシステム（カーテン＆フロントサイド）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ダイナミック・スタビリティ・コントロールシステム（DSC）＆トラクション・コントロール・システム（TCS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アドバンストスマートシティブレーキサポート [前進時]（アドバンストSCBS）＆AT誤発進抑制制御［前進時］","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"スマートシティブレーキサポート [後退時]（SCBS　R）＆AT誤発進抑制制御［後退時］","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"リアパーキングセンサー（センター／コーナー）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"クルーズコントロール","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"スマート・ブレーキ・サポート（SBS）＆マツダ・レーダー・クルーズ・コントロール（MRCC）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ブラインド・スポット・モニタリング（BSM）＊リア・クロス・トラフィック・アラート（RCTA）機能付","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"車線逸脱警報システム（LDWS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ヒル・ローンチ・アシスト（HLA）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アダプティブ・LED・ヘッドライト（ALH）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ハイ・ビーム・コントロールシステム（HBC）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）A","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"交通標識認識システム（TSR）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"360°ビュー・モニター＋フロントパーキングセンサー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ハロゲンヘッドランプ","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"LEDリアコンビランプ","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"フロントフォグランプ（LED）","value":[""],"unit":"standard","description":""},{"category":"視界","name":"リアフォグランプ","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ヘッドランプウォッシャー","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"オートライトシステム","value":[""],"unit":"standard","description":""},{"category":"視界","name":"レインセンサーワイパー","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"ダークティンテッドガラス（フロント／フロントドア除く）","value":[""],"unit":"standard","description":""},{"category":"視界","name":"スーパーUVカットガラス（フロントドア）","value":[""],"unit":"blank","description":""},{"category":"視界","name":"LEDドアミラーウインカー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ヒ―テッドドアミラー","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"ステアリング本革巻","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"シフトノブ本革巻","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラー）","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラーA）","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"インテリジェント・ドライブ・マスター（i-DM）","value":[""],"unit":"confirm","description":""},{"category":"インテリア","name":"7インチWVGAセンターディスプレイ＆コマンダーコントロール","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"チルト＆テレスコピックステアリング","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"ステアリングオーディオリモートコントロールスイッチ","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"ステアリング シフトスイッチ","value":[""],"unit":"blank","description":""},{"category":"シート","name":"シート材質","value":["クロス"],"unit":"seat1","description":""},{"category":"シート","name":"フロントシート","value":[""],"unit":"standard","description":"運転席ラチェットレバー式シートリフター"},{"category":"空調","name":"フルオートエアコン","value":[""],"unit":"blank","description":""},{"category":"オーディオ＆ナビゲーション他","name":"AM／FMラジオ","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CDプレーヤー","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CD／DVDプレーヤー+地上デジタルTVチューナー（フルセグ）","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"4スピーカー","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"6スピーカー","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"SKYACTIV-VEHICLE DYNAMICS G-ベクタリング コントロール（GVC）","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"i-ELOOP","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"i-stop","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ドライブセレクション","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ナチュラル・サウンド・スムーザー","value":[""],"unit":"blank","description":""},{"category":"タイヤ＆ホイール","name":"15インチ","value":[""],"unit":"standard","description":""},{"category":"タイヤ＆ホイール","name":"アルミホイール","value":[""],"unit":"blank","description":""},{"category":"セキュリティ・他","name":"プッシュボタンスタートシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"電波式キーレスエントリーシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"アドバンストキーレスエントリーシステム","value":[""],"unit":"blank","description":""}]},{"variantId":"C613A0","price":"3952800","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"50","weightTaxRate":"50"},"subsidy":"true"},{"variantId":"C6C3A0","price":"4190400","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C6A310","price":"4190400","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["5000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["2000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"SKYACTIV-DRIVE","value":["82<111>"],"unit":"confirm","description":""},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1","description":""}]}]},{"gradeId":"20S","gradeName":"20Saa","gradeCode":"1","defaultDrive":"2WD","defaultMission":"6EC-AT","variants":[{"variantId":"C12110","price":"2829600","engine":"SKYACTIV-G 2.0","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"100"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全長","value":["5000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["2000"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"SKYACTIV-DRIVE","value":["82<111>"],"unit":"confirm","description":""},{"category":"シート","name":"シート材質","value":["パーフォレーションレザー"],"unit":"seat1","description":""}]}]},{"gradeId":"25S L Package","gradeCode":"3","defaultDrive":"2WD","defaultMission":"6EC-AT","supportCar":"サポカーSワイド","variants":[{"variantId":"C32310","price":"3542400","engine":"SKYACTIV-G 2.5","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"20","weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["4,865"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"ホイールベース","value":["2,830"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"乗車定員","value":["5"],"unit":"","description":"（名）"},{"category":"主要諸元","name":"車両重量","value":["1130","1140","1150"],"unit":"","description":"（kg）"},{"category":"主要諸元","name":"タイヤサイズ","value":["185／65R15"],"unit":"","description":""},{"category":"主要諸元","name":"ホイールタイプ","value":["スチール"],"unit":"","description":""},{"category":"主要諸元","name":"最小回転半径","value":["4.7"],"unit":"","description":"（m）"},{"category":"主要諸元","name":"サスペンション","value":["マクファーソンストラット式"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"ブレーキ","value":["ベンチレーテッドディスク"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"エンジンタイプ","value":["SKYACTIV-G　1.5"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン種類","value":["水冷直列4気筒DOHC16バルブ"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン総排気量","value":["1.496"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"エンジン最高出力","value":["81〈110〉／6,000"],"unit":"","description":"（kW＜PS＞／rpm）"},{"category":"主要諸元","name":"エンジン最大トルク","value":["141〈14.4〉／4,000"],"unit":"","description":"（N・m＜kgf・m＞／rpm）"},{"category":"主要諸元","name":"使用燃料","value":["無鉛レギュラーガソリン"],"unit":"","description":""},{"category":"主要諸元","name":"タンク容量","value":["44"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"JC08モード燃費","value":[""],"unit":"blank","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.0"],"unit":"","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["15.0"],"unit":"","description":"市街地モード（WLTC-L）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.4"],"unit":"","description":"郊外モード（WLTC-M）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["21.2"],"unit":"","description":"高速道路モード（WLTC-H）　（km／L）"},{"category":"セーフティ","name":"エマージェンシー・シグナル・システム（ESS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"SRSエアバッグシステム（カーテン＆フロントサイド）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ダイナミック・スタビリティ・コントロールシステム（DSC）＆トラクション・コントロール・システム（TCS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アドバンストスマートシティブレーキサポート [前進時]（アドバンストSCBS）＆AT誤発進抑制制御［前進時］","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"スマートシティブレーキサポート [後退時]（SCBS　R）＆AT誤発進抑制制御［後退時］","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"リアパーキングセンサー（センター／コーナー）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"クルーズコントロール","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"スマート・ブレーキ・サポート（SBS）＆マツダ・レーダー・クルーズ・コントロール（MRCC）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ブラインド・スポット・モニタリング（BSM）＊リア・クロス・トラフィック・アラート（RCTA）機能付","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"車線逸脱警報システム（LDWS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ヒル・ローンチ・アシスト（HLA）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アダプティブ・LED・ヘッドライト（ALH）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ハイ・ビーム・コントロールシステム（HBC）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）A","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"交通標識認識システム（TSR）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"360°ビュー・モニター＋フロントパーキングセンサー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ハロゲンヘッドランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"LEDリアコンビランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"フロントフォグランプ（LED）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"リアフォグランプ","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ヘッドランプウォッシャー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"オートライトシステム","value":[""],"unit":"standard","description":""},{"category":"視界","name":"レインセンサーワイパー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ダークティンテッドガラス（フロント／フロントドア除く）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"スーパーUVカットガラス（フロントドア）","value":[""],"unit":"blank","description":""},{"category":"視界","name":"LEDドアミラーウインカー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ヒ―テッドドアミラー","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"ステアリング本革巻","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"シフトノブ本革巻","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラー）","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラーA）","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"インテリジェント・ドライブ・マスター（i-DM）","value":[""],"unit":"confirm","description":""},{"category":"インテリア","name":"7インチWVGAセンターディスプレイ＆コマンダーコントロール","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"チルト＆テレスコピックステアリング","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"ステアリングオーディオリモートコントロールスイッチ","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"ステアリング シフトスイッチ","value":[""],"unit":"blank","description":""},{"category":"シート","name":"シート材質","value":["ナッパレザー"],"unit":"seat1","description":""},{"category":"シート","name":"フロントシート","value":[""],"unit":"standard","description":"運転席ラチェットレバー式シートリフター"},{"category":"空調","name":"フルオートエアコン","value":[""],"unit":"blank","description":""},{"category":"オーディオ＆ナビゲーション他","name":"AM／FMラジオ","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CDプレーヤー","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CD／DVDプレーヤー+地上デジタルTVチューナー（フルセグ）","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"4スピーカー","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"6スピーカー","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"SKYACTIV-VEHICLE DYNAMICS G-ベクタリング コントロール（GVC）","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"i-ELOOP","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"i-stop","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ドライブセレクション","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ナチュラル・サウンド・スムーザー","value":[""],"unit":"blank","description":""},{"category":"タイヤ＆ホイール","name":"15インチ","value":[""],"unit":"standard","description":""},{"category":"タイヤ＆ホイール","name":"アルミホイール","value":[""],"unit":"blank","description":""},{"category":"セキュリティ・他","name":"プッシュボタンスタートシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"電波式キーレスエントリーシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"アドバンストキーレスエントリーシステム","value":[""],"unit":"blank","description":""}]},{"variantId":"C32310","price":"3542400","engine":"SKYACTIV-G 2.5","drive":"2WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"100"},"subsidy":"true"},{"variantId":"C32310","price":"3542400","engine":"SKYACTIV-G 2.5","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"20","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C32310","price":"3600000","engine":"SKYACTIV-G 2.5","drive":"4WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"20","weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["4,865"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"ホイールベース","value":["2,830"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"乗車定員","value":["5"],"unit":"","description":"（名）"},{"category":"主要諸元","name":"車両重量","value":["1130","1140","1150"],"unit":"","description":"（kg）"},{"category":"主要諸元","name":"タイヤサイズ","value":["185／65R15"],"unit":"","description":""},{"category":"主要諸元","name":"ホイールタイプ","value":["スチール"],"unit":"","description":""},{"category":"主要諸元","name":"最小回転半径","value":["4.7"],"unit":"","description":"（m）"},{"category":"主要諸元","name":"サスペンション","value":["マクファーソンストラット式"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"ブレーキ","value":["ベンチレーテッドディスク"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"エンジンタイプ","value":["SKYACTIV-G　1.5"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン種類","value":["水冷直列4気筒DOHC16バルブ"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン総排気量","value":["1.496"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"エンジン最高出力","value":["81〈110〉／6,000"],"unit":"","description":"（kW＜PS＞／rpm）"},{"category":"主要諸元","name":"エンジン最大トルク","value":["141〈14.4〉／4,000"],"unit":"","description":"（N・m＜kgf・m＞／rpm）"},{"category":"主要諸元","name":"使用燃料","value":["無鉛レギュラーガソリン"],"unit":"","description":""},{"category":"主要諸元","name":"タンク容量","value":["44"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"JC08モード燃費","value":[""],"unit":"blank","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.0"],"unit":"","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["15.0"],"unit":"","description":"市街地モード（WLTC-L）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.4"],"unit":"","description":"郊外モード（WLTC-M）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["21.2"],"unit":"","description":"高速道路モード（WLTC-H）　（km／L）"},{"category":"セーフティ","name":"エマージェンシー・シグナル・システム（ESS）★★","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"SRSエアバッグシステム（カーテン＆フロントサイド）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ダイナミック・スタビリティ・コントロールシステム（DSC）＆トラクション・コントロール・システム（TCS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アドバンストスマートシティブレーキサポート [前進時]（アドバンストSCBS）＆AT誤発進抑制制御［前進時］","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"スマートシティブレーキサポート [後退時]（SCBS　R）＆AT誤発進抑制制御［後退時］","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"リアパーキングセンサー（センター／コーナー）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"クルーズコントロール","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"スマート・ブレーキ・サポート（SBS）＆マツダ・レーダー・クルーズ・コントロール（MRCC）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ブラインド・スポット・モニタリング（BSM）＊リア・クロス・トラフィック・アラート（RCTA）機能付","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"車線逸脱警報システム（LDWS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ヒル・ローンチ・アシスト（HLA）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アダプティブ・LED・ヘッドライト（ALH）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ハイ・ビーム・コントロールシステム（HBC）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）A","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"交通標識認識システム（TSR）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"360°ビュー・モニター＋フロントパーキングセンサー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ハロゲンヘッドランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"LEDリアコンビランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"フロントフォグランプ（LED）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"リアフォグランプ","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ヘッドランプウォッシャー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"オートライトシステム","value":[""],"unit":"standard","description":""},{"category":"視界","name":"レインセンサーワイパー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ダークティンテッドガラス（フロント／フロントドア除く）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"スーパーUVカットガラス（フロントドア）","value":[""],"unit":"blank","description":""},{"category":"視界","name":"LEDドアミラーウインカー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ヒ―テッドドアミラー","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"ステアリング本革巻","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"シフトノブ本革巻","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラー）","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラーA）","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"インテリジェント・ドライブ・マスター（i-DM）","value":[""],"unit":"confirm","description":""},{"category":"インテリア","name":"7インチWVGAセンターディスプレイ＆コマンダーコントロール","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"チルト＆テレスコピックステアリング","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"ステアリングオーディオリモートコントロールスイッチ","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"ステアリング シフトスイッチ","value":[""],"unit":"blank","description":""},{"category":"シート","name":"シート材質","value":["ナッパレザー"],"unit":"seat1","description":""},{"category":"シート","name":"フロントシート","value":[""],"unit":"standard","description":"運転席ラチェットレバー式シートリフター"},{"category":"空調","name":"フルオートエアコン","value":[""],"unit":"blank","description":""},{"category":"オーディオ＆ナビゲーション他","name":"AM／FMラジオ","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CDプレーヤー","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CD／DVDプレーヤー+地上デジタルTVチューナー（フルセグ）","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"4スピーカー","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"6スピーカー","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"SKYACTIV-VEHICLE DYNAMICS G-ベクタリング コントロール（GVC）","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"i-ELOOP","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"i-stop","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ドライブセレクション","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ナチュラル・サウンド・スムーザー","value":[""],"unit":"blank","description":""},{"category":"タイヤ＆ホイール","name":"15インチ","value":[""],"unit":"standard","description":""},{"category":"タイヤ＆ホイール","name":"アルミホイール","value":[""],"unit":"blank","description":""},{"category":"セキュリティ・他","name":"プッシュボタンスタートシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"電波式キーレスエントリーシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"アドバンストキーレスエントリーシステム","value":[""],"unit":"blank","description":""}]}]},{"gradeId":"20S PROACTIVE","gradeName":"20S PROACTIVEaa","gradeCode":"2","defaultDrive":"2WD","defaultMission":"6EC-AT","variants":[{"variantId":"C22210","price":"2959200","engine":"SKYACTIV-G 2.0","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"20","weightTaxRate":"0"},"subsidy":"false","specs":[{"category":"主要諸元","name":"全長","value":["4,865"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"ホイールベース","value":["2,830"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"乗車定員","value":["5"],"unit":"","description":"（名）"},{"category":"主要諸元","name":"車両重量","value":["1130","1140","1150"],"unit":"","description":"（kg）"},{"category":"主要諸元","name":"タイヤサイズ","value":["185／65R15"],"unit":"","description":""},{"category":"主要諸元","name":"ホイールタイプ","value":["スチール"],"unit":"","description":""},{"category":"主要諸元","name":"最小回転半径","value":["4.7"],"unit":"","description":"（m）"},{"category":"主要諸元","name":"サスペンション","value":["マクファーソンストラット式"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"ブレーキ","value":["ベンチレーテッドディスク"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"エンジンタイプ","value":["SKYACTIV-G　1.5"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン種類","value":["水冷直列4気筒DOHC16バルブ"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン総排気量","value":["1.496"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"エンジン最高出力","value":["81〈110〉／6,000"],"unit":"","description":"（kW＜PS＞／rpm）"},{"category":"主要諸元","name":"エンジン最大トルク","value":["141〈14.4〉／4,000"],"unit":"","description":"（N・m＜kgf・m＞／rpm）"},{"category":"主要諸元","name":"使用燃料","value":["無鉛レギュラーガソリン"],"unit":"","description":""},{"category":"主要諸元","name":"タンク容量","value":["44"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"JC08モード燃費","value":[""],"unit":"blank","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.0"],"unit":"","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["15.0"],"unit":"","description":"市街地モード（WLTC-L）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.4"],"unit":"","description":"郊外モード（WLTC-M）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["21.2"],"unit":"","description":"高速道路モード（WLTC-H）　（km／L）"},{"category":"セーフティ","name":"エマージェンシー・シグナル・システム（ESS）★★★★","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"SRSエアバッグシステム（カーテン＆フロントサイド）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ダイナミック・スタビリティ・コントロールシステム（DSC）＆トラクション・コントロール・システム（TCS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アドバンストスマートシティブレーキサポート [前進時]（アドバンストSCBS）＆AT誤発進抑制制御［前進時］","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"スマートシティブレーキサポート [後退時]（SCBS　R）＆AT誤発進抑制制御［後退時］","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"リアパーキングセンサー（センター／コーナー）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"クルーズコントロール","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"スマート・ブレーキ・サポート（SBS）＆マツダ・レーダー・クルーズ・コントロール（MRCC）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ブラインド・スポット・モニタリング（BSM）＊リア・クロス・トラフィック・アラート（RCTA）機能付","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"車線逸脱警報システム（LDWS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ヒル・ローンチ・アシスト（HLA）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アダプティブ・LED・ヘッドライト（ALH）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ハイ・ビーム・コントロールシステム（HBC）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）A","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"交通標識認識システム（TSR）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"360°ビュー・モニター＋フロントパーキングセンサー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ハロゲンヘッドランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"LEDリアコンビランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"フロントフォグランプ（LED）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"リアフォグランプ","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ヘッドランプウォッシャー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"オートライトシステム","value":[""],"unit":"standard","description":""},{"category":"視界","name":"レインセンサーワイパー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ダークティンテッドガラス（フロント／フロントドア除く）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"スーパーUVカットガラス（フロントドア）","value":[""],"unit":"blank","description":""},{"category":"視界","name":"LEDドアミラーウインカー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ヒ―テッドドアミラー","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"ステアリング本革巻","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"シフトノブ本革巻","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラー）","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラーA）","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"インテリジェント・ドライブ・マスター（i-DM）","value":[""],"unit":"confirm","description":""},{"category":"インテリア","name":"7インチWVGAセンターディスプレイ＆コマンダーコントロール","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"チルト＆テレスコピックステアリング","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"ステアリングオーディオリモートコントロールスイッチ","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"ステアリング シフトスイッチ","value":[""],"unit":"blank","description":""},{"category":"シート","name":"シート材質","value":["クロス"],"unit":"seat1","description":""},{"category":"シート","name":"フロントシート","value":[""],"unit":"standard","description":"運転席ラチェットレバー式シートリフター"},{"category":"空調","name":"フルオートエアコン","value":[""],"unit":"blank","description":""},{"category":"オーディオ＆ナビゲーション他","name":"AM／FMラジオ","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CDプレーヤー","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CD／DVDプレーヤー+地上デジタルTVチューナー（フルセグ）","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"4スピーカー","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"6スピーカー","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"SKYACTIV-VEHICLE DYNAMICS G-ベクタリング コントロール（GVC）","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"i-ELOOP","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"i-stop","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ドライブセレクション","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ナチュラル・サウンド・スムーザー","value":[""],"unit":"blank","description":""},{"category":"タイヤ＆ホイール","name":"15インチ","value":[""],"unit":"standard","description":""},{"category":"タイヤ＆ホイール","name":"アルミホイール","value":[""],"unit":"blank","description":""},{"category":"セキュリティ・他","name":"プッシュボタンスタートシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"電波式キーレスエントリーシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"アドバンストキーレスエントリーシステム","value":[""],"unit":"blank","description":""}]}]},{"gradeId":"XDwelfare","gradeName":"MAZDA ATENZA|助手席回転シート車"},{"gradeId":"XD PROACTIVE","gradeCode":"6","variants":[{"variantId":"C53210","price":"3369600","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C51211","price":"3423600","engine":"SKYACTIV-D 2.2","drive":"2WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"0"},"subsidy":"true"},{"variantId":"C5C210","price":"3607200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6EC-AT","taxInfo":{"acquisitionTaxRate":"100","weightTaxRate":"0"},"subsidy":"true","specs":[{"category":"主要諸元","name":"全長","value":["4,865"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"全幅","value":["1,840"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"ホイールベース","value":["2,830"],"unit":"","description":"（mm）"},{"category":"主要諸元","name":"乗車定員","value":["5"],"unit":"","description":"（名）"},{"category":"主要諸元","name":"車両重量","value":["1130","1140","1150"],"unit":"","description":"（kg）"},{"category":"主要諸元","name":"タイヤサイズ","value":["185／65R15"],"unit":"","description":""},{"category":"主要諸元","name":"ホイールタイプ","value":["スチール"],"unit":"","description":""},{"category":"主要諸元","name":"最小回転半径","value":["4.7"],"unit":"","description":"（m）"},{"category":"主要諸元","name":"サスペンション","value":["マクファーソンストラット式"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"ブレーキ","value":["ベンチレーテッドディスク"],"unit":"","description":"（フロント）"},{"category":"主要諸元","name":"エンジンタイプ","value":["SKYACTIV-G　1.5"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン種類","value":["水冷直列4気筒DOHC16バルブ"],"unit":"","description":""},{"category":"主要諸元","name":"エンジン総排気量","value":["1.496"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"エンジン最高出力","value":["81〈110〉／6,000"],"unit":"","description":"（kW＜PS＞／rpm）"},{"category":"主要諸元","name":"エンジン最大トルク","value":["141〈14.4〉／4,000"],"unit":"","description":"（N・m＜kgf・m＞／rpm）"},{"category":"主要諸元","name":"使用燃料","value":["無鉛レギュラーガソリン"],"unit":"","description":""},{"category":"主要諸元","name":"タンク容量","value":["44"],"unit":"","description":"（L）"},{"category":"主要諸元","name":"JC08モード燃費","value":[""],"unit":"blank","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.0"],"unit":"","description":"（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["15.0"],"unit":"","description":"市街地モード（WLTC-L）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["19.4"],"unit":"","description":"郊外モード（WLTC-M）　（km／L）"},{"category":"主要諸元","name":"WLTCモード燃費","value":["21.2"],"unit":"","description":"高速道路モード（WLTC-H）　（km／L）"},{"category":"セーフティ","name":"エマージェンシー・シグナル・システム（ESS）★★★★","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"SRSエアバッグシステム（カーテン＆フロントサイド）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ダイナミック・スタビリティ・コントロールシステム（DSC）＆トラクション・コントロール・システム（TCS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アドバンストスマートシティブレーキサポート [前進時]（アドバンストSCBS）＆AT誤発進抑制制御［前進時］","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"スマートシティブレーキサポート [後退時]（SCBS　R）＆AT誤発進抑制制御［後退時］","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"リアパーキングセンサー（センター／コーナー）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"クルーズコントロール","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"スマート・ブレーキ・サポート（SBS）＆マツダ・レーダー・クルーズ・コントロール（MRCC）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ブラインド・スポット・モニタリング（BSM）＊リア・クロス・トラフィック・アラート（RCTA）機能付","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"車線逸脱警報システム（LDWS）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ヒル・ローンチ・アシスト（HLA）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"アダプティブ・LED・ヘッドライト（ALH）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ハイ・ビーム・コントロールシステム（HBC）","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"ドライバー・アテンション・アラート（DAA）A","value":[""],"unit":"standard","description":""},{"category":"セーフティ","name":"交通標識認識システム（TSR）","value":[""],"unit":"blank","description":""},{"category":"セーフティ","name":"360°ビュー・モニター＋フロントパーキングセンサー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ハロゲンヘッドランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"LEDリアコンビランプ","value":[""],"unit":"standard","description":""},{"category":"視界","name":"フロントフォグランプ（LED）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"リアフォグランプ","value":[""],"unit":"blank","description":""},{"category":"視界","name":"ヘッドランプウォッシャー","value":[""],"unit":"blank","description":""},{"category":"視界","name":"オートライトシステム","value":[""],"unit":"standard","description":""},{"category":"視界","name":"レインセンサーワイパー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ダークティンテッドガラス（フロント／フロントドア除く）","value":[""],"unit":"maker-option","description":""},{"category":"視界","name":"スーパーUVカットガラス（フロントドア）","value":[""],"unit":"blank","description":""},{"category":"視界","name":"LEDドアミラーウインカー","value":[""],"unit":"standard","description":""},{"category":"視界","name":"ヒ―テッドドアミラー","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"ステアリング本革巻","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"シフトノブ本革巻","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラー）","value":[""],"unit":"blank","description":""},{"category":"インテリア","name":"アクティブ・ドライビング・ディスプレイ（カラーA）","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"インテリジェント・ドライブ・マスター（i-DM）","value":[""],"unit":"confirm","description":""},{"category":"インテリア","name":"7インチWVGAセンターディスプレイ＆コマンダーコントロール","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"チルト＆テレスコピックステアリング","value":[""],"unit":"standard","description":""},{"category":"インテリア","name":"ステアリングオーディオリモートコントロールスイッチ","value":[""],"unit":"maker-option","description":""},{"category":"インテリア","name":"ステアリング シフトスイッチ","value":[""],"unit":"blank","description":""},{"category":"シート","name":"シート材質","value":["クロス"],"unit":"seat1","description":""},{"category":"シート","name":"フロントシート","value":[""],"unit":"standard","description":"運転席ラチェットレバー式シートリフター"},{"category":"空調","name":"フルオートエアコン","value":[""],"unit":"blank","description":""},{"category":"オーディオ＆ナビゲーション他","name":"AM／FMラジオ","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CDプレーヤー","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"CD／DVDプレーヤー+地上デジタルTVチューナー（フルセグ）","value":[""],"unit":"maker-option","description":""},{"category":"オーディオ＆ナビゲーション他","name":"4スピーカー","value":[""],"unit":"standard","description":""},{"category":"オーディオ＆ナビゲーション他","name":"6スピーカー","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"SKYACTIV-VEHICLE DYNAMICS G-ベクタリング コントロール（GVC）","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"i-ELOOP","value":[""],"unit":"maker-option","description":""},{"category":"シャシー・メカニズム他","name":"i-stop","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ドライブセレクション","value":[""],"unit":"standard","description":""},{"category":"シャシー・メカニズム他","name":"ナチュラル・サウンド・スムーザー","value":[""],"unit":"blank","description":""},{"category":"タイヤ＆ホイール","name":"15インチ","value":[""],"unit":"standard","description":""},{"category":"タイヤ＆ホイール","name":"アルミホイール","value":[""],"unit":"blank","description":""},{"category":"セキュリティ・他","name":"プッシュボタンスタートシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"電波式キーレスエントリーシステム","value":[""],"unit":"standard","description":""},{"category":"セキュリティ・他","name":"アドバンストキーレスエントリーシステム","value":[""],"unit":"blank","description":""}]},{"variantId":"C5A211","price":"3661200","engine":"SKYACTIV-D 2.2","drive":"4WD","transmission":"6MT","taxInfo":{"acquisitionTaxRate":"0","weightTaxRate":"0"},"subsidy":"true"}]}]}}]}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_slider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_body__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_custom_png__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_custom_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__image_custom_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_maker_png__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_maker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__icon_maker_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\dealer-detail-content\\index.jsx',
    _class2,
    _temp2,
    _class3,
    _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import iconConsultation from "./icon-consultation.png";





/**
 *  DealerDetailContent
 */
var DealerDetailContent = (_temp = _class = function (_Component) {
  _inherits(DealerDetailContent, _Component);

  function DealerDetailContent(props) {
    _classCallCheck(this, DealerDetailContent);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleResize = function () {
      var maxHeight = 0;
      _this.informationRefs.map(function (ref, index) {
        if (_this.refs[ref] && _this.refs[ref].clientHeight) {
          var height = _this.refs[ref].clientHeight;
          if (maxHeight < height) {
            maxHeight = height;
          }
        }
      });
      _this.setState({
        informationHeight: maxHeight
      });
    };

    _this.getText = function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (val && val !== '') {
        return val;
      } else {
        if (defaultVal && defaultVal !== '') {
          return defaultVal;
        } else {
          return null;
        }
      }
    };

    _this.getArray = function (arr) {
      if (arr && arr instanceof Array && 1 <= arr.length) {
        return arr;
      } else {
        return null;
      }
    };

    _this.getResponsiveText = function (val, mbVal) {
      if (mbVal && mbVal !== '') {
        return mbVal;
      } else {
        if (val && val !== '') {
          return val;
        } else {
          return null;
        }
      }
    };

    _this.getIsActiveByDate = function () {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (_this.today === null) return false;
      //
      if (end === null || start === null) return true;
      //
      var todayTime = _this.today.getTime();
      var startDate = new Date(start.substr(0, 4), start.substr(4, 2) - 1, start.substr(6, 2));
      var startTime = startDate.getTime();
      var endDate = new Date(end.substr(0, 4), end.substr(4, 2) - 1, end.substr(6, 2));
      var endTime = endDate.getTime();
      if (startTime <= todayTime && todayTime <= endTime) {
        return true;
      } else {
        return false;
      }
    };

    _this.getDateByStr = function (str) {
      return new Date(str.substr(0, 4), str.substr(4, 2) - 1, str.substr(6, 2));
    };

    _this.getCalendersInfo = function (date) {

      // カレンダー情報取得
      var getCalenders = function getCalenders() {
        var arr = [];
        if (_this.getArray(_this.props.shop.calendars)) {
          var _i = void 0,
              _max = void 0;
          for (_i = 0, _max = _this.props.shop.calendars.length; _i < _max; _i = _i + 1) {
            var calendar = _this.props.shop.calendars[_i];
            var _date = _this.getDateByStr(calendar.date);
            var week = _date.getDay() - 1;
            var sales = false;
            if (calendar.sales === true) sales = true;
            var service = false;
            if (calendar.service === true) service = true;
            if (week <= -1) week = 6;
            //
            var isToday = false;
            if (_this.today.getFullYear() + '' + _this.today.getMonth() + '' + _this.today.getDate() === _date.getFullYear() + '' + _date.getMonth() + '' + _date.getDate()) {
              isToday = true;
            }
            //
            arr.push({
              dataExist: true,
              today: isToday,
              year: _date.getFullYear(),
              month: _date.getMonth(),
              day: _date.getDate(),
              week: week,
              sales: sales,
              service: service
            });
          }
        }
        return arr;
      };

      // 月情報取得
      var getMonth = function getMonth(year, month, calenders) {
        var date = new Array(31);
        var i = void 0,
            max = void 0;
        for (i = 0, max = calenders.length; i < max; i = i + 1) {
          if (calenders[i].year === year && calenders[i].month === month) {
            date[calenders[i].day - 1] = calenders[i];
          }
        }
        for (i = 0, max = date.length; i < max; i = i + 1) {
          var _date2 = new Date(year, month, i + 1);
          if (_date2.getMonth() === month) {
            if (!date[i]) {
              //
              var week = _date2.getDay() - 1;
              if (week <= -1) week = 6;
              //
              var isToday = false;
              if (_this.today.getFullYear() + '' + _this.today.getMonth() + '' + _this.today.getDate() === year + '' + month + '' + (i + 1)) {
                isToday = true;
              }
              date[i] = {
                dataExist: false,
                today: isToday,
                year: year,
                month: month,
                day: i + 1,
                week: week
              };
            }
          }
        }
        var date2 = [];
        for (i = 0, max = date.length; i < max; i = i + 1) {
          if (date[i]) {
            date2.push(date[i]);
          }
        }
        return {
          year: year,
          month: month,
          date: date2
        };
      };

      var arr = [];
      var todayMonth = date.getMonth();
      var todayYear = date.getFullYear();
      var nextMonth = todayMonth + 1;
      var nextYear = todayYear;
      if (12 <= nextMonth) {
        nextMonth = 0;
        nextYear = nextYear + 1;
      }
      var calenders = getCalenders();

      // 一つ目のカレンダー
      var flg = false;
      var month = getMonth(todayYear, todayMonth, calenders);
      var i = void 0,
          max = void 0;
      // 月の全てのデータがなかった場合
      for (i = 0, max = month.date.length; i < max; i = i + 1) {
        if (month.date[i].dataExist === true) {
          flg = true;
          break;
        }
      }
      if (flg) {
        // 販売及び、サービスが一つでもあれば
        flg = false;
        for (i = 0, max = month.date.length; i < max; i = i + 1) {
          if (_this.serviceType.type === 'A') {
            if (month.date[i].sales === true || month.date[i].service === true) {
              flg = true;
              break;
            }
          } else if (_this.serviceType.type === 'B') {
            if (month.date[i].service === true) {
              flg = true;
              break;
            }
          } else if (_this.serviceType.type === 'C') {
            if (month.date[i].sales === true) {
              flg = true;
              break;
            }
          }
        }
        if (flg) arr.push(month);
      }

      // 二つ目のカレンダー
      flg = false;
      month = getMonth(nextYear, nextMonth, calenders);
      for (i = 0, max = month.date.length; i < max; i = i + 1) {
        if (month.date[i].dataExist === true) {
          flg = true;
          break;
        }
      }
      if (flg) {
        // 販売及び、サービスが一つでもあれば
        flg = false;
        for (i = 0, max = month.date.length; i < max; i = i + 1) {
          if (_this.serviceType.type === 'A') {
            if (month.date[i].sales === true || month.date[i].service === true) {
              flg = true;
              break;
            }
          } else if (_this.serviceType.type === 'B') {
            if (month.date[i].service === true) {
              flg = true;
              break;
            }
          } else if (_this.serviceType.type === 'C') {
            if (month.date[i].sales === true) {
              flg = true;
              break;
            }
          }
        }
        if (flg) arr.push(month);
      }

      // arr.push(getMonth(todayYear, todayMonth, calenders));
      // arr.push(getMonth(nextYear, nextMonth, calenders));
      return arr;
    };

    _this.getIsShopServiceType = function () {
      var i = void 0,
          max = void 0;
      var flg = false;
      var flg2 = false;
      var flg3 = false;
      for (i = 0, max = _this.props.shop.services.length; i < max; i = i + 1) {
        var service = _this.props.shop.services[i];
        if (service.service === '新車' && service.isHighlighted === true) flg = true;
        if (service.service === '中古車' && service.isHighlighted === true) flg2 = true;
        if (service.service === 'サービス' && service.isHighlighted === true) flg3 = true;
      }
      if ((flg === true || flg2 === true) && flg3 === true) {
        // 新車販売・中古車・修理3つともあり
        return {
          type: 'A',
          newCar: flg,
          usedCar: flg2,
          repair: flg3
        };
      } else if (flg === false && flg2 === false) {
        // 新車販売・中古車ともになし
        return {
          type: 'B',
          newCar: flg,
          usedCar: flg2,
          repair: flg3
        };
      } else if (flg3 === false) {
        // 修理なし
        return {
          type: 'C',
          newCar: flg,
          usedCar: flg2,
          repair: flg3
        };
      }
    };

    _this.getBodyTypesInfo = function () {
      var arr = [];
      if (_this.getArray(_this.props.shop.cars)) {
        var i = void 0,
            max = void 0;
        for (i = 0, max = _this.props.shop.cars.length; i < max; i = i + 1) {
          var car = _this.props.shop.cars[i];
          var modelName = car.modelName;
          var j = void 0,
              max2 = void 0;
          for (j = 0, max2 = car.bodyTypes.length; j < max2; j = j + 1) {
            var bodyType = car.bodyTypes[j];
            var carTypeCode = _this.getText(bodyType.defaultCarTypeCode);
            if (!carTypeCode) bodyType.generations[0].carTypeCode;
            arr.push({
              modelName: modelName,
              carId: bodyType.carId,
              bodyType: bodyType.bodyType,
              carTypeCode: carTypeCode
            });
          }
        }
      }
      //console.log(arr);
      return arr;
    };

    _this.setCookie = function (key, val) {
      var date = new Date();
      date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
      document.cookie = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + ';path=/';
      //document.cookie = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + ';sameSite=true;httpOnly=false;secure=true;';
    };

    _this.getCookie = function (key) {
      var arr = document.cookie.split(';');
      var i = void 0,
          max = void 0;
      for (i = 0, max = arr.length; i < max; i = i + 1) {
        var pair = arr[i].split('=');
        if (key === pair[0].trim()) {
          return decodeURIComponent(pair[1]);
        }
      }
      return null;
    };

    _this.getSavedBodyType = function () {
      var ddbt = _this.getCookie('mj_ddbt');
      if (ddbt !== null) {
        var arr = ddbt.split(',');
        if (_this.props.shop.dealerId === arr[0] && _this.props.shop.shopId === arr[1]) {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this.bodyTypesInfo.length; i < max; i = i + 1) {
            if (_this.bodyTypesInfo[i].bodyType === arr[2]) {
              return arr[2];
            }
          }
        }
        return null;
      }
      return null;
    };

    _this.getOffers = function () {
      if (_this.props.shop.offers === null) return null;
      //
      var arr = [];
      var i = void 0,
          max = void 0;
      for (i = 0, max = _this.props.shop.offers.length; i < max; i = i + 1) {
        var offer = _this.props.shop.offers[i].offer;
        if (_this.getIsActiveByDate(offer.startDate, offer.endDate) === true) {
          arr.push({
            title: _this.getText(offer.title),
            description: _this.getText(offer.description),
            imageUrl: _this.getText(offer.imageUrl),
            offerLink: _this.getText(offer.offerLink)
          });
        }
      }
      return _this.getArray(arr);
    };

    _this.props = props;
    _this.state = {
      isMounted: false,
      currentShopIntroductionImageIndex: 0,
      today: null,
      currentTestDriveBodyType: null,
      isOpenedQRModal: false,
      informationHeight: null
    };
    //
    _this.today = null;
    _this.calendersInfo = null;
    _this.serviceType = _this.getIsShopServiceType();
    _this.informationRefs = [];
    _this.testDriveBodyTypeNum = 5;
    _this.bodyTypesInfo = _this.getBodyTypesInfo();
    _this.offers = null;
    //
    //console.log(this.props);
    return _this;
  }

  DealerDetailContent.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.today = new Date();
    this.offers = this.getOffers();
    //
    if (window.matchMedia('(min-width:768px)').matches) {
      this.testDriveBodyTypeNum = 5;
    } else {
      this.testDriveBodyTypeNum = 2;
    }
    //
    var currentTestDriveBodyType = null;

    if (this.getArray(this.props.shop.cars)) {
      var savedBodyType = this.getSavedBodyType();
      if (savedBodyType !== null) {
        if (this.bodyTypesInfo.length <= this.testDriveBodyTypeNum) {
          currentTestDriveBodyType = savedBodyType;
        }
      } else {
        if (this.bodyTypesInfo.length <= this.testDriveBodyTypeNum) {
          currentTestDriveBodyType = this.bodyTypesInfo[0].bodyType;
        }
      }
    }

    //
    this.setState({
      isMounted: true,
      today: this.today,
      currentTestDriveBodyType: currentTestDriveBodyType
    });
    //
    this.calendersInfo = this.getCalendersInfo(this.today);

    //console.log('販売会社のサービスタイプ');
    //console.log(this.serviceType);
    //console.log('本日の日付 : ' + this.today);
    //console.log(this.calendersInfo);

    // Cookie設定
    this.setCookie('mj_drl', this.props.shop.dealerId);
    this.setCookie('mj_shp', this.props.shop.shopId);
    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(function () {
      _this2.handleResize();
    }, 200);
  };

  DealerDetailContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      isMounted: false
    });
    window.removeEventListener('resize', this.handleResize);
  };

  DealerDetailContent.prototype.render = function render() {
    var _this3 = this;

    console.log('DealerDetailContent : render');

    // ヘッダー表示
    var renderHeader = function renderHeader() {
      var prefecture = _this3.getText(_this3.props.shop.address.prefecture);
      var address1 = _this3.getText(_this3.props.shop.address.address1);
      var address2 = _this3.getText(_this3.props.shop.address.address2);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__header', __source: {
            fileName: _jsxFileName,
            lineNumber: 129
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__header__box', __source: {
              fileName: _jsxFileName,
              lineNumber: 130
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__header__box-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 131
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'DealerDetailContent__header__heading', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 132
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 133
                  }
                },
                _this3.getText(_this3.props.shop.dealerName)
              ),
              _this3.getText(_this3.props.shop.shopName)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__header__box-right', __source: {
                fileName: _jsxFileName,
                lineNumber: 137
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dl',
              { className: 'DealerDetailContent__header__list-dl', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 138
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dt',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 139
                  }
                },
                '\u4F4F\u6240'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dd',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 140
                  }
                },
                '〒 ' + _this3.getText(_this3.props.shop.address.zip) + ' ' + (prefecture ? prefecture : '') + (address1 ? address1 : '') + (address2 ? address2 : '')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dl',
              { className: 'DealerDetailContent__header__list-dl', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 142
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dt',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 143
                  }
                },
                'TEL'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dd',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 144
                  }
                },
                _this3.getText(_this3.props.shop.contact.phoneNumber)
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'DealerDetailContent__header__list-ul', __source: {
              fileName: _jsxFileName,
              lineNumber: 148
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 149
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
              ctaType: 'Free',
              href: 'javascript:void(0);',
              text: 'MAP',
              targetBlank: false,
              color: 'Dark',
              buttonStyle: 'Action',
              linkType: 'Button-With-Icon',
              iconSrc: DealerDetailContent.iconMap,
              handleClick: function handleClick(e) {
                e.preventDefault();
                //
                __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].scrollToNode(_this3.refs.map);
              }
            }, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 150
              }
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 168
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
              ctaType: 'Free',
              href: 'tel:' + _this3.getText(_this3.props.shop.contact.phoneNumber).replace(/-/g, ''),
              text: 'TEL',
              targetBlank: false,
              color: 'Dark',
              buttonStyle: 'Action',
              linkType: 'Button-With-Icon',
              iconSrc: DealerDetailContent.iconTel
            }, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 169
              }
            }))
          )
        )
      );
    };

    // SHOP INTRODUCTION表示
    var renderShopIntroduction = function renderShopIntroduction() {

      var renderImages = function renderImages() {

        var renderDescription = function renderDescription() {
          var description = _this3.getText(_this3.props.shop.dealerInfo.description);
          if (description) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'DealerDetailContent__shop-introduction__description Wysiwyg', dangerouslySetInnerHTML: { __html: description }, __source: {
                fileName: _jsxFileName,
                lineNumber: 196
              }
            });
          } else {
            return null;
          }
        };

        var renderSmallImages = function renderSmallImages() {
          var images = _this3.getArray(_this3.props.shop.dealerInfo.images);
          if (images !== null) {
            var arr = [images[0] ? images[0] : null, images[1] ? images[1] : null, images[2] ? images[2] : null];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'DealerDetailContent__shop-introduction__small-images', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 208
                }
              },
              arr.map(function (image, index) {
                if (arr[index]) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 212
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 213
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: _this3.getText(arr[index].image), __source: {
                          fileName: _jsxFileName,
                          lineNumber: 214
                        }
                      })
                    )
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 220
                    }
                  });
                }
              })
            );
          } else {
            return null;
          }
        };

        var newImages = _this3.getArray(_this3.props.shop.dealerInfo.newImages);
        var defaultImage = _this3.getText(_this3.props.shop.dealerInfo.defaultImage);
        if (newImages !== null) {
          if (2 <= newImages.length) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 236
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__shop-introduction__large-images', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 237
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DealerDetailContent__shop-introduction__large-images__box', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 238
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__components_slider__["a" /* default */],
                    {
                      ref: 'slider',
                      settings: {
                        autoplay: false,
                        speed: 1000,
                        ease: 'linear',
                        fade: true,
                        infinite: true,
                        initialSlide: _this3.state.currentShopIntroductionImageIndex,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        swipe: false,
                        draggable: false,
                        arrows: false,
                        dots: false,
                        adaptiveHeight: false,
                        centerMode: false,
                        centerPadding: 0,
                        focusOnSelect: true,
                        //lazyLoad: 'progressive',
                        lazyLoad: 'ondemand',
                        waitForAnimate: false,
                        beforeChange: function beforeChange(old, current) {
                          if (_this3.refs.thumbnail) _this3.refs.thumbnail.slickGoTo(current);
                        },
                        responsive: [{
                          breakpoint: 767,
                          settings: {
                            swipe: true,
                            arrows: false,
                            fade: false,
                            dots: true
                            //prevArrow: '<div></div>',
                            //nextArrow: '<div></div>',
                          }
                        }]
                      },
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 239
                      }
                    },
                    newImages.map(function (newImage, index) {
                      if (5 <= index) return null;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: index, className: 'DealerDetailContent__shop-introduction__large-images__image', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 282
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { backgroundImage: 'url(' + _this3.getText(newImage.image) + ')' }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 283
                          }
                        })
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DealerDetailContent__shop-introduction__large-images__box2', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 290
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'DealerDetailContent__shop-introduction__large-images__list-ul', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 291
                      }
                    },
                    newImages.map(function (newImage, index) {
                      if (5 <= index) return null;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 295
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'DealerDetailContent__shop-introduction__large-images__link' + (_this3.state.currentShopIntroductionImageIndex === index ? ' current' : ''), href: 'javascript:void(0);', onClick: function onClick(e) {
                              e.preventDefault();
                              //
                              if (_this3.state.currentShopIntroductionImageIndex !== index) {
                                _this3.setState({
                                  currentShopIntroductionImageIndex: index
                                });
                                if (_this3.refs.slider) _this3.refs.slider.slickGoTo(index);
                              }
                            }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 296
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { backgroundImage: 'url(' + _this3.getText(newImage.image) + ')' }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 306
                            }
                          })
                        )
                      );
                    })
                  )
                )
              ),
              renderDescription()
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 320
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__shop-introduction__large-image', src: _this3.getText(newImages[0].image), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 321
                }
              }),
              renderDescription()
            );
          }
        } else {
          if (defaultImage !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 329
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__shop-introduction__large-image', src: defaultImage, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 330
                }
              }),
              renderDescription(),
              renderSmallImages()
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 337
                }
              },
              renderDescription()
            );
          }
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__shop-introduction', __source: {
            fileName: _jsxFileName,
            lineNumber: 346
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__shop-introduction__heading Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 347
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__shop-introduction__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.shopIntroductionText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 348
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__shop-introduction__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.shopIntroductionText, _this3.props.mbShopIntroductionText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 349
            }
          })
        ),
        renderImages()
      );
    };

    // ONLINE SERVICE表示
    var renderOnlineService = function renderOnlineService() {

      // 試乗車一覧
      var renderTestDrive = function renderTestDrive() {
        //if (this.props.shop.cta.hasTestDrive === true) {
        if (_this3.getArray(_this3.props.shop.cars)) {
          var src = _this3.getText(_this3.props.testDriveImage);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 365
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'DealerDetailContent__online-service__link', href: 'javascript:void(0);', onClick: function onClick(e) {
                  e.preventDefault();
                  //
                  __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].scrollToNode(_this3.refs.testdrive);
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 366
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 371
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 372
                    }
                  },
                  src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__online-service__icon', src: src, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 373
                    }
                  }) : null,
                  _this3.getText(_this3.props.testDriveTitle, '試乗車一覧')
                )
              )
            )
          );
        } else {
          return null;
        }
      };

      // 商談申込
      var renderConsultation = function renderConsultation() {
        if (_this3.props.shop.cta.brochures === true) {
          var url = 'https://my.mazda.co.jp/purchase/consultation/index.html';
          url += '?select_ken=' + encodeURIComponent(_this3.getText(_this3.props.shop.address.prefecture));
          url += '&dealer_code=' + _this3.getText(_this3.props.shop.dealerId);
          url += '&shop_code=' + _this3.getText(_this3.props.shop.shopId);
          var src = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            src = '/assets-dev/assets/purchase/dealer/detail/icon_meeting_dark.png';
          } else {
            src = '/globalassets/assets/purchase/dealer/detail/icon_meeting_dark.png';
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 399
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'DealerDetailContent__online-service__link', href: url, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 400
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 401
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 402
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__online-service__icon', src: src, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 403
                    }
                  }),
                  '\u5546\u8AC7\u7533\u8FBC'
                )
              )
            )
          );
        } else {
          return null;
        }
      };

      // カタログ請求
      var renderCatalogue = function renderCatalogue() {
        if (_this3.props.shop.cta.brochures === true) {
          var src = _this3.getText(_this3.props.catalogImage);
          //
          var url = 'https://www.mazda.co.jp/purchase/webcatalog/';
          // let url = 'https://ssl.mazda.co.jp/purchase/catalog/';
          // if (this.state.isMounted === true) {
          //   if (IS_MOBILE) {
          //     url = 'https://ssl.mazda.co.jp/sp/purchase/catalog/';
          //   }
          // }
          //
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 430
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'DealerDetailContent__online-service__link', href: url + '?dlr=' + _this3.getText(_this3.props.shop.dealerId) + '&shp=' + _this3.getText(_this3.props.shop.shopId), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 431
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 432
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 433
                    }
                  },
                  src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__online-service__icon', src: src, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 434
                    }
                  }) : null,
                  _this3.getText(_this3.props.catalogTitle, 'カタログ閲覧')
                )
              )
            )
          );
        } else {
          return null;
        }
      };

      // 見積依頼
      var renderEstimate = function renderEstimate() {
        if (_this3.props.shop.cta.requestPriceEstimate === true) {
          var src = _this3.getText(_this3.props.estimateImage);
          //
          var url = '/purchase/estimate/';
          // let url = 'https://ssl.mazda.co.jp/purchase/estimate/';
          // if (this.state.isMounted === true) {
          //   if (IS_MOBILE) {
          //     url = 'https://ssl.mazda.co.jp/sp/purchase/estimate/';
          //   }
          // }
          //
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 460
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'DealerDetailContent__online-service__link', href: url + '?dlr=' + _this3.getText(_this3.props.shop.dealerId) + '&shp=' + _this3.getText(_this3.props.shop.shopId), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 461
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 462
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 463
                    }
                  },
                  src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__online-service__icon', src: src, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 464
                    }
                  }) : null,
                  _this3.getText(_this3.props.estimateTitle, '見積依頼')
                )
              )
            )
          );
        } else {
          return null;
        }
      };

      // 中古車検索
      var renderUsedCar = function renderUsedCar() {
        if (_this3.props.shop.cta.secondhand === true) {
          var src = _this3.getText(_this3.props.uCarImage);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 481
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'DealerDetailContent__online-service__link', href: 'http://www2.mazda.co.jp/purchase/ucar/result.html' + '?dc=' + _this3.getText(_this3.props.shop.dealerId) + '&sc=' + _this3.getText(_this3.props.shop.shopId), __source: {
                  fileName: _jsxFileName,
                  lineNumber: 482
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 483
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 484
                    }
                  },
                  src ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__online-service__icon', src: src, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 485
                    }
                  }) : null,
                  _this3.getText(_this3.props.uCarTitle, '中古車検索')
                )
              )
            )
          );
        } else {
          return null;
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__online-service', __source: {
            fileName: _jsxFileName,
            lineNumber: 498
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__online-service__heading Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 499
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__online-service__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.onlineServiceText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 500
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__online-service__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.onlineServiceText, _this3.props.mbOnlineServiceText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 501
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'DealerDetailContent__online-service__list-ul', __source: {
              fileName: _jsxFileName,
              lineNumber: 503
            }
          },
          renderTestDrive(),
          renderConsultation(),
          renderCatalogue(),
          renderEstimate(),
          renderUsedCar()
        )
      );
      // // if (this.props.shop.cta.requestPriceEstimate || this.props.shop.cta.brochures || this.props.shop.cta.secondhand || this.props.shop.cta.hasTestDrive) {
      // if (this.props.shop.cta.requestPriceEstimate || this.props.shop.cta.brochures || this.props.shop.cta.secondhand || this.getArray(this.props.shop.cars)) {
      //   return (
      //     <div className="DealerDetailContent__online-service">
      //       <div className="DealerDetailContent__online-service__heading Wysiwyg">
      //         <div className="DealerDetailContent__online-service__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.onlineServiceText)}}/>
      //         <div className="DealerDetailContent__online-service__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.onlineServiceText, this.props.mbOnlineServiceText)}}/>
      //       </div>
      //       <ul className="DealerDetailContent__online-service__list-ul">
      //         {renderTestDrive()}
      //         {renderConsultation()}
      //         {renderCatalogue()}
      //         {renderEstimate()}
      //         {renderUsedCar()}
      //       </ul>
      //     </div>
      //   )
      // } else {
      //   return null;
      // }
    };

    // SHOP SERVICE表示
    var renderShopService = function renderShopService() {

      // 取扱サービス
      var renderMainService = function renderMainService() {

        var getService = function getService(label) {
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this3.props.shop.services.length; i < max; i = i + 1) {
            var service = _this3.props.shop.services[i];
            if (service.service === label && service.isHighlighted === true) {
              return service.service;
            }
          }
          return null;
        };

        var newCar = getService('新車');
        var usedCar = getService('中古車');
        var repair = getService('サービス');

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'dl',
          { className: 'DealerDetailContent__shop-service__list-dl', __source: {
              fileName: _jsxFileName,
              lineNumber: 556
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dt',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 557
              }
            },
            '\u53D6\u6271\u30B5\u30FC\u30D3\u30B9'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { className: newCar ? 'active' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 558
              }
            },
            '\u65B0\u8ECA'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { className: usedCar ? 'active' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 559
              }
            },
            '\u4E2D\u53E4\u8ECA'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dd',
            { className: repair ? 'active' : '', __source: {
                fileName: _jsxFileName,
                lineNumber: 560
              }
            },
            '\u30B5\u30FC\u30D3\u30B9'
          )
        );
      };

      // 店舗設備
      var renderSubService = function renderSubService() {

        var getService = function getService() {
          var arr = [];
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this3.props.shop.services.length; i < max; i = i + 1) {
            var service = _this3.props.shop.services[i];
            if (service.service !== '新車' && service.service !== '中古車' && service.service !== 'サービス') {
              if (service.isHighlighted === true) {
                arr.push(service.service);
              }
            }
          }
          return arr;
        };

        var services = _this3.getArray(getService());
        if (services) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dl',
            { className: 'DealerDetailContent__shop-service__list-dl', __source: {
                fileName: _jsxFileName,
                lineNumber: 585
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dt',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 586
                }
              },
              '\u5E97\u8217\u8A2D\u5099'
            ),
            services.map(function (service, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dd',
                { className: 'active', key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 589
                  }
                },
                service
              );
            })
          );
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__shop-service', __source: {
            fileName: _jsxFileName,
            lineNumber: 598
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__shop-service__heading Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 599
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__shop-service__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.shopServiceText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 600
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__shop-service__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.shopServiceText, _this3.props.mbShopServiceText) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 601
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__shop-service__box', __source: {
              fileName: _jsxFileName,
              lineNumber: 603
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__shop-service__box-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 604
              }
            },
            renderMainService()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__shop-service__box-right', __source: {
                fileName: _jsxFileName,
                lineNumber: 607
              }
            },
            renderSubService()
          )
        )
      );
    };

    // INFORMATION表示
    var renderInformation = function renderInformation() {
      var information = _this3.getArray(_this3.props.shop.dealerInfo.information);
      var count = 0;
      _this3.informationRefs = [];
      if (information !== null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__information', __source: {
              fileName: _jsxFileName,
              lineNumber: 622
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__information__heading Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 623
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__information__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.informationText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 624
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__information__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.informationText, _this3.props.mbInformationText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 625
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'DealerDetailContent__information__list-ul', __source: {
                fileName: _jsxFileName,
                lineNumber: 627
              }
            },
            information.map(function (info, index) {
              if (3 <= count) return;
              var title = _this3.getText(info.title);
              var description = _this3.getText(info.description);
              if (title !== null || description !== null) {
                count = count + 1;
                _this3.informationRefs.push('information' + index);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 636
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DealerDetailContent__information__box', style: 1 <= _this3.state.informationHeight ? { height: _this3.state.informationHeight } : { height: 'auto' }, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 637
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'dl',
                      { className: 'DealerDetailContent__information__list-dl', ref: 'information' + index, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 638
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: _this3.getText(info.title) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 639
                        }
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: _this3.getText(info.description) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 640
                        }
                      })
                    )
                  )
                );
              } else {
                return null;
              }
            })
          )
        );
      } else {
        return null;
      }
    };

    // EVENT & CAMPAIGN表示
    var renderEventCampaign = function renderEventCampaign() {
      if (_this3.offers !== null) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__event-campaign', __source: {
              fileName: _jsxFileName,
              lineNumber: 661
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__event-campaign__heading Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 662
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__event-campaign__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.eventAndCampaignText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 663
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__event-campaign__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.eventAndCampaignText, _this3.props.mbEventAndCampaignText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 664
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'DealerDetailContent__event-campaign__list-ul', __source: {
                fileName: _jsxFileName,
                lineNumber: 666
              }
            },
            _this3.offers.map(function (offer, index) {
              if (index < 3) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 670
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DealerDetailContent__event-campaign__box', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 671
                      }
                    },
                    offer.imageUrl !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'DealerDetailContent__event-campaign__box-left', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 673
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: offer.imageUrl, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 674
                        }
                      })
                    ) : '',
                    offer.title !== null || offer.description !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'DealerDetailContent__event-campaign__box-center', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 678
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'dl',
                        { className: 'DealerDetailContent__event-campaign__list-dl', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 679
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: offer.title }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 680
                          }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: offer.description }, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 681
                          }
                        })
                      )
                    ) : '',
                    offer.offerLink !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'DealerDetailContent__event-campaign__box-right', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 686
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
                        ctaType: 'Free',
                        href: offer.offerLink,
                        text: '詳細はこちら',
                        targetBlank: false,
                        color: 'Dark',
                        buttonStyle: 'Action',
                        linkType: 'Button'
                      }, {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 687
                        }
                      }))
                    ) : ''
                  )
                );
              } else {
                return null;
              }
            })
          )
        );
      } else {
        return null;
      }
    };

    // TEST DRIVE表示
    var renderTestDrive = function renderTestDrive() {

      var renderBodyTypes = function renderBodyTypes() {

        // ボディータイプ画像取得
        var getBodyTypeImageSrc = function getBodyTypeImageSrc(modelName, carId) {
          var carTypeCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

          var str = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            str = '/assets-dev/assets/cars/';
          } else {
            str = '/globalassets/assets/cars/';
          }
          str = str + modelName + '/';
          str = str + carId + '/';
          if (carTypeCode !== null) {
            str = str + carTypeCode + '/';
            str = str + 'common/default_s.png';
            str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
            return str;
          } else {
            str = str + 'common/default_s.png';
            str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
            return str;
          }
        };

        // 機種情報取得
        //const getVariantsInfo = (modelName, carId, carTypeCode)=> {
        var getVariantsInfo = function getVariantsInfo(modelName, carId) {
          if (!_this3.getText(modelName) || !_this3.getText(carId)) return null;
          //if (!this.getText(modelName) || !this.getText(carId) || !this.getText(carTypeCode)) return null;
          var i = void 0,
              max = void 0;
          for (i = 0, max = _this3.props.shop.cars.length; i < max; i = i + 1) {
            var car = _this3.props.shop.cars[i];
            if (car && modelName === car.modelName) {
              if (!car.bodyTypes) continue;
              var j = void 0,
                  max2 = void 0;
              for (j = 0, max2 = car.bodyTypes.length; j < max2; j = j + 1) {
                var bodyType = car.bodyTypes[j];
                if (bodyType && carId === bodyType.carId) {
                  if (!bodyType.generations) continue;
                  var k = void 0,
                      max3 = void 0;
                  var _arr = [];
                  for (k = 0, max3 = bodyType.generations.length; k < max3; k = k + 1) {
                    var generation = bodyType.generations[k];
                    //if (generation && carTypeCode === generation.carTypeCode) {
                    if (generation) {
                      //let arr = [];
                      if (!generation.grades) continue;
                      var h = void 0,
                          max4 = void 0;
                      for (h = 0, max4 = generation.grades.length; h < max4; h = h + 1) {
                        var grade = generation.grades[h];
                        var gradeName = grade.grade;
                        var engine = grade.engine.name;
                        var fuel = grade.engine.fuel;
                        if (!grade.variants) continue;
                        var g = void 0,
                            max5 = void 0;
                        for (g = 0, max5 = grade.variants.length; g < max5; g = g + 1) {
                          var variant = grade.variants[g];
                          _arr.push({
                            modelName: modelName,
                            carId: carId,
                            //carTypeCode: carTypeCode,
                            carTypeCode: generation.carTypeCode,
                            grade: gradeName,
                            engine: engine,
                            fuel: fuel,
                            variantId: variant.variantId,
                            drive: variant.drive,
                            transmission: variant.transmission,
                            settingExist: variant.settingExist,
                            customImage: variant.customImage,
                            trialCarId: variant.trialCarId,
                            description: variant.description,
                            memo: variant.memo,
                            trialCarColor: variant.trialCarColor,
                            trialCarColorCode: variant.trialCarColorCode
                          });
                        }
                      }
                      // return arr;
                    }
                  }

                  return _arr;
                }
              }
            }
          }
          return null;
        };

        var arr = [];
        var i = void 0,
            max = void 0;
        for (i = 0, max = Math.ceil(_this3.bodyTypesInfo.length / _this3.testDriveBodyTypeNum); i < max; i = i + 1) {
          arr.push(i * _this3.testDriveBodyTypeNum);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 814
            }
          },
          arr.map(function (start, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 817
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__text-drive__body-type', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 818
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'DealerDetailContent__text-drive__body-type__list', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 819
                    }
                  },
                  _this3.bodyTypesInfo.map(function (bodyType, index2) {
                    if (start <= index2 && index2 < start + _this3.testDriveBodyTypeNum) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index2, ref: bodyType.bodyType, __source: {
                            fileName: _jsxFileName,
                            lineNumber: 823
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'a',
                          { className: 'DealerDetailContent__text-drive__body-type__link' + (_this3.state.currentTestDriveBodyType === bodyType.bodyType ? ' current' : ''),
                            href: 'javascript:void(0);',
                            onClick: function onClick(e) {
                              e.preventDefault();
                              //
                              if (_this3.state.currentTestDriveBodyType === bodyType.bodyType) {
                                _this3.setState({
                                  currentTestDriveBodyType: null
                                });
                              } else {
                                _this3.setState({
                                  currentTestDriveBodyType: bodyType.bodyType
                                });
                                // Cookie保存
                                _this3.setCookie('mj_ddbt', _this3.props.shop.dealerId + ',' + _this3.props.shop.shopId + ',' + bodyType.bodyType);
                                //
                                setTimeout(function () {
                                  __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].scrollToNode(_this3.refs[bodyType.bodyType]);
                                }, 100);
                              }
                            }, __source: {
                              fileName: _jsxFileName,
                              lineNumber: 824
                            }
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__text-drive__body-type__image', src: getBodyTypeImageSrc(bodyType.modelName, bodyType.carId, bodyType.carTypeCode), __source: {
                              fileName: _jsxFileName,
                              lineNumber: 846
                            }
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'DealerDetailContent__text-drive__body-type__paragraph', __source: {
                                fileName: _jsxFileName,
                                lineNumber: 847
                              }
                            },
                            bodyType.bodyType
                          )
                        )
                      );
                    } else {
                      return null;
                    }
                  })
                )
              ),
              _this3.bodyTypesInfo.map(function (bodyType, index2) {
                if (start <= index2 && index2 < start + _this3.testDriveBodyTypeNum) {
                  var variantsInfo = getVariantsInfo(bodyType.modelName, bodyType.carId);
                  //const variantsInfo = getVariantsInfo(bodyType.modelName, bodyType.carId, bodyType.carTypeCode);
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Variant, {
                    variantsInfo: _this3.getArray(variantsInfo),
                    isOpened: _this3.state.currentTestDriveBodyType === bodyType.bodyType ? true : false,
                    description: _this3.getText(_this3.props.testDriveCarCommonDescription),
                    mbDescription: _this3.getResponsiveText(_this3.props.testDriveCarCommonDescription, _this3.props.mbTestDriveCarCommonDescription),
                    hasTestDrive: _this3.props.shop.cta.hasTestDrive,
                    dealerId: _this3.props.shop.dealerId,
                    shopId: _this3.props.shop.shopId,
                    phoneNumber: _this3.getText(_this3.props.shop.contact.phoneNumber),
                    key: index2,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 862
                    }
                  });
                } else {
                  return null;
                }
              })
            );
          })
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__text-drive', __source: {
            fileName: _jsxFileName,
            lineNumber: 886
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__text-drive__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 887
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__text-drive__heading Wysiwyg', __source: {
                fileName: _jsxFileName,
                lineNumber: 888
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__text-drive__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.testDriveText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 889
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__text-drive__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.testDriveText, _this3.props.mbTestDriveText) }, __source: {
                fileName: _jsxFileName,
                lineNumber: 890
              }
            })
          )
        ),
        renderBodyTypes()
      );
    };

    // ADDRESS表示
    var renderAddress = function renderAddress() {

      // 住所表示
      var renderAddressInfo = function renderAddressInfo() {
        if (_this3.props.shop.address) {
          // 郵便番号
          var zip = _this3.getText(_this3.props.shop.address.zip);
          if (zip !== null) zip = '〒' + zip;
          // 都道府県
          var prefecture = _this3.getText(_this3.props.shop.address.prefecture);
          if (prefecture) prefecture = ' ' + prefecture;
          // 住所1
          var address1 = _this3.getText(_this3.props.shop.address.address1);
          // 住所1
          var address2 = _this3.getText(_this3.props.shop.address.address2);
          //
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 916
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dl',
              { className: 'DealerDetailContent__address__list-dl', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 917
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dt',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 918
                  }
                },
                '\u4F4F\u6240'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dd',
                {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 919
                  }
                },
                _this3.getText(zip),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 919
                  }
                }),
                (prefecture ? prefecture : '') + (address1 ? address1 : '') + (address2 ? address2 : '')
              )
            )
          );
        } else {
          return null;
        }
      };

      // TEL表示
      var renderTel = function renderTel() {
        if (_this3.props.shop.contact) {
          var phoneNumber = _this3.getText(_this3.props.shop.contact.phoneNumber);
          if (phoneNumber !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 934
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'DealerDetailContent__address__list-dl', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 935
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 936
                    }
                  },
                  'TEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dd',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 937
                    }
                  },
                  phoneNumber
                )
              )
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // FAX表示
      var renderFax = function renderFax() {
        if (_this3.props.shop.contact) {
          var faxNumber = _this3.getText(_this3.props.shop.contact.faxNumber);
          if (faxNumber !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 955
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'DealerDetailContent__address__list-dl', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 956
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 957
                    }
                  },
                  'FAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dd',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 958
                    }
                  },
                  faxNumber
                )
              )
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // 営業時間表示
      var renderOpenTime = function renderOpenTime() {
        if (_this3.props.shop.contact) {
          var openTime = _this3.getText(_this3.props.shop.contact.openTime);
          if (openTime !== null && openTime !== ' ' && openTime !== '　') {
            openTime = openTime.replace(/<br\/>/g, '|');
            openTime = openTime.replace(/<br \/>/g, '|');
            openTime = openTime.replace(/<br>/g, '|');
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 979
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'DealerDetailContent__address__list-dl', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 980
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 981
                    }
                  },
                  '\u55B6\u696D\u6642\u9593'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(openTime) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 982
                  }
                })
              )
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // 定休日表示
      var renderCloseTime = function renderCloseTime() {
        if (_this3.props.shop.contact) {
          var closeTime = _this3.getText(_this3.props.shop.contact.closeTime);
          if (closeTime !== null && closeTime !== ' ' && closeTime !== '　') {
            closeTime = closeTime.replace(/<br\/>/g, '|');
            closeTime = closeTime.replace(/<br \/>/g, '|');
            closeTime = closeTime.replace(/<br>/g, '|');
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1003
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'dl',
                { className: 'DealerDetailContent__address__list-dl', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1004
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'dt',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1005
                    }
                  },
                  '\u5B9A\u4F11\u65E5'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd', { className: 'Wysiwyg', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(closeTime) }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1006
                  }
                })
              )
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // Webサイトへのリンク表示
      var renderWebSiteLink = function renderWebSiteLink() {
        if (_this3.props.shop.contact) {
          var websiteUrl = _this3.getText(_this3.props.shop.contact.websiteUrl);
          if (websiteUrl !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__address__box2', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1024
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
                ctaType: 'Free',
                href: websiteUrl,
                text: '販売会社ホームページ',
                targetBlank: true,
                iconSrc: DealerDetailContent.iconBlank,
                color: 'Dark',
                buttonStyle: 'Action',
                linkType: 'Button-With-Icon'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1025
                }
              }))
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // QRコード表示
      var renderQrCode = function renderQrCode() {
        if (_this3.props.shop.contact) {
          var qrCodeUrl = _this3.getText(_this3.props.shop.contact.qrCodeUrl);
          if (qrCodeUrl !== null) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__address__box4', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1053
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'DealerDetailContent__address__link-open', href: 'javascript:void(0);', onClick: function onClick(e) {
                    e.preventDefault();
                    //
                    _this3.setState({
                      isOpenedQRModal: true
                    });
                  }, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1054
                  }
                },
                'QR\u30B3\u30FC\u30C9\u3092\u8868\u793A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__address__modal' + (_this3.state.isOpenedQRModal ? ' open' : ''), __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1061
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'DealerDetailContent__address__link-close', href: 'javascript:void(0);', onClick: function onClick(e) {
                      e.preventDefault();
                      //
                      _this3.setState({
                        isOpenedQRModal: false
                      });
                    }, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1062
                    }
                  },
                  'CLOSE'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__address__image-qr', src: qrCodeUrl, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1069
                  }
                })
              )
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // カレンダー表示
      var renderCalenders = function renderCalenders() {

        var renderCalender = function renderCalender(year, month, date) {

          // 日表示
          var renderDate = function renderDate(index, date2) {
            var cls = '';
            if (date2.today === true) {
              cls = 'today';
            } else if (date2.dataExist === false) {
              cls = 'blank';
            }
            if (_this3.serviceType.type === 'A') {
              // 新車販売・中古車・修理3つともあり
              if (date2.sales === true && date2.service === true) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1099
                    }
                  },
                  date2.day
                );
              } else if (date2.sales === true && date2.service === false) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1103
                    }
                  },
                  date2.day,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1103
                      }
                    },
                    _this3.getText(_this3.props.calendarMark1)
                  )
                );
              } else if (date2.sales === false && date2.service === true) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1107
                    }
                  },
                  date2.day,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1107
                      }
                    },
                    _this3.getText(_this3.props.calendarMark2)
                  )
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls + ' blank', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1111
                    }
                  },
                  date2.day
                );
              }
            } else if (_this3.serviceType.type === 'B') {
              // 新車販売・中古車ともになし
              if (date2.service === true) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1118
                    }
                  },
                  date2.day
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls + ' blank', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1122
                    }
                  },
                  date2.day
                );
              }
            } else if (_this3.serviceType.type === 'C') {
              // 修理なし
              if (date2.sales === true) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls, key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1129
                    }
                  },
                  date2.day
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: cls + ' blank', key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1133
                    }
                  },
                  date2.day
                );
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: cls, key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1138
                  }
                },
                date2.day
              );
            }
          };

          // 始めの週表示
          var renderFirstWeek = function renderFirstWeek() {
            var arr = ['', '', '', '', '', '', ''];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1147
                }
              },
              arr.map(function (item, index) {
                if (date[0].week <= index) {
                  count = count + 1;
                  var date2 = date[count - 1] || null;
                  if (date2) {
                    return renderDate(index, date2);
                  } else {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { key: index, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1156
                      }
                    });
                  }
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1161
                    }
                  });
                }
              })
            );
          };

          // 始め以外の週表示
          var renderWeek = function renderWeek() {
            if (date.length <= count) return null;
            var arr = ['', '', '', '', '', '', ''];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1174
                }
              },
              arr.map(function (item, index) {
                count = count + 1;
                var date2 = date[count - 1];
                if (date2) {
                  return renderDate(index, date2);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { key: index, __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1182
                    }
                  });
                }
              })
            );
          };

          var count = 0;

          var calenderCls = '';
          if (_this3.serviceType.type === 'A') {
            calenderCls = ' type-a';
          } else if (_this3.serviceType.type === 'B') {
            calenderCls = ' type-b';
          } else if (_this3.serviceType.type === 'C') {
            calenderCls = ' type-c';
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dl',
            { className: 'DealerDetailContent__address__list-dl2', __source: {
                fileName: _jsxFileName,
                lineNumber: 1202
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dt',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1203
                }
              },
              year + '.' + (month + 1)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'dd',
              {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1204
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'DealerDetailContent__address__calender' + calenderCls, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1205
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  {
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1206
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    {
                      __source: {
                        fileName: _jsxFileName,
                        lineNumber: 1207
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1208
                        }
                      },
                      'MON'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1209
                        }
                      },
                      'TUE'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1210
                        }
                      },
                      'WED'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1211
                        }
                      },
                      'THU'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1212
                        }
                      },
                      'FRI'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1213
                        }
                      },
                      'SAT'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 1214
                        }
                      },
                      'SUN'
                    )
                  ),
                  renderFirstWeek(),
                  renderWeek(),
                  renderWeek(),
                  renderWeek(),
                  renderWeek(),
                  renderWeek()
                )
              )
            )
          );
        };

        //if (this.calendersInfo && 1 <= this.calendersInfo.length) {
        if (_this3.getArray(_this3.calendersInfo)) {
          if (_this3.calendersInfo[0] && _this3.calendersInfo[1]) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__address__box3', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1233
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__address__box3-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1234
                  }
                },
                renderCalender(_this3.calendersInfo[0].year, _this3.calendersInfo[0].month, _this3.calendersInfo[0].date),
                renderDescription()
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__address__box3-right last', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1238
                  }
                },
                renderCalender(_this3.calendersInfo[1].year, _this3.calendersInfo[1].month, _this3.calendersInfo[1].date)
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__address__box3', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1245
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__address__box3-left last', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1246
                  }
                },
                renderCalender(_this3.calendersInfo[0].year, _this3.calendersInfo[0].month, _this3.calendersInfo[0].date)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__address__box3-right last', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1249
                }
              })
            );
          }
        } else {
          return null;
        }
      };

      // 注釈表示
      var renderDescription = function renderDescription() {
        //if (this.calendersInfo && 1 <= this.calendersInfo.length) {
        if (_this3.getArray(_this3.calendersInfo)) {
          if (_this3.serviceType.type === 'A') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'DealerDetailContent__address__description Wysiwyg', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1265
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__address__description-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.calendarDescription) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1266
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__address__description-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.calendarDescription, _this3.props.mbCalendarDescription) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1267
                }
              })
            );
          } else if (_this3.serviceType.type === 'B' || _this3.serviceType.type === 'C') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'DealerDetailContent__address__description Wysiwyg', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1272
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__address__description-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.defaultCalendarDescription) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1273
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__address__description-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.defaultCalendarDescription, _this3.props.mbDefaultCalendarDescription) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1274
                }
              })
            );
          }
        } else {
          return null;
        }
      };

      // マップ表示
      var renderMap = function renderMap() {
        // let apiKey = null;
        // if (0 <= String(location.hostname).indexOf('localhost')) {
        //   apiKey = 'AIzaSyBb0EsDARLM_4-pNHncpHquNN7_iMZM-xo';
        // } else {
        //   apiKey = 'AIzaSyBG0b5Aho-6eOQuY2XaMP0p0OzhK_Fxzb4';
        // }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__address__map', __source: {
              fileName: _jsxFileName,
              lineNumber: 1292
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'DealerDetailContent__address__link-rout', href: 'https://www.google.com/maps/dir/?api=1&destination=' + _this3.props.shop.address.latitude + ',' + _this3.props.shop.address.longitude, target: '_blank', __source: {
                fileName: _jsxFileName,
                lineNumber: 1293
              }
            },
            '\u30EB\u30FC\u30C8\u691C\u7D22'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components__["a" /* Map */]
          //apiKey={apiKey}
          , { center: {
              lat: Number(_this3.props.shop.address.latitude),
              lng: Number(_this3.props.shop.address.longitude)
            },
            style: {
              height: 350,
              width: '100%'
            },
            zoom: 15,
            coordinates: [{
              title: _this3.props.shop.dealerName + ' ' + _this3.props.shop.shopName,
              position: {
                lat: Number(_this3.props.shop.address.latitude),
                lng: Number(_this3.props.shop.address.longitude)
              },
              icon: __WEBPACK_IMPORTED_MODULE_11__icon_maker_png___default.a
            }],
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1294
            }
          })
        );
      };

      // マップ表示
      // const renderMap_ = ()=> {
      //   let src = '//www.google.com/maps/embed/v1/view?key=AIzaSyBb0EsDARLM_4-pNHncpHquNN7_iMZM-xo';
      //   src = src + '&center=' + this.props.shop.address.latitude + ',' + this.props.shop.address.longitude;
      //   src = src + '&zoom=15';
      //   return (
      //     <iframe className="DealerDetailContent__address__map" src={src}></iframe>
      //   )
      // };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__address', __source: {
            fileName: _jsxFileName,
            lineNumber: 1331
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__address__box', __source: {
              fileName: _jsxFileName,
              lineNumber: 1332
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__address__box-left', __source: {
                fileName: _jsxFileName,
                lineNumber: 1333
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__address__heading Wysiwyg', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1334
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__address__heading-pc', dangerouslySetInnerHTML: { __html: _this3.getText(_this3.props.addressText) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1335
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DealerDetailContent__address__heading-mb', dangerouslySetInnerHTML: { __html: _this3.getResponsiveText(_this3.props.addressText, _this3.props.mbAddressText) }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1336
                }
              })
            ),
            renderAddressInfo(),
            renderTel(),
            renderFax(),
            renderOpenTime(),
            renderCloseTime(),
            renderWebSiteLink(),
            renderQrCode()
          ),
          function () {
            // if (this.getArray(this.props.shop.calendars)) {
            if (_this3.getArray(_this3.calendersInfo)) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__address__box-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1350
                  }
                },
                renderCalenders(),
                renderDescription()
              );
            } else {
              return null;
            }
          }()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__address__box2', ref: 'map', __source: {
              fileName: _jsxFileName,
              lineNumber: 1360
            }
          },
          renderMap()
        )
      );
    };

    if (this.getIsActiveByDate(this.props.shop.startDate, this.props.shop.endDate) === true) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components_wrapper_index__["a" /* default */],
        {
          containerId: this.props.containerId,
          containerClass: this.props.containerClass,
          anchorPoint: this.props.anchorPoint,
          anchorName: this.props.anchorName,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 1369
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent', __source: {
              fileName: _jsxFileName,
              lineNumber: 1375
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 1376
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__container__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1377
                }
              },
              renderHeader()
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__container2', __source: {
                fileName: _jsxFileName,
                lineNumber: 1381
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__container2__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1382
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__container2__inner-left', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1383
                  }
                },
                renderShopIntroduction()
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__container2__inner-right', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1386
                  }
                },
                renderOnlineService(),
                renderShopService()
              )
            )
          ),
          function () {
            if (_this3.getArray(_this3.offers) || _this3.getArray(_this3.props.shop.dealerInfo.information)) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__container4', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1395
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DealerDetailContent__container4__inner', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 1396
                    }
                  },
                  renderInformation(),
                  renderEventCampaign()
                )
              );
            } else {
              return null;
            }
          }(),
          function () {
            if (_this3.getArray(_this3.props.shop.cars)) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'DealerDetailContent__container3', ref: 'testdrive', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 1409
                  }
                },
                renderTestDrive()
              );
            } else {
              return null;
            }
          }(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__container', __source: {
                fileName: _jsxFileName,
                lineNumber: 1417
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__container__inner', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1418
                }
              },
              renderAddress()
            )
          )
        )
      );
    } else {
      return null;
    }
  };

  // ボディタイプ情報取得


  // Cookie設定


  // Cookie取得


  // イベント&キャンペーン取得


  return DealerDetailContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.iconBlank = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAgMAAABj6rKSAAAADFBMVEUAAAD19fX19fX19fULZa1RAAAAA3RSTlMAiHfHTTICAAAATklEQVQoz2OgM2ANBYEAMJv/Pwh8wGRfBSoJh7IPAAlmdDZXA5QNFqU5+9WqVatWQ9gQd2KyEf4C6oQAItlA00EAKRT+Y7Ahpocy0B4AANNmVtHLQfM4AAAAAElFTkSuQmCC', _class.iconTestDrive = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAmVBMVEUAAAAZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRlb5GNTAAAAMnRSTlMAZu+R+wbi9ogjz8uTNaNMKwPq5t3An5ltae3Z1cS0VC8UDquod1nzuIl+Px0ar6dnX3E0cQYAAAGWSURBVDjL5dDXkptAEIXhJg1B5IxAAWVL2nTe/+Hcg1yUF0YON3thf1UaKPovpBb9N+IOSp47b10dOLfFvnKOtcbqo1PtV60NpLPa8mCeEppJPkwsps9rQKNkezs1R8dxDJ+PY32KtsljMurfw9VCx4qoxMyaEg/6oig/diTpGNwoADuLPF+wPBdnsIgiDJZBwDGwKEtzTbTiXaxPi7zkaC0qzLL0gKKQscNHF8g31DSxARq6dXxnIMtkHPKxpaSD3WgT7zqyHQ+J3uB5MjariC8RntDkN1QmfJ9vUt6ZV3VzKGX83t2Fr/c7yb1sbn/tBShIkn/mb3VAHA9xQ4fKfR661YF8PH4z4JIJM4zVaRzykE6AEEPMH2a+Br12NcKLJ2xbeJfQuGp98GoCSOkO9iM+YGBj4vFAbIjGWK4bXdcZFESo8Tqf48EeM3tiyrhPMZH2T2PaYGJDz2MKfIGR8ANSx6O4ObS23b41MTFFrPbF8R/5upiU1PFSHS/H+fKn+Js6Nsa5DAwdTDcsdWyNc+vv4n/ed1RHfTj44/2vAAAAAElFTkSuQmCC', _class.iconTestDriveHover = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMAZu2RBfviy/aIIzXPn0wr6t3Ao5ltaQLm2cS0k1Qv8tWrqIl3WRQPuH4/HRrvr6dnXwsc6YM2AAABmElEQVQ4y+XP6W6jMBSG4cNis0PYIZC12ZOu3/3f2xzoKJmCo07/9Ef7Shjk88jI9GuKfCjz3bF1H4FFnawyZ5NrXL5xstW0toHJSJs+xLakUeWrgDXczwGNyvlpW2wcxzEMXjb5NpyX75Nr+5d0ai0wJQowqqHSh24lweu+x4/oO5EHbiHj2OLiWC7AhRSiT/c8xoAVBKIhmvJdzA8XucSoTUpEEPhAknTY4WXpdSfkNGgGFHRa8tcDqqrDAS9zMpewC23Qi47qjYdEz/D9Doss5FeIO2ndHzIBw+CPCdC8Ebmx2lZ87v4AyPOZunvZe/qkC5BQF9DQpy2BKOpxQevMvQ/dbE0t0LY9dklApJGaRikPaQtI2WN+OPHk7bSjkR4sadvSOqTGUdt5TwLAhM7g/uI1+mwMet+QM1Y3TJfw2FRQJFONr/MR963GdkWcEu8mQzvZ3cU0G+IZ3cfktfImZeuREt+KinVt2/VzERGnwOq+Gf9X34dJmRrraqxf5/o/+EGNjeu8A4YOTjdMNTavc/Nr+Mf3B9f8fuEURnlBAAAAAElFTkSuQmCC', _class.iconMap = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAApVBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVjjqjoAAAANnRSTlMA8ZZaAof9w+d2Iwv1RS4or6JiNe/rzaqNUB8H+N7a0ce5tHFuZ14P8teKFr6cgnxXTD0aEmy25xbaAAABnElEQVQ4y+3U2XKCMBSA4QNGFBBkERFxF9S6b837P1o5hCNYHcx1p/+NjHxkSMgEahpup0ow09cgkd7heUH02Q44pTU+2YiXdbr1lk1wyGPXd1GH9dhHo+JTs+xiZNbiJWIrnyddYRZ7h5tIVo+J0hT5JHmzkickfRNg2MariDDnG/VluiuOfTUHueU2YUybR6yU3TMYvFrACBeN9TtkGZ6bDTaEfhWrYBJWLEfL1/7guWNx9wSritVsCGeNWGDcM0Hl5mbhAasM7YKRjdYmDGB6U/Fp57qfv+FVI9u7QTrKfksslr91jatLLToDwK7zCzdwJmVxn14CU+oxGL18rU0pDJFG21MCwwD3hyyOZweQxnAz5fEO4C6Nw51/lMat/bgpjzn/x38Na1vjDWa+Ph9xPr2wJ5xxx2JVzOzlQuFFk+X6gfWxOAO/TcQIE6dHsC2OKtUuMLDLPP9Lyd7QScP2A7qeAcZAPLgfZVjUVTeFIBimdAqb6ZSLgFonE4I9J7EZVCsOTihj1kLjymJJ8KlhMyBMGT7B12KvDz/Dw3X9+GrjcAAAAABJRU5ErkJggg==', _class.iconTel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAqFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fUjfWL/AAAAN3RSTlMA2vwaEgr18ZJoXPmHcE40H+vTz652SEEj3svBu6CBLgYC9+3ox7eppJxiVD0pDwPlzrCPe5qV2I+PWQAAAZVJREFUOMvdlNl2gjAQhgFlEZRFVOraqlXrUrv3e/83a0hqPVVMvPa/mSHnO5PJ8CfWrek+jwbd2nXsQx+hWbC/Bg5ReiyugHMYBT7ghEa2ByTW/sMRdM8EL2FYxkIUf3UNowBime0caOjhMdhTla5hqWVr0bFcCG0t3ITs0GgDFlq4Dc1DHsDKBPfTY97VwhvAVr54lgPXavJHN0WiRRXDk4juHCYmuAXsVIxMPr3zoCPiPoOxgXVz8FPVjXOnZ186QFhaJIJvA7tGbf4ygKxehdQ/3+yW7GEFLNzfkYRVJwo8hALLSgci5mW9GOico8nKQelj4wODkr0XWf+sid5Icl5go9Rxy70ysZSc9qrQx8+6VZP0TDo5tasaXiNkN8pikh4+S//0qbpOC2hvp4cr8h7LWMyp9MQY3k/Xug7VLo7BSf+tpCPE2qbyUXuVZjx+t/zyvLvLbowPH9OtnMjwki0fbPAKNcaGRL3W1LqkZAZO0Iu7y0j9E60ptxFHDQvTmzlHyXtKLKPqkzc/y79C17op/QBoj0D2+QpEYwAAAABJRU5ErkJggg==', _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorPoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  anchorName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null
}, _temp);
DealerDetailContent.displayName = 'DealerDetailContent';


/* harmony default export */ __webpack_exports__["a"] = (DealerDetailContent);

var Variant = (_temp2 = _class2 = function (_Component2) {
  _inherits(Variant, _Component2);

  function Variant(props) {
    _classCallCheck(this, Variant);

    var _this4 = _possibleConstructorReturn(this, _Component2.call(this));

    _this4.handleResize = function () {
      if (_this4.props.isOpened === false) {
        _this4.setState({ height: 0 });
      } else {
        _this4.setState({ height: 'auto' });
        // this.setState({height: this.refs.content.clientHeight});
      }
    };

    _this4.getText = function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (val && val !== '') {
        return val;
      } else {
        if (defaultVal && defaultVal !== '') {
          return defaultVal;
        } else {
          return null;
        }
      }
    };

    _this4.getResponsiveText = function (val, mbVal) {
      if (mbVal && mbVal !== '') {
        return mbVal;
      } else {
        if (val && val !== '') {
          return val;
        } else {
          return null;
        }
      }
    };

    _this4.props = props;
    //
    _this4.state = {
      height: 0
    };
    return _this4;
  }

  Variant.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  Variant.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props) && JSON.stringify(nextState) === JSON.stringify(this.state)) {
      return false;
    } else {
      return true;
    }
  };

  Variant.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  Variant.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    var _this5 = this;

    setTimeout(function () {
      _this5.handleResize();
    }, 100);
  };

  Variant.prototype.render = function render() {
    var _this6 = this;

    // グレード画像取得
    var getGradeImageSrc = function getGradeImageSrc(modelName, carId, carTypeCode, gradeId) {
      var code = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var str = '';
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/';
      } else {
        str = '/globalassets/assets/cars/';
      }

      str = str + modelName + '/';
      str = str + carId + '/';
      if (carTypeCode !== null) {
        str = str + carTypeCode + '/';
        str = str + gradeId + '/';
        if (code) {
          str = str + 'common/' + gradeId + '_' + code + '_s.png';
        } else {
          str = str + 'common/' + gradeId + '_default_s.png';
        }
        str = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["g" /* convertKataToRome */])(str);
        str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        return str;
      } else {
        str = str + 'common/default_s.png';
        str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        return str;
      }

      /*
      str = str + modelName + '/';
      str = str + carId + '/';
      str = str + carTypeCode + '/';
      str = str + gradeId + '/';
      if (code) {
        str = str + 'common/' + gradeId + '_' + code + '_s.png';
      } else {
        str = str + 'common/' + gradeId + '_default_s.png';
      }
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
      */
    };

    // メモ表示
    var renderMemo = function renderMemo(memo) {
      if (memo && memo !== '') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'DealerDetailContent__text-drive__variant__memo', __source: {
              fileName: _jsxFileName,
              lineNumber: 1895
            }
          },
          memo
        );
      } else {
        return null;
      }
    };

    // 共通詳細表示
    var renderDescription = function renderDescription() {
      if (_this6.props.description) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'DealerDetailContent__text-drive__variant__description Wysiwyg', __source: {
              fileName: _jsxFileName,
              lineNumber: 1906
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__text-drive__variant__description-pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(_this6.getText(_this6.props.description)) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1907
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'DealerDetailContent__text-drive__variant__description-mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* convertPipeToBrTag */])(_this6.getResponsiveText(_this6.props.description, _this6.props.mbDescription)) }, __source: {
              fileName: _jsxFileName,
              lineNumber: 1908
            }
          })
        );
      } else {
        return null;
      }
    };

    // CTAボタン表示
    var renderCta = function renderCta() {
      var trialCarId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var variantInfo = arguments[1];

      if (_this6.props.hasTestDrive === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__text-drive__variant__cta', __source: {
              fileName: _jsxFileName,
              lineNumber: 1920
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
            ctaType: 'Free',
            href: 'https://my.mazda.co.jp/purchase/testdrive/index.html?dealer_code=' + _this6.props.dealerId + '&shop_code=' + _this6.props.shopId + '&trial_car_id=' + trialCarId,
            // href: 'https://ssl.mazda.co.jp/purchase/testdrive/input?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId,
            text: '試乗申込',
            targetBlank: false,
            color: 'Light',
            iconSrc: DealerDetailContent.iconTestDrive,
            hoverIconSrc: DealerDetailContent.iconTestDriveHover,
            buttonStyle: 'Action',
            linkType: 'Button-With-Icon',
            handleClick: function handleClick(e) {
              e.preventDefault();

              // GTMイベント
              __WEBPACK_IMPORTED_MODULE_5__components_body__["a" /* default */].setGTMEvent({
                trialcar: variantInfo.carId,
                trialgrade: variantInfo.grade,
                trialvariant: variantInfo.drive + '(' + variantInfo.transmission + ')',
                trialcolor: variantInfo.trialCarColor,
                event: 'DealerDetailTrialCar'
              });

              location.href = 'https://my.mazda.co.jp/purchase/testdrive/index.html?dealer_code=' + _this6.props.dealerId + '&shop_code=' + _this6.props.shopId + '&trial_car_id=' + trialCarId;
              // location.href = 'https://ssl.mazda.co.jp/purchase/testdrive/input?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId;
            }
          }, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 1921
            }
          }))
        );
      } else {
        if (_this6.props.phoneNumber) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DealerDetailContent__text-drive__variant__cta', __source: {
                fileName: _jsxFileName,
                lineNumber: 1955
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__text-drive__variant__cta-pc', style: { pointerEvents: 'none', cursor: 'default' }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1956
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
                ctaType: 'Free',
                href: 'javascript:void(0);',
                // href: 'tel:' + this.getText(this.props.phoneNumber).replace(/-/g, ''),
                text: 'TEL ' + _this6.props.phoneNumber,
                targetBlank: false,
                color: 'Light',
                buttonStyle: 'Standard',
                linkType: 'Button'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1957
                }
              }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'DealerDetailContent__text-drive__variant__cta-mb', __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1970
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__blocks__["Cta"], _extends({
                ctaType: 'Free',
                href: 'tel:' + _this6.getText(_this6.props.phoneNumber).replace(/-/g, ''),
                text: '電話で試乗予約',
                targetBlank: false,
                color: 'Light',
                buttonStyle: 'Standard',
                iconSrc: DealerDetailContent.iconTel,
                linkType: 'Button-With-Icon'
              }, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 1971
                }
              }))
            )
          );
        } else {
          return null;
        }
      }
    };

    if (this.props.variantsInfo) {

      // 100th Anniversary Special Edition > 100周年特別記念車
      var convert100th = function convert100th(text) {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          text = text.replace('Monitor-', 'モニター専用車 ');
          return text;
        } else {
          return text;
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__text-drive__variant', __source: {
            fileName: _jsxFileName,
            lineNumber: 2022
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'DealerDetailContent__text-drive__variant__container' + (this.props.isOpened ? ' current' : ''), style: { height: this.state.height }, __source: {
              fileName: _jsxFileName,
              lineNumber: 2023
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'DealerDetailContent__text-drive__variant__list', ref: 'content', __source: {
                fileName: _jsxFileName,
                lineNumber: 2024
              }
            },
            this.props.variantsInfo.map(function (variant, index) {
              var src = null;
              if (variant.customImage) {
                src = __WEBPACK_IMPORTED_MODULE_8__image_custom_png___default.a;
              } else if (variant.settingExist === true || variant.settingExist === 'yes') {
                src = getGradeImageSrc(variant.modelName, variant.carId, variant.carTypeCode, variant.grade, variant.trialCarColorCode);
              } else {
                src = getGradeImageSrc(variant.modelName, variant.carId, null, null, null);
                // src = getGradeImageSrc(variant.modelName, variant.carId, variant.carTypeCode, variant.grade, null);
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: index, __source: {
                    fileName: _jsxFileName,
                    lineNumber: 2036
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DealerDetailContent__text-drive__variant__box', __source: {
                      fileName: _jsxFileName,
                      lineNumber: 2037
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DealerDetailContent__text-drive__variant__box-left', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2038
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'DealerDetailContent__text-drive__variant__image', src: src, alt: '', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2039
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DealerDetailContent__text-drive__variant__box-center', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2041
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { className: 'DealerDetailContent__text-drive__variant__text-grade', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2042
                        }
                      },
                      convert100th(variant.grade)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { className: 'DealerDetailContent__text-drive__variant__text-variant', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2043
                        }
                      },
                      variant.fuel,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2043
                        }
                      }),
                      variant.drive + '(' + variant.transmission + ')',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', {
                        __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2043
                        }
                      }),
                      variant.trialCarColor
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DealerDetailContent__text-drive__variant__box-right', __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2045
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'DealerDetailContent__text-drive__variant__box2', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 2046
                        }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'DealerDetailContent__text-drive__variant__box2-left', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 2047
                          }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'DealerDetailContent__text-drive__variant__text-variant', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 2048
                            }
                          },
                          variant.fuel + ' / ' + variant.drive + '(' + variant.transmission + ') / ' + variant.trialCarColor
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'DealerDetailContent__text-drive__variant__box2-right', __source: {
                            fileName: _jsxFileName,
                            lineNumber: 2050
                          }
                        },
                        renderCta(variant.trialCarId, variant)
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description, { description: variant.description, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 2054
                      }
                    }),
                    renderMemo(variant.memo),
                    renderDescription()
                  )
                )
              );
            })
          )
        )
      );
    } else {
      return null;
    }
  };

  return Variant;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  variantsInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  isOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mbDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hasTestDrive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dealerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shopId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  phoneNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class2.defaultProps = {
  variantsInfo: null,
  isOpened: null,
  description: null,
  mbDescription: null,
  hasTestDrive: null,
  dealerId: null,
  shopId: null,
  phoneNumber: null
}, _temp2);
Variant.displayName = 'Variant';
var Description = (_temp3 = _class3 = function (_Component3) {
  _inherits(Description, _Component3);

  function Description(props) {
    _classCallCheck(this, Description);

    var _this7 = _possibleConstructorReturn(this, _Component3.call(this));

    _this7.props = props;
    //
    _this7.description = null;
    if (_this7.props.description && _this7.props.description !== '') {
      var description = _this7.props.description.split('|');
      if (description && description instanceof Array && 1 <= description.length) {
        _this7.description = description;
      }
    }
    _this7.state = {
      isOpened: false
    };
    return _this7;
  }

  Description.prototype.render = function render() {
    var _this8 = this;

    if (this.description) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'DealerDetailContent__text-drive__variant__description', __source: {
            fileName: _jsxFileName,
            lineNumber: 2133
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'DealerDetailContent__text-drive__variant__link-description-open' + (this.state.isOpened ? ' open' : ''), href: 'javascript:void(0);', onClick: function onClick(e) {
              e.preventDefault();
              //
              _this8.setState({
                isOpened: !_this8.state.isOpened
              });
            }, __source: {
              fileName: _jsxFileName,
              lineNumber: 2134
            }
          },
          '\u30E1\u30FC\u30AB\u30FC\u30AA\u30D7\u30B7\u30E7\u30F3'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'DealerDetailContent__text-drive__variant__list-description' + (this.state.isOpened ? ' open' : ''), __source: {
              fileName: _jsxFileName,
              lineNumber: 2141
            }
          },
          this.description.map(function (option, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 2144
                }
              },
              option
            );
          })
        )
      );
    } else {
      return null;
    }
  };

  return Description;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class3.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class3.defaultProps = {
  description: null
}, _temp3);
Description.displayName = 'Description';

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DealerDetailContent":"DealerDetailContent","DealerDetailContent__container":"DealerDetailContent__container","DealerDetailContent__container__inner":"DealerDetailContent__container__inner","DealerDetailContent__container2":"DealerDetailContent__container2","DealerDetailContent__container2__inner":"DealerDetailContent__container2__inner","DealerDetailContent__container2__inner-left":"DealerDetailContent__container2__inner-left","DealerDetailContent__container2__inner-right":"DealerDetailContent__container2__inner-right","DealerDetailContent__container3":"DealerDetailContent__container3","DealerDetailContent__container4":"DealerDetailContent__container4","DealerDetailContent__container4__inner":"DealerDetailContent__container4__inner","DealerDetailContent__header":"DealerDetailContent__header","DealerDetailContent__header__box":"DealerDetailContent__header__box","DealerDetailContent__header__box-left":"DealerDetailContent__header__box-left","DealerDetailContent__header__box-right":"DealerDetailContent__header__box-right","DealerDetailContent__header__heading":"DealerDetailContent__header__heading","DealerDetailContent__header__list-dl":"DealerDetailContent__header__list-dl","DealerDetailContent__header__list-ul":"DealerDetailContent__header__list-ul","DealerDetailContent__shop-introduction":"DealerDetailContent__shop-introduction","DealerDetailContent__shop-introduction__heading":"DealerDetailContent__shop-introduction__heading","DealerDetailContent__shop-introduction__heading-pc":"DealerDetailContent__shop-introduction__heading-pc","DealerDetailContent__shop-introduction__heading-mb":"DealerDetailContent__shop-introduction__heading-mb","DealerDetailContent__shop-introduction__large-images":"DealerDetailContent__shop-introduction__large-images","DealerDetailContent__shop-introduction__large-images__box":"DealerDetailContent__shop-introduction__large-images__box","DealerDetailContent__shop-introduction__large-images__box2":"DealerDetailContent__shop-introduction__large-images__box2","DealerDetailContent__shop-introduction__large-images__image":"DealerDetailContent__shop-introduction__large-images__image","DealerDetailContent__shop-introduction__large-images__list-ul":"DealerDetailContent__shop-introduction__large-images__list-ul","DealerDetailContent__shop-introduction__large-images__link":"DealerDetailContent__shop-introduction__large-images__link","current":"current","DealerDetailContent__shop-introduction__large-image":"DealerDetailContent__shop-introduction__large-image","DealerDetailContent__shop-introduction__small-images":"DealerDetailContent__shop-introduction__small-images","DealerDetailContent__shop-introduction__description":"DealerDetailContent__shop-introduction__description","DealerDetailContent__online-service":"DealerDetailContent__online-service","DealerDetailContent__online-service__heading":"DealerDetailContent__online-service__heading","DealerDetailContent__online-service__heading-pc":"DealerDetailContent__online-service__heading-pc","DealerDetailContent__online-service__heading-mb":"DealerDetailContent__online-service__heading-mb","DealerDetailContent__online-service__list-ul":"DealerDetailContent__online-service__list-ul","DealerDetailContent__online-service__link":"DealerDetailContent__online-service__link","DealerDetailContent__online-service__icon":"DealerDetailContent__online-service__icon","DealerDetailContent__shop-service":"DealerDetailContent__shop-service","DealerDetailContent__shop-service__heading":"DealerDetailContent__shop-service__heading","DealerDetailContent__shop-service__heading-pc":"DealerDetailContent__shop-service__heading-pc","DealerDetailContent__shop-service__heading-mb":"DealerDetailContent__shop-service__heading-mb","DealerDetailContent__shop-service__box":"DealerDetailContent__shop-service__box","DealerDetailContent__shop-service__box-left":"DealerDetailContent__shop-service__box-left","DealerDetailContent__shop-service__box-right":"DealerDetailContent__shop-service__box-right","DealerDetailContent__shop-service__list-dl":"DealerDetailContent__shop-service__list-dl","active":"active","DealerDetailContent__information":"DealerDetailContent__information","DealerDetailContent__information__heading":"DealerDetailContent__information__heading","DealerDetailContent__information__heading-pc":"DealerDetailContent__information__heading-pc","DealerDetailContent__information__heading-mb":"DealerDetailContent__information__heading-mb","DealerDetailContent__information__list-ul":"DealerDetailContent__information__list-ul","DealerDetailContent__information__box":"DealerDetailContent__information__box","DealerDetailContent__information__list-dl":"DealerDetailContent__information__list-dl","DealerDetailContent__event-campaign":"DealerDetailContent__event-campaign","DealerDetailContent__event-campaign__heading":"DealerDetailContent__event-campaign__heading","DealerDetailContent__event-campaign__heading-pc":"DealerDetailContent__event-campaign__heading-pc","DealerDetailContent__event-campaign__heading-mb":"DealerDetailContent__event-campaign__heading-mb","DealerDetailContent__event-campaign__list-ul":"DealerDetailContent__event-campaign__list-ul","DealerDetailContent__event-campaign__box":"DealerDetailContent__event-campaign__box","DealerDetailContent__event-campaign__box-left":"DealerDetailContent__event-campaign__box-left","DealerDetailContent__event-campaign__box-center":"DealerDetailContent__event-campaign__box-center","DealerDetailContent__event-campaign__box-right":"DealerDetailContent__event-campaign__box-right","DealerDetailContent__event-campaign__list-dl":"DealerDetailContent__event-campaign__list-dl","Cta":"Cta","Cta__button":"Cta__button","DealerDetailContent__text-drive":"DealerDetailContent__text-drive","DealerDetailContent__text-drive__heading":"DealerDetailContent__text-drive__heading","DealerDetailContent__text-drive__heading-pc":"DealerDetailContent__text-drive__heading-pc","DealerDetailContent__text-drive__heading-mb":"DealerDetailContent__text-drive__heading-mb","DealerDetailContent__text-drive__body-type":"DealerDetailContent__text-drive__body-type","DealerDetailContent__text-drive__body-type__list":"DealerDetailContent__text-drive__body-type__list","DealerDetailContent__text-drive__body-type__link":"DealerDetailContent__text-drive__body-type__link","DealerDetailContent__text-drive__body-type__paragraph":"DealerDetailContent__text-drive__body-type__paragraph","DealerDetailContent__text-drive__body-type__image":"DealerDetailContent__text-drive__body-type__image","DealerDetailContent__text-drive__variant":"DealerDetailContent__text-drive__variant","DealerDetailContent__text-drive__variant__container":"DealerDetailContent__text-drive__variant__container","DealerDetailContent__text-drive__variant__list":"DealerDetailContent__text-drive__variant__list","DealerDetailContent__text-drive__variant__image":"DealerDetailContent__text-drive__variant__image","DealerDetailContent__text-drive__variant__box":"DealerDetailContent__text-drive__variant__box","DealerDetailContent__text-drive__variant__box-left":"DealerDetailContent__text-drive__variant__box-left","DealerDetailContent__text-drive__variant__box-center":"DealerDetailContent__text-drive__variant__box-center","DealerDetailContent__text-drive__variant__text-variant":"DealerDetailContent__text-drive__variant__text-variant","DealerDetailContent__text-drive__variant__box-right":"DealerDetailContent__text-drive__variant__box-right","DealerDetailContent__text-drive__variant__box2":"DealerDetailContent__text-drive__variant__box2","DealerDetailContent__text-drive__variant__box2-left":"DealerDetailContent__text-drive__variant__box2-left","DealerDetailContent__text-drive__variant__box2-right":"DealerDetailContent__text-drive__variant__box2-right","DealerDetailContent__text-drive__variant__text-grade":"DealerDetailContent__text-drive__variant__text-grade","DealerDetailContent__text-drive__variant__memo":"DealerDetailContent__text-drive__variant__memo","DealerDetailContent__text-drive__variant__description":"DealerDetailContent__text-drive__variant__description","DealerDetailContent__text-drive__variant__description-pc":"DealerDetailContent__text-drive__variant__description-pc","DealerDetailContent__text-drive__variant__description-mb":"DealerDetailContent__text-drive__variant__description-mb","DealerDetailContent__text-drive__variant__cta":"DealerDetailContent__text-drive__variant__cta","DealerDetailContent__text-drive__variant__cta-pc":"DealerDetailContent__text-drive__variant__cta-pc","DealerDetailContent__text-drive__variant__cta-mb":"DealerDetailContent__text-drive__variant__cta-mb","DealerDetailContent__text-drive__variant__link-description-open":"DealerDetailContent__text-drive__variant__link-description-open","open":"open","DealerDetailContent__text-drive__variant__list-description":"DealerDetailContent__text-drive__variant__list-description","DealerDetailContent__address":"DealerDetailContent__address","DealerDetailContent__address__heading":"DealerDetailContent__address__heading","DealerDetailContent__address__heading-pc":"DealerDetailContent__address__heading-pc","DealerDetailContent__address__heading-mb":"DealerDetailContent__address__heading-mb","DealerDetailContent__address__box":"DealerDetailContent__address__box","DealerDetailContent__address__box-left":"DealerDetailContent__address__box-left","DealerDetailContent__address__box-right":"DealerDetailContent__address__box-right","DealerDetailContent__address__list-dl":"DealerDetailContent__address__list-dl","DealerDetailContent__address__box2":"DealerDetailContent__address__box2","DealerDetailContent__address__box4":"DealerDetailContent__address__box4","DealerDetailContent__address__box3":"DealerDetailContent__address__box3","DealerDetailContent__address__box3-left":"DealerDetailContent__address__box3-left","DealerDetailContent__address__box3-right":"DealerDetailContent__address__box3-right","DealerDetailContent__address__description":"DealerDetailContent__address__description","DealerDetailContent__address__list-dl2":"DealerDetailContent__address__list-dl2","DealerDetailContent__address__calender":"DealerDetailContent__address__calender","type-a":"type-a","blank":"blank","today":"today","DealerDetailContent__address__description-pc":"DealerDetailContent__address__description-pc","DealerDetailContent__address__description-mb":"DealerDetailContent__address__description-mb","DealerDetailContent__address__link-open":"DealerDetailContent__address__link-open","DealerDetailContent__address__link-close":"DealerDetailContent__address__link-close","DealerDetailContent__address__modal":"DealerDetailContent__address__modal","DealerDetailContent__address__image-qr":"DealerDetailContent__address__image-qr","DealerDetailContent__address__map":"DealerDetailContent__address__map","DealerDetailContent__address__link-rout":"DealerDetailContent__address__link-rout","last":"last"};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e51024df66f99da5cdad440d61221e5.png";

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps_loader__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_map__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_google_map__);
var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\map\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Map = function (_Component) {
  _inherits(Map, _Component);

  function Map(props) {
    _classCallCheck(this, Map);

    return _possibleConstructorReturn(this, _Component.call(this, props));
  }

  Map.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps_loader__["a" /* default */], {
      params: {
        key: 'AIzaSyBmeZA4ivQs0VB_JfIyozmerRhNMnyz3Xw',
        region: 'JP'
      }
      // params={{
      //   client: 'gme-mazdamotorcorporation1',
      //   signature: 'QbXS0wAebJscLvYZZ688gKHTkkw='
      // }}
      // params={{
      //   key: this.props.apiKey,
      // }}
      , style: this.props.style,
      render: function render(googleMaps) {
        return googleMaps && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_map___default.a, {
          googleMaps: googleMaps,
          coordinates: _this2.props.coordinates,
          center: _this2.props.center,
          zoom: _this2.props.zoom,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        });
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    });
  };

  return Map;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Map.displayName = 'Map';


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loadGoogleMapsSdk__ = __webpack_require__(895);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var GoogleMapsLoader = function (_React$Component) {
  _inherits(GoogleMapsLoader, _React$Component);

  function GoogleMapsLoader() {
    _classCallCheck(this, GoogleMapsLoader);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      googleMaps: null,
      error: null
    };
    return _this;
  }

  GoogleMapsLoader.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var params = this.props.params;

    Object(__WEBPACK_IMPORTED_MODULE_2__loadGoogleMapsSdk__["a" /* default */])(params, function (_ref) {
      var googleMaps = _ref.googleMaps,
          error = _ref.error;
      return _this2.setState({ googleMaps: googleMaps, error: error });
    });
  };

  GoogleMapsLoader.prototype.render = function render() {
    var _state = this.state,
        googleMaps = _state.googleMaps,
        error = _state.error;
    var render = this.props.render;

    return render(googleMaps, error);
  };

  return GoogleMapsLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

GoogleMapsLoader.propTypes =  false ? {
  params: PropTypes.shape({
    key: PropTypes.string.isRequired,
    libraries: PropTypes.string
  }).isRequired,
  render: PropTypes.func.isRequired
} : {};

/* harmony default export */ __webpack_exports__["a"] = (GoogleMapsLoader);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_little_loader__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_little_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_little_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);



var GOOGLE_MAP_PLACES_API = "https://maps.googleapis.com/maps/api/js";
var NOT_LOADED = 0;
var LOADING = 1;
var LOADED = 2;

var queue = [];
var state = NOT_LOADED;
var googleMaps = null;
var error = null;

function loadGoogleMapsSdk(params, callback) {
  if (typeof window !== "undefined") {
    window.gm_authFailure = function () {
      callback({ googleMaps: googleMaps, error: "SDK Authentication Error" });
    };

    if (state === LOADED) {
      callback({ googleMaps: googleMaps, error: error });
    } else if (state === LOADING) {
      queue.push(callback);
    } else {
      if (!window.google) {
        window.google = undefined;
      }

      state = LOADING;
      queue.push(callback);

      __WEBPACK_IMPORTED_MODULE_0_little_loader___default()(GOOGLE_MAP_PLACES_API + "?" + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(params), function (err) {
        state = LOADED;
        error = err ? "Network Error" : null;
        googleMaps = window.google ? window.google.maps : null;

        while (queue.length > 0) {
          queue.pop()({ googleMaps: googleMaps, error: error });
        }
      });
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (loadGoogleMapsSdk);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Script loading is difficult thanks to IE. We need callbacks to fire
 * immediately following the script's execution, with no other scripts
 * running in between. If other scripts on the page are able to run
 * between our script and its callback, bad things can happen, such as
 * `jQuery.noConflict` not being called in time, resulting in plugins
 * latching onto our version of jQuery, etc.
 *
 * For IE<10 we use a relatively well-documented "preloading" strategy,
 * which ensures that the script is ready to execute *before* appending
 * it to the DOM. That way when it is finally appended, it is
 * executed immediately.
 *
 * References:
 * - http://www.html5rocks.com/en/tutorials/speed/script-loading/
 * - http://blog.getify.com/ie11-please-bring-real-script-preloading-back/
 * - https://github.com/jrburke/requirejs/issues/526
 * - https://connect.microsoft.com/IE/feedback/details/729164/
 *           ie10-dynamic-script-element-fires-loaded-readystate-prematurely
 */
(function () {

  // Global state.
  var pendingScripts = {};
  var scriptCounter = 0;

  /**
   * Insert script into the DOM
   *
   * @param {Object} script Script DOM object
   * @returns {void}
   */
  var _addScript = function (script) {
    // Get the first script element, we're just going to use it
    // as a reference for where to insert ours. Do NOT try to do
    // this just once at the top and then re-use the same script
    // as a reference later. Some weird loaders *remove* script
    // elements after the browser has executed their contents,
    // so the same reference might not have a parentNode later.
    var firstScript = document.getElementsByTagName("script")[0];

    // Append the script to the DOM, triggering execution.
    firstScript.parentNode.insertBefore(script, firstScript);
  };

  /**
   * Load Script.
   *
   * @param {String}    src       URI of script
   * @param {Function}  callback  (Optional) Called on script load completion
   * @param {Object}    context   (Optional) Callback context (`this`)
   * @returns {void}
   */
  var _lload = function (src, callback, context) {
    /*eslint max-statements: [2, 25]*/
    var script = document.createElement("script");
    var done = false;
    var err;
    var _cleanup; // _must_ be set below.

    /**
     * Final handler for error or completion.
     *
     * **Note**: Will only be called _once_.
     *
     * @returns {void}
     */
    var _finish = function () {
      // Only call once.
      if (done) { return; }
      done = true;

      // Internal cleanup.
      _cleanup();

      // Callback.
      if (callback) {
        callback.call(context, err);
      }
    };

    /**
     * Error handler
     *
     * @returns {void}
     */
    var _error = function () {
      err = new Error(src || "EMPTY");
      _finish();
    };

    if (script.readyState && !("async" in script)) {
      /*eslint-disable consistent-return*/

      // This section is only for IE<10. Some other old browsers may
      // satisfy the above condition and enter this branch, but we don't
      // support those browsers anyway.

      var id = scriptCounter++;
      var isReady = { loaded: true, complete: true };
      var inserted = false;

      // Clear out listeners, state.
      _cleanup = function () {
        script.onreadystatechange = script.onerror = null;
        pendingScripts[id] = void 0;
      };

      // Attach the handler before setting src, otherwise we might
      // miss events (consider that IE could fire them synchronously
      // upon setting src, for example).
      script.onreadystatechange = function () {
        var firstState = script.readyState;

        // Protect against any errors from state change randomness.
        if (err) { return; }

        if (!inserted && isReady[firstState]) {
          inserted = true;

          // Append to DOM.
          _addScript(script);
        }

        // --------------------------------------------------------------------
        //                       GLORIOUS IE8 HACKAGE!!!
        // --------------------------------------------------------------------
        //
        // Oh IE8, how you disappoint. IE8 won't call `script.onerror`, so
        // we have to resort to drastic measures.
        // See, e.g. http://www.quirksmode.org/dom/events/error.html#t02
        //
        // As with all things development, there's a Stack Overflow comment that
        // asserts the following combinations of state changes in IE8 indicate a
        // script load error. And crazily, it seems to work!
        //
        // http://stackoverflow.com/a/18840568/741892
        //
        // The `script.readyState` transitions we're interested are:
        //
        // * If state starts as `loaded`
        // * Call `script.children`, which _should_ change state to `complete`
        // * If state is now `loading`, then **we have a load error**
        //
        // For the reader's amusement, here is HeadJS's catalog of various
        // `readyState` transitions in normal operation for IE:
        // https://github.com/headjs/headjs/blob/master/src/2.0.0/load.js#L379-L419
        if (firstState === "loaded") {
          // The act of accessing the property should change the script's
          // `readyState`.
          //
          // And, oh yeah, this hack is so hacky-ish we need the following
          // eslint disable...
          /*eslint-disable no-unused-expressions*/
          script.children;
          /*eslint-enable no-unused-expressions*/

          if (script.readyState === "loading") {
            // State transitions indicate we've hit the load error.
            //
            // **Note**: We are not intending to _return_ a value, just have
            // a shorter short-circuit code path here.
            return _error();
          }
        }

        // It's possible for readyState to be "complete" immediately
        // after we insert (and execute) the script in the branch
        // above. So check readyState again here and react without
        // waiting for another onreadystatechange.
        if (script.readyState === "complete") {
          _finish();
        }
      };

      // Onerror handler _may_ work here.
      script.onerror = _error;

      // Since we're not appending the script to the DOM yet, the
      // reference to our script element might get garbage collected
      // when this function ends, without onreadystatechange ever being
      // fired. This has been witnessed to happen. Adding it to
      // `pendingScripts` ensures this can't happen.
      pendingScripts[id] = script;

      // This triggers a request for the script, but its contents won't
      // be executed until we append it to the DOM.
      script.src = src;

      // In some cases, the readyState is already "loaded" immediately
      // after setting src. It's a lie! Don't append to the DOM until
      // the onreadystatechange event says so.

    } else {
      // This section is for modern browsers, including IE10+.

      // Clear out listeners.
      _cleanup = function () {
        script.onload = script.onerror = null;
      };

      script.onerror = _error;
      script.onload = _finish;
      script.async = true;
      script.charset = "utf-8";
      script.src = src;

      // Append to DOM.
      _addScript(script);
    }
  };

  // UMD wrapper.
  /*global define:false*/
  if (true) {
    // CommonJS
    module.exports = _lload;

  } else if (typeof define === "function" && define.amd) {
    // AMD
    define([], function () { return _lload; });

  } else {
    // VanillaJS
    window._lload = _lload;
  }
}());


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-google-map"]=t(require("react")):e["react-google-map"]=t(e.React)}(this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function i(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},f=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(10),p=r(l),d=n(11),y=r(d),v={position:"relative",overflow:"hidden",height:"100%",width:"100%"},h=function(e){function t(){a(this,t);var e=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.state={map:null,markers:new Map},e}return s(t,e),f(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props,n=t.coordinates,r=t.googleMaps,o=t.onLoaded,a=i(t,["coordinates","googleMaps","onLoaded"]),u=new r.Map(this.ref_map,c({},a));this.setState({map:u},function(){e.addNewMarkers(n)}),o&&o(r,u)}},{key:"componentWillReceiveProps",value:function(e){var t=this,n=e.coordinates.some(function(e){return!t.state.markers.has(t.getMarkerId(e))}),r=[].concat(o(this.state.markers.keys())).some(function(n){return!e.coordinates.some(function(e){return n===t.getMarkerId(e)})});r&&this.removeOldMarkers(e.coordinates),n&&this.addNewMarkers(e.coordinates)}},{key:"shouldComponentUpdate",value:function(e,t){return JSON.stringify(this.props.coordinates)!==JSON.stringify(e.coordinates)}},{key:"getMarkerId",value:function(e){return e.position.lat+"_"+e.position.lng}},{key:"removeOldMarkers",value:function(e){var t=this,n=this.state.markers,r=this.props.autoFitBounds;n.forEach(function(r,o){var i=e.some(function(e){return t.getMarkerId(e)===o});i||(r.setMap(null),n.delete(o))}),this.setState({markers:n}),r&&this.fitBounds()}},{key:"addNewMarkers",value:function(e){var t=this,n=this.state.markers,r=this.props.autoFitBounds;e.forEach(function(e){var r=t.getMarkerId(e);n.has(r)||n.set(r,t.addMarker(r,e))}),this.setState({markers:n}),r&&this.fitBounds()}},{key:"addMarker",value:function(e,t){var n=this.state.map,r=this.props.googleMaps,o=t.onLoaded,a=i(t,["onLoaded"]),u=new r.Marker(c({map:n},a));return o&&o(r,n,u),u}},{key:"fitBounds",value:function(){var e=this.state,t=e.map,n=e.markers,r=this.props,o=r.boundsOffset,i=r.googleMaps;if(t&&0!==n.size){var a=Array.from(n.values()).reduce(function(e,t){return e.extend(t.getPosition())},new i.LatLngBounds),u=a.getCenter();a.extend(new i.LatLng(u.lat()+o,u.lng()+o)).extend(new i.LatLng(u.lat()-o,u.lng()-o)),t.setCenter(u),t.fitBounds(a)}}},{key:"render",value:function(){var e=this;return y.default.createElement("div",{ref:function(t){return e.ref_map=t},style:v})}}]),t}(y.default.Component);h.propTypes={autoFitBounds:p.default.bool,boundsOffset:p.default.number,coordinates:p.default.arrayOf(p.default.shape({onLoaded:p.default.func})),googleMaps:p.default.object.isRequired,onLoaded:p.default.func},h.defaultProps={autoFitBounds:!1,boundsOffset:.002,coordinates:[],onLoaded:null},t.default=h},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function i(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function a(){v&&d&&(v=!1,d.length?y=d.concat(y):h=-1,y.length&&u())}function u(){if(!v){var e=o(a);v=!0;for(var t=y.length;t;){for(d=y,y=[];++h<t;)d&&d[h].run();h=-1,t=y.length}d=null,v=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function c(){}var f,l,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var d,y=[],v=!1,h=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];y.push(new s(e,t)),1!==y.length||v||o(u)},s.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,s){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[n,o,i,a,u,s],l=0;c=new Error(t.replace(/%s/g,function(){return f[l++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(2),o=r;if("production"!==t.env.NODE_ENV){var i=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];i.apply(void 0,[t].concat(r))}}}e.exports=o}).call(t,n(1))},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,u,s=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var f in r)i.call(r,f)&&(s[f]=r[f]);if(o){u=o(r);for(var l=0;l<u.length;l++)a.call(r,u[l])&&(s[u[l]]=r[u[l]])}}return s}},function(e,t,n){(function(t){"use strict";function r(e,n,r,s,c){if("production"!==t.env.NODE_ENV)for(var f in e)if(e.hasOwnProperty(f)){var l;try{o("function"==typeof e[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",s||"React class",r,f,typeof e[f]),l=e[f](n,f,s,r,null,a)}catch(e){l=e}if(i(!l||l instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",s||"React class",r,f,typeof l),l instanceof Error&&!(l.message in u)){u[l.message]=!0;var p=c?c():"";i(!1,"Failed %s type: %s%s",r,l.message,null!=p?p:"")}}}if("production"!==t.env.NODE_ENV)var o=n(3),i=n(5),a=n(4),u={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(2),o=n(3),i=n(4);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){(function(t){"use strict";var r=n(2),o=n(3),i=n(5),a=n(6),u=n(4),s=n(7);e.exports=function(e,n){function c(e){var t=e&&(R&&e[R]||e[S]);if("function"==typeof t)return t}function f(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function l(e){this.message=e,this.stack=""}function p(e){function r(r,c,f,p,d,y,v){if(p=p||M,y=y||f,v!==u)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var h=p+":"+f;!a[h]&&s<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",y,p),a[h]=!0,s++)}return null==c[f]?r?new l(null===c[f]?"The "+d+" `"+y+"` is marked as required "+("in `"+p+"`, but its value is `null`."):"The "+d+" `"+y+"` is marked as required in "+("`"+p+"`, but its value is `undefined`.")):null:e(c,f,p,d,y)}if("production"!==t.env.NODE_ENV)var a={},s=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,o,i,a){var u=t[n],s=E(u);if(s!==e){var c=N(u);return new l("Invalid "+o+" `"+i+"` of type "+("`"+c+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return p(t)}function y(){return p(r.thatReturnsNull)}function v(e){function t(t,n,r,o,i){if("function"!=typeof e)return new l("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var a=t[n];if(!Array.isArray(a)){var s=E(a);return new l("Invalid "+o+" `"+i+"` of type "+("`"+s+"` supplied to `"+r+"`, expected an array."))}for(var c=0;c<a.length;c++){var f=e(a,c,r,o,i+"["+c+"]",u);if(f instanceof Error)return f}return null}return p(t)}function h(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=E(a);return new l("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return p(t)}function m(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||M,u=_(t[n]);return new l("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return p(t)}function g(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(f(a,e[u]))return null;var s=JSON.stringify(e);return new l("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+s+"."))}return Array.isArray(e)?p(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function b(e){function t(t,n,r,o,i){if("function"!=typeof e)return new l("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var a=t[n],s=E(a);if("object"!==s)return new l("Invalid "+o+" `"+i+"` of type "+("`"+s+"` supplied to `"+r+"`, expected an object."));for(var c in a)if(a.hasOwnProperty(c)){var f=e(a,c,r,o,i+"."+c,u);if(f instanceof Error)return f}return null}return p(t)}function O(e){function n(t,n,r,o,i){for(var a=0;a<e.length;a++){var s=e[a];if(null==s(t,n,r,o,i,u))return null}return new l("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var a=e[o];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",P(a),o),r.thatReturnsNull}return p(n)}function w(){function e(e,t,n,r,o){return j(e[t])?null:new l("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return p(e)}function k(e){function t(t,n,r,o,i){var a=t[n],s=E(a);if("object"!==s)return new l("Invalid "+o+" `"+i+"` of type `"+s+"` "+("supplied to `"+r+"`, expected `object`."));for(var c in e){var f=e[c];if(f){var p=f(a,c,r,o,i+"."+c,u);if(p)return p}}return null}return p(t)}function T(e){function t(t,n,r,o,i){var s=t[n],c=E(s);if("object"!==c)return new l("Invalid "+o+" `"+i+"` of type `"+c+"` "+("supplied to `"+r+"`, expected `object`."));var f=a({},t[n],e);for(var p in f){var d=e[p];if(!d)return new l("Invalid "+o+" `"+i+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var y=d(s,p,r,o,i+"."+p,u);if(y)return y}return null}return p(t)}function j(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(j);if(null===t||e(t))return!0;var n=c(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!j(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!j(i[1]))return!1}return!0;default:return!1}}function x(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function E(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":x(t,e)?"symbol":t}function N(e){if("undefined"==typeof e||null===e)return""+e;var t=E(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function P(e){var t=N(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:M}var R="function"==typeof Symbol&&Symbol.iterator,S="@@iterator",M="<<anonymous>>",I={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:y(),arrayOf:v,element:h(),instanceOf:m,node:w(),objectOf:b,oneOf:g,oneOfType:O,shape:k,exact:T};return l.prototype=Error.prototype,I.checkPropTypes=s,I.PropTypes=I,I}}).call(t,n(1))},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(9)(o,i)}else e.exports=n(8)()}).call(t,n(1))},function(t,n){t.exports=e}])});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb9007ad6bad74c434eeaff019a5ba12.png";

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wrapper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\sitemap\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 *  Sitemap
 */
var Sitemap = (_temp = _class = function (_Component) {
  _inherits(Sitemap, _Component);

  function Sitemap(props) {
    _classCallCheck(this, Sitemap);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.props = props;
    return _this;
  }

  Sitemap.prototype.componentDidMount = function componentDidMount() {};

  Sitemap.prototype.render = function render() {
    var _props = this.props,
        containerId = _props.containerId,
        containerClass = _props.containerClass,
        anchorPoint = _props.anchorPoint,
        anchorName = _props.anchorName,
        links = _props.links;

    //

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__components_wrapper__["a" /* default */],
      {
        containerId: containerId,
        containerClass: containerClass,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Sitemap', __source: {
            fileName: _jsxFileName,
            lineNumber: 54
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'Sitemap__container', __source: {
              fileName: _jsxFileName,
              lineNumber: 55
            }
          },
          function () {
            if (links && Array.isArray(links) && links.length > 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'Sitemap__container__list-lv2', __source: {
                    fileName: _jsxFileName,
                    lineNumber: 59
                  }
                },
                links.map(function (link_lv2, index_lv2) {
                  var href = link_lv2.href && link_lv2.href !== '' ? link_lv2.href : null;
                  var target = link_lv2.external != null && link_lv2.external === true ? '_blank' : null;
                  var pcText = link_lv2.pcText && link_lv2.pcText !== '' ? link_lv2.pcText : link_lv2.pageName && link_lv2.pageName !== '' ? link_lv2.pageName : null;
                  var mbText = link_lv2.mbText && link_lv2.mbText !== '' ? link_lv2.mbText : link_lv2.pcText && link_lv2.pcText !== '' ? link_lv2.pcText : link_lv2.pageName && link_lv2.pageName !== '' ? link_lv2.pageName : null;
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { className: 'Sitemap__container__list-lv2__item', key: index_lv2, __source: {
                        fileName: _jsxFileName,
                        lineNumber: 66
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { href: href, target: target, className: 'Sitemap__container__list-lv2__item__link', __source: {
                          fileName: _jsxFileName,
                          lineNumber: 67
                        }
                      },
                      pcText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv2__item__link__text--pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(pcText) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 68
                        }
                      }) : null,
                      mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv2__item__link__text--mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                          fileName: _jsxFileName,
                          lineNumber: 69
                        }
                      }) : null
                    ),
                    function () {
                      if (link_lv2.links && Array.isArray(link_lv2.links) && link_lv2.links.length > 0) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'ul',
                          { className: 'Sitemap__container__list-lv3', __source: {
                              fileName: _jsxFileName,
                              lineNumber: 74
                            }
                          },
                          link_lv2.links.map(function (link_lv3, index_lv3) {
                            var href = link_lv3.href && link_lv3.href !== '' ? link_lv3.href : null;
                            var target = link_lv3.external != null && link_lv3.external === true ? '_blank' : null;
                            var pcText = link_lv3.pcText && link_lv3.pcText !== '' ? link_lv3.pcText : link_lv3.pageName && link_lv3.pageName !== '' ? link_lv3.pageName : null;
                            var mbText = link_lv3.mbText && link_lv3.mbText !== '' ? link_lv3.mbText : link_lv3.pcText && link_lv3.pcText !== '' ? link_lv3.pcText : link_lv3.pageName && link_lv3.pageName !== '' ? link_lv3.pageName : null;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'li',
                              { className: 'Sitemap__container__list-lv3__item', key: index_lv3, __source: {
                                  fileName: _jsxFileName,
                                  lineNumber: 81
                                }
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                { href: href, target: target, className: 'Sitemap__container__list-lv3__item__link', __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 82
                                  }
                                },
                                pcText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv3__item__link__text--pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(pcText) }, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 83
                                  }
                                }) : null,
                                mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv3__item__link__text--mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                                    fileName: _jsxFileName,
                                    lineNumber: 84
                                  }
                                }) : null
                              ),
                              function () {
                                if (link_lv3.links && Array.isArray(link_lv3.links) && link_lv3.links.length > 0) {
                                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'ul',
                                    { className: 'Sitemap__container__list-lv4', __source: {
                                        fileName: _jsxFileName,
                                        lineNumber: 89
                                      }
                                    },
                                    link_lv3.links.map(function (link_lv4, index_lv4) {
                                      var href = link_lv4.href && link_lv4.href !== '' ? link_lv4.href : null;
                                      var target = link_lv4.external != null && link_lv4.external === true ? '_blank' : null;
                                      var pcText = link_lv4.pcText && link_lv4.pcText !== '' ? link_lv4.pcText : link_lv4.pageName && link_lv4.pageName !== '' ? link_lv4.pageName : null;
                                      var mbText = link_lv4.mbText && link_lv4.mbText !== '' ? link_lv4.mbText : link_lv4.pcText && link_lv4.pcText !== '' ? link_lv4.pcText : link_lv4.pageName && link_lv4.pageName !== '' ? link_lv4.pageName : null;
                                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'li',
                                        { className: 'Sitemap__container__list-lv4__item', key: index_lv4, __source: {
                                            fileName: _jsxFileName,
                                            lineNumber: 96
                                          }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'a',
                                          { href: href, target: target, className: 'Sitemap__container__list-lv4__item__link', __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 97
                                            }
                                          },
                                          pcText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv4__item__link__text--pc', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(pcText) }, __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 98
                                            }
                                          }) : null,
                                          mbText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'Sitemap__container__list-lv4__item__link__text--mb', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* convertPipeToBrTag */])(mbText) }, __source: {
                                              fileName: _jsxFileName,
                                              lineNumber: 99
                                            }
                                          }) : null
                                        )
                                      );
                                    })
                                  );
                                }
                              }()
                            );
                          })
                        );
                      }
                    }()
                  );
                })
              );
            }
          }()
        )
      )
    );
  };

  return Sitemap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  containerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pcText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    mbText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
}, _class.defaultProps = {
  containerId: null,
  containerClass: null,
  links: null
}, _temp);
Sitemap.displayName = 'Sitemap';


/* harmony default export */ __webpack_exports__["a"] = (Sitemap);

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Sitemap":"Sitemap","Sitemap__container":"Sitemap__container","Sitemap__container__list-lv2":"Sitemap__container__list-lv2","Sitemap__container__list-lv2__item":"Sitemap__container__list-lv2__item","Sitemap__container__list-lv2__item__link":"Sitemap__container__list-lv2__item__link","Sitemap__container__list-lv2__item__link__text--pc":"Sitemap__container__list-lv2__item__link__text--pc","Sitemap__container__list-lv2__item__link__text--mb":"Sitemap__container__list-lv2__item__link__text--mb","Sitemap__container__list-lv3":"Sitemap__container__list-lv3","Sitemap__container__list-lv3__item":"Sitemap__container__list-lv3__item","Sitemap__container__list-lv3__item__link":"Sitemap__container__list-lv3__item__link","Sitemap__container__list-lv3__item__link__text--pc":"Sitemap__container__list-lv3__item__link__text--pc","Sitemap__container__list-lv3__item__link__text--mb":"Sitemap__container__list-lv3__item__link__text--mb","Sitemap__container__list-lv4":"Sitemap__container__list-lv4","Sitemap__container__list-lv4__item":"Sitemap__container__list-lv4__item","Sitemap__container__list-lv4__item__link":"Sitemap__container__list-lv4__item__link","Sitemap__container__list-lv4__item__link__text--pc":"Sitemap__container__list-lv4__item__link__text--pc","Sitemap__container__list-lv4__item__link__text--mb":"Sitemap__container__list-lv4__item__link__text--mb"};

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EstimationHistory":"EstimationHistory","EstimationHistory__container":"EstimationHistory__container","EstimationHistory__container__estType":"EstimationHistory__container__estType","EstimationHistory__container__estType__list":"EstimationHistory__container__estType__list","EstimationHistory__container__estType__list__item":"EstimationHistory__container__estType__list__item","EstimationHistory__container__estType__list__item__label":"EstimationHistory__container__estType__list__item__label","disabled":"disabled","EstimationHistory__container__estType__list__item__label__radio":"EstimationHistory__container__estType__list__item__label__radio","EstimationHistory__container__estType__list__item__label__text":"EstimationHistory__container__estType__list__item__label__text","EstimationHistory__container__ests":"EstimationHistory__container__ests","fadein":"fadein","EstimationHistory__container__ests__slider":"EstimationHistory__container__ests__slider","show":"show","Slide":"Slide","slick-slider":"slick-slider","slick-prev":"slick-prev","slick-next":"slick-next","slick-dots":"slick-dots","EstimationHistory__container__ests__slider__item":"EstimationHistory__container__ests__slider__item","EstimationHistory__container__ests__slider__item__name":"EstimationHistory__container__ests__slider__item__name","EstimationHistory__container__ests__slider__item__title":"EstimationHistory__container__ests__slider__item__title","EstimationHistory__container__ests__slider__item__title__gradeId":"EstimationHistory__container__ests__slider__item__title__gradeId","EstimationHistory__container__ests__slider__item__title__fuel":"EstimationHistory__container__ests__slider__item__title__fuel","EstimationHistory__container__ests__slider__item__title__drive":"EstimationHistory__container__ests__slider__item__title__drive","EstimationHistory__container__ests__slider__item__title__mission":"EstimationHistory__container__ests__slider__item__title__mission","EstimationHistory__container__ests__slider__item__image":"EstimationHistory__container__ests__slider__item__image","EstimationHistory__container__ests__slider__item__image__img":"EstimationHistory__container__ests__slider__item__image__img","EstimationHistory__container__no-ests":"EstimationHistory__container__no-ests","EstimationHistory__container__no-ests__content":"EstimationHistory__container__no-ests__content","EstimationHistory__container__no-ests__content__image":"EstimationHistory__container__no-ests__content__image","EstimationHistory__container__no-ests__content__image__img":"EstimationHistory__container__no-ests__content__image__img","EstimationHistory__container__no-ests__content__recommendText":"EstimationHistory__container__no-ests__content__recommendText","EstimationHistory__container__no-ests__content__recommendText--pc":"EstimationHistory__container__no-ests__content__recommendText--pc","EstimationHistory__container__no-ests__content__recommendText--mb":"EstimationHistory__container__no-ests__content__recommendText--mb","EstimationHistory__container__no-ests__content__button":"EstimationHistory__container__no-ests__content__button","Cta__button":"Cta__button","EstimationHistory__container__detail":"EstimationHistory__container__detail","EstimationHistory__container__detail__prices":"EstimationHistory__container__detail__prices","EstimationHistory__container__detail__prices__title":"EstimationHistory__container__detail__prices__title","EstimationHistory__container__detail__prices__list":"EstimationHistory__container__detail__prices__list","EstimationHistory__container__detail__prices__list__title":"EstimationHistory__container__detail__prices__list__title","header":"header","text":"text","footer":"footer","EstimationHistory__container__detail__prices__list__data":"EstimationHistory__container__detail__prices__list__data","tax":"tax","EstimationHistory__container__detail__prices__total-expenses-remarks":"EstimationHistory__container__detail__prices__total-expenses-remarks","EstimationHistory__container__detail__prices__button":"EstimationHistory__container__detail__prices__button","EstimationHistory__container__detail__colors":"EstimationHistory__container__detail__colors","EstimationHistory__container__detail__colors__list":"EstimationHistory__container__detail__colors__list","EstimationHistory__container__detail__colors__list__group":"EstimationHistory__container__detail__colors__list__group","body-color":"body-color","seat-color":"seat-color","EstimationHistory__container__detail__colors__list__title":"EstimationHistory__container__detail__colors__list__title","EstimationHistory__container__detail__colors__list__data":"EstimationHistory__container__detail__colors__list__data","colortip":"colortip","EstimationHistory__container__detail__options":"EstimationHistory__container__detail__options","EstimationHistory__container__detail__options__list":"EstimationHistory__container__detail__options__list","EstimationHistory__container__detail__options__list__title":"EstimationHistory__container__detail__options__list__title","EstimationHistory__container__detail__options__list__data":"EstimationHistory__container__detail__options__list__data","EstimationHistory__container__detail__options__list__data__moption":"EstimationHistory__container__detail__options__list__data__moption","hasInfo":"hasInfo","mouse":"mouse","EstimationHistory__container__detail__options__list__data__explain":"EstimationHistory__container__detail__options__list__data__explain","touch":"touch","showInfo":"showInfo"};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1d0bc4b60f1dbf2bbfa28b16f8bac882.png";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b956fe61ea1c81caa738f459fd1ced6d.png";

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\components\\preloader\\index.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 *  Preloader
 */
var Preloader = (_temp = _class = function (_PureComponent) {
  _inherits(Preloader, _PureComponent);

  function Preloader(props) {
    _classCallCheck(this, Preloader);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));

    _this.initAnimation = function () {
      _this.currentFrame = 0;
      _this.setState({
        top: 0,
        left: 0
      });
    };

    _this.startAnimation = function () {
      _this.intervalId = setInterval(function () {
        _this.setState({
          top: -Math.floor(_this.currentFrame / Preloader.ROW_MAX) * Preloader.IMAGE_HEIGHT,
          left: -(_this.currentFrame % Preloader.ROW_MAX) * Preloader.IMAGE_WIDTH
        });
        //
        _this.currentFrame = _this.currentFrame + 1;
        if (Preloader.TOTAL_FRAMES <= _this.currentFrame) {
          _this.currentFrame = 0;
        }
      }, 1000 / 40);
    };

    _this.stopAnimation = function () {
      if (_this.intervalId) clearInterval(_this.intervalId);
    };

    _this.props = props;
    _this.intervalId = null;
    _this.currentFrame = 0;
    _this.state = {
      top: 0,
      left: 0,
      loading: false
    };
    return _this;
  }

  Preloader.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Preloader' + (this.props.loading ? ' visible' : ''), __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { backgroundPosition: this.state.left + 'px ' + this.state.top + 'px' }, __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        })
      )
    );
  };

  Preloader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.state.loading === nextProps.loading) return;
    this.setState({
      loading: nextProps.loading
    });
    if (nextProps.loading === true) {
      this.stopAnimation();
      this.initAnimation();
      this.startAnimation();
    } else {
      this.stopAnimation();
    }
  };

  Preloader.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopAnimation();
  };

  return Preloader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.IMAGE_WIDTH = 150, _class.IMAGE_HEIGHT = 150, _class.ROW_MAX = 6, _class.TOTAL_FRAMES = 40, _temp);
Preloader.displayName = 'Preloader';


/* harmony default export */ __webpack_exports__["a"] = (Preloader);

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Preloader":"Preloader","visible":"visible"};

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks_interior360_item__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class,
    _temp,
    _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\containers\\interior360\\Interior360Items.jsx';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 *  Interior360
 */
var Interior360Items = (_temp = _class = function (_Component) {
  _inherits(Interior360Items, _Component);

  function Interior360Items(props) {
    _classCallCheck(this, Interior360Items);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.changeItem = function (index) {
      // スクロール
      if (_this._items.current) {
        var easing = function easing(t, b, c, d) {
          return c * ((t = t / d - 1) * t * t + 1) + b;
        };
        var time = 0;
        var target = index * 65 + 5 - (_this._items.current.clientWidth - 30) / 2 + 25;
        var current = _this._items.current.scrollLeft;
        var sub = target - current;
        if (_this._intervalId2) clearInterval(_this._intervalId2);
        _this._intervalId2 = setInterval(function () {
          time = time + 1 / 30 * 2;
          // time = time + (1 / 60) * 2;
          if (1 < time) {
            clearInterval(_this._intervalId2);
          } else {
            _this._items.current.scrollLeft = current + easing(time, 0, 1, 1) * sub;
          }
        }, 1000 / 30);
      }

      // イメージ変更
      _this.props.onChangeItem(index);
    };

    _this.checkScrollEnabled = function () {
      if (_this._items.current) {
        if (_this._items.current.clientWidth - 35 < _this.props.items.length * 65 - 15) {
          _this.setState({
            isScrollEnabled: true
          });
        } else {
          _this.setState({
            isScrollEnabled: false
          });
        }
      }
    };

    _this.props = props;
    //
    _this.state = {
      hoverItemIndex: 0,
      isScrollEnabled: false
    };
    //
    _this._intervalId = null;
    _this._intervalId2 = null;
    _this._items = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }

  Interior360Items.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // アイテムをスクロールさせるか
    if (this._intervalId) clearInterval(this._intervalId);
    this._intervalId = setInterval(function () {
      _this2.checkScrollEnabled();
    }, 200);
  };

  Interior360Items.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // SPでタブを切り替えても、サムネイルのスクロール位置が初期化されない
    if (this.props.items !== nextProps.items) {
      if (this._intervalId2) clearInterval(this._intervalId2);
      if (this._items && this._items.current) {
        this._items.current.scrollLeft = 0;
      }
    }
    // // SPでタブを切り替えても、サムネイルのスクロール位置が初期化されない
    // if (this.props.currentItemIndex !== nextProps.currentItemIndex) {
    //   if (nextProps.currentItemIndex === 0) {
    //     if (this._intervalId2) clearInterval(this._intervalId2);
    //     this._items.current.scrollLeft = 0;
    //   }
    // }
    return true;
  };

  // アイテム変更


  // アイテムをスクロールさせるか


  Interior360Items.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        currentItemIndex = _props.currentItemIndex,
        items = _props.items,
        isMultipleLines = _props.isMultipleLines,
        isSingleLines = _props.isSingleLines,
        isViewIcons = _props.isViewIcons;

    // アイテム表示

    var renderItems = function renderItems() {
      if (!isViewIcons) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Interior360__items opened', __source: {
            fileName: _jsxFileName,
            lineNumber: 122
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'Interior360__items__list' + (_this3.state.isScrollEnabled ? ' scrollEnabled' : ''), ref: _this3._items, __source: {
              fileName: _jsxFileName,
              lineNumber: 123
            }
          },
          items.map(function (child, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 126
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__blocks_interior360_item__["a" /* default */], _extends({}, child.props, {
                index: index,
                onMouseOver: function onMouseOver(e) {
                  _this3.setState({
                    hoverItemIndex: e
                  });
                },
                onMouseOut: function onMouseOut(e) {
                  _this3.setState({
                    hoverItemIndex: null
                  });
                },
                onClick: function onClick(e) {
                  // アイテム変更
                  _this3.changeItem(e);
                },
                isCurrent: index === currentItemIndex,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 127
                }
              }))
            );
          })
        )
      );
    };

    // インテリア名表示
    var renderInteriorName = function renderInteriorName() {
      var data = null;
      if (null !== _this3.state.hoverItemIndex) {
        data = items[_this3.state.hoverItemIndex].props;
      } else {
        data = items[currentItemIndex].props;
      }
      var getPcInteriorName = function getPcInteriorName() {
        if (data.pcInteriorName && data.pcInteriorName !== '') {
          return data.pcInteriorName.replace(/[|]/g, '<br>');
        } else {
          return null;
        }
      };
      var getMbInteriorName = function getMbInteriorName() {
        if (data.mbInteriorName && data.mbInteriorName !== '') {
          return data.mbInteriorName.replace(/[|]/g, '<br>');
        } else {
          return getPcInteriorName();
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'Interior360__interior-name' + (isMultipleLines ? ' multiline' : '') + (isSingleLines ? ' singleline' : ''), __source: {
            fileName: _jsxFileName,
            lineNumber: 176
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'pc', dangerouslySetInnerHTML: { __html: getPcInteriorName() }, __source: {
            fileName: _jsxFileName,
            lineNumber: 177
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'mb', dangerouslySetInnerHTML: { __html: getMbInteriorName() }, __source: {
            fileName: _jsxFileName,
            lineNumber: 178
          }
        })
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184
        }
      },
      renderItems(),
      renderInteriorName()
    );
  };

  return Interior360Items;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  currentItemIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  isMultipleLines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isSingleLines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChangeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isViewIcons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class.defaultProps = {
  currentItemIndex: 0,
  items: [],
  isMultipleLines: false,
  isSingleLines: false,
  onChangeItem: null,
  isViewIcons: true
}, _temp);
Interior360Items.displayName = 'Interior360Items';


/* harmony default export */ __webpack_exports__["a"] = (Interior360Items);

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Interior360Item":"Interior360Item","Interior360Item__link":"Interior360Item__link","Interior360Item__border":"Interior360Item__border","current":"current","Interior360Item__box":"Interior360Item__box"};

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pnlm-container":"pnlm-container","pnlm-ui":"pnlm-ui","pnlm-grab":"pnlm-grab","pnlm-grabbing":"pnlm-grabbing","pnlm-sprite":"pnlm-sprite","pnlm-render-container":"pnlm-render-container","pnlm-controls":"pnlm-controls","pnlm-control":"pnlm-control","pnlm-controls-container":"pnlm-controls-container","pnlm-zoom-controls":"pnlm-zoom-controls","pnlm-zoom-in":"pnlm-zoom-in","pnlm-zoom-out":"pnlm-zoom-out","pnlm-fullscreen-toggle-button":"pnlm-fullscreen-toggle-button","pnlm-orientation-button":"pnlm-orientation-button","pnlm-hot-spot-debug-indicator":"pnlm-hot-spot-debug-indicator","pnlm-orientation-button-inactive":"pnlm-orientation-button-inactive","pnlm-orientation-button-active":"pnlm-orientation-button-active","pnlm-fullscreen-toggle-button-inactive":"pnlm-fullscreen-toggle-button-inactive","pnlm-fullscreen-toggle-button-active":"pnlm-fullscreen-toggle-button-active","pnlm-panorama-info":"pnlm-panorama-info","pnlm-title-box":"pnlm-title-box","pnlm-author-box":"pnlm-author-box","pnlm-load-box":"pnlm-load-box","pnlm-lbox":"pnlm-lbox","pnlm-loading":"pnlm-loading","pnlm-mv":"pnlm-mv","pnlm-load-button":"pnlm-load-button","pnlm-info-box":"pnlm-info-box","pnlm-error-msg":"pnlm-error-msg","pnlm-about-msg":"pnlm-about-msg","pnlm-hotspot-base":"pnlm-hotspot-base","pnlm-hotspot":"pnlm-hotspot","pnlm-info":"pnlm-info","pnlm-scene":"pnlm-scene","pnlm-tooltip":"pnlm-tooltip","pnlm-compass":"pnlm-compass","pnlm-world":"pnlm-world","pnlm-face":"pnlm-face","pnlm-dragfix":"pnlm-dragfix","pnlm-preview-img":"pnlm-preview-img","pnlm-lbar":"pnlm-lbar","pnlm-lbar-fill":"pnlm-lbar-fill","pnlm-lmsg":"pnlm-lmsg","pnlm-fade-img":"pnlm-fade-img","pnlm-pointer":"pnlm-pointer"};

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_home_page__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_header__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_hero_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_hero_video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_hero_image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_social_icons_container_block__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_sub_footer_navigation__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_footer_navigation__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_html__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\home-page\\index.jsx';













var HomePageBlock = function HomePageBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_home_page__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    }
  }));
};
HomePageBlock.displayName = 'HomePageBlock';
HomePageBlock.displayName = 'HomePage';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_hero_carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_hero_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_hero_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__containers_social_icons_container_block__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__blocks_sub_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__containers_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_html__["a" /* default */]],
  mapInputToOutput: [['header', 'header'], ['hero', 'hero'], ['components', 'children'], ['footer', 'footer'], ['ctaNavi', 'ctaNavi'], ['anchorNavi', 'anchorNavi'], ['cookieEditor', 'cookieEditor']]
})(HomePageBlock));

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_standard_page__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_header__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_sub_navigation__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_hero_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_hero_video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_hero_image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_social_icons_container_block__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_sub_footer_navigation__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_footer_navigation__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blocks_full_width__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__blocks_exterior_view__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_tab_navigation__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blocks_spec_comparison__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_eco_tax__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blocks_photogallery__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blocks_video__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_one_column_layout__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_two_column_layout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_three_column_layout__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__containers_four_column_layout__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_accessory_list__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__containers_cta_navigation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__containers_anchor_navigation__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__containers_promo_and_button_modal_window__ = __webpack_require__(116);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\standard-page\\index.jsx';
































var StandardPageBlock = function StandardPageBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_standard_page__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    }
  }));
};
StandardPageBlock.displayName = 'StandardPageBlock';
StandardPageBlock.displayName = 'StandardPage';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_sub_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_hero_carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_hero_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__blocks_hero_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__containers_social_icons_container_block__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__blocks_sub_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__blocks_full_width__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__containers_photo_info__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__blocks_exterior_view__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__containers_tab_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__blocks_spec_comparison__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__containers_eco_tax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__blocks_photogallery__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__blocks_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__containers_one_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__containers_two_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__containers_three_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__containers_four_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__containers_accessory_list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__containers_cta_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__containers_anchor_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__containers_promo_and_button_modal_window__["a" /* default */]],
  mapInputToOutput: [['header', 'header'], ['upperPageNavigation', 'upperPageNavigation'], ['hero', 'hero'], ['components', 'children'], ['lowerPageNavigation', 'lowerPageNavigation'], ['footer', 'footer'], ['ctaNavi', 'ctaNavi'], ['anchorNavi', 'anchorNavi'], ['cookieEditor', 'cookieEditor']]
})(StandardPageBlock));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_feature_categories__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_feature_category_container__ = __webpack_require__(340);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\feature-categories\\index.jsx';





var FeatureCategoriesBlock = function FeatureCategoriesBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_feature_categories__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
FeatureCategoriesBlock.displayName = 'FeatureCategoriesBlock';
FeatureCategoriesBlock.displayName = 'FeatureCategories';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_feature_category_container__["a" /* default */]],
  mapInputToOutput: [['categories', 'categories']]
})(FeatureCategoriesBlock));

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_promo_slider__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_promo__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\promo-slider\\index.jsx';





var PromoSliderBlock = function PromoSliderBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_promo_slider__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
PromoSliderBlock.displayName = 'PromoSliderBlock';
PromoSliderBlock.displayName = 'PromoSlider';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_promo__["a" /* default */]],
  mapInputToOutput: [['components', 'children']]
})(PromoSliderBlock));

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_equipment__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_equipment_container__ = __webpack_require__(344);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\equipment\\index.jsx';





var EquipmentBlock = function EquipmentBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_equipment__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
EquipmentBlock.displayName = 'EquipmentBlock';
EquipmentBlock.displayName = 'Equipment';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_equipment_container__["a" /* default */]],
  mapInputToOutput: [['equipmentContainer', 'equipmentContainer']]
})(EquipmentBlock));

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_maker_set_option__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_maker_set_option_more_info_item__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\maker-set-option\\index.jsx';





var MakerSetOptionBlock = function MakerSetOptionBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_maker_set_option__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
MakerSetOptionBlock.displayName = 'MakerSetOptionBlock';
MakerSetOptionBlock.displayName = 'MakerSetOption';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_maker_set_option_more_info_item__["a" /* default */]],
  mapInputToOutput: [['makerSetOptionMoreInfoItems', 'makerSetOptionMoreInfoItems']]
})(MakerSetOptionBlock));

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_grade_and_spec__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_grade_and_spec_data__ = __webpack_require__(345);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\grade-and-spec\\index.jsx';





var GradeAndSpecBlock = function GradeAndSpecBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_grade_and_spec__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
GradeAndSpecBlock.displayName = 'GradeAndSpecBlock';
GradeAndSpecBlock.displayName = 'GradeAndSpec';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_grade_and_spec_data__["a" /* default */]],
  mapInputToOutput: [['gradeAndSpecData', 'gradeAndSpecData']]
})(GradeAndSpecBlock));

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_car_lineup__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_car_lineup_filter__ = __webpack_require__(346);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\car-lineup\\index.jsx';





var CarLineupBlock = function CarLineupBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_car_lineup__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
CarLineupBlock.displayName = 'CarLineupBlock';
CarLineupBlock.displayName = 'CarLineup';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_car_lineup_filter__["a" /* default */]],
  mapInputToOutput: [
    // ['passengerCarFilters', 'passengerCarFilters'],
    // ['models', 'models'],
  ]
})(CarLineupBlock));

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_credit_plan__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_one_column_layout__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_two_column_layout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_three_column_layout__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_four_column_layout__ = __webpack_require__(351);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\credit-plan\\index.jsx';









var CreditPlanBlock = function CreditPlanBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_credit_plan__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    }
  }));
};
CreditPlanBlock.displayName = 'CreditPlanBlock';
CreditPlanBlock.displayName = 'CreditPlan';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_one_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_two_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_three_column_layout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_four_column_layout__["a" /* default */]],
  mapInputToOutput: [['images', 'images'], ['mbImages', 'mbImages']]
})(CreditPlanBlock));

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accordion_container__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_accordion_item__ = __webpack_require__(352);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accordion-container\\index.jsx';





var AccordionContainerBlock = function AccordionContainerBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accordion_container__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
AccordionContainerBlock.displayName = 'AccordionContainerBlock';
AccordionContainerBlock.displayName = 'AccordionContainer';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_accordion_item__["a" /* default */]],
  mapInputToOutput: []
})(AccordionContainerBlock));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_cta_navigation__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\cta-navigation\\index.jsx';





var CTANavigationBlock = function CTANavigationBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_cta_navigation__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
CTANavigationBlock.displayName = 'CTANavigationBlock';
CTANavigationBlock.displayName = 'CTANavigation';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__containers_cta__["a" /* default */]],
  mapInputToOutput: []
})(CTANavigationBlock));

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_list__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_accessory_body_type_tab_name__ = __webpack_require__(353);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-list\\index.jsx';





var AccessoryListBlock = function AccessoryListBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_list__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
};
AccessoryListBlock.displayName = 'AccessoryListBlock';
AccessoryListBlock.displayName = 'AccessoryList';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_accessory_body_type_tab_name__["a" /* default */]],
  mapInputToOutput: []
})(AccessoryListBlock));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_detail_page__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_header__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_sub_navigation__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_hero_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_hero_video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_hero_image__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_social_icons_container_block__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_sub_footer_navigation__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_footer_navigation__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blocks_full_width__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__blocks_exterior_view__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_photo_info__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_tab_navigation__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blocks_spec_comparison__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_eco_tax__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_accessory_detail_content__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-detail-page\\index.jsx';























var AccessoryDetailPageBlock = function AccessoryDetailPageBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_detail_page__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    }
  }));
};
AccessoryDetailPageBlock.displayName = 'AccessoryDetailPageBlock';
AccessoryDetailPageBlock.displayName = 'AccessoryDetailPage';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__blocks_sub_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__blocks_hero_carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__blocks_hero_video__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__blocks_hero_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__containers_social_icons_container_block__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__blocks_sub_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__containers_footer_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__containers_html__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__blocks_full_width__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__containers_photo_info__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__blocks_exterior_view__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__containers_tab_navigation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__blocks_spec_comparison__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__containers_eco_tax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__containers_accessory_detail_content__["a" /* default */]],
  mapInputToOutput: [['header', 'header'], ['upperPageNavigation', 'upperPageNavigation'], ['hero', 'hero'], ['components', 'children'], ['lowerPageNavigation', 'lowerPageNavigation'], ['footer', 'footer'], ['ctaNavi', 'ctaNavi'], ['anchorNavi', 'anchorNavi'], ['cookieEditor', 'cookieEditor']]
})(AccessoryDetailPageBlock));

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_accessory_detail_content__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_accessory_info_container__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_cta__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\accessory-detail-content\\index.jsx';






var AccessoryDetailContentBlock = function AccessoryDetailContentBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_accessory_detail_content__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
AccessoryDetailContentBlock.displayName = 'AccessoryDetailContentBlock';
AccessoryDetailContentBlock.displayName = 'AccessoryDetailContent';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_accessory_info_container__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_cta__["a" /* default */]],
  mapInputToOutput: []
})(AccessoryDetailContentBlock));

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_higher_order_components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_interior360__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_interior360_item__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_photo_info__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'C:\\build\\master\\mjo\\mjo-frontend\\src\\blocks\\interior360\\index.jsx';






var Interior360Block = function Interior360Block(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_interior360__["a" /* default */], _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    }
  }));
};
Interior360Block.displayName = 'Interior360Block';
Interior360Block.displayName = 'Interior360';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_higher_order_components__["c" /* withDynamicComponents */])({
  componentWhitelist: [__WEBPACK_IMPORTED_MODULE_3__blocks_interior360_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__containers_photo_info__["a" /* default */]],
  mapInputToOutput: [['interior360Item', 'interior360Item'], ['photoInfo', 'photoInfo']]
})(Interior360Block));

/***/ }),
/* 924 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_event_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__containers_utilities_console_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__containers_utilities_url_polyfill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_config__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(3);
/* global Event */










__webpack_require__(545);
// use patched version for quiet failure
// require('expose-loader?ReactDOM!./patched-react-dom')
__webpack_require__(546);
__webpack_require__(554) // semicolon is important

// Polyfill for requestAnimationFrame
;

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();

if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils__["s" /* isOldBrowser */])()) {
  __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.config(__WEBPACK_IMPORTED_MODULE_6__constants_config__["c" /* SENTRY_URL */], {
    release: __WEBPACK_IMPORTED_MODULE_6__constants_config__["b" /* RELEASE */]
  }).install();
}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * console-shim 1.0.3
 * https://github.com/kayahr/console-shim
 * Copyright (C) 2011 Klaus Reimer <k@ailis.de>
 * Licensed under the MIT license
 * (See http://www.opensource.org/licenses/mit-license)
 */

(function () {
  /**
   * Returns a function which calls the specified function in the specified
   * scope.
   *
   * @param {Function} func
   *            The function to call.
   * @param {Object} scope
   *            The scope to call the function in.
   * @param {...*} args
   *            Additional arguments to pass to the bound function.
   * @returns {function(...[*]): undefined}
   *            The bound function.
   */
  var bind = function bind(func, scope, args) {
    var fixedArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
      var args = fixedArgs.concat(Array.prototype.slice.call(arguments, 0));
      /** @type {Function} */func.apply(scope, args);
    };
  };

  // Create console if not present
  if (!window.console) window.console /** @type {Console} */ = {};
  var console = /** @type {Object} */window.console;

  // Implement console log if needed
  if (!console.log) {
    // Use log4javascript if present
    if (window.log4javascript) {
      var log = log4javascript.getDefaultLogger();
      console.log = bind(log.info, log);
      console.debug = bind(log.debug, log);
      console.info = bind(log.info, log);
      console.warn = bind(log.warn, log);
      console.error = bind(log.error, log);
    } else {
      // Use empty dummy implementation to ignore logging
      console.log = /** @param {...*} args */function (args) {};
    }
  }

  // Implement other log levels to console.log if missing
  if (!console.debug) console.debug = console.log;
  if (!console.info) console.info = console.log;
  if (!console.warn) console.warn = console.log;
  if (!console.error) console.error = console.log;

  // Wrap the log methods in IE (<=9) because their argument handling is wrong
  // This wrapping is also done if the __consoleShimTest__ symbol is set. This
  // is needed for unit testing.
  if (window.__consoleShimTest__ != null || eval('/*@cc_on @_jscript_version <= 9@*/')) {
    /**
     * Wraps the call to a real IE logging method. Modifies the arguments so
     * parameters which are not represented by a placeholder are properly
     * printed with a space character as separator.
     *
     * @param {...*} args
     *            The function arguments. First argument is the log function
     *            to call, the other arguments are the log arguments.
     */
    var wrap = function wrap(args) {
      var i = void 0,
          max = void 0,
          match = void 0,
          log = void 0;

      // Convert argument list to real array
      args = Array.prototype.slice.call(arguments, 0);

      // First argument is the log method to call
      log = args.shift();

      max = args.length;
      if (max > 1 && window.__consoleShimTest__ !== false) {
        // When first parameter is not a string then add a format string to
        // the argument list so we are able to modify it in the next stop
        if (typeof args[0] !== 'string') {
          args.unshift('%o');
          max += 1;
        }

        // For each additional parameter which has no placeholder in the
        // format string we add another placeholder separated with a
        // space character.
        match = args[0].match(/%[a-z]/g);
        for (i = match ? match.length + 1 : 1; i < max; i += 1) {
          args[0] += ' %o';
        }
      }
      Function.apply.call(log, console, args);
    };

    // Wrap the native log methods of IE to fix argument output problems
    console.log = bind(wrap, window, console.log);
    console.debug = bind(wrap, window, console.debug);
    console.info = bind(wrap, window, console.info);
    console.warn = bind(wrap, window, console.warn);
    console.error = bind(wrap, window, console.error);
  }

  // Implement console.assert if missing
  if (!console.assert) {
    console.assert = function () {
      var args = Array.prototype.slice.call(arguments, 0);
      var expr = args.shift();
      if (!expr) {
        args[0] = 'Assertion failed: ' + args[0];
        console.error.apply(console, args);
      }
    };
  }

  // Linking console.dir and console.dirxml to the console.log method if
  // missing. Hopefully the browser already logs objects and DOM nodes as a
  // tree.
  if (!console.dir) console.dir = console.log;
  if (!console.dirxml) console.dirxml = console.log;

  // Linking console.exception to console.error. This is not the same but
  // at least some error message is displayed.
  if (!console.exception) console.exception = console.error;

  // Implement console.time and console.timeEnd if one of them is missing
  if (!console.time || !console.timeEnd) {
    var timers = {};
    console.time = function (id) {
      timers[id] = new Date().getTime();
    };
    console.timeEnd = function (id) {
      var start = timers[id];
      if (start) {
        console.log(id + ': ' + (new Date().getTime() - start) + 'ms');
        delete timers[id];
      }
    };
  }

  // Implement console.table if missing
  if (!console.table) {
    console.table = function (data, columns) {
      var i = void 0,
          iMax = void 0,
          row = void 0,
          j = void 0,
          jMax = void 0,
          k = void 0;

      // Do nothing if data has wrong type or no data was specified
      if (!data || !(data instanceof Array) || !data.length) return;

      // Auto-calculate columns array if not set
      if (!columns || !(columns instanceof Array)) {
        columns = [];
        for (k in data[0]) {
          if (!data[0].hasOwnProperty(k)) continue;
          columns.push(k);
        }
      }

      for (i = 0, iMax = data.length; i < iMax; i += 1) {
        row = [];
        for (j = 0, jMax = columns.length; j < jMax; j += 1) {
          row.push(data[i][columns[j]]);
        }

        Function.apply.call(console.log, console, row);
      }
    };
  }

  // Dummy implementations of other console features to prevent error messages
  // in browsers not supporting it.
  if (!console.clear) console.clear = function () {};
  if (!console.trace) console.trace = function () {};
  if (!console.group) console.group = function () {};
  if (!console.groupCollapsed) console.groupCollapsed = function () {};
  if (!console.groupEnd) console.groupEnd = function () {};
  if (!console.timeStamp) console.timeStamp = function () {};
  if (!console.profile) console.profile = function () {};
  if (!console.profileEnd) console.profileEnd = function () {};
  if (!console.count) console.count = function () {};
})();

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// URL Polyfill
// Draft specification: https://url.spec.whatwg.org

// Notes:
// - Primarily useful for parsing URLs and modifying query parameters
// - Should work in IE8+ and everything more modern

(function (global) {
  // Browsers may have:
  // * No global URL object
  // * URL with static methods only - may have a dummy constructor
  // * URL with members except searchParams
  // * Full URL API support
  var origURL = global.URL;
  var nativeURL = void 0;
  try {
    if (origURL) {
      nativeURL = new global.URL('http://example.com');
      if ('searchParams' in nativeURL) return;
      if (!('href' in nativeURL)) nativeURL = undefined;
    }
  } catch (_) {}

  // NOTE: Doesn't do the encoding/decoding dance
  function urlencoded_serialize(pairs) {
    var output = '',
        first = true;
    pairs.forEach(function (pair) {
      var name = encodeURIComponent(pair.name);
      var value = encodeURIComponent(pair.value);
      if (!first) output += '&';
      output += name + '=' + value;
      first = false;
    });
    return output.replace(/%20/g, '+');
  }

  // NOTE: Doesn't do the encoding/decoding dance
  function urlencoded_parse(input, isindex) {
    var sequences = input.split('&');
    if (isindex && sequences[0].indexOf('=') === -1) sequences[0] = '=' + sequences[0];
    var pairs = [];
    sequences.forEach(function (bytes) {
      if (bytes.length === 0) return;
      var index = bytes.indexOf('=');
      if (index !== -1) {
        var name = bytes.substring(0, index);
        var value = bytes.substring(index + 1);
      } else {
        name = bytes;
        value = '';
      }
      name = name.replace(/\+/g, ' ');
      value = value.replace(/\+/g, ' ');
      pairs.push({ name: name, value: value });
    });
    var output = [];
    pairs.forEach(function (pair) {
      output.push({
        name: decodeURIComponent(pair.name),
        value: decodeURIComponent(pair.value)
      });
    });
    return output;
  }

  function URLUtils(url) {
    if (nativeURL) return new origURL(url);
    var anchor = document.createElement('a');
    anchor.href = url;
    return anchor;
  }

  function URLSearchParams(init) {
    var $this = this;
    this._list = [];

    if (init === undefined || init === null) init = '';

    if (Object(init) !== init || init instanceof URLSearchParams) init = String(init);

    if (typeof init === 'string') {
      if (init.substring(0, 1) === '?') {
        init = init.substring(1);
      }
      this._list = urlencoded_parse(init);
    }

    this._url_object = null;
    this._setList = function (list) {
      if (!updating) $this._list = list;
    };

    var updating = false;
    this._update_steps = function () {
      if (updating) return;
      updating = true;

      if (!$this._url_object) return;

      // Partial workaround for IE issue with 'about:'
      if ($this._url_object.protocol === 'about:' && $this._url_object.pathname.indexOf('?') !== -1) {
        $this._url_object.pathname = $this._url_object.pathname.split('?')[0];
      }

      $this._url_object.search = urlencoded_serialize($this._list);

      updating = false;
    };
  }

  Object.defineProperties(URLSearchParams.prototype, {
    append: {
      value: function value(name, _value) {
        this._list.push({ name: name, value: _value });
        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    delete: {
      value: function value(name) {
        for (var i = 0; i < this._list.length;) {
          if (this._list[i].name === name) this._list.splice(i, 1);else ++i;
        }
        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    get: {
      value: function value(name) {
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) return this._list[i].value;
        }
        return null;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    getAll: {
      value: function value(name) {
        var result = [];
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) result.push(this._list[i].value);
        }
        return result;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    has: {
      value: function value(name) {
        for (var i = 0; i < this._list.length; ++i) {
          if (this._list[i].name === name) return true;
        }
        return false;
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    set: {
      value: function value(name, _value2) {
        var found = false;
        for (var i = 0; i < this._list.length;) {
          if (this._list[i].name === name) {
            if (!found) {
              this._list[i].value = _value2;
              found = true;
              ++i;
            } else {
              this._list.splice(i, 1);
            }
          } else {
            ++i;
          }
        }

        if (!found) this._list.push({ name: name, value: _value2 });

        this._update_steps();
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    entries: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: [pair.name, pair.value] };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    keys: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: pair.name };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    values: {
      value: function value() {
        var $this = this,
            index = 0;
        return {
          next: function next() {
            if (index >= $this._list.length) return { done: true, value: undefined };
            var pair = $this._list[index++];
            return { done: false, value: pair.value };
          }
        };
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    forEach: {
      value: function value(callback) {
        var thisArg = arguments.length > 1 ? arguments[1] : undefined;
        this._list.forEach(function (pair, index) {
          callback.call(thisArg, pair.value, pair.name);
        });
      },

      writable: true,
      enumerable: true,
      configurable: true
    },

    toString: {
      value: function value() {
        return urlencoded_serialize(this._list);
      },

      writable: true,
      enumerable: false,
      configurable: true
    }
  });

  if ('Symbol' in global && 'iterator' in global.Symbol) {
    Object.defineProperty(URLSearchParams.prototype, global.Symbol.iterator, {
      value: URLSearchParams.prototype.entries,
      writable: true,
      enumerable: true,
      configurable: true
    });
  }

  function URL(url, base) {
    if (!(this instanceof global.URL)) {
      throw new TypeError("Failed to construct 'URL': Please use the 'new' operator.");
    }

    if (base) {
      url = function () {
        if (nativeURL) return new origURL(url, base).href;

        var doc = void 0;
        // Use another document/base tag/anchor for relative URL resolution, if possible
        if (document.implementation && document.implementation.createHTMLDocument) {
          doc = document.implementation.createHTMLDocument('');
        } else if (document.implementation && document.implementation.createDocument) {
          doc = document.implementation.createDocument('http://www.w3.org/1999/xhtml', 'html', null);
          doc.documentElement.appendChild(doc.createElement('head'));
          doc.documentElement.appendChild(doc.createElement('body'));
        } else if (window.ActiveXObject) {
          doc = new window.ActiveXObject('htmlfile');
          doc.write('<head></head><body></body>');
          doc.close();
        }

        if (!doc) throw Error('base not supported');

        var baseTag = doc.createElement('base');
        baseTag.href = base;
        doc.getElementsByTagName('head')[0].appendChild(baseTag);
        var anchor = doc.createElement('a');
        anchor.href = url;
        return anchor.href;
      }();
    }

    // An inner object implementing URLUtils (either a native URL
    // object or an HTMLAnchorElement instance) is used to perform the
    // URL algorithms. With full ES5 getter/setter support, return a
    // regular object For IE8's limited getter/setter support, a
    // different HTMLAnchorElement is returned with properties
    // overridden

    var instance = URLUtils(url || '');

    // Detect for ES5 getter/setter support
    // (an Object.defineProperties polyfill that doesn't support getters/setters may throw)
    var ES5_GET_SET = function () {
      if (!('defineProperties' in Object)) return false;
      try {
        var obj = {};
        Object.defineProperties(obj, {
          prop: {
            get: function get() {
              return true;
            }
          }
        });
        return obj.prop;
      } catch (_) {
        return false;
      }
    }();

    var self = ES5_GET_SET ? this : document.createElement('a');

    var query_object = new URLSearchParams(instance.search ? instance.search.substring(1) : null);
    query_object._url_object = self;

    Object.defineProperties(self, {
      href: {
        get: function get() {
          return instance.href;
        },
        set: function set(v) {
          instance.href = v;
          tidy_instance();
          update_steps();
        },

        enumerable: true,
        configurable: true
      },
      origin: {
        get: function get() {
          if ('origin' in instance) return instance.origin;
          return this.protocol + '//' + this.host;
        },

        enumerable: true,
        configurable: true
      },
      protocol: {
        get: function get() {
          return instance.protocol;
        },
        set: function set(v) {
          instance.protocol = v;
        },

        enumerable: true,
        configurable: true
      },
      username: {
        get: function get() {
          return instance.username;
        },
        set: function set(v) {
          instance.username = v;
        },

        enumerable: true,
        configurable: true
      },
      password: {
        get: function get() {
          return instance.password;
        },
        set: function set(v) {
          instance.password = v;
        },

        enumerable: true,
        configurable: true
      },
      host: {
        get: function get() {
          // IE returns default port in |host|
          var re = { 'http:': /:80$/, 'https:': /:443$/, 'ftp:': /:21$/ }[instance.protocol];
          return re ? instance.host.replace(re, '') : instance.host;
        },
        set: function set(v) {
          instance.host = v;
        },

        enumerable: true,
        configurable: true
      },
      hostname: {
        get: function get() {
          return instance.hostname;
        },
        set: function set(v) {
          instance.hostname = v;
        },

        enumerable: true,
        configurable: true
      },
      port: {
        get: function get() {
          return instance.port;
        },
        set: function set(v) {
          instance.port = v;
        },

        enumerable: true,
        configurable: true
      },
      pathname: {
        get: function get() {
          // IE does not include leading '/' in |pathname|
          if (instance.pathname.charAt(0) !== '/') return '/' + instance.pathname;
          return instance.pathname;
        },
        set: function set(v) {
          instance.pathname = v;
        },

        enumerable: true,
        configurable: true
      },
      search: {
        get: function get() {
          return instance.search;
        },
        set: function set(v) {
          if (instance.search === v) return;
          instance.search = v;
          tidy_instance();
          update_steps();
        },

        enumerable: true,
        configurable: true
      },
      searchParams: {
        get: function get() {
          return query_object;
        },

        enumerable: true,
        configurable: true
      },
      hash: {
        get: function get() {
          return instance.hash;
        },
        set: function set(v) {
          instance.hash = v;
          tidy_instance();
        },

        enumerable: true,
        configurable: true
      },
      toString: {
        value: function value() {
          return instance.toString();
        },

        enumerable: false,
        configurable: true
      },
      valueOf: {
        value: function value() {
          return instance.valueOf();
        },

        enumerable: false,
        configurable: true
      }
    });

    function tidy_instance() {
      var href = instance.href.replace(/#$|\?$|\?(?=#)/g, '');
      if (instance.href !== href) instance.href = href;
    }

    function update_steps() {
      query_object._setList(instance.search ? urlencoded_parse(instance.search.substring(1)) : []);
      query_object._update_steps();
    }

    return self;
  }

  if (origURL) {
    for (var i in origURL) {
      if (origURL.hasOwnProperty(i) && typeof origURL[i] === 'function') URL[i] = origURL[i];
    }
  }

  global.URL = URL;
  global.URLSearchParams = URLSearchParams;
})(self);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(930);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(931);
var stringify = __webpack_require__(924);
var md5 = __webpack_require__(932);
var RavenConfigError = __webpack_require__(933);

var utils = __webpack_require__(475);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(934).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    keepalive: true,
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.26.4',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = Object.assign(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(475);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 932 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(475);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// client.bundle.534309a.js